'use strict';
var $i_snabbdom = require("snabbdom");
var $linkingInfo = Object.freeze({
  "esVersion": 6,
  "assumingES6": true,
  "productionMode": false,
  "linkerVersion": "1.9.0",
  "fileLevelThis": this
});
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)))
  };
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = {};
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      });
      i = ((i + 1) | 0)
    };
    return descriptors
  })
})());
var $L0;
function $propertyName(arg0) {
  for (var prop in arg0) {
    return prop
  }
}
function $Char(c) {
  this.c = c
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c)
});
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ClassCastException(((arg0 + " is not an instance of ") + arg1)))
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1)
  };
  $throwClassCastException(arg0, arg1)
}
function $throwArrayIndexOutOfBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))))
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object")
}
function $newArrayObject(arg0, arg1) {
  return $newArrayObjectInternal(arg0, arg1, 0)
}
function $newArrayObjectInternal(arg0, arg1, arg2) {
  var result = new arg0.constr(arg1[arg2]);
  if ((arg2 < (arg1.length - 1))) {
    var subArrayClassData = arg0.componentData;
    var subLengthIndex = (arg2 + 1);
    var underlying = result.u;
    for (var i = 0; (i < underlying.length); (i++)) {
      underlying[i] = $newArrayObjectInternal(subArrayClassData, arg1, subLengthIndex)
    }
  };
  return result
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0))
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0))
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf()
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf()
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf()
        } else {
          return $d_jl_Integer.getClassOf()
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf()
      } else {
        return $d_jl_Double.getClassOf()
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf()
    }
    case "undefined": {
      return $d_jl_Void.getClassOf()
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf()
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf()
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf()
      } else {
        return null
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String"
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte"
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short"
        } else {
          return "java.lang.Integer"
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float"
      } else {
        return "java.lang.Double"
      }
    }
    case "boolean": {
      return "java.lang.Boolean"
    }
    case "undefined": {
      return "java.lang.Void"
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long"
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character"
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name
      } else {
        return null.getName__T()
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0)
  } else {
    return instance.charAt__I__C(x0)
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0)
  } else {
    return instance.codePointAt__I__I(x0)
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0)
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0)
    }
    default: {
      if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__compareTo__O__I(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I(instance, x0)
      } else {
        return instance.compareTo__O__I(x0)
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0)
  } else {
    return instance.compareTo__T__I(x0)
  }
}
function $dp_endsWith__T__Z(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__endsWith__T__Z(instance, x0)
  } else {
    return instance.endsWith__T__Z(x0)
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0)
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0)
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0)
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__equals__O__Z(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance, x0)
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0)
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3)
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3)
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance)
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance)
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I()
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__hashCode__I(instance)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance)
      } else {
        return $c_O.prototype.hashCode__I.call(instance)
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0)
  } else {
    return instance.indexOf__I__I(x0)
  }
}
function $dp_indexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I__I(instance, x0, x1)
  } else {
    return instance.indexOf__I__I__I(x0, x1)
  }
}
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0)
  } else {
    return instance.lastIndexOf__I__I(x0)
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance)
  } else {
    return instance.length__I()
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1)
  } else {
    return instance.split__T__I__AT(x0, x1)
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1)
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1)
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance)
  } else {
    return instance.toCharArray__AC()
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString())
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance)
  } else {
    return instance.trim__T()
  }
}
function $intDiv(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 / arg1) | 0)
  }
}
function $intMod(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 % arg1) | 0)
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)))
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc
    };
    superProto = getPrototypeOf(superProto)
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value)
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0)
    }
  };
  throw new TypeError((("super has no setter '" + arg2) + "'."))
}
function $moduleDefault(arg0) {
  return (((arg0 && ((typeof arg0) === "object")) && ("default" in arg0)) ? arg0["default"] : arg0)
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 < 0) || (arg3 < 0)) || (arg4 < 0)) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOfBoundsException(null)
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj)
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj)
      };
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32))
      };
      return biHash
    }
    case "boolean": {
      return (obj ? 1231 : 1237)
    }
    case "undefined": {
      return 0
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description))
    }
    default: {
      if ((obj === null)) {
        return 0
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash)
        };
        return hash
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)))
}
function $bC(arg0) {
  return new $Char(arg0)
}
var $bC0 = $bC(0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"))
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"))
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"))
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"))
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"))
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"))
}
function $uJ(arg0) {
  return (((arg0 instanceof $c_RTLong) || (arg0 === null)) ? ((arg0 === null) ? $L0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"))
}
function $uF(arg0) {
  return (($isFloat(arg0) || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"))
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"))
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"))
}
function $ct_O__($thiz) {
  return $thiz
}
/** @constructor */
function $c_O() {
  /*<skip>*/
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
  /*<skip>*/
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T($uD((i >>> 0)).toString(16)))
});
$c_O.prototype.toString = (function() {
  return this.toString__T()
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null
    }
  } else {
    this.u = arg
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_O.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice())
});
function $ah_O() {
  /*<skip>*/
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false
    }
  } else {
    this.u = arg
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice())
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Uint16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_C.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice())
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int8Array(arg)
  } else {
    this.u = arg
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_B.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice())
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_S.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice())
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_I.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice())
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0
    }
  } else {
    this.u = arg
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_J.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice())
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_F.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice())
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float64Array(arg)
  } else {
    this.u = arg
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_D.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice())
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isJSClass = false;
  this.isInstance = (void 0)
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = {};
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass)
  };
  return this
});
$TypeData.prototype.initClass = (function(internalNameObj, isInterface, fullName, ancestors, isJSType, parentData, isInstance) {
  var internalName = $propertyName(internalNameObj);
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (!(!isJSType));
  this.name = fullName;
  this.isInterface = isInterface;
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  return this
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array)));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null
      }
    } else {
      this.u = arg
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice())
  });
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  ArrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)))
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)))
  });
  return this
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this)
  };
  return this._arrayOf
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this)
  };
  return this._classOf
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that))
});
$TypeData.prototype.checkCast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name)
  }
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null)
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null)
});
$TypeData.prototype.newArrayOfThisClass = (function(lengths) {
  var arrayClassData = this;
  for (var i = 0; (i < lengths.length); (i++)) {
    arrayClassData = arrayClassData.getArrayOf()
  };
  return $newArrayObject(arrayClassData, lengths)
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth))
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))))
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))))
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))))
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))))
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))))
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))))
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))))
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))))
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth)
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Z", depth)
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "C", depth)
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "B", depth)
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "S", depth)
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "I", depth)
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "J", depth)
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "F", depth)
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "D", depth)
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = {
  O: 1
};
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1))
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
/** @constructor */
function $c_Lcats_Always$() {
  /*<skip>*/
}
$c_Lcats_Always$.prototype = new $h_O();
$c_Lcats_Always$.prototype.constructor = $c_Lcats_Always$;
/** @constructor */
function $h_Lcats_Always$() {
  /*<skip>*/
}
$h_Lcats_Always$.prototype = $c_Lcats_Always$.prototype;
$c_Lcats_Always$.prototype.apply__F0__Lcats_Always = (function(a) {
  return new $c_Lcats_Always(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => a$2.apply__O()))(this, a)))
});
var $d_Lcats_Always$ = new $TypeData().initClass({
  Lcats_Always$: 0
}, false, "cats.Always$", {
  Lcats_Always$: 1,
  O: 1
});
$c_Lcats_Always$.prototype.$classData = $d_Lcats_Always$;
var $n_Lcats_Always$;
function $m_Lcats_Always$() {
  if ((!$n_Lcats_Always$)) {
    $n_Lcats_Always$ = new $c_Lcats_Always$()
  };
  return $n_Lcats_Always$
}
/** @constructor */
function $c_Lcats_Eval$FnStack() {
  /*<skip>*/
}
$c_Lcats_Eval$FnStack.prototype = new $h_O();
$c_Lcats_Eval$FnStack.prototype.constructor = $c_Lcats_Eval$FnStack;
/** @constructor */
function $h_Lcats_Eval$FnStack() {
  /*<skip>*/
}
$h_Lcats_Eval$FnStack.prototype = $c_Lcats_Eval$FnStack.prototype;
/** @constructor */
function $c_Lcats_EvalInstances1() {
  /*<skip>*/
}
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
  /*<skip>*/
}
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval($thiz, lb$2, f$19, it) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((this$1, lb$2$2, f$19$2, it$2) => (() => (it$2.hasNext__Z() ? $as_Lcats_Eval(f$19$2.apply__O__O__O(it$2.next__O(), $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval(this$1, lb$2$2, f$19$2, it$2))) : lb$2$2)))($thiz, lb$2, f$19, it));
  return new $c_Lcats_Eval$$anon$5(a)
}
/** @constructor */
function $c_Lcats_Foldable$() {
  this.Lcats_Foldable$__f_cats$Foldable$$$sentinel = null;
  $n_Lcats_Foldable$ = this;
  this.Lcats_Foldable$__f_cats$Foldable$$$sentinel = new $c_Lcats_Foldable$$anon$2()
}
$c_Lcats_Foldable$.prototype = new $h_O();
$c_Lcats_Foldable$.prototype.constructor = $c_Lcats_Foldable$;
/** @constructor */
function $h_Lcats_Foldable$() {
  /*<skip>*/
}
$h_Lcats_Foldable$.prototype = $c_Lcats_Foldable$.prototype;
$c_Lcats_Foldable$.prototype.iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval = (function(iterable, lb, f) {
  return $m_Lcats_Eval$().always__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((this$1, iterable$2) => (() => iterable$2.iterator__sc_Iterator()))(this, iterable))).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((it) => {
    var it$1 = $as_sc_Iterator(it);
    return $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval(this$2, lb$2, f$2, it$1)
  }))(this, lb, f)))
});
var $d_Lcats_Foldable$ = new $TypeData().initClass({
  Lcats_Foldable$: 0
}, false, "cats.Foldable$", {
  Lcats_Foldable$: 1,
  O: 1
});
$c_Lcats_Foldable$.prototype.$classData = $d_Lcats_Foldable$;
var $n_Lcats_Foldable$;
function $m_Lcats_Foldable$() {
  if ((!$n_Lcats_Foldable$)) {
    $n_Lcats_Foldable$ = new $c_Lcats_Foldable$()
  };
  return $n_Lcats_Foldable$
}
/** @constructor */
function $c_Lcats_Foldable$Source() {
  /*<skip>*/
}
$c_Lcats_Foldable$Source.prototype = new $h_O();
$c_Lcats_Foldable$Source.prototype.constructor = $c_Lcats_Foldable$Source;
/** @constructor */
function $h_Lcats_Foldable$Source() {
  /*<skip>*/
}
$h_Lcats_Foldable$Source.prototype = $c_Lcats_Foldable$Source.prototype;
function $as_Lcats_Foldable$Source(obj) {
  return (((obj instanceof $c_Lcats_Foldable$Source) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable$Source"))
}
function $isArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable$Source)))
}
function $asArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (($isArrayOf_Lcats_Foldable$Source(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable$Source;", depth))
}
/** @constructor */
function $c_Lcats_Foldable$Source$() {
  this.Lcats_Foldable$Source$__f_Empty = null;
  $n_Lcats_Foldable$Source$ = this;
  this.Lcats_Foldable$Source$__f_Empty = new $c_Lcats_Foldable$$anon$3()
}
$c_Lcats_Foldable$Source$.prototype = new $h_O();
$c_Lcats_Foldable$Source$.prototype.constructor = $c_Lcats_Foldable$Source$;
/** @constructor */
function $h_Lcats_Foldable$Source$() {
  /*<skip>*/
}
$h_Lcats_Foldable$Source$.prototype = $c_Lcats_Foldable$Source$.prototype;
$c_Lcats_Foldable$Source$.prototype.fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source = (function(fa, F) {
  var value = this.Lcats_Foldable$Source$__f_Empty;
  return $as_Lcats_Foldable$Source(F.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(value), new $c_sjsr_AnonFunction2(((this$2) => ((a, evalSrc) => {
    var evalSrc$1 = $as_Lcats_Eval(evalSrc);
    return $m_Lcats_Later$().apply__F0__Lcats_Later(new $c_sjsr_AnonFunction0(((this$3, a$2, evalSrc$2) => (() => new $c_Lcats_Foldable$$anon$4(a$2, evalSrc$2)))(this$2, a, evalSrc$1)))
  }))(this))).value__O())
});
var $d_Lcats_Foldable$Source$ = new $TypeData().initClass({
  Lcats_Foldable$Source$: 0
}, false, "cats.Foldable$Source$", {
  Lcats_Foldable$Source$: 1,
  O: 1
});
$c_Lcats_Foldable$Source$.prototype.$classData = $d_Lcats_Foldable$Source$;
var $n_Lcats_Foldable$Source$;
function $m_Lcats_Foldable$Source$() {
  if ((!$n_Lcats_Foldable$Source$)) {
    $n_Lcats_Foldable$Source$ = new $c_Lcats_Foldable$Source$()
  };
  return $n_Lcats_Foldable$Source$
}
/** @constructor */
function $c_Lcats_Later$() {
  /*<skip>*/
}
$c_Lcats_Later$.prototype = new $h_O();
$c_Lcats_Later$.prototype.constructor = $c_Lcats_Later$;
/** @constructor */
function $h_Lcats_Later$() {
  /*<skip>*/
}
$h_Lcats_Later$.prototype = $c_Lcats_Later$.prototype;
$c_Lcats_Later$.prototype.apply__F0__Lcats_Later = (function(a) {
  return new $c_Lcats_Later(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => a$2.apply__O()))(this, a)))
});
var $d_Lcats_Later$ = new $TypeData().initClass({
  Lcats_Later$: 0
}, false, "cats.Later$", {
  Lcats_Later$: 1,
  O: 1
});
$c_Lcats_Later$.prototype.$classData = $d_Lcats_Later$;
var $n_Lcats_Later$;
function $m_Lcats_Later$() {
  if ((!$n_Lcats_Later$)) {
    $n_Lcats_Later$ = new $c_Lcats_Later$()
  };
  return $n_Lcats_Later$
}
function $f_Lcats_SemigroupalArityFunctions__map3__O__O__O__F3__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f, semigroupal, functor) {
  return functor.map__O__F1__O(semigroupal.product__O__O__O(f0, semigroupal.product__O__O__O(f1, f2)), new $c_sjsr_AnonFunction1(((f$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x18 = $as_T2(x$1$1._2__O());
      var a0 = x$1$1._1__O();
      if ((x18 !== null)) {
        var a1 = x18._1__O();
        var a2 = x18._2__O();
        return f$2.apply__O__O__O__O(a0, a1, a2)
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f)))
}
/** @constructor */
function $c_Lcats_Show$ShowInterpolator$() {
  /*<skip>*/
}
$c_Lcats_Show$ShowInterpolator$.prototype = new $h_O();
$c_Lcats_Show$ShowInterpolator$.prototype.constructor = $c_Lcats_Show$ShowInterpolator$;
/** @constructor */
function $h_Lcats_Show$ShowInterpolator$() {
  /*<skip>*/
}
$h_Lcats_Show$ShowInterpolator$.prototype = $c_Lcats_Show$ShowInterpolator$.prototype;
$c_Lcats_Show$ShowInterpolator$.prototype.toString__T = (function() {
  return "ShowInterpolator"
});
$c_Lcats_Show$ShowInterpolator$.prototype.show$extension__s_StringContext__sci_Seq__T = (function(this$, args) {
  var f = ((this$1) => ((str) => {
    var str$1 = $as_T(str);
    return $m_s_StringContext$().processEscapes__T__T(str$1)
  }))(this);
  var parts = this$.s_StringContext__f_parts;
  $m_s_StringContext$().checkLengths__sc_Seq__sci_Seq__V(args, parts);
  var pi = parts.iterator__sc_Iterator();
  var ai = args.iterator__sc_Iterator();
  var arg1 = pi.next__O();
  var bldr = $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), $as_T(f(arg1)));
  while (ai.hasNext__Z()) {
    var obj = ai.next__O();
    bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var arg1$1 = pi.next__O();
    var str$2 = $as_T(f(arg1$1));
    bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2)
  };
  return bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Lcats_Show$ShowInterpolator$ = new $TypeData().initClass({
  Lcats_Show$ShowInterpolator$: 0
}, false, "cats.Show$ShowInterpolator$", {
  Lcats_Show$ShowInterpolator$: 1,
  O: 1
});
$c_Lcats_Show$ShowInterpolator$.prototype.$classData = $d_Lcats_Show$ShowInterpolator$;
var $n_Lcats_Show$ShowInterpolator$;
function $m_Lcats_Show$ShowInterpolator$() {
  if ((!$n_Lcats_Show$ShowInterpolator$)) {
    $n_Lcats_Show$ShowInterpolator$ = new $c_Lcats_Show$ShowInterpolator$()
  };
  return $n_Lcats_Show$ShowInterpolator$
}
/** @constructor */
function $c_Lcats_Show$Shown$() {
  /*<skip>*/
}
$c_Lcats_Show$Shown$.prototype = new $h_O();
$c_Lcats_Show$Shown$.prototype.constructor = $c_Lcats_Show$Shown$;
/** @constructor */
function $h_Lcats_Show$Shown$() {
  /*<skip>*/
}
$h_Lcats_Show$Shown$.prototype = $c_Lcats_Show$Shown$.prototype;
$c_Lcats_Show$Shown$.prototype.toString__T = (function() {
  return "Shown"
});
$c_Lcats_Show$Shown$.prototype.mat__O__Lcats_Show$ContravariantShow__T = (function(x, z) {
  var toString = z.show__O__T(x);
  return toString
});
$c_Lcats_Show$Shown$.prototype.equals$extension__T__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcats_Show$Shown)) {
    var x$0$2 = ((x$0 === null) ? null : $as_Lcats_Show$Shown(x$0).Lcats_Show$Shown__f_toString);
    return (this$ === x$0$2)
  } else {
    return false
  }
});
$c_Lcats_Show$Shown$.prototype.productElement$extension__T__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_Show$Shown$ = new $TypeData().initClass({
  Lcats_Show$Shown$: 0
}, false, "cats.Show$Shown$", {
  Lcats_Show$Shown$: 1,
  O: 1
});
$c_Lcats_Show$Shown$.prototype.$classData = $d_Lcats_Show$Shown$;
var $n_Lcats_Show$Shown$;
function $m_Lcats_Show$Shown$() {
  if ((!$n_Lcats_Show$Shown$)) {
    $n_Lcats_Show$Shown$ = new $c_Lcats_Show$Shown$()
  };
  return $n_Lcats_Show$Shown$
}
/** @constructor */
function $c_Lcats_data_AndThenInstances1() {
  /*<skip>*/
}
$c_Lcats_data_AndThenInstances1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances1.prototype.constructor = $c_Lcats_data_AndThenInstances1;
/** @constructor */
function $h_Lcats_data_AndThenInstances1() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances1.prototype = $c_Lcats_data_AndThenInstances1.prototype;
/** @constructor */
function $c_Lcats_data_Chain() {
  /*<skip>*/
}
$c_Lcats_data_Chain.prototype = new $h_O();
$c_Lcats_data_Chain.prototype.constructor = $c_Lcats_data_Chain;
/** @constructor */
function $h_Lcats_data_Chain() {
  /*<skip>*/
}
$h_Lcats_data_Chain.prototype = $c_Lcats_data_Chain.prototype;
$c_Lcats_data_Chain.prototype.uncons__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(this);
    var c = non;
    var rights = null;
    var result = null;
    while ((result === null)) {
      var x3 = c;
      if ((x3 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x3);
        var x13 = x$1.Lcats_data_Chain$Singleton__f_a;
        var next = ((rights === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : rights);
        result = $ct_T2__O__O__(new $c_T2(), x13, next);
        continue
      };
      if ((x3 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x3);
        var x9 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
        var x10 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
        if ((rights === null)) {
          rights = x10
        } else {
          var rightNE = rights;
          rights = new $c_Lcats_data_Chain$Append(x10, rightNE)
        };
        c = x9;
        continue
      };
      if ((x3 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x3);
        var x6 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
        var tail = $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain($as_sci_Seq(x6.tail__O()));
        if ((rights === null)) {
          var next$2 = tail
        } else if ((tail instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var non$2 = $as_Lcats_data_Chain$NonEmpty(tail);
          var rightNE$1 = rights;
          var next$2 = new $c_Lcats_data_Chain$Append(non$2, rightNE$1)
        } else {
          var next$2 = rights
        };
        var _1 = x6.head__O();
        result = $ct_T2__O__O__(new $c_T2(), _1, next$2);
        continue
      };
      throw new $c_s_MatchError(x3)
    };
    var value = result;
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_data_Chain.prototype.isEmpty__Z = (function() {
  return (!(this instanceof $c_Lcats_data_Chain$NonEmpty))
});
$c_Lcats_data_Chain.prototype.append__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this, ($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)))
});
$c_Lcats_data_Chain.prototype.map__F1__Lcats_data_Chain = (function(f) {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x34 = x$1.Lcats_data_Chain$Wrap__f_seq;
    var seq = $as_sci_Seq(x34.map__F1__O(f));
    return new $c_Lcats_data_Chain$Wrap(seq)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$3 = this.iterator__sc_Iterator();
    var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
    return $$x1.fromSeq__sci_Seq__Lcats_data_Chain($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$4))
  }
});
$c_Lcats_data_Chain.prototype.flatMap__F1__Lcats_data_Chain = (function(f) {
  var this$1 = $m_Lcats_data_Chain$();
  var result = this$1.Lcats_data_Chain$__f_nil;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var this$2 = result;
    var c = $as_Lcats_data_Chain(f.apply__O__O(iter.next__O()));
    result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c)
  };
  return result
});
$c_Lcats_data_Chain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x84 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x84.iterator__sc_Iterator()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x81 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    $m_s_package$();
    return new $c_sc_Iterator$$anon$20(x81)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    return new $c_Lcats_data_Chain$ChainIterator(app)
  } else {
    return $m_s_package$().s_package$__f_Iterator.sc_Iterator$__f_scala$collection$Iterator$$_empty
  }
});
$c_Lcats_data_Chain.prototype.toList__sci_List = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x100 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x100.toList__sci_List()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x97 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    var this$3 = $m_s_package$().s_package$__f_Nil;
    return new $c_sci_$colon$colon(x97, this$3)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$4 = new $c_Lcats_data_Chain$ChainIterator(app);
    $m_sci_List$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4)
  } else {
    return $m_s_package$().s_package$__f_Nil
  }
});
$c_Lcats_data_Chain.prototype.toVector__sci_Vector = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x108 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x108.toVector__sci_Vector()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x105 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    $m_s_package$();
    var this$4 = $m_sci_Vector0$();
    return this$4.appended__O__sci_Vector(x105)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$5 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$5)
  } else {
    $m_s_package$();
    return $m_sci_Vector0$()
  }
});
$c_Lcats_data_Chain.prototype.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z = (function(that, A) {
  if ((this === that)) {
    return true
  } else {
    var iterX = this.iterator__sc_Iterator();
    var iterY = that.iterator__sc_Iterator();
    while ((iterX.hasNext__Z() && iterY.hasNext__Z())) {
      if ((!A.eqv__O__O__Z(iterX.next__O(), iterY.next__O()))) {
        return false
      }
    };
    return (iterX.hasNext__Z() === iterY.hasNext__Z())
  }
});
$c_Lcats_data_Chain.prototype.show__Lcats_Show__T = (function(AA) {
  var builder = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), "Chain(");
  var first = new $c_sr_BooleanRef(true);
  var f = ((AA$2, builder$2, first$2) => ((a) => {
    if (first$2.sr_BooleanRef__f_elem) {
      var s = AA$2.show__O__T(a);
      builder$2.addAll__T__scm_StringBuilder(s);
      first$2.sr_BooleanRef__f_elem = false
    } else {
      var s$1 = (", " + AA$2.show__O__T(a));
      builder$2.addAll__T__scm_StringBuilder(s$1)
    };
    return false
  }))(AA, builder, first);
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non = $as_Lcats_data_Chain$NonEmpty(this);
      var c = non;
      var rights = $m_s_package$().s_package$__f_Nil;
      while ((c !== null)) {
        var x64 = c;
        if ((x64 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x$1 = $as_Lcats_data_Chain$Singleton(x64);
          var x74 = x$1.Lcats_data_Chain$Singleton__f_a;
          var b = $uZ(f(x74));
          if (b) {
            break
          };
          if (rights.isEmpty__Z()) {
            c = null
          } else {
            var head = $as_Lcats_data_Chain$NonEmpty(rights.head__O());
            rights = $as_sci_List(rights.tail__O());
            c = head
          };
          continue
        };
        if ((x64 instanceof $c_Lcats_data_Chain$Append)) {
          var x$1$1 = $as_Lcats_data_Chain$Append(x64);
          var x70 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
          var x71 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
          var this$4 = rights;
          rights = new $c_sci_$colon$colon(x71, this$4);
          c = x70;
          continue
        };
        if ((x64 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x$1$2 = $as_Lcats_data_Chain$Wrap(x64);
          var x67 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
          var iterator = x67.iterator__sc_Iterator();
          while (iterator.hasNext__Z()) {
            var arg1 = iterator.next__O();
            var b$2 = $uZ(f(arg1));
            if (b$2) {
              break _return
            }
          };
          if (rights.isEmpty__Z()) {
            c = null
          } else {
            var head$2 = $as_Lcats_data_Chain$NonEmpty(rights.head__O());
            rights = $as_sci_List(rights.tail__O());
            c = head$2
          };
          continue
        };
        throw new $c_s_MatchError(x64)
      }
    }
  };
  builder.addOne__C__scm_StringBuilder(41);
  return builder.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lcats_data_Chain.prototype.toString__T = (function() {
  $m_Lcats_Show$();
  var f = new $c_sjsr_AnonFunction1(((_$4) => $dp_toString__T(_$4)));
  return this.show__Lcats_Show__T(new $c_Lcats_Show$$anon$3(f))
});
$c_Lcats_data_Chain.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lcats_data_Chain)) {
    var thatChain = $as_Lcats_data_Chain(o);
    return this.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z(thatChain, ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$5()))
  } else {
    return false
  }
});
$c_Lcats_data_Chain.prototype.hashCode__I = (function() {
  $m_Lcats_package$();
  var hashA = new $c_Lcats_kernel_Hash$$anon$3();
  return $m_Lcats_kernel_instances_StaticMethods$().orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I(this.iterator__sc_Iterator(), hashA)
});
function $as_Lcats_data_Chain(obj) {
  return (((obj instanceof $c_Lcats_data_Chain) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain"))
}
function $isArrayOf_Lcats_data_Chain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain)))
}
function $asArrayOf_Lcats_data_Chain(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain;", depth))
}
/** @constructor */
function $c_Lcats_data_ChainInstances3() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances3.prototype = new $h_O();
$c_Lcats_data_ChainInstances3.prototype.constructor = $c_Lcats_data_ChainInstances3;
/** @constructor */
function $h_Lcats_data_ChainInstances3() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances3.prototype = $c_Lcats_data_ChainInstances3.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances2() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances2.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances2.prototype.constructor = $c_Lcats_data_ValidatedInstances2;
/** @constructor */
function $h_Lcats_data_ValidatedInstances2() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances2.prototype = $c_Lcats_data_ValidatedInstances2.prototype;
function $f_Lcats_data_WriterTFunctions__putT__O__O__Lcats_Functor__Lcats_data_WriterT($thiz, vf, l, functorF) {
  var run = functorF.map__O__F1__O(vf, new $c_sjsr_AnonFunction1(((l$2) => ((v) => $ct_T2__O__O__(new $c_T2(), l$2, v)))(l)));
  return new $c_Lcats_data_WriterT(run)
}
function $f_Lcats_data_WriterTFunctions__put__O__O__Lcats_Applicative__Lcats_data_WriterT($thiz, v, l, applicativeF) {
  var this$1 = $m_Lcats_data_WriterT$();
  var vf = applicativeF.pure__O__O(v);
  return $f_Lcats_data_WriterTFunctions__putT__O__O__Lcats_Functor__Lcats_data_WriterT(this$1, vf, l, applicativeF)
}
/** @constructor */
function $c_Lcats_data_WriterTInstances13() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances13.prototype = new $h_O();
$c_Lcats_data_WriterTInstances13.prototype.constructor = $c_Lcats_data_WriterTInstances13;
/** @constructor */
function $h_Lcats_data_WriterTInstances13() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances13.prototype = $c_Lcats_data_WriterTInstances13.prototype;
/** @constructor */
function $c_Lcats_data_package$Writer$() {
  /*<skip>*/
}
$c_Lcats_data_package$Writer$.prototype = new $h_O();
$c_Lcats_data_package$Writer$.prototype.constructor = $c_Lcats_data_package$Writer$;
/** @constructor */
function $h_Lcats_data_package$Writer$() {
  /*<skip>*/
}
$h_Lcats_data_package$Writer$.prototype = $c_Lcats_data_package$Writer$.prototype;
$c_Lcats_data_package$Writer$.prototype.apply__O__O__Lcats_data_WriterT = (function(l, v) {
  var run = $ct_T2__O__O__(new $c_T2(), l, v);
  return new $c_Lcats_data_WriterT(run)
});
var $d_Lcats_data_package$Writer$ = new $TypeData().initClass({
  Lcats_data_package$Writer$: 0
}, false, "cats.data.package$Writer$", {
  Lcats_data_package$Writer$: 1,
  O: 1
});
$c_Lcats_data_package$Writer$.prototype.$classData = $d_Lcats_data_package$Writer$;
var $n_Lcats_data_package$Writer$;
function $m_Lcats_data_package$Writer$() {
  if ((!$n_Lcats_data_package$Writer$)) {
    $n_Lcats_data_package$Writer$ = new $c_Lcats_data_package$Writer$()
  };
  return $n_Lcats_data_package$Writer$
}
function $f_Lcats_instances_InvariantInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$1());
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$2())
}
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1());
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$2())
}
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_compat_HashCompat() {
  /*<skip>*/
}
$c_Lcats_kernel_compat_HashCompat.prototype = new $h_O();
$c_Lcats_kernel_compat_HashCompat.prototype.constructor = $c_Lcats_kernel_compat_HashCompat;
/** @constructor */
function $h_Lcats_kernel_compat_HashCompat() {
  /*<skip>*/
}
$h_Lcats_kernel_compat_HashCompat.prototype = $c_Lcats_kernel_compat_HashCompat.prototype;
$c_Lcats_kernel_compat_HashCompat.prototype.orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I = (function(xs, A) {
  var it = xs.iterator__sc_Iterator();
  var h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_seqSeed;
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 0)
  };
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(x0)), 1)
  };
  var x1 = it.next__O();
  var initial = A.hash__O__I(x0);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, initial);
  var h0 = h;
  var prev = A.hash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, prev);
    var hash = A.hash__O__I(it.next__O());
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(it.next__O()));
        i = ((1 + i) | 0)
      };
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.avalanche__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h0, rangeDiff), prev))
});
$c_Lcats_kernel_compat_HashCompat.prototype.avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigDecimalOrder());
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigDecimalGroup())
}
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigIntOrder());
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigIntGroup())
}
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BitSetPartialOrder());
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_BitSetSemilattice())
}
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ByteOrder());
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ByteGroup())
}
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DoubleOrder());
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DoubleGroup())
}
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DurationOrder());
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DurationGroup())
}
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FiniteDurationOrder());
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FiniteDurationGroup())
}
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FloatOrder());
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FloatGroup())
}
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_IntOrder());
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_IntGroup())
}
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup())
}
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ShortOrder());
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ShortGroup())
}
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_StringOrder());
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V(new $c_Lcats_kernel_instances_StringMonoid())
}
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_UnitOrder());
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_UnitAlgebra())
}
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_catsRepresentableForId = null;
  this.Lcats_package$__f_catsParallelForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Comparison = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  this.Lcats_package$__f_Monoid = null;
  this.Lcats_package$__f_Group = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  this.Lcats_package$__f_catsRepresentableForId = new $c_Lcats_package$$anon$2();
  $m_Lcats_Invariant$();
  var evidence$31 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lcats_package$__f_catsParallelForId = new $c_Lcats_Parallel$$anon$2(evidence$31);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  this.Lcats_package$__f_Comparison = $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$();
  this.Lcats_package$__f_Monoid = $m_Lcats_kernel_Monoid$();
  this.Lcats_package$__f_Group = $m_Lcats_kernel_Group$()
}
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
  /*<skip>*/
}
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass({
  Lcats_package$: 0
}, false, "cats.package$", {
  Lcats_package$: 1,
  O: 1
});
$c_Lcats_package$.prototype.$classData = $d_Lcats_package$;
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$()
  };
  return $n_Lcats_package$
}
/** @constructor */
function $c_Lcats_syntax_ApplicativeErrorOps$() {
  /*<skip>*/
}
$c_Lcats_syntax_ApplicativeErrorOps$.prototype = new $h_O();
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.constructor = $c_Lcats_syntax_ApplicativeErrorOps$;
/** @constructor */
function $h_Lcats_syntax_ApplicativeErrorOps$() {
  /*<skip>*/
}
$h_Lcats_syntax_ApplicativeErrorOps$.prototype = $c_Lcats_syntax_ApplicativeErrorOps$.prototype;
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.orElse$extension__O__F0__Lcats_ApplicativeError__O = (function(this$, other, F) {
  return F.handleErrorWith__O__F1__O(this$, new $c_sjsr_AnonFunction1(((this$1, other$2) => ((_$6) => other$2.apply__O()))(this, other)))
});
var $d_Lcats_syntax_ApplicativeErrorOps$ = new $TypeData().initClass({
  Lcats_syntax_ApplicativeErrorOps$: 0
}, false, "cats.syntax.ApplicativeErrorOps$", {
  Lcats_syntax_ApplicativeErrorOps$: 1,
  O: 1
});
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.$classData = $d_Lcats_syntax_ApplicativeErrorOps$;
var $n_Lcats_syntax_ApplicativeErrorOps$;
function $m_Lcats_syntax_ApplicativeErrorOps$() {
  if ((!$n_Lcats_syntax_ApplicativeErrorOps$)) {
    $n_Lcats_syntax_ApplicativeErrorOps$ = new $c_Lcats_syntax_ApplicativeErrorOps$()
  };
  return $n_Lcats_syntax_ApplicativeErrorOps$
}
/** @constructor */
function $c_Lcats_syntax_EitherUtil$() {
  this.Lcats_syntax_EitherUtil$__f_unit = null;
  $n_Lcats_syntax_EitherUtil$ = this;
  this.Lcats_syntax_EitherUtil$__f_unit = ($m_s_package$(), new $c_s_util_Right((void 0)))
}
$c_Lcats_syntax_EitherUtil$.prototype = new $h_O();
$c_Lcats_syntax_EitherUtil$.prototype.constructor = $c_Lcats_syntax_EitherUtil$;
/** @constructor */
function $h_Lcats_syntax_EitherUtil$() {
  /*<skip>*/
}
$h_Lcats_syntax_EitherUtil$.prototype = $c_Lcats_syntax_EitherUtil$.prototype;
var $d_Lcats_syntax_EitherUtil$ = new $TypeData().initClass({
  Lcats_syntax_EitherUtil$: 0
}, false, "cats.syntax.EitherUtil$", {
  Lcats_syntax_EitherUtil$: 1,
  O: 1
});
$c_Lcats_syntax_EitherUtil$.prototype.$classData = $d_Lcats_syntax_EitherUtil$;
var $n_Lcats_syntax_EitherUtil$;
function $m_Lcats_syntax_EitherUtil$() {
  if ((!$n_Lcats_syntax_EitherUtil$)) {
    $n_Lcats_syntax_EitherUtil$ = new $c_Lcats_syntax_EitherUtil$()
  };
  return $n_Lcats_syntax_EitherUtil$
}
/** @constructor */
function $c_Ldiffson_circe_package$() {
  this.Ldiffson_circe_package$__f_pointerEncoder = null;
  this.Ldiffson_circe_package$__f_pointerDecoder = null;
  this.Ldiffson_circe_package$__f_operationEncoder = null;
  this.Ldiffson_circe_package$__f_operationDecoder = null;
  this.Ldiffson_circe_package$__f_jsonPatchEncoder = null;
  this.Ldiffson_circe_package$__f_jsonPatchDecoder = null;
  this.Ldiffson_circe_package$__f_jsonMergePatchEncoder = null;
  this.Ldiffson_circe_package$__f_jsonMergePatchDecoder = null;
  $n_Ldiffson_circe_package$ = this;
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((_$2) => {
    var _$2$1 = ((_$2 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(_$2).Ldiffson_jsonpointer_package$Pointer__f_parts);
    $m_Lcats_implicits$();
    var target = new $c_Ldiffson_jsonpointer_package$Pointer(_$2$1);
    var tc = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
    var this$4 = new $c_Lcats_Show$$anon$2(target, tc);
    return this$4.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$4.Lcats_Show$$anon$2__f_self)
  }))(this));
  this.Ldiffson_circe_package$__f_pointerEncoder = new $c_Lio_circe_Encoder$$anon$1(f, instance);
  $m_Lio_circe_Decoder$();
  var instance$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var f$1 = new $c_sjsr_AnonFunction1(((this$2$1) => ((_$4) => {
    var _$4$1 = $as_T(_$4);
    $m_Lcats_implicits$();
    var eab = $as_s_util_Either($m_Ldiffson_jsonpointer_package$Pointer$().parse__T__Lcats_MonadError__O(_$4$1, ($m_Lcats_implicits$(), new $c_Lcats_instances_EitherInstances$$anon$2())));
    if ((eab instanceof $c_s_util_Left)) {
      var a = $as_s_util_Left(eab).s_util_Left__f_value;
      $m_s_package$();
      var _$5 = $as_jl_Throwable(a);
      var value = _$5.getMessage__T();
      return new $c_s_util_Left(value)
    };
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      return r
    };
    throw new $c_s_MatchError(eab)
  }))(this));
  this.Ldiffson_circe_package$__f_pointerDecoder = new $c_Lio_circe_Decoder$$anon$13(f$1, instance$1);
  $m_Lio_circe_Encoder$();
  var f$2 = new $c_sjsr_AnonFunction1(((this$3$1) => ((x$1) => {
    var x$1$1 = $as_Ldiffson_jsonpatch_Operation(x$1);
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Add)) {
      var x$1$2 = $as_Ldiffson_jsonpatch_Add(x$1$1);
      var x38 = x$1$2.Ldiffson_jsonpatch_Add__f_path;
      var x39 = $as_Lio_circe_Json(x$1$2.Ldiffson_jsonpatch_Add__f_value);
      var this$24 = $m_Lio_circe_Json$();
      var $$x2 = $m_sr_ScalaRunTime$();
      $m_Lio_circe_Json$();
      var y = new $c_Lio_circe_Json$JString("add");
      var $$x1 = $ct_T2__O__O__(new $c_T2(), "op", y);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$1 = new $c_Ldiffson_jsonpointer_package$Pointer(x38);
      var tc$1 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$18 = new $c_Lcats_Show$$anon$2(target$1, tc$1);
      var value$1 = this$18.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$18.Lcats_Show$$anon$2__f_self);
      var y$1 = new $c_Lio_circe_Json$JString(value$1);
      var fields = $$x2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x1, $ct_T2__O__O__(new $c_T2(), "path", y$1), $ct_T2__O__O__(new $c_T2(), "value", x39)]));
      return this$24.fromFields__sc_Iterable__Lio_circe_Json(fields)
    };
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Remove)) {
      var x$1$3 = $as_Ldiffson_jsonpatch_Remove(x$1$1);
      var x32 = x$1$3.Ldiffson_jsonpatch_Remove__f_path;
      var x33 = x$1$3.Ldiffson_jsonpatch_Remove__f_old;
      if ((x33 instanceof $c_s_Some)) {
        var old = $as_Lio_circe_Json($as_s_Some(x33).s_Some__f_value);
        var this$38 = $m_Lio_circe_Json$();
        var $$x4 = $m_sr_ScalaRunTime$();
        $m_Lio_circe_Json$();
        var y$2 = new $c_Lio_circe_Json$JString("remove");
        var $$x3 = $ct_T2__O__O__(new $c_T2(), "op", y$2);
        $m_Lio_circe_Json$();
        $m_Lcats_implicits$();
        var target$2 = new $c_Ldiffson_jsonpointer_package$Pointer(x32);
        var tc$2 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
        var this$32 = new $c_Lcats_Show$$anon$2(target$2, tc$2);
        var value$2 = this$32.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$32.Lcats_Show$$anon$2__f_self);
        var y$3 = new $c_Lio_circe_Json$JString(value$2);
        var fields$1 = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x3, $ct_T2__O__O__(new $c_T2(), "path", y$3), $ct_T2__O__O__(new $c_T2(), "old", old)]));
        return this$38.fromFields__sc_Iterable__Lio_circe_Json(fields$1)
      };
      var x = $m_s_None$();
      if ((x === x33)) {
        var this$49 = $m_Lio_circe_Json$();
        var $$x6 = $m_sr_ScalaRunTime$();
        $m_Lio_circe_Json$();
        var y$4 = new $c_Lio_circe_Json$JString("remove");
        var $$x5 = $ct_T2__O__O__(new $c_T2(), "op", y$4);
        $m_Lio_circe_Json$();
        $m_Lcats_implicits$();
        var target$3 = new $c_Ldiffson_jsonpointer_package$Pointer(x32);
        var tc$3 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
        var this$45 = new $c_Lcats_Show$$anon$2(target$3, tc$3);
        var value$3 = this$45.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$45.Lcats_Show$$anon$2__f_self);
        var y$5 = new $c_Lio_circe_Json$JString(value$3);
        var fields$2 = $$x6.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x5, $ct_T2__O__O__(new $c_T2(), "path", y$5)]));
        return this$49.fromFields__sc_Iterable__Lio_circe_Json(fields$2)
      }
    };
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Replace)) {
      var x$1$4 = $as_Ldiffson_jsonpatch_Replace(x$1$1);
      var x21 = x$1$4.Ldiffson_jsonpatch_Replace__f_path;
      var x22 = $as_Lio_circe_Json(x$1$4.Ldiffson_jsonpatch_Replace__f_value);
      var x23 = x$1$4.Ldiffson_jsonpatch_Replace__f_old;
      if ((x23 instanceof $c_s_Some)) {
        var old$2 = $as_Lio_circe_Json($as_s_Some(x23).s_Some__f_value);
        var this$65 = $m_Lio_circe_Json$();
        var $$x8 = $m_sr_ScalaRunTime$();
        $m_Lio_circe_Json$();
        var y$6 = new $c_Lio_circe_Json$JString("replace");
        var $$x7 = $ct_T2__O__O__(new $c_T2(), "op", y$6);
        $m_Lio_circe_Json$();
        $m_Lcats_implicits$();
        var target$4 = new $c_Ldiffson_jsonpointer_package$Pointer(x21);
        var tc$4 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
        var this$57 = new $c_Lcats_Show$$anon$2(target$4, tc$4);
        var value$4 = this$57.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$57.Lcats_Show$$anon$2__f_self);
        var y$7 = new $c_Lio_circe_Json$JString(value$4);
        var fields$3 = $$x8.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x7, $ct_T2__O__O__(new $c_T2(), "path", y$7), $ct_T2__O__O__(new $c_T2(), "value", x22), $ct_T2__O__O__(new $c_T2(), "old", old$2)]));
        return this$65.fromFields__sc_Iterable__Lio_circe_Json(fields$3)
      };
      var x$3 = $m_s_None$();
      if ((x$3 === x23)) {
        var this$78 = $m_Lio_circe_Json$();
        var $$x10 = $m_sr_ScalaRunTime$();
        $m_Lio_circe_Json$();
        var y$8 = new $c_Lio_circe_Json$JString("replace");
        var $$x9 = $ct_T2__O__O__(new $c_T2(), "op", y$8);
        $m_Lio_circe_Json$();
        $m_Lcats_implicits$();
        var target$5 = new $c_Ldiffson_jsonpointer_package$Pointer(x21);
        var tc$5 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
        var this$72 = new $c_Lcats_Show$$anon$2(target$5, tc$5);
        var value$5 = this$72.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$72.Lcats_Show$$anon$2__f_self);
        var y$9 = new $c_Lio_circe_Json$JString(value$5);
        var fields$4 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $ct_T2__O__O__(new $c_T2(), "path", y$9), $ct_T2__O__O__(new $c_T2(), "value", x22)]));
        return this$78.fromFields__sc_Iterable__Lio_circe_Json(fields$4)
      }
    };
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Move)) {
      var x$1$5 = $as_Ldiffson_jsonpatch_Move(x$1$1);
      var x12 = x$1$5.Ldiffson_jsonpatch_Move__f_from;
      var x13 = x$1$5.Ldiffson_jsonpatch_Move__f_path;
      var this$96 = $m_Lio_circe_Json$();
      var $$x13 = $m_sr_ScalaRunTime$();
      $m_Lio_circe_Json$();
      var y$10 = new $c_Lio_circe_Json$JString("move");
      var $$x12 = $ct_T2__O__O__(new $c_T2(), "op", y$10);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$6 = new $c_Ldiffson_jsonpointer_package$Pointer(x12);
      var tc$6 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$86 = new $c_Lcats_Show$$anon$2(target$6, tc$6);
      var value$6 = this$86.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$86.Lcats_Show$$anon$2__f_self);
      var y$11 = new $c_Lio_circe_Json$JString(value$6);
      var $$x11 = $ct_T2__O__O__(new $c_T2(), "from", y$11);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$7 = new $c_Ldiffson_jsonpointer_package$Pointer(x13);
      var tc$7 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$92 = new $c_Lcats_Show$$anon$2(target$7, tc$7);
      var value$7 = this$92.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$92.Lcats_Show$$anon$2__f_self);
      var y$12 = new $c_Lio_circe_Json$JString(value$7);
      var fields$5 = $$x13.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "path", y$12)]));
      return this$96.fromFields__sc_Iterable__Lio_circe_Json(fields$5)
    };
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Copy)) {
      var x$1$6 = $as_Ldiffson_jsonpatch_Copy(x$1$1);
      var x8 = x$1$6.Ldiffson_jsonpatch_Copy__f_from;
      var x9 = x$1$6.Ldiffson_jsonpatch_Copy__f_path;
      var this$114 = $m_Lio_circe_Json$();
      var $$x16 = $m_sr_ScalaRunTime$();
      $m_Lio_circe_Json$();
      var y$13 = new $c_Lio_circe_Json$JString("copy");
      var $$x15 = $ct_T2__O__O__(new $c_T2(), "op", y$13);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$8 = new $c_Ldiffson_jsonpointer_package$Pointer(x8);
      var tc$8 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$104 = new $c_Lcats_Show$$anon$2(target$8, tc$8);
      var value$8 = this$104.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$104.Lcats_Show$$anon$2__f_self);
      var y$14 = new $c_Lio_circe_Json$JString(value$8);
      var $$x14 = $ct_T2__O__O__(new $c_T2(), "from", y$14);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$9 = new $c_Ldiffson_jsonpointer_package$Pointer(x9);
      var tc$9 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$110 = new $c_Lcats_Show$$anon$2(target$9, tc$9);
      var value$9 = this$110.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$110.Lcats_Show$$anon$2__f_self);
      var y$15 = new $c_Lio_circe_Json$JString(value$9);
      var fields$6 = $$x16.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x15, $$x14, $ct_T2__O__O__(new $c_T2(), "path", y$15)]));
      return this$114.fromFields__sc_Iterable__Lio_circe_Json(fields$6)
    };
    if ((x$1$1 instanceof $c_Ldiffson_jsonpatch_Test)) {
      var x$1$7 = $as_Ldiffson_jsonpatch_Test(x$1$1);
      var x4 = x$1$7.Ldiffson_jsonpatch_Test__f_path;
      var x5 = $as_Lio_circe_Json(x$1$7.Ldiffson_jsonpatch_Test__f_value);
      var this$128 = $m_Lio_circe_Json$();
      var $$x18 = $m_sr_ScalaRunTime$();
      $m_Lio_circe_Json$();
      var y$16 = new $c_Lio_circe_Json$JString("test");
      var $$x17 = $ct_T2__O__O__(new $c_T2(), "op", y$16);
      $m_Lio_circe_Json$();
      $m_Lcats_implicits$();
      var target$10 = new $c_Ldiffson_jsonpointer_package$Pointer(x4);
      var tc$10 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show;
      var this$122 = new $c_Lcats_Show$$anon$2(target$10, tc$10);
      var value$10 = this$122.Lcats_Show$$anon$2__f_typeClassInstance.show__O__T(this$122.Lcats_Show$$anon$2__f_self);
      var y$17 = new $c_Lio_circe_Json$JString(value$10);
      var fields$7 = $$x18.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x17, $ct_T2__O__O__(new $c_T2(), "path", y$17), $ct_T2__O__O__(new $c_T2(), "value", x5)]));
      return this$128.fromFields__sc_Iterable__Lio_circe_Json(fields$7)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this));
  this.Ldiffson_circe_package$__f_operationEncoder = new $c_Lio_circe_Encoder$$anon$20(f$2);
  this.Ldiffson_circe_package$__f_operationDecoder = new $c_Ldiffson_circe_package$$anon$1();
  $m_Lio_circe_Encoder$();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJson;
  var instance$2 = new $c_Lio_circe_Encoder$$anon$26(encodeA);
  var f$4 = new $c_sjsr_AnonFunction1(((this$4$1) => ((_$13) => {
    var _$13$1 = $as_Ldiffson_jsonpatch_JsonPatch(_$13);
    var this$135 = _$13$1.Ldiffson_jsonpatch_JsonPatch__f_ops;
    var f$3 = ((this$132) => ((_$14) => {
      var _$14$1 = $as_Ldiffson_jsonpatch_Operation(_$14);
      var encoder = this$132.Ldiffson_circe_package$__f_operationEncoder;
      return encoder.apply__O__Lio_circe_Json(_$14$1)
    }))(this$4$1);
    if ((this$135 === $m_sci_Nil$())) {
      return $m_sci_Nil$()
    } else {
      var arg1 = this$135.head__O();
      var h = new $c_sci_$colon$colon(f$3(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$135.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f$3(arg1$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List(rest.tail__O())
      };
      return h
    }
  }))(this));
  this.Ldiffson_circe_package$__f_jsonPatchEncoder = new $c_Lio_circe_Encoder$$anon$1(f$4, instance$2);
  this.Ldiffson_circe_package$__f_jsonPatchDecoder = new $c_Ldiffson_circe_package$$anon$2();
  $m_Lio_circe_Encoder$();
  var f$5 = new $c_sjsr_AnonFunction1(((this$5$1) => ((_$17) => {
    var _$17$1 = $as_Ldiffson_jsonmergepatch_JsonMergePatch(_$17);
    return $as_Lio_circe_Json(_$17$1.toJson__O())
  }))(this));
  this.Ldiffson_circe_package$__f_jsonMergePatchEncoder = new $c_Lio_circe_Encoder$$anon$20(f$5);
  this.Ldiffson_circe_package$__f_jsonMergePatchDecoder = new $c_Ldiffson_circe_package$$anon$3()
}
$c_Ldiffson_circe_package$.prototype = new $h_O();
$c_Ldiffson_circe_package$.prototype.constructor = $c_Ldiffson_circe_package$;
/** @constructor */
function $h_Ldiffson_circe_package$() {
  /*<skip>*/
}
$h_Ldiffson_circe_package$.prototype = $c_Ldiffson_circe_package$.prototype;
var $d_Ldiffson_circe_package$ = new $TypeData().initClass({
  Ldiffson_circe_package$: 0
}, false, "diffson.circe.package$", {
  Ldiffson_circe_package$: 1,
  O: 1
});
$c_Ldiffson_circe_package$.prototype.$classData = $d_Ldiffson_circe_package$;
var $n_Ldiffson_circe_package$;
function $m_Ldiffson_circe_package$() {
  if ((!$n_Ldiffson_circe_package$)) {
    $n_Ldiffson_circe_package$ = new $c_Ldiffson_circe_package$()
  };
  return $n_Ldiffson_circe_package$
}
function $is_Ldiffson_jsonmergepatch_JsonMergePatch(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiffson_jsonmergepatch_JsonMergePatch)))
}
function $as_Ldiffson_jsonmergepatch_JsonMergePatch(obj) {
  return (($is_Ldiffson_jsonmergepatch_JsonMergePatch(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonmergepatch.JsonMergePatch"))
}
function $isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonmergepatch_JsonMergePatch)))
}
function $asArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonmergepatch.JsonMergePatch;", depth))
}
function $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__($thiz, evidence$1) {
  $thiz.Ldiffson_jsonpatch_Operation__f_evidence$1 = evidence$1;
  return $thiz
}
/** @constructor */
function $c_Ldiffson_jsonpatch_Operation() {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null
}
$c_Ldiffson_jsonpatch_Operation.prototype = new $h_O();
$c_Ldiffson_jsonpatch_Operation.prototype.constructor = $c_Ldiffson_jsonpatch_Operation;
/** @constructor */
function $h_Ldiffson_jsonpatch_Operation() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Operation.prototype = $c_Ldiffson_jsonpatch_Operation.prototype;
$c_Ldiffson_jsonpatch_Operation.prototype.apply__O__Lcats_MonadError__O = (function(value, F) {
  return this.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(value, this.path__Lcats_data_Chain(), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root, F)
});
$c_Ldiffson_jsonpatch_Operation.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O = (function(value, pointer, parent, F) {
  var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(pointer);
  var x4 = $ct_T2__O__O__(new $c_T2(), value, _2);
  var x35 = x4.T2__f__1;
  var x36 = ((x4.T2__f__2 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x4.T2__f__2).Ldiffson_jsonpointer_package$Pointer__f_parts);
  var x = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
  if (((x === null) ? (x36 === null) : x.equals__O__Z(x36))) {
    return F.pure__O__O(value)
  };
  if ((x35 !== null)) {
    var Json = this.Ldiffson_jsonpatch_Operation__f_evidence$1;
    var x32 = Json.fields__Lio_circe_Json__s_Option($as_Lio_circe_Json(x35));
    if ((!x32.isEmpty__Z())) {
      var x33 = $as_sci_Map(x32.get__O());
      var x25 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x36);
      if ((!x25.isEmpty__Z())) {
        var x26 = $as_T2(x25.get__O());
        var x27 = $as_s_util_Either(x26._1__O());
        if ((x27 !== null)) {
          var x29 = $m_Ldiffson_jsonpointer_package$ObjectField$().unapply__s_util_Either__s_Option(x27);
          if ((!x29.isEmpty__Z())) {
            var x30 = $as_T(x29.get__O());
            var tl = ((x26._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x26._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
            if (x33.contains__O__Z(x30)) {
              $m_Lcats_implicits$();
              $m_Lcats_implicits$();
              var target = this.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(x33.apply__O__O(x30), tl, $m_Ldiffson_jsonpointer_package$Pointer$().$div$extension__Lcats_data_Chain__T__Lcats_data_Chain(parent, x30), F);
              var this$4 = new $c_Lcats_Functor$$anon$4(target, F);
              var f = new $c_sjsr_AnonFunction1(((fields$2, elem$2) => ((_$3) => $as_sci_Map(fields$2.updated__O__O__sci_MapOps(elem$2, _$3))))(x33, x30));
              var target$1 = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f);
              var this$8 = new $c_Lcats_Functor$$anon$4(target$1, F);
              var f$1 = new $c_sjsr_AnonFunction1(((this$6) => ((_$4) => {
                var _$4$1 = $as_sci_Map(_$4);
                return $m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json(_$4$1)
              }))(this));
              return this$8.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$$anon$4__f_self, f$1)
            }
          }
        }
      }
    };
    var json = $as_Lio_circe_Json(x35);
    var x20 = json.asArray__s_Option();
    if ((!x20.isEmpty__Z())) {
      var x21 = $as_sci_Vector(x20.get__O());
      var x13 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x36);
      if ((!x13.isEmpty__Z())) {
        var x14 = $as_T2(x13.get__O());
        var x15 = $as_s_util_Either(x14._1__O());
        if ((x15 !== null)) {
          var x17 = x15.toOption__s_Option();
          if ((!x17.isEmpty__Z())) {
            var x18 = $uI(x17.get__O());
            var tl$2 = ((x14._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x14._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
            if ((x18 >= x21.length__I())) {
              var $$x1 = $m_Lcats_Show$ShowInterpolator$();
              $m_Lcats_implicits$();
              var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
              var sc = new $c_s_StringContext(parts);
              return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x18, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForInt)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
            } else {
              $m_Lcats_implicits$();
              var target$2 = this.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(x21.apply__I__O(x18), tl$2, $m_Ldiffson_jsonpointer_package$Pointer$().$div$extension__Lcats_data_Chain__I__Lcats_data_Chain(parent, x18), F);
              var this$20 = new $c_Lcats_Functor$$anon$4(target$2, F);
              var f$2 = new $c_sjsr_AnonFunction1(((this$2$1, elems$2, idx$2) => ((updated) => {
                matchResult1: {
                  var \u03b41$___1;
                  var \u03b41$___2;
                  var x1 = $f_sc_IterableOps__splitAt__I__T2(elems$2, idx$2);
                  if ((x1 !== null)) {
                    var before = $as_sci_Vector(x1._1__O());
                    var after = $as_sci_Vector(x1._2__O());
                    var \u03b41$___1 = before;
                    var \u03b41$___2 = after;
                    break matchResult1
                  };
                  throw new $c_s_MatchError(x1)
                };
                var before$2 = $as_sci_Vector(\u03b41$___1);
                var after$2 = $as_sci_Vector(\u03b41$___2);
                var this$16 = after$2.tail__sci_Vector();
                var suffix = this$16.prepended__O__sci_Vector(updated);
                var values = before$2.appendedAll__sc_IterableOnce__sci_Vector(suffix);
                $m_Lio_circe_Json$();
                return new $c_Lio_circe_Json$JArray(values)
              }))(this, x21, x18));
              return this$20.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$20.Lcats_Functor$$anon$4__f_self, f$2)
            }
          }
        }
      }
    }
  };
  var x7 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x36);
  if ((!x7.isEmpty__Z())) {
    var x8 = $as_T2(x7.get__O());
    var elem$3 = $as_s_util_Either(x8._1__O());
    var $$x4 = $m_Lcats_Show$ShowInterpolator$();
    $m_Lcats_implicits$();
    var parts$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
    var sc$1 = new $c_s_StringContext(parts$1);
    var $$x3 = $m_sr_ScalaRunTime$();
    if ((elem$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(elem$3);
      var b = x2.s_util_Right__f_value;
      var _$5 = $uI(b);
      var $$x2 = new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(("" + _$5), $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString))
    } else {
      if ((!(elem$3 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(elem$3)
      };
      var x3 = $as_s_util_Left(elem$3);
      var a = x3.s_util_Left__f_value;
      var x$1 = $as_T(a);
      var $$x2 = new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x$1, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString))
    };
    return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x4.show$extension__s_StringContext__sci_Seq__T(sc$1, $$x3.genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([$$x2, new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
  };
  throw new $c_s_MatchError(x4)
});
function $as_Ldiffson_jsonpatch_Operation(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Operation) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Operation"))
}
function $isArrayOf_Ldiffson_jsonpatch_Operation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Operation)))
}
function $asArrayOf_Ldiffson_jsonpatch_Operation(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Operation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Operation;", depth))
}
/** @constructor */
function $c_Ldiffson_jsonpointer_package$Inner$() {
  /*<skip>*/
}
$c_Ldiffson_jsonpointer_package$Inner$.prototype = new $h_O();
$c_Ldiffson_jsonpointer_package$Inner$.prototype.constructor = $c_Ldiffson_jsonpointer_package$Inner$;
/** @constructor */
function $h_Ldiffson_jsonpointer_package$Inner$() {
  /*<skip>*/
}
$h_Ldiffson_jsonpointer_package$Inner$.prototype = $c_Ldiffson_jsonpointer_package$Inner$.prototype;
$c_Ldiffson_jsonpointer_package$Inner$.prototype.unapply__Lcats_data_Chain__s_Option = (function(parts) {
  var this$1 = parts.uncons__s_Option();
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_T2(arg1);
    matchResult7: {
      var $$x1;
      if ((x$1 !== null)) {
        var h = $as_s_util_Either(x$1._1__O());
        var t = $as_Lcats_data_Chain(x$1._2__O());
        var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(t);
        var $$x1 = $ct_T2__O__O__(new $c_T2(), h, _2);
        break matchResult7
      };
      throw new $c_s_MatchError(x$1)
    };
    return new $c_s_Some($$x1)
  }
});
var $d_Ldiffson_jsonpointer_package$Inner$ = new $TypeData().initClass({
  Ldiffson_jsonpointer_package$Inner$: 0
}, false, "diffson.jsonpointer.package$Inner$", {
  Ldiffson_jsonpointer_package$Inner$: 1,
  O: 1
});
$c_Ldiffson_jsonpointer_package$Inner$.prototype.$classData = $d_Ldiffson_jsonpointer_package$Inner$;
var $n_Ldiffson_jsonpointer_package$Inner$;
function $m_Ldiffson_jsonpointer_package$Inner$() {
  if ((!$n_Ldiffson_jsonpointer_package$Inner$)) {
    $n_Ldiffson_jsonpointer_package$Inner$ = new $c_Ldiffson_jsonpointer_package$Inner$()
  };
  return $n_Ldiffson_jsonpointer_package$Inner$
}
/** @constructor */
function $c_Ldiffson_jsonpointer_package$Leaf$() {
  /*<skip>*/
}
$c_Ldiffson_jsonpointer_package$Leaf$.prototype = new $h_O();
$c_Ldiffson_jsonpointer_package$Leaf$.prototype.constructor = $c_Ldiffson_jsonpointer_package$Leaf$;
/** @constructor */
function $h_Ldiffson_jsonpointer_package$Leaf$() {
  /*<skip>*/
}
$h_Ldiffson_jsonpointer_package$Leaf$.prototype = $c_Ldiffson_jsonpointer_package$Leaf$.prototype;
$c_Ldiffson_jsonpointer_package$Leaf$.prototype.unapply__Lcats_data_Chain__s_Option = (function(p) {
  var this$1 = p.uncons__s_Option();
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_T2(arg1);
    if ((x$1 !== null)) {
      var a = $as_s_util_Either(x$1._1__O());
      var rest = $as_Lcats_data_Chain(x$1._2__O());
      if (rest.isEmpty__Z()) {
        return new $c_s_Some(a)
      }
    };
    return $m_s_None$()
  }
});
var $d_Ldiffson_jsonpointer_package$Leaf$ = new $TypeData().initClass({
  Ldiffson_jsonpointer_package$Leaf$: 0
}, false, "diffson.jsonpointer.package$Leaf$", {
  Ldiffson_jsonpointer_package$Leaf$: 1,
  O: 1
});
$c_Ldiffson_jsonpointer_package$Leaf$.prototype.$classData = $d_Ldiffson_jsonpointer_package$Leaf$;
var $n_Ldiffson_jsonpointer_package$Leaf$;
function $m_Ldiffson_jsonpointer_package$Leaf$() {
  if ((!$n_Ldiffson_jsonpointer_package$Leaf$)) {
    $n_Ldiffson_jsonpointer_package$Leaf$ = new $c_Ldiffson_jsonpointer_package$Leaf$()
  };
  return $n_Ldiffson_jsonpointer_package$Leaf$
}
/** @constructor */
function $c_Ldiffson_jsonpointer_package$ObjectField$() {
  /*<skip>*/
}
$c_Ldiffson_jsonpointer_package$ObjectField$.prototype = new $h_O();
$c_Ldiffson_jsonpointer_package$ObjectField$.prototype.constructor = $c_Ldiffson_jsonpointer_package$ObjectField$;
/** @constructor */
function $h_Ldiffson_jsonpointer_package$ObjectField$() {
  /*<skip>*/
}
$h_Ldiffson_jsonpointer_package$ObjectField$.prototype = $c_Ldiffson_jsonpointer_package$ObjectField$.prototype;
$c_Ldiffson_jsonpointer_package$ObjectField$.prototype.unapply__s_util_Either__s_Option = (function(e) {
  if ((e instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(e);
    var b = x2.s_util_Right__f_value;
    var _$8 = $uI(b);
    var value = ("" + _$8)
  } else {
    if ((!(e instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(e)
    };
    var x3 = $as_s_util_Left(e);
    var a = x3.s_util_Left__f_value;
    var x = $as_T(a);
    var value = x
  };
  return new $c_s_Some(value)
});
var $d_Ldiffson_jsonpointer_package$ObjectField$ = new $TypeData().initClass({
  Ldiffson_jsonpointer_package$ObjectField$: 0
}, false, "diffson.jsonpointer.package$ObjectField$", {
  Ldiffson_jsonpointer_package$ObjectField$: 1,
  O: 1
});
$c_Ldiffson_jsonpointer_package$ObjectField$.prototype.$classData = $d_Ldiffson_jsonpointer_package$ObjectField$;
var $n_Ldiffson_jsonpointer_package$ObjectField$;
function $m_Ldiffson_jsonpointer_package$ObjectField$() {
  if ((!$n_Ldiffson_jsonpointer_package$ObjectField$)) {
    $n_Ldiffson_jsonpointer_package$ObjectField$ = new $c_Ldiffson_jsonpointer_package$ObjectField$()
  };
  return $n_Ldiffson_jsonpointer_package$ObjectField$
}
/** @constructor */
function $c_Ldiffson_jsonpointer_package$Pointer$() {
  this.Ldiffson_jsonpointer_package$Pointer$__f_Root = null;
  this.Ldiffson_jsonpointer_package$Pointer$__f_IsNumber = null;
  this.Ldiffson_jsonpointer_package$Pointer$__f_show = null;
  $n_Ldiffson_jsonpointer_package$Pointer$ = this;
  $m_Ldiffson_jsonpointer_package$Pointer$();
  var this$1 = $m_Lcats_data_Chain$();
  var parts = this$1.Lcats_data_Chain$__f_nil;
  this.Ldiffson_jsonpointer_package$Pointer$__f_Root = parts;
  this.Ldiffson_jsonpointer_package$Pointer$__f_IsNumber = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(0|[1-9][0-9]*)", $m_sci_Nil$());
  $m_Lcats_Show$();
  var f = new $c_sjsr_AnonFunction1(((this$5) => ((pointer) => {
    var pointer$1 = ((pointer === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(pointer).Ldiffson_jsonpointer_package$Pointer__f_parts);
    if (pointer$1.isEmpty__Z()) {
      return ""
    } else {
      var this$11 = pointer$1.map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1(((this$6) => ((x$1) => {
        var x$1$1 = $as_s_util_Either(x$1);
        if ((x$1$1 instanceof $c_s_util_Left)) {
          var l = $as_T($as_s_util_Left(x$1$1).s_util_Left__f_value);
          var this$8 = $as_T(l.split("~").join("~0"));
          return $as_T(this$8.split("/").join("~1"))
        };
        if ((x$1$1 instanceof $c_s_util_Right)) {
          var r = $uI($as_s_util_Right(x$1$1).s_util_Right__f_value);
          return ("" + r)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(this$5))).toList__sci_List();
      return ("/" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$11, "", "/", ""))
    }
  }))(this));
  this.Ldiffson_jsonpointer_package$Pointer$__f_show = new $c_Lcats_Show$$anon$3(f)
}
$c_Ldiffson_jsonpointer_package$Pointer$.prototype = new $h_O();
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.constructor = $c_Ldiffson_jsonpointer_package$Pointer$;
/** @constructor */
function $h_Ldiffson_jsonpointer_package$Pointer$() {
  /*<skip>*/
}
$h_Ldiffson_jsonpointer_package$Pointer$.prototype = $c_Ldiffson_jsonpointer_package$Pointer$.prototype;
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.toString__T = (function() {
  return "Pointer"
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.apply__sci_Seq__Lcats_data_Chain = (function(elems) {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  var parts = $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain($as_sci_Seq(elems.map__F1__O(new $c_sjsr_AnonFunction1(((this$1) => ((x$1) => {
    var x$1$1 = $as_T(x$1);
    if ((x$1$1 !== null)) {
      var x2 = this$1.Ldiffson_jsonpointer_package$Pointer$__f_IsNumber.unapplySeq__jl_CharSequence__s_Option(x$1$1);
      if ((!x2.isEmpty__Z())) {
        var x3 = $as_sci_List(x2.get__O());
        if ((x3.lengthCompare__I__I(1) === 0)) {
          var x4 = $as_T($f_sc_LinearSeqOps__apply__I__O(x3, 0));
          $m_Lcats_implicits$();
          $m_Lcats_implicits$();
          try {
            var this$5 = $m_jl_Integer$();
            var t = new $c_s_util_Success(this$5.parseInt__T__I__I(x4, 10))
          } catch (e) {
            var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
            if ((e$2 !== null)) {
              matchEnd8: {
                var t;
                if ((e$2 !== null)) {
                  var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
                  if ((!o11.isEmpty__Z())) {
                    var e$3 = $as_jl_Throwable(o11.get__O());
                    var t = new $c_s_util_Failure(e$3);
                    break matchEnd8
                  }
                };
                throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
              }
            } else {
              var t;
              throw e
            }
          };
          $m_Lcats_implicits$();
          var F = new $c_Lcats_instances_EitherInstances$$anon$2();
          var this$9 = $m_s_$less$colon$less$();
          var ev = this$9.s_$less$colon$less$__f_singleton;
          var eab = $as_s_util_Either($f_Lcats_ApplicativeError__fromTry__s_util_Try__s_$less$colon$less__O(F, t, ev));
          if ((eab instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(eab).s_util_Left__f_value;
            $m_s_package$();
            $as_jl_Throwable(a);
            return new $c_s_util_Left(x$1$1)
          };
          if ((eab instanceof $c_s_util_Right)) {
            var r = $as_s_util_Right(eab);
            $m_Lcats_syntax_EitherUtil$();
            return r
          };
          throw new $c_s_MatchError(eab)
        }
      }
    };
    $m_s_package$();
    return new $c_s_util_Left(x$1$1)
  }))(this)))));
  return parts
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.parse__T__Lcats_MonadError__O = (function(input, F) {
  if (((input === null) || (input === ""))) {
    return F.pure__O__O(new $c_Ldiffson_jsonpointer_package$Pointer($m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root))
  } else if ((!(($uI(input.length) >= 0) && ($as_T(input.substring(0, $uI("/".length))) === "/")))) {
    return F.raiseError__O__O(new $c_Ldiffson_PointerException("A JSON pointer must start with '/'"))
  } else {
    var xs = $f_T__split__T__I__AT(input, "/", 0);
    var parts = $asArrayOf_T($m_sc_ArrayOps$().drop$extension__O__I__O(xs, 1), 1);
    if ((parts.u.length === 0)) {
      return F.pure__O__O(new $c_Ldiffson_jsonpointer_package$Pointer($m_Ldiffson_jsonpointer_package$Pointer$().apply__sci_Seq__Lcats_data_Chain($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([""])))))
    } else {
      _return: {
        var i = 0;
        while ((i < parts.u.length)) {
          var arg1 = parts.get(i);
          var _$6 = $as_T(arg1);
          var this$6 = $m_ju_regex_Pattern$();
          if (this$6.java$util$regex$Pattern$$matches__T__T__Z(".*~(?![01]).*", _$6)) {
            var $$x1 = i;
            break _return
          };
          i = ((1 + i) | 0)
        };
        var $$x1 = (-1)
      };
      if (($$x1 >= 0)) {
        return F.raiseError__O__O(new $c_Ldiffson_PointerException("Occurrences of '~' must be followed by '0' or '1'"))
      } else {
        if ($f_T__endsWith__T__Z(input, "/")) {
          var this$11 = $m_s_Array$();
          var newLength = ((1 + parts.u.length) | 0);
          if ($d_T.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(parts).getComponentType__jl_Class())) {
            var dest$1 = ($d_T.getClassOf().isPrimitive__Z() ? this$11.copyOf__O__I__O(parts, newLength) : $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(parts, newLength, $d_T.getArrayOf().getClassOf()))
          } else {
            var dest = new ($d_T.getArrayOf().constr)(newLength);
            $m_s_Array$().copy__O__I__O__I__I__V(parts, 0, dest, 0, parts.u.length);
            var dest$1 = dest
          };
          $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, parts.u.length, "");
          var allParts = $asArrayOf_T(dest$1, 1)
        } else {
          var allParts = parts
        };
        var f = ((this$2$1) => ((_$7) => {
          var _$7$1 = $as_T(_$7);
          var this$15 = $as_T(_$7$1.split("~1").join("/"));
          return $as_T(this$15.split("~0").join("~"))
        }))(this);
        var len = allParts.u.length;
        var ys = new ($d_T.getArrayOf().constr)(len);
        if ((len > 0)) {
          var i$1 = 0;
          if ((allParts !== null)) {
            while ((i$1 < len)) {
              var $$x2 = i$1;
              var arg1$1 = allParts.get(i$1);
              ys.set($$x2, f(arg1$1));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_I)) {
            var x3 = $asArrayOf_I(allParts, 1);
            while ((i$1 < len)) {
              var $$x3 = i$1;
              var arg1$2 = x3.get(i$1);
              ys.set($$x3, f(arg1$2));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_D)) {
            var x4 = $asArrayOf_D(allParts, 1);
            while ((i$1 < len)) {
              var $$x4 = i$1;
              var arg1$3 = x4.get(i$1);
              ys.set($$x4, f(arg1$3));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_J)) {
            var x5 = $asArrayOf_J(allParts, 1);
            while ((i$1 < len)) {
              var $$x5 = i$1;
              var t = x5.get(i$1);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              ys.set($$x5, f(new $c_RTLong(lo, hi)));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_F)) {
            var x6 = $asArrayOf_F(allParts, 1);
            while ((i$1 < len)) {
              var $$x6 = i$1;
              var arg1$4 = x6.get(i$1);
              ys.set($$x6, f(arg1$4));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_C)) {
            var x7 = $asArrayOf_C(allParts, 1);
            while ((i$1 < len)) {
              var $$x7 = i$1;
              var arg1$5 = x7.get(i$1);
              ys.set($$x7, f($bC(arg1$5)));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_B)) {
            var x8 = $asArrayOf_B(allParts, 1);
            while ((i$1 < len)) {
              var $$x8 = i$1;
              var arg1$6 = x8.get(i$1);
              ys.set($$x8, f(arg1$6));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_S)) {
            var x9 = $asArrayOf_S(allParts, 1);
            while ((i$1 < len)) {
              var $$x9 = i$1;
              var arg1$7 = x9.get(i$1);
              ys.set($$x9, f(arg1$7));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((allParts instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(allParts, 1);
            while ((i$1 < len)) {
              var $$x10 = i$1;
              var arg1$8 = x10.get(i$1);
              ys.set($$x10, f(arg1$8));
              i$1 = ((1 + i$1) | 0)
            }
          } else {
            throw new $c_s_MatchError(allParts)
          }
        };
        return F.pure__O__O(new $c_Ldiffson_jsonpointer_package$Pointer($m_Ldiffson_jsonpointer_package$Pointer$().apply__sci_Seq__Lcats_data_Chain($m_sc_compat_immutable_package$().sc_compat_immutable_package$__f_ArraySeq.unsafeWrapArray__O__sci_ArraySeq(ys))))
      }
    }
  }
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.equals$extension__Lcats_data_Chain__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Ldiffson_jsonpointer_package$Pointer)) {
    var x$0$2 = ((x$0 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x$0).Ldiffson_jsonpointer_package$Pointer__f_parts);
    return ((this$ === null) ? (x$0$2 === null) : this$.equals__O__Z(x$0$2))
  } else {
    return false
  }
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.toString$extension__Lcats_data_Chain__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Ldiffson_jsonpointer_package$Pointer(this$))
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.productElement$extension__Lcats_data_Chain__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.$div$extension__Lcats_data_Chain__T__Lcats_data_Chain = (function(this$, s) {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  var parts = this$.append__O__Lcats_data_Chain(($m_s_package$(), new $c_s_util_Left(s)));
  return parts
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.$div$extension__Lcats_data_Chain__I__Lcats_data_Chain = (function(this$, i) {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  var parts = this$.append__O__Lcats_data_Chain(($m_s_package$(), new $c_s_util_Right(i)));
  return parts
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.evaluate$extension__Lcats_data_Chain__O__Lcats_MonadError__Ldiffson_Jsony__O = (function(this$, json, F, Json) {
  var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(($m_Ldiffson_jsonpointer_package$Pointer$(), this$));
  var _3 = new $c_Ldiffson_jsonpointer_package$Pointer($m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root);
  return F.tailRecM__O__F1__O(new $c_T3(json, _2, _3), new $c_sjsr_AnonFunction1(((this$3, F$2, Json$2) => ((x$1) => {
    var x$1$1 = $as_T3(x$1);
    if ((x$1$1 !== null)) {
      var x37 = x$1$1.T3__f__1;
      var x38 = ((x$1$1.T3__f__2 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x$1$1.T3__f__2).Ldiffson_jsonpointer_package$Pointer__f_parts);
      var x39 = ((x$1$1.T3__f__3 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x$1$1.T3__f__3).Ldiffson_jsonpointer_package$Pointer__f_parts);
      if ((x37 !== null)) {
        var x46 = Json$2.fields__Lio_circe_Json__s_Option($as_Lio_circe_Json(x37));
        if ((!x46.isEmpty__Z())) {
          var x47 = $as_sci_Map(x46.get__O());
          var x40 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x38);
          if ((!x40.isEmpty__Z())) {
            var x41 = $as_T2(x40.get__O());
            var x42 = $as_s_util_Either(x41._1__O());
            if ((x42 instanceof $c_s_util_Left)) {
              var elem = $as_T($as_s_util_Left(x42).s_util_Left__f_value);
              var tl = ((x41._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x41._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
              $m_s_package$();
              var _1 = x47.getOrElse__O__F0__O(elem, new $c_sjsr_AnonFunction0(((this$5, Json$1$2) => (() => $m_Lio_circe_Json$().Lio_circe_Json$__f_Null))(this$3, Json$2)));
              var _2$1 = new $c_Ldiffson_jsonpointer_package$Pointer(tl);
              var _3$1 = new $c_Ldiffson_jsonpointer_package$Pointer(this$3.$div$extension__Lcats_data_Chain__T__Lcats_data_Chain(x39, elem));
              var value = new $c_T3(_1, _2$1, _3$1);
              return F$2.pure__O__O(new $c_s_util_Left(value))
            }
          }
        };
        var json$1 = $as_Lio_circe_Json(x37);
        var x34 = json$1.asArray__s_Option();
        if ((!x34.isEmpty__Z())) {
          var x35 = $as_sci_Vector(x34.get__O());
          var x28 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x38);
          if ((!x28.isEmpty__Z())) {
            var x29 = $as_T2(x28.get__O());
            var x30 = $as_s_util_Either(x29._1__O());
            if ((x30 instanceof $c_s_util_Right)) {
              var idx = $uI($as_s_util_Right(x30).s_util_Right__f_value);
              var tl$2 = ((x29._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x29._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
              if ((idx >= x35.length__I())) {
                var $$x1 = $m_Lcats_Show$ShowInterpolator$();
                $m_Lcats_implicits$();
                var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
                var sc = new $c_s_StringContext(parts);
                return F$2.raiseError__O__O(new $c_Ldiffson_PointerException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(idx, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForInt)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(x39), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
              } else {
                $m_s_package$();
                var _1$1 = x35.apply__I__O(idx);
                var _2$2 = new $c_Ldiffson_jsonpointer_package$Pointer(tl$2);
                var _3$2 = new $c_Ldiffson_jsonpointer_package$Pointer(this$3.$div$extension__Lcats_data_Chain__I__Lcats_data_Chain(x39, idx));
                var value$1 = new $c_T3(_1$1, _2$2, _3$2);
                return F$2.pure__O__O(new $c_s_util_Left(value$1))
              }
            }
          }
        }
      };
      var x = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
      if (((x === null) ? (x38 === null) : x.equals__O__Z(x38))) {
        return F$2.pure__O__O(($m_s_package$(), new $c_s_util_Right(x37)))
      };
      var x18 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x38);
      if ((!x18.isEmpty__Z())) {
        var x19 = $as_T2(x18.get__O());
        var elem$2 = $as_s_util_Either(x19._1__O());
        if ((x19._2__O() === null)) {
          /*<skip>*/
        } else {
          $as_Ldiffson_jsonpointer_package$Pointer(x19._2__O())
        };
        if ((elem$2 instanceof $c_s_util_Right)) {
          var x2 = $as_s_util_Right(elem$2);
          var b = x2.s_util_Right__f_value;
          var _$2 = $uI(b);
          var $$x2 = ("" + _$2)
        } else {
          if ((!(elem$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(elem$2)
          };
          var x3 = $as_s_util_Left(elem$2);
          var a = x3.s_util_Left__f_value;
          var x$2 = $as_T(a);
          var $$x2 = x$2
        };
        var elems = $as_T($$x2);
        var $$x3 = $m_Lcats_Show$ShowInterpolator$();
        $m_Lcats_implicits$();
        var parts$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
        var sc$1 = new $c_s_StringContext(parts$1);
        return F$2.raiseError__O__O(new $c_Ldiffson_PointerException($$x3.show$extension__s_StringContext__sci_Seq__T(sc$1, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(elems, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(x39), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, F, Json)))
});
var $d_Ldiffson_jsonpointer_package$Pointer$ = new $TypeData().initClass({
  Ldiffson_jsonpointer_package$Pointer$: 0
}, false, "diffson.jsonpointer.package$Pointer$", {
  Ldiffson_jsonpointer_package$Pointer$: 1,
  O: 1
});
$c_Ldiffson_jsonpointer_package$Pointer$.prototype.$classData = $d_Ldiffson_jsonpointer_package$Pointer$;
var $n_Ldiffson_jsonpointer_package$Pointer$;
function $m_Ldiffson_jsonpointer_package$Pointer$() {
  if ((!$n_Ldiffson_jsonpointer_package$Pointer$)) {
    $n_Ldiffson_jsonpointer_package$Pointer$ = new $c_Ldiffson_jsonpointer_package$Pointer$()
  };
  return $n_Ldiffson_jsonpointer_package$Pointer$
}
/** @constructor */
function $c_Lio_circe_CursorOp$() {
  this.Lio_circe_CursorOp$__f_showCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = null;
  $n_Lio_circe_CursorOp$ = this;
  $m_Lcats_Show$();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((x$1) => {
    var x$1$1 = $as_Lio_circe_CursorOp(x$1);
    var x = $m_Lio_circe_CursorOp$MoveLeft$();
    if ((x === x$1$1)) {
      return "<-"
    };
    var x$3 = $m_Lio_circe_CursorOp$MoveRight$();
    if ((x$3 === x$1$1)) {
      return "->"
    };
    var x$5 = $m_Lio_circe_CursorOp$MoveUp$();
    if ((x$5 === x$1$1)) {
      return "_/"
    };
    if (false) {
      var x$1$2 = $as_Lio_circe_CursorOp$Field(x$1$1);
      var x32 = x$1$2.Lio_circe_CursorOp$Field__f_k;
      return (("--(" + x32) + ")")
    };
    if ((x$1$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
      var x$1$3 = $as_Lio_circe_CursorOp$DownField(x$1$1);
      var x29 = x$1$3.Lio_circe_CursorOp$DownField__f_k;
      return (("--\\(" + x29) + ")")
    };
    var x$7 = $m_Lio_circe_CursorOp$DownArray$();
    if ((x$7 === x$1$1)) {
      return "\\\\"
    };
    if (false) {
      var x$1$4 = $as_Lio_circe_CursorOp$DownN(x$1$1);
      var x26 = x$1$4.Lio_circe_CursorOp$DownN__f_n;
      return (("=\\(" + x26) + ")")
    };
    var x$9 = $m_Lio_circe_CursorOp$DeleteGoParent$();
    if ((x$9 === x$1$1)) {
      return "!_/"
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this));
  this.Lio_circe_CursorOp$__f_showCursorOp = new $c_Lcats_Show$$anon$3(f);
  this.Lio_circe_CursorOp$__f_eqCursorOp = ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$5());
  $m_Lcats_instances_package$list$();
  var evidence$4 = this.Lio_circe_CursorOp$__f_eqCursorOp;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = new $c_Lcats_kernel_instances_ListEq(evidence$4)
}
$c_Lio_circe_CursorOp$.prototype = new $h_O();
$c_Lio_circe_CursorOp$.prototype.constructor = $c_Lio_circe_CursorOp$;
/** @constructor */
function $h_Lio_circe_CursorOp$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$.prototype = $c_Lio_circe_CursorOp$.prototype;
$c_Lio_circe_CursorOp$.prototype.opsToPath__sci_List__T = (function(history) {
  $m_s_package$();
  var z = $m_sci_Nil$();
  var acc = z;
  var these = history.reverse__sci_List();
  while ((!these.isEmpty__Z())) {
    var arg1 = these.head__O();
    var arg2 = acc;
    var x$1 = $as_Lio_circe_CursorOp(arg1);
    var x$2 = $as_sci_List(arg2);
    matchResult30: {
      if ((x$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
        var x$1$1 = $as_Lio_circe_CursorOp$DownField(x$1);
        var x75 = x$1$1.Lio_circe_CursorOp$DownField__f_k;
        var elem$1 = new $c_Lio_circe_CursorOp$SelectField(x75);
        acc = new $c_sci_$colon$colon(elem$1, x$2);
        break matchResult30
      };
      var x = $m_Lio_circe_CursorOp$DownArray$();
      if ((x === x$1)) {
        var elem$2 = new $c_Lio_circe_CursorOp$SelectIndex(0);
        acc = new $c_sci_$colon$colon(elem$2, x$2);
        break matchResult30
      };
      var x$4 = $m_Lio_circe_CursorOp$MoveUp$();
      if (((x$4 === x$1) && (x$2 instanceof $c_sci_$colon$colon))) {
        var x68 = $as_sci_$colon$colon(x$2).sci_$colon$colon__f_next;
        acc = x68;
        break matchResult30
      };
      var x$6 = $m_Lio_circe_CursorOp$MoveRight$();
      if (((x$6 === x$1) && (x$2 instanceof $c_sci_$colon$colon))) {
        var x58 = $as_sci_$colon$colon(x$2);
        var x59 = $as_Lio_circe_CursorOp$Selection(x58.sci_$colon$colon__f_head);
        var x60 = x58.sci_$colon$colon__f_next;
        if ((x59 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x$1$2 = $as_Lio_circe_CursorOp$SelectIndex(x59);
          var x63 = x$1$2.Lio_circe_CursorOp$SelectIndex__f_index;
          var index = ((1 + x63) | 0);
          var elem$3 = new $c_Lio_circe_CursorOp$SelectIndex(index);
          acc = new $c_sci_$colon$colon(elem$3, x60);
          break matchResult30
        }
      };
      var x$8 = $m_Lio_circe_CursorOp$MoveLeft$();
      if (((x$8 === x$1) && (x$2 instanceof $c_sci_$colon$colon))) {
        var x50 = $as_sci_$colon$colon(x$2);
        var x51 = $as_Lio_circe_CursorOp$Selection(x50.sci_$colon$colon__f_head);
        var x52 = x50.sci_$colon$colon__f_next;
        if ((x51 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x$1$3 = $as_Lio_circe_CursorOp$SelectIndex(x51);
          var x55 = x$1$3.Lio_circe_CursorOp$SelectIndex__f_index;
          var index$1 = (((-1) + x55) | 0);
          var elem$4 = new $c_Lio_circe_CursorOp$SelectIndex(index$1);
          acc = new $c_sci_$colon$colon(elem$4, x52);
          break matchResult30
        }
      };
      var elem$5 = new $c_Lio_circe_CursorOp$Op(x$1);
      acc = new $c_sci_$colon$colon(elem$5, x$2)
    };
    these = $as_sci_List(these.tail__O())
  };
  var selections = $as_sci_List(acc);
  var acc$1 = "";
  var these$1 = selections;
  while ((!these$1.isEmpty__Z())) {
    var arg1$1 = acc$1;
    var arg2$1 = these$1.head__O();
    var x$1$4 = $as_T(arg1$1);
    var x$2$1 = $as_Lio_circe_CursorOp$Selection(arg2$1);
    matchResult31: {
      var x76 = $ct_T2__O__O__(new $c_T2(), x$1$4, x$2$1);
      var x87 = $as_T(x76.T2__f__1);
      var x88 = $as_Lio_circe_CursorOp$Selection(x76.T2__f__2);
      if ((x88 instanceof $c_Lio_circe_CursorOp$SelectField)) {
        var x$1$5 = $as_Lio_circe_CursorOp$SelectField(x88);
        var x91 = x$1$5.Lio_circe_CursorOp$SelectField__f_field;
        acc$1 = (("." + x91) + x87);
        break matchResult31
      };
      if ((x88 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
        var x$1$6 = $as_Lio_circe_CursorOp$SelectIndex(x88);
        var x86 = x$1$6.Lio_circe_CursorOp$SelectIndex__f_index;
        acc$1 = ((("[" + x86) + "]") + x87);
        break matchResult31
      };
      if ((x88 instanceof $c_Lio_circe_CursorOp$Op)) {
        var x$1$7 = $as_Lio_circe_CursorOp$Op(x88);
        var x81 = x$1$7.Lio_circe_CursorOp$Op__f_op;
        $m_Lcats_Show$();
        var instance = this.Lio_circe_CursorOp$__f_showCursorOp;
        acc$1 = ((("{" + instance.show__O__T(x81)) + "}") + x87);
        break matchResult31
      };
      throw new $c_s_MatchError(x76)
    };
    these$1 = $as_sc_LinearSeq(these$1.tail__O())
  };
  return $as_T(acc$1)
});
var $d_Lio_circe_CursorOp$ = new $TypeData().initClass({
  Lio_circe_CursorOp$: 0
}, false, "io.circe.CursorOp$", {
  Lio_circe_CursorOp$: 1,
  O: 1
});
$c_Lio_circe_CursorOp$.prototype.$classData = $d_Lio_circe_CursorOp$;
var $n_Lio_circe_CursorOp$;
function $m_Lio_circe_CursorOp$() {
  if ((!$n_Lio_circe_CursorOp$)) {
    $n_Lio_circe_CursorOp$ = new $c_Lio_circe_CursorOp$()
  };
  return $n_Lio_circe_CursorOp$
}
function $is_Lio_circe_CursorOp$Selection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_CursorOp$Selection)))
}
function $as_Lio_circe_CursorOp$Selection(obj) {
  return (($is_Lio_circe_CursorOp$Selection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Selection"))
}
function $isArrayOf_Lio_circe_CursorOp$Selection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Selection)))
}
function $asArrayOf_Lio_circe_CursorOp$Selection(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Selection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Selection;", depth))
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$() {
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = null;
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = null;
  $n_Lio_circe_DecodingFailure$ = this;
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2(((this$1) => ((a, b) => {
    var a$1 = $as_Lio_circe_DecodingFailure(a);
    var b$1 = $as_Lio_circe_DecodingFailure(b);
    return ((a$1.Lio_circe_DecodingFailure__f_message === b$1.Lio_circe_DecodingFailure__f_message) && $m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_eqCursorOpList.eqv__O__O__Z(a$1.history__sci_List(), b$1.history__sci_List()))
  }))(this));
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = new $c_Lcats_kernel_Eq$$anon$4(f);
  $m_Lcats_Show$();
  var f$1 = new $c_sjsr_AnonFunction1(((this$2$1) => ((failure) => {
    var failure$1 = $as_Lio_circe_DecodingFailure(failure);
    var path = $m_Lio_circe_CursorOp$().opsToPath__sci_List__T(failure$1.history__sci_List());
    return ((("DecodingFailure at " + path) + ": ") + failure$1.Lio_circe_DecodingFailure__f_message)
  }))(this));
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = new $c_Lcats_Show$$anon$3(f$1)
}
$c_Lio_circe_DecodingFailure$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$.prototype.constructor = $c_Lio_circe_DecodingFailure$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$() {
  /*<skip>*/
}
$h_Lio_circe_DecodingFailure$.prototype = $c_Lio_circe_DecodingFailure$.prototype;
var $d_Lio_circe_DecodingFailure$ = new $TypeData().initClass({
  Lio_circe_DecodingFailure$: 0
}, false, "io.circe.DecodingFailure$", {
  Lio_circe_DecodingFailure$: 1,
  O: 1
});
$c_Lio_circe_DecodingFailure$.prototype.$classData = $d_Lio_circe_DecodingFailure$;
var $n_Lio_circe_DecodingFailure$;
function $m_Lio_circe_DecodingFailure$() {
  if ((!$n_Lio_circe_DecodingFailure$)) {
    $n_Lio_circe_DecodingFailure$ = new $c_Lio_circe_DecodingFailure$()
  };
  return $n_Lio_circe_DecodingFailure$
}
function $f_Lio_circe_DerivedInstance__elemCount__I($thiz) {
  return $thiz.elemLabels__AT().u.length
}
/** @constructor */
function $c_Lio_circe_JsonNumber$() {
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = null;
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = null;
  $n_Lio_circe_JsonNumber$ = this;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  var f = new $c_sjsr_AnonFunction2(((this$1) => ((x$1, x$2) => {
    var x$1$1 = $as_Lio_circe_JsonNumber(x$1);
    var x$2$1 = $as_Lio_circe_JsonNumber(x$2);
    if ((x$1$1 instanceof $c_Lio_circe_JsonLong)) {
      var x$1$2 = $as_Lio_circe_JsonLong(x$1$1);
      var t = x$1$2.Lio_circe_JsonLong__f_value;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((x$2$1 instanceof $c_Lio_circe_JsonLong)) {
        var x$1$3 = $as_Lio_circe_JsonLong(x$2$1);
        var t$1 = x$1$3.Lio_circe_JsonLong__f_value;
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        return ((lo === lo$1) && (hi === hi$1))
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_JsonDouble)) {
      var x$1$4 = $as_Lio_circe_JsonDouble(x$1$1);
      var x50 = x$1$4.Lio_circe_JsonDouble__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_JsonDouble)) {
        var x$1$5 = $as_Lio_circe_JsonDouble(x$2$1);
        var x47 = x$1$5.Lio_circe_JsonDouble__f_value;
        return ($m_jl_Double$().compare__D__D__I(x50, x47) === 0)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_JsonFloat)) {
      var x$1$6 = $as_Lio_circe_JsonFloat(x$1$1);
      var x42 = x$1$6.Lio_circe_JsonFloat__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_JsonFloat)) {
        var x$1$7 = $as_Lio_circe_JsonFloat(x$2$1);
        var x39 = x$1$7.Lio_circe_JsonFloat__f_value;
        return ($m_jl_Double$().compare__D__D__I(x42, x39) === 0)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_JsonBigDecimal)) {
      var x$1$8 = $as_Lio_circe_JsonBigDecimal(x$1$1);
      var x34 = x$1$8.Lio_circe_JsonBigDecimal__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_JsonBigDecimal)) {
        var x$1$9 = $as_Lio_circe_JsonBigDecimal(x$2$1);
        var x31 = x$1$9.Lio_circe_JsonBigDecimal__f_value;
        return (x34.compareTo__Ljava_math_BigDecimal__I(x31) === 0)
      }
    };
    var x$6 = x$1$1.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    var x$7 = x$2$1.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    return ((x$6 === null) ? (x$7 === null) : x$6.equals__O__Z(x$7))
  }))(this));
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = new $c_Lcats_kernel_Eq$$anon$4(f)
}
$c_Lio_circe_JsonNumber$.prototype = new $h_O();
$c_Lio_circe_JsonNumber$.prototype.constructor = $c_Lio_circe_JsonNumber$;
/** @constructor */
function $h_Lio_circe_JsonNumber$() {
  /*<skip>*/
}
$h_Lio_circe_JsonNumber$.prototype = $c_Lio_circe_JsonNumber$.prototype;
$c_Lio_circe_JsonNumber$.prototype.fromString__T__s_Option = (function(value) {
  var result = $m_Lio_circe_numbers_BiggerDecimal$().parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal(value);
  if ((result === null)) {
    return $m_s_None$()
  } else {
    var value$1 = new $c_Lio_circe_JsonBiggerDecimal(result, value);
    return new $c_s_Some(value$1)
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsWhole__Ljava_math_BigDecimal__Z = (function(value) {
  if (((value.signum__I() === 0) || (value.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0))) {
    return true
  } else {
    var this$1 = value.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsValidLong__Ljava_math_BigDecimal__Z = (function(value) {
  return ((this.bigDecimalIsWhole__Ljava_math_BigDecimal__Z(value) && (value.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMinLong) >= 0)) && (value.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong) <= 0))
});
var $d_Lio_circe_JsonNumber$ = new $TypeData().initClass({
  Lio_circe_JsonNumber$: 0
}, false, "io.circe.JsonNumber$", {
  Lio_circe_JsonNumber$: 1,
  O: 1
});
$c_Lio_circe_JsonNumber$.prototype.$classData = $d_Lio_circe_JsonNumber$;
var $n_Lio_circe_JsonNumber$;
function $m_Lio_circe_JsonNumber$() {
  if ((!$n_Lio_circe_JsonNumber$)) {
    $n_Lio_circe_JsonNumber$ = new $c_Lio_circe_JsonNumber$()
  };
  return $n_Lio_circe_JsonNumber$
}
/** @constructor */
function $c_Lio_circe_JsonObject$() {
  this.Lio_circe_JsonObject$__f_empty = null;
  this.Lio_circe_JsonObject$__f_showJsonObject = null;
  this.Lio_circe_JsonObject$__f_eqJsonObject = null;
  $n_Lio_circe_JsonObject$ = this;
  this.Lio_circe_JsonObject$__f_empty = new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($m_sci_Map$EmptyMap$(), ($m_s_package$(), $m_sci_Vector0$()));
  this.Lio_circe_JsonObject$__f_showJsonObject = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lio_circe_JsonObject$__f_eqJsonObject = ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$5())
}
$c_Lio_circe_JsonObject$.prototype = new $h_O();
$c_Lio_circe_JsonObject$.prototype.constructor = $c_Lio_circe_JsonObject$;
/** @constructor */
function $h_Lio_circe_JsonObject$() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$.prototype = $c_Lio_circe_JsonObject$.prototype;
$c_Lio_circe_JsonObject$.prototype.fromIterable__sc_Iterable__Lio_circe_JsonObject = (function(fields) {
  var map = $ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap());
  var iterator = fields.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    matchResult5: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x16 = $as_T2(iterator.next__O());
      if ((x16 !== null)) {
        var key = $as_T(x16._1__O());
        var value = $as_Lio_circe_Json(x16._2__O());
        var \u03b41$___1 = key;
        var \u03b41$___2 = value;
        break matchResult5
      };
      throw new $c_s_MatchError(x16)
    };
    var key$2 = $as_T(\u03b41$___1);
    var value$2 = $as_Lio_circe_Json(\u03b41$___2);
    if ((key$2 === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $f_T__hashCode__I(key$2);
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    map.java$util$HashMap$$put0__O__O__I__Z__O(key$2, value$2, $$x1, false)
  };
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(map)
});
var $d_Lio_circe_JsonObject$ = new $TypeData().initClass({
  Lio_circe_JsonObject$: 0
}, false, "io.circe.JsonObject$", {
  Lio_circe_JsonObject$: 1,
  O: 1
});
$c_Lio_circe_JsonObject$.prototype.$classData = $d_Lio_circe_JsonObject$;
var $n_Lio_circe_JsonObject$;
function $m_Lio_circe_JsonObject$() {
  if ((!$n_Lio_circe_JsonObject$)) {
    $n_Lio_circe_JsonObject$ = new $c_Lio_circe_JsonObject$()
  };
  return $n_Lio_circe_JsonObject$
}
/** @constructor */
function $c_Lio_circe_KeyDecoder$() {
  this.Lio_circe_KeyDecoder$__f_decodeKeyString = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeySymbol = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyUUID = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyByte = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyShort = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyInt = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyLong = null;
  this.Lio_circe_KeyDecoder$__f_keyDecoderInstances = null;
  $n_Lio_circe_KeyDecoder$ = this;
  this.Lio_circe_KeyDecoder$__f_decodeKeyString = new $c_Lio_circe_KeyDecoder$$anon$3();
  this.Lio_circe_KeyDecoder$__f_decodeKeySymbol = new $c_Lio_circe_KeyDecoder$$anon$4();
  this.Lio_circe_KeyDecoder$__f_decodeKeyUUID = new $c_Lio_circe_KeyDecoder$$anon$5();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((x$0) => {
    var x$0$1 = $as_T(x$0);
    var this$2 = $m_jl_Byte$();
    return this$2.parseByte__T__I__B(x$0$1, 10)
  }))(this));
  this.Lio_circe_KeyDecoder$__f_decodeKeyByte = new $c_Lio_circe_KeyDecoder$$anon$8(f);
  var f$1 = new $c_sjsr_AnonFunction1(((this$2$1) => ((x$0$2) => {
    var x$0$3 = $as_T(x$0$2);
    var this$3 = $m_jl_Short$();
    return this$3.parseShort__T__I__S(x$0$3, 10)
  }))(this));
  this.Lio_circe_KeyDecoder$__f_decodeKeyShort = new $c_Lio_circe_KeyDecoder$$anon$8(f$1);
  var f$2 = new $c_sjsr_AnonFunction1(((this$3$1) => ((x$0$3$1) => {
    var x$0$4 = $as_T(x$0$3$1);
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x$0$4, 10)
  }))(this));
  this.Lio_circe_KeyDecoder$__f_decodeKeyInt = new $c_Lio_circe_KeyDecoder$$anon$8(f$2);
  var f$3 = new $c_sjsr_AnonFunction1(((this$4$1) => ((x$0$4$1) => {
    var x$0$5 = $as_T(x$0$4$1);
    var this$5 = $m_jl_Long$();
    return this$5.parseLong__T__I__J(x$0$5, 10)
  }))(this));
  this.Lio_circe_KeyDecoder$__f_decodeKeyLong = new $c_Lio_circe_KeyDecoder$$anon$8(f$3);
  this.Lio_circe_KeyDecoder$__f_keyDecoderInstances = new $c_Lio_circe_KeyDecoder$$anon$6()
}
$c_Lio_circe_KeyDecoder$.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$.prototype.constructor = $c_Lio_circe_KeyDecoder$;
/** @constructor */
function $h_Lio_circe_KeyDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$.prototype = $c_Lio_circe_KeyDecoder$.prototype;
var $d_Lio_circe_KeyDecoder$ = new $TypeData().initClass({
  Lio_circe_KeyDecoder$: 0
}, false, "io.circe.KeyDecoder$", {
  Lio_circe_KeyDecoder$: 1,
  O: 1
});
$c_Lio_circe_KeyDecoder$.prototype.$classData = $d_Lio_circe_KeyDecoder$;
var $n_Lio_circe_KeyDecoder$;
function $m_Lio_circe_KeyDecoder$() {
  if ((!$n_Lio_circe_KeyDecoder$)) {
    $n_Lio_circe_KeyDecoder$ = new $c_Lio_circe_KeyDecoder$()
  };
  return $n_Lio_circe_KeyDecoder$
}
/** @constructor */
function $c_Lio_circe_MapDecoder$() {
  /*<skip>*/
}
$c_Lio_circe_MapDecoder$.prototype = new $h_O();
$c_Lio_circe_MapDecoder$.prototype.constructor = $c_Lio_circe_MapDecoder$;
/** @constructor */
function $h_Lio_circe_MapDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_MapDecoder$.prototype = $c_Lio_circe_MapDecoder$.prototype;
$c_Lio_circe_MapDecoder$.prototype.failure__Lio_circe_HCursor__Lio_circe_DecodingFailure = (function(c) {
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0(((this$1, c$2) => (() => c$2.history__sci_List()))(this, c));
  return new $c_Lio_circe_DecodingFailure$$anon$2("[K, V]Map[K, V]", ops)
});
$c_Lio_circe_MapDecoder$.prototype.failureResult__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  var value = this.failure__Lio_circe_HCursor__Lio_circe_DecodingFailure(c);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_MapDecoder$ = new $TypeData().initClass({
  Lio_circe_MapDecoder$: 0
}, false, "io.circe.MapDecoder$", {
  Lio_circe_MapDecoder$: 1,
  O: 1
});
$c_Lio_circe_MapDecoder$.prototype.$classData = $d_Lio_circe_MapDecoder$;
var $n_Lio_circe_MapDecoder$;
function $m_Lio_circe_MapDecoder$() {
  if ((!$n_Lio_circe_MapDecoder$)) {
    $n_Lio_circe_MapDecoder$ = new $c_Lio_circe_MapDecoder$()
  };
  return $n_Lio_circe_MapDecoder$
}
/** @constructor */
function $c_Lio_circe_Printer$SizePredictor() {
  /*<skip>*/
}
$c_Lio_circe_Printer$SizePredictor.prototype = new $h_O();
$c_Lio_circe_Printer$SizePredictor.prototype.constructor = $c_Lio_circe_Printer$SizePredictor;
/** @constructor */
function $h_Lio_circe_Printer$SizePredictor() {
  /*<skip>*/
}
$h_Lio_circe_Printer$SizePredictor.prototype = $c_Lio_circe_Printer$SizePredictor.prototype;
function $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal($thiz, unscaled, scale) {
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
    return $thiz.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero
  } else {
    var current = unscaled;
    var lo = scale.RTLong__f_lo;
    var hi = scale.RTLong__f_hi;
    var depth__lo = lo;
    var depth__hi = hi;
    var divAndRem = current.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
    while (true) {
      var xn = divAndRem.get(1);
      var yn$1 = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn$1)) {
        current = divAndRem.get(0);
        var b__lo = depth__lo;
        var b__hi = depth__hi;
        var bhi = b__hi;
        var lo$1 = (((-1) + b__lo) | 0);
        var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
        var $$x1__lo = lo$1;
        var $$x1__hi = hi$1;
        depth__lo = $$x1__lo;
        depth__hi = $$x1__hi;
        divAndRem = current.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN)
      } else {
        break
      }
    };
    var $$x2 = current;
    var lVal__lo = depth__lo;
    var lVal__hi = depth__hi;
    return new $c_Lio_circe_numbers_SigAndExp($$x2, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lVal__lo, lVal__hi)))
  }
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$() {
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxLong = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MinLong = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = null;
  $n_Lio_circe_numbers_BiggerDecimal$ = this;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(262144, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(2147483647, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-2147483648), (-1)));
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  this.Lio_circe_numbers_BiggerDecimal$__f_MinLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$1();
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$2()
}
$c_Lio_circe_numbers_BiggerDecimal$.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal$.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$.prototype = $c_Lio_circe_numbers_BiggerDecimal$.prototype;
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromLong__J__Lio_circe_numbers_BiggerDecimal = (function(d) {
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(d), $L0)
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal = (function(d) {
  if (($m_jl_Double$().compare__D__D__I(d, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero
  } else {
    var d$1 = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
    var $$x1 = d$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = d$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $$x1, new $c_RTLong(value, hi))
  }
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromFloat__F__Lio_circe_numbers_BiggerDecimal = (function(f) {
  if (($m_jl_Double$().compare__D__D__I(f, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero
  } else {
    var d = $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + f));
    var $$x1 = d.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = d.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $$x1, new $c_RTLong(value, hi))
  }
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal = (function(input) {
  var len = $uI(input.length);
  if ((len === 0)) {
    return null
  } else {
    var zeros = 0;
    var decIndex = (-1);
    var expIndex = (-1);
    var i = (((65535 & $uI(input.charCodeAt(0))) === 45) ? 1 : 0);
    if ((i >= len)) {
      var state = 0
    } else {
      var index = i;
      if (((65535 & $uI(input.charCodeAt(index))) !== 48)) {
        var state = 1
      } else {
        i = ((1 + i) | 0);
        var state = 2
      }
    };
    while (((i < len) && (state !== 0))) {
      var index$1 = i;
      var c = (65535 & $uI(input.charCodeAt(index$1)));
      var x10 = state;
      switch (x10) {
        case 1: {
          if (((c >= 49) && (c <= 57))) {
            state = 8
          } else {
            state = 0
          };
          break
        }
        case 2: {
          if ((c === 46)) {
            state = 3
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 8: {
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 8
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 8
          } else if ((c === 46)) {
            state = 3
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 3: {
          decIndex = (((-1) + i) | 0);
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 4
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 4
          } else {
            state = 0
          };
          break
        }
        case 5: {
          expIndex = (((-1) + i) | 0);
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else if (((c === 43) || (c === 45))) {
            state = 6
          } else {
            state = 0
          };
          break
        }
        case 4: {
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 4
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 4
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 6: {
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else {
            state = 0
          };
          break
        }
        case 7: {
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else {
            state = 0
          };
          break
        }
        default: {
          throw new $c_s_MatchError(x10)
        }
      };
      i = ((1 + i) | 0)
    };
    if (((((state === 0) || (state === 3)) || (state === 5)) || (state === 6))) {
      return null
    } else {
      if ((decIndex >= 0)) {
        var endIndex = decIndex;
        var integral = $as_T(input.substring(0, endIndex))
      } else if ((expIndex === (-1))) {
        var integral = input
      } else {
        var endIndex$1 = expIndex;
        var integral = $as_T(input.substring(0, endIndex$1))
      };
      if ((decIndex === (-1))) {
        var fractional = ""
      } else if ((expIndex === (-1))) {
        var beginIndex = ((1 + decIndex) | 0);
        var fractional = $as_T(input.substring(beginIndex))
      } else {
        var beginIndex$1 = ((1 + decIndex) | 0);
        var endIndex$2 = expIndex;
        var fractional = $as_T(input.substring(beginIndex$1, endIndex$2))
      };
      var unscaledString = (("" + integral) + fractional);
      var endIndex$3 = (($uI(unscaledString.length) - zeros) | 0);
      var unscaled = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), $as_T(unscaledString.substring(0, endIndex$3)));
      var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
        return (((65535 & $uI(input.charCodeAt(0))) === 45) ? this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero : this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero)
      } else {
        var value = (($uI(fractional.length) - zeros) | 0);
        var hi = (value >> 31);
        var rescale = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value, hi));
        if ((expIndex === (-1))) {
          var scale = rescale
        } else {
          var beginIndex$2 = ((1 + expIndex) | 0);
          var bi = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), $as_T(input.substring(beginIndex$2)));
          var scale = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(rescale, bi)
        };
        return new $c_Lio_circe_numbers_SigAndExp(unscaled, scale)
      }
    }
  }
});
var $d_Lio_circe_numbers_BiggerDecimal$ = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$: 0
}, false, "io.circe.numbers.BiggerDecimal$", {
  Lio_circe_numbers_BiggerDecimal$: 1,
  O: 1
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$;
var $n_Lio_circe_numbers_BiggerDecimal$;
function $m_Lio_circe_numbers_BiggerDecimal$() {
  if ((!$n_Lio_circe_numbers_BiggerDecimal$)) {
    $n_Lio_circe_numbers_BiggerDecimal$ = new $c_Lio_circe_numbers_BiggerDecimal$()
  };
  return $n_Lio_circe_numbers_BiggerDecimal$
}
/** @constructor */
function $c_Lio_circe_scalajs_package$() {
  this.Lio_circe_scalajs_package$__f_toJsAnyFolder = null;
  $n_Lio_circe_scalajs_package$ = this;
  this.Lio_circe_scalajs_package$__f_toJsAnyFolder = new $c_Lio_circe_scalajs_package$$anon$1()
}
$c_Lio_circe_scalajs_package$.prototype = new $h_O();
$c_Lio_circe_scalajs_package$.prototype.constructor = $c_Lio_circe_scalajs_package$;
/** @constructor */
function $h_Lio_circe_scalajs_package$() {
  /*<skip>*/
}
$h_Lio_circe_scalajs_package$.prototype = $c_Lio_circe_scalajs_package$.prototype;
$c_Lio_circe_scalajs_package$.prototype.convertAnyToJsonUnsafe__O__Lio_circe_Json = (function(input) {
  if (((typeof input) === "string")) {
    var s = $as_T(input);
    $m_Lio_circe_Json$();
    return new $c_Lio_circe_Json$JString(s)
  };
  if (((typeof input) === "number")) {
    var n = $uD(input);
    return $m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(n)
  };
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(true, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_True
  };
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(false, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_False
  };
  if ((input === null)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
  };
  if ($uZ((input instanceof Array))) {
    $m_Lio_circe_Json$();
    var len = $uI(input.length);
    var res = new Array(len);
    var i = 0;
    while ((i < len)) {
      var $$x1 = i;
      var arg1 = input[i];
      res[$$x1] = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(arg1);
      i = ((1 + i) | 0)
    };
    var values = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
    var value = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(values);
    return new $c_Lio_circe_Json$JArray(value)
  };
  if ($uZ((input instanceof Object))) {
    var $$x2 = $m_Lio_circe_Json$();
    var this$9 = new $c_sjs_js_WrappedDictionary(input);
    var f = new $c_sjsr_AnonFunction1(((this$2$1) => ((input$2) => $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input$2)))(this));
    var this$10 = new $c_sc_MapView$MapValues(this$9, f);
    return $$x2.fromFields__sc_Iterable__Lio_circe_Json($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$10))
  };
  if ((input === (void 0))) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
  };
  throw new $c_s_MatchError(input)
});
$c_Lio_circe_scalajs_package$.prototype.convertJsToJson__sjs_js_Any__s_util_Either = (function(input) {
  try {
    $m_s_package$();
    var value = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input);
    return new $c_s_util_Right(value)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x7 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x7.isEmpty__Z())) {
        var x8 = $as_jl_Throwable(x7.get__O());
        $m_s_package$();
        return new $c_s_util_Left(x8)
      }
    };
    throw e$2
  }
});
var $d_Lio_circe_scalajs_package$ = new $TypeData().initClass({
  Lio_circe_scalajs_package$: 0
}, false, "io.circe.scalajs.package$", {
  Lio_circe_scalajs_package$: 1,
  O: 1
});
$c_Lio_circe_scalajs_package$.prototype.$classData = $d_Lio_circe_scalajs_package$;
var $n_Lio_circe_scalajs_package$;
function $m_Lio_circe_scalajs_package$() {
  if ((!$n_Lio_circe_scalajs_package$)) {
    $n_Lio_circe_scalajs_package$ = new $c_Lio_circe_scalajs_package$()
  };
  return $n_Lio_circe_scalajs_package$
}
/** @constructor */
function $c_jl_Class(data0) {
  this.jl_Class__f_data = null;
  this.jl_Class__f_cachedSimpleName = null;
  this.jl_Class__f_data = data0
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
  /*<skip>*/
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.isInterface__Z() ? "interface " : (this.isPrimitive__Z() ? "" : "class ")) + this.getName__T())
});
$c_jl_Class.prototype.isAssignableFrom__jl_Class__Z = (function(that) {
  return $uZ(this.jl_Class__f_data.isAssignableFrom(that.jl_Class__f_data))
});
$c_jl_Class.prototype.isInterface__Z = (function() {
  return $uZ(this.jl_Class__f_data.isInterface)
});
$c_jl_Class.prototype.isArray__Z = (function() {
  return $uZ(this.jl_Class__f_data.isArrayClass)
});
$c_jl_Class.prototype.isPrimitive__Z = (function() {
  return $uZ(this.jl_Class__f_data.isPrimitive)
});
$c_jl_Class.prototype.getName__T = (function() {
  return $as_T(this.jl_Class__f_data.name)
});
$c_jl_Class.prototype.getComponentType__jl_Class = (function() {
  return $as_jl_Class(this.jl_Class__f_data.getComponentType())
});
$c_jl_Class.prototype.newArrayOfThisClass__O__O = (function(dimensions) {
  return this.jl_Class__f_data.newArrayOfThisClass(dimensions)
});
function $as_jl_Class(obj) {
  return (((obj instanceof $c_jl_Class) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Class"))
}
function $isArrayOf_jl_Class(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Class)))
}
function $asArrayOf_jl_Class(obj, depth) {
  return (($isArrayOf_jl_Class(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Class;", depth))
}
var $d_jl_Class = new $TypeData().initClass({
  jl_Class: 0
}, false, "java.lang.Class", {
  jl_Class: 1,
  O: 1
});
$c_jl_Class.prototype.$classData = $d_jl_Class;
function $is_jl_Comparable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Comparable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $c_RTLong)) || (obj instanceof $Char))
}
function $as_jl_Comparable(obj) {
  return (($is_jl_Comparable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Comparable"))
}
function $isArrayOf_jl_Comparable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Comparable)))
}
function $asArrayOf_jl_Comparable(obj, depth) {
  return (($isArrayOf_jl_Comparable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Comparable;", depth))
}
/** @constructor */
function $c_jl_FloatingPointBits$() {
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = false;
  this.jl_FloatingPointBits$__f_arrayBuffer = null;
  this.jl_FloatingPointBits$__f_int32Array = null;
  this.jl_FloatingPointBits$__f_float32Array = null;
  this.jl_FloatingPointBits$__f_float64Array = null;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = false;
  this.jl_FloatingPointBits$__f_highOffset = 0;
  this.jl_FloatingPointBits$__f_lowOffset = 0;
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null;
  $n_jl_FloatingPointBits$ = this;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = true;
  this.jl_FloatingPointBits$__f_arrayBuffer = new ArrayBuffer(8);
  this.jl_FloatingPointBits$__f_int32Array = new Int32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float32Array = new Float32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float64Array = new Float64Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 1);
  this.jl_FloatingPointBits$__f_int32Array[0] = 16909060;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = ($uB(new Int8Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 8)[0]) === 1);
  this.jl_FloatingPointBits$__f_highOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 0 : 1);
  this.jl_FloatingPointBits$__f_lowOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 1 : 0);
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null
}
$c_jl_FloatingPointBits$.prototype = new $h_O();
$c_jl_FloatingPointBits$.prototype.constructor = $c_jl_FloatingPointBits$;
/** @constructor */
function $h_jl_FloatingPointBits$() {
  /*<skip>*/
}
$h_jl_FloatingPointBits$.prototype = $c_jl_FloatingPointBits$.prototype;
$c_jl_FloatingPointBits$.prototype.numberHashCode__D__I = (function(value) {
  var iv = $uI((value | 0));
  if (((iv === value) && ((1.0 / value) !== (-Infinity)))) {
    return iv
  } else {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    return ($uI(this.jl_FloatingPointBits$__f_int32Array[0]) ^ $uI(this.jl_FloatingPointBits$__f_int32Array[1]))
  }
});
$c_jl_FloatingPointBits$.prototype.intBitsToFloat__I__F = (function(bits) {
  this.jl_FloatingPointBits$__f_int32Array[0] = bits;
  return $uF(this.jl_FloatingPointBits$__f_float32Array[0])
});
$c_jl_FloatingPointBits$.prototype.floatToIntBits__F__I = (function(value) {
  this.jl_FloatingPointBits$__f_float32Array[0] = value;
  return $uI(this.jl_FloatingPointBits$__f_int32Array[0])
});
$c_jl_FloatingPointBits$.prototype.longBitsToDouble__J__D = (function(bits) {
  var $$x2 = this.jl_FloatingPointBits$__f_int32Array;
  var $$x1 = this.jl_FloatingPointBits$__f_highOffset;
  var hi = bits.RTLong__f_hi;
  $$x2[$$x1] = hi;
  this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset] = bits.RTLong__f_lo;
  return $uD(this.jl_FloatingPointBits$__f_float64Array[0])
});
$c_jl_FloatingPointBits$.prototype.doubleToLongBits__D__J = (function(value) {
  this.jl_FloatingPointBits$__f_float64Array[0] = value;
  var value$1 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_highOffset]);
  var value$2 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset]);
  return new $c_RTLong(value$2, value$1)
});
var $d_jl_FloatingPointBits$ = new $TypeData().initClass({
  jl_FloatingPointBits$: 0
}, false, "java.lang.FloatingPointBits$", {
  jl_FloatingPointBits$: 1,
  O: 1
});
$c_jl_FloatingPointBits$.prototype.$classData = $d_jl_FloatingPointBits$;
var $n_jl_FloatingPointBits$;
function $m_jl_FloatingPointBits$() {
  if ((!$n_jl_FloatingPointBits$)) {
    $n_jl_FloatingPointBits$ = new $c_jl_FloatingPointBits$()
  };
  return $n_jl_FloatingPointBits$
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = $L0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
  /*<skip>*/
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"))
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)))
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth))
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass({
  jl_Long$StringRadixInfo: 0
}, false, "java.lang.Long$StringRadixInfo", {
  jl_Long$StringRadixInfo: 1,
  O: 1
});
$c_jl_Long$StringRadixInfo.prototype.$classData = $d_jl_Long$StringRadixInfo;
/** @constructor */
function $c_jl_Math$() {
  /*<skip>*/
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
  /*<skip>*/
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  if (((a !== a) || (a === Infinity))) {
    return a
  } else if ((a === (-0))) {
    return 1.401298464324817E-45
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? ((1 + abits) | 0) : (((-1) + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  if (((a !== a) || (a === (-Infinity)))) {
    return a
  } else if ((a === 0.0)) {
    return (-1.401298464324817E-45)
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? (((-1) + abits) | 0) : ((1 + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.addExact__J__J__J = (function(a, b) {
  var alo = a.RTLong__f_lo;
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var resSgnBit = (hi < 0);
  var ahi$1 = a.RTLong__f_hi;
  if ((resSgnBit === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    var $$x1 = (resSgnBit === (ahi$2 < 0))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.subtractExact__J__J__J = (function(a, b) {
  var alo = a.RTLong__f_lo;
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  var resSgnBit = (hi < 0);
  var ahi$1 = a.RTLong__f_hi;
  if ((resSgnBit === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    var $$x1 = (resSgnBit === ((ahi$2 === 0) ? (b.RTLong__f_lo !== 0) : (ahi$2 > 0)))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.multiplyExact__J__J__J = (function(a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var this$1 = $m_RTLong$();
    var lo = this$1.divideImpl__I__I__I__I__I((-1), 2147483647, b.RTLong__f_lo, b.RTLong__f_hi);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi))) {
      var overflow = true
    } else {
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(0, (-2147483648), b.RTLong__f_lo, b.RTLong__f_hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var ahi$2 = a.RTLong__f_hi;
      var overflow = ((ahi$2 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$2 < hi$1))
    }
  } else {
    var ahi$3 = b.RTLong__f_hi;
    if (((ahi$3 === (-1)) ? (b.RTLong__f_lo !== (-1)) : (ahi$3 < (-1)))) {
      var this$3 = $m_RTLong$();
      var lo$2 = this$3.divideImpl__I__I__I__I__I(0, (-2147483648), b.RTLong__f_lo, b.RTLong__f_hi);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var ahi$4 = a.RTLong__f_hi;
      if (((ahi$4 === hi$2) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo$2)) : (ahi$4 > hi$2))) {
        var overflow = true
      } else {
        var this$4 = $m_RTLong$();
        var lo$3 = this$4.divideImpl__I__I__I__I__I((-1), 2147483647, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var ahi$5 = a.RTLong__f_hi;
        var overflow = ((ahi$5 === hi$3) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$3)) : (ahi$5 < hi$3))
      }
    } else {
      var overflow = (((b.RTLong__f_lo === (-1)) && (b.RTLong__f_hi === (-1))) && ((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === (-2147483648))))
    }
  };
  if ((!overflow)) {
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return new $c_RTLong(lo$4, hi$4)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.toIntExact__J__I = (function(a) {
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ a.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var ahi$1 = a.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ a.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return a.RTLong__f_lo
  } else {
    throw new $c_jl_ArithmeticException("Integer overflow")
  }
});
$c_jl_Math$.prototype.floorDiv__J__J__J = (function(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var ahi = a.RTLong__f_hi;
  var ahi$1 = b.RTLong__f_hi;
  if (((ahi < 0) === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(lo, b.RTLong__f_hi) + Math.imul(hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $$x1 = ((lo$1 === a.RTLong__f_lo) && (hi$1 === a.RTLong__f_hi))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    var lo$2 = (((-1) + lo) | 0);
    var hi$2 = ((lo$2 !== (-1)) ? hi : (((-1) + hi) | 0));
    return new $c_RTLong(lo$2, hi$2)
  }
});
$c_jl_Math$.prototype.floorMod__J__J__J = (function(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var ahi = a.RTLong__f_hi;
  var ahi$1 = b.RTLong__f_hi;
  if ((((ahi < 0) === (ahi$1 < 0)) || ((lo === 0) && (hi === 0)))) {
    return new $c_RTLong(lo, hi)
  } else {
    var bhi = b.RTLong__f_hi;
    var lo$1 = ((lo + b.RTLong__f_lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi + bhi) | 0)) | 0) : ((hi + bhi) | 0));
    return new $c_RTLong(lo$1, hi$1)
  }
});
var $d_jl_Math$ = new $TypeData().initClass({
  jl_Math$: 0
}, false, "java.lang.Math$", {
  jl_Math$: 1,
  O: 1
});
$c_jl_Math$.prototype.$classData = $d_jl_Math$;
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$()
  };
  return $n_jl_Math$
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_out = null;
  this.jl_System$Streams$__f_err = null;
  this.jl_System$Streams$__f_in = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_out = new $c_jl_JSConsoleBasedPrintStream(false);
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
  this.jl_System$Streams$__f_in = null
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
  /*<skip>*/
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass({
  jl_System$Streams$: 0
}, false, "java.lang.System$Streams$", {
  jl_System$Streams$: 1,
  O: 1
});
$c_jl_System$Streams$.prototype.$classData = $d_jl_System$Streams$;
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$()
  };
  return $n_jl_System$Streams$
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = {};
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  var value = $as_T($linkingInfo.linkerVersion);
  result["java.vm.version"] = value;
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
  /*<skip>*/
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  return ((this.jl_System$SystemProperties$__f_dict !== null) ? $as_T($m_jl_Utils$().dictGetOrElse__O__T__O__O(this.jl_System$SystemProperties$__f_dict, key, default$1)) : this.jl_System$SystemProperties$__f_properties.getProperty__T__T__T(key, default$1))
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass({
  jl_System$SystemProperties$: 0
}, false, "java.lang.System$SystemProperties$", {
  jl_System$SystemProperties$: 1,
  O: 1
});
$c_jl_System$SystemProperties$.prototype.$classData = $d_jl_System$SystemProperties$;
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$()
  };
  return $n_jl_System$SystemProperties$
}
function $ct_jl_ThreadLocal__($thiz) {
  $thiz.jl_ThreadLocal__f_hasValue = false;
  return $thiz
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
  /*<skip>*/
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(this.initialValue__O())
  };
  return this.jl_ThreadLocal__f_v
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true
});
/** @constructor */
function $c_jl_Utils$() {
  /*<skip>*/
}
$c_jl_Utils$.prototype = new $h_O();
$c_jl_Utils$.prototype.constructor = $c_jl_Utils$;
/** @constructor */
function $h_jl_Utils$() {
  /*<skip>*/
}
$h_jl_Utils$.prototype = $c_jl_Utils$.prototype;
$c_jl_Utils$.prototype.dictGetOrElse__O__T__O__O = (function(dict, key, default$1) {
  return ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1)
});
var $d_jl_Utils$ = new $TypeData().initClass({
  jl_Utils$: 0
}, false, "java.lang.Utils$", {
  jl_Utils$: 1,
  O: 1
});
$c_jl_Utils$.prototype.$classData = $d_jl_Utils$;
var $n_jl_Utils$;
function $m_jl_Utils$() {
  if ((!$n_jl_Utils$)) {
    $n_jl_Utils$ = new $c_jl_Utils$()
  };
  return $n_jl_Utils$
}
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
  /*<skip>*/
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass({
  jl_Utils$Cache$: 0
}, false, "java.lang.Utils$Cache$", {
  jl_Utils$Cache$: 1,
  O: 1
});
$c_jl_Utils$Cache$.prototype.$classData = $d_jl_Utils$Cache$;
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$()
  };
  return $n_jl_Utils$Cache$
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined"
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"))
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)))
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth))
}
var $d_jl_Void = new $TypeData().initClass({
  jl_Void: 0
}, false, "java.lang.Void", {
  jl_Void: 1,
  O: 1
}, (void 0), (void 0), ((x) => (x === (void 0))));
/** @constructor */
function $c_jl_reflect_Array$() {
  /*<skip>*/
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
  /*<skip>*/
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__I__O = (function(componentType, length) {
  return componentType.newArrayOfThisClass__O__O([length])
});
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__AI__O = (function(componentType, dimensions) {
  var jsDims = [];
  var len = dimensions.u.length;
  var i = 0;
  while ((i !== len)) {
    jsDims.push(dimensions.get(i));
    i = ((1 + i) | 0)
  };
  return componentType.newArrayOfThisClass__O__O(jsDims)
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return x2.u.length
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return x3.u.length
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return x4.u.length
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return x5.u.length
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return x6.u.length
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return x7.u.length
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return x8.u.length
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return x9.u.length
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return x10.u.length
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch")
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass({
  jl_reflect_Array$: 0
}, false, "java.lang.reflect.Array$", {
  jl_reflect_Array$: 1,
  O: 1
});
$c_jl_reflect_Array$.prototype.$classData = $d_jl_reflect_Array$;
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$()
  };
  return $n_jl_reflect_Array$
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem])
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass({
  Ljava_math_BigInteger$QuotAndRem: 0
}, false, "java.math.BigInteger$QuotAndRem", {
  Ljava_math_BigInteger$QuotAndRem: 1,
  O: 1
});
$c_Ljava_math_BigInteger$QuotAndRem.prototype.$classData = $d_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $c_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if ((bi.Ljava_math_BigInteger__f_sign === 0)) {
    return 0
  } else {
    var bLength = (bi.Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = bi.Ljava_math_BigInteger__f_digits.get((((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0));
    if ((bi.Ljava_math_BigInteger__f_sign < 0)) {
      var i = bi.getFirstNonzeroDigit__I();
      if ((i === (((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0)
      }
    };
    var $$x1 = bLength;
    var i$1 = highDigit;
    bLength = (($$x1 - Math.clz32(i$1)) | 0);
    return bLength
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = ((((source.Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var length = ((result.u.length - intCount) | 0);
    source.copyTo(0, result, intCount, length)
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.set((((-1) + result.u.length) | 0), 0);
    var i = (((-1) + result.u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.set(ev$1, (result.get(ev$1) | ((source.get((((-1) + ((i - intCount) | 0)) | 0)) >>> rightShiftCount) | 0)));
      result.set((((-1) + i) | 0), (source.get((((-1) + ((i - intCount) | 0)) | 0)) << count));
      i = (((-1) + i) | 0)
    }
  };
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var arg1 = i$1;
    result.set(arg1, 0);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = source.Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var arg1 = i;
    var iVal = source.get(arg1);
    result.set(arg1, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0)
  };
  if ((elem !== 0)) {
    result.set(srcLen, elem)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  if ((intCount >= source.Ljava_math_BigInteger__f_numberLength)) {
    return ((source.Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO)
  } else {
    var resLength = ((source.Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
    if ((source.Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && (source.Ljava_math_BigInteger__f_digits.get(i) === 0))) {
        i = ((1 + i) | 0)
      };
      var cmp = ((source.Ljava_math_BigInteger__f_digits.get(i) << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.get(i) === (-1)))) {
          resDigits.set(i, 0);
          i = ((1 + i) | 0)
        };
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0)
        };
        var ev$1 = i;
        resDigits.set(ev$1, ((1 + resDigits.get(ev$1)) | 0))
      }
    };
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.get(i) === 0))));
    i = ((1 + i) | 0)
  };
  if ((count === 0)) {
    source.copyTo(intCount, result, 0, resultLen)
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      result.set(i, (((source.get(((i + intCount) | 0)) >>> count) | 0) | (source.get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0)
    };
    result.set(i, ((source.get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0)
  };
  return allZero
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass({
  Ljava_math_BitLevel$: 0
}, false, "java.math.BitLevel$", {
  Ljava_math_BitLevel$: 1,
  O: 1
});
$c_Ljava_math_BitLevel$.prototype.$classData = $d_Ljava_math_BitLevel$;
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$()
  };
  return $n_Ljava_math_BitLevel$
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = $uI(s.length);
  while (true) {
    if ((zeroPrefixLength < len)) {
      var index = zeroPrefixLength;
      var $$x1 = ((65535 & $uI(s.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0)
    } else {
      break
    }
  };
  var beginIndex = zeroPrefixLength;
  return $as_T(s.substring(beginIndex))
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]))
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
  /*<skip>*/
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  var radixOutOfBounds = ((radix < 2) || (radix > 36));
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var highDigit = digits.get((((-1) + numberLength) | 0));
    var v__lo = highDigit;
    var v__hi = 0;
    if ((sign < 0)) {
      var this$2__lo = v__lo;
      var this$2__hi = v__hi;
      var lo = this$2__lo;
      var hi$1 = this$2__hi;
      var lo$1 = ((-lo) | 0);
      var hi$2 = ((lo !== 0) ? (~hi$1) : ((-hi$1) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$2;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi
    };
    var i__lo = v__lo;
    var i__hi = v__hi;
    var this$5 = $m_jl_Long$();
    return ((((radix === 10) || (radix < 2)) || (radix > 36)) ? $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(i__lo, i__hi) : this$5.java$lang$Long$$toStringImpl__J__I__T(new $c_RTLong(i__lo, i__hi), radix))
  } else if (((radix === 10) || radixOutOfBounds)) {
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(bi)
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$8 = bi.abs__Ljava_math_BigInteger();
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$8);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      digits.copyTo(0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = this.Ljava_math_Conversion$__f_DigitFitInInt.get(radix);
      var bigRadix = this.Ljava_math_Conversion$__f_BigRadices.get((((-2) + radix) | 0));
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var digit = $intMod(elem$2, radix);
          var this$13 = $m_jl_Character$().forDigit__I__I__C(digit, radix);
          elem = (("" + $as_T(String.fromCharCode(this$13))) + $as_T(elem));
          elem$2 = $intDiv(elem$2, radix);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue
          };
          break
        };
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = (((-1) + elem$1) | 0);
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        i$1 = (((-1) + elem$3) | 0);
        while (((i$1 > 0) && (temp.get(i$1) === 0))) {
          i$1 = (((-1) + i$1) | 0)
        };
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.get(0) === 0)))) {
          continue
        };
        break
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var arg1 = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & (digits.get(arg1) >> (j << 2)));
          elem$1 = (((-1) + elem$1) | 0);
          var i$3 = elem$2;
          elem = (("" + $as_T($uD((i$3 >>> 0)).toString(16))) + $as_T(elem));
          j = ((1 + j) | 0)
        };
        i$2 = ((1 + i$2) | 0)
      }
    };
    var dropLen = 0;
    while (true) {
      var this$18 = $as_T(elem);
      var index = dropLen;
      if (((65535 & $uI(this$18.charCodeAt(index))) === 48)) {
        dropLen = ((1 + dropLen) | 0)
      } else {
        break
      }
    };
    if ((dropLen !== 0)) {
      var this$19 = $as_T(elem);
      var beginIndex = dropLen;
      elem = $as_T(this$19.substring(beginIndex))
    };
    return ((sign === (-1)) ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var i = digits.get(0);
    var absStr = $as_T($uD((i >>> 0)).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr)
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var length = tempLen;
    digits.copyTo(0, temp, 0, length);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.get(i$1);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideUnsignedImpl__I__I__I__I__I(value$1, value, 1000000000, 0);
        temp.set(i$1, lo);
        var hi$3 = (lo >> 31);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(51712, b0);
        var a1b0 = Math.imul(15258, b0);
        var a0b1 = Math.imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$4 = ((((((Math.imul(1000000000, hi$3) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0)
      };
      var this$8 = rem;
      var remStr = ("" + this$8);
      var beginIndex = $uI(remStr.length);
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.get((((-1) + tempLen) | 0)) === 0))) {
        tempLen = (((-1) + tempLen) | 0)
      };
      if ((tempLen !== 0)) {
        /*<skip>*/
      } else {
        break
      }
    };
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result)
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break
      }
      case 1: {
        return "0.0";
        break
      }
      case 2: {
        return "0.00";
        break
      }
      case 3: {
        return "0.000";
        break
      }
      case 4: {
        return "0.0000";
        break
      }
      case 5: {
        return "0.00000";
        break
      }
      case 6: {
        return "0.000000";
        break
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648"
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i)
        };
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal)
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var t = new $c_RTLong(x__lo, x__hi)
    } else {
      var t = value
    };
    var lo$2 = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var v__lo = lo$2;
    var v__hi = hi$2;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var this$5__lo = v__lo;
      var this$5__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$3 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, 10, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$3;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((Math.imul(10, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var alo = prev__lo;
      var ahi$1 = prev__hi;
      var lo$5 = ((alo - lo$4) | 0);
      elem = (("" + lo$5) + $as_T(elem));
      var this$9__lo = v__lo;
      var this$9__hi = v__hi;
      if ((!((this$9__lo === 0) && (this$9__hi === 0)))) {
        /*<skip>*/
      } else {
        break
      }
    };
    var value$1 = ((18 - currentChar) | 0);
    var hi$6 = (value$1 >> 31);
    var hi$7 = (scale >> 31);
    var lo$6 = ((value$1 - scale) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
    var lo$7 = (((-1) + lo$6) | 0);
    var hi$9 = ((lo$7 !== (-1)) ? hi$8 : (((-1) + hi$8) | 0));
    if (((scale > 0) && ((hi$9 === (-1)) ? (((-2147483648) ^ lo$7) >= 2147483642) : (hi$9 > (-1))))) {
      var index = ((1 + lo$7) | 0);
      if ((index > 0)) {
        var this$14 = $as_T(elem);
        var $$x2 = $as_T(this$14.substring(0, index));
        var this$15 = $as_T(elem);
        elem = (($$x2 + ".") + $as_T(this$15.substring(index)))
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        elem = ("0." + $as_T(elem))
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$9 === 0) ? (lo$7 !== 0) : (hi$9 > 0)) ? ("E+" + new $c_RTLong(lo$7, hi$9)) : ("E" + new $c_RTLong(lo$7, hi$9)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$19 = $as_T(elem);
        var $$x3 = $as_T(this$19.substring(0, 1));
        var this$20 = $as_T(elem);
        elem = ((($$x3 + ".") + $as_T(this$20.substring(1))) + exponentStr)
      } else {
        elem = ($as_T(elem) + exponentStr)
      }
    };
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass({
  Ljava_math_Conversion$: 0
}, false, "java.math.Conversion$", {
  Ljava_math_Conversion$: 1,
  O: 1
});
$c_Ljava_math_Conversion$.prototype.$classData = $d_Ljava_math_Conversion$;
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$()
  };
  return $n_Ljava_math_Conversion$
}
/** @constructor */
function $c_Ljava_math_Division$() {
  /*<skip>*/
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
  /*<skip>*/
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.get((((-1) + bLength) | 0));
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift)
  } else {
    a.copyTo(0, normA, 0, aLength);
    b.copyTo(0, normB, 0, bLength)
  };
  var firstDivisorDigit = normB.get((((-1) + bLength) | 0));
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.get(elem) === firstDivisorDigit)) {
      elem$1 = (-1)
    } else {
      var value = normA.get(elem);
      var value$1 = normA.get((((-1) + elem) | 0));
      var this$7 = $m_RTLong$();
      var lo = this$7.divideUnsignedImpl__I__I__I__I__I(value$1, value, firstDivisorDigit, 0);
      var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((Math.imul(hi$3, firstDivisorDigit) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.get((((-2) + bLength) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.get((((-2) + elem) | 0));
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$13 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$6)) ? 1 : 0);
          if ((hi$13 === 0)) {
            elem$2 = lo$4;
            var hi$14 = ((-2147483648) ^ hi$8);
            var hi$15 = ((-2147483648) ^ value$4);
            if (((hi$14 === hi$15) ? (((-2147483648) ^ lo$3) > ((-2147483648) ^ value$5)) : (hi$14 > hi$15))) {
              continue
            }
          };
          break
        }
      }
    };
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $$x1__lo = 0;
        var $$x1__hi = 0;
        elem$3__lo = $$x1__lo;
        elem$3__hi = $$x1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var arg1 = i$2;
          var this$24__lo = elem$3__lo;
          var this$24__hi = elem$3__hi;
          var value$7 = normA.get(((((elem - bLength) | 0) + arg1) | 0));
          var value$8 = normB.get(arg1);
          var lo$5 = ((value$7 + value$8) | 0);
          var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ value$7)) ? 1 : 0);
          var alo = this$24__lo;
          var ahi = this$24__hi;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$18) | 0)) | 0) : ((ahi + hi$18) | 0));
          var $$x2__lo = lo$6;
          var $$x2__hi = hi$19;
          elem$3__lo = $$x2__lo;
          elem$3__hi = $$x2__hi;
          var $$x3 = elem;
          var this$26__lo = elem$3__lo;
          var this$26__hi = elem$3__hi;
          normA.set((((($$x3 - bLength) | 0) + arg1) | 0), this$26__lo);
          var this$27__lo = elem$3__lo;
          var this$27__hi = elem$3__hi;
          var hi$20 = this$27__hi;
          var $$x4__lo = hi$20;
          var $$x4__hi = 0;
          elem$3__lo = $$x4__lo;
          elem$3__hi = $$x4__hi;
          i$2 = ((1 + i$2) | 0)
        }
      }
    };
    if ((quot !== null)) {
      quot.set(i$1, elem$1)
    };
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0)
  };
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB
  } else {
    normA.copyTo(0, normB, 0, bLength);
    return normA
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = bi.Ljava_math_BigInteger__f_digits;
  var valLen = bi.Ljava_math_BigInteger__f_numberLength;
  var valSign = bi.Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = valDigits.get(0);
    if ((divisor === 0)) {
      var value = $intDiv(0, 0)
    } else {
      var n = ($uD((valDigit >>> 0)) / $uD((divisor >>> 0)));
      var value = $uI((n | 0))
    };
    var quo__lo = value;
    var quo__hi = 0;
    if ((divisor === 0)) {
      var value$1 = $intMod(0, 0)
    } else {
      var n$1 = ($uD((valDigit >>> 0)) % $uD((divisor >>> 0)));
      var value$1 = $uI((n$1 | 0))
    };
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var this$5__lo = quo__lo;
      var this$5__hi = quo__hi;
      var lo = this$5__lo;
      var hi$2 = this$5__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      quo__lo = $$x1__lo;
      quo__hi = $$x1__hi
    };
    if ((valSign < 0)) {
      var this$8__lo = rem__lo;
      var this$8__hi = rem__hi;
      var lo$2 = this$8__lo;
      var hi$4 = this$8__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      rem__lo = $$x2__lo;
      rem__hi = $$x2__hi
    };
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)))
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.get(i);
    var this$4 = $m_RTLong$();
    var lo = this$4.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((Math.imul(hi$3, divisor) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    dest.set(i, lo);
    i = (((-1) + i) | 0)
  };
  return rem
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.get(arg1);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    var value = a.get(((start + arg1) | 0));
    var lo$2 = ((value - lo$1) | 0);
    var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$1 = elem$1;
    var hi$7 = (value$1 >> 31);
    var lo$3 = ((lo$2 + value$1) | 0);
    var hi$8 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$6 + hi$7) | 0)) | 0) : ((hi$6 + hi$7) | 0));
    a.set(((start + arg1) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  var value$2 = a.get(((start + bLen) | 0));
  var value$3 = elem;
  var lo$4 = ((value$2 - value$3) | 0);
  var hi$13 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value$2)) ? (-1) : 0);
  var value$4 = elem$1;
  var hi$14 = (value$4 >> 31);
  var lo$5 = ((lo$4 + value$4) | 0);
  var hi$15 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$13 + hi$14) | 0)) | 0) : ((hi$13 + hi$14) | 0));
  a.set(((start + bLen) | 0), lo$5);
  return hi$15
});
var $d_Ljava_math_Division$ = new $TypeData().initClass({
  Ljava_math_Division$: 0
}, false, "java.math.Division$", {
  Ljava_math_Division$: 1,
  O: 1
});
$c_Ljava_math_Division$.prototype.$classData = $d_Ljava_math_Division$;
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$()
  };
  return $n_Ljava_math_Division$
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.get(0);
  var value$1 = b.get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
  res.set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.get(i);
      var value$3 = b.get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ value$2)) ? 1 : 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$6) | 0) : hi$6);
      res.set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0)
    };
    while ((i < aSize)) {
      var value$5 = a.get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ value$5)) ? 1 : 0);
      res.set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0)
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.get(i);
      var value$8 = b.get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$7)) ? 1 : 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$16) | 0) : hi$16);
      res.set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0)
    };
    while ((i < bSize)) {
      var value$10 = b.get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ value$10)) ? 1 : 0);
      res.set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0)
    }
  };
  if ((carry !== 0)) {
    res.set(i, carry)
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.get(i);
    var value$1 = b.get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
    res.set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0)
  };
  while ((i < aSize)) {
    var value$3 = a.get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ value$3)) ? ((1 + hi$7) | 0) : hi$7);
    res.set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0)
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
  /*<skip>*/
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
  /*<skip>*/
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2
  } else if ((op2Sign === 0)) {
    return op1
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
    } else {
      var $$x1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$1)) ? (-1) : 0);
        var x__lo = lo$1;
        var x__hi = hi$3
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
        var x__lo = lo$2;
        var x__hi = hi$4
      };
      return $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi))
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      };
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1
      }
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && (a.get(i) === b.get(i)))) {
    i = (((-1) + i) | 0)
  };
  if ((i < 0)) {
    return 0
  } else {
    var value = a.get(i);
    var value$1 = b.get(i);
    if ((((-2147483648) ^ value) < ((-2147483648) ^ value$1))) {
      return (-1)
    } else {
      return 1
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
    a.set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0)
  };
  return carry
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1
  } else if ((op1Sign === 0)) {
    return op2.negate__Ljava_math_BigInteger()
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var a__lo = value;
    var a__hi = 0;
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var this$3__lo = a__lo;
      var this$3__hi = a__hi;
      var lo = this$3__lo;
      var hi$2 = this$3__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      a__lo = $$x1__lo;
      a__hi = $$x1__hi
    };
    if ((op2Sign < 0)) {
      var this$6__lo = b__lo;
      var this$6__hi = b__hi;
      var lo$2 = this$6__lo;
      var hi$4 = this$6__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      b__lo = $$x2__lo;
      b__hi = $$x2__hi
    };
    var $$x3 = $m_Ljava_math_BigInteger$();
    var this$9__lo = a__lo;
    var this$9__hi = a__hi;
    var b$1__lo = b__lo;
    var b$1__hi = b__hi;
    var alo = this$9__lo;
    var ahi = this$9__hi;
    var bhi = b$1__hi;
    var lo$4 = ((alo - b$1__lo) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    return $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$6))
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
    };
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass({
  Ljava_math_Elementary$: 0
}, false, "java.math.Elementary$", {
  Ljava_math_Elementary$: 1,
  O: 1
});
$c_Ljava_math_Elementary$.prototype.$classData = $d_Ljava_math_Elementary$;
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$()
  };
  return $n_Ljava_math_Elementary$
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
  /*<skip>*/
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === x2.Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = x2.Ljava_math_MathContext__f_roundingMode;
      return (x$2 === x$3)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | this.Ljava_math_MathContext__f_roundingMode.jl_Enum__f__ordinal)
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode)
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"))
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)))
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth))
}
var $d_Ljava_math_MathContext = new $TypeData().initClass({
  Ljava_math_MathContext: 0
}, false, "java.math.MathContext", {
  Ljava_math_MathContext: 1,
  O: 1
});
$c_Ljava_math_MathContext.prototype.$classData = $d_Ljava_math_MathContext;
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  this.Ljava_math_MathContext$__f_DECIMAL32 = null;
  this.Ljava_math_MathContext$__f_DECIMAL64 = null;
  this.Ljava_math_MathContext$__f_UNLIMITED = null;
  $n_Ljava_math_MathContext$ = this;
  $m_Ljava_math_MathContext$();
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_MathContext$();
  var roundingMode$1 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL32 = new $c_Ljava_math_MathContext(7, roundingMode$1);
  $m_Ljava_math_MathContext$();
  var roundingMode$2 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL64 = new $c_Ljava_math_MathContext(16, roundingMode$2);
  $m_Ljava_math_MathContext$();
  var roundingMode$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
  this.Ljava_math_MathContext$__f_UNLIMITED = new $c_Ljava_math_MathContext(0, roundingMode$3)
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
  /*<skip>*/
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass({
  Ljava_math_MathContext$: 0
}, false, "java.math.MathContext$", {
  Ljava_math_MathContext$: 1,
  O: 1
});
$c_Ljava_math_MathContext$.prototype.$classData = $d_Ljava_math_MathContext$;
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$()
  };
  return $n_Ljava_math_MathContext$
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $$x1__lo = 1;
  var $$x1__hi = 0;
  elem__lo = $$x1__lo;
  elem__hi = $$x1__hi;
  var i = 0;
  while ((i < 32)) {
    var arg1 = i;
    if ((arg1 <= 18)) {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi)));
      var $$x3 = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows;
      var $$x2 = $m_Ljava_math_BigInteger$();
      var this$4__lo = elem__lo;
      var this$4__hi = elem__hi;
      var lo = this$4__lo;
      var lo$1 = (((32 & arg1) === 0) ? (lo << arg1) : 0);
      var hi = (((32 & arg1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - arg1) | 0)) | 0) | (this$4__hi << arg1)) : (lo << arg1));
      $$x3.set(arg1, $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi)));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$1;
      elem__lo = $$x4__lo;
      elem__hi = $$x4__hi
    } else {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get(1)));
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN))
    };
    i = ((1 + i) | 0)
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.get(arg1);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    res.set(arg1, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  return elem
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t)
  } else {
    var i = 0;
    while ((i < aLen)) {
      var arg1 = i;
      var elem = 0;
      elem = 0;
      var aI = a.get(arg1);
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var arg1$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.get(arg1$1);
        var c = t.get(((arg1 + arg1$1) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
        t.set(((arg1 + arg1$1) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0)
      };
      t.set(((arg1 + bLen) | 0), elem);
      i = ((1 + i) | 0)
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((len > 0)) {
    var array = new $ac_I(len);
    var acc = 1;
    var i = 1;
    array.set(0, $uI(acc));
    while ((i < len)) {
      var arg1 = acc;
      var x$2 = $uI(arg1);
      acc = Math.imul(x$2, pow);
      array.set(i, $uI(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_I(0)
  }
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_FivePows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  this.Ljava_math_Multiplication$__f_FivePows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this)
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
  /*<skip>*/
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = bi.Ljava_math_BigInteger__f_sign;
  var aNumberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var aDigits = bi.Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else if ((aNumberLength === 1)) {
    var a = aDigits.get(0);
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    resDigits.set(aNumberLength, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor));
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp) {
  var value = this.Ljava_math_Multiplication$__f_TenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, this.Ljava_math_Multiplication$__f_TenPows.get(exp.RTLong__f_lo))
  } else {
    return bi.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp))
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var arg1 = i;
    elem = 0;
    var _\uff3fself = ((1 + arg1) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var arg1$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.get(arg1);
      var b = a.get(arg1$1);
      var c = res.get(((arg1 + arg1$1) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
      res.set(((arg1 + arg1$1) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0)
    };
    res.set(((arg1 + aLen) | 0), elem);
    i = ((1 + i) | 0)
  };
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$3 = 0;
  var index = 0;
  while ((i$3 < aLen)) {
    var a$2 = a.get(i$3);
    var b$1 = a.get(i$3);
    var c$1 = res.get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + hi$9) | 0) : hi$9);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$11) | 0) : hi$11);
    res.set(index, lo$5);
    index = ((1 + index) | 0);
    var value = res.get(index);
    var lo$6 = ((hi$13 + value) | 0);
    var hi$15 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ hi$13)) ? 1 : 0);
    res.set(index, lo$6);
    elem = hi$15;
    i$3 = ((1 + i$3) | 0);
    index = ((1 + index) | 0)
  };
  return res
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if ((val2.Ljava_math_BigInteger__f_numberLength > val1.Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1
  } else {
    var x1___1 = val1;
    var x1___2 = val2
  };
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if ((op2.Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2)
  } else {
    var ndiv2 = (((-2) & op1.Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = op1.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = op2.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var bi = upperOp1.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, bi);
    var bi$1 = upperOp2.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp2, upperOp2));
    var this$1 = middle;
    var bi$2 = upper;
    var this$2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi$2);
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, lower);
    middle = middle.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = upper.shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$3 = upper;
    var bi$3 = middle;
    var this$4 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi$3);
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, lower)
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.get(0)))
    } else if ((bLen === 1)) {
      resDigits.set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.get(0)))
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen)
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = a.Ljava_math_BigInteger__f_numberLength;
  var bLen = b.Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.Ljava_math_BigInteger__f_sign !== b.Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.Ljava_math_BigInteger__f_digits.get(0);
    var b$1 = b.Ljava_math_BigInteger__f_digits.get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var aDigits = a.Ljava_math_BigInteger__f_digits;
    var bDigits = b.Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if ((acc.Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = acc.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
    } else {
      var a = new $ac_I((acc.Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI(acc.Ljava_math_BigInteger__f_digits, acc.Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq)
    };
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2
  };
  return res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = this.Ljava_math_Multiplication$__f_BigTenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.Ljava_math_Multiplication$__f_BigTenPows.get(exp.RTLong__f_lo)
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-2147483598)) : (ahi$1 < 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-1)) : (ahi$2 < 0))) {
        return this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
      } else {
        var powerOfFive = this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var bhi = exp.RTLong__f_hi;
        var lo = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$1 = ((((-2147483648) ^ lo) < 1) ? bhi : (((-1) + bhi) | 0));
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$3 = $m_RTLong$();
        var lo$1 = this$3.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var this$4__lo = longExp__lo;
          var this$4__hi = longExp__hi;
          var ahi$3 = this$4__hi;
          if (((ahi$3 === 0) ? (((-2147483648) ^ this$4__lo) > (-1)) : (ahi$3 > 0))) {
            res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var bhi$1 = b__hi;
            var lo$2 = (((-2147483647) + b__lo) | 0);
            var hi$3 = ((((-2147483648) ^ lo$2) < 1) ? bhi$1 : (((-1) + bhi$1) | 0));
            var $$x1__lo = lo$2;
            var $$x1__hi = hi$3;
            longExp__lo = $$x1__lo;
            longExp__hi = $$x1__hi
          } else {
            break
          }
        };
        res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(lo$1));
        res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var bhi$2 = exp.RTLong__f_hi;
        var lo$3 = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$4 = ((((-2147483648) ^ lo$3) < 1) ? bhi$2 : (((-1) + bhi$2) | 0));
        var $$x2__lo = lo$3;
        var $$x2__hi = hi$4;
        longExp__lo = $$x2__lo;
        longExp__hi = $$x2__hi;
        while (true) {
          var this$7__lo = longExp__lo;
          var this$7__hi = longExp__hi;
          var ahi$4 = this$7__hi;
          if (((ahi$4 === 0) ? (((-2147483648) ^ this$7__lo) > (-1)) : (ahi$4 > 0))) {
            res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var bhi$3 = b$1__hi;
            var lo$4 = (((-2147483647) + b$1__lo) | 0);
            var hi$5 = ((((-2147483648) ^ lo$4) < 1) ? bhi$3 : (((-1) + bhi$3) | 0));
            var $$x3__lo = lo$4;
            var $$x3__hi = hi$5;
            longExp__lo = $$x3__lo;
            longExp__hi = $$x3__hi
          } else {
            break
          }
        };
        return res.shiftLeft__I__Ljava_math_BigInteger(lo$1)
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass({
  Ljava_math_Multiplication$: 0
}, false, "java.math.Multiplication$", {
  Ljava_math_Multiplication$: 1,
  O: 1
});
$c_Ljava_math_Multiplication$.prototype.$classData = $d_Ljava_math_Multiplication$;
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$()
  };
  return $n_Ljava_math_Multiplication$
}
/** @constructor */
function $c_Ljava_text_ParsePosition(index) {
  this.Ljava_text_ParsePosition__f_index = 0;
  this.Ljava_text_ParsePosition__f_errorIndex = 0;
  this.Ljava_text_ParsePosition__f_index = index;
  this.Ljava_text_ParsePosition__f_errorIndex = (-1)
}
$c_Ljava_text_ParsePosition.prototype = new $h_O();
$c_Ljava_text_ParsePosition.prototype.constructor = $c_Ljava_text_ParsePosition;
/** @constructor */
function $h_Ljava_text_ParsePosition() {
  /*<skip>*/
}
$h_Ljava_text_ParsePosition.prototype = $c_Ljava_text_ParsePosition.prototype;
$c_Ljava_text_ParsePosition.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_text_ParsePosition)) {
    var that = $as_Ljava_text_ParsePosition(other);
    return ((this.Ljava_text_ParsePosition__f_errorIndex === that.Ljava_text_ParsePosition__f_errorIndex) && (this.Ljava_text_ParsePosition__f_index === that.Ljava_text_ParsePosition__f_index))
  } else {
    return false
  }
});
$c_Ljava_text_ParsePosition.prototype.hashCode__I = (function() {
  var state = $as_sci_Seq($m_s_package$().s_package$__f_Seq.apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapIntArray__AI__sci_ArraySeq(new $ac_I(new Int32Array([this.Ljava_text_ParsePosition__f_errorIndex, this.Ljava_text_ParsePosition__f_index])))));
  return $uI($as_sc_IterableOnceOps(state.map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $uI(_$1);
    return _$1$1
  })))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2(((a, b) => {
    var a$1 = $uI(a);
    var b$1 = $uI(b);
    return ((Math.imul(31, a$1) + b$1) | 0)
  }))))
});
$c_Ljava_text_ParsePosition.prototype.toString__T = (function() {
  return (((("java.text.ParsePosition[index=" + this.Ljava_text_ParsePosition__f_index) + ",errorIndex=") + this.Ljava_text_ParsePosition__f_errorIndex) + "]")
});
function $as_Ljava_text_ParsePosition(obj) {
  return (((obj instanceof $c_Ljava_text_ParsePosition) || (obj === null)) ? obj : $throwClassCastException(obj, "java.text.ParsePosition"))
}
function $isArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_text_ParsePosition)))
}
function $asArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (($isArrayOf_Ljava_text_ParsePosition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.text.ParsePosition;", depth))
}
var $d_Ljava_text_ParsePosition = new $TypeData().initClass({
  Ljava_text_ParsePosition: 0
}, false, "java.text.ParsePosition", {
  Ljava_text_ParsePosition: 1,
  O: 1
});
$c_Ljava_text_ParsePosition.prototype.$classData = $d_Ljava_text_ParsePosition;
/** @constructor */
function $c_Ljava_time_Clock() {
  /*<skip>*/
}
$c_Ljava_time_Clock.prototype = new $h_O();
$c_Ljava_time_Clock.prototype.constructor = $c_Ljava_time_Clock;
/** @constructor */
function $h_Ljava_time_Clock() {
  /*<skip>*/
}
$h_Ljava_time_Clock.prototype = $c_Ljava_time_Clock.prototype;
/** @constructor */
function $c_Ljava_time_Duration$() {
  this.Ljava_time_Duration$__f_ZERO$lzy1 = null;
  this.Ljava_time_Duration$__f_ZERObitmap$1 = false
}
$c_Ljava_time_Duration$.prototype = new $h_O();
$c_Ljava_time_Duration$.prototype.constructor = $c_Ljava_time_Duration$;
/** @constructor */
function $h_Ljava_time_Duration$() {
  /*<skip>*/
}
$h_Ljava_time_Duration$.prototype = $c_Ljava_time_Duration$.prototype;
$c_Ljava_time_Duration$.prototype.ZERO__Ljava_time_Duration = (function() {
  if ((!this.Ljava_time_Duration$__f_ZERObitmap$1)) {
    this.Ljava_time_Duration$__f_ZERO$lzy1 = new $c_Ljava_time_Duration($L0, 0);
    this.Ljava_time_Duration$__f_ZERObitmap$1 = true
  };
  return this.Ljava_time_Duration$__f_ZERO$lzy1
});
$c_Ljava_time_Duration$.prototype.ofSeconds__J__J__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var t = $m_jl_Math$().floorDiv__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(seconds, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var nos = this$1.RTLong__f_lo;
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(lo$1, hi$1), nos)
});
$c_Ljava_time_Duration$.prototype.ofNanos__J__Ljava_time_Duration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var secs__lo = lo;
  var secs__hi = hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var nos = lo$1;
  if ((nos < 0)) {
    nos = ((1000000000 + nos) | 0);
    var b__lo = secs__lo;
    var b__hi = secs__hi;
    var bhi = b__hi;
    var lo$2 = (((-1) + b__lo) | 0);
    var hi$2 = ((lo$2 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var $$x1__lo = lo$2;
    var $$x1__hi = hi$2;
    secs__lo = $$x1__lo;
    secs__hi = $$x1__hi
  };
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(secs__lo, secs__hi), nos)
});
$c_Ljava_time_Duration$.prototype.java$time$Duration$$$create__J__I__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var hi = (nanoAdjustment >> 31);
  var lo = (seconds.RTLong__f_lo | nanoAdjustment);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.ZERO__Ljava_time_Duration()
  } else {
    return new $c_Ljava_time_Duration(seconds, nanoAdjustment)
  }
});
var $d_Ljava_time_Duration$ = new $TypeData().initClass({
  Ljava_time_Duration$: 0
}, false, "java.time.Duration$", {
  Ljava_time_Duration$: 1,
  O: 1
});
$c_Ljava_time_Duration$.prototype.$classData = $d_Ljava_time_Duration$;
var $n_Ljava_time_Duration$;
function $m_Ljava_time_Duration$() {
  if ((!$n_Ljava_time_Duration$)) {
    $n_Ljava_time_Duration$ = new $c_Ljava_time_Duration$()
  };
  return $n_Ljava_time_Duration$
}
/** @constructor */
function $c_Ljava_time_Instant$() {
  this.Ljava_time_Instant$__f_EPOCH$lzy1 = null;
  this.Ljava_time_Instant$__f_EPOCHbitmap$1 = false;
  this.Ljava_time_Instant$__f_MIN$lzy1 = null;
  this.Ljava_time_Instant$__f_MINbitmap$1 = false;
  this.Ljava_time_Instant$__f_MAX$lzy1 = null;
  this.Ljava_time_Instant$__f_MAXbitmap$1 = false
}
$c_Ljava_time_Instant$.prototype = new $h_O();
$c_Ljava_time_Instant$.prototype.constructor = $c_Ljava_time_Instant$;
/** @constructor */
function $h_Ljava_time_Instant$() {
  /*<skip>*/
}
$h_Ljava_time_Instant$.prototype = $c_Ljava_time_Instant$.prototype;
$c_Ljava_time_Instant$.prototype.EPOCH__Ljava_time_Instant = (function() {
  if ((!this.Ljava_time_Instant$__f_EPOCHbitmap$1)) {
    this.Ljava_time_Instant$__f_EPOCH$lzy1 = new $c_Ljava_time_Instant($L0, 0);
    this.Ljava_time_Instant$__f_EPOCHbitmap$1 = true
  };
  return this.Ljava_time_Instant$__f_EPOCH$lzy1
});
$c_Ljava_time_Instant$.prototype.ofEpochSecond__J__J__Ljava_time_Instant = (function(epochSecond, nanoAdjustment) {
  var t = $m_jl_Math$().floorDiv__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(epochSecond, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var nos = this$1.RTLong__f_lo;
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1), nos)
});
$c_Ljava_time_Instant$.prototype.ofEpochMilli__J__Ljava_time_Instant = (function(epochMilli) {
  var t = $m_jl_Math$().floorDiv__J__J__J(epochMilli, new $c_RTLong(1000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(epochMilli, new $c_RTLong(1000, 0));
  var mos = this$1.RTLong__f_lo;
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), Math.imul(1000000, mos))
});
$c_Ljava_time_Instant$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant = (function(temporal) {
  try {
    var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var nanoOfSecond = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var $$x2 = $m_Ljava_time_Instant$();
    var $$x1 = new $c_RTLong(lo, hi);
    var hi$1 = (nanoOfSecond >> 31);
    return $$x2.ofEpochSecond__J__J__Ljava_time_Instant($$x1, new $c_RTLong(nanoOfSecond, hi$1))
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain Instant from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)), ex)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_Instant$.prototype.java$time$Instant$$$create__J__I__Ljava_time_Instant = (function(seconds, nanoOfSecond) {
  var hi = (nanoOfSecond >> 31);
  var lo = (seconds.RTLong__f_lo | nanoOfSecond);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.EPOCH__Ljava_time_Instant()
  } else {
    var ahi = seconds.RTLong__f_hi;
    if (((ahi === (-7347440)) ? (((-2147483648) ^ seconds.RTLong__f_lo) < (-1805380608)) : (ahi < (-7347440)))) {
      var $$x1 = true
    } else {
      var ahi$1 = seconds.RTLong__f_hi;
      var $$x1 = ((ahi$1 === 7347410) ? (((-2147483648) ^ seconds.RTLong__f_lo) > 2056616191) : (ahi$1 > 7347410))
    };
    if ($$x1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Instant exceeds minimum or maximum instant")
    } else {
      return new $c_Ljava_time_Instant(seconds, nanoOfSecond)
    }
  }
});
var $d_Ljava_time_Instant$ = new $TypeData().initClass({
  Ljava_time_Instant$: 0
}, false, "java.time.Instant$", {
  Ljava_time_Instant$: 1,
  O: 1
});
$c_Ljava_time_Instant$.prototype.$classData = $d_Ljava_time_Instant$;
var $n_Ljava_time_Instant$;
function $m_Ljava_time_Instant$() {
  if ((!$n_Ljava_time_Instant$)) {
    $n_Ljava_time_Instant$ = new $c_Ljava_time_Instant$()
  };
  return $n_Ljava_time_Instant$
}
function $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate($thiz, year, month, dayOfMonth) {
  if ((dayOfMonth > 28)) {
    var $$x2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    var $$x1 = (dayOfMonth > month.length__Z__I($$x2.isLeapYear__J__Z(new $c_RTLong(year, hi))))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    if ((dayOfMonth === 29)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'February 29' as '" + year) + "' is not a leap year"))
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Invalid date '" + month.jl_Enum__f__name) + " ") + dayOfMonth) + "'"))
    }
  } else {
    return new $c_Ljava_time_LocalDate(year, month.getValue__I(), dayOfMonth)
  }
}
/** @constructor */
function $c_Ljava_time_LocalDate$() {
  this.Ljava_time_LocalDate$__f_MIN$lzy1 = null;
  this.Ljava_time_LocalDate$__f_MINbitmap$1 = false;
  this.Ljava_time_LocalDate$__f_MAX$lzy1 = null;
  this.Ljava_time_LocalDate$__f_MAXbitmap$1 = false;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 0;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = $L0;
  $n_Ljava_time_LocalDate$ = this;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 146097;
  var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(5, b0);
  var a0b1 = Math.imul(5, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(5, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = (((-10957) + lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) < 2147472691) ? hi$1 : (((-1) + hi$1) | 0));
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = new $c_RTLong(lo$1, hi$2)
}
$c_Ljava_time_LocalDate$.prototype = new $h_O();
$c_Ljava_time_LocalDate$.prototype.constructor = $c_Ljava_time_LocalDate$;
/** @constructor */
function $h_Ljava_time_LocalDate$() {
  /*<skip>*/
}
$h_Ljava_time_LocalDate$.prototype = $c_Ljava_time_LocalDate$.prototype;
$c_Ljava_time_LocalDate$.prototype.of__I__Ljava_time_Month__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  if ((month === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "month")
  };
  var this$5 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  var hi$1 = (dayOfMonth >> 31);
  this$5.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$1), this$5);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, month, dayOfMonth)
});
$c_Ljava_time_LocalDate$.prototype.of__I__I__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (month >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  var hi$2 = (dayOfMonth >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$2), this$6);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, $m_Ljava_time_Month$().of__I__Ljava_time_Month(month), dayOfMonth)
});
$c_Ljava_time_LocalDate$.prototype.ofYearDay__I__I__Ljava_time_LocalDate = (function(year, dayOfYear) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (dayOfYear >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfYear, hi$1), this$4);
  var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var hi$2 = (year >> 31);
  var leap = $$x1.isLeapYear__J__Z(new $c_RTLong(year, hi$2));
  if (((dayOfYear === 366) && (!leap))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'DayOfYear 366' as '" + year) + "' is not a leap year"))
  };
  var moy = $m_Ljava_time_Month$().of__I__Ljava_time_Month(((1 + (((((-1) + dayOfYear) | 0) / 31) | 0)) | 0));
  var monthEnd = (((-1) + ((moy.firstDayOfYear__Z__I(leap) + moy.length__Z__I(leap)) | 0)) | 0);
  if ((dayOfYear > monthEnd)) {
    moy = moy.plus__J__Ljava_time_Month(new $c_RTLong(1, 0))
  };
  var dom = ((1 + ((dayOfYear - moy.firstDayOfYear__Z__I(leap)) | 0)) | 0);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, moy, dom)
});
$c_Ljava_time_LocalDate$.prototype.ofEpochDay__J__Ljava_time_LocalDate = (function(epochDay) {
  var this$1 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(epochDay, this$1);
  var b = this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970;
  var alo = epochDay.RTLong__f_lo;
  var ahi = epochDay.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var zeroDay__lo = lo;
  var zeroDay__hi = hi;
  var b$1__lo = zeroDay__lo;
  var b$1__hi = zeroDay__hi;
  var bhi$1 = b$1__hi;
  var lo$1 = (((-60) + b$1__lo) | 0);
  var hi$1 = ((((-2147483648) ^ lo$1) < 2147483588) ? bhi$1 : (((-1) + bhi$1) | 0));
  var $$x1__lo = lo$1;
  var $$x1__hi = hi$1;
  zeroDay__lo = $$x1__lo;
  zeroDay__hi = $$x1__hi;
  var adjust__lo = 0;
  var adjust__hi = 0;
  var this$4__lo = zeroDay__lo;
  var this$4__hi = zeroDay__hi;
  var ahi$1 = this$4__hi;
  if ((ahi$1 < 0)) {
    var b$2__lo = zeroDay__lo;
    var b$2__hi = zeroDay__hi;
    var bhi$2 = b$2__hi;
    var lo$2 = ((1 + b$2__lo) | 0);
    var hi$2 = ((lo$2 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
    var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$3 = (value >> 31);
    var this$7 = $m_RTLong$();
    var lo$3 = this$7.divideImpl__I__I__I__I__I(lo$2, hi$2, value, hi$3);
    var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = (((-1) + lo$3) | 0);
    var hi$5 = ((lo$4 !== (-1)) ? hi$4 : (((-1) + hi$4) | 0));
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(400, b0);
    var a0b1 = Math.imul(400, b1);
    var lo$5 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(400, hi$5) + ((c1part >>> 16) | 0)) | 0);
    var $$x2__lo = lo$5;
    var $$x2__hi = hi$6;
    adjust__lo = $$x2__lo;
    adjust__hi = $$x2__hi;
    var this$12__lo = zeroDay__lo;
    var this$12__hi = zeroDay__hi;
    var lo$6 = ((-lo$4) | 0);
    var hi$7 = ((lo$4 !== 0) ? (~hi$5) : ((-hi$5) | 0));
    var value$1 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$8 = (value$1 >> 31);
    var a0 = (65535 & lo$6);
    var a1 = ((lo$6 >>> 16) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0, b0$1);
    var a1b0 = Math.imul(a1, b0$1);
    var a0b1$1 = Math.imul(a0, b1$1);
    var lo$7 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((((((Math.imul(lo$6, hi$8) + Math.imul(hi$7, value$1)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var alo$1 = this$12__lo;
    var ahi$2 = this$12__hi;
    var lo$8 = ((alo$1 + lo$7) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$2 + hi$9) | 0)) | 0) : ((ahi$2 + hi$9) | 0));
    var $$x3__lo = lo$8;
    var $$x3__hi = hi$10;
    zeroDay__lo = $$x3__lo;
    zeroDay__hi = $$x3__hi
  };
  var b$3__lo = zeroDay__lo;
  var b$3__hi = zeroDay__hi;
  var blo = b$3__lo;
  var b0$2 = (65535 & blo);
  var b1$2 = ((blo >>> 16) | 0);
  var a0b0$2 = Math.imul(400, b0$2);
  var a0b1$2 = Math.imul(400, b1$2);
  var lo$9 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((Math.imul(400, b$3__hi) + ((c1part$2 >>> 16) | 0)) | 0);
  var lo$10 = ((591 + lo$9) | 0);
  var hi$12 = ((((-2147483648) ^ lo$10) < (-2147483057)) ? ((1 + hi$11) | 0) : hi$11);
  var value$2 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi$13 = (value$2 >> 31);
  var this$16 = $m_RTLong$();
  var lo$11 = this$16.divideImpl__I__I__I__I__I(lo$10, hi$12, value$2, hi$13);
  var hi$14 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var yearEst__lo = lo$11;
  var yearEst__hi = hi$14;
  var this$26__lo = zeroDay__lo;
  var this$26__hi = zeroDay__hi;
  var b$4__lo = yearEst__lo;
  var b$4__hi = yearEst__hi;
  var blo$1 = b$4__lo;
  var b0$3 = (65535 & blo$1);
  var b1$3 = ((blo$1 >>> 16) | 0);
  var a0b0$3 = Math.imul(365, b0$3);
  var a0b1$3 = Math.imul(365, b1$3);
  var lo$12 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$15 = ((Math.imul(365, b$4__hi) + ((c1part$3 >>> 16) | 0)) | 0);
  var this$17__lo = yearEst__lo;
  var this$17__hi = yearEst__hi;
  var this$18 = $m_RTLong$();
  var lo$13 = this$18.divideImpl__I__I__I__I__I(this$17__lo, this$17__hi, 4, 0);
  var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$14 = ((lo$12 + lo$13) | 0);
  var hi$17 = ((((-2147483648) ^ lo$14) < ((-2147483648) ^ lo$12)) ? ((1 + ((hi$15 + hi$16) | 0)) | 0) : ((hi$15 + hi$16) | 0));
  var this$20__lo = yearEst__lo;
  var this$20__hi = yearEst__hi;
  var this$21 = $m_RTLong$();
  var lo$15 = this$21.divideImpl__I__I__I__I__I(this$20__lo, this$20__hi, 100, 0);
  var hi$18 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$16 = ((lo$14 - lo$15) | 0);
  var hi$19 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ lo$14)) ? (((-1) + ((hi$17 - hi$18) | 0)) | 0) : ((hi$17 - hi$18) | 0));
  var this$23__lo = yearEst__lo;
  var this$23__hi = yearEst__hi;
  var this$24 = $m_RTLong$();
  var lo$17 = this$24.divideImpl__I__I__I__I__I(this$23__lo, this$23__hi, 400, 0);
  var hi$20 = this$24.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$18 = ((lo$16 + lo$17) | 0);
  var hi$21 = ((((-2147483648) ^ lo$18) < ((-2147483648) ^ lo$16)) ? ((1 + ((hi$19 + hi$20) | 0)) | 0) : ((hi$19 + hi$20) | 0));
  var alo$2 = this$26__lo;
  var ahi$3 = this$26__hi;
  var lo$19 = ((alo$2 - lo$18) | 0);
  var hi$22 = ((((-2147483648) ^ lo$19) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$3 - hi$21) | 0)) | 0) : ((ahi$3 - hi$21) | 0));
  var doyEst__lo = lo$19;
  var doyEst__hi = hi$22;
  var this$28__lo = doyEst__lo;
  var this$28__hi = doyEst__hi;
  var ahi$4 = this$28__hi;
  if ((ahi$4 < 0)) {
    var b$5__lo = yearEst__lo;
    var b$5__hi = yearEst__hi;
    var bhi$3 = b$5__hi;
    var lo$20 = (((-1) + b$5__lo) | 0);
    var hi$23 = ((lo$20 !== (-1)) ? bhi$3 : (((-1) + bhi$3) | 0));
    var $$x4__lo = lo$20;
    var $$x4__hi = hi$23;
    yearEst__lo = $$x4__lo;
    yearEst__hi = $$x4__hi;
    var this$39__lo = zeroDay__lo;
    var this$39__hi = zeroDay__hi;
    var b$6__lo = yearEst__lo;
    var b$6__hi = yearEst__hi;
    var blo$2 = b$6__lo;
    var b0$4 = (65535 & blo$2);
    var b1$4 = ((blo$2 >>> 16) | 0);
    var a0b0$4 = Math.imul(365, b0$4);
    var a0b1$4 = Math.imul(365, b1$4);
    var lo$21 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$24 = ((Math.imul(365, b$6__hi) + ((c1part$4 >>> 16) | 0)) | 0);
    var this$30__lo = yearEst__lo;
    var this$30__hi = yearEst__hi;
    var this$31 = $m_RTLong$();
    var lo$22 = this$31.divideImpl__I__I__I__I__I(this$30__lo, this$30__hi, 4, 0);
    var hi$25 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$23 = ((lo$21 + lo$22) | 0);
    var hi$26 = ((((-2147483648) ^ lo$23) < ((-2147483648) ^ lo$21)) ? ((1 + ((hi$24 + hi$25) | 0)) | 0) : ((hi$24 + hi$25) | 0));
    var this$33__lo = yearEst__lo;
    var this$33__hi = yearEst__hi;
    var this$34 = $m_RTLong$();
    var lo$24 = this$34.divideImpl__I__I__I__I__I(this$33__lo, this$33__hi, 100, 0);
    var hi$27 = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$25 = ((lo$23 - lo$24) | 0);
    var hi$28 = ((((-2147483648) ^ lo$25) > ((-2147483648) ^ lo$23)) ? (((-1) + ((hi$26 - hi$27) | 0)) | 0) : ((hi$26 - hi$27) | 0));
    var this$36__lo = yearEst__lo;
    var this$36__hi = yearEst__hi;
    var this$37 = $m_RTLong$();
    var lo$26 = this$37.divideImpl__I__I__I__I__I(this$36__lo, this$36__hi, 400, 0);
    var hi$29 = this$37.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$27 = ((lo$25 + lo$26) | 0);
    var hi$30 = ((((-2147483648) ^ lo$27) < ((-2147483648) ^ lo$25)) ? ((1 + ((hi$28 + hi$29) | 0)) | 0) : ((hi$28 + hi$29) | 0));
    var alo$3 = this$39__lo;
    var ahi$5 = this$39__hi;
    var lo$28 = ((alo$3 - lo$27) | 0);
    var hi$31 = ((((-2147483648) ^ lo$28) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$5 - hi$30) | 0)) | 0) : ((ahi$5 - hi$30) | 0));
    var $$x5__lo = lo$28;
    var $$x5__hi = hi$31;
    doyEst__lo = $$x5__lo;
    doyEst__hi = $$x5__hi
  };
  var this$41__lo = yearEst__lo;
  var this$41__hi = yearEst__hi;
  var b$7__lo = adjust__lo;
  var b$7__hi = adjust__hi;
  var alo$4 = this$41__lo;
  var ahi$6 = this$41__hi;
  var bhi$4 = b$7__hi;
  var lo$29 = ((alo$4 + b$7__lo) | 0);
  var hi$32 = ((((-2147483648) ^ lo$29) < ((-2147483648) ^ alo$4)) ? ((1 + ((ahi$6 + bhi$4) | 0)) | 0) : ((ahi$6 + bhi$4) | 0));
  var $$x6__lo = lo$29;
  var $$x6__hi = hi$32;
  yearEst__lo = $$x6__lo;
  yearEst__hi = $$x6__hi;
  var this$43__lo = doyEst__lo;
  var this$43__hi = doyEst__hi;
  var marchDoy0 = this$43__lo;
  var marchMonth0 = ((((2 + Math.imul(5, marchDoy0)) | 0) / 153) | 0);
  var month = ((1 + ((((2 + marchMonth0) | 0) % 12) | 0)) | 0);
  var dom = ((1 + ((marchDoy0 - ((((5 + Math.imul(306, marchMonth0)) | 0) / 10) | 0)) | 0)) | 0);
  var this$45__lo = yearEst__lo;
  var this$45__hi = yearEst__hi;
  var value$3 = ((marchMonth0 / 10) | 0);
  var hi$33 = (value$3 >> 31);
  var alo$5 = this$45__lo;
  var ahi$7 = this$45__hi;
  var lo$30 = ((alo$5 + value$3) | 0);
  var hi$34 = ((((-2147483648) ^ lo$30) < ((-2147483648) ^ alo$5)) ? ((1 + ((ahi$7 + hi$33) | 0)) | 0) : ((ahi$7 + hi$33) | 0));
  var $$x7__lo = lo$30;
  var $$x7__hi = hi$34;
  yearEst__lo = $$x7__lo;
  yearEst__hi = $$x7__hi;
  var this$47 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var value$4__lo = yearEst__lo;
  var value$4__hi = yearEst__hi;
  var year = this$47.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(value$4__lo, value$4__hi), this$47);
  return new $c_Ljava_time_LocalDate(year, month, dom)
});
$c_Ljava_time_LocalDate$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  var date = $as_Ljava_time_LocalDate(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()));
  if ((date === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDate from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
  };
  return date
});
$c_Ljava_time_LocalDate$.prototype.java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate = (function(year, month, day) {
  var _day;
  switch (month) {
    case 2: {
      var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var hi = (year >> 31);
      if ($$x1.isLeapYear__J__Z(new $c_RTLong(year, hi))) {
        var b = 29
      } else {
        var b = 28
      };
      var _day = ((day < b) ? day : b);
      break
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      var _day = ((day < 30) ? day : 30);
      break
    }
    default: {
      var _day = day
    }
  };
  return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, _day)
});
var $d_Ljava_time_LocalDate$ = new $TypeData().initClass({
  Ljava_time_LocalDate$: 0
}, false, "java.time.LocalDate$", {
  Ljava_time_LocalDate$: 1,
  O: 1
});
$c_Ljava_time_LocalDate$.prototype.$classData = $d_Ljava_time_LocalDate$;
var $n_Ljava_time_LocalDate$;
function $m_Ljava_time_LocalDate$() {
  if ((!$n_Ljava_time_LocalDate$)) {
    $n_Ljava_time_LocalDate$ = new $c_Ljava_time_LocalDate$()
  };
  return $n_Ljava_time_LocalDate$
}
/** @constructor */
function $c_Ljava_time_LocalDateTime$() {
  this.Ljava_time_LocalDateTime$__f_MIN$lzy1 = null;
  this.Ljava_time_LocalDateTime$__f_MINbitmap$1 = false;
  this.Ljava_time_LocalDateTime$__f_MAX$lzy1 = null;
  this.Ljava_time_LocalDateTime$__f_MAXbitmap$1 = false
}
$c_Ljava_time_LocalDateTime$.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$.prototype.constructor = $c_Ljava_time_LocalDateTime$;
/** @constructor */
function $h_Ljava_time_LocalDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_LocalDateTime$.prototype = $c_Ljava_time_LocalDateTime$.prototype;
$c_Ljava_time_LocalDateTime$.prototype.of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime = (function(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
  var date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, dayOfMonth);
  var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime = (function(date, time) {
  if ((date === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "date")
  };
  if ((time === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "time")
  };
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(epochSecond, nanoOfSecond, offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  var value = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var ahi = epochSecond.RTLong__f_hi;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
  var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi$2 = (value$1 >> 31);
  var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(value$1, hi$2));
  var lo$1 = t.RTLong__f_lo;
  var hi$3 = t.RTLong__f_hi;
  var value$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi$4 = (value$2 >> 31);
  var this$6 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(value$2, hi$4));
  var secsOfDay = this$6.RTLong__f_lo;
  var date = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$3));
  var $$x1 = $m_Ljava_time_LocalTime$();
  var hi$5 = (secsOfDay >> 31);
  var time = $$x1.ofSecondOfDay__J__I__Ljava_time_LocalTime(new $c_RTLong(secsOfDay, hi$5), nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(temporal);
    return l
  } else if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var z = $as_Ljava_time_ZonedDateTime(temporal);
    return z.Ljava_time_ZonedDateTime__f_dateTime
  } else {
    try {
      var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      var time = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
      return new $c_Ljava_time_LocalDateTime(date, time)
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
      } else {
        throw e
      }
    }
  }
});
var $d_Ljava_time_LocalDateTime$ = new $TypeData().initClass({
  Ljava_time_LocalDateTime$: 0
}, false, "java.time.LocalDateTime$", {
  Ljava_time_LocalDateTime$: 1,
  O: 1
});
$c_Ljava_time_LocalDateTime$.prototype.$classData = $d_Ljava_time_LocalDateTime$;
var $n_Ljava_time_LocalDateTime$;
function $m_Ljava_time_LocalDateTime$() {
  if ((!$n_Ljava_time_LocalDateTime$)) {
    $n_Ljava_time_LocalDateTime$ = new $c_Ljava_time_LocalDateTime$()
  };
  return $n_Ljava_time_LocalDateTime$
}
function $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz) {
  if ((!$thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1)) {
    var dimensions = new $ac_I(new Int32Array([24]));
    var hours = $asArrayOf_Ljava_time_LocalTime($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_LocalTime.getClassOf(), dimensions), 1);
    var i = 0;
    while ((i < hours.u.length)) {
      hours.set(i, new $c_Ljava_time_LocalTime(i, 0, 0, 0));
      i = ((1 + i) | 0)
    };
    $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1 = hours;
    $thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1 = true
  };
  return $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1
}
/** @constructor */
function $c_Ljava_time_LocalTime$() {
  this.Ljava_time_LocalTime$__f_HOURS$lzy1 = null;
  this.Ljava_time_LocalTime$__f_HOURSbitmap$1 = false;
  this.Ljava_time_LocalTime$__f_MIN$lzy1 = null;
  this.Ljava_time_LocalTime$__f_MINbitmap$1 = false;
  this.Ljava_time_LocalTime$__f_MAX$lzy1 = null;
  this.Ljava_time_LocalTime$__f_MAXbitmap$1 = false;
  this.Ljava_time_LocalTime$__f_MIDNIGHT$lzy1 = null;
  this.Ljava_time_LocalTime$__f_MIDNIGHTbitmap$1 = false;
  this.Ljava_time_LocalTime$__f_NOON$lzy1 = null;
  this.Ljava_time_LocalTime$__f_NOONbitmap$1 = false;
  this.Ljava_time_LocalTime$__f_HOURS_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_MILLIS_PER_DAY = $L0;
  this.Ljava_time_LocalTime$__f_MICROS_PER_DAY = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_DAY = $L0;
  $n_Ljava_time_LocalTime$ = this;
  this.Ljava_time_LocalTime$__f_HOURS_PER_DAY = 24;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_DAY = Math.imul(this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR, this.Ljava_time_LocalTime$__f_HOURS_PER_DAY);
  this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR = Math.imul(this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE, this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR);
  this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY = Math.imul(this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR, this.Ljava_time_LocalTime$__f_HOURS_PER_DAY);
  var value = this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(1000, b0);
  var a0b1 = Math.imul(1000, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_MILLIS_PER_DAY = new $c_RTLong(lo, hi$1);
  var value$1 = this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(16960, b0$1);
  var a1b0 = Math.imul(15, b0$1);
  var a0b1$1 = Math.imul(16960, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((Math.imul(1000000, hi$2) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_MICROS_PER_DAY = new $c_RTLong(lo$1, hi$3);
  this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND = new $c_RTLong(1000000000, 0);
  var this$4 = this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var value$2 = this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$4 = (value$2 >> 31);
  var alo = this$4.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0$2 = (65535 & value$2);
  var b1$2 = ((value$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0, b0$2);
  var a1b0$1 = Math.imul(a1, b0$2);
  var a0b1$2 = Math.imul(a0, b1$2);
  var lo$2 = ((a0b0$2 + (((a1b0$1 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$5 = ((((((((Math.imul(alo, hi$4) + Math.imul(this$4.RTLong__f_hi, value$2)) | 0) + Math.imul(a1, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE = new $c_RTLong(lo$2, hi$5);
  var this$6 = this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var value$3 = this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR;
  var hi$6 = (value$3 >> 31);
  var alo$1 = this$6.RTLong__f_lo;
  var a0$1 = (65535 & alo$1);
  var a1$1 = ((alo$1 >>> 16) | 0);
  var b0$3 = (65535 & value$3);
  var b1$3 = ((value$3 >>> 16) | 0);
  var a0b0$3 = Math.imul(a0$1, b0$3);
  var a1b0$2 = Math.imul(a1$1, b0$3);
  var a0b1$3 = Math.imul(a0$1, b1$3);
  var lo$3 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((((Math.imul(alo$1, hi$6) + Math.imul(this$6.RTLong__f_hi, value$3)) | 0) + Math.imul(a1$1, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR = new $c_RTLong(lo$3, hi$7);
  var this$8 = this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var value$4 = this.Ljava_time_LocalTime$__f_HOURS_PER_DAY;
  var hi$8 = (value$4 >> 31);
  var alo$2 = this$8.RTLong__f_lo;
  var a0$2 = (65535 & alo$2);
  var a1$2 = ((alo$2 >>> 16) | 0);
  var b0$4 = (65535 & value$4);
  var b1$4 = ((value$4 >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$2, b0$4);
  var a1b0$3 = Math.imul(a1$2, b0$4);
  var a0b1$4 = Math.imul(a0$2, b1$4);
  var lo$4 = ((a0b0$4 + (((a1b0$3 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$9 = ((((((((Math.imul(alo$2, hi$8) + Math.imul(this$8.RTLong__f_hi, value$4)) | 0) + Math.imul(a1$2, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_DAY = new $c_RTLong(lo$4, hi$9)
}
$c_Ljava_time_LocalTime$.prototype = new $h_O();
$c_Ljava_time_LocalTime$.prototype.constructor = $c_Ljava_time_LocalTime$;
/** @constructor */
function $h_Ljava_time_LocalTime$() {
  /*<skip>*/
}
$h_Ljava_time_LocalTime$.prototype = $c_Ljava_time_LocalTime$.prototype;
$c_Ljava_time_LocalTime$.prototype.MIDNIGHT__Ljava_time_LocalTime = (function() {
  if ((!this.Ljava_time_LocalTime$__f_MIDNIGHTbitmap$1)) {
    this.Ljava_time_LocalTime$__f_MIDNIGHT$lzy1 = $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).get(0);
    this.Ljava_time_LocalTime$__f_MIDNIGHTbitmap$1 = true
  };
  return this.Ljava_time_LocalTime$__f_MIDNIGHT$lzy1
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__Ljava_time_LocalTime = (function(hour, minute) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if ((minute === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).get(hour)
  } else {
    var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi$1 = (minute >> 31);
    this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
    return new $c_Ljava_time_LocalTime(hour, minute, 0, 0)
  }
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if (((minute | second) === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).get(hour)
  };
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  return new $c_Ljava_time_LocalTime(hour, minute, second, 0)
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  var this$8 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$3 = (nanoOfSecond >> 31);
  this$8.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$3), this$8);
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond)
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__Ljava_time_LocalTime = (function(secondOfDay) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$3__lo = _secondOfDay__lo;
  var this$3__hi = _secondOfDay__hi;
  var value$1 = this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR;
  var hi$1 = (value$1 >> 31);
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(this$3__lo, this$3__hi, value$1, hi$1);
  var this$6__lo = _secondOfDay__lo;
  var this$6__hi = _secondOfDay__hi;
  var value$2 = Math.imul(lo$1, this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR);
  var hi$3 = (value$2 >> 31);
  var alo = this$6__lo;
  var ahi = this$6__hi;
  var lo$2 = ((alo - value$2) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$3) | 0)) | 0) : ((ahi - hi$3) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$4;
  _secondOfDay__lo = $$x1__lo;
  _secondOfDay__hi = $$x1__hi;
  var this$9__lo = _secondOfDay__lo;
  var this$9__hi = _secondOfDay__hi;
  var value$3 = this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$5 = (value$3 >> 31);
  var this$10 = $m_RTLong$();
  var lo$3 = this$10.divideImpl__I__I__I__I__I(this$9__lo, this$9__hi, value$3, hi$5);
  var this$12__lo = _secondOfDay__lo;
  var this$12__hi = _secondOfDay__hi;
  var value$4 = Math.imul(lo$3, this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE);
  var hi$7 = (value$4 >> 31);
  var alo$1 = this$12__lo;
  var ahi$1 = this$12__hi;
  var lo$4 = ((alo$1 - value$4) | 0);
  var hi$8 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$7) | 0)) | 0) : ((ahi$1 - hi$7) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$8;
  _secondOfDay__lo = $$x2__lo;
  _secondOfDay__hi = $$x2__hi;
  var this$14__lo = _secondOfDay__lo;
  var this$14__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, this$14__lo, 0)
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__I__Ljava_time_LocalTime = (function(secondOfDay, nanoOfSecond) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$1 = (nanoOfSecond >> 31);
  this$3.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$1), this$3);
  var this$5__lo = _secondOfDay__lo;
  var this$5__hi = _secondOfDay__hi;
  var value$1 = this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR;
  var hi$2 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$1 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, value$1, hi$2);
  var this$8__lo = _secondOfDay__lo;
  var this$8__hi = _secondOfDay__hi;
  var value$2 = Math.imul(lo$1, this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR);
  var hi$4 = (value$2 >> 31);
  var alo = this$8__lo;
  var ahi = this$8__hi;
  var lo$2 = ((alo - value$2) | 0);
  var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$5;
  _secondOfDay__lo = $$x1__lo;
  _secondOfDay__hi = $$x1__hi;
  var this$11__lo = _secondOfDay__lo;
  var this$11__hi = _secondOfDay__hi;
  var value$3 = this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$6 = (value$3 >> 31);
  var this$12 = $m_RTLong$();
  var lo$3 = this$12.divideImpl__I__I__I__I__I(this$11__lo, this$11__hi, value$3, hi$6);
  var this$14__lo = _secondOfDay__lo;
  var this$14__hi = _secondOfDay__hi;
  var value$4 = Math.imul(lo$3, this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE);
  var hi$8 = (value$4 >> 31);
  var alo$1 = this$14__lo;
  var ahi$1 = this$14__hi;
  var lo$4 = ((alo$1 - value$4) | 0);
  var hi$9 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$8) | 0)) | 0) : ((ahi$1 - hi$8) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$9;
  _secondOfDay__lo = $$x2__lo;
  _secondOfDay__hi = $$x2__hi;
  var this$16__lo = _secondOfDay__lo;
  var this$16__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, this$16__lo, nanoOfSecond)
});
$c_Ljava_time_LocalTime$.prototype.ofNanoOfDay__J__Ljava_time_LocalTime = (function(nanoOfDay) {
  var lo = nanoOfDay.RTLong__f_lo;
  var hi = nanoOfDay.RTLong__f_hi;
  var _nanoOfDay__lo = lo;
  var _nanoOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _nanoOfDay__lo;
  var value__hi = _nanoOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$2__lo = _nanoOfDay__lo;
  var this$2__hi = _nanoOfDay__hi;
  var b = this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var this$3 = $m_RTLong$();
  var lo$1 = this$3.divideImpl__I__I__I__I__I(this$2__lo, this$2__hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var this$5__lo = _nanoOfDay__lo;
  var this$5__hi = _nanoOfDay__hi;
  var hi$2 = (lo$1 >> 31);
  var b$1 = this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var blo = b$1.RTLong__f_lo;
  var a0 = (65535 & lo$1);
  var a1 = ((lo$1 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(lo$1, b$1.RTLong__f_hi) + Math.imul(hi$2, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var alo = this$5__lo;
  var ahi = this$5__hi;
  var lo$3 = ((alo - lo$2) | 0);
  var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$3) | 0)) | 0) : ((ahi - hi$3) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$4;
  _nanoOfDay__lo = $$x1__lo;
  _nanoOfDay__hi = $$x1__hi;
  var this$7__lo = _nanoOfDay__lo;
  var this$7__hi = _nanoOfDay__hi;
  var b$2 = this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var this$8 = $m_RTLong$();
  var lo$4 = this$8.divideImpl__I__I__I__I__I(this$7__lo, this$7__hi, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
  var this$10__lo = _nanoOfDay__lo;
  var this$10__hi = _nanoOfDay__hi;
  var hi$6 = (lo$4 >> 31);
  var b$3 = this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var blo$1 = b$3.RTLong__f_lo;
  var a0$1 = (65535 & lo$4);
  var a1$1 = ((lo$4 >>> 16) | 0);
  var b0$1 = (65535 & blo$1);
  var b1$1 = ((blo$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$7 = ((((((((Math.imul(lo$4, b$3.RTLong__f_hi) + Math.imul(hi$6, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo$1 = this$10__lo;
  var ahi$1 = this$10__hi;
  var lo$6 = ((alo$1 - lo$5) | 0);
  var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$7) | 0)) | 0) : ((ahi$1 - hi$7) | 0));
  var $$x2__lo = lo$6;
  var $$x2__hi = hi$8;
  _nanoOfDay__lo = $$x2__lo;
  _nanoOfDay__hi = $$x2__hi;
  var this$12__lo = _nanoOfDay__lo;
  var this$12__hi = _nanoOfDay__hi;
  var b$4 = this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var this$13 = $m_RTLong$();
  var lo$7 = this$13.divideImpl__I__I__I__I__I(this$12__lo, this$12__hi, b$4.RTLong__f_lo, b$4.RTLong__f_hi);
  var this$15__lo = _nanoOfDay__lo;
  var this$15__hi = _nanoOfDay__hi;
  var hi$10 = (lo$7 >> 31);
  var b$5 = this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var blo$2 = b$5.RTLong__f_lo;
  var a0$2 = (65535 & lo$7);
  var a1$2 = ((lo$7 >>> 16) | 0);
  var b0$2 = (65535 & blo$2);
  var b1$2 = ((blo$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$8 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((((((((Math.imul(lo$7, b$5.RTLong__f_hi) + Math.imul(hi$10, blo$2)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$2 = this$15__lo;
  var ahi$2 = this$15__hi;
  var lo$9 = ((alo$2 - lo$8) | 0);
  var hi$12 = ((((-2147483648) ^ lo$9) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$11) | 0)) | 0) : ((ahi$2 - hi$11) | 0));
  var $$x3__lo = lo$9;
  var $$x3__hi = hi$12;
  _nanoOfDay__lo = $$x3__lo;
  _nanoOfDay__hi = $$x3__hi;
  var this$17__lo = _nanoOfDay__lo;
  var this$17__hi = _nanoOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$4, lo$7, this$17__lo)
});
$c_Ljava_time_LocalTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  var time = $as_Ljava_time_LocalTime(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()));
  if ((time === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
  } else {
    return time
  }
});
$c_Ljava_time_LocalTime$.prototype.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  return ((((minute | second) | nanoOfSecond) === 0) ? $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).get(hour) : new $c_Ljava_time_LocalTime(hour, minute, second, nanoOfSecond))
});
var $d_Ljava_time_LocalTime$ = new $TypeData().initClass({
  Ljava_time_LocalTime$: 0
}, false, "java.time.LocalTime$", {
  Ljava_time_LocalTime$: 1,
  O: 1
});
$c_Ljava_time_LocalTime$.prototype.$classData = $d_Ljava_time_LocalTime$;
var $n_Ljava_time_LocalTime$;
function $m_Ljava_time_LocalTime$() {
  if ((!$n_Ljava_time_LocalTime$)) {
    $n_Ljava_time_LocalTime$ = new $c_Ljava_time_LocalTime$()
  };
  return $n_Ljava_time_LocalTime$
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime$() {
  this.Ljava_time_OffsetDateTime$__f_MIN$lzy1 = null;
  this.Ljava_time_OffsetDateTime$__f_MINbitmap$1 = false;
  this.Ljava_time_OffsetDateTime$__f_MAX$lzy1 = null;
  this.Ljava_time_OffsetDateTime$__f_MAXbitmap$1 = false;
  this.Ljava_time_OffsetDateTime$__f_INSTANT_COMPARATOR$lzy1 = null;
  this.Ljava_time_OffsetDateTime$__f_INSTANT_COMPARATORbitmap$1 = false
}
$c_Ljava_time_OffsetDateTime$.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime$.prototype.constructor = $c_Ljava_time_OffsetDateTime$;
/** @constructor */
function $h_Ljava_time_OffsetDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_OffsetDateTime$.prototype = $c_Ljava_time_OffsetDateTime$.prototype;
$c_Ljava_time_OffsetDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var rules = zone.getRules__Ljava_time_zone_ZoneRules();
  var offset = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  var ldt = $m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(instant.Ljava_time_Instant__f_seconds, instant.Ljava_time_Instant__f_nanos, offset);
  return new $c_Ljava_time_OffsetDateTime(ldt, offset)
});
$c_Ljava_time_OffsetDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_OffsetDateTime)) {
    var time = $as_Ljava_time_OffsetDateTime(temporal);
    return time
  } else {
    try {
      var offset = $m_Ljava_time_ZoneOffset$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
      try {
        var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
        return new $c_Ljava_time_OffsetDateTime(ldt, offset)
      } catch (e) {
        if ((e instanceof $c_Ljava_time_DateTimeException)) {
          var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
          return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(instant, offset)
        } else {
          throw e
        }
      }
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain OffsetDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
      } else {
        throw e$2
      }
    }
  }
});
var $d_Ljava_time_OffsetDateTime$ = new $TypeData().initClass({
  Ljava_time_OffsetDateTime$: 0
}, false, "java.time.OffsetDateTime$", {
  Ljava_time_OffsetDateTime$: 1,
  O: 1
});
$c_Ljava_time_OffsetDateTime$.prototype.$classData = $d_Ljava_time_OffsetDateTime$;
var $n_Ljava_time_OffsetDateTime$;
function $m_Ljava_time_OffsetDateTime$() {
  if ((!$n_Ljava_time_OffsetDateTime$)) {
    $n_Ljava_time_OffsetDateTime$ = new $c_Ljava_time_OffsetDateTime$()
  };
  return $n_Ljava_time_OffsetDateTime$
}
/** @constructor */
function $c_Ljava_time_Period$() {
  this.Ljava_time_Period$__f_ZERO$lzy1 = null;
  this.Ljava_time_Period$__f_ZERObitmap$1 = false;
  this.Ljava_time_Period$__f_PATTERN$lzy1 = null;
  this.Ljava_time_Period$__f_PATTERNbitmap$1 = false
}
$c_Ljava_time_Period$.prototype = new $h_O();
$c_Ljava_time_Period$.prototype.constructor = $c_Ljava_time_Period$;
/** @constructor */
function $h_Ljava_time_Period$() {
  /*<skip>*/
}
$h_Ljava_time_Period$.prototype = $c_Ljava_time_Period$.prototype;
$c_Ljava_time_Period$.prototype.ZERO__Ljava_time_Period = (function() {
  if ((!this.Ljava_time_Period$__f_ZERObitmap$1)) {
    this.Ljava_time_Period$__f_ZERO$lzy1 = new $c_Ljava_time_Period(0, 0, 0);
    this.Ljava_time_Period$__f_ZERObitmap$1 = true
  };
  return this.Ljava_time_Period$__f_ZERO$lzy1
});
$c_Ljava_time_Period$.prototype.java$time$Period$$$create__I__I__I__Ljava_time_Period = (function(years, months, days) {
  return ((((years | months) | days) === 0) ? this.ZERO__Ljava_time_Period() : new $c_Ljava_time_Period(years, months, days))
});
var $d_Ljava_time_Period$ = new $TypeData().initClass({
  Ljava_time_Period$: 0
}, false, "java.time.Period$", {
  Ljava_time_Period$: 1,
  O: 1
});
$c_Ljava_time_Period$.prototype.$classData = $d_Ljava_time_Period$;
var $n_Ljava_time_Period$;
function $m_Ljava_time_Period$() {
  if ((!$n_Ljava_time_Period$)) {
    $n_Ljava_time_Period$ = new $c_Ljava_time_Period$()
  };
  return $n_Ljava_time_Period$
}
/** @constructor */
function $c_Ljava_time_Year$() {
  this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = false;
  this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = false;
  this.Ljava_time_Year$__f_PARSER$lzy1 = null;
  this.Ljava_time_Year$__f_PARSERbitmap$1 = false
}
$c_Ljava_time_Year$.prototype = new $h_O();
$c_Ljava_time_Year$.prototype.constructor = $c_Ljava_time_Year$;
/** @constructor */
function $h_Ljava_time_Year$() {
  /*<skip>*/
}
$h_Ljava_time_Year$.prototype = $c_Ljava_time_Year$.prototype;
$c_Ljava_time_Year$.prototype.MIN_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MIN_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = (-999999999);
    this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = true
  };
  return this.Ljava_time_Year$__f_MIN_VALUE$lzy1
});
$c_Ljava_time_Year$.prototype.MAX_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MAX_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 999999999;
    this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = true
  };
  return this.Ljava_time_Year$__f_MAX_VALUE$lzy1
});
$c_Ljava_time_Year$.prototype.isLeap__J__Z = (function(year) {
  var lo = (3 & year.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_RTLong$();
    var lo$1 = this$1.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 100, 0);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true
    } else {
      var this$2 = $m_RTLong$();
      var lo$2 = this$2.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 400, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0))
    }
  } else {
    return false
  }
});
var $d_Ljava_time_Year$ = new $TypeData().initClass({
  Ljava_time_Year$: 0
}, false, "java.time.Year$", {
  Ljava_time_Year$: 1,
  O: 1
});
$c_Ljava_time_Year$.prototype.$classData = $d_Ljava_time_Year$;
var $n_Ljava_time_Year$;
function $m_Ljava_time_Year$() {
  if ((!$n_Ljava_time_Year$)) {
    $n_Ljava_time_Year$ = new $c_Ljava_time_Year$()
  };
  return $n_Ljava_time_Year$
}
function $p_Ljava_time_ZoneId$__ShortIds__sci_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneId$__f_ShortIdsbitmap$1)) {
    var this$57 = $m_s_Predef$().s_Predef$__f_Map;
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), "ACT", "Australia/Darwin"), $ct_T2__O__O__(new $c_T2(), "AET", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "AGT", "America/Argentina/Buenos_Aires"), $ct_T2__O__O__(new $c_T2(), "ART", "Africa/Cairo"), $ct_T2__O__O__(new $c_T2(), "AST", "America/Anchorage"), $ct_T2__O__O__(new $c_T2(), "BET", "America/Sao_Paulo"), $ct_T2__O__O__(new $c_T2(), "BST", "Asia/Dhaka"), $ct_T2__O__O__(new $c_T2(), "CAT", "Africa/Harare"), $ct_T2__O__O__(new $c_T2(), "CNT", "America/St_Johns"), $ct_T2__O__O__(new $c_T2(), "CST", "America/Chicago"), $ct_T2__O__O__(new $c_T2(), "CTT", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "EAT", "Africa/Addis_Ababa"), $ct_T2__O__O__(new $c_T2(), "ECT", "Europe/Paris"), $ct_T2__O__O__(new $c_T2(), "IET", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "IST", "Asia/Kolkata"), $ct_T2__O__O__(new $c_T2(), "JST", "Asia/Tokyo"), $ct_T2__O__O__(new $c_T2(), "MIT", "Pacific/Apia"), $ct_T2__O__O__(new $c_T2(), "NET", "Asia/Yerevan"), $ct_T2__O__O__(new $c_T2(), "NST", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "PLT", "Asia/Karachi"), $ct_T2__O__O__(new $c_T2(), "PNT", "America/Phoenix"), $ct_T2__O__O__(new $c_T2(), "PRT", "America/Puerto_Rico"), $ct_T2__O__O__(new $c_T2(), "PST", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "SST", "Pacific/Guadalcanal"), $ct_T2__O__O__(new $c_T2(), "VST", "Asia/Ho_Chi_Minh"), $ct_T2__O__O__(new $c_T2(), "EST", "-05:00"), $ct_T2__O__O__(new $c_T2(), "MST", "-07:00"), $ct_T2__O__O__(new $c_T2(), "HST", "-10:00")]));
    $thiz.Ljava_time_ZoneId$__f_ShortIds$lzy1 = this$57.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Ljava_time_ZoneId$__f_ShortIdsbitmap$1 = true
  };
  return $thiz.Ljava_time_ZoneId$__f_ShortIds$lzy1
}
function $p_Ljava_time_ZoneId$__of2__T__sci_Map__Ljava_time_ZoneId($thiz, zoneId, aliasMap) {
  var this$1 = aliasMap.get__O__s_Option(zoneId);
  return $thiz.of__T__Ljava_time_ZoneId($as_T((this$1.isEmpty__Z() ? zoneId : this$1.get__O())))
}
/** @constructor */
function $c_Ljava_time_ZoneId$() {
  this.Ljava_time_ZoneId$__f_SHORT_IDS$lzy1 = null;
  this.Ljava_time_ZoneId$__f_SHORT_IDSbitmap$1 = false;
  this.Ljava_time_ZoneId$__f_ShortIds$lzy1 = null;
  this.Ljava_time_ZoneId$__f_ShortIdsbitmap$1 = false
}
$c_Ljava_time_ZoneId$.prototype = new $h_O();
$c_Ljava_time_ZoneId$.prototype.constructor = $c_Ljava_time_ZoneId$;
/** @constructor */
function $h_Ljava_time_ZoneId$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneId$.prototype = $c_Ljava_time_ZoneId$.prototype;
$c_Ljava_time_ZoneId$.prototype.systemDefault__Ljava_time_ZoneId = (function() {
  var this$1 = $m_ju_TimeZone$().ju_TimeZone$__f_default;
  return $p_Ljava_time_ZoneId$__of2__T__sci_Map__Ljava_time_ZoneId(this, this$1.ju_SimpleTimeZone__f_ID, $p_Ljava_time_ZoneId$__ShortIds__sci_Map(this))
});
$c_Ljava_time_ZoneId$.prototype.of__T__Ljava_time_ZoneId = (function(zoneId) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  if ((zoneId === "Z")) {
    return $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()
  } else if (($uI(zoneId.length) === 1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + zoneId))
  } else if (((($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("+".length))) === "+")) || (($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("-".length))) === "-")))) {
    return $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset(zoneId)
  } else if ((((zoneId === "UTC") || (zoneId === "GMT")) || (zoneId === "UT"))) {
    var this$4 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    return new $c_Ljava_time_ZoneRegion(zoneId, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$4))
  } else if (((((($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("UTC+".length))) === "UTC+")) || (($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("GMT+".length))) === "GMT+"))) || (($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("UTC-".length))) === "UTC-"))) || (($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("GMT-".length))) === "GMT-")))) {
    var offset = $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset($as_T(zoneId.substring(3)));
    return ((offset.Ljava_time_ZoneOffset__f_totalSeconds === 0) ? new $c_Ljava_time_ZoneRegion($as_T(zoneId.substring(0, 3)), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset)) : new $c_Ljava_time_ZoneRegion((("" + $as_T(zoneId.substring(0, 3))) + offset.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset)))
  } else if (((($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("UT+".length))) === "UT+")) || (($uI(zoneId.length) >= 0) && ($as_T(zoneId.substring(0, $uI("UT-".length))) === "UT-")))) {
    var offset$2 = $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset($as_T(zoneId.substring(2)));
    return ((offset$2.Ljava_time_ZoneOffset__f_totalSeconds === 0) ? new $c_Ljava_time_ZoneRegion("UT", $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset$2)) : new $c_Ljava_time_ZoneRegion(("UT" + offset$2.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset$2)))
  } else {
    return $m_Ljava_time_ZoneRegion$().ofId__T__Z__Ljava_time_ZoneRegion(zoneId, true)
  }
});
$c_Ljava_time_ZoneId$.prototype.ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId = (function(prefix, offset) {
  if ((prefix === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "prefix")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  if (($uI(prefix.length) === 0)) {
    return offset
  };
  if ((((prefix === "GMT") || (prefix === "UTC")) || (prefix === "UT"))) {
    if ((offset.Ljava_time_ZoneOffset__f_totalSeconds === 0)) {
      return new $c_Ljava_time_ZoneRegion(prefix, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset))
    };
    return new $c_Ljava_time_ZoneRegion((("" + prefix) + offset.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset))
  };
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid prefix, must be GMT, UTC or UT: " + prefix))
});
$c_Ljava_time_ZoneId$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var obj = $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()));
  if ((obj === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneId from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
  } else {
    return obj
  }
});
var $d_Ljava_time_ZoneId$ = new $TypeData().initClass({
  Ljava_time_ZoneId$: 0
}, false, "java.time.ZoneId$", {
  Ljava_time_ZoneId$: 1,
  O: 1
});
$c_Ljava_time_ZoneId$.prototype.$classData = $d_Ljava_time_ZoneId$;
var $n_Ljava_time_ZoneId$;
function $m_Ljava_time_ZoneId$() {
  if ((!$n_Ljava_time_ZoneId$)) {
    $n_Ljava_time_ZoneId$ = new $c_Ljava_time_ZoneId$()
  };
  return $n_Ljava_time_ZoneId$
}
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = true
  };
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1
}
function $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = true
  };
  return $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1
}
function $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I($thiz, offsetId, pos, precededByColon) {
  if ((precededByColon && ($dp_charAt__I__C(offsetId, (((-1) + pos) | 0)) !== 58))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId))
  };
  var ch1 = $dp_charAt__I__C(offsetId, pos);
  var ch2 = $dp_charAt__I__C(offsetId, ((1 + pos) | 0));
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId))
  };
  return ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0)
}
function $p_Ljava_time_ZoneOffset$__validate__I__I__I__V($thiz, hours, minutes, seconds) {
  if (((hours < (-18)) || (hours > 18))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Zone offset hours not in valid range: value " + hours) + " is not in the range -18 to 18"))
  };
  if ((hours > 0)) {
    if (((minutes < 0) || (seconds < 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "positive"))
    }
  } else if ((hours < 0)) {
    if (((minutes > 0) || (seconds > 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "negative"))
    }
  } else if ((((minutes > 0) && (seconds < 0)) || ((minutes < 0) && (seconds > 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset minutes and seconds must have the same sign")
  };
  if ((((minutes < 0) ? ((-minutes) | 0) : minutes) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes, "minutes"))
  };
  if ((((seconds < 0) ? ((-seconds) | 0) : seconds) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes, "seconds"))
  };
  if (((((hours < 0) ? ((-hours) | 0) : hours) === 18) && ((((minutes < 0) ? ((-minutes) | 0) : minutes) > 0) || (((seconds < 0) ? ((-seconds) | 0) : seconds) > 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00")
  }
}
function $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I($thiz, hours, minutes, seconds) {
  return ((((Math.imul(hours, $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR) + Math.imul(minutes, $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0) + seconds) | 0)
}
function $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes$1, v) {
  return (((("Zone offset " + v) + " not in valid range: abs(value) ") + ((minutes$1 < 0) ? ((-minutes$1) | 0) : minutes$1)) + " is not in the range 0 to 59")
}
function $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, v) {
  return ((("Zone offset minutes and seconds must be " + v) + " because hours is ") + v)
}
/** @constructor */
function $c_Ljava_time_ZoneOffset$() {
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = 0;
  this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_MIN$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_MINbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_MAX$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_MAXbitmap$1 = false;
  $n_Ljava_time_ZoneOffset$ = this;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 3600;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = Math.imul(18, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR)
}
$c_Ljava_time_ZoneOffset$.prototype = new $h_O();
$c_Ljava_time_ZoneOffset$.prototype.constructor = $c_Ljava_time_ZoneOffset$;
/** @constructor */
function $h_Ljava_time_ZoneOffset$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneOffset$.prototype = $c_Ljava_time_ZoneOffset$.prototype;
$c_Ljava_time_ZoneOffset$.prototype.UTC__Ljava_time_ZoneOffset = (function() {
  if ((!this.Ljava_time_ZoneOffset$__f_UTCbitmap$1)) {
    this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(0);
    this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = true
  };
  return this.Ljava_time_ZoneOffset$__f_UTC$lzy1
});
$c_Ljava_time_ZoneOffset$.prototype.of__T__Ljava_time_ZoneOffset = (function(offsetId) {
  var _offsetId = offsetId;
  var obj = _offsetId;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetId")
  };
  var this$2 = $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this);
  var key = _offsetId;
  var offset = $as_Ljava_time_ZoneOffset($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, key, null));
  if ((offset !== null)) {
    return offset
  };
  var hours = 0;
  var minutes = 0;
  var seconds = 0;
  var this$3 = _offsetId;
  if (($uI(this$3.length) === 2)) {
    var this$4 = _offsetId;
    var $$x1 = $uI(this$4.charCodeAt(0));
    var this$5 = _offsetId;
    _offsetId = (($bC((65535 & $$x1)) + "0") + $bC((65535 & $uI(this$5.charCodeAt(1)))))
  };
  var this$6 = _offsetId;
  var x3 = $uI(this$6.length);
  switch (x3) {
    case 3: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = 0;
      seconds = 0;
      break
    }
    case 5: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = 0;
      break
    }
    case 6: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = 0;
      break
    }
    case 7: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 5, false);
      break
    }
    case 9: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 7, true);
      break
    }
    default: {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + _offsetId))
    }
  };
  var this$7 = _offsetId;
  var first = (65535 & $uI(this$7.charCodeAt(0)));
  if (((first !== 43) && (first !== 45))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, plus/minus not found when expected: " + _offsetId))
  };
  return ((first === 45) ? this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(((-hours) | 0), ((-minutes) | 0), ((-seconds) | 0)) : this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(hours, minutes, seconds))
});
$c_Ljava_time_ZoneOffset$.prototype.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset = (function(hours, minutes, seconds) {
  $p_Ljava_time_ZoneOffset$__validate__I__I__I__V(this, hours, minutes, seconds);
  var totalSecs = $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I(this, hours, minutes, seconds);
  return this.ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSecs)
});
$c_Ljava_time_ZoneOffset$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  var offset = $as_Ljava_time_ZoneOffset(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
  if ((offset === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneOffset from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
  };
  return offset
});
$c_Ljava_time_ZoneOffset$.prototype.ofTotalSeconds__I__Ljava_time_ZoneOffset = (function(totalSeconds) {
  if ((((totalSeconds < 0) ? ((-totalSeconds) | 0) : totalSeconds) > this.Ljava_time_ZoneOffset$__f_MAX_SECONDS)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00")
  } else if (($intMod(totalSeconds, Math.imul(15, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) === 0)) {
    var this$3 = $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this);
    var result = $as_Ljava_time_ZoneOffset($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$3, totalSeconds, null));
    if ((result === null)) {
      result = new $c_Ljava_time_ZoneOffset(totalSeconds);
      var this$4 = $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this);
      var value = result;
      this$4.java$util$HashMap$$put0__O__O__I__Z__O(totalSeconds, value, (totalSeconds ^ ((totalSeconds >>> 16) | 0)), false);
      var this$6 = $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this);
      result = $as_Ljava_time_ZoneOffset($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$6, totalSeconds, null));
      var this$7 = $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this);
      var key = result.Ljava_time_ZoneOffset__f_id;
      var value$1 = result;
      if ((key === null)) {
        var $$x1 = 0
      } else {
        var originalHash = $f_T__hashCode__I(key);
        var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
      };
      this$7.java$util$HashMap$$put0__O__O__I__Z__O(key, value$1, $$x1, false)
    };
    return result
  } else {
    return new $c_Ljava_time_ZoneOffset(totalSeconds)
  }
});
$c_Ljava_time_ZoneOffset$.prototype.java$time$ZoneOffset$$$buildId__I__T = (function(totalSeconds) {
  if ((totalSeconds === 0)) {
    return "Z"
  } else {
    var absTotalSeconds = ((totalSeconds < 0) ? ((-totalSeconds) | 0) : totalSeconds);
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    var absHours = $intDiv(absTotalSeconds, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR);
    var absMinutes = $intMod($intDiv(absTotalSeconds, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE), this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR);
    buf.append__T__scm_StringBuilder(((totalSeconds < 0) ? "-" : "+")).append__T__scm_StringBuilder(((absHours < 10) ? "0" : "")).append__I__scm_StringBuilder(absHours).append__T__scm_StringBuilder(((absMinutes < 10) ? ":0" : ":")).append__I__scm_StringBuilder(absMinutes);
    var absSeconds = $intMod(absTotalSeconds, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE);
    if ((absSeconds !== 0)) {
      buf.append__T__scm_StringBuilder(((absSeconds < 10) ? ":0" : ":")).append__I__scm_StringBuilder(absSeconds)
    };
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
var $d_Ljava_time_ZoneOffset$ = new $TypeData().initClass({
  Ljava_time_ZoneOffset$: 0
}, false, "java.time.ZoneOffset$", {
  Ljava_time_ZoneOffset$: 1,
  O: 1
});
$c_Ljava_time_ZoneOffset$.prototype.$classData = $d_Ljava_time_ZoneOffset$;
var $n_Ljava_time_ZoneOffset$;
function $m_Ljava_time_ZoneOffset$() {
  if ((!$n_Ljava_time_ZoneOffset$)) {
    $n_Ljava_time_ZoneOffset$ = new $c_Ljava_time_ZoneOffset$()
  };
  return $n_Ljava_time_ZoneOffset$
}
function $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern($thiz) {
  if ((!$thiz.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1)) {
    $thiz.Ljava_time_ZoneRegion$__f_PATTERN$lzy1 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("[A-Za-z][A-Za-z0-9~/._+-]+", 0);
    $thiz.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1 = true
  };
  return $thiz.Ljava_time_ZoneRegion$__f_PATTERN$lzy1
}
/** @constructor */
function $c_Ljava_time_ZoneRegion$() {
  this.Ljava_time_ZoneRegion$__f_PATTERN$lzy1 = null;
  this.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1 = false
}
$c_Ljava_time_ZoneRegion$.prototype = new $h_O();
$c_Ljava_time_ZoneRegion$.prototype.constructor = $c_Ljava_time_ZoneRegion$;
/** @constructor */
function $h_Ljava_time_ZoneRegion$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneRegion$.prototype = $c_Ljava_time_ZoneRegion$.prototype;
$c_Ljava_time_ZoneRegion$.prototype.ofId__T__Z__Ljava_time_ZoneRegion = (function(zoneId, checkAvailable) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  if (($uI(zoneId.length) < 2)) {
    var $$x1 = true
  } else {
    var this$2 = $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern(this);
    var $$x1 = (!new $c_ju_regex_Matcher(this$2, zoneId).matches__Z())
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for region-based ZoneId, invalid format: " + zoneId))
  };
  var rules = null;
  try {
    rules = $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(zoneId, true)
  } catch (e) {
    if ((e instanceof $c_Ljava_time_zone_ZoneRulesException)) {
      var ex = $as_Ljava_time_zone_ZoneRulesException(e);
      if ((zoneId === "GMT0")) {
        var this$3 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
        rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$3)
      } else if (checkAvailable) {
        throw ex
      }
    } else {
      throw e
    }
  };
  return new $c_Ljava_time_ZoneRegion(zoneId, rules)
});
var $d_Ljava_time_ZoneRegion$ = new $TypeData().initClass({
  Ljava_time_ZoneRegion$: 0
}, false, "java.time.ZoneRegion$", {
  Ljava_time_ZoneRegion$: 1,
  O: 1
});
$c_Ljava_time_ZoneRegion$.prototype.$classData = $d_Ljava_time_ZoneRegion$;
var $n_Ljava_time_ZoneRegion$;
function $m_Ljava_time_ZoneRegion$() {
  if ((!$n_Ljava_time_ZoneRegion$)) {
    $n_Ljava_time_ZoneRegion$ = new $c_Ljava_time_ZoneRegion$()
  };
  return $n_Ljava_time_ZoneRegion$
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime$() {
  /*<skip>*/
}
$c_Ljava_time_ZonedDateTime$.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime$.prototype.constructor = $c_Ljava_time_ZonedDateTime$;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_ZonedDateTime$.prototype = $c_Ljava_time_ZonedDateTime$.prototype;
$c_Ljava_time_ZonedDateTime$.prototype.now__Ljava_time_Clock__Ljava_time_ZonedDateTime = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock")
  };
  var $$x1 = $m_Ljava_time_Instant$();
  var this$3 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$3.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $$x1.ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  return this.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(now, clock.Ljava_time_Clock$SystemClock__f_zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime = (function(localDateTime, zone, preferredOffset) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var _localDateTime = localDateTime;
  if ((zone instanceof $c_Ljava_time_ZoneOffset)) {
    var offset = $as_Ljava_time_ZoneOffset(zone);
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset, zone)
  } else {
    var rules = zone.getRules__Ljava_time_zone_ZoneRules();
    var validOffsets = rules.getValidOffsets__Ljava_time_LocalDateTime__ju_List(_localDateTime);
    var offset$2 = null;
    if ((validOffsets.size__I() === 1)) {
      offset$2 = $as_Ljava_time_ZoneOffset(validOffsets.get__I__O(0))
    } else if ((validOffsets.size__I() === 0)) {
      var trans = rules.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition(_localDateTime);
      var this$6 = _localDateTime;
      var this$4 = $m_Ljava_time_Duration$();
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value >> 31);
      var this$5 = this$4.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(value, hi), 0);
      var t = this$5.Ljava_time_Duration__f_seconds;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      _localDateTime = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(lo, hi$1), $L0, 1);
      offset$2 = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
    } else if (((preferredOffset !== null) && validOffsets.contains__O__Z(preferredOffset))) {
      offset$2 = preferredOffset
    } else {
      var obj = validOffsets.get__I__O(0);
      if ((obj === null)) {
        throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
      };
      offset$2 = $as_Ljava_time_ZoneOffset(obj)
    };
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset$2, zone)
  }
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant.Ljava_time_Instant__f_seconds, instant.Ljava_time_Instant__f_nanos, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(localDateTime, offset, zone) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var $$x1 = localDateTime.toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$4 = localDateTime.Ljava_time_LocalDateTime__f_time;
  return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x1, this$4.Ljava_time_LocalTime__f_nano, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(epochSecond, nanoOfSecond, zone) {
  var rules = zone.getRules__Ljava_time_zone_ZoneRules();
  var $$x1 = $m_Ljava_time_Instant$();
  var hi = (nanoOfSecond >> 31);
  var instant = $$x1.ofEpochSecond__J__J__Ljava_time_Instant(epochSecond, new $c_RTLong(nanoOfSecond, hi));
  var offset = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return new $c_Ljava_time_ZonedDateTime($m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(epochSecond, nanoOfSecond, offset), offset, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var time = $as_Ljava_time_ZonedDateTime(temporal);
    return time
  } else {
    try {
      var zone = $m_Ljava_time_ZoneId$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        try {
          var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var nanoOfSecond = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
          return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(new $c_RTLong(lo, hi), nanoOfSecond, zone)
        } catch (e) {
          if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
            throw e
          }
        }
      };
      var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
      return this.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(ldt, zone, null)
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZonedDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)))
      } else {
        throw e$2
      }
    }
  }
});
$c_Ljava_time_ZonedDateTime$.prototype.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_ZonedDateTime = (function(text, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  return $as_Ljava_time_ZonedDateTime(formatter.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(text, new $c_Ljava_time_ZonedDateTime$$anon$1()))
});
var $d_Ljava_time_ZonedDateTime$ = new $TypeData().initClass({
  Ljava_time_ZonedDateTime$: 0
}, false, "java.time.ZonedDateTime$", {
  Ljava_time_ZonedDateTime$: 1,
  O: 1
});
$c_Ljava_time_ZonedDateTime$.prototype.$classData = $d_Ljava_time_ZonedDateTime$;
var $n_Ljava_time_ZonedDateTime$;
function $m_Ljava_time_ZonedDateTime$() {
  if ((!$n_Ljava_time_ZonedDateTime$)) {
    $n_Ljava_time_ZonedDateTime$ = new $c_Ljava_time_ZonedDateTime$()
  };
  return $n_Ljava_time_ZonedDateTime$
}
/** @constructor */
function $c_Ljava_time_chrono_Chronology$() {
  this.Ljava_time_chrono_Chronology$__f_CHRONOS_BY_ID$lzy1 = null;
  this.Ljava_time_chrono_Chronology$__f_CHRONOS_BY_IDbitmap$1 = false;
  this.Ljava_time_chrono_Chronology$__f_CHRONOS_BY_TYPE$lzy1 = null;
  this.Ljava_time_chrono_Chronology$__f_CHRONOS_BY_TYPEbitmap$1 = false
}
$c_Ljava_time_chrono_Chronology$.prototype = new $h_O();
$c_Ljava_time_chrono_Chronology$.prototype.constructor = $c_Ljava_time_chrono_Chronology$;
/** @constructor */
function $h_Ljava_time_chrono_Chronology$() {
  /*<skip>*/
}
$h_Ljava_time_chrono_Chronology$.prototype = $c_Ljava_time_chrono_Chronology$.prototype;
$c_Ljava_time_chrono_Chronology$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology = (function(temporal) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  var obj = $as_Ljava_time_chrono_Chronology(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()));
  return ((obj !== null) ? obj : $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology())
});
var $d_Ljava_time_chrono_Chronology$ = new $TypeData().initClass({
  Ljava_time_chrono_Chronology$: 0
}, false, "java.time.chrono.Chronology$", {
  Ljava_time_chrono_Chronology$: 1,
  O: 1
});
$c_Ljava_time_chrono_Chronology$.prototype.$classData = $d_Ljava_time_chrono_Chronology$;
var $n_Ljava_time_chrono_Chronology$;
function $m_Ljava_time_chrono_Chronology$() {
  if ((!$n_Ljava_time_chrono_Chronology$)) {
    $n_Ljava_time_chrono_Chronology$ = new $c_Ljava_time_chrono_Chronology$()
  };
  return $n_Ljava_time_chrono_Chronology$
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology$() {
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = null;
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = false
}
$c_Ljava_time_chrono_IsoChronology$.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology$.prototype.constructor = $c_Ljava_time_chrono_IsoChronology$;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology$() {
  /*<skip>*/
}
$h_Ljava_time_chrono_IsoChronology$.prototype = $c_Ljava_time_chrono_IsoChronology$.prototype;
$c_Ljava_time_chrono_IsoChronology$.prototype.INSTANCE__Ljava_time_chrono_IsoChronology = (function() {
  if ((!this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1)) {
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = new $c_Ljava_time_chrono_IsoChronology();
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = true
  };
  return this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1
});
var $d_Ljava_time_chrono_IsoChronology$ = new $TypeData().initClass({
  Ljava_time_chrono_IsoChronology$: 0
}, false, "java.time.chrono.IsoChronology$", {
  Ljava_time_chrono_IsoChronology$: 1,
  O: 1
});
$c_Ljava_time_chrono_IsoChronology$.prototype.$classData = $d_Ljava_time_chrono_IsoChronology$;
var $n_Ljava_time_chrono_IsoChronology$;
function $m_Ljava_time_chrono_IsoChronology$() {
  if ((!$n_Ljava_time_chrono_IsoChronology$)) {
    $n_Ljava_time_chrono_IsoChronology$ = new $c_Ljava_time_chrono_IsoChronology$()
  };
  return $n_Ljava_time_chrono_IsoChronology$
}
function $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException($thiz, text, ex) {
  var abbr = (($dp_length__I(text) > 64) ? ($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $dp_toString__T(text));
  return new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed: ") + ex.getMessage__T()), text, 0, ex)
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = null;
  this.Ljava_time_format_DateTimeFormatter__f_locale = null;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = null;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = null;
  this.Ljava_time_format_DateTimeFormatter__f_zone = null;
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = printerParser;
  this.Ljava_time_format_DateTimeFormatter__f_locale = locale;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = decimalStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = resolverStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = resolverFields;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = chrono;
  this.Ljava_time_format_DateTimeFormatter__f_zone = zone;
  if ((printerParser === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "printerParser")
  };
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale")
  };
  if ((decimalStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "decimalStyle")
  };
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle")
  }
}
$c_Ljava_time_format_DateTimeFormatter.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatter.prototype = $c_Ljava_time_format_DateTimeFormatter.prototype;
$c_Ljava_time_format_DateTimeFormatter.prototype.withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter = (function(chrono) {
  var a = this.Ljava_time_format_DateTimeFormatter__f_chrono;
  if (((a === null) ? (chrono === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(a, chrono))) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, chrono, this.Ljava_time_format_DateTimeFormatter__f_zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter = (function(resolverStyle) {
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle")
  };
  var a = this.Ljava_time_format_DateTimeFormatter__f_resolverStyle;
  if ((a === resolverStyle)) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, this.Ljava_time_format_DateTimeFormatter__f_zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.format__Ljava_time_temporal_TemporalAccessor__T = (function(temporal) {
  var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
  this.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V(temporal, buf);
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_format_DateTimeFormatter.prototype.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V = (function(temporal, appendable) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  if ((appendable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "appendable")
  };
  try {
    var context = $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimePrintContext(), temporal, this);
    if ((appendable instanceof $c_jl_StringBuilder)) {
      this.Ljava_time_format_DateTimeFormatter__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, $as_jl_StringBuilder(appendable))
    } else {
      var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
      this.Ljava_time_format_DateTimeFormatter__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
      appendable.append__jl_CharSequence__jl_Appendable(buf)
    }
  } catch (e) {
    if (false) {
      var ex = $as_Ljava_io_IOException(e);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ex.getMessage__T(), ex)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O = (function(text, type) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  if ((type === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "type")
  };
  try {
    var builder = this.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder(text, null).resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder(this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields);
    return type.queryFrom__Ljava_time_temporal_TemporalAccessor__O(builder)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 instanceof $c_Ljava_time_format_DateTimeParseException)) {
      var ex$2 = $as_Ljava_time_format_DateTimeParseException(e$2);
      throw ex$2
    } else if ((e$2 instanceof $c_jl_RuntimeException)) {
      var ex = $as_jl_RuntimeException(e$2);
      throw $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException(this, text, ex)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder = (function(text, position) {
  var pos = ((position !== null) ? position : new $c_Ljava_text_ParsePosition(0));
  var result = this.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(text, pos);
  if ((((result === null) || (pos.Ljava_text_ParsePosition__f_errorIndex >= 0)) || ((position === null) && (pos.Ljava_text_ParsePosition__f_index < $dp_length__I(text))))) {
    var abbr = (($dp_length__I(text) > 64) ? ($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $dp_toString__T(text));
    if ((pos.Ljava_text_ParsePosition__f_errorIndex >= 0)) {
      throw new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed at index ") + pos.Ljava_text_ParsePosition__f_errorIndex), text, pos.Ljava_text_ParsePosition__f_errorIndex, null)
    } else {
      throw new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed, unparsed text found at index ") + pos.Ljava_text_ParsePosition__f_index), text, pos.Ljava_text_ParsePosition__f_index, null)
    }
  };
  return result.toBuilder__Ljava_time_format_DateTimeBuilder()
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function(text, position) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  if ((position === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "position")
  };
  var context = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this);
  var pos = this.Ljava_time_format_DateTimeFormatter__f_printerParser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, position.Ljava_text_ParsePosition__f_index);
  if ((pos < 0)) {
    position.Ljava_text_ParsePosition__f_errorIndex = (~pos);
    return null
  } else {
    position.Ljava_text_ParsePosition__f_index = pos;
    return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.toString__T = (function() {
  var pattern = this.Ljava_time_format_DateTimeFormatter__f_printerParser.toString__T();
  if ((($uI(pattern.length) >= 0) && ($as_T(pattern.substring(0, $uI("[".length))) === "["))) {
    return pattern
  } else {
    var endIndex = (((-1) + $uI(pattern.length)) | 0);
    return $as_T(pattern.substring(1, endIndex))
  }
});
var $d_Ljava_time_format_DateTimeFormatter = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatter: 0
}, false, "java.time.format.DateTimeFormatter", {
  Ljava_time_format_DateTimeFormatter: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatter.prototype.$classData = $d_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter$() {
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_DATE_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_DATE_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_ORDINAL_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_ORDINAL_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_WEEK_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_WEEK_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_BASIC_ISO_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_BASIC_ISO_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_RFC_1123_DATE_TIME$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_RFC_1123_DATE_TIMEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_PARSED_EXCESS_DAYS$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_PARSED_EXCESS_DAYSbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_PARSED_LEAP_SECOND$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_PARSED_LEAP_SECONDbitmap$1 = false
}
$c_Ljava_time_format_DateTimeFormatter$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter$() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatter$.prototype = $c_Ljava_time_format_DateTimeFormatter$.prototype;
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), 4, 10, $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), 2);
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIMEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2).optionalStart__Ljava_time_format_DateTimeFormatterBuilder().appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2).optionalStart__Ljava_time_format_DateTimeFormatterBuilder().appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), 0, 9, true);
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIMEbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME$lzy1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_DATE_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIMEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder().append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder(this.ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(84).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder(this.ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter());
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIMEbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME$lzy1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_OFFSET_DATE_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIMEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder().append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder(this.ISO_LOCAL_DATE_TIME__Ljava_time_format_DateTimeFormatter()).appendOffsetId__Ljava_time_format_DateTimeFormatterBuilder();
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIME$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIMEbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_OFFSET_DATE_TIME$lzy1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_ZONED_DATE_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIMEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder(this.ISO_OFFSET_DATE_TIME__Ljava_time_format_DateTimeFormatter()).optionalStart__Ljava_time_format_DateTimeFormatterBuilder().appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(91).parseCaseSensitive__Ljava_time_format_DateTimeFormatterBuilder().appendZoneRegionId__Ljava_time_format_DateTimeFormatterBuilder().appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(93);
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIME$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIMEbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_ZONED_DATE_TIME$lzy1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_INSTANT__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder().appendInstant__Ljava_time_format_DateTimeFormatterBuilder();
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1
});
var $d_Ljava_time_format_DateTimeFormatter$ = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatter$: 0
}, false, "java.time.format.DateTimeFormatter$", {
  Ljava_time_format_DateTimeFormatter$: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.$classData = $d_Ljava_time_format_DateTimeFormatter$;
var $n_Ljava_time_format_DateTimeFormatter$;
function $m_Ljava_time_format_DateTimeFormatter$() {
  if ((!$n_Ljava_time_format_DateTimeFormatter$)) {
    $n_Ljava_time_format_DateTimeFormatter$ = new $c_Ljava_time_format_DateTimeFormatter$()
  };
  return $n_Ljava_time_format_DateTimeFormatter$
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, parent, optional) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_parent = parent;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_optional = optional;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active = $thiz;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  return $thiz
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__($thiz) {
  $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, null, false);
  return $thiz
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder($thiz, pp) {
  if ((($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex >= 0) && ($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.get__I__O($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex) instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser))) {
    var activeValueParser = $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex;
    var basePP = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.get__I__O(activeValueParser));
    if (((pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && (pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
      basePP = basePP.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth);
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser());
      $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = activeValueParser
    } else {
      basePP = basePP.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser();
      $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp)
    };
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.set__I__O__O(activeValueParser, basePP)
  } else {
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp)
  };
  return $thiz
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp) {
  var _pp = pp;
  var obj = _pp;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pp")
  };
  if (($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth > 0)) {
    if ((_pp !== null)) {
      _pp = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(_pp, $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth, $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar)
    };
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0
  };
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.add__O__Z(_pp);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  return (((-1) + $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.size__I()) | 0)
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_parent = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_optional = false;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = 0
}
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.parseCaseSensitive__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder = (function(field, width) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if (((width < 1) || (width > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The width must be from 1 to 19 inclusive but was " + width))
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, width, width, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, signStyle) {
  if (((minWidth === maxWidth) && (signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
    return this.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, maxWidth)
  };
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((signStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "signStyle")
  };
  if (((minWidth < 1) || (minWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The minimum width must be from 1 to 19 inclusive but was " + minWidth))
  };
  if (((maxWidth < 1) || (maxWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The maximum width must be from 1 to 19 inclusive but was " + maxWidth))
  };
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("The maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth))
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, minWidth, maxWidth, signStyle));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, decimalPoint) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendInstant__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser((-2)));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendOffsetId__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID);
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendZoneRegionId__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser($m_Ljava_time_format_DateTimeFormatterBuilder$().java$time$format$DateTimeFormatterBuilder$$$QUERY_REGION_ONLY__Ljava_time_temporal_TemporalQuery(), "ZoneRegionId()"));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder = (function(literal) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder = (function(formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, formatter.Ljava_time_format_DateTimeFormatter__f_printerParser.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalStart__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__(new $c_Ljava_time_format_DateTimeFormatterBuilder(), this.Ljava_time_format_DateTimeFormatterBuilder__f_active, true);
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  if ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot call optionalEnd() as there was no previous call to optionalStart()")
  };
  if ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.size__I() > 0)) {
    var cpp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_optional);
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent;
    $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, cpp)
  } else {
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent
  };
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(locale) {
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale")
  };
  while ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent !== null)) {
    this.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder()
  };
  var pp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, false);
  return new $c_Ljava_time_format_DateTimeFormatter(pp, locale, $m_Ljava_time_format_DecimalStyle$().STANDARD__Ljava_time_format_DecimalStyle(), $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle(), null, null, null)
});
var $d_Ljava_time_format_DateTimeFormatterBuilder = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder: 0
}, false, "java.time.format.DateTimeFormatterBuilder", {
  Ljava_time_format_DateTimeFormatterBuilder: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$() {
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLY$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLYbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAP$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAPbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1 = false
}
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder$.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.java$time$format$DateTimeFormatterBuilder$$$QUERY_REGION_ONLY__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLYbitmap$1)) {
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLY$lzy1 = new $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2();
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLYbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatterBuilder$__f_QUERY_REGION_ONLY$lzy1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.LENGTH_SORT__ju_Comparator = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1)) {
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1 = new $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3();
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1 = true
  };
  return this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$ = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder$: 0
}, false, "java.time.format.DateTimeFormatterBuilder$", {
  Ljava_time_format_DateTimeFormatterBuilder$: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder$;
var $n_Ljava_time_format_DateTimeFormatterBuilder$;
function $m_Ljava_time_format_DateTimeFormatterBuilder$() {
  if ((!$n_Ljava_time_format_DateTimeFormatterBuilder$)) {
    $n_Ljava_time_format_DateTimeFormatterBuilder$ = new $c_Ljava_time_format_DateTimeFormatterBuilder$()
  };
  return $n_Ljava_time_format_DateTimeFormatterBuilder$
}
/** @constructor */
function $c_Ljava_time_format_DecimalStyle(zeroDigit, positiveSign, negativeSign, decimalSeparator) {
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = 0;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = 0;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = 0;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = 0;
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = zeroDigit;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = positiveSign;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = negativeSign;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = decimalSeparator
}
$c_Ljava_time_format_DecimalStyle.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle.prototype.constructor = $c_Ljava_time_format_DecimalStyle;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_DecimalStyle.prototype = $c_Ljava_time_format_DecimalStyle.prototype;
$c_Ljava_time_format_DecimalStyle.prototype.convertToDigit__C__I = (function(ch) {
  var value = ((ch - this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  return (((value >= 0) && (value <= 9)) ? value : (-1))
});
$c_Ljava_time_format_DecimalStyle.prototype.convertNumberToI18N__T__T = (function(numericText) {
  if ((this.Ljava_time_format_DecimalStyle__f_zeroDigit === 48)) {
    return numericText
  };
  var diff = (((-48) + this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  var array = $f_T__toCharArray__AC(numericText);
  var i = 0;
  while ((i < array.u.length)) {
    array.set(i, (65535 & ((array.get(i) + diff) | 0)));
    i = ((1 + i) | 0)
  };
  var this$1 = $m_jl_String$();
  return this$1.new__AC__I__I__T(array, 0, array.u.length)
});
$c_Ljava_time_format_DecimalStyle.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_format_DecimalStyle)) {
    var other = $as_Ljava_time_format_DecimalStyle(obj);
    return ((this === other) || ((((this.Ljava_time_format_DecimalStyle__f_zeroDigit === other.Ljava_time_format_DecimalStyle__f_zeroDigit) && (this.Ljava_time_format_DecimalStyle__f_positiveSign === other.Ljava_time_format_DecimalStyle__f_positiveSign)) && (this.Ljava_time_format_DecimalStyle__f_negativeSign === other.Ljava_time_format_DecimalStyle__f_negativeSign)) && (this.Ljava_time_format_DecimalStyle__f_decimalSeparator === other.Ljava_time_format_DecimalStyle__f_decimalSeparator)))
  } else {
    return false
  }
});
$c_Ljava_time_format_DecimalStyle.prototype.hashCode__I = (function() {
  return ((((((this.Ljava_time_format_DecimalStyle__f_zeroDigit + this.Ljava_time_format_DecimalStyle__f_positiveSign) | 0) + this.Ljava_time_format_DecimalStyle__f_negativeSign) | 0) + this.Ljava_time_format_DecimalStyle__f_decimalSeparator) | 0)
});
$c_Ljava_time_format_DecimalStyle.prototype.toString__T = (function() {
  return ((((("DecimalStyle[" + $bC(this.Ljava_time_format_DecimalStyle__f_zeroDigit)) + $bC(this.Ljava_time_format_DecimalStyle__f_positiveSign)) + $bC(this.Ljava_time_format_DecimalStyle__f_negativeSign)) + $bC(this.Ljava_time_format_DecimalStyle__f_decimalSeparator)) + "]")
});
function $as_Ljava_time_format_DecimalStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_DecimalStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.DecimalStyle"))
}
function $isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DecimalStyle)))
}
function $asArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.DecimalStyle;", depth))
}
var $d_Ljava_time_format_DecimalStyle = new $TypeData().initClass({
  Ljava_time_format_DecimalStyle: 0
}, false, "java.time.format.DecimalStyle", {
  Ljava_time_format_DecimalStyle: 1,
  O: 1
});
$c_Ljava_time_format_DecimalStyle.prototype.$classData = $d_Ljava_time_format_DecimalStyle;
/** @constructor */
function $c_Ljava_time_format_DecimalStyle$() {
  this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = null;
  this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = false;
  this.Ljava_time_format_DecimalStyle$__f_CACHE$lzy1 = null;
  this.Ljava_time_format_DecimalStyle$__f_CACHEbitmap$1 = false
}
$c_Ljava_time_format_DecimalStyle$.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle$.prototype.constructor = $c_Ljava_time_format_DecimalStyle$;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_DecimalStyle$.prototype = $c_Ljava_time_format_DecimalStyle$.prototype;
$c_Ljava_time_format_DecimalStyle$.prototype.STANDARD__Ljava_time_format_DecimalStyle = (function() {
  if ((!this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1)) {
    this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = new $c_Ljava_time_format_DecimalStyle(48, 43, 45, 46);
    this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = true
  };
  return this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1
});
var $d_Ljava_time_format_DecimalStyle$ = new $TypeData().initClass({
  Ljava_time_format_DecimalStyle$: 0
}, false, "java.time.format.DecimalStyle$", {
  Ljava_time_format_DecimalStyle$: 1,
  O: 1
});
$c_Ljava_time_format_DecimalStyle$.prototype.$classData = $d_Ljava_time_format_DecimalStyle$;
var $n_Ljava_time_format_DecimalStyle$;
function $m_Ljava_time_format_DecimalStyle$() {
  if ((!$n_Ljava_time_format_DecimalStyle$)) {
    $n_Ljava_time_format_DecimalStyle$ = new $c_Ljava_time_format_DecimalStyle$()
  };
  return $n_Ljava_time_format_DecimalStyle$
}
function $is_Ljava_time_format_internal_DateTimePrinterParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_format_internal_DateTimePrinterParser)))
}
function $as_Ljava_time_format_internal_DateTimePrinterParser(obj) {
  return (($is_Ljava_time_format_internal_DateTimePrinterParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.DateTimePrinterParser"))
}
function $isArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_DateTimePrinterParser)))
}
function $asArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.DateTimePrinterParser;", depth))
}
var $d_Ljava_time_format_internal_DateTimePrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_DateTimePrinterParser: 0
}, true, "java.time.format.internal.DateTimePrinterParser", {
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  O: 1
});
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = new $c_RTLong(2036907392, 73);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = new $c_RTLong(2037677056, 14)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = new $ac_I(new Int32Array([0, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]))
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = new ($d_T.getArrayOf().constr)(["+HH", "+HHmm", "+HH:mm", "+HHMM", "+HH:MM", "+HHMMss", "+HH:MM:ss", "+HHMMSS", "+HH:MM:SS"]);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("Z", "+HH:MM:ss")
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = null
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(availableIDs) {
  var ids = $ct_ju_ArrayList__ju_Collection__(new $c_ju_ArrayList(), availableIDs);
  var c = $m_Ljava_time_format_DateTimeFormatterBuilder$().LENGTH_SORT__ju_Comparator();
  $f_ju_List__sort__ju_Comparator__V(ids, c);
  var this$2 = $as_T(ids.get__I__O(0));
  var tree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($uI(this$2.length));
  var idsIterator = ids.listIterator__I__ju_ListIterator(0);
  while (idsIterator.hasNext__Z()) {
    var id = $as_T(idsIterator.next__O());
    tree.add__T__V(id)
  };
  return tree
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(length) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = length;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = $ct_ju_HashMap__(new $c_ju_HashMap())
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(substring2, caseSensitive) {
  if (caseSensitive) {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap;
    return $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, substring2, null))
  } else {
    var this$3 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI;
    var string = $dp_toString__T(substring2);
    var key = $as_T(string.toLowerCase());
    return $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$3, key, null))
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.add__T__V = (function(newSubstring) {
  var this$ = this;
  while (true) {
    var idLen = $uI(newSubstring.length);
    if ((idLen === this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      var this$1 = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap;
      if ((newSubstring === null)) {
        var $$x1 = 0
      } else {
        var originalHash = $f_T__hashCode__I(newSubstring);
        var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
      };
      this$1.java$util$HashMap$$put0__O__O__I__Z__O(newSubstring, null, $$x1, false);
      var this$4 = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI;
      var key = $as_T(newSubstring.toLowerCase());
      if ((key === null)) {
        var $$x2 = 0
      } else {
        var originalHash$1 = $f_T__hashCode__I(key);
        var $$x2 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0))
      };
      this$4.java$util$HashMap$$put0__O__O__I__Z__O(key, null, $$x2, false)
    } else if ((idLen > this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      var endIndex = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
      var substring = $as_T(newSubstring.substring(0, endIndex));
      var this$6 = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap;
      var parserTree = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$6, substring, null));
      if ((parserTree === null)) {
        parserTree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(idLen);
        var this$7 = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap;
        var value = parserTree;
        if ((substring === null)) {
          var $$x3 = 0
        } else {
          var originalHash$2 = $f_T__hashCode__I(substring);
          var $$x3 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0))
        };
        this$7.java$util$HashMap$$put0__O__O__I__Z__O(substring, value, $$x3, false);
        var this$10 = this$.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI;
        var key$1 = $as_T(substring.toLowerCase());
        var value$1 = parserTree;
        if ((key$1 === null)) {
          var $$x4 = 0
        } else {
          var originalHash$3 = $f_T__hashCode__I(key$1);
          var $$x4 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0))
        };
        this$10.java$util$HashMap$$put0__O__O__I__Z__O(key$1, value$1, $$x4, false)
      };
      this$ = parserTree;
      continue
    };
    return (void 0)
  }
});
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, locale, symbols, overrideChronology, overrideZone, caseSensitive, strict) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = overrideChronology;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone = overrideZone;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = caseSensitive;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = strict;
  var list = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  list.add__O__Z(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz));
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = list;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__($thiz, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, formatter.Ljava_time_format_DateTimeFormatter__f_locale, formatter.Ljava_time_format_DateTimeFormatter__f_decimalStyle, formatter.Ljava_time_format_DateTimeFormatter__f_chrono, formatter.Ljava_time_format_DateTimeFormatter__f_zone, true, true);
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__($thiz, other) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict);
  return $thiz
}
function $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz) {
  return $as_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.get__I__O((((-1) + $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0)))
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = null
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getEffectiveChronology__Ljava_time_chrono_Chronology = (function() {
  var chrono = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono;
  if ((chrono === null)) {
    chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology;
    if ((chrono === null)) {
      chrono = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
    }
  };
  return chrono
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z = (function(cs1, offset1, cs2, offset2, length) {
  if (((((offset1 + length) | 0) > $dp_length__I(cs1)) || (((offset2 + length) | 0) > $dp_length__I(cs2)))) {
    return false
  };
  if (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive) {
    var i = 0;
    while ((i < length)) {
      var ch1 = $dp_charAt__I__C(cs1, ((offset1 + i) | 0));
      var ch2 = $dp_charAt__I__C(cs2, ((offset2 + i) | 0));
      if ((ch1 !== ch2)) {
        return false
      };
      i = ((1 + i) | 0)
    }
  } else {
    var i$2 = 0;
    while ((i$2 < length)) {
      var ch1$2 = $dp_charAt__I__C(cs1, ((offset1 + i$2) | 0));
      var ch2$2 = $dp_charAt__I__C(cs2, ((offset2 + i$2) | 0));
      if ((((ch1$2 !== ch2$2) && ($m_jl_Character$().toUpperCase__C__C(ch1$2) !== $m_jl_Character$().toUpperCase__C__C(ch2$2))) && ($m_jl_Character$().toLowerCase__C__C(ch1$2) !== $m_jl_Character$().toLowerCase__C__C(ch2$2)))) {
        return false
      };
      i$2 = ((1 + i$2) | 0)
    }
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.charEquals__C__C__Z = (function(ch1, ch2) {
  return (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive ? (ch1 === ch2) : $m_Ljava_time_format_internal_TTBPDateTimeParseContext$().charEqualsIgnoreCase__C__C__Z(ch1, ch2))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.startOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.add__O__Z($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed())
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.endOptional__Z__V = (function(successful) {
  if (successful) {
    this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.remove__I__O((((-2) + this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0))
  } else {
    this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.remove__I__O((((-1) + this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0))
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getParsed__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  var this$1 = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues;
  return $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, field, null))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I = (function(field, value, errorPos, successPos) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var this$3 = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues;
  if ((field === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $systemIdentityHashCode(field);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var old = $as_jl_Long(this$3.java$util$HashMap$$put0__O__O__I__Z__O(field, value, $$x1, false));
  if ((old !== null)) {
    var this$6 = $uJ(old);
    var $$x2 = (!((this$6.RTLong__f_lo === value.RTLong__f_lo) && (this$6.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    return (~errorPos)
  } else {
    return successPos
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsed__Ljava_time_ZoneId__V = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = zone
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.toString__T = (function() {
  return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).toString__T()
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext", {
  Ljava_time_format_internal_TTBPDateTimeParseContext: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.charEqualsIgnoreCase__C__C__Z = (function(c1, c2) {
  return (((c1 === c2) || ($m_jl_Character$().toUpperCase__C__C(c1) === $m_jl_Character$().toUpperCase__C__C(c2))) || ($m_jl_Character$().toLowerCase__C__C(c1) === $m_jl_Character$().toLowerCase__C__C(c2)))
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext$: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext$", {
  Ljava_time_format_internal_TTBPDateTimeParseContext$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext$;
var $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
function $m_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeParseContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeParseContext$
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, temporal, locale, symbols) {
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = temporal;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__($thiz, temporal, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, $m_Ljava_time_format_internal_TTBPDateTimePrintContext$().adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor(temporal, formatter), formatter.Ljava_time_format_DateTimeFormatter__f_locale, formatter.Ljava_time_format_DateTimeFormatter__f_decimalStyle);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.startOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = ((1 + this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.endOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = (((-1) + this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var result = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.query__Ljava_time_temporal_TemporalQuery__O(query);
  if (((result === null) && (this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional === 0))) {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal;
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unable to extract value: " + $objectGetClass(this$1)))
  } else {
    return result
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  try {
    var t = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.getLong__Ljava_time_temporal_TemporalField__J(field);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_RTLong(lo, hi)
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      if ((this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional > 0)) {
        return null
      } else {
        throw ex
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.toString__T = (function() {
  return this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.toString__T()
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext", {
  Ljava_time_format_internal_TTBPDateTimePrintContext: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor = (function(temporal, formatter) {
  var elem = formatter.Ljava_time_format_DateTimeFormatter__f_chrono;
  var overrideChrono = new $c_sr_ObjectRef(elem);
  var overrideZone = formatter.Ljava_time_format_DateTimeFormatter__f_zone;
  if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
    return temporal
  } else {
    var temporalChrono = $as_Ljava_time_chrono_Chronology(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()));
    var temporalZone = $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
    var b = $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem);
    if (((temporalChrono === null) ? (b === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(temporalChrono, b))) {
      overrideChrono.sr_ObjectRef__f_elem = null
    };
    var b$1 = overrideZone;
    if (((temporalZone === null) ? (b$1 === null) : temporalZone.equals__O__Z(b$1))) {
      overrideZone = null
    };
    if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
      return temporal
    };
    var effectiveChrono = (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null) ? $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) : temporalChrono);
    var effectiveZone = ((overrideZone !== null) ? overrideZone : temporalZone);
    if ((overrideZone !== null)) {
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        if ((effectiveChrono !== null)) {
          /*<skip>*/
        } else {
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
        };
        var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
        var zone = overrideZone;
        return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, zone)
      };
      var normalizedOffset = overrideZone.normalized__Ljava_time_ZoneId();
      var temporalOffset = $as_Ljava_time_ZoneOffset(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
      if ((((normalizedOffset instanceof $c_Ljava_time_ZoneOffset) && (temporalOffset !== null)) && (!((normalizedOffset === null) ? (temporalOffset === null) : normalizedOffset.equals__O__Z(temporalOffset))))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override zone for temporal: " + overrideZone) + " ") + temporal))
      }
    };
    if (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null)) {
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
        var effectiveDate = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)
      } else {
        if ((!(($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()) && (temporalChrono === null)))) {
          var xs = $m_Ljava_time_temporal_ChronoField$().values__ALjava_time_temporal_ChronoField();
          var f$2 = ((this$5, temporal$2, overrideChrono$2) => ((f) => {
            var f$1 = $as_Ljava_time_temporal_ChronoField(f);
            if ((f$1.isDateBased__Z() && temporal$2.isSupported__Ljava_time_temporal_TemporalField__Z(f$1))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override chronology for temporal: " + $as_Ljava_time_chrono_Chronology(overrideChrono$2.sr_ObjectRef__f_elem)) + " ") + temporal$2))
            }
          }))(this, temporal, overrideChrono);
          var len = xs.u.length;
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var arg1 = xs.get(i);
              f$2(arg1);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs, 1);
            while ((i < len)) {
              var arg1$1 = x3.get(i);
              f$2(arg1$1);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs, 1);
            while ((i < len)) {
              var arg1$2 = x4.get(i);
              f$2(arg1$2);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs, 1);
            while ((i < len)) {
              var t = x5.get(i);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              f$2(new $c_RTLong(lo, hi));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs, 1);
            while ((i < len)) {
              var arg1$3 = x6.get(i);
              f$2(arg1$3);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs, 1);
            while ((i < len)) {
              var arg1$4 = x7.get(i);
              f$2($bC(arg1$4));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs, 1);
            while ((i < len)) {
              var arg1$5 = x8.get(i);
              f$2(arg1$5);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs, 1);
            while ((i < len)) {
              var arg1$6 = x9.get(i);
              f$2(arg1$6);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs, 1);
            while ((i < len)) {
              var arg1$7 = x10.get(i);
              f$2(arg1$7);
              i = ((1 + i) | 0)
            }
          } else {
            throw new $c_s_MatchError(xs)
          }
        };
        var effectiveDate = null
      }
    } else {
      var effectiveDate = null
    };
    return new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(temporal, effectiveChrono, effectiveZone, effectiveDate)
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext$", {
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext$;
var $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
function $m_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimePrintContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimePrintContext$
}
function $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($thiz, field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($thiz.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      return field.Ljava_time_temporal_ChronoField__f__range
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
    }
  } else {
    return $thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
}
function $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  return $thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($thiz.getLong__Ljava_time_temporal_TemporalField__J(field), field)
}
function $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts1: {
    matchAlts2: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === query)) {
        break matchAlts2
      };
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === query)) {
        break matchAlts2
      };
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts2
      };
      break matchAlts1
    };
    return null
  };
  return query.queryFrom__Ljava_time_temporal_TemporalAccessor__O($thiz)
}
function $is_Ljava_time_temporal_TemporalAccessor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalAccessor)))
}
function $as_Ljava_time_temporal_TemporalAccessor(obj) {
  return (($is_Ljava_time_temporal_TemporalAccessor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalAccessor"))
}
function $isArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalAccessor)))
}
function $asArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalAccessor;", depth))
}
function $is_Ljava_time_temporal_TemporalField(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalField)))
}
function $as_Ljava_time_temporal_TemporalField(obj) {
  return (($is_Ljava_time_temporal_TemporalField(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalField"))
}
function $isArrayOf_Ljava_time_temporal_TemporalField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalField)))
}
function $asArrayOf_Ljava_time_temporal_TemporalField(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalField;", depth))
}
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$() {
  this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = false
}
$c_Ljava_time_temporal_TemporalQueries$.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$.prototype = $c_Ljava_time_temporal_TemporalQueries$.prototype;
$c_Ljava_time_temporal_TemporalQueries$.prototype.zoneId__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$1();
    this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.chronology__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$2();
    this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.precision__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$3();
    this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.offset__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$4();
    this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.zone__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$5();
    this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localDate__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$6();
    this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localTime__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$7();
    this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = true
  };
  return this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1
});
var $d_Ljava_time_temporal_TemporalQueries$ = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$: 0
}, false, "java.time.temporal.TemporalQueries$", {
  Ljava_time_temporal_TemporalQueries$: 1,
  O: 1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$;
var $n_Ljava_time_temporal_TemporalQueries$;
function $m_Ljava_time_temporal_TemporalQueries$() {
  if ((!$n_Ljava_time_temporal_TemporalQueries$)) {
    $n_Ljava_time_temporal_TemporalQueries$ = new $c_Ljava_time_temporal_TemporalQueries$()
  };
  return $n_Ljava_time_temporal_TemporalQueries$
}
function $is_Ljava_time_temporal_TemporalUnit(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalUnit)))
}
function $as_Ljava_time_temporal_TemporalUnit(obj) {
  return (($is_Ljava_time_temporal_TemporalUnit(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalUnit"))
}
function $isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalUnit)))
}
function $asArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalUnit;", depth))
}
/** @constructor */
function $c_Ljava_time_temporal_ValueRange$() {
  /*<skip>*/
}
$c_Ljava_time_temporal_ValueRange$.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange$.prototype.constructor = $c_Ljava_time_temporal_ValueRange$;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ValueRange$.prototype = $c_Ljava_time_temporal_ValueRange$.prototype;
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__Ljava_time_temporal_ValueRange = (function(min, max) {
  var ahi = min.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ min.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value")
  } else {
    return new $c_Ljava_time_temporal_ValueRange(min, min, max, max)
  }
});
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__J__J__Ljava_time_temporal_ValueRange = (function(minSmallest, minLargest, maxSmallest, maxLargest) {
  var ahi = minSmallest.RTLong__f_hi;
  var bhi = minLargest.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ minSmallest.RTLong__f_lo) > ((-2147483648) ^ minLargest.RTLong__f_lo)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest minimum value must be less than largest minimum value")
  };
  var ahi$1 = maxSmallest.RTLong__f_hi;
  var bhi$1 = maxLargest.RTLong__f_hi;
  if (((ahi$1 === bhi$1) ? (((-2147483648) ^ maxSmallest.RTLong__f_lo) > ((-2147483648) ^ maxLargest.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest maximum value must be less than largest maximum value")
  };
  var ahi$2 = minLargest.RTLong__f_hi;
  var bhi$2 = maxLargest.RTLong__f_hi;
  if (((ahi$2 === bhi$2) ? (((-2147483648) ^ minLargest.RTLong__f_lo) > ((-2147483648) ^ maxLargest.RTLong__f_lo)) : (ahi$2 > bhi$2))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value")
  };
  return new $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest)
});
var $d_Ljava_time_temporal_ValueRange$ = new $TypeData().initClass({
  Ljava_time_temporal_ValueRange$: 0
}, false, "java.time.temporal.ValueRange$", {
  Ljava_time_temporal_ValueRange$: 1,
  O: 1
});
$c_Ljava_time_temporal_ValueRange$.prototype.$classData = $d_Ljava_time_temporal_ValueRange$;
var $n_Ljava_time_temporal_ValueRange$;
function $m_Ljava_time_temporal_ValueRange$() {
  if ((!$n_Ljava_time_temporal_ValueRange$)) {
    $n_Ljava_time_temporal_ValueRange$ = new $c_Ljava_time_temporal_ValueRange$()
  };
  return $n_Ljava_time_temporal_ValueRange$
}
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules$() {
  this.Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$$LAST_CACHED_YEAR = 0;
  this.Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$$LAST_CACHED_YEAR = 2100
}
$c_Ljava_time_zone_StandardZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_StandardZoneRules$.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules$() {
  /*<skip>*/
}
$h_Ljava_time_zone_StandardZoneRules$.prototype = $c_Ljava_time_zone_StandardZoneRules$.prototype;
$c_Ljava_time_zone_StandardZoneRules$.prototype.apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  var dimensions = new $ac_I(new Int32Array([standardOffsetTransitionList.size__I()]));
  var standardTransitions = $asArrayOf_J($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_J.getClassOf(), dimensions), 1);
  var dimensions$1 = new $ac_I(new Int32Array([((1 + standardOffsetTransitionList.size__I()) | 0)]));
  var standardOffsets = $asArrayOf_Ljava_time_ZoneOffset($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_ZoneOffset.getClassOf(), dimensions$1), 1);
  standardOffsets.set(0, baseStandardOffset);
  var i = 0;
  while ((i < standardOffsetTransitionList.size__I())) {
    var $$x1 = i;
    var this$3 = $as_Ljava_time_zone_ZoneOffsetTransition(standardOffsetTransitionList.get__I__O(i));
    standardTransitions.set($$x1, this$3.Ljava_time_zone_ZoneOffsetTransition__f_transition.toEpochSecond__Ljava_time_ZoneOffset__J(this$3.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore));
    var $$x2 = i;
    var this$4 = $as_Ljava_time_zone_ZoneOffsetTransition(standardOffsetTransitionList.get__I__O(i));
    standardOffsets.set(((1 + $$x2) | 0), this$4.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
    i = ((1 + i) | 0)
  };
  var localTransitionList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var localTransitionOffsetList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  localTransitionOffsetList.add__O__Z(baseWallOffset);
  var transitions = transitionList.iterator__ju_Iterator();
  while (transitions.hasNext__Z()) {
    var trans = $as_Ljava_time_zone_ZoneOffsetTransition(transitions.next__O());
    if (trans.isGap__Z()) {
      localTransitionList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var this$6 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value, hi), $L0, 1))
    } else {
      var this$8 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi$1 = (value$1 >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$8, this$8.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi$1), $L0, 1));
      localTransitionList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_transition)
    };
    localTransitionOffsetList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter)
  };
  var dimensions$2 = new $ac_I(new Int32Array([localTransitionList.size__I()]));
  var savingsLocalTransitions = $asArrayOf_Ljava_time_LocalDateTime(localTransitionList.toArray__AO__AO($asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_LocalDateTime.getClassOf(), dimensions$2), 1)), 1);
  var dimensions$3 = new $ac_I(new Int32Array([localTransitionOffsetList.size__I()]));
  var wallOffsets = $asArrayOf_Ljava_time_ZoneOffset(localTransitionOffsetList.toArray__AO__AO($asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_ZoneOffset.getClassOf(), dimensions$3), 1)), 1);
  var dimensions$4 = new $ac_I(new Int32Array([transitionList.size__I()]));
  var savingsInstantTransitions = $asArrayOf_J($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_J.getClassOf(), dimensions$4), 1);
  var i$2 = 0;
  while ((i$2 < transitionList.size__I())) {
    var $$x3 = i$2;
    var this$12 = $as_Ljava_time_zone_ZoneOffsetTransition(transitionList.get__I__O(i$2));
    var this$13 = this$12.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this$12.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
    savingsInstantTransitions.set($$x3, this$13.Ljava_time_Instant__f_seconds);
    i$2 = ((1 + i$2) | 0)
  };
  if ((lastRules.size__I() > 15)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Too many transition rules")
  };
  var dimensions$5 = new $ac_I(new Int32Array([lastRules.size__I()]));
  var resultLastRules = $asArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(lastRules.toArray__AO__AO($asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_zone_ZoneOffsetTransitionRule.getClassOf(), dimensions$5), 1)), 1);
  return new $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, resultLastRules, savingsLocalTransitions)
});
var $d_Ljava_time_zone_StandardZoneRules$ = new $TypeData().initClass({
  Ljava_time_zone_StandardZoneRules$: 0
}, false, "java.time.zone.StandardZoneRules$", {
  Ljava_time_zone_StandardZoneRules$: 1,
  O: 1
});
$c_Ljava_time_zone_StandardZoneRules$.prototype.$classData = $d_Ljava_time_zone_StandardZoneRules$;
var $n_Ljava_time_zone_StandardZoneRules$;
function $m_Ljava_time_zone_StandardZoneRules$() {
  if ((!$n_Ljava_time_zone_StandardZoneRules$)) {
    $n_Ljava_time_zone_StandardZoneRules$ = new $c_Ljava_time_zone_StandardZoneRules$()
  };
  return $n_Ljava_time_zone_StandardZoneRules$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransition$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransition$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransition$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransition$.prototype = $c_Ljava_time_zone_ZoneOffsetTransition$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.of__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransition = (function(transition, offsetBefore, offsetAfter) {
  if ((transition === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "transition")
  };
  if ((offsetBefore === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetBefore")
  };
  if ((offsetAfter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetAfter")
  };
  if (((offsetBefore === null) ? (offsetAfter === null) : offsetBefore.equals__O__Z(offsetAfter))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Offsets must not be equal")
  };
  var this$4 = transition.Ljava_time_LocalDateTime__f_time;
  if ((this$4.Ljava_time_LocalTime__f_nano !== 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Nano-of-second must be zero")
  };
  return new $c_Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter)
});
var $d_Ljava_time_zone_ZoneOffsetTransition$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransition$: 0
}, false, "java.time.zone.ZoneOffsetTransition$", {
  Ljava_time_zone_ZoneOffsetTransition$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransition$;
var $n_Ljava_time_zone_ZoneOffsetTransition$;
function $m_Ljava_time_zone_ZoneOffsetTransition$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransition$)) {
    $n_Ljava_time_zone_ZoneOffsetTransition$ = new $c_Ljava_time_zone_ZoneOffsetTransition$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransition$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.of__Ljava_time_Month__I__Ljava_time_DayOfWeek__Ljava_time_LocalTime__Z__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransitionRule = (function(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter) {
  if ((month === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "month")
  };
  if ((time === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "time")
  };
  if ((timeDefnition === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "timeDefnition")
  };
  if ((standardOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "standardOffset")
  };
  if ((offsetBefore === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetBefore")
  };
  if ((offsetAfter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetAfter")
  };
  if ((((dayOfMonthIndicator < (-28)) || (dayOfMonthIndicator > 31)) || (dayOfMonthIndicator === 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Day of month indicator must be between -28 and 31 inclusive excluding zero")
  };
  if (timeEndOfDay) {
    var x$2 = $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime();
    var $$x1 = (!((time === null) ? (x$2 === null) : time.equals__O__Z(x$2)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Time must be midnight when end of day flag is true")
  };
  return new $c_Ljava_time_zone_ZoneOffsetTransitionRule(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter)
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$", {
  Ljava_time_zone_ZoneOffsetTransitionRule$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$;
var $n_Ljava_time_zone_ZoneOffsetTransitionRule$;
function $m_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransitionRule$)) {
    $n_Ljava_time_zone_ZoneOffsetTransitionRule$ = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransitionRule$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRules.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules.prototype.constructor = $c_Ljava_time_zone_ZoneRules;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules.prototype = $c_Ljava_time_zone_ZoneRules.prototype;
function $as_Ljava_time_zone_ZoneRules(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRules) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRules"))
}
function $isArrayOf_Ljava_time_zone_ZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules)))
}
function $asArrayOf_Ljava_time_zone_ZoneRules(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRules;", depth))
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules$.prototype.constructor = $c_Ljava_time_zone_ZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules$.prototype = $c_Ljava_time_zone_ZoneRules$.prototype;
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  if ((baseStandardOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseStandardOffset")
  };
  if ((baseWallOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseWallOffset")
  };
  if ((standardOffsetTransitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "standardOffsetTransitionList")
  };
  if ((transitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "transitionList")
  };
  if ((lastRules === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "lastRules")
  };
  return $m_Ljava_time_zone_StandardZoneRules$().apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules)
});
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  return new $c_Ljava_time_zone_ZoneRules$Fixed(offset)
});
var $d_Ljava_time_zone_ZoneRules$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRules$: 0
}, false, "java.time.zone.ZoneRules$", {
  Ljava_time_zone_ZoneRules$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRules$.prototype.$classData = $d_Ljava_time_zone_ZoneRules$;
var $n_Ljava_time_zone_ZoneRules$;
function $m_Ljava_time_zone_ZoneRules$() {
  if ((!$n_Ljava_time_zone_ZoneRules$)) {
    $n_Ljava_time_zone_ZoneRules$ = new $c_Ljava_time_zone_ZoneRules$()
  };
  return $n_Ljava_time_zone_ZoneRules$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRulesInitializer.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesInitializer.prototype = $c_Ljava_time_zone_ZoneRulesInitializer.prototype;
function $as_Ljava_time_zone_ZoneRulesInitializer(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesInitializer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesInitializer"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesInitializer)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesInitializer;", depth))
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1 = new $c_ju_concurrent_atomic_AtomicBoolean(false);
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1 = true
  };
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1 = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1 = true
  };
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer$() {
  this.Ljava_time_zone_ZoneRulesInitializer$__f_DO_NOTHING$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_DO_NOTHINGbitmap$1 = false;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1 = false;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1 = false
}
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesInitializer$.prototype = $c_Ljava_time_zone_ZoneRulesInitializer$.prototype;
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.initialize__V = (function() {
  if ($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean(this).getAndSet__Z__Z(true)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Already initialized")
  };
  $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this).compareAndSet__O__O__Z(null, new $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer());
  $as_Ljava_time_zone_ZoneRulesInitializer($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this).ju_concurrent_atomic_AtomicReference__f_value).initializeProviders__V()
});
var $d_Ljava_time_zone_ZoneRulesInitializer$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesInitializer$: 0
}, false, "java.time.zone.ZoneRulesInitializer$", {
  Ljava_time_zone_ZoneRulesInitializer$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.$classData = $d_Ljava_time_zone_ZoneRulesInitializer$;
var $n_Ljava_time_zone_ZoneRulesInitializer$;
function $m_Ljava_time_zone_ZoneRulesInitializer$() {
  if ((!$n_Ljava_time_zone_ZoneRulesInitializer$)) {
    $n_Ljava_time_zone_ZoneRulesInitializer$ = new $c_Ljava_time_zone_ZoneRulesInitializer$()
  };
  return $n_Ljava_time_zone_ZoneRulesInitializer$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRulesProvider.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesProvider.prototype = $c_Ljava_time_zone_ZoneRulesProvider.prototype;
function $as_Ljava_time_zone_ZoneRulesProvider(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesProvider) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesProvider"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesProvider)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesProvider;", depth))
}
var $d_Ljava_time_zone_ZoneRulesProvider = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesProvider: 0
}, false, "java.time.zone.ZoneRulesProvider", {
  Ljava_time_zone_ZoneRulesProvider: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRulesProvider.prototype.$classData = $d_Ljava_time_zone_ZoneRulesProvider;
function $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1 = $ct_ju_ArrayList__(new $c_ju_ArrayList());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1 = true
  };
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1
}
function $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1 = true
  };
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1
}
function $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider($thiz, zoneId) {
  var this$1 = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz);
  var provider = $as_Ljava_time_zone_ZoneRulesProvider($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, zoneId, null));
  if ((provider === null)) {
    if ($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz).isEmpty__Z()) {
      throw new $c_Ljava_time_zone_ZoneRulesException("No time-zone data files registered")
    } else {
      throw new $c_Ljava_time_zone_ZoneRulesException(("Unknown time-zone ID: " + zoneId))
    }
  } else {
    return provider
  }
}
function $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V($thiz, provider) {
  var zoneIds = provider.provideZoneIds__ju_Set().iterator__ju_Iterator();
  while (zoneIds.hasNext__Z()) {
    var zoneId = $as_T(zoneIds.next__O());
    if ((zoneId === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
    };
    var this$2 = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz);
    if ((zoneId === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $f_T__hashCode__I(zoneId);
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var old = $as_Ljava_time_zone_ZoneRulesProvider(this$2.java$util$HashMap$$put0__O__O__I__Z__O(zoneId, provider, $$x1, false));
    if ((old !== null)) {
      throw new $c_Ljava_time_zone_ZoneRulesException(((("Unable to register zone as one already registered with that ID: " + zoneId) + ", currently loading from provider: ") + provider))
    }
  }
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider$() {
  this.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1 = false;
  this.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1 = false;
  $n_Ljava_time_zone_ZoneRulesProvider$ = this;
  $m_Ljava_time_zone_ZoneRulesInitializer$().initialize__V()
}
$c_Ljava_time_zone_ZoneRulesProvider$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesProvider$.prototype = $c_Ljava_time_zone_ZoneRulesProvider$.prototype;
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getAvailableZoneIds__ju_Set = (function() {
  var this$1 = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map(this);
  var a = new $c_ju_HashMap$KeySet(this$1);
  return new $c_ju_Collections$UnmodifiableSet(a)
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getRules__T__Z__Ljava_time_zone_ZoneRules = (function(zoneId, forCaching) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  return $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider(this, zoneId).provideRules__T__Z__Ljava_time_zone_ZoneRules(zoneId, forCaching)
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.registerProvider__Ljava_time_zone_ZoneRulesProvider__V = (function(provider) {
  if ((provider === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "provider")
  };
  $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V(this, provider);
  $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList(this).add__O__Z(provider)
});
var $d_Ljava_time_zone_ZoneRulesProvider$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesProvider$: 0
}, false, "java.time.zone.ZoneRulesProvider$", {
  Ljava_time_zone_ZoneRulesProvider$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.$classData = $d_Ljava_time_zone_ZoneRulesProvider$;
var $n_Ljava_time_zone_ZoneRulesProvider$;
function $m_Ljava_time_zone_ZoneRulesProvider$() {
  if ((!$n_Ljava_time_zone_ZoneRulesProvider$)) {
    $n_Ljava_time_zone_ZoneRulesProvider$ = new $c_Ljava_time_zone_ZoneRulesProvider$()
  };
  return $n_Ljava_time_zone_ZoneRulesProvider$
}
/** @constructor */
function $c_ju_AbstractMap$() {
  /*<skip>*/
}
$c_ju_AbstractMap$.prototype = new $h_O();
$c_ju_AbstractMap$.prototype.constructor = $c_ju_AbstractMap$;
/** @constructor */
function $h_ju_AbstractMap$() {
  /*<skip>*/
}
$h_ju_AbstractMap$.prototype = $c_ju_AbstractMap$.prototype;
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z = (function(entry, other) {
  if ($is_ju_Map$Entry(other)) {
    var x2 = $as_ju_Map$Entry(other);
    var a = entry.getKey__O();
    var b = x2.getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = entry.getValue__O();
      var b$1 = x2.getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I = (function(entry) {
  var o = entry.getKey__O();
  var $$x1 = ((o === null) ? 0 : $dp_hashCode__I(o));
  var o$1 = entry.getValue__O();
  return ($$x1 ^ ((o$1 === null) ? 0 : $dp_hashCode__I(o$1)))
});
var $d_ju_AbstractMap$ = new $TypeData().initClass({
  ju_AbstractMap$: 0
}, false, "java.util.AbstractMap$", {
  ju_AbstractMap$: 1,
  O: 1
});
$c_ju_AbstractMap$.prototype.$classData = $d_ju_AbstractMap$;
var $n_ju_AbstractMap$;
function $m_ju_AbstractMap$() {
  if ((!$n_ju_AbstractMap$)) {
    $n_ju_AbstractMap$ = new $c_ju_AbstractMap$()
  };
  return $n_ju_AbstractMap$
}
/** @constructor */
function $c_ju_Arrays$() {
  /*<skip>*/
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
  /*<skip>*/
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  var evidence$3 = $m_s_math_Ordering$Int$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_I(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  var evidence$3 = $m_s_math_Ordering$Long$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_J(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  var evidence$3 = $m_s_math_Ordering$Short$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_S(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  var evidence$3 = $m_s_math_Ordering$Char$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_C(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  var evidence$3 = $m_s_math_Ordering$Byte$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_B(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var ord = ((comparator === null) ? new $c_ju_Arrays$$anon$1() : new $c_ju_Arrays$$anon$3(comparator));
  var end = array.u.length;
  if ((end > 16)) {
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(array, new $ac_O(array.u.length), 0, end, ord)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(array, 0, end, ord)
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var ord = ((comparator === null) ? new $c_ju_Arrays$$anon$1() : new $c_ju_Arrays$$anon$3(comparator));
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    array.get(fromIndex)
  };
  if ((toIndex > 0)) {
    array.get((((-1) + toIndex) | 0))
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(array, new $ac_O(array.u.length), fromIndex, toIndex, ord)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(array, fromIndex, toIndex, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V = (function(a, temp, start, end, ord) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, temp, start, middle, ord);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, temp, middle, end, ord);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ord.lteq__O__O__Z($m_sr_ScalaRunTime$().array_apply__O__I__O(a, leftInIndex), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, rightInIndex))))) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(temp, outIndex, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0)
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(temp, outIndex, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0)
      };
      outIndex = ((1 + outIndex) | 0)
    };
    temp.copyTo(start, a, start, length)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, start, end, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, start, end, ord) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, start), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + start) | 0))) > 0)) {
      var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, start);
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, start, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + start) | 0)));
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + start) | 0), temp)
    };
    var m = 2;
    while ((m < n)) {
      var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((start + m) | 0));
      if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
            iB = ix
          } else {
            iA = ix
          }
        };
        var ix$2 = ((iA + ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
          i = (((-1) + i) | 0)
        };
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next)
      };
      m = ((1 + m) | 0)
    }
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V = (function(a, temp, start, end, ord) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(a, temp, start, middle, ord);
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(a, temp, middle, end, ord);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ord.lteq__O__O__Z(a.get(leftInIndex), a.get(rightInIndex))))) {
        temp.set(outIndex, a.get(leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0)
      } else {
        temp.set(outIndex, a.get(rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0)
      };
      outIndex = ((1 + outIndex) | 0)
    };
    temp.copyTo(start, a, start, length)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(a, start, end, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V = (function(a, start, end, ord) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    if ((ord.compare__O__O__I(a.get(start), a.get(((1 + start) | 0))) > 0)) {
      var temp = a.get(start);
      a.set(start, a.get(((1 + start) | 0)));
      a.set(((1 + start) | 0), temp)
    };
    var m = 2;
    while ((m < n)) {
      var next = a.get(((start + m) | 0));
      if ((ord.compare__O__O__I(next, a.get((((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((ord.compare__O__O__I(next, a.get(ix)) < 0)) {
            iB = ix
          } else {
            iA = ix
          }
        };
        var ix$2 = ((iA + ((ord.compare__O__O__I(next, a.get(iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          a.set(i, a.get((((-1) + i) | 0)));
          i = (((-1) + i) | 0)
        };
        a.set(ix$2, next)
      };
      m = ((1 + m) | 0)
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = a.get(mid);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var ahi = key.RTLong__f_hi;
      if (((ahi === hi$1) ? (((-2147483648) ^ key.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi < hi$1))) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, new $c_RTLong(lo, hi))) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.get(mid);
      if ((key < elem)) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, elem)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AO__O__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var cmp = $dp_compareTo__O__I($as_jl_Comparable(key), a.get(mid));
      if ((cmp < 0)) {
        endIndex = mid
      } else if ((cmp === 0)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var t = a.get(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = b.get(i);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($bC(x), $bC(y)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AD__AD__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AF__AF__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AO__AO__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    a.get(fromIndex)
  };
  if ((toIndex > 0)) {
    a.get((((-1) + toIndex) | 0))
  };
  var i = fromIndex;
  while ((i !== toIndex)) {
    a.set(i, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = a.u.length;
  var i = 0;
  while ((i !== toIndex)) {
    a.set(i, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.fill__AO__I__I__O__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    a.get(fromIndex)
  };
  if ((toIndex > 0)) {
    a.get((((-1) + toIndex) | 0))
  };
  var i = fromIndex;
  while ((i !== toIndex)) {
    a.set(i, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  var tagT = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = tagT.newArray__I__O(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  var tag = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag(newType.getComponentType__jl_Class());
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = tag.newArray__I__O(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$FloatManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$DoubleManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$BooleanManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  var evidence$6 = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to))
  };
  var retLength = ((to - from) | 0);
  var b = ((original.u.length - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = evidence$6.newArray__I__O(retLength);
  original.copyTo(from, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$FloatManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$DoubleManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$BooleanManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.asList__AO__ju_List = (function(a) {
  return new $c_ju_Arrays$$anon$2(a)
});
$c_ju_Arrays$.prototype.hashCode__AJ__I = (function(a) {
  if ((a === null)) {
    return 0
  } else {
    var elem = 0;
    elem = 1;
    var end = a.u.length;
    var i = 0;
    while ((i < end)) {
      var arg1 = i;
      var $$x1 = elem;
      var t = a.get(arg1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      elem = ((Math.imul(31, $$x1) + (lo$1 ^ hi$1)) | 0);
      i = ((1 + i) | 0)
    };
    return elem
  }
});
$c_ju_Arrays$.prototype.hashCode__AO__I = (function(a) {
  if ((a === null)) {
    return 0
  } else {
    var elem = 0;
    elem = 1;
    var end = a.u.length;
    var i = 0;
    while ((i < end)) {
      var arg1 = i;
      var $$x1 = elem;
      var arg1$1 = a.get(arg1);
      elem = ((Math.imul(31, $$x1) + ((arg1$1 === null) ? 0 : $dp_hashCode__I(arg1$1))) | 0);
      i = ((1 + i) | 0)
    };
    return elem
  }
});
var $d_ju_Arrays$ = new $TypeData().initClass({
  ju_Arrays$: 0
}, false, "java.util.Arrays$", {
  ju_Arrays$: 1,
  O: 1
});
$c_ju_Arrays$.prototype.$classData = $d_ju_Arrays$;
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$()
  };
  return $n_ju_Arrays$
}
function $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List($thiz) {
  if (((((2 & $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.ju_Collections$__f_EMPTY_LIST = new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$2());
    $thiz.ju_Collections$__f_bitmap$0 = (((2 | $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.ju_Collections$__f_EMPTY_LIST
}
/** @constructor */
function $c_ju_Collections$() {
  this.ju_Collections$__f_EMPTY_SET = null;
  this.ju_Collections$__f_EMPTY_LIST = null;
  this.ju_Collections$__f_EMPTY_MAP = null;
  this.ju_Collections$__f_EMPTY_ITERATOR = null;
  this.ju_Collections$__f_EMPTY_LIST_ITERATOR = null;
  this.ju_Collections$__f_EMPTY_ENUMERATION = null;
  this.ju_Collections$__f_bitmap$0 = 0
}
$c_ju_Collections$.prototype = new $h_O();
$c_ju_Collections$.prototype.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
  /*<skip>*/
}
$h_ju_Collections$.prototype = $c_ju_Collections$.prototype;
$c_ju_Collections$.prototype.EMPTY_LIST__ju_List = (function() {
  return (((((2 & this.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0) ? $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List(this) : this.ju_Collections$__f_EMPTY_LIST)
});
$c_ju_Collections$.prototype.singletonList__O__ju_List = (function(o) {
  return new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$15(o))
});
var $d_ju_Collections$ = new $TypeData().initClass({
  ju_Collections$: 0
}, false, "java.util.Collections$", {
  ju_Collections$: 1,
  O: 1
});
$c_ju_Collections$.prototype.$classData = $d_ju_Collections$;
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$()
  };
  return $n_ju_Collections$
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)))
}
function $as_ju_Formattable(obj) {
  return (($is_ju_Formattable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Formattable"))
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)))
}
function $asArrayOf_ju_Formattable(obj, depth) {
  return (($isArrayOf_ju_Formattable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Formattable;", depth))
}
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I(new Int32Array([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)]))
}
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
  /*<skip>*/
}
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    return $as_T("00000000000000000000".substring(0, count))
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = (((-20) + remaining) | 0)
    };
    var $$x1 = result;
    var endIndex = remaining;
    return (("" + $$x1) + $as_T("00000000000000000000".substring(0, endIndex)))
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0
    } else {
      var $$x2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      var s$1 = $as_T(s.substring(beginIndex));
      var $$x1 = $$x2(s$1);
      var e = $uI($$x1)
    };
    var significandEnd = ((ePos < 0) ? $uI(s.length) : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      var unscaledValue = $as_T(s.substring(0, significandEnd));
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale)
    } else {
      var $$x3 = $as_T(s.substring(0, dotPos));
      var beginIndex$1 = ((1 + dotPos) | 0);
      var digits = (("" + $$x3) + $as_T(s.substring(beginIndex$1, significandEnd)));
      var digitsLen = $uI(digits.length);
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $$x4 = ((65535 & $uI(digits.charCodeAt(index))) === 48)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          i = ((1 + i) | 0)
        } else {
          break
        }
      };
      var beginIndex$2 = i;
      var unscaledValue$2 = $as_T(digits.substring(beginIndex$2));
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2)
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = x.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0)
  } else {
    var negative = ((65535 & $uI(unscaledValueWithSign.charCodeAt(0))) === 45);
    var unscaledValue = (negative ? $as_T(unscaledValueWithSign.substring(1)) : unscaledValueWithSign);
    var scale = x.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale)
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass({
  ju_Formatter$: 0
}, false, "java.util.Formatter$", {
  ju_Formatter$: 1,
  O: 1
});
$c_ju_Formatter$.prototype.$classData = $d_ju_Formatter$;
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$()
  };
  return $n_ju_Formatter$
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var digitsLen = $uI(digits.length);
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else if ((roundingPos >= digitsLen)) {
    return $thiz
  } else if (((65535 & $uI(digits.charCodeAt(roundingPos))) < 53)) {
    if ((roundingPos === 0)) {
      var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
      return new $c_ju_Formatter$Decimal(negative$1, "0", 0)
    } else {
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, $as_T(digits.substring(0, roundingPos)), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0))
    }
  } else {
    var lastNonNinePos = (((-1) + roundingPos) | 0);
    while (true) {
      if ((lastNonNinePos >= 0)) {
        var index = lastNonNinePos;
        var $$x1 = ((65535 & $uI(digits.charCodeAt(index))) === 57)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        lastNonNinePos = (((-1) + lastNonNinePos) | 0)
      } else {
        break
      }
    };
    if ((lastNonNinePos < 0)) {
      var newUnscaledValue = "1"
    } else {
      var endIndex = lastNonNinePos;
      var $$x2 = $as_T(digits.substring(0, endIndex));
      var index$1 = lastNonNinePos;
      var newUnscaledValue = (("" + $$x2) + $bC((65535 & ((1 + (65535 & $uI(digits.charCodeAt(index$1)))) | 0))))
    };
    var pos = ((1 + lastNonNinePos) | 0);
    var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
    return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale)
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale
}
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
  /*<skip>*/
}
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0")
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw new $c_jl_AssertionError("Decimal.round() called with non-positive precision")
  };
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision)
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = this.ju_Formatter$Decimal__f_unscaledValue;
  var roundingPos = (((($uI(this$1.length) + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = (rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw new $c_jl_AssertionError("roundAtPos returned a non-zero value with a scale too large")
  };
  return ((rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + rounded.ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - rounded.ju_Formatter$Decimal__f_scale) | 0))), newScale))
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")")
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass({
  ju_Formatter$Decimal: 0
}, false, "java.util.Formatter$Decimal", {
  ju_Formatter$Decimal: 1,
  O: 1
});
$c_ju_Formatter$Decimal.prototype.$classData = $d_ju_Formatter$Decimal;
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $p_ju_Locale__updateSpecialLanguages__T__T($thiz, l) {
  return ((l === "iw") ? "he" : ((l === "ji") ? "yi" : ((l === "in") ? "id" : l)))
}
function $p_ju_Locale__translateSpecialLanguages__T__T($thiz, l) {
  return ((l === "he") ? "iw" : ((l === "yi") ? "ji" : ((l === "id") ? "in" : l)))
}
function $p_ju_Locale__isEqual__ju_Locale__Z($thiz, l) {
  if (((($thiz.ju_Locale__f_language === l.getLanguage__T()) && ($thiz.ju_Locale__f_country === l.getCountry__T())) && ($thiz.ju_Locale__f_variant === l.ju_Locale__f_variant))) {
    var this$1 = $thiz.ju_Locale__f_script;
    if (this$1.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$1.get__O();
      var _$13 = $as_T(arg1);
      var $$x1 = (_$13 === l.getScript__T())
    }
  } else {
    var $$x1 = false
  };
  if ((($$x1 && $thiz.ju_Locale__f_extensions.forall__F1__Z(new $c_sjsr_AnonFunction1(((l$3) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var k = $uC(x$1$1._1__O());
      var v = $as_T(x$1$1._2__O());
      return (l$3.getExtension__C__T(k) === v)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(l)))) && $thiz.ju_Locale__f_unicodeExtensions.forall__F1__Z(new $c_sjsr_AnonFunction1(((l$4) => ((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    if ((x$1$3 !== null)) {
      var k$1 = $as_T(x$1$3._1__O());
      var v$1 = $as_T(x$1$3._2__O());
      return (l$4.getUnicodeLocaleType__T__T(k$1) === v$1)
    };
    throw new $c_s_MatchError(x$1$3)
  }))(l))))) {
    var x = $thiz.ju_Locale__f_unicodeAttributes;
    var this$2 = $m_s_jdk_CollectionConverters$();
    var s = l.getUnicodeLocaleAttributes__ju_Set();
    var x$2 = new $c_sc_convert_AsScalaExtensions$SetHasAsScala(this$2, s).asScala__scm_Set();
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
}
/** @constructor */
function $c_ju_Locale(language, country, variant, script, _extensions, unicodeExtensions, unicodeAttributes, supportSpecialCases) {
  this.ju_Locale__f_language = null;
  this.ju_Locale__f_country = null;
  this.ju_Locale__f_variant = null;
  this.ju_Locale__f_script = null;
  this.ju_Locale__f_unicodeExtensions = null;
  this.ju_Locale__f_unicodeAttributes = null;
  this.ju_Locale__f_extensions = null;
  this.ju_Locale__f_language = language;
  this.ju_Locale__f_country = country;
  this.ju_Locale__f_variant = variant;
  this.ju_Locale__f_script = script;
  this.ju_Locale__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale__f_unicodeAttributes = unicodeAttributes;
  if ((((language === null) || (country === null)) || (variant === null))) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Null argument to constructor not allowed")
  };
  var x = new $c_T3(language, country, variant);
  var x$2 = new $c_T3("ja", "JP", "JP");
  if ((x.equals__O__Z(x$2) && supportSpecialCases)) {
    var $$x3 = $m_sc_Map$();
    var $$x2 = $m_sr_ScalaRunTime$();
    var self = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
    var xs = $as_sc_IterableOnce($$x3.apply__sci_Seq__O($$x2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $bC(self), "ca-japanese")]))));
    var $$x1 = $as_sc_Map(_extensions.concat__sc_IterableOnce__sc_IterableOps(xs))
  } else {
    var x$3 = new $c_T3(language, country, variant);
    var x$4 = new $c_T3("th", "TH", "TH");
    if ((x$3.equals__O__Z(x$4) && supportSpecialCases)) {
      var $$x5 = $m_sc_Map$();
      var $$x4 = $m_sr_ScalaRunTime$();
      var self$1 = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
      var xs$1 = $as_sc_IterableOnce($$x5.apply__sci_Seq__O($$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $bC(self$1), "nu-thai")]))));
      var $$x1 = $as_sc_Map(_extensions.concat__sc_IterableOnce__sc_IterableOps(xs$1))
    } else {
      var $$x1 = _extensions
    }
  };
  this.ju_Locale__f_extensions = $$x1
}
$c_ju_Locale.prototype = new $h_O();
$c_ju_Locale.prototype.constructor = $c_ju_Locale;
/** @constructor */
function $h_ju_Locale() {
  /*<skip>*/
}
$h_ju_Locale.prototype = $c_ju_Locale.prototype;
$c_ju_Locale.prototype.getLanguage__T = (function() {
  var this$1 = this.ju_Locale__f_language;
  return $p_ju_Locale__translateSpecialLanguages__T__T(this, $as_T(this$1.toLowerCase()))
});
$c_ju_Locale.prototype.getScript__T = (function() {
  var this$1 = this.ju_Locale__f_script;
  return $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()))
});
$c_ju_Locale.prototype.getCountry__T = (function() {
  var this$1 = this.ju_Locale__f_country;
  return $as_T(this$1.toUpperCase())
});
$c_ju_Locale.prototype.hasExtensions__Z = (function() {
  var this$1 = this.ju_Locale__f_extensions;
  if ((!this$1.isEmpty__Z())) {
    return true
  } else {
    var this$2 = this.ju_Locale__f_unicodeExtensions;
    return (!this$2.isEmpty__Z())
  }
});
$c_ju_Locale.prototype.getExtension__C__T = (function(key) {
  if ((key === $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION)) {
    var this$1 = this.ju_Locale__f_unicodeExtensions;
    var $$x1 = (!this$1.isEmpty__Z())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$2 = $as_sc_IterableOnceOps(this.ju_Locale__f_unicodeExtensions.collect__s_PartialFunction__O(new $c_ju_Locale$$anon$1()));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "-", "")
  } else {
    var this$4 = this.ju_Locale__f_extensions.get__O__s_Option($bC(key));
    $m_s_$less$colon$less$();
    return $as_T((this$4.isEmpty__Z() ? null : this$4.get__O()))
  }
});
$c_ju_Locale.prototype.getUnicodeLocaleAttributes__ju_Set = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var s = this.ju_Locale__f_unicodeAttributes;
  return new $c_sc_convert_AsJavaExtensions$SetHasAsJava(this$1, s).asJava__ju_Set()
});
$c_ju_Locale.prototype.getUnicodeLocaleType__T__T = (function(key) {
  var this$2 = this.ju_Locale__f_unicodeExtensions.get__O__s_Option(key);
  $m_s_$less$colon$less$();
  return $as_T((this$2.isEmpty__Z() ? null : this$2.get__O()))
});
$c_ju_Locale.prototype.toString__T = (function() {
  var x = this.ju_Locale__f_variant;
  var hasVariant = (x !== "");
  var x$1 = this.getCountry__T();
  var hasCountry = (x$1 !== "");
  var x$2 = this.getLanguage__T();
  var hasLanguage = (x$2 !== "");
  var x$3 = this.getScript__T();
  var hasScript = (x$3 !== "");
  var countryPart = (hasCountry ? ("_" + this.getCountry__T()) : ((hasVariant || hasScript) ? "_" : ""));
  var variantPart = (hasVariant ? ("_" + this.ju_Locale__f_variant) : (hasScript ? "_" : ""));
  var scriptPart = ((hasScript && this.hasExtensions__Z()) ? (("#" + this.getScript__T()) + "_") : (hasScript ? ("#" + this.getScript__T()) : (this.hasExtensions__Z() ? "_#" : "")));
  var this$9 = $as_sc_IterableOnceOps(this.ju_Locale__f_extensions.map__F1__O(new $c_sjsr_AnonFunction1(((x$1$1) => {
    var x$1$2 = $as_T2(x$1$1);
    if ((x$1$2 !== null)) {
      var x$4 = $uC(x$1$2._1__O());
      var v = $as_T(x$1$2._2__O());
      return (($bC(x$4) + "-") + v)
    };
    throw new $c_s_MatchError(x$1$2)
  }))));
  var extensionsPart = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "", "", "");
  return ((hasLanguage || hasCountry) ? ((((this.getLanguage__T() + countryPart) + variantPart) + scriptPart) + extensionsPart) : "")
});
$c_ju_Locale.prototype.toLanguageTag__T = (function() {
  var x = this.getLanguage__T();
  if (((x !== "") && $m_ju_Locale$().checkLanguage__T__Z(this.getLanguage__T()))) {
    var language = $p_ju_Locale__updateSpecialLanguages__T__T(this, this.getLanguage__T())
  } else {
    var language = "und"
  };
  var country = ($m_ju_Locale$().checkRegion__T__Z(this.getCountry__T()) ? ("-" + this.getCountry__T()) : "");
  var this$3 = this.ju_Locale__f_variant;
  var variantSegments = $f_T__split__T__I__AT(this$3, "-|_", 0);
  _return: {
    var i = 0;
    while ((i < variantSegments.u.length)) {
      var arg1 = variantSegments.get(i);
      var l = $as_T(arg1);
      if ((!$m_ju_Locale$().checkVariantSegment__T__Z(l))) {
        var allSegmentsWellFormed = false;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var allSegmentsWellFormed = true
  };
  _return$1: {
    var i$1 = 0;
    while ((i$1 < variantSegments.u.length)) {
      var arg1$1 = variantSegments.get(i$1);
      var l$1 = $as_T(arg1$1);
      if ((!$m_ju_Locale$().checkAcceptableVariantSegment__T__Z(l$1))) {
        var allAcceptableSegments = false;
        break _return$1
      };
      i$1 = ((1 + i$1) | 0)
    };
    var allAcceptableSegments = true
  };
  if (allSegmentsWellFormed) {
    var this$8 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(variantSegments);
    var variant = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "-", "-", "")
  } else if (allAcceptableSegments) {
    var evidence$1 = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(variantSegments).getComponentType__jl_Class());
    var res1 = new $c_scm_ArrayBuilder$generic(evidence$1.runtimeClass__jl_Class());
    var evidence$1$1 = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(variantSegments).getComponentType__jl_Class());
    var res2 = new $c_scm_ArrayBuilder$generic(evidence$1$1.runtimeClass__jl_Class());
    var i$2 = 0;
    while ((i$2 < variantSegments.u.length)) {
      var x$1 = variantSegments.get(i$2);
      var l$2 = $as_T(x$1);
      if ($m_ju_Locale$().checkVariantSegment__T__Z(l$2)) {
        var this$17 = res1
      } else {
        var this$17 = res2
      };
      this$17.addOne__O__scm_ArrayBuilder$generic(x$1);
      i$2 = ((1 + i$2) | 0)
    };
    var _1 = res1.result__O();
    var _2 = res2.result__O();
    var wellFormed = $asArrayOf_T(_1, 1);
    var acceptable = $asArrayOf_T(_2, 1);
    var \u03b41$___1 = wellFormed;
    var \u03b41$___2 = acceptable;
    var wellFormed$2 = $asArrayOf_T(\u03b41$___1, 1);
    var acceptable$2 = $asArrayOf_T(\u03b41$___2, 1);
    if ((wellFormed$2.u.length !== 0)) {
      var this$23 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O($m_sc_ArrayOps$().slice$extension__O__I__I__O(wellFormed$2, 0, 1), 1));
      var pre = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$23, "-", "-", "-")
    } else {
      var pre = "-"
    };
    var $$x1 = $m_s_Predef$();
    var xs = $m_sc_ArrayOps$().drop$extension__O__I__O(wellFormed$2, 1);
    var this$29 = $m_s_Array$();
    var newLength = ((acceptable$2.u.length + $m_sr_ScalaRunTime$().array_length__O__I(xs)) | 0);
    if ($d_T.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(acceptable$2).getComponentType__jl_Class())) {
      var dest$1 = ($d_T.getClassOf().isPrimitive__Z() ? this$29.copyOf__O__I__O(acceptable$2, newLength) : $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(acceptable$2, newLength, $d_T.getArrayOf().getClassOf()))
    } else {
      var dest = new ($d_T.getArrayOf().constr)(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(acceptable$2, 0, dest, 0, acceptable$2.u.length);
      var dest$1 = dest
    };
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest$1, acceptable$2.u.length, $m_sr_ScalaRunTime$().array_length__O__I(xs));
    var this$31 = $$x1.wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O(dest$1, 1));
    var variant = ((pre + "x-lvariant") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$31, "-", "-", ""))
  } else {
    var variant = ""
  };
  var this$32 = this.ju_Locale__f_extensions;
  if ((!this$32.isEmpty__Z())) {
    var this$33 = $as_sc_IterableOnceOps(this.ju_Locale__f_extensions.map__F1__O(new $c_sjsr_AnonFunction1(((x$1$1) => {
      var x$1$2 = $as_T2(x$1$1);
      if ((x$1$2 !== null)) {
        var x$2 = $uC(x$1$2._1__O());
        var v = $as_T(x$1$2._2__O());
        return (($bC(x$2) + "-") + v)
      };
      throw new $c_s_MatchError(x$1$2)
    }))));
    var ext = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$33, "-", "-", "")
  } else {
    var ext = ""
  };
  var this$34 = this.ju_Locale__f_script;
  if (this$34.isEmpty__Z()) {
    var this$35 = $m_s_None$()
  } else {
    var arg1$2 = this$34.get__O();
    $as_T(arg1$2);
    var this$35 = new $c_s_Some(("-" + this.getScript__T()))
  };
  var script = $as_T((this$35.isEmpty__Z() ? "" : this$35.get__O()));
  return ((((this.getLanguage__T() === "no") && (this.getCountry__T() === "NO")) && (this.ju_Locale__f_variant === "NY")) ? "nn-NO" : ((((("" + language) + script) + country) + ext) + variant))
});
$c_ju_Locale.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_ju_Locale)) {
    var l = $as_ju_Locale(x);
    return $p_ju_Locale__isEqual__ju_Locale__Z(this, l)
  } else {
    return false
  }
});
$c_ju_Locale.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.toLanguageTag__T())
});
function $as_ju_Locale(obj) {
  return (((obj instanceof $c_ju_Locale) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale"))
}
function $isArrayOf_ju_Locale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale)))
}
function $asArrayOf_ju_Locale(obj, depth) {
  return (($isArrayOf_ju_Locale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale;", depth))
}
var $d_ju_Locale = new $TypeData().initClass({
  ju_Locale: 0
}, false, "java.util.Locale", {
  ju_Locale: 1,
  O: 1
});
$c_ju_Locale.prototype.$classData = $d_ju_Locale;
/** @constructor */
function $c_ju_Locale$() {
  this.ju_Locale$__f_ENGLISH$lzy1 = null;
  this.ju_Locale$__f_ENGLISHbitmap$1 = false;
  this.ju_Locale$__f_FRENCH$lzy1 = null;
  this.ju_Locale$__f_FRENCHbitmap$1 = false;
  this.ju_Locale$__f_GERMAN$lzy1 = null;
  this.ju_Locale$__f_GERMANbitmap$1 = false;
  this.ju_Locale$__f_ITALIAN$lzy1 = null;
  this.ju_Locale$__f_ITALIANbitmap$1 = false;
  this.ju_Locale$__f_JAPANESE$lzy1 = null;
  this.ju_Locale$__f_JAPANESEbitmap$1 = false;
  this.ju_Locale$__f_KOREAN$lzy1 = null;
  this.ju_Locale$__f_KOREANbitmap$1 = false;
  this.ju_Locale$__f_CHINESE$lzy1 = null;
  this.ju_Locale$__f_CHINESEbitmap$1 = false;
  this.ju_Locale$__f_SIMPLIFIED_CHINESE$lzy1 = null;
  this.ju_Locale$__f_SIMPLIFIED_CHINESEbitmap$1 = false;
  this.ju_Locale$__f_TRADITIONAL_CHINESE$lzy1 = null;
  this.ju_Locale$__f_TRADITIONAL_CHINESEbitmap$1 = false;
  this.ju_Locale$__f_FRANCE$lzy1 = null;
  this.ju_Locale$__f_FRANCEbitmap$1 = false;
  this.ju_Locale$__f_GERMANY$lzy1 = null;
  this.ju_Locale$__f_GERMANYbitmap$1 = false;
  this.ju_Locale$__f_ITALY$lzy1 = null;
  this.ju_Locale$__f_ITALYbitmap$1 = false;
  this.ju_Locale$__f_JAPAN$lzy1 = null;
  this.ju_Locale$__f_JAPANbitmap$1 = false;
  this.ju_Locale$__f_KOREA$lzy1 = null;
  this.ju_Locale$__f_KOREAbitmap$1 = false;
  this.ju_Locale$__f_CHINA$lzy1 = null;
  this.ju_Locale$__f_CHINAbitmap$1 = false;
  this.ju_Locale$__f_PRC$lzy1 = null;
  this.ju_Locale$__f_PRCbitmap$1 = false;
  this.ju_Locale$__f_TAIWAN$lzy1 = null;
  this.ju_Locale$__f_TAIWANbitmap$1 = false;
  this.ju_Locale$__f_UK$lzy1 = null;
  this.ju_Locale$__f_UKbitmap$1 = false;
  this.ju_Locale$__f_US$lzy1 = null;
  this.ju_Locale$__f_USbitmap$1 = false;
  this.ju_Locale$__f_CANADA$lzy1 = null;
  this.ju_Locale$__f_CANADAbitmap$1 = false;
  this.ju_Locale$__f_CANADA_FRENCH$lzy1 = null;
  this.ju_Locale$__f_CANADA_FRENCHbitmap$1 = false;
  this.ju_Locale$__f_ROOT$lzy1 = null;
  this.ju_Locale$__f_ROOTbitmap$1 = false;
  this.ju_Locale$__f_PRIVATE_USE_EXTENSION = 0;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 0;
  this.ju_Locale$__f_defaultLocale = null;
  this.ju_Locale$__f_defaultPerCategory = null;
  $n_ju_Locale$ = this;
  this.ju_Locale$__f_PRIVATE_USE_EXTENSION = 120;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 117;
  this.ju_Locale$__f_defaultLocale = $m_Llocales_DefaultLocale$().platformLocale__ju_Locale();
  var $$x10 = $m_s_Predef$();
  var xs = $m_ju_Locale$Category$().values__Aju_Locale$Category();
  var f = ((this$2) => ((_$5) => {
    var _$5$1 = $as_ju_Locale$Category(_$5);
    var value = this$2.ju_Locale$__f_defaultLocale;
    var y = new $c_s_Some(value);
    return $ct_T2__O__O__(new $c_T2(), _$5$1, y)
  }))(this);
  var len = xs.u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $$x1 = i;
        var arg1 = xs.get(i);
        ys.set($$x1, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $$x2 = i;
        var arg1$1 = x3.get(i);
        ys.set($$x2, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$2 = x4.get(i);
        ys.set($$x3, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $$x4 = i;
        var t = x5.get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $$x5 = i;
        var arg1$3 = x6.get(i);
        ys.set($$x5, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$4 = x7.get(i);
        ys.set($$x6, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$5 = x8.get(i);
        ys.set($$x7, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$6 = x9.get(i);
        ys.set($$x8, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$7 = x10.get(i);
        ys.set($$x9, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  var this$9 = $$x10.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  $m_s_$less$colon$less$();
  this.ju_Locale$__f_defaultPerCategory = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$9)
}
$c_ju_Locale$.prototype = new $h_O();
$c_ju_Locale$.prototype.constructor = $c_ju_Locale$;
/** @constructor */
function $h_ju_Locale$() {
  /*<skip>*/
}
$h_ju_Locale$.prototype = $c_ju_Locale$.prototype;
$c_ju_Locale$.prototype.ROOT__ju_Locale = (function() {
  if ((!this.ju_Locale$__f_ROOTbitmap$1)) {
    this.ju_Locale$__f_ROOT$lzy1 = $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root.toLocale__ju_Locale();
    this.ju_Locale$__f_ROOTbitmap$1 = true
  };
  return this.ju_Locale$__f_ROOT$lzy1
});
$c_ju_Locale$.prototype.checkRegex__s_util_matching_Regex__T__Z = (function(regex, s) {
  if ((s !== null)) {
    var x32 = regex.unapplySeq__jl_CharSequence__s_Option(s);
    if ((!x32.isEmpty__Z())) {
      var x33 = $as_sci_List(x32.get__O());
      if ((x33.lengthCompare__I__I(0) === 0)) {
        return true
      }
    }
  };
  return false
});
$c_ju_Locale$.prototype.checkLanguage__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2,8}", $m_sci_Nil$()), l)
});
$c_ju_Locale$.prototype.checkScript__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{4}", $m_sci_Nil$()), l)
});
$c_ju_Locale$.prototype.checkRegion__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9]{3}", $m_sci_Nil$()), l))
});
$c_ju_Locale$.prototype.checkAcceptableVariantSegment__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{1,8}", $m_sci_Nil$()), l)
});
$c_ju_Locale$.prototype.checkVariantSegment__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9][0-9a-zA-Z]{3}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{5,8}", $m_sci_Nil$()), l))
});
$c_ju_Locale$.prototype.checkVariant__T__Z = (function(l) {
  var parts = $f_T__split__T__I__AT(l, "-|_", 0);
  var i = 0;
  while ((i < parts.u.length)) {
    var arg1 = parts.get(i);
    var l$1 = $as_T(arg1);
    if ((!this.checkVariantSegment__T__Z(l$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_ju_Locale$ = new $TypeData().initClass({
  ju_Locale$: 0
}, false, "java.util.Locale$", {
  ju_Locale$: 1,
  O: 1
});
$c_ju_Locale$.prototype.$classData = $d_ju_Locale$;
var $n_ju_Locale$;
function $m_ju_Locale$() {
  if ((!$n_ju_Locale$)) {
    $n_ju_Locale$ = new $c_ju_Locale$()
  };
  return $n_ju_Locale$
}
/** @constructor */
function $c_ju_Locale$Builder() {
  this.ju_Locale$Builder__f_builder = null;
  var language = $m_s_None$();
  var region = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var extensions = $as_sc_Map($m_sc_Map$().empty__O());
  var unicodeExtensions = $as_sc_Map($m_sc_Map$().empty__O());
  var unicodeAttributes = $as_sc_Set($m_sc_Set$().empty__O());
  this.ju_Locale$Builder__f_builder = new $c_ju_Locale$LocaleBuilder(true, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes)
}
$c_ju_Locale$Builder.prototype = new $h_O();
$c_ju_Locale$Builder.prototype.constructor = $c_ju_Locale$Builder;
/** @constructor */
function $h_ju_Locale$Builder() {
  /*<skip>*/
}
$h_ju_Locale$Builder.prototype = $c_ju_Locale$Builder.prototype;
$c_ju_Locale$Builder.prototype.setLanguage__T__ju_Locale$Builder = (function(language) {
  var this$1 = this.ju_Locale$Builder__f_builder.language__T__s_Option(language);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid language " + language))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setScript__T__ju_Locale$Builder = (function(script) {
  var this$1 = this.ju_Locale$Builder__f_builder.script__T__s_Option(script);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid script " + script))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setRegion__T__ju_Locale$Builder = (function(region) {
  var this$1 = this.ju_Locale$Builder__f_builder.region__T__s_Option(region);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid region " + region))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setVariant__T__ju_Locale$Builder = (function(variant) {
  var this$1 = this.ju_Locale$Builder__f_builder.variant__T__s_Option(variant);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid variant " + variant))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.build__ju_Locale = (function() {
  return this.ju_Locale$Builder__f_builder.build__ju_Locale()
});
var $d_ju_Locale$Builder = new $TypeData().initClass({
  ju_Locale$Builder: 0
}, false, "java.util.Locale$Builder", {
  ju_Locale$Builder: 1,
  O: 1
});
$c_ju_Locale$Builder.prototype.$classData = $d_ju_Locale$Builder;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)))
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"))
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)))
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth))
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)))
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"))
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)))
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth))
}
function $is_ju_RandomAccess(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_RandomAccess)))
}
function $as_ju_RandomAccess(obj) {
  return (($is_ju_RandomAccess(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.RandomAccess"))
}
function $isArrayOf_ju_RandomAccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_RandomAccess)))
}
function $asArrayOf_ju_RandomAccess(obj, depth) {
  return (($isArrayOf_ju_RandomAccess(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.RandomAccess;", depth))
}
function $p_ju_TimeZone$__offsetInMillis$1__I($thiz) {
  var browserDate = new Date();
  return Math.imul(1000, Math.imul(60, $doubleToInt($uD(browserDate.getTimezoneOffset()))))
}
function $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz) {
  try {
    var browserDate = new Date();
    var $$x1 = $m_sc_StringOps$();
    var x = $as_T(browserDate.toTimeString());
    var x$1 = $$x1.split$extension__T__C__AT(x, 32).get(1);
    _return: {
      var len = $uI(x$1.length);
      var i = 0;
      while ((i < len)) {
        var index = i;
        var arg1 = (65535 & $uI(x$1.charCodeAt(index)));
        if ((arg1 === 32)) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var x1 = (-1)
    };
    return new $c_s_util_Success(((x1 === (-1)) ? x$1 : $as_T(x$1.substring(0, x1))))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
}
function $p_ju_TimeZone$__timeZone$1__T($thiz) {
  try {
    var x = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    var $$x1 = new $c_s_util_Success($as_T(((x === (void 0)) ? $as_T($p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz).getOrElse__F0__O(new $c_sjsr_AnonFunction0(((this$6) => (() => "UTC"))($thiz)))) : x)))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      matchEnd8: {
        var $$x1;
        if ((e$2 !== null)) {
          var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!o11.isEmpty__Z())) {
            var e$3 = $as_jl_Throwable(o11.get__O());
            var $$x1 = new $c_s_util_Failure(e$3);
            break matchEnd8
          }
        };
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
      }
    } else {
      var $$x1;
      throw e
    }
  };
  return $as_T($$x1.orElse__F0__s_util_Try(new $c_sjsr_AnonFunction0(((this$2$1) => (() => $p_ju_TimeZone$__browserTZ$1__s_util_Try(this$2$1)))($thiz))).getOrElse__F0__O(new $c_sjsr_AnonFunction0(((this$3$1) => (() => "UTC"))($thiz))))
}
/** @constructor */
function $c_ju_TimeZone$() {
  this.ju_TimeZone$__f_default = null;
  $n_ju_TimeZone$ = this;
  this.ju_TimeZone$__f_default = new $c_ju_SimpleTimeZone($p_ju_TimeZone$__offsetInMillis$1__I(this), $p_ju_TimeZone$__timeZone$1__T(this))
}
$c_ju_TimeZone$.prototype = new $h_O();
$c_ju_TimeZone$.prototype.constructor = $c_ju_TimeZone$;
/** @constructor */
function $h_ju_TimeZone$() {
  /*<skip>*/
}
$h_ju_TimeZone$.prototype = $c_ju_TimeZone$.prototype;
var $d_ju_TimeZone$ = new $TypeData().initClass({
  ju_TimeZone$: 0
}, false, "java.util.TimeZone$", {
  ju_TimeZone$: 1,
  O: 1
});
$c_ju_TimeZone$.prototype.$classData = $d_ju_TimeZone$;
var $n_ju_TimeZone$;
function $m_ju_TimeZone$() {
  if ((!$n_ju_TimeZone$)) {
    $n_ju_TimeZone$ = new $c_ju_TimeZone$()
  };
  return $n_ju_TimeZone$
}
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex)
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var value = m[1];
    if ((value !== (void 0))) {
      var chars = $as_T(value);
      var end = $uI(chars.length);
      var i = 0;
      while ((i < end)) {
        var arg1 = i;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags | $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I((65535 & $uI(chars.charCodeAt(arg1)))));
        i = ((1 + i) | 0)
      }
    };
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
    };
    var value$1 = m[2];
    if ((value$1 !== (void 0))) {
      var chars$3 = $as_T(value$1);
      var end$1 = $uI(chars$3.length);
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var arg1$1 = i$1;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags & (~$m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I((65535 & $uI(chars$3.charCodeAt(arg1$1))))));
        i$1 = ((1 + i$1) | 0)
      }
    };
    var $$x1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var value$2 = m[0];
    if ((value$2 === (void 0))) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
    };
    var this$19 = $as_T(value$2);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($$x1 + $uI(this$19.length)) | 0)
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var len = $uI(s.length);
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I(s, i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0)
  };
  return result
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((cp >= 65) && (cp <= 90)) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((cp >= 97) && (cp <= 122)) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + cp) | 0))) + s) + "]") : s)))
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s)
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = (65535 & $uI(pattern.charCodeAt(index)));
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break
        }
      }
    };
    break
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var repeaterDispatchChar = ((startOfRepeater === len) ? 46 : (65535 & $uI(pattern.charCodeAt(startOfRepeater))));
  if (((((repeaterDispatchChar === 63) || (repeaterDispatchChar === 42)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = (65535 & $uI(pattern.charCodeAt(index)));
      switch (x1) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater);
          break
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + compiledToken) + baseRepeater) + "?");
          break
        }
        default: {
          return (("" + compiledToken) + baseRepeater)
        }
      }
    } else {
      return (("" + compiledToken) + baseRepeater)
    }
  } else {
    return compiledToken
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var len = $uI(pattern.length);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x1 = true
    } else {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = (!((c >= 48) && (c <= 57)))
    };
    if ($$x1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = (65535 & $uI(pattern.charCodeAt(index$1)));
        var $$x2 = ((c$1 >= 48) && (c$1 <= 57))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
      } else {
        break
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if (((65535 & $uI(pattern.charCodeAt(index$2))) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = (65535 & $uI(pattern.charCodeAt(index$3)));
          var $$x3 = ((c$2 >= 48) && (c$2 <= 57))
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
        } else {
          break
        }
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x4 = true
    } else {
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $$x4 = ((65535 & $uI(pattern.charCodeAt(index$4))) !== 125)
    };
    if ($$x4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  var endIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  return $as_T(pattern.substring(startOfRepeater, endIndex))
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length);
  var i = 0;
  while ((i < end)) {
    var arg1 = i;
    var mapped = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[arg1]);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[arg1] = ((1 + mapped) | 0)
    };
    i = ((1 + i) | 0)
  };
  var amendedToken = $as_T(compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg$outer, compiledGroupCountBeforeThisToken$1) => ((arg1$2, arg2$2, arg3$2) => {
    var arg1$1 = $as_T(arg1$2);
    var arg2 = $as_T(arg2$2);
    var arg3 = $as_T(arg3$2);
    return arg$outer.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T(arg1$1, arg2, arg3, compiledGroupCountBeforeThisToken$1)
  }))($thiz, compiledGroupCountBeforeThisToken)));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")")
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern")
  };
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = (65535 & $uI(pattern.charCodeAt(index)));
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 1: {
          return (("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 2: {
          return (("[" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break
        }
        default: {
          throw new $c_s_MatchError(x1$2)
        }
      };
      break
    }
    case 98: {
      var beginIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var endIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($as_T(pattern.substring(beginIndex, endIndex)) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported")
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b"
      };
      break
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B"
      };
      break
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:^)";
      break
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:$)";
      break
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var index$1 = end;
          var c = (65535 & $uI(pattern.charCodeAt(index$1)));
          var $$x2 = ((c >= 48) && (c <= 57))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var endIndex$1 = ((1 + end) | 0);
          var s = $as_T(pattern.substring(start, endIndex$1));
          var $$x1 = ($uI(parseInt(s, 10)) <= (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          end = ((1 + end) | 0)
        } else {
          break
        }
      };
      var endIndex$2 = end;
      var groupString = $as_T(pattern.substring(start, endIndex$2));
      var groupNumber = $uI(parseInt(groupString, 10));
      if ((groupNumber > (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"))
      };
      var compiledGroupNumber = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $$x3 = true
      } else {
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $$x3 = ((65535 & $uI(pattern.charCodeAt(index$2))) !== 60)
      };
      if ($$x3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      var x1 = ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, groupName)) ? new $c_s_Some(dict[groupName]) : $m_s_None$());
      if ((!(x1 instanceof $c_s_Some))) {
        var x = $m_s_None$();
        if ((x === x1)) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"))
        };
        throw new $c_s_MatchError(x1)
      };
      var x2 = $as_s_Some(x1);
      var v = x2.s_Some__f_value;
      var groupNumber$2 = $uI(v);
      var compiledGroupNumber$2 = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var end$2 = $uI(pattern.indexOf("\\E", start$2));
      if ((end$2 < 0)) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = $uI(pattern.length);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2)))
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2, end$2)))
      };
      break
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz))
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === $uI(pattern.length))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence")
      };
      var cp = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break
    }
    default: {
      if ((((x1 >= 65) && (x1 <= 90)) || ((x1 >= 97) && (x1 <= 122)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var index = ((1 + start) | 0);
    var d1 = (((-48) + (65535 & $uI(pattern.charCodeAt(index)))) | 0)
  } else {
    var d1 = (-1)
  };
  if (((d1 < 0) || (d1 > 7))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence")
  };
  if ((((2 + start) | 0) < len)) {
    var index$1 = ((2 + start) | 0);
    var d2 = (((-48) + (65535 & $uI(pattern.charCodeAt(index$1)))) | 0)
  } else {
    var d2 = (-1)
  };
  if (((d2 < 0) || (d2 > 7))) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0)
  } else {
    if ((((3 + start) | 0) < len)) {
      var index$2 = ((3 + start) | 0);
      var d3 = (((-48) + (65535 & $uI(pattern.charCodeAt(index$2)))) | 0)
    } else {
      var d3 = (-1)
    };
    if (((d3 < 0) || (d3 > 7))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0)
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (((start !== len) && ((65535 & $uI(pattern.charCodeAt(start))) === 123))) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = $uI(pattern.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence")
    };
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && ($as_T(pattern.substring(end, lowStart)) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low))
    } else {
      return codeUnit
    }
  } else {
    return codeUnit
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  if (((start === end) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
  };
  var i = start;
  while ((i < end)) {
    var arg1 = i;
    var c = (65535 & $uI(pattern.charCodeAt(arg1)));
    if ((!((((c >= 48) && (c <= 57)) || ((c >= 65) && (c <= 70))) || ((c >= 97) && (c <= 102))))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
    };
    i = ((1 + i) | 0)
  };
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112
  } else {
    var s = $as_T(pattern.substring(start, end));
    var cp = $uI(parseInt(s, 16))
  };
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big")
  };
  return cp
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break
    }
    default: {
      var positive;
      throw new $c_s_MatchError($bC(dispatchChar))
    }
  };
  return ((dispatchChar >= 97) ? positive : positive.negated__ju_regex_PatternCompiler$CompiledCharClass())
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?"
  } else if (((65535 & $uI(pattern.charCodeAt(start))) === 123)) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = $uI(pattern.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family")
    };
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
    var property = $as_T(pattern.substring(innerStart, innerEnd))
  } else {
    var endIndex = ((1 + start) | 0);
    var property = $as_T(pattern.substring(start, endIndex))
  };
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, property)))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018")
  };
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$1, property2)))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + property2))
  };
  var result = $as_ju_regex_PatternCompiler$CompiledCharClass(dict$1[property2]);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = ((65535 & $uI(pattern.charCodeAt(index))) === 94)
  } else {
    var isNegated = false
  };
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $$x1 = ((65535 & $uI(pattern.charCodeAt(index$1))) === 38)
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V()
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder)
          };
          break matchResult;
          break
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence")
          };
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = (65535 & $uI(pattern.charCodeAt(index$2)));
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = $uI(pattern.indexOf("\\E", fromIndex));
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
              };
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder)
            }
          };
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder)
    }
  };
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $$x1 = true
  } else {
    var index = ((1 + start) | 0);
    var $$x1 = ((65535 & $uI(pattern.charCodeAt(index))) !== 63)
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
    };
    var index$1 = ((2 + start) | 0);
    var c1 = (65535 & $uI(pattern.charCodeAt(index$1)));
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      var endIndex = ((3 + start) | 0);
      return ((("" + $as_T(pattern.substring(start, endIndex))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
      };
      var index$2 = ((3 + start) | 0);
      var c2 = (65535 & $uI(pattern.charCodeAt(index$2)));
      if ((((c2 >= 65) && (c2 <= 90)) || ((c2 >= 97) && (c2 <= 122)))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"))
        };
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
      } else {
        if (((c2 !== 61) && (c2 !== 33))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group")
        };
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018")
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")")
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported")
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = ((((c >= 65) && (c <= 90)) || ((c >= 97) && (c <= 122))) || ((c >= 48) && (c <= 57)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $$x2 = true
  } else {
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x2 = ((65535 & $uI(pattern.charCodeAt(index$1))) !== 62)
  };
  if ($$x2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'")
  };
  var endIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  return $as_T(pattern.substring(start, endIndex))
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz)
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x1 = ((65535 & $uI(pattern$3.charCodeAt(index))) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz)
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
    };
    var cpEnd = $f_T__codePointAt__I__I(pattern$3, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      builder$1.addSingleCodePoint__I__V(startCodePoint);
      builder$1.addSingleCodePoint__I__V(45)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range")
      };
      builder$1.addCodePointRange__I__I__V(startCodePoint, endCodePoint)
    }
  } else {
    builder$1.addSingleCodePoint__I__V(startCodePoint)
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = {}
}
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
  };
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this)
  };
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported")
  };
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018")
  };
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018")
  };
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern)
  } else {
    var this$5 = this.ju_regex_PatternCompiler__f_pattern;
    var beginIndex = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var endIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (($as_T(this$5.substring(beginIndex, endIndex)) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    };
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false)
  };
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (((-1) + $uI(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups)
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."))
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I(pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break
        }
      };
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "(?:^)";
          break
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "(?:$)";
          break
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP)
        }
      };
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken))
    }
  };
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group")
  };
  return result
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  }
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T = (function(str, backslashes, groupString, compiledGroupCountBeforeThisToken$1) {
  if (((($uI(backslashes.length) % 2) | 0) === 0)) {
    return str
  } else {
    var groupNumber = $uI(parseInt(groupString, 10));
    return ((groupNumber > compiledGroupCountBeforeThisToken$1) ? (("" + backslashes) + ((1 + groupNumber) | 0)) : str)
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass({
  ju_regex_PatternCompiler: 0
}, false, "java.util.regex.PatternCompiler", {
  ju_regex_PatternCompiler: 1,
  O: 1
});
$c_ju_regex_PatternCompiler.prototype.$classData = $d_ju_regex_PatternCompiler;
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 instanceof $c_sjs_js_JavaScriptException)) {
      return false
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$predefinedPCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$canonicalizedScriptNameCache = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  this.ju_regex_PatternCompiler$__f_bitmap$0 = 0;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var array = [$ct_T2__O__O__(new $c_T2(), "Lower", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z")), $ct_T2__O__O__(new $c_T2(), "Upper", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z")), $ct_T2__O__O__(new $c_T2(), "ASCII", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f")), $ct_T2__O__O__(new $c_T2(), "Alpha", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z")), $ct_T2__O__O__(new $c_T2(), "Digit", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9")), $ct_T2__O__O__(new $c_T2(), "Alnum", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z")), $ct_T2__O__O__(new $c_T2(), "Punct", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~")), $ct_T2__O__O__(new $c_T2(), "Graph", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~")), $ct_T2__O__O__(new $c_T2(), "Print", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~")), $ct_T2__O__O__(new $c_T2(), "Blank", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ")), $ct_T2__O__O__(new $c_T2(), "Cntrl", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f")), $ct_T2__O__O__(new $c_T2(), "XDigit", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f")), $ct_T2__O__O__(new $c_T2(), "Space", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r "))];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g")
}
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern()
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break
    }
    case 100: {
      return 1;
      break
    }
    case 109: {
      return 8;
      break
    }
    case 115: {
      return 32;
      break
    }
    case 117: {
      return 64;
      break
    }
    case 120: {
      return 4;
      break
    }
    case 85: {
      return 256;
      break
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag")
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"))
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return $as_T(String.fromCodePoint(codePoint))
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass({
  ju_regex_PatternCompiler$: 0
}, false, "java.util.regex.PatternCompiler$", {
  ju_regex_PatternCompiler$: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$.prototype.$classData = $d_ju_regex_PatternCompiler$;
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$()
  };
  return $n_ju_regex_PatternCompiler$
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt)
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"))
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")))
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((codePoint === 93) || (codePoint === 92)) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s)
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
}
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"))
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I(str, i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0)
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((codePoint >= 65) && (codePoint <= 90))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)))
    } else if (((codePoint >= 97) && (codePoint <= 122))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + codePoint) | 0)))
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $$x1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)))
    };
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $$x2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = (((-32) + start$2) | 0);
      var end$3 = (((-32) + end$2) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)))
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass({
  ju_regex_PatternCompiler$CharacterClassBuilder: 0
}, false, "java.util.regex.PatternCompiler$CharacterClassBuilder", {
  ju_regex_PatternCompiler$CharacterClassBuilder: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.$classData = $d_ju_regex_PatternCompiler$CharacterClassBuilder;
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true
  };
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data
}
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated)
});
function $as_ju_regex_PatternCompiler$CompiledCharClass(obj) {
  return (((obj instanceof $c_ju_regex_PatternCompiler$CompiledCharClass) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.PatternCompiler$CompiledCharClass"))
}
function $isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_PatternCompiler$CompiledCharClass)))
}
function $asArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (($isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.PatternCompiler$CompiledCharClass;", depth))
}
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass({
  ju_regex_PatternCompiler$CompiledCharClass: 0
}, false, "java.util.regex.PatternCompiler$CompiledCharClass", {
  ju_regex_PatternCompiler$CompiledCharClass: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.$classData = $d_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $c_Llocales_DefaultLocale$() {
  this.Llocales_DefaultLocale$__f_window$lzy1 = null;
  this.Llocales_DefaultLocale$__f_windowbitmap$1 = false
}
$c_Llocales_DefaultLocale$.prototype = new $h_O();
$c_Llocales_DefaultLocale$.prototype.constructor = $c_Llocales_DefaultLocale$;
/** @constructor */
function $h_Llocales_DefaultLocale$() {
  /*<skip>*/
}
$h_Llocales_DefaultLocale$.prototype = $c_Llocales_DefaultLocale$.prototype;
$c_Llocales_DefaultLocale$.prototype.window__Llocales_Window = (function() {
  if ((!this.Llocales_DefaultLocale$__f_windowbitmap$1)) {
    this.Llocales_DefaultLocale$__f_window$lzy1 = window;
    this.Llocales_DefaultLocale$__f_windowbitmap$1 = true
  };
  return this.Llocales_DefaultLocale$__f_window$lzy1
});
$c_Llocales_DefaultLocale$.prototype.platformLocale__ju_Locale = (function() {
  try {
    var value = $as_T(this.window__Llocales_Window().navigator.language);
    var lang = new $c_s_Some(value)
  } catch (e) {
    $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    var lang = $m_s_None$()
  };
  if (lang.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = lang.get__O();
    var key = $as_T(arg1);
    var $$x1 = $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_ldmls.contains__O__Z(key)
  };
  if ($$x1) {
    var this$2 = lang
  } else {
    var this$2 = $m_s_None$()
  };
  var l = $as_T((this$2.isEmpty__Z() ? "en" : this$2.get__O()));
  var this$3 = $m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option(l);
  return $as_ju_Locale((this$3.isEmpty__Z() ? $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root.toLocale__ju_Locale() : this$3.get__O()))
});
var $d_Llocales_DefaultLocale$ = new $TypeData().initClass({
  Llocales_DefaultLocale$: 0
}, false, "locales.DefaultLocale$", {
  Llocales_DefaultLocale$: 1,
  O: 1
});
$c_Llocales_DefaultLocale$.prototype.$classData = $d_Llocales_DefaultLocale$;
var $n_Llocales_DefaultLocale$;
function $m_Llocales_DefaultLocale$() {
  if ((!$n_Llocales_DefaultLocale$)) {
    $n_Llocales_DefaultLocale$ = new $c_Llocales_DefaultLocale$()
  };
  return $n_Llocales_DefaultLocale$
}
/** @constructor */
function $c_Llocales_LocalesDb$() {
  this.Llocales_LocalesDb$__f_provider = null;
  this.Llocales_LocalesDb$__f_root = null;
  this.Llocales_LocalesDb$__f_latn = null;
  this.Llocales_LocalesDb$__f_ldmls = null;
  this.Llocales_LocalesDb$__f_metadata = null;
  this.Llocales_LocalesDb$__f_currencydata = null;
  $n_Llocales_LocalesDb$ = this;
  var this$2 = $m_sjs_reflect_Reflect$().lookupLoadableModuleClass__T__s_Option("locales.cldr.data.LocalesProvider$");
  if (this$2.isEmpty__Z()) {
    var this$3 = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var m = $as_sjs_reflect_LoadableModuleClass(arg1);
    var this$3 = new $c_s_Some($as_Llocales_cldr_LocalesProvider(m.loadModule__O()))
  };
  this.Llocales_LocalesDb$__f_provider = $as_Llocales_cldr_LocalesProvider((this$3.isEmpty__Z() ? $m_Llocales_cldr_fallback_LocalesProvider$() : this$3.get__O()));
  this.Llocales_LocalesDb$__f_root = $m_Llocales_cldr_fallback_data_\uff3froot$();
  this.Llocales_LocalesDb$__f_latn = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  this.Llocales_LocalesDb$__f_ldmls = this.Llocales_LocalesDb$__f_provider.ldmls__sci_Map();
  this.Llocales_LocalesDb$__f_metadata = this.Llocales_LocalesDb$__f_provider.metadata__Llocales_cldr_CLDRMetadata();
  this.Llocales_LocalesDb$__f_currencydata = this.Llocales_LocalesDb$__f_provider.currencyData__Llocales_cldr_CurrencyData()
}
$c_Llocales_LocalesDb$.prototype = new $h_O();
$c_Llocales_LocalesDb$.prototype.constructor = $c_Llocales_LocalesDb$;
/** @constructor */
function $h_Llocales_LocalesDb$() {
  /*<skip>*/
}
$h_Llocales_LocalesDb$.prototype = $c_Llocales_LocalesDb$.prototype;
$c_Llocales_LocalesDb$.prototype.localeForLanguageTag__T__s_Option = (function(languageTag) {
  if ((languageTag === "und")) {
    var value = $m_ju_Locale$().ROOT__ju_Locale();
    return new $c_s_Some(value)
  } else {
    var this$2 = this.Llocales_LocalesDb$__f_provider.ldmls__sci_Map().get__O__s_Option(languageTag);
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var _$1 = $as_Llocales_cldr_LDML(arg1);
      return new $c_s_Some(_$1.toLocale__ju_Locale())
    }
  }
});
var $d_Llocales_LocalesDb$ = new $TypeData().initClass({
  Llocales_LocalesDb$: 0
}, false, "locales.LocalesDb$", {
  Llocales_LocalesDb$: 1,
  O: 1
});
$c_Llocales_LocalesDb$.prototype.$classData = $d_Llocales_LocalesDb$;
var $n_Llocales_LocalesDb$;
function $m_Llocales_LocalesDb$() {
  if ((!$n_Llocales_LocalesDb$)) {
    $n_Llocales_LocalesDb$ = new $c_Llocales_LocalesDb$()
  };
  return $n_Llocales_LocalesDb$
}
function $is_Llocales_cldr_LocalesProvider(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llocales_cldr_LocalesProvider)))
}
function $as_Llocales_cldr_LocalesProvider(obj) {
  return (($is_Llocales_cldr_LocalesProvider(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LocalesProvider"))
}
function $isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LocalesProvider)))
}
function $asArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LocalesProvider;", depth))
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = null;
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = false
}
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype;
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.all__ALlocales_cldr_LDML = (function() {
  if ((!this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1)) {
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = new ($d_Llocales_cldr_LDML.getArrayOf().constr)([$m_Llocales_cldr_fallback_data_\uff3fen$(), $m_Llocales_cldr_fallback_data_\uff3froot$()]);
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = true
  };
  return this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1
});
var $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 0
}, false, "locales.cldr.fallback.data._all_$", {
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 1,
  O: 1
});
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
var $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_numericsystems$() {
  this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = null;
  this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = false
}
$c_Llocales_cldr_fallback_data_numericsystems$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.constructor = $c_Llocales_cldr_fallback_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_numericsystems$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_numericsystems$.prototype = $c_Llocales_cldr_fallback_data_numericsystems$.prototype;
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  if ((!this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1)) {
    $m_s_package$();
    var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57])));
    var digits = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = new $c_Llocales_cldr_NumberingSystem("latn", digits);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = true
  };
  return this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1
});
var $d_Llocales_cldr_fallback_data_numericsystems$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_numericsystems$: 0
}, false, "locales.cldr.fallback.data.numericsystems$", {
  Llocales_cldr_fallback_data_numericsystems$: 1,
  O: 1
});
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.$classData = $d_Llocales_cldr_fallback_data_numericsystems$;
var $n_Llocales_cldr_fallback_data_numericsystems$;
function $m_Llocales_cldr_fallback_data_numericsystems$() {
  if ((!$n_Llocales_cldr_fallback_data_numericsystems$)) {
    $n_Llocales_cldr_fallback_data_numericsystems$ = new $c_Llocales_cldr_fallback_data_numericsystems$()
  };
  return $n_Llocales_cldr_fallback_data_numericsystems$
}
function $p_Lnet_timerboard_InputEffects$__affectInputElement__T__F1__F1__Ltyrian_Cmd($thiz, elementId, modifier, resultToMessage) {
  var observable = new $c_Lnet_timerboard_InputEffects$$anon$2(elementId, modifier);
  var this$3 = new $c_Ltyrian_Cmd$Run$ImcompleteRunCmd(observable);
  var observable$1 = this$3.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable;
  return new $c_Ltyrian_Cmd$Run(observable$1, resultToMessage)
}
/** @constructor */
function $c_Lnet_timerboard_InputEffects$() {
  /*<skip>*/
}
$c_Lnet_timerboard_InputEffects$.prototype = new $h_O();
$c_Lnet_timerboard_InputEffects$.prototype.constructor = $c_Lnet_timerboard_InputEffects$;
/** @constructor */
function $h_Lnet_timerboard_InputEffects$() {
  /*<skip>*/
}
$h_Lnet_timerboard_InputEffects$.prototype = $c_Lnet_timerboard_InputEffects$.prototype;
$c_Lnet_timerboard_InputEffects$.prototype.clear__T__F1__Ltyrian_Cmd = (function(elementId, resultToMessage) {
  return $p_Lnet_timerboard_InputEffects$__affectInputElement__T__F1__F1__Ltyrian_Cmd(this, elementId, new $c_sjsr_AnonFunction1(((this$1) => ((_$1) => {
    _$1.value = ""
  }))(this)), resultToMessage)
});
$c_Lnet_timerboard_InputEffects$.prototype.setContents__T__T__Ltyrian_Cmd = (function(elementId, value) {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0(((this$1, elementId$2, value$2) => (() => {
    document.getElementById(elementId$2).value = value$2
  }))(this, elementId, value)))
});
var $d_Lnet_timerboard_InputEffects$ = new $TypeData().initClass({
  Lnet_timerboard_InputEffects$: 0
}, false, "net.timerboard.InputEffects$", {
  Lnet_timerboard_InputEffects$: 1,
  O: 1
});
$c_Lnet_timerboard_InputEffects$.prototype.$classData = $d_Lnet_timerboard_InputEffects$;
var $n_Lnet_timerboard_InputEffects$;
function $m_Lnet_timerboard_InputEffects$() {
  if ((!$n_Lnet_timerboard_InputEffects$)) {
    $n_Lnet_timerboard_InputEffects$ = new $c_Lnet_timerboard_InputEffects$()
  };
  return $n_Lnet_timerboard_InputEffects$
}
function $p_Lnet_timerboard_MapData$__decodeMapData__F1($thiz) {
  $m_Ltyrian_http_Http$Decoder$();
  var decoder = new $c_sjsr_AnonFunction1(((this$1) => ((response) => {
    var response$1 = $as_Ltyrian_http_Response(response);
    var json = $as_T(response$1.Ltyrian_http_Response__f_body);
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var target = $m_Lio_circe_parser_package$().parse__T__s_util_Either(json);
    var tc = $m_Lcats_implicits$().Lcats_implicits$__f_catsStdBitraverseForEither;
    var this$3 = new $c_Lcats_Bifunctor$$anon$5(target, tc);
    var fab = this$3.Lcats_Bifunctor$$anon$5__f_self;
    var this$5 = $as_s_util_Either(fab);
    if ((this$5 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$5);
      var b = x2.s_util_Right__f_value;
      var _$1 = $as_Lio_circe_Json(b);
      $m_Lio_circe_Decoder$();
      var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
      var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
      var d = new $c_Lio_circe_Decoder$$anon$42(decodeK, decodeV);
      var eab = d.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(_$1, null, null))
    } else {
      var eab = this$5
    };
    if ((eab instanceof $c_s_util_Left)) {
      var a = $as_s_util_Left(eab).s_util_Left__f_value;
      $m_s_package$();
      var _$2 = $as_jl_Throwable(a);
      var value = _$2.getMessage__T();
      return new $c_s_util_Left(value)
    };
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      return r
    };
    throw new $c_s_MatchError(eab)
  }))($thiz));
  return decoder
}
/** @constructor */
function $c_Lnet_timerboard_MapData$() {
  this.Lnet_timerboard_MapData$__f_get = null;
  $n_Lnet_timerboard_MapData$ = this;
  this.Lnet_timerboard_MapData$__f_get = $m_Ltyrian_http_Http$().send__Ltyrian_http_Request__F1__Ltyrian_Cmd($m_Ltyrian_http_Request$().get__T__F1__Ltyrian_http_Request("./system2region.json", $p_Lnet_timerboard_MapData$__decodeMapData__F1(this)), new $c_sjsr_AnonFunction1(((this$1) => ((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    if ((_$3$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$3$1);
      var b = x2.s_util_Right__f_value;
      var _$5 = $as_sci_Map(b);
      var $$x1 = new $c_Lnet_timerboard_Msg$LoadSystemRegions(_$5)
    } else {
      if ((!(_$3$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(_$3$1)
      };
      var x3 = $as_s_util_Left(_$3$1);
      var a = x3.s_util_Left__f_value;
      var _$4 = $as_Ltyrian_http_HttpError(a);
      var $$x1 = new $c_Lnet_timerboard_Msg$BadHttp(_$4)
    };
    return $as_Lnet_timerboard_Msg($$x1)
  }))(this)))
}
$c_Lnet_timerboard_MapData$.prototype = new $h_O();
$c_Lnet_timerboard_MapData$.prototype.constructor = $c_Lnet_timerboard_MapData$;
/** @constructor */
function $h_Lnet_timerboard_MapData$() {
  /*<skip>*/
}
$h_Lnet_timerboard_MapData$.prototype = $c_Lnet_timerboard_MapData$.prototype;
var $d_Lnet_timerboard_MapData$ = new $TypeData().initClass({
  Lnet_timerboard_MapData$: 0
}, false, "net.timerboard.MapData$", {
  Lnet_timerboard_MapData$: 1,
  O: 1
});
$c_Lnet_timerboard_MapData$.prototype.$classData = $d_Lnet_timerboard_MapData$;
var $n_Lnet_timerboard_MapData$;
function $m_Lnet_timerboard_MapData$() {
  if ((!$n_Lnet_timerboard_MapData$)) {
    $n_Lnet_timerboard_MapData$ = new $c_Lnet_timerboard_MapData$()
  };
  return $n_Lnet_timerboard_MapData$
}
function $p_Lnet_timerboard_Routefinder$__decodeDistances__F1($thiz) {
  $m_Ltyrian_http_Http$Decoder$();
  var decoder = new $c_sjsr_AnonFunction1(((this$1) => ((response) => {
    var response$1 = $as_Ltyrian_http_Response(response);
    var json = $as_T(response$1.Ltyrian_http_Response__f_body);
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var target = $m_Lio_circe_parser_package$().parse__T__s_util_Either(json);
    var tc = $m_Lcats_implicits$().Lcats_implicits$__f_catsStdBitraverseForEither;
    var this$3 = new $c_Lcats_Bifunctor$$anon$5(target, tc);
    var fab = this$3.Lcats_Bifunctor$$anon$5__f_self;
    var this$5 = $as_s_util_Either(fab);
    if ((this$5 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$5);
      var b = x2.s_util_Right__f_value;
      var _$6 = $as_Lio_circe_Json(b);
      $m_Lio_circe_Decoder$();
      var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
      var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
      var d = new $c_Lio_circe_Decoder$$anon$42(decodeK, decodeV);
      var this$8 = d.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(_$6, null, null));
      if ((this$8 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$8);
        var b$1 = x2$1.s_util_Right__f_value;
        var _$7 = $as_sci_Map(b$1);
        var eab = new $c_s_util_Right($as_sci_Map(_$7.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((this$9) => ((x$1) => {
          var x$1$1 = $as_T2(x$1);
          if ((x$1$1 !== null)) {
            var k = $as_T(x$1$1._1__O());
            var v = $uI(x$1$1._2__O());
            var this$12 = $m_jl_Long$();
            var t = this$12.parseLong__T__I__J(k, 10);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            return $ct_T2__O__O__(new $c_T2(), new $c_RTLong(lo, hi), v)
          };
          throw new $c_s_MatchError(x$1$1)
        }))(this$1)))))
      } else {
        var eab = this$8
      }
    } else {
      var eab = this$5
    };
    if ((eab instanceof $c_s_util_Left)) {
      var a = $as_s_util_Left(eab).s_util_Left__f_value;
      $m_s_package$();
      var _$8 = $as_jl_Throwable(a);
      var value = _$8.getMessage__T();
      return new $c_s_util_Left(value)
    };
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      return r
    };
    throw new $c_s_MatchError(eab)
  }))($thiz));
  return decoder
}
/** @constructor */
function $c_Lnet_timerboard_Routefinder$() {
  /*<skip>*/
}
$c_Lnet_timerboard_Routefinder$.prototype = new $h_O();
$c_Lnet_timerboard_Routefinder$.prototype.constructor = $c_Lnet_timerboard_Routefinder$;
/** @constructor */
function $h_Lnet_timerboard_Routefinder$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Routefinder$.prototype = $c_Lnet_timerboard_Routefinder$.prototype;
$c_Lnet_timerboard_Routefinder$.prototype.get__J__Ltyrian_Cmd = (function(systemId) {
  return $m_Ltyrian_http_Http$().send__Ltyrian_http_Request__F1__Ltyrian_Cmd($m_Ltyrian_http_Request$().get__T__F1__Ltyrian_http_Request(("https://routes.timerboard.net/v1/routes/" + systemId), $p_Lnet_timerboard_Routefinder$__decodeDistances__F1(this)), new $c_sjsr_AnonFunction1(((this$1) => ((_$9) => {
    var _$9$1 = $as_s_util_Either(_$9);
    if ((_$9$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$9$1);
      var b = x2.s_util_Right__f_value;
      var _$11 = $as_sci_Map(b);
      var $$x1 = new $c_Lnet_timerboard_Msg$UpdateDistances(_$11)
    } else {
      if ((!(_$9$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(_$9$1)
      };
      var x3 = $as_s_util_Left(_$9$1);
      var a = x3.s_util_Left__f_value;
      var _$10 = $as_Ltyrian_http_HttpError(a);
      var $$x1 = new $c_Lnet_timerboard_Msg$BadHttp(_$10)
    };
    return $as_Lnet_timerboard_Msg($$x1)
  }))(this)))
});
var $d_Lnet_timerboard_Routefinder$ = new $TypeData().initClass({
  Lnet_timerboard_Routefinder$: 0
}, false, "net.timerboard.Routefinder$", {
  Lnet_timerboard_Routefinder$: 1,
  O: 1
});
$c_Lnet_timerboard_Routefinder$.prototype.$classData = $d_Lnet_timerboard_Routefinder$;
var $n_Lnet_timerboard_Routefinder$;
function $m_Lnet_timerboard_Routefinder$() {
  if ((!$n_Lnet_timerboard_Routefinder$)) {
    $n_Lnet_timerboard_Routefinder$ = new $c_Lnet_timerboard_Routefinder$()
  };
  return $n_Lnet_timerboard_Routefinder$
}
/** @constructor */
function $c_Lnet_timerboard_SearchHashes$() {
  /*<skip>*/
}
$c_Lnet_timerboard_SearchHashes$.prototype = new $h_O();
$c_Lnet_timerboard_SearchHashes$.prototype.constructor = $c_Lnet_timerboard_SearchHashes$;
/** @constructor */
function $h_Lnet_timerboard_SearchHashes$() {
  /*<skip>*/
}
$h_Lnet_timerboard_SearchHashes$.prototype = $c_Lnet_timerboard_SearchHashes$.prototype;
$c_Lnet_timerboard_SearchHashes$.prototype.updateModelFromhash__Lnet_timerboard_Model__T__Lnet_timerboard_Model = (function(m, s) {
  var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(s, ",", 0));
  $m_sci_List$();
  var searchTags$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
  var socket$1 = m.Lnet_timerboard_Model__f_socket;
  var logs$1 = m.Lnet_timerboard_Model__f_logs;
  var state$1 = m.Lnet_timerboard_Model__f_state;
  var now$1 = m.Lnet_timerboard_Model__f_now;
  var system$1 = m.Lnet_timerboard_Model__f_system;
  var systemNames$1 = m.Lnet_timerboard_Model__f_systemNames;
  var distances$1 = m.Lnet_timerboard_Model__f_distances;
  var search$1 = m.Lnet_timerboard_Model__f_search;
  var sortBy$1 = m.Lnet_timerboard_Model__f_sortBy;
  var sortDirection$1 = m.Lnet_timerboard_Model__f_sortDirection;
  var systems$1 = m.Lnet_timerboard_Model__f_systems;
  return new $c_Lnet_timerboard_Model(socket$1, logs$1, state$1, now$1, system$1, systemNames$1, distances$1, search$1, searchTags$1, sortBy$1, sortDirection$1, systems$1)
});
$c_Lnet_timerboard_SearchHashes$.prototype.createHashFromModel__Lnet_timerboard_Model__T = (function(m) {
  var this$1 = m.Lnet_timerboard_Model__f_searchTags;
  var elem = m.Lnet_timerboard_Model__f_search;
  var this$5 = new $c_sci_$colon$colon(elem, this$1);
  var f = ((this$2) => ((_$17) => {
    var _$17$1 = $as_T(_$17);
    return (_$17$1 !== "")
  }))(this);
  var l = this$5;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = l.head__O();
        var t = $as_sci_List(l.tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = remaining.head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(result, "", ",", "")
});
var $d_Lnet_timerboard_SearchHashes$ = new $TypeData().initClass({
  Lnet_timerboard_SearchHashes$: 0
}, false, "net.timerboard.SearchHashes$", {
  Lnet_timerboard_SearchHashes$: 1,
  O: 1
});
$c_Lnet_timerboard_SearchHashes$.prototype.$classData = $d_Lnet_timerboard_SearchHashes$;
var $n_Lnet_timerboard_SearchHashes$;
function $m_Lnet_timerboard_SearchHashes$() {
  if ((!$n_Lnet_timerboard_SearchHashes$)) {
    $n_Lnet_timerboard_SearchHashes$ = new $c_Lnet_timerboard_SearchHashes$()
  };
  return $n_Lnet_timerboard_SearchHashes$
}
function $p_Lnet_timerboard_Systems$__decodeSystems__F1($thiz) {
  $m_Ltyrian_http_Http$Decoder$();
  var decoder = new $c_sjsr_AnonFunction1(((this$1) => ((response) => {
    var response$1 = $as_Ltyrian_http_Response(response);
    var json = $as_T(response$1.Ltyrian_http_Response__f_body);
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var target = $m_Lio_circe_parser_package$().parse__T__s_util_Either(json);
    var tc = $m_Lcats_implicits$().Lcats_implicits$__f_catsStdBitraverseForEither;
    var this$3 = new $c_Lcats_Bifunctor$$anon$5(target, tc);
    var fab = this$3.Lcats_Bifunctor$$anon$5__f_self;
    var this$5 = $as_s_util_Either(fab);
    if ((this$5 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$5);
      var b = x2.s_util_Right__f_value;
      var _$12 = $as_Lio_circe_Json(b);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lnet_timerboard_SolarSystem$().derived$Decoder__Lio_circe_Decoder();
      var d = new $c_Lio_circe_Decoder$$anon$45(decodeA);
      var eab = d.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(_$12, null, null))
    } else {
      var eab = this$5
    };
    if ((eab instanceof $c_s_util_Left)) {
      var a = $as_s_util_Left(eab).s_util_Left__f_value;
      $m_s_package$();
      var _$13 = $as_jl_Throwable(a);
      var value = _$13.getMessage__T();
      return new $c_s_util_Left(value)
    };
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      return r
    };
    throw new $c_s_MatchError(eab)
  }))($thiz));
  return decoder
}
/** @constructor */
function $c_Lnet_timerboard_Systems$() {
  this.Lnet_timerboard_Systems$__f_get = null;
  $n_Lnet_timerboard_Systems$ = this;
  this.Lnet_timerboard_Systems$__f_get = $m_Ltyrian_http_Http$().send__Ltyrian_http_Request__F1__Ltyrian_Cmd($m_Ltyrian_http_Request$().get__T__F1__Ltyrian_http_Request("https://routes.timerboard.net/v1/systems", $p_Lnet_timerboard_Systems$__decodeSystems__F1(this)), new $c_sjsr_AnonFunction1(((this$1) => ((_$14) => {
    var _$14$1 = $as_s_util_Either(_$14);
    if ((_$14$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$14$1);
      var b = x2.s_util_Right__f_value;
      var _$16 = $as_sci_List(b);
      var $$x1 = new $c_Lnet_timerboard_Msg$LoadSystems(_$16)
    } else {
      if ((!(_$14$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(_$14$1)
      };
      var x3 = $as_s_util_Left(_$14$1);
      var a = x3.s_util_Left__f_value;
      var _$15 = $as_Ltyrian_http_HttpError(a);
      var $$x1 = new $c_Lnet_timerboard_Msg$BadHttp(_$15)
    };
    return $as_Lnet_timerboard_Msg($$x1)
  }))(this)))
}
$c_Lnet_timerboard_Systems$.prototype = new $h_O();
$c_Lnet_timerboard_Systems$.prototype.constructor = $c_Lnet_timerboard_Systems$;
/** @constructor */
function $h_Lnet_timerboard_Systems$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Systems$.prototype = $c_Lnet_timerboard_Systems$.prototype;
var $d_Lnet_timerboard_Systems$ = new $TypeData().initClass({
  Lnet_timerboard_Systems$: 0
}, false, "net.timerboard.Systems$", {
  Lnet_timerboard_Systems$: 1,
  O: 1
});
$c_Lnet_timerboard_Systems$.prototype.$classData = $d_Lnet_timerboard_Systems$;
var $n_Lnet_timerboard_Systems$;
function $m_Lnet_timerboard_Systems$() {
  if ((!$n_Lnet_timerboard_Systems$)) {
    $n_Lnet_timerboard_Systems$ = new $c_Lnet_timerboard_Systems$()
  };
  return $n_Lnet_timerboard_Systems$
}
/** @constructor */
function $c_Lnet_timerboard_TimeDiff$() {
  /*<skip>*/
}
$c_Lnet_timerboard_TimeDiff$.prototype = new $h_O();
$c_Lnet_timerboard_TimeDiff$.prototype.constructor = $c_Lnet_timerboard_TimeDiff$;
/** @constructor */
function $h_Lnet_timerboard_TimeDiff$() {
  /*<skip>*/
}
$h_Lnet_timerboard_TimeDiff$.prototype = $c_Lnet_timerboard_TimeDiff$.prototype;
$c_Lnet_timerboard_TimeDiff$.prototype.apply__Ljava_time_ZonedDateTime__Ljava_time_ZonedDateTime__T = (function(now, event) {
  var this$8 = $m_Lsquants_time_Seconds$();
  var this$1 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
  var t = now.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(event, this$1);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var n__lo = lo$1;
    var n__hi = hi$1
  } else {
    var n__lo = lo;
    var n__hi = hi
  };
  var num = $m_s_math_Numeric$LongIsIntegral$();
  var fullSeconds = $m_Lsquants_time_Time$().apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time(new $c_RTLong(n__lo, n__hi), this$8, num);
  $m_Lcats_implicits$();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsquants_time_TimeUnit.getArrayOf().constr)([$m_Lsquants_time_Days$(), $m_Lsquants_time_Hours$(), $m_Lsquants_time_Minutes$(), $m_Lsquants_time_Seconds$()]));
  var target = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var tc = $as_Lcats_Foldable($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
  var this$19 = new $c_Lcats_Foldable$$anon$6(target, tc);
  var f = new $c_sjsr_AnonFunction2(((this$11) => ((x$1, x$2) => {
    var x$1$1 = $as_Lsquants_time_Time(x$1);
    var x$2$1 = $as_Lsquants_time_TimeUnit(x$2);
    var quantity = $as_Lsquants_time_Time(x$1$1.in__Lsquants_UnitOfMeasure__Lsquants_Quantity(x$2$1).floor__Lsquants_Quantity());
    var $$x3 = $m_Lcats_data_package$Writer$();
    $m_s_package$();
    var $$x2 = $m_sr_ScalaRunTime$();
    var y = $doubleToInt(quantity.Lsquants_time_Time__f_value);
    var elems$1 = $$x2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), x$2$1, y)]));
    return $$x3.apply__O__O__Lcats_data_WriterT($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1), x$1$1.plus__Lsquants_Quantity__Lsquants_Quantity(quantity.negate__Lsquants_Quantity()))
  }))(this));
  $m_Lcats_implicits$();
  var evidence$7 = new $c_Lcats_kernel_instances_ListMonoid();
  $m_Lcats_Invariant$();
  var F = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  var G = new $c_Lcats_data_WriterTInstances4$$anon$1(F, evidence$7);
  var $$x1 = $as_sc_IterableOnceOps($as_T2($as_Lcats_data_WriterT(this$19.Lcats_Foldable$$anon$6__f_typeClassInstance.foldM__O__O__F2__Lcats_Monad__O(this$19.Lcats_Foldable$$anon$6__f_self, fullSeconds, f, G)).Lcats_data_WriterT__f_run)._1__O());
  var this$20 = $m_s_$less$colon$less$();
  var times = $$x1.toMap__s_$less$colon$less__sci_Map(this$20.s_$less$colon$less$__f_singleton);
  var days = $uI(times.getOrElse__O__F0__O($m_Lsquants_time_Days$(), new $c_sjsr_AnonFunction0(((this$2$1) => (() => 0))(this))));
  var hours = $uI(times.getOrElse__O__F0__O($m_Lsquants_time_Hours$(), new $c_sjsr_AnonFunction0(((this$3$1) => (() => 0))(this))));
  var minutes = $uI(times.getOrElse__O__F0__O($m_Lsquants_time_Minutes$(), new $c_sjsr_AnonFunction0(((this$4$1) => (() => 0))(this))));
  var seconds = $uI(times.getOrElse__O__F0__O($m_Lsquants_time_Seconds$(), new $c_sjsr_AnonFunction0(((this$5$1) => (() => 0))(this))));
  var symbol = ($f_Ljava_time_chrono_ChronoZonedDateTime__isAfter__Ljava_time_chrono_ChronoZonedDateTime__Z(now, event) ? "-" : "");
  return ((((((((symbol + days) + "d ") + hours) + "h ") + minutes) + "m ") + seconds) + "s")
});
var $d_Lnet_timerboard_TimeDiff$ = new $TypeData().initClass({
  Lnet_timerboard_TimeDiff$: 0
}, false, "net.timerboard.TimeDiff$", {
  Lnet_timerboard_TimeDiff$: 1,
  O: 1
});
$c_Lnet_timerboard_TimeDiff$.prototype.$classData = $d_Lnet_timerboard_TimeDiff$;
var $n_Lnet_timerboard_TimeDiff$;
function $m_Lnet_timerboard_TimeDiff$() {
  if ((!$n_Lnet_timerboard_TimeDiff$)) {
    $n_Lnet_timerboard_TimeDiff$ = new $c_Lnet_timerboard_TimeDiff$()
  };
  return $n_Lnet_timerboard_TimeDiff$
}
function $is_Lnet_timerboard_WebsocketEvent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_timerboard_WebsocketEvent)))
}
function $as_Lnet_timerboard_WebsocketEvent(obj) {
  return (($is_Lnet_timerboard_WebsocketEvent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.WebsocketEvent"))
}
function $isArrayOf_Lnet_timerboard_WebsocketEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_WebsocketEvent)))
}
function $asArrayOf_Lnet_timerboard_WebsocketEvent(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_WebsocketEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.WebsocketEvent;", depth))
}
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi
}
$c_RTLong.prototype = new $h_O();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
  /*<skip>*/
}
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_RTLong(that);
    return ((this.RTLong__f_lo === x2.RTLong__f_lo) && (this.RTLong__f_hi === x2.RTLong__f_hi))
  } else {
    return false
  }
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi)
});
$c_RTLong.prototype.toString__T = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toInt__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.toFloat__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toDouble__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24)
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16)
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.longValue__J = (function() {
  return $uJ(this)
});
$c_RTLong.prototype.floatValue__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.doubleValue__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__O__I = (function(that) {
  var b = $as_RTLong(that);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
});
$c_RTLong.prototype.equals__RTLong__Z = (function(b) {
  return ((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi))
});
$c_RTLong.prototype.notEquals__RTLong__Z = (function(b) {
  return (!((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi)))
});
$c_RTLong.prototype.$less__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$less$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) <= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$greater__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.$greater$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) >= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.unary_$tilde__RTLong = (function() {
  return new $c_RTLong((~this.RTLong__f_lo), (~this.RTLong__f_hi))
});
$c_RTLong.prototype.$bar__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo | b.RTLong__f_lo), (this.RTLong__f_hi | b.RTLong__f_hi))
});
$c_RTLong.prototype.$amp__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo & b.RTLong__f_lo), (this.RTLong__f_hi & b.RTLong__f_hi))
});
$c_RTLong.prototype.$up__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo ^ b.RTLong__f_lo), (this.RTLong__f_hi ^ b.RTLong__f_hi))
});
$c_RTLong.prototype.$less$less__I__RTLong = (function(n) {
  var lo = this.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this.RTLong__f_hi << n)) : (lo << n)))
});
$c_RTLong.prototype.$greater$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0))
});
$c_RTLong.prototype.$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)))
});
$c_RTLong.prototype.unary_$minus__RTLong = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return new $c_RTLong(((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))
});
$c_RTLong.prototype.$plus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0)))
});
$c_RTLong.prototype.$minus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0)))
});
$c_RTLong.prototype.$times__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi)
});
$c_RTLong.prototype.$div__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong.prototype.$percent__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
function $as_RTLong(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "org.scalajs.linker.runtime.RuntimeLong"))
}
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)))
}
function $asArrayOf_RTLong(obj, depth) {
  return (($isArrayOf_RTLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lorg.scalajs.linker.runtime.RuntimeLong;", depth))
}
var $d_RTLong = new $TypeData().initClass({
  RTLong: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong", {
  RTLong: 1,
  O: 1
});
$c_RTLong.prototype.$classData = $d_RTLong;
function $p_RTLong$__toUnsignedString__I__I__T($thiz, lo, hi) {
  if ((((-2097152) & hi) === 0)) {
    var this$1 = ((4.294967296E9 * hi) + $uD((lo >>> 0)));
    return ("" + this$1)
  } else {
    return $as_T($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, lo, hi, 1000000000, 0, 2))
  }
}
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - Math.clz32(blo)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - Math.clz32(bhi)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0)
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 0))
  }
}
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 1))
  }
}
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, ask) {
  var shift = ((((bhi !== 0) ? Math.clz32(bhi) : ((32 + Math.clz32(blo)) | 0)) - ((ahi !== 0) ? Math.clz32(ahi) : ((32 + Math.clz32(alo)) | 0))) | 0);
  var n = shift;
  var lo = (((32 & n) === 0) ? (blo << n) : 0);
  var hi = (((32 & n) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (bhi << n)) : (blo << n));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ alo$1) >= ((-2147483648) ^ blo$1)) : (((-2147483648) ^ ahi$1) >= ((-2147483648) ^ bhi$1)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift))
      } else {
        quotHi = (quotHi | (1 << shift))
      }
    };
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5
  };
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? (((-2147483648) ^ alo$2) >= ((-2147483648) ^ blo)) : (((-2147483648) ^ ahi$2) >= ((-2147483648) ^ bhi)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + $uD((lo$6 >>> 0)));
    var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
    if ((ask !== 1)) {
      var x = (remDouble / bDouble);
      var lo$7 = $uI((x | 0));
      var x$1 = (x / 4.294967296E9);
      var hi$7 = $uI((x$1 | 0));
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$8)) ? ((1 + ((hi$8 + hi$7) | 0)) | 0) : ((hi$8 + hi$7) | 0));
      quotLo = lo$9;
      quotHi = hi$9
    };
    if ((ask !== 0)) {
      var rem_mod_bDouble = (remDouble % bDouble);
      remLo = $uI((rem_mod_bDouble | 0));
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      remHi = $uI((x$2 | 0))
    }
  };
  if ((ask === 0)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo
  } else if ((ask === 1)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo
  } else {
    var lo$10 = quotLo;
    var hi$10 = quotHi;
    var quot = ((4.294967296E9 * hi$10) + $uD((lo$10 >>> 0)));
    var this$3 = remLo;
    var remStr = ("" + this$3);
    var start = $uI(remStr.length);
    return ((("" + quot) + $as_T("000000000".substring(start))) + remStr)
  }
}
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
  /*<skip>*/
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  return ((hi === (lo >> 31)) ? ("" + lo) : ((hi < 0) ? ("-" + $p_RTLong$__toUnsignedString__I__I__T(this, ((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))) : $p_RTLong$__toUnsignedString__I__I__T(this, lo, hi)))
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D = (function(lo, hi) {
  if ((hi < 0)) {
    var x = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var $$x1 = $uD((x >>> 0));
    var x$1 = ((-lo) | 0);
    return (-((4.294967296E9 * $$x1) + $uD((x$1 >>> 0))))
  } else {
    return ((4.294967296E9 * hi) + $uD((lo >>> 0)))
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F = (function(lo, hi) {
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var abs__lo = lo$1;
    var abs__hi = hi$1
  } else {
    var abs__lo = lo;
    var abs__hi = hi
  };
  var hi$2 = abs__hi;
  if (((((-2097152) & hi$2) === 0) || ((65535 & abs__lo) === 0))) {
    var compressedAbsLo = abs__lo
  } else {
    var compressedAbsLo = (32768 | ((-65536) & abs__lo))
  };
  var x = abs__hi;
  var absRes = ((4.294967296E9 * $uD((x >>> 0))) + $uD((compressedAbsLo >>> 0)));
  return Math.fround(((hi < 0) ? (-absRes) : absRes))
});
$c_RTLong$.prototype.fromInt__I__RTLong = (function(value) {
  return new $c_RTLong(value, (value >> 31))
});
$c_RTLong$.prototype.fromDouble__D__RTLong = (function(value) {
  var lo = this.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1)
  } else {
    var rawLo = $uI((value | 0));
    var x = (value / 4.294967296E9);
    var rawHi = $uI((x | 0));
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : ((((-2147483648) ^ alo) < ((-2147483648) ^ blo)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1))
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648)
      } else {
        var lo = $intDiv(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1)
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo
    } else {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      if ((blo === 0)) {
        return $intDiv(0, 0)
      } else {
        var n = ($uD((alo >>> 0)) / $uD((blo >>> 0)));
        return $uI((n | 0))
      }
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi)
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if ((blo !== (-1))) {
        var lo = $intMod(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      } else {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return 0
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if ((ahi < 0)) {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    } else {
      return absRLo
    }
  }
});
var $d_RTLong$ = new $TypeData().initClass({
  RTLong$: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong$", {
  RTLong$: 1,
  O: 1
});
$c_RTLong$.prototype.$classData = $d_RTLong$;
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$()
  };
  return $n_RTLong$
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = null;
  this.s_Array$EmptyArrays$__f_emptyByteArray = null;
  this.s_Array$EmptyArrays$__f_emptyCharArray = null;
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = null;
  this.s_Array$EmptyArrays$__f_emptyFloatArray = null;
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyLongArray = null;
  this.s_Array$EmptyArrays$__f_emptyShortArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = new $ac_Z(0);
  this.s_Array$EmptyArrays$__f_emptyByteArray = new $ac_B(0);
  this.s_Array$EmptyArrays$__f_emptyCharArray = new $ac_C(0);
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = new $ac_D(0);
  this.s_Array$EmptyArrays$__f_emptyFloatArray = new $ac_F(0);
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyLongArray = new $ac_J(0);
  this.s_Array$EmptyArrays$__f_emptyShortArray = new $ac_S(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0)
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
  /*<skip>*/
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass({
  s_Array$EmptyArrays$: 0
}, false, "scala.Array$EmptyArrays$", {
  s_Array$EmptyArrays$: 1,
  O: 1
});
$c_s_Array$EmptyArrays$.prototype.$classData = $d_s_Array$EmptyArrays$;
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$()
  };
  return $n_s_Array$EmptyArrays$
}
/** @constructor */
function $c_s_Array$UnapplySeqWrapper$() {
  /*<skip>*/
}
$c_s_Array$UnapplySeqWrapper$.prototype = new $h_O();
$c_s_Array$UnapplySeqWrapper$.prototype.constructor = $c_s_Array$UnapplySeqWrapper$;
/** @constructor */
function $h_s_Array$UnapplySeqWrapper$() {
  /*<skip>*/
}
$h_s_Array$UnapplySeqWrapper$.prototype = $c_s_Array$UnapplySeqWrapper$.prototype;
$c_s_Array$UnapplySeqWrapper$.prototype.lengthCompare$extension__O__I__I = (function(this$, len) {
  return $m_sc_ArrayOps$().lengthCompare$extension__O__I__I(this$, len)
});
var $d_s_Array$UnapplySeqWrapper$ = new $TypeData().initClass({
  s_Array$UnapplySeqWrapper$: 0
}, false, "scala.Array$UnapplySeqWrapper$", {
  s_Array$UnapplySeqWrapper$: 1,
  O: 1
});
$c_s_Array$UnapplySeqWrapper$.prototype.$classData = $d_s_Array$UnapplySeqWrapper$;
var $n_s_Array$UnapplySeqWrapper$;
function $m_s_Array$UnapplySeqWrapper$() {
  if ((!$n_s_Array$UnapplySeqWrapper$)) {
    $n_s_Array$UnapplySeqWrapper$ = new $c_s_Array$UnapplySeqWrapper$()
  };
  return $n_s_Array$UnapplySeqWrapper$
}
function $is_F0(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F0)))
}
function $as_F0(obj) {
  return (($is_F0(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function0"))
}
function $isArrayOf_F0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F0)))
}
function $asArrayOf_F0(obj, depth) {
  return (($isArrayOf_F0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function0;", depth))
}
function $f_F1__compose__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((this$1, g$1) => ((x$2) => this$1.apply__O__O(g$1.apply__O__O(x$2))))($thiz, g))
}
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((this$1, g$1) => ((x$2) => g$1.apply__O__O(this$1.apply__O__O(x$2))))($thiz, g))
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)))
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"))
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)))
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth))
}
function $f_F2__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((this$1) => ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = x0$1._1__O();
      var x2 = x0$1._2__O();
      return this$1.apply__O__O__O(x1$2, x2)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))($thiz))
}
function $ct_s_JSUniquenessCache__($thiz) {
  $thiz.s_JSUniquenessCache__f_cache = {};
  return $thiz
}
/** @constructor */
function $c_s_JSUniquenessCache() {
  this.s_JSUniquenessCache__f_cache = null
}
$c_s_JSUniquenessCache.prototype = new $h_O();
$c_s_JSUniquenessCache.prototype.constructor = $c_s_JSUniquenessCache;
/** @constructor */
function $h_s_JSUniquenessCache() {
  /*<skip>*/
}
$h_s_JSUniquenessCache.prototype = $c_s_JSUniquenessCache.prototype;
$c_s_JSUniquenessCache.prototype.apply__T__O = (function(name) {
  var dict = this.s_JSUniquenessCache__f_cache;
  var x1 = ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name)) ? new $c_s_Some(dict[name]) : $m_s_None$());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = new $c_s_Symbol(name);
      dict[name] = d;
      return d
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
/** @constructor */
function $c_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sjsr_AnonFunction1(((this$1) => ((x$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn))(this));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sjsr_AnonFunction1(((this$2) => ((x$3$2) => false))(this));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1()
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
  /*<skip>*/
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x)
});
var $d_s_PartialFunction$ = new $TypeData().initClass({
  s_PartialFunction$: 0
}, false, "scala.PartialFunction$", {
  s_PartialFunction$: 1,
  O: 1
});
$c_s_PartialFunction$.prototype.$classData = $d_s_PartialFunction$;
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$()
  };
  return $n_s_PartialFunction$
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.sr_RichLong__f_self)
}
/** @constructor */
function $c_T$() {
  this.T$__f_canEqualEmptyTuple$lzy1 = null;
  this.T$__f_canEqualEmptyTuplebitmap$1 = false
}
$c_T$.prototype = new $h_O();
$c_T$.prototype.constructor = $c_T$;
/** @constructor */
function $h_T$() {
  /*<skip>*/
}
$h_T$.prototype = $c_T$.prototype;
$c_T$.prototype.fromArray__O__s_Product = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var xs$2 = $asArrayOf_O(xs, 1);
    var xs2 = xs$2
  } else {
    var f = ((this$2) => ((_$9) => _$9))(this);
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    var len = $m_sr_ScalaRunTime$().array_length__O__I(xs);
    var ys = new $ac_O(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs instanceof $ac_O)) {
        var x2 = $asArrayOf_O(xs, 1);
        while ((i < len)) {
          var $$x1 = i;
          var arg1 = x2.get(i);
          ys.set($$x1, f(arg1));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var $$x2 = i;
          var arg1$1 = x3.get(i);
          ys.set($$x2, f(arg1$1));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var $$x3 = i;
          var arg1$2 = x4.get(i);
          ys.set($$x3, f(arg1$2));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var $$x4 = i;
          var t = x5.get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.set($$x4, f(new $c_RTLong(lo, hi)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var $$x5 = i;
          var arg1$3 = x6.get(i);
          ys.set($$x5, f(arg1$3));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var $$x6 = i;
          var arg1$4 = x7.get(i);
          ys.set($$x6, f($bC(arg1$4)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var $$x7 = i;
          var arg1$5 = x8.get(i);
          ys.set($$x7, f(arg1$5));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var $$x8 = i;
          var arg1$6 = x9.get(i);
          ys.set($$x8, f(arg1$6));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var $$x9 = i;
          var arg1$7 = x10.get(i);
          ys.set($$x9, f(arg1$7));
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      }
    };
    var xs2 = ys
  };
  return $m_sr_Tuples$().fromArray__AO__s_Product(xs2)
});
var $d_T$ = new $TypeData().initClass({
  T$: 0
}, false, "scala.Tuple$", {
  T$: 1,
  O: 1
});
$c_T$.prototype.$classData = $d_T$;
var $n_T$;
function $m_T$() {
  if ((!$n_T$)) {
    $n_T$ = new $c_T$()
  };
  return $n_T$
}
function $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O($thiz, len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_sr_ScalaRunTime$().array_length__O__I(a), ord$1);
    return a
  } else {
    var this$4 = $m_s_Array$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(\u03b4this$2).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$4.copyOf__O__I__O(\u03b4this$2, len$1)
      } else {
        var original = $asArrayOf_O(\u03b4this$2, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, len$1, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(\u03b4this$2));
      var $$x1 = dest
    };
    var a$2 = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    return $m_s_Array$().copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(\u03b4this$2).getComponentType__jl_Class()))
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  /*<skip>*/
}
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
  /*<skip>*/
}
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.lengthCompare$extension__O__I__I = (function(this$, len) {
  var x = $m_sr_ScalaRunTime$().array_length__O__I(this$);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_sr_ScalaRunTime$().array_length__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      var x2 = $asArrayOf_O(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(x2, lo, hi)
    } else if ((this$ instanceof $ac_I)) {
      var x3 = $asArrayOf_I(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(x3, lo, hi)
    } else if ((this$ instanceof $ac_D)) {
      var x4 = $asArrayOf_D(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(x4, lo, hi)
    } else if ((this$ instanceof $ac_J)) {
      var x5 = $asArrayOf_J(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(x5, lo, hi)
    } else if ((this$ instanceof $ac_F)) {
      var x6 = $asArrayOf_F(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(x6, lo, hi)
    } else if ((this$ instanceof $ac_C)) {
      var x7 = $asArrayOf_C(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(x7, lo, hi)
    } else if ((this$ instanceof $ac_B)) {
      var x8 = $asArrayOf_B(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(x8, lo, hi)
    } else if ((this$ instanceof $ac_S)) {
      var x9 = $asArrayOf_S(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(x9, lo, hi)
    } else if ((this$ instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(x10, lo, hi)
    } else {
      throw new $c_s_MatchError(this$)
    }
  } else {
    return $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$).getComponentType__jl_Class()).newArray__I__O(0)
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array")
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_sr_ScalaRunTime$().array_length__O__I(this$))
  }
});
$c_sc_ArrayOps$.prototype.init$extension__O__O = (function(this$) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty array")
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, (((-1) + $m_sr_ScalaRunTime$().array_length__O__I(this$)) | 0))
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_sr_ScalaRunTime$().array_length__O__I(this$))
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_sr_ScalaRunTime$().array_length__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$)
  } else if ((this$ instanceof $ac_O)) {
    var x2 = $asArrayOf_O(this$, 1);
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(x2, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a
  } else if ((this$ instanceof $ac_I)) {
    var x3 = $asArrayOf_I(this$, 1);
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(x3, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_J)) {
    var x4 = $asArrayOf_J(this$, 1);
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(x4, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_C)) {
    var x5 = $asArrayOf_C(this$, 1);
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(x5, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_B)) {
    var x6 = $asArrayOf_B(this$, 1);
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(x6, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_S)) {
    var x7 = $asArrayOf_S(this$, 1);
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(x7, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_Z)) {
    var x8 = $asArrayOf_Z(this$, 1);
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(x8, len);
      var this$1 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$1.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, a$7.u.length, evidence$3);
      return a$7
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else {
    return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
  }
});
var $d_sc_ArrayOps$ = new $TypeData().initClass({
  sc_ArrayOps$: 0
}, false, "scala.collection.ArrayOps$", {
  sc_ArrayOps$: 1,
  O: 1
});
$c_sc_ArrayOps$.prototype.$classData = $d_sc_ArrayOps$;
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$()
  };
  return $n_sc_ArrayOps$
}
/** @constructor */
function $c_sc_BitSetOps$() {
  /*<skip>*/
}
$c_sc_BitSetOps$.prototype = new $h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
  /*<skip>*/
}
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w) {
  var len = elems.u.length;
  while (true) {
    if ((len > 0)) {
      var this$1 = elems.get((((-1) + len) | 0));
      if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
        var $$x1 = true
      } else {
        var $$x1 = (((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)) && (idx === (((-1) + len) | 0)))
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      len = (((-1) + len) | 0)
    } else {
      break
    }
  };
  var newlen = len;
  if (((idx >= newlen) && (!((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0))))) {
    newlen = ((1 + idx) | 0)
  };
  var newelems = new $ac_J(newlen);
  $m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    newelems.set(idx, w)
  } else {
    $m_s_Predef$().assert__Z__V(((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)))
  };
  return newelems
});
var $d_sc_BitSetOps$ = new $TypeData().initClass({
  sc_BitSetOps$: 0
}, false, "scala.collection.BitSetOps$", {
  sc_BitSetOps$: 1,
  O: 1
});
$c_sc_BitSetOps$.prototype.$classData = $d_sc_BitSetOps$;
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$()
  };
  return $n_sc_BitSetOps$
}
/** @constructor */
function $c_sc_Hashing$() {
  /*<skip>*/
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
  /*<skip>*/
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0))
});
var $d_sc_Hashing$ = new $TypeData().initClass({
  sc_Hashing$: 0
}, false, "scala.collection.Hashing$", {
  sc_Hashing$: 1,
  O: 1
});
$c_sc_Hashing$.prototype.$classData = $d_sc_Hashing$;
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$()
  };
  return $n_sc_Hashing$
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)))
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"))
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)))
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth))
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    f.apply__O__O(it.next__O())
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while ((res && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (((!res) && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var a = it.next__O();
    if ($uZ(p.apply__O__O(a))) {
      return new $c_s_Some(a)
    }
  };
  return $m_s_None$()
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  var result = z;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    result = op.apply__O__O__O(result, it.next__O())
  };
  return result
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  return (!$as_sc_IterableOnce($thiz).iterator__sc_Iterator().hasNext__Z())
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    return $as_sc_IterableOnce($thiz).knownSize__I()
  } else {
    var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
    var len = 0;
    while (it.hasNext__Z()) {
      len = ((1 + len) | 0);
      it.next__O()
    };
    return len
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, xs, start, len) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  var i = start;
  var y = (($m_sr_ScalaRunTime$().array_length__O__I(xs) - start) | 0);
  var end = ((start + ((len < y) ? len : y)) | 0);
  while (((i < end) && it.hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(xs, i, it.next__O());
    i = ((1 + i) | 0)
  };
  return ((i - start) | 0)
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if ($thiz.isEmpty__Z()) {
    return (("" + start) + end)
  } else {
    var this$1 = $thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end);
    return this$1.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var obj = it.next__O();
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while (it.hasNext__Z()) {
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      var obj$1 = it.next__O();
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1)
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return b
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    var destination = evidence$2.newArray__I__O($as_sc_IterableOnce($thiz).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$2.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var rassoc$1 = it.next__O();
    var this$1 = xs;
    xs = new $c_sci_$colon$colon(rassoc$1, this$1)
  };
  return xs
}
function $is_sc_IterableOnceOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnceOps)))
}
function $as_sc_IterableOnceOps(obj) {
  return (($is_sc_IterableOnceOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps"))
}
function $isArrayOf_sc_IterableOnceOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps)))
}
function $asArrayOf_sc_IterableOnceOps(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps;", depth))
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $as_sc_IterableOnce(this.sc_Iterator$ConcatIteratorCell__f_head.apply__O()).iterator__sc_Iterator()
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass({
  sc_Iterator$ConcatIteratorCell: 0
}, false, "scala.collection.Iterator$ConcatIteratorCell", {
  sc_Iterator$ConcatIteratorCell: 1,
  O: 1
});
$c_sc_Iterator$ConcatIteratorCell.prototype.$classData = $d_sc_Iterator$ConcatIteratorCell;
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($thiz.sc_LinearSeqIterator$LazyCell__f_st.apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true
  };
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v)
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass({
  sc_LinearSeqIterator$LazyCell: 0
}, false, "scala.collection.LinearSeqIterator$LazyCell", {
  sc_LinearSeqIterator$LazyCell: 1,
  O: 1
});
$c_sc_LinearSeqIterator$LazyCell.prototype.$classData = $d_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $c_sc_StringOps$() {
  /*<skip>*/
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
  /*<skip>*/
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.escape$extension__T__C__T = (function(this$, ch) {
  return (((((ch >= 97) && (ch <= 122)) || ((ch >= 65) && (ch <= 90))) || ((ch >= 48) && (ch <= 57))) ? $as_T(String.fromCharCode(ch)) : ("\\" + $bC(ch)))
});
$c_sc_StringOps$.prototype.split$extension__T__C__AT = (function(this$, separator) {
  var regex = $m_sc_StringOps$().escape$extension__T__C__T(this$, separator);
  return $f_T__split__T__I__AT(this$, regex, 0)
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  if ((arg instanceof $c_s_math_ScalaNumber)) {
    var x2 = $as_s_math_ScalaNumber(arg);
    return x2.underlying__O()
  } else {
    return arg
  }
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = $asArrayOf_O($as_sc_IterableOnceOps(args.map__F1__O(new $c_sjsr_AnonFunction1(((this$1, this$$1) => ((arg$2) => $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$$1, arg$2)))(this, this$)))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$()), 1);
  return $m_jl_String$().format__T__AO__T(this$, args$1)
});
var $d_sc_StringOps$ = new $TypeData().initClass({
  sc_StringOps$: 0
}, false, "scala.collection.StringOps$", {
  sc_StringOps$: 1,
  O: 1
});
$c_sc_StringOps$.prototype.$classData = $d_sc_StringOps$;
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$()
  };
  return $n_sc_StringOps$
}
/** @constructor */
function $c_sc_compat_immutable_package$() {
  this.sc_compat_immutable_package$__f_ArraySeq = null;
  this.sc_compat_immutable_package$__f_LazyList = null;
  $n_sc_compat_immutable_package$ = this;
  this.sc_compat_immutable_package$__f_ArraySeq = $m_sci_ArraySeq$();
  this.sc_compat_immutable_package$__f_LazyList = $m_sci_LazyList$()
}
$c_sc_compat_immutable_package$.prototype = new $h_O();
$c_sc_compat_immutable_package$.prototype.constructor = $c_sc_compat_immutable_package$;
/** @constructor */
function $h_sc_compat_immutable_package$() {
  /*<skip>*/
}
$h_sc_compat_immutable_package$.prototype = $c_sc_compat_immutable_package$.prototype;
var $d_sc_compat_immutable_package$ = new $TypeData().initClass({
  sc_compat_immutable_package$: 0
}, false, "scala.collection.compat.immutable.package$", {
  sc_compat_immutable_package$: 1,
  O: 1
});
$c_sc_compat_immutable_package$.prototype.$classData = $d_sc_compat_immutable_package$;
var $n_sc_compat_immutable_package$;
function $m_sc_compat_immutable_package$() {
  if ((!$n_sc_compat_immutable_package$)) {
    $n_sc_compat_immutable_package$ = new $c_sc_compat_immutable_package$()
  };
  return $n_sc_compat_immutable_package$
}
function $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set($thiz, s) {
  if ((s === null)) {
    return null
  } else if ((s instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper)) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$JSetWrapper(s);
    var wrapped = x3.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying;
    return wrapped
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$SetWrapper(s)
  }
}
/** @constructor */
function $c_sc_convert_AsJavaExtensions$SetHasAsJava(outer, s) {
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = null;
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_$outer = null;
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = s;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_convert_AsJavaExtensions$SetHasAsJava__f_$outer = outer
  }
}
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = new $h_O();
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.constructor = $c_sc_convert_AsJavaExtensions$SetHasAsJava;
/** @constructor */
function $h_sc_convert_AsJavaExtensions$SetHasAsJava() {
  /*<skip>*/
}
$h_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = $c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype;
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.asJava__ju_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s;
  return $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set(this$1, s)
});
var $d_sc_convert_AsJavaExtensions$SetHasAsJava = new $TypeData().initClass({
  sc_convert_AsJavaExtensions$SetHasAsJava: 0
}, false, "scala.collection.convert.AsJavaExtensions$SetHasAsJava", {
  sc_convert_AsJavaExtensions$SetHasAsJava: 1,
  O: 1
});
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.$classData = $d_sc_convert_AsJavaExtensions$SetHasAsJava;
function $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($thiz, i) {
  if ((i === null)) {
    return null
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(i);
    var wrapped = x3.underlying__sc_Iterator();
    return wrapped
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(i)
  }
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($thiz, s) {
  if ((s === null)) {
    return null
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(s);
    var wrapped = x3.underlying__scm_Set();
    return wrapped
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JSetWrapper(s)
  }
}
/** @constructor */
function $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(outer, i) {
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = null;
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_$outer = null;
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = i;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_$outer = outer
  }
}
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$IteratorHasAsScala() {
  /*<skip>*/
}
$h_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.asScala__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var i = this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator(this$1, i)
});
var $d_sc_convert_AsScalaExtensions$IteratorHasAsScala = new $TypeData().initClass({
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 0
}, false, "scala.collection.convert.AsScalaExtensions$IteratorHasAsScala", {
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 1,
  O: 1
});
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.$classData = $d_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $c_sc_convert_AsScalaExtensions$SetHasAsScala(outer, s) {
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = null;
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_$outer = null;
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = s;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_convert_AsScalaExtensions$SetHasAsScala__f_$outer = outer
  }
}
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$SetHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$SetHasAsScala() {
  /*<skip>*/
}
$h_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.asScala__scm_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set(this$1, s)
});
var $d_sc_convert_AsScalaExtensions$SetHasAsScala = new $TypeData().initClass({
  sc_convert_AsScalaExtensions$SetHasAsScala: 0
}, false, "scala.collection.convert.AsScalaExtensions$SetHasAsScala", {
  sc_convert_AsScalaExtensions$SetHasAsScala: 1,
  O: 1
});
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.$classData = $d_sc_convert_AsScalaExtensions$SetHasAsScala;
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth)
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = node.payloadArity__I()
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $thiz.sci_ChampBaseIterator__f_nodes.set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(cursorIndex, 0);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(lengthIndex, node.nodeArity__I())
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(cursorIndex);
    var nodeLength = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      ev$1.set(cursorIndex, ((1 + ev$1.get(cursorIndex)) | 0));
      var nextNode = $thiz.sci_ChampBaseIterator__f_nodes.get($thiz.sci_ChampBaseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      if (nextNode.hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode)
      };
      if (nextNode.hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz)
    }
  };
  return false
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode)
  };
  if (rootNode.hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode)
  };
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null
}
$c_sci_ChampBaseIterator.prototype = new $h_O();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this))
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + node.payloadArity__I()) | 0)
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + node.nodeArity__I()) | 0))
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + nodeCursor) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode)
    } else {
      var currNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true
      }
    }
  };
  return false
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_O();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this))
});
function $p_sci_IndexedSeqDefaults$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 64
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $p_sci_IndexedSeqDefaults$__liftedTree1$1__I(this)
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
  /*<skip>*/
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass({
  sci_IndexedSeqDefaults$: 0
}, false, "scala.collection.immutable.IndexedSeqDefaults$", {
  sci_IndexedSeqDefaults$: 1,
  O: 1
});
$c_sci_IndexedSeqDefaults$.prototype.$classData = $d_sci_IndexedSeqDefaults$;
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$()
  };
  return $n_sci_IndexedSeqDefaults$
}
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
  /*<skip>*/
}
$c_sci_LazyList$Deferrer$.prototype = new $h_O();
$c_sci_LazyList$Deferrer$.prototype.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
  /*<skip>*/
}
$h_sci_LazyList$Deferrer$.prototype = $c_sci_LazyList$Deferrer$.prototype;
$c_sci_LazyList$Deferrer$.prototype.$hash$colon$colon$extension__F0__F0__sci_LazyList = (function(this$, elem) {
  $m_sci_LazyList$();
  var state$1 = new $c_sjsr_AnonFunction0(((this$1, elem$1, this$$1) => (() => {
    $m_sci_LazyList$();
    var hd = elem$1.apply__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0(((this$2, \u03b4this$1) => (() => $as_sci_LazyList(\u03b4this$1.apply__O()).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))(this$1, this$$1));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  }))(this, elem, this$));
  return new $c_sci_LazyList(state$1)
});
var $d_sci_LazyList$Deferrer$ = new $TypeData().initClass({
  sci_LazyList$Deferrer$: 0
}, false, "scala.collection.immutable.LazyList$Deferrer$", {
  sci_LazyList$Deferrer$: 1,
  O: 1
});
$c_sci_LazyList$Deferrer$.prototype.$classData = $d_sci_LazyList$Deferrer$;
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$()
  };
  return $n_sci_LazyList$Deferrer$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = null
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList$State = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__state;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized")
  };
  return $as_sci_LazyList$State(state.apply__O())
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__state !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized")
  };
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = state
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass({
  sci_LazyList$LazyBuilder$DeferredState: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", {
  sci_LazyList$LazyBuilder$DeferredState: 1,
  O: 1
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.$classData = $d_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
  /*<skip>*/
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass({
  sci_MapNode$: 0
}, false, "scala.collection.immutable.MapNode$", {
  sci_MapNode$: 1,
  O: 1
});
$c_sci_MapNode$.prototype.$classData = $d_sci_MapNode$;
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$()
  };
  return $n_sci_MapNode$
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_sr_ScalaRunTime$().array_length__O__I(as)) | 0)))
}
/** @constructor */
function $c_sci_Node() {
  /*<skip>*/
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
  /*<skip>*/
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > (((-1) + as.u.length) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I((((-1) + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + ((as.u.length - ix) | 0)) | 0);
  as.copyTo(srcPos, result, ix, length);
  return result
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > as.u.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
});
var $d_sci_Node = new $TypeData().initClass({
  sci_Node: 0
}, false, "scala.collection.immutable.Node", {
  sci_Node: 1,
  O: 1
});
$c_sci_Node.prototype.$classData = $d_sci_Node;
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)))
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
  /*<skip>*/
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0))
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask)
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos))
});
var $d_sci_Node$ = new $TypeData().initClass({
  sci_Node$: 0
}, false, "scala.collection.immutable.Node$", {
  sci_Node$: 1,
  O: 1
});
$c_sci_Node$.prototype.$classData = $d_sci_Node$;
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$()
  };
  return $n_sci_Node$
}
function $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = tree;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = tree;
      $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f)
    };
    var this$3 = tree;
    f.apply__O__O(this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    var this$4 = tree;
    if ((this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$5 = tree;
      tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue
    };
    return (void 0)
  }
}
function $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  return ((t === null) ? null : t.black__sci_RedBlackTree$Tree())
}
function $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  if ($thiz.isBlack__sci_RedBlackTree$Tree__Z(t)) {
    return t
  } else {
    var tree = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var $$x1 = true
    } else {
      var tree$1 = t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    };
    if ($$x1) {
      return t.black__sci_RedBlackTree$Tree()
    } else {
      return t
    }
  }
}
function $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, isBlack, key, value, left, right) {
  var sizeAndColour = (((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0) | (isBlack ? (-2147483648) : 0));
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, sizeAndColour)
}
function $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return tree
  } else if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = newLeft_left.black__sci_RedBlackTree$Tree();
      var resultRight = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else if (((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
    } else {
      return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
    }
  } else {
    return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
  }
}
function $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newRight) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return tree
  } else if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var resultLeft$2 = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.black__sci_RedBlackTree$Tree();
        return newRight.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
      }
    }
  } else {
    return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
  }
}
function $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, v, overwrite, ordering) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null)
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return (overwrite ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree)
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v, overwrite, ordering)) : ((cmp > 0) ? $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, overwrite, ordering)) : ((overwrite && (!Object.is(v, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))) ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree)))
  }
}
function $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree, idx, k, v) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null)
  } else {
    var rank = ((1 + $thiz.count__sci_RedBlackTree$Tree__I(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) | 0);
    return ((idx < rank) ? $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, idx, k, v)) : ((idx > rank) ? $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((idx - rank) | 0), k, v)) : tree))
  }
}
function $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return tree
    } else {
      var $$x1 = n;
      var this$1 = tree;
      if (($$x1 >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return null
      } else {
        var this$2 = tree;
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n > l)) {
          var this$3 = tree;
          var temp$tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var temp$n = (((-1) + ((n - l) | 0)) | 0);
          tree = temp$tree;
          n = temp$n
        } else if ((n === l)) {
          var this$4 = tree;
          var $$x3 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$5 = tree;
          var $$x2 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$6 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(null, $$x3, $$x2, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          var this$7 = tree;
          var $$x6 = $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, n);
          var this$8 = tree;
          var $$x5 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = tree;
          var $$x4 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x6, $$x5, $$x4, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return null
    } else {
      var this$1 = tree;
      if ((n >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return tree
      } else {
        var this$2 = tree;
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n <= l)) {
          var this$3 = tree;
          tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
        } else if ((n === ((1 + l) | 0))) {
          var this$4 = tree;
          var $$x2 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$5 = tree;
          var $$x1 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$6 = tree;
          return $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, $$x2, n, $$x1, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))
        } else {
          var this$7 = tree;
          var $$x5 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$8 = tree;
          var $$x4 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = tree;
          var $$x3 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x5, $$x4, $$x3, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-1) + ((n - l) | 0)) | 0)))
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, ordering) {
  if ((tree === null)) {
    return null
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp < 0)) {
      var newLeft = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, ordering);
      if ((newLeft === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
        return tree
      } else {
        var tree$1 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          return tree.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
        }
      }
    } else if ((cmp > 0)) {
      var newRight = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, ordering);
      if ((newRight === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
        return tree
      } else {
        var tree$2 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight)
        } else {
          return tree.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
        }
      }
    } else {
      return $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr.black__sci_RedBlackTree$Tree())
    } else {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        return tl.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
      } else {
        var tree$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
          var $$x2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var $$x1 = tl.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          return $$x2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x1, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
        } else {
          return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
        }
      }
    }
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    var tree$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((tree$3 !== null) && (tree$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tr.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree())
    } else {
      var tree$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$4 !== null) && (tree$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var $$x4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var this$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var $$x3 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        return $$x4.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x3, tr.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
      } else {
        return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
      }
    }
  } else {
    return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
  }
}
function $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr)
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr.red__sci_RedBlackTree$Tree())
  } else {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var $$x3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x2 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      return $$x3.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x2, $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tr, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.red__sci_RedBlackTree$Tree()))
    } else {
      $m_s_sys_package$().error__T__E("Defect: invariance violation")
    }
  }
}
function $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.black__sci_RedBlackTree$Tree())
  } else if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl.red__sci_RedBlackTree$Tree(), tr)
  } else {
    if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var $$x4 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x3 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.red__sci_RedBlackTree$Tree();
      var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x2 = $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, $$x3, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      return $$x4.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x2, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
    } else {
      $m_s_sys_package$().error__T__E("Defect: invariance violation")
    }
  }
}
function $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr) {
  if ((tl === null)) {
    return tr
  } else if ((tr === null)) {
    return tl
  } else if ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var bc = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      return (((bc !== null) && (bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc)))
    } else {
      return tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
    }
  } else if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    var bc$2 = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
    return (((bc$2 !== null) && (bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc$2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2)))
  } else {
    return tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))
  }
}
function $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, bhtl, rtr) {
  var rtl = ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0)));
  if ((rtl === (((rtr / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    var tlBlack = ((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtlr = (tlBlack ? (((-1) + bhtl) | 0) : bhtl);
    var ttr = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, tr, bhtlr, rtr);
    if ((tlBlack && ((ttr !== null) && (ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree())
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tlBlack, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr)
    }
  }
}
function $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, rtl, bhtr) {
  var rtr = ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0)));
  if ((rtr === (((rtl / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    var trBlack = ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtrl = (trBlack ? (((-1) + bhtr) | 0) : bhtr);
    var ttl = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, rtl, bhtrl);
    if ((trBlack && ((ttl !== null) && (ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, trBlack, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t, k2, ordering) {
  if ((t === null)) {
    return new $c_T4(null, null, null, k2)
  } else {
    var cmp = ordering.compare__O__O__I(k2, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp === 0)) {
      return new $c_T4(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
    } else if ((cmp < 0)) {
      var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k2, ordering);
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var ll = $as_sci_RedBlackTree$Tree(x1.T4__f__1);
      var b = $as_sci_RedBlackTree$Tree(x1.T4__f__2);
      var lr = $as_sci_RedBlackTree$Tree(x1.T4__f__3);
      var k1 = x1.T4__f__4;
      return new $c_T4(ll, b, $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(lr, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right), k1)
    } else {
      var x1$2 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k2, ordering);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var rl = $as_sci_RedBlackTree$Tree(x1$2.T4__f__1);
      var b$3 = $as_sci_RedBlackTree$Tree(x1$2.T4__f__2);
      var rr = $as_sci_RedBlackTree$Tree(x1$2.T4__f__3);
      var k1$3 = x1$2.T4__f__4;
      return new $c_T4($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, rl), b$3, rr, k1$3)
    }
  }
}
function $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t1 === t2))) {
    return t2
  } else if ((t2 === null)) {
    return t1
  } else {
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var l1 = $as_sci_RedBlackTree$Tree(x1.T4__f__1);
    var r1 = $as_sci_RedBlackTree$Tree(x1.T4__f__3);
    var k1 = x1.T4__f__4;
    var tl = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var tr = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, k1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tr)
  }
}
function $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  } else {
    var tl = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    return ((tl === null) ? tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl), tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) : tree.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))))
  }
}
function $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, level, size, maxUsedDepth$1, xs$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$1) || (level === 1)), xs$1.next__O(), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, maxUsedDepth$1, xs$1);
      var x = xs$1.next__O();
      var right = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), maxUsedDepth$1, xs$1);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(x, null, left, right)
    }
  }
}
function $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I($thiz, t, i) {
  while (true) {
    if ((t === null)) {
      return ((1 + i) | 0)
    } else {
      var this$1 = t;
      var temp$t = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$2 = t;
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var temp$i = ((1 + i) | 0)
      } else {
        var temp$i = i
      };
      t = temp$t;
      i = temp$i
    }
  }
}
/** @constructor */
function $c_sci_RedBlackTree$() {
  this.sci_RedBlackTree$__f_null2 = null;
  $n_sci_RedBlackTree$ = this;
  this.sci_RedBlackTree$__f_null2 = $ct_T2__O__O__(new $c_T2(), null, null)
}
$c_sci_RedBlackTree$.prototype = new $h_O();
$c_sci_RedBlackTree$.prototype.constructor = $c_sci_RedBlackTree$;
/** @constructor */
function $h_sci_RedBlackTree$() {
  /*<skip>*/
}
$h_sci_RedBlackTree$.prototype = $c_sci_RedBlackTree$.prototype;
$c_sci_RedBlackTree$.prototype.contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, x, evidence$1) {
  return (this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$1) !== null)
});
$c_sci_RedBlackTree$.prototype.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, x, ordering) {
  while (true) {
    if ((tree === null)) {
      return null
    } else {
      var this$1 = tree;
      var cmp = ordering.compare__O__O__I(x, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$2 = tree;
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else if ((cmp > 0)) {
        var this$3 = tree;
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      } else {
        return tree
      }
    }
  }
});
$c_sci_RedBlackTree$.prototype.count__sci_RedBlackTree$Tree__I = (function(tree) {
  return ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
});
$c_sci_RedBlackTree$.prototype.update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, v, overwrite, evidence$3) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, v, overwrite, evidence$3))
});
$c_sci_RedBlackTree$.prototype.delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, evidence$4) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, evidence$4))
});
$c_sci_RedBlackTree$.prototype.drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$10) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n))
});
$c_sci_RedBlackTree$.prototype.take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$11) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n))
});
$c_sci_RedBlackTree$.prototype.smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, tree))
});
$c_sci_RedBlackTree$.prototype.keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$13) {
  return ((a === b) || ((a !== null) && ((b !== null) && (((2147483647 & a.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === (2147483647 & b.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) && new $c_sci_RedBlackTree$EqualsIterator(a, evidence$13).sameKeys__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$13))))))
});
$c_sci_RedBlackTree$.prototype.foreachKey__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V(this, tree, f)
  }
});
$c_sci_RedBlackTree$.prototype.isBlack__sci_RedBlackTree$Tree__Z = (function(tree) {
  return ((tree === null) || (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))
});
$c_sci_RedBlackTree$.prototype.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, size)
});
$c_sci_RedBlackTree$.prototype.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, ((-2147483648) | size))
});
$c_sci_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree(this, 1, size, maxUsedDepth, xs)
});
$c_sci_RedBlackTree$.prototype.union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering))
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, k, v, tr) {
  var bhtl = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tl, 0);
  var bhtr = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tr, 0);
  if ((bhtl > bhtr)) {
    var tt = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, bhtl, ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0))));
    if (((tt !== null) && (tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree = tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return tt.black__sci_RedBlackTree$Tree()
    } else {
      return tt
    }
  } else if ((bhtr > bhtl)) {
    var tt$2 = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0))), bhtr);
    if (((tt$2 !== null) && (tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x2 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return tt$2.black__sci_RedBlackTree$Tree()
    } else {
      return tt$2
    }
  } else {
    return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) || ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))), k, v, tl, tr)
  }
});
var $d_sci_RedBlackTree$ = new $TypeData().initClass({
  sci_RedBlackTree$: 0
}, false, "scala.collection.immutable.RedBlackTree$", {
  sci_RedBlackTree$: 1,
  O: 1
});
$c_sci_RedBlackTree$.prototype.$classData = $d_sci_RedBlackTree$;
var $n_sci_RedBlackTree$;
function $m_sci_RedBlackTree$() {
  if ((!$n_sci_RedBlackTree$)) {
    $n_sci_RedBlackTree$ = new $c_sci_RedBlackTree$()
  };
  return $n_sci_RedBlackTree$
}
function $ct_sci_RedBlackTree$Helper__s_math_Ordering__($thiz, ordering) {
  $thiz.sci_RedBlackTree$Helper__f_ordering = ordering;
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$Helper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$Helper.prototype = new $h_O();
$c_sci_RedBlackTree$Helper.prototype.constructor = $c_sci_RedBlackTree$Helper;
/** @constructor */
function $h_sci_RedBlackTree$Helper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Helper.prototype = $c_sci_RedBlackTree$Helper.prototype;
$c_sci_RedBlackTree$Helper.prototype.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    return tree
  } else if (((2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var res = tree.mutableBlack__sci_RedBlackTree$Tree().makeImmutable__sci_RedBlackTree$Tree();
    return res
  } else {
    return tree.black__sci_RedBlackTree$Tree()
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newLeft) {
  if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (($m_sci_RedBlackTree$(), ((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var resultLeft = newLeft_left.mutableBlack__sci_RedBlackTree$Tree();
      var resultRight = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else if (($m_sci_RedBlackTree$(), ((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
    } else {
      return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
    }
  } else {
    return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newRight) {
  if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (($m_sci_RedBlackTree$(), ((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var resultLeft = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (($m_sci_RedBlackTree$(), ((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
        var resultLeft$2 = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.mutableBlack__sci_RedBlackTree$Tree();
        return newRight.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
      }
    }
  } else {
    return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
  }
});
function $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__sci_RedBlackTree$Tree($thiz) {
  if (((2147483647 & $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var size = 1;
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.makeImmutable__sci_RedBlackTree$Tree();
      var $$x1 = size;
      var this$1 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      size = (($$x1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.makeImmutable__sci_RedBlackTree$Tree();
      var $$x2 = size;
      var this$2 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      size = (($$x2 + (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = ($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count | size)
  };
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$Tree(_key, _value, _left, _right, _count) {
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = 0;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = _key;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = _value;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = _left;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = _right;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = _count
}
$c_sci_RedBlackTree$Tree.prototype = new $h_O();
$c_sci_RedBlackTree$Tree.prototype.constructor = $c_sci_RedBlackTree$Tree;
/** @constructor */
function $h_sci_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Tree.prototype = $c_sci_RedBlackTree$Tree.prototype;
$c_sci_RedBlackTree$Tree.prototype.toString__T = (function() {
  return (((((((((((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? "RedTree" : "BlackTree") + "(") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) + ")")
});
$c_sci_RedBlackTree$Tree.prototype.makeImmutable__sci_RedBlackTree$Tree = (function() {
  $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__sci_RedBlackTree$Tree(this);
  return this
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlack__sci_RedBlackTree$Tree = (function() {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.black__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.red__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.withV__O__sci_RedBlackTree$Tree = (function(newValue) {
  return (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
});
$c_sci_RedBlackTree$Tree.prototype.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) | size))
  }
});
function $as_sci_RedBlackTree$Tree(obj) {
  return (((obj instanceof $c_sci_RedBlackTree$Tree) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.RedBlackTree$Tree"))
}
function $isArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_RedBlackTree$Tree)))
}
function $asArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (($isArrayOf_sci_RedBlackTree$Tree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.RedBlackTree$Tree;", depth))
}
var $d_sci_RedBlackTree$Tree = new $TypeData().initClass({
  sci_RedBlackTree$Tree: 0
}, false, "scala.collection.immutable.RedBlackTree$Tree", {
  sci_RedBlackTree$Tree: 1,
  O: 1
});
$c_sci_RedBlackTree$Tree.prototype.$classData = $d_sci_RedBlackTree$Tree;
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
  /*<skip>*/
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass({
  sci_SetNode$: 0
}, false, "scala.collection.immutable.SetNode$", {
  sci_SetNode$: 1,
  O: 1
});
$c_sci_SetNode$.prototype.$classData = $d_sci_SetNode$;
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$()
  };
  return $n_sci_SetNode$
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === a$1.u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)))
    } else {
      var bitsN = Math.imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $$x1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x1, (((loN === 0) && (hiN === a$2.u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)))
        } else {
          if ((hiN > loN)) {
            var $$x2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x2, (((loN === 0) && (hiN === a$3.u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)))
          };
          var temp$n = (((-1) + n) | 0);
          var temp$a = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = $asArrayOf_O(a.get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), $asArrayOf_O(a.get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x3, (((start$1 === 0) && (hiN === a$4.u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)))
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x4, (((start$2 === 0) && (hiN === a$5.u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)))
          };
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue
        }
      }
    };
    return (void 0)
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0)
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0)
  };
  $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(idx, a)
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($$x1.get((((-1) + n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), preN1.get(0));
      if ((preN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set((((-1) + n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get(((11 - n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = preN1.u.length;
        $$x5.set((((-1) + n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to))
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($$x1.get(((11 - n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), sufN1.get((((-1) + sufN1.u.length) | 0)));
      if ((sufN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get((((-1) + n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + sufN1.u.length) | 0);
        $$x5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to))
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
  /*<skip>*/
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul(a.u.length, (1 << Math.imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0)
  };
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0)
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$()
    } else {
      var prefix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
      var suffix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = ((prefix1.u.length + suffix1.u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = prefix1.u.length;
          var length = suffix1.u.length;
          suffix1.copyTo(0, dest, destPos, length);
          var a = dest
        } else {
          var a = prefix1
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1
      } else {
        var prefix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1), 2);
        if ((prefix2 !== null)) {
          var a = prefix2.get(0)
        } else {
          var suffix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9), 2);
          var a = suffix2.get(0)
        }
      };
      return new $c_sci_Vector1(a)
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $$x1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $$x1.get((((-1) + n) | 0));
      var $$x2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $$x2.get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.u.length + suf.u.length) | 0) <= 30)) {
          var $$x3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = ((pre.u.length + suf.u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = pre.u.length;
          var length$1 = suf.u.length;
          suf.copyTo(0, dest$1, destPos$1, length$1);
          $$x3.set((((-1) + n$2) | 0), dest$1);
          var $$x4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $$x4.set(((11 - n$3) | 0), null)
        } else {
          resultDim = ((1 + resultDim) | 0)
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if ((one.u.length > 30)) {
          resultDim = ((1 + resultDim) | 0)
        }
      }
    };
    var prefix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
    var suffix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
    var len1 = prefix1$2.u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        if ((p !== null)) {
          var $$x5 = p
        } else {
          var s = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
          var $$x5 = ((s !== null) ? s : a$1)
        };
        var data2 = $asArrayOf_O($$x5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        if ((p$2 !== null)) {
          var $$x6 = p$2
        } else {
          var s$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
          var $$x6 = ((s$1 !== null) ? s$1 : a$3)
        };
        var data3 = $asArrayOf_O($$x6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + (prefix2$2.u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        if ((p$5 !== null)) {
          var $$x7 = p$5
        } else {
          var s$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
          var $$x7 = ((s$3 !== null) ? s$3 : a$7)
        };
        var data4 = $asArrayOf_O($$x7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + (prefix2$3.u.length << 5)) | 0);
        var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        if ((p$9 !== null)) {
          var $$x8 = p$9
        } else {
          var s$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
          var $$x8 = ((s$6 !== null) ? s$6 : a$13)
        };
        var data5 = $asArrayOf_O($$x8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + (prefix2$4.u.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
        var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
        if ((p$14 !== null)) {
          var $$x9 = p$14
        } else {
          var s$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
          var $$x9 = ((s$10 !== null) ? s$10 : a$21)
        };
        var data6 = $asArrayOf_O($$x9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + (prefix2$5.u.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
        var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1)
      }
    };
    return res
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")")
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass({
  sci_VectorSliceBuilder: 0
}, false, "scala.collection.immutable.VectorSliceBuilder", {
  sci_VectorSliceBuilder: 1,
  O: 1
});
$c_sci_VectorSliceBuilder.prototype.$classData = $d_sci_VectorSliceBuilder;
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0)
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
  /*<skip>*/
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = a.u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  a.copyTo(0, ac, 0, alen);
  ac.set(alen, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + a.u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  ac.set((((-1) + ac.u.length) | 0), elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + a.u.length) | 0));
  var length = a.u.length;
  a.copyTo(0, ac, 1, length);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = ((1 + a.u.length) | 0);
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  var length$1 = a.u.length;
  a.copyTo(0, ac, 1, length$1);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = a.u.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.apply__O__O(a.get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O(a.get(i), 1), f);
      i = ((1 + i) | 0)
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < a.u.length)) {
    var v1 = a.get(i);
    var v2 = f.apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2)
    };
    i = ((1 + i) | 0)
  };
  return a
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O(a.u.length);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, f.apply__O__O(a.get(i)));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f)
  } else {
    var i = 0;
    while ((i < a.u.length)) {
      var v1 = a.get(i);
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2)
      };
      i = ((1 + i) | 0)
    };
    return a
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = a.u.length;
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(a.get(i), 1), f));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if ((x2.sizeCompare__I__I(((32 - suffix1.u.length) | 0)) <= 0)) {
      var x1$2 = x2.size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, x2.head__O());
          break
        }
        default: {
          var newLength = ((suffix1.u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var start = suffix1.u.length;
          x2.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b
        }
      }
    } else {
      return null
    }
  } else {
    var s = xs.knownSize__I();
    if (((s > 0) && (s <= ((32 - suffix1.u.length) | 0)))) {
      var newLength$1 = ((suffix1.u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$1 = xs.iterator__sc_Iterator();
      var start$1 = suffix1.u.length;
      this$1.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2
    } else {
      return null
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass({
  sci_VectorStatics$: 0
}, false, "scala.collection.immutable.VectorStatics$", {
  sci_VectorStatics$: 1,
  O: 1
});
$c_sci_VectorStatics$.prototype.$classData = $d_sci_VectorStatics$;
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$()
  };
  return $n_sci_VectorStatics$
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
  /*<skip>*/
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashMap$Node__f__key))) {
      return _$this
    } else if (((_$this.scm_HashMap$Node__f__next === null) || (_$this.scm_HashMap$Node__f__hash > h))) {
      return null
    } else {
      _$this = _$this.scm_HashMap$Node__f__next
    }
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O__O(_$this.scm_HashMap$Node__f__key, _$this.scm_HashMap$Node__f__value);
    if ((_$this.scm_HashMap$Node__f__next !== null)) {
      _$this = _$this.scm_HashMap$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next)
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"))
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)))
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth))
}
var $d_scm_HashMap$Node = new $TypeData().initClass({
  scm_HashMap$Node: 0
}, false, "scala.collection.mutable.HashMap$Node", {
  scm_HashMap$Node: 1,
  O: 1
});
$c_scm_HashMap$Node.prototype.$classData = $d_scm_HashMap$Node;
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next
}
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
  /*<skip>*/
}
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashSet$Node__f__key))) {
      return _$this
    } else if (((_$this.scm_HashSet$Node__f__next === null) || (_$this.scm_HashSet$Node__f__hash > h))) {
      return null
    } else {
      _$this = _$this.scm_HashSet$Node__f__next
    }
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next)
});
function $as_scm_HashSet$Node(obj) {
  return (((obj instanceof $c_scm_HashSet$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet$Node"))
}
function $isArrayOf_scm_HashSet$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet$Node)))
}
function $asArrayOf_scm_HashSet$Node(obj, depth) {
  return (($isArrayOf_scm_HashSet$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet$Node;", depth))
}
var $d_scm_HashSet$Node = new $TypeData().initClass({
  scm_HashSet$Node: 0
}, false, "scala.collection.mutable.HashSet$Node", {
  scm_HashSet$Node: 1,
  O: 1
});
$c_scm_HashSet$Node.prototype.$classData = $d_scm_HashSet$Node;
/** @constructor */
function $c_scm_MutationTracker$() {
  /*<skip>*/
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
  /*<skip>*/
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message)
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass({
  scm_MutationTracker$: 0
}, false, "scala.collection.mutable.MutationTracker$", {
  scm_MutationTracker$: 1,
  O: 1
});
$c_scm_MutationTracker$.prototype.$classData = $d_scm_MutationTracker$;
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$()
  };
  return $n_scm_MutationTracker$
}
function $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($thiz, node, key, ord) {
  while (true) {
    if ((node === null)) {
      return null
    } else {
      var cmp = ord.compare__O__O__I(key, node.scm_RedBlackTree$Node__f_key);
      if ((cmp < 0)) {
        node = node.scm_RedBlackTree$Node__f_left
      } else if ((cmp > 0)) {
        node = node.scm_RedBlackTree$Node__f_right
      } else {
        return node
      }
    }
  }
}
function $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($thiz, node) {
  return ((node === null) ? null : $thiz.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
}
function $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, node) {
  var z = node;
  while ($thiz.isRed__scm_RedBlackTree$Node__Z(z.scm_RedBlackTree$Node__f_parent)) {
    if ((z.scm_RedBlackTree$Node__f_parent === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
      var y = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y)) {
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        y.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        z = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right)) {
          z = z.scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent)
      }
    } else {
      var y$2 = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y$2)) {
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        y$2.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        z = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
          z = z.scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent)
      }
    }
  };
  tree.scm_RedBlackTree$Tree__f_root.scm_RedBlackTree$Node__f_red = false
}
function $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, node, parent) {
  var x = node;
  var xParent = parent;
  while (((x !== tree.scm_RedBlackTree$Tree__f_root) && $thiz.isBlack__scm_RedBlackTree$Node__Z(x))) {
    if ((x === xParent.scm_RedBlackTree$Node__f_left)) {
      var w = xParent.scm_RedBlackTree$Node__f_right;
      if (w.scm_RedBlackTree$Node__f_red) {
        w.scm_RedBlackTree$Node__f_red = false;
        xParent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w = xParent.scm_RedBlackTree$Node__f_right
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_left) && $thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_right))) {
        w.scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_right)) {
          w.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_red = false;
          w.scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w);
          w = xParent.scm_RedBlackTree$Node__f_right
        };
        w.scm_RedBlackTree$Node__f_red = xParent.scm_RedBlackTree$Node__f_red;
        xParent.scm_RedBlackTree$Node__f_red = false;
        w.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = tree.scm_RedBlackTree$Tree__f_root
      }
    } else {
      var w$2 = xParent.scm_RedBlackTree$Node__f_left;
      if (w$2.scm_RedBlackTree$Node__f_red) {
        w$2.scm_RedBlackTree$Node__f_red = false;
        xParent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w$2 = xParent.scm_RedBlackTree$Node__f_left
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_right) && $thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_left))) {
        w$2.scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_left)) {
          w$2.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_red = false;
          w$2.scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w$2);
          w$2 = xParent.scm_RedBlackTree$Node__f_left
        };
        w$2.scm_RedBlackTree$Node__f_red = xParent.scm_RedBlackTree$Node__f_red;
        xParent.scm_RedBlackTree$Node__f_red = false;
        w$2.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = tree.scm_RedBlackTree$Tree__f_root
      }
    };
    xParent = x.scm_RedBlackTree$Node__f_parent
  };
  if ((x !== null)) {
    x.scm_RedBlackTree$Node__f_red = false
  }
}
function $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = x.scm_RedBlackTree$Node__f_right;
    x.scm_RedBlackTree$Node__f_right = y.scm_RedBlackTree$Node__f_left;
    if ((y.scm_RedBlackTree$Node__f_left !== null)) {
      y.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = x
    };
    y.scm_RedBlackTree$Node__f_parent = x.scm_RedBlackTree$Node__f_parent;
    if ((x.scm_RedBlackTree$Node__f_parent === null)) {
      tree.scm_RedBlackTree$Tree__f_root = y
    } else if ((x === x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = y
    } else {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = y
    };
    y.scm_RedBlackTree$Node__f_left = x;
    x.scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = x.scm_RedBlackTree$Node__f_left;
    x.scm_RedBlackTree$Node__f_left = y.scm_RedBlackTree$Node__f_right;
    if ((y.scm_RedBlackTree$Node__f_right !== null)) {
      y.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = x
    };
    y.scm_RedBlackTree$Node__f_parent = x.scm_RedBlackTree$Node__f_parent;
    if ((x.scm_RedBlackTree$Node__f_parent === null)) {
      tree.scm_RedBlackTree$Tree__f_root = y
    } else if ((x === x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right)) {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = y
    } else {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = y
    };
    y.scm_RedBlackTree$Node__f_right = x;
    x.scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, to, from) {
  if ((to.scm_RedBlackTree$Node__f_parent === null)) {
    tree.scm_RedBlackTree$Tree__f_root = from
  } else if ((to === to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
    to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = from
  } else {
    to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = from
  };
  if ((from !== null)) {
    from.scm_RedBlackTree$Node__f_parent = to.scm_RedBlackTree$Node__f_parent
  }
}
function $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, level, size, xs$1, maxUsedDepth$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return new $c_scm_RedBlackTree$Node(xs$1.next__O(), null, ((level === maxUsedDepth$1) && (level !== 1)), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), leftSize, xs$1, maxUsedDepth$1);
      var x = xs$1.next__O();
      var right = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$1, maxUsedDepth$1);
      var n = new $c_scm_RedBlackTree$Node(x, null, false, left, right, null);
      if ((left !== null)) {
        left.scm_RedBlackTree$Node__f_parent = n
      };
      right.scm_RedBlackTree$Node__f_parent = n;
      return n
    }
  }
}
/** @constructor */
function $c_scm_RedBlackTree$() {
  /*<skip>*/
}
$c_scm_RedBlackTree$.prototype = new $h_O();
$c_scm_RedBlackTree$.prototype.constructor = $c_scm_RedBlackTree$;
/** @constructor */
function $h_scm_RedBlackTree$() {
  /*<skip>*/
}
$h_scm_RedBlackTree$.prototype = $c_scm_RedBlackTree$.prototype;
$c_scm_RedBlackTree$.prototype.isRed__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node !== null) && node.scm_RedBlackTree$Node__f_red)
});
$c_scm_RedBlackTree$.prototype.isBlack__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node === null) || (!node.scm_RedBlackTree$Node__f_red))
});
$c_scm_RedBlackTree$.prototype.isEmpty__scm_RedBlackTree$Tree__Z = (function(tree) {
  return (tree.scm_RedBlackTree$Tree__f_root === null)
});
$c_scm_RedBlackTree$.prototype.contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, key, evidence$2) {
  return ($p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root, key, evidence$2) !== null)
});
$c_scm_RedBlackTree$.prototype.minKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = this.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  return ((node === null) ? null : this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
});
$c_scm_RedBlackTree$.prototype.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if ((node.scm_RedBlackTree$Node__f_left === null)) {
      return node
    } else {
      node = node.scm_RedBlackTree$Node__f_left
    }
  }
});
$c_scm_RedBlackTree$.prototype.maxKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if ((node.scm_RedBlackTree$Node__f_right === null)) {
      return node
    } else {
      node = node.scm_RedBlackTree$Node__f_right
    }
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node = (function(node, key, ord) {
  if ((node === null)) {
    return null
  } else {
    var y = null;
    var x = node;
    var cmp = 1;
    while (((x !== null) && (cmp !== 0))) {
      y = x;
      cmp = ord.compare__O__O__I(key, x.scm_RedBlackTree$Node__f_key);
      x = ((cmp < 0) ? x.scm_RedBlackTree$Node__f_left : x.scm_RedBlackTree$Node__f_right)
    };
    return ((cmp <= 0) ? y : this.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(y))
  }
});
$c_scm_RedBlackTree$.prototype.insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V = (function(tree, key, value, ord) {
  var y = null;
  var x = tree.scm_RedBlackTree$Tree__f_root;
  var cmp = 1;
  while (((x !== null) && (cmp !== 0))) {
    y = x;
    cmp = ord.compare__O__O__I(key, x.scm_RedBlackTree$Node__f_key);
    x = ((cmp < 0) ? x.scm_RedBlackTree$Node__f_left : x.scm_RedBlackTree$Node__f_right)
  };
  if ((cmp === 0)) {
    y.scm_RedBlackTree$Node__f_value = value
  } else {
    var parent = y;
    var z = new $c_scm_RedBlackTree$Node(key, value, true, null, null, parent);
    if ((y === null)) {
      tree.scm_RedBlackTree$Tree__f_root = z
    } else if ((cmp < 0)) {
      y.scm_RedBlackTree$Node__f_left = z
    } else {
      y.scm_RedBlackTree$Node__f_right = z
    };
    $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V(this, tree, z);
    tree.scm_RedBlackTree$Tree__f_size = ((1 + tree.scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V = (function(tree, key, ord) {
  var z = $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root, key, ord);
  if ((z !== null)) {
    var y = z;
    var yIsRed = y.scm_RedBlackTree$Node__f_red;
    var x = null;
    var xParent = null;
    if ((z.scm_RedBlackTree$Node__f_left === null)) {
      x = z.scm_RedBlackTree$Node__f_right;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, z.scm_RedBlackTree$Node__f_right);
      xParent = z.scm_RedBlackTree$Node__f_parent
    } else if ((z.scm_RedBlackTree$Node__f_right === null)) {
      x = z.scm_RedBlackTree$Node__f_left;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, z.scm_RedBlackTree$Node__f_left);
      xParent = z.scm_RedBlackTree$Node__f_parent
    } else {
      y = this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(z.scm_RedBlackTree$Node__f_right);
      yIsRed = y.scm_RedBlackTree$Node__f_red;
      x = y.scm_RedBlackTree$Node__f_right;
      if ((y.scm_RedBlackTree$Node__f_parent === z)) {
        xParent = y
      } else {
        xParent = y.scm_RedBlackTree$Node__f_parent;
        $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, y, y.scm_RedBlackTree$Node__f_right);
        y.scm_RedBlackTree$Node__f_right = z.scm_RedBlackTree$Node__f_right;
        y.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = y
      };
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, y);
      y.scm_RedBlackTree$Node__f_left = z.scm_RedBlackTree$Node__f_left;
      y.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = y;
      y.scm_RedBlackTree$Node__f_red = z.scm_RedBlackTree$Node__f_red
    };
    if ((!yIsRed)) {
      $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, x, xParent)
    };
    tree.scm_RedBlackTree$Tree__f_size = (((-1) + tree.scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  if ((node.scm_RedBlackTree$Node__f_right !== null)) {
    return this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node.scm_RedBlackTree$Node__f_right)
  } else {
    var x = node;
    var y = x.scm_RedBlackTree$Node__f_parent;
    while (((y !== null) && (x === y.scm_RedBlackTree$Node__f_right))) {
      x = y;
      y = y.scm_RedBlackTree$Node__f_parent
    };
    return y
  }
});
$c_scm_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return new $c_scm_RedBlackTree$Tree($p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node(this, 1, size, xs, maxUsedDepth), size)
});
$c_scm_RedBlackTree$.prototype.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(n) {
  if ((n === null)) {
    return null
  } else {
    var c = new $c_scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_key, n.scm_RedBlackTree$Node__f_value, n.scm_RedBlackTree$Node__f_red, this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_left), this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_right), null);
    if ((c.scm_RedBlackTree$Node__f_left !== null)) {
      c.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = c
    };
    if ((c.scm_RedBlackTree$Node__f_right !== null)) {
      c.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = c
    };
    return c
  }
});
var $d_scm_RedBlackTree$ = new $TypeData().initClass({
  scm_RedBlackTree$: 0
}, false, "scala.collection.mutable.RedBlackTree$", {
  scm_RedBlackTree$: 1,
  O: 1
});
$c_scm_RedBlackTree$.prototype.$classData = $d_scm_RedBlackTree$;
var $n_scm_RedBlackTree$;
function $m_scm_RedBlackTree$() {
  if ((!$n_scm_RedBlackTree$)) {
    $n_scm_RedBlackTree$ = new $c_scm_RedBlackTree$()
  };
  return $n_scm_RedBlackTree$
}
/** @constructor */
function $c_scm_RedBlackTree$Node(key, value, red, left, right, parent) {
  this.scm_RedBlackTree$Node__f_key = null;
  this.scm_RedBlackTree$Node__f_value = null;
  this.scm_RedBlackTree$Node__f_red = false;
  this.scm_RedBlackTree$Node__f_left = null;
  this.scm_RedBlackTree$Node__f_right = null;
  this.scm_RedBlackTree$Node__f_parent = null;
  this.scm_RedBlackTree$Node__f_key = key;
  this.scm_RedBlackTree$Node__f_value = value;
  this.scm_RedBlackTree$Node__f_red = red;
  this.scm_RedBlackTree$Node__f_left = left;
  this.scm_RedBlackTree$Node__f_right = right;
  this.scm_RedBlackTree$Node__f_parent = parent
}
$c_scm_RedBlackTree$Node.prototype = new $h_O();
$c_scm_RedBlackTree$Node.prototype.constructor = $c_scm_RedBlackTree$Node;
/** @constructor */
function $h_scm_RedBlackTree$Node() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Node.prototype = $c_scm_RedBlackTree$Node.prototype;
$c_scm_RedBlackTree$Node.prototype.toString__T = (function() {
  return (((((((((("Node(" + this.scm_RedBlackTree$Node__f_key) + ", ") + this.scm_RedBlackTree$Node__f_value) + ", ") + this.scm_RedBlackTree$Node__f_red) + ", ") + this.scm_RedBlackTree$Node__f_left) + ", ") + this.scm_RedBlackTree$Node__f_right) + ")")
});
var $d_scm_RedBlackTree$Node = new $TypeData().initClass({
  scm_RedBlackTree$Node: 0
}, false, "scala.collection.mutable.RedBlackTree$Node", {
  scm_RedBlackTree$Node: 1,
  O: 1
});
$c_scm_RedBlackTree$Node.prototype.$classData = $d_scm_RedBlackTree$Node;
/** @constructor */
function $c_scm_RedBlackTree$Tree(root, size) {
  this.scm_RedBlackTree$Tree__f_root = null;
  this.scm_RedBlackTree$Tree__f_size = 0;
  this.scm_RedBlackTree$Tree__f_root = root;
  this.scm_RedBlackTree$Tree__f_size = size
}
$c_scm_RedBlackTree$Tree.prototype = new $h_O();
$c_scm_RedBlackTree$Tree.prototype.constructor = $c_scm_RedBlackTree$Tree;
/** @constructor */
function $h_scm_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Tree.prototype = $c_scm_RedBlackTree$Tree.prototype;
$c_scm_RedBlackTree$Tree.prototype.treeCopy__scm_RedBlackTree$Tree = (function() {
  return new $c_scm_RedBlackTree$Tree($m_scm_RedBlackTree$().copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this.scm_RedBlackTree$Tree__f_root), this.scm_RedBlackTree$Tree__f_size)
});
var $d_scm_RedBlackTree$Tree = new $TypeData().initClass({
  scm_RedBlackTree$Tree: 0
}, false, "scala.collection.mutable.RedBlackTree$Tree", {
  scm_RedBlackTree$Tree: 1,
  O: 1
});
$c_scm_RedBlackTree$Tree.prototype.$classData = $d_scm_RedBlackTree$Tree;
function $is_scm_Shrinkable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Shrinkable)))
}
function $as_scm_Shrinkable(obj) {
  return (($is_scm_Shrinkable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Shrinkable"))
}
function $isArrayOf_scm_Shrinkable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Shrinkable)))
}
function $asArrayOf_scm_Shrinkable(obj, depth) {
  return (($isArrayOf_scm_Shrinkable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Shrinkable;", depth))
}
/** @constructor */
function $c_sc_package$$colon$plus$() {
  /*<skip>*/
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
  /*<skip>*/
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
var $d_sc_package$$colon$plus$ = new $TypeData().initClass({
  sc_package$$colon$plus$: 0
}, false, "scala.collection.package$$colon$plus$", {
  sc_package$$colon$plus$: 1,
  O: 1
});
$c_sc_package$$colon$plus$.prototype.$classData = $d_sc_package$$colon$plus$;
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$()
  };
  return $n_sc_package$$colon$plus$
}
/** @constructor */
function $c_sc_package$$plus$colon$() {
  /*<skip>*/
}
$c_sc_package$$plus$colon$.prototype = new $h_O();
$c_sc_package$$plus$colon$.prototype.constructor = $c_sc_package$$plus$colon$;
/** @constructor */
function $h_sc_package$$plus$colon$() {
  /*<skip>*/
}
$h_sc_package$$plus$colon$.prototype = $c_sc_package$$plus$colon$.prototype;
var $d_sc_package$$plus$colon$ = new $TypeData().initClass({
  sc_package$$plus$colon$: 0
}, false, "scala.collection.package$$plus$colon$", {
  sc_package$$plus$colon$: 1,
  O: 1
});
$c_sc_package$$plus$colon$.prototype.$classData = $d_sc_package$$plus$colon$;
var $n_sc_package$$plus$colon$;
function $m_sc_package$$plus$colon$() {
  if ((!$n_sc_package$$plus$colon$)) {
    $n_sc_package$$plus$colon$ = new $c_sc_package$$plus$colon$()
  };
  return $n_sc_package$$plus$colon$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $as_s_concurrent_duration_package$DurationInt(x$1).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1)
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt$: 0
}, false, "scala.concurrent.duration.package$DurationInt$", {
  s_concurrent_duration_package$DurationInt$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationInt$.prototype.$classData = $d_s_concurrent_duration_package$DurationInt$;
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$()
  };
  return $n_s_concurrent_duration_package$DurationInt$
}
/** @constructor */
function $c_s_math_Ordered$() {
  /*<skip>*/
}
$c_s_math_Ordered$.prototype = new $h_O();
$c_s_math_Ordered$.prototype.constructor = $c_s_math_Ordered$;
/** @constructor */
function $h_s_math_Ordered$() {
  /*<skip>*/
}
$h_s_math_Ordered$.prototype = $c_s_math_Ordered$.prototype;
var $d_s_math_Ordered$ = new $TypeData().initClass({
  s_math_Ordered$: 0
}, false, "scala.math.Ordered$", {
  s_math_Ordered$: 1,
  O: 1
});
$c_s_math_Ordered$.prototype.$classData = $d_s_math_Ordered$;
var $n_s_math_Ordered$;
function $m_s_math_Ordered$() {
  if ((!$n_s_math_Ordered$)) {
    $n_s_math_Ordered$ = new $c_s_math_Ordered$()
  };
  return $n_s_math_Ordered$
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? (((-2147483648) ^ lo) >= 0) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-1)) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)))
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2))
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3))
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4))
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5))
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$1 = $thiz.longValue__J();
    return ((this$1.RTLong__f_lo === lo) && (this$1.RTLong__f_hi === hi))
  } else if ($isFloat(x)) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7)
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8)
  } else {
    return false
  }
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigDecimal
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigInt
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_AnyRef = null;
  this.s_package$__f_Traversable = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_IndexedSeq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$colon = null;
  this.s_package$__f_$plus$colon = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_StringBuilder = null;
  this.s_package$__f_Range = null;
  this.s_package$__f_Equiv = null;
  this.s_package$__f_Fractional = null;
  this.s_package$__f_Integral = null;
  this.s_package$__f_Numeric = null;
  this.s_package$__f_Ordered = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_AnyRef = new $c_s_package$$anon$1();
  this.s_package$__f_Traversable = $m_sc_Iterable$();
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  this.s_package$__f_IndexedSeq = $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$colon = $m_sci_$colon$colon$();
  this.s_package$__f_$plus$colon = $m_sc_package$$plus$colon$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_StringBuilder = $m_scm_StringBuilder$();
  this.s_package$__f_Range = $m_sci_Range$();
  this.s_package$__f_Equiv = $m_s_math_Equiv$();
  this.s_package$__f_Fractional = $m_s_math_Fractional$();
  this.s_package$__f_Integral = $m_s_math_Integral$();
  this.s_package$__f_Numeric = $m_s_math_Numeric$();
  this.s_package$__f_Ordered = $m_s_math_Ordered$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$()
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
  /*<skip>*/
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal)
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt)
});
var $d_s_package$ = new $TypeData().initClass({
  s_package$: 0
}, false, "scala.package$", {
  s_package$: 1,
  O: 1
});
$c_s_package$.prototype.$classData = $d_s_package$;
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$()
  };
  return $n_s_package$
}
/** @constructor */
function $c_s_package$$hash$colon$colon$() {
  /*<skip>*/
}
$c_s_package$$hash$colon$colon$.prototype = new $h_O();
$c_s_package$$hash$colon$colon$.prototype.constructor = $c_s_package$$hash$colon$colon$;
/** @constructor */
function $h_s_package$$hash$colon$colon$() {
  /*<skip>*/
}
$h_s_package$$hash$colon$colon$.prototype = $c_s_package$$hash$colon$colon$.prototype;
$c_s_package$$hash$colon$colon$.prototype.unapply__sci_Stream__s_Option = (function(s) {
  return ((!s.isEmpty__Z()) ? new $c_s_Some($ct_T2__O__O__(new $c_T2(), s.head__O(), s.tail__O())) : $m_s_None$())
});
var $d_s_package$$hash$colon$colon$ = new $TypeData().initClass({
  s_package$$hash$colon$colon$: 0
}, false, "scala.package$$hash$colon$colon$", {
  s_package$$hash$colon$colon$: 1,
  O: 1
});
$c_s_package$$hash$colon$colon$.prototype.$classData = $d_s_package$$hash$colon$colon$;
var $n_s_package$$hash$colon$colon$;
function $m_s_package$$hash$colon$colon$() {
  if ((!$n_s_package$$hash$colon$colon$)) {
    $n_s_package$$hash$colon$colon$ = new $c_s_package$$hash$colon$colon$()
  };
  return $n_s_package$$hash$colon$colon$
}
/** @constructor */
function $c_sr_BoxesRunTime$() {
  /*<skip>*/
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
  /*<skip>*/
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y)
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y)
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z(x, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2)
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      return (x2$1 === $uC(x3))
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(x3);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z(xn, x3))
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2)
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi))
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return x4.equals__O__Z(x2)
    } else {
      return false
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2))
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1) === x3$3)
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return x4$2.equals__O__Z(new $c_RTLong(lo$1, hi$1))
    } else {
      return false
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    return ($uC(xc) === $uC(x2))
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      return (x2$1 === $uC(xc))
    } else if ((x3 instanceof $c_RTLong)) {
      var t = $uJ(x3);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(xc);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z(x3, xc))
    }
  } else {
    return ((xc === null) && (y === null))
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass({
  sr_BoxesRunTime$: 0
}, false, "scala.runtime.BoxesRunTime$", {
  sr_BoxesRunTime$: 1,
  O: 1
});
$c_sr_BoxesRunTime$.prototype.$classData = $d_sr_BoxesRunTime$;
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$()
  };
  return $n_sr_BoxesRunTime$
}
var $d_sr_Null$ = new $TypeData().initClass({
  sr_Null$: 0
}, false, "scala.runtime.Null$", {
  sr_Null$: 1,
  O: 1
});
/** @constructor */
function $c_sr_RichLong$() {
  /*<skip>*/
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
  /*<skip>*/
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = $as_sr_RichLong(x$1).sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass({
  sr_RichLong$: 0
}, false, "scala.runtime.RichLong$", {
  sr_RichLong$: 1,
  O: 1
});
$c_sr_RichLong$.prototype.$classData = $d_sr_RichLong$;
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$()
  };
  return $n_sr_RichLong$
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
  /*<skip>*/
}
$c_sr_Scala3RunTime$.prototype = new $h_O();
$c_sr_Scala3RunTime$.prototype.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
  /*<skip>*/
}
$h_sr_Scala3RunTime$.prototype = $c_sr_Scala3RunTime$.prototype;
$c_sr_Scala3RunTime$.prototype.assertFailed__E = (function() {
  throw new $c_jl_AssertionError("assertion failed")
});
var $d_sr_Scala3RunTime$ = new $TypeData().initClass({
  sr_Scala3RunTime$: 0
}, false, "scala.runtime.Scala3RunTime$", {
  sr_Scala3RunTime$: 1,
  O: 1
});
$c_sr_Scala3RunTime$.prototype.$classData = $d_sr_Scala3RunTime$;
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$()
  };
  return $n_sr_Scala3RunTime$
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
  /*<skip>*/
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return x2.get(idx)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return x3.get(idx)
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return x4.get(idx)
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return x5.get(idx)
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return x6.get(idx)
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC(x7.get(idx))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return x8.get(idx)
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return x9.get(idx)
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return x10.get(idx)
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    x2.set(idx, value)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    x3.set(idx, $uI(value))
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    x4.set(idx, $uD(value))
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    x5.set(idx, $uJ(value))
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    x6.set(idx, $uF(value))
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    x7.set(idx, $uC(value))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    x8.set(idx, $uB(value))
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    x9.set(idx, $uS(value))
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    x10.set(idx, $uZ(value))
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_length__O__I = (function(xs) {
  return $m_jl_reflect_Array$().getLength__O__I(xs)
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return x2.clone__O()
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return x3.clone__O()
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return x4.clone__O()
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return x5.clone__O()
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return x6.clone__O()
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return x7.clone__O()
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return x8.clone__O()
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return x9.clone__O()
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return x10.clone__O()
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  var this$1 = x.productIterator__sc_Iterator();
  var start = (x.productPrefix__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, start, ",", ")")
});
$c_sr_ScalaRunTime$.prototype.genericWrapArray__O__sci_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(xs))
});
$c_sr_ScalaRunTime$.prototype.wrapRefArray__AO__sci_ArraySeq = (function(xs) {
  if ((xs === null)) {
    return null
  } else if ((xs.u.length === 0)) {
    var this$3 = $m_sci_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$3)
  } else {
    return new $c_sci_ArraySeq$ofRef(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.wrapIntArray__AI__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofInt(xs) : null)
});
$c_sr_ScalaRunTime$.prototype.wrapCharArray__AC__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofChar(xs) : null)
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass({
  sr_ScalaRunTime$: 0
}, false, "scala.runtime.ScalaRunTime$", {
  sr_ScalaRunTime$: 1,
  O: 1
});
$c_sr_ScalaRunTime$.prototype.$classData = $d_sr_ScalaRunTime$;
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$()
  };
  return $n_sr_ScalaRunTime$
}
/** @constructor */
function $c_sr_Statics$() {
  /*<skip>*/
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
  /*<skip>*/
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length))
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi))
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === dv) ? (lo ^ hi) : $m_jl_FloatingPointBits$().numberHashCode__D__I(dv))
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3)
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi))
  } else {
    return $dp_hashCode__I(x)
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_sr_Statics$ = new $TypeData().initClass({
  sr_Statics$: 0
}, false, "scala.runtime.Statics$", {
  sr_Statics$: 1,
  O: 1
});
$c_sr_Statics$.prototype.$classData = $d_sr_Statics$;
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$()
  };
  return $n_sr_Statics$
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass({
  sr_Statics$PFMarker$: 0
}, false, "scala.runtime.Statics$PFMarker$", {
  sr_Statics$PFMarker$: 1,
  O: 1
});
$c_sr_Statics$PFMarker$.prototype.$classData = $d_sr_Statics$PFMarker$;
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$()
  };
  return $n_sr_Statics$PFMarker$
}
/** @constructor */
function $c_sr_Tuples$() {
  /*<skip>*/
}
$c_sr_Tuples$.prototype = new $h_O();
$c_sr_Tuples$.prototype.constructor = $c_sr_Tuples$;
/** @constructor */
function $h_sr_Tuples$() {
  /*<skip>*/
}
$h_sr_Tuples$.prototype = $c_sr_Tuples$.prototype;
$c_sr_Tuples$.prototype.fromArray__AO__s_Product = (function(xs) {
  var x7 = xs.u.length;
  switch (x7) {
    case 0: {
      return $m_T$package$EmptyTuple$();
      break
    }
    case 1: {
      var _1 = xs.get(0);
      return new $c_T1(_1);
      break
    }
    case 2: {
      var _1$1 = xs.get(0);
      var _2 = xs.get(1);
      return $ct_T2__O__O__(new $c_T2(), _1$1, _2);
      break
    }
    case 3: {
      var _1$2 = xs.get(0);
      var _2$1 = xs.get(1);
      var _3 = xs.get(2);
      return new $c_T3(_1$2, _2$1, _3);
      break
    }
    case 4: {
      var _1$3 = xs.get(0);
      var _2$2 = xs.get(1);
      var _3$1 = xs.get(2);
      var _4 = xs.get(3);
      return new $c_T4(_1$3, _2$2, _3$1, _4);
      break
    }
    case 5: {
      var _1$4 = xs.get(0);
      var _2$3 = xs.get(1);
      var _3$2 = xs.get(2);
      var _4$1 = xs.get(3);
      var _5 = xs.get(4);
      return new $c_T5(_1$4, _2$3, _3$2, _4$1, _5);
      break
    }
    case 6: {
      var _1$5 = xs.get(0);
      var _2$4 = xs.get(1);
      var _3$3 = xs.get(2);
      var _4$2 = xs.get(3);
      var _5$1 = xs.get(4);
      var _6 = xs.get(5);
      return new $c_T6(_1$5, _2$4, _3$3, _4$2, _5$1, _6);
      break
    }
    case 7: {
      var _1$6 = xs.get(0);
      var _2$5 = xs.get(1);
      var _3$4 = xs.get(2);
      var _4$3 = xs.get(3);
      var _5$2 = xs.get(4);
      var _6$1 = xs.get(5);
      var _7 = xs.get(6);
      return new $c_T7(_1$6, _2$5, _3$4, _4$3, _5$2, _6$1, _7);
      break
    }
    case 8: {
      var _1$7 = xs.get(0);
      var _2$6 = xs.get(1);
      var _3$5 = xs.get(2);
      var _4$4 = xs.get(3);
      var _5$3 = xs.get(4);
      var _6$2 = xs.get(5);
      var _7$1 = xs.get(6);
      var _8 = xs.get(7);
      return new $c_T8(_1$7, _2$6, _3$5, _4$4, _5$3, _6$2, _7$1, _8);
      break
    }
    case 9: {
      var _1$8 = xs.get(0);
      var _2$7 = xs.get(1);
      var _3$6 = xs.get(2);
      var _4$5 = xs.get(3);
      var _5$4 = xs.get(4);
      var _6$3 = xs.get(5);
      var _7$2 = xs.get(6);
      var _8$1 = xs.get(7);
      var _9 = xs.get(8);
      return new $c_T9(_1$8, _2$7, _3$6, _4$5, _5$4, _6$3, _7$2, _8$1, _9);
      break
    }
    case 10: {
      var _1$9 = xs.get(0);
      var _2$8 = xs.get(1);
      var _3$7 = xs.get(2);
      var _4$6 = xs.get(3);
      var _5$5 = xs.get(4);
      var _6$4 = xs.get(5);
      var _7$3 = xs.get(6);
      var _8$2 = xs.get(7);
      var _9$1 = xs.get(8);
      var _10 = xs.get(9);
      return new $c_T10(_1$9, _2$8, _3$7, _4$6, _5$5, _6$4, _7$3, _8$2, _9$1, _10);
      break
    }
    case 11: {
      var _1$10 = xs.get(0);
      var _2$9 = xs.get(1);
      var _3$8 = xs.get(2);
      var _4$7 = xs.get(3);
      var _5$6 = xs.get(4);
      var _6$5 = xs.get(5);
      var _7$4 = xs.get(6);
      var _8$3 = xs.get(7);
      var _9$2 = xs.get(8);
      var _10$1 = xs.get(9);
      var _11 = xs.get(10);
      return new $c_T11(_1$10, _2$9, _3$8, _4$7, _5$6, _6$5, _7$4, _8$3, _9$2, _10$1, _11);
      break
    }
    case 12: {
      var _1$11 = xs.get(0);
      var _2$10 = xs.get(1);
      var _3$9 = xs.get(2);
      var _4$8 = xs.get(3);
      var _5$7 = xs.get(4);
      var _6$6 = xs.get(5);
      var _7$5 = xs.get(6);
      var _8$4 = xs.get(7);
      var _9$3 = xs.get(8);
      var _10$2 = xs.get(9);
      var _11$1 = xs.get(10);
      var _12 = xs.get(11);
      return new $c_T12(_1$11, _2$10, _3$9, _4$8, _5$7, _6$6, _7$5, _8$4, _9$3, _10$2, _11$1, _12);
      break
    }
    case 13: {
      var _1$12 = xs.get(0);
      var _2$11 = xs.get(1);
      var _3$10 = xs.get(2);
      var _4$9 = xs.get(3);
      var _5$8 = xs.get(4);
      var _6$7 = xs.get(5);
      var _7$6 = xs.get(6);
      var _8$5 = xs.get(7);
      var _9$4 = xs.get(8);
      var _10$3 = xs.get(9);
      var _11$2 = xs.get(10);
      var _12$1 = xs.get(11);
      var _13 = xs.get(12);
      return new $c_T13(_1$12, _2$11, _3$10, _4$9, _5$8, _6$7, _7$6, _8$5, _9$4, _10$3, _11$2, _12$1, _13);
      break
    }
    case 14: {
      var _1$13 = xs.get(0);
      var _2$12 = xs.get(1);
      var _3$11 = xs.get(2);
      var _4$10 = xs.get(3);
      var _5$9 = xs.get(4);
      var _6$8 = xs.get(5);
      var _7$7 = xs.get(6);
      var _8$6 = xs.get(7);
      var _9$5 = xs.get(8);
      var _10$4 = xs.get(9);
      var _11$3 = xs.get(10);
      var _12$2 = xs.get(11);
      var _13$1 = xs.get(12);
      var _14 = xs.get(13);
      return new $c_T14(_1$13, _2$12, _3$11, _4$10, _5$9, _6$8, _7$7, _8$6, _9$5, _10$4, _11$3, _12$2, _13$1, _14);
      break
    }
    case 15: {
      var _1$14 = xs.get(0);
      var _2$13 = xs.get(1);
      var _3$12 = xs.get(2);
      var _4$11 = xs.get(3);
      var _5$10 = xs.get(4);
      var _6$9 = xs.get(5);
      var _7$8 = xs.get(6);
      var _8$7 = xs.get(7);
      var _9$6 = xs.get(8);
      var _10$5 = xs.get(9);
      var _11$4 = xs.get(10);
      var _12$3 = xs.get(11);
      var _13$2 = xs.get(12);
      var _14$1 = xs.get(13);
      var _15 = xs.get(14);
      return new $c_T15(_1$14, _2$13, _3$12, _4$11, _5$10, _6$9, _7$8, _8$7, _9$6, _10$5, _11$4, _12$3, _13$2, _14$1, _15);
      break
    }
    case 16: {
      var _1$15 = xs.get(0);
      var _2$14 = xs.get(1);
      var _3$13 = xs.get(2);
      var _4$12 = xs.get(3);
      var _5$11 = xs.get(4);
      var _6$10 = xs.get(5);
      var _7$9 = xs.get(6);
      var _8$8 = xs.get(7);
      var _9$7 = xs.get(8);
      var _10$6 = xs.get(9);
      var _11$5 = xs.get(10);
      var _12$4 = xs.get(11);
      var _13$3 = xs.get(12);
      var _14$2 = xs.get(13);
      var _15$1 = xs.get(14);
      var _16 = xs.get(15);
      return new $c_T16(_1$15, _2$14, _3$13, _4$12, _5$11, _6$10, _7$9, _8$8, _9$7, _10$6, _11$5, _12$4, _13$3, _14$2, _15$1, _16);
      break
    }
    case 17: {
      var _1$16 = xs.get(0);
      var _2$15 = xs.get(1);
      var _3$14 = xs.get(2);
      var _4$13 = xs.get(3);
      var _5$12 = xs.get(4);
      var _6$11 = xs.get(5);
      var _7$10 = xs.get(6);
      var _8$9 = xs.get(7);
      var _9$8 = xs.get(8);
      var _10$7 = xs.get(9);
      var _11$6 = xs.get(10);
      var _12$5 = xs.get(11);
      var _13$4 = xs.get(12);
      var _14$3 = xs.get(13);
      var _15$2 = xs.get(14);
      var _16$1 = xs.get(15);
      var _17 = xs.get(16);
      return new $c_T17(_1$16, _2$15, _3$14, _4$13, _5$12, _6$11, _7$10, _8$9, _9$8, _10$7, _11$6, _12$5, _13$4, _14$3, _15$2, _16$1, _17);
      break
    }
    case 18: {
      var _1$17 = xs.get(0);
      var _2$16 = xs.get(1);
      var _3$15 = xs.get(2);
      var _4$14 = xs.get(3);
      var _5$13 = xs.get(4);
      var _6$12 = xs.get(5);
      var _7$11 = xs.get(6);
      var _8$10 = xs.get(7);
      var _9$9 = xs.get(8);
      var _10$8 = xs.get(9);
      var _11$7 = xs.get(10);
      var _12$6 = xs.get(11);
      var _13$5 = xs.get(12);
      var _14$4 = xs.get(13);
      var _15$3 = xs.get(14);
      var _16$2 = xs.get(15);
      var _17$1 = xs.get(16);
      var _18 = xs.get(17);
      return new $c_T18(_1$17, _2$16, _3$15, _4$14, _5$13, _6$12, _7$11, _8$10, _9$9, _10$8, _11$7, _12$6, _13$5, _14$4, _15$3, _16$2, _17$1, _18);
      break
    }
    case 19: {
      var _1$18 = xs.get(0);
      var _2$17 = xs.get(1);
      var _3$16 = xs.get(2);
      var _4$15 = xs.get(3);
      var _5$14 = xs.get(4);
      var _6$13 = xs.get(5);
      var _7$12 = xs.get(6);
      var _8$11 = xs.get(7);
      var _9$10 = xs.get(8);
      var _10$9 = xs.get(9);
      var _11$8 = xs.get(10);
      var _12$7 = xs.get(11);
      var _13$6 = xs.get(12);
      var _14$5 = xs.get(13);
      var _15$4 = xs.get(14);
      var _16$3 = xs.get(15);
      var _17$2 = xs.get(16);
      var _18$1 = xs.get(17);
      var _19 = xs.get(18);
      return new $c_T19(_1$18, _2$17, _3$16, _4$15, _5$14, _6$13, _7$12, _8$11, _9$10, _10$9, _11$8, _12$7, _13$6, _14$5, _15$4, _16$3, _17$2, _18$1, _19);
      break
    }
    case 20: {
      var _1$19 = xs.get(0);
      var _2$18 = xs.get(1);
      var _3$17 = xs.get(2);
      var _4$16 = xs.get(3);
      var _5$15 = xs.get(4);
      var _6$14 = xs.get(5);
      var _7$13 = xs.get(6);
      var _8$12 = xs.get(7);
      var _9$11 = xs.get(8);
      var _10$10 = xs.get(9);
      var _11$9 = xs.get(10);
      var _12$8 = xs.get(11);
      var _13$7 = xs.get(12);
      var _14$6 = xs.get(13);
      var _15$5 = xs.get(14);
      var _16$4 = xs.get(15);
      var _17$3 = xs.get(16);
      var _18$2 = xs.get(17);
      var _19$1 = xs.get(18);
      var _20 = xs.get(19);
      return new $c_T20(_1$19, _2$18, _3$17, _4$16, _5$15, _6$14, _7$13, _8$12, _9$11, _10$10, _11$9, _12$8, _13$7, _14$6, _15$5, _16$4, _17$3, _18$2, _19$1, _20);
      break
    }
    case 21: {
      var _1$20 = xs.get(0);
      var _2$19 = xs.get(1);
      var _3$18 = xs.get(2);
      var _4$17 = xs.get(3);
      var _5$16 = xs.get(4);
      var _6$15 = xs.get(5);
      var _7$14 = xs.get(6);
      var _8$13 = xs.get(7);
      var _9$12 = xs.get(8);
      var _10$11 = xs.get(9);
      var _11$10 = xs.get(10);
      var _12$9 = xs.get(11);
      var _13$8 = xs.get(12);
      var _14$7 = xs.get(13);
      var _15$6 = xs.get(14);
      var _16$5 = xs.get(15);
      var _17$4 = xs.get(16);
      var _18$3 = xs.get(17);
      var _19$2 = xs.get(18);
      var _20$1 = xs.get(19);
      var _21 = xs.get(20);
      return new $c_T21(_1$20, _2$19, _3$18, _4$17, _5$16, _6$15, _7$14, _8$13, _9$12, _10$11, _11$10, _12$9, _13$8, _14$7, _15$6, _16$5, _17$4, _18$3, _19$2, _20$1, _21);
      break
    }
    case 22: {
      var _1$21 = xs.get(0);
      var _2$20 = xs.get(1);
      var _3$19 = xs.get(2);
      var _4$18 = xs.get(3);
      var _5$17 = xs.get(4);
      var _6$16 = xs.get(5);
      var _7$15 = xs.get(6);
      var _8$14 = xs.get(7);
      var _9$13 = xs.get(8);
      var _10$12 = xs.get(9);
      var _11$11 = xs.get(10);
      var _12$10 = xs.get(11);
      var _13$9 = xs.get(12);
      var _14$8 = xs.get(13);
      var _15$7 = xs.get(14);
      var _16$6 = xs.get(15);
      var _17$5 = xs.get(16);
      var _18$4 = xs.get(17);
      var _19$3 = xs.get(18);
      var _20$2 = xs.get(19);
      var _21$1 = xs.get(20);
      var _22 = xs.get(21);
      return new $c_T22(_1$21, _2$20, _3$19, _4$18, _5$17, _6$16, _7$15, _8$14, _9$13, _10$12, _11$11, _12$10, _13$9, _14$8, _15$7, _16$6, _17$5, _18$4, _19$3, _20$2, _21$1, _22);
      break
    }
    default: {
      var elems = xs.clone__O();
      return new $c_sr_TupleXXL(elems)
    }
  }
});
var $d_sr_Tuples$ = new $TypeData().initClass({
  sr_Tuples$: 0
}, false, "scala.runtime.Tuples$", {
  sr_Tuples$: 1,
  O: 1
});
$c_sr_Tuples$.prototype.$classData = $d_sr_Tuples$;
var $n_sr_Tuples$;
function $m_sr_Tuples$() {
  if ((!$n_sr_Tuples$)) {
    $n_sr_Tuples$ = new $c_sr_Tuples$()
  };
  return $n_sr_Tuples$
}
/** @constructor */
function $c_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$c_sjs_js_ArrayOps$.prototype = new $h_O();
$c_sjs_js_ArrayOps$.prototype.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$h_sjs_js_ArrayOps$.prototype = $c_sjs_js_ArrayOps$.prototype;
$c_sjs_js_ArrayOps$.prototype.insert$extension__sjs_js_Array__I__O__V = (function(this$, idx, elem) {
  if (((idx < 0) || (idx > $uI(this$.length)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  this$.splice(idx, 0, elem)
});
$c_sjs_js_ArrayOps$.prototype.remove$extension__sjs_js_Array__I__O = (function(this$, idx) {
  if (((idx < 0) || (idx >= $uI(this$.length)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return this$.splice(idx, 1)[0]
});
var $d_sjs_js_ArrayOps$ = new $TypeData().initClass({
  sjs_js_ArrayOps$: 0
}, false, "scala.scalajs.js.ArrayOps$", {
  sjs_js_ArrayOps$: 1,
  O: 1
});
$c_sjs_js_ArrayOps$.prototype.$classData = $d_sjs_js_ArrayOps$;
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$()
  };
  return $n_sjs_js_ArrayOps$
}
/** @constructor */
function $c_sjs_js_JSConverters$JSRichIterableOnce$() {
  /*<skip>*/
}
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype = new $h_O();
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.constructor = $c_sjs_js_JSConverters$JSRichIterableOnce$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichIterableOnce$() {
  /*<skip>*/
}
$h_sjs_js_JSConverters$JSRichIterableOnce$.prototype = $c_sjs_js_JSConverters$JSRichIterableOnce$.prototype;
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.toJSArray$extension__sc_IterableOnce__sjs_js_Array = (function(this$) {
  if ((this$ instanceof $c_sjs_js_WrappedArray)) {
    var x2 = $as_sjs_js_WrappedArray(this$);
    return x2.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array
  } else {
    var result = [];
    var this$2 = this$.iterator__sc_Iterator();
    while (this$2.hasNext__Z()) {
      var arg1 = this$2.next__O();
      $uI(result.push(arg1))
    };
    return result
  }
});
var $d_sjs_js_JSConverters$JSRichIterableOnce$ = new $TypeData().initClass({
  sjs_js_JSConverters$JSRichIterableOnce$: 0
}, false, "scala.scalajs.js.JSConverters$JSRichIterableOnce$", {
  sjs_js_JSConverters$JSRichIterableOnce$: 1,
  O: 1
});
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.$classData = $d_sjs_js_JSConverters$JSRichIterableOnce$;
var $n_sjs_js_JSConverters$JSRichIterableOnce$;
function $m_sjs_js_JSConverters$JSRichIterableOnce$() {
  if ((!$n_sjs_js_JSConverters$JSRichIterableOnce$)) {
    $n_sjs_js_JSConverters$JSRichIterableOnce$ = new $c_sjs_js_JSConverters$JSRichIterableOnce$()
  };
  return $n_sjs_js_JSConverters$JSRichIterableOnce$
}
/** @constructor */
function $c_sjs_js_JSConverters$JSRichMap$() {
  /*<skip>*/
}
$c_sjs_js_JSConverters$JSRichMap$.prototype = new $h_O();
$c_sjs_js_JSConverters$JSRichMap$.prototype.constructor = $c_sjs_js_JSConverters$JSRichMap$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichMap$() {
  /*<skip>*/
}
$h_sjs_js_JSConverters$JSRichMap$.prototype = $c_sjs_js_JSConverters$JSRichMap$.prototype;
var $d_sjs_js_JSConverters$JSRichMap$ = new $TypeData().initClass({
  sjs_js_JSConverters$JSRichMap$: 0
}, false, "scala.scalajs.js.JSConverters$JSRichMap$", {
  sjs_js_JSConverters$JSRichMap$: 1,
  O: 1
});
$c_sjs_js_JSConverters$JSRichMap$.prototype.$classData = $d_sjs_js_JSConverters$JSRichMap$;
var $n_sjs_js_JSConverters$JSRichMap$;
function $m_sjs_js_JSConverters$JSRichMap$() {
  if ((!$n_sjs_js_JSConverters$JSRichMap$)) {
    $n_sjs_js_JSConverters$JSRichMap$ = new $c_sjs_js_JSConverters$JSRichMap$()
  };
  return $n_sjs_js_JSConverters$JSRichMap$
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass({
  sjs_js_WrappedDictionary$Cache$: 0
}, false, "scala.scalajs.js.WrappedDictionary$Cache$", {
  sjs_js_WrappedDictionary$Cache$: 1,
  O: 1
});
$c_sjs_js_WrappedDictionary$Cache$.prototype.$classData = $d_sjs_js_WrappedDictionary$Cache$;
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$()
  };
  return $n_sjs_js_WrappedDictionary$Cache$
}
/** @constructor */
function $c_sjs_js_special_package$() {
  /*<skip>*/
}
$c_sjs_js_special_package$.prototype = new $h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
  /*<skip>*/
}
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = {};
  properties.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$1, result$1) => ((pair$2) => {
    var pair = $as_T2(pair$2);
    result$1[pair._1__O()] = pair._2__O()
  }))(this, result)));
  return result
});
var $d_sjs_js_special_package$ = new $TypeData().initClass({
  sjs_js_special_package$: 0
}, false, "scala.scalajs.js.special.package$", {
  sjs_js_special_package$: 1,
  O: 1
});
$c_sjs_js_special_package$.prototype.$classData = $d_sjs_js_special_package$;
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$()
  };
  return $n_sjs_js_special_package$
}
/** @constructor */
function $c_sjs_js_timers_package$() {
  /*<skip>*/
}
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
  /*<skip>*/
}
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  return setTimeout(((body$1) => (() => {
    body$1.apply__O()
  }))(body), interval)
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass({
  sjs_js_timers_package$: 0
}, false, "scala.scalajs.js.timers.package$", {
  sjs_js_timers_package$: 1,
  O: 1
});
$c_sjs_js_timers_package$.prototype.$classData = $d_sjs_js_timers_package$;
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$()
  };
  return $n_sjs_js_timers_package$
}
/** @constructor */
function $c_sjs_reflect_InstantiatableClass(runtimeClass, declaredConstructors) {
  this.sjs_reflect_InstantiatableClass__f_runtimeClass = null;
  this.sjs_reflect_InstantiatableClass__f_declaredConstructors = null;
  this.sjs_reflect_InstantiatableClass__f_runtimeClass = runtimeClass;
  this.sjs_reflect_InstantiatableClass__f_declaredConstructors = declaredConstructors
}
$c_sjs_reflect_InstantiatableClass.prototype = new $h_O();
$c_sjs_reflect_InstantiatableClass.prototype.constructor = $c_sjs_reflect_InstantiatableClass;
/** @constructor */
function $h_sjs_reflect_InstantiatableClass() {
  /*<skip>*/
}
$h_sjs_reflect_InstantiatableClass.prototype = $c_sjs_reflect_InstantiatableClass.prototype;
$c_sjs_reflect_InstantiatableClass.prototype.newInstance__O = (function() {
  var this$1 = this.getConstructor__sci_Seq__s_Option($m_sci_Nil$());
  if (this$1.isEmpty__Z()) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(new $c_jl_InstantiationException(this.sjs_reflect_InstantiatableClass__f_runtimeClass.getName__T()).initCause__jl_Throwable__jl_Throwable(new $c_jl_NoSuchMethodException((this.sjs_reflect_InstantiatableClass__f_runtimeClass.getName__T() + ".<init>()"))))
  } else {
    var arg1 = this$1.get__O();
    var ctor = $as_sjs_reflect_InvokableConstructor(arg1);
    return ctor.newInstance__sci_Seq__O($m_sci_Nil$())
  }
});
$c_sjs_reflect_InstantiatableClass.prototype.getConstructor__sci_Seq__s_Option = (function(parameterTypes) {
  var this$1 = this.sjs_reflect_InstantiatableClass__f_declaredConstructors;
  var these = this$1;
  while ((!these.isEmpty__Z())) {
    var arg1 = these.head__O();
    var x$1 = $as_sjs_reflect_InvokableConstructor(arg1);
    var this$2 = x$1.sjs_reflect_InvokableConstructor__f_parameterTypes;
    if ($f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this$2, parameterTypes)) {
      return new $c_s_Some(these.head__O())
    };
    these = $as_sci_List(these.tail__O())
  };
  return $m_s_None$()
});
function $as_sjs_reflect_InstantiatableClass(obj) {
  return (((obj instanceof $c_sjs_reflect_InstantiatableClass) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.InstantiatableClass"))
}
function $isArrayOf_sjs_reflect_InstantiatableClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_InstantiatableClass)))
}
function $asArrayOf_sjs_reflect_InstantiatableClass(obj, depth) {
  return (($isArrayOf_sjs_reflect_InstantiatableClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.InstantiatableClass;", depth))
}
var $d_sjs_reflect_InstantiatableClass = new $TypeData().initClass({
  sjs_reflect_InstantiatableClass: 0
}, false, "scala.scalajs.reflect.InstantiatableClass", {
  sjs_reflect_InstantiatableClass: 1,
  O: 1
});
$c_sjs_reflect_InstantiatableClass.prototype.$classData = $d_sjs_reflect_InstantiatableClass;
/** @constructor */
function $c_sjs_reflect_InvokableConstructor(parameterTypes, newInstanceFun) {
  this.sjs_reflect_InvokableConstructor__f_parameterTypes = null;
  this.sjs_reflect_InvokableConstructor__f_newInstanceFun = null;
  this.sjs_reflect_InvokableConstructor__f_parameterTypes = parameterTypes;
  this.sjs_reflect_InvokableConstructor__f_newInstanceFun = newInstanceFun
}
$c_sjs_reflect_InvokableConstructor.prototype = new $h_O();
$c_sjs_reflect_InvokableConstructor.prototype.constructor = $c_sjs_reflect_InvokableConstructor;
/** @constructor */
function $h_sjs_reflect_InvokableConstructor() {
  /*<skip>*/
}
$h_sjs_reflect_InvokableConstructor.prototype = $c_sjs_reflect_InvokableConstructor.prototype;
$c_sjs_reflect_InvokableConstructor.prototype.newInstance__sci_Seq__O = (function(args) {
  var $$x2 = $m_s_Predef$();
  var $$x1 = args.length__I();
  var this$1 = this.sjs_reflect_InvokableConstructor__f_parameterTypes;
  $$x2.require__Z__V(($$x1 === this$1.length__I()));
  return (0, this.sjs_reflect_InvokableConstructor__f_newInstanceFun)(...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(args))
});
function $as_sjs_reflect_InvokableConstructor(obj) {
  return (((obj instanceof $c_sjs_reflect_InvokableConstructor) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.InvokableConstructor"))
}
function $isArrayOf_sjs_reflect_InvokableConstructor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_InvokableConstructor)))
}
function $asArrayOf_sjs_reflect_InvokableConstructor(obj, depth) {
  return (($isArrayOf_sjs_reflect_InvokableConstructor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.InvokableConstructor;", depth))
}
var $d_sjs_reflect_InvokableConstructor = new $TypeData().initClass({
  sjs_reflect_InvokableConstructor: 0
}, false, "scala.scalajs.reflect.InvokableConstructor", {
  sjs_reflect_InvokableConstructor: 1,
  O: 1
});
$c_sjs_reflect_InvokableConstructor.prototype.$classData = $d_sjs_reflect_InvokableConstructor;
function $as_sjs_reflect_LoadableModuleClass(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.LoadableModuleClass"))
}
function $isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_LoadableModuleClass)))
}
function $asArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (($isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.LoadableModuleClass;", depth))
}
/** @constructor */
function $c_sjs_reflect_Reflect$() {
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = null;
  this.sjs_reflect_Reflect$__f_instantiatableClasses = null;
  $n_sjs_reflect_Reflect$ = this;
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = {};
  this.sjs_reflect_Reflect$__f_instantiatableClasses = {}
}
$c_sjs_reflect_Reflect$.prototype = new $h_O();
$c_sjs_reflect_Reflect$.prototype.constructor = $c_sjs_reflect_Reflect$;
/** @constructor */
function $h_sjs_reflect_Reflect$() {
  /*<skip>*/
}
$h_sjs_reflect_Reflect$.prototype = $c_sjs_reflect_Reflect$.prototype;
$c_sjs_reflect_Reflect$.prototype.registerInstantiatableClass__T__jl_Class__sjs_js_Array__V = (function(fqcn, runtimeClass, constructors) {
  var len = $uI(constructors.length);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var arg1 = constructors[i];
    var array = arg1[0];
    var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
    $m_sci_List$();
    res[$$x1] = new $c_sjs_reflect_InvokableConstructor($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4), arg1[1]);
    i = ((1 + i) | 0)
  };
  var dict = this.sjs_reflect_Reflect$__f_instantiatableClasses;
  var this$8 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
  $m_sci_List$();
  var value = new $c_sjs_reflect_InstantiatableClass(runtimeClass, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8));
  dict[fqcn] = value
});
$c_sjs_reflect_Reflect$.prototype.lookupLoadableModuleClass__T__s_Option = (function(fqcn) {
  var dict = this.sjs_reflect_Reflect$__f_loadableModuleClasses;
  return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, fqcn)) ? new $c_s_Some(dict[fqcn]) : $m_s_None$())
});
$c_sjs_reflect_Reflect$.prototype.lookupInstantiatableClass__T__s_Option = (function(fqcn) {
  var dict = this.sjs_reflect_Reflect$__f_instantiatableClasses;
  return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, fqcn)) ? new $c_s_Some(dict[fqcn]) : $m_s_None$())
});
var $d_sjs_reflect_Reflect$ = new $TypeData().initClass({
  sjs_reflect_Reflect$: 0
}, false, "scala.scalajs.reflect.Reflect$", {
  sjs_reflect_Reflect$: 1,
  O: 1
});
$c_sjs_reflect_Reflect$.prototype.$classData = $d_sjs_reflect_Reflect$;
var $n_sjs_reflect_Reflect$;
function $m_sjs_reflect_Reflect$() {
  if ((!$n_sjs_reflect_Reflect$)) {
    $n_sjs_reflect_Reflect$ = new $c_sjs_reflect_Reflect$()
  };
  return $n_sjs_reflect_Reflect$
}
/** @constructor */
function $c_sjsr_Compat$() {
  /*<skip>*/
}
$c_sjsr_Compat$.prototype = new $h_O();
$c_sjsr_Compat$.prototype.constructor = $c_sjsr_Compat$;
/** @constructor */
function $h_sjsr_Compat$() {
  /*<skip>*/
}
$h_sjsr_Compat$.prototype = $c_sjsr_Compat$.prototype;
$c_sjsr_Compat$.prototype.toJSVarArgsImpl__sci_Seq__sjs_js_Array = (function(seq) {
  if ((seq instanceof $c_sjsr_WrappedVarArgs)) {
    var x2 = $as_sjsr_WrappedVarArgs(seq);
    return x2.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array
  } else {
    var result = [];
    seq.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$1, result$1) => ((x$2) => $uI(result$1.push(x$2))))(this, result)));
    return result
  }
});
var $d_sjsr_Compat$ = new $TypeData().initClass({
  sjsr_Compat$: 0
}, false, "scala.scalajs.runtime.Compat$", {
  sjsr_Compat$: 1,
  O: 1
});
$c_sjsr_Compat$.prototype.$classData = $d_sjsr_Compat$;
var $n_sjsr_Compat$;
function $m_sjsr_Compat$() {
  if ((!$n_sjsr_Compat$)) {
    $n_sjsr_Compat$ = new $c_sjsr_Compat$()
  };
  return $n_sjsr_Compat$
}
/** @constructor */
function $c_sjsr_package$() {
  /*<skip>*/
}
$c_sjsr_package$.prototype = new $h_O();
$c_sjsr_package$.prototype.constructor = $c_sjsr_package$;
/** @constructor */
function $h_sjsr_package$() {
  /*<skip>*/
}
$h_sjsr_package$.prototype = $c_sjsr_package$.prototype;
$c_sjsr_package$.prototype.wrapJavaScriptException__O__jl_Throwable = (function(e) {
  if ((e instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(e);
    return x2
  } else {
    return new $c_sjs_js_JavaScriptException(e)
  }
});
$c_sjsr_package$.prototype.unwrapJavaScriptException__jl_Throwable__O = (function(th) {
  if ((th instanceof $c_sjs_js_JavaScriptException)) {
    var x2 = $as_sjs_js_JavaScriptException(th);
    var e = x2.sjs_js_JavaScriptException__f_exception;
    return e
  } else {
    return th
  }
});
var $d_sjsr_package$ = new $TypeData().initClass({
  sjsr_package$: 0
}, false, "scala.scalajs.runtime.package$", {
  sjsr_package$: 1,
  O: 1
});
$c_sjsr_package$.prototype.$classData = $d_sjsr_package$;
var $n_sjsr_package$;
function $m_sjsr_package$() {
  if ((!$n_sjsr_package$)) {
    $n_sjsr_package$ = new $c_sjsr_package$()
  };
  return $n_sjsr_package$
}
/** @constructor */
function $c_s_sys_package$() {
  /*<skip>*/
}
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
  /*<skip>*/
}
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message))
});
var $d_s_sys_package$ = new $TypeData().initClass({
  s_sys_package$: 0
}, false, "scala.sys.package$", {
  s_sys_package$: 1,
  O: 1
});
$c_s_sys_package$.prototype.$classData = $d_s_sys_package$;
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$()
  };
  return $n_s_sys_package$
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.s_util_DynamicVariable__f_v = null;
  this.s_util_DynamicVariable__f_v = init
}
$c_s_util_DynamicVariable.prototype = new $h_O();
$c_s_util_DynamicVariable.prototype.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
  /*<skip>*/
}
$h_s_util_DynamicVariable.prototype = $c_s_util_DynamicVariable.prototype;
$c_s_util_DynamicVariable.prototype.toString__T = (function() {
  return (("DynamicVariable(" + this.s_util_DynamicVariable__f_v) + ")")
});
var $d_s_util_DynamicVariable = new $TypeData().initClass({
  s_util_DynamicVariable: 0
}, false, "scala.util.DynamicVariable", {
  s_util_DynamicVariable: 1,
  O: 1
});
$c_s_util_DynamicVariable.prototype.$classData = $d_s_util_DynamicVariable;
/** @constructor */
function $c_s_util_Sorting$() {
  /*<skip>*/
}
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
  /*<skip>*/
}
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0)
  };
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp)
  };
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((i0 + m) | 0)) | 0))) < 0)) {
      var iA = i0;
      var iB = (((-1) + ((i0 + m) | 0)) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix
        } else {
          iA = ix
        }
      };
      var ix$2 = ((iA + ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
        i = (((-1) + i) | 0)
      };
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next)
    };
    m = ((1 + m) | 0)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord)
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? evidence$2.newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + iK) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0)
    };
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0)
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0)
      };
      k = ((1 + k) | 0)
    };
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0)
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__V = (function(a) {
  var i = 0;
  var n = 0;
  while ((i < a.u.length)) {
    if ((!a.get(i))) {
      n = ((1 + n) | 0)
    };
    i = ((1 + i) | 0)
  };
  i = 0;
  while ((i < n)) {
    a.set(i, false);
    i = ((1 + i) | 0)
  };
  while ((i < a.u.length)) {
    a.set(i, true);
    i = ((1 + i) | 0)
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_sr_ScalaRunTime$().array_length__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering")
    };
    var array = $asArrayOf_O(a, 1);
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(array, from, until, evidence$4)
  } else if ((a instanceof $ac_I)) {
    var x3 = $asArrayOf_I(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__V(x3)
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, until, evidence$4)
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, iK, evidence$4)
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK$1, iK, evidence$4, sc)
        };
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, iK, until, evidence$4)
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, iK, iK$2, until, evidence$4, sc)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK, until, evidence$4, sc)
      }
    }
  } else if ((a instanceof $ac_D)) {
    var x4 = $asArrayOf_D(a, 1);
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, until, evidence$4)
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, iK$3, evidence$4)
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$4, iK$3, evidence$4, sc$1)
      };
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, iK$3, until, evidence$4)
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, iK$3, iK$5, until, evidence$4, sc$1)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$3, until, evidence$4, sc$1)
    }
  } else if ((a instanceof $ac_J)) {
    var x5 = $asArrayOf_J(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__V(x5)
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, until, evidence$4)
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, iK$6, evidence$4)
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$7, iK$6, evidence$4, sc$2)
        };
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, iK$6, until, evidence$4)
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, iK$6, iK$8, until, evidence$4, sc$2)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$6, until, evidence$4, sc$2)
      }
    }
  } else if ((a instanceof $ac_F)) {
    var x6 = $asArrayOf_F(a, 1);
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, until, evidence$4)
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, iK$9, evidence$4)
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$10, iK$9, evidence$4, sc$3)
      };
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, iK$9, until, evidence$4)
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, iK$9, iK$11, until, evidence$4, sc$3)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$9, until, evidence$4, sc$3)
    }
  } else if ((a instanceof $ac_C)) {
    var x7 = $asArrayOf_C(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__V(x7)
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, until, evidence$4)
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, iK$12, evidence$4)
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$13, iK$12, evidence$4, sc$4)
        };
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, iK$12, until, evidence$4)
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, iK$12, iK$14, until, evidence$4, sc$4)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$12, until, evidence$4, sc$4)
      }
    }
  } else if ((a instanceof $ac_B)) {
    var x8 = $asArrayOf_B(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__V(x8)
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, until, evidence$4)
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, iK$15, evidence$4)
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$16, iK$15, evidence$4, sc$5)
        };
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, iK$15, until, evidence$4)
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, iK$15, iK$17, until, evidence$4, sc$5)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$15, until, evidence$4, sc$5)
      }
    }
  } else if ((a instanceof $ac_S)) {
    var x9 = $asArrayOf_S(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__V(x9)
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, until, evidence$4)
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, iK$18, evidence$4)
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$19, iK$18, evidence$4, sc$6)
        };
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, iK$18, until, evidence$4)
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, iK$18, iK$20, until, evidence$4, sc$6)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$18, until, evidence$4, sc$6)
      }
    }
  } else if ((a instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__V(x10)
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, until, evidence$4)
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, iK$21, evidence$4)
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$22, iK$21, evidence$4, sc$7)
        };
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, iK$21, until, evidence$4)
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, iK$21, iK$23, until, evidence$4, sc$7)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$21, until, evidence$4, sc$7)
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(a)
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass({
  s_util_Sorting$: 0
}, false, "scala.util.Sorting$", {
  s_util_Sorting$: 1,
  O: 1
});
$c_s_util_Sorting$.prototype.$classData = $d_s_util_Sorting$;
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$()
  };
  return $n_s_util_Sorting$
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
  /*<skip>*/
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
  /*<skip>*/
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || (t instanceof $c_s_util_control_ControlThrowable))))))
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$())
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass({
  s_util_control_NonFatal$: 0
}, false, "scala.util.control.NonFatal$", {
  s_util_control_NonFatal$: 1,
  O: 1
});
$c_s_util_control_NonFatal$.prototype.$classData = $d_s_util_control_NonFatal$;
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$()
  };
  return $n_s_util_control_NonFatal$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length))
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2)
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = x.productArity__I();
  if ((arr === 0)) {
    return $f_T__hashCode__I(x.productPrefix__T())
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I(x.productPrefix__T()))
    };
    var i = 0;
    while ((i < arr)) {
      var $$x1 = h;
      var x$1 = x.productElement__I__O(i);
      h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0)
    };
    return this.finalizeHash__I__I__I(h, arr)
  }
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    var x = iterator.next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0)
  };
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n)
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = xs.iterator__sc_Iterator();
  var h = seed;
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0)
  };
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1)
  };
  var x1 = it.next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = it.next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        var $$x1 = h;
        var x$1 = it.next__O();
        h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0)
      };
      return this.finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_sr_ScalaRunTime$().array_length__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last))
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = a.length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = a.apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = a.apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = a.apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = a.apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = a.apply__I__O(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.isEmpty__Z())) {
    var head = elems.head__O();
    var tail = $as_sci_List(elems.tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break
      }
      case 2: {
        if ((rangeDiff !== ((hash - prev) | 0))) {
          rangeState = 3
        };
        break
      }
    };
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail
  };
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, (a.get(0) ? 1231 : 1237)), 1);
      break
    }
    default: {
      var initial = (a.get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = (a.get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = (a.get(i) ? 1231 : 1237);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, (a.get(i) ? 1231 : 1237));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var dv = a.get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break
    }
    default: {
      var dv$1 = a.get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = a.get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = a.get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var dv$4 = a.get(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var fv = a.get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, this$1.doubleHash__D__I(fv)), 1);
      break
    }
    default: {
      var fv$1 = a.get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = a.get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = a.get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var fv$4 = a.get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($$x2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var t = a.get(0);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break
    }
    default: {
      var t$1 = a.get(0);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = a.get(1);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = a.get(i);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var t$4 = a.get(i);
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if ((rangeDiff !== ((-prev) | 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = 0;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
function $f_Lsnabbdom_SnabbdomSyntax__h__T__sjs_js_Object__sci_Seq__Lsnabbdom_VNode($thiz, selector, opts, children) {
  var $$x1 = $i_snabbdom.h;
  var seq = $as_sci_Seq(children.flatMap__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Lsnabbdom_VNodeParam(_$1);
    return _$1$1.asVnodes__sci_List()
  }))));
  return $$x1(selector, opts, [...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq)])
}
var $d_Lsnabbdom_VNode = new $TypeData().initClass({
  Lsnabbdom_VNode: 0
}, false, "snabbdom.VNode", {
  Lsnabbdom_VNode: 1,
  O: 1
}, true, (void 0), $noIsInstance);
function $is_Lsnabbdom_VNodeParam(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_VNodeParam)))
}
function $as_Lsnabbdom_VNodeParam(obj) {
  return (($is_Lsnabbdom_VNodeParam(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeParam"))
}
function $isArrayOf_Lsnabbdom_VNodeParam(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeParam)))
}
function $asArrayOf_Lsnabbdom_VNodeParam(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeParam(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeParam;", depth))
}
function $f_Lsquants_Dimension__equals__O__Z($thiz, that) {
  if ($is_Lsquants_Dimension(that)) {
    var dimension = $as_Lsquants_Dimension(that);
    return ($objectClassName(dimension) === $objectClassName($thiz))
  } else {
    return false
  }
}
function $f_Lsquants_Dimension__hashCode__I($thiz) {
  return $f_T__hashCode__I($objectClassName($thiz))
}
function $is_Lsquants_Dimension(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsquants_Dimension)))
}
function $as_Lsquants_Dimension(obj) {
  return (($is_Lsquants_Dimension(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "squants.Dimension"))
}
function $isArrayOf_Lsquants_Dimension(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_Dimension)))
}
function $asArrayOf_Lsquants_Dimension(obj, depth) {
  return (($isArrayOf_Lsquants_Dimension(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsquants.Dimension;", depth))
}
/** @constructor */
function $c_Lsquants_Platform$() {
  /*<skip>*/
}
$c_Lsquants_Platform$.prototype = new $h_O();
$c_Lsquants_Platform$.prototype.constructor = $c_Lsquants_Platform$;
/** @constructor */
function $h_Lsquants_Platform$() {
  /*<skip>*/
}
$h_Lsquants_Platform$.prototype = $c_Lsquants_Platform$.prototype;
$c_Lsquants_Platform$.prototype.crossFormat__D__T = (function(d) {
  var this$1 = $m_RTLong$();
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(d);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === d)) {
    return $m_sc_StringOps$().format$extension__T__sci_Seq__T("%.1f", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([d])))
  } else {
    return ("" + d)
  }
});
var $d_Lsquants_Platform$ = new $TypeData().initClass({
  Lsquants_Platform$: 0
}, false, "squants.Platform$", {
  Lsquants_Platform$: 1,
  O: 1
});
$c_Lsquants_Platform$.prototype.$classData = $d_Lsquants_Platform$;
var $n_Lsquants_Platform$;
function $m_Lsquants_Platform$() {
  if ((!$n_Lsquants_Platform$)) {
    $n_Lsquants_Platform$ = new $c_Lsquants_Platform$()
  };
  return $n_Lsquants_Platform$
}
function $f_Lsquants_UnitConverter__converterTo__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((this$1) => ((value) => {
    var value$1 = $uD(value);
    return (value$1 / this$1.conversionFactor__D())
  }))($thiz))
}
function $f_Lsquants_UnitConverter__converterFrom__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((this$1) => ((value) => {
    var value$1 = $uD(value);
    return (value$1 * this$1.conversionFactor__D())
  }))($thiz))
}
function $is_Ltyrian_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Attr)))
}
function $as_Ltyrian_Attr(obj) {
  return (($is_Ltyrian_Attr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attr"))
}
function $isArrayOf_Ltyrian_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attr)))
}
function $asArrayOf_Ltyrian_Attr(obj, depth) {
  return (($isArrayOf_Ltyrian_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attr;", depth))
}
var $d_Ltyrian_Attr = new $TypeData().initClass({
  Ltyrian_Attr: 0
}, true, "tyrian.Attr", {
  Ltyrian_Attr: 1,
  O: 1
});
function $is_Ltyrian_Cmd(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Cmd)))
}
function $as_Ltyrian_Cmd(obj) {
  return (($is_Ltyrian_Cmd(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd"))
}
function $isArrayOf_Ltyrian_Cmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd)))
}
function $asArrayOf_Ltyrian_Cmd(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd;", depth))
}
var $d_Ltyrian_Cmd = new $TypeData().initClass({
  Ltyrian_Cmd: 0
}, true, "tyrian.Cmd", {
  Ltyrian_Cmd: 1,
  O: 1
});
function $is_Ltyrian_Elem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Elem)))
}
function $as_Ltyrian_Elem(obj) {
  return (($is_Ltyrian_Elem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Elem"))
}
function $isArrayOf_Ltyrian_Elem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Elem)))
}
function $asArrayOf_Ltyrian_Elem(obj, depth) {
  return (($isArrayOf_Ltyrian_Elem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Elem;", depth))
}
var $d_Ltyrian_Elem = new $TypeData().initClass({
  Ltyrian_Elem: 0
}, true, "tyrian.Elem", {
  Ltyrian_Elem: 1,
  O: 1
});
function $f_Ltyrian_HtmlAttributes__$init$__V($thiz) {
  $thiz.Ltyrian_Html$__f_accept$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accept");
  $thiz.Ltyrian_Html$__f_accessKey$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accesskey");
  $thiz.Ltyrian_Html$__f_action$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "action");
  $thiz.Ltyrian_Html$__f_alt$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "alt");
  $thiz.Ltyrian_Html$__f_autoComplete$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "autocomplete");
  $thiz.Ltyrian_Html$__f_charset$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "charset");
  $thiz.Ltyrian_Html$__f_cite$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cite");
  $thiz.Ltyrian_Html$__f_$u0060class$u0060$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_cls$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_className$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f__class$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_cols$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cols");
  $thiz.Ltyrian_Html$__f_cols$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "cols");
  $thiz.Ltyrian_Html$__f_colSpan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_colSpan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_content$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "content");
  $thiz.Ltyrian_Html$__f_contentEditable$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_contentEditable$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_coords$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "coords");
  $thiz.Ltyrian_Html$__f_data$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "data");
  $thiz.Ltyrian_Html$__f_dateTime$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "datetime");
  $thiz.Ltyrian_Html$__f_dir$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dir");
  $thiz.Ltyrian_Html$__f_dirname$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dirname");
  $thiz.Ltyrian_Html$__f_draggable$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "draggable");
  $thiz.Ltyrian_Html$__f_draggable$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "draggable");
  $thiz.Ltyrian_Html$__f_encType$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "enctype");
  $thiz.Ltyrian_Html$__f_forId$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  $thiz.Ltyrian_Html$__f_htmlFor$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  $thiz.Ltyrian_Html$__f_form$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "form");
  $thiz.Ltyrian_Html$__f_formAction$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "formaction");
  $thiz.Ltyrian_Html$__f_headers$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "headers");
  $thiz.Ltyrian_Html$__f_height$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "height");
  $thiz.Ltyrian_Html$__f_height$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "height");
  $thiz.Ltyrian_Html$__f_high$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "high");
  $thiz.Ltyrian_Html$__f_high$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "high");
  $thiz.Ltyrian_Html$__f_href$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "href");
  $thiz.Ltyrian_Html$__f_hrefLang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "hreflang");
  $thiz.Ltyrian_Html$__f_http$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "http");
  $thiz.Ltyrian_Html$__f_id$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "id");
  $thiz.Ltyrian_Html$__f_kind$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "kind");
  $thiz.Ltyrian_Html$__f_label$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "label");
  $thiz.Ltyrian_Html$__f_lang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "lang");
  $thiz.Ltyrian_Html$__f_list$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "list");
  $thiz.Ltyrian_Html$__f_low$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "low");
  $thiz.Ltyrian_Html$__f_low$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "low");
  $thiz.Ltyrian_Html$__f_max$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "max");
  $thiz.Ltyrian_Html$__f_max$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "max");
  $thiz.Ltyrian_Html$__f_maxLength$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_maxLength$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_media$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "media");
  $thiz.Ltyrian_Html$__f_method$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "method");
  $thiz.Ltyrian_Html$__f_min$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "min");
  $thiz.Ltyrian_Html$__f_min$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "min");
  $thiz.Ltyrian_Html$__f_multiple$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "multiple");
  $thiz.Ltyrian_Html$__f_muted$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "muted");
  $thiz.Ltyrian_Html$__f_name$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "name");
  $thiz.Ltyrian_Html$__f_optimum$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "optimum");
  $thiz.Ltyrian_Html$__f_optimum$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "optimum");
  $thiz.Ltyrian_Html$__f_pattern$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "pattern");
  $thiz.Ltyrian_Html$__f_placeholder$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "placeholder");
  $thiz.Ltyrian_Html$__f_poster$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "poster");
  $thiz.Ltyrian_Html$__f_preload$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "preload");
  $thiz.Ltyrian_Html$__f_rel$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rel");
  $thiz.Ltyrian_Html$__f_rows$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rows");
  $thiz.Ltyrian_Html$__f_rows$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rows");
  $thiz.Ltyrian_Html$__f_rowSpan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_rowSpan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_scope$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "scope");
  $thiz.Ltyrian_Html$__f_shape$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "shape");
  $thiz.Ltyrian_Html$__f_size$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "size");
  $thiz.Ltyrian_Html$__f_size$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "size");
  $thiz.Ltyrian_Html$__f_sizes$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "sizes");
  $thiz.Ltyrian_Html$__f_span$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "span");
  $thiz.Ltyrian_Html$__f_span$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "span");
  $thiz.Ltyrian_Html$__f_spellCheck$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_spellCheck$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_src$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "src");
  $thiz.Ltyrian_Html$__f_srcDoc$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcdoc");
  $thiz.Ltyrian_Html$__f_srcLang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srclang");
  $thiz.Ltyrian_Html$__f_srcSet$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcset");
  $thiz.Ltyrian_Html$__f_start$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "start");
  $thiz.Ltyrian_Html$__f_start$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "start");
  $thiz.Ltyrian_Html$__f_step$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "step");
  $thiz.Ltyrian_Html$__f_step$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "step");
  $thiz.Ltyrian_Html$__f_style$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "style");
  $thiz.Ltyrian_Html$__f_tabIndex$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_tabIndex$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_target$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "target");
  $thiz.Ltyrian_Html$__f_title$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "title");
  $thiz.Ltyrian_Html$__f_translate$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "translate");
  $thiz.Ltyrian_Html$__f_$u0060type$u0060$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f__type$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_typ$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_tpe$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_useMap$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "usemap");
  $thiz.Ltyrian_Html$__f_width$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "width");
  $thiz.Ltyrian_Html$__f_width$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "width");
  $thiz.Ltyrian_Html$__f_wrap$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "wrap");
  $thiz.Ltyrian_Html$__f_value$minusString = new $c_Ltyrian_HtmlAttributes$PropertyNameString($thiz, "value");
  $thiz.Ltyrian_Html$__f_value$minusDouble = new $c_Ltyrian_HtmlAttributes$PropertyNameDouble($thiz, "value");
  $thiz.Ltyrian_Html$__f_value$minusBoolean = new $c_Ltyrian_HtmlAttributes$PropertyNameBoolean($thiz, "value")
}
function $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr($thiz, msg) {
  var msg$1 = new $c_sjsr_AnonFunction1(((msg$2) => ((_$9) => msg$2))(msg));
  return new $c_Ltyrian_Event("click", msg$1)
}
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameBoolean(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameBoolean() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameBoolean = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameBoolean: 0
}, false, "tyrian.HtmlAttributes$AttributeNameBoolean", {
  Ltyrian_HtmlAttributes$AttributeNameBoolean: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameBoolean;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameDouble(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameDouble;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameDouble() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameDouble = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameDouble: 0
}, false, "tyrian.HtmlAttributes$AttributeNameDouble", {
  Ltyrian_HtmlAttributes$AttributeNameDouble: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameDouble;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameInt(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameInt;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameInt() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameInt = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameInt: 0
}, false, "tyrian.HtmlAttributes$AttributeNameInt", {
  Ltyrian_HtmlAttributes$AttributeNameInt: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameInt;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameString(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameString() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameString.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameString.prototype;
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.$colon$eq__T__Ltyrian_Attribute = (function(value) {
  $m_Ltyrian_Attribute$();
  var this$1 = this.Ltyrian_HtmlAttributes$AttributeNameString__f_name;
  return new $c_Ltyrian_Attribute(this$1, value)
});
var $d_Ltyrian_HtmlAttributes$AttributeNameString = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameString: 0
}, false, "tyrian.HtmlAttributes$AttributeNameString", {
  Ltyrian_HtmlAttributes$AttributeNameString: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameString;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameBoolean(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameBoolean() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameBoolean = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameBoolean: 0
}, false, "tyrian.HtmlAttributes$PropertyNameBoolean", {
  Ltyrian_HtmlAttributes$PropertyNameBoolean: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameBoolean;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameDouble(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameDouble;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameDouble() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameDouble = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameDouble: 0
}, false, "tyrian.HtmlAttributes$PropertyNameDouble", {
  Ltyrian_HtmlAttributes$PropertyNameDouble: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameDouble;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameString(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameString() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameString.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameString.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameString = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameString: 0
}, false, "tyrian.HtmlAttributes$PropertyNameString", {
  Ltyrian_HtmlAttributes$PropertyNameString: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameString;
function $f_Ltyrian_HtmlTags__a$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = attributes.toList__sci_List();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("a", attributes$1, children)
}
function $f_Ltyrian_HtmlTags__i$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = attributes.toList__sci_List();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("i", attributes$1, children)
}
function $f_Ltyrian_HtmlTags__option$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("option", attributes, children)
}
function $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("p", attributes, children)
}
function $f_Ltyrian_HtmlTags__span$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("span", attributes, children)
}
function $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("td", attributes, children)
}
/** @constructor */
function $c_Ltyrian_Navigation$() {
  /*<skip>*/
}
$c_Ltyrian_Navigation$.prototype = new $h_O();
$c_Ltyrian_Navigation$.prototype.constructor = $c_Ltyrian_Navigation$;
/** @constructor */
function $h_Ltyrian_Navigation$() {
  /*<skip>*/
}
$h_Ltyrian_Navigation$.prototype = $c_Ltyrian_Navigation$.prototype;
$c_Ltyrian_Navigation$.prototype.getLocationHash__F1__Ltyrian_Cmd = (function(resultToMessage) {
  var observable = new $c_Ltyrian_Navigation$$anon$2();
  var this$3 = new $c_Ltyrian_Cmd$Run$ImcompleteRunCmd(observable);
  var observable$1 = this$3.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable;
  return new $c_Ltyrian_Cmd$Run(observable$1, resultToMessage)
});
$c_Ltyrian_Navigation$.prototype.setLocationHash__T__Ltyrian_Cmd = (function(newHash) {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0(((this$1, newHash$2) => (() => {
    window.location.hash = ((($uI(newHash$2.length) >= 0) && ($as_T(newHash$2.substring(0, $uI("#".length))) === "#")) ? newHash$2 : ("#" + newHash$2))
  }))(this, newHash)))
});
var $d_Ltyrian_Navigation$ = new $TypeData().initClass({
  Ltyrian_Navigation$: 0
}, false, "tyrian.Navigation$", {
  Ltyrian_Navigation$: 1,
  O: 1
});
$c_Ltyrian_Navigation$.prototype.$classData = $d_Ltyrian_Navigation$;
var $n_Ltyrian_Navigation$;
function $m_Ltyrian_Navigation$() {
  if ((!$n_Ltyrian_Navigation$)) {
    $n_Ltyrian_Navigation$ = new $c_Ltyrian_Navigation$()
  };
  return $n_Ltyrian_Navigation$
}
function $is_Ltyrian_Sub(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Sub)))
}
function $as_Ltyrian_Sub(obj) {
  return (($is_Ltyrian_Sub(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub"))
}
function $isArrayOf_Ltyrian_Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub)))
}
function $asArrayOf_Ltyrian_Sub(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub;", depth))
}
var $d_Ltyrian_Sub = new $TypeData().initClass({
  Ltyrian_Sub: 0
}, true, "tyrian.Sub", {
  Ltyrian_Sub: 1,
  O: 1
});
function $is_Ltyrian_Task(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Task)))
}
function $as_Ltyrian_Task(obj) {
  return (($is_Ltyrian_Task(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task"))
}
function $isArrayOf_Ltyrian_Task(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task)))
}
function $asArrayOf_Ltyrian_Task(obj, depth) {
  return (($isArrayOf_Ltyrian_Task(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task;", depth))
}
function $is_Ltyrian_Task$Cancelable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Task$Cancelable)))
}
function $as_Ltyrian_Task$Cancelable(obj) {
  return (($is_Ltyrian_Task$Cancelable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Cancelable"))
}
function $isArrayOf_Ltyrian_Task$Cancelable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Cancelable)))
}
function $asArrayOf_Ltyrian_Task$Cancelable(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Cancelable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Cancelable;", depth))
}
/** @constructor */
function $c_Ltyrian_Tyrian$() {
  /*<skip>*/
}
$c_Ltyrian_Tyrian$.prototype = new $h_O();
$c_Ltyrian_Tyrian$.prototype.constructor = $c_Ltyrian_Tyrian$;
/** @constructor */
function $h_Ltyrian_Tyrian$() {
  /*<skip>*/
}
$h_Ltyrian_Tyrian$.prototype = $c_Ltyrian_Tyrian$.prototype;
$c_Ltyrian_Tyrian$.prototype.start__Lorg_scalajs_dom_Element__T2__F2__F1__F1__V = (function(node, init, update, view, subscriptions) {
  new $c_Ltyrian_runtime_TyrianRuntime(init, update, view, subscriptions, node).start__V()
});
var $d_Ltyrian_Tyrian$ = new $TypeData().initClass({
  Ltyrian_Tyrian$: 0
}, false, "tyrian.Tyrian$", {
  Ltyrian_Tyrian$: 1,
  O: 1
});
$c_Ltyrian_Tyrian$.prototype.$classData = $d_Ltyrian_Tyrian$;
var $n_Ltyrian_Tyrian$;
function $m_Ltyrian_Tyrian$() {
  if ((!$n_Ltyrian_Tyrian$)) {
    $n_Ltyrian_Tyrian$ = new $c_Ltyrian_Tyrian$()
  };
  return $n_Ltyrian_Tyrian$
}
function $f_Ltyrian_TyrianApp__launch__T__V($thiz, containerId) {
  var this$1 = $m_s_Predef$().s_Predef$__f_Map;
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  $p_Ltyrian_TyrianApp__ready__T__sci_Map__V($thiz, containerId, this$1.from__sc_IterableOnce__sci_Map(elems))
}
function $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V($thiz, containerId, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  $m_s_$less$colon$less$();
  $p_Ltyrian_TyrianApp__ready__T__sci_Map__V($thiz, containerId, $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3))
}
function $p_Ltyrian_TyrianApp__ready__T__sci_Map__V($thiz, parentElementId, flags) {
  $m_Ltyrian_Tyrian$().start__Lorg_scalajs_dom_Element__T2__F2__F1__F1__V(document.getElementById(parentElementId), $thiz.init__sci_Map__T2(flags), new $c_sjsr_AnonFunction2(((this$1) => ((msg, model) => this$1.update__Lnet_timerboard_Msg__Lnet_timerboard_Model__T2($as_Lnet_timerboard_Msg(msg), $as_Lnet_timerboard_Model(model))))($thiz)), new $c_sjsr_AnonFunction1(((this$2) => ((model$2) => this$2.view__Lnet_timerboard_Model__Ltyrian_Html($as_Lnet_timerboard_Model(model$2))))($thiz)), new $c_sjsr_AnonFunction1(((this$3) => ((model$3) => this$3.subscriptions__Lnet_timerboard_Model__Ltyrian_Sub($as_Lnet_timerboard_Model(model$3))))($thiz)))
}
function $p_Ltyrian_cmds_Dom$__affectInputElement__T__F1__F1__Ltyrian_Cmd($thiz, elementId, modifier, resultToMessage) {
  var observable = new $c_Ltyrian_cmds_Dom$$anon$2(elementId, modifier);
  var this$3 = new $c_Ltyrian_Cmd$Run$ImcompleteRunCmd(observable);
  var observable$1 = this$3.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable;
  return new $c_Ltyrian_Cmd$Run(observable$1, resultToMessage)
}
/** @constructor */
function $c_Ltyrian_cmds_Dom$() {
  /*<skip>*/
}
$c_Ltyrian_cmds_Dom$.prototype = new $h_O();
$c_Ltyrian_cmds_Dom$.prototype.constructor = $c_Ltyrian_cmds_Dom$;
/** @constructor */
function $h_Ltyrian_cmds_Dom$() {
  /*<skip>*/
}
$h_Ltyrian_cmds_Dom$.prototype = $c_Ltyrian_cmds_Dom$.prototype;
$c_Ltyrian_cmds_Dom$.prototype.focus__T__F1__Ltyrian_Cmd = (function(elementId, resultToMessage) {
  return $p_Ltyrian_cmds_Dom$__affectInputElement__T__F1__F1__Ltyrian_Cmd(this, elementId, new $c_sjsr_AnonFunction1(((this$1) => ((_$1) => {
    _$1.focus()
  }))(this)), resultToMessage)
});
var $d_Ltyrian_cmds_Dom$ = new $TypeData().initClass({
  Ltyrian_cmds_Dom$: 0
}, false, "tyrian.cmds.Dom$", {
  Ltyrian_cmds_Dom$: 1,
  O: 1
});
$c_Ltyrian_cmds_Dom$.prototype.$classData = $d_Ltyrian_cmds_Dom$;
var $n_Ltyrian_cmds_Dom$;
function $m_Ltyrian_cmds_Dom$() {
  if ((!$n_Ltyrian_cmds_Dom$)) {
    $n_Ltyrian_cmds_Dom$ = new $c_Ltyrian_cmds_Dom$()
  };
  return $n_Ltyrian_cmds_Dom$
}
function $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T($thiz, level, message) {
  return ((("[" + level) + "] [Tyrian] ") + message)
}
/** @constructor */
function $c_Ltyrian_cmds_Logger$() {
  this.Ltyrian_cmds_Logger$__f_INFO = null;
  this.Ltyrian_cmds_Logger$__f_ERROR = null;
  this.Ltyrian_cmds_Logger$__f_DEBUG = null;
  this.Ltyrian_cmds_Logger$__f_errorLogs = null;
  this.Ltyrian_cmds_Logger$__f_debugLogs = null;
  this.Ltyrian_cmds_Logger$__f_consoleLogString = null;
  this.Ltyrian_cmds_Logger$__f_infoString = null;
  this.Ltyrian_cmds_Logger$__f_errorString = null;
  this.Ltyrian_cmds_Logger$__f_errorOnceString = null;
  this.Ltyrian_cmds_Logger$__f_debugString = null;
  this.Ltyrian_cmds_Logger$__f_debugOnceString = null;
  $n_Ltyrian_cmds_Logger$ = this;
  this.Ltyrian_cmds_Logger$__f_INFO = "INFO";
  this.Ltyrian_cmds_Logger$__f_ERROR = "ERROR";
  this.Ltyrian_cmds_Logger$__f_DEBUG = "DEBUG";
  this.Ltyrian_cmds_Logger$__f_errorLogs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  this.Ltyrian_cmds_Logger$__f_debugLogs = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  this.Ltyrian_cmds_Logger$__f_consoleLogString = new $c_sjsr_AnonFunction1(((this$1) => ((message) => {
    var message$1 = $as_T(message);
    var this$3 = $m_s_Console$();
    var this$4 = this$3.out__Ljava_io_PrintStream();
    this$4.java$lang$JSConsoleBasedPrintStream$$printString__T__V((message$1 + "\n"))
  }))(this));
  this.Ltyrian_cmds_Logger$__f_infoString = new $c_sjsr_AnonFunction1(((this$2$1) => ((message$2) => {
    var message$3 = $as_T(message$2);
    var x = $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T(this$2$1, this$2$1.Ltyrian_cmds_Logger$__f_INFO, message$3);
    var this$6 = $m_s_Console$();
    var this$7 = this$6.out__Ljava_io_PrintStream();
    this$7.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x + "\n"))
  }))(this));
  this.Ltyrian_cmds_Logger$__f_errorString = new $c_sjsr_AnonFunction1(((this$3$1) => ((message$3$1) => {
    var message$4 = $as_T(message$3$1);
    var x$1 = $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T(this$3$1, this$3$1.Ltyrian_cmds_Logger$__f_ERROR, message$4);
    var this$9 = $m_s_Console$();
    var this$10 = this$9.out__Ljava_io_PrintStream();
    this$10.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x$1 + "\n"))
  }))(this));
  this.Ltyrian_cmds_Logger$__f_errorOnceString = new $c_sjsr_AnonFunction1(((this$4$1) => ((message$4$1) => {
    var message$5 = $as_T(message$4$1);
    var this$11 = this$4$1.Ltyrian_cmds_Logger$__f_errorLogs;
    if ((!$f_sc_SeqOps__contains__O__Z(this$11, message$5))) {
      var this$12 = this$4$1.Ltyrian_cmds_Logger$__f_errorLogs;
      this$12.addOne__O__scm_ArrayBuffer(message$5);
      var x$2 = $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T(this$4$1, this$4$1.Ltyrian_cmds_Logger$__f_ERROR, message$5);
      var this$14 = $m_s_Console$();
      var this$15 = this$14.out__Ljava_io_PrintStream();
      this$15.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x$2 + "\n"))
    }
  }))(this));
  this.Ltyrian_cmds_Logger$__f_debugString = new $c_sjsr_AnonFunction1(((this$5$1) => ((message$5$1) => {
    var message$6 = $as_T(message$5$1);
    var x$3 = $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T(this$5$1, this$5$1.Ltyrian_cmds_Logger$__f_DEBUG, message$6);
    var this$17 = $m_s_Console$();
    var this$18 = this$17.out__Ljava_io_PrintStream();
    this$18.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x$3 + "\n"))
  }))(this));
  this.Ltyrian_cmds_Logger$__f_debugOnceString = new $c_sjsr_AnonFunction1(((this$6$1) => ((message$6$1) => {
    var message$7 = $as_T(message$6$1);
    var this$19 = this$6$1.Ltyrian_cmds_Logger$__f_debugLogs;
    if ((!$f_sc_SeqOps__contains__O__Z(this$19, message$7))) {
      var this$20 = this$6$1.Ltyrian_cmds_Logger$__f_debugLogs;
      this$20.addOne__O__scm_ArrayBuffer(message$7);
      var x$4 = $p_Ltyrian_cmds_Logger$__formatMessage__T__T__T(this$6$1, this$6$1.Ltyrian_cmds_Logger$__f_DEBUG, message$7);
      var this$22 = $m_s_Console$();
      var this$23 = this$22.out__Ljava_io_PrintStream();
      this$23.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x$4 + "\n"))
    }
  }))(this))
}
$c_Ltyrian_cmds_Logger$.prototype = new $h_O();
$c_Ltyrian_cmds_Logger$.prototype.constructor = $c_Ltyrian_cmds_Logger$;
/** @constructor */
function $h_Ltyrian_cmds_Logger$() {
  /*<skip>*/
}
$h_Ltyrian_cmds_Logger$.prototype = $c_Ltyrian_cmds_Logger$.prototype;
$c_Ltyrian_cmds_Logger$.prototype.info__sci_Seq__Ltyrian_Cmd$SideEffect = (function(messages) {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0(((this$1, messages$2) => (() => {
    var $$x1 = this$1.Ltyrian_cmds_Logger$__f_infoString;
    var this$2 = messages$2.toList__sci_List();
    $$x1.apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", ", ", ""))
  }))(this, messages)))
});
$c_Ltyrian_cmds_Logger$.prototype.error__sci_Seq__Ltyrian_Cmd$SideEffect = (function(messages) {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0(((this$1, messages$2) => (() => {
    var $$x1 = this$1.Ltyrian_cmds_Logger$__f_errorString;
    var this$2 = messages$2.toList__sci_List();
    $$x1.apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", ", ", ""))
  }))(this, messages)))
});
var $d_Ltyrian_cmds_Logger$ = new $TypeData().initClass({
  Ltyrian_cmds_Logger$: 0
}, false, "tyrian.cmds.Logger$", {
  Ltyrian_cmds_Logger$: 1,
  O: 1
});
$c_Ltyrian_cmds_Logger$.prototype.$classData = $d_Ltyrian_cmds_Logger$;
var $n_Ltyrian_cmds_Logger$;
function $m_Ltyrian_cmds_Logger$() {
  if ((!$n_Ltyrian_cmds_Logger$)) {
    $n_Ltyrian_cmds_Logger$ = new $c_Ltyrian_cmds_Logger$()
  };
  return $n_Ltyrian_cmds_Logger$
}
function $p_Ltyrian_http_Http$__parseHeaders__T__sci_Map($thiz, headers) {
  var $$x11 = $m_s_Predef$();
  var xs = $f_T__split__T__I__AT(headers, "[\\u000d\\u000a]+", 0);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var i = 0;
  while ((i < xs.u.length)) {
    var arg1 = xs.get(i);
    var h = $as_T(arg1);
    try {
      matchResult3: {
        var \u03b41$___1;
        var \u03b41$___2;
        var xs$1 = $f_T__split__T__I__AT(h, ":", 0);
        var f = ((this$8) => ((_$6) => {
          var _$6$1 = $as_T(_$6);
          return $f_T__trim__T(_$6$1)
        }))($thiz);
        var len = xs$1.u.length;
        var ys = new ($d_T.getArrayOf().constr)(len);
        if ((len > 0)) {
          var i$1 = 0;
          if ((xs$1 !== null)) {
            while ((i$1 < len)) {
              var $$x2 = i$1;
              var arg1$1 = xs$1.get(i$1);
              ys.set($$x2, f(arg1$1));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs$1, 1);
            while ((i$1 < len)) {
              var $$x3 = i$1;
              var arg1$2 = x3.get(i$1);
              ys.set($$x3, f(arg1$2));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs$1, 1);
            while ((i$1 < len)) {
              var $$x4 = i$1;
              var arg1$3 = x4.get(i$1);
              ys.set($$x4, f(arg1$3));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs$1, 1);
            while ((i$1 < len)) {
              var $$x5 = i$1;
              var t = x5.get(i$1);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              ys.set($$x5, f(new $c_RTLong(lo, hi)));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs$1, 1);
            while ((i$1 < len)) {
              var $$x6 = i$1;
              var arg1$4 = x6.get(i$1);
              ys.set($$x6, f(arg1$4));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs$1, 1);
            while ((i$1 < len)) {
              var $$x7 = i$1;
              var arg1$5 = x7.get(i$1);
              ys.set($$x7, f($bC(arg1$5)));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs$1, 1);
            while ((i$1 < len)) {
              var $$x8 = i$1;
              var arg1$6 = x8.get(i$1);
              ys.set($$x8, f(arg1$6));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs$1, 1);
            while ((i$1 < len)) {
              var $$x9 = i$1;
              var arg1$7 = x9.get(i$1);
              ys.set($$x9, f(arg1$7));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((xs$1 instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs$1, 1);
            while ((i$1 < len)) {
              var $$x10 = i$1;
              var arg1$8 = x10.get(i$1);
              ys.set($$x10, f(arg1$8));
              i$1 = ((1 + i$1) | 0)
            }
          } else {
            throw new $c_s_MatchError(xs$1)
          }
        };
        var x11 = $asArrayOf_T($m_sc_ArrayOps$().slice$extension__O__I__I__O(ys, 0, 2), 1);
        if ((x11 !== null)) {
          if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x11, 2) === 0)) {
            var x13 = $as_T(x11.get(0));
            var x14 = $as_T(x11.get(1));
            var \u03b41$___1 = x13;
            var \u03b41$___2 = x14;
            break matchResult3
          }
        };
        throw new $c_s_MatchError(x11)
      };
      var fst$2 = $as_T(\u03b41$___1);
      var scd$2 = $as_T(\u03b41$___2);
      var $$x1 = new $c_s_util_Success($ct_T2__O__O__(new $c_T2(), fst$2, scd$2))
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if ((e$2 !== null)) {
        matchEnd8: {
          var $$x1;
          if ((e$2 !== null)) {
            var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
            if ((!o11.isEmpty__Z())) {
              var e$3 = $as_jl_Throwable(o11.get__O());
              var $$x1 = new $c_s_util_Failure(e$3);
              break matchEnd8
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        }
      } else {
        var $$x1;
        throw e
      }
    };
    var xs$2 = $$x1.toOption__s_Option();
    var it = xs$2.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    i = ((1 + i) | 0)
  };
  var this$18 = $$x11.wrapRefArray__AO__scm_ArraySeq$ofRef(new ($d_T2.getArrayOf().constr)(jsElems));
  $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$18)
}
function $p_Ltyrian_http_Http$__liftedTree1$1__Ltyrian_http_Request__Ltyrian_Task$Observer__Lorg_scalajs_dom_XMLHttpRequest__V($thiz, request$2, observer$1, xhr$1) {
  try {
    var this$1 = request$2.Ltyrian_http_Request__f_headers;
    var these = this$1;
    while ((!these.isEmpty__Z())) {
      var arg1 = these.head__O();
      var h = $as_Ltyrian_http_Header(arg1);
      xhr$1.setRequestHeader(h.name__T(), h.value__T());
      these = $as_sci_List(these.tail__O())
    };
    var this$2 = request$2.Ltyrian_http_Request__f_timeout;
    if (this$2.isEmpty__Z()) {
      var this$4 = $m_s_None$()
    } else {
      var arg1$1 = this$2.get__O();
      var _$1 = $as_s_concurrent_duration_FiniteDuration(arg1$1);
      var this$3 = _$1.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(_$1.s_concurrent_duration_FiniteDuration__f_length);
      var this$4 = new $c_s_Some($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi))
    };
    xhr$1.timeout = $uD((this$4.isEmpty__Z() ? 0.0 : this$4.get__O()));
    xhr$1.withCredentials = request$2.Ltyrian_http_Request__f_withCredentials;
    xhr$1.open(request$2.Ltyrian_http_Request__f_method.asString__T(), request$2.Ltyrian_http_Request__f_url);
    xhr$1.onload = ((this$4$1, observer$1$2, xhr$1$3) => ((_$2) => {
      observer$1$2.onNext__O__V(xhr$1$3)
    }))($thiz, observer$1, xhr$1);
    xhr$1.onerror = ((this$5, observer$1$3) => ((_$3) => {
      observer$1$3.onError__O__V($s_Ltyrian_http_HttpError$__NetworkError__Ltyrian_http_HttpError())
    }))($thiz, observer$1);
    xhr$1.ontimeout = ((this$6, observer$1$4) => ((_$4) => {
      observer$1$4.onError__O__V($s_Ltyrian_http_HttpError$__Timeout__Ltyrian_http_HttpError())
    }))($thiz, observer$1);
    matchResult1: {
      var x1 = request$2.Ltyrian_http_Request__f_body;
      var x = $s_Ltyrian_http_Body$__Empty__Ltyrian_http_Body();
      if (((x === null) ? (x1 === null) : x.equals__O__Z(x1))) {
        xhr$1.send(null);
        break matchResult1
      };
      if (false) {
        var x$1 = $as_Ltyrian_http_Body$PlainText(x1);
        var x4 = x$1.Ltyrian_http_Body$PlainText__f_contentType;
        var x5 = x$1.Ltyrian_http_Body$PlainText__f_body;
        xhr$1.setRequestHeader("Content-Type", x4);
        xhr$1.send(x5);
        break matchResult1
      };
      throw new $c_s_MatchError(x1)
    }
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    var msg = e$2.getMessage__T();
    observer$1.onError__O__V(new $c_Ltyrian_http_HttpError$BadRequest(msg))
  }
}
/** @constructor */
function $c_Ltyrian_http_Http$() {
  /*<skip>*/
}
$c_Ltyrian_http_Http$.prototype = new $h_O();
$c_Ltyrian_http_Http$.prototype.constructor = $c_Ltyrian_http_Http$;
/** @constructor */
function $h_Ltyrian_http_Http$() {
  /*<skip>*/
}
$h_Ltyrian_http_Http$.prototype = $c_Ltyrian_http_Http$.prototype;
$c_Ltyrian_http_Http$.prototype.send__Ltyrian_http_Request__F1__Ltyrian_Cmd = (function(request, resultToMessage) {
  var observable = new $c_Ltyrian_http_Http$$anon$2(request);
  var this$8 = new $c_Ltyrian_Task$RunObservable(observable);
  var toMessage = new $c_sjsr_AnonFunction1(((this$2, request$2) => ((_$5) => {
    var _$5$1 = $as_s_util_Either(_$5);
    if ((_$5$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$5$1);
      var b = x2.s_util_Right__f_value;
      var url = request$2.Ltyrian_http_Request__f_url;
      var code = $uI(b.status);
      var message = $as_T(b.statusText);
      var status = new $c_Ltyrian_http_Status(code, message);
      var headers = $p_Ltyrian_http_Http$__parseHeaders__T__sci_Map(this$2, $as_T(b.getAllResponseHeaders()));
      var body = $as_T(b.responseText);
      var response = new $c_Ltyrian_http_Response(url, status, headers, body);
      var x6 = $as_s_util_Either(request$2.Ltyrian_http_Request__f_expect.apply__O__O(response));
      if ((x6 instanceof $c_s_util_Right)) {
        var r = $as_s_util_Right(x6).s_util_Right__f_value;
        $m_s_package$();
        return new $c_s_util_Right(r)
      };
      if ((x6 instanceof $c_s_util_Left)) {
        var e = $as_T($as_s_util_Left(x6).s_util_Left__f_value);
        $m_s_package$();
        var value = new $c_Ltyrian_http_HttpError$DecodingFailure(e, response);
        return new $c_s_util_Left(value)
      };
      throw new $c_s_MatchError(x6)
    } else {
      return _$5$1
    }
  }))(this, request));
  var this$10 = new $c_Ltyrian_Cmd$RunTask(this$8, toMessage);
  return this$10.map__F1__Ltyrian_Cmd$RunTask(resultToMessage)
});
var $d_Ltyrian_http_Http$ = new $TypeData().initClass({
  Ltyrian_http_Http$: 0
}, false, "tyrian.http.Http$", {
  Ltyrian_http_Http$: 1,
  O: 1
});
$c_Ltyrian_http_Http$.prototype.$classData = $d_Ltyrian_http_Http$;
var $n_Ltyrian_http_Http$;
function $m_Ltyrian_http_Http$() {
  if ((!$n_Ltyrian_http_Http$)) {
    $n_Ltyrian_http_Http$ = new $c_Ltyrian_http_Http$()
  };
  return $n_Ltyrian_http_Http$
}
/** @constructor */
function $c_Ltyrian_http_Http$Decoder$() {
  this.Ltyrian_http_Http$Decoder$__f_asString = null;
  $n_Ltyrian_http_Http$Decoder$ = this;
  $m_Ltyrian_http_Http$Decoder$();
  var decoder = new $c_sjsr_AnonFunction1(((this$1) => ((response) => {
    var response$1 = $as_Ltyrian_http_Response(response);
    $m_s_package$();
    var value = response$1.Ltyrian_http_Response__f_body;
    return new $c_s_util_Right(value)
  }))(this));
  this.Ltyrian_http_Http$Decoder$__f_asString = decoder
}
$c_Ltyrian_http_Http$Decoder$.prototype = new $h_O();
$c_Ltyrian_http_Http$Decoder$.prototype.constructor = $c_Ltyrian_http_Http$Decoder$;
/** @constructor */
function $h_Ltyrian_http_Http$Decoder$() {
  /*<skip>*/
}
$h_Ltyrian_http_Http$Decoder$.prototype = $c_Ltyrian_http_Http$Decoder$.prototype;
var $d_Ltyrian_http_Http$Decoder$ = new $TypeData().initClass({
  Ltyrian_http_Http$Decoder$: 0
}, false, "tyrian.http.Http$Decoder$", {
  Ltyrian_http_Http$Decoder$: 1,
  O: 1
});
$c_Ltyrian_http_Http$Decoder$.prototype.$classData = $d_Ltyrian_http_Http$Decoder$;
var $n_Ltyrian_http_Http$Decoder$;
function $m_Ltyrian_http_Http$Decoder$() {
  if ((!$n_Ltyrian_http_Http$Decoder$)) {
    $n_Ltyrian_http_Http$Decoder$ = new $c_Ltyrian_http_Http$Decoder$()
  };
  return $n_Ltyrian_http_Http$Decoder$
}
function $p_Ltyrian_runtime_CmdRunner$__loop$1__F1__F1__Ltyrian_Cmd__V($thiz, callback$1, async$1, cmd) {
  var cmd$tailLocal1 = cmd;
  while (true) {
    matchResult1: {
      var x1 = cmd$tailLocal1;
      var x = $m_Ltyrian_Cmd$Empty$();
      if ((x === x1)) {
        break matchResult1
      };
      if ((x1 instanceof $c_Ltyrian_Cmd$Emit)) {
        var x$1 = $as_Ltyrian_Cmd$Emit(x1);
        var x22 = x$1.Ltyrian_Cmd$Emit__f_msg;
        callback$1.apply__O__O(x22);
        break matchResult1
      };
      if ((x1 instanceof $c_Ltyrian_Cmd$SideEffect)) {
        var x$1$1 = $as_Ltyrian_Cmd$SideEffect(x1);
        var x19 = x$1$1.Ltyrian_Cmd$SideEffect__f_task;
        async$1.apply__O__O(new $c_sjsr_AnonFunction0(((this$3, task$2) => (() => {
          $m_Ltyrian_runtime_TaskRunner$().execTask__Ltyrian_Task__F1__V(task$2, new $c_sjsr_AnonFunction1(((this$4) => ((_$1) => {
            $as_s_util_Either(_$1)
          }))(this$3)))
        }))($thiz, x19)));
        break matchResult1
      };
      if ((x1 instanceof $c_Ltyrian_Cmd$Run)) {
        var x$1$2 = $as_Ltyrian_Cmd$Run(x1);
        var x15 = x$1$2.Ltyrian_Cmd$Run__f_observable;
        var x16 = x$1$2.Ltyrian_Cmd$Run__f_toMessage;
        async$1.apply__O__O(new $c_sjsr_AnonFunction0(((this$2$1, callback$1$2, obs$2, f$2) => (() => {
          $m_Ltyrian_runtime_TaskRunner$().execTask__Ltyrian_Task__F1__V(new $c_Ltyrian_Task$RunObservable(obs$2), f$2.andThen__F1__F1(callback$1$2))
        }))($thiz, callback$1, x15, x16)));
        break matchResult1
      };
      if ((x1 instanceof $c_Ltyrian_Cmd$RunTask)) {
        var x$1$3 = $as_Ltyrian_Cmd$RunTask(x1);
        var x11 = x$1$3.Ltyrian_Cmd$RunTask__f_task;
        var x12 = x$1$3.Ltyrian_Cmd$RunTask__f_toMessage;
        async$1.apply__O__O(new $c_sjsr_AnonFunction0(((this$3$1, callback$1$3, task$4, f$4) => (() => {
          $m_Ltyrian_runtime_TaskRunner$().execTask__Ltyrian_Task__F1__V(task$4, f$4.andThen__F1__F1(callback$1$3))
        }))($thiz, callback$1, x11, x12)));
        break matchResult1
      };
      if (false) {
        var x$1$4 = $as_Ltyrian_Cmd$Combine(x1);
        var x7 = x$1$4.Ltyrian_Cmd$Combine__f_cmd1;
        var x8 = x$1$4.Ltyrian_Cmd$Combine__f_cmd2;
        $p_Ltyrian_runtime_CmdRunner$__loop$1__F1__F1__Ltyrian_Cmd__V($thiz, callback$1, async$1, x7);
        cmd$tailLocal1 = x8;
        continue
      };
      if ((x1 instanceof $c_Ltyrian_Cmd$Batch)) {
        var x$1$5 = $as_Ltyrian_Cmd$Batch(x1);
        var x4 = x$1$5.Ltyrian_Cmd$Batch__f_cmds;
        var these = x4;
        while ((!these.isEmpty__Z())) {
          var arg1 = these.head__O();
          var cmd$1 = $as_Ltyrian_Cmd(arg1);
          $p_Ltyrian_runtime_CmdRunner$__loop$1__F1__F1__Ltyrian_Cmd__V($thiz, callback$1, async$1, cmd$1);
          these = $as_sci_List(these.tail__O())
        };
        break matchResult1
      };
      throw new $c_s_MatchError(x1)
    };
    return (void 0)
  }
}
/** @constructor */
function $c_Ltyrian_runtime_CmdRunner$() {
  /*<skip>*/
}
$c_Ltyrian_runtime_CmdRunner$.prototype = new $h_O();
$c_Ltyrian_runtime_CmdRunner$.prototype.constructor = $c_Ltyrian_runtime_CmdRunner$;
/** @constructor */
function $h_Ltyrian_runtime_CmdRunner$() {
  /*<skip>*/
}
$h_Ltyrian_runtime_CmdRunner$.prototype = $c_Ltyrian_runtime_CmdRunner$.prototype;
$c_Ltyrian_runtime_CmdRunner$.prototype.runCmd__Ltyrian_Cmd__F1__F1__V = (function(cmd, callback, async) {
  $p_Ltyrian_runtime_CmdRunner$__loop$1__F1__F1__Ltyrian_Cmd__V(this, callback, async, cmd)
});
var $d_Ltyrian_runtime_CmdRunner$ = new $TypeData().initClass({
  Ltyrian_runtime_CmdRunner$: 0
}, false, "tyrian.runtime.CmdRunner$", {
  Ltyrian_runtime_CmdRunner$: 1,
  O: 1
});
$c_Ltyrian_runtime_CmdRunner$.prototype.$classData = $d_Ltyrian_runtime_CmdRunner$;
var $n_Ltyrian_runtime_CmdRunner$;
function $m_Ltyrian_runtime_CmdRunner$() {
  if ((!$n_Ltyrian_runtime_CmdRunner$)) {
    $n_Ltyrian_runtime_CmdRunner$ = new $c_Ltyrian_runtime_CmdRunner$()
  };
  return $n_Ltyrian_runtime_CmdRunner$
}
function $p_Ltyrian_runtime_TaskRunner$__liftedTree1$1__F0__s_util_Either($thiz, thunk$1) {
  try {
    $m_s_package$();
    var value = thunk$1.apply__O();
    return new $c_s_util_Right(value)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x2.isEmpty__Z())) {
        var x3 = $as_jl_Throwable(x2.get__O());
        $m_s_package$();
        var value$1 = x3.getMessage__T();
        return new $c_s_util_Left(value$1)
      }
    };
    throw e$2
  }
}
function $p_Ltyrian_runtime_TaskRunner$__notifyProduct$1__F1__sr_ObjectRef__sr_ObjectRef__V($thiz, notify$3, r1$1, r2$1) {
  var _1 = $as_s_Option(r1$1.sr_ObjectRef__f_elem);
  var _2 = $as_s_Option(r2$1.sr_ObjectRef__f_elem);
  if ((_1 instanceof $c_s_Some)) {
    var x64 = $as_s_util_Either($as_s_Some(_1).s_Some__f_value);
    if ((x64 instanceof $c_s_util_Right)) {
      var s1 = $as_s_util_Right(x64).s_util_Right__f_value;
      if ((_2 instanceof $c_s_Some)) {
        var x60 = $as_s_util_Either($as_s_Some(_2).s_Some__f_value);
        if ((x60 instanceof $c_s_util_Right)) {
          var s2 = $as_s_util_Right(x60).s_util_Right__f_value;
          $m_s_package$();
          var value = $ct_T2__O__O__(new $c_T2(), s1, s2);
          notify$3.apply__O__O(new $c_s_util_Right(value));
          return (void 0)
        }
      }
    };
    if ((x64 instanceof $c_s_util_Left)) {
      var e = $as_s_util_Left(x64).s_util_Left__f_value;
      notify$3.apply__O__O(($m_s_package$(), new $c_s_util_Left(e)));
      return (void 0)
    }
  };
  if ((_2 instanceof $c_s_Some)) {
    var x48 = $as_s_util_Either($as_s_Some(_2).s_Some__f_value);
    if ((x48 instanceof $c_s_util_Left)) {
      var e$2 = $as_s_util_Left(x48).s_util_Left__f_value;
      notify$3.apply__O__O(($m_s_package$(), new $c_s_util_Left(e$2)));
      return (void 0)
    }
  }
}
/** @constructor */
function $c_Ltyrian_runtime_TaskRunner$() {
  /*<skip>*/
}
$c_Ltyrian_runtime_TaskRunner$.prototype = new $h_O();
$c_Ltyrian_runtime_TaskRunner$.prototype.constructor = $c_Ltyrian_runtime_TaskRunner$;
/** @constructor */
function $h_Ltyrian_runtime_TaskRunner$() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TaskRunner$.prototype = $c_Ltyrian_runtime_TaskRunner$.prototype;
$c_Ltyrian_runtime_TaskRunner$.prototype.execTask__Ltyrian_Task__F1__V = (function(task, notifier) {
  if ((task instanceof $c_Ltyrian_Task$SideEffect)) {
    var x$1 = $as_Ltyrian_Task$SideEffect(task);
    var x36 = x$1.Ltyrian_Task$SideEffect__f_thunk;
    x36.apply__O();
    return (void 0)
  };
  if ((task instanceof $c_Ltyrian_Task$Delay)) {
    var x$1$1 = $as_Ltyrian_Task$Delay(task);
    var x33 = x$1$1.Ltyrian_Task$Delay__f_thunk;
    notifier.apply__O__O($p_Ltyrian_runtime_TaskRunner$__liftedTree1$1__F0__s_util_Either(this, x33));
    return (void 0)
  };
  if (false) {
    var x$1$2 = $as_Ltyrian_Task$Succeeded(task);
    var x30 = x$1$2.Ltyrian_Task$Succeeded__f_value;
    notifier.apply__O__O(($m_s_package$(), new $c_s_util_Right(x30)));
    return (void 0)
  };
  if (false) {
    var x$1$3 = $as_Ltyrian_Task$Failed(task);
    var x27 = x$1$3.Ltyrian_Task$Failed__f_error;
    notifier.apply__O__O(($m_s_package$(), new $c_s_util_Left(x27)));
    return (void 0)
  };
  if ((task instanceof $c_Ltyrian_Task$RunObservable)) {
    var x$1$4 = $as_Ltyrian_Task$RunObservable(task);
    var x24 = x$1$4.Ltyrian_Task$RunObservable__f_observable;
    x24.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable(new $c_Ltyrian_runtime_TaskRunner$$anon$1(notifier));
    return (void 0)
  };
  if ((task instanceof $c_Ltyrian_Task$Mapped)) {
    var x$1$5 = $as_Ltyrian_Task$Mapped(task);
    var t = $as_Ltyrian_Task$Mapped(task);
    this.execTaskMapped__Ltyrian_Task$Mapped__F1__V(t, notifier);
    return (void 0)
  };
  if (false) {
    var x$1$6 = $as_Ltyrian_Task$Recovered(task);
    var t$2 = $as_Ltyrian_Task$Recovered(task);
    this.execTaskRecovered__Ltyrian_Task$Recovered__F1__V(t$2, notifier);
    return (void 0)
  };
  if (false) {
    var x$1$7 = $as_Ltyrian_Task$Multiplied(task);
    var t$3 = $as_Ltyrian_Task$Multiplied(task);
    this.execTaskMultiplied__Ltyrian_Task$Multiplied__F1__V(t$3, notifier);
    return (void 0)
  };
  if (false) {
    var x$1$8 = $as_Ltyrian_Task$FlatMapped(task);
    var t$4 = $as_Ltyrian_Task$FlatMapped(task);
    this.execTaskFlatMapped__Ltyrian_Task$FlatMapped__F1__V(t$4, notifier);
    return (void 0)
  };
  throw new $c_s_MatchError(task)
});
$c_Ltyrian_runtime_TaskRunner$.prototype.execTaskMapped__Ltyrian_Task$Mapped__F1__V = (function(mapped, notify) {
  this.execTask__Ltyrian_Task__F1__V(mapped.Ltyrian_Task$Mapped__f_task, new $c_sjsr_AnonFunction1(((this$1, mapped$2, notify$2) => ((msg) => {
    var msg$1 = $as_s_util_Either(msg);
    notify$2.apply__O__O(msg$1.map__F1__s_util_Either(mapped$2.Ltyrian_Task$Mapped__f_f))
  }))(this, mapped, notify)))
});
$c_Ltyrian_runtime_TaskRunner$.prototype.execTaskRecovered__Ltyrian_Task$Recovered__F1__V = (function(recovered, notify) {
  this.execTask__Ltyrian_Task__F1__V(recovered.Ltyrian_Task$Recovered__f_task, new $c_sjsr_AnonFunction1(((this$1, recovered$2, notify$2) => ((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    matchResult3: {
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var err = $as_s_util_Left(x$1$1).s_util_Left__f_value;
        this$1.execTask__Ltyrian_Task__F1__V($as_Ltyrian_Task(recovered$2.Ltyrian_Task$Recovered__f_recoverWith.apply__O__O(err)), notify$2);
        break matchResult3
      };
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var success = $as_s_util_Right(x$1$1).s_util_Right__f_value;
        notify$2.apply__O__O(($m_s_package$(), new $c_s_util_Right(success)));
        break matchResult3
      };
      throw new $c_s_MatchError(x$1$1)
    }
  }))(this, recovered, notify)))
});
$c_Ltyrian_runtime_TaskRunner$.prototype.execTaskMultiplied__Ltyrian_Task$Multiplied__F1__V = (function(multiplied, notify) {
  var elem = $m_s_None$();
  var r1 = new $c_sr_ObjectRef(elem);
  var elem$1 = $m_s_None$();
  var r2 = new $c_sr_ObjectRef(elem$1);
  this.execTask__Ltyrian_Task__F1__V(multiplied.Ltyrian_Task$Multiplied__f_task1, new $c_sjsr_AnonFunction1(((this$3, notify$2, r1$2, r2$2) => ((result) => {
    var result$1 = $as_s_util_Either(result);
    var this$4 = $as_s_Option(r2$2.sr_ObjectRef__f_elem);
    if (this$4.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$4.get__O();
      var _$1 = $as_s_util_Either(arg1);
      var $$x1 = _$1.isRight__Z()
    };
    if ($$x1) {
      var ev$1 = new $c_s_Some(result$1);
      r1$2.sr_ObjectRef__f_elem = ev$1;
      $p_Ltyrian_runtime_TaskRunner$__notifyProduct$1__F1__sr_ObjectRef__sr_ObjectRef__V(this$3, notify$2, r1$2, r2$2)
    }
  }))(this, notify, r1, r2)));
  this.execTask__Ltyrian_Task__F1__V(multiplied.Ltyrian_Task$Multiplied__f_task2, new $c_sjsr_AnonFunction1(((this$2$1, notify$3, r1$3, r2$3) => ((result$2) => {
    var result$3 = $as_s_util_Either(result$2);
    var this$6 = $as_s_Option(r1$3.sr_ObjectRef__f_elem);
    if (this$6.isEmpty__Z()) {
      var $$x2 = true
    } else {
      var arg1$1 = this$6.get__O();
      var _$2 = $as_s_util_Either(arg1$1);
      var $$x2 = _$2.isRight__Z()
    };
    if ($$x2) {
      var ev$2 = new $c_s_Some(result$3);
      r2$3.sr_ObjectRef__f_elem = ev$2;
      $p_Ltyrian_runtime_TaskRunner$__notifyProduct$1__F1__sr_ObjectRef__sr_ObjectRef__V(this$2$1, notify$3, r1$3, r2$3)
    }
  }))(this, notify, r1, r2)))
});
$c_Ltyrian_runtime_TaskRunner$.prototype.execTaskFlatMapped__Ltyrian_Task$FlatMapped__F1__V = (function(flatMapped, notify) {
  this.execTask__Ltyrian_Task__F1__V(flatMapped.Ltyrian_Task$FlatMapped__f_task, new $c_sjsr_AnonFunction1(((this$1, flatMapped$2, notify$2) => ((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    if ((_$3$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$3$1);
      var b = x2.s_util_Right__f_value;
      this$1.execTask__Ltyrian_Task__F1__V($as_Ltyrian_Task(flatMapped$2.Ltyrian_Task$FlatMapped__f_f.apply__O__O(b)), notify$2)
    }
  }))(this, flatMapped, notify)))
});
var $d_Ltyrian_runtime_TaskRunner$ = new $TypeData().initClass({
  Ltyrian_runtime_TaskRunner$: 0
}, false, "tyrian.runtime.TaskRunner$", {
  Ltyrian_runtime_TaskRunner$: 1,
  O: 1
});
$c_Ltyrian_runtime_TaskRunner$.prototype.$classData = $d_Ltyrian_runtime_TaskRunner$;
var $n_Ltyrian_runtime_TaskRunner$;
function $m_Ltyrian_runtime_TaskRunner$() {
  if ((!$n_Ltyrian_runtime_TaskRunner$)) {
    $n_Ltyrian_runtime_TaskRunner$ = new $c_Ltyrian_runtime_TaskRunner$()
  };
  return $n_Ltyrian_runtime_TaskRunner$
}
/** @constructor */
function $c_Ltyrian_websocket_LiveSocket(socket, subs) {
  this.Ltyrian_websocket_LiveSocket__f_socket = null;
  this.Ltyrian_websocket_LiveSocket__f_subs = null;
  this.Ltyrian_websocket_LiveSocket__f_socket = socket;
  this.Ltyrian_websocket_LiveSocket__f_subs = subs
}
$c_Ltyrian_websocket_LiveSocket.prototype = new $h_O();
$c_Ltyrian_websocket_LiveSocket.prototype.constructor = $c_Ltyrian_websocket_LiveSocket;
/** @constructor */
function $h_Ltyrian_websocket_LiveSocket() {
  /*<skip>*/
}
$h_Ltyrian_websocket_LiveSocket.prototype = $c_Ltyrian_websocket_LiveSocket.prototype;
function $as_Ltyrian_websocket_LiveSocket(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_LiveSocket) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.LiveSocket"))
}
function $isArrayOf_Ltyrian_websocket_LiveSocket(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_LiveSocket)))
}
function $asArrayOf_Ltyrian_websocket_LiveSocket(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_LiveSocket(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.LiveSocket;", depth))
}
var $d_Ltyrian_websocket_LiveSocket = new $TypeData().initClass({
  Ltyrian_websocket_LiveSocket: 0
}, false, "tyrian.websocket.LiveSocket", {
  Ltyrian_websocket_LiveSocket: 1,
  O: 1
});
$c_Ltyrian_websocket_LiveSocket.prototype.$classData = $d_Ltyrian_websocket_LiveSocket;
/** @constructor */
function $c_Ltyrian_websocket_WebSocket(liveSocket) {
  this.Ltyrian_websocket_WebSocket__f_liveSocket = null;
  this.Ltyrian_websocket_WebSocket__f_liveSocket = liveSocket
}
$c_Ltyrian_websocket_WebSocket.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocket.prototype.constructor = $c_Ltyrian_websocket_WebSocket;
/** @constructor */
function $h_Ltyrian_websocket_WebSocket() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocket.prototype = $c_Ltyrian_websocket_WebSocket.prototype;
$c_Ltyrian_websocket_WebSocket.prototype.disconnect__Ltyrian_Cmd = (function() {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0(((this$1) => (() => {
    this$1.Ltyrian_websocket_WebSocket__f_liveSocket.Ltyrian_websocket_LiveSocket__f_socket.close(1000, "Graceful shutdown")
  }))(this)))
});
$c_Ltyrian_websocket_WebSocket.prototype.subscribe__F1__Ltyrian_Sub = (function(f) {
  return ($m_Ltyrian_websocket_WebSocketReadyState$().fromInt__I__Ltyrian_websocket_WebSocketReadyState($uI(this.Ltyrian_websocket_WebSocket__f_liveSocket.Ltyrian_websocket_LiveSocket__f_socket.readyState)).isOpen__Z() ? this.Ltyrian_websocket_WebSocket__f_liveSocket.Ltyrian_websocket_LiveSocket__f_subs.map__F1__Ltyrian_Sub(f) : $m_Ltyrian_Sub$().emit__O__Ltyrian_Sub(f.apply__O__O(new $c_Ltyrian_websocket_WebSocketEvent$Error("Connection not ready"))))
});
function $as_Ltyrian_websocket_WebSocket(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocket) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocket"))
}
function $isArrayOf_Ltyrian_websocket_WebSocket(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocket)))
}
function $asArrayOf_Ltyrian_websocket_WebSocket(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocket(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocket;", depth))
}
var $d_Ltyrian_websocket_WebSocket = new $TypeData().initClass({
  Ltyrian_websocket_WebSocket: 0
}, false, "tyrian.websocket.WebSocket", {
  Ltyrian_websocket_WebSocket: 1,
  O: 1
});
$c_Ltyrian_websocket_WebSocket.prototype.$classData = $d_Ltyrian_websocket_WebSocket;
function $p_Ltyrian_websocket_WebSocket$__connectTask__T__T__Ltyrian_websocket_KeepAliveSettings__Ltyrian_Task($thiz, address, onOpenMessage, keepAliveSettings) {
  var this$3 = $p_Ltyrian_websocket_WebSocket$__newConnection__T__s_Option__Ltyrian_websocket_KeepAliveSettings__Ltyrian_Task($thiz, address, new $c_s_Some(onOpenMessage), keepAliveSettings);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((_$4) => {
    var _$4$1 = $as_Ltyrian_websocket_LiveSocket(_$4);
    return new $c_Ltyrian_websocket_WebSocket(_$4$1)
  }))($thiz));
  return new $c_Ltyrian_Task$Mapped(this$3, f)
}
function $p_Ltyrian_websocket_WebSocket$__newConnection__T__s_Option__Ltyrian_websocket_KeepAliveSettings__Ltyrian_Task($thiz, address, onOpenSendMessage, settings) {
  var thunk = new $c_sjsr_AnonFunction0(((this$1, address$2, onOpenSendMessage$2, settings$2) => (() => {
    var socket = new WebSocket(address$2);
    var keepAlive = new $c_Ltyrian_websocket_WebSocket$KeepAlive(socket, settings$2);
    var subs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([$m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Ltyrian_Sub("message", socket, new $c_sjsr_AnonFunction1(((this$2) => ((e) => {
      var message = $dp_toString__T(e.data);
      var value = new $c_Ltyrian_websocket_WebSocketEvent$Receive(message);
      return new $c_s_Some(value)
    }))(this$1))), $m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Ltyrian_Sub("error", socket, new $c_sjsr_AnonFunction1(((this$2$1) => ((e$2) => {
      var msg = $p_Ltyrian_websocket_WebSocket$__liftedTree1$1__O__T(this$2$1, e$2);
      var value$1 = new $c_Ltyrian_websocket_WebSocketEvent$Error(msg);
      return new $c_s_Some(value$1)
    }))(this$1))), $m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Ltyrian_Sub("close", socket, new $c_sjsr_AnonFunction1(((this$3$1) => ((e$3) => {
      var code = $uI(e$3.code);
      var reason = $as_T(e$3.reason);
      var value$2 = new $c_Ltyrian_websocket_WebSocketEvent$Close(code, reason);
      return new $c_s_Some(value$2)
    }))(this$1))), $m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Ltyrian_Sub("open", socket, new $c_sjsr_AnonFunction1(((this$4$1, onOpenSendMessage$1$2, socket$2) => ((_$5) => {
      if ((!onOpenSendMessage$1$2.isEmpty__Z())) {
        var arg1 = onOpenSendMessage$1$2.get__O();
        var msg$1 = $as_T(arg1);
        socket$2.send(msg$1)
      };
      var value$3 = $s_Ltyrian_websocket_WebSocketEvent$__Open__Ltyrian_websocket_WebSocketEvent();
      return new $c_s_Some(value$3)
    }))(this$1, onOpenSendMessage$2, socket))), keepAlive.run__Ltyrian_Sub()]));
    $m_sci_List$();
    var subs$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(subs);
    var subs$2 = new $c_Ltyrian_Sub$Batch(subs$1);
    return new $c_Ltyrian_websocket_LiveSocket(socket, subs$2)
  }))($thiz, address, onOpenSendMessage, settings));
  return new $c_Ltyrian_Task$Delay(thunk)
}
function $p_Ltyrian_websocket_WebSocket$__liftedTree1$1__O__T($thiz, e$1) {
  try {
    return $as_T(e$1.message)
  } catch (e) {
    $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    return "Unknown"
  }
}
/** @constructor */
function $c_Ltyrian_websocket_WebSocket$() {
  /*<skip>*/
}
$c_Ltyrian_websocket_WebSocket$.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocket$.prototype.constructor = $c_Ltyrian_websocket_WebSocket$;
/** @constructor */
function $h_Ltyrian_websocket_WebSocket$() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocket$.prototype = $c_Ltyrian_websocket_WebSocket$.prototype;
$c_Ltyrian_websocket_WebSocket$.prototype.connect__T__T__Ltyrian_websocket_KeepAliveSettings__F1__Ltyrian_Cmd = (function(address, onOpenMessage, keepAliveSettings, resultToMessage) {
  var task = $p_Ltyrian_websocket_WebSocket$__connectTask__T__T__Ltyrian_websocket_KeepAliveSettings__Ltyrian_Task(this, address, onOpenMessage, keepAliveSettings);
  return new $c_Ltyrian_Cmd$RunTask(task, resultToMessage)
});
var $d_Ltyrian_websocket_WebSocket$ = new $TypeData().initClass({
  Ltyrian_websocket_WebSocket$: 0
}, false, "tyrian.websocket.WebSocket$", {
  Ltyrian_websocket_WebSocket$: 1,
  O: 1
});
$c_Ltyrian_websocket_WebSocket$.prototype.$classData = $d_Ltyrian_websocket_WebSocket$;
var $n_Ltyrian_websocket_WebSocket$;
function $m_Ltyrian_websocket_WebSocket$() {
  if ((!$n_Ltyrian_websocket_WebSocket$)) {
    $n_Ltyrian_websocket_WebSocket$ = new $c_Ltyrian_websocket_WebSocket$()
  };
  return $n_Ltyrian_websocket_WebSocket$
}
/** @constructor */
function $c_Ltyrian_websocket_WebSocket$KeepAlive(socket, settings) {
  this.Ltyrian_websocket_WebSocket$KeepAlive__f_socket = null;
  this.Ltyrian_websocket_WebSocket$KeepAlive__f_settings = null;
  this.Ltyrian_websocket_WebSocket$KeepAlive__f_socket = socket;
  this.Ltyrian_websocket_WebSocket$KeepAlive__f_settings = settings
}
$c_Ltyrian_websocket_WebSocket$KeepAlive.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocket$KeepAlive.prototype.constructor = $c_Ltyrian_websocket_WebSocket$KeepAlive;
/** @constructor */
function $h_Ltyrian_websocket_WebSocket$KeepAlive() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocket$KeepAlive.prototype = $c_Ltyrian_websocket_WebSocket$KeepAlive.prototype;
$c_Ltyrian_websocket_WebSocket$KeepAlive.prototype.run__Ltyrian_Sub = (function() {
  return (((this.Ltyrian_websocket_WebSocket$KeepAlive__f_socket !== null) && $m_Ltyrian_websocket_WebSocketReadyState$().fromInt__I__Ltyrian_websocket_WebSocketReadyState($uI(this.Ltyrian_websocket_WebSocket$KeepAlive__f_socket.readyState)).isOpen__Z()) ? $m_Ltyrian_Sub$().every__s_concurrent_duration_FiniteDuration__T__Ltyrian_Sub(this.Ltyrian_websocket_WebSocket$KeepAlive__f_settings.Ltyrian_websocket_KeepAliveSettings__f_timeout, "ws-heartbeat").map__F1__Ltyrian_Sub(new $c_sjsr_AnonFunction1(((this$1) => ((_$6) => $s_Ltyrian_websocket_WebSocketEvent$__Heartbeat__Ltyrian_websocket_WebSocketEvent()))(this))) : $m_Ltyrian_Sub$Empty$())
});
var $d_Ltyrian_websocket_WebSocket$KeepAlive = new $TypeData().initClass({
  Ltyrian_websocket_WebSocket$KeepAlive: 0
}, false, "tyrian.websocket.WebSocket$KeepAlive", {
  Ltyrian_websocket_WebSocket$KeepAlive: 1,
  O: 1
});
$c_Ltyrian_websocket_WebSocket$KeepAlive.prototype.$classData = $d_Ltyrian_websocket_WebSocket$KeepAlive;
/** @constructor */
function $c_Lzonedb_java_tzdb$() {
  this.Lzonedb_java_tzdb$__f_version$lzy1 = null;
  this.Lzonedb_java_tzdb$__f_versionbitmap$1 = false;
  this.Lzonedb_java_tzdb$__f_fixedZones$lzy1 = null;
  this.Lzonedb_java_tzdb$__f_fixedZonesbitmap$1 = false;
  this.Lzonedb_java_tzdb$__f_stdZones$lzy1 = null;
  this.Lzonedb_java_tzdb$__f_stdZonesbitmap$1 = false;
  this.Lzonedb_java_tzdb$__f_zoneLinks$lzy1 = null;
  this.Lzonedb_java_tzdb$__f_zoneLinksbitmap$1 = false
}
$c_Lzonedb_java_tzdb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$.prototype.constructor = $c_Lzonedb_java_tzdb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$.prototype = $c_Lzonedb_java_tzdb$.prototype;
$c_Lzonedb_java_tzdb$.prototype.fixedZones__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$__f_fixedZonesbitmap$1)) {
    var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), "Etc/GMT-8", 28800), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+2", (-7200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+12", (-43200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+5", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+1", (-3600)), $ct_T2__O__O__(new $c_T2(), "HST", (-36000)), $ct_T2__O__O__(new $c_T2(), "WET", 0), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-11", 39600), $ct_T2__O__O__(new $c_T2(), "EST", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-12", 43200), $ct_T2__O__O__(new $c_T2(), "Etc/UTC", 0), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+11", (-39600)), $ct_T2__O__O__(new $c_T2(), "PST8PDT", (-28800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-2", 7200), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+7", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-13", 46800), $ct_T2__O__O__(new $c_T2(), "Etc/GMT", 0), $ct_T2__O__O__(new $c_T2(), "CET", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+10", (-36000)), $ct_T2__O__O__(new $c_T2(), "CST6CDT", (-21600)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-1", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-4", 14400), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-10", 36000), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+4", (-14400)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+6", (-21600)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-5", 18000), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+8", (-28800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-14", 50400), $ct_T2__O__O__(new $c_T2(), "MST", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-7", 25200), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-6", 21600), $ct_T2__O__O__(new $c_T2(), "MST7MDT", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+3", (-10800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-3", 10800), $ct_T2__O__O__(new $c_T2(), "MET", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+9", (-32400)), $ct_T2__O__O__(new $c_T2(), "EET", 7200), $ct_T2__O__O__(new $c_T2(), "EST5EDT", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-9", 32400)]));
    this.Lzonedb_java_tzdb$__f_fixedZones$lzy1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    this.Lzonedb_java_tzdb$__f_fixedZonesbitmap$1 = true
  };
  return this.Lzonedb_java_tzdb$__f_fixedZones$lzy1
});
$c_Lzonedb_java_tzdb$.prototype.stdZones__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$__f_stdZonesbitmap$1)) {
    var $$x348 = $m_sr_ScalaRunTime$();
    var _2 = $m_Lzonedb_java_tzdb$eurns$().Lzonedb_java_tzdb$eurns$__f_Europe_Minsk;
    var $$x347 = $ct_T2__O__O__(new $c_T2(), "Europe/Minsk", _2);
    var _2$1 = $m_Lzonedb_java_tzdb$asiin$().Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh;
    var $$x346 = $ct_T2__O__O__(new $c_T2(), "Asia/Ho_Chi_Minh", _2$1);
    var _2$2 = $m_Lzonedb_java_tzdb$anter$().Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera;
    var $$x345 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Rothera", _2$2);
    var _2$3 = $m_Lzonedb_java_tzdb$amefa$().Lzonedb_java_tzdb$amefa$__f_America_Halifax;
    var $$x344 = $ct_T2__O__O__(new $c_T2(), "America/Halifax", _2$3);
    var _2$4 = $m_Lzonedb_java_tzdb$ameei$().Lzonedb_java_tzdb$ameei$__f_America_Maceio;
    var $$x343 = $ct_T2__O__O__(new $c_T2(), "America/Maceio", _2$4);
    var _2$5 = $m_Lzonedb_java_tzdb$ameto$().Lzonedb_java_tzdb$ameto$__f_America_Creston;
    var $$x342 = $ct_T2__O__O__(new $c_T2(), "America/Creston", _2$5);
    var _2$6 = $m_Lzonedb_java_tzdb$asina$().Lzonedb_java_tzdb$asina$__f_Asia_Qostanay;
    var $$x341 = $ct_T2__O__O__(new $c_T2(), "Asia/Qostanay", _2$6);
    var _2$7 = $m_Lzonedb_java_tzdb$antol$().Lzonedb_java_tzdb$antol$__f_Antarctica_Troll;
    var $$x340 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Troll", _2$7);
    var _2$8 = $m_Lzonedb_java_tzdb$amele$().Lzonedb_java_tzdb$amele$__f_America_Belem;
    var $$x339 = $ct_T2__O__O__(new $c_T2(), "America/Belem", _2$8);
    var _2$9 = $m_Lzonedb_java_tzdb$asiad$().Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh;
    var $$x338 = $ct_T2__O__O__(new $c_T2(), "Asia/Riyadh", _2$9);
    var _2$10 = $m_Lzonedb_java_tzdb$ameni$().Lzonedb_java_tzdb$ameni$__f_America_Phoenix;
    var $$x337 = $ct_T2__O__O__(new $c_T2(), "America/Phoenix", _2$10);
    var _2$11 = $m_Lzonedb_java_tzdb$afrur$().Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg;
    var $$x336 = $ct_T2__O__O__(new $c_T2(), "Africa/Johannesburg", _2$11);
    var _2$12 = $m_Lzonedb_java_tzdb$indco$().Lzonedb_java_tzdb$indco$__f_Indian_Cocos;
    var $$x335 = $ct_T2__O__O__(new $c_T2(), "Indian/Cocos", _2$12);
    var _2$13 = $m_Lzonedb_java_tzdb$asipu$().Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur;
    var $$x334 = $ct_T2__O__O__(new $c_T2(), "Asia/Kuala_Lumpur", _2$13);
    var _2$14 = $m_Lzonedb_java_tzdb$ameto$().Lzonedb_java_tzdb$ameto$__f_America_Edmonton;
    var $$x333 = $ct_T2__O__O__(new $c_T2(), "America/Edmonton", _2$14);
    var _2$15 = $m_Lzonedb_java_tzdb$asien$().Lzonedb_java_tzdb$asien$__f_Asia_Tashkent;
    var $$x332 = $ct_T2__O__O__(new $c_T2(), "Asia/Tashkent", _2$15);
    var _2$16 = $m_Lzonedb_java_tzdb$amequ$().Lzonedb_java_tzdb$amequ$__f_America_Martinique;
    var $$x331 = $ct_T2__O__O__(new $c_T2(), "America/Martinique", _2$16);
    var _2$17 = $m_Lzonedb_java_tzdb$ameim$().Lzonedb_java_tzdb$ameim$__f_America_Lima;
    var $$x330 = $ct_T2__O__O__(new $c_T2(), "America/Lima", _2$17);
    var _2$18 = $m_Lzonedb_java_tzdb$afrou$().Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum;
    var $$x329 = $ct_T2__O__O__(new $c_T2(), "Africa/Khartoum", _2$18);
    var _2$19 = $m_Lzonedb_java_tzdb$pacof$().Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo;
    var $$x328 = $ct_T2__O__O__(new $c_T2(), "Pacific/Fakaofo", _2$19);
    var _2$20 = $m_Lzonedb_java_tzdb$antll$().Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville;
    var $$x327 = $ct_T2__O__O__(new $c_T2(), "Antarctica/DumontDUrville", _2$20);
    var _2$21 = $m_Lzonedb_java_tzdb$auscl$().Lzonedb_java_tzdb$auscl$__f_Australia_Eucla;
    var $$x326 = $ct_T2__O__O__(new $c_T2(), "Australia/Eucla", _2$21);
    var _2$22 = $m_Lzonedb_java_tzdb$ameng$().Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo;
    var $$x325 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Marengo", _2$22);
    var _2$23 = $m_Lzonedb_java_tzdb$eurol$().Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm;
    var $$x324 = $ct_T2__O__O__(new $c_T2(), "Europe/Stockholm", _2$23);
    var _2$24 = $m_Lzonedb_java_tzdb$ameua$().Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan;
    var $$x323 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/San_Juan", _2$24);
    var _2$25 = $m_Lzonedb_java_tzdb$amera$().Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas;
    var $$x322 = $ct_T2__O__O__(new $c_T2(), "America/Bahia_Banderas", _2$25);
    var _2$26 = $m_Lzonedb_java_tzdb$amell$().Lzonedb_java_tzdb$amell$__f_America_Hermosillo;
    var $$x321 = $ct_T2__O__O__(new $c_T2(), "America/Hermosillo", _2$26);
    var _2$27 = $m_Lzonedb_java_tzdb$ausrn$().Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne;
    var $$x320 = $ct_T2__O__O__(new $c_T2(), "Australia/Melbourne", _2$27);
    var _2$28 = $m_Lzonedb_java_tzdb$amere$().Lzonedb_java_tzdb$amere$__f_America_Santarem;
    var $$x319 = $ct_T2__O__O__(new $c_T2(), "America/Santarem", _2$28);
    var _2$29 = $m_Lzonedb_java_tzdb$indiu$().Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius;
    var $$x318 = $ct_T2__O__O__(new $c_T2(), "Indian/Mauritius", _2$29);
    var _2$30 = $m_Lzonedb_java_tzdb$asigo$().Lzonedb_java_tzdb$asigo$__f_Asia_Yangon;
    var $$x317 = $ct_T2__O__O__(new $c_T2(), "Asia/Yangon", _2$30);
    var _2$31 = $m_Lzonedb_java_tzdb$asirs$().Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk;
    var $$x316 = $ct_T2__O__O__(new $c_T2(), "Asia/Novosibirsk", _2$31);
    var _2$32 = $m_Lzonedb_java_tzdb$asiob$().Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe;
    var $$x315 = $ct_T2__O__O__(new $c_T2(), "Asia/Aqtobe", _2$32);
    var _2$33 = $m_Lzonedb_java_tzdb$eurnn$().Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna;
    var $$x314 = $ct_T2__O__O__(new $c_T2(), "Europe/Vienna", _2$33);
    var _2$34 = $m_Lzonedb_java_tzdb$ameag$().Lzonedb_java_tzdb$ameag$__f_America_Santiago;
    var $$x313 = $ct_T2__O__O__(new $c_T2(), "America/Santiago", _2$34);
    var _2$35 = $m_Lzonedb_java_tzdb$pacna$().Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal;
    var $$x312 = $ct_T2__O__O__(new $c_T2(), "Pacific/Guadalcanal", _2$35);
    var _2$36 = $m_Lzonedb_java_tzdb$asims$().Lzonedb_java_tzdb$asims$__f_Asia_Tomsk;
    var $$x311 = $ct_T2__O__O__(new $c_T2(), "Asia/Tomsk", _2$36);
    var _2$37 = $m_Lzonedb_java_tzdb$asine$().Lzonedb_java_tzdb$asine$__f_Asia_Brunei;
    var $$x310 = $ct_T2__O__O__(new $c_T2(), "Asia/Brunei", _2$37);
    var _2$38 = $m_Lzonedb_java_tzdb$pacme$().Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea;
    var $$x309 = $ct_T2__O__O__(new $c_T2(), "Pacific/Noumea", _2$38);
    var _2$39 = $m_Lzonedb_java_tzdb$asiil$().Lzonedb_java_tzdb$asiil$__f_Asia_Manila;
    var $$x308 = $ct_T2__O__O__(new $c_T2(), "Asia/Manila", _2$39);
    var _2$40 = $m_Lzonedb_java_tzdb$pacag$().Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago;
    var $$x307 = $ct_T2__O__O__(new $c_T2(), "Pacific/Pago_Pago", _2$40);
    var _2$41 = $m_Lzonedb_java_tzdb$asiat$().Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata;
    var $$x306 = $ct_T2__O__O__(new $c_T2(), "Asia/Kolkata", _2$41);
    var _2$42 = $m_Lzonedb_java_tzdb$eurgu$().Lzonedb_java_tzdb$eurgu$__f_Europe_Prague;
    var $$x305 = $ct_T2__O__O__(new $c_T2(), "Europe/Prague", _2$42);
    var _2$43 = $m_Lzonedb_java_tzdb$afrja$().Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan;
    var $$x304 = $ct_T2__O__O__(new $c_T2(), "Africa/Abidjan", _2$43);
    var _2$44 = $m_Lzonedb_java_tzdb$eurad$().Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade;
    var $$x303 = $ct_T2__O__O__(new $c_T2(), "Europe/Belgrade", _2$44);
    var _2$45 = $m_Lzonedb_java_tzdb$amego$().Lzonedb_java_tzdb$amego$__f_America_Nipigon;
    var $$x302 = $ct_T2__O__O__(new $c_T2(), "America/Nipigon", _2$45);
    var _2$46 = $m_Lzonedb_java_tzdb$euran$().Lzonedb_java_tzdb$euran$__f_Europe_Tirane;
    var $$x301 = $ct_T2__O__O__(new $c_T2(), "Europe/Tirane", _2$46);
    var _2$47 = $m_Lzonedb_java_tzdb$eurie$().Lzonedb_java_tzdb$eurie$__f_Europe_Kiev;
    var $$x300 = $ct_T2__O__O__(new $c_T2(), "Europe/Kiev", _2$47);
    var _2$48 = $m_Lzonedb_java_tzdb$eurac$().Lzonedb_java_tzdb$eurac$__f_Europe_Monaco;
    var $$x299 = $ct_T2__O__O__(new $c_T2(), "Europe/Monaco", _2$48);
    var _2$49 = $m_Lzonedb_java_tzdb$asiau$().Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul;
    var $$x298 = $ct_T2__O__O__(new $c_T2(), "Asia/Barnaul", _2$49);
    var _2$50 = $m_Lzonedb_java_tzdb$asipe$().Lzonedb_java_tzdb$asipe$__f_Asia_Taipei;
    var $$x297 = $ct_T2__O__O__(new $c_T2(), "Asia/Taipei", _2$50);
    var _2$51 = $m_Lzonedb_java_tzdb$asich$().Lzonedb_java_tzdb$asich$__f_Asia_Karachi;
    var $$x296 = $ct_T2__O__O__(new $c_T2(), "Asia/Karachi", _2$51);
    var _2$52 = $m_Lzonedb_java_tzdb$eurge$().Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen;
    var $$x295 = $ct_T2__O__O__(new $c_T2(), "Europe/Copenhagen", _2$52);
    var _2$53 = $m_Lzonedb_java_tzdb$asiil$().Lzonedb_java_tzdb$asiil$__f_Asia_Dili;
    var $$x294 = $ct_T2__O__O__(new $c_T2(), "Asia/Dili", _2$53);
    var _2$54 = $m_Lzonedb_java_tzdb$ameai$().Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia;
    var $$x293 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Ushuaia", _2$54);
    var _2$55 = $m_Lzonedb_java_tzdb$ameli$().Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis;
    var $$x292 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Indianapolis", _2$55);
    var _2$56 = $m_Lzonedb_java_tzdb$ameea$().Lzonedb_java_tzdb$ameea$__f_America_Juneau;
    var $$x291 = $ct_T2__O__O__(new $c_T2(), "America/Juneau", _2$56);
    var _2$57 = $m_Lzonedb_java_tzdb$afroe$().Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek;
    var $$x290 = $ct_T2__O__O__(new $c_T2(), "Africa/Windhoek", _2$57);
    var _2$58 = $m_Lzonedb_java_tzdb$eurta$().Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar;
    var $$x289 = $ct_T2__O__O__(new $c_T2(), "Europe/Gibraltar", _2$58);
    var _2$59 = $m_Lzonedb_java_tzdb$amehn$().Lzonedb_java_tzdb$amehn$__f_America_St_Johns;
    var $$x288 = $ct_T2__O__O__(new $c_T2(), "America/St_Johns", _2$59);
    var _2$60 = $m_Lzonedb_java_tzdb$asina$().Lzonedb_java_tzdb$asina$__f_Asia_Pontianak;
    var $$x287 = $ct_T2__O__O__(new $c_T2(), "Asia/Pontianak", _2$60);
    var _2$61 = $m_Lzonedb_java_tzdb$amell$().Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello;
    var $$x286 = $ct_T2__O__O__(new $c_T2(), "America/Kentucky/Monticello", _2$61);
    var _2$62 = $m_Lzonedb_java_tzdb$ameau$().Lzonedb_java_tzdb$ameau$__f_America_Manaus;
    var $$x285 = $ct_T2__O__O__(new $c_T2(), "America/Manaus", _2$62);
    var _2$63 = $m_Lzonedb_java_tzdb$eurro$().Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod;
    var $$x284 = $ct_T2__O__O__(new $c_T2(), "Europe/Uzhgorod", _2$63);
    var _2$64 = $m_Lzonedb_java_tzdb$amego$().Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos;
    var $$x283 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Rio_Gallegos", _2$64);
    var _2$65 = $m_Lzonedb_java_tzdb$ausar$().Lzonedb_java_tzdb$ausar$__f_Australia_Hobart;
    var $$x282 = $ct_T2__O__O__(new $c_T2(), "Australia/Hobart", _2$65);
    var _2$66 = $m_Lzonedb_java_tzdb$asisa$().Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan;
    var $$x281 = $ct_T2__O__O__(new $c_T2(), "Asia/Choibalsan", _2$66);
    var _2$67 = $m_Lzonedb_java_tzdb$antow$().Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa;
    var $$x280 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Syowa", _2$67);
    var _2$68 = $m_Lzonedb_java_tzdb$asida$().Lzonedb_java_tzdb$asida$__f_Asia_Magadan;
    var $$x279 = $ct_T2__O__O__(new $c_T2(), "Asia/Magadan", _2$68);
    var _2$69 = $m_Lzonedb_java_tzdb$amend$().Lzonedb_java_tzdb$amend$__f_America_Campo_Grande;
    var $$x278 = $ct_T2__O__O__(new $c_T2(), "America/Campo_Grande", _2$69);
    var _2$70 = $m_Lzonedb_java_tzdb$amene$().Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes;
    var $$x277 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Vincennes", _2$70);
    var _2$71 = $m_Lzonedb_java_tzdb$atlir$().Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira;
    var $$x276 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Madeira", _2$71);
    var _2$72 = $m_Lzonedb_java_tzdb$asits$().Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk;
    var $$x275 = $ct_T2__O__O__(new $c_T2(), "Asia/Irkutsk", _2$72);
    var _2$73 = $m_Lzonedb_java_tzdb$asiba$().Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat;
    var $$x274 = $ct_T2__O__O__(new $c_T2(), "Asia/Ashgabat", _2$73);
    var _2$74 = $m_Lzonedb_java_tzdb$ausma$().Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman;
    var $$x273 = $ct_T2__O__O__(new $c_T2(), "Australia/Lindeman", _2$74);
    var _2$75 = $m_Lzonedb_java_tzdb$asirs$().Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk;
    var $$x272 = $ct_T2__O__O__(new $c_T2(), "Asia/Krasnoyarsk", _2$75);
    var _2$76 = $m_Lzonedb_java_tzdb$asirt$().Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta;
    var $$x271 = $ct_T2__O__O__(new $c_T2(), "Asia/Jakarta", _2$76);
    var _2$77 = $m_Lzonedb_java_tzdb$amein$().Lzonedb_java_tzdb$amein$__f_America_Regina;
    var $$x270 = $ct_T2__O__O__(new $c_T2(), "America/Regina", _2$77);
    var _2$78 = $m_Lzonedb_java_tzdb$afrut$().Lzonedb_java_tzdb$afrut$__f_Africa_Maputo;
    var $$x269 = $ct_T2__O__O__(new $c_T2(), "Africa/Maputo", _2$78);
    var _2$79 = $m_Lzonedb_java_tzdb$asiaz$().Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza;
    var $$x268 = $ct_T2__O__O__(new $c_T2(), "Asia/Gaza", _2$79);
    var _2$80 = $m_Lzonedb_java_tzdb$indma$().Lzonedb_java_tzdb$indma$__f_Indian_Christmas;
    var $$x267 = $ct_T2__O__O__(new $c_T2(), "Indian/Christmas", _2$80);
    var _2$81 = $m_Lzonedb_java_tzdb$asiha$().Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai;
    var $$x266 = $ct_T2__O__O__(new $c_T2(), "Asia/Shanghai", _2$81);
    var _2$82 = $m_Lzonedb_java_tzdb$amene$().Lzonedb_java_tzdb$amene$__f_America_Menominee;
    var $$x265 = $ct_T2__O__O__(new $c_T2(), "America/Menominee", _2$82);
    var _2$83 = $m_Lzonedb_java_tzdb$eurri$().Lzonedb_java_tzdb$eurri$__f_Europe_Madrid;
    var $$x264 = $ct_T2__O__O__(new $c_T2(), "Europe/Madrid", _2$83);
    var _2$84 = $m_Lzonedb_java_tzdb$afrvi$().Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia;
    var $$x263 = $ct_T2__O__O__(new $c_T2(), "Africa/Monrovia", _2$84);
    var _2$85 = $m_Lzonedb_java_tzdb$ameun$().Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund;
    var $$x262 = $ct_T2__O__O__(new $c_T2(), "America/Scoresbysund", _2$85);
    var _2$86 = $m_Lzonedb_java_tzdb$amelp$().Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa;
    var $$x261 = $ct_T2__O__O__(new $c_T2(), "America/Tegucigalpa", _2$86);
    var _2$87 = $m_Lzonedb_java_tzdb$antri$().Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie;
    var $$x260 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Macquarie", _2$87);
    var _2$88 = $m_Lzonedb_java_tzdb$ameif$().Lzonedb_java_tzdb$ameif$__f_America_Recife;
    var $$x259 = $ct_T2__O__O__(new $c_T2(), "America/Recife", _2$88);
    var _2$89 = $m_Lzonedb_java_tzdb$ameba$().Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay;
    var $$x258 = $ct_T2__O__O__(new $c_T2(), "America/Goose_Bay", _2$89);
    var _2$90 = $m_Lzonedb_java_tzdb$asits$().Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk;
    var $$x257 = $ct_T2__O__O__(new $c_T2(), "Asia/Novokuznetsk", _2$90);
    var _2$91 = $m_Lzonedb_java_tzdb$amell$().Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville;
    var $$x256 = $ct_T2__O__O__(new $c_T2(), "America/Kentucky/Louisville", _2$91);
    var _2$92 = $m_Lzonedb_java_tzdb$asibu$().Lzonedb_java_tzdb$asibu$__f_Asia_Kabul;
    var $$x255 = $ct_T2__O__O__(new $c_T2(), "Asia/Kabul", _2$92);
    var _2$93 = $m_Lzonedb_java_tzdb$afrol$().Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli;
    var $$x254 = $ct_T2__O__O__(new $c_T2(), "Africa/Tripoli", _2$93);
    var _2$94 = $m_Lzonedb_java_tzdb$ameab$().Lzonedb_java_tzdb$ameab$__f_America_Cuiaba;
    var $$x253 = $ct_T2__O__O__(new $c_T2(), "America/Cuiaba", _2$94);
    var _2$95 = $m_Lzonedb_java_tzdb$asira$().Lzonedb_java_tzdb$asira$__f_Asia_Atyrau;
    var $$x252 = $ct_T2__O__O__(new $c_T2(), "Asia/Atyrau", _2$95);
    var _2$96 = $m_Lzonedb_java_tzdb$ameva$().Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay;
    var $$x251 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Vevay", _2$96);
    var _2$97 = $m_Lzonedb_java_tzdb$amean$().Lzonedb_java_tzdb$amean$__f_America_Tijuana;
    var $$x250 = $ct_T2__O__O__(new $c_T2(), "America/Tijuana", _2$97);
    var _2$98 = $m_Lzonedb_java_tzdb$eurvs$().Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk;
    var $$x249 = $ct_T2__O__O__(new $c_T2(), "Europe/Ulyanovsk", _2$98);
    var _2$99 = $m_Lzonedb_java_tzdb$pacul$().Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu;
    var $$x248 = $ct_T2__O__O__(new $c_T2(), "Pacific/Honolulu", _2$99);
    var _2$100 = $m_Lzonedb_java_tzdb$ameba$().Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay;
    var $$x247 = $ct_T2__O__O__(new $c_T2(), "America/Thunder_Bay", _2$100);
    var _2$101 = $m_Lzonedb_java_tzdb$ameis$().Lzonedb_java_tzdb$ameis$__f_America_Boise;
    var $$x246 = $ct_T2__O__O__(new $c_T2(), "America/Boise", _2$101);
    var _2$102 = $m_Lzonedb_java_tzdb$ameio$().Lzonedb_java_tzdb$ameio$__f_America_Asuncion;
    var $$x245 = $ct_T2__O__O__(new $c_T2(), "America/Asuncion", _2$102);
    var _2$103 = $m_Lzonedb_java_tzdb$antto$().Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok;
    var $$x244 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Vostok", _2$103);
    var _2$104 = $m_Lzonedb_java_tzdb$eurur$().Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg;
    var $$x243 = $ct_T2__O__O__(new $c_T2(), "Europe/Luxembourg", _2$104);
    var _2$105 = $m_Lzonedb_java_tzdb$pacij$().Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji;
    var $$x242 = $ct_T2__O__O__(new $c_T2(), "Pacific/Fiji", _2$105);
    var _2$106 = $m_Lzonedb_java_tzdb$ameam$().Lzonedb_java_tzdb$ameam$__f_America_Panama;
    var $$x241 = $ct_T2__O__O__(new $c_T2(), "America/Panama", _2$106);
    var _2$107 = $m_Lzonedb_java_tzdb$amela$().Lzonedb_java_tzdb$amela$__f_America_Mazatlan;
    var $$x240 = $ct_T2__O__O__(new $c_T2(), "America/Mazatlan", _2$107);
    var _2$108 = $m_Lzonedb_java_tzdb$afrsa$().Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau;
    var $$x239 = $ct_T2__O__O__(new $c_T2(), "Africa/Bissau", _2$108);
    var _2$109 = $m_Lzonedb_java_tzdb$asian$().Lzonedb_java_tzdb$asian$__f_Asia_Samarkand;
    var $$x238 = $ct_T2__O__O__(new $c_T2(), "Asia/Samarkand", _2$109);
    var _2$110 = $m_Lzonedb_java_tzdb$asiba$().Lzonedb_java_tzdb$asiba$__f_Asia_Dubai;
    var $$x237 = $ct_T2__O__O__(new $c_T2(), "Asia/Dubai", _2$110);
    var _2$111 = $m_Lzonedb_java_tzdb$pacpe$().Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei;
    var $$x236 = $ct_T2__O__O__(new $c_T2(), "Pacific/Pohnpei", _2$111);
    var _2$112 = $m_Lzonedb_java_tzdb$ausne$().Lzonedb_java_tzdb$ausne$__f_Australia_Sydney;
    var $$x235 = $ct_T2__O__O__(new $c_T2(), "Australia/Sydney", _2$112);
    var _2$113 = $m_Lzonedb_java_tzdb$ausid$().Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide;
    var $$x234 = $ct_T2__O__O__(new $c_T2(), "Australia/Adelaide", _2$113);
    var _2$114 = $m_Lzonedb_java_tzdb$ameoz$().Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza;
    var $$x233 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Mendoza", _2$114);
    var _2$115 = $m_Lzonedb_java_tzdb$asiph$().Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu;
    var $$x232 = $ct_T2__O__O__(new $c_T2(), "Asia/Thimphu", _2$115);
    var _2$116 = $m_Lzonedb_java_tzdb$pacte$().Lzonedb_java_tzdb$pacte$__f_Pacific_Easter;
    var $$x231 = $ct_T2__O__O__(new $c_T2(), "Pacific/Easter", _2$116);
    var _2$117 = $m_Lzonedb_java_tzdb$asita$().Lzonedb_java_tzdb$asita$__f_Asia_Qatar;
    var $$x230 = $ct_T2__O__O__(new $c_T2(), "Asia/Qatar", _2$117);
    var _2$118 = $m_Lzonedb_java_tzdb$ameno$().Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox;
    var $$x229 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Knox", _2$118);
    var _2$119 = $m_Lzonedb_java_tzdb$atlvi$().Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik;
    var $$x228 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Reykjavik", _2$119);
    var _2$120 = $m_Lzonedb_java_tzdb$ameit$().Lzonedb_java_tzdb$ameit$__f_America_Mexico_City;
    var $$x227 = $ct_T2__O__O__(new $c_T2(), "America/Mexico_City", _2$120);
    var _2$121 = $m_Lzonedb_java_tzdb$asira$().Lzonedb_java_tzdb$asira$__f_Asia_Tehran;
    var $$x226 = $ct_T2__O__O__(new $c_T2(), "Asia/Tehran", _2$121);
    var _2$122 = $m_Lzonedb_java_tzdb$indah$().Lzonedb_java_tzdb$indah$__f_Indian_Mahe;
    var $$x225 = $ct_T2__O__O__(new $c_T2(), "Indian/Mahe", _2$122);
    var _2$123 = $m_Lzonedb_java_tzdb$eurpo$().Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol;
    var $$x224 = $ct_T2__O__O__(new $c_T2(), "Europe/Simferopol", _2$123);
    var _2$124 = $m_Lzonedb_java_tzdb$eurri$().Lzonedb_java_tzdb$eurri$__f_Europe_Paris;
    var $$x223 = $ct_T2__O__O__(new $c_T2(), "Europe/Paris", _2$124);
    var _2$125 = $m_Lzonedb_java_tzdb$ameif$().Lzonedb_java_tzdb$ameif$__f_America_Yellowknife;
    var $$x222 = $ct_T2__O__O__(new $c_T2(), "America/Yellowknife", _2$125);
    var _2$126 = $m_Lzonedb_java_tzdb$asiou$().Lzonedb_java_tzdb$asiou$__f_Asia_Seoul;
    var $$x221 = $ct_T2__O__O__(new $c_T2(), "Asia/Seoul", _2$126);
    var _2$127 = $m_Lzonedb_java_tzdb$asile$().Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem;
    var $$x220 = $ct_T2__O__O__(new $c_T2(), "Asia/Jerusalem", _2$127);
    var _2$128 = $m_Lzonedb_java_tzdb$eurto$().Lzonedb_java_tzdb$eurto$__f_Europe_Saratov;
    var $$x219 = $ct_T2__O__O__(new $c_T2(), "Europe/Saratov", _2$128);
    var _2$129 = $m_Lzonedb_java_tzdb$ameav$().Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn;
    var $$x218 = $ct_T2__O__O__(new $c_T2(), "America/Danmarkshavn", _2$129);
    var _2$130 = $m_Lzonedb_java_tzdb$asiro$().Lzonedb_java_tzdb$asiro$__f_Asia_Hebron;
    var $$x217 = $ct_T2__O__O__(new $c_T2(), "Asia/Hebron", _2$130);
    var _2$131 = $m_Lzonedb_java_tzdb$ameha$().Lzonedb_java_tzdb$ameha$__f_America_Godthab;
    var $$x216 = $ct_T2__O__O__(new $c_T2(), "America/Godthab", _2$131);
    var _2$132 = $m_Lzonedb_java_tzdb$afrob$().Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi;
    var $$x215 = $ct_T2__O__O__(new $c_T2(), "Africa/Nairobi", _2$132);
    var _2$133 = $m_Lzonedb_java_tzdb$amevi$().Lzonedb_java_tzdb$amevi$__f_America_Inuvik;
    var $$x214 = $ct_T2__O__O__(new $c_T2(), "America/Inuvik", _2$133);
    var _2$134 = $m_Lzonedb_java_tzdb$ameez$().Lzonedb_java_tzdb$ameez$__f_America_Fortaleza;
    var $$x213 = $ct_T2__O__O__(new $c_T2(), "America/Fortaleza", _2$134);
    var _2$135 = $m_Lzonedb_java_tzdb$asiru$().Lzonedb_java_tzdb$asiru$__f_Asia_Beirut;
    var $$x212 = $ct_T2__O__O__(new $c_T2(), "Asia/Beirut", _2$135);
    var _2$136 = $m_Lzonedb_java_tzdb$ameiz$().Lzonedb_java_tzdb$ameiz$__f_America_Belize;
    var $$x211 = $ct_T2__O__O__(new $c_T2(), "America/Belize", _2$136);
    var _2$137 = $m_Lzonedb_java_tzdb$ausri$().Lzonedb_java_tzdb$ausri$__f_Australia_Currie;
    var $$x210 = $ct_T2__O__O__(new $c_T2(), "Australia/Currie", _2$137);
    var _2$138 = $m_Lzonedb_java_tzdb$amela$().Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah;
    var $$x209 = $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/Beulah", _2$138);
    var _2$139 = $m_Lzonedb_java_tzdb$eures$().Lzonedb_java_tzdb$eures$__f_Europe_Bucharest;
    var $$x208 = $ct_T2__O__O__(new $c_T2(), "Europe/Bucharest", _2$139);
    var _2$140 = $m_Lzonedb_java_tzdb$amean$().Lzonedb_java_tzdb$amean$__f_America_Guyana;
    var $$x207 = $ct_T2__O__O__(new $c_T2(), "America/Guyana", _2$140);
    var _2$141 = $m_Lzonedb_java_tzdb$ameul$().Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo;
    var $$x206 = $ct_T2__O__O__(new $c_T2(), "America/Sao_Paulo", _2$141);
    var _2$142 = $m_Lzonedb_java_tzdb$ameic$().Lzonedb_java_tzdb$ameic$__f_America_Jamaica;
    var $$x205 = $ct_T2__O__O__(new $c_T2(), "America/Jamaica", _2$142);
    var _2$143 = $m_Lzonedb_java_tzdb$ameur$().Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg;
    var $$x204 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Petersburg", _2$143);
    var _2$144 = $m_Lzonedb_java_tzdb$eurom$().Lzonedb_java_tzdb$eurom$__f_Europe_Rome;
    var $$x203 = $ct_T2__O__O__(new $c_T2(), "Europe/Rome", _2$144);
    var _2$145 = $m_Lzonedb_java_tzdb$asisi$().Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia;
    var $$x202 = $ct_T2__O__O__(new $c_T2(), "Asia/Nicosia", _2$145);
    var _2$146 = $m_Lzonedb_java_tzdb$pacsa$().Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas;
    var $$x201 = $ct_T2__O__O__(new $c_T2(), "Pacific/Marquesas", _2$146);
    var _2$147 = $m_Lzonedb_java_tzdb$afriu$().Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun;
    var $$x200 = $ct_T2__O__O__(new $c_T2(), "Africa/El_Aaiun", _2$147);
    var _2$148 = $m_Lzonedb_java_tzdb$ameot$().Lzonedb_java_tzdb$ameot$__f_America_Bogota;
    var $$x199 = $ct_T2__O__O__(new $c_T2(), "America/Bogota", _2$148);
    var _2$149 = $m_Lzonedb_java_tzdb$asinb$().Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe;
    var $$x198 = $ct_T2__O__O__(new $c_T2(), "Asia/Dushanbe", _2$149);
    var _2$150 = $m_Lzonedb_java_tzdb$pacha$().Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham;
    var $$x197 = $ct_T2__O__O__(new $c_T2(), "Pacific/Chatham", _2$150);
    var _2$151 = $m_Lzonedb_java_tzdb$asisa$().Lzonedb_java_tzdb$asisa$__f_Asia_Makassar;
    var $$x196 = $ct_T2__O__O__(new $c_T2(), "Asia/Makassar", _2$151);
    var _2$152 = $m_Lzonedb_java_tzdb$atlrd$().Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde;
    var $$x195 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Cape_Verde", _2$152);
    var _2$153 = $m_Lzonedb_java_tzdb$eurdo$().Lzonedb_java_tzdb$eurdo$__f_Europe_London;
    var $$x194 = $ct_T2__O__O__(new $c_T2(), "Europe/London", _2$153);
    var _2$154 = $m_Lzonedb_java_tzdb$antme$().Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer;
    var $$x193 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Palmer", _2$154);
    var _2$155 = $m_Lzonedb_java_tzdb$afrut$().Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta;
    var $$x192 = $ct_T2__O__O__(new $c_T2(), "Africa/Ceuta", _2$155);
    var _2$156 = $m_Lzonedb_java_tzdb$asimq$().Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi;
    var $$x191 = $ct_T2__O__O__(new $c_T2(), "Asia/Urumqi", _2$156);
    var _2$157 = $m_Lzonedb_java_tzdb$amelo$().Lzonedb_java_tzdb$amelo$__f_America_Miquelon;
    var $$x190 = $ct_T2__O__O__(new $c_T2(), "America/Miquelon", _2$157);
    var _2$158 = $m_Lzonedb_java_tzdb$eurra$().Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad;
    var $$x189 = $ct_T2__O__O__(new $c_T2(), "Europe/Kaliningrad", _2$158);
    var _2$159 = $m_Lzonedb_java_tzdb$ameob$().Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba;
    var $$x188 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Cordoba", _2$159);
    var _2$160 = $m_Lzonedb_java_tzdb$pacng$().Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga;
    var $$x187 = $ct_T2__O__O__(new $c_T2(), "Pacific/Rarotonga", _2$160);
    var _2$161 = $m_Lzonedb_java_tzdb$amede$().Lzonedb_java_tzdb$amede$__f_America_Montevideo;
    var $$x186 = $ct_T2__O__O__(new $c_T2(), "America/Montevideo", _2$161);
    var _2$162 = $m_Lzonedb_java_tzdb$paciu$().Lzonedb_java_tzdb$paciu$__f_Pacific_Niue;
    var $$x185 = $ct_T2__O__O__(new $c_T2(), "Pacific/Niue", _2$162);
    var _2$163 = $m_Lzonedb_java_tzdb$ameju$().Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy;
    var $$x184 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Jujuy", _2$163);
    var _2$164 = $m_Lzonedb_java_tzdb$asili$().Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin;
    var $$x183 = $ct_T2__O__O__(new $c_T2(), "Asia/Sakhalin", _2$164);
    var _2$165 = $m_Lzonedb_java_tzdb$amere$().Lzonedb_java_tzdb$amere$__f_America_Monterrey;
    var $$x182 = $ct_T2__O__O__(new $c_T2(), "America/Monterrey", _2$165);
    var _2$166 = $m_Lzonedb_java_tzdb$eurfi$().Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia;
    var $$x181 = $ct_T2__O__O__(new $c_T2(), "Europe/Sofia", _2$166);
    var _2$167 = $m_Lzonedb_java_tzdb$amein$().Lzonedb_java_tzdb$amein$__f_America_Araguaina;
    var $$x180 = $ct_T2__O__O__(new $c_T2(), "America/Araguaina", _2$167);
    var _2$168 = $m_Lzonedb_java_tzdb$pacur$().Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury;
    var $$x179 = $ct_T2__O__O__(new $c_T2(), "Pacific/Enderbury", _2$168);
    var _2$169 = $m_Lzonedb_java_tzdb$ameca$().Lzonedb_java_tzdb$ameca$__f_America_Curacao;
    var $$x178 = $ct_T2__O__O__(new $c_T2(), "America/Curacao", _2$169);
    var _2$170 = $m_Lzonedb_java_tzdb$pacgo$().Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos;
    var $$x177 = $ct_T2__O__O__(new $c_T2(), "Pacific/Galapagos", _2$170);
    var _2$171 = $m_Lzonedb_java_tzdb$asike$().Lzonedb_java_tzdb$asike$__f_Asia_Bishkek;
    var $$x176 = $ct_T2__O__O__(new $c_T2(), "Asia/Bishkek", _2$171);
    var _2$172 = $m_Lzonedb_java_tzdb$euriu$().Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius;
    var $$x175 = $ct_T2__O__O__(new $c_T2(), "Europe/Vilnius", _2$172);
    var _2$173 = $m_Lzonedb_java_tzdb$pacan$().Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland;
    var $$x174 = $ct_T2__O__O__(new $c_T2(), "Pacific/Auckland", _2$173);
    var _2$174 = $m_Lzonedb_java_tzdb$ameul$().Lzonedb_java_tzdb$ameul$__f_America_Thule;
    var $$x173 = $ct_T2__O__O__(new $c_T2(), "America/Thule", _2$174);
    var _2$175 = $m_Lzonedb_java_tzdb$amean$().Lzonedb_java_tzdb$amean$__f_America_Havana;
    var $$x172 = $ct_T2__O__O__(new $c_T2(), "America/Havana", _2$175);
    var _2$176 = $m_Lzonedb_java_tzdb$ameda$().Lzonedb_java_tzdb$ameda$__f_America_Adak;
    var $$x171 = $ct_T2__O__O__(new $c_T2(), "America/Adak", _2$176);
    var _2$177 = $m_Lzonedb_java_tzdb$ameom$().Lzonedb_java_tzdb$ameom$__f_America_Nome;
    var $$x170 = $ct_T2__O__O__(new $c_T2(), "America/Nome", _2$177);
    var _2$178 = $m_Lzonedb_java_tzdb$eurig$().Lzonedb_java_tzdb$eurig$__f_Europe_Riga;
    var $$x169 = $ct_T2__O__O__(new $c_T2(), "Europe/Riga", _2$178);
    var _2$179 = $m_Lzonedb_java_tzdb$afrub$().Lzonedb_java_tzdb$afrub$__f_Africa_Juba;
    var $$x168 = $ct_T2__O__O__(new $c_T2(), "Africa/Juba", _2$179);
    var _2$180 = $m_Lzonedb_java_tzdb$asiur$().Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg;
    var $$x167 = $ct_T2__O__O__(new $c_T2(), "Asia/Yekaterinburg", _2$180);
    var _2$181 = $m_Lzonedb_java_tzdb$pacla$().Lzonedb_java_tzdb$pacla$__f_Pacific_Palau;
    var $$x166 = $ct_T2__O__O__(new $c_T2(), "Pacific/Palau", _2$181);
    var _2$182 = $m_Lzonedb_java_tzdb$eurli$().Lzonedb_java_tzdb$eurli$__f_Europe_Berlin;
    var $$x165 = $ct_T2__O__O__(new $c_T2(), "Europe/Berlin", _2$182);
    var _2$183 = $m_Lzonedb_java_tzdb$ameit$().Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City;
    var $$x164 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Tell_City", _2$183);
    var _2$184 = $m_Lzonedb_java_tzdb$amenh$().Lzonedb_java_tzdb$amenh$__f_America_Noronha;
    var $$x163 = $ct_T2__O__O__(new $c_T2(), "America/Noronha", _2$184);
    var _2$185 = $m_Lzonedb_java_tzdb$asiva$().Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan;
    var $$x162 = $ct_T2__O__O__(new $c_T2(), "Asia/Yerevan", _2$185);
    var _2$186 = $m_Lzonedb_java_tzdb$amele$().Lzonedb_java_tzdb$amele$__f_America_Los_Angeles;
    var $$x161 = $ct_T2__O__O__(new $c_T2(), "America/Los_Angeles", _2$186);
    var _2$187 = $m_Lzonedb_java_tzdb$afrnc$().Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca;
    var $$x160 = $ct_T2__O__O__(new $c_T2(), "Africa/Casablanca", _2$187);
    var _2$188 = $m_Lzonedb_java_tzdb$asiit$().Lzonedb_java_tzdb$asiit$__f_Asia_Chita;
    var $$x159 = $ct_T2__O__O__(new $c_T2(), "Asia/Chita", _2$188);
    var _2$189 = $m_Lzonedb_java_tzdb$pacur$().Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru;
    var $$x158 = $ct_T2__O__O__(new $c_T2(), "Pacific/Nauru", _2$189);
    var _2$190 = $m_Lzonedb_java_tzdb$asima$().Lzonedb_java_tzdb$asima$__f_Asia_Amman;
    var $$x157 = $ct_T2__O__O__(new $c_T2(), "Asia/Amman", _2$190);
    var _2$191 = $m_Lzonedb_java_tzdb$ameca$().Lzonedb_java_tzdb$ameca$__f_America_Caracas;
    var $$x156 = $ct_T2__O__O__(new $c_T2(), "America/Caracas", _2$191);
    var _2$192 = $m_Lzonedb_java_tzdb$asian$().Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang;
    var $$x155 = $ct_T2__O__O__(new $c_T2(), "Asia/Pyongyang", _2$192);
    var _2$193 = $m_Lzonedb_java_tzdb$ameoi$().Lzonedb_java_tzdb$ameoi$__f_America_Detroit;
    var $$x154 = $ct_T2__O__O__(new $c_T2(), "America/Detroit", _2$193);
    var _2$194 = $m_Lzonedb_java_tzdb$asird$().Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda;
    var $$x153 = $ct_T2__O__O__(new $c_T2(), "Asia/Qyzylorda", _2$194);
    var _2$195 = $m_Lzonedb_java_tzdb$eurlt$().Lzonedb_java_tzdb$eurlt$__f_Europe_Malta;
    var $$x152 = $ct_T2__O__O__(new $c_T2(), "Europe/Malta", _2$195);
    var _2$196 = $m_Lzonedb_java_tzdb$afrom$().Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome;
    var $$x151 = $ct_T2__O__O__(new $c_T2(), "Africa/Sao_Tome", _2$196);
    var _2$197 = $m_Lzonedb_java_tzdb$amerc$().Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca;
    var $$x150 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Catamarca", _2$197);
    var _2$198 = $m_Lzonedb_java_tzdb$indgo$().Lzonedb_java_tzdb$indgo$__f_Indian_Chagos;
    var $$x149 = $ct_T2__O__O__(new $c_T2(), "Indian/Chagos", _2$198);
    var _2$199 = $m_Lzonedb_java_tzdb$amenc$().Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince;
    var $$x148 = $ct_T2__O__O__(new $c_T2(), "America/Port-au-Prince", _2$199);
    var _2$200 = $m_Lzonedb_java_tzdb$ameag$().Lzonedb_java_tzdb$ameag$__f_America_Ojinaga;
    var $$x147 = $ct_T2__O__O__(new $c_T2(), "America/Ojinaga", _2$200);
    var _2$201 = $m_Lzonedb_java_tzdb$pacll$().Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville;
    var $$x146 = $ct_T2__O__O__(new $c_T2(), "Pacific/Bougainville", _2$201);
    var _2$202 = $m_Lzonedb_java_tzdb$atlud$().Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda;
    var $$x145 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Bermuda", _2$202);
    var _2$203 = $m_Lzonedb_java_tzdb$eurhy$().Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye;
    var $$x144 = $ct_T2__O__O__(new $c_T2(), "Europe/Zaporozhye", _2$203);
    var _2$204 = $m_Lzonedb_java_tzdb$asiur$().Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura;
    var $$x143 = $ct_T2__O__O__(new $c_T2(), "Asia/Jayapura", _2$204);
    var _2$205 = $m_Lzonedb_java_tzdb$atlle$().Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley;
    var $$x142 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Stanley", _2$205);
    var _2$206 = $m_Lzonedb_java_tzdb$asind$().Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu;
    var $$x141 = $ct_T2__O__O__(new $c_T2(), "Asia/Kathmandu", _2$206);
    var _2$207 = $m_Lzonedb_java_tzdb$asier$().Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera;
    var $$x140 = $ct_T2__O__O__(new $c_T2(), "Asia/Ust-Nera", _2$207);
    var _2$208 = $m_Lzonedb_java_tzdb$ameba$().Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay;
    var $$x139 = $ct_T2__O__O__(new $c_T2(), "America/Glace_Bay", _2$208);
    var _2$209 = $m_Lzonedb_java_tzdb$afrir$().Lzonedb_java_tzdb$afrir$__f_Africa_Cairo;
    var $$x138 = $ct_T2__O__O__(new $c_T2(), "Africa/Cairo", _2$209);
    var _2$210 = $m_Lzonedb_java_tzdb$asiak$().Lzonedb_java_tzdb$asiak$__f_Asia_Baku;
    var $$x137 = $ct_T2__O__O__(new $c_T2(), "Asia/Baku", _2$210);
    var _2$211 = $m_Lzonedb_java_tzdb$ameic$().Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica;
    var $$x136 = $ct_T2__O__O__(new $c_T2(), "America/Costa_Rica", _2$211);
    var _2$212 = $m_Lzonedb_java_tzdb$antso$().Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson;
    var $$x135 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Mawson", _2$212);
    var _2$213 = $m_Lzonedb_java_tzdb$ausil$().Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill;
    var $$x134 = $ct_T2__O__O__(new $c_T2(), "Australia/Broken_Hill", _2$213);
    var _2$214 = $m_Lzonedb_java_tzdb$amedo$().Lzonedb_java_tzdb$amedo$__f_America_El_Salvador;
    var $$x133 = $ct_T2__O__O__(new $c_T2(), "America/El_Salvador", _2$214);
    var _2$215 = $m_Lzonedb_java_tzdb$asims$().Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk;
    var $$x132 = $ct_T2__O__O__(new $c_T2(), "Asia/Srednekolymsk", _2$215);
    var _2$216 = $m_Lzonedb_java_tzdb$asiov$().Lzonedb_java_tzdb$asiov$__f_Asia_Hovd;
    var $$x131 = $ct_T2__O__O__(new $c_T2(), "Asia/Hovd", _2$216);
    var _2$217 = $m_Lzonedb_java_tzdb$ameta$().Lzonedb_java_tzdb$ameta$__f_America_Yakutat;
    var $$x130 = $ct_T2__O__O__(new $c_T2(), "America/Yakutat", _2$217);
    var _2$218 = $m_Lzonedb_java_tzdb$ameag$().Lzonedb_java_tzdb$ameag$__f_America_Chicago;
    var $$x129 = $ct_T2__O__O__(new $c_T2(), "America/Chicago", _2$218);
    var _2$219 = $m_Lzonedb_java_tzdb$eursa$().Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw;
    var $$x128 = $ct_T2__O__O__(new $c_T2(), "Europe/Warsaw", _2$219);
    var _2$220 = $m_Lzonedb_java_tzdb$ameoj$().Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja;
    var $$x127 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/La_Rioja", _2$220);
    var _2$221 = $m_Lzonedb_java_tzdb$asion$().Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong;
    var $$x126 = $ct_T2__O__O__(new $c_T2(), "Asia/Hong_Kong", _2$221);
    var _2$222 = $m_Lzonedb_java_tzdb$atlre$().Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores;
    var $$x125 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Azores", _2$222);
    var _2$223 = $m_Lzonedb_java_tzdb$eurnk$().Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki;
    var $$x124 = $ct_T2__O__O__(new $c_T2(), "Europe/Helsinki", _2$223);
    var _2$224 = $m_Lzonedb_java_tzdb$pacat$().Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati;
    var $$x123 = $ct_T2__O__O__(new $c_T2(), "Pacific/Kiritimati", _2$224);
    var _2$225 = $m_Lzonedb_java_tzdb$eurel$().Lzonedb_java_tzdb$eurel$__f_Europe_Brussels;
    var $$x122 = $ct_T2__O__O__(new $c_T2(), "Europe/Brussels", _2$225);
    var _2$226 = $m_Lzonedb_java_tzdb$asiko$().Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok;
    var $$x121 = $ct_T2__O__O__(new $c_T2(), "Asia/Bangkok", _2$226);
    var _2$227 = $m_Lzonedb_java_tzdb$ameee$().Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek;
    var $$x120 = $ct_T2__O__O__(new $c_T2(), "America/Dawson_Creek", _2$227);
    var _2$228 = $m_Lzonedb_java_tzdb$asiis$().Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi;
    var $$x119 = $ct_T2__O__O__(new $c_T2(), "Asia/Tbilisi", _2$228);
    var _2$229 = $m_Lzonedb_java_tzdb$asira$().Lzonedb_java_tzdb$asira$__f_Asia_Oral;
    var $$x118 = $ct_T2__O__O__(new $c_T2(), "Asia/Oral", _2$229);
    var _2$230 = $m_Lzonedb_java_tzdb$amele$().Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet;
    var $$x117 = $ct_T2__O__O__(new $c_T2(), "America/Rankin_Inlet", _2$230);
    var _2$231 = $m_Lzonedb_java_tzdb$asita$().Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar;
    var $$x116 = $ct_T2__O__O__(new $c_T2(), "Asia/Ulaanbaatar", _2$231);
    var _2$232 = $m_Lzonedb_java_tzdb$ameen$().Lzonedb_java_tzdb$ameen$__f_America_Swift_Current;
    var $$x115 = $ct_T2__O__O__(new $c_T2(), "America/Swift_Current", _2$232);
    var _2$233 = $m_Lzonedb_java_tzdb$amehu$().Lzonedb_java_tzdb$amehu$__f_America_Chihuahua;
    var $$x114 = $ct_T2__O__O__(new $c_T2(), "America/Chihuahua", _2$233);
    var _2$234 = $m_Lzonedb_java_tzdb$eurha$().Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan;
    var $$x113 = $ct_T2__O__O__(new $c_T2(), "Europe/Astrakhan", _2$234);
    var _2$235 = $m_Lzonedb_java_tzdb$amema$().Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman;
    var $$x112 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Tucuman", _2$235);
    var _2$236 = $m_Lzonedb_java_tzdb$pacut$().Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti;
    var $$x111 = $ct_T2__O__O__(new $c_T2(), "Pacific/Funafuti", _2$236);
    var _2$237 = $m_Lzonedb_java_tzdb$asiak$().Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka;
    var $$x110 = $ct_T2__O__O__(new $c_T2(), "Asia/Dhaka", _2$237);
    var _2$238 = $m_Lzonedb_java_tzdb$amelt$().Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta;
    var $$x109 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Salta", _2$238);
    var _2$239 = $m_Lzonedb_java_tzdb$ameto$().Lzonedb_java_tzdb$ameto$__f_America_Moncton;
    var $$x108 = $ct_T2__O__O__(new $c_T2(), "America/Moncton", _2$239);
    var _2$240 = $m_Lzonedb_java_tzdb$pacur$().Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro;
    var $$x107 = $ct_T2__O__O__(new $c_T2(), "Pacific/Majuro", _2$240);
    var _2$241 = $m_Lzonedb_java_tzdb$afren$().Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena;
    var $$x106 = $ct_T2__O__O__(new $c_T2(), "Africa/Ndjamena", _2$241);
    var _2$242 = $m_Lzonedb_java_tzdb$asiky$().Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo;
    var $$x105 = $ct_T2__O__O__(new $c_T2(), "Asia/Tokyo", _2$242);
    var _2$243 = $m_Lzonedb_java_tzdb$ameic$().Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico;
    var $$x104 = $ct_T2__O__O__(new $c_T2(), "America/Puerto_Rico", _2$243);
    var _2$244 = $m_Lzonedb_java_tzdb$ameve$().Lzonedb_java_tzdb$ameve$__f_America_Denver;
    var $$x103 = $ct_T2__O__O__(new $c_T2(), "America/Denver", _2$244);
    var _2$245 = $m_Lzonedb_java_tzdb$euric$().Lzonedb_java_tzdb$euric$__f_Europe_Zurich;
    var $$x102 = $ct_T2__O__O__(new $c_T2(), "Europe/Zurich", _2$245);
    var _2$246 = $m_Lzonedb_java_tzdb$amelh$().Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho;
    var $$x101 = $ct_T2__O__O__(new $c_T2(), "America/Porto_Velho", _2$246);
    var _2$247 = $m_Lzonedb_java_tzdb$pacei$().Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein;
    var $$x100 = $ct_T2__O__O__(new $c_T2(), "Pacific/Kwajalein", _2$247);
    var _2$248 = $m_Lzonedb_java_tzdb$pacsb$().Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby;
    var $$x99 = $ct_T2__O__O__(new $c_T2(), "Pacific/Port_Moresby", _2$248);
    var _2$249 = $m_Lzonedb_java_tzdb$ament$().Lzonedb_java_tzdb$ament$__f_America_Toronto;
    var $$x98 = $ct_T2__O__O__(new $c_T2(), "America/Toronto", _2$249);
    var _2$250 = $m_Lzonedb_java_tzdb$eurbu$().Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul;
    var $$x97 = $ct_T2__O__O__(new $c_T2(), "Europe/Istanbul", _2$250);
    var _2$251 = $m_Lzonedb_java_tzdb$pacaw$().Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa;
    var $$x96 = $ct_T2__O__O__(new $c_T2(), "Pacific/Tarawa", _2$251);
    var _2$252 = $m_Lzonedb_java_tzdb$atlar$().Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary;
    var $$x95 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Canary", _2$252);
    var _2$253 = $m_Lzonedb_java_tzdb$pacit$().Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti;
    var $$x94 = $ct_T2__O__O__(new $c_T2(), "Pacific/Tahiti", _2$253);
    var _2$254 = $m_Lzonedb_java_tzdb$pacie$().Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier;
    var $$x93 = $ct_T2__O__O__(new $c_T2(), "Pacific/Gambier", _2$254);
    var _2$255 = $m_Lzonedb_java_tzdb$indle$().Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen;
    var $$x92 = $ct_T2__O__O__(new $c_T2(), "Indian/Kerguelen", _2$255);
    var _2$256 = $m_Lzonedb_java_tzdb$amedo$().Lzonedb_java_tzdb$amedo$__f_America_Barbados;
    var $$x91 = $ct_T2__O__O__(new $c_T2(), "America/Barbados", _2$256);
    var _2$257 = $m_Lzonedb_java_tzdb$ameui$().Lzonedb_java_tzdb$ameui$__f_America_Iqaluit;
    var $$x90 = $ct_T2__O__O__(new $c_T2(), "America/Iqaluit", _2$257);
    var _2$258 = $m_Lzonedb_java_tzdb$amers$().Lzonedb_java_tzdb$amers$__f_America_Whitehorse;
    var $$x89 = $ct_T2__O__O__(new $c_T2(), "America/Whitehorse", _2$258);
    var _2$259 = $m_Lzonedb_java_tzdb$ameui$().Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis;
    var $$x88 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/San_Luis", _2$259);
    var _2$260 = $m_Lzonedb_java_tzdb$eurra$().Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd;
    var $$x87 = $ct_T2__O__O__(new $c_T2(), "Europe/Volgograd", _2$260);
    var _2$261 = $m_Lzonedb_java_tzdb$atlgi$().Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia;
    var $$x86 = $ct_T2__O__O__(new $c_T2(), "Atlantic/South_Georgia", _2$261);
    var _2$262 = $m_Lzonedb_java_tzdb$ametk$().Lzonedb_java_tzdb$ametk$__f_America_Sitka;
    var $$x85 = $ct_T2__O__O__(new $c_T2(), "America/Sitka", _2$262);
    var _2$263 = $m_Lzonedb_java_tzdb$ausow$().Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe;
    var $$x84 = $ct_T2__O__O__(new $c_T2(), "Australia/Lord_Howe", _2$263);
    var _2$264 = $m_Lzonedb_java_tzdb$eurro$().Lzonedb_java_tzdb$eurro$__f_Europe_Kirov;
    var $$x83 = $ct_T2__O__O__(new $c_T2(), "Europe/Kirov", _2$264);
    var _2$265 = $m_Lzonedb_java_tzdb$amere$().Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires;
    var $$x82 = $ct_T2__O__O__(new $c_T2(), "America/Argentina/Buenos_Aires", _2$265);
    var _2$266 = $m_Lzonedb_java_tzdb$pacra$().Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae;
    var $$x81 = $ct_T2__O__O__(new $c_T2(), "Pacific/Kosrae", _2$266);
    var _2$267 = $m_Lzonedb_java_tzdb$ameve$().Lzonedb_java_tzdb$ameve$__f_America_Vancouver;
    var $$x80 = $ct_T2__O__O__(new $c_T2(), "America/Vancouver", _2$267);
    var _2$268 = $m_Lzonedb_java_tzdb$eures$().Lzonedb_java_tzdb$eures$__f_Europe_Budapest;
    var $$x79 = $ct_T2__O__O__(new $c_T2(), "Europe/Budapest", _2$268);
    var _2$269 = $m_Lzonedb_java_tzdb$asits$().Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk;
    var $$x78 = $ct_T2__O__O__(new $c_T2(), "Asia/Yakutsk", _2$269);
    var _2$270 = $m_Lzonedb_java_tzdb$amehi$().Lzonedb_java_tzdb$amehi$__f_America_Bahia;
    var $$x77 = $ct_T2__O__O__(new $c_T2(), "America/Bahia", _2$270);
    var _2$271 = $m_Lzonedb_java_tzdb$ameid$().Lzonedb_java_tzdb$ameid$__f_America_Merida;
    var $$x76 = $ct_T2__O__O__(new $c_T2(), "America/Merida", _2$271);
    var _2$272 = $m_Lzonedb_java_tzdb$antvi$().Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis;
    var $$x75 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Davis", _2$272);
    var _2$273 = $m_Lzonedb_java_tzdb$asitk$().Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka;
    var $$x74 = $ct_T2__O__O__(new $c_T2(), "Asia/Kamchatka", _2$273);
    var _2$274 = $m_Lzonedb_java_tzdb$eurar$().Lzonedb_java_tzdb$eurar$__f_Europe_Samara;
    var $$x73 = $ct_T2__O__O__(new $c_T2(), "Europe/Samara", _2$274);
    var _2$275 = $m_Lzonedb_java_tzdb$ameng$().Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo;
    var $$x72 = $ct_T2__O__O__(new $c_T2(), "America/Santo_Domingo", _2$275);
    var _2$276 = $m_Lzonedb_java_tzdb$amegu$().Lzonedb_java_tzdb$amegu$__f_America_Managua;
    var $$x71 = $ct_T2__O__O__(new $c_T2(), "America/Managua", _2$276);
    var _2$277 = $m_Lzonedb_java_tzdb$ameag$().Lzonedb_java_tzdb$ameag$__f_America_Anchorage;
    var $$x70 = $ct_T2__O__O__(new $c_T2(), "America/Anchorage", _2$277);
    var _2$278 = $m_Lzonedb_java_tzdb$eurbo$().Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon;
    var $$x69 = $ct_T2__O__O__(new $c_T2(), "Europe/Lisbon", _2$278);
    var _2$279 = $m_Lzonedb_java_tzdb$eurco$().Lzonedb_java_tzdb$eurco$__f_Europe_Moscow;
    var $$x68 = $ct_T2__O__O__(new $c_T2(), "Europe/Moscow", _2$279);
    var _2$280 = $m_Lzonedb_java_tzdb$asiat$().Lzonedb_java_tzdb$asiat$__f_Asia_Almaty;
    var $$x67 = $ct_T2__O__O__(new $c_T2(), "Asia/Almaty", _2$280);
    var _2$281 = $m_Lzonedb_java_tzdb$ameui$().Lzonedb_java_tzdb$ameui$__f_America_Guayaquil;
    var $$x66 = $ct_T2__O__O__(new $c_T2(), "America/Guayaquil", _2$281);
    var _2$282 = $m_Lzonedb_java_tzdb$pacuu$().Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk;
    var $$x65 = $ct_T2__O__O__(new $c_T2(), "Pacific/Chuuk", _2$282);
    var _2$283 = $m_Lzonedb_java_tzdb$afrer$().Lzonedb_java_tzdb$afrer$__f_Africa_Algiers;
    var $$x64 = $ct_T2__O__O__(new $c_T2(), "Africa/Algiers", _2$283);
    var _2$284 = $m_Lzonedb_java_tzdb$ameut$().Lzonedb_java_tzdb$ameut$__f_America_Resolute;
    var $$x63 = $ct_T2__O__O__(new $c_T2(), "America/Resolute", _2$284);
    var _2$285 = $m_Lzonedb_java_tzdb$auswi$().Lzonedb_java_tzdb$auswi$__f_Australia_Darwin;
    var $$x62 = $ct_T2__O__O__(new $c_T2(), "Australia/Darwin", _2$285);
    var _2$286 = $m_Lzonedb_java_tzdb$asida$().Lzonedb_java_tzdb$asida$__f_Asia_Baghdad;
    var $$x61 = $ct_T2__O__O__(new $c_T2(), "Asia/Baghdad", _2$286);
    var _2$287 = $m_Lzonedb_java_tzdb$pacol$().Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk;
    var $$x60 = $ct_T2__O__O__(new $c_T2(), "Pacific/Norfolk", _2$287);
    var _2$288 = $m_Lzonedb_java_tzdb$indio$().Lzonedb_java_tzdb$indio$__f_Indian_Reunion;
    var $$x59 = $ct_T2__O__O__(new $c_T2(), "Indian/Reunion", _2$288);
    var _2$289 = $m_Lzonedb_java_tzdb$amema$().Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac;
    var $$x58 = $ct_T2__O__O__(new $c_T2(), "America/Indiana/Winamac", _2$289);
    var _2$290 = $m_Lzonedb_java_tzdb$asior$().Lzonedb_java_tzdb$asior$__f_Asia_Singapore;
    var $$x57 = $ct_T2__O__O__(new $c_T2(), "Asia/Singapore", _2$290);
    var _2$291 = $m_Lzonedb_java_tzdb$eurin$().Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn;
    var $$x56 = $ct_T2__O__O__(new $c_T2(), "Europe/Tallinn", _2$291);
    var _2$292 = $m_Lzonedb_java_tzdb$amesa$().Lzonedb_java_tzdb$amesa$__f_America_Nassau;
    var $$x55 = $ct_T2__O__O__(new $c_T2(), "America/Nassau", _2$292);
    var _2$293 = $m_Lzonedb_java_tzdb$asiyg$().Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga;
    var $$x54 = $ct_T2__O__O__(new $c_T2(), "Asia/Khandyga", _2$293);
    var _2$294 = $m_Lzonedb_java_tzdb$ameun$().Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung;
    var $$x53 = $ct_T2__O__O__(new $c_T2(), "America/Pangnirtung", _2$294);
    var _2$295 = $m_Lzonedb_java_tzdb$pacua$().Lzonedb_java_tzdb$pacua$__f_Pacific_Guam;
    var $$x52 = $ct_T2__O__O__(new $c_T2(), "Pacific/Guam", _2$295);
    var _2$296 = $m_Lzonedb_java_tzdb$ametl$().Lzonedb_java_tzdb$ametl$__f_America_Metlakatla;
    var $$x51 = $ct_T2__O__O__(new $c_T2(), "America/Metlakatla", _2$296);
    var _2$297 = $m_Lzonedb_java_tzdb$amepe$().Lzonedb_java_tzdb$amepe$__f_America_Winnipeg;
    var $$x50 = $ct_T2__O__O__(new $c_T2(), "America/Winnipeg", _2$297);
    var _2$298 = $m_Lzonedb_java_tzdb$ameor$().Lzonedb_java_tzdb$ameor$__f_America_New_York;
    var $$x49 = $ct_T2__O__O__(new $c_T2(), "America/New_York", _2$298);
    var _2$299 = $m_Lzonedb_java_tzdb$pacak$().Lzonedb_java_tzdb$pacak$__f_Pacific_Wake;
    var $$x48 = $ct_T2__O__O__(new $c_T2(), "Pacific/Wake", _2$299);
    var _2$300 = $m_Lzonedb_java_tzdb$pacir$().Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn;
    var $$x47 = $ct_T2__O__O__(new $c_T2(), "Pacific/Pitcairn", _2$300);
    var _2$301 = $m_Lzonedb_java_tzdb$asica$().Lzonedb_java_tzdb$asica$__f_Asia_Macau;
    var $$x46 = $ct_T2__O__O__(new $c_T2(), "Asia/Macau", _2$301);
    var _2$302 = $m_Lzonedb_java_tzdb$asims$().Lzonedb_java_tzdb$asims$__f_Asia_Omsk;
    var $$x45 = $ct_T2__O__O__(new $c_T2(), "Asia/Omsk", _2$302);
    var _2$303 = $m_Lzonedb_java_tzdb$pacpi$().Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia;
    var $$x44 = $ct_T2__O__O__(new $c_T2(), "Pacific/Apia", _2$303);
    var _2$304 = $m_Lzonedb_java_tzdb$ameso$().Lzonedb_java_tzdb$ameso$__f_America_Dawson;
    var $$x43 = $ct_T2__O__O__(new $c_T2(), "America/Dawson", _2$304);
    var _2$305 = $m_Lzonedb_java_tzdb$amena$().Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas;
    var $$x42 = $ct_T2__O__O__(new $c_T2(), "America/Punta_Arenas", _2$305);
    var _2$306 = $m_Lzonedb_java_tzdb$ameur$().Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk;
    var $$x41 = $ct_T2__O__O__(new $c_T2(), "America/Grand_Turk", _2$306);
    var _2$307 = $m_Lzonedb_java_tzdb$pacap$().Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu;
    var $$x40 = $ct_T2__O__O__(new $c_T2(), "Pacific/Tongatapu", _2$307);
    var _2$308 = $m_Lzonedb_java_tzdb$amenn$().Lzonedb_java_tzdb$amenn$__f_America_Cayenne;
    var $$x39 = $ct_T2__O__O__(new $c_T2(), "America/Cayenne", _2$308);
    var _2$309 = $m_Lzonedb_java_tzdb$ameso$().Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson;
    var $$x38 = $ct_T2__O__O__(new $c_T2(), "America/Fort_Nelson", _2$309);
    var _2$310 = $m_Lzonedb_java_tzdb$pacli$().Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis;
    var $$x37 = $ct_T2__O__O__(new $c_T2(), "Pacific/Wallis", _2$310);
    var _2$311 = $m_Lzonedb_java_tzdb$asita$().Lzonedb_java_tzdb$asita$__f_Asia_Aqtau;
    var $$x36 = $ct_T2__O__O__(new $c_T2(), "Asia/Aqtau", _2$311);
    var _2$312 = $m_Lzonedb_java_tzdb$pacat$().Lzonedb_java_tzdb$pacat$__f_Pacific_Efate;
    var $$x35 = $ct_T2__O__O__(new $c_T2(), "Pacific/Efate", _2$312);
    var _2$313 = $m_Lzonedb_java_tzdb$euren$().Lzonedb_java_tzdb$euren$__f_Europe_Athens;
    var $$x34 = $ct_T2__O__O__(new $c_T2(), "Europe/Athens", _2$313);
    var _2$314 = $m_Lzonedb_java_tzdb$amete$().Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center;
    var $$x33 = $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/Center", _2$314);
    var _2$315 = $m_Lzonedb_java_tzdb$asist$().Lzonedb_java_tzdb$asist$__f_Asia_Famagusta;
    var $$x32 = $ct_T2__O__O__(new $c_T2(), "Asia/Famagusta", _2$315);
    var _2$316 = $m_Lzonedb_java_tzdb$asito$().Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok;
    var $$x31 = $ct_T2__O__O__(new $c_T2(), "Asia/Vladivostok", _2$316);
    var _2$317 = $m_Lzonedb_java_tzdb$amepa$().Lzonedb_java_tzdb$amepa$__f_America_La_Paz;
    var $$x30 = $ct_T2__O__O__(new $c_T2(), "America/La_Paz", _2$317);
    var _2$318 = $m_Lzonedb_java_tzdb$antse$().Lzonedb_java_tzdb$antse$__f_Antarctica_Casey;
    var $$x29 = $ct_T2__O__O__(new $c_T2(), "Antarctica/Casey", _2$318);
    var _2$319 = $m_Lzonedb_java_tzdb$amero$().Lzonedb_java_tzdb$amero$__f_America_Matamoros;
    var $$x28 = $ct_T2__O__O__(new $c_T2(), "America/Matamoros", _2$319);
    var _2$320 = $m_Lzonedb_java_tzdb$amele$().Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem;
    var $$x27 = $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/New_Salem", _2$320);
    var _2$321 = $m_Lzonedb_java_tzdb$ausrt$().Lzonedb_java_tzdb$ausrt$__f_Australia_Perth;
    var $$x26 = $ct_T2__O__O__(new $c_T2(), "Australia/Perth", _2$321);
    var _2$322 = $m_Lzonedb_java_tzdb$ameib$().Lzonedb_java_tzdb$ameib$__f_America_Paramaribo;
    var $$x25 = $ct_T2__O__O__(new $c_T2(), "America/Paramaribo", _2$322);
    var _2$323 = $m_Lzonedb_java_tzdb$afrni$().Lzonedb_java_tzdb$afrni$__f_Africa_Tunis;
    var $$x24 = $ct_T2__O__O__(new $c_T2(), "Africa/Tunis", _2$323);
    var _2$324 = $m_Lzonedb_java_tzdb$asicu$().Lzonedb_java_tzdb$asicu$__f_Asia_Damascus;
    var $$x23 = $ct_T2__O__O__(new $c_T2(), "Asia/Damascus", _2$324);
    var _2$325 = $m_Lzonedb_java_tzdb$ameai$().Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain;
    var $$x22 = $ct_T2__O__O__(new $c_T2(), "America/Port_of_Spain", _2$325);
    var _2$326 = $m_Lzonedb_java_tzdb$eurli$().Lzonedb_java_tzdb$eurli$__f_Europe_Dublin;
    var $$x21 = $ct_T2__O__O__(new $c_T2(), "Europe/Dublin", _2$326);
    var _2$327 = $m_Lzonedb_java_tzdb$afrgo$().Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos;
    var $$x20 = $ct_T2__O__O__(new $c_T2(), "Africa/Lagos", _2$327);
    var _2$328 = $m_Lzonedb_java_tzdb$amenc$().Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco;
    var $$x19 = $ct_T2__O__O__(new $c_T2(), "America/Rio_Branco", _2$328);
    var _2$329 = $m_Lzonedb_java_tzdb$ameba$().Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay;
    var $$x18 = $ct_T2__O__O__(new $c_T2(), "America/Cambridge_Bay", _2$329);
    var _2$330 = $m_Lzonedb_java_tzdb$ameve$().Lzonedb_java_tzdb$ameve$__f_America_Rainy_River;
    var $$x17 = $ct_T2__O__O__(new $c_T2(), "America/Rainy_River", _2$330);
    var _2$331 = $m_Lzonedb_java_tzdb$eurrr$().Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra;
    var $$x16 = $ct_T2__O__O__(new $c_T2(), "Europe/Andorra", _2$331);
    var _2$332 = $m_Lzonedb_java_tzdb$afrcr$().Lzonedb_java_tzdb$afrcr$__f_Africa_Accra;
    var $$x15 = $ct_T2__O__O__(new $c_T2(), "Africa/Accra", _2$332);
    var _2$333 = $m_Lzonedb_java_tzdb$ameka$().Lzonedb_java_tzdb$ameka$__f_America_Atikokan;
    var $$x14 = $ct_T2__O__O__(new $c_T2(), "America/Atikokan", _2$333);
    var _2$334 = $m_Lzonedb_java_tzdb$eurna$().Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau;
    var $$x13 = $ct_T2__O__O__(new $c_T2(), "Europe/Chisinau", _2$334);
    var _2$335 = $m_Lzonedb_java_tzdb$asimb$().Lzonedb_java_tzdb$asimb$__f_Asia_Colombo;
    var $$x12 = $ct_T2__O__O__(new $c_T2(), "Asia/Colombo", _2$335);
    var _2$336 = $m_Lzonedb_java_tzdb$ameal$().Lzonedb_java_tzdb$ameal$__f_America_Guatemala;
    var $$x11 = $ct_T2__O__O__(new $c_T2(), "America/Guatemala", _2$336);
    var _2$337 = $m_Lzonedb_java_tzdb$ausan$().Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane;
    var $$x10 = $ct_T2__O__O__(new $c_T2(), "Australia/Brisbane", _2$337);
    var _2$338 = $m_Lzonedb_java_tzdb$eurda$().Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam;
    var $$x9 = $ct_T2__O__O__(new $c_T2(), "Europe/Amsterdam", _2$338);
    var _2$339 = $m_Lzonedb_java_tzdb$asiin$().Lzonedb_java_tzdb$asiin$__f_Asia_Kuching;
    var $$x8 = $ct_T2__O__O__(new $c_T2(), "Asia/Kuching", _2$339);
    var _2$340 = $m_Lzonedb_java_tzdb$asidy$().Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr;
    var $$x7 = $ct_T2__O__O__(new $c_T2(), "Asia/Anadyr", _2$340);
    var _2$341 = $m_Lzonedb_java_tzdb$eursl$().Lzonedb_java_tzdb$eursl$__f_Europe_Oslo;
    var $$x6 = $ct_T2__O__O__(new $c_T2(), "Europe/Oslo", _2$341);
    var _2$342 = $m_Lzonedb_java_tzdb$amelo$().Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon;
    var $$x5 = $ct_T2__O__O__(new $c_T2(), "America/Blanc-Sablon", _2$342);
    var _2$343 = $m_Lzonedb_java_tzdb$amecu$().Lzonedb_java_tzdb$amecu$__f_America_Cancun;
    var $$x4 = $ct_T2__O__O__(new $c_T2(), "America/Cancun", _2$343);
    var _2$344 = $m_Lzonedb_java_tzdb$atlro$().Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe;
    var $$x3 = $ct_T2__O__O__(new $c_T2(), "Atlantic/Faroe", _2$344);
    var _2$345 = $m_Lzonedb_java_tzdb$indve$().Lzonedb_java_tzdb$indve$__f_Indian_Maldives;
    var $$x2 = $ct_T2__O__O__(new $c_T2(), "Indian/Maldives", _2$345);
    var _2$346 = $m_Lzonedb_java_tzdb$amest$().Lzonedb_java_tzdb$amest$__f_America_Boa_Vista;
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "America/Boa_Vista", _2$346);
    var _2$347 = $m_Lzonedb_java_tzdb$ameep$().Lzonedb_java_tzdb$ameep$__f_America_Eirunepe;
    var fields = $$x348.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x347, $$x346, $$x345, $$x344, $$x343, $$x342, $$x341, $$x340, $$x339, $$x338, $$x337, $$x336, $$x335, $$x334, $$x333, $$x332, $$x331, $$x330, $$x329, $$x328, $$x327, $$x326, $$x325, $$x324, $$x323, $$x322, $$x321, $$x320, $$x319, $$x318, $$x317, $$x316, $$x315, $$x314, $$x313, $$x312, $$x311, $$x310, $$x309, $$x308, $$x307, $$x306, $$x305, $$x304, $$x303, $$x302, $$x301, $$x300, $$x299, $$x298, $$x297, $$x296, $$x295, $$x294, $$x293, $$x292, $$x291, $$x290, $$x289, $$x288, $$x287, $$x286, $$x285, $$x284, $$x283, $$x282, $$x281, $$x280, $$x279, $$x278, $$x277, $$x276, $$x275, $$x274, $$x273, $$x272, $$x271, $$x270, $$x269, $$x268, $$x267, $$x266, $$x265, $$x264, $$x263, $$x262, $$x261, $$x260, $$x259, $$x258, $$x257, $$x256, $$x255, $$x254, $$x253, $$x252, $$x251, $$x250, $$x249, $$x248, $$x247, $$x246, $$x245, $$x244, $$x243, $$x242, $$x241, $$x240, $$x239, $$x238, $$x237, $$x236, $$x235, $$x234, $$x233, $$x232, $$x231, $$x230, $$x229, $$x228, $$x227, $$x226, $$x225, $$x224, $$x223, $$x222, $$x221, $$x220, $$x219, $$x218, $$x217, $$x216, $$x215, $$x214, $$x213, $$x212, $$x211, $$x210, $$x209, $$x208, $$x207, $$x206, $$x205, $$x204, $$x203, $$x202, $$x201, $$x200, $$x199, $$x198, $$x197, $$x196, $$x195, $$x194, $$x193, $$x192, $$x191, $$x190, $$x189, $$x188, $$x187, $$x186, $$x185, $$x184, $$x183, $$x182, $$x181, $$x180, $$x179, $$x178, $$x177, $$x176, $$x175, $$x174, $$x173, $$x172, $$x171, $$x170, $$x169, $$x168, $$x167, $$x166, $$x165, $$x164, $$x163, $$x162, $$x161, $$x160, $$x159, $$x158, $$x157, $$x156, $$x155, $$x154, $$x153, $$x152, $$x151, $$x150, $$x149, $$x148, $$x147, $$x146, $$x145, $$x144, $$x143, $$x142, $$x141, $$x140, $$x139, $$x138, $$x137, $$x136, $$x135, $$x134, $$x133, $$x132, $$x131, $$x130, $$x129, $$x128, $$x127, $$x126, $$x125, $$x124, $$x123, $$x122, $$x121, $$x120, $$x119, $$x118, $$x117, $$x116, $$x115, $$x114, $$x113, $$x112, $$x111, $$x110, $$x109, $$x108, $$x107, $$x106, $$x105, $$x104, $$x103, $$x102, $$x101, $$x100, $$x99, $$x98, $$x97, $$x96, $$x95, $$x94, $$x93, $$x92, $$x91, $$x90, $$x89, $$x88, $$x87, $$x86, $$x85, $$x84, $$x83, $$x82, $$x81, $$x80, $$x79, $$x78, $$x77, $$x76, $$x75, $$x74, $$x73, $$x72, $$x71, $$x70, $$x69, $$x68, $$x67, $$x66, $$x65, $$x64, $$x63, $$x62, $$x61, $$x60, $$x59, $$x58, $$x57, $$x56, $$x55, $$x54, $$x53, $$x52, $$x51, $$x50, $$x49, $$x48, $$x47, $$x46, $$x45, $$x44, $$x43, $$x42, $$x41, $$x40, $$x39, $$x38, $$x37, $$x36, $$x35, $$x34, $$x33, $$x32, $$x31, $$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $$x24, $$x23, $$x22, $$x21, $$x20, $$x19, $$x18, $$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "America/Eirunepe", _2$347)]));
    this.Lzonedb_java_tzdb$__f_stdZones$lzy1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    this.Lzonedb_java_tzdb$__f_stdZonesbitmap$1 = true
  };
  return this.Lzonedb_java_tzdb$__f_stdZones$lzy1
});
$c_Lzonedb_java_tzdb$.prototype.zoneLinks__sci_Map = (function() {
  if ((!this.Lzonedb_java_tzdb$__f_zoneLinksbitmap$1)) {
    var this$207 = $m_s_Predef$().s_Predef$__f_Map;
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), "America/Cayman", "America/Panama"), $ct_T2__O__O__(new $c_T2(), "GMT", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/Universal", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Etc/Zulu", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Etc/Greenwich", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "US/Pacific-New", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "Africa/Asmera", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Timbuktu", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "America/Argentina/ComodRivadavia", "America/Argentina/Catamarca"), $ct_T2__O__O__(new $c_T2(), "America/Atka", "America/Adak"), $ct_T2__O__O__(new $c_T2(), "America/Buenos_Aires", "America/Argentina/Buenos_Aires"), $ct_T2__O__O__(new $c_T2(), "America/Catamarca", "America/Argentina/Catamarca"), $ct_T2__O__O__(new $c_T2(), "America/Coral_Harbour", "America/Atikokan"), $ct_T2__O__O__(new $c_T2(), "America/Cordoba", "America/Argentina/Cordoba"), $ct_T2__O__O__(new $c_T2(), "America/Ensenada", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "America/Fort_Wayne", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "America/Indianapolis", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "America/Jujuy", "America/Argentina/Jujuy"), $ct_T2__O__O__(new $c_T2(), "America/Knox_IN", "America/Indiana/Knox"), $ct_T2__O__O__(new $c_T2(), "America/Louisville", "America/Kentucky/Louisville"), $ct_T2__O__O__(new $c_T2(), "America/Mendoza", "America/Argentina/Mendoza"), $ct_T2__O__O__(new $c_T2(), "America/Montreal", "America/Toronto"), $ct_T2__O__O__(new $c_T2(), "America/Porto_Acre", "America/Rio_Branco"), $ct_T2__O__O__(new $c_T2(), "America/Rosario", "America/Argentina/Cordoba"), $ct_T2__O__O__(new $c_T2(), "America/Santa_Isabel", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "America/Shiprock", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "America/Virgin", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "Antarctica/South_Pole", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "Asia/Ashkhabad", "Asia/Ashgabat"), $ct_T2__O__O__(new $c_T2(), "Asia/Calcutta", "Asia/Kolkata"), $ct_T2__O__O__(new $c_T2(), "Asia/Chongqing", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Chungking", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Dacca", "Asia/Dhaka"), $ct_T2__O__O__(new $c_T2(), "Asia/Harbin", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Kashgar", "Asia/Urumqi"), $ct_T2__O__O__(new $c_T2(), "Asia/Katmandu", "Asia/Kathmandu"), $ct_T2__O__O__(new $c_T2(), "Asia/Macao", "Asia/Macau"), $ct_T2__O__O__(new $c_T2(), "Asia/Rangoon", "Asia/Yangon"), $ct_T2__O__O__(new $c_T2(), "Asia/Saigon", "Asia/Ho_Chi_Minh"), $ct_T2__O__O__(new $c_T2(), "Asia/Tel_Aviv", "Asia/Jerusalem"), $ct_T2__O__O__(new $c_T2(), "Asia/Thimbu", "Asia/Thimphu"), $ct_T2__O__O__(new $c_T2(), "Asia/Ujung_Pandang", "Asia/Makassar"), $ct_T2__O__O__(new $c_T2(), "Asia/Ulan_Bator", "Asia/Ulaanbaatar"), $ct_T2__O__O__(new $c_T2(), "Atlantic/Faeroe", "Atlantic/Faroe"), $ct_T2__O__O__(new $c_T2(), "Atlantic/Jan_Mayen", "Europe/Oslo"), $ct_T2__O__O__(new $c_T2(), "Australia/ACT", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/Canberra", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/LHI", "Australia/Lord_Howe"), $ct_T2__O__O__(new $c_T2(), "Australia/NSW", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/North", "Australia/Darwin"), $ct_T2__O__O__(new $c_T2(), "Australia/Queensland", "Australia/Brisbane"), $ct_T2__O__O__(new $c_T2(), "Australia/South", "Australia/Adelaide"), $ct_T2__O__O__(new $c_T2(), "Australia/Tasmania", "Australia/Hobart"), $ct_T2__O__O__(new $c_T2(), "Australia/Victoria", "Australia/Melbourne"), $ct_T2__O__O__(new $c_T2(), "Australia/West", "Australia/Perth"), $ct_T2__O__O__(new $c_T2(), "Australia/Yancowinna", "Australia/Broken_Hill"), $ct_T2__O__O__(new $c_T2(), "Brazil/Acre", "America/Rio_Branco"), $ct_T2__O__O__(new $c_T2(), "Brazil/DeNoronha", "America/Noronha"), $ct_T2__O__O__(new $c_T2(), "Brazil/East", "America/Sao_Paulo"), $ct_T2__O__O__(new $c_T2(), "Brazil/West", "America/Manaus"), $ct_T2__O__O__(new $c_T2(), "Canada/Atlantic", "America/Halifax"), $ct_T2__O__O__(new $c_T2(), "Canada/Central", "America/Winnipeg"), $ct_T2__O__O__(new $c_T2(), "Canada/Eastern", "America/Toronto"), $ct_T2__O__O__(new $c_T2(), "Canada/Mountain", "America/Edmonton"), $ct_T2__O__O__(new $c_T2(), "Canada/Newfoundland", "America/St_Johns"), $ct_T2__O__O__(new $c_T2(), "Canada/Pacific", "America/Vancouver"), $ct_T2__O__O__(new $c_T2(), "Canada/Saskatchewan", "America/Regina"), $ct_T2__O__O__(new $c_T2(), "Canada/Yukon", "America/Whitehorse"), $ct_T2__O__O__(new $c_T2(), "Chile/Continental", "America/Santiago"), $ct_T2__O__O__(new $c_T2(), "Chile/EasterIsland", "Pacific/Easter"), $ct_T2__O__O__(new $c_T2(), "Cuba", "America/Havana"), $ct_T2__O__O__(new $c_T2(), "Egypt", "Africa/Cairo"), $ct_T2__O__O__(new $c_T2(), "Eire", "Europe/Dublin"), $ct_T2__O__O__(new $c_T2(), "Etc/UCT", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Europe/Belfast", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Tiraspol", "Europe/Chisinau"), $ct_T2__O__O__(new $c_T2(), "GB", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "GB-Eire", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "GMT+0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "GMT-0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "GMT0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Greenwich", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Hongkong", "Asia/Hong_Kong"), $ct_T2__O__O__(new $c_T2(), "Iceland", "Atlantic/Reykjavik"), $ct_T2__O__O__(new $c_T2(), "Iran", "Asia/Tehran"), $ct_T2__O__O__(new $c_T2(), "Israel", "Asia/Jerusalem"), $ct_T2__O__O__(new $c_T2(), "Jamaica", "America/Jamaica"), $ct_T2__O__O__(new $c_T2(), "Japan", "Asia/Tokyo"), $ct_T2__O__O__(new $c_T2(), "Kwajalein", "Pacific/Kwajalein"), $ct_T2__O__O__(new $c_T2(), "Libya", "Africa/Tripoli"), $ct_T2__O__O__(new $c_T2(), "Mexico/BajaNorte", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "Mexico/BajaSur", "America/Mazatlan"), $ct_T2__O__O__(new $c_T2(), "Mexico/General", "America/Mexico_City"), $ct_T2__O__O__(new $c_T2(), "NZ", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "NZ-CHAT", "Pacific/Chatham"), $ct_T2__O__O__(new $c_T2(), "Navajo", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "PRC", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Pacific/Johnston", "Pacific/Honolulu"), $ct_T2__O__O__(new $c_T2(), "Pacific/Ponape", "Pacific/Pohnpei"), $ct_T2__O__O__(new $c_T2(), "Pacific/Samoa", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "Pacific/Truk", "Pacific/Chuuk"), $ct_T2__O__O__(new $c_T2(), "Pacific/Yap", "Pacific/Chuuk"), $ct_T2__O__O__(new $c_T2(), "Poland", "Europe/Warsaw"), $ct_T2__O__O__(new $c_T2(), "Portugal", "Europe/Lisbon"), $ct_T2__O__O__(new $c_T2(), "ROC", "Asia/Taipei"), $ct_T2__O__O__(new $c_T2(), "ROK", "Asia/Seoul"), $ct_T2__O__O__(new $c_T2(), "Singapore", "Asia/Singapore"), $ct_T2__O__O__(new $c_T2(), "Turkey", "Europe/Istanbul"), $ct_T2__O__O__(new $c_T2(), "UCT", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "US/Alaska", "America/Anchorage"), $ct_T2__O__O__(new $c_T2(), "US/Aleutian", "America/Adak"), $ct_T2__O__O__(new $c_T2(), "US/Arizona", "America/Phoenix"), $ct_T2__O__O__(new $c_T2(), "US/Central", "America/Chicago"), $ct_T2__O__O__(new $c_T2(), "US/East-Indiana", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "US/Eastern", "America/New_York"), $ct_T2__O__O__(new $c_T2(), "US/Hawaii", "Pacific/Honolulu"), $ct_T2__O__O__(new $c_T2(), "US/Indiana-Starke", "America/Indiana/Knox"), $ct_T2__O__O__(new $c_T2(), "US/Michigan", "America/Detroit"), $ct_T2__O__O__(new $c_T2(), "US/Mountain", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "US/Pacific", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "US/Samoa", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "UTC", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Universal", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "W-SU", "Europe/Moscow"), $ct_T2__O__O__(new $c_T2(), "Zulu", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Africa/Bamako", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Banjul", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Conakry", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Dakar", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Freetown", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Lome", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Nouakchott", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Ouagadougou", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Atlantic/St_Helena", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Addis_Ababa", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Asmara", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Dar_es_Salaam", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Djibouti", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Kampala", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Mogadishu", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Antananarivo", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Comoro", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Mayotte", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Blantyre", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Bujumbura", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Gaborone", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Harare", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Kigali", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Lubumbashi", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Lusaka", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Bangui", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Brazzaville", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Douala", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Kinshasa", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Libreville", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Luanda", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Malabo", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Niamey", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Porto-Novo", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Maseru", "Africa/Johannesburg"), $ct_T2__O__O__(new $c_T2(), "Africa/Mbabane", "Africa/Johannesburg"), $ct_T2__O__O__(new $c_T2(), "Pacific/Saipan", "Pacific/Guam"), $ct_T2__O__O__(new $c_T2(), "Antarctica/McMurdo", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "Pacific/Midway", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "Europe/Jersey", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Guernsey", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Isle_of_Man", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Mariehamn", "Europe/Helsinki"), $ct_T2__O__O__(new $c_T2(), "Europe/Busingen", "Europe/Zurich"), $ct_T2__O__O__(new $c_T2(), "Europe/Vatican", "Europe/Rome"), $ct_T2__O__O__(new $c_T2(), "Europe/San_Marino", "Europe/Rome"), $ct_T2__O__O__(new $c_T2(), "Europe/Vaduz", "Europe/Zurich"), $ct_T2__O__O__(new $c_T2(), "Arctic/Longyearbyen", "Europe/Oslo"), $ct_T2__O__O__(new $c_T2(), "Europe/Ljubljana", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Podgorica", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Sarajevo", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Skopje", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Zagreb", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Bratislava", "Europe/Prague"), $ct_T2__O__O__(new $c_T2(), "Asia/Istanbul", "Europe/Istanbul"), $ct_T2__O__O__(new $c_T2(), "Europe/Nicosia", "Asia/Nicosia"), $ct_T2__O__O__(new $c_T2(), "Asia/Bahrain", "Asia/Qatar"), $ct_T2__O__O__(new $c_T2(), "Asia/Aden", "Asia/Riyadh"), $ct_T2__O__O__(new $c_T2(), "Asia/Kuwait", "Asia/Riyadh"), $ct_T2__O__O__(new $c_T2(), "Asia/Phnom_Penh", "Asia/Bangkok"), $ct_T2__O__O__(new $c_T2(), "Asia/Vientiane", "Asia/Bangkok"), $ct_T2__O__O__(new $c_T2(), "Asia/Muscat", "Asia/Dubai"), $ct_T2__O__O__(new $c_T2(), "America/Aruba", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Lower_Princes", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Kralendijk", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Anguilla", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Antigua", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Dominica", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Grenada", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Guadeloupe", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Marigot", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Montserrat", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Barthelemy", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Kitts", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Lucia", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Thomas", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Vincent", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Tortola", "America/Port_of_Spain")]));
    this.Lzonedb_java_tzdb$__f_zoneLinks$lzy1 = this$207.from__sc_IterableOnce__sci_Map(elems);
    this.Lzonedb_java_tzdb$__f_zoneLinksbitmap$1 = true
  };
  return this.Lzonedb_java_tzdb$__f_zoneLinks$lzy1
});
var $d_Lzonedb_java_tzdb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$: 0
}, false, "zonedb.java.tzdb$", {
  Lzonedb_java_tzdb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$.prototype.$classData = $d_Lzonedb_java_tzdb$;
var $n_Lzonedb_java_tzdb$;
function $m_Lzonedb_java_tzdb$() {
  if ((!$n_Lzonedb_java_tzdb$)) {
    $n_Lzonedb_java_tzdb$ = new $c_Lzonedb_java_tzdb$()
  };
  return $n_Lzonedb_java_tzdb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrcr$() {
  this.Lzonedb_java_tzdb$afrcr$__f_Africa_Accra = null;
  $n_Lzonedb_java_tzdb$afrcr$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-52));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-52));
  var _2 = [[1918001, 0, (-52), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1918001, 0, (-52), 0], [1920245, 0, 0, 1200], [1920366, 0, 1200, 0], [1921244, 0, 0, 1200], [1921365, 0, 1200, 0], [1922244, 0, 0, 1200], [1922365, 0, 1200, 0], [1923244, 0, 0, 1200], [1923365, 0, 1200, 0], [1924245, 0, 0, 1200], [1924366, 0, 1200, 0], [1925244, 0, 0, 1200], [1925365, 0, 1200, 0], [1926244, 0, 0, 1200], [1926365, 0, 1200, 0], [1927244, 0, 0, 1200], [1927365, 0, 1200, 0], [1928245, 0, 0, 1200], [1928366, 0, 1200, 0], [1929244, 0, 0, 1200], [1929365, 0, 1200, 0], [1930244, 0, 0, 1200], [1930365, 0, 1200, 0], [1931244, 0, 0, 1200], [1931365, 0, 1200, 0], [1932245, 0, 0, 1200], [1932366, 0, 1200, 0], [1933244, 0, 0, 1200], [1933365, 0, 1200, 0], [1934244, 0, 0, 1200], [1934365, 0, 1200, 0], [1935244, 0, 0, 1200], [1935365, 0, 1200, 0], [1936245, 0, 0, 1200], [1936366, 0, 1200, 0], [1937244, 0, 0, 1200], [1937365, 0, 1200, 0], [1938244, 0, 0, 1200], [1938365, 0, 1200, 0], [1939244, 0, 0, 1200], [1939365, 0, 1200, 0], [1940245, 0, 0, 1200], [1940366, 0, 1200, 0], [1941244, 0, 0, 1200], [1941365, 0, 1200, 0], [1942244, 0, 0, 1200], [1942365, 0, 1200, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrcr$__f_Africa_Accra = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrcr$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrcr$.prototype.constructor = $c_Lzonedb_java_tzdb$afrcr$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrcr$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrcr$.prototype = $c_Lzonedb_java_tzdb$afrcr$.prototype;
var $d_Lzonedb_java_tzdb$afrcr$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrcr$: 0
}, false, "zonedb.java.tzdb$afrcr$", {
  Lzonedb_java_tzdb$afrcr$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrcr$.prototype.$classData = $d_Lzonedb_java_tzdb$afrcr$;
var $n_Lzonedb_java_tzdb$afrcr$;
function $m_Lzonedb_java_tzdb$afrcr$() {
  if ((!$n_Lzonedb_java_tzdb$afrcr$)) {
    $n_Lzonedb_java_tzdb$afrcr$ = new $c_Lzonedb_java_tzdb$afrcr$()
  };
  return $n_Lzonedb_java_tzdb$afrcr$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afren$() {
  this.Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena = null;
  $n_Lzonedb_java_tzdb$afren$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3612);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3612);
  var _2 = [[1912001, 0, 3612, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912001, 0, 3612, 3600], [1979287, 0, 3600, 7200], [1980068, 0, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afren$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afren$.prototype.constructor = $c_Lzonedb_java_tzdb$afren$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afren$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afren$.prototype = $c_Lzonedb_java_tzdb$afren$.prototype;
var $d_Lzonedb_java_tzdb$afren$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afren$: 0
}, false, "zonedb.java.tzdb$afren$", {
  Lzonedb_java_tzdb$afren$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afren$.prototype.$classData = $d_Lzonedb_java_tzdb$afren$;
var $n_Lzonedb_java_tzdb$afren$;
function $m_Lzonedb_java_tzdb$afren$() {
  if ((!$n_Lzonedb_java_tzdb$afren$)) {
    $n_Lzonedb_java_tzdb$afren$ = new $c_Lzonedb_java_tzdb$afren$()
  };
  return $n_Lzonedb_java_tzdb$afren$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrer$() {
  this.Lzonedb_java_tzdb$afrer$__f_Africa_Algiers = null;
  $n_Lzonedb_java_tzdb$afrer$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 732);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 732);
  var _2 = [[1891074, 60, 732, 561], [1911070, 0, 561, 0], [1940056, 7200, 0, 3600], [1946280, 0, 3600, 0], [1956029, 0, 0, 3600], [1963104, 0, 3600, 0], [1977293, 82800, 0, 3600], [1979299, 0, 3600, 0], [1981121, 0, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1891074, 60, 732, 561], [1911070, 0, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921173, 0, 3600, 0], [1939254, 82800, 0, 3600], [1939323, 3600, 3600, 0], [1940056, 7200, 0, 3600], [1944094, 7200, 3600, 7200], [1944282, 7200, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 3600, 7200, 3600], [1946280, 0, 3600, 0], [1956029, 0, 0, 3600], [1963104, 0, 3600, 0], [1971115, 82800, 0, 3600], [1971270, 0, 3600, 0], [1977126, 0, 0, 3600], [1978083, 3600, 3600, 7200], [1978265, 10800, 7200, 3600], [1979299, 0, 3600, 0], [1980116, 0, 0, 3600], [1980305, 7200, 3600, 0], [1981121, 0, 0, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrer$__f_Africa_Algiers = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrer$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrer$.prototype.constructor = $c_Lzonedb_java_tzdb$afrer$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrer$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrer$.prototype = $c_Lzonedb_java_tzdb$afrer$.prototype;
var $d_Lzonedb_java_tzdb$afrer$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrer$: 0
}, false, "zonedb.java.tzdb$afrer$", {
  Lzonedb_java_tzdb$afrer$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrer$.prototype.$classData = $d_Lzonedb_java_tzdb$afrer$;
var $n_Lzonedb_java_tzdb$afrer$;
function $m_Lzonedb_java_tzdb$afrer$() {
  if ((!$n_Lzonedb_java_tzdb$afrer$)) {
    $n_Lzonedb_java_tzdb$afrer$ = new $c_Lzonedb_java_tzdb$afrer$()
  };
  return $n_Lzonedb_java_tzdb$afrer$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrgo$() {
  this.Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos = null;
  $n_Lzonedb_java_tzdb$afrgo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 816);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 816);
  var _2 = [[1919244, 0, 816, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919244, 0, 816, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrgo$.prototype.constructor = $c_Lzonedb_java_tzdb$afrgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrgo$.prototype = $c_Lzonedb_java_tzdb$afrgo$.prototype;
var $d_Lzonedb_java_tzdb$afrgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrgo$: 0
}, false, "zonedb.java.tzdb$afrgo$", {
  Lzonedb_java_tzdb$afrgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrgo$.prototype.$classData = $d_Lzonedb_java_tzdb$afrgo$;
var $n_Lzonedb_java_tzdb$afrgo$;
function $m_Lzonedb_java_tzdb$afrgo$() {
  if ((!$n_Lzonedb_java_tzdb$afrgo$)) {
    $n_Lzonedb_java_tzdb$afrgo$ = new $c_Lzonedb_java_tzdb$afrgo$()
  };
  return $n_Lzonedb_java_tzdb$afrgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrir$() {
  this.Lzonedb_java_tzdb$afrir$__f_Africa_Cairo = null;
  $n_Lzonedb_java_tzdb$afrir$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 7509);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 7509);
  var _2 = [[1900274, 0, 7509, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900274, 0, 7509, 7200], [1940197, 0, 7200, 10800], [1940275, 0, 10800, 7200], [1941105, 0, 7200, 10800], [1941259, 0, 10800, 7200], [1942091, 0, 7200, 10800], [1942300, 0, 10800, 7200], [1943091, 0, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967274, 10800, 10800, 7200], [1968122, 3600, 7200, 10800], [1968275, 10800, 10800, 7200], [1969121, 3600, 7200, 10800], [1969274, 10800, 10800, 7200], [1970121, 3600, 7200, 10800], [1970274, 10800, 10800, 7200], [1971121, 3600, 7200, 10800], [1971274, 10800, 10800, 7200], [1972122, 3600, 7200, 10800], [1972275, 10800, 10800, 7200], [1973121, 3600, 7200, 10800], [1973274, 10800, 10800, 7200], [1974121, 3600, 7200, 10800], [1974274, 10800, 10800, 7200], [1975121, 3600, 7200, 10800], [1975274, 10800, 10800, 7200], [1976122, 3600, 7200, 10800], [1976275, 10800, 10800, 7200], [1977121, 3600, 7200, 10800], [1977274, 10800, 10800, 7200], [1978121, 3600, 7200, 10800], [1978274, 10800, 10800, 7200], [1979121, 3600, 7200, 10800], [1979274, 10800, 10800, 7200], [1980122, 3600, 7200, 10800], [1980275, 10800, 10800, 7200], [1981121, 3600, 7200, 10800], [1981274, 10800, 10800, 7200], [1982206, 3600, 7200, 10800], [1982274, 10800, 10800, 7200], [1983193, 3600, 7200, 10800], [1983274, 10800, 10800, 7200], [1984122, 3600, 7200, 10800], [1984275, 10800, 10800, 7200], [1985121, 3600, 7200, 10800], [1985274, 10800, 10800, 7200], [1986121, 3600, 7200, 10800], [1986274, 10800, 10800, 7200], [1987121, 3600, 7200, 10800], [1987274, 10800, 10800, 7200], [1988122, 3600, 7200, 10800], [1988275, 10800, 10800, 7200], [1989126, 3600, 7200, 10800], [1989274, 10800, 10800, 7200], [1990121, 3600, 7200, 10800], [1990274, 10800, 10800, 7200], [1991121, 3600, 7200, 10800], [1991274, 10800, 10800, 7200], [1992122, 3600, 7200, 10800], [1992275, 10800, 10800, 7200], [1993121, 3600, 7200, 10800], [1993274, 10800, 10800, 7200], [1994121, 3600, 7200, 10800], [1994274, 10800, 10800, 7200], [1995118, 0, 7200, 10800], [1995272, 0, 10800, 7200], [1996117, 0, 7200, 10800], [1996271, 0, 10800, 7200], [1997115, 0, 7200, 10800], [1997269, 0, 10800, 7200], [1998114, 0, 7200, 10800], [1998268, 0, 10800, 7200], [1999120, 0, 7200, 10800], [1999274, 0, 10800, 7200], [2000119, 0, 7200, 10800], [2000273, 0, 10800, 7200], [2001117, 0, 7200, 10800], [2001271, 0, 10800, 7200], [2002116, 0, 7200, 10800], [2002270, 0, 10800, 7200], [2003115, 0, 7200, 10800], [2003269, 0, 10800, 7200], [2004121, 0, 7200, 10800], [2004275, 0, 10800, 7200], [2005119, 0, 7200, 10800], [2005273, 0, 10800, 7200], [2006118, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007117, 0, 7200, 10800], [2007250, 0, 10800, 7200], [2008116, 0, 7200, 10800], [2008242, 0, 10800, 7200], [2009114, 0, 7200, 10800], [2009233, 0, 10800, 7200], [2010120, 0, 7200, 10800], [2010223, 0, 10800, 7200], [2010253, 0, 7200, 10800], [2010274, 0, 10800, 7200], [2014136, 0, 7200, 10800], [2014178, 0, 10800, 7200], [2014213, 0, 7200, 10800], [2014269, 0, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrir$__f_Africa_Cairo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrir$.prototype.constructor = $c_Lzonedb_java_tzdb$afrir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrir$.prototype = $c_Lzonedb_java_tzdb$afrir$.prototype;
var $d_Lzonedb_java_tzdb$afrir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrir$: 0
}, false, "zonedb.java.tzdb$afrir$", {
  Lzonedb_java_tzdb$afrir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrir$.prototype.$classData = $d_Lzonedb_java_tzdb$afrir$;
var $n_Lzonedb_java_tzdb$afrir$;
function $m_Lzonedb_java_tzdb$afrir$() {
  if ((!$n_Lzonedb_java_tzdb$afrir$)) {
    $n_Lzonedb_java_tzdb$afrir$ = new $c_Lzonedb_java_tzdb$afrir$()
  };
  return $n_Lzonedb_java_tzdb$afrir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afriu$() {
  this.Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun = null;
  $n_Lzonedb_java_tzdb$afriu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-3168));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-3168));
  var _2 = [[1934001, 0, (-3168), (-3600)], [1976105, 0, (-3600), 0], [2018301, 7200, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1934001, 0, (-3168), (-3600)], [1976105, 0, (-3600), 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [2008153, 0, 0, 3600], [2008245, 0, 3600, 0], [2009152, 0, 0, 3600], [2009233, 0, 3600, 0], [2010122, 0, 0, 3600], [2010220, 0, 3600, 0], [2011093, 0, 0, 3600], [2011212, 0, 3600, 0], [2012120, 7200, 0, 3600], [2012202, 10800, 3600, 0], [2012233, 7200, 0, 3600], [2012274, 10800, 3600, 0], [2013118, 7200, 0, 3600], [2013188, 10800, 3600, 0], [2013222, 7200, 0, 3600], [2013300, 10800, 3600, 0], [2014089, 7200, 0, 3600], [2014179, 10800, 3600, 0], [2014214, 7200, 0, 3600], [2014299, 10800, 3600, 0], [2015088, 7200, 0, 3600], [2015165, 10800, 3600, 0], [2015200, 7200, 0, 3600], [2015298, 10800, 3600, 0], [2016087, 7200, 0, 3600], [2016157, 10800, 3600, 0], [2016192, 7200, 0, 3600], [2016304, 10800, 3600, 0], [2017085, 7200, 0, 3600], [2017141, 10800, 3600, 0], [2017183, 7200, 0, 3600], [2017302, 10800, 3600, 0], [2018084, 7200, 0, 3600], [2018133, 10800, 3600, 0], [2018168, 7200, 0, 3600], [2019125, 10800, 3600, 0], [2019160, 7200, 0, 3600], [2020110, 10800, 3600, 0], [2020145, 7200, 0, 3600], [2021101, 10800, 3600, 0], [2021136, 7200, 0, 3600], [2022086, 10800, 3600, 0], [2022128, 7200, 0, 3600], [2023078, 10800, 3600, 0], [2023113, 7200, 0, 3600], [2024070, 10800, 3600, 0], [2024105, 7200, 0, 3600], [2025054, 10800, 3600, 0], [2025096, 7200, 0, 3600], [2026046, 10800, 3600, 0], [2026081, 7200, 0, 3600], [2027038, 10800, 3600, 0], [2027073, 7200, 0, 3600], [2028023, 10800, 3600, 0], [2028058, 7200, 0, 3600], [2029014, 10800, 3600, 0], [2029049, 7200, 0, 3600], [2029364, 10800, 3600, 0], [2030041, 7200, 0, 3600], [2030356, 10800, 3600, 0], [2031026, 7200, 0, 3600], [2031348, 10800, 3600, 0], [2032018, 7200, 0, 3600], [2032333, 10800, 3600, 0], [2033009, 7200, 0, 3600], [2033324, 10800, 3600, 0], [2033359, 7200, 0, 3600], [2034309, 10800, 3600, 0], [2034351, 7200, 0, 3600], [2035301, 10800, 3600, 0], [2035336, 7200, 0, 3600], [2036293, 10800, 3600, 0], [2036328, 7200, 0, 3600], [2037277, 10800, 3600, 0], [2037319, 7200, 0, 3600], [2038269, 10800, 3600, 0], [2038304, 7200, 0, 3600], [2039261, 10800, 3600, 0], [2039296, 7200, 0, 3600], [2040246, 10800, 3600, 0], [2040288, 7200, 0, 3600], [2041237, 10800, 3600, 0], [2041272, 7200, 0, 3600], [2042222, 10800, 3600, 0], [2042264, 7200, 0, 3600], [2043214, 10800, 3600, 0], [2043249, 7200, 0, 3600], [2044206, 10800, 3600, 0], [2044241, 7200, 0, 3600], [2045190, 10800, 3600, 0], [2045232, 7200, 0, 3600], [2046182, 10800, 3600, 0], [2046217, 7200, 0, 3600], [2047174, 10800, 3600, 0], [2047209, 7200, 0, 3600], [2048159, 10800, 3600, 0], [2048201, 7200, 0, 3600], [2049150, 10800, 3600, 0], [2049185, 7200, 0, 3600], [2050135, 10800, 3600, 0], [2050177, 7200, 0, 3600], [2051127, 10800, 3600, 0], [2051162, 7200, 0, 3600], [2052119, 10800, 3600, 0], [2052154, 7200, 0, 3600], [2053103, 10800, 3600, 0], [2053145, 7200, 0, 3600], [2054095, 10800, 3600, 0], [2054130, 7200, 0, 3600], [2055087, 10800, 3600, 0], [2055122, 7200, 0, 3600], [2056072, 10800, 3600, 0], [2056114, 7200, 0, 3600], [2057063, 10800, 3600, 0], [2057098, 7200, 0, 3600], [2058048, 10800, 3600, 0], [2058090, 7200, 0, 3600], [2059040, 10800, 3600, 0], [2059075, 7200, 0, 3600], [2060032, 10800, 3600, 0], [2060067, 7200, 0, 3600], [2061016, 10800, 3600, 0], [2061058, 7200, 0, 3600], [2062008, 10800, 3600, 0], [2062043, 7200, 0, 3600], [2062365, 10800, 3600, 0], [2063035, 7200, 0, 3600], [2063350, 10800, 3600, 0], [2064020, 7200, 0, 3600], [2064342, 10800, 3600, 0], [2065011, 7200, 0, 3600], [2065326, 10800, 3600, 0], [2066003, 7200, 0, 3600], [2066318, 10800, 3600, 0], [2066353, 7200, 0, 3600], [2067310, 10800, 3600, 0], [2067345, 7200, 0, 3600], [2068295, 10800, 3600, 0], [2068337, 7200, 0, 3600], [2069286, 10800, 3600, 0], [2069321, 7200, 0, 3600], [2070278, 10800, 3600, 0], [2070313, 7200, 0, 3600], [2071263, 10800, 3600, 0], [2071298, 7200, 0, 3600], [2072255, 10800, 3600, 0], [2072290, 7200, 0, 3600], [2073239, 10800, 3600, 0], [2073281, 7200, 0, 3600], [2074231, 10800, 3600, 0], [2074266, 7200, 0, 3600], [2075223, 10800, 3600, 0], [2075258, 7200, 0, 3600], [2076208, 10800, 3600, 0], [2076250, 7200, 0, 3600], [2077199, 10800, 3600, 0], [2077234, 7200, 0, 3600], [2078191, 10800, 3600, 0], [2078226, 7200, 0, 3600], [2079176, 10800, 3600, 0], [2079211, 7200, 0, 3600], [2080168, 10800, 3600, 0], [2080203, 7200, 0, 3600], [2081152, 10800, 3600, 0], [2081194, 7200, 0, 3600], [2082144, 10800, 3600, 0], [2082179, 7200, 0, 3600], [2083136, 10800, 3600, 0], [2083171, 7200, 0, 3600], [2084121, 10800, 3600, 0], [2084163, 7200, 0, 3600], [2085112, 10800, 3600, 0], [2085147, 7200, 0, 3600], [2086104, 10800, 3600, 0], [2086139, 7200, 0, 3600], [2087089, 10800, 3600, 0], [2087124, 7200, 0, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afriu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afriu$.prototype.constructor = $c_Lzonedb_java_tzdb$afriu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afriu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afriu$.prototype = $c_Lzonedb_java_tzdb$afriu$.prototype;
var $d_Lzonedb_java_tzdb$afriu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afriu$: 0
}, false, "zonedb.java.tzdb$afriu$", {
  Lzonedb_java_tzdb$afriu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afriu$.prototype.$classData = $d_Lzonedb_java_tzdb$afriu$;
var $n_Lzonedb_java_tzdb$afriu$;
function $m_Lzonedb_java_tzdb$afriu$() {
  if ((!$n_Lzonedb_java_tzdb$afriu$)) {
    $n_Lzonedb_java_tzdb$afriu$ = new $c_Lzonedb_java_tzdb$afriu$()
  };
  return $n_Lzonedb_java_tzdb$afriu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrja$() {
  this.Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan = null;
  $n_Lzonedb_java_tzdb$afrja$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-968));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-968));
  var _2 = [[1912001, 0, (-968), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912001, 0, (-968), 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrja$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrja$.prototype.constructor = $c_Lzonedb_java_tzdb$afrja$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrja$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrja$.prototype = $c_Lzonedb_java_tzdb$afrja$.prototype;
var $d_Lzonedb_java_tzdb$afrja$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrja$: 0
}, false, "zonedb.java.tzdb$afrja$", {
  Lzonedb_java_tzdb$afrja$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrja$.prototype.$classData = $d_Lzonedb_java_tzdb$afrja$;
var $n_Lzonedb_java_tzdb$afrja$;
function $m_Lzonedb_java_tzdb$afrja$() {
  if ((!$n_Lzonedb_java_tzdb$afrja$)) {
    $n_Lzonedb_java_tzdb$afrja$ = new $c_Lzonedb_java_tzdb$afrja$()
  };
  return $n_Lzonedb_java_tzdb$afrja$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrnc$() {
  this.Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca = null;
  $n_Lzonedb_java_tzdb$afrnc$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-1820));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-1820));
  var _2 = [[1913299, 0, (-1820), 0], [1984076, 0, 0, 3600], [1986001, 0, 3600, 0], [2018301, 7200, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1913299, 0, (-1820), 0], [1939255, 0, 0, 3600], [1939323, 0, 3600, 0], [1940056, 0, 0, 3600], [1945322, 0, 3600, 0], [1950162, 0, 0, 3600], [1950302, 0, 3600, 0], [1967154, 43200, 0, 3600], [1967274, 0, 3600, 0], [1974175, 0, 0, 3600], [1974244, 0, 3600, 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [1984076, 0, 0, 3600], [1986001, 0, 3600, 0], [2008153, 0, 0, 3600], [2008245, 0, 3600, 0], [2009152, 0, 0, 3600], [2009233, 0, 3600, 0], [2010122, 0, 0, 3600], [2010220, 0, 3600, 0], [2011093, 0, 0, 3600], [2011212, 0, 3600, 0], [2012120, 7200, 0, 3600], [2012202, 10800, 3600, 0], [2012233, 7200, 0, 3600], [2012274, 10800, 3600, 0], [2013118, 7200, 0, 3600], [2013188, 10800, 3600, 0], [2013222, 7200, 0, 3600], [2013300, 10800, 3600, 0], [2014089, 7200, 0, 3600], [2014179, 10800, 3600, 0], [2014214, 7200, 0, 3600], [2014299, 10800, 3600, 0], [2015088, 7200, 0, 3600], [2015165, 10800, 3600, 0], [2015200, 7200, 0, 3600], [2015298, 10800, 3600, 0], [2016087, 7200, 0, 3600], [2016157, 10800, 3600, 0], [2016192, 7200, 0, 3600], [2016304, 10800, 3600, 0], [2017085, 7200, 0, 3600], [2017141, 10800, 3600, 0], [2017183, 7200, 0, 3600], [2017302, 10800, 3600, 0], [2018084, 7200, 0, 3600], [2018133, 10800, 3600, 0], [2018168, 7200, 0, 3600], [2019125, 10800, 3600, 0], [2019160, 7200, 0, 3600], [2020110, 10800, 3600, 0], [2020145, 7200, 0, 3600], [2021101, 10800, 3600, 0], [2021136, 7200, 0, 3600], [2022086, 10800, 3600, 0], [2022128, 7200, 0, 3600], [2023078, 10800, 3600, 0], [2023113, 7200, 0, 3600], [2024070, 10800, 3600, 0], [2024105, 7200, 0, 3600], [2025054, 10800, 3600, 0], [2025096, 7200, 0, 3600], [2026046, 10800, 3600, 0], [2026081, 7200, 0, 3600], [2027038, 10800, 3600, 0], [2027073, 7200, 0, 3600], [2028023, 10800, 3600, 0], [2028058, 7200, 0, 3600], [2029014, 10800, 3600, 0], [2029049, 7200, 0, 3600], [2029364, 10800, 3600, 0], [2030041, 7200, 0, 3600], [2030356, 10800, 3600, 0], [2031026, 7200, 0, 3600], [2031348, 10800, 3600, 0], [2032018, 7200, 0, 3600], [2032333, 10800, 3600, 0], [2033009, 7200, 0, 3600], [2033324, 10800, 3600, 0], [2033359, 7200, 0, 3600], [2034309, 10800, 3600, 0], [2034351, 7200, 0, 3600], [2035301, 10800, 3600, 0], [2035336, 7200, 0, 3600], [2036293, 10800, 3600, 0], [2036328, 7200, 0, 3600], [2037277, 10800, 3600, 0], [2037319, 7200, 0, 3600], [2038269, 10800, 3600, 0], [2038304, 7200, 0, 3600], [2039261, 10800, 3600, 0], [2039296, 7200, 0, 3600], [2040246, 10800, 3600, 0], [2040288, 7200, 0, 3600], [2041237, 10800, 3600, 0], [2041272, 7200, 0, 3600], [2042222, 10800, 3600, 0], [2042264, 7200, 0, 3600], [2043214, 10800, 3600, 0], [2043249, 7200, 0, 3600], [2044206, 10800, 3600, 0], [2044241, 7200, 0, 3600], [2045190, 10800, 3600, 0], [2045232, 7200, 0, 3600], [2046182, 10800, 3600, 0], [2046217, 7200, 0, 3600], [2047174, 10800, 3600, 0], [2047209, 7200, 0, 3600], [2048159, 10800, 3600, 0], [2048201, 7200, 0, 3600], [2049150, 10800, 3600, 0], [2049185, 7200, 0, 3600], [2050135, 10800, 3600, 0], [2050177, 7200, 0, 3600], [2051127, 10800, 3600, 0], [2051162, 7200, 0, 3600], [2052119, 10800, 3600, 0], [2052154, 7200, 0, 3600], [2053103, 10800, 3600, 0], [2053145, 7200, 0, 3600], [2054095, 10800, 3600, 0], [2054130, 7200, 0, 3600], [2055087, 10800, 3600, 0], [2055122, 7200, 0, 3600], [2056072, 10800, 3600, 0], [2056114, 7200, 0, 3600], [2057063, 10800, 3600, 0], [2057098, 7200, 0, 3600], [2058048, 10800, 3600, 0], [2058090, 7200, 0, 3600], [2059040, 10800, 3600, 0], [2059075, 7200, 0, 3600], [2060032, 10800, 3600, 0], [2060067, 7200, 0, 3600], [2061016, 10800, 3600, 0], [2061058, 7200, 0, 3600], [2062008, 10800, 3600, 0], [2062043, 7200, 0, 3600], [2062365, 10800, 3600, 0], [2063035, 7200, 0, 3600], [2063350, 10800, 3600, 0], [2064020, 7200, 0, 3600], [2064342, 10800, 3600, 0], [2065011, 7200, 0, 3600], [2065326, 10800, 3600, 0], [2066003, 7200, 0, 3600], [2066318, 10800, 3600, 0], [2066353, 7200, 0, 3600], [2067310, 10800, 3600, 0], [2067345, 7200, 0, 3600], [2068295, 10800, 3600, 0], [2068337, 7200, 0, 3600], [2069286, 10800, 3600, 0], [2069321, 7200, 0, 3600], [2070278, 10800, 3600, 0], [2070313, 7200, 0, 3600], [2071263, 10800, 3600, 0], [2071298, 7200, 0, 3600], [2072255, 10800, 3600, 0], [2072290, 7200, 0, 3600], [2073239, 10800, 3600, 0], [2073281, 7200, 0, 3600], [2074231, 10800, 3600, 0], [2074266, 7200, 0, 3600], [2075223, 10800, 3600, 0], [2075258, 7200, 0, 3600], [2076208, 10800, 3600, 0], [2076250, 7200, 0, 3600], [2077199, 10800, 3600, 0], [2077234, 7200, 0, 3600], [2078191, 10800, 3600, 0], [2078226, 7200, 0, 3600], [2079176, 10800, 3600, 0], [2079211, 7200, 0, 3600], [2080168, 10800, 3600, 0], [2080203, 7200, 0, 3600], [2081152, 10800, 3600, 0], [2081194, 7200, 0, 3600], [2082144, 10800, 3600, 0], [2082179, 7200, 0, 3600], [2083136, 10800, 3600, 0], [2083171, 7200, 0, 3600], [2084121, 10800, 3600, 0], [2084163, 7200, 0, 3600], [2085112, 10800, 3600, 0], [2085147, 7200, 0, 3600], [2086104, 10800, 3600, 0], [2086139, 7200, 0, 3600], [2087089, 10800, 3600, 0], [2087124, 7200, 0, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrnc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrnc$.prototype.constructor = $c_Lzonedb_java_tzdb$afrnc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrnc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrnc$.prototype = $c_Lzonedb_java_tzdb$afrnc$.prototype;
var $d_Lzonedb_java_tzdb$afrnc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrnc$: 0
}, false, "zonedb.java.tzdb$afrnc$", {
  Lzonedb_java_tzdb$afrnc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrnc$.prototype.$classData = $d_Lzonedb_java_tzdb$afrnc$;
var $n_Lzonedb_java_tzdb$afrnc$;
function $m_Lzonedb_java_tzdb$afrnc$() {
  if ((!$n_Lzonedb_java_tzdb$afrnc$)) {
    $n_Lzonedb_java_tzdb$afrnc$ = new $c_Lzonedb_java_tzdb$afrnc$()
  };
  return $n_Lzonedb_java_tzdb$afrnc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrni$() {
  this.Lzonedb_java_tzdb$afrni$__f_Africa_Tunis = null;
  $n_Lzonedb_java_tzdb$afrni$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 2444);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 2444);
  var _2 = [[1881132, 0, 2444, 561], [1911070, 0, 561, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1881132, 0, 2444, 561], [1911070, 0, 561, 3600], [1939105, 82800, 3600, 7200], [1939323, 0, 7200, 3600], [1940056, 82800, 3600, 7200], [1941279, 0, 7200, 3600], [1942068, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943107, 7200, 7200, 3600], [1943115, 7200, 3600, 7200], [1943277, 7200, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 0, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 0, 7200, 3600], [1977120, 0, 3600, 7200], [1977267, 3600, 7200, 3600], [1978121, 0, 3600, 7200], [1978274, 3600, 7200, 3600], [1988153, 0, 3600, 7200], [1988269, 3600, 7200, 3600], [1989085, 0, 3600, 7200], [1989267, 3600, 7200, 3600], [1990121, 0, 3600, 7200], [1990273, 3600, 7200, 3600], [2005121, 0, 3600, 7200], [2005273, 7200, 7200, 3600], [2006085, 7200, 3600, 7200], [2006302, 10800, 7200, 3600], [2007084, 7200, 3600, 7200], [2007301, 10800, 7200, 3600], [2008090, 7200, 3600, 7200], [2008300, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrni$__f_Africa_Tunis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrni$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrni$.prototype.constructor = $c_Lzonedb_java_tzdb$afrni$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrni$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrni$.prototype = $c_Lzonedb_java_tzdb$afrni$.prototype;
var $d_Lzonedb_java_tzdb$afrni$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrni$: 0
}, false, "zonedb.java.tzdb$afrni$", {
  Lzonedb_java_tzdb$afrni$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrni$.prototype.$classData = $d_Lzonedb_java_tzdb$afrni$;
var $n_Lzonedb_java_tzdb$afrni$;
function $m_Lzonedb_java_tzdb$afrni$() {
  if ((!$n_Lzonedb_java_tzdb$afrni$)) {
    $n_Lzonedb_java_tzdb$afrni$ = new $c_Lzonedb_java_tzdb$afrni$()
  };
  return $n_Lzonedb_java_tzdb$afrni$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrob$() {
  this.Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi = null;
  $n_Lzonedb_java_tzdb$afrob$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8836);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8836);
  var _2 = [[1928183, 0, 8836, 10800], [1930001, 0, 10800, 9000], [1940001, 0, 9000, 9900], [1960001, 0, 9900, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1928183, 0, 8836, 10800], [1930001, 0, 10800, 9000], [1940001, 0, 9000, 9900], [1960001, 0, 9900, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrob$.prototype.constructor = $c_Lzonedb_java_tzdb$afrob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrob$.prototype = $c_Lzonedb_java_tzdb$afrob$.prototype;
var $d_Lzonedb_java_tzdb$afrob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrob$: 0
}, false, "zonedb.java.tzdb$afrob$", {
  Lzonedb_java_tzdb$afrob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrob$.prototype.$classData = $d_Lzonedb_java_tzdb$afrob$;
var $n_Lzonedb_java_tzdb$afrob$;
function $m_Lzonedb_java_tzdb$afrob$() {
  if ((!$n_Lzonedb_java_tzdb$afrob$)) {
    $n_Lzonedb_java_tzdb$afrob$ = new $c_Lzonedb_java_tzdb$afrob$()
  };
  return $n_Lzonedb_java_tzdb$afrob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afroe$() {
  this.Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek = null;
  $n_Lzonedb_java_tzdb$afroe$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 4104);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 4104);
  var _2 = [[1892039, 0, 4104, 5400], [1903060, 0, 5400, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1892039, 0, 4104, 5400], [1903060, 0, 5400, 7200], [1942263, 7200, 7200, 10800], [1943080, 7200, 10800, 7200], [1994080, 0, 7200, 3600], [1994247, 7200, 3600, 7200], [1995092, 7200, 7200, 3600], [1995246, 7200, 3600, 7200], [1996098, 7200, 7200, 3600], [1996245, 7200, 3600, 7200], [1997096, 7200, 7200, 3600], [1997250, 7200, 3600, 7200], [1998095, 7200, 7200, 3600], [1998249, 7200, 3600, 7200], [1999094, 7200, 7200, 3600], [1999248, 7200, 3600, 7200], [2000093, 7200, 7200, 3600], [2000247, 7200, 3600, 7200], [2001091, 7200, 7200, 3600], [2001245, 7200, 3600, 7200], [2002097, 7200, 7200, 3600], [2002244, 7200, 3600, 7200], [2003096, 7200, 7200, 3600], [2003250, 7200, 3600, 7200], [2004095, 7200, 7200, 3600], [2004249, 7200, 3600, 7200], [2005093, 7200, 7200, 3600], [2005247, 7200, 3600, 7200], [2006092, 7200, 7200, 3600], [2006246, 7200, 3600, 7200], [2007091, 7200, 7200, 3600], [2007245, 7200, 3600, 7200], [2008097, 7200, 7200, 3600], [2008251, 7200, 3600, 7200], [2009095, 7200, 7200, 3600], [2009249, 7200, 3600, 7200], [2010094, 7200, 7200, 3600], [2010248, 7200, 3600, 7200], [2011093, 7200, 7200, 3600], [2011247, 7200, 3600, 7200], [2012092, 7200, 7200, 3600], [2012246, 7200, 3600, 7200], [2013097, 7200, 7200, 3600], [2013244, 7200, 3600, 7200], [2014096, 7200, 7200, 3600], [2014250, 7200, 3600, 7200], [2015095, 7200, 7200, 3600], [2015249, 7200, 3600, 7200], [2016094, 7200, 7200, 3600], [2016248, 7200, 3600, 7200], [2017092, 7200, 7200, 3600], [2017246, 7200, 3600, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afroe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afroe$.prototype.constructor = $c_Lzonedb_java_tzdb$afroe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afroe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afroe$.prototype = $c_Lzonedb_java_tzdb$afroe$.prototype;
var $d_Lzonedb_java_tzdb$afroe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afroe$: 0
}, false, "zonedb.java.tzdb$afroe$", {
  Lzonedb_java_tzdb$afroe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afroe$.prototype.$classData = $d_Lzonedb_java_tzdb$afroe$;
var $n_Lzonedb_java_tzdb$afroe$;
function $m_Lzonedb_java_tzdb$afroe$() {
  if ((!$n_Lzonedb_java_tzdb$afroe$)) {
    $n_Lzonedb_java_tzdb$afroe$ = new $c_Lzonedb_java_tzdb$afroe$()
  };
  return $n_Lzonedb_java_tzdb$afroe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrol$() {
  this.Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli = null;
  $n_Lzonedb_java_tzdb$afrol$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3164);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3164);
  var _2 = [[1920001, 0, 3164, 3600], [1959001, 0, 3600, 7200], [1982001, 0, 7200, 3600], [1990124, 0, 3600, 7200], [1996274, 0, 7200, 3600], [1997276, 82800, 3600, 7200], [2012315, 7200, 7200, 3600], [2013298, 3600, 3600, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920001, 0, 3164, 3600], [1951287, 7200, 3600, 7200], [1952001, 0, 7200, 3600], [1953282, 7200, 3600, 7200], [1954001, 0, 7200, 3600], [1955273, 0, 3600, 7200], [1956001, 0, 7200, 3600], [1959001, 0, 3600, 7200], [1982001, 0, 7200, 3600], [1982091, 0, 3600, 7200], [1982274, 0, 7200, 3600], [1983091, 0, 3600, 7200], [1983274, 0, 7200, 3600], [1984092, 0, 3600, 7200], [1984275, 0, 7200, 3600], [1985096, 0, 3600, 7200], [1985274, 0, 7200, 3600], [1986094, 0, 3600, 7200], [1986276, 0, 7200, 3600], [1987091, 0, 3600, 7200], [1987274, 0, 7200, 3600], [1988092, 0, 3600, 7200], [1988275, 0, 7200, 3600], [1989091, 0, 3600, 7200], [1989274, 0, 7200, 3600], [1990124, 0, 3600, 7200], [1996274, 0, 7200, 3600], [1997094, 0, 3600, 7200], [2012315, 7200, 7200, 3600], [2013088, 3600, 3600, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrol$.prototype.constructor = $c_Lzonedb_java_tzdb$afrol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrol$.prototype = $c_Lzonedb_java_tzdb$afrol$.prototype;
var $d_Lzonedb_java_tzdb$afrol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrol$: 0
}, false, "zonedb.java.tzdb$afrol$", {
  Lzonedb_java_tzdb$afrol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrol$.prototype.$classData = $d_Lzonedb_java_tzdb$afrol$;
var $n_Lzonedb_java_tzdb$afrol$;
function $m_Lzonedb_java_tzdb$afrol$() {
  if ((!$n_Lzonedb_java_tzdb$afrol$)) {
    $n_Lzonedb_java_tzdb$afrol$ = new $c_Lzonedb_java_tzdb$afrol$()
  };
  return $n_Lzonedb_java_tzdb$afrol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrom$() {
  this.Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome = null;
  $n_Lzonedb_java_tzdb$afrom$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 1616);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 1616);
  var _2 = [[1884001, 0, 1616, (-2205)], [1911365, 84195, (-2205), 0], [2018001, 3600, 0, 3600], [2019001, 7200, 3600, 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, 1616, (-2205)], [1911365, 84195, (-2205), 0], [2018001, 3600, 0, 3600], [2019001, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrom$.prototype.constructor = $c_Lzonedb_java_tzdb$afrom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrom$.prototype = $c_Lzonedb_java_tzdb$afrom$.prototype;
var $d_Lzonedb_java_tzdb$afrom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrom$: 0
}, false, "zonedb.java.tzdb$afrom$", {
  Lzonedb_java_tzdb$afrom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrom$.prototype.$classData = $d_Lzonedb_java_tzdb$afrom$;
var $n_Lzonedb_java_tzdb$afrom$;
function $m_Lzonedb_java_tzdb$afrom$() {
  if ((!$n_Lzonedb_java_tzdb$afrom$)) {
    $n_Lzonedb_java_tzdb$afrom$ = new $c_Lzonedb_java_tzdb$afrom$()
  };
  return $n_Lzonedb_java_tzdb$afrom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrou$() {
  this.Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum = null;
  $n_Lzonedb_java_tzdb$afrou$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 7808);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 7808);
  var _2 = [[1931001, 0, 7808, 7200], [2000015, 43200, 7200, 10800], [2017305, 0, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931001, 0, 7808, 7200], [1970121, 0, 7200, 10800], [1970288, 0, 10800, 7200], [1971120, 0, 7200, 10800], [1971288, 0, 10800, 7200], [1972121, 0, 7200, 10800], [1972289, 0, 10800, 7200], [1973119, 0, 7200, 10800], [1973288, 0, 10800, 7200], [1974118, 0, 7200, 10800], [1974288, 0, 10800, 7200], [1975117, 0, 7200, 10800], [1975288, 0, 10800, 7200], [1976116, 0, 7200, 10800], [1976289, 0, 10800, 7200], [1977114, 0, 7200, 10800], [1977288, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978288, 0, 10800, 7200], [1979119, 0, 7200, 10800], [1979288, 0, 10800, 7200], [1980118, 0, 7200, 10800], [1980289, 0, 10800, 7200], [1981116, 0, 7200, 10800], [1981288, 0, 10800, 7200], [1982115, 0, 7200, 10800], [1982288, 0, 10800, 7200], [1983114, 0, 7200, 10800], [1983288, 0, 10800, 7200], [1984120, 0, 7200, 10800], [1984289, 0, 10800, 7200], [1985118, 0, 7200, 10800], [1985288, 0, 10800, 7200], [2000015, 43200, 7200, 10800], [2017305, 0, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrou$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrou$.prototype.constructor = $c_Lzonedb_java_tzdb$afrou$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrou$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrou$.prototype = $c_Lzonedb_java_tzdb$afrou$.prototype;
var $d_Lzonedb_java_tzdb$afrou$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrou$: 0
}, false, "zonedb.java.tzdb$afrou$", {
  Lzonedb_java_tzdb$afrou$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrou$.prototype.$classData = $d_Lzonedb_java_tzdb$afrou$;
var $n_Lzonedb_java_tzdb$afrou$;
function $m_Lzonedb_java_tzdb$afrou$() {
  if ((!$n_Lzonedb_java_tzdb$afrou$)) {
    $n_Lzonedb_java_tzdb$afrou$ = new $c_Lzonedb_java_tzdb$afrou$()
  };
  return $n_Lzonedb_java_tzdb$afrou$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrsa$() {
  this.Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau = null;
  $n_Lzonedb_java_tzdb$afrsa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-3740));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-3740));
  var _2 = [[1911365, 86260, (-3740), (-3600)], [1975001, 0, (-3600), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911365, 86260, (-3740), (-3600)], [1975001, 0, (-3600), 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrsa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrsa$.prototype.constructor = $c_Lzonedb_java_tzdb$afrsa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrsa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrsa$.prototype = $c_Lzonedb_java_tzdb$afrsa$.prototype;
var $d_Lzonedb_java_tzdb$afrsa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrsa$: 0
}, false, "zonedb.java.tzdb$afrsa$", {
  Lzonedb_java_tzdb$afrsa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrsa$.prototype.$classData = $d_Lzonedb_java_tzdb$afrsa$;
var $n_Lzonedb_java_tzdb$afrsa$;
function $m_Lzonedb_java_tzdb$afrsa$() {
  if ((!$n_Lzonedb_java_tzdb$afrsa$)) {
    $n_Lzonedb_java_tzdb$afrsa$ = new $c_Lzonedb_java_tzdb$afrsa$()
  };
  return $n_Lzonedb_java_tzdb$afrsa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrub$() {
  this.Lzonedb_java_tzdb$afrub$__f_Africa_Juba = null;
  $n_Lzonedb_java_tzdb$afrub$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 7588);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 7588);
  var _2 = [[1931001, 0, 7588, 7200], [2000015, 43200, 7200, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931001, 0, 7588, 7200], [1970121, 0, 7200, 10800], [1970288, 0, 10800, 7200], [1971120, 0, 7200, 10800], [1971288, 0, 10800, 7200], [1972121, 0, 7200, 10800], [1972289, 0, 10800, 7200], [1973119, 0, 7200, 10800], [1973288, 0, 10800, 7200], [1974118, 0, 7200, 10800], [1974288, 0, 10800, 7200], [1975117, 0, 7200, 10800], [1975288, 0, 10800, 7200], [1976116, 0, 7200, 10800], [1976289, 0, 10800, 7200], [1977114, 0, 7200, 10800], [1977288, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978288, 0, 10800, 7200], [1979119, 0, 7200, 10800], [1979288, 0, 10800, 7200], [1980118, 0, 7200, 10800], [1980289, 0, 10800, 7200], [1981116, 0, 7200, 10800], [1981288, 0, 10800, 7200], [1982115, 0, 7200, 10800], [1982288, 0, 10800, 7200], [1983114, 0, 7200, 10800], [1983288, 0, 10800, 7200], [1984120, 0, 7200, 10800], [1984289, 0, 10800, 7200], [1985118, 0, 7200, 10800], [1985288, 0, 10800, 7200], [2000015, 43200, 7200, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrub$__f_Africa_Juba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrub$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrub$.prototype.constructor = $c_Lzonedb_java_tzdb$afrub$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrub$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrub$.prototype = $c_Lzonedb_java_tzdb$afrub$.prototype;
var $d_Lzonedb_java_tzdb$afrub$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrub$: 0
}, false, "zonedb.java.tzdb$afrub$", {
  Lzonedb_java_tzdb$afrub$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrub$.prototype.$classData = $d_Lzonedb_java_tzdb$afrub$;
var $n_Lzonedb_java_tzdb$afrub$;
function $m_Lzonedb_java_tzdb$afrub$() {
  if ((!$n_Lzonedb_java_tzdb$afrub$)) {
    $n_Lzonedb_java_tzdb$afrub$ = new $c_Lzonedb_java_tzdb$afrub$()
  };
  return $n_Lzonedb_java_tzdb$afrub$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrur$() {
  this.Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg = null;
  $n_Lzonedb_java_tzdb$afrur$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6720);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6720);
  var _2 = [[1892039, 0, 6720, 5400], [1903060, 0, 5400, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1892039, 0, 6720, 5400], [1903060, 0, 5400, 7200], [1942263, 7200, 7200, 10800], [1943080, 7200, 10800, 7200], [1943262, 7200, 7200, 10800], [1944079, 7200, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrur$.prototype.constructor = $c_Lzonedb_java_tzdb$afrur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrur$.prototype = $c_Lzonedb_java_tzdb$afrur$.prototype;
var $d_Lzonedb_java_tzdb$afrur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrur$: 0
}, false, "zonedb.java.tzdb$afrur$", {
  Lzonedb_java_tzdb$afrur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrur$.prototype.$classData = $d_Lzonedb_java_tzdb$afrur$;
var $n_Lzonedb_java_tzdb$afrur$;
function $m_Lzonedb_java_tzdb$afrur$() {
  if ((!$n_Lzonedb_java_tzdb$afrur$)) {
    $n_Lzonedb_java_tzdb$afrur$ = new $c_Lzonedb_java_tzdb$afrur$()
  };
  return $n_Lzonedb_java_tzdb$afrur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrut$() {
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Maputo = null;
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta = null;
  $n_Lzonedb_java_tzdb$afrut$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 7820);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 7820);
  var _2 = [[1903060, 0, 7820, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1903060, 0, 7820, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Maputo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-1276));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-1276));
  var _2$3 = [[1900365, 85124, (-1276), 0], [1984076, 0, 0, 3600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1900365, 85124, (-1276), 0], [1918126, 82800, 0, 3600], [1918280, 82800, 3600, 0], [1924107, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928106, 0, 0, 3600], [1928281, 3600, 3600, 0], [1967154, 43200, 0, 3600], [1967274, 0, 3600, 0], [1974175, 0, 0, 3600], [1974244, 0, 3600, 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [1984076, 0, 0, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$afrut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrut$.prototype.constructor = $c_Lzonedb_java_tzdb$afrut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrut$.prototype = $c_Lzonedb_java_tzdb$afrut$.prototype;
var $d_Lzonedb_java_tzdb$afrut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrut$: 0
}, false, "zonedb.java.tzdb$afrut$", {
  Lzonedb_java_tzdb$afrut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrut$.prototype.$classData = $d_Lzonedb_java_tzdb$afrut$;
var $n_Lzonedb_java_tzdb$afrut$;
function $m_Lzonedb_java_tzdb$afrut$() {
  if ((!$n_Lzonedb_java_tzdb$afrut$)) {
    $n_Lzonedb_java_tzdb$afrut$ = new $c_Lzonedb_java_tzdb$afrut$()
  };
  return $n_Lzonedb_java_tzdb$afrut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrvi$() {
  this.Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia = null;
  $n_Lzonedb_java_tzdb$afrvi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-2588));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-2588));
  var _2 = [[1919060, 0, (-2588), (-2670)], [1972007, 0, (-2670), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919060, 0, (-2588), (-2670)], [1972007, 0, (-2670), 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$afrvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrvi$.prototype.constructor = $c_Lzonedb_java_tzdb$afrvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrvi$.prototype = $c_Lzonedb_java_tzdb$afrvi$.prototype;
var $d_Lzonedb_java_tzdb$afrvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrvi$: 0
}, false, "zonedb.java.tzdb$afrvi$", {
  Lzonedb_java_tzdb$afrvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrvi$.prototype.$classData = $d_Lzonedb_java_tzdb$afrvi$;
var $n_Lzonedb_java_tzdb$afrvi$;
function $m_Lzonedb_java_tzdb$afrvi$() {
  if ((!$n_Lzonedb_java_tzdb$afrvi$)) {
    $n_Lzonedb_java_tzdb$afrvi$ = new $c_Lzonedb_java_tzdb$afrvi$()
  };
  return $n_Lzonedb_java_tzdb$afrvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameab$() {
  this.Lzonedb_java_tzdb$ameab$__f_America_Cuiaba = null;
  $n_Lzonedb_java_tzdb$ameab$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13460));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13460));
  var _2 = [[1914001, 0, (-13460), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-13460), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1988290, 0, (-14400), (-10800)], [1989029, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990042, 0, (-10800), (-14400)], [1990294, 0, (-14400), (-10800)], [1991048, 0, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1992040, 0, (-10800), (-14400)], [1992299, 0, (-14400), (-10800)], [1993031, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)], [1994289, 0, (-14400), (-10800)], [1995050, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996042, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997047, 0, (-10800), (-14400)], [1997279, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998284, 0, (-14400), (-10800)], [1999052, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2001049, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002048, 0, (-10800), (-14400)], [2002307, 0, (-14400), (-10800)], [2003047, 0, (-10800), (-14400)], [2004307, 0, (-14400), (-10800)], [2005051, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006050, 0, (-10800), (-14400)], [2006309, 0, (-14400), (-10800)], [2007056, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008048, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009046, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010052, 0, (-10800), (-14400)], [2010290, 0, (-14400), (-10800)], [2011051, 0, (-10800), (-14400)], [2011289, 0, (-14400), (-10800)], [2012057, 0, (-10800), (-14400)], [2012295, 0, (-14400), (-10800)], [2013048, 0, (-10800), (-14400)], [2013293, 0, (-14400), (-10800)], [2014047, 0, (-10800), (-14400)], [2014292, 0, (-14400), (-10800)], [2015053, 0, (-10800), (-14400)], [2015291, 0, (-14400), (-10800)], [2016052, 0, (-10800), (-14400)], [2016290, 0, (-14400), (-10800)], [2017050, 0, (-10800), (-14400)], [2017288, 0, (-14400), (-10800)], [2018049, 0, (-10800), (-14400)], [2018308, 0, (-14400), (-10800)], [2019048, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameab$__f_America_Cuiaba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameab$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameab$.prototype.constructor = $c_Lzonedb_java_tzdb$ameab$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameab$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameab$.prototype = $c_Lzonedb_java_tzdb$ameab$.prototype;
var $d_Lzonedb_java_tzdb$ameab$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameab$: 0
}, false, "zonedb.java.tzdb$ameab$", {
  Lzonedb_java_tzdb$ameab$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameab$.prototype.$classData = $d_Lzonedb_java_tzdb$ameab$;
var $n_Lzonedb_java_tzdb$ameab$;
function $m_Lzonedb_java_tzdb$ameab$() {
  if ((!$n_Lzonedb_java_tzdb$ameab$)) {
    $n_Lzonedb_java_tzdb$ameab$ = new $c_Lzonedb_java_tzdb$ameab$()
  };
  return $n_Lzonedb_java_tzdb$ameab$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameag$() {
  this.Lzonedb_java_tzdb$ameag$__f_America_Santiago = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Ojinaga = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Chicago = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Anchorage = null;
  $n_Lzonedb_java_tzdb$ameag$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16966));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16966));
  var _2 = [[1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-14400)], [1928092, 0, (-14400), (-18000)], [1928245, 0, (-18000), (-14400)], [1929091, 0, (-14400), (-18000)], [1929244, 0, (-18000), (-14400)], [1930091, 0, (-14400), (-18000)], [1930244, 0, (-18000), (-14400)], [1931091, 0, (-14400), (-18000)], [1931244, 0, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1946196, 0, (-14400), (-10800)], [1946244, 0, (-10800), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [1968308, 0, (-14400), (-10800)], [1969089, 0, (-10800), (-14400)], [1969327, 0, (-14400), (-10800)], [1970088, 0, (-10800), (-14400)], [1970284, 0, (-14400), (-10800)], [1971073, 0, (-10800), (-14400)], [1971283, 0, (-14400), (-10800)], [1972072, 0, (-10800), (-14400)], [1972289, 0, (-14400), (-10800)], [1973070, 0, (-10800), (-14400)], [1973273, 0, (-14400), (-10800)], [1974069, 0, (-10800), (-14400)], [1974286, 0, (-14400), (-10800)], [1975068, 0, (-10800), (-14400)], [1975285, 0, (-14400), (-10800)], [1976074, 0, (-10800), (-14400)], [1976284, 0, (-14400), (-10800)], [1977072, 0, (-10800), (-14400)], [1977282, 0, (-14400), (-10800)], [1978071, 0, (-10800), (-14400)], [1978288, 0, (-14400), (-10800)], [1979070, 0, (-10800), (-14400)], [1979287, 0, (-14400), (-10800)], [1980069, 0, (-10800), (-14400)], [1980286, 0, (-14400), (-10800)], [1981074, 0, (-10800), (-14400)], [1981284, 0, (-14400), (-10800)], [1982073, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)], [2017134, 0, (-10800), (-14400)], [2017225, 0, (-14400), (-10800)], [2018133, 0, (-10800), (-14400)], [2018224, 0, (-14400), (-10800)], [2019097, 0, (-10800), (-14400)], [2019251, 0, (-14400), (-10800)], [2020096, 0, (-10800), (-14400)], [2020250, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 2, 7, 10800, 0, 0, (-14400), (-10800), (-14400)], [9, 2, 7, 14400, 0, 0, (-14400), (-14400), (-10800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameag$__f_America_Santiago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-25060));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-25060));
  var _2$3 = [[1922001, 140, (-25060), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1998095, 10800, (-21600), (-25200)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1922001, 140, (-25060), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007091, 7200, (-25200), (-21600)], [2007301, 7200, (-21600), (-25200)], [2008097, 7200, (-25200), (-21600)], [2008300, 7200, (-21600), (-25200)], [2009095, 7200, (-25200), (-21600)], [2009298, 7200, (-21600), (-25200)], [2010073, 7200, (-25200), (-21600)], [2010311, 7200, (-21600), (-25200)], [2011072, 7200, (-25200), (-21600)], [2011310, 7200, (-21600), (-25200)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameag$__f_America_Ojinaga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-21036));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-21036));
  var _2$6 = [[1883322, 43764, (-21036), (-21600)], [1936061, 7200, (-21600), (-18000)], [1936320, 7200, (-18000), (-21600)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1883322, 43764, (-21036), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1920165, 7200, (-21600), (-18000)], [1920305, 7200, (-18000), (-21600)], [1921086, 7200, (-21600), (-18000)], [1921303, 7200, (-18000), (-21600)], [1922120, 7200, (-21600), (-18000)], [1922267, 7200, (-18000), (-21600)], [1923119, 7200, (-21600), (-18000)], [1923273, 7200, (-18000), (-21600)], [1924118, 7200, (-21600), (-18000)], [1924272, 7200, (-18000), (-21600)], [1925116, 7200, (-21600), (-18000)], [1925270, 7200, (-18000), (-21600)], [1926115, 7200, (-21600), (-18000)], [1926269, 7200, (-18000), (-21600)], [1927114, 7200, (-21600), (-18000)], [1927268, 7200, (-18000), (-21600)], [1928120, 7200, (-21600), (-18000)], [1928274, 7200, (-18000), (-21600)], [1929118, 7200, (-21600), (-18000)], [1929272, 7200, (-18000), (-21600)], [1930117, 7200, (-21600), (-18000)], [1930271, 7200, (-18000), (-21600)], [1931116, 7200, (-21600), (-18000)], [1931270, 7200, (-18000), (-21600)], [1932115, 7200, (-21600), (-18000)], [1932269, 7200, (-18000), (-21600)], [1933120, 7200, (-21600), (-18000)], [1933267, 7200, (-18000), (-21600)], [1934119, 7200, (-21600), (-18000)], [1934273, 7200, (-18000), (-21600)], [1935118, 7200, (-21600), (-18000)], [1935272, 7200, (-18000), (-21600)], [1936061, 7200, (-21600), (-18000)], [1936320, 7200, (-18000), (-21600)], [1937115, 7200, (-21600), (-18000)], [1937269, 7200, (-18000), (-21600)], [1938114, 7200, (-21600), (-18000)], [1938268, 7200, (-18000), (-21600)], [1939120, 7200, (-21600), (-18000)], [1939267, 7200, (-18000), (-21600)], [1940119, 7200, (-21600), (-18000)], [1940273, 7200, (-18000), (-21600)], [1941117, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957300, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958299, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1964299, 7200, (-18000), (-21600)], [1965115, 7200, (-21600), (-18000)], [1965304, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameag$__f_America_Chicago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  var $$x20 = $m_sr_ScalaRunTime$();
  var $$x19 = $ct_T2__O__O__(new $c_T2(), "s", 50424);
  var $$x18 = $ct_T2__O__O__(new $c_T2(), "w", 50424);
  var _2$9 = [[1867292, 52297, 50424, (-35976)], [1900232, 43200, (-35976), (-36000)], [1983303, 3600, (-36000), (-32400)]];
  var $$x17 = $ct_T2__O__O__(new $c_T2(), "t", _2$9);
  var _2$10 = [[1867292, 52297, 50424, (-35976)], [1900232, 43200, (-35976), (-36000)], [1942040, 7200, (-36000), (-32400)], [1945273, 7200, (-32400), (-36000)], [1969117, 7200, (-36000), (-32400)], [1969299, 7200, (-32400), (-36000)], [1970116, 7200, (-36000), (-32400)], [1970298, 7200, (-32400), (-36000)], [1971115, 7200, (-36000), (-32400)], [1971304, 7200, (-32400), (-36000)], [1972121, 7200, (-36000), (-32400)], [1972303, 7200, (-32400), (-36000)], [1973119, 7200, (-36000), (-32400)], [1973301, 7200, (-32400), (-36000)], [1974006, 7200, (-36000), (-32400)], [1974300, 7200, (-32400), (-36000)], [1975054, 7200, (-36000), (-32400)], [1975299, 7200, (-32400), (-36000)], [1976116, 7200, (-36000), (-32400)], [1976305, 7200, (-32400), (-36000)], [1977114, 7200, (-36000), (-32400)], [1977303, 7200, (-32400), (-36000)], [1978120, 7200, (-36000), (-32400)], [1978302, 7200, (-32400), (-36000)], [1979119, 7200, (-36000), (-32400)], [1979301, 7200, (-32400), (-36000)], [1980118, 7200, (-36000), (-32400)], [1980300, 7200, (-32400), (-36000)], [1981116, 7200, (-36000), (-32400)], [1981298, 7200, (-32400), (-36000)], [1982115, 7200, (-36000), (-32400)], [1982304, 7200, (-32400), (-36000)], [1983114, 7200, (-36000), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]];
  var $$x16 = $ct_T2__O__O__(new $c_T2(), "l", _2$10);
  var _2$11 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields$3 = $$x20.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x19, $$x18, $$x17, $$x16, $ct_T2__O__O__(new $c_T2(), "r", _2$11)]));
  this.Lzonedb_java_tzdb$ameag$__f_America_Anchorage = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3)
}
$c_Lzonedb_java_tzdb$ameag$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameag$.prototype.constructor = $c_Lzonedb_java_tzdb$ameag$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameag$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameag$.prototype = $c_Lzonedb_java_tzdb$ameag$.prototype;
var $d_Lzonedb_java_tzdb$ameag$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameag$: 0
}, false, "zonedb.java.tzdb$ameag$", {
  Lzonedb_java_tzdb$ameag$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameag$.prototype.$classData = $d_Lzonedb_java_tzdb$ameag$;
var $n_Lzonedb_java_tzdb$ameag$;
function $m_Lzonedb_java_tzdb$ameag$() {
  if ((!$n_Lzonedb_java_tzdb$ameag$)) {
    $n_Lzonedb_java_tzdb$ameag$ = new $c_Lzonedb_java_tzdb$ameag$()
  };
  return $n_Lzonedb_java_tzdb$ameag$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameai$() {
  this.Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia = null;
  this.Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain = null;
  $n_Lzonedb_java_tzdb$ameai$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16392));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16392));
  var _2 = [[1894304, 0, (-16392), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004151, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-16392), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004151, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-14764));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-14764));
  var _2$3 = [[1912062, 0, (-14764), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1912062, 0, (-14764), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameai$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameai$.prototype.constructor = $c_Lzonedb_java_tzdb$ameai$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameai$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameai$.prototype = $c_Lzonedb_java_tzdb$ameai$.prototype;
var $d_Lzonedb_java_tzdb$ameai$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameai$: 0
}, false, "zonedb.java.tzdb$ameai$", {
  Lzonedb_java_tzdb$ameai$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameai$.prototype.$classData = $d_Lzonedb_java_tzdb$ameai$;
var $n_Lzonedb_java_tzdb$ameai$;
function $m_Lzonedb_java_tzdb$ameai$() {
  if ((!$n_Lzonedb_java_tzdb$ameai$)) {
    $n_Lzonedb_java_tzdb$ameai$ = new $c_Lzonedb_java_tzdb$ameai$()
  };
  return $n_Lzonedb_java_tzdb$ameai$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameal$() {
  this.Lzonedb_java_tzdb$ameal$__f_America_Guatemala = null;
  $n_Lzonedb_java_tzdb$ameal$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21724));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21724));
  var _2 = [[1918278, 0, (-21724), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1918278, 0, (-21724), (-21600)], [1973329, 0, (-21600), (-18000)], [1974055, 0, (-18000), (-21600)], [1983141, 0, (-21600), (-18000)], [1983265, 0, (-18000), (-21600)], [1991082, 0, (-21600), (-18000)], [1991250, 0, (-18000), (-21600)], [2006120, 0, (-21600), (-18000)], [2006274, 0, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameal$__f_America_Guatemala = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameal$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameal$.prototype.constructor = $c_Lzonedb_java_tzdb$ameal$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameal$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameal$.prototype = $c_Lzonedb_java_tzdb$ameal$.prototype;
var $d_Lzonedb_java_tzdb$ameal$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameal$: 0
}, false, "zonedb.java.tzdb$ameal$", {
  Lzonedb_java_tzdb$ameal$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameal$.prototype.$classData = $d_Lzonedb_java_tzdb$ameal$;
var $n_Lzonedb_java_tzdb$ameal$;
function $m_Lzonedb_java_tzdb$ameal$() {
  if ((!$n_Lzonedb_java_tzdb$ameal$)) {
    $n_Lzonedb_java_tzdb$ameal$ = new $c_Lzonedb_java_tzdb$ameal$()
  };
  return $n_Lzonedb_java_tzdb$ameal$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameam$() {
  this.Lzonedb_java_tzdb$ameam$__f_America_Panama = null;
  $n_Lzonedb_java_tzdb$ameam$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-19088));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-19088));
  var _2 = [[1890001, 0, (-19088), (-19176)], [1908113, 0, (-19176), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-19088), (-19176)], [1908113, 0, (-19176), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameam$__f_America_Panama = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameam$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameam$.prototype.constructor = $c_Lzonedb_java_tzdb$ameam$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameam$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameam$.prototype = $c_Lzonedb_java_tzdb$ameam$.prototype;
var $d_Lzonedb_java_tzdb$ameam$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameam$: 0
}, false, "zonedb.java.tzdb$ameam$", {
  Lzonedb_java_tzdb$ameam$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameam$.prototype.$classData = $d_Lzonedb_java_tzdb$ameam$;
var $n_Lzonedb_java_tzdb$ameam$;
function $m_Lzonedb_java_tzdb$ameam$() {
  if ((!$n_Lzonedb_java_tzdb$ameam$)) {
    $n_Lzonedb_java_tzdb$ameam$ = new $c_Lzonedb_java_tzdb$ameam$()
  };
  return $n_Lzonedb_java_tzdb$ameam$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amean$() {
  this.Lzonedb_java_tzdb$amean$__f_America_Tijuana = null;
  this.Lzonedb_java_tzdb$amean$__f_America_Guyana = null;
  this.Lzonedb_java_tzdb$amean$__f_America_Havana = null;
  $n_Lzonedb_java_tzdb$amean$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-28084));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-28084));
  var _2 = [[1922001, 716, (-28084), (-25200)], [1924001, 0, (-25200), (-28800)], [1927161, 82800, (-28800), (-25200)], [1930319, 0, (-25200), (-28800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922001, 716, (-28084), (-25200)], [1924001, 0, (-25200), (-28800)], [1927161, 82800, (-28800), (-25200)], [1930319, 0, (-25200), (-28800)], [1931091, 0, (-28800), (-25200)], [1931273, 0, (-25200), (-28800)], [1942114, 0, (-28800), (-25200)], [1945316, 0, (-25200), (-28800)], [1948096, 0, (-28800), (-25200)], [1949014, 0, (-25200), (-28800)], [1954115, 3600, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 3600, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 3600, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 3600, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 3600, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 3600, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 3600, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007091, 7200, (-28800), (-25200)], [2007301, 7200, (-25200), (-28800)], [2008097, 7200, (-28800), (-25200)], [2008300, 7200, (-25200), (-28800)], [2009095, 7200, (-28800), (-25200)], [2009298, 7200, (-25200), (-28800)], [2010073, 7200, (-28800), (-25200)], [2010311, 7200, (-25200), (-28800)], [2011072, 7200, (-28800), (-25200)], [2011310, 7200, (-25200), (-28800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amean$__f_America_Tijuana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-13960));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-13960));
  var _2$3 = [[1915060, 0, (-13960), (-13500)], [1975212, 0, (-13500), (-10800)], [1991001, 0, (-10800), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1915060, 0, (-13960), (-13500)], [1975212, 0, (-13500), (-10800)], [1991001, 0, (-10800), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amean$__f_America_Guyana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-19768));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-19768));
  var _2$6 = [[1890001, 0, (-19768), (-19776)], [1925200, 43200, (-19776), (-18000)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1890001, 0, (-19768), (-19776)], [1925200, 43200, (-19776), (-18000)], [1928162, 0, (-18000), (-14400)], [1928284, 0, (-14400), (-18000)], [1940154, 0, (-18000), (-14400)], [1940245, 0, (-14400), (-18000)], [1941152, 0, (-18000), (-14400)], [1941250, 0, (-14400), (-18000)], [1942158, 0, (-18000), (-14400)], [1942249, 0, (-14400), (-18000)], [1945154, 0, (-18000), (-14400)], [1945245, 0, (-14400), (-18000)], [1946153, 0, (-18000), (-14400)], [1946244, 0, (-14400), (-18000)], [1965152, 0, (-18000), (-14400)], [1965273, 0, (-14400), (-18000)], [1966149, 0, (-18000), (-14400)], [1966275, 0, (-14400), (-18000)], [1967098, 0, (-18000), (-14400)], [1967253, 0, (-14400), (-18000)], [1968105, 0, (-18000), (-14400)], [1968252, 0, (-14400), (-18000)], [1969117, 0, (-18000), (-14400)], [1969299, 0, (-14400), (-18000)], [1970116, 0, (-18000), (-14400)], [1970298, 0, (-14400), (-18000)], [1971115, 0, (-18000), (-14400)], [1971304, 0, (-14400), (-18000)], [1972121, 0, (-18000), (-14400)], [1972282, 0, (-14400), (-18000)], [1973119, 0, (-18000), (-14400)], [1973281, 0, (-14400), (-18000)], [1974118, 0, (-18000), (-14400)], [1974281, 0, (-14400), (-18000)], [1975117, 0, (-18000), (-14400)], [1975299, 0, (-14400), (-18000)], [1976116, 0, (-18000), (-14400)], [1976305, 0, (-14400), (-18000)], [1977114, 0, (-18000), (-14400)], [1977303, 0, (-14400), (-18000)], [1978127, 0, (-18000), (-14400)], [1978281, 0, (-14400), (-18000)], [1979077, 0, (-18000), (-14400)], [1979287, 0, (-14400), (-18000)], [1980076, 0, (-18000), (-14400)], [1980286, 0, (-14400), (-18000)], [1981130, 0, (-18000), (-14400)], [1981284, 0, (-14400), (-18000)], [1982129, 0, (-18000), (-14400)], [1982283, 0, (-14400), (-18000)], [1983128, 0, (-18000), (-14400)], [1983282, 0, (-14400), (-18000)], [1984127, 0, (-18000), (-14400)], [1984288, 0, (-14400), (-18000)], [1985125, 0, (-18000), (-14400)], [1985286, 0, (-14400), (-18000)], [1986075, 0, (-18000), (-14400)], [1986285, 0, (-14400), (-18000)], [1987074, 0, (-18000), (-14400)], [1987284, 0, (-14400), (-18000)], [1988080, 0, (-18000), (-14400)], [1988283, 0, (-14400), (-18000)], [1989078, 0, (-18000), (-14400)], [1989281, 0, (-14400), (-18000)], [1990091, 0, (-18000), (-14400)], [1990287, 0, (-14400), (-18000)], [1991097, 0, (-18000), (-14400)], [1991286, 3600, (-14400), (-18000)], [1992096, 0, (-18000), (-14400)], [1992285, 3600, (-14400), (-18000)], [1993094, 0, (-18000), (-14400)], [1993283, 3600, (-14400), (-18000)], [1994093, 0, (-18000), (-14400)], [1994282, 3600, (-14400), (-18000)], [1995092, 0, (-18000), (-14400)], [1995281, 3600, (-14400), (-18000)], [1996098, 0, (-18000), (-14400)], [1996280, 3600, (-14400), (-18000)], [1997096, 0, (-18000), (-14400)], [1997285, 3600, (-14400), (-18000)], [1998088, 0, (-18000), (-14400)], [1998298, 3600, (-14400), (-18000)], [1999087, 0, (-18000), (-14400)], [1999304, 3600, (-14400), (-18000)], [2000093, 0, (-18000), (-14400)], [2000303, 3600, (-14400), (-18000)], [2001091, 0, (-18000), (-14400)], [2001301, 3600, (-14400), (-18000)], [2002097, 0, (-18000), (-14400)], [2002300, 3600, (-14400), (-18000)], [2003096, 0, (-18000), (-14400)], [2003299, 3600, (-14400), (-18000)], [2004088, 0, (-18000), (-14400)], [2006302, 3600, (-14400), (-18000)], [2007070, 0, (-18000), (-14400)], [2007301, 3600, (-14400), (-18000)], [2008076, 0, (-18000), (-14400)], [2008300, 3600, (-14400), (-18000)], [2009067, 0, (-18000), (-14400)], [2009298, 3600, (-14400), (-18000)], [2010073, 0, (-18000), (-14400)], [2010304, 3600, (-14400), (-18000)], [2011079, 0, (-18000), (-14400)], [2011317, 3600, (-14400), (-18000)], [2012092, 0, (-18000), (-14400)], [2012309, 3600, (-14400), (-18000)], [2013069, 0, (-18000), (-14400)], [2013307, 3600, (-14400), (-18000)], [2014068, 0, (-18000), (-14400)], [2014306, 3600, (-14400), (-18000)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 0, 0, 2, (-18000), (-18000), (-14400)], [11, 1, 7, 0, 0, 2, (-18000), (-14400), (-18000)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$amean$__f_America_Havana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$amean$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amean$.prototype.constructor = $c_Lzonedb_java_tzdb$amean$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amean$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amean$.prototype = $c_Lzonedb_java_tzdb$amean$.prototype;
var $d_Lzonedb_java_tzdb$amean$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amean$: 0
}, false, "zonedb.java.tzdb$amean$", {
  Lzonedb_java_tzdb$amean$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amean$.prototype.$classData = $d_Lzonedb_java_tzdb$amean$;
var $n_Lzonedb_java_tzdb$amean$;
function $m_Lzonedb_java_tzdb$amean$() {
  if ((!$n_Lzonedb_java_tzdb$amean$)) {
    $n_Lzonedb_java_tzdb$amean$ = new $c_Lzonedb_java_tzdb$amean$()
  };
  return $n_Lzonedb_java_tzdb$amean$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameau$() {
  this.Lzonedb_java_tzdb$ameau$__f_America_Manaus = null;
  $n_Lzonedb_java_tzdb$ameau$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-14404));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-14404));
  var _2 = [[1914001, 0, (-14404), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-14404), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameau$__f_America_Manaus = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameau$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameau$.prototype.constructor = $c_Lzonedb_java_tzdb$ameau$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameau$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameau$.prototype = $c_Lzonedb_java_tzdb$ameau$.prototype;
var $d_Lzonedb_java_tzdb$ameau$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameau$: 0
}, false, "zonedb.java.tzdb$ameau$", {
  Lzonedb_java_tzdb$ameau$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameau$.prototype.$classData = $d_Lzonedb_java_tzdb$ameau$;
var $n_Lzonedb_java_tzdb$ameau$;
function $m_Lzonedb_java_tzdb$ameau$() {
  if ((!$n_Lzonedb_java_tzdb$ameau$)) {
    $n_Lzonedb_java_tzdb$ameau$ = new $c_Lzonedb_java_tzdb$ameau$()
  };
  return $n_Lzonedb_java_tzdb$ameau$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameav$() {
  this.Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn = null;
  $n_Lzonedb_java_tzdb$ameav$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-4480));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-4480));
  var _2 = [[1916210, 0, (-4480), (-10800)], [1996001, 0, (-10800), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916210, 0, (-4480), (-10800)], [1980097, 7200, (-10800), (-7200)], [1980271, 82800, (-7200), (-10800)], [1981087, 79200, (-10800), (-7200)], [1981269, 82800, (-7200), (-10800)], [1982086, 79200, (-10800), (-7200)], [1982268, 82800, (-7200), (-10800)], [1983085, 79200, (-10800), (-7200)], [1983267, 82800, (-7200), (-10800)], [1984084, 79200, (-10800), (-7200)], [1984273, 82800, (-7200), (-10800)], [1985089, 79200, (-10800), (-7200)], [1985271, 82800, (-7200), (-10800)], [1986088, 79200, (-10800), (-7200)], [1986270, 82800, (-7200), (-10800)], [1987087, 79200, (-10800), (-7200)], [1987269, 82800, (-7200), (-10800)], [1988086, 79200, (-10800), (-7200)], [1988268, 82800, (-7200), (-10800)], [1989084, 79200, (-10800), (-7200)], [1989266, 82800, (-7200), (-10800)], [1990083, 79200, (-10800), (-7200)], [1990272, 82800, (-7200), (-10800)], [1991089, 79200, (-10800), (-7200)], [1991271, 82800, (-7200), (-10800)], [1992088, 79200, (-10800), (-7200)], [1992270, 82800, (-7200), (-10800)], [1993086, 79200, (-10800), (-7200)], [1993268, 82800, (-7200), (-10800)], [1994085, 79200, (-10800), (-7200)], [1994267, 82800, (-7200), (-10800)], [1995084, 79200, (-10800), (-7200)], [1995266, 82800, (-7200), (-10800)], [1996001, 0, (-10800), 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameav$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameav$.prototype.constructor = $c_Lzonedb_java_tzdb$ameav$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameav$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameav$.prototype = $c_Lzonedb_java_tzdb$ameav$.prototype;
var $d_Lzonedb_java_tzdb$ameav$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameav$: 0
}, false, "zonedb.java.tzdb$ameav$", {
  Lzonedb_java_tzdb$ameav$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameav$.prototype.$classData = $d_Lzonedb_java_tzdb$ameav$;
var $n_Lzonedb_java_tzdb$ameav$;
function $m_Lzonedb_java_tzdb$ameav$() {
  if ((!$n_Lzonedb_java_tzdb$ameav$)) {
    $n_Lzonedb_java_tzdb$ameav$ = new $c_Lzonedb_java_tzdb$ameav$()
  };
  return $n_Lzonedb_java_tzdb$ameav$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameba$() {
  this.Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay = null;
  $n_Lzonedb_java_tzdb$ameba$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-14500));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-14500));
  var _2 = [[1884001, 0, (-14500), (-12652)], [1935089, 0, (-12652), (-12600)], [1966074, 7200, (-12600), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, (-14500), (-12652)], [1918104, 7200, (-12652), (-9052)], [1918300, 7200, (-9052), (-12652)], [1935089, 0, (-12652), (-12600)], [1936132, 0, (-12600), (-9000)], [1936279, 0, (-9000), (-12600)], [1937130, 0, (-12600), (-9000)], [1937277, 0, (-9000), (-12600)], [1938129, 0, (-12600), (-9000)], [1938276, 0, (-9000), (-12600)], [1939135, 0, (-12600), (-9000)], [1939275, 0, (-9000), (-12600)], [1940134, 0, (-12600), (-9000)], [1940281, 0, (-9000), (-12600)], [1941132, 0, (-12600), (-9000)], [1941279, 0, (-9000), (-12600)], [1942131, 0, (-12600), (-9000)], [1945273, 7200, (-9000), (-12600)], [1946132, 7200, (-12600), (-9000)], [1946279, 7200, (-9000), (-12600)], [1947131, 7200, (-12600), (-9000)], [1947278, 7200, (-9000), (-12600)], [1948130, 7200, (-12600), (-9000)], [1948277, 7200, (-9000), (-12600)], [1949128, 7200, (-12600), (-9000)], [1949275, 7200, (-9000), (-12600)], [1950134, 7200, (-12600), (-9000)], [1950281, 7200, (-9000), (-12600)], [1951119, 7200, (-12600), (-9000)], [1951273, 7200, (-9000), (-12600)], [1952118, 7200, (-12600), (-9000)], [1952272, 7200, (-9000), (-12600)], [1953116, 7200, (-12600), (-9000)], [1953270, 7200, (-9000), (-12600)], [1954115, 7200, (-12600), (-9000)], [1954269, 7200, (-9000), (-12600)], [1955114, 7200, (-12600), (-9000)], [1955268, 7200, (-9000), (-12600)], [1956120, 7200, (-12600), (-9000)], [1956274, 7200, (-9000), (-12600)], [1957118, 7200, (-12600), (-9000)], [1957272, 7200, (-9000), (-12600)], [1958117, 7200, (-12600), (-9000)], [1958271, 7200, (-9000), (-12600)], [1959116, 7200, (-12600), (-9000)], [1959270, 7200, (-9000), (-12600)], [1960115, 7200, (-12600), (-9000)], [1960304, 7200, (-9000), (-12600)], [1961120, 7200, (-12600), (-9000)], [1961302, 7200, (-9000), (-12600)], [1962119, 7200, (-12600), (-9000)], [1962301, 7200, (-9000), (-12600)], [1963118, 7200, (-12600), (-9000)], [1963300, 7200, (-9000), (-12600)], [1964117, 7200, (-12600), (-9000)], [1964299, 7200, (-9000), (-12600)], [1965115, 7200, (-12600), (-9000)], [1965304, 7200, (-9000), (-12600)], [1966074, 7200, (-12600), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 60, (-14400), (-10800)], [1987298, 60, (-10800), (-14400)], [1988094, 60, (-14400), (-7200)], [1988304, 60, (-7200), (-14400)], [1989092, 60, (-14400), (-10800)], [1989302, 60, (-10800), (-14400)], [1990091, 60, (-14400), (-10800)], [1990301, 60, (-10800), (-14400)], [1991097, 60, (-14400), (-10800)], [1991300, 60, (-10800), (-14400)], [1992096, 60, (-14400), (-10800)], [1992299, 60, (-10800), (-14400)], [1993094, 60, (-14400), (-10800)], [1993304, 60, (-10800), (-14400)], [1994093, 60, (-14400), (-10800)], [1994303, 60, (-10800), (-14400)], [1995092, 60, (-14400), (-10800)], [1995302, 60, (-10800), (-14400)], [1996098, 60, (-14400), (-10800)], [1996301, 60, (-10800), (-14400)], [1997096, 60, (-14400), (-10800)], [1997299, 60, (-10800), (-14400)], [1998095, 60, (-14400), (-10800)], [1998298, 60, (-10800), (-14400)], [1999094, 60, (-14400), (-10800)], [1999304, 60, (-10800), (-14400)], [2000093, 60, (-14400), (-10800)], [2000303, 60, (-10800), (-14400)], [2001091, 60, (-14400), (-10800)], [2001301, 60, (-10800), (-14400)], [2002097, 60, (-14400), (-10800)], [2002300, 60, (-10800), (-14400)], [2003096, 60, (-14400), (-10800)], [2003299, 60, (-10800), (-14400)], [2004095, 60, (-14400), (-10800)], [2004305, 60, (-10800), (-14400)], [2005093, 60, (-14400), (-10800)], [2005303, 60, (-10800), (-14400)], [2006092, 60, (-14400), (-10800)], [2006302, 60, (-10800), (-14400)], [2007070, 60, (-14400), (-10800)], [2007308, 60, (-10800), (-14400)], [2008069, 60, (-14400), (-10800)], [2008307, 60, (-10800), (-14400)], [2009067, 60, (-14400), (-10800)], [2009305, 60, (-10800), (-14400)], [2010073, 60, (-14400), (-10800)], [2010311, 60, (-10800), (-14400)], [2011072, 60, (-14400), (-10800)], [2011310, 7200, (-10800), (-14400)], [2012071, 7200, (-14400), (-10800)], [2012309, 7200, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-21420));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-21420));
  var _2$3 = [[1895001, 0, (-21420), (-21600)], [1910001, 0, (-21600), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1895001, 0, (-21420), (-21600)], [1910001, 0, (-21600), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-14388));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-14388));
  var _2$6 = [[1902166, 0, (-14388), (-14400)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1902166, 0, (-14388), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  var $$x20 = $m_sr_ScalaRunTime$();
  var $$x19 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x18 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2$9 = [[1920001, 0, 0, (-25200)], [1999304, 3600, (-25200), (-21600)], [2000303, 3600, (-21600), (-18000)], [2000310, 0, (-18000), (-21600)], [2001091, 10800, (-21600), (-25200)]];
  var $$x17 = $ct_T2__O__O__(new $c_T2(), "t", _2$9);
  var _2$10 = [[1920001, 0, 0, (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 0, (-25200), (-18000)], [1965304, 7200, (-18000), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000310, 0, (-18000), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x16 = $ct_T2__O__O__(new $c_T2(), "l", _2$10);
  var _2$11 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields$3 = $$x20.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x19, $$x18, $$x17, $$x16, $ct_T2__O__O__(new $c_T2(), "r", _2$11)]));
  this.Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3)
}
$c_Lzonedb_java_tzdb$ameba$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameba$.prototype.constructor = $c_Lzonedb_java_tzdb$ameba$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameba$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameba$.prototype = $c_Lzonedb_java_tzdb$ameba$.prototype;
var $d_Lzonedb_java_tzdb$ameba$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameba$: 0
}, false, "zonedb.java.tzdb$ameba$", {
  Lzonedb_java_tzdb$ameba$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameba$.prototype.$classData = $d_Lzonedb_java_tzdb$ameba$;
var $n_Lzonedb_java_tzdb$ameba$;
function $m_Lzonedb_java_tzdb$ameba$() {
  if ((!$n_Lzonedb_java_tzdb$ameba$)) {
    $n_Lzonedb_java_tzdb$ameba$ = new $c_Lzonedb_java_tzdb$ameba$()
  };
  return $n_Lzonedb_java_tzdb$ameba$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameca$() {
  this.Lzonedb_java_tzdb$ameca$__f_America_Curacao = null;
  this.Lzonedb_java_tzdb$ameca$__f_America_Caracas = null;
  $n_Lzonedb_java_tzdb$ameca$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16547));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16547));
  var _2 = [[1912043, 0, (-16547), (-16200)], [1965001, 0, (-16200), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912043, 0, (-16547), (-16200)], [1965001, 0, (-16200), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameca$__f_America_Curacao = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-16064));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-16064));
  var _2$3 = [[1890001, 0, (-16064), (-16060)], [1912043, 0, (-16060), (-16200)], [1965001, 0, (-16200), (-14400)], [2007343, 10800, (-14400), (-16200)], [2016122, 9000, (-16200), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890001, 0, (-16064), (-16060)], [1912043, 0, (-16060), (-16200)], [1965001, 0, (-16200), (-14400)], [2007343, 10800, (-14400), (-16200)], [2016122, 9000, (-16200), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameca$__f_America_Caracas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameca$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameca$.prototype.constructor = $c_Lzonedb_java_tzdb$ameca$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameca$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameca$.prototype = $c_Lzonedb_java_tzdb$ameca$.prototype;
var $d_Lzonedb_java_tzdb$ameca$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameca$: 0
}, false, "zonedb.java.tzdb$ameca$", {
  Lzonedb_java_tzdb$ameca$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameca$.prototype.$classData = $d_Lzonedb_java_tzdb$ameca$;
var $n_Lzonedb_java_tzdb$ameca$;
function $m_Lzonedb_java_tzdb$ameca$() {
  if ((!$n_Lzonedb_java_tzdb$ameca$)) {
    $n_Lzonedb_java_tzdb$ameca$ = new $c_Lzonedb_java_tzdb$ameca$()
  };
  return $n_Lzonedb_java_tzdb$ameca$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amecu$() {
  this.Lzonedb_java_tzdb$amecu$__f_America_Cancun = null;
  $n_Lzonedb_java_tzdb$amecu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20824));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20824));
  var _2 = [[1922001, 776, (-20824), (-21600)], [1981357, 0, (-21600), (-18000)], [1998214, 3600, (-18000), (-21600)], [2015032, 7200, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922001, 776, (-20824), (-21600)], [1981357, 0, (-21600), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998214, 7200, (-14400), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007091, 7200, (-21600), (-18000)], [2007301, 7200, (-18000), (-21600)], [2008097, 7200, (-21600), (-18000)], [2008300, 7200, (-18000), (-21600)], [2009095, 7200, (-21600), (-18000)], [2009298, 7200, (-18000), (-21600)], [2010094, 7200, (-21600), (-18000)], [2010304, 7200, (-18000), (-21600)], [2011093, 7200, (-21600), (-18000)], [2011303, 7200, (-18000), (-21600)], [2012092, 7200, (-21600), (-18000)], [2012302, 7200, (-18000), (-21600)], [2013097, 7200, (-21600), (-18000)], [2013300, 7200, (-18000), (-21600)], [2014096, 7200, (-21600), (-18000)], [2014299, 7200, (-18000), (-21600)], [2015032, 7200, (-21600), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amecu$__f_America_Cancun = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amecu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amecu$.prototype.constructor = $c_Lzonedb_java_tzdb$amecu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amecu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amecu$.prototype = $c_Lzonedb_java_tzdb$amecu$.prototype;
var $d_Lzonedb_java_tzdb$amecu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amecu$: 0
}, false, "zonedb.java.tzdb$amecu$", {
  Lzonedb_java_tzdb$amecu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amecu$.prototype.$classData = $d_Lzonedb_java_tzdb$amecu$;
var $n_Lzonedb_java_tzdb$amecu$;
function $m_Lzonedb_java_tzdb$amecu$() {
  if ((!$n_Lzonedb_java_tzdb$amecu$)) {
    $n_Lzonedb_java_tzdb$amecu$ = new $c_Lzonedb_java_tzdb$amecu$()
  };
  return $n_Lzonedb_java_tzdb$amecu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameda$() {
  this.Lzonedb_java_tzdb$ameda$__f_America_Adak = null;
  $n_Lzonedb_java_tzdb$ameda$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 44002);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 44002);
  var _2 = [[1867292, 45875, 44002, (-42398)], [1900232, 43200, (-42398), (-39600)], [1983303, 3600, (-39600), (-36000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 45875, 44002, (-42398)], [1900232, 43200, (-42398), (-39600)], [1942040, 7200, (-39600), (-36000)], [1945273, 7200, (-36000), (-39600)], [1969117, 7200, (-39600), (-36000)], [1969299, 7200, (-36000), (-39600)], [1970116, 7200, (-39600), (-36000)], [1970298, 7200, (-36000), (-39600)], [1971115, 7200, (-39600), (-36000)], [1971304, 7200, (-36000), (-39600)], [1972121, 7200, (-39600), (-36000)], [1972303, 7200, (-36000), (-39600)], [1973119, 7200, (-39600), (-36000)], [1973301, 7200, (-36000), (-39600)], [1974006, 7200, (-39600), (-36000)], [1974300, 7200, (-36000), (-39600)], [1975054, 7200, (-39600), (-36000)], [1975299, 7200, (-36000), (-39600)], [1976116, 7200, (-39600), (-36000)], [1976305, 7200, (-36000), (-39600)], [1977114, 7200, (-39600), (-36000)], [1977303, 7200, (-36000), (-39600)], [1978120, 7200, (-39600), (-36000)], [1978302, 7200, (-36000), (-39600)], [1979119, 7200, (-39600), (-36000)], [1979301, 7200, (-36000), (-39600)], [1980118, 7200, (-39600), (-36000)], [1980300, 7200, (-36000), (-39600)], [1981116, 7200, (-39600), (-36000)], [1981298, 7200, (-36000), (-39600)], [1982115, 7200, (-39600), (-36000)], [1982304, 7200, (-36000), (-39600)], [1983114, 7200, (-39600), (-36000)], [1984120, 7200, (-36000), (-32400)], [1984302, 7200, (-32400), (-36000)], [1985118, 7200, (-36000), (-32400)], [1985300, 7200, (-32400), (-36000)], [1986117, 7200, (-36000), (-32400)], [1986299, 7200, (-32400), (-36000)], [1987095, 7200, (-36000), (-32400)], [1987298, 7200, (-32400), (-36000)], [1988094, 7200, (-36000), (-32400)], [1988304, 7200, (-32400), (-36000)], [1989092, 7200, (-36000), (-32400)], [1989302, 7200, (-32400), (-36000)], [1990091, 7200, (-36000), (-32400)], [1990301, 7200, (-32400), (-36000)], [1991097, 7200, (-36000), (-32400)], [1991300, 7200, (-32400), (-36000)], [1992096, 7200, (-36000), (-32400)], [1992299, 7200, (-32400), (-36000)], [1993094, 7200, (-36000), (-32400)], [1993304, 7200, (-32400), (-36000)], [1994093, 7200, (-36000), (-32400)], [1994303, 7200, (-32400), (-36000)], [1995092, 7200, (-36000), (-32400)], [1995302, 7200, (-32400), (-36000)], [1996098, 7200, (-36000), (-32400)], [1996301, 7200, (-32400), (-36000)], [1997096, 7200, (-36000), (-32400)], [1997299, 7200, (-32400), (-36000)], [1998095, 7200, (-36000), (-32400)], [1998298, 7200, (-32400), (-36000)], [1999094, 7200, (-36000), (-32400)], [1999304, 7200, (-32400), (-36000)], [2000093, 7200, (-36000), (-32400)], [2000303, 7200, (-32400), (-36000)], [2001091, 7200, (-36000), (-32400)], [2001301, 7200, (-32400), (-36000)], [2002097, 7200, (-36000), (-32400)], [2002300, 7200, (-32400), (-36000)], [2003096, 7200, (-36000), (-32400)], [2003299, 7200, (-32400), (-36000)], [2004095, 7200, (-36000), (-32400)], [2004305, 7200, (-32400), (-36000)], [2005093, 7200, (-36000), (-32400)], [2005303, 7200, (-32400), (-36000)], [2006092, 7200, (-36000), (-32400)], [2006302, 7200, (-32400), (-36000)], [2007070, 7200, (-36000), (-32400)], [2007308, 7200, (-32400), (-36000)], [2008069, 7200, (-36000), (-32400)], [2008307, 7200, (-32400), (-36000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-36000), (-36000), (-32400)], [11, 1, 7, 7200, 0, 1, (-36000), (-32400), (-36000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameda$__f_America_Adak = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameda$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameda$.prototype.constructor = $c_Lzonedb_java_tzdb$ameda$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameda$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameda$.prototype = $c_Lzonedb_java_tzdb$ameda$.prototype;
var $d_Lzonedb_java_tzdb$ameda$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameda$: 0
}, false, "zonedb.java.tzdb$ameda$", {
  Lzonedb_java_tzdb$ameda$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameda$.prototype.$classData = $d_Lzonedb_java_tzdb$ameda$;
var $n_Lzonedb_java_tzdb$ameda$;
function $m_Lzonedb_java_tzdb$ameda$() {
  if ((!$n_Lzonedb_java_tzdb$ameda$)) {
    $n_Lzonedb_java_tzdb$ameda$ = new $c_Lzonedb_java_tzdb$ameda$()
  };
  return $n_Lzonedb_java_tzdb$ameda$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amede$() {
  this.Lzonedb_java_tzdb$amede$__f_America_Montevideo = null;
  $n_Lzonedb_java_tzdb$amede$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13491));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13491));
  var _2 = [[1920122, 0, (-13491), (-14400)], [1923274, 0, (-14400), (-12600)], [1942347, 84600, (-12600), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920122, 0, (-13491), (-14400)], [1923274, 0, (-14400), (-10800)], [1924092, 0, (-10800), (-12600)], [1924275, 0, (-12600), (-10800)], [1925091, 0, (-10800), (-12600)], [1925274, 0, (-12600), (-10800)], [1926091, 0, (-10800), (-12600)], [1933302, 0, (-12600), (-10800)], [1934091, 0, (-10800), (-12600)], [1934301, 0, (-12600), (-10800)], [1935090, 0, (-10800), (-12600)], [1935300, 0, (-12600), (-10800)], [1936089, 0, (-10800), (-12600)], [1936299, 0, (-12600), (-10800)], [1937087, 0, (-10800), (-12600)], [1937304, 0, (-12600), (-10800)], [1938086, 0, (-10800), (-12600)], [1938303, 0, (-12600), (-10800)], [1939085, 0, (-10800), (-12600)], [1939274, 0, (-12600), (-10800)], [1940091, 0, (-10800), (-12600)], [1940301, 0, (-12600), (-10800)], [1941089, 0, (-10800), (-12600)], [1941213, 0, (-12600), (-10800)], [1942348, 0, (-10800), (-9000)], [1943073, 0, (-9000), (-10800)], [1959144, 0, (-10800), (-9000)], [1959319, 0, (-9000), (-10800)], [1960017, 0, (-10800), (-7200)], [1960066, 0, (-7200), (-10800)], [1965094, 0, (-10800), (-7200)], [1965269, 0, (-7200), (-10800)], [1968148, 0, (-10800), (-9000)], [1968336, 0, (-9000), (-10800)], [1970115, 0, (-10800), (-7200)], [1970165, 0, (-7200), (-10800)], [1972114, 0, (-10800), (-7200)], [1972198, 0, (-7200), (-10800)], [1974013, 0, (-10800), (-5400)], [1974069, 0, (-5400), (-9000)], [1974244, 0, (-9000), (-10800)], [1974356, 0, (-10800), (-7200)], [1975089, 0, (-7200), (-10800)], [1976354, 0, (-10800), (-7200)], [1977065, 0, (-7200), (-10800)], [1977338, 0, (-10800), (-7200)], [1978064, 0, (-7200), (-10800)], [1978351, 0, (-10800), (-7200)], [1979063, 0, (-7200), (-10800)], [1979119, 0, (-10800), (-7200)], [1980076, 0, (-7200), (-10800)], [1987348, 0, (-10800), (-7200)], [1988059, 0, (-7200), (-10800)], [1988346, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989302, 0, (-10800), (-7200)], [1990056, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991300, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993059, 0, (-7200), (-10800)], [2004263, 0, (-10800), (-7200)], [2005086, 7200, (-7200), (-10800)], [2005282, 7200, (-10800), (-7200)], [2006071, 7200, (-7200), (-10800)], [2006274, 7200, (-10800), (-7200)], [2007070, 7200, (-7200), (-10800)], [2007280, 7200, (-10800), (-7200)], [2008069, 7200, (-7200), (-10800)], [2008279, 7200, (-10800), (-7200)], [2009067, 7200, (-7200), (-10800)], [2009277, 7200, (-10800), (-7200)], [2010073, 7200, (-7200), (-10800)], [2010276, 7200, (-10800), (-7200)], [2011072, 7200, (-7200), (-10800)], [2011275, 7200, (-10800), (-7200)], [2012071, 7200, (-7200), (-10800)], [2012281, 7200, (-10800), (-7200)], [2013069, 7200, (-7200), (-10800)], [2013279, 7200, (-10800), (-7200)], [2014068, 7200, (-7200), (-10800)], [2014278, 7200, (-10800), (-7200)], [2015067, 7200, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amede$__f_America_Montevideo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amede$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amede$.prototype.constructor = $c_Lzonedb_java_tzdb$amede$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amede$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amede$.prototype = $c_Lzonedb_java_tzdb$amede$.prototype;
var $d_Lzonedb_java_tzdb$amede$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amede$: 0
}, false, "zonedb.java.tzdb$amede$", {
  Lzonedb_java_tzdb$amede$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amede$.prototype.$classData = $d_Lzonedb_java_tzdb$amede$;
var $n_Lzonedb_java_tzdb$amede$;
function $m_Lzonedb_java_tzdb$amede$() {
  if ((!$n_Lzonedb_java_tzdb$amede$)) {
    $n_Lzonedb_java_tzdb$amede$ = new $c_Lzonedb_java_tzdb$amede$()
  };
  return $n_Lzonedb_java_tzdb$amede$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amedo$() {
  this.Lzonedb_java_tzdb$amedo$__f_America_El_Salvador = null;
  this.Lzonedb_java_tzdb$amedo$__f_America_Barbados = null;
  $n_Lzonedb_java_tzdb$amedo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21408));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21408));
  var _2 = [[1921001, 0, (-21408), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921001, 0, (-21408), (-21600)], [1987123, 0, (-21600), (-18000)], [1987270, 0, (-18000), (-21600)], [1988122, 0, (-21600), (-18000)], [1988269, 0, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amedo$__f_America_El_Salvador = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-14309));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-14309));
  var _2$3 = [[1932001, 0, (-14309), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1932001, 0, (-14309), (-14400)], [1977163, 7200, (-14400), (-10800)], [1977275, 7200, (-10800), (-14400)], [1978106, 7200, (-14400), (-10800)], [1978274, 7200, (-10800), (-14400)], [1979105, 7200, (-14400), (-10800)], [1979273, 7200, (-10800), (-14400)], [1980111, 7200, (-14400), (-10800)], [1980269, 7200, (-10800), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amedo$__f_America_Barbados = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amedo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amedo$.prototype.constructor = $c_Lzonedb_java_tzdb$amedo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amedo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amedo$.prototype = $c_Lzonedb_java_tzdb$amedo$.prototype;
var $d_Lzonedb_java_tzdb$amedo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amedo$: 0
}, false, "zonedb.java.tzdb$amedo$", {
  Lzonedb_java_tzdb$amedo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amedo$.prototype.$classData = $d_Lzonedb_java_tzdb$amedo$;
var $n_Lzonedb_java_tzdb$amedo$;
function $m_Lzonedb_java_tzdb$amedo$() {
  if ((!$n_Lzonedb_java_tzdb$amedo$)) {
    $n_Lzonedb_java_tzdb$amedo$ = new $c_Lzonedb_java_tzdb$amedo$()
  };
  return $n_Lzonedb_java_tzdb$amedo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameea$() {
  this.Lzonedb_java_tzdb$ameea$__f_America_Juneau = null;
  $n_Lzonedb_java_tzdb$ameea$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 54139);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 54139);
  var _2 = [[1867292, 56012, 54139, (-32261)], [1900232, 43200, (-32261), (-28800)], [1980118, 7200, (-28800), (-32400)], [1980300, 3600, (-32400), (-28800)], [1983303, 3600, (-28800), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 56012, 54139, (-32261)], [1900232, 43200, (-32261), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameea$__f_America_Juneau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameea$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameea$.prototype.constructor = $c_Lzonedb_java_tzdb$ameea$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameea$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameea$.prototype = $c_Lzonedb_java_tzdb$ameea$.prototype;
var $d_Lzonedb_java_tzdb$ameea$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameea$: 0
}, false, "zonedb.java.tzdb$ameea$", {
  Lzonedb_java_tzdb$ameea$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameea$.prototype.$classData = $d_Lzonedb_java_tzdb$ameea$;
var $n_Lzonedb_java_tzdb$ameea$;
function $m_Lzonedb_java_tzdb$ameea$() {
  if ((!$n_Lzonedb_java_tzdb$ameea$)) {
    $n_Lzonedb_java_tzdb$ameea$ = new $c_Lzonedb_java_tzdb$ameea$()
  };
  return $n_Lzonedb_java_tzdb$ameea$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameee$() {
  this.Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek = null;
  $n_Lzonedb_java_tzdb$ameee$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-28856));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-28856));
  var _2 = [[1884001, 0, (-28856), (-28800)], [1972243, 3600, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, (-28856), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameee$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameee$.prototype.constructor = $c_Lzonedb_java_tzdb$ameee$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameee$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameee$.prototype = $c_Lzonedb_java_tzdb$ameee$.prototype;
var $d_Lzonedb_java_tzdb$ameee$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameee$: 0
}, false, "zonedb.java.tzdb$ameee$", {
  Lzonedb_java_tzdb$ameee$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameee$.prototype.$classData = $d_Lzonedb_java_tzdb$ameee$;
var $n_Lzonedb_java_tzdb$ameee$;
function $m_Lzonedb_java_tzdb$ameee$() {
  if ((!$n_Lzonedb_java_tzdb$ameee$)) {
    $n_Lzonedb_java_tzdb$ameee$ = new $c_Lzonedb_java_tzdb$ameee$()
  };
  return $n_Lzonedb_java_tzdb$ameee$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameei$() {
  this.Lzonedb_java_tzdb$ameei$__f_America_Maceio = null;
  $n_Lzonedb_java_tzdb$ameei$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-8572));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-8572));
  var _2 = [[1914001, 0, (-8572), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-8572), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000296, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameei$__f_America_Maceio = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameei$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameei$.prototype.constructor = $c_Lzonedb_java_tzdb$ameei$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameei$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameei$.prototype = $c_Lzonedb_java_tzdb$ameei$.prototype;
var $d_Lzonedb_java_tzdb$ameei$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameei$: 0
}, false, "zonedb.java.tzdb$ameei$", {
  Lzonedb_java_tzdb$ameei$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameei$.prototype.$classData = $d_Lzonedb_java_tzdb$ameei$;
var $n_Lzonedb_java_tzdb$ameei$;
function $m_Lzonedb_java_tzdb$ameei$() {
  if ((!$n_Lzonedb_java_tzdb$ameei$)) {
    $n_Lzonedb_java_tzdb$ameei$ = new $c_Lzonedb_java_tzdb$ameei$()
  };
  return $n_Lzonedb_java_tzdb$ameei$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameen$() {
  this.Lzonedb_java_tzdb$ameen$__f_America_Swift_Current = null;
  $n_Lzonedb_java_tzdb$ameen$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25880));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25880));
  var _2 = [[1905244, 0, (-25880), (-25200)], [1972121, 7200, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905244, 0, (-25880), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1946118, 7200, (-25200), (-21600)], [1946286, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1948116, 7200, (-25200), (-21600)], [1948270, 7200, (-21600), (-25200)], [1949114, 7200, (-25200), (-21600)], [1949268, 7200, (-21600), (-25200)], [1957118, 7200, (-25200), (-21600)], [1957300, 7200, (-21600), (-25200)], [1959116, 7200, (-25200), (-21600)], [1959298, 7200, (-21600), (-25200)], [1960115, 7200, (-25200), (-21600)], [1960269, 7200, (-21600), (-25200)], [1961120, 7200, (-25200), (-21600)], [1961267, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameen$__f_America_Swift_Current = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameen$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameen$.prototype.constructor = $c_Lzonedb_java_tzdb$ameen$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameen$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameen$.prototype = $c_Lzonedb_java_tzdb$ameen$.prototype;
var $d_Lzonedb_java_tzdb$ameen$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameen$: 0
}, false, "zonedb.java.tzdb$ameen$", {
  Lzonedb_java_tzdb$ameen$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameen$.prototype.$classData = $d_Lzonedb_java_tzdb$ameen$;
var $n_Lzonedb_java_tzdb$ameen$;
function $m_Lzonedb_java_tzdb$ameen$() {
  if ((!$n_Lzonedb_java_tzdb$ameen$)) {
    $n_Lzonedb_java_tzdb$ameen$ = new $c_Lzonedb_java_tzdb$ameen$()
  };
  return $n_Lzonedb_java_tzdb$ameen$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameep$() {
  this.Lzonedb_java_tzdb$ameep$__f_America_Eirunepe = null;
  $n_Lzonedb_java_tzdb$ameep$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16768));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16768));
  var _2 = [[1914001, 0, (-16768), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-16768), (-18000)], [1931276, 39600, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932277, 0, (-18000), (-14400)], [1933091, 0, (-14400), (-18000)], [1949335, 0, (-18000), (-14400)], [1950106, 3600, (-14400), (-18000)], [1950335, 0, (-18000), (-14400)], [1951091, 0, (-14400), (-18000)], [1951335, 0, (-18000), (-14400)], [1952092, 0, (-14400), (-18000)], [1952336, 0, (-18000), (-14400)], [1953060, 0, (-14400), (-18000)], [1963343, 0, (-18000), (-14400)], [1964061, 0, (-14400), (-18000)], [1965031, 0, (-18000), (-14400)], [1965090, 0, (-14400), (-18000)], [1965335, 0, (-18000), (-14400)], [1966060, 0, (-14400), (-18000)], [1966305, 0, (-18000), (-14400)], [1967060, 0, (-14400), (-18000)], [1967305, 0, (-18000), (-14400)], [1968061, 0, (-14400), (-18000)], [1985306, 0, (-18000), (-14400)], [1986074, 0, (-14400), (-18000)], [1986298, 0, (-18000), (-14400)], [1987045, 0, (-14400), (-18000)], [1987298, 0, (-18000), (-14400)], [1988038, 0, (-14400), (-18000)], [1993290, 0, (-18000), (-14400)], [1994051, 0, (-14400), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameep$__f_America_Eirunepe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameep$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameep$.prototype.constructor = $c_Lzonedb_java_tzdb$ameep$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameep$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameep$.prototype = $c_Lzonedb_java_tzdb$ameep$.prototype;
var $d_Lzonedb_java_tzdb$ameep$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameep$: 0
}, false, "zonedb.java.tzdb$ameep$", {
  Lzonedb_java_tzdb$ameep$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameep$.prototype.$classData = $d_Lzonedb_java_tzdb$ameep$;
var $n_Lzonedb_java_tzdb$ameep$;
function $m_Lzonedb_java_tzdb$ameep$() {
  if ((!$n_Lzonedb_java_tzdb$ameep$)) {
    $n_Lzonedb_java_tzdb$ameep$ = new $c_Lzonedb_java_tzdb$ameep$()
  };
  return $n_Lzonedb_java_tzdb$ameep$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameez$() {
  this.Lzonedb_java_tzdb$ameez$__f_America_Fortaleza = null;
  $n_Lzonedb_java_tzdb$ameez$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-9240));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-9240));
  var _2 = [[1914001, 0, (-9240), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-9240), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000296, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameez$__f_America_Fortaleza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameez$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameez$.prototype.constructor = $c_Lzonedb_java_tzdb$ameez$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameez$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameez$.prototype = $c_Lzonedb_java_tzdb$ameez$.prototype;
var $d_Lzonedb_java_tzdb$ameez$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameez$: 0
}, false, "zonedb.java.tzdb$ameez$", {
  Lzonedb_java_tzdb$ameez$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameez$.prototype.$classData = $d_Lzonedb_java_tzdb$ameez$;
var $n_Lzonedb_java_tzdb$ameez$;
function $m_Lzonedb_java_tzdb$ameez$() {
  if ((!$n_Lzonedb_java_tzdb$ameez$)) {
    $n_Lzonedb_java_tzdb$ameez$ = new $c_Lzonedb_java_tzdb$ameez$()
  };
  return $n_Lzonedb_java_tzdb$ameez$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amefa$() {
  this.Lzonedb_java_tzdb$amefa$__f_America_Halifax = null;
  $n_Lzonedb_java_tzdb$amefa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15264));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15264));
  var _2 = [[1902166, 0, (-15264), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1902166, 0, (-15264), (-14400)], [1916092, 0, (-14400), (-10800)], [1916275, 0, (-10800), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1920130, 0, (-14400), (-10800)], [1920242, 0, (-10800), (-14400)], [1921126, 0, (-14400), (-10800)], [1921248, 0, (-10800), (-14400)], [1922120, 0, (-14400), (-10800)], [1922248, 0, (-10800), (-14400)], [1923126, 0, (-14400), (-10800)], [1923247, 0, (-10800), (-14400)], [1924125, 0, (-14400), (-10800)], [1924259, 0, (-10800), (-14400)], [1925123, 0, (-14400), (-10800)], [1925271, 0, (-10800), (-14400)], [1926136, 0, (-14400), (-10800)], [1926256, 0, (-10800), (-14400)], [1927121, 0, (-14400), (-10800)], [1927269, 0, (-10800), (-14400)], [1928134, 0, (-14400), (-10800)], [1928253, 0, (-10800), (-14400)], [1929132, 0, (-14400), (-10800)], [1929246, 0, (-10800), (-14400)], [1930131, 0, (-14400), (-10800)], [1930258, 0, (-10800), (-14400)], [1931130, 0, (-14400), (-10800)], [1931271, 0, (-10800), (-14400)], [1932122, 0, (-14400), (-10800)], [1932270, 0, (-10800), (-14400)], [1933120, 0, (-14400), (-10800)], [1933275, 0, (-10800), (-14400)], [1934140, 0, (-14400), (-10800)], [1934259, 0, (-10800), (-14400)], [1935153, 0, (-14400), (-10800)], [1935273, 0, (-10800), (-14400)], [1936153, 0, (-14400), (-10800)], [1936258, 0, (-10800), (-14400)], [1937122, 0, (-14400), (-10800)], [1937270, 0, (-10800), (-14400)], [1938121, 0, (-14400), (-10800)], [1938269, 0, (-10800), (-14400)], [1939148, 0, (-14400), (-10800)], [1939268, 0, (-10800), (-14400)], [1940126, 0, (-14400), (-10800)], [1940274, 0, (-10800), (-14400)], [1941124, 0, (-14400), (-10800)], [1941272, 0, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1946118, 7200, (-14400), (-10800)], [1946272, 7200, (-10800), (-14400)], [1947117, 7200, (-14400), (-10800)], [1947271, 7200, (-10800), (-14400)], [1948116, 7200, (-14400), (-10800)], [1948270, 7200, (-10800), (-14400)], [1949114, 7200, (-14400), (-10800)], [1949268, 7200, (-10800), (-14400)], [1951119, 7200, (-14400), (-10800)], [1951273, 7200, (-10800), (-14400)], [1952118, 7200, (-14400), (-10800)], [1952272, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1954115, 7200, (-14400), (-10800)], [1954269, 7200, (-10800), (-14400)], [1956120, 7200, (-14400), (-10800)], [1956274, 7200, (-10800), (-14400)], [1957118, 7200, (-14400), (-10800)], [1957272, 7200, (-10800), (-14400)], [1958117, 7200, (-14400), (-10800)], [1958271, 7200, (-10800), (-14400)], [1959116, 7200, (-14400), (-10800)], [1959270, 7200, (-10800), (-14400)], [1962119, 7200, (-14400), (-10800)], [1962301, 7200, (-10800), (-14400)], [1963118, 7200, (-14400), (-10800)], [1963300, 7200, (-10800), (-14400)], [1964117, 7200, (-14400), (-10800)], [1964299, 7200, (-10800), (-14400)], [1965115, 7200, (-14400), (-10800)], [1965304, 7200, (-10800), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amefa$__f_America_Halifax = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amefa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amefa$.prototype.constructor = $c_Lzonedb_java_tzdb$amefa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amefa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amefa$.prototype = $c_Lzonedb_java_tzdb$amefa$.prototype;
var $d_Lzonedb_java_tzdb$amefa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amefa$: 0
}, false, "zonedb.java.tzdb$amefa$", {
  Lzonedb_java_tzdb$amefa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amefa$.prototype.$classData = $d_Lzonedb_java_tzdb$amefa$;
var $n_Lzonedb_java_tzdb$amefa$;
function $m_Lzonedb_java_tzdb$amefa$() {
  if ((!$n_Lzonedb_java_tzdb$amefa$)) {
    $n_Lzonedb_java_tzdb$amefa$ = new $c_Lzonedb_java_tzdb$amefa$()
  };
  return $n_Lzonedb_java_tzdb$amefa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amego$() {
  this.Lzonedb_java_tzdb$amego$__f_America_Nipigon = null;
  this.Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos = null;
  $n_Lzonedb_java_tzdb$amego$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21184));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21184));
  var _2 = [[1895001, 0, (-21184), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, (-21184), (-18000)], [1918104, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1940273, 0, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amego$__f_America_Nipigon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-16612));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-16612));
  var _2$3 = [[1894304, 0, (-16612), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1894304, 0, (-16612), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amego$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amego$.prototype.constructor = $c_Lzonedb_java_tzdb$amego$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amego$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amego$.prototype = $c_Lzonedb_java_tzdb$amego$.prototype;
var $d_Lzonedb_java_tzdb$amego$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amego$: 0
}, false, "zonedb.java.tzdb$amego$", {
  Lzonedb_java_tzdb$amego$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amego$.prototype.$classData = $d_Lzonedb_java_tzdb$amego$;
var $n_Lzonedb_java_tzdb$amego$;
function $m_Lzonedb_java_tzdb$amego$() {
  if ((!$n_Lzonedb_java_tzdb$amego$)) {
    $n_Lzonedb_java_tzdb$amego$ = new $c_Lzonedb_java_tzdb$amego$()
  };
  return $n_Lzonedb_java_tzdb$amego$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amegu$() {
  this.Lzonedb_java_tzdb$amegu$__f_America_Managua = null;
  $n_Lzonedb_java_tzdb$amegu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20708));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20708));
  var _2 = [[1890001, 0, (-20708), (-20712)], [1934174, 0, (-20712), (-21600)], [1973121, 0, (-21600), (-18000)], [1975047, 0, (-18000), (-21600)], [1992001, 14400, (-21600), (-18000)], [1992268, 0, (-18000), (-21600)], [1993001, 0, (-21600), (-18000)], [1997001, 0, (-18000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-20708), (-20712)], [1934174, 0, (-20712), (-21600)], [1973121, 0, (-21600), (-18000)], [1975047, 0, (-18000), (-21600)], [1979077, 0, (-21600), (-18000)], [1979176, 0, (-18000), (-21600)], [1980076, 0, (-21600), (-18000)], [1980175, 0, (-18000), (-21600)], [1992001, 14400, (-21600), (-18000)], [1992268, 0, (-18000), (-21600)], [1993001, 0, (-21600), (-18000)], [1997001, 0, (-18000), (-21600)], [2005100, 0, (-21600), (-18000)], [2005275, 0, (-18000), (-21600)], [2006120, 7200, (-21600), (-18000)], [2006274, 3600, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amegu$__f_America_Managua = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amegu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amegu$.prototype.constructor = $c_Lzonedb_java_tzdb$amegu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amegu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amegu$.prototype = $c_Lzonedb_java_tzdb$amegu$.prototype;
var $d_Lzonedb_java_tzdb$amegu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amegu$: 0
}, false, "zonedb.java.tzdb$amegu$", {
  Lzonedb_java_tzdb$amegu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amegu$.prototype.$classData = $d_Lzonedb_java_tzdb$amegu$;
var $n_Lzonedb_java_tzdb$amegu$;
function $m_Lzonedb_java_tzdb$amegu$() {
  if ((!$n_Lzonedb_java_tzdb$amegu$)) {
    $n_Lzonedb_java_tzdb$amegu$ = new $c_Lzonedb_java_tzdb$amegu$()
  };
  return $n_Lzonedb_java_tzdb$amegu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameha$() {
  this.Lzonedb_java_tzdb$ameha$__f_America_Godthab = null;
  $n_Lzonedb_java_tzdb$ameha$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-12416));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-12416));
  var _2 = [[1916210, 0, (-12416), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916210, 0, (-12416), (-10800)], [1980097, 7200, (-10800), (-7200)], [1980271, 82800, (-7200), (-10800)], [1981087, 79200, (-10800), (-7200)], [1981269, 82800, (-7200), (-10800)], [1982086, 79200, (-10800), (-7200)], [1982268, 82800, (-7200), (-10800)], [1983085, 79200, (-10800), (-7200)], [1983267, 82800, (-7200), (-10800)], [1984084, 79200, (-10800), (-7200)], [1984273, 82800, (-7200), (-10800)], [1985089, 79200, (-10800), (-7200)], [1985271, 82800, (-7200), (-10800)], [1986088, 79200, (-10800), (-7200)], [1986270, 82800, (-7200), (-10800)], [1987087, 79200, (-10800), (-7200)], [1987269, 82800, (-7200), (-10800)], [1988086, 79200, (-10800), (-7200)], [1988268, 82800, (-7200), (-10800)], [1989084, 79200, (-10800), (-7200)], [1989266, 82800, (-7200), (-10800)], [1990083, 79200, (-10800), (-7200)], [1990272, 82800, (-7200), (-10800)], [1991089, 79200, (-10800), (-7200)], [1991271, 82800, (-7200), (-10800)], [1992088, 79200, (-10800), (-7200)], [1992270, 82800, (-7200), (-10800)], [1993086, 79200, (-10800), (-7200)], [1993268, 82800, (-7200), (-10800)], [1994085, 79200, (-10800), (-7200)], [1994267, 82800, (-7200), (-10800)], [1995084, 79200, (-10800), (-7200)], [1995266, 82800, (-7200), (-10800)], [1996090, 79200, (-10800), (-7200)], [1996300, 82800, (-7200), (-10800)], [1997088, 79200, (-10800), (-7200)], [1997298, 82800, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, (-10800), (-10800), (-7200)], [10, 25, 7, 3600, 0, 0, (-10800), (-7200), (-10800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameha$__f_America_Godthab = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameha$.prototype.constructor = $c_Lzonedb_java_tzdb$ameha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameha$.prototype = $c_Lzonedb_java_tzdb$ameha$.prototype;
var $d_Lzonedb_java_tzdb$ameha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameha$: 0
}, false, "zonedb.java.tzdb$ameha$", {
  Lzonedb_java_tzdb$ameha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameha$.prototype.$classData = $d_Lzonedb_java_tzdb$ameha$;
var $n_Lzonedb_java_tzdb$ameha$;
function $m_Lzonedb_java_tzdb$ameha$() {
  if ((!$n_Lzonedb_java_tzdb$ameha$)) {
    $n_Lzonedb_java_tzdb$ameha$ = new $c_Lzonedb_java_tzdb$ameha$()
  };
  return $n_Lzonedb_java_tzdb$ameha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehi$() {
  this.Lzonedb_java_tzdb$amehi$__f_America_Bahia = null;
  $n_Lzonedb_java_tzdb$amehi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-9244));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-9244));
  var _2 = [[1914001, 0, (-9244), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-9244), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991048, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992040, 0, (-7200), (-10800)], [1992299, 0, (-10800), (-7200)], [1993031, 0, (-7200), (-10800)], [1993290, 0, (-10800), (-7200)], [1994051, 0, (-7200), (-10800)], [1994289, 0, (-10800), (-7200)], [1995050, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2011289, 0, (-10800), (-7200)], [2012057, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amehi$__f_America_Bahia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amehi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehi$.prototype.constructor = $c_Lzonedb_java_tzdb$amehi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehi$.prototype = $c_Lzonedb_java_tzdb$amehi$.prototype;
var $d_Lzonedb_java_tzdb$amehi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehi$: 0
}, false, "zonedb.java.tzdb$amehi$", {
  Lzonedb_java_tzdb$amehi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehi$.prototype.$classData = $d_Lzonedb_java_tzdb$amehi$;
var $n_Lzonedb_java_tzdb$amehi$;
function $m_Lzonedb_java_tzdb$amehi$() {
  if ((!$n_Lzonedb_java_tzdb$amehi$)) {
    $n_Lzonedb_java_tzdb$amehi$ = new $c_Lzonedb_java_tzdb$amehi$()
  };
  return $n_Lzonedb_java_tzdb$amehi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehn$() {
  this.Lzonedb_java_tzdb$amehn$__f_America_St_Johns = null;
  $n_Lzonedb_java_tzdb$amehn$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-12652));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-12652));
  var _2 = [[1935089, 0, (-12652), (-12600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1917098, 7200, (-12652), (-9052)], [1917260, 7200, (-9052), (-12652)], [1918104, 7200, (-12652), (-9052)], [1918300, 7200, (-9052), (-12652)], [1919125, 82800, (-12652), (-9052)], [1919224, 82800, (-9052), (-12652)], [1920123, 82800, (-12652), (-9052)], [1920305, 82800, (-9052), (-12652)], [1921121, 82800, (-12652), (-9052)], [1921303, 82800, (-9052), (-12652)], [1922127, 82800, (-12652), (-9052)], [1922302, 82800, (-9052), (-12652)], [1923126, 82800, (-12652), (-9052)], [1923301, 82800, (-9052), (-12652)], [1924125, 82800, (-12652), (-9052)], [1924300, 82800, (-9052), (-12652)], [1925123, 82800, (-12652), (-9052)], [1925298, 82800, (-9052), (-12652)], [1926122, 82800, (-12652), (-9052)], [1926304, 82800, (-9052), (-12652)], [1927121, 82800, (-12652), (-9052)], [1927303, 82800, (-9052), (-12652)], [1928127, 82800, (-12652), (-9052)], [1928302, 82800, (-9052), (-12652)], [1929125, 82800, (-12652), (-9052)], [1929300, 82800, (-9052), (-12652)], [1930124, 82800, (-12652), (-9052)], [1930299, 82800, (-9052), (-12652)], [1931123, 82800, (-12652), (-9052)], [1931298, 82800, (-9052), (-12652)], [1932122, 82800, (-12652), (-9052)], [1932304, 82800, (-9052), (-12652)], [1933127, 82800, (-12652), (-9052)], [1933302, 82800, (-9052), (-12652)], [1934126, 82800, (-12652), (-9052)], [1934301, 82800, (-9052), (-12652)], [1935089, 0, (-12652), (-12600)], [1935125, 82800, (-12600), (-9000)], [1935300, 82800, (-9000), (-12600)], [1936132, 0, (-12600), (-9000)], [1936279, 0, (-9000), (-12600)], [1937130, 0, (-12600), (-9000)], [1937277, 0, (-9000), (-12600)], [1938129, 0, (-12600), (-9000)], [1938276, 0, (-9000), (-12600)], [1939135, 0, (-12600), (-9000)], [1939275, 0, (-9000), (-12600)], [1940134, 0, (-12600), (-9000)], [1940281, 0, (-9000), (-12600)], [1941132, 0, (-12600), (-9000)], [1941279, 0, (-9000), (-12600)], [1942131, 0, (-12600), (-9000)], [1945273, 7200, (-9000), (-12600)], [1946132, 7200, (-12600), (-9000)], [1946279, 7200, (-9000), (-12600)], [1947131, 7200, (-12600), (-9000)], [1947278, 7200, (-9000), (-12600)], [1948130, 7200, (-12600), (-9000)], [1948277, 7200, (-9000), (-12600)], [1949128, 7200, (-12600), (-9000)], [1949275, 7200, (-9000), (-12600)], [1950134, 7200, (-12600), (-9000)], [1950281, 7200, (-9000), (-12600)], [1951119, 7200, (-12600), (-9000)], [1951273, 7200, (-9000), (-12600)], [1952118, 7200, (-12600), (-9000)], [1952272, 7200, (-9000), (-12600)], [1953116, 7200, (-12600), (-9000)], [1953270, 7200, (-9000), (-12600)], [1954115, 7200, (-12600), (-9000)], [1954269, 7200, (-9000), (-12600)], [1955114, 7200, (-12600), (-9000)], [1955268, 7200, (-9000), (-12600)], [1956120, 7200, (-12600), (-9000)], [1956274, 7200, (-9000), (-12600)], [1957118, 7200, (-12600), (-9000)], [1957272, 7200, (-9000), (-12600)], [1958117, 7200, (-12600), (-9000)], [1958271, 7200, (-9000), (-12600)], [1959116, 7200, (-12600), (-9000)], [1959270, 7200, (-9000), (-12600)], [1960115, 7200, (-12600), (-9000)], [1960304, 7200, (-9000), (-12600)], [1961120, 7200, (-12600), (-9000)], [1961302, 7200, (-9000), (-12600)], [1962119, 7200, (-12600), (-9000)], [1962301, 7200, (-9000), (-12600)], [1963118, 7200, (-12600), (-9000)], [1963300, 7200, (-9000), (-12600)], [1964117, 7200, (-12600), (-9000)], [1964299, 7200, (-9000), (-12600)], [1965115, 7200, (-12600), (-9000)], [1965304, 7200, (-9000), (-12600)], [1966114, 7200, (-12600), (-9000)], [1966303, 7200, (-9000), (-12600)], [1967120, 7200, (-12600), (-9000)], [1967302, 7200, (-9000), (-12600)], [1968119, 7200, (-12600), (-9000)], [1968301, 7200, (-9000), (-12600)], [1969117, 7200, (-12600), (-9000)], [1969299, 7200, (-9000), (-12600)], [1970116, 7200, (-12600), (-9000)], [1970298, 7200, (-9000), (-12600)], [1971115, 7200, (-12600), (-9000)], [1971304, 7200, (-9000), (-12600)], [1972121, 7200, (-12600), (-9000)], [1972303, 7200, (-9000), (-12600)], [1973119, 7200, (-12600), (-9000)], [1973301, 7200, (-9000), (-12600)], [1974118, 7200, (-12600), (-9000)], [1974300, 7200, (-9000), (-12600)], [1975117, 7200, (-12600), (-9000)], [1975299, 7200, (-9000), (-12600)], [1976116, 7200, (-12600), (-9000)], [1976305, 7200, (-9000), (-12600)], [1977114, 7200, (-12600), (-9000)], [1977303, 7200, (-9000), (-12600)], [1978120, 7200, (-12600), (-9000)], [1978302, 7200, (-9000), (-12600)], [1979119, 7200, (-12600), (-9000)], [1979301, 7200, (-9000), (-12600)], [1980118, 7200, (-12600), (-9000)], [1980300, 7200, (-9000), (-12600)], [1981116, 7200, (-12600), (-9000)], [1981298, 7200, (-9000), (-12600)], [1982115, 7200, (-12600), (-9000)], [1982304, 7200, (-9000), (-12600)], [1983114, 7200, (-12600), (-9000)], [1983303, 7200, (-9000), (-12600)], [1984120, 7200, (-12600), (-9000)], [1984302, 7200, (-9000), (-12600)], [1985118, 7200, (-12600), (-9000)], [1985300, 7200, (-9000), (-12600)], [1986117, 7200, (-12600), (-9000)], [1986299, 7200, (-9000), (-12600)], [1987095, 60, (-12600), (-9000)], [1987298, 60, (-9000), (-12600)], [1988094, 60, (-12600), (-5400)], [1988304, 60, (-5400), (-12600)], [1989092, 60, (-12600), (-9000)], [1989302, 60, (-9000), (-12600)], [1990091, 60, (-12600), (-9000)], [1990301, 60, (-9000), (-12600)], [1991097, 60, (-12600), (-9000)], [1991300, 60, (-9000), (-12600)], [1992096, 60, (-12600), (-9000)], [1992299, 60, (-9000), (-12600)], [1993094, 60, (-12600), (-9000)], [1993304, 60, (-9000), (-12600)], [1994093, 60, (-12600), (-9000)], [1994303, 60, (-9000), (-12600)], [1995092, 60, (-12600), (-9000)], [1995302, 60, (-9000), (-12600)], [1996098, 60, (-12600), (-9000)], [1996301, 60, (-9000), (-12600)], [1997096, 60, (-12600), (-9000)], [1997299, 60, (-9000), (-12600)], [1998095, 60, (-12600), (-9000)], [1998298, 60, (-9000), (-12600)], [1999094, 60, (-12600), (-9000)], [1999304, 60, (-9000), (-12600)], [2000093, 60, (-12600), (-9000)], [2000303, 60, (-9000), (-12600)], [2001091, 60, (-12600), (-9000)], [2001301, 60, (-9000), (-12600)], [2002097, 60, (-12600), (-9000)], [2002300, 60, (-9000), (-12600)], [2003096, 60, (-12600), (-9000)], [2003299, 60, (-9000), (-12600)], [2004095, 60, (-12600), (-9000)], [2004305, 60, (-9000), (-12600)], [2005093, 60, (-12600), (-9000)], [2005303, 60, (-9000), (-12600)], [2006092, 60, (-12600), (-9000)], [2006302, 60, (-9000), (-12600)], [2007070, 60, (-12600), (-9000)], [2007308, 60, (-9000), (-12600)], [2008069, 60, (-12600), (-9000)], [2008307, 60, (-9000), (-12600)], [2009067, 60, (-12600), (-9000)], [2009305, 60, (-9000), (-12600)], [2010073, 60, (-12600), (-9000)], [2010311, 60, (-9000), (-12600)], [2011072, 60, (-12600), (-9000)], [2011310, 7200, (-9000), (-12600)], [2012071, 7200, (-12600), (-9000)], [2012309, 7200, (-9000), (-12600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-12600), (-12600), (-9000)], [11, 1, 7, 7200, 0, 1, (-12600), (-9000), (-12600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amehn$__f_America_St_Johns = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amehn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehn$.prototype.constructor = $c_Lzonedb_java_tzdb$amehn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehn$.prototype = $c_Lzonedb_java_tzdb$amehn$.prototype;
var $d_Lzonedb_java_tzdb$amehn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehn$: 0
}, false, "zonedb.java.tzdb$amehn$", {
  Lzonedb_java_tzdb$amehn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehn$.prototype.$classData = $d_Lzonedb_java_tzdb$amehn$;
var $n_Lzonedb_java_tzdb$amehn$;
function $m_Lzonedb_java_tzdb$amehn$() {
  if ((!$n_Lzonedb_java_tzdb$amehn$)) {
    $n_Lzonedb_java_tzdb$amehn$ = new $c_Lzonedb_java_tzdb$amehn$()
  };
  return $n_Lzonedb_java_tzdb$amehn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehu$() {
  this.Lzonedb_java_tzdb$amehu$__f_America_Chihuahua = null;
  $n_Lzonedb_java_tzdb$amehu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25460));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25460));
  var _2 = [[1921365, 86140, (-25460), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1998095, 10800, (-21600), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921365, 86140, (-25460), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [10, 25, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amehu$__f_America_Chihuahua = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amehu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehu$.prototype.constructor = $c_Lzonedb_java_tzdb$amehu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehu$.prototype = $c_Lzonedb_java_tzdb$amehu$.prototype;
var $d_Lzonedb_java_tzdb$amehu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehu$: 0
}, false, "zonedb.java.tzdb$amehu$", {
  Lzonedb_java_tzdb$amehu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehu$.prototype.$classData = $d_Lzonedb_java_tzdb$amehu$;
var $n_Lzonedb_java_tzdb$amehu$;
function $m_Lzonedb_java_tzdb$amehu$() {
  if ((!$n_Lzonedb_java_tzdb$amehu$)) {
    $n_Lzonedb_java_tzdb$amehu$ = new $c_Lzonedb_java_tzdb$amehu$()
  };
  return $n_Lzonedb_java_tzdb$amehu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameib$() {
  this.Lzonedb_java_tzdb$ameib$__f_America_Paramaribo = null;
  $n_Lzonedb_java_tzdb$ameib$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13240));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13240));
  var _2 = [[1911001, 0, (-13240), (-13252)], [1935001, 0, (-13252), (-13236)], [1945274, 0, (-13236), (-12600)], [1984275, 0, (-12600), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911001, 0, (-13240), (-13252)], [1935001, 0, (-13252), (-13236)], [1945274, 0, (-13236), (-12600)], [1984275, 0, (-12600), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameib$__f_America_Paramaribo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameib$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameib$.prototype.constructor = $c_Lzonedb_java_tzdb$ameib$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameib$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameib$.prototype = $c_Lzonedb_java_tzdb$ameib$.prototype;
var $d_Lzonedb_java_tzdb$ameib$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameib$: 0
}, false, "zonedb.java.tzdb$ameib$", {
  Lzonedb_java_tzdb$ameib$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameib$.prototype.$classData = $d_Lzonedb_java_tzdb$ameib$;
var $n_Lzonedb_java_tzdb$ameib$;
function $m_Lzonedb_java_tzdb$ameib$() {
  if ((!$n_Lzonedb_java_tzdb$ameib$)) {
    $n_Lzonedb_java_tzdb$ameib$ = new $c_Lzonedb_java_tzdb$ameib$()
  };
  return $n_Lzonedb_java_tzdb$ameib$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameic$() {
  this.Lzonedb_java_tzdb$ameic$__f_America_Jamaica = null;
  this.Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica = null;
  this.Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico = null;
  $n_Lzonedb_java_tzdb$ameic$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-18430));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-18430));
  var _2 = [[1912032, 0, (-18430), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912032, 0, (-18430), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameic$__f_America_Jamaica = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-20173));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-20173));
  var _2$3 = [[1921015, 0, (-20173), (-21600)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1921015, 0, (-20173), (-21600)], [1979056, 0, (-21600), (-18000)], [1979154, 0, (-18000), (-21600)], [1980055, 0, (-21600), (-18000)], [1980153, 0, (-18000), (-21600)], [1991019, 0, (-21600), (-18000)], [1991182, 0, (-18000), (-21600)], [1992018, 0, (-21600), (-18000)], [1992075, 0, (-18000), (-21600)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-15865));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-15865));
  var _2$6 = [[1899087, 43200, (-15865), (-14400)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1899087, 43200, (-15865), (-14400)], [1942123, 0, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$ameic$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameic$.prototype.constructor = $c_Lzonedb_java_tzdb$ameic$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameic$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameic$.prototype = $c_Lzonedb_java_tzdb$ameic$.prototype;
var $d_Lzonedb_java_tzdb$ameic$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameic$: 0
}, false, "zonedb.java.tzdb$ameic$", {
  Lzonedb_java_tzdb$ameic$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameic$.prototype.$classData = $d_Lzonedb_java_tzdb$ameic$;
var $n_Lzonedb_java_tzdb$ameic$;
function $m_Lzonedb_java_tzdb$ameic$() {
  if ((!$n_Lzonedb_java_tzdb$ameic$)) {
    $n_Lzonedb_java_tzdb$ameic$ = new $c_Lzonedb_java_tzdb$ameic$()
  };
  return $n_Lzonedb_java_tzdb$ameic$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameid$() {
  this.Lzonedb_java_tzdb$ameid$__f_America_Merida = null;
  $n_Lzonedb_java_tzdb$ameid$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21508));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21508));
  var _2 = [[1922001, 92, (-21508), (-21600)], [1981357, 0, (-21600), (-18000)], [1982336, 0, (-18000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922001, 92, (-21508), (-21600)], [1981357, 0, (-21600), (-18000)], [1982336, 0, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameid$__f_America_Merida = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameid$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameid$.prototype.constructor = $c_Lzonedb_java_tzdb$ameid$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameid$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameid$.prototype = $c_Lzonedb_java_tzdb$ameid$.prototype;
var $d_Lzonedb_java_tzdb$ameid$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameid$: 0
}, false, "zonedb.java.tzdb$ameid$", {
  Lzonedb_java_tzdb$ameid$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameid$.prototype.$classData = $d_Lzonedb_java_tzdb$ameid$;
var $n_Lzonedb_java_tzdb$ameid$;
function $m_Lzonedb_java_tzdb$ameid$() {
  if ((!$n_Lzonedb_java_tzdb$ameid$)) {
    $n_Lzonedb_java_tzdb$ameid$ = new $c_Lzonedb_java_tzdb$ameid$()
  };
  return $n_Lzonedb_java_tzdb$ameid$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameif$() {
  this.Lzonedb_java_tzdb$ameif$__f_America_Recife = null;
  this.Lzonedb_java_tzdb$ameif$__f_America_Yellowknife = null;
  $n_Lzonedb_java_tzdb$ameif$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-8376));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-8376));
  var _2 = [[1914001, 0, (-8376), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-8376), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000289, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameif$__f_America_Recife = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2$3 = [[1935001, 0, 0, (-25200)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1935001, 0, 0, (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 0, (-25200), (-18000)], [1965304, 7200, (-18000), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameif$__f_America_Yellowknife = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameif$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameif$.prototype.constructor = $c_Lzonedb_java_tzdb$ameif$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameif$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameif$.prototype = $c_Lzonedb_java_tzdb$ameif$.prototype;
var $d_Lzonedb_java_tzdb$ameif$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameif$: 0
}, false, "zonedb.java.tzdb$ameif$", {
  Lzonedb_java_tzdb$ameif$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameif$.prototype.$classData = $d_Lzonedb_java_tzdb$ameif$;
var $n_Lzonedb_java_tzdb$ameif$;
function $m_Lzonedb_java_tzdb$ameif$() {
  if ((!$n_Lzonedb_java_tzdb$ameif$)) {
    $n_Lzonedb_java_tzdb$ameif$ = new $c_Lzonedb_java_tzdb$ameif$()
  };
  return $n_Lzonedb_java_tzdb$ameif$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameim$() {
  this.Lzonedb_java_tzdb$ameim$__f_America_Lima = null;
  $n_Lzonedb_java_tzdb$ameim$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-18492));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-18492));
  var _2 = [[1890001, 0, (-18492), (-18516)], [1908210, 0, (-18516), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-18492), (-18516)], [1908210, 0, (-18516), (-18000)], [1938001, 0, (-18000), (-14400)], [1938091, 0, (-14400), (-18000)], [1938268, 0, (-18000), (-14400)], [1939085, 0, (-14400), (-18000)], [1939267, 0, (-18000), (-14400)], [1940084, 0, (-14400), (-18000)], [1986001, 0, (-18000), (-14400)], [1986091, 0, (-14400), (-18000)], [1987001, 0, (-18000), (-14400)], [1987091, 0, (-14400), (-18000)], [1990001, 0, (-18000), (-14400)], [1990091, 0, (-14400), (-18000)], [1994001, 0, (-18000), (-14400)], [1994091, 0, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameim$__f_America_Lima = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameim$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameim$.prototype.constructor = $c_Lzonedb_java_tzdb$ameim$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameim$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameim$.prototype = $c_Lzonedb_java_tzdb$ameim$.prototype;
var $d_Lzonedb_java_tzdb$ameim$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameim$: 0
}, false, "zonedb.java.tzdb$ameim$", {
  Lzonedb_java_tzdb$ameim$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameim$.prototype.$classData = $d_Lzonedb_java_tzdb$ameim$;
var $n_Lzonedb_java_tzdb$ameim$;
function $m_Lzonedb_java_tzdb$ameim$() {
  if ((!$n_Lzonedb_java_tzdb$ameim$)) {
    $n_Lzonedb_java_tzdb$ameim$ = new $c_Lzonedb_java_tzdb$ameim$()
  };
  return $n_Lzonedb_java_tzdb$ameim$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amein$() {
  this.Lzonedb_java_tzdb$amein$__f_America_Regina = null;
  this.Lzonedb_java_tzdb$amein$__f_America_Araguaina = null;
  $n_Lzonedb_java_tzdb$amein$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25116));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25116));
  var _2 = [[1905244, 0, (-25116), (-25200)], [1960115, 7200, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905244, 0, (-25116), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1930124, 0, (-25200), (-21600)], [1930278, 0, (-21600), (-25200)], [1931123, 0, (-25200), (-21600)], [1931277, 0, (-21600), (-25200)], [1932122, 0, (-25200), (-21600)], [1932276, 0, (-21600), (-25200)], [1933127, 0, (-25200), (-21600)], [1933274, 0, (-21600), (-25200)], [1934126, 0, (-25200), (-21600)], [1934280, 0, (-21600), (-25200)], [1937101, 0, (-25200), (-21600)], [1937283, 0, (-21600), (-25200)], [1938100, 0, (-25200), (-21600)], [1938275, 0, (-21600), (-25200)], [1939099, 0, (-25200), (-21600)], [1939281, 0, (-21600), (-25200)], [1940105, 0, (-25200), (-21600)], [1940287, 0, (-21600), (-25200)], [1941103, 0, (-25200), (-21600)], [1941285, 0, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1946104, 7200, (-25200), (-21600)], [1946286, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1948116, 7200, (-25200), (-21600)], [1948270, 7200, (-21600), (-25200)], [1949114, 7200, (-25200), (-21600)], [1949268, 7200, (-21600), (-25200)], [1950120, 7200, (-25200), (-21600)], [1950267, 7200, (-21600), (-25200)], [1951119, 7200, (-25200), (-21600)], [1951273, 7200, (-21600), (-25200)], [1952118, 7200, (-25200), (-21600)], [1952272, 7200, (-21600), (-25200)], [1953116, 7200, (-25200), (-21600)], [1953270, 7200, (-21600), (-25200)], [1954115, 7200, (-25200), (-21600)], [1954269, 7200, (-21600), (-25200)], [1955114, 7200, (-25200), (-21600)], [1955268, 7200, (-21600), (-25200)], [1956120, 7200, (-25200), (-21600)], [1956274, 7200, (-21600), (-25200)], [1957118, 7200, (-25200), (-21600)], [1957272, 7200, (-21600), (-25200)], [1959116, 7200, (-25200), (-21600)], [1959298, 7200, (-21600), (-25200)], [1960115, 7200, (-25200), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amein$__f_America_Regina = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-11568));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-11568));
  var _2$3 = [[1914001, 0, (-11568), (-10800)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1914001, 0, (-11568), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2012295, 0, (-10800), (-7200)], [2013048, 0, (-7200), (-10800)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amein$__f_America_Araguaina = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amein$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amein$.prototype.constructor = $c_Lzonedb_java_tzdb$amein$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amein$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amein$.prototype = $c_Lzonedb_java_tzdb$amein$.prototype;
var $d_Lzonedb_java_tzdb$amein$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amein$: 0
}, false, "zonedb.java.tzdb$amein$", {
  Lzonedb_java_tzdb$amein$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amein$.prototype.$classData = $d_Lzonedb_java_tzdb$amein$;
var $n_Lzonedb_java_tzdb$amein$;
function $m_Lzonedb_java_tzdb$amein$() {
  if ((!$n_Lzonedb_java_tzdb$amein$)) {
    $n_Lzonedb_java_tzdb$amein$ = new $c_Lzonedb_java_tzdb$amein$()
  };
  return $n_Lzonedb_java_tzdb$amein$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameio$() {
  this.Lzonedb_java_tzdb$ameio$__f_America_Asuncion = null;
  $n_Lzonedb_java_tzdb$ameio$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13840));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13840));
  var _2 = [[1931283, 0, (-13840), (-14400)], [1972275, 0, (-14400), (-10800)], [1974091, 0, (-10800), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931283, 0, (-13840), (-14400)], [1972275, 0, (-14400), (-10800)], [1974091, 0, (-10800), (-14400)], [1975274, 0, (-14400), (-10800)], [1976061, 0, (-10800), (-14400)], [1976275, 0, (-14400), (-10800)], [1977060, 0, (-10800), (-14400)], [1977274, 0, (-14400), (-10800)], [1978060, 0, (-10800), (-14400)], [1978274, 0, (-14400), (-10800)], [1979091, 0, (-10800), (-14400)], [1979274, 0, (-14400), (-10800)], [1980092, 0, (-10800), (-14400)], [1980275, 0, (-14400), (-10800)], [1981091, 0, (-10800), (-14400)], [1981274, 0, (-14400), (-10800)], [1982091, 0, (-10800), (-14400)], [1982274, 0, (-14400), (-10800)], [1983091, 0, (-10800), (-14400)], [1983274, 0, (-14400), (-10800)], [1984092, 0, (-10800), (-14400)], [1984275, 0, (-14400), (-10800)], [1985091, 0, (-10800), (-14400)], [1985274, 0, (-14400), (-10800)], [1986091, 0, (-10800), (-14400)], [1986274, 0, (-14400), (-10800)], [1987091, 0, (-10800), (-14400)], [1987274, 0, (-14400), (-10800)], [1988092, 0, (-10800), (-14400)], [1988275, 0, (-14400), (-10800)], [1989091, 0, (-10800), (-14400)], [1989295, 0, (-14400), (-10800)], [1990091, 0, (-10800), (-14400)], [1990274, 0, (-14400), (-10800)], [1991091, 0, (-10800), (-14400)], [1991279, 0, (-14400), (-10800)], [1992061, 0, (-10800), (-14400)], [1992279, 0, (-14400), (-10800)], [1993090, 0, (-10800), (-14400)], [1993274, 0, (-14400), (-10800)], [1994058, 0, (-10800), (-14400)], [1994274, 0, (-14400), (-10800)], [1995057, 0, (-10800), (-14400)], [1995274, 0, (-14400), (-10800)], [1996061, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997054, 0, (-10800), (-14400)], [1997278, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998277, 0, (-14400), (-10800)], [1999066, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000065, 0, (-10800), (-14400)], [2000275, 0, (-14400), (-10800)], [2001063, 0, (-10800), (-14400)], [2001280, 0, (-14400), (-10800)], [2002097, 0, (-10800), (-14400)], [2002244, 0, (-14400), (-10800)], [2003096, 0, (-10800), (-14400)], [2003250, 0, (-14400), (-10800)], [2004095, 0, (-10800), (-14400)], [2004291, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007294, 0, (-14400), (-10800)], [2008069, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009067, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010101, 0, (-10800), (-14400)], [2010276, 0, (-14400), (-10800)], [2011100, 0, (-10800), (-14400)], [2011275, 0, (-14400), (-10800)], [2012099, 0, (-10800), (-14400)], [2012281, 0, (-14400), (-10800)], [2013083, 0, (-10800), (-14400)], [2013279, 0, (-14400), (-10800)], [2014082, 0, (-10800), (-14400)], [2014278, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 22, 7, 0, 0, 1, (-14400), (-10800), (-14400)], [10, 1, 7, 0, 0, 1, (-14400), (-14400), (-10800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameio$__f_America_Asuncion = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameio$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameio$.prototype.constructor = $c_Lzonedb_java_tzdb$ameio$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameio$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameio$.prototype = $c_Lzonedb_java_tzdb$ameio$.prototype;
var $d_Lzonedb_java_tzdb$ameio$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameio$: 0
}, false, "zonedb.java.tzdb$ameio$", {
  Lzonedb_java_tzdb$ameio$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameio$.prototype.$classData = $d_Lzonedb_java_tzdb$ameio$;
var $n_Lzonedb_java_tzdb$ameio$;
function $m_Lzonedb_java_tzdb$ameio$() {
  if ((!$n_Lzonedb_java_tzdb$ameio$)) {
    $n_Lzonedb_java_tzdb$ameio$ = new $c_Lzonedb_java_tzdb$ameio$()
  };
  return $n_Lzonedb_java_tzdb$ameio$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameis$() {
  this.Lzonedb_java_tzdb$ameis$__f_America_Boise = null;
  $n_Lzonedb_java_tzdb$ameis$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-27889));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-27889));
  var _2 = [[1883322, 44111, (-27889), (-28800)], [1923133, 7200, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44111, (-27889), (-28800)], [1918090, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1919089, 7200, (-28800), (-25200)], [1919299, 7200, (-25200), (-28800)], [1923133, 7200, (-28800), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974034, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameis$__f_America_Boise = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameis$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameis$.prototype.constructor = $c_Lzonedb_java_tzdb$ameis$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameis$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameis$.prototype = $c_Lzonedb_java_tzdb$ameis$.prototype;
var $d_Lzonedb_java_tzdb$ameis$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameis$: 0
}, false, "zonedb.java.tzdb$ameis$", {
  Lzonedb_java_tzdb$ameis$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameis$.prototype.$classData = $d_Lzonedb_java_tzdb$ameis$;
var $n_Lzonedb_java_tzdb$ameis$;
function $m_Lzonedb_java_tzdb$ameis$() {
  if ((!$n_Lzonedb_java_tzdb$ameis$)) {
    $n_Lzonedb_java_tzdb$ameis$ = new $c_Lzonedb_java_tzdb$ameis$()
  };
  return $n_Lzonedb_java_tzdb$ameis$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameit$() {
  this.Lzonedb_java_tzdb$ameit$__f_America_Mexico_City = null;
  this.Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City = null;
  $n_Lzonedb_java_tzdb$ameit$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-23796));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-23796));
  var _2 = [[1922001, 1404, (-23796), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922001, 1404, (-23796), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1939036, 0, (-21600), (-18000)], [1939176, 0, (-18000), (-21600)], [1940344, 0, (-21600), (-18000)], [1941091, 0, (-18000), (-21600)], [1943350, 0, (-21600), (-18000)], [1944122, 0, (-18000), (-21600)], [1950043, 0, (-21600), (-18000)], [1950211, 0, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameit$__f_America_Mexico_City = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-20823));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-20823));
  var _2$3 = [[1883322, 43977, (-20823), (-21600)], [1964117, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1883322, 43977, (-20823), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameit$.prototype.constructor = $c_Lzonedb_java_tzdb$ameit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameit$.prototype = $c_Lzonedb_java_tzdb$ameit$.prototype;
var $d_Lzonedb_java_tzdb$ameit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameit$: 0
}, false, "zonedb.java.tzdb$ameit$", {
  Lzonedb_java_tzdb$ameit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameit$.prototype.$classData = $d_Lzonedb_java_tzdb$ameit$;
var $n_Lzonedb_java_tzdb$ameit$;
function $m_Lzonedb_java_tzdb$ameit$() {
  if ((!$n_Lzonedb_java_tzdb$ameit$)) {
    $n_Lzonedb_java_tzdb$ameit$ = new $c_Lzonedb_java_tzdb$ameit$()
  };
  return $n_Lzonedb_java_tzdb$ameit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameiz$() {
  this.Lzonedb_java_tzdb$ameiz$__f_America_Belize = null;
  $n_Lzonedb_java_tzdb$ameiz$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21168));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21168));
  var _2 = [[1912092, 0, (-21168), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912092, 0, (-21168), (-21600)], [1918279, 0, (-21600), (-19800)], [1919040, 0, (-19800), (-21600)], [1919278, 0, (-21600), (-19800)], [1920046, 0, (-19800), (-21600)], [1920277, 0, (-21600), (-19800)], [1921044, 0, (-19800), (-21600)], [1921275, 0, (-21600), (-19800)], [1922043, 0, (-19800), (-21600)], [1922281, 0, (-21600), (-19800)], [1923042, 0, (-19800), (-21600)], [1923280, 0, (-21600), (-19800)], [1924041, 0, (-19800), (-21600)], [1924279, 0, (-21600), (-19800)], [1925046, 0, (-19800), (-21600)], [1925277, 0, (-21600), (-19800)], [1926045, 0, (-19800), (-21600)], [1926276, 0, (-21600), (-19800)], [1927044, 0, (-19800), (-21600)], [1927275, 0, (-21600), (-19800)], [1928043, 0, (-19800), (-21600)], [1928281, 0, (-21600), (-19800)], [1929041, 0, (-19800), (-21600)], [1929279, 0, (-21600), (-19800)], [1930040, 0, (-19800), (-21600)], [1930278, 0, (-21600), (-19800)], [1931046, 0, (-19800), (-21600)], [1931277, 0, (-21600), (-19800)], [1932045, 0, (-19800), (-21600)], [1932276, 0, (-21600), (-19800)], [1933043, 0, (-19800), (-21600)], [1933281, 0, (-21600), (-19800)], [1934042, 0, (-19800), (-21600)], [1934280, 0, (-21600), (-19800)], [1935041, 0, (-19800), (-21600)], [1935279, 0, (-21600), (-19800)], [1936040, 0, (-19800), (-21600)], [1936278, 0, (-21600), (-19800)], [1937045, 0, (-19800), (-21600)], [1937276, 0, (-21600), (-19800)], [1938044, 0, (-19800), (-21600)], [1938275, 0, (-21600), (-19800)], [1939043, 0, (-19800), (-21600)], [1939281, 0, (-21600), (-19800)], [1940042, 0, (-19800), (-21600)], [1940280, 0, (-21600), (-19800)], [1941040, 0, (-19800), (-21600)], [1941278, 0, (-21600), (-19800)], [1942046, 0, (-19800), (-21600)], [1942277, 0, (-21600), (-19800)], [1943045, 0, (-19800), (-21600)], [1973339, 0, (-21600), (-18000)], [1974040, 0, (-18000), (-21600)], [1982352, 0, (-21600), (-18000)], [1983043, 0, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameiz$__f_America_Belize = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameiz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameiz$.prototype.constructor = $c_Lzonedb_java_tzdb$ameiz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameiz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameiz$.prototype = $c_Lzonedb_java_tzdb$ameiz$.prototype;
var $d_Lzonedb_java_tzdb$ameiz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameiz$: 0
}, false, "zonedb.java.tzdb$ameiz$", {
  Lzonedb_java_tzdb$ameiz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameiz$.prototype.$classData = $d_Lzonedb_java_tzdb$ameiz$;
var $n_Lzonedb_java_tzdb$ameiz$;
function $m_Lzonedb_java_tzdb$ameiz$() {
  if ((!$n_Lzonedb_java_tzdb$ameiz$)) {
    $n_Lzonedb_java_tzdb$ameiz$ = new $c_Lzonedb_java_tzdb$ameiz$()
  };
  return $n_Lzonedb_java_tzdb$ameiz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameju$() {
  this.Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy = null;
  $n_Lzonedb_java_tzdb$ameju$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15672));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15672));
  var _2 = [[1894304, 0, (-15672), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990062, 82800, (-10800), (-14400)], [1991279, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-15672), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-14400)], [1990301, 0, (-14400), (-10800)], [1991076, 0, (-10800), (-14400)], [1991279, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameju$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameju$.prototype.constructor = $c_Lzonedb_java_tzdb$ameju$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameju$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameju$.prototype = $c_Lzonedb_java_tzdb$ameju$.prototype;
var $d_Lzonedb_java_tzdb$ameju$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameju$: 0
}, false, "zonedb.java.tzdb$ameju$", {
  Lzonedb_java_tzdb$ameju$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameju$.prototype.$classData = $d_Lzonedb_java_tzdb$ameju$;
var $n_Lzonedb_java_tzdb$ameju$;
function $m_Lzonedb_java_tzdb$ameju$() {
  if ((!$n_Lzonedb_java_tzdb$ameju$)) {
    $n_Lzonedb_java_tzdb$ameju$ = new $c_Lzonedb_java_tzdb$ameju$()
  };
  return $n_Lzonedb_java_tzdb$ameju$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameka$() {
  this.Lzonedb_java_tzdb$ameka$__f_America_Atikokan = null;
  $n_Lzonedb_java_tzdb$ameka$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21988));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21988));
  var _2 = [[1895001, 0, (-21988), (-21600)], [1945273, 3600, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, (-21988), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1940273, 0, (-21600), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameka$__f_America_Atikokan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameka$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameka$.prototype.constructor = $c_Lzonedb_java_tzdb$ameka$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameka$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameka$.prototype = $c_Lzonedb_java_tzdb$ameka$.prototype;
var $d_Lzonedb_java_tzdb$ameka$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameka$: 0
}, false, "zonedb.java.tzdb$ameka$", {
  Lzonedb_java_tzdb$ameka$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameka$.prototype.$classData = $d_Lzonedb_java_tzdb$ameka$;
var $n_Lzonedb_java_tzdb$ameka$;
function $m_Lzonedb_java_tzdb$ameka$() {
  if ((!$n_Lzonedb_java_tzdb$ameka$)) {
    $n_Lzonedb_java_tzdb$ameka$ = new $c_Lzonedb_java_tzdb$ameka$()
  };
  return $n_Lzonedb_java_tzdb$ameka$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amela$() {
  this.Lzonedb_java_tzdb$amela$__f_America_Mazatlan = null;
  this.Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah = null;
  $n_Lzonedb_java_tzdb$amela$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25540));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25540));
  var _2 = [[1921365, 86060, (-25540), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921365, 86060, (-25540), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [10, 25, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amela$__f_America_Mazatlan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-24427));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-24427));
  var _2$3 = [[1883322, 43973, (-24427), (-25200)], [2010311, 3600, (-25200), (-21600)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1883322, 43973, (-24427), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)], [2009067, 7200, (-25200), (-21600)], [2009305, 7200, (-21600), (-25200)], [2010073, 7200, (-25200), (-21600)], [2011072, 7200, (-21600), (-18000)], [2011310, 7200, (-18000), (-21600)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amela$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amela$.prototype.constructor = $c_Lzonedb_java_tzdb$amela$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amela$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amela$.prototype = $c_Lzonedb_java_tzdb$amela$.prototype;
var $d_Lzonedb_java_tzdb$amela$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amela$: 0
}, false, "zonedb.java.tzdb$amela$", {
  Lzonedb_java_tzdb$amela$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amela$.prototype.$classData = $d_Lzonedb_java_tzdb$amela$;
var $n_Lzonedb_java_tzdb$amela$;
function $m_Lzonedb_java_tzdb$amela$() {
  if ((!$n_Lzonedb_java_tzdb$amela$)) {
    $n_Lzonedb_java_tzdb$amela$ = new $c_Lzonedb_java_tzdb$amela$()
  };
  return $n_Lzonedb_java_tzdb$amela$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amele$() {
  this.Lzonedb_java_tzdb$amele$__f_America_Belem = null;
  this.Lzonedb_java_tzdb$amele$__f_America_Los_Angeles = null;
  this.Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet = null;
  this.Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem = null;
  $n_Lzonedb_java_tzdb$amele$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-11636));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-11636));
  var _2 = [[1914001, 0, (-11636), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-11636), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amele$__f_America_Belem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-28378));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-28378));
  var _2$3 = [[1883322, 43622, (-28378), (-28800)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1883322, 43622, (-28378), (-28800)], [1918090, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1919089, 7200, (-28800), (-25200)], [1919299, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1948074, 7260, (-28800), (-25200)], [1949001, 7200, (-25200), (-28800)], [1950120, 3600, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 3600, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 3600, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 3600, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 3600, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 3600, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 3600, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 3600, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 3600, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 3600, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 3600, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 3600, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 3600, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 3600, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 3600, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 3600, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 3600, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amele$__f_America_Los_Angeles = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2$6 = [[1957001, 0, 0, (-21600)], [2000303, 3600, (-21600), (-18000)], [2001091, 10800, (-18000), (-21600)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1957001, 0, 0, (-21600)], [1965115, 0, (-21600), (-14400)], [1965304, 7200, (-14400), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  var $$x20 = $m_sr_ScalaRunTime$();
  var $$x19 = $ct_T2__O__O__(new $c_T2(), "s", (-24339));
  var $$x18 = $ct_T2__O__O__(new $c_T2(), "w", (-24339));
  var _2$9 = [[1883322, 44061, (-24339), (-25200)], [2003299, 3600, (-25200), (-21600)]];
  var $$x17 = $ct_T2__O__O__(new $c_T2(), "t", _2$9);
  var _2$10 = [[1883322, 44061, (-24339), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x16 = $ct_T2__O__O__(new $c_T2(), "l", _2$10);
  var _2$11 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$3 = $$x20.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x19, $$x18, $$x17, $$x16, $ct_T2__O__O__(new $c_T2(), "r", _2$11)]));
  this.Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3)
}
$c_Lzonedb_java_tzdb$amele$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amele$.prototype.constructor = $c_Lzonedb_java_tzdb$amele$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amele$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amele$.prototype = $c_Lzonedb_java_tzdb$amele$.prototype;
var $d_Lzonedb_java_tzdb$amele$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amele$: 0
}, false, "zonedb.java.tzdb$amele$", {
  Lzonedb_java_tzdb$amele$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amele$.prototype.$classData = $d_Lzonedb_java_tzdb$amele$;
var $n_Lzonedb_java_tzdb$amele$;
function $m_Lzonedb_java_tzdb$amele$() {
  if ((!$n_Lzonedb_java_tzdb$amele$)) {
    $n_Lzonedb_java_tzdb$amele$ = new $c_Lzonedb_java_tzdb$amele$()
  };
  return $n_Lzonedb_java_tzdb$amele$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelh$() {
  this.Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho = null;
  $n_Lzonedb_java_tzdb$amelh$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15336));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15336));
  var _2 = [[1914001, 0, (-15336), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-15336), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amelh$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelh$.prototype.constructor = $c_Lzonedb_java_tzdb$amelh$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelh$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelh$.prototype = $c_Lzonedb_java_tzdb$amelh$.prototype;
var $d_Lzonedb_java_tzdb$amelh$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelh$: 0
}, false, "zonedb.java.tzdb$amelh$", {
  Lzonedb_java_tzdb$amelh$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelh$.prototype.$classData = $d_Lzonedb_java_tzdb$amelh$;
var $n_Lzonedb_java_tzdb$amelh$;
function $m_Lzonedb_java_tzdb$amelh$() {
  if ((!$n_Lzonedb_java_tzdb$amelh$)) {
    $n_Lzonedb_java_tzdb$amelh$ = new $c_Lzonedb_java_tzdb$amelh$()
  };
  return $n_Lzonedb_java_tzdb$amelh$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameli$() {
  this.Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis = null;
  $n_Lzonedb_java_tzdb$ameli$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20678));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20678));
  var _2 = [[1883322, 44122, (-20678), (-21600)], [1955114, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44122, (-20678), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1941173, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameli$.prototype.constructor = $c_Lzonedb_java_tzdb$ameli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameli$.prototype = $c_Lzonedb_java_tzdb$ameli$.prototype;
var $d_Lzonedb_java_tzdb$ameli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameli$: 0
}, false, "zonedb.java.tzdb$ameli$", {
  Lzonedb_java_tzdb$ameli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameli$.prototype.$classData = $d_Lzonedb_java_tzdb$ameli$;
var $n_Lzonedb_java_tzdb$ameli$;
function $m_Lzonedb_java_tzdb$ameli$() {
  if ((!$n_Lzonedb_java_tzdb$ameli$)) {
    $n_Lzonedb_java_tzdb$ameli$ = new $c_Lzonedb_java_tzdb$ameli$()
  };
  return $n_Lzonedb_java_tzdb$ameli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amell$() {
  this.Lzonedb_java_tzdb$amell$__f_America_Hermosillo = null;
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello = null;
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville = null;
  $n_Lzonedb_java_tzdb$amell$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-26632));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-26632));
  var _2 = [[1921365, 84968, (-26632), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921365, 84968, (-26632), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amell$__f_America_Hermosillo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-20364));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-20364));
  var _2$3 = [[1883322, 44436, (-20364), (-21600)], [2000303, 3600, (-21600), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1883322, 44436, (-20364), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-20582));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-20582));
  var _2$6 = [[1883322, 44218, (-20582), (-21600)], [1961204, 3600, (-21600), (-18000)], [1974006, 7200, (-18000), (-21600)], [1974300, 3600, (-21600), (-18000)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1883322, 44218, (-20582), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1921121, 7200, (-21600), (-18000)], [1921244, 7200, (-18000), (-21600)], [1941117, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 60, (-21600), (-18000)], [1946153, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957300, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958299, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$amell$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amell$.prototype.constructor = $c_Lzonedb_java_tzdb$amell$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amell$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amell$.prototype = $c_Lzonedb_java_tzdb$amell$.prototype;
var $d_Lzonedb_java_tzdb$amell$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amell$: 0
}, false, "zonedb.java.tzdb$amell$", {
  Lzonedb_java_tzdb$amell$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amell$.prototype.$classData = $d_Lzonedb_java_tzdb$amell$;
var $n_Lzonedb_java_tzdb$amell$;
function $m_Lzonedb_java_tzdb$amell$() {
  if ((!$n_Lzonedb_java_tzdb$amell$)) {
    $n_Lzonedb_java_tzdb$amell$ = new $c_Lzonedb_java_tzdb$amell$()
  };
  return $n_Lzonedb_java_tzdb$amell$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelo$() {
  this.Lzonedb_java_tzdb$amelo$__f_America_Miquelon = null;
  this.Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon = null;
  $n_Lzonedb_java_tzdb$amelo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13480));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13480));
  var _2 = [[1911135, 0, (-13480), (-14400)], [1980122, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911135, 0, (-13480), (-14400)], [1980122, 0, (-14400), (-10800)], [1987095, 7200, (-10800), (-7200)], [1987298, 7200, (-7200), (-10800)], [1988094, 7200, (-10800), (-7200)], [1988304, 7200, (-7200), (-10800)], [1989092, 7200, (-10800), (-7200)], [1989302, 7200, (-7200), (-10800)], [1990091, 7200, (-10800), (-7200)], [1990301, 7200, (-7200), (-10800)], [1991097, 7200, (-10800), (-7200)], [1991300, 7200, (-7200), (-10800)], [1992096, 7200, (-10800), (-7200)], [1992299, 7200, (-7200), (-10800)], [1993094, 7200, (-10800), (-7200)], [1993304, 7200, (-7200), (-10800)], [1994093, 7200, (-10800), (-7200)], [1994303, 7200, (-7200), (-10800)], [1995092, 7200, (-10800), (-7200)], [1995302, 7200, (-7200), (-10800)], [1996098, 7200, (-10800), (-7200)], [1996301, 7200, (-7200), (-10800)], [1997096, 7200, (-10800), (-7200)], [1997299, 7200, (-7200), (-10800)], [1998095, 7200, (-10800), (-7200)], [1998298, 7200, (-7200), (-10800)], [1999094, 7200, (-10800), (-7200)], [1999304, 7200, (-7200), (-10800)], [2000093, 7200, (-10800), (-7200)], [2000303, 7200, (-7200), (-10800)], [2001091, 7200, (-10800), (-7200)], [2001301, 7200, (-7200), (-10800)], [2002097, 7200, (-10800), (-7200)], [2002300, 7200, (-7200), (-10800)], [2003096, 7200, (-10800), (-7200)], [2003299, 7200, (-7200), (-10800)], [2004095, 7200, (-10800), (-7200)], [2004305, 7200, (-7200), (-10800)], [2005093, 7200, (-10800), (-7200)], [2005303, 7200, (-7200), (-10800)], [2006092, 7200, (-10800), (-7200)], [2006302, 7200, (-7200), (-10800)], [2007070, 7200, (-10800), (-7200)], [2007308, 7200, (-7200), (-10800)], [2008069, 7200, (-10800), (-7200)], [2008307, 7200, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-10800), (-10800), (-7200)], [11, 1, 7, 7200, 0, 1, (-10800), (-7200), (-10800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amelo$__f_America_Miquelon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-13708));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-13708));
  var _2$3 = [[1884001, 0, (-13708), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1884001, 0, (-13708), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amelo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelo$.prototype.constructor = $c_Lzonedb_java_tzdb$amelo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelo$.prototype = $c_Lzonedb_java_tzdb$amelo$.prototype;
var $d_Lzonedb_java_tzdb$amelo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelo$: 0
}, false, "zonedb.java.tzdb$amelo$", {
  Lzonedb_java_tzdb$amelo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelo$.prototype.$classData = $d_Lzonedb_java_tzdb$amelo$;
var $n_Lzonedb_java_tzdb$amelo$;
function $m_Lzonedb_java_tzdb$amelo$() {
  if ((!$n_Lzonedb_java_tzdb$amelo$)) {
    $n_Lzonedb_java_tzdb$amelo$ = new $c_Lzonedb_java_tzdb$amelo$()
  };
  return $n_Lzonedb_java_tzdb$amelo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelp$() {
  this.Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa = null;
  $n_Lzonedb_java_tzdb$amelp$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20932));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20932));
  var _2 = [[1921091, 0, (-20932), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921091, 0, (-20932), (-21600)], [1987123, 0, (-21600), (-18000)], [1987270, 0, (-18000), (-21600)], [1988122, 0, (-21600), (-18000)], [1988269, 0, (-18000), (-21600)], [2006127, 0, (-21600), (-18000)], [2006219, 0, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amelp$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelp$.prototype.constructor = $c_Lzonedb_java_tzdb$amelp$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelp$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelp$.prototype = $c_Lzonedb_java_tzdb$amelp$.prototype;
var $d_Lzonedb_java_tzdb$amelp$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelp$: 0
}, false, "zonedb.java.tzdb$amelp$", {
  Lzonedb_java_tzdb$amelp$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelp$.prototype.$classData = $d_Lzonedb_java_tzdb$amelp$;
var $n_Lzonedb_java_tzdb$amelp$;
function $m_Lzonedb_java_tzdb$amelp$() {
  if ((!$n_Lzonedb_java_tzdb$amelp$)) {
    $n_Lzonedb_java_tzdb$amelp$ = new $c_Lzonedb_java_tzdb$amelp$()
  };
  return $n_Lzonedb_java_tzdb$amelp$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelt$() {
  this.Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta = null;
  $n_Lzonedb_java_tzdb$amelt$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15700));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15700));
  var _2 = [[1894304, 0, (-15700), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-15700), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amelt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelt$.prototype.constructor = $c_Lzonedb_java_tzdb$amelt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelt$.prototype = $c_Lzonedb_java_tzdb$amelt$.prototype;
var $d_Lzonedb_java_tzdb$amelt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelt$: 0
}, false, "zonedb.java.tzdb$amelt$", {
  Lzonedb_java_tzdb$amelt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelt$.prototype.$classData = $d_Lzonedb_java_tzdb$amelt$;
var $n_Lzonedb_java_tzdb$amelt$;
function $m_Lzonedb_java_tzdb$amelt$() {
  if ((!$n_Lzonedb_java_tzdb$amelt$)) {
    $n_Lzonedb_java_tzdb$amelt$ = new $c_Lzonedb_java_tzdb$amelt$()
  };
  return $n_Lzonedb_java_tzdb$amelt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amema$() {
  this.Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman = null;
  this.Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac = null;
  $n_Lzonedb_java_tzdb$amema$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15652));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15652));
  var _2 = [[1894304, 0, (-15652), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004165, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-15652), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004165, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-20785));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-20785));
  var _2$3 = [[1883322, 44015, (-20785), (-21600)], [1961120, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1883322, 44015, (-20785), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amema$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amema$.prototype.constructor = $c_Lzonedb_java_tzdb$amema$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amema$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amema$.prototype = $c_Lzonedb_java_tzdb$amema$.prototype;
var $d_Lzonedb_java_tzdb$amema$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amema$: 0
}, false, "zonedb.java.tzdb$amema$", {
  Lzonedb_java_tzdb$amema$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amema$.prototype.$classData = $d_Lzonedb_java_tzdb$amema$;
var $n_Lzonedb_java_tzdb$amema$;
function $m_Lzonedb_java_tzdb$amema$() {
  if ((!$n_Lzonedb_java_tzdb$amema$)) {
    $n_Lzonedb_java_tzdb$amema$ = new $c_Lzonedb_java_tzdb$amema$()
  };
  return $n_Lzonedb_java_tzdb$amema$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amena$() {
  this.Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas = null;
  $n_Lzonedb_java_tzdb$amena$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-17020));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-17020));
  var _2 = [[1890001, 0, (-17020), (-16966)], [1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [2016338, 82800, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-17020), (-16966)], [1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-14400)], [1928092, 0, (-14400), (-18000)], [1928245, 0, (-18000), (-14400)], [1929091, 0, (-14400), (-18000)], [1929244, 0, (-18000), (-14400)], [1930091, 0, (-14400), (-18000)], [1930244, 0, (-18000), (-14400)], [1931091, 0, (-14400), (-18000)], [1931244, 0, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [1968308, 0, (-14400), (-10800)], [1969089, 0, (-10800), (-14400)], [1969327, 0, (-14400), (-10800)], [1970088, 0, (-10800), (-14400)], [1970284, 0, (-14400), (-10800)], [1971073, 0, (-10800), (-14400)], [1971283, 0, (-14400), (-10800)], [1972072, 0, (-10800), (-14400)], [1972289, 0, (-14400), (-10800)], [1973070, 0, (-10800), (-14400)], [1973273, 0, (-14400), (-10800)], [1974069, 0, (-10800), (-14400)], [1974286, 0, (-14400), (-10800)], [1975068, 0, (-10800), (-14400)], [1975285, 0, (-14400), (-10800)], [1976074, 0, (-10800), (-14400)], [1976284, 0, (-14400), (-10800)], [1977072, 0, (-10800), (-14400)], [1977282, 0, (-14400), (-10800)], [1978071, 0, (-10800), (-14400)], [1978288, 0, (-14400), (-10800)], [1979070, 0, (-10800), (-14400)], [1979287, 0, (-14400), (-10800)], [1980069, 0, (-10800), (-14400)], [1980286, 0, (-14400), (-10800)], [1981074, 0, (-10800), (-14400)], [1981284, 0, (-14400), (-10800)], [1982073, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amena$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amena$.prototype.constructor = $c_Lzonedb_java_tzdb$amena$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amena$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amena$.prototype = $c_Lzonedb_java_tzdb$amena$.prototype;
var $d_Lzonedb_java_tzdb$amena$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amena$: 0
}, false, "zonedb.java.tzdb$amena$", {
  Lzonedb_java_tzdb$amena$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amena$.prototype.$classData = $d_Lzonedb_java_tzdb$amena$;
var $n_Lzonedb_java_tzdb$amena$;
function $m_Lzonedb_java_tzdb$amena$() {
  if ((!$n_Lzonedb_java_tzdb$amena$)) {
    $n_Lzonedb_java_tzdb$amena$ = new $c_Lzonedb_java_tzdb$amena$()
  };
  return $n_Lzonedb_java_tzdb$amena$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenc$() {
  this.Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince = null;
  this.Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco = null;
  $n_Lzonedb_java_tzdb$amenc$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-17360));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-17360));
  var _2 = [[1890001, 0, (-17360), (-17340)], [1917024, 43200, (-17340), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-17360), (-17340)], [1917024, 43200, (-17340), (-18000)], [1983128, 0, (-18000), (-14400)], [1983303, 0, (-14400), (-18000)], [1984120, 0, (-18000), (-14400)], [1984302, 0, (-14400), (-18000)], [1985118, 0, (-18000), (-14400)], [1985300, 0, (-14400), (-18000)], [1986117, 0, (-18000), (-14400)], [1986299, 0, (-14400), (-18000)], [1987116, 0, (-18000), (-14400)], [1987298, 0, (-14400), (-18000)], [1988094, 3600, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 3600, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 3600, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 3600, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 3600, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 3600, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 3600, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 3600, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 3600, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 3600, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [2005093, 0, (-18000), (-14400)], [2005303, 0, (-14400), (-18000)], [2006092, 0, (-18000), (-14400)], [2006302, 0, (-14400), (-18000)], [2012071, 7200, (-18000), (-14400)], [2012309, 7200, (-14400), (-18000)], [2013069, 7200, (-18000), (-14400)], [2013307, 7200, (-14400), (-18000)], [2014068, 7200, (-18000), (-14400)], [2014306, 7200, (-14400), (-18000)], [2015067, 7200, (-18000), (-14400)], [2015305, 7200, (-14400), (-18000)], [2017071, 7200, (-18000), (-14400)], [2017309, 7200, (-14400), (-18000)], [2018070, 7200, (-18000), (-14400)], [2018308, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-16272));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-16272));
  var _2$3 = [[1914001, 0, (-16272), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1914001, 0, (-16272), (-18000)], [1931276, 39600, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932277, 0, (-18000), (-14400)], [1933091, 0, (-14400), (-18000)], [1949335, 0, (-18000), (-14400)], [1950106, 3600, (-14400), (-18000)], [1950335, 0, (-18000), (-14400)], [1951091, 0, (-14400), (-18000)], [1951335, 0, (-18000), (-14400)], [1952092, 0, (-14400), (-18000)], [1952336, 0, (-18000), (-14400)], [1953060, 0, (-14400), (-18000)], [1963343, 0, (-18000), (-14400)], [1964061, 0, (-14400), (-18000)], [1965031, 0, (-18000), (-14400)], [1965090, 0, (-14400), (-18000)], [1965335, 0, (-18000), (-14400)], [1966060, 0, (-14400), (-18000)], [1966305, 0, (-18000), (-14400)], [1967060, 0, (-14400), (-18000)], [1967305, 0, (-18000), (-14400)], [1968061, 0, (-14400), (-18000)], [1985306, 0, (-18000), (-14400)], [1986074, 0, (-14400), (-18000)], [1986298, 0, (-18000), (-14400)], [1987045, 0, (-14400), (-18000)], [1987298, 0, (-18000), (-14400)], [1988038, 0, (-14400), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amenc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenc$.prototype.constructor = $c_Lzonedb_java_tzdb$amenc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenc$.prototype = $c_Lzonedb_java_tzdb$amenc$.prototype;
var $d_Lzonedb_java_tzdb$amenc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenc$: 0
}, false, "zonedb.java.tzdb$amenc$", {
  Lzonedb_java_tzdb$amenc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenc$.prototype.$classData = $d_Lzonedb_java_tzdb$amenc$;
var $n_Lzonedb_java_tzdb$amenc$;
function $m_Lzonedb_java_tzdb$amenc$() {
  if ((!$n_Lzonedb_java_tzdb$amenc$)) {
    $n_Lzonedb_java_tzdb$amenc$ = new $c_Lzonedb_java_tzdb$amenc$()
  };
  return $n_Lzonedb_java_tzdb$amenc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amend$() {
  this.Lzonedb_java_tzdb$amend$__f_America_Campo_Grande = null;
  $n_Lzonedb_java_tzdb$amend$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13108));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13108));
  var _2 = [[1914001, 0, (-13108), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-13108), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1988290, 0, (-14400), (-10800)], [1989029, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990042, 0, (-10800), (-14400)], [1990294, 0, (-14400), (-10800)], [1991048, 0, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1992040, 0, (-10800), (-14400)], [1992299, 0, (-14400), (-10800)], [1993031, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)], [1994289, 0, (-14400), (-10800)], [1995050, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996042, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997047, 0, (-10800), (-14400)], [1997279, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998284, 0, (-14400), (-10800)], [1999052, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2001049, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002048, 0, (-10800), (-14400)], [2002307, 0, (-14400), (-10800)], [2003047, 0, (-10800), (-14400)], [2003292, 0, (-14400), (-10800)], [2004046, 0, (-10800), (-14400)], [2004307, 0, (-14400), (-10800)], [2005051, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006050, 0, (-10800), (-14400)], [2006309, 0, (-14400), (-10800)], [2007056, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008048, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009046, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010052, 0, (-10800), (-14400)], [2010290, 0, (-14400), (-10800)], [2011051, 0, (-10800), (-14400)], [2011289, 0, (-14400), (-10800)], [2012057, 0, (-10800), (-14400)], [2012295, 0, (-14400), (-10800)], [2013048, 0, (-10800), (-14400)], [2013293, 0, (-14400), (-10800)], [2014047, 0, (-10800), (-14400)], [2014292, 0, (-14400), (-10800)], [2015053, 0, (-10800), (-14400)], [2015291, 0, (-14400), (-10800)], [2016052, 0, (-10800), (-14400)], [2016290, 0, (-14400), (-10800)], [2017050, 0, (-10800), (-14400)], [2017288, 0, (-14400), (-10800)], [2018049, 0, (-10800), (-14400)], [2018308, 0, (-14400), (-10800)], [2019048, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amend$__f_America_Campo_Grande = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amend$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amend$.prototype.constructor = $c_Lzonedb_java_tzdb$amend$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amend$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amend$.prototype = $c_Lzonedb_java_tzdb$amend$.prototype;
var $d_Lzonedb_java_tzdb$amend$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amend$: 0
}, false, "zonedb.java.tzdb$amend$", {
  Lzonedb_java_tzdb$amend$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amend$.prototype.$classData = $d_Lzonedb_java_tzdb$amend$;
var $n_Lzonedb_java_tzdb$amend$;
function $m_Lzonedb_java_tzdb$amend$() {
  if ((!$n_Lzonedb_java_tzdb$amend$)) {
    $n_Lzonedb_java_tzdb$amend$ = new $c_Lzonedb_java_tzdb$amend$()
  };
  return $n_Lzonedb_java_tzdb$amend$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amene$() {
  this.Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes = null;
  this.Lzonedb_java_tzdb$amene$__f_America_Menominee = null;
  $n_Lzonedb_java_tzdb$amene$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21007));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21007));
  var _2 = [[1883322, 43793, (-21007), (-21600)], [1964117, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007308, 3600, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 43793, (-21007), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961267, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-21027));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-21027));
  var _2$3 = [[1885261, 43200, (-21027), (-21600)], [1969117, 7200, (-21600), (-18000)], [1973119, 7200, (-18000), (-21600)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1885261, 43200, (-21027), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amene$__f_America_Menominee = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$amene$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amene$.prototype.constructor = $c_Lzonedb_java_tzdb$amene$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amene$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amene$.prototype = $c_Lzonedb_java_tzdb$amene$.prototype;
var $d_Lzonedb_java_tzdb$amene$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amene$: 0
}, false, "zonedb.java.tzdb$amene$", {
  Lzonedb_java_tzdb$amene$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amene$.prototype.$classData = $d_Lzonedb_java_tzdb$amene$;
var $n_Lzonedb_java_tzdb$amene$;
function $m_Lzonedb_java_tzdb$amene$() {
  if ((!$n_Lzonedb_java_tzdb$amene$)) {
    $n_Lzonedb_java_tzdb$amene$ = new $c_Lzonedb_java_tzdb$amene$()
  };
  return $n_Lzonedb_java_tzdb$amene$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameng$() {
  this.Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo = null;
  this.Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo = null;
  $n_Lzonedb_java_tzdb$ameng$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20723));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20723));
  var _2 = [[1883322, 44077, (-20723), (-21600)], [1961120, 7200, (-21600), (-18000)], [1974006, 7200, (-18000), (-21600)], [1974300, 3600, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44077, (-20723), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-16776));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-16776));
  var _2$3 = [[1890001, 0, (-16776), (-16800)], [1933091, 43200, (-16800), (-18000)], [1974300, 0, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2000338, 3600, (-18000), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890001, 0, (-16776), (-16800)], [1933091, 43200, (-16800), (-18000)], [1966303, 0, (-18000), (-14400)], [1967059, 0, (-14400), (-18000)], [1969299, 0, (-18000), (-16200)], [1970052, 0, (-16200), (-18000)], [1970298, 0, (-18000), (-16200)], [1971020, 0, (-16200), (-18000)], [1971304, 0, (-18000), (-16200)], [1972021, 0, (-16200), (-18000)], [1972303, 0, (-18000), (-16200)], [1973021, 0, (-16200), (-18000)], [1973301, 0, (-18000), (-16200)], [1974021, 0, (-16200), (-18000)], [1974300, 0, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2000338, 3600, (-18000), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameng$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameng$.prototype.constructor = $c_Lzonedb_java_tzdb$ameng$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameng$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameng$.prototype = $c_Lzonedb_java_tzdb$ameng$.prototype;
var $d_Lzonedb_java_tzdb$ameng$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameng$: 0
}, false, "zonedb.java.tzdb$ameng$", {
  Lzonedb_java_tzdb$ameng$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameng$.prototype.$classData = $d_Lzonedb_java_tzdb$ameng$;
var $n_Lzonedb_java_tzdb$ameng$;
function $m_Lzonedb_java_tzdb$ameng$() {
  if ((!$n_Lzonedb_java_tzdb$ameng$)) {
    $n_Lzonedb_java_tzdb$ameng$ = new $c_Lzonedb_java_tzdb$ameng$()
  };
  return $n_Lzonedb_java_tzdb$ameng$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenh$() {
  this.Lzonedb_java_tzdb$amenh$__f_America_Noronha = null;
  $n_Lzonedb_java_tzdb$amenh$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-7780));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-7780));
  var _2 = [[1914001, 0, (-7780), (-7200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-7780), (-7200)], [1931276, 39600, (-7200), (-3600)], [1932092, 0, (-3600), (-7200)], [1932277, 0, (-7200), (-3600)], [1933091, 0, (-3600), (-7200)], [1949335, 0, (-7200), (-3600)], [1950106, 3600, (-3600), (-7200)], [1950335, 0, (-7200), (-3600)], [1951091, 0, (-3600), (-7200)], [1951335, 0, (-7200), (-3600)], [1952092, 0, (-3600), (-7200)], [1952336, 0, (-7200), (-3600)], [1953060, 0, (-3600), (-7200)], [1963343, 0, (-7200), (-3600)], [1964061, 0, (-3600), (-7200)], [1965031, 0, (-7200), (-3600)], [1965090, 0, (-3600), (-7200)], [1965335, 0, (-7200), (-3600)], [1966060, 0, (-3600), (-7200)], [1966305, 0, (-7200), (-3600)], [1967060, 0, (-3600), (-7200)], [1967305, 0, (-7200), (-3600)], [1968061, 0, (-3600), (-7200)], [1985306, 0, (-7200), (-3600)], [1986074, 0, (-3600), (-7200)], [1986298, 0, (-7200), (-3600)], [1987045, 0, (-3600), (-7200)], [1987298, 0, (-7200), (-3600)], [1988038, 0, (-3600), (-7200)], [1988290, 0, (-7200), (-3600)], [1989029, 0, (-3600), (-7200)], [1989288, 0, (-7200), (-3600)], [1990042, 0, (-3600), (-7200)], [1999276, 0, (-7200), (-3600)], [2000058, 0, (-3600), (-7200)], [2000282, 0, (-7200), (-3600)], [2000289, 0, (-3600), (-7200)], [2001287, 0, (-7200), (-3600)], [2002048, 0, (-3600), (-7200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amenh$__f_America_Noronha = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amenh$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenh$.prototype.constructor = $c_Lzonedb_java_tzdb$amenh$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenh$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenh$.prototype = $c_Lzonedb_java_tzdb$amenh$.prototype;
var $d_Lzonedb_java_tzdb$amenh$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenh$: 0
}, false, "zonedb.java.tzdb$amenh$", {
  Lzonedb_java_tzdb$amenh$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenh$.prototype.$classData = $d_Lzonedb_java_tzdb$amenh$;
var $n_Lzonedb_java_tzdb$amenh$;
function $m_Lzonedb_java_tzdb$amenh$() {
  if ((!$n_Lzonedb_java_tzdb$amenh$)) {
    $n_Lzonedb_java_tzdb$amenh$ = new $c_Lzonedb_java_tzdb$amenh$()
  };
  return $n_Lzonedb_java_tzdb$amenh$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameni$() {
  this.Lzonedb_java_tzdb$ameni$__f_America_Phoenix = null;
  $n_Lzonedb_java_tzdb$ameni$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-26898));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-26898));
  var _2 = [[1883322, 41502, (-26898), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 41502, (-26898), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1944001, 60, (-21600), (-25200)], [1944092, 60, (-25200), (-21600)], [1944275, 60, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameni$__f_America_Phoenix = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameni$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameni$.prototype.constructor = $c_Lzonedb_java_tzdb$ameni$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameni$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameni$.prototype = $c_Lzonedb_java_tzdb$ameni$.prototype;
var $d_Lzonedb_java_tzdb$ameni$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameni$: 0
}, false, "zonedb.java.tzdb$ameni$", {
  Lzonedb_java_tzdb$ameni$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameni$.prototype.$classData = $d_Lzonedb_java_tzdb$ameni$;
var $n_Lzonedb_java_tzdb$ameni$;
function $m_Lzonedb_java_tzdb$ameni$() {
  if ((!$n_Lzonedb_java_tzdb$ameni$)) {
    $n_Lzonedb_java_tzdb$ameni$ = new $c_Lzonedb_java_tzdb$ameni$()
  };
  return $n_Lzonedb_java_tzdb$ameni$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenn$() {
  this.Lzonedb_java_tzdb$amenn$__f_America_Cayenne = null;
  $n_Lzonedb_java_tzdb$amenn$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-12560));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-12560));
  var _2 = [[1911182, 0, (-12560), (-14400)], [1967274, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911182, 0, (-12560), (-14400)], [1967274, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amenn$__f_America_Cayenne = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amenn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenn$.prototype.constructor = $c_Lzonedb_java_tzdb$amenn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenn$.prototype = $c_Lzonedb_java_tzdb$amenn$.prototype;
var $d_Lzonedb_java_tzdb$amenn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenn$: 0
}, false, "zonedb.java.tzdb$amenn$", {
  Lzonedb_java_tzdb$amenn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenn$.prototype.$classData = $d_Lzonedb_java_tzdb$amenn$;
var $n_Lzonedb_java_tzdb$amenn$;
function $m_Lzonedb_java_tzdb$amenn$() {
  if ((!$n_Lzonedb_java_tzdb$amenn$)) {
    $n_Lzonedb_java_tzdb$amenn$ = new $c_Lzonedb_java_tzdb$amenn$()
  };
  return $n_Lzonedb_java_tzdb$amenn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameno$() {
  this.Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox = null;
  $n_Lzonedb_java_tzdb$ameno$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20790));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20790));
  var _2 = [[1883322, 44010, (-20790), (-21600)], [1962119, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1991300, 3600, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44010, (-20790), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameno$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameno$.prototype.constructor = $c_Lzonedb_java_tzdb$ameno$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameno$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameno$.prototype = $c_Lzonedb_java_tzdb$ameno$.prototype;
var $d_Lzonedb_java_tzdb$ameno$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameno$: 0
}, false, "zonedb.java.tzdb$ameno$", {
  Lzonedb_java_tzdb$ameno$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameno$.prototype.$classData = $d_Lzonedb_java_tzdb$ameno$;
var $n_Lzonedb_java_tzdb$ameno$;
function $m_Lzonedb_java_tzdb$ameno$() {
  if ((!$n_Lzonedb_java_tzdb$ameno$)) {
    $n_Lzonedb_java_tzdb$ameno$ = new $c_Lzonedb_java_tzdb$ameno$()
  };
  return $n_Lzonedb_java_tzdb$ameno$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ament$() {
  this.Lzonedb_java_tzdb$ament$__f_America_Toronto = null;
  $n_Lzonedb_java_tzdb$ament$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-19052));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-19052));
  var _2 = [[1895001, 0, (-19052), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, (-19052), (-18000)], [1918104, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1919089, 84600, (-18000), (-14400)], [1919299, 0, (-14400), (-18000)], [1920123, 7200, (-18000), (-14400)], [1920270, 0, (-14400), (-18000)], [1921135, 7200, (-18000), (-14400)], [1921258, 7200, (-14400), (-18000)], [1922134, 7200, (-18000), (-14400)], [1922260, 7200, (-14400), (-18000)], [1923133, 7200, (-18000), (-14400)], [1923259, 7200, (-14400), (-18000)], [1924125, 7200, (-18000), (-14400)], [1924265, 7200, (-14400), (-18000)], [1925123, 7200, (-18000), (-14400)], [1925263, 7200, (-14400), (-18000)], [1926122, 7200, (-18000), (-14400)], [1926262, 7200, (-14400), (-18000)], [1927121, 7200, (-18000), (-14400)], [1927268, 7200, (-14400), (-18000)], [1928120, 7200, (-18000), (-14400)], [1928274, 7200, (-14400), (-18000)], [1929118, 7200, (-18000), (-14400)], [1929272, 7200, (-14400), (-18000)], [1930117, 7200, (-18000), (-14400)], [1930271, 7200, (-14400), (-18000)], [1931116, 7200, (-18000), (-14400)], [1931270, 7200, (-14400), (-18000)], [1932122, 7200, (-18000), (-14400)], [1932269, 7200, (-14400), (-18000)], [1933120, 7200, (-18000), (-14400)], [1933274, 7200, (-14400), (-18000)], [1934119, 7200, (-18000), (-14400)], [1934273, 7200, (-14400), (-18000)], [1935118, 7200, (-18000), (-14400)], [1935272, 7200, (-14400), (-18000)], [1936117, 7200, (-18000), (-14400)], [1936271, 7200, (-14400), (-18000)], [1937115, 7200, (-18000), (-14400)], [1937269, 7200, (-14400), (-18000)], [1938114, 7200, (-18000), (-14400)], [1938268, 7200, (-14400), (-18000)], [1939120, 7200, (-18000), (-14400)], [1939267, 7200, (-14400), (-18000)], [1940119, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1946118, 7200, (-18000), (-14400)], [1946272, 7200, (-14400), (-18000)], [1947117, 0, (-18000), (-14400)], [1947271, 0, (-14400), (-18000)], [1948116, 0, (-18000), (-14400)], [1948270, 0, (-14400), (-18000)], [1949114, 0, (-18000), (-14400)], [1949331, 0, (-14400), (-18000)], [1950120, 7200, (-18000), (-14400)], [1950330, 7200, (-14400), (-18000)], [1951119, 7200, (-18000), (-14400)], [1951273, 7200, (-14400), (-18000)], [1952118, 7200, (-18000), (-14400)], [1952272, 7200, (-14400), (-18000)], [1953116, 7200, (-18000), (-14400)], [1953270, 7200, (-14400), (-18000)], [1954115, 7200, (-18000), (-14400)], [1954269, 7200, (-14400), (-18000)], [1955114, 7200, (-18000), (-14400)], [1955268, 7200, (-14400), (-18000)], [1956120, 7200, (-18000), (-14400)], [1956274, 7200, (-14400), (-18000)], [1957118, 7200, (-18000), (-14400)], [1957300, 7200, (-14400), (-18000)], [1958117, 7200, (-18000), (-14400)], [1958299, 7200, (-14400), (-18000)], [1959116, 7200, (-18000), (-14400)], [1959298, 7200, (-14400), (-18000)], [1960115, 7200, (-18000), (-14400)], [1960304, 7200, (-14400), (-18000)], [1961120, 7200, (-18000), (-14400)], [1961302, 7200, (-14400), (-18000)], [1962119, 7200, (-18000), (-14400)], [1962301, 7200, (-14400), (-18000)], [1963118, 7200, (-18000), (-14400)], [1963300, 7200, (-14400), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ament$__f_America_Toronto = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ament$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ament$.prototype.constructor = $c_Lzonedb_java_tzdb$ament$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ament$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ament$.prototype = $c_Lzonedb_java_tzdb$ament$.prototype;
var $d_Lzonedb_java_tzdb$ament$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ament$: 0
}, false, "zonedb.java.tzdb$ament$", {
  Lzonedb_java_tzdb$ament$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ament$.prototype.$classData = $d_Lzonedb_java_tzdb$ament$;
var $n_Lzonedb_java_tzdb$ament$;
function $m_Lzonedb_java_tzdb$ament$() {
  if ((!$n_Lzonedb_java_tzdb$ament$)) {
    $n_Lzonedb_java_tzdb$ament$ = new $c_Lzonedb_java_tzdb$ament$()
  };
  return $n_Lzonedb_java_tzdb$ament$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameob$() {
  this.Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba = null;
  $n_Lzonedb_java_tzdb$ameob$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15408));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15408));
  var _2 = [[1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameob$.prototype.constructor = $c_Lzonedb_java_tzdb$ameob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameob$.prototype = $c_Lzonedb_java_tzdb$ameob$.prototype;
var $d_Lzonedb_java_tzdb$ameob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameob$: 0
}, false, "zonedb.java.tzdb$ameob$", {
  Lzonedb_java_tzdb$ameob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameob$.prototype.$classData = $d_Lzonedb_java_tzdb$ameob$;
var $n_Lzonedb_java_tzdb$ameob$;
function $m_Lzonedb_java_tzdb$ameob$() {
  if ((!$n_Lzonedb_java_tzdb$ameob$)) {
    $n_Lzonedb_java_tzdb$ameob$ = new $c_Lzonedb_java_tzdb$ameob$()
  };
  return $n_Lzonedb_java_tzdb$ameob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoi$() {
  this.Lzonedb_java_tzdb$ameoi$__f_America_Detroit = null;
  $n_Lzonedb_java_tzdb$ameoi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-19931));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-19931));
  var _2 = [[1905001, 0, (-19931), (-21600)], [1915135, 7200, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905001, 0, (-19931), (-21600)], [1915135, 7200, (-21600), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1948116, 7200, (-18000), (-14400)], [1948270, 7200, (-14400), (-18000)], [1967165, 60, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameoi$__f_America_Detroit = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameoi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoi$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoi$.prototype = $c_Lzonedb_java_tzdb$ameoi$.prototype;
var $d_Lzonedb_java_tzdb$ameoi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoi$: 0
}, false, "zonedb.java.tzdb$ameoi$", {
  Lzonedb_java_tzdb$ameoi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoi$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoi$;
var $n_Lzonedb_java_tzdb$ameoi$;
function $m_Lzonedb_java_tzdb$ameoi$() {
  if ((!$n_Lzonedb_java_tzdb$ameoi$)) {
    $n_Lzonedb_java_tzdb$ameoi$ = new $c_Lzonedb_java_tzdb$ameoi$()
  };
  return $n_Lzonedb_java_tzdb$ameoi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoj$() {
  this.Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja = null;
  $n_Lzonedb_java_tzdb$ameoj$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16044));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16044));
  var _2 = [[1894304, 0, (-16044), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991059, 82800, (-10800), (-14400)], [1991127, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-16044), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991060, 0, (-7200), (-14400)], [1991127, 0, (-14400), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameoj$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoj$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoj$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoj$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoj$.prototype = $c_Lzonedb_java_tzdb$ameoj$.prototype;
var $d_Lzonedb_java_tzdb$ameoj$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoj$: 0
}, false, "zonedb.java.tzdb$ameoj$", {
  Lzonedb_java_tzdb$ameoj$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoj$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoj$;
var $n_Lzonedb_java_tzdb$ameoj$;
function $m_Lzonedb_java_tzdb$ameoj$() {
  if ((!$n_Lzonedb_java_tzdb$ameoj$)) {
    $n_Lzonedb_java_tzdb$ameoj$ = new $c_Lzonedb_java_tzdb$ameoj$()
  };
  return $n_Lzonedb_java_tzdb$ameoj$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameom$() {
  this.Lzonedb_java_tzdb$ameom$__f_America_Nome = null;
  $n_Lzonedb_java_tzdb$ameom$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 46702);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 46702);
  var _2 = [[1867292, 48575, 46702, (-39698)], [1900232, 43200, (-39698), (-39600)], [1983303, 3600, (-39600), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 48575, 46702, (-39698)], [1900232, 43200, (-39698), (-39600)], [1942040, 7200, (-39600), (-36000)], [1945273, 7200, (-36000), (-39600)], [1969117, 7200, (-39600), (-36000)], [1969299, 7200, (-36000), (-39600)], [1970116, 7200, (-39600), (-36000)], [1970298, 7200, (-36000), (-39600)], [1971115, 7200, (-39600), (-36000)], [1971304, 7200, (-36000), (-39600)], [1972121, 7200, (-39600), (-36000)], [1972303, 7200, (-36000), (-39600)], [1973119, 7200, (-39600), (-36000)], [1973301, 7200, (-36000), (-39600)], [1974006, 7200, (-39600), (-36000)], [1974300, 7200, (-36000), (-39600)], [1975054, 7200, (-39600), (-36000)], [1975299, 7200, (-36000), (-39600)], [1976116, 7200, (-39600), (-36000)], [1976305, 7200, (-36000), (-39600)], [1977114, 7200, (-39600), (-36000)], [1977303, 7200, (-36000), (-39600)], [1978120, 7200, (-39600), (-36000)], [1978302, 7200, (-36000), (-39600)], [1979119, 7200, (-39600), (-36000)], [1979301, 7200, (-36000), (-39600)], [1980118, 7200, (-39600), (-36000)], [1980300, 7200, (-36000), (-39600)], [1981116, 7200, (-39600), (-36000)], [1981298, 7200, (-36000), (-39600)], [1982115, 7200, (-39600), (-36000)], [1982304, 7200, (-36000), (-39600)], [1983114, 7200, (-39600), (-36000)], [1983303, 7200, (-36000), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameom$__f_America_Nome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameom$.prototype.constructor = $c_Lzonedb_java_tzdb$ameom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameom$.prototype = $c_Lzonedb_java_tzdb$ameom$.prototype;
var $d_Lzonedb_java_tzdb$ameom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameom$: 0
}, false, "zonedb.java.tzdb$ameom$", {
  Lzonedb_java_tzdb$ameom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameom$.prototype.$classData = $d_Lzonedb_java_tzdb$ameom$;
var $n_Lzonedb_java_tzdb$ameom$;
function $m_Lzonedb_java_tzdb$ameom$() {
  if ((!$n_Lzonedb_java_tzdb$ameom$)) {
    $n_Lzonedb_java_tzdb$ameom$ = new $c_Lzonedb_java_tzdb$ameom$()
  };
  return $n_Lzonedb_java_tzdb$ameom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameor$() {
  this.Lzonedb_java_tzdb$ameor$__f_America_New_York = null;
  $n_Lzonedb_java_tzdb$ameor$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-17762));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-17762));
  var _2 = [[1883322, 43438, (-17762), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 43438, (-17762), (-18000)], [1918090, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1919089, 7200, (-18000), (-14400)], [1919299, 7200, (-14400), (-18000)], [1920088, 7200, (-18000), (-14400)], [1920305, 7200, (-14400), (-18000)], [1921114, 7200, (-18000), (-14400)], [1921268, 7200, (-14400), (-18000)], [1922120, 7200, (-18000), (-14400)], [1922267, 7200, (-14400), (-18000)], [1923119, 7200, (-18000), (-14400)], [1923273, 7200, (-14400), (-18000)], [1924118, 7200, (-18000), (-14400)], [1924272, 7200, (-14400), (-18000)], [1925116, 7200, (-18000), (-14400)], [1925270, 7200, (-14400), (-18000)], [1926115, 7200, (-18000), (-14400)], [1926269, 7200, (-14400), (-18000)], [1927114, 7200, (-18000), (-14400)], [1927268, 7200, (-14400), (-18000)], [1928120, 7200, (-18000), (-14400)], [1928274, 7200, (-14400), (-18000)], [1929118, 7200, (-18000), (-14400)], [1929272, 7200, (-14400), (-18000)], [1930117, 7200, (-18000), (-14400)], [1930271, 7200, (-14400), (-18000)], [1931116, 7200, (-18000), (-14400)], [1931270, 7200, (-14400), (-18000)], [1932115, 7200, (-18000), (-14400)], [1932269, 7200, (-14400), (-18000)], [1933120, 7200, (-18000), (-14400)], [1933267, 7200, (-14400), (-18000)], [1934119, 7200, (-18000), (-14400)], [1934273, 7200, (-14400), (-18000)], [1935118, 7200, (-18000), (-14400)], [1935272, 7200, (-14400), (-18000)], [1936117, 7200, (-18000), (-14400)], [1936271, 7200, (-14400), (-18000)], [1937115, 7200, (-18000), (-14400)], [1937269, 7200, (-14400), (-18000)], [1938114, 7200, (-18000), (-14400)], [1938268, 7200, (-14400), (-18000)], [1939120, 7200, (-18000), (-14400)], [1939267, 7200, (-14400), (-18000)], [1940119, 7200, (-18000), (-14400)], [1940273, 7200, (-14400), (-18000)], [1941117, 7200, (-18000), (-14400)], [1941271, 7200, (-14400), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1946118, 7200, (-18000), (-14400)], [1946272, 7200, (-14400), (-18000)], [1947117, 7200, (-18000), (-14400)], [1947271, 7200, (-14400), (-18000)], [1948116, 7200, (-18000), (-14400)], [1948270, 7200, (-14400), (-18000)], [1949114, 7200, (-18000), (-14400)], [1949268, 7200, (-14400), (-18000)], [1950120, 7200, (-18000), (-14400)], [1950267, 7200, (-14400), (-18000)], [1951119, 7200, (-18000), (-14400)], [1951273, 7200, (-14400), (-18000)], [1952118, 7200, (-18000), (-14400)], [1952272, 7200, (-14400), (-18000)], [1953116, 7200, (-18000), (-14400)], [1953270, 7200, (-14400), (-18000)], [1954115, 7200, (-18000), (-14400)], [1954269, 7200, (-14400), (-18000)], [1955114, 7200, (-18000), (-14400)], [1955303, 7200, (-14400), (-18000)], [1956120, 7200, (-18000), (-14400)], [1956302, 7200, (-14400), (-18000)], [1957118, 7200, (-18000), (-14400)], [1957300, 7200, (-14400), (-18000)], [1958117, 7200, (-18000), (-14400)], [1958299, 7200, (-14400), (-18000)], [1959116, 7200, (-18000), (-14400)], [1959298, 7200, (-14400), (-18000)], [1960115, 7200, (-18000), (-14400)], [1960304, 7200, (-14400), (-18000)], [1961120, 7200, (-18000), (-14400)], [1961302, 7200, (-14400), (-18000)], [1962119, 7200, (-18000), (-14400)], [1962301, 7200, (-14400), (-18000)], [1963118, 7200, (-18000), (-14400)], [1963300, 7200, (-14400), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameor$__f_America_New_York = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameor$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameor$.prototype.constructor = $c_Lzonedb_java_tzdb$ameor$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameor$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameor$.prototype = $c_Lzonedb_java_tzdb$ameor$.prototype;
var $d_Lzonedb_java_tzdb$ameor$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameor$: 0
}, false, "zonedb.java.tzdb$ameor$", {
  Lzonedb_java_tzdb$ameor$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameor$.prototype.$classData = $d_Lzonedb_java_tzdb$ameor$;
var $n_Lzonedb_java_tzdb$ameor$;
function $m_Lzonedb_java_tzdb$ameor$() {
  if ((!$n_Lzonedb_java_tzdb$ameor$)) {
    $n_Lzonedb_java_tzdb$ameor$ = new $c_Lzonedb_java_tzdb$ameor$()
  };
  return $n_Lzonedb_java_tzdb$ameor$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameot$() {
  this.Lzonedb_java_tzdb$ameot$__f_America_Bogota = null;
  $n_Lzonedb_java_tzdb$ameot$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-17776));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-17776));
  var _2 = [[1914327, 0, (-17776), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914327, 0, (-17776), (-18000)], [1992124, 0, (-18000), (-14400)], [1993094, 0, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameot$__f_America_Bogota = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameot$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameot$.prototype.constructor = $c_Lzonedb_java_tzdb$ameot$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameot$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameot$.prototype = $c_Lzonedb_java_tzdb$ameot$.prototype;
var $d_Lzonedb_java_tzdb$ameot$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameot$: 0
}, false, "zonedb.java.tzdb$ameot$", {
  Lzonedb_java_tzdb$ameot$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameot$.prototype.$classData = $d_Lzonedb_java_tzdb$ameot$;
var $n_Lzonedb_java_tzdb$ameot$;
function $m_Lzonedb_java_tzdb$ameot$() {
  if ((!$n_Lzonedb_java_tzdb$ameot$)) {
    $n_Lzonedb_java_tzdb$ameot$ = new $c_Lzonedb_java_tzdb$ameot$()
  };
  return $n_Lzonedb_java_tzdb$ameot$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoz$() {
  this.Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza = null;
  $n_Lzonedb_java_tzdb$ameoz$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16516));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16516));
  var _2 = [[1894304, 0, (-16516), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990062, 82800, (-10800), (-14400)], [1992292, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004144, 0, (-10800), (-14400)], [2004270, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-16516), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-14400)], [1990288, 0, (-14400), (-10800)], [1991060, 0, (-10800), (-14400)], [1991288, 0, (-14400), (-10800)], [1992061, 0, (-10800), (-14400)], [1992292, 0, (-14400), (-7200)], [1993066, 0, (-7200), (-10800)], [2004144, 0, (-10800), (-14400)], [2004270, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameoz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoz$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoz$.prototype = $c_Lzonedb_java_tzdb$ameoz$.prototype;
var $d_Lzonedb_java_tzdb$ameoz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoz$: 0
}, false, "zonedb.java.tzdb$ameoz$", {
  Lzonedb_java_tzdb$ameoz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoz$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoz$;
var $n_Lzonedb_java_tzdb$ameoz$;
function $m_Lzonedb_java_tzdb$ameoz$() {
  if ((!$n_Lzonedb_java_tzdb$ameoz$)) {
    $n_Lzonedb_java_tzdb$ameoz$ = new $c_Lzonedb_java_tzdb$ameoz$()
  };
  return $n_Lzonedb_java_tzdb$ameoz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amepa$() {
  this.Lzonedb_java_tzdb$amepa$__f_America_La_Paz = null;
  $n_Lzonedb_java_tzdb$amepa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16356));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16356));
  var _2 = [[1932080, 82800, (-16356), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931288, 0, (-16356), (-12756)], [1932081, 0, (-12756), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amepa$__f_America_La_Paz = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amepa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amepa$.prototype.constructor = $c_Lzonedb_java_tzdb$amepa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amepa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amepa$.prototype = $c_Lzonedb_java_tzdb$amepa$.prototype;
var $d_Lzonedb_java_tzdb$amepa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amepa$: 0
}, false, "zonedb.java.tzdb$amepa$", {
  Lzonedb_java_tzdb$amepa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amepa$.prototype.$classData = $d_Lzonedb_java_tzdb$amepa$;
var $n_Lzonedb_java_tzdb$amepa$;
function $m_Lzonedb_java_tzdb$amepa$() {
  if ((!$n_Lzonedb_java_tzdb$amepa$)) {
    $n_Lzonedb_java_tzdb$amepa$ = new $c_Lzonedb_java_tzdb$amepa$()
  };
  return $n_Lzonedb_java_tzdb$amepa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amepe$() {
  this.Lzonedb_java_tzdb$amepe$__f_America_Winnipeg = null;
  $n_Lzonedb_java_tzdb$amepe$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-23316));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-23316));
  var _2 = [[1887197, 0, (-23316), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1887197, 0, (-23316), (-21600)], [1916114, 0, (-21600), (-18000)], [1916261, 0, (-18000), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1937136, 7200, (-21600), (-18000)], [1937269, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946132, 7200, (-21600), (-18000)], [1946286, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950121, 7200, (-21600), (-18000)], [1950273, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963265, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 10800, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 10800, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 10800, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 10800, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 10800, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 10800, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 10800, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 10800, (-18000), (-21600)], [1974118, 7200, (-21600), (-18000)], [1974300, 10800, (-18000), (-21600)], [1975117, 7200, (-21600), (-18000)], [1975299, 10800, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 10800, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 10800, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 10800, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 10800, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 10800, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 10800, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 10800, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 10800, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 10800, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 10800, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 10800, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 10800, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 10800, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 10800, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 10800, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 10800, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 10800, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 10800, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 10800, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 10800, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 10800, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 10800, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 10800, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 10800, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 10800, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 10800, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 10800, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 10800, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 10800, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 10800, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amepe$__f_America_Winnipeg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amepe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amepe$.prototype.constructor = $c_Lzonedb_java_tzdb$amepe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amepe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amepe$.prototype = $c_Lzonedb_java_tzdb$amepe$.prototype;
var $d_Lzonedb_java_tzdb$amepe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amepe$: 0
}, false, "zonedb.java.tzdb$amepe$", {
  Lzonedb_java_tzdb$amepe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amepe$.prototype.$classData = $d_Lzonedb_java_tzdb$amepe$;
var $n_Lzonedb_java_tzdb$amepe$;
function $m_Lzonedb_java_tzdb$amepe$() {
  if ((!$n_Lzonedb_java_tzdb$amepe$)) {
    $n_Lzonedb_java_tzdb$amepe$ = new $c_Lzonedb_java_tzdb$amepe$()
  };
  return $n_Lzonedb_java_tzdb$amepe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amequ$() {
  this.Lzonedb_java_tzdb$amequ$__f_America_Martinique = null;
  $n_Lzonedb_java_tzdb$amequ$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-14660));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-14660));
  var _2 = [[1911121, 0, (-14660), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911121, 0, (-14660), (-14400)], [1980097, 0, (-14400), (-10800)], [1980272, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amequ$__f_America_Martinique = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amequ$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amequ$.prototype.constructor = $c_Lzonedb_java_tzdb$amequ$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amequ$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amequ$.prototype = $c_Lzonedb_java_tzdb$amequ$.prototype;
var $d_Lzonedb_java_tzdb$amequ$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amequ$: 0
}, false, "zonedb.java.tzdb$amequ$", {
  Lzonedb_java_tzdb$amequ$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amequ$.prototype.$classData = $d_Lzonedb_java_tzdb$amequ$;
var $n_Lzonedb_java_tzdb$amequ$;
function $m_Lzonedb_java_tzdb$amequ$() {
  if ((!$n_Lzonedb_java_tzdb$amequ$)) {
    $n_Lzonedb_java_tzdb$amequ$ = new $c_Lzonedb_java_tzdb$amequ$()
  };
  return $n_Lzonedb_java_tzdb$amequ$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amera$() {
  this.Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas = null;
  $n_Lzonedb_java_tzdb$amera$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25260));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25260));
  var _2 = [[1921365, 86340, (-25260), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [2010094, 7200, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921365, 86340, (-25260), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007091, 7200, (-25200), (-21600)], [2007301, 7200, (-21600), (-25200)], [2008097, 7200, (-25200), (-21600)], [2008300, 7200, (-21600), (-25200)], [2009095, 7200, (-25200), (-21600)], [2009298, 7200, (-21600), (-25200)], [2010094, 7200, (-25200), (-18000)], [2010304, 7200, (-18000), (-21600)], [2011093, 7200, (-21600), (-18000)], [2011303, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amera$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amera$.prototype.constructor = $c_Lzonedb_java_tzdb$amera$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amera$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amera$.prototype = $c_Lzonedb_java_tzdb$amera$.prototype;
var $d_Lzonedb_java_tzdb$amera$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amera$: 0
}, false, "zonedb.java.tzdb$amera$", {
  Lzonedb_java_tzdb$amera$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amera$.prototype.$classData = $d_Lzonedb_java_tzdb$amera$;
var $n_Lzonedb_java_tzdb$amera$;
function $m_Lzonedb_java_tzdb$amera$() {
  if ((!$n_Lzonedb_java_tzdb$amera$)) {
    $n_Lzonedb_java_tzdb$amera$ = new $c_Lzonedb_java_tzdb$amera$()
  };
  return $n_Lzonedb_java_tzdb$amera$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amerc$() {
  this.Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca = null;
  $n_Lzonedb_java_tzdb$amerc$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15788));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15788));
  var _2 = [[1894304, 0, (-15788), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-15788), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amerc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amerc$.prototype.constructor = $c_Lzonedb_java_tzdb$amerc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amerc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amerc$.prototype = $c_Lzonedb_java_tzdb$amerc$.prototype;
var $d_Lzonedb_java_tzdb$amerc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amerc$: 0
}, false, "zonedb.java.tzdb$amerc$", {
  Lzonedb_java_tzdb$amerc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amerc$.prototype.$classData = $d_Lzonedb_java_tzdb$amerc$;
var $n_Lzonedb_java_tzdb$amerc$;
function $m_Lzonedb_java_tzdb$amerc$() {
  if ((!$n_Lzonedb_java_tzdb$amerc$)) {
    $n_Lzonedb_java_tzdb$amerc$ = new $c_Lzonedb_java_tzdb$amerc$()
  };
  return $n_Lzonedb_java_tzdb$amerc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amere$() {
  this.Lzonedb_java_tzdb$amere$__f_America_Santarem = null;
  this.Lzonedb_java_tzdb$amere$__f_America_Monterrey = null;
  this.Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires = null;
  $n_Lzonedb_java_tzdb$amere$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13128));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13128));
  var _2 = [[1914001, 0, (-13128), (-14400)], [2008176, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-13128), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [2008176, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amere$__f_America_Santarem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-24076));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-24076));
  var _2$3 = [[1921365, 83924, (-24076), (-21600)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1921365, 83924, (-24076), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$amere$__f_America_Monterrey = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-14028));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-14028));
  var _2$6 = [[1894304, 0, (-14028), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1894304, 0, (-14028), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$amere$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amere$.prototype.constructor = $c_Lzonedb_java_tzdb$amere$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amere$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amere$.prototype = $c_Lzonedb_java_tzdb$amere$.prototype;
var $d_Lzonedb_java_tzdb$amere$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amere$: 0
}, false, "zonedb.java.tzdb$amere$", {
  Lzonedb_java_tzdb$amere$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amere$.prototype.$classData = $d_Lzonedb_java_tzdb$amere$;
var $n_Lzonedb_java_tzdb$amere$;
function $m_Lzonedb_java_tzdb$amere$() {
  if ((!$n_Lzonedb_java_tzdb$amere$)) {
    $n_Lzonedb_java_tzdb$amere$ = new $c_Lzonedb_java_tzdb$amere$()
  };
  return $n_Lzonedb_java_tzdb$amere$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amero$() {
  this.Lzonedb_java_tzdb$amero$__f_America_Matamoros = null;
  $n_Lzonedb_java_tzdb$amero$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-24000));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-24000));
  var _2 = [[1921365, 84000, (-24000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921365, 84000, (-24000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007091, 7200, (-21600), (-18000)], [2007301, 7200, (-18000), (-21600)], [2008097, 7200, (-21600), (-18000)], [2008300, 7200, (-18000), (-21600)], [2009095, 7200, (-21600), (-18000)], [2009298, 7200, (-18000), (-21600)], [2010073, 7200, (-21600), (-18000)], [2010311, 7200, (-18000), (-21600)], [2011072, 7200, (-21600), (-18000)], [2011310, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amero$__f_America_Matamoros = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amero$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amero$.prototype.constructor = $c_Lzonedb_java_tzdb$amero$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amero$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amero$.prototype = $c_Lzonedb_java_tzdb$amero$.prototype;
var $d_Lzonedb_java_tzdb$amero$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amero$: 0
}, false, "zonedb.java.tzdb$amero$", {
  Lzonedb_java_tzdb$amero$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amero$.prototype.$classData = $d_Lzonedb_java_tzdb$amero$;
var $n_Lzonedb_java_tzdb$amero$;
function $m_Lzonedb_java_tzdb$amero$() {
  if ((!$n_Lzonedb_java_tzdb$amero$)) {
    $n_Lzonedb_java_tzdb$amero$ = new $c_Lzonedb_java_tzdb$amero$()
  };
  return $n_Lzonedb_java_tzdb$amero$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amers$() {
  this.Lzonedb_java_tzdb$amers$__f_America_Whitehorse = null;
  $n_Lzonedb_java_tzdb$amers$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-32412));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-32412));
  var _2 = [[1900232, 0, (-32412), (-32400)], [1967148, 0, (-32400), (-28800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900232, 0, (-32412), (-32400)], [1918104, 7200, (-32400), (-28800)], [1918300, 7200, (-28800), (-32400)], [1919145, 7200, (-32400), (-28800)], [1919305, 0, (-28800), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1965115, 0, (-32400), (-25200)], [1965304, 7200, (-25200), (-32400)], [1967148, 0, (-32400), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amers$__f_America_Whitehorse = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amers$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amers$.prototype.constructor = $c_Lzonedb_java_tzdb$amers$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amers$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amers$.prototype = $c_Lzonedb_java_tzdb$amers$.prototype;
var $d_Lzonedb_java_tzdb$amers$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amers$: 0
}, false, "zonedb.java.tzdb$amers$", {
  Lzonedb_java_tzdb$amers$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amers$.prototype.$classData = $d_Lzonedb_java_tzdb$amers$;
var $n_Lzonedb_java_tzdb$amers$;
function $m_Lzonedb_java_tzdb$amers$() {
  if ((!$n_Lzonedb_java_tzdb$amers$)) {
    $n_Lzonedb_java_tzdb$amers$ = new $c_Lzonedb_java_tzdb$amers$()
  };
  return $n_Lzonedb_java_tzdb$amers$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amesa$() {
  this.Lzonedb_java_tzdb$amesa$__f_America_Nassau = null;
  $n_Lzonedb_java_tzdb$amesa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-18570));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-18570));
  var _2 = [[1912062, 0, (-18570), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912062, 0, (-18570), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amesa$__f_America_Nassau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amesa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amesa$.prototype.constructor = $c_Lzonedb_java_tzdb$amesa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amesa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amesa$.prototype = $c_Lzonedb_java_tzdb$amesa$.prototype;
var $d_Lzonedb_java_tzdb$amesa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amesa$: 0
}, false, "zonedb.java.tzdb$amesa$", {
  Lzonedb_java_tzdb$amesa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amesa$.prototype.$classData = $d_Lzonedb_java_tzdb$amesa$;
var $n_Lzonedb_java_tzdb$amesa$;
function $m_Lzonedb_java_tzdb$amesa$() {
  if ((!$n_Lzonedb_java_tzdb$amesa$)) {
    $n_Lzonedb_java_tzdb$amesa$ = new $c_Lzonedb_java_tzdb$amesa$()
  };
  return $n_Lzonedb_java_tzdb$amesa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameso$() {
  this.Lzonedb_java_tzdb$ameso$__f_America_Dawson = null;
  this.Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson = null;
  $n_Lzonedb_java_tzdb$ameso$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-33460));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-33460));
  var _2 = [[1900232, 0, (-33460), (-32400)], [1973301, 0, (-32400), (-28800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900232, 0, (-33460), (-32400)], [1918104, 7200, (-32400), (-28800)], [1918300, 7200, (-28800), (-32400)], [1919145, 7200, (-32400), (-28800)], [1919305, 0, (-28800), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1965115, 0, (-32400), (-25200)], [1965304, 7200, (-25200), (-32400)], [1973301, 0, (-32400), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameso$__f_America_Dawson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-29447));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-29447));
  var _2$3 = [[1884001, 0, (-29447), (-28800)], [2015067, 7200, (-28800), (-25200)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1884001, 0, (-29447), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974118, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975117, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)], [2009067, 7200, (-28800), (-25200)], [2009305, 7200, (-25200), (-28800)], [2010073, 7200, (-28800), (-25200)], [2010311, 7200, (-25200), (-28800)], [2011072, 7200, (-28800), (-25200)], [2011310, 7200, (-25200), (-28800)], [2012071, 7200, (-28800), (-25200)], [2012309, 7200, (-25200), (-28800)], [2013069, 7200, (-28800), (-25200)], [2013307, 7200, (-25200), (-28800)], [2014068, 7200, (-28800), (-25200)], [2014306, 7200, (-25200), (-28800)], [2015067, 7200, (-28800), (-25200)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameso$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameso$.prototype.constructor = $c_Lzonedb_java_tzdb$ameso$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameso$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameso$.prototype = $c_Lzonedb_java_tzdb$ameso$.prototype;
var $d_Lzonedb_java_tzdb$ameso$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameso$: 0
}, false, "zonedb.java.tzdb$ameso$", {
  Lzonedb_java_tzdb$ameso$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameso$.prototype.$classData = $d_Lzonedb_java_tzdb$ameso$;
var $n_Lzonedb_java_tzdb$ameso$;
function $m_Lzonedb_java_tzdb$ameso$() {
  if ((!$n_Lzonedb_java_tzdb$ameso$)) {
    $n_Lzonedb_java_tzdb$ameso$ = new $c_Lzonedb_java_tzdb$ameso$()
  };
  return $n_Lzonedb_java_tzdb$ameso$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amest$() {
  this.Lzonedb_java_tzdb$amest$__f_America_Boa_Vista = null;
  $n_Lzonedb_java_tzdb$amest$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-14560));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-14560));
  var _2 = [[1914001, 0, (-14560), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-14560), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2000289, 0, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amest$__f_America_Boa_Vista = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amest$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amest$.prototype.constructor = $c_Lzonedb_java_tzdb$amest$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amest$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amest$.prototype = $c_Lzonedb_java_tzdb$amest$.prototype;
var $d_Lzonedb_java_tzdb$amest$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amest$: 0
}, false, "zonedb.java.tzdb$amest$", {
  Lzonedb_java_tzdb$amest$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amest$.prototype.$classData = $d_Lzonedb_java_tzdb$amest$;
var $n_Lzonedb_java_tzdb$amest$;
function $m_Lzonedb_java_tzdb$amest$() {
  if ((!$n_Lzonedb_java_tzdb$amest$)) {
    $n_Lzonedb_java_tzdb$amest$ = new $c_Lzonedb_java_tzdb$amest$()
  };
  return $n_Lzonedb_java_tzdb$amest$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameta$() {
  this.Lzonedb_java_tzdb$ameta$__f_America_Yakutat = null;
  $n_Lzonedb_java_tzdb$ameta$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 52865);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 52865);
  var _2 = [[1867292, 54738, 52865, (-33535)], [1900232, 43200, (-33535), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 54738, 52865, (-33535)], [1900232, 43200, (-33535), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1969117, 7200, (-32400), (-28800)], [1969299, 7200, (-28800), (-32400)], [1970116, 7200, (-32400), (-28800)], [1970298, 7200, (-28800), (-32400)], [1971115, 7200, (-32400), (-28800)], [1971304, 7200, (-28800), (-32400)], [1972121, 7200, (-32400), (-28800)], [1972303, 7200, (-28800), (-32400)], [1973119, 7200, (-32400), (-28800)], [1973301, 7200, (-28800), (-32400)], [1974006, 7200, (-32400), (-28800)], [1974300, 7200, (-28800), (-32400)], [1975054, 7200, (-32400), (-28800)], [1975299, 7200, (-28800), (-32400)], [1976116, 7200, (-32400), (-28800)], [1976305, 7200, (-28800), (-32400)], [1977114, 7200, (-32400), (-28800)], [1977303, 7200, (-28800), (-32400)], [1978120, 7200, (-32400), (-28800)], [1978302, 7200, (-28800), (-32400)], [1979119, 7200, (-32400), (-28800)], [1979301, 7200, (-28800), (-32400)], [1980118, 7200, (-32400), (-28800)], [1980300, 7200, (-28800), (-32400)], [1981116, 7200, (-32400), (-28800)], [1981298, 7200, (-28800), (-32400)], [1982115, 7200, (-32400), (-28800)], [1982304, 7200, (-28800), (-32400)], [1983114, 7200, (-32400), (-28800)], [1983303, 7200, (-28800), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameta$__f_America_Yakutat = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameta$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameta$.prototype.constructor = $c_Lzonedb_java_tzdb$ameta$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameta$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameta$.prototype = $c_Lzonedb_java_tzdb$ameta$.prototype;
var $d_Lzonedb_java_tzdb$ameta$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameta$: 0
}, false, "zonedb.java.tzdb$ameta$", {
  Lzonedb_java_tzdb$ameta$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameta$.prototype.$classData = $d_Lzonedb_java_tzdb$ameta$;
var $n_Lzonedb_java_tzdb$ameta$;
function $m_Lzonedb_java_tzdb$ameta$() {
  if ((!$n_Lzonedb_java_tzdb$ameta$)) {
    $n_Lzonedb_java_tzdb$ameta$ = new $c_Lzonedb_java_tzdb$ameta$()
  };
  return $n_Lzonedb_java_tzdb$ameta$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amete$() {
  this.Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center = null;
  $n_Lzonedb_java_tzdb$amete$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-24312));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-24312));
  var _2 = [[1883322, 44088, (-24312), (-25200)], [1992299, 3600, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44088, (-24312), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amete$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amete$.prototype.constructor = $c_Lzonedb_java_tzdb$amete$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amete$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amete$.prototype = $c_Lzonedb_java_tzdb$amete$.prototype;
var $d_Lzonedb_java_tzdb$amete$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amete$: 0
}, false, "zonedb.java.tzdb$amete$", {
  Lzonedb_java_tzdb$amete$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amete$.prototype.$classData = $d_Lzonedb_java_tzdb$amete$;
var $n_Lzonedb_java_tzdb$amete$;
function $m_Lzonedb_java_tzdb$amete$() {
  if ((!$n_Lzonedb_java_tzdb$amete$)) {
    $n_Lzonedb_java_tzdb$amete$ = new $c_Lzonedb_java_tzdb$amete$()
  };
  return $n_Lzonedb_java_tzdb$amete$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ametk$() {
  this.Lzonedb_java_tzdb$ametk$__f_America_Sitka = null;
  $n_Lzonedb_java_tzdb$ametk$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 53927);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 53927);
  var _2 = [[1867292, 55800, 53927, (-32473)], [1900232, 43200, (-32473), (-28800)], [1983303, 3600, (-28800), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 55800, 53927, (-32473)], [1900232, 43200, (-32473), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ametk$__f_America_Sitka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ametk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ametk$.prototype.constructor = $c_Lzonedb_java_tzdb$ametk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ametk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ametk$.prototype = $c_Lzonedb_java_tzdb$ametk$.prototype;
var $d_Lzonedb_java_tzdb$ametk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ametk$: 0
}, false, "zonedb.java.tzdb$ametk$", {
  Lzonedb_java_tzdb$ametk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ametk$.prototype.$classData = $d_Lzonedb_java_tzdb$ametk$;
var $n_Lzonedb_java_tzdb$ametk$;
function $m_Lzonedb_java_tzdb$ametk$() {
  if ((!$n_Lzonedb_java_tzdb$ametk$)) {
    $n_Lzonedb_java_tzdb$ametk$ = new $c_Lzonedb_java_tzdb$ametk$()
  };
  return $n_Lzonedb_java_tzdb$ametk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ametl$() {
  this.Lzonedb_java_tzdb$ametl$__f_America_Metlakatla = null;
  $n_Lzonedb_java_tzdb$ametl$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 54822);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 54822);
  var _2 = [[1867292, 56695, 54822, (-31578)], [1900232, 43200, (-31578), (-28800)], [2015305, 7200, (-28800), (-32400)], [2018308, 3600, (-32400), (-28800)], [2019020, 7200, (-28800), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1867292, 56695, 54822, (-31578)], [1900232, 43200, (-31578), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [2015305, 7200, (-28800), (-32400)], [2016073, 7200, (-32400), (-28800)], [2016311, 7200, (-28800), (-32400)], [2017071, 7200, (-32400), (-28800)], [2017309, 7200, (-28800), (-32400)], [2018070, 7200, (-32400), (-28800)], [2019020, 7200, (-28800), (-32400)], [2019069, 7200, (-32400), (-28800)], [2019307, 7200, (-28800), (-32400)], [2020068, 7200, (-32400), (-28800)], [2020306, 7200, (-28800), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ametl$__f_America_Metlakatla = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ametl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ametl$.prototype.constructor = $c_Lzonedb_java_tzdb$ametl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ametl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ametl$.prototype = $c_Lzonedb_java_tzdb$ametl$.prototype;
var $d_Lzonedb_java_tzdb$ametl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ametl$: 0
}, false, "zonedb.java.tzdb$ametl$", {
  Lzonedb_java_tzdb$ametl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ametl$.prototype.$classData = $d_Lzonedb_java_tzdb$ametl$;
var $n_Lzonedb_java_tzdb$ametl$;
function $m_Lzonedb_java_tzdb$ametl$() {
  if ((!$n_Lzonedb_java_tzdb$ametl$)) {
    $n_Lzonedb_java_tzdb$ametl$ = new $c_Lzonedb_java_tzdb$ametl$()
  };
  return $n_Lzonedb_java_tzdb$ametl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameto$() {
  this.Lzonedb_java_tzdb$ameto$__f_America_Creston = null;
  this.Lzonedb_java_tzdb$ameto$__f_America_Edmonton = null;
  this.Lzonedb_java_tzdb$ameto$__f_America_Moncton = null;
  $n_Lzonedb_java_tzdb$ameto$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-27964));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-27964));
  var _2 = [[1884001, 0, (-27964), (-25200)], [1916275, 0, (-25200), (-28800)], [1918153, 0, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, (-27964), (-25200)], [1916275, 0, (-25200), (-28800)], [1918153, 0, (-28800), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameto$__f_America_Creston = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-27232));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-27232));
  var _2$3 = [[1906244, 0, (-27232), (-25200)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1906244, 0, (-27232), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919103, 7200, (-25200), (-21600)], [1919147, 7200, (-21600), (-25200)], [1920116, 7200, (-25200), (-21600)], [1920305, 7200, (-21600), (-25200)], [1921114, 7200, (-25200), (-21600)], [1921268, 7200, (-21600), (-25200)], [1922120, 7200, (-25200), (-21600)], [1922267, 7200, (-21600), (-25200)], [1923119, 7200, (-25200), (-21600)], [1923273, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974118, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975117, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameto$__f_America_Edmonton = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-15548));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-15548));
  var _2$6 = [[1883343, 0, (-15548), (-18000)], [1902166, 0, (-18000), (-14400)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1883343, 0, (-15548), (-18000)], [1902166, 0, (-18000), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1933162, 3600, (-14400), (-10800)], [1933253, 3600, (-10800), (-14400)], [1934161, 3600, (-14400), (-10800)], [1934252, 3600, (-10800), (-14400)], [1935160, 3600, (-14400), (-10800)], [1935251, 3600, (-10800), (-14400)], [1936159, 3600, (-14400), (-10800)], [1936250, 3600, (-10800), (-14400)], [1937157, 3600, (-14400), (-10800)], [1937248, 3600, (-10800), (-14400)], [1938156, 3600, (-14400), (-10800)], [1938247, 3600, (-10800), (-14400)], [1939147, 3600, (-14400), (-10800)], [1939266, 3600, (-10800), (-14400)], [1940140, 3600, (-14400), (-10800)], [1940265, 3600, (-10800), (-14400)], [1941124, 3600, (-14400), (-10800)], [1941270, 3600, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1946118, 7200, (-14400), (-10800)], [1946272, 7200, (-10800), (-14400)], [1947117, 7200, (-14400), (-10800)], [1947271, 7200, (-10800), (-14400)], [1948116, 7200, (-14400), (-10800)], [1948270, 7200, (-10800), (-14400)], [1949114, 7200, (-14400), (-10800)], [1949268, 7200, (-10800), (-14400)], [1950120, 7200, (-14400), (-10800)], [1950267, 7200, (-10800), (-14400)], [1951119, 7200, (-14400), (-10800)], [1951273, 7200, (-10800), (-14400)], [1952118, 7200, (-14400), (-10800)], [1952272, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1954115, 7200, (-14400), (-10800)], [1954269, 7200, (-10800), (-14400)], [1955114, 7200, (-14400), (-10800)], [1955268, 7200, (-10800), (-14400)], [1956120, 7200, (-14400), (-10800)], [1956274, 7200, (-10800), (-14400)], [1957118, 7200, (-14400), (-10800)], [1957300, 7200, (-10800), (-14400)], [1958117, 7200, (-14400), (-10800)], [1958299, 7200, (-10800), (-14400)], [1959116, 7200, (-14400), (-10800)], [1959298, 7200, (-10800), (-14400)], [1960115, 7200, (-14400), (-10800)], [1960304, 7200, (-10800), (-14400)], [1961120, 7200, (-14400), (-10800)], [1961302, 7200, (-10800), (-14400)], [1962119, 7200, (-14400), (-10800)], [1962301, 7200, (-10800), (-14400)], [1963118, 7200, (-14400), (-10800)], [1963300, 7200, (-10800), (-14400)], [1964117, 7200, (-14400), (-10800)], [1964299, 7200, (-10800), (-14400)], [1965115, 7200, (-14400), (-10800)], [1965304, 7200, (-10800), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 60, (-14400), (-10800)], [1993304, 60, (-10800), (-14400)], [1994093, 60, (-14400), (-10800)], [1994303, 60, (-10800), (-14400)], [1995092, 60, (-14400), (-10800)], [1995302, 60, (-10800), (-14400)], [1996098, 60, (-14400), (-10800)], [1996301, 60, (-10800), (-14400)], [1997096, 60, (-14400), (-10800)], [1997299, 60, (-10800), (-14400)], [1998095, 60, (-14400), (-10800)], [1998298, 60, (-10800), (-14400)], [1999094, 60, (-14400), (-10800)], [1999304, 60, (-10800), (-14400)], [2000093, 60, (-14400), (-10800)], [2000303, 60, (-10800), (-14400)], [2001091, 60, (-14400), (-10800)], [2001301, 60, (-10800), (-14400)], [2002097, 60, (-14400), (-10800)], [2002300, 60, (-10800), (-14400)], [2003096, 60, (-14400), (-10800)], [2003299, 60, (-10800), (-14400)], [2004095, 60, (-14400), (-10800)], [2004305, 60, (-10800), (-14400)], [2005093, 60, (-14400), (-10800)], [2005303, 60, (-10800), (-14400)], [2006092, 60, (-14400), (-10800)], [2006302, 60, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameto$__f_America_Moncton = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$ameto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameto$.prototype.constructor = $c_Lzonedb_java_tzdb$ameto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameto$.prototype = $c_Lzonedb_java_tzdb$ameto$.prototype;
var $d_Lzonedb_java_tzdb$ameto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameto$: 0
}, false, "zonedb.java.tzdb$ameto$", {
  Lzonedb_java_tzdb$ameto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameto$.prototype.$classData = $d_Lzonedb_java_tzdb$ameto$;
var $n_Lzonedb_java_tzdb$ameto$;
function $m_Lzonedb_java_tzdb$ameto$() {
  if ((!$n_Lzonedb_java_tzdb$ameto$)) {
    $n_Lzonedb_java_tzdb$ameto$ = new $c_Lzonedb_java_tzdb$ameto$()
  };
  return $n_Lzonedb_java_tzdb$ameto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameua$() {
  this.Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan = null;
  $n_Lzonedb_java_tzdb$ameua$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-16444));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-16444));
  var _2 = [[1894304, 0, (-16444), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991059, 82800, (-10800), (-14400)], [1991127, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894304, 0, (-16444), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991060, 0, (-7200), (-14400)], [1991127, 0, (-14400), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameua$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameua$.prototype.constructor = $c_Lzonedb_java_tzdb$ameua$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameua$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameua$.prototype = $c_Lzonedb_java_tzdb$ameua$.prototype;
var $d_Lzonedb_java_tzdb$ameua$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameua$: 0
}, false, "zonedb.java.tzdb$ameua$", {
  Lzonedb_java_tzdb$ameua$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameua$.prototype.$classData = $d_Lzonedb_java_tzdb$ameua$;
var $n_Lzonedb_java_tzdb$ameua$;
function $m_Lzonedb_java_tzdb$ameua$() {
  if ((!$n_Lzonedb_java_tzdb$ameua$)) {
    $n_Lzonedb_java_tzdb$ameua$ = new $c_Lzonedb_java_tzdb$ameua$()
  };
  return $n_Lzonedb_java_tzdb$ameua$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameui$() {
  this.Lzonedb_java_tzdb$ameui$__f_America_Iqaluit = null;
  this.Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis = null;
  this.Lzonedb_java_tzdb$ameui$__f_America_Guayaquil = null;
  $n_Lzonedb_java_tzdb$ameui$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1942213, 0, 0, (-18000)], [1999304, 3600, (-18000), (-21600)], [2000303, 3600, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1942213, 0, 0, (-14400)], [1945273, 7200, (-14400), (-18000)], [1965115, 0, (-18000), (-10800)], [1965304, 7200, (-10800), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameui$__f_America_Iqaluit = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-15924));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-15924));
  var _2$3 = [[1894304, 0, (-15924), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990072, 82800, (-10800), (-14400)], [1991152, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2008020, 82800, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1894304, 0, (-15924), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990073, 0, (-7200), (-14400)], [1990288, 0, (-14400), (-10800)], [1991060, 0, (-10800), (-14400)], [1991152, 0, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008021, 0, (-7200), (-10800)], [2008069, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009067, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-19160));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-19160));
  var _2$6 = [[1890001, 0, (-19160), (-18840)], [1931001, 0, (-18840), (-18000)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1890001, 0, (-19160), (-18840)], [1931001, 0, (-18840), (-18000)], [1992333, 0, (-18000), (-14400)], [1993036, 0, (-14400), (-18000)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameui$__f_America_Guayaquil = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$ameui$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameui$.prototype.constructor = $c_Lzonedb_java_tzdb$ameui$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameui$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameui$.prototype = $c_Lzonedb_java_tzdb$ameui$.prototype;
var $d_Lzonedb_java_tzdb$ameui$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameui$: 0
}, false, "zonedb.java.tzdb$ameui$", {
  Lzonedb_java_tzdb$ameui$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameui$.prototype.$classData = $d_Lzonedb_java_tzdb$ameui$;
var $n_Lzonedb_java_tzdb$ameui$;
function $m_Lzonedb_java_tzdb$ameui$() {
  if ((!$n_Lzonedb_java_tzdb$ameui$)) {
    $n_Lzonedb_java_tzdb$ameui$ = new $c_Lzonedb_java_tzdb$ameui$()
  };
  return $n_Lzonedb_java_tzdb$ameui$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameul$() {
  this.Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo = null;
  this.Lzonedb_java_tzdb$ameul$__f_America_Thule = null;
  $n_Lzonedb_java_tzdb$ameul$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-11188));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-11188));
  var _2 = [[1914001, 0, (-11188), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, (-11188), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963296, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991048, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992040, 0, (-7200), (-10800)], [1992299, 0, (-10800), (-7200)], [1993031, 0, (-7200), (-10800)], [1993290, 0, (-10800), (-7200)], [1994051, 0, (-7200), (-10800)], [1994289, 0, (-10800), (-7200)], [1995050, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2003292, 0, (-10800), (-7200)], [2004046, 0, (-7200), (-10800)], [2004307, 0, (-10800), (-7200)], [2005051, 0, (-7200), (-10800)], [2005289, 0, (-10800), (-7200)], [2006050, 0, (-7200), (-10800)], [2006309, 0, (-10800), (-7200)], [2007056, 0, (-7200), (-10800)], [2007287, 0, (-10800), (-7200)], [2008048, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009046, 0, (-7200), (-10800)], [2009291, 0, (-10800), (-7200)], [2010052, 0, (-7200), (-10800)], [2010290, 0, (-10800), (-7200)], [2011051, 0, (-7200), (-10800)], [2011289, 0, (-10800), (-7200)], [2012057, 0, (-7200), (-10800)], [2012295, 0, (-10800), (-7200)], [2013048, 0, (-7200), (-10800)], [2013293, 0, (-10800), (-7200)], [2014047, 0, (-7200), (-10800)], [2014292, 0, (-10800), (-7200)], [2015053, 0, (-7200), (-10800)], [2015291, 0, (-10800), (-7200)], [2016052, 0, (-7200), (-10800)], [2016290, 0, (-10800), (-7200)], [2017050, 0, (-7200), (-10800)], [2017288, 0, (-10800), (-7200)], [2018049, 0, (-7200), (-10800)], [2018308, 0, (-10800), (-7200)], [2019048, 0, (-7200), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-16508));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-16508));
  var _2$3 = [[1916210, 0, (-16508), (-14400)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1916210, 0, (-16508), (-14400)], [1991090, 7200, (-14400), (-10800)], [1991272, 7200, (-10800), (-14400)], [1992089, 7200, (-14400), (-10800)], [1992271, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameul$__f_America_Thule = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameul$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameul$.prototype.constructor = $c_Lzonedb_java_tzdb$ameul$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameul$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameul$.prototype = $c_Lzonedb_java_tzdb$ameul$.prototype;
var $d_Lzonedb_java_tzdb$ameul$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameul$: 0
}, false, "zonedb.java.tzdb$ameul$", {
  Lzonedb_java_tzdb$ameul$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameul$.prototype.$classData = $d_Lzonedb_java_tzdb$ameul$;
var $n_Lzonedb_java_tzdb$ameul$;
function $m_Lzonedb_java_tzdb$ameul$() {
  if ((!$n_Lzonedb_java_tzdb$ameul$)) {
    $n_Lzonedb_java_tzdb$ameul$ = new $c_Lzonedb_java_tzdb$ameul$()
  };
  return $n_Lzonedb_java_tzdb$ameul$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameun$() {
  this.Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund = null;
  this.Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung = null;
  $n_Lzonedb_java_tzdb$ameun$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-5272));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-5272));
  var _2 = [[1916210, 0, (-5272), (-7200)], [1981088, 0, (-7200), (-3600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916210, 0, (-5272), (-7200)], [1980097, 7200, (-7200), (-3600)], [1980272, 10800, (-3600), (-7200)], [1981088, 0, (-7200), 0], [1981270, 3600, 0, (-3600)], [1982087, 0, (-3600), 0], [1982269, 3600, 0, (-3600)], [1983086, 0, (-3600), 0], [1983268, 3600, 0, (-3600)], [1984085, 0, (-3600), 0], [1984274, 3600, 0, (-3600)], [1985090, 0, (-3600), 0], [1985272, 3600, 0, (-3600)], [1986089, 0, (-3600), 0], [1986271, 3600, 0, (-3600)], [1987088, 0, (-3600), 0], [1987270, 3600, 0, (-3600)], [1988087, 0, (-3600), 0], [1988269, 3600, 0, (-3600)], [1989085, 0, (-3600), 0], [1989267, 3600, 0, (-3600)], [1990084, 0, (-3600), 0], [1990273, 3600, 0, (-3600)], [1991090, 0, (-3600), 0], [1991272, 3600, 0, (-3600)], [1992089, 0, (-3600), 0], [1992271, 3600, 0, (-3600)], [1993087, 0, (-3600), 0], [1993269, 3600, 0, (-3600)], [1994086, 0, (-3600), 0], [1994268, 3600, 0, (-3600)], [1995085, 0, (-3600), 0], [1995267, 3600, 0, (-3600)], [1996091, 0, (-3600), 0], [1996301, 3600, 0, (-3600)], [1997089, 0, (-3600), 0], [1997299, 3600, 0, (-3600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, (-3600), (-3600), 0], [10, 25, 7, 3600, 0, 0, (-3600), 0, (-3600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2$3 = [[1921001, 0, 0, (-14400)], [1995092, 7200, (-14400), (-18000)], [1999304, 3600, (-18000), (-21600)], [2000303, 3600, (-21600), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1921001, 0, 0, (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1965115, 0, (-14400), (-7200)], [1965304, 7200, (-7200), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameun$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameun$.prototype.constructor = $c_Lzonedb_java_tzdb$ameun$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameun$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameun$.prototype = $c_Lzonedb_java_tzdb$ameun$.prototype;
var $d_Lzonedb_java_tzdb$ameun$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameun$: 0
}, false, "zonedb.java.tzdb$ameun$", {
  Lzonedb_java_tzdb$ameun$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameun$.prototype.$classData = $d_Lzonedb_java_tzdb$ameun$;
var $n_Lzonedb_java_tzdb$ameun$;
function $m_Lzonedb_java_tzdb$ameun$() {
  if ((!$n_Lzonedb_java_tzdb$ameun$)) {
    $n_Lzonedb_java_tzdb$ameun$ = new $c_Lzonedb_java_tzdb$ameun$()
  };
  return $n_Lzonedb_java_tzdb$ameun$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameur$() {
  this.Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg = null;
  this.Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk = null;
  $n_Lzonedb_java_tzdb$ameur$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20947));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20947));
  var _2 = [[1883322, 43853, (-20947), (-21600)], [1965115, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1977303, 3600, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007308, 3600, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 43853, (-20947), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1964299, 7200, (-18000), (-21600)], [1965115, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-17072));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-17072));
  var _2$3 = [[1890001, 0, (-17072), (-18430)], [1912032, 0, (-18430), (-18000)], [2015305, 3600, (-18000), (-14400)], [2018070, 10800, (-14400), (-18000)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890001, 0, (-17072), (-18430)], [1912032, 0, (-18430), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)], [2009067, 7200, (-18000), (-14400)], [2009305, 7200, (-14400), (-18000)], [2010073, 7200, (-18000), (-14400)], [2010311, 7200, (-14400), (-18000)], [2011072, 7200, (-18000), (-14400)], [2011310, 7200, (-14400), (-18000)], [2012071, 7200, (-18000), (-14400)], [2012309, 7200, (-14400), (-18000)], [2013069, 7200, (-18000), (-14400)], [2013307, 7200, (-14400), (-18000)], [2014068, 7200, (-18000), (-14400)], [2014306, 7200, (-14400), (-18000)], [2015067, 7200, (-18000), (-14400)], [2018308, 7200, (-14400), (-18000)], [2019069, 7200, (-18000), (-14400)], [2019307, 7200, (-14400), (-18000)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$ameur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameur$.prototype.constructor = $c_Lzonedb_java_tzdb$ameur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameur$.prototype = $c_Lzonedb_java_tzdb$ameur$.prototype;
var $d_Lzonedb_java_tzdb$ameur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameur$: 0
}, false, "zonedb.java.tzdb$ameur$", {
  Lzonedb_java_tzdb$ameur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameur$.prototype.$classData = $d_Lzonedb_java_tzdb$ameur$;
var $n_Lzonedb_java_tzdb$ameur$;
function $m_Lzonedb_java_tzdb$ameur$() {
  if ((!$n_Lzonedb_java_tzdb$ameur$)) {
    $n_Lzonedb_java_tzdb$ameur$ = new $c_Lzonedb_java_tzdb$ameur$()
  };
  return $n_Lzonedb_java_tzdb$ameur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameut$() {
  this.Lzonedb_java_tzdb$ameut$__f_America_Resolute = null;
  $n_Lzonedb_java_tzdb$ameut$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1947243, 0, 0, (-21600)], [2000303, 3600, (-21600), (-18000)], [2001091, 10800, (-18000), (-21600)], [2006302, 3600, (-21600), (-18000)], [2007070, 10800, (-18000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1947243, 0, 0, (-21600)], [1965115, 0, (-21600), (-14400)], [1965304, 7200, (-14400), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameut$__f_America_Resolute = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameut$.prototype.constructor = $c_Lzonedb_java_tzdb$ameut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameut$.prototype = $c_Lzonedb_java_tzdb$ameut$.prototype;
var $d_Lzonedb_java_tzdb$ameut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameut$: 0
}, false, "zonedb.java.tzdb$ameut$", {
  Lzonedb_java_tzdb$ameut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameut$.prototype.$classData = $d_Lzonedb_java_tzdb$ameut$;
var $n_Lzonedb_java_tzdb$ameut$;
function $m_Lzonedb_java_tzdb$ameut$() {
  if ((!$n_Lzonedb_java_tzdb$ameut$)) {
    $n_Lzonedb_java_tzdb$ameut$ = new $c_Lzonedb_java_tzdb$ameut$()
  };
  return $n_Lzonedb_java_tzdb$ameut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameva$() {
  this.Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay = null;
  $n_Lzonedb_java_tzdb$ameva$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-20416));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-20416));
  var _2 = [[1883322, 44384, (-20416), (-21600)], [1954115, 7200, (-21600), (-18000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 44384, (-20416), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ameva$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameva$.prototype.constructor = $c_Lzonedb_java_tzdb$ameva$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameva$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameva$.prototype = $c_Lzonedb_java_tzdb$ameva$.prototype;
var $d_Lzonedb_java_tzdb$ameva$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameva$: 0
}, false, "zonedb.java.tzdb$ameva$", {
  Lzonedb_java_tzdb$ameva$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameva$.prototype.$classData = $d_Lzonedb_java_tzdb$ameva$;
var $n_Lzonedb_java_tzdb$ameva$;
function $m_Lzonedb_java_tzdb$ameva$() {
  if ((!$n_Lzonedb_java_tzdb$ameva$)) {
    $n_Lzonedb_java_tzdb$ameva$ = new $c_Lzonedb_java_tzdb$ameva$()
  };
  return $n_Lzonedb_java_tzdb$ameva$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameve$() {
  this.Lzonedb_java_tzdb$ameve$__f_America_Denver = null;
  this.Lzonedb_java_tzdb$ameve$__f_America_Vancouver = null;
  this.Lzonedb_java_tzdb$ameve$__f_America_Rainy_River = null;
  $n_Lzonedb_java_tzdb$ameve$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-25196));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-25196));
  var _2 = [[1883322, 43204, (-25196), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1883322, 43204, (-25196), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1920088, 7200, (-25200), (-21600)], [1920305, 7200, (-21600), (-25200)], [1921086, 7200, (-25200), (-21600)], [1921142, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 7200, (-25200), (-21600)], [1965304, 7200, (-21600), (-25200)], [1966114, 7200, (-25200), (-21600)], [1966303, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ameve$__f_America_Denver = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-29548));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-29548));
  var _2$3 = [[1884001, 0, (-29548), (-28800)]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1884001, 0, (-29548), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1946118, 7200, (-28800), (-25200)], [1946272, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974118, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975117, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$ameve$__f_America_Vancouver = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", (-22696));
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", (-22696));
  var _2$6 = [[1895001, 0, (-22696), (-21600)]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1895001, 0, (-22696), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1940273, 0, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1974118, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975117, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$ameve$__f_America_Rainy_River = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$ameve$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameve$.prototype.constructor = $c_Lzonedb_java_tzdb$ameve$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameve$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameve$.prototype = $c_Lzonedb_java_tzdb$ameve$.prototype;
var $d_Lzonedb_java_tzdb$ameve$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameve$: 0
}, false, "zonedb.java.tzdb$ameve$", {
  Lzonedb_java_tzdb$ameve$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameve$.prototype.$classData = $d_Lzonedb_java_tzdb$ameve$;
var $n_Lzonedb_java_tzdb$ameve$;
function $m_Lzonedb_java_tzdb$ameve$() {
  if ((!$n_Lzonedb_java_tzdb$ameve$)) {
    $n_Lzonedb_java_tzdb$ameve$ = new $c_Lzonedb_java_tzdb$ameve$()
  };
  return $n_Lzonedb_java_tzdb$ameve$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amevi$() {
  this.Lzonedb_java_tzdb$amevi$__f_America_Inuvik = null;
  $n_Lzonedb_java_tzdb$amevi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1953001, 0, 0, (-28800)], [1979119, 7200, (-28800), (-25200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1953001, 0, 0, (-28800)], [1965115, 0, (-28800), (-21600)], [1965304, 7200, (-21600), (-28800)], [1979119, 7200, (-28800), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$amevi$__f_America_Inuvik = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$amevi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amevi$.prototype.constructor = $c_Lzonedb_java_tzdb$amevi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amevi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amevi$.prototype = $c_Lzonedb_java_tzdb$amevi$.prototype;
var $d_Lzonedb_java_tzdb$amevi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amevi$: 0
}, false, "zonedb.java.tzdb$amevi$", {
  Lzonedb_java_tzdb$amevi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amevi$.prototype.$classData = $d_Lzonedb_java_tzdb$amevi$;
var $n_Lzonedb_java_tzdb$amevi$;
function $m_Lzonedb_java_tzdb$amevi$() {
  if ((!$n_Lzonedb_java_tzdb$amevi$)) {
    $n_Lzonedb_java_tzdb$amevi$ = new $c_Lzonedb_java_tzdb$amevi$()
  };
  return $n_Lzonedb_java_tzdb$amevi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$anter$() {
  this.Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera = null;
  $n_Lzonedb_java_tzdb$anter$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1976336, 0, 0, (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1976336, 0, 0, (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$anter$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$anter$.prototype.constructor = $c_Lzonedb_java_tzdb$anter$;
/** @constructor */
function $h_Lzonedb_java_tzdb$anter$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$anter$.prototype = $c_Lzonedb_java_tzdb$anter$.prototype;
var $d_Lzonedb_java_tzdb$anter$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$anter$: 0
}, false, "zonedb.java.tzdb$anter$", {
  Lzonedb_java_tzdb$anter$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$anter$.prototype.$classData = $d_Lzonedb_java_tzdb$anter$;
var $n_Lzonedb_java_tzdb$anter$;
function $m_Lzonedb_java_tzdb$anter$() {
  if ((!$n_Lzonedb_java_tzdb$anter$)) {
    $n_Lzonedb_java_tzdb$anter$ = new $c_Lzonedb_java_tzdb$anter$()
  };
  return $n_Lzonedb_java_tzdb$anter$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antll$() {
  this.Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville = null;
  $n_Lzonedb_java_tzdb$antll$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1947001, 0, 0, 36000], [1952014, 0, 36000, 0], [1956306, 0, 0, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1947001, 0, 0, 36000], [1952014, 0, 36000, 0], [1956306, 0, 0, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antll$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antll$.prototype.constructor = $c_Lzonedb_java_tzdb$antll$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antll$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antll$.prototype = $c_Lzonedb_java_tzdb$antll$.prototype;
var $d_Lzonedb_java_tzdb$antll$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antll$: 0
}, false, "zonedb.java.tzdb$antll$", {
  Lzonedb_java_tzdb$antll$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antll$.prototype.$classData = $d_Lzonedb_java_tzdb$antll$;
var $n_Lzonedb_java_tzdb$antll$;
function $m_Lzonedb_java_tzdb$antll$() {
  if ((!$n_Lzonedb_java_tzdb$antll$)) {
    $n_Lzonedb_java_tzdb$antll$ = new $c_Lzonedb_java_tzdb$antll$()
  };
  return $n_Lzonedb_java_tzdb$antll$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antme$() {
  this.Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer = null;
  $n_Lzonedb_java_tzdb$antme$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1965001, 0, 0, (-14400)], [1969278, 0, (-14400), (-10800)], [1982121, 0, (-10800), (-14400)], [2016338, 82800, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1965001, 0, 0, (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1982121, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antme$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antme$.prototype.constructor = $c_Lzonedb_java_tzdb$antme$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antme$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antme$.prototype = $c_Lzonedb_java_tzdb$antme$.prototype;
var $d_Lzonedb_java_tzdb$antme$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antme$: 0
}, false, "zonedb.java.tzdb$antme$", {
  Lzonedb_java_tzdb$antme$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antme$.prototype.$classData = $d_Lzonedb_java_tzdb$antme$;
var $n_Lzonedb_java_tzdb$antme$;
function $m_Lzonedb_java_tzdb$antme$() {
  if ((!$n_Lzonedb_java_tzdb$antme$)) {
    $n_Lzonedb_java_tzdb$antme$ = new $c_Lzonedb_java_tzdb$antme$()
  };
  return $n_Lzonedb_java_tzdb$antme$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antol$() {
  this.Lzonedb_java_tzdb$antol$__f_Antarctica_Troll = null;
  $n_Lzonedb_java_tzdb$antol$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[2005086, 3600, 0, 7200], [2005303, 10800, 7200, 0], [2006085, 3600, 0, 7200], [2006302, 10800, 7200, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 7200], [10, 25, 7, 3600, 0, 0, 0, 7200, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antol$__f_Antarctica_Troll = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antol$.prototype.constructor = $c_Lzonedb_java_tzdb$antol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antol$.prototype = $c_Lzonedb_java_tzdb$antol$.prototype;
var $d_Lzonedb_java_tzdb$antol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antol$: 0
}, false, "zonedb.java.tzdb$antol$", {
  Lzonedb_java_tzdb$antol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antol$.prototype.$classData = $d_Lzonedb_java_tzdb$antol$;
var $n_Lzonedb_java_tzdb$antol$;
function $m_Lzonedb_java_tzdb$antol$() {
  if ((!$n_Lzonedb_java_tzdb$antol$)) {
    $n_Lzonedb_java_tzdb$antol$ = new $c_Lzonedb_java_tzdb$antol$()
  };
  return $n_Lzonedb_java_tzdb$antol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antow$() {
  this.Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa = null;
  $n_Lzonedb_java_tzdb$antow$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1957029, 0, 0, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1957029, 0, 0, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antow$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antow$.prototype.constructor = $c_Lzonedb_java_tzdb$antow$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antow$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antow$.prototype = $c_Lzonedb_java_tzdb$antow$.prototype;
var $d_Lzonedb_java_tzdb$antow$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antow$: 0
}, false, "zonedb.java.tzdb$antow$", {
  Lzonedb_java_tzdb$antow$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antow$.prototype.$classData = $d_Lzonedb_java_tzdb$antow$;
var $n_Lzonedb_java_tzdb$antow$;
function $m_Lzonedb_java_tzdb$antow$() {
  if ((!$n_Lzonedb_java_tzdb$antow$)) {
    $n_Lzonedb_java_tzdb$antow$ = new $c_Lzonedb_java_tzdb$antow$()
  };
  return $n_Lzonedb_java_tzdb$antow$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antri$() {
  this.Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie = null;
  $n_Lzonedb_java_tzdb$antri$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1899305, 0, 0, 36000], [1919091, 0, 36000, 0], [1948085, 0, 0, 36000], [2010094, 7200, 36000, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1899305, 0, 0, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1919091, 0, 36000, 0], [1948085, 0, 0, 36000], [1967274, 7200, 36000, 39600], [1968091, 10800, 39600, 36000], [1968301, 7200, 36000, 39600], [1969068, 10800, 39600, 36000], [1969299, 7200, 36000, 39600], [1970067, 10800, 39600, 36000], [1970298, 7200, 36000, 39600], [1971073, 10800, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antri$.prototype.constructor = $c_Lzonedb_java_tzdb$antri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antri$.prototype = $c_Lzonedb_java_tzdb$antri$.prototype;
var $d_Lzonedb_java_tzdb$antri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antri$: 0
}, false, "zonedb.java.tzdb$antri$", {
  Lzonedb_java_tzdb$antri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antri$.prototype.$classData = $d_Lzonedb_java_tzdb$antri$;
var $n_Lzonedb_java_tzdb$antri$;
function $m_Lzonedb_java_tzdb$antri$() {
  if ((!$n_Lzonedb_java_tzdb$antri$)) {
    $n_Lzonedb_java_tzdb$antri$ = new $c_Lzonedb_java_tzdb$antri$()
  };
  return $n_Lzonedb_java_tzdb$antri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antse$() {
  this.Lzonedb_java_tzdb$antse$__f_Antarctica_Casey = null;
  $n_Lzonedb_java_tzdb$antse$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1969001, 0, 0, 28800], [2009291, 7200, 28800, 39600], [2010064, 7200, 39600, 28800], [2011301, 7200, 28800, 39600], [2012053, 14400, 39600, 28800], [2016296, 0, 28800, 39600], [2018070, 14400, 39600, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1969001, 0, 0, 28800], [2009291, 7200, 28800, 39600], [2010064, 7200, 39600, 28800], [2011301, 7200, 28800, 39600], [2012053, 14400, 39600, 28800], [2016296, 0, 28800, 39600], [2018070, 14400, 39600, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antse$__f_Antarctica_Casey = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antse$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antse$.prototype.constructor = $c_Lzonedb_java_tzdb$antse$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antse$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antse$.prototype = $c_Lzonedb_java_tzdb$antse$.prototype;
var $d_Lzonedb_java_tzdb$antse$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antse$: 0
}, false, "zonedb.java.tzdb$antse$", {
  Lzonedb_java_tzdb$antse$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antse$.prototype.$classData = $d_Lzonedb_java_tzdb$antse$;
var $n_Lzonedb_java_tzdb$antse$;
function $m_Lzonedb_java_tzdb$antse$() {
  if ((!$n_Lzonedb_java_tzdb$antse$)) {
    $n_Lzonedb_java_tzdb$antse$ = new $c_Lzonedb_java_tzdb$antse$()
  };
  return $n_Lzonedb_java_tzdb$antse$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antso$() {
  this.Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson = null;
  $n_Lzonedb_java_tzdb$antso$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1954044, 0, 0, 21600], [2009291, 7200, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1954044, 0, 0, 21600], [2009291, 7200, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antso$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antso$.prototype.constructor = $c_Lzonedb_java_tzdb$antso$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antso$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antso$.prototype = $c_Lzonedb_java_tzdb$antso$.prototype;
var $d_Lzonedb_java_tzdb$antso$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antso$: 0
}, false, "zonedb.java.tzdb$antso$", {
  Lzonedb_java_tzdb$antso$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antso$.prototype.$classData = $d_Lzonedb_java_tzdb$antso$;
var $n_Lzonedb_java_tzdb$antso$;
function $m_Lzonedb_java_tzdb$antso$() {
  if ((!$n_Lzonedb_java_tzdb$antso$)) {
    $n_Lzonedb_java_tzdb$antso$ = new $c_Lzonedb_java_tzdb$antso$()
  };
  return $n_Lzonedb_java_tzdb$antso$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antto$() {
  this.Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok = null;
  $n_Lzonedb_java_tzdb$antto$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1957350, 0, 0, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1957350, 0, 0, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antto$.prototype.constructor = $c_Lzonedb_java_tzdb$antto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antto$.prototype = $c_Lzonedb_java_tzdb$antto$.prototype;
var $d_Lzonedb_java_tzdb$antto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antto$: 0
}, false, "zonedb.java.tzdb$antto$", {
  Lzonedb_java_tzdb$antto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antto$.prototype.$classData = $d_Lzonedb_java_tzdb$antto$;
var $n_Lzonedb_java_tzdb$antto$;
function $m_Lzonedb_java_tzdb$antto$() {
  if ((!$n_Lzonedb_java_tzdb$antto$)) {
    $n_Lzonedb_java_tzdb$antto$ = new $c_Lzonedb_java_tzdb$antto$()
  };
  return $n_Lzonedb_java_tzdb$antto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antvi$() {
  this.Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis = null;
  $n_Lzonedb_java_tzdb$antvi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1957013, 0, 0, 25200], [1964306, 0, 25200, 0], [1969032, 0, 0, 25200], [2009291, 7200, 25200, 18000], [2010070, 3600, 18000, 25200], [2011301, 7200, 25200, 18000], [2012053, 3600, 18000, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1957013, 0, 0, 25200], [1964306, 0, 25200, 0], [1969032, 0, 0, 25200], [2009291, 7200, 25200, 18000], [2010070, 3600, 18000, 25200], [2011301, 7200, 25200, 18000], [2012053, 3600, 18000, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$antvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antvi$.prototype.constructor = $c_Lzonedb_java_tzdb$antvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antvi$.prototype = $c_Lzonedb_java_tzdb$antvi$.prototype;
var $d_Lzonedb_java_tzdb$antvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antvi$: 0
}, false, "zonedb.java.tzdb$antvi$", {
  Lzonedb_java_tzdb$antvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antvi$.prototype.$classData = $d_Lzonedb_java_tzdb$antvi$;
var $n_Lzonedb_java_tzdb$antvi$;
function $m_Lzonedb_java_tzdb$antvi$() {
  if ((!$n_Lzonedb_java_tzdb$antvi$)) {
    $n_Lzonedb_java_tzdb$antvi$ = new $c_Lzonedb_java_tzdb$antvi$()
  };
  return $n_Lzonedb_java_tzdb$antvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiad$() {
  this.Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh = null;
  $n_Lzonedb_java_tzdb$asiad$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 11212);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 11212);
  var _2 = [[1947073, 0, 11212, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1947073, 0, 11212, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiad$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiad$.prototype.constructor = $c_Lzonedb_java_tzdb$asiad$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiad$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiad$.prototype = $c_Lzonedb_java_tzdb$asiad$.prototype;
var $d_Lzonedb_java_tzdb$asiad$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiad$: 0
}, false, "zonedb.java.tzdb$asiad$", {
  Lzonedb_java_tzdb$asiad$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiad$.prototype.$classData = $d_Lzonedb_java_tzdb$asiad$;
var $n_Lzonedb_java_tzdb$asiad$;
function $m_Lzonedb_java_tzdb$asiad$() {
  if ((!$n_Lzonedb_java_tzdb$asiad$)) {
    $n_Lzonedb_java_tzdb$asiad$ = new $c_Lzonedb_java_tzdb$asiad$()
  };
  return $n_Lzonedb_java_tzdb$asiad$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiak$() {
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Baku = null;
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka = null;
  $n_Lzonedb_java_tzdb$asiak$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 11964);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 11964);
  var _2 = [[1924123, 0, 11964, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1992271, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 11964, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 7200, 10800, 14400], [1996091, 18000, 14400, 18000], [1996301, 21600, 18000, 14400], [1997089, 14400, 14400, 18000], [1997299, 18000, 18000, 14400], [1998088, 14400, 14400, 18000], [1998298, 18000, 18000, 14400], [1999087, 14400, 14400, 18000], [1999304, 18000, 18000, 14400], [2000086, 14400, 14400, 18000], [2000303, 18000, 18000, 14400], [2001084, 14400, 14400, 18000], [2001301, 18000, 18000, 14400], [2002090, 14400, 14400, 18000], [2002300, 18000, 18000, 14400], [2003089, 14400, 14400, 18000], [2003299, 18000, 18000, 14400], [2004088, 14400, 14400, 18000], [2004305, 18000, 18000, 14400], [2005086, 14400, 14400, 18000], [2005303, 18000, 18000, 14400], [2006085, 14400, 14400, 18000], [2006302, 18000, 18000, 14400], [2007084, 14400, 14400, 18000], [2007301, 18000, 18000, 14400], [2008090, 14400, 14400, 18000], [2008300, 18000, 18000, 14400], [2009088, 14400, 14400, 18000], [2009298, 18000, 18000, 14400], [2010087, 14400, 14400, 18000], [2010304, 18000, 18000, 14400], [2011086, 14400, 14400, 18000], [2011303, 18000, 18000, 14400], [2012085, 14400, 14400, 18000], [2012302, 18000, 18000, 14400], [2013090, 14400, 14400, 18000], [2013300, 18000, 18000, 14400], [2014089, 14400, 14400, 18000], [2014299, 18000, 18000, 14400], [2015088, 14400, 14400, 18000], [2015298, 18000, 18000, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Baku = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 21700);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 21700);
  var _2$3 = [[1890001, 0, 21700, 21200], [1941274, 0, 21200, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1951273, 0, 23400, 21600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890001, 0, 21700, 21200], [1941274, 0, 21200, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1951273, 0, 23400, 21600], [2009170, 82800, 21600, 25200], [2010001, 0, 25200, 21600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiak$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiak$.prototype.constructor = $c_Lzonedb_java_tzdb$asiak$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiak$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiak$.prototype = $c_Lzonedb_java_tzdb$asiak$.prototype;
var $d_Lzonedb_java_tzdb$asiak$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiak$: 0
}, false, "zonedb.java.tzdb$asiak$", {
  Lzonedb_java_tzdb$asiak$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiak$.prototype.$classData = $d_Lzonedb_java_tzdb$asiak$;
var $n_Lzonedb_java_tzdb$asiak$;
function $m_Lzonedb_java_tzdb$asiak$() {
  if ((!$n_Lzonedb_java_tzdb$asiak$)) {
    $n_Lzonedb_java_tzdb$asiak$ = new $c_Lzonedb_java_tzdb$asiak$()
  };
  return $n_Lzonedb_java_tzdb$asiak$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asian$() {
  this.Lzonedb_java_tzdb$asian$__f_Asia_Samarkand = null;
  this.Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang = null;
  $n_Lzonedb_java_tzdb$asian$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 16073);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 16073);
  var _2 = [[1924123, 0, 16073, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 16073, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991090, 7200, 18000, 21600], [1991272, 10800, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asian$__f_Asia_Samarkand = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 30180);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 30180);
  var _2$3 = [[1908092, 0, 30180, 30600], [1912001, 0, 30600, 32400], [2015227, 0, 32400, 30600], [2018124, 84600, 30600, 32400]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1908092, 0, 30180, 30600], [1912001, 0, 30600, 32400], [2015227, 0, 32400, 30600], [2018124, 84600, 30600, 32400]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asian$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asian$.prototype.constructor = $c_Lzonedb_java_tzdb$asian$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asian$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asian$.prototype = $c_Lzonedb_java_tzdb$asian$.prototype;
var $d_Lzonedb_java_tzdb$asian$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asian$: 0
}, false, "zonedb.java.tzdb$asian$", {
  Lzonedb_java_tzdb$asian$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asian$.prototype.$classData = $d_Lzonedb_java_tzdb$asian$;
var $n_Lzonedb_java_tzdb$asian$;
function $m_Lzonedb_java_tzdb$asian$() {
  if ((!$n_Lzonedb_java_tzdb$asian$)) {
    $n_Lzonedb_java_tzdb$asian$ = new $c_Lzonedb_java_tzdb$asian$()
  };
  return $n_Lzonedb_java_tzdb$asian$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiat$() {
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata = null;
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Almaty = null;
  $n_Lzonedb_java_tzdb$asiat$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 21208);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 21208);
  var _2 = [[1854179, 0, 21208, 21200], [1870001, 0, 21200, 19270], [1906001, 0, 19270, 19800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1854179, 0, 21208, 21200], [1870001, 0, 21200, 19270], [1906001, 0, 19270, 19800], [1941274, 0, 19800, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1945288, 0, 23400, 19800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 18468);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 18468);
  var _2$3 = [[1924123, 0, 18468, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [1992019, 7200, 18000, 21600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1924123, 0, 18468, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 25200], [1992271, 10800, 25200, 21600], [1993087, 7200, 21600, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Almaty = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiat$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiat$.prototype.constructor = $c_Lzonedb_java_tzdb$asiat$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiat$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiat$.prototype = $c_Lzonedb_java_tzdb$asiat$.prototype;
var $d_Lzonedb_java_tzdb$asiat$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiat$: 0
}, false, "zonedb.java.tzdb$asiat$", {
  Lzonedb_java_tzdb$asiat$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiat$.prototype.$classData = $d_Lzonedb_java_tzdb$asiat$;
var $n_Lzonedb_java_tzdb$asiat$;
function $m_Lzonedb_java_tzdb$asiat$() {
  if ((!$n_Lzonedb_java_tzdb$asiat$)) {
    $n_Lzonedb_java_tzdb$asiat$ = new $c_Lzonedb_java_tzdb$asiat$()
  };
  return $n_Lzonedb_java_tzdb$asiat$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiau$() {
  this.Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul = null;
  $n_Lzonedb_java_tzdb$asiau$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 20100);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 20100);
  var _2 = [[1919344, 0, 20100, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [1995147, 82800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016087, 7200, 21600, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919344, 0, 20100, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995148, 0, 28800, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016087, 7200, 21600, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiau$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiau$.prototype.constructor = $c_Lzonedb_java_tzdb$asiau$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiau$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiau$.prototype = $c_Lzonedb_java_tzdb$asiau$.prototype;
var $d_Lzonedb_java_tzdb$asiau$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiau$: 0
}, false, "zonedb.java.tzdb$asiau$", {
  Lzonedb_java_tzdb$asiau$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiau$.prototype.$classData = $d_Lzonedb_java_tzdb$asiau$;
var $n_Lzonedb_java_tzdb$asiau$;
function $m_Lzonedb_java_tzdb$asiau$() {
  if ((!$n_Lzonedb_java_tzdb$asiau$)) {
    $n_Lzonedb_java_tzdb$asiau$ = new $c_Lzonedb_java_tzdb$asiau$()
  };
  return $n_Lzonedb_java_tzdb$asiau$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiaz$() {
  this.Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza = null;
  $n_Lzonedb_java_tzdb$asiaz$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8272);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8272);
  var _2 = [[1900274, 0, 8272, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900274, 0, 8272, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967156, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999106, 0, 7200, 10800], [1999288, 0, 10800, 7200], [2000112, 0, 7200, 10800], [2000294, 0, 10800, 7200], [2001110, 0, 7200, 10800], [2001292, 0, 10800, 7200], [2002109, 0, 7200, 10800], [2002291, 0, 10800, 7200], [2003108, 0, 7200, 10800], [2003290, 0, 10800, 7200], [2004107, 0, 7200, 10800], [2004275, 3600, 10800, 7200], [2005105, 0, 7200, 10800], [2005277, 7200, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007091, 0, 7200, 10800], [2007256, 7200, 10800, 7200], [2008088, 0, 7200, 10800], [2008242, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009247, 3600, 10800, 7200], [2010086, 60, 7200, 10800], [2010223, 0, 10800, 7200], [2011091, 60, 7200, 10800], [2011213, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012265, 3600, 10800, 7200], [2013088, 0, 7200, 10800], [2013270, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014297, 0, 10800, 7200], [2015087, 0, 7200, 10800], [2015296, 0, 10800, 7200], [2016086, 3600, 7200, 10800], [2016303, 3600, 10800, 7200], [2017084, 3600, 7200, 10800], [2017301, 3600, 10800, 7200], [2018083, 3600, 7200, 10800], [2018300, 3600, 10800, 7200], [2019088, 0, 7200, 10800], [2019299, 3600, 10800, 7200], [2020087, 0, 7200, 10800], [2020305, 3600, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 6, 3600, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiaz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiaz$.prototype.constructor = $c_Lzonedb_java_tzdb$asiaz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiaz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiaz$.prototype = $c_Lzonedb_java_tzdb$asiaz$.prototype;
var $d_Lzonedb_java_tzdb$asiaz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiaz$: 0
}, false, "zonedb.java.tzdb$asiaz$", {
  Lzonedb_java_tzdb$asiaz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiaz$.prototype.$classData = $d_Lzonedb_java_tzdb$asiaz$;
var $n_Lzonedb_java_tzdb$asiaz$;
function $m_Lzonedb_java_tzdb$asiaz$() {
  if ((!$n_Lzonedb_java_tzdb$asiaz$)) {
    $n_Lzonedb_java_tzdb$asiaz$ = new $c_Lzonedb_java_tzdb$asiaz$()
  };
  return $n_Lzonedb_java_tzdb$asiaz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiba$() {
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat = null;
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Dubai = null;
  $n_Lzonedb_java_tzdb$asiba$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 14012);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 14012);
  var _2 = [[1924123, 0, 14012, 14400], [1930172, 0, 14400, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 14012, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1981274, 0, 21600, 18000], [1982091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 13272);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 13272);
  var _2$3 = [[1920001, 0, 13272, 14400]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1920001, 0, 13272, 14400]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Dubai = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiba$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiba$.prototype.constructor = $c_Lzonedb_java_tzdb$asiba$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiba$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiba$.prototype = $c_Lzonedb_java_tzdb$asiba$.prototype;
var $d_Lzonedb_java_tzdb$asiba$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiba$: 0
}, false, "zonedb.java.tzdb$asiba$", {
  Lzonedb_java_tzdb$asiba$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiba$.prototype.$classData = $d_Lzonedb_java_tzdb$asiba$;
var $n_Lzonedb_java_tzdb$asiba$;
function $m_Lzonedb_java_tzdb$asiba$() {
  if ((!$n_Lzonedb_java_tzdb$asiba$)) {
    $n_Lzonedb_java_tzdb$asiba$ = new $c_Lzonedb_java_tzdb$asiba$()
  };
  return $n_Lzonedb_java_tzdb$asiba$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asibu$() {
  this.Lzonedb_java_tzdb$asibu$__f_Asia_Kabul = null;
  $n_Lzonedb_java_tzdb$asibu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 16608);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 16608);
  var _2 = [[1890001, 0, 16608, 14400], [1945001, 0, 14400, 16200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, 16608, 14400], [1945001, 0, 14400, 16200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asibu$__f_Asia_Kabul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asibu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asibu$.prototype.constructor = $c_Lzonedb_java_tzdb$asibu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asibu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asibu$.prototype = $c_Lzonedb_java_tzdb$asibu$.prototype;
var $d_Lzonedb_java_tzdb$asibu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asibu$: 0
}, false, "zonedb.java.tzdb$asibu$", {
  Lzonedb_java_tzdb$asibu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asibu$.prototype.$classData = $d_Lzonedb_java_tzdb$asibu$;
var $n_Lzonedb_java_tzdb$asibu$;
function $m_Lzonedb_java_tzdb$asibu$() {
  if ((!$n_Lzonedb_java_tzdb$asibu$)) {
    $n_Lzonedb_java_tzdb$asibu$ = new $c_Lzonedb_java_tzdb$asibu$()
  };
  return $n_Lzonedb_java_tzdb$asibu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asica$() {
  this.Lzonedb_java_tzdb$asica$__f_Asia_Macau = null;
  $n_Lzonedb_java_tzdb$asica$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27250);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27250);
  var _2 = [[1904304, 0, 27250, 28800], [1941355, 82800, 28800, 32400], [1945274, 0, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1904304, 0, 27250, 28800], [1941355, 82800, 28800, 32400], [1942120, 82800, 32400, 36000], [1942321, 82800, 36000, 32400], [1943120, 82800, 32400, 36000], [1943273, 82800, 36000, 32400], [1945274, 0, 32400, 28800], [1946120, 82800, 28800, 32400], [1946274, 0, 32400, 28800], [1947109, 82800, 28800, 32400], [1947335, 0, 32400, 28800], [1948123, 82800, 28800, 32400], [1948306, 0, 32400, 28800], [1949092, 82800, 28800, 32400], [1949303, 0, 32400, 28800], [1950091, 82800, 28800, 32400], [1950302, 0, 32400, 28800], [1951090, 82800, 28800, 32400], [1951302, 0, 32400, 28800], [1952096, 82800, 28800, 32400], [1952307, 0, 32400, 28800], [1953094, 82800, 28800, 32400], [1953305, 0, 32400, 28800], [1954079, 82800, 28800, 32400], [1954304, 0, 32400, 28800], [1955078, 82800, 28800, 32400], [1955310, 0, 32400, 28800], [1956077, 82800, 28800, 32400], [1956309, 12600, 32400, 28800], [1957083, 12600, 28800, 32400], [1957307, 12600, 32400, 28800], [1958082, 12600, 28800, 32400], [1958306, 12600, 32400, 28800], [1959081, 12600, 28800, 32400], [1959305, 12600, 32400, 28800], [1960080, 12600, 28800, 32400], [1960311, 12600, 32400, 28800], [1961078, 12600, 28800, 32400], [1961309, 12600, 32400, 28800], [1962077, 12600, 28800, 32400], [1962308, 12600, 32400, 28800], [1963083, 12600, 28800, 32400], [1963307, 12600, 32400, 28800], [1964082, 12600, 28800, 32400], [1964306, 12600, 32400, 28800], [1965108, 12600, 28800, 32400], [1965290, 9000, 32400, 28800], [1966107, 12600, 28800, 32400], [1966289, 9000, 32400, 28800], [1967106, 12600, 28800, 32400], [1967295, 12600, 32400, 28800], [1968112, 12600, 28800, 32400], [1968294, 12600, 32400, 28800], [1969110, 12600, 28800, 32400], [1969292, 12600, 32400, 28800], [1970109, 12600, 28800, 32400], [1970291, 12600, 32400, 28800], [1971108, 12600, 28800, 32400], [1971290, 12600, 32400, 28800], [1972107, 12600, 28800, 32400], [1972296, 12600, 32400, 28800], [1973112, 12600, 28800, 32400], [1973294, 12600, 32400, 28800], [1973364, 12600, 28800, 32400], [1974293, 12600, 32400, 28800], [1975110, 12600, 28800, 32400], [1975292, 12600, 32400, 28800], [1976109, 12600, 28800, 32400], [1976291, 12600, 32400, 28800], [1979133, 12600, 28800, 32400], [1979294, 12600, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asica$__f_Asia_Macau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asica$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asica$.prototype.constructor = $c_Lzonedb_java_tzdb$asica$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asica$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asica$.prototype = $c_Lzonedb_java_tzdb$asica$.prototype;
var $d_Lzonedb_java_tzdb$asica$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asica$: 0
}, false, "zonedb.java.tzdb$asica$", {
  Lzonedb_java_tzdb$asica$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asica$.prototype.$classData = $d_Lzonedb_java_tzdb$asica$;
var $n_Lzonedb_java_tzdb$asica$;
function $m_Lzonedb_java_tzdb$asica$() {
  if ((!$n_Lzonedb_java_tzdb$asica$)) {
    $n_Lzonedb_java_tzdb$asica$ = new $c_Lzonedb_java_tzdb$asica$()
  };
  return $n_Lzonedb_java_tzdb$asica$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asich$() {
  this.Lzonedb_java_tzdb$asich$__f_Asia_Karachi = null;
  $n_Lzonedb_java_tzdb$asich$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 16092);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 16092);
  var _2 = [[1907001, 0, 16092, 19800], [1951273, 0, 19800, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1907001, 0, 16092, 19800], [1942244, 0, 19800, 23400], [1945288, 0, 23400, 19800], [1951273, 0, 19800, 18000], [2002097, 0, 18000, 21600], [2002279, 0, 21600, 18000], [2008153, 0, 18000, 21600], [2008306, 0, 21600, 18000], [2009105, 0, 18000, 21600], [2009305, 0, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asich$__f_Asia_Karachi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asich$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asich$.prototype.constructor = $c_Lzonedb_java_tzdb$asich$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asich$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asich$.prototype = $c_Lzonedb_java_tzdb$asich$.prototype;
var $d_Lzonedb_java_tzdb$asich$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asich$: 0
}, false, "zonedb.java.tzdb$asich$", {
  Lzonedb_java_tzdb$asich$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asich$.prototype.$classData = $d_Lzonedb_java_tzdb$asich$;
var $n_Lzonedb_java_tzdb$asich$;
function $m_Lzonedb_java_tzdb$asich$() {
  if ((!$n_Lzonedb_java_tzdb$asich$)) {
    $n_Lzonedb_java_tzdb$asich$ = new $c_Lzonedb_java_tzdb$asich$()
  };
  return $n_Lzonedb_java_tzdb$asich$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asicu$() {
  this.Lzonedb_java_tzdb$asicu$__f_Asia_Damascus = null;
  $n_Lzonedb_java_tzdb$asicu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8712);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8712);
  var _2 = [[1920001, 0, 8712, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920001, 0, 8712, 7200], [1920109, 7200, 7200, 10800], [1920277, 7200, 10800, 7200], [1921107, 7200, 7200, 10800], [1921275, 7200, 10800, 7200], [1922106, 7200, 7200, 10800], [1922274, 7200, 10800, 7200], [1923105, 7200, 7200, 10800], [1923280, 7200, 10800, 7200], [1962119, 7200, 7200, 10800], [1962274, 7200, 10800, 7200], [1963121, 7200, 7200, 10800], [1963273, 7200, 10800, 7200], [1964122, 7200, 7200, 10800], [1964275, 7200, 10800, 7200], [1965121, 7200, 7200, 10800], [1965273, 7200, 10800, 7200], [1966114, 7200, 7200, 10800], [1966274, 7200, 10800, 7200], [1967121, 7200, 7200, 10800], [1967274, 7200, 10800, 7200], [1968122, 7200, 7200, 10800], [1968275, 7200, 10800, 7200], [1969121, 7200, 7200, 10800], [1969274, 7200, 10800, 7200], [1970121, 7200, 7200, 10800], [1970274, 7200, 10800, 7200], [1971121, 7200, 7200, 10800], [1971274, 7200, 10800, 7200], [1972122, 7200, 7200, 10800], [1972275, 7200, 10800, 7200], [1973121, 7200, 7200, 10800], [1973274, 7200, 10800, 7200], [1974121, 7200, 7200, 10800], [1974274, 7200, 10800, 7200], [1975121, 7200, 7200, 10800], [1975274, 7200, 10800, 7200], [1976122, 7200, 7200, 10800], [1976275, 7200, 10800, 7200], [1977121, 7200, 7200, 10800], [1977244, 7200, 10800, 7200], [1978121, 7200, 7200, 10800], [1978244, 7200, 10800, 7200], [1983099, 7200, 7200, 10800], [1983274, 7200, 10800, 7200], [1984100, 7200, 7200, 10800], [1984275, 7200, 10800, 7200], [1986047, 7200, 7200, 10800], [1986282, 7200, 10800, 7200], [1987060, 7200, 7200, 10800], [1987304, 7200, 10800, 7200], [1988075, 7200, 7200, 10800], [1988305, 7200, 10800, 7200], [1989090, 7200, 7200, 10800], [1989274, 7200, 10800, 7200], [1990091, 7200, 7200, 10800], [1990273, 7200, 10800, 7200], [1991091, 0, 7200, 10800], [1991274, 0, 10800, 7200], [1992099, 0, 7200, 10800], [1992275, 0, 10800, 7200], [1993085, 0, 7200, 10800], [1993268, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994274, 0, 10800, 7200], [1995091, 0, 7200, 10800], [1995274, 0, 10800, 7200], [1996092, 0, 7200, 10800], [1996275, 0, 10800, 7200], [1997090, 0, 7200, 10800], [1997274, 0, 10800, 7200], [1998089, 0, 7200, 10800], [1998274, 0, 10800, 7200], [1999091, 0, 7200, 10800], [1999274, 0, 10800, 7200], [2000092, 0, 7200, 10800], [2000275, 0, 10800, 7200], [2001091, 0, 7200, 10800], [2001274, 0, 10800, 7200], [2002091, 0, 7200, 10800], [2002274, 0, 10800, 7200], [2003091, 0, 7200, 10800], [2003274, 0, 10800, 7200], [2004092, 0, 7200, 10800], [2004275, 0, 10800, 7200], [2005091, 0, 7200, 10800], [2005274, 0, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007089, 0, 7200, 10800], [2007306, 0, 10800, 7200], [2008095, 0, 7200, 10800], [2008306, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009303, 0, 10800, 7200], [2010092, 0, 7200, 10800], [2010302, 0, 10800, 7200], [2011091, 0, 7200, 10800], [2011301, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012300, 0, 10800, 7200], [2013088, 0, 7200, 10800], [2013298, 0, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 5, 0, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asicu$__f_Asia_Damascus = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asicu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asicu$.prototype.constructor = $c_Lzonedb_java_tzdb$asicu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asicu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asicu$.prototype = $c_Lzonedb_java_tzdb$asicu$.prototype;
var $d_Lzonedb_java_tzdb$asicu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asicu$: 0
}, false, "zonedb.java.tzdb$asicu$", {
  Lzonedb_java_tzdb$asicu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asicu$.prototype.$classData = $d_Lzonedb_java_tzdb$asicu$;
var $n_Lzonedb_java_tzdb$asicu$;
function $m_Lzonedb_java_tzdb$asicu$() {
  if ((!$n_Lzonedb_java_tzdb$asicu$)) {
    $n_Lzonedb_java_tzdb$asicu$ = new $c_Lzonedb_java_tzdb$asicu$()
  };
  return $n_Lzonedb_java_tzdb$asicu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asida$() {
  this.Lzonedb_java_tzdb$asida$__f_Asia_Magadan = null;
  this.Lzonedb_java_tzdb$asida$__f_Asia_Baghdad = null;
  $n_Lzonedb_java_tzdb$asida$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 36192);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 36192);
  var _2 = [[1924123, 0, 36192, 36000], [1930172, 0, 36000, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 36000], [2016115, 7200, 36000, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 36192, 36000], [1930172, 0, 36000, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 36000], [2016115, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asida$__f_Asia_Magadan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 10660);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 10660);
  var _2$3 = [[1890001, 0, 10660, 10656], [1918001, 0, 10656, 10800]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890001, 0, 10660, 10656], [1918001, 0, 10656, 10800], [1982121, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983090, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984275, 0, 14400, 10800], [1985091, 0, 10800, 14400], [1985272, 7200, 14400, 10800], [1986089, 3600, 10800, 14400], [1986271, 7200, 14400, 10800], [1987088, 3600, 10800, 14400], [1987270, 7200, 14400, 10800], [1988087, 3600, 10800, 14400], [1988269, 7200, 14400, 10800], [1989085, 3600, 10800, 14400], [1989267, 7200, 14400, 10800], [1990084, 3600, 10800, 14400], [1990273, 7200, 14400, 10800], [1991091, 10800, 10800, 14400], [1991274, 14400, 14400, 10800], [1992092, 10800, 10800, 14400], [1992275, 14400, 14400, 10800], [1993091, 10800, 10800, 14400], [1993274, 14400, 14400, 10800], [1994091, 10800, 10800, 14400], [1994274, 14400, 14400, 10800], [1995091, 10800, 10800, 14400], [1995274, 14400, 14400, 10800], [1996092, 10800, 10800, 14400], [1996275, 14400, 14400, 10800], [1997091, 10800, 10800, 14400], [1997274, 14400, 14400, 10800], [1998091, 10800, 10800, 14400], [1998274, 14400, 14400, 10800], [1999091, 10800, 10800, 14400], [1999274, 14400, 14400, 10800], [2000092, 10800, 10800, 14400], [2000275, 14400, 14400, 10800], [2001091, 10800, 10800, 14400], [2001274, 14400, 14400, 10800], [2002091, 10800, 10800, 14400], [2002274, 14400, 14400, 10800], [2003091, 10800, 10800, 14400], [2003274, 14400, 14400, 10800], [2004092, 10800, 10800, 14400], [2004275, 14400, 14400, 10800], [2005091, 10800, 10800, 14400], [2005274, 14400, 14400, 10800], [2006091, 10800, 10800, 14400], [2006274, 14400, 14400, 10800], [2007091, 10800, 10800, 14400], [2007274, 14400, 14400, 10800]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asida$__f_Asia_Baghdad = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asida$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asida$.prototype.constructor = $c_Lzonedb_java_tzdb$asida$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asida$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asida$.prototype = $c_Lzonedb_java_tzdb$asida$.prototype;
var $d_Lzonedb_java_tzdb$asida$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asida$: 0
}, false, "zonedb.java.tzdb$asida$", {
  Lzonedb_java_tzdb$asida$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asida$.prototype.$classData = $d_Lzonedb_java_tzdb$asida$;
var $n_Lzonedb_java_tzdb$asida$;
function $m_Lzonedb_java_tzdb$asida$() {
  if ((!$n_Lzonedb_java_tzdb$asida$)) {
    $n_Lzonedb_java_tzdb$asida$ = new $c_Lzonedb_java_tzdb$asida$()
  };
  return $n_Lzonedb_java_tzdb$asida$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asidy$() {
  this.Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr = null;
  $n_Lzonedb_java_tzdb$asidy$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 42596);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 42596);
  var _2 = [[1924123, 0, 42596, 43200], [1930172, 0, 43200, 46800], [1982091, 0, 46800, 43200], [1991090, 7200, 43200, 39600], [1992019, 7200, 39600, 43200], [2010087, 7200, 43200, 39600], [2011086, 7200, 39600, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 42596, 43200], [1930172, 0, 43200, 46800], [1981091, 0, 46800, 50400], [1981274, 0, 50400, 46800], [1982274, 0, 46800, 43200], [1983091, 0, 43200, 46800], [1983274, 0, 46800, 43200], [1984092, 0, 43200, 46800], [1984274, 10800, 46800, 43200], [1985090, 7200, 43200, 46800], [1985272, 10800, 46800, 43200], [1986089, 7200, 43200, 46800], [1986271, 10800, 46800, 43200], [1987088, 7200, 43200, 46800], [1987270, 10800, 46800, 43200], [1988087, 7200, 43200, 46800], [1988269, 10800, 46800, 43200], [1989085, 7200, 43200, 46800], [1989267, 10800, 46800, 43200], [1990084, 7200, 43200, 46800], [1990273, 10800, 46800, 43200], [1991272, 10800, 43200, 39600], [1992019, 7200, 39600, 43200], [1992089, 7200, 43200, 46800], [1992271, 10800, 46800, 43200], [1993087, 7200, 43200, 46800], [1993269, 10800, 46800, 43200], [1994086, 7200, 43200, 46800], [1994268, 10800, 46800, 43200], [1995085, 7200, 43200, 46800], [1995267, 10800, 46800, 43200], [1996091, 7200, 43200, 46800], [1996301, 10800, 46800, 43200], [1997089, 7200, 43200, 46800], [1997299, 10800, 46800, 43200], [1998088, 7200, 43200, 46800], [1998298, 10800, 46800, 43200], [1999087, 7200, 43200, 46800], [1999304, 10800, 46800, 43200], [2000086, 7200, 43200, 46800], [2000303, 10800, 46800, 43200], [2001084, 7200, 43200, 46800], [2001301, 10800, 46800, 43200], [2002090, 7200, 43200, 46800], [2002300, 10800, 46800, 43200], [2003089, 7200, 43200, 46800], [2003299, 10800, 46800, 43200], [2004088, 7200, 43200, 46800], [2004305, 10800, 46800, 43200], [2005086, 7200, 43200, 46800], [2005303, 10800, 46800, 43200], [2006085, 7200, 43200, 46800], [2006302, 10800, 46800, 43200], [2007084, 7200, 43200, 46800], [2007301, 10800, 46800, 43200], [2008090, 7200, 43200, 46800], [2008300, 10800, 46800, 43200], [2009088, 7200, 43200, 46800], [2009298, 10800, 46800, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asidy$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asidy$.prototype.constructor = $c_Lzonedb_java_tzdb$asidy$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asidy$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asidy$.prototype = $c_Lzonedb_java_tzdb$asidy$.prototype;
var $d_Lzonedb_java_tzdb$asidy$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asidy$: 0
}, false, "zonedb.java.tzdb$asidy$", {
  Lzonedb_java_tzdb$asidy$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asidy$.prototype.$classData = $d_Lzonedb_java_tzdb$asidy$;
var $n_Lzonedb_java_tzdb$asidy$;
function $m_Lzonedb_java_tzdb$asidy$() {
  if ((!$n_Lzonedb_java_tzdb$asidy$)) {
    $n_Lzonedb_java_tzdb$asidy$ = new $c_Lzonedb_java_tzdb$asidy$()
  };
  return $n_Lzonedb_java_tzdb$asidy$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asien$() {
  this.Lzonedb_java_tzdb$asien$__f_Asia_Tashkent = null;
  $n_Lzonedb_java_tzdb$asien$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 16631);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 16631);
  var _2 = [[1924123, 0, 16631, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 16631, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asien$__f_Asia_Tashkent = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asien$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asien$.prototype.constructor = $c_Lzonedb_java_tzdb$asien$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asien$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asien$.prototype = $c_Lzonedb_java_tzdb$asien$.prototype;
var $d_Lzonedb_java_tzdb$asien$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asien$: 0
}, false, "zonedb.java.tzdb$asien$", {
  Lzonedb_java_tzdb$asien$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asien$.prototype.$classData = $d_Lzonedb_java_tzdb$asien$;
var $n_Lzonedb_java_tzdb$asien$;
function $m_Lzonedb_java_tzdb$asien$() {
  if ((!$n_Lzonedb_java_tzdb$asien$)) {
    $n_Lzonedb_java_tzdb$asien$ = new $c_Lzonedb_java_tzdb$asien$()
  };
  return $n_Lzonedb_java_tzdb$asien$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asier$() {
  this.Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera = null;
  $n_Lzonedb_java_tzdb$asier$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 34374);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 34374);
  var _2 = [[1919349, 0, 34374, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2011256, 0, 43200, 39600], [2014299, 7200, 39600, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919349, 0, 34374, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2011256, 0, 43200, 39600], [2014299, 7200, 39600, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asier$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asier$.prototype.constructor = $c_Lzonedb_java_tzdb$asier$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asier$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asier$.prototype = $c_Lzonedb_java_tzdb$asier$.prototype;
var $d_Lzonedb_java_tzdb$asier$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asier$: 0
}, false, "zonedb.java.tzdb$asier$", {
  Lzonedb_java_tzdb$asier$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asier$.prototype.$classData = $d_Lzonedb_java_tzdb$asier$;
var $n_Lzonedb_java_tzdb$asier$;
function $m_Lzonedb_java_tzdb$asier$() {
  if ((!$n_Lzonedb_java_tzdb$asier$)) {
    $n_Lzonedb_java_tzdb$asier$ = new $c_Lzonedb_java_tzdb$asier$()
  };
  return $n_Lzonedb_java_tzdb$asier$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asigo$() {
  this.Lzonedb_java_tzdb$asigo$__f_Asia_Yangon = null;
  $n_Lzonedb_java_tzdb$asigo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 23087);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 23087);
  var _2 = [[1920001, 0, 23087, 23400], [1942121, 0, 23400, 32400], [1945123, 0, 32400, 23400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920001, 0, 23087, 23400], [1942121, 0, 23400, 32400], [1945123, 0, 32400, 23400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asigo$__f_Asia_Yangon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asigo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asigo$.prototype.constructor = $c_Lzonedb_java_tzdb$asigo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asigo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asigo$.prototype = $c_Lzonedb_java_tzdb$asigo$.prototype;
var $d_Lzonedb_java_tzdb$asigo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asigo$: 0
}, false, "zonedb.java.tzdb$asigo$", {
  Lzonedb_java_tzdb$asigo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asigo$.prototype.$classData = $d_Lzonedb_java_tzdb$asigo$;
var $n_Lzonedb_java_tzdb$asigo$;
function $m_Lzonedb_java_tzdb$asigo$() {
  if ((!$n_Lzonedb_java_tzdb$asigo$)) {
    $n_Lzonedb_java_tzdb$asigo$ = new $c_Lzonedb_java_tzdb$asigo$()
  };
  return $n_Lzonedb_java_tzdb$asigo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiha$() {
  this.Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai = null;
  $n_Lzonedb_java_tzdb$asiha$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 29143);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 29143);
  var _2 = [[1901001, 0, 29143, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 29143, 28800], [1940153, 0, 28800, 32400], [1940287, 0, 32400, 28800], [1941074, 0, 28800, 32400], [1941306, 0, 32400, 28800], [1942031, 0, 28800, 32400], [1945245, 0, 32400, 28800], [1946135, 0, 28800, 32400], [1946274, 0, 32400, 28800], [1947105, 0, 28800, 32400], [1947305, 0, 32400, 28800], [1948122, 0, 28800, 32400], [1948275, 0, 32400, 28800], [1949121, 0, 28800, 32400], [1949148, 0, 32400, 28800], [1986124, 7200, 28800, 32400], [1986257, 7200, 32400, 28800], [1987102, 7200, 28800, 32400], [1987256, 7200, 32400, 28800], [1988108, 7200, 28800, 32400], [1988255, 7200, 32400, 28800], [1989106, 7200, 28800, 32400], [1989260, 7200, 32400, 28800], [1990105, 7200, 28800, 32400], [1990259, 7200, 32400, 28800], [1991104, 7200, 28800, 32400], [1991258, 7200, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiha$.prototype.constructor = $c_Lzonedb_java_tzdb$asiha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiha$.prototype = $c_Lzonedb_java_tzdb$asiha$.prototype;
var $d_Lzonedb_java_tzdb$asiha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiha$: 0
}, false, "zonedb.java.tzdb$asiha$", {
  Lzonedb_java_tzdb$asiha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiha$.prototype.$classData = $d_Lzonedb_java_tzdb$asiha$;
var $n_Lzonedb_java_tzdb$asiha$;
function $m_Lzonedb_java_tzdb$asiha$() {
  if ((!$n_Lzonedb_java_tzdb$asiha$)) {
    $n_Lzonedb_java_tzdb$asiha$ = new $c_Lzonedb_java_tzdb$asiha$()
  };
  return $n_Lzonedb_java_tzdb$asiha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiil$() {
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Manila = null;
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Dili = null;
  $n_Lzonedb_java_tzdb$asiil$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-57360));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-57360));
  var _2 = [[1844366, 0, (-57360), 29040], [1899131, 0, 29040, 28800], [1942121, 0, 28800, 32400], [1944306, 0, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-57360), 29040], [1899131, 0, 29040, 28800], [1936306, 0, 28800, 32400], [1937032, 0, 32400, 28800], [1942121, 0, 28800, 32400], [1944306, 0, 32400, 28800], [1954102, 0, 28800, 32400], [1954182, 0, 32400, 28800], [1978081, 0, 28800, 32400], [1978264, 0, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Manila = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 30140);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 30140);
  var _2$3 = [[1912001, 0, 30140, 28800], [1942052, 82800, 28800, 32400], [1976124, 0, 32400, 28800], [2000261, 0, 28800, 32400]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1912001, 0, 30140, 28800], [1942052, 82800, 28800, 32400], [1976124, 0, 32400, 28800], [2000261, 0, 28800, 32400]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Dili = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiil$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiil$.prototype.constructor = $c_Lzonedb_java_tzdb$asiil$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiil$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiil$.prototype = $c_Lzonedb_java_tzdb$asiil$.prototype;
var $d_Lzonedb_java_tzdb$asiil$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiil$: 0
}, false, "zonedb.java.tzdb$asiil$", {
  Lzonedb_java_tzdb$asiil$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiil$.prototype.$classData = $d_Lzonedb_java_tzdb$asiil$;
var $n_Lzonedb_java_tzdb$asiil$;
function $m_Lzonedb_java_tzdb$asiil$() {
  if ((!$n_Lzonedb_java_tzdb$asiil$)) {
    $n_Lzonedb_java_tzdb$asiil$ = new $c_Lzonedb_java_tzdb$asiil$()
  };
  return $n_Lzonedb_java_tzdb$asiil$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiin$() {
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh = null;
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Kuching = null;
  $n_Lzonedb_java_tzdb$asiin$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 25600);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 25600);
  var _2 = [[1906182, 0, 25600, 25590], [1911121, 0, 25590, 25200], [1942365, 82800, 25200, 28800], [1945073, 82800, 28800, 32400], [1945245, 0, 32400, 25200], [1947091, 0, 25200, 28800], [1955182, 0, 28800, 25200], [1959365, 82800, 25200, 28800], [1975164, 0, 28800, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1906182, 0, 25600, 25590], [1911121, 0, 25590, 25200], [1942365, 82800, 25200, 28800], [1945073, 82800, 28800, 32400], [1945245, 0, 32400, 25200], [1947091, 0, 25200, 28800], [1955182, 0, 28800, 25200], [1959365, 82800, 25200, 28800], [1975164, 0, 28800, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 26480);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 26480);
  var _2$3 = [[1926060, 0, 26480, 27000], [1933001, 0, 27000, 28800], [1942047, 0, 28800, 32400], [1945255, 0, 32400, 28800]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1926060, 0, 26480, 27000], [1933001, 0, 27000, 28800], [1935257, 0, 28800, 30000], [1935348, 0, 30000, 28800], [1936258, 0, 28800, 30000], [1936349, 0, 30000, 28800], [1937257, 0, 28800, 30000], [1937348, 0, 30000, 28800], [1938257, 0, 28800, 30000], [1938348, 0, 30000, 28800], [1939257, 0, 28800, 30000], [1939348, 0, 30000, 28800], [1940258, 0, 28800, 30000], [1940349, 0, 30000, 28800], [1941257, 0, 28800, 30000], [1941348, 0, 30000, 28800], [1942047, 0, 28800, 32400], [1945255, 0, 32400, 28800]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Kuching = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiin$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiin$.prototype.constructor = $c_Lzonedb_java_tzdb$asiin$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiin$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiin$.prototype = $c_Lzonedb_java_tzdb$asiin$.prototype;
var $d_Lzonedb_java_tzdb$asiin$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiin$: 0
}, false, "zonedb.java.tzdb$asiin$", {
  Lzonedb_java_tzdb$asiin$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiin$.prototype.$classData = $d_Lzonedb_java_tzdb$asiin$;
var $n_Lzonedb_java_tzdb$asiin$;
function $m_Lzonedb_java_tzdb$asiin$() {
  if ((!$n_Lzonedb_java_tzdb$asiin$)) {
    $n_Lzonedb_java_tzdb$asiin$ = new $c_Lzonedb_java_tzdb$asiin$()
  };
  return $n_Lzonedb_java_tzdb$asiin$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiis$() {
  this.Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi = null;
  $n_Lzonedb_java_tzdb$asiis$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 10751);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 10751);
  var _2 = [[1924123, 0, 10751, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1994267, 82800, 10800, 14400], [2004178, 82800, 14400, 10800], [2005086, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 10751, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 0, 10800, 14400], [1992271, 0, 14400, 10800], [1993087, 0, 10800, 14400], [1993269, 0, 14400, 10800], [1994086, 0, 10800, 14400], [1995085, 0, 14400, 18000], [1995267, 0, 18000, 14400], [1996091, 0, 14400, 18000], [1997299, 0, 18000, 14400], [1998088, 0, 14400, 18000], [1998298, 0, 18000, 14400], [1999087, 0, 14400, 18000], [1999304, 0, 18000, 14400], [2000086, 0, 14400, 18000], [2000303, 0, 18000, 14400], [2001084, 0, 14400, 18000], [2001301, 0, 18000, 14400], [2002090, 0, 14400, 18000], [2002300, 0, 18000, 14400], [2003089, 0, 14400, 18000], [2003299, 0, 18000, 14400], [2004088, 0, 14400, 18000], [2004179, 0, 18000, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiis$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiis$.prototype.constructor = $c_Lzonedb_java_tzdb$asiis$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiis$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiis$.prototype = $c_Lzonedb_java_tzdb$asiis$.prototype;
var $d_Lzonedb_java_tzdb$asiis$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiis$: 0
}, false, "zonedb.java.tzdb$asiis$", {
  Lzonedb_java_tzdb$asiis$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiis$.prototype.$classData = $d_Lzonedb_java_tzdb$asiis$;
var $n_Lzonedb_java_tzdb$asiis$;
function $m_Lzonedb_java_tzdb$asiis$() {
  if ((!$n_Lzonedb_java_tzdb$asiis$)) {
    $n_Lzonedb_java_tzdb$asiis$ = new $c_Lzonedb_java_tzdb$asiis$()
  };
  return $n_Lzonedb_java_tzdb$asiis$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiit$() {
  this.Lzonedb_java_tzdb$asiit$__f_Asia_Chita = null;
  $n_Lzonedb_java_tzdb$asiit$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27232);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27232);
  var _2 = [[1919349, 0, 27232, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 28800], [2016087, 7200, 28800, 32400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919349, 0, 27232, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004088, 7200, 32400, 36000], [2004305, 10800, 36000, 32400], [2005086, 7200, 32400, 36000], [2005303, 10800, 36000, 32400], [2006085, 7200, 32400, 36000], [2006302, 10800, 36000, 32400], [2007084, 7200, 32400, 36000], [2007301, 10800, 36000, 32400], [2008090, 7200, 32400, 36000], [2008300, 10800, 36000, 32400], [2009088, 7200, 32400, 36000], [2009298, 10800, 36000, 32400], [2010087, 7200, 32400, 36000], [2010304, 10800, 36000, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 28800], [2016087, 7200, 28800, 32400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiit$__f_Asia_Chita = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiit$.prototype.constructor = $c_Lzonedb_java_tzdb$asiit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiit$.prototype = $c_Lzonedb_java_tzdb$asiit$.prototype;
var $d_Lzonedb_java_tzdb$asiit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiit$: 0
}, false, "zonedb.java.tzdb$asiit$", {
  Lzonedb_java_tzdb$asiit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiit$.prototype.$classData = $d_Lzonedb_java_tzdb$asiit$;
var $n_Lzonedb_java_tzdb$asiit$;
function $m_Lzonedb_java_tzdb$asiit$() {
  if ((!$n_Lzonedb_java_tzdb$asiit$)) {
    $n_Lzonedb_java_tzdb$asiit$ = new $c_Lzonedb_java_tzdb$asiit$()
  };
  return $n_Lzonedb_java_tzdb$asiit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asike$() {
  this.Lzonedb_java_tzdb$asike$__f_Asia_Bishkek = null;
  $n_Lzonedb_java_tzdb$asike$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 17904);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 17904);
  var _2 = [[1924123, 0, 17904, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [2005223, 82800, 18000, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 17904, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991243, 7200, 21600, 18000], [1992103, 0, 18000, 21600], [1992271, 0, 21600, 18000], [1993101, 0, 18000, 21600], [1993269, 0, 21600, 18000], [1994100, 0, 18000, 21600], [1994268, 0, 21600, 18000], [1995099, 0, 18000, 21600], [1995267, 0, 21600, 18000], [1996098, 0, 18000, 21600], [1996273, 0, 21600, 18000], [1997089, 9000, 18000, 21600], [1997299, 9000, 21600, 18000], [1998088, 9000, 18000, 21600], [1998298, 9000, 21600, 18000], [1999087, 9000, 18000, 21600], [1999304, 9000, 21600, 18000], [2000086, 9000, 18000, 21600], [2000303, 9000, 21600, 18000], [2001084, 9000, 18000, 21600], [2001301, 9000, 21600, 18000], [2002090, 9000, 18000, 21600], [2002300, 9000, 21600, 18000], [2003089, 9000, 18000, 21600], [2003299, 9000, 21600, 18000], [2004088, 9000, 18000, 21600], [2004305, 9000, 21600, 18000], [2005086, 9000, 18000, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asike$__f_Asia_Bishkek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asike$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asike$.prototype.constructor = $c_Lzonedb_java_tzdb$asike$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asike$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asike$.prototype = $c_Lzonedb_java_tzdb$asike$.prototype;
var $d_Lzonedb_java_tzdb$asike$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asike$: 0
}, false, "zonedb.java.tzdb$asike$", {
  Lzonedb_java_tzdb$asike$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asike$.prototype.$classData = $d_Lzonedb_java_tzdb$asike$;
var $n_Lzonedb_java_tzdb$asike$;
function $m_Lzonedb_java_tzdb$asike$() {
  if ((!$n_Lzonedb_java_tzdb$asike$)) {
    $n_Lzonedb_java_tzdb$asike$ = new $c_Lzonedb_java_tzdb$asike$()
  };
  return $n_Lzonedb_java_tzdb$asike$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiko$() {
  this.Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok = null;
  $n_Lzonedb_java_tzdb$asiko$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 24124);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 24124);
  var _2 = [[1920092, 0, 24124, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920092, 0, 24124, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiko$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiko$.prototype.constructor = $c_Lzonedb_java_tzdb$asiko$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiko$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiko$.prototype = $c_Lzonedb_java_tzdb$asiko$.prototype;
var $d_Lzonedb_java_tzdb$asiko$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiko$: 0
}, false, "zonedb.java.tzdb$asiko$", {
  Lzonedb_java_tzdb$asiko$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiko$.prototype.$classData = $d_Lzonedb_java_tzdb$asiko$;
var $n_Lzonedb_java_tzdb$asiko$;
function $m_Lzonedb_java_tzdb$asiko$() {
  if ((!$n_Lzonedb_java_tzdb$asiko$)) {
    $n_Lzonedb_java_tzdb$asiko$ = new $c_Lzonedb_java_tzdb$asiko$()
  };
  return $n_Lzonedb_java_tzdb$asiko$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiky$() {
  this.Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo = null;
  $n_Lzonedb_java_tzdb$asiky$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 33539);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 33539);
  var _2 = [[1888001, 1139, 33539, 32400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1888001, 1139, 33539, 32400], [1948123, 0, 32400, 36000], [1948256, 3600, 36000, 32400], [1949093, 0, 32400, 36000], [1949254, 3600, 36000, 32400], [1950127, 0, 32400, 36000], [1950253, 3600, 36000, 32400], [1951126, 0, 32400, 36000], [1951259, 3600, 36000, 32400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiky$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiky$.prototype.constructor = $c_Lzonedb_java_tzdb$asiky$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiky$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiky$.prototype = $c_Lzonedb_java_tzdb$asiky$.prototype;
var $d_Lzonedb_java_tzdb$asiky$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiky$: 0
}, false, "zonedb.java.tzdb$asiky$", {
  Lzonedb_java_tzdb$asiky$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiky$.prototype.$classData = $d_Lzonedb_java_tzdb$asiky$;
var $n_Lzonedb_java_tzdb$asiky$;
function $m_Lzonedb_java_tzdb$asiky$() {
  if ((!$n_Lzonedb_java_tzdb$asiky$)) {
    $n_Lzonedb_java_tzdb$asiky$ = new $c_Lzonedb_java_tzdb$asiky$()
  };
  return $n_Lzonedb_java_tzdb$asiky$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asile$() {
  this.Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem = null;
  $n_Lzonedb_java_tzdb$asile$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8454);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8454);
  var _2 = [[1880001, 0, 8454, 8440], [1918001, 0, 8440, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 8454, 8440], [1918001, 0, 8440, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1948144, 0, 7200, 14400], [1948245, 0, 14400, 10800], [1948306, 7200, 10800, 7200], [1949121, 0, 7200, 10800], [1949305, 7200, 10800, 7200], [1950106, 0, 7200, 10800], [1950258, 10800, 10800, 7200], [1951091, 0, 7200, 10800], [1951315, 10800, 10800, 7200], [1952111, 7200, 7200, 10800], [1952293, 10800, 10800, 7200], [1953102, 7200, 7200, 10800], [1953256, 10800, 10800, 7200], [1954164, 0, 7200, 10800], [1954255, 0, 10800, 7200], [1955162, 7200, 7200, 10800], [1955254, 0, 10800, 7200], [1956155, 0, 7200, 10800], [1956274, 10800, 10800, 7200], [1957119, 7200, 7200, 10800], [1957265, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996075, 0, 7200, 10800], [1996260, 0, 10800, 7200], [1997080, 0, 7200, 10800], [1997257, 0, 10800, 7200], [1998079, 0, 7200, 10800], [1998249, 0, 10800, 7200], [1999092, 7200, 7200, 10800], [1999246, 7200, 10800, 7200], [2000105, 7200, 7200, 10800], [2000280, 3600, 10800, 7200], [2001099, 3600, 7200, 10800], [2001267, 3600, 10800, 7200], [2002088, 3600, 7200, 10800], [2002280, 3600, 10800, 7200], [2003087, 3600, 7200, 10800], [2003276, 3600, 10800, 7200], [2004098, 3600, 7200, 10800], [2004266, 3600, 10800, 7200], [2005091, 7200, 7200, 10800], [2005282, 7200, 10800, 7200], [2006090, 7200, 7200, 10800], [2006274, 7200, 10800, 7200], [2007089, 7200, 7200, 10800], [2007259, 7200, 10800, 7200], [2008088, 7200, 7200, 10800], [2008279, 7200, 10800, 7200], [2009086, 7200, 7200, 10800], [2009270, 7200, 10800, 7200], [2010085, 7200, 7200, 10800], [2010255, 7200, 10800, 7200], [2011091, 7200, 7200, 10800], [2011275, 7200, 10800, 7200], [2012090, 7200, 7200, 10800], [2012267, 7200, 10800, 7200], [2013088, 7200, 7200, 10800], [2013300, 7200, 10800, 7200], [2014087, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 23, 5, 7200, 0, 1, 7200, 7200, 10800], [10, 25, 7, 7200, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asile$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asile$.prototype.constructor = $c_Lzonedb_java_tzdb$asile$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asile$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asile$.prototype = $c_Lzonedb_java_tzdb$asile$.prototype;
var $d_Lzonedb_java_tzdb$asile$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asile$: 0
}, false, "zonedb.java.tzdb$asile$", {
  Lzonedb_java_tzdb$asile$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asile$.prototype.$classData = $d_Lzonedb_java_tzdb$asile$;
var $n_Lzonedb_java_tzdb$asile$;
function $m_Lzonedb_java_tzdb$asile$() {
  if ((!$n_Lzonedb_java_tzdb$asile$)) {
    $n_Lzonedb_java_tzdb$asile$ = new $c_Lzonedb_java_tzdb$asile$()
  };
  return $n_Lzonedb_java_tzdb$asile$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asili$() {
  this.Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin = null;
  $n_Lzonedb_java_tzdb$asili$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 34248);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 34248);
  var _2 = [[1905235, 0, 34248, 32400], [1945237, 0, 32400, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [1997089, 7200, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000], [2016087, 7200, 36000, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905235, 0, 34248, 32400], [1945237, 0, 32400, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997299, 10800, 39600, 36000], [1998088, 7200, 36000, 39600], [1998298, 10800, 39600, 36000], [1999087, 7200, 36000, 39600], [1999304, 10800, 39600, 36000], [2000086, 7200, 36000, 39600], [2000303, 10800, 39600, 36000], [2001084, 7200, 36000, 39600], [2001301, 10800, 39600, 36000], [2002090, 7200, 36000, 39600], [2002300, 10800, 39600, 36000], [2003089, 7200, 36000, 39600], [2003299, 10800, 39600, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000], [2016087, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asili$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asili$.prototype.constructor = $c_Lzonedb_java_tzdb$asili$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asili$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asili$.prototype = $c_Lzonedb_java_tzdb$asili$.prototype;
var $d_Lzonedb_java_tzdb$asili$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asili$: 0
}, false, "zonedb.java.tzdb$asili$", {
  Lzonedb_java_tzdb$asili$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asili$.prototype.$classData = $d_Lzonedb_java_tzdb$asili$;
var $n_Lzonedb_java_tzdb$asili$;
function $m_Lzonedb_java_tzdb$asili$() {
  if ((!$n_Lzonedb_java_tzdb$asili$)) {
    $n_Lzonedb_java_tzdb$asili$ = new $c_Lzonedb_java_tzdb$asili$()
  };
  return $n_Lzonedb_java_tzdb$asili$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asima$() {
  this.Lzonedb_java_tzdb$asima$__f_Asia_Amman = null;
  $n_Lzonedb_java_tzdb$asima$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8624);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8624);
  var _2 = [[1931001, 0, 8624, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931001, 0, 8624, 7200], [1973157, 0, 7200, 10800], [1973274, 0, 10800, 7200], [1974121, 0, 7200, 10800], [1974274, 0, 10800, 7200], [1975121, 0, 7200, 10800], [1975274, 0, 10800, 7200], [1976122, 0, 7200, 10800], [1976306, 0, 10800, 7200], [1977121, 0, 7200, 10800], [1977274, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978273, 0, 10800, 7200], [1985091, 0, 7200, 10800], [1985274, 0, 10800, 7200], [1986094, 0, 7200, 10800], [1986276, 0, 10800, 7200], [1987093, 0, 7200, 10800], [1987275, 0, 10800, 7200], [1988092, 0, 7200, 10800], [1988281, 0, 10800, 7200], [1989128, 0, 7200, 10800], [1989279, 0, 10800, 7200], [1990117, 0, 7200, 10800], [1990278, 0, 10800, 7200], [1991107, 0, 7200, 10800], [1991270, 0, 10800, 7200], [1992101, 0, 7200, 10800], [1992276, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993274, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994259, 0, 10800, 7200], [1995097, 0, 7200, 10800], [1995258, 3600, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999182, 0, 7200, 10800], [1999267, 3600, 10800, 7200], [2000090, 0, 7200, 10800], [2000273, 3600, 10800, 7200], [2001088, 0, 7200, 10800], [2001271, 3600, 10800, 7200], [2002088, 0, 7200, 10800], [2002270, 3600, 10800, 7200], [2003087, 0, 7200, 10800], [2003297, 3600, 10800, 7200], [2004086, 0, 7200, 10800], [2004289, 3600, 10800, 7200], [2005091, 0, 7200, 10800], [2005273, 3600, 10800, 7200], [2006090, 0, 7200, 10800], [2006300, 3600, 10800, 7200], [2007089, 0, 7200, 10800], [2007299, 3600, 10800, 7200], [2008088, 0, 7200, 10800], [2008305, 3600, 10800, 7200], [2009086, 0, 7200, 10800], [2009303, 3600, 10800, 7200], [2010085, 0, 7200, 10800], [2010302, 3600, 10800, 7200], [2011091, 0, 7200, 10800], [2011301, 3600, 10800, 7200], [2012090, 0, 7200, 10800], [2013354, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014304, 3600, 10800, 7200], [2015086, 0, 7200, 10800], [2015303, 3600, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 26, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 5, 0, 0, 2, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asima$__f_Asia_Amman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asima$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asima$.prototype.constructor = $c_Lzonedb_java_tzdb$asima$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asima$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asima$.prototype = $c_Lzonedb_java_tzdb$asima$.prototype;
var $d_Lzonedb_java_tzdb$asima$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asima$: 0
}, false, "zonedb.java.tzdb$asima$", {
  Lzonedb_java_tzdb$asima$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asima$.prototype.$classData = $d_Lzonedb_java_tzdb$asima$;
var $n_Lzonedb_java_tzdb$asima$;
function $m_Lzonedb_java_tzdb$asima$() {
  if ((!$n_Lzonedb_java_tzdb$asima$)) {
    $n_Lzonedb_java_tzdb$asima$ = new $c_Lzonedb_java_tzdb$asima$()
  };
  return $n_Lzonedb_java_tzdb$asima$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asimb$() {
  this.Lzonedb_java_tzdb$asimb$__f_Asia_Colombo = null;
  $n_Lzonedb_java_tzdb$asimb$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 19164);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 19164);
  var _2 = [[1880001, 0, 19164, 19172], [1906001, 0, 19172, 19800], [1996146, 0, 19800, 23400], [1996300, 1800, 23400, 21600], [2006105, 1800, 21600, 19800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 19164, 19172], [1906001, 0, 19172, 19800], [1942005, 0, 19800, 21600], [1942244, 0, 21600, 23400], [1945289, 7200, 23400, 19800], [1996146, 0, 19800, 23400], [1996300, 1800, 23400, 21600], [2006105, 1800, 21600, 19800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asimb$__f_Asia_Colombo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asimb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asimb$.prototype.constructor = $c_Lzonedb_java_tzdb$asimb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asimb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asimb$.prototype = $c_Lzonedb_java_tzdb$asimb$.prototype;
var $d_Lzonedb_java_tzdb$asimb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asimb$: 0
}, false, "zonedb.java.tzdb$asimb$", {
  Lzonedb_java_tzdb$asimb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asimb$.prototype.$classData = $d_Lzonedb_java_tzdb$asimb$;
var $n_Lzonedb_java_tzdb$asimb$;
function $m_Lzonedb_java_tzdb$asimb$() {
  if ((!$n_Lzonedb_java_tzdb$asimb$)) {
    $n_Lzonedb_java_tzdb$asimb$ = new $c_Lzonedb_java_tzdb$asimb$()
  };
  return $n_Lzonedb_java_tzdb$asimb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asimq$() {
  this.Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi = null;
  $n_Lzonedb_java_tzdb$asimq$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 21020);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 21020);
  var _2 = [[1928001, 0, 21020, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1928001, 0, 21020, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asimq$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asimq$.prototype.constructor = $c_Lzonedb_java_tzdb$asimq$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asimq$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asimq$.prototype = $c_Lzonedb_java_tzdb$asimq$.prototype;
var $d_Lzonedb_java_tzdb$asimq$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asimq$: 0
}, false, "zonedb.java.tzdb$asimq$", {
  Lzonedb_java_tzdb$asimq$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asimq$.prototype.$classData = $d_Lzonedb_java_tzdb$asimq$;
var $n_Lzonedb_java_tzdb$asimq$;
function $m_Lzonedb_java_tzdb$asimq$() {
  if ((!$n_Lzonedb_java_tzdb$asimq$)) {
    $n_Lzonedb_java_tzdb$asimq$ = new $c_Lzonedb_java_tzdb$asimq$()
  };
  return $n_Lzonedb_java_tzdb$asimq$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asims$() {
  this.Lzonedb_java_tzdb$asims$__f_Asia_Tomsk = null;
  this.Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk = null;
  this.Lzonedb_java_tzdb$asims$__f_Asia_Omsk = null;
  $n_Lzonedb_java_tzdb$asims$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 20391);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 20391);
  var _2 = [[1919356, 0, 20391, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2002121, 7200, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016150, 7200, 21600, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919356, 0, 20391, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002121, 10800, 28800, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016150, 7200, 21600, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asims$__f_Asia_Tomsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 36892);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 36892);
  var _2$3 = [[1924123, 0, 36892, 36000], [1930172, 0, 36000, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 39600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1924123, 0, 36892, 36000], [1930172, 0, 36000, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 39600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 17610);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 17610);
  var _2$6 = [[1919318, 0, 17610, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [1992019, 7200, 18000, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1919318, 0, 17610, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 25200], [1992271, 10800, 25200, 21600], [1993087, 7200, 21600, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$asims$__f_Asia_Omsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$asims$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asims$.prototype.constructor = $c_Lzonedb_java_tzdb$asims$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asims$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asims$.prototype = $c_Lzonedb_java_tzdb$asims$.prototype;
var $d_Lzonedb_java_tzdb$asims$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asims$: 0
}, false, "zonedb.java.tzdb$asims$", {
  Lzonedb_java_tzdb$asims$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asims$.prototype.$classData = $d_Lzonedb_java_tzdb$asims$;
var $n_Lzonedb_java_tzdb$asims$;
function $m_Lzonedb_java_tzdb$asims$() {
  if ((!$n_Lzonedb_java_tzdb$asims$)) {
    $n_Lzonedb_java_tzdb$asims$ = new $c_Lzonedb_java_tzdb$asims$()
  };
  return $n_Lzonedb_java_tzdb$asims$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asina$() {
  this.Lzonedb_java_tzdb$asina$__f_Asia_Qostanay = null;
  this.Lzonedb_java_tzdb$asina$__f_Asia_Pontianak = null;
  $n_Lzonedb_java_tzdb$asina$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 15268);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 15268);
  var _2 = [[1924123, 0, 15268, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [2004305, 7200, 18000, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 15268, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asina$__f_Asia_Qostanay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 26240);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 26240);
  var _2$3 = [[1932306, 0, 26240, 27000], [1942029, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 28800], [1988001, 0, 28800, 25200]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1932306, 0, 26240, 27000], [1942029, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 28800], [1988001, 0, 28800, 25200]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asina$__f_Asia_Pontianak = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asina$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asina$.prototype.constructor = $c_Lzonedb_java_tzdb$asina$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asina$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asina$.prototype = $c_Lzonedb_java_tzdb$asina$.prototype;
var $d_Lzonedb_java_tzdb$asina$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asina$: 0
}, false, "zonedb.java.tzdb$asina$", {
  Lzonedb_java_tzdb$asina$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asina$.prototype.$classData = $d_Lzonedb_java_tzdb$asina$;
var $n_Lzonedb_java_tzdb$asina$;
function $m_Lzonedb_java_tzdb$asina$() {
  if ((!$n_Lzonedb_java_tzdb$asina$)) {
    $n_Lzonedb_java_tzdb$asina$ = new $c_Lzonedb_java_tzdb$asina$()
  };
  return $n_Lzonedb_java_tzdb$asina$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asinb$() {
  this.Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe = null;
  $n_Lzonedb_java_tzdb$asinb$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 16512);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 16512);
  var _2 = [[1924123, 0, 16512, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 16512, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991252, 10800, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asinb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asinb$.prototype.constructor = $c_Lzonedb_java_tzdb$asinb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asinb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asinb$.prototype = $c_Lzonedb_java_tzdb$asinb$.prototype;
var $d_Lzonedb_java_tzdb$asinb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asinb$: 0
}, false, "zonedb.java.tzdb$asinb$", {
  Lzonedb_java_tzdb$asinb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asinb$.prototype.$classData = $d_Lzonedb_java_tzdb$asinb$;
var $n_Lzonedb_java_tzdb$asinb$;
function $m_Lzonedb_java_tzdb$asinb$() {
  if ((!$n_Lzonedb_java_tzdb$asinb$)) {
    $n_Lzonedb_java_tzdb$asinb$ = new $c_Lzonedb_java_tzdb$asinb$()
  };
  return $n_Lzonedb_java_tzdb$asinb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asind$() {
  this.Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu = null;
  $n_Lzonedb_java_tzdb$asind$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 20476);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 20476);
  var _2 = [[1920001, 0, 20476, 19800], [1986001, 0, 19800, 20700]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920001, 0, 20476, 19800], [1986001, 0, 19800, 20700]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asind$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asind$.prototype.constructor = $c_Lzonedb_java_tzdb$asind$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asind$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asind$.prototype = $c_Lzonedb_java_tzdb$asind$.prototype;
var $d_Lzonedb_java_tzdb$asind$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asind$: 0
}, false, "zonedb.java.tzdb$asind$", {
  Lzonedb_java_tzdb$asind$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asind$.prototype.$classData = $d_Lzonedb_java_tzdb$asind$;
var $n_Lzonedb_java_tzdb$asind$;
function $m_Lzonedb_java_tzdb$asind$() {
  if ((!$n_Lzonedb_java_tzdb$asind$)) {
    $n_Lzonedb_java_tzdb$asind$ = new $c_Lzonedb_java_tzdb$asind$()
  };
  return $n_Lzonedb_java_tzdb$asind$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asine$() {
  this.Lzonedb_java_tzdb$asine$__f_Asia_Brunei = null;
  $n_Lzonedb_java_tzdb$asine$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27580);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27580);
  var _2 = [[1926060, 0, 27580, 27000], [1933001, 0, 27000, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1926060, 0, 27580, 27000], [1933001, 0, 27000, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asine$__f_Asia_Brunei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asine$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asine$.prototype.constructor = $c_Lzonedb_java_tzdb$asine$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asine$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asine$.prototype = $c_Lzonedb_java_tzdb$asine$.prototype;
var $d_Lzonedb_java_tzdb$asine$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asine$: 0
}, false, "zonedb.java.tzdb$asine$", {
  Lzonedb_java_tzdb$asine$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asine$.prototype.$classData = $d_Lzonedb_java_tzdb$asine$;
var $n_Lzonedb_java_tzdb$asine$;
function $m_Lzonedb_java_tzdb$asine$() {
  if ((!$n_Lzonedb_java_tzdb$asine$)) {
    $n_Lzonedb_java_tzdb$asine$ = new $c_Lzonedb_java_tzdb$asine$()
  };
  return $n_Lzonedb_java_tzdb$asine$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiob$() {
  this.Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe = null;
  $n_Lzonedb_java_tzdb$asiob$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 13720);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 13720);
  var _2 = [[1924123, 0, 13720, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 13720, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2004305, 10800, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiob$.prototype.constructor = $c_Lzonedb_java_tzdb$asiob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiob$.prototype = $c_Lzonedb_java_tzdb$asiob$.prototype;
var $d_Lzonedb_java_tzdb$asiob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiob$: 0
}, false, "zonedb.java.tzdb$asiob$", {
  Lzonedb_java_tzdb$asiob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiob$.prototype.$classData = $d_Lzonedb_java_tzdb$asiob$;
var $n_Lzonedb_java_tzdb$asiob$;
function $m_Lzonedb_java_tzdb$asiob$() {
  if ((!$n_Lzonedb_java_tzdb$asiob$)) {
    $n_Lzonedb_java_tzdb$asiob$ = new $c_Lzonedb_java_tzdb$asiob$()
  };
  return $n_Lzonedb_java_tzdb$asiob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asion$() {
  this.Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong = null;
  $n_Lzonedb_java_tzdb$asion$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27402);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27402);
  var _2 = [[1904304, 2202, 27402, 28800], [1941358, 84600, 28800, 32400], [1945322, 7200, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1904304, 2202, 27402, 28800], [1941166, 10800, 28800, 32400], [1941274, 14400, 32400, 30600], [1941359, 0, 30600, 32400], [1945322, 7200, 32400, 28800], [1946111, 0, 28800, 32400], [1946335, 16200, 32400, 28800], [1947103, 12600, 28800, 32400], [1947334, 16200, 32400, 28800], [1948123, 12600, 28800, 32400], [1948305, 16200, 32400, 28800], [1949093, 12600, 28800, 32400], [1949303, 16200, 32400, 28800], [1950092, 12600, 28800, 32400], [1950302, 16200, 32400, 28800], [1951091, 12600, 28800, 32400], [1951301, 16200, 32400, 28800], [1952097, 12600, 28800, 32400], [1952307, 16200, 32400, 28800], [1953095, 12600, 28800, 32400], [1953305, 12600, 32400, 28800], [1954080, 12600, 28800, 32400], [1954304, 12600, 32400, 28800], [1955079, 12600, 28800, 32400], [1955310, 12600, 32400, 28800], [1956078, 12600, 28800, 32400], [1956309, 12600, 32400, 28800], [1957083, 12600, 28800, 32400], [1957307, 12600, 32400, 28800], [1958082, 12600, 28800, 32400], [1958306, 12600, 32400, 28800], [1959081, 12600, 28800, 32400], [1959305, 12600, 32400, 28800], [1960080, 12600, 28800, 32400], [1960311, 12600, 32400, 28800], [1961078, 12600, 28800, 32400], [1961309, 12600, 32400, 28800], [1962077, 12600, 28800, 32400], [1962308, 12600, 32400, 28800], [1963083, 12600, 28800, 32400], [1963307, 12600, 32400, 28800], [1964082, 12600, 28800, 32400], [1964306, 12600, 32400, 28800], [1965108, 12600, 28800, 32400], [1965290, 12600, 32400, 28800], [1966107, 12600, 28800, 32400], [1966289, 12600, 32400, 28800], [1967106, 12600, 28800, 32400], [1967295, 12600, 32400, 28800], [1968112, 12600, 28800, 32400], [1968294, 12600, 32400, 28800], [1969110, 12600, 28800, 32400], [1969292, 12600, 32400, 28800], [1970109, 12600, 28800, 32400], [1970291, 12600, 32400, 28800], [1971108, 12600, 28800, 32400], [1971290, 12600, 32400, 28800], [1972107, 12600, 28800, 32400], [1972296, 12600, 32400, 28800], [1973112, 12600, 28800, 32400], [1973294, 12600, 32400, 28800], [1973364, 12600, 28800, 32400], [1974293, 12600, 32400, 28800], [1975110, 12600, 28800, 32400], [1975292, 12600, 32400, 28800], [1976109, 12600, 28800, 32400], [1976291, 12600, 32400, 28800], [1979133, 12600, 28800, 32400], [1979294, 12600, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asion$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asion$.prototype.constructor = $c_Lzonedb_java_tzdb$asion$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asion$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asion$.prototype = $c_Lzonedb_java_tzdb$asion$.prototype;
var $d_Lzonedb_java_tzdb$asion$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asion$: 0
}, false, "zonedb.java.tzdb$asion$", {
  Lzonedb_java_tzdb$asion$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asion$.prototype.$classData = $d_Lzonedb_java_tzdb$asion$;
var $n_Lzonedb_java_tzdb$asion$;
function $m_Lzonedb_java_tzdb$asion$() {
  if ((!$n_Lzonedb_java_tzdb$asion$)) {
    $n_Lzonedb_java_tzdb$asion$ = new $c_Lzonedb_java_tzdb$asion$()
  };
  return $n_Lzonedb_java_tzdb$asion$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asior$() {
  this.Lzonedb_java_tzdb$asior$__f_Asia_Singapore = null;
  $n_Lzonedb_java_tzdb$asior$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 24925);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 24925);
  var _2 = [[1905152, 0, 24925, 25200], [1935365, 85200, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905152, 0, 24925, 25200], [1933001, 0, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asior$__f_Asia_Singapore = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asior$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asior$.prototype.constructor = $c_Lzonedb_java_tzdb$asior$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asior$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asior$.prototype = $c_Lzonedb_java_tzdb$asior$.prototype;
var $d_Lzonedb_java_tzdb$asior$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asior$: 0
}, false, "zonedb.java.tzdb$asior$", {
  Lzonedb_java_tzdb$asior$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asior$.prototype.$classData = $d_Lzonedb_java_tzdb$asior$;
var $n_Lzonedb_java_tzdb$asior$;
function $m_Lzonedb_java_tzdb$asior$() {
  if ((!$n_Lzonedb_java_tzdb$asior$)) {
    $n_Lzonedb_java_tzdb$asior$ = new $c_Lzonedb_java_tzdb$asior$()
  };
  return $n_Lzonedb_java_tzdb$asior$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiou$() {
  this.Lzonedb_java_tzdb$asiou$__f_Asia_Seoul = null;
  $n_Lzonedb_java_tzdb$asiou$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 30472);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 30472);
  var _2 = [[1908092, 0, 30472, 30600], [1912001, 0, 30600, 32400], [1954080, 0, 32400, 30600], [1961222, 0, 30600, 32400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1908092, 0, 30472, 30600], [1912001, 0, 30600, 32400], [1948153, 0, 32400, 36000], [1948257, 0, 36000, 32400], [1949093, 0, 32400, 36000], [1949254, 0, 36000, 32400], [1950091, 0, 32400, 36000], [1950253, 0, 36000, 32400], [1951126, 0, 32400, 36000], [1951252, 0, 36000, 32400], [1954080, 0, 32400, 30600], [1955125, 0, 30600, 34200], [1955252, 0, 34200, 30600], [1956141, 0, 30600, 34200], [1956274, 0, 34200, 30600], [1957125, 0, 30600, 34200], [1957265, 0, 34200, 30600], [1958124, 0, 30600, 34200], [1958264, 0, 34200, 30600], [1959123, 0, 30600, 34200], [1959263, 0, 34200, 30600], [1960122, 0, 30600, 34200], [1960262, 0, 34200, 30600], [1961222, 0, 30600, 32400], [1987130, 7200, 32400, 36000], [1987284, 10800, 36000, 32400], [1988129, 7200, 32400, 36000], [1988283, 10800, 36000, 32400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiou$__f_Asia_Seoul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiou$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiou$.prototype.constructor = $c_Lzonedb_java_tzdb$asiou$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiou$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiou$.prototype = $c_Lzonedb_java_tzdb$asiou$.prototype;
var $d_Lzonedb_java_tzdb$asiou$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiou$: 0
}, false, "zonedb.java.tzdb$asiou$", {
  Lzonedb_java_tzdb$asiou$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiou$.prototype.$classData = $d_Lzonedb_java_tzdb$asiou$;
var $n_Lzonedb_java_tzdb$asiou$;
function $m_Lzonedb_java_tzdb$asiou$() {
  if ((!$n_Lzonedb_java_tzdb$asiou$)) {
    $n_Lzonedb_java_tzdb$asiou$ = new $c_Lzonedb_java_tzdb$asiou$()
  };
  return $n_Lzonedb_java_tzdb$asiou$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiov$() {
  this.Lzonedb_java_tzdb$asiov$__f_Asia_Hovd = null;
  $n_Lzonedb_java_tzdb$asiov$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 21996);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 21996);
  var _2 = [[1905213, 0, 21996, 21600], [1978001, 0, 21600, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905213, 0, 21996, 21600], [1978001, 0, 21600, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 0, 28800, 25200], [1985090, 0, 25200, 28800], [1985272, 0, 28800, 25200], [1986089, 0, 25200, 28800], [1986271, 0, 28800, 25200], [1987088, 0, 25200, 28800], [1987270, 0, 28800, 25200], [1988087, 0, 25200, 28800], [1988269, 0, 28800, 25200], [1989085, 0, 25200, 28800], [1989267, 0, 28800, 25200], [1990084, 0, 25200, 28800], [1990273, 0, 28800, 25200], [1991090, 0, 25200, 28800], [1991272, 0, 28800, 25200], [1992089, 0, 25200, 28800], [1992271, 0, 28800, 25200], [1993087, 0, 25200, 28800], [1993269, 0, 28800, 25200], [1994086, 0, 25200, 28800], [1994268, 0, 28800, 25200], [1995085, 0, 25200, 28800], [1995267, 0, 28800, 25200], [1996091, 0, 25200, 28800], [1996273, 0, 28800, 25200], [1997089, 0, 25200, 28800], [1997271, 0, 28800, 25200], [1998088, 0, 25200, 28800], [1998270, 0, 28800, 25200], [2001118, 7200, 25200, 28800], [2001272, 7200, 28800, 25200], [2002089, 7200, 25200, 28800], [2002271, 7200, 28800, 25200], [2003088, 7200, 25200, 28800], [2003270, 7200, 28800, 25200], [2004087, 7200, 25200, 28800], [2004269, 7200, 28800, 25200], [2005085, 7200, 25200, 28800], [2005267, 7200, 28800, 25200], [2006084, 7200, 25200, 28800], [2006273, 7200, 28800, 25200], [2015087, 7200, 25200, 28800], [2015269, 0, 28800, 25200], [2016086, 7200, 25200, 28800], [2016268, 0, 28800, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiov$__f_Asia_Hovd = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiov$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiov$.prototype.constructor = $c_Lzonedb_java_tzdb$asiov$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiov$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiov$.prototype = $c_Lzonedb_java_tzdb$asiov$.prototype;
var $d_Lzonedb_java_tzdb$asiov$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiov$: 0
}, false, "zonedb.java.tzdb$asiov$", {
  Lzonedb_java_tzdb$asiov$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiov$.prototype.$classData = $d_Lzonedb_java_tzdb$asiov$;
var $n_Lzonedb_java_tzdb$asiov$;
function $m_Lzonedb_java_tzdb$asiov$() {
  if ((!$n_Lzonedb_java_tzdb$asiov$)) {
    $n_Lzonedb_java_tzdb$asiov$ = new $c_Lzonedb_java_tzdb$asiov$()
  };
  return $n_Lzonedb_java_tzdb$asiov$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asipe$() {
  this.Lzonedb_java_tzdb$asipe$__f_Asia_Taipei = null;
  $n_Lzonedb_java_tzdb$asipe$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 29160);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 29160);
  var _2 = [[1896001, 0, 29160, 28800], [1937274, 0, 28800, 32400], [1945264, 3600, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1896001, 0, 29160, 28800], [1937274, 0, 28800, 32400], [1945264, 3600, 32400, 28800], [1946135, 0, 28800, 32400], [1946274, 0, 32400, 28800], [1947105, 0, 28800, 32400], [1947305, 0, 32400, 28800], [1948122, 0, 28800, 32400], [1948275, 0, 32400, 28800], [1949121, 0, 28800, 32400], [1949274, 0, 32400, 28800], [1950121, 0, 28800, 32400], [1950274, 0, 32400, 28800], [1951121, 0, 28800, 32400], [1951274, 0, 32400, 28800], [1952061, 0, 28800, 32400], [1952306, 0, 32400, 28800], [1953091, 0, 28800, 32400], [1953305, 0, 32400, 28800], [1954091, 0, 28800, 32400], [1954305, 0, 32400, 28800], [1955091, 0, 28800, 32400], [1955274, 0, 32400, 28800], [1956092, 0, 28800, 32400], [1956275, 0, 32400, 28800], [1957091, 0, 28800, 32400], [1957274, 0, 32400, 28800], [1958091, 0, 28800, 32400], [1958274, 0, 32400, 28800], [1959091, 0, 28800, 32400], [1959274, 0, 32400, 28800], [1960153, 0, 28800, 32400], [1960275, 0, 32400, 28800], [1961152, 0, 28800, 32400], [1961274, 0, 32400, 28800], [1974091, 0, 28800, 32400], [1974274, 0, 32400, 28800], [1975091, 0, 28800, 32400], [1975274, 0, 32400, 28800], [1979182, 0, 28800, 32400], [1979274, 0, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asipe$__f_Asia_Taipei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asipe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asipe$.prototype.constructor = $c_Lzonedb_java_tzdb$asipe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asipe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asipe$.prototype = $c_Lzonedb_java_tzdb$asipe$.prototype;
var $d_Lzonedb_java_tzdb$asipe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asipe$: 0
}, false, "zonedb.java.tzdb$asipe$", {
  Lzonedb_java_tzdb$asipe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asipe$.prototype.$classData = $d_Lzonedb_java_tzdb$asipe$;
var $n_Lzonedb_java_tzdb$asipe$;
function $m_Lzonedb_java_tzdb$asipe$() {
  if ((!$n_Lzonedb_java_tzdb$asipe$)) {
    $n_Lzonedb_java_tzdb$asipe$ = new $c_Lzonedb_java_tzdb$asipe$()
  };
  return $n_Lzonedb_java_tzdb$asipe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiph$() {
  this.Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu = null;
  $n_Lzonedb_java_tzdb$asiph$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 21516);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 21516);
  var _2 = [[1947227, 0, 21516, 19800], [1987274, 0, 19800, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1947227, 0, 21516, 19800], [1987274, 0, 19800, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiph$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiph$.prototype.constructor = $c_Lzonedb_java_tzdb$asiph$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiph$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiph$.prototype = $c_Lzonedb_java_tzdb$asiph$.prototype;
var $d_Lzonedb_java_tzdb$asiph$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiph$: 0
}, false, "zonedb.java.tzdb$asiph$", {
  Lzonedb_java_tzdb$asiph$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiph$.prototype.$classData = $d_Lzonedb_java_tzdb$asiph$;
var $n_Lzonedb_java_tzdb$asiph$;
function $m_Lzonedb_java_tzdb$asiph$() {
  if ((!$n_Lzonedb_java_tzdb$asiph$)) {
    $n_Lzonedb_java_tzdb$asiph$ = new $c_Lzonedb_java_tzdb$asiph$()
  };
  return $n_Lzonedb_java_tzdb$asiph$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asipu$() {
  this.Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur = null;
  $n_Lzonedb_java_tzdb$asipu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 24406);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 24406);
  var _2 = [[1901001, 0, 24406, 24925], [1905152, 0, 24925, 25200], [1935365, 85200, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 24406, 24925], [1905152, 0, 24925, 25200], [1933001, 0, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asipu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asipu$.prototype.constructor = $c_Lzonedb_java_tzdb$asipu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asipu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asipu$.prototype = $c_Lzonedb_java_tzdb$asipu$.prototype;
var $d_Lzonedb_java_tzdb$asipu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asipu$: 0
}, false, "zonedb.java.tzdb$asipu$", {
  Lzonedb_java_tzdb$asipu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asipu$.prototype.$classData = $d_Lzonedb_java_tzdb$asipu$;
var $n_Lzonedb_java_tzdb$asipu$;
function $m_Lzonedb_java_tzdb$asipu$() {
  if ((!$n_Lzonedb_java_tzdb$asipu$)) {
    $n_Lzonedb_java_tzdb$asipu$ = new $c_Lzonedb_java_tzdb$asipu$()
  };
  return $n_Lzonedb_java_tzdb$asipu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asira$() {
  this.Lzonedb_java_tzdb$asira$__f_Asia_Atyrau = null;
  this.Lzonedb_java_tzdb$asira$__f_Asia_Tehran = null;
  this.Lzonedb_java_tzdb$asira$__f_Asia_Oral = null;
  $n_Lzonedb_java_tzdb$asira$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 12464);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 12464);
  var _2 = [[1924123, 0, 12464, 10800], [1930172, 0, 10800, 18000], [1981274, 0, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1999087, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 12464, 10800], [1930172, 0, 10800, 18000], [1981274, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asira$__f_Asia_Atyrau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 12344);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 12344);
  var _2$3 = [[1946001, 0, 12344, 12600], [1977305, 0, 12600, 14400], [1979001, 0, 14400, 12600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1946001, 0, 12344, 12600], [1977305, 0, 12600, 14400], [1978080, 0, 14400, 18000], [1978294, 0, 18000, 14400], [1979001, 0, 14400, 12600], [1979080, 0, 12600, 16200], [1979262, 0, 16200, 12600], [1980081, 0, 12600, 16200], [1980267, 0, 16200, 12600], [1991123, 0, 12600, 16200], [1991265, 0, 16200, 12600], [1992082, 0, 12600, 16200], [1992266, 0, 16200, 12600], [1993081, 0, 12600, 16200], [1993265, 0, 16200, 12600], [1994081, 0, 12600, 16200], [1994265, 0, 16200, 12600], [1995081, 0, 12600, 16200], [1995265, 0, 16200, 12600], [1996081, 0, 12600, 16200], [1996265, 0, 16200, 12600], [1997081, 0, 12600, 16200], [1997265, 0, 16200, 12600], [1998081, 0, 12600, 16200], [1998265, 0, 16200, 12600], [1999081, 0, 12600, 16200], [1999265, 0, 16200, 12600], [2000081, 0, 12600, 16200], [2000265, 0, 16200, 12600], [2001081, 0, 12600, 16200], [2001265, 0, 16200, 12600], [2002081, 0, 12600, 16200], [2002265, 0, 16200, 12600], [2003081, 0, 12600, 16200], [2003265, 0, 16200, 12600], [2004081, 0, 12600, 16200], [2004265, 0, 16200, 12600], [2005081, 0, 12600, 16200], [2005265, 0, 16200, 12600], [2008081, 0, 12600, 16200], [2008265, 0, 16200, 12600], [2009081, 0, 12600, 16200], [2009265, 0, 16200, 12600], [2010081, 0, 12600, 16200], [2010265, 0, 16200, 12600], [2011081, 0, 12600, 16200], [2011265, 0, 16200, 12600], [2012081, 0, 12600, 16200], [2012265, 0, 16200, 12600], [2013081, 0, 12600, 16200], [2013265, 0, 16200, 12600], [2014081, 0, 12600, 16200], [2014265, 0, 16200, 12600], [2015081, 0, 12600, 16200], [2015265, 0, 16200, 12600], [2016081, 0, 12600, 16200], [2016265, 0, 16200, 12600], [2017081, 0, 12600, 16200], [2017265, 0, 16200, 12600], [2018081, 0, 12600, 16200], [2018265, 0, 16200, 12600], [2019081, 0, 12600, 16200], [2019265, 0, 16200, 12600], [2020081, 0, 12600, 16200], [2020265, 0, 16200, 12600], [2021081, 0, 12600, 16200], [2021265, 0, 16200, 12600], [2022081, 0, 12600, 16200], [2022265, 0, 16200, 12600], [2023081, 0, 12600, 16200], [2023265, 0, 16200, 12600], [2024081, 0, 12600, 16200], [2024265, 0, 16200, 12600], [2025081, 0, 12600, 16200], [2025265, 0, 16200, 12600], [2026081, 0, 12600, 16200], [2026265, 0, 16200, 12600], [2027081, 0, 12600, 16200], [2027265, 0, 16200, 12600], [2028081, 0, 12600, 16200], [2028265, 0, 16200, 12600], [2029080, 0, 12600, 16200], [2029264, 0, 16200, 12600], [2030081, 0, 12600, 16200], [2030265, 0, 16200, 12600], [2031081, 0, 12600, 16200], [2031265, 0, 16200, 12600], [2032081, 0, 12600, 16200], [2032265, 0, 16200, 12600], [2033080, 0, 12600, 16200], [2033264, 0, 16200, 12600], [2034081, 0, 12600, 16200], [2034265, 0, 16200, 12600], [2035081, 0, 12600, 16200], [2035265, 0, 16200, 12600], [2036081, 0, 12600, 16200], [2036265, 0, 16200, 12600], [2037080, 0, 12600, 16200], [2037264, 0, 16200, 12600], [2038081, 0, 12600, 16200], [2038265, 0, 16200, 12600], [2039081, 0, 12600, 16200], [2039265, 0, 16200, 12600], [2040081, 0, 12600, 16200], [2040265, 0, 16200, 12600], [2041080, 0, 12600, 16200], [2041264, 0, 16200, 12600], [2042081, 0, 12600, 16200], [2042265, 0, 16200, 12600], [2043081, 0, 12600, 16200], [2043265, 0, 16200, 12600], [2044081, 0, 12600, 16200], [2044265, 0, 16200, 12600], [2045080, 0, 12600, 16200], [2045264, 0, 16200, 12600], [2046081, 0, 12600, 16200], [2046265, 0, 16200, 12600], [2047081, 0, 12600, 16200], [2047265, 0, 16200, 12600], [2048081, 0, 12600, 16200], [2048265, 0, 16200, 12600], [2049080, 0, 12600, 16200], [2049264, 0, 16200, 12600], [2050081, 0, 12600, 16200], [2050265, 0, 16200, 12600], [2051081, 0, 12600, 16200], [2051265, 0, 16200, 12600], [2052081, 0, 12600, 16200], [2052265, 0, 16200, 12600], [2053080, 0, 12600, 16200], [2053264, 0, 16200, 12600], [2054081, 0, 12600, 16200], [2054265, 0, 16200, 12600], [2055081, 0, 12600, 16200], [2055265, 0, 16200, 12600], [2056081, 0, 12600, 16200], [2056265, 0, 16200, 12600], [2057080, 0, 12600, 16200], [2057264, 0, 16200, 12600], [2058081, 0, 12600, 16200], [2058265, 0, 16200, 12600], [2059081, 0, 12600, 16200], [2059265, 0, 16200, 12600], [2060081, 0, 12600, 16200], [2060265, 0, 16200, 12600], [2061080, 0, 12600, 16200], [2061264, 0, 16200, 12600], [2062080, 0, 12600, 16200], [2062264, 0, 16200, 12600], [2063081, 0, 12600, 16200], [2063265, 0, 16200, 12600], [2064081, 0, 12600, 16200], [2064265, 0, 16200, 12600], [2065080, 0, 12600, 16200], [2065264, 0, 16200, 12600], [2066080, 0, 12600, 16200], [2066264, 0, 16200, 12600], [2067081, 0, 12600, 16200], [2067265, 0, 16200, 12600], [2068081, 0, 12600, 16200], [2068265, 0, 16200, 12600], [2069080, 0, 12600, 16200], [2069264, 0, 16200, 12600], [2070080, 0, 12600, 16200], [2070264, 0, 16200, 12600], [2071081, 0, 12600, 16200], [2071265, 0, 16200, 12600], [2072081, 0, 12600, 16200], [2072265, 0, 16200, 12600], [2073080, 0, 12600, 16200], [2073264, 0, 16200, 12600], [2074080, 0, 12600, 16200], [2074264, 0, 16200, 12600], [2075081, 0, 12600, 16200], [2075265, 0, 16200, 12600], [2076081, 0, 12600, 16200], [2076265, 0, 16200, 12600], [2077080, 0, 12600, 16200], [2077264, 0, 16200, 12600], [2078080, 0, 12600, 16200], [2078264, 0, 16200, 12600], [2079081, 0, 12600, 16200], [2079265, 0, 16200, 12600], [2080081, 0, 12600, 16200], [2080265, 0, 16200, 12600], [2081080, 0, 12600, 16200], [2081264, 0, 16200, 12600], [2082080, 0, 12600, 16200], [2082264, 0, 16200, 12600], [2083081, 0, 12600, 16200], [2083265, 0, 16200, 12600], [2084081, 0, 12600, 16200], [2084265, 0, 16200, 12600], [2085080, 0, 12600, 16200], [2085264, 0, 16200, 12600], [2086080, 0, 12600, 16200], [2086264, 0, 16200, 12600], [2087081, 0, 12600, 16200], [2087265, 0, 16200, 12600], [2088081, 0, 12600, 16200], [2088265, 0, 16200, 12600], [2089080, 0, 12600, 16200], [2089264, 0, 16200, 12600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 21, (-1), 0, 0, 1, 12600, 12600, 16200], [9, 21, (-1), 0, 0, 1, 12600, 16200, 12600]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asira$__f_Asia_Tehran = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 12324);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 12324);
  var _2$6 = [[1924123, 0, 12324, 10800], [1930172, 0, 10800, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1989085, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1924123, 0, 12324, 10800], [1930172, 0, 10800, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991090, 7200, 14400, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992271, 10800, 18000, 14400], [1993087, 7200, 14400, 18000], [1993269, 10800, 18000, 14400], [1994086, 7200, 14400, 18000], [1994268, 10800, 18000, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$asira$__f_Asia_Oral = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$asira$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asira$.prototype.constructor = $c_Lzonedb_java_tzdb$asira$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asira$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asira$.prototype = $c_Lzonedb_java_tzdb$asira$.prototype;
var $d_Lzonedb_java_tzdb$asira$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asira$: 0
}, false, "zonedb.java.tzdb$asira$", {
  Lzonedb_java_tzdb$asira$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asira$.prototype.$classData = $d_Lzonedb_java_tzdb$asira$;
var $n_Lzonedb_java_tzdb$asira$;
function $m_Lzonedb_java_tzdb$asira$() {
  if ((!$n_Lzonedb_java_tzdb$asira$)) {
    $n_Lzonedb_java_tzdb$asira$ = new $c_Lzonedb_java_tzdb$asira$()
  };
  return $n_Lzonedb_java_tzdb$asira$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asird$() {
  this.Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda = null;
  $n_Lzonedb_java_tzdb$asird$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 15712);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 15712);
  var _2 = [[1924123, 0, 15712, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1991272, 7200, 14400, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 18000], [2004305, 7200, 18000, 21600], [2018355, 0, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 15712, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2018355, 0, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asird$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asird$.prototype.constructor = $c_Lzonedb_java_tzdb$asird$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asird$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asird$.prototype = $c_Lzonedb_java_tzdb$asird$.prototype;
var $d_Lzonedb_java_tzdb$asird$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asird$: 0
}, false, "zonedb.java.tzdb$asird$", {
  Lzonedb_java_tzdb$asird$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asird$.prototype.$classData = $d_Lzonedb_java_tzdb$asird$;
var $n_Lzonedb_java_tzdb$asird$;
function $m_Lzonedb_java_tzdb$asird$() {
  if ((!$n_Lzonedb_java_tzdb$asird$)) {
    $n_Lzonedb_java_tzdb$asird$ = new $c_Lzonedb_java_tzdb$asird$()
  };
  return $n_Lzonedb_java_tzdb$asird$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiro$() {
  this.Lzonedb_java_tzdb$asiro$__f_Asia_Hebron = null;
  $n_Lzonedb_java_tzdb$asiro$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8423);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8423);
  var _2 = [[1900274, 0, 8423, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900274, 0, 8423, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967156, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999106, 0, 7200, 10800], [1999288, 0, 10800, 7200], [2000112, 0, 7200, 10800], [2000294, 0, 10800, 7200], [2001110, 0, 7200, 10800], [2001292, 0, 10800, 7200], [2002109, 0, 7200, 10800], [2002291, 0, 10800, 7200], [2003108, 0, 7200, 10800], [2003290, 0, 10800, 7200], [2004107, 0, 7200, 10800], [2004275, 3600, 10800, 7200], [2005105, 0, 7200, 10800], [2005277, 7200, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007091, 0, 7200, 10800], [2007256, 7200, 10800, 7200], [2008088, 0, 7200, 10800], [2008245, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009247, 3600, 10800, 7200], [2010085, 0, 7200, 10800], [2010223, 0, 10800, 7200], [2011091, 60, 7200, 10800], [2011213, 0, 10800, 7200], [2011242, 0, 7200, 10800], [2011273, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012265, 3600, 10800, 7200], [2013088, 0, 7200, 10800], [2013270, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014297, 0, 10800, 7200], [2015087, 0, 7200, 10800], [2015296, 0, 10800, 7200], [2016086, 3600, 7200, 10800], [2016303, 3600, 10800, 7200], [2017084, 3600, 7200, 10800], [2017301, 3600, 10800, 7200], [2018083, 3600, 7200, 10800], [2018300, 3600, 10800, 7200], [2019088, 0, 7200, 10800], [2019299, 3600, 10800, 7200], [2020087, 0, 7200, 10800], [2020305, 3600, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 6, 3600, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiro$__f_Asia_Hebron = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiro$.prototype.constructor = $c_Lzonedb_java_tzdb$asiro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiro$.prototype = $c_Lzonedb_java_tzdb$asiro$.prototype;
var $d_Lzonedb_java_tzdb$asiro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiro$: 0
}, false, "zonedb.java.tzdb$asiro$", {
  Lzonedb_java_tzdb$asiro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiro$.prototype.$classData = $d_Lzonedb_java_tzdb$asiro$;
var $n_Lzonedb_java_tzdb$asiro$;
function $m_Lzonedb_java_tzdb$asiro$() {
  if ((!$n_Lzonedb_java_tzdb$asiro$)) {
    $n_Lzonedb_java_tzdb$asiro$ = new $c_Lzonedb_java_tzdb$asiro$()
  };
  return $n_Lzonedb_java_tzdb$asiro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asirs$() {
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk = null;
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk = null;
  $n_Lzonedb_java_tzdb$asirs$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 19900);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 19900);
  var _2 = [[1919348, 21600, 19900, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [1993142, 82800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016206, 7200, 21600, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919348, 21600, 19900, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993143, 0, 28800, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016206, 7200, 21600, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 22286);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 22286);
  var _2$3 = [[1920006, 0, 22286, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2011086, 7200, 25200, 28800], [2014299, 7200, 28800, 25200]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1920006, 0, 22286, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002300, 10800, 28800, 25200], [2003089, 7200, 25200, 28800], [2003299, 10800, 28800, 25200], [2004088, 7200, 25200, 28800], [2004305, 10800, 28800, 25200], [2005086, 7200, 25200, 28800], [2005303, 10800, 28800, 25200], [2006085, 7200, 25200, 28800], [2006302, 10800, 28800, 25200], [2007084, 7200, 25200, 28800], [2007301, 10800, 28800, 25200], [2008090, 7200, 25200, 28800], [2008300, 10800, 28800, 25200], [2009088, 7200, 25200, 28800], [2009298, 10800, 28800, 25200], [2010087, 7200, 25200, 28800], [2010304, 10800, 28800, 25200], [2011086, 7200, 25200, 28800], [2014299, 7200, 28800, 25200]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asirs$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asirs$.prototype.constructor = $c_Lzonedb_java_tzdb$asirs$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asirs$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asirs$.prototype = $c_Lzonedb_java_tzdb$asirs$.prototype;
var $d_Lzonedb_java_tzdb$asirs$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asirs$: 0
}, false, "zonedb.java.tzdb$asirs$", {
  Lzonedb_java_tzdb$asirs$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asirs$.prototype.$classData = $d_Lzonedb_java_tzdb$asirs$;
var $n_Lzonedb_java_tzdb$asirs$;
function $m_Lzonedb_java_tzdb$asirs$() {
  if ((!$n_Lzonedb_java_tzdb$asirs$)) {
    $n_Lzonedb_java_tzdb$asirs$ = new $c_Lzonedb_java_tzdb$asirs$()
  };
  return $n_Lzonedb_java_tzdb$asirs$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asirt$() {
  this.Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta = null;
  $n_Lzonedb_java_tzdb$asirt$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 25632);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 25632);
  var _2 = [[1923365, 85632, 25632, 26400], [1932306, 0, 26400, 27000], [1942082, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1923365, 85632, 25632, 26400], [1932306, 0, 26400, 27000], [1942082, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asirt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asirt$.prototype.constructor = $c_Lzonedb_java_tzdb$asirt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asirt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asirt$.prototype = $c_Lzonedb_java_tzdb$asirt$.prototype;
var $d_Lzonedb_java_tzdb$asirt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asirt$: 0
}, false, "zonedb.java.tzdb$asirt$", {
  Lzonedb_java_tzdb$asirt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asirt$.prototype.$classData = $d_Lzonedb_java_tzdb$asirt$;
var $n_Lzonedb_java_tzdb$asirt$;
function $m_Lzonedb_java_tzdb$asirt$() {
  if ((!$n_Lzonedb_java_tzdb$asirt$)) {
    $n_Lzonedb_java_tzdb$asirt$ = new $c_Lzonedb_java_tzdb$asirt$()
  };
  return $n_Lzonedb_java_tzdb$asirt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiru$() {
  this.Lzonedb_java_tzdb$asiru$__f_Asia_Beirut = null;
  $n_Lzonedb_java_tzdb$asiru$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8520);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8520);
  var _2 = [[1880001, 0, 8520, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 8520, 7200], [1920088, 0, 7200, 10800], [1920299, 0, 10800, 7200], [1921093, 0, 7200, 10800], [1921276, 0, 10800, 7200], [1922085, 0, 7200, 10800], [1922281, 0, 10800, 7200], [1923112, 0, 7200, 10800], [1923259, 0, 10800, 7200], [1957121, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 0, 7200, 10800], [1959274, 0, 10800, 7200], [1960122, 0, 7200, 10800], [1960275, 0, 10800, 7200], [1961121, 0, 7200, 10800], [1961274, 0, 10800, 7200], [1972174, 0, 7200, 10800], [1972275, 0, 10800, 7200], [1973121, 0, 7200, 10800], [1973274, 0, 10800, 7200], [1974121, 0, 7200, 10800], [1974274, 0, 10800, 7200], [1975121, 0, 7200, 10800], [1975274, 0, 10800, 7200], [1976122, 0, 7200, 10800], [1976275, 0, 10800, 7200], [1977121, 0, 7200, 10800], [1977274, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978273, 0, 10800, 7200], [1984122, 0, 7200, 10800], [1984290, 0, 10800, 7200], [1985121, 0, 7200, 10800], [1985289, 0, 10800, 7200], [1986121, 0, 7200, 10800], [1986289, 0, 10800, 7200], [1987121, 0, 7200, 10800], [1987289, 0, 10800, 7200], [1988153, 0, 7200, 10800], [1988290, 0, 10800, 7200], [1989130, 0, 7200, 10800], [1989289, 0, 10800, 7200], [1990121, 0, 7200, 10800], [1990289, 0, 10800, 7200], [1991121, 0, 7200, 10800], [1991289, 0, 10800, 7200], [1992122, 0, 7200, 10800], [1992278, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998270, 0, 10800, 7200], [1999087, 0, 7200, 10800], [1999304, 0, 10800, 7200], [2000086, 0, 7200, 10800], [2000303, 0, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 0, 0, 1, 7200, 7200, 10800], [10, 25, 7, 0, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiru$__f_Asia_Beirut = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiru$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiru$.prototype.constructor = $c_Lzonedb_java_tzdb$asiru$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiru$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiru$.prototype = $c_Lzonedb_java_tzdb$asiru$.prototype;
var $d_Lzonedb_java_tzdb$asiru$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiru$: 0
}, false, "zonedb.java.tzdb$asiru$", {
  Lzonedb_java_tzdb$asiru$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiru$.prototype.$classData = $d_Lzonedb_java_tzdb$asiru$;
var $n_Lzonedb_java_tzdb$asiru$;
function $m_Lzonedb_java_tzdb$asiru$() {
  if ((!$n_Lzonedb_java_tzdb$asiru$)) {
    $n_Lzonedb_java_tzdb$asiru$ = new $c_Lzonedb_java_tzdb$asiru$()
  };
  return $n_Lzonedb_java_tzdb$asiru$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asisa$() {
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan = null;
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Makassar = null;
  $n_Lzonedb_java_tzdb$asisa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27480);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27480);
  var _2 = [[1905213, 0, 27480, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 32400], [2008091, 0, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1905213, 0, 27480, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 0, 36000, 32400], [1985090, 0, 32400, 36000], [1985272, 0, 36000, 32400], [1986089, 0, 32400, 36000], [1986271, 0, 36000, 32400], [1987088, 0, 32400, 36000], [1987270, 0, 36000, 32400], [1988087, 0, 32400, 36000], [1988269, 0, 36000, 32400], [1989085, 0, 32400, 36000], [1989267, 0, 36000, 32400], [1990084, 0, 32400, 36000], [1990273, 0, 36000, 32400], [1991090, 0, 32400, 36000], [1991272, 0, 36000, 32400], [1992089, 0, 32400, 36000], [1992271, 0, 36000, 32400], [1993087, 0, 32400, 36000], [1993269, 0, 36000, 32400], [1994086, 0, 32400, 36000], [1994268, 0, 36000, 32400], [1995085, 0, 32400, 36000], [1995267, 0, 36000, 32400], [1996091, 0, 32400, 36000], [1996273, 0, 36000, 32400], [1997089, 0, 32400, 36000], [1997271, 0, 36000, 32400], [1998088, 0, 32400, 36000], [1998270, 0, 36000, 32400], [2001118, 7200, 32400, 36000], [2001272, 7200, 36000, 32400], [2002089, 7200, 32400, 36000], [2002271, 7200, 36000, 32400], [2003088, 7200, 32400, 36000], [2003270, 7200, 36000, 32400], [2004087, 7200, 32400, 36000], [2004269, 7200, 36000, 32400], [2005085, 7200, 32400, 36000], [2005267, 7200, 36000, 32400], [2006084, 7200, 32400, 36000], [2006273, 7200, 36000, 32400], [2008091, 0, 32400, 28800], [2015087, 7200, 28800, 32400], [2015269, 0, 32400, 28800], [2016086, 7200, 28800, 32400], [2016268, 0, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 28656);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 28656);
  var _2$3 = [[1932306, 0, 28656, 28800], [1942040, 0, 28800, 32400], [1945266, 0, 32400, 28800]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1932306, 0, 28656, 28800], [1942040, 0, 28800, 32400], [1945266, 0, 32400, 28800]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Makassar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asisa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asisa$.prototype.constructor = $c_Lzonedb_java_tzdb$asisa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asisa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asisa$.prototype = $c_Lzonedb_java_tzdb$asisa$.prototype;
var $d_Lzonedb_java_tzdb$asisa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asisa$: 0
}, false, "zonedb.java.tzdb$asisa$", {
  Lzonedb_java_tzdb$asisa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asisa$.prototype.$classData = $d_Lzonedb_java_tzdb$asisa$;
var $n_Lzonedb_java_tzdb$asisa$;
function $m_Lzonedb_java_tzdb$asisa$() {
  if ((!$n_Lzonedb_java_tzdb$asisa$)) {
    $n_Lzonedb_java_tzdb$asisa$ = new $c_Lzonedb_java_tzdb$asisa$()
  };
  return $n_Lzonedb_java_tzdb$asisa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asisi$() {
  this.Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia = null;
  $n_Lzonedb_java_tzdb$asisi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8008);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8008);
  var _2 = [[1921318, 0, 8008, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921318, 0, 8008, 7200], [1975103, 0, 7200, 10800], [1975285, 0, 10800, 7200], [1976136, 0, 7200, 10800], [1976285, 0, 10800, 7200], [1977093, 0, 7200, 10800], [1977268, 0, 10800, 7200], [1978092, 0, 7200, 10800], [1978275, 0, 10800, 7200], [1979091, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980097, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 0, 7200, 10800], [1981270, 0, 10800, 7200], [1982087, 0, 7200, 10800], [1982269, 0, 10800, 7200], [1983086, 0, 7200, 10800], [1983268, 0, 10800, 7200], [1984085, 0, 7200, 10800], [1984274, 0, 10800, 7200], [1985090, 0, 7200, 10800], [1985272, 0, 10800, 7200], [1986089, 0, 7200, 10800], [1986271, 0, 10800, 7200], [1987088, 0, 7200, 10800], [1987270, 0, 10800, 7200], [1988087, 0, 7200, 10800], [1988269, 0, 10800, 7200], [1989085, 0, 7200, 10800], [1989267, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990273, 0, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asisi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asisi$.prototype.constructor = $c_Lzonedb_java_tzdb$asisi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asisi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asisi$.prototype = $c_Lzonedb_java_tzdb$asisi$.prototype;
var $d_Lzonedb_java_tzdb$asisi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asisi$: 0
}, false, "zonedb.java.tzdb$asisi$", {
  Lzonedb_java_tzdb$asisi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asisi$.prototype.$classData = $d_Lzonedb_java_tzdb$asisi$;
var $n_Lzonedb_java_tzdb$asisi$;
function $m_Lzonedb_java_tzdb$asisi$() {
  if ((!$n_Lzonedb_java_tzdb$asisi$)) {
    $n_Lzonedb_java_tzdb$asisi$ = new $c_Lzonedb_java_tzdb$asisi$()
  };
  return $n_Lzonedb_java_tzdb$asisi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asist$() {
  this.Lzonedb_java_tzdb$asist$__f_Asia_Famagusta = null;
  $n_Lzonedb_java_tzdb$asist$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8148);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8148);
  var _2 = [[1921318, 0, 8148, 7200], [2016251, 82800, 7200, 10800], [2017302, 14400, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921318, 0, 8148, 7200], [1975103, 0, 7200, 10800], [1975285, 0, 10800, 7200], [1976136, 0, 7200, 10800], [1976285, 0, 10800, 7200], [1977093, 0, 7200, 10800], [1977268, 0, 10800, 7200], [1978092, 0, 7200, 10800], [1978275, 0, 10800, 7200], [1979091, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980097, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 0, 7200, 10800], [1981270, 0, 10800, 7200], [1982087, 0, 7200, 10800], [1982269, 0, 10800, 7200], [1983086, 0, 7200, 10800], [1983268, 0, 10800, 7200], [1984085, 0, 7200, 10800], [1984274, 0, 10800, 7200], [1985090, 0, 7200, 10800], [1985272, 0, 10800, 7200], [1986089, 0, 7200, 10800], [1986271, 0, 10800, 7200], [1987088, 0, 7200, 10800], [1987270, 0, 10800, 7200], [1988087, 0, 7200, 10800], [1988269, 0, 10800, 7200], [1989085, 0, 7200, 10800], [1989267, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990273, 0, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2000086, 10800, 7200, 10800], [2000303, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200], [2005086, 10800, 7200, 10800], [2005303, 14400, 10800, 7200], [2006085, 10800, 7200, 10800], [2006302, 14400, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011086, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014089, 10800, 7200, 10800], [2014299, 14400, 10800, 7200], [2015088, 10800, 7200, 10800], [2015298, 14400, 10800, 7200], [2016087, 10800, 7200, 10800], [2017302, 14400, 10800, 7200], [2018084, 10800, 7200, 10800], [2018301, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asist$__f_Asia_Famagusta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asist$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asist$.prototype.constructor = $c_Lzonedb_java_tzdb$asist$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asist$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asist$.prototype = $c_Lzonedb_java_tzdb$asist$.prototype;
var $d_Lzonedb_java_tzdb$asist$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asist$: 0
}, false, "zonedb.java.tzdb$asist$", {
  Lzonedb_java_tzdb$asist$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asist$.prototype.$classData = $d_Lzonedb_java_tzdb$asist$;
var $n_Lzonedb_java_tzdb$asist$;
function $m_Lzonedb_java_tzdb$asist$() {
  if ((!$n_Lzonedb_java_tzdb$asist$)) {
    $n_Lzonedb_java_tzdb$asist$ = new $c_Lzonedb_java_tzdb$asist$()
  };
  return $n_Lzonedb_java_tzdb$asist$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asita$() {
  this.Lzonedb_java_tzdb$asita$__f_Asia_Qatar = null;
  this.Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar = null;
  this.Lzonedb_java_tzdb$asita$__f_Asia_Aqtau = null;
  $n_Lzonedb_java_tzdb$asita$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 12368);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 12368);
  var _2 = [[1920001, 0, 12368, 14400], [1972153, 0, 14400, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920001, 0, 12368, 14400], [1972153, 0, 14400, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asita$__f_Asia_Qatar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 25652);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 25652);
  var _2$3 = [[1905213, 0, 25652, 25200], [1978001, 0, 25200, 28800]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1905213, 0, 25652, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 32400], [1983274, 0, 32400, 28800], [1984092, 0, 28800, 32400], [1984274, 0, 32400, 28800], [1985090, 0, 28800, 32400], [1985272, 0, 32400, 28800], [1986089, 0, 28800, 32400], [1986271, 0, 32400, 28800], [1987088, 0, 28800, 32400], [1987270, 0, 32400, 28800], [1988087, 0, 28800, 32400], [1988269, 0, 32400, 28800], [1989085, 0, 28800, 32400], [1989267, 0, 32400, 28800], [1990084, 0, 28800, 32400], [1990273, 0, 32400, 28800], [1991090, 0, 28800, 32400], [1991272, 0, 32400, 28800], [1992089, 0, 28800, 32400], [1992271, 0, 32400, 28800], [1993087, 0, 28800, 32400], [1993269, 0, 32400, 28800], [1994086, 0, 28800, 32400], [1994268, 0, 32400, 28800], [1995085, 0, 28800, 32400], [1995267, 0, 32400, 28800], [1996091, 0, 28800, 32400], [1996273, 0, 32400, 28800], [1997089, 0, 28800, 32400], [1997271, 0, 32400, 28800], [1998088, 0, 28800, 32400], [1998270, 0, 32400, 28800], [2001118, 7200, 28800, 32400], [2001272, 7200, 32400, 28800], [2002089, 7200, 28800, 32400], [2002271, 7200, 32400, 28800], [2003088, 7200, 28800, 32400], [2003270, 7200, 32400, 28800], [2004087, 7200, 28800, 32400], [2004269, 7200, 32400, 28800], [2005085, 7200, 28800, 32400], [2005267, 7200, 32400, 28800], [2006084, 7200, 28800, 32400], [2006273, 7200, 32400, 28800], [2015087, 7200, 28800, 32400], [2015269, 0, 32400, 28800], [2016086, 7200, 28800, 32400], [2016268, 0, 32400, 28800]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 12064);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 12064);
  var _2$6 = [[1924123, 0, 12064, 14400], [1930172, 0, 14400, 18000], [1981274, 0, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1994268, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1924123, 0, 12064, 14400], [1930172, 0, 14400, 18000], [1981274, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$asita$__f_Asia_Aqtau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$asita$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asita$.prototype.constructor = $c_Lzonedb_java_tzdb$asita$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asita$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asita$.prototype = $c_Lzonedb_java_tzdb$asita$.prototype;
var $d_Lzonedb_java_tzdb$asita$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asita$: 0
}, false, "zonedb.java.tzdb$asita$", {
  Lzonedb_java_tzdb$asita$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asita$.prototype.$classData = $d_Lzonedb_java_tzdb$asita$;
var $n_Lzonedb_java_tzdb$asita$;
function $m_Lzonedb_java_tzdb$asita$() {
  if ((!$n_Lzonedb_java_tzdb$asita$)) {
    $n_Lzonedb_java_tzdb$asita$ = new $c_Lzonedb_java_tzdb$asita$()
  };
  return $n_Lzonedb_java_tzdb$asita$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asitk$() {
  this.Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka = null;
  $n_Lzonedb_java_tzdb$asitk$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 38076);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 38076);
  var _2 = [[1922314, 0, 38076, 39600], [1930172, 0, 39600, 43200], [1991090, 7200, 43200, 39600], [1992019, 7200, 39600, 43200], [2010087, 7200, 43200, 39600], [2011086, 7200, 39600, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922314, 0, 38076, 39600], [1930172, 0, 39600, 43200], [1981091, 0, 43200, 46800], [1981274, 0, 46800, 43200], [1982091, 0, 43200, 46800], [1982274, 0, 46800, 43200], [1983091, 0, 43200, 46800], [1983274, 0, 46800, 43200], [1984092, 0, 43200, 46800], [1984274, 10800, 46800, 43200], [1985090, 7200, 43200, 46800], [1985272, 10800, 46800, 43200], [1986089, 7200, 43200, 46800], [1986271, 10800, 46800, 43200], [1987088, 7200, 43200, 46800], [1987270, 10800, 46800, 43200], [1988087, 7200, 43200, 46800], [1988269, 10800, 46800, 43200], [1989085, 7200, 43200, 46800], [1989267, 10800, 46800, 43200], [1990084, 7200, 43200, 46800], [1990273, 10800, 46800, 43200], [1991272, 10800, 43200, 39600], [1992019, 7200, 39600, 43200], [1992089, 7200, 43200, 46800], [1992271, 10800, 46800, 43200], [1993087, 7200, 43200, 46800], [1993269, 10800, 46800, 43200], [1994086, 7200, 43200, 46800], [1994268, 10800, 46800, 43200], [1995085, 7200, 43200, 46800], [1995267, 10800, 46800, 43200], [1996091, 7200, 43200, 46800], [1996301, 10800, 46800, 43200], [1997089, 7200, 43200, 46800], [1997299, 10800, 46800, 43200], [1998088, 7200, 43200, 46800], [1998298, 10800, 46800, 43200], [1999087, 7200, 43200, 46800], [1999304, 10800, 46800, 43200], [2000086, 7200, 43200, 46800], [2000303, 10800, 46800, 43200], [2001084, 7200, 43200, 46800], [2001301, 10800, 46800, 43200], [2002090, 7200, 43200, 46800], [2002300, 10800, 46800, 43200], [2003089, 7200, 43200, 46800], [2003299, 10800, 46800, 43200], [2004088, 7200, 43200, 46800], [2004305, 10800, 46800, 43200], [2005086, 7200, 43200, 46800], [2005303, 10800, 46800, 43200], [2006085, 7200, 43200, 46800], [2006302, 10800, 46800, 43200], [2007084, 7200, 43200, 46800], [2007301, 10800, 46800, 43200], [2008090, 7200, 43200, 46800], [2008300, 10800, 46800, 43200], [2009088, 7200, 43200, 46800], [2009298, 10800, 46800, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asitk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asitk$.prototype.constructor = $c_Lzonedb_java_tzdb$asitk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asitk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asitk$.prototype = $c_Lzonedb_java_tzdb$asitk$.prototype;
var $d_Lzonedb_java_tzdb$asitk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asitk$: 0
}, false, "zonedb.java.tzdb$asitk$", {
  Lzonedb_java_tzdb$asitk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asitk$.prototype.$classData = $d_Lzonedb_java_tzdb$asitk$;
var $n_Lzonedb_java_tzdb$asitk$;
function $m_Lzonedb_java_tzdb$asitk$() {
  if ((!$n_Lzonedb_java_tzdb$asitk$)) {
    $n_Lzonedb_java_tzdb$asitk$ = new $c_Lzonedb_java_tzdb$asitk$()
  };
  return $n_Lzonedb_java_tzdb$asitk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asito$() {
  this.Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok = null;
  $n_Lzonedb_java_tzdb$asito$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 31651);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 31651);
  var _2 = [[1922319, 0, 31651, 32400], [1930172, 0, 32400, 36000], [1991090, 7200, 36000, 32400], [1992019, 7200, 32400, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922319, 0, 31651, 32400], [1930172, 0, 32400, 36000], [1981091, 0, 36000, 39600], [1981274, 0, 39600, 36000], [1982091, 0, 36000, 39600], [1982274, 0, 39600, 36000], [1983091, 0, 36000, 39600], [1983274, 0, 39600, 36000], [1984092, 0, 36000, 39600], [1984274, 10800, 39600, 36000], [1985090, 7200, 36000, 39600], [1985272, 10800, 39600, 36000], [1986089, 7200, 36000, 39600], [1986271, 10800, 39600, 36000], [1987088, 7200, 36000, 39600], [1987270, 10800, 39600, 36000], [1988087, 7200, 36000, 39600], [1988269, 10800, 39600, 36000], [1989085, 7200, 36000, 39600], [1989267, 10800, 39600, 36000], [1990084, 7200, 36000, 39600], [1990273, 10800, 39600, 36000], [1991272, 10800, 36000, 32400], [1992019, 7200, 32400, 36000], [1992089, 7200, 36000, 39600], [1992271, 10800, 39600, 36000], [1993087, 7200, 36000, 39600], [1993269, 10800, 39600, 36000], [1994086, 7200, 36000, 39600], [1994268, 10800, 39600, 36000], [1995085, 7200, 36000, 39600], [1995267, 10800, 39600, 36000], [1996091, 7200, 36000, 39600], [1996301, 10800, 39600, 36000], [1997089, 7200, 36000, 39600], [1997299, 10800, 39600, 36000], [1998088, 7200, 36000, 39600], [1998298, 10800, 39600, 36000], [1999087, 7200, 36000, 39600], [1999304, 10800, 39600, 36000], [2000086, 7200, 36000, 39600], [2000303, 10800, 39600, 36000], [2001084, 7200, 36000, 39600], [2001301, 10800, 39600, 36000], [2002090, 7200, 36000, 39600], [2002300, 10800, 39600, 36000], [2003089, 7200, 36000, 39600], [2003299, 10800, 39600, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asito$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asito$.prototype.constructor = $c_Lzonedb_java_tzdb$asito$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asito$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asito$.prototype = $c_Lzonedb_java_tzdb$asito$.prototype;
var $d_Lzonedb_java_tzdb$asito$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asito$: 0
}, false, "zonedb.java.tzdb$asito$", {
  Lzonedb_java_tzdb$asito$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asito$.prototype.$classData = $d_Lzonedb_java_tzdb$asito$;
var $n_Lzonedb_java_tzdb$asito$;
function $m_Lzonedb_java_tzdb$asito$() {
  if ((!$n_Lzonedb_java_tzdb$asito$)) {
    $n_Lzonedb_java_tzdb$asito$ = new $c_Lzonedb_java_tzdb$asito$()
  };
  return $n_Lzonedb_java_tzdb$asito$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asits$() {
  this.Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk = null;
  this.Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk = null;
  this.Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk = null;
  $n_Lzonedb_java_tzdb$asits$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 25025);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 25025);
  var _2 = [[1920025, 0, 25025, 25200], [1930172, 0, 25200, 28800], [1991090, 7200, 28800, 25200], [1992019, 7200, 25200, 28800], [2011086, 7200, 28800, 32400], [2014299, 7200, 32400, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1920025, 0, 25025, 25200], [1930172, 0, 25200, 28800], [1981091, 0, 28800, 32400], [1981274, 0, 32400, 28800], [1982091, 0, 28800, 32400], [1982274, 0, 32400, 28800], [1983091, 0, 28800, 32400], [1983274, 0, 32400, 28800], [1984092, 0, 28800, 32400], [1984274, 10800, 32400, 28800], [1985090, 7200, 28800, 32400], [1985272, 10800, 32400, 28800], [1986089, 7200, 28800, 32400], [1986271, 10800, 32400, 28800], [1987088, 7200, 28800, 32400], [1987270, 10800, 32400, 28800], [1988087, 7200, 28800, 32400], [1988269, 10800, 32400, 28800], [1989085, 7200, 28800, 32400], [1989267, 10800, 32400, 28800], [1990084, 7200, 28800, 32400], [1990273, 10800, 32400, 28800], [1991272, 10800, 28800, 25200], [1992019, 7200, 25200, 28800], [1992089, 7200, 28800, 32400], [1992271, 10800, 32400, 28800], [1993087, 7200, 28800, 32400], [1993269, 10800, 32400, 28800], [1994086, 7200, 28800, 32400], [1994268, 10800, 32400, 28800], [1995085, 7200, 28800, 32400], [1995267, 10800, 32400, 28800], [1996091, 7200, 28800, 32400], [1996301, 10800, 32400, 28800], [1997089, 7200, 28800, 32400], [1997299, 10800, 32400, 28800], [1998088, 7200, 28800, 32400], [1998298, 10800, 32400, 28800], [1999087, 7200, 28800, 32400], [1999304, 10800, 32400, 28800], [2000086, 7200, 28800, 32400], [2000303, 10800, 32400, 28800], [2001084, 7200, 28800, 32400], [2001301, 10800, 32400, 28800], [2002090, 7200, 28800, 32400], [2002300, 10800, 32400, 28800], [2003089, 7200, 28800, 32400], [2003299, 10800, 32400, 28800], [2004088, 7200, 28800, 32400], [2004305, 10800, 32400, 28800], [2005086, 7200, 28800, 32400], [2005303, 10800, 32400, 28800], [2006085, 7200, 28800, 32400], [2006302, 10800, 32400, 28800], [2007084, 7200, 28800, 32400], [2007301, 10800, 32400, 28800], [2008090, 7200, 28800, 32400], [2008300, 10800, 32400, 28800], [2009088, 7200, 28800, 32400], [2009298, 10800, 32400, 28800], [2010087, 7200, 28800, 32400], [2010304, 10800, 32400, 28800], [2011086, 7200, 28800, 32400], [2014299, 7200, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 20928);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 20928);
  var _2$3 = [[1924122, 0, 20928, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2010087, 7200, 25200, 21600], [2011086, 7200, 21600, 25200]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1924122, 0, 20928, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002300, 10800, 28800, 25200], [2003089, 7200, 25200, 28800], [2003299, 10800, 28800, 25200], [2004088, 7200, 25200, 28800], [2004305, 10800, 28800, 25200], [2005086, 7200, 25200, 28800], [2005303, 10800, 28800, 25200], [2006085, 7200, 25200, 28800], [2006302, 10800, 28800, 25200], [2007084, 7200, 25200, 28800], [2007301, 10800, 28800, 25200], [2008090, 7200, 25200, 28800], [2008300, 10800, 28800, 25200], [2009088, 7200, 25200, 28800], [2009298, 10800, 28800, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 31138);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 31138);
  var _2$6 = [[1919349, 0, 31138, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 32400]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1919349, 0, 31138, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004088, 7200, 32400, 36000], [2004305, 10800, 36000, 32400], [2005086, 7200, 32400, 36000], [2005303, 10800, 36000, 32400], [2006085, 7200, 32400, 36000], [2006302, 10800, 36000, 32400], [2007084, 7200, 32400, 36000], [2007301, 10800, 36000, 32400], [2008090, 7200, 32400, 36000], [2008300, 10800, 36000, 32400], [2009088, 7200, 32400, 36000], [2009298, 10800, 36000, 32400], [2010087, 7200, 32400, 36000], [2010304, 10800, 36000, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 32400]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$asits$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asits$.prototype.constructor = $c_Lzonedb_java_tzdb$asits$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asits$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asits$.prototype = $c_Lzonedb_java_tzdb$asits$.prototype;
var $d_Lzonedb_java_tzdb$asits$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asits$: 0
}, false, "zonedb.java.tzdb$asits$", {
  Lzonedb_java_tzdb$asits$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asits$.prototype.$classData = $d_Lzonedb_java_tzdb$asits$;
var $n_Lzonedb_java_tzdb$asits$;
function $m_Lzonedb_java_tzdb$asits$() {
  if ((!$n_Lzonedb_java_tzdb$asits$)) {
    $n_Lzonedb_java_tzdb$asits$ = new $c_Lzonedb_java_tzdb$asits$()
  };
  return $n_Lzonedb_java_tzdb$asits$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiur$() {
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg = null;
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura = null;
  $n_Lzonedb_java_tzdb$asiur$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 14553);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 14553);
  var _2 = [[1916185, 0, 14553, 13505], [1919196, 14400, 13505, 14400], [1930172, 0, 14400, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [2011086, 7200, 18000, 21600], [2014299, 7200, 21600, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916185, 0, 14553, 13505], [1919196, 14400, 13505, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1981274, 0, 21600, 18000], [1982091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2004305, 10800, 21600, 18000], [2005086, 7200, 18000, 21600], [2005303, 10800, 21600, 18000], [2006085, 7200, 18000, 21600], [2006302, 10800, 21600, 18000], [2007084, 7200, 18000, 21600], [2007301, 10800, 21600, 18000], [2008090, 7200, 18000, 21600], [2008300, 10800, 21600, 18000], [2009088, 7200, 18000, 21600], [2009298, 10800, 21600, 18000], [2010087, 7200, 18000, 21600], [2010304, 10800, 21600, 18000], [2011086, 7200, 18000, 21600], [2014299, 7200, 21600, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 33768);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 33768);
  var _2$3 = [[1932306, 0, 33768, 32400], [1944245, 0, 32400, 34200], [1964001, 0, 34200, 32400]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1932306, 0, 33768, 32400], [1944245, 0, 32400, 34200], [1964001, 0, 34200, 32400]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$asiur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiur$.prototype.constructor = $c_Lzonedb_java_tzdb$asiur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiur$.prototype = $c_Lzonedb_java_tzdb$asiur$.prototype;
var $d_Lzonedb_java_tzdb$asiur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiur$: 0
}, false, "zonedb.java.tzdb$asiur$", {
  Lzonedb_java_tzdb$asiur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiur$.prototype.$classData = $d_Lzonedb_java_tzdb$asiur$;
var $n_Lzonedb_java_tzdb$asiur$;
function $m_Lzonedb_java_tzdb$asiur$() {
  if ((!$n_Lzonedb_java_tzdb$asiur$)) {
    $n_Lzonedb_java_tzdb$asiur$ = new $c_Lzonedb_java_tzdb$asiur$()
  };
  return $n_Lzonedb_java_tzdb$asiur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiva$() {
  this.Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan = null;
  $n_Lzonedb_java_tzdb$asiva$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 10680);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 10680);
  var _2 = [[1924123, 0, 10680, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1995267, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 10680, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000], [2004305, 10800, 18000, 14400], [2005086, 7200, 14400, 18000], [2005303, 10800, 18000, 14400], [2006085, 7200, 14400, 18000], [2006302, 10800, 18000, 14400], [2007084, 7200, 14400, 18000], [2007301, 10800, 18000, 14400], [2008090, 7200, 14400, 18000], [2008300, 10800, 18000, 14400], [2009088, 7200, 14400, 18000], [2009298, 10800, 18000, 14400], [2010087, 7200, 14400, 18000], [2010304, 10800, 18000, 14400], [2011086, 7200, 14400, 18000], [2011303, 10800, 18000, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiva$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiva$.prototype.constructor = $c_Lzonedb_java_tzdb$asiva$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiva$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiva$.prototype = $c_Lzonedb_java_tzdb$asiva$.prototype;
var $d_Lzonedb_java_tzdb$asiva$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiva$: 0
}, false, "zonedb.java.tzdb$asiva$", {
  Lzonedb_java_tzdb$asiva$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiva$.prototype.$classData = $d_Lzonedb_java_tzdb$asiva$;
var $n_Lzonedb_java_tzdb$asiva$;
function $m_Lzonedb_java_tzdb$asiva$() {
  if ((!$n_Lzonedb_java_tzdb$asiva$)) {
    $n_Lzonedb_java_tzdb$asiva$ = new $c_Lzonedb_java_tzdb$asiva$()
  };
  return $n_Lzonedb_java_tzdb$asiva$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiyg$() {
  this.Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga = null;
  $n_Lzonedb_java_tzdb$asiyg$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 32533);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 32533);
  var _2 = [[1919349, 0, 32533, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2004001, 0, 32400, 36000], [2011086, 7200, 36000, 39600], [2011256, 0, 39600, 36000], [2014299, 7200, 36000, 32400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919349, 0, 32533, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004001, 0, 32400, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2011256, 0, 39600, 36000], [2014299, 7200, 36000, 32400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$asiyg$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiyg$.prototype.constructor = $c_Lzonedb_java_tzdb$asiyg$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiyg$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiyg$.prototype = $c_Lzonedb_java_tzdb$asiyg$.prototype;
var $d_Lzonedb_java_tzdb$asiyg$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiyg$: 0
}, false, "zonedb.java.tzdb$asiyg$", {
  Lzonedb_java_tzdb$asiyg$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiyg$.prototype.$classData = $d_Lzonedb_java_tzdb$asiyg$;
var $n_Lzonedb_java_tzdb$asiyg$;
function $m_Lzonedb_java_tzdb$asiyg$() {
  if ((!$n_Lzonedb_java_tzdb$asiyg$)) {
    $n_Lzonedb_java_tzdb$asiyg$ = new $c_Lzonedb_java_tzdb$asiyg$()
  };
  return $n_Lzonedb_java_tzdb$asiyg$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlar$() {
  this.Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary = null;
  $n_Lzonedb_java_tzdb$atlar$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-3696));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-3696));
  var _2 = [[1922060, 0, (-3696), (-3600)], [1946273, 3600, (-3600), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1922060, 0, (-3696), (-3600)], [1946273, 3600, (-3600), 0], [1980097, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlar$.prototype.constructor = $c_Lzonedb_java_tzdb$atlar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlar$.prototype = $c_Lzonedb_java_tzdb$atlar$.prototype;
var $d_Lzonedb_java_tzdb$atlar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlar$: 0
}, false, "zonedb.java.tzdb$atlar$", {
  Lzonedb_java_tzdb$atlar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlar$.prototype.$classData = $d_Lzonedb_java_tzdb$atlar$;
var $n_Lzonedb_java_tzdb$atlar$;
function $m_Lzonedb_java_tzdb$atlar$() {
  if ((!$n_Lzonedb_java_tzdb$atlar$)) {
    $n_Lzonedb_java_tzdb$atlar$ = new $c_Lzonedb_java_tzdb$atlar$()
  };
  return $n_Lzonedb_java_tzdb$atlar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlgi$() {
  this.Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia = null;
  $n_Lzonedb_java_tzdb$atlgi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-8768));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-8768));
  var _2 = [[1890001, 0, (-8768), (-7200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890001, 0, (-8768), (-7200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlgi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlgi$.prototype.constructor = $c_Lzonedb_java_tzdb$atlgi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlgi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlgi$.prototype = $c_Lzonedb_java_tzdb$atlgi$.prototype;
var $d_Lzonedb_java_tzdb$atlgi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlgi$: 0
}, false, "zonedb.java.tzdb$atlgi$", {
  Lzonedb_java_tzdb$atlgi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlgi$.prototype.$classData = $d_Lzonedb_java_tzdb$atlgi$;
var $n_Lzonedb_java_tzdb$atlgi$;
function $m_Lzonedb_java_tzdb$atlgi$() {
  if ((!$n_Lzonedb_java_tzdb$atlgi$)) {
    $n_Lzonedb_java_tzdb$atlgi$ = new $c_Lzonedb_java_tzdb$atlgi$()
  };
  return $n_Lzonedb_java_tzdb$atlgi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlir$() {
  this.Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira = null;
  $n_Lzonedb_java_tzdb$atlir$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-4056));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-4056));
  var _2 = [[1911365, 85944, (-4056), (-3600)], [1966093, 7200, (-3600), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911365, 85944, (-4056), (-3600)], [1916169, 82800, (-3600), 0], [1916306, 3600, 0, (-3600)], [1917059, 82800, (-3600), 0], [1917288, 0, 0, (-3600)], [1918060, 82800, (-3600), 0], [1918288, 0, 0, (-3600)], [1919059, 82800, (-3600), 0], [1919288, 0, 0, (-3600)], [1920060, 82800, (-3600), 0], [1920289, 0, 0, (-3600)], [1921059, 82800, (-3600), 0], [1921288, 0, 0, (-3600)], [1924107, 82800, (-3600), 0], [1924289, 0, 0, (-3600)], [1926107, 82800, (-3600), 0], [1926276, 0, 0, (-3600)], [1927099, 82800, (-3600), 0], [1927275, 0, 0, (-3600)], [1928105, 82800, (-3600), 0], [1928281, 0, 0, (-3600)], [1929110, 82800, (-3600), 0], [1929279, 0, 0, (-3600)], [1931108, 82800, (-3600), 0], [1931277, 0, 0, (-3600)], [1932093, 82800, (-3600), 0], [1932276, 0, 0, (-3600)], [1934097, 82800, (-3600), 0], [1934280, 0, 0, (-3600)], [1935089, 82800, (-3600), 0], [1935279, 0, 0, (-3600)], [1936109, 82800, (-3600), 0], [1936278, 0, 0, (-3600)], [1937093, 82800, (-3600), 0], [1937276, 0, 0, (-3600)], [1938085, 82800, (-3600), 0], [1938275, 0, 0, (-3600)], [1939105, 82800, (-3600), 0], [1939323, 0, 0, (-3600)], [1940055, 82800, (-3600), 0], [1940280, 0, 0, (-3600)], [1941095, 82800, (-3600), 0], [1941279, 0, 0, (-3600)], [1942073, 82800, (-3600), 0], [1942115, 82800, 0, 3600], [1942228, 0, 3600, 0], [1942298, 0, 0, (-3600)], [1943072, 82800, (-3600), 0], [1943107, 82800, 0, 3600], [1943241, 0, 3600, 0], [1943304, 0, 0, (-3600)], [1944071, 82800, (-3600), 0], [1944113, 82800, 0, 3600], [1944240, 0, 3600, 0], [1944303, 0, 0, (-3600)], [1945069, 82800, (-3600), 0], [1945111, 82800, 0, 3600], [1945238, 0, 3600, 0], [1945301, 0, 0, (-3600)], [1946096, 82800, (-3600), 0], [1946279, 0, 0, (-3600)], [1947096, 7200, (-3600), 0], [1947278, 10800, 0, (-3600)], [1948095, 7200, (-3600), 0], [1948277, 10800, 0, (-3600)], [1949093, 7200, (-3600), 0], [1949275, 10800, 0, (-3600)], [1951091, 7200, (-3600), 0], [1951280, 10800, 0, (-3600)], [1952097, 7200, (-3600), 0], [1952279, 10800, 0, (-3600)], [1953095, 7200, (-3600), 0], [1953277, 10800, 0, (-3600)], [1954094, 7200, (-3600), 0], [1954276, 10800, 0, (-3600)], [1955093, 7200, (-3600), 0], [1955275, 10800, 0, (-3600)], [1956092, 7200, (-3600), 0], [1956281, 10800, 0, (-3600)], [1957097, 7200, (-3600), 0], [1957279, 10800, 0, (-3600)], [1958096, 7200, (-3600), 0], [1958278, 10800, 0, (-3600)], [1959095, 7200, (-3600), 0], [1959277, 10800, 0, (-3600)], [1960094, 7200, (-3600), 0], [1960276, 10800, 0, (-3600)], [1961092, 7200, (-3600), 0], [1961274, 10800, 0, (-3600)], [1962091, 7200, (-3600), 0], [1962280, 10800, 0, (-3600)], [1963097, 7200, (-3600), 0], [1963279, 10800, 0, (-3600)], [1964096, 7200, (-3600), 0], [1964278, 10800, 0, (-3600)], [1965094, 7200, (-3600), 0], [1965276, 10800, 0, (-3600)], [1966093, 7200, (-3600), 0], [1977086, 0, 0, 3600], [1977268, 3600, 3600, 0], [1978092, 0, 0, 3600], [1978274, 3600, 3600, 0], [1979091, 0, 0, 3600], [1979273, 7200, 3600, 0], [1980090, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 7200, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlir$.prototype.constructor = $c_Lzonedb_java_tzdb$atlir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlir$.prototype = $c_Lzonedb_java_tzdb$atlir$.prototype;
var $d_Lzonedb_java_tzdb$atlir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlir$: 0
}, false, "zonedb.java.tzdb$atlir$", {
  Lzonedb_java_tzdb$atlir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlir$.prototype.$classData = $d_Lzonedb_java_tzdb$atlir$;
var $n_Lzonedb_java_tzdb$atlir$;
function $m_Lzonedb_java_tzdb$atlir$() {
  if ((!$n_Lzonedb_java_tzdb$atlir$)) {
    $n_Lzonedb_java_tzdb$atlir$ = new $c_Lzonedb_java_tzdb$atlir$()
  };
  return $n_Lzonedb_java_tzdb$atlir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlle$() {
  this.Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley = null;
  $n_Lzonedb_java_tzdb$atlle$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-13884));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-13884));
  var _2 = [[1912072, 0, (-13884), (-14400)], [1983121, 0, (-14400), (-10800)], [1985258, 0, (-10800), (-14400)], [2010248, 7200, (-14400), (-10800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912072, 0, (-13884), (-14400)], [1937269, 0, (-14400), (-10800)], [1938079, 0, (-10800), (-14400)], [1938268, 0, (-14400), (-10800)], [1939078, 0, (-10800), (-14400)], [1939274, 0, (-14400), (-10800)], [1940084, 0, (-10800), (-14400)], [1940273, 0, (-14400), (-10800)], [1941082, 0, (-10800), (-14400)], [1941271, 0, (-14400), (-10800)], [1942081, 0, (-10800), (-14400)], [1942270, 0, (-14400), (-10800)], [1943001, 0, (-10800), (-14400)], [1983121, 0, (-14400), (-10800)], [1983268, 0, (-10800), (-7200)], [1984120, 0, (-7200), (-10800)], [1984260, 0, (-10800), (-7200)], [1985118, 0, (-7200), (-10800)], [1986110, 0, (-10800), (-14400)], [1986257, 0, (-14400), (-10800)], [1987109, 0, (-10800), (-14400)], [1987256, 0, (-14400), (-10800)], [1988108, 0, (-10800), (-14400)], [1988255, 0, (-14400), (-10800)], [1989106, 0, (-10800), (-14400)], [1989253, 0, (-14400), (-10800)], [1990112, 0, (-10800), (-14400)], [1990252, 0, (-14400), (-10800)], [1991111, 0, (-10800), (-14400)], [1991258, 0, (-14400), (-10800)], [1992110, 0, (-10800), (-14400)], [1992257, 0, (-14400), (-10800)], [1993108, 0, (-10800), (-14400)], [1993255, 0, (-14400), (-10800)], [1994107, 0, (-10800), (-14400)], [1994254, 0, (-14400), (-10800)], [1995106, 0, (-10800), (-14400)], [1995253, 0, (-14400), (-10800)], [1996112, 0, (-10800), (-14400)], [1996259, 0, (-14400), (-10800)], [1997110, 0, (-10800), (-14400)], [1997257, 0, (-14400), (-10800)], [1998109, 0, (-10800), (-14400)], [1998256, 0, (-14400), (-10800)], [1999108, 0, (-10800), (-14400)], [1999255, 0, (-14400), (-10800)], [2000107, 0, (-10800), (-14400)], [2000254, 0, (-14400), (-10800)], [2001105, 7200, (-10800), (-14400)], [2001245, 7200, (-14400), (-10800)], [2002111, 7200, (-10800), (-14400)], [2002244, 7200, (-14400), (-10800)], [2003110, 7200, (-10800), (-14400)], [2003250, 7200, (-14400), (-10800)], [2004109, 7200, (-10800), (-14400)], [2004249, 7200, (-14400), (-10800)], [2005107, 7200, (-10800), (-14400)], [2005247, 7200, (-14400), (-10800)], [2006106, 7200, (-10800), (-14400)], [2006246, 7200, (-14400), (-10800)], [2007105, 7200, (-10800), (-14400)], [2007245, 7200, (-14400), (-10800)], [2008111, 7200, (-10800), (-14400)], [2008251, 7200, (-14400), (-10800)], [2009109, 7200, (-10800), (-14400)], [2009249, 7200, (-14400), (-10800)], [2010108, 7200, (-10800), (-14400)], [2010248, 7200, (-14400), (-10800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlle$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlle$.prototype.constructor = $c_Lzonedb_java_tzdb$atlle$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlle$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlle$.prototype = $c_Lzonedb_java_tzdb$atlle$.prototype;
var $d_Lzonedb_java_tzdb$atlle$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlle$: 0
}, false, "zonedb.java.tzdb$atlle$", {
  Lzonedb_java_tzdb$atlle$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlle$.prototype.$classData = $d_Lzonedb_java_tzdb$atlle$;
var $n_Lzonedb_java_tzdb$atlle$;
function $m_Lzonedb_java_tzdb$atlle$() {
  if ((!$n_Lzonedb_java_tzdb$atlle$)) {
    $n_Lzonedb_java_tzdb$atlle$ = new $c_Lzonedb_java_tzdb$atlle$()
  };
  return $n_Lzonedb_java_tzdb$atlle$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlrd$() {
  this.Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde = null;
  $n_Lzonedb_java_tzdb$atlrd$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-5644));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-5644));
  var _2 = [[1912001, 1556, (-5644), (-7200)], [1975329, 7200, (-7200), (-3600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912001, 1556, (-5644), (-7200)], [1942244, 0, (-7200), (-3600)], [1945288, 0, (-3600), (-7200)], [1975329, 7200, (-7200), (-3600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlrd$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlrd$.prototype.constructor = $c_Lzonedb_java_tzdb$atlrd$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlrd$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlrd$.prototype = $c_Lzonedb_java_tzdb$atlrd$.prototype;
var $d_Lzonedb_java_tzdb$atlrd$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlrd$: 0
}, false, "zonedb.java.tzdb$atlrd$", {
  Lzonedb_java_tzdb$atlrd$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlrd$.prototype.$classData = $d_Lzonedb_java_tzdb$atlrd$;
var $n_Lzonedb_java_tzdb$atlrd$;
function $m_Lzonedb_java_tzdb$atlrd$() {
  if ((!$n_Lzonedb_java_tzdb$atlrd$)) {
    $n_Lzonedb_java_tzdb$atlrd$ = new $c_Lzonedb_java_tzdb$atlrd$()
  };
  return $n_Lzonedb_java_tzdb$atlrd$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlre$() {
  this.Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores = null;
  $n_Lzonedb_java_tzdb$atlre$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-6160));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-6160));
  var _2 = [[1884001, 0, (-6160), (-6872)], [1912001, 328, (-6872), (-7200)], [1966093, 7200, (-7200), (-3600)], [1992271, 3600, (-3600), 0], [1993087, 3600, 0, (-3600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, (-6160), (-6872)], [1912001, 328, (-6872), (-7200)], [1916169, 82800, (-7200), (-3600)], [1916306, 3600, (-3600), (-7200)], [1917059, 82800, (-7200), (-3600)], [1917288, 0, (-3600), (-7200)], [1918060, 82800, (-7200), (-3600)], [1918288, 0, (-3600), (-7200)], [1919059, 82800, (-7200), (-3600)], [1919288, 0, (-3600), (-7200)], [1920060, 82800, (-7200), (-3600)], [1920289, 0, (-3600), (-7200)], [1921059, 82800, (-7200), (-3600)], [1921288, 0, (-3600), (-7200)], [1924107, 82800, (-7200), (-3600)], [1924289, 0, (-3600), (-7200)], [1926107, 82800, (-7200), (-3600)], [1926276, 0, (-3600), (-7200)], [1927099, 82800, (-7200), (-3600)], [1927275, 0, (-3600), (-7200)], [1928105, 82800, (-7200), (-3600)], [1928281, 0, (-3600), (-7200)], [1929110, 82800, (-7200), (-3600)], [1929279, 0, (-3600), (-7200)], [1931108, 82800, (-7200), (-3600)], [1931277, 0, (-3600), (-7200)], [1932093, 82800, (-7200), (-3600)], [1932276, 0, (-3600), (-7200)], [1934097, 82800, (-7200), (-3600)], [1934280, 0, (-3600), (-7200)], [1935089, 82800, (-7200), (-3600)], [1935279, 0, (-3600), (-7200)], [1936109, 82800, (-7200), (-3600)], [1936278, 0, (-3600), (-7200)], [1937093, 82800, (-7200), (-3600)], [1937276, 0, (-3600), (-7200)], [1938085, 82800, (-7200), (-3600)], [1938275, 0, (-3600), (-7200)], [1939105, 82800, (-7200), (-3600)], [1939323, 0, (-3600), (-7200)], [1940055, 82800, (-7200), (-3600)], [1940280, 0, (-3600), (-7200)], [1941095, 82800, (-7200), (-3600)], [1941279, 0, (-3600), (-7200)], [1942073, 82800, (-7200), (-3600)], [1942115, 82800, (-3600), 0], [1942228, 0, 0, (-3600)], [1942298, 0, (-3600), (-7200)], [1943072, 82800, (-7200), (-3600)], [1943107, 82800, (-3600), 0], [1943241, 0, 0, (-3600)], [1943304, 0, (-3600), (-7200)], [1944071, 82800, (-7200), (-3600)], [1944113, 82800, (-3600), 0], [1944240, 0, 0, (-3600)], [1944303, 0, (-3600), (-7200)], [1945069, 82800, (-7200), (-3600)], [1945111, 82800, (-3600), 0], [1945238, 0, 0, (-3600)], [1945301, 0, (-3600), (-7200)], [1946096, 82800, (-7200), (-3600)], [1946279, 0, (-3600), (-7200)], [1947096, 7200, (-7200), (-3600)], [1947278, 10800, (-3600), (-7200)], [1948095, 7200, (-7200), (-3600)], [1948277, 10800, (-3600), (-7200)], [1949093, 7200, (-7200), (-3600)], [1949275, 10800, (-3600), (-7200)], [1951091, 7200, (-7200), (-3600)], [1951280, 10800, (-3600), (-7200)], [1952097, 7200, (-7200), (-3600)], [1952279, 10800, (-3600), (-7200)], [1953095, 7200, (-7200), (-3600)], [1953277, 10800, (-3600), (-7200)], [1954094, 7200, (-7200), (-3600)], [1954276, 10800, (-3600), (-7200)], [1955093, 7200, (-7200), (-3600)], [1955275, 10800, (-3600), (-7200)], [1956092, 7200, (-7200), (-3600)], [1956281, 10800, (-3600), (-7200)], [1957097, 7200, (-7200), (-3600)], [1957279, 10800, (-3600), (-7200)], [1958096, 7200, (-7200), (-3600)], [1958278, 10800, (-3600), (-7200)], [1959095, 7200, (-7200), (-3600)], [1959277, 10800, (-3600), (-7200)], [1960094, 7200, (-7200), (-3600)], [1960276, 10800, (-3600), (-7200)], [1961092, 7200, (-7200), (-3600)], [1961274, 10800, (-3600), (-7200)], [1962091, 7200, (-7200), (-3600)], [1962280, 10800, (-3600), (-7200)], [1963097, 7200, (-7200), (-3600)], [1963279, 10800, (-3600), (-7200)], [1964096, 7200, (-7200), (-3600)], [1964278, 10800, (-3600), (-7200)], [1965094, 7200, (-7200), (-3600)], [1965276, 10800, (-3600), (-7200)], [1966093, 7200, (-7200), (-3600)], [1977086, 0, (-3600), 0], [1977268, 3600, 0, (-3600)], [1978092, 0, (-3600), 0], [1978274, 3600, 0, (-3600)], [1979091, 0, (-3600), 0], [1979273, 7200, 0, (-3600)], [1980090, 0, (-3600), 0], [1980272, 7200, 0, (-3600)], [1981088, 3600, (-3600), 0], [1981270, 7200, 0, (-3600)], [1982087, 3600, (-3600), 0], [1982269, 7200, 0, (-3600)], [1983086, 7200, (-3600), 0], [1983268, 7200, 0, (-3600)], [1984085, 3600, (-3600), 0], [1984274, 7200, 0, (-3600)], [1985090, 3600, (-3600), 0], [1985272, 7200, 0, (-3600)], [1986089, 3600, (-3600), 0], [1986271, 7200, 0, (-3600)], [1987088, 3600, (-3600), 0], [1987270, 7200, 0, (-3600)], [1988087, 3600, (-3600), 0], [1988269, 7200, 0, (-3600)], [1989085, 3600, (-3600), 0], [1989267, 7200, 0, (-3600)], [1990084, 3600, (-3600), 0], [1990273, 7200, 0, (-3600)], [1991090, 3600, (-3600), 0], [1991272, 7200, 0, (-3600)], [1992089, 3600, (-3600), 0], [1993269, 3600, 0, (-3600)], [1994086, 0, (-3600), 0], [1994268, 3600, 0, (-3600)], [1995085, 0, (-3600), 0], [1995267, 3600, 0, (-3600)], [1996091, 0, (-3600), 0], [1996301, 3600, 0, (-3600)], [1997089, 0, (-3600), 0], [1997299, 3600, 0, (-3600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, (-3600), (-3600), 0], [10, 25, 7, 3600, 0, 0, (-3600), 0, (-3600)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlre$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlre$.prototype.constructor = $c_Lzonedb_java_tzdb$atlre$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlre$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlre$.prototype = $c_Lzonedb_java_tzdb$atlre$.prototype;
var $d_Lzonedb_java_tzdb$atlre$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlre$: 0
}, false, "zonedb.java.tzdb$atlre$", {
  Lzonedb_java_tzdb$atlre$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlre$.prototype.$classData = $d_Lzonedb_java_tzdb$atlre$;
var $n_Lzonedb_java_tzdb$atlre$;
function $m_Lzonedb_java_tzdb$atlre$() {
  if ((!$n_Lzonedb_java_tzdb$atlre$)) {
    $n_Lzonedb_java_tzdb$atlre$ = new $c_Lzonedb_java_tzdb$atlre$()
  };
  return $n_Lzonedb_java_tzdb$atlre$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlro$() {
  this.Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe = null;
  $n_Lzonedb_java_tzdb$atlro$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-1624));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-1624));
  var _2 = [[1908011, 0, (-1624), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1908011, 0, (-1624), 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlro$.prototype.constructor = $c_Lzonedb_java_tzdb$atlro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlro$.prototype = $c_Lzonedb_java_tzdb$atlro$.prototype;
var $d_Lzonedb_java_tzdb$atlro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlro$: 0
}, false, "zonedb.java.tzdb$atlro$", {
  Lzonedb_java_tzdb$atlro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlro$.prototype.$classData = $d_Lzonedb_java_tzdb$atlro$;
var $n_Lzonedb_java_tzdb$atlro$;
function $m_Lzonedb_java_tzdb$atlro$() {
  if ((!$n_Lzonedb_java_tzdb$atlro$)) {
    $n_Lzonedb_java_tzdb$atlro$ = new $c_Lzonedb_java_tzdb$atlro$()
  };
  return $n_Lzonedb_java_tzdb$atlro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlud$() {
  this.Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda = null;
  $n_Lzonedb_java_tzdb$atlud$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-15558));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-15558));
  var _2 = [[1930001, 7200, (-15558), (-14400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1930001, 7200, (-15558), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlud$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlud$.prototype.constructor = $c_Lzonedb_java_tzdb$atlud$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlud$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlud$.prototype = $c_Lzonedb_java_tzdb$atlud$.prototype;
var $d_Lzonedb_java_tzdb$atlud$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlud$: 0
}, false, "zonedb.java.tzdb$atlud$", {
  Lzonedb_java_tzdb$atlud$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlud$.prototype.$classData = $d_Lzonedb_java_tzdb$atlud$;
var $n_Lzonedb_java_tzdb$atlud$;
function $m_Lzonedb_java_tzdb$atlud$() {
  if ((!$n_Lzonedb_java_tzdb$atlud$)) {
    $n_Lzonedb_java_tzdb$atlud$ = new $c_Lzonedb_java_tzdb$atlud$()
  };
  return $n_Lzonedb_java_tzdb$atlud$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlvi$() {
  this.Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik = null;
  $n_Lzonedb_java_tzdb$atlvi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-5280));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-5280));
  var _2 = [[1908001, 0, (-5280), (-3600)], [1968098, 3600, (-3600), 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1908001, 0, (-5280), (-3600)], [1917050, 82800, (-3600), 0], [1917294, 3600, 0, (-3600)], [1918050, 82800, (-3600), 0], [1918320, 3600, 0, (-3600)], [1919050, 82800, (-3600), 0], [1919320, 3600, 0, (-3600)], [1921078, 82800, (-3600), 0], [1921174, 3600, 0, (-3600)], [1939119, 82800, (-3600), 0], [1939302, 7200, 0, (-3600)], [1940056, 7200, (-3600), 0], [1940308, 7200, 0, (-3600)], [1941061, 3600, (-3600), 0], [1941306, 7200, 0, (-3600)], [1942067, 3600, (-3600), 0], [1942298, 7200, 0, (-3600)], [1943066, 3600, (-3600), 0], [1943297, 7200, 0, (-3600)], [1944065, 3600, (-3600), 0], [1944296, 7200, 0, (-3600)], [1945063, 3600, (-3600), 0], [1945301, 7200, 0, (-3600)], [1946062, 3600, (-3600), 0], [1946300, 7200, 0, (-3600)], [1947096, 3600, (-3600), 0], [1947299, 7200, 0, (-3600)], [1948095, 3600, (-3600), 0], [1948298, 7200, 0, (-3600)], [1949093, 3600, (-3600), 0], [1949303, 7200, 0, (-3600)], [1950092, 3600, (-3600), 0], [1950295, 7200, 0, (-3600)], [1951091, 3600, (-3600), 0], [1951301, 7200, 0, (-3600)], [1952097, 3600, (-3600), 0], [1952300, 7200, 0, (-3600)], [1953095, 3600, (-3600), 0], [1953298, 7200, 0, (-3600)], [1954094, 3600, (-3600), 0], [1954297, 7200, 0, (-3600)], [1955093, 3600, (-3600), 0], [1955296, 7200, 0, (-3600)], [1956092, 3600, (-3600), 0], [1956302, 7200, 0, (-3600)], [1957097, 3600, (-3600), 0], [1957300, 7200, 0, (-3600)], [1958096, 3600, (-3600), 0], [1958299, 7200, 0, (-3600)], [1959095, 3600, (-3600), 0], [1959298, 7200, 0, (-3600)], [1960094, 3600, (-3600), 0], [1960297, 7200, 0, (-3600)], [1961092, 3600, (-3600), 0], [1961295, 7200, 0, (-3600)], [1962091, 3600, (-3600), 0], [1962301, 7200, 0, (-3600)], [1963097, 3600, (-3600), 0], [1963300, 7200, 0, (-3600)], [1964096, 3600, (-3600), 0], [1964299, 7200, 0, (-3600)], [1965094, 3600, (-3600), 0], [1965297, 7200, 0, (-3600)], [1966093, 3600, (-3600), 0], [1966296, 7200, 0, (-3600)], [1967092, 3600, (-3600), 0], [1967302, 7200, 0, (-3600)], [1968098, 3600, (-3600), 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$atlvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlvi$.prototype.constructor = $c_Lzonedb_java_tzdb$atlvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlvi$.prototype = $c_Lzonedb_java_tzdb$atlvi$.prototype;
var $d_Lzonedb_java_tzdb$atlvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlvi$: 0
}, false, "zonedb.java.tzdb$atlvi$", {
  Lzonedb_java_tzdb$atlvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlvi$.prototype.$classData = $d_Lzonedb_java_tzdb$atlvi$;
var $n_Lzonedb_java_tzdb$atlvi$;
function $m_Lzonedb_java_tzdb$atlvi$() {
  if ((!$n_Lzonedb_java_tzdb$atlvi$)) {
    $n_Lzonedb_java_tzdb$atlvi$ = new $c_Lzonedb_java_tzdb$atlvi$()
  };
  return $n_Lzonedb_java_tzdb$atlvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausan$() {
  this.Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane = null;
  $n_Lzonedb_java_tzdb$ausan$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 36728);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 36728);
  var _2 = [[1895001, 0, 36728, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, 36728, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausan$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausan$.prototype.constructor = $c_Lzonedb_java_tzdb$ausan$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausan$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausan$.prototype = $c_Lzonedb_java_tzdb$ausan$.prototype;
var $d_Lzonedb_java_tzdb$ausan$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausan$: 0
}, false, "zonedb.java.tzdb$ausan$", {
  Lzonedb_java_tzdb$ausan$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausan$.prototype.$classData = $d_Lzonedb_java_tzdb$ausan$;
var $n_Lzonedb_java_tzdb$ausan$;
function $m_Lzonedb_java_tzdb$ausan$() {
  if ((!$n_Lzonedb_java_tzdb$ausan$)) {
    $n_Lzonedb_java_tzdb$ausan$ = new $c_Lzonedb_java_tzdb$ausan$()
  };
  return $n_Lzonedb_java_tzdb$ausan$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausar$() {
  this.Lzonedb_java_tzdb$ausar$__f_Australia_Hobart = null;
  $n_Lzonedb_java_tzdb$ausar$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 35356);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 35356);
  var _2 = [[1895244, 0, 35356, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895244, 0, 35356, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1967274, 7200, 36000, 39600], [1968091, 10800, 39600, 36000], [1968301, 7200, 36000, 39600], [1969068, 10800, 39600, 36000], [1969299, 7200, 36000, 39600], [1970067, 10800, 39600, 36000], [1970298, 7200, 36000, 39600], [1971073, 10800, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausar$__f_Australia_Hobart = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausar$.prototype.constructor = $c_Lzonedb_java_tzdb$ausar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausar$.prototype = $c_Lzonedb_java_tzdb$ausar$.prototype;
var $d_Lzonedb_java_tzdb$ausar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausar$: 0
}, false, "zonedb.java.tzdb$ausar$", {
  Lzonedb_java_tzdb$ausar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausar$.prototype.$classData = $d_Lzonedb_java_tzdb$ausar$;
var $n_Lzonedb_java_tzdb$ausar$;
function $m_Lzonedb_java_tzdb$ausar$() {
  if ((!$n_Lzonedb_java_tzdb$ausar$)) {
    $n_Lzonedb_java_tzdb$ausar$ = new $c_Lzonedb_java_tzdb$ausar$()
  };
  return $n_Lzonedb_java_tzdb$ausar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$auscl$() {
  this.Lzonedb_java_tzdb$auscl$__f_Australia_Eucla = null;
  $n_Lzonedb_java_tzdb$auscl$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 30928);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 30928);
  var _2 = [[1895335, 0, 30928, 31500]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895335, 0, 30928, 31500], [1917001, 60, 31500, 35100], [1917084, 7200, 35100, 31500], [1942001, 7200, 31500, 35100], [1942088, 7200, 35100, 31500], [1942270, 7200, 31500, 35100], [1943087, 7200, 35100, 31500], [1974300, 7200, 31500, 35100], [1975061, 10800, 35100, 31500], [1983303, 7200, 31500, 35100], [1984064, 10800, 35100, 31500], [1991321, 7200, 31500, 35100], [1992061, 10800, 35100, 31500], [2006337, 7200, 31500, 35100], [2007084, 10800, 35100, 31500], [2007301, 7200, 31500, 35100], [2008090, 10800, 35100, 31500], [2008300, 7200, 31500, 35100], [2009088, 10800, 35100, 31500]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$auscl$__f_Australia_Eucla = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$auscl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$auscl$.prototype.constructor = $c_Lzonedb_java_tzdb$auscl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$auscl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$auscl$.prototype = $c_Lzonedb_java_tzdb$auscl$.prototype;
var $d_Lzonedb_java_tzdb$auscl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$auscl$: 0
}, false, "zonedb.java.tzdb$auscl$", {
  Lzonedb_java_tzdb$auscl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$auscl$.prototype.$classData = $d_Lzonedb_java_tzdb$auscl$;
var $n_Lzonedb_java_tzdb$auscl$;
function $m_Lzonedb_java_tzdb$auscl$() {
  if ((!$n_Lzonedb_java_tzdb$auscl$)) {
    $n_Lzonedb_java_tzdb$auscl$ = new $c_Lzonedb_java_tzdb$auscl$()
  };
  return $n_Lzonedb_java_tzdb$auscl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausid$() {
  this.Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide = null;
  $n_Lzonedb_java_tzdb$ausid$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 33260);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 33260);
  var _2 = [[1895032, 0, 33260, 32400], [1899121, 0, 32400, 34200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 33260, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200], [1971304, 7200, 34200, 37800], [1972058, 10800, 37800, 34200], [1972303, 7200, 34200, 37800], [1973063, 10800, 37800, 34200], [1973301, 7200, 34200, 37800], [1974062, 10800, 37800, 34200], [1974300, 7200, 34200, 37800], [1975061, 10800, 37800, 34200], [1975299, 7200, 34200, 37800], [1976067, 10800, 37800, 34200], [1976305, 7200, 34200, 37800], [1977065, 10800, 37800, 34200], [1977303, 7200, 34200, 37800], [1978064, 10800, 37800, 34200], [1978302, 7200, 34200, 37800], [1979063, 10800, 37800, 34200], [1979301, 7200, 34200, 37800], [1980062, 10800, 37800, 34200], [1980300, 7200, 34200, 37800], [1981060, 10800, 37800, 34200], [1981298, 7200, 34200, 37800], [1982066, 10800, 37800, 34200], [1982304, 7200, 34200, 37800], [1983065, 10800, 37800, 34200], [1983303, 7200, 34200, 37800], [1984064, 10800, 37800, 34200], [1984302, 7200, 34200, 37800], [1985062, 10800, 37800, 34200], [1985300, 7200, 34200, 37800], [1986075, 10800, 37800, 34200], [1986292, 7200, 34200, 37800], [1987074, 10800, 37800, 34200], [1987298, 7200, 34200, 37800], [1988080, 10800, 37800, 34200], [1988304, 7200, 34200, 37800], [1989078, 10800, 37800, 34200], [1989302, 7200, 34200, 37800], [1990077, 10800, 37800, 34200], [1990301, 7200, 34200, 37800], [1991062, 10800, 37800, 34200], [1991300, 7200, 34200, 37800], [1992082, 10800, 37800, 34200], [1992299, 7200, 34200, 37800], [1993066, 10800, 37800, 34200], [1993304, 7200, 34200, 37800], [1994079, 10800, 37800, 34200], [1994303, 7200, 34200, 37800], [1995085, 10800, 37800, 34200], [1995302, 7200, 34200, 37800], [1996091, 10800, 37800, 34200], [1996301, 7200, 34200, 37800], [1997089, 10800, 37800, 34200], [1997299, 7200, 34200, 37800], [1998088, 10800, 37800, 34200], [1998298, 7200, 34200, 37800], [1999087, 10800, 37800, 34200], [1999304, 7200, 34200, 37800], [2000086, 10800, 37800, 34200], [2000303, 7200, 34200, 37800], [2001084, 10800, 37800, 34200], [2001301, 7200, 34200, 37800], [2002090, 10800, 37800, 34200], [2002300, 7200, 34200, 37800], [2003089, 10800, 37800, 34200], [2003299, 7200, 34200, 37800], [2004088, 10800, 37800, 34200], [2004305, 7200, 34200, 37800], [2005086, 10800, 37800, 34200], [2005303, 7200, 34200, 37800], [2006092, 10800, 37800, 34200], [2006302, 7200, 34200, 37800], [2007084, 10800, 37800, 34200], [2007301, 7200, 34200, 37800], [2008097, 10800, 37800, 34200], [2008279, 7200, 34200, 37800], [2009095, 10800, 37800, 34200], [2009277, 7200, 34200, 37800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 34200, 37800, 34200], [10, 1, 7, 7200, 0, 2, 34200, 34200, 37800]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausid$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausid$.prototype.constructor = $c_Lzonedb_java_tzdb$ausid$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausid$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausid$.prototype = $c_Lzonedb_java_tzdb$ausid$.prototype;
var $d_Lzonedb_java_tzdb$ausid$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausid$: 0
}, false, "zonedb.java.tzdb$ausid$", {
  Lzonedb_java_tzdb$ausid$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausid$.prototype.$classData = $d_Lzonedb_java_tzdb$ausid$;
var $n_Lzonedb_java_tzdb$ausid$;
function $m_Lzonedb_java_tzdb$ausid$() {
  if ((!$n_Lzonedb_java_tzdb$ausid$)) {
    $n_Lzonedb_java_tzdb$ausid$ = new $c_Lzonedb_java_tzdb$ausid$()
  };
  return $n_Lzonedb_java_tzdb$ausid$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausil$() {
  this.Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill = null;
  $n_Lzonedb_java_tzdb$ausil$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 33948);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 33948);
  var _2 = [[1895032, 0, 33948, 36000], [1896236, 0, 36000, 32400], [1899121, 0, 32400, 34200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 33948, 36000], [1896236, 0, 36000, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200], [1971304, 7200, 34200, 37800], [1972058, 10800, 37800, 34200], [1972303, 7200, 34200, 37800], [1973063, 10800, 37800, 34200], [1973301, 7200, 34200, 37800], [1974062, 10800, 37800, 34200], [1974300, 7200, 34200, 37800], [1975061, 10800, 37800, 34200], [1975299, 7200, 34200, 37800], [1976067, 10800, 37800, 34200], [1976305, 7200, 34200, 37800], [1977065, 10800, 37800, 34200], [1977303, 7200, 34200, 37800], [1978064, 10800, 37800, 34200], [1978302, 7200, 34200, 37800], [1979063, 10800, 37800, 34200], [1979301, 7200, 34200, 37800], [1980062, 10800, 37800, 34200], [1980300, 7200, 34200, 37800], [1981060, 10800, 37800, 34200], [1981298, 7200, 34200, 37800], [1982094, 10800, 37800, 34200], [1982304, 7200, 34200, 37800], [1983065, 10800, 37800, 34200], [1983303, 7200, 34200, 37800], [1984064, 10800, 37800, 34200], [1984302, 7200, 34200, 37800], [1985062, 10800, 37800, 34200], [1985300, 7200, 34200, 37800], [1986075, 10800, 37800, 34200], [1986292, 7200, 34200, 37800], [1987074, 10800, 37800, 34200], [1987298, 7200, 34200, 37800], [1988080, 10800, 37800, 34200], [1988304, 7200, 34200, 37800], [1989078, 10800, 37800, 34200], [1989302, 7200, 34200, 37800], [1990063, 10800, 37800, 34200], [1990301, 7200, 34200, 37800], [1991062, 10800, 37800, 34200], [1991300, 7200, 34200, 37800], [1992061, 10800, 37800, 34200], [1992299, 7200, 34200, 37800], [1993066, 10800, 37800, 34200], [1993304, 7200, 34200, 37800], [1994065, 10800, 37800, 34200], [1994303, 7200, 34200, 37800], [1995064, 10800, 37800, 34200], [1995302, 7200, 34200, 37800], [1996091, 10800, 37800, 34200], [1996301, 7200, 34200, 37800], [1997089, 10800, 37800, 34200], [1997299, 7200, 34200, 37800], [1998088, 10800, 37800, 34200], [1998298, 7200, 34200, 37800], [1999087, 10800, 37800, 34200], [1999304, 7200, 34200, 37800], [2000086, 10800, 37800, 34200], [2000303, 7200, 34200, 37800], [2001084, 10800, 37800, 34200], [2001301, 7200, 34200, 37800], [2002090, 10800, 37800, 34200], [2002300, 7200, 34200, 37800], [2003089, 10800, 37800, 34200], [2003299, 7200, 34200, 37800], [2004088, 10800, 37800, 34200], [2004305, 7200, 34200, 37800], [2005086, 10800, 37800, 34200], [2005303, 7200, 34200, 37800], [2006092, 10800, 37800, 34200], [2006302, 7200, 34200, 37800], [2007084, 10800, 37800, 34200], [2007301, 7200, 34200, 37800], [2008097, 10800, 37800, 34200], [2008279, 7200, 34200, 37800], [2009095, 10800, 37800, 34200], [2009277, 7200, 34200, 37800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 34200, 37800, 34200], [10, 1, 7, 7200, 0, 2, 34200, 34200, 37800]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausil$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausil$.prototype.constructor = $c_Lzonedb_java_tzdb$ausil$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausil$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausil$.prototype = $c_Lzonedb_java_tzdb$ausil$.prototype;
var $d_Lzonedb_java_tzdb$ausil$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausil$: 0
}, false, "zonedb.java.tzdb$ausil$", {
  Lzonedb_java_tzdb$ausil$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausil$.prototype.$classData = $d_Lzonedb_java_tzdb$ausil$;
var $n_Lzonedb_java_tzdb$ausil$;
function $m_Lzonedb_java_tzdb$ausil$() {
  if ((!$n_Lzonedb_java_tzdb$ausil$)) {
    $n_Lzonedb_java_tzdb$ausil$ = new $c_Lzonedb_java_tzdb$ausil$()
  };
  return $n_Lzonedb_java_tzdb$ausil$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausma$() {
  this.Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman = null;
  $n_Lzonedb_java_tzdb$ausma$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 35756);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 35756);
  var _2 = [[1895001, 0, 35756, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, 35756, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausma$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausma$.prototype.constructor = $c_Lzonedb_java_tzdb$ausma$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausma$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausma$.prototype = $c_Lzonedb_java_tzdb$ausma$.prototype;
var $d_Lzonedb_java_tzdb$ausma$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausma$: 0
}, false, "zonedb.java.tzdb$ausma$", {
  Lzonedb_java_tzdb$ausma$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausma$.prototype.$classData = $d_Lzonedb_java_tzdb$ausma$;
var $n_Lzonedb_java_tzdb$ausma$;
function $m_Lzonedb_java_tzdb$ausma$() {
  if ((!$n_Lzonedb_java_tzdb$ausma$)) {
    $n_Lzonedb_java_tzdb$ausma$ = new $c_Lzonedb_java_tzdb$ausma$()
  };
  return $n_Lzonedb_java_tzdb$ausma$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausne$() {
  this.Lzonedb_java_tzdb$ausne$__f_Australia_Sydney = null;
  $n_Lzonedb_java_tzdb$ausne$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 36292);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 36292);
  var _2 = [[1895032, 0, 36292, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 36292, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982094, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983065, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986075, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000], [1994303, 7200, 36000, 39600], [1995064, 10800, 39600, 36000], [1995302, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996301, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997299, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998298, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999304, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001301, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002300, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003299, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004305, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005303, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006302, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007301, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausne$__f_Australia_Sydney = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausne$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausne$.prototype.constructor = $c_Lzonedb_java_tzdb$ausne$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausne$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausne$.prototype = $c_Lzonedb_java_tzdb$ausne$.prototype;
var $d_Lzonedb_java_tzdb$ausne$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausne$: 0
}, false, "zonedb.java.tzdb$ausne$", {
  Lzonedb_java_tzdb$ausne$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausne$.prototype.$classData = $d_Lzonedb_java_tzdb$ausne$;
var $n_Lzonedb_java_tzdb$ausne$;
function $m_Lzonedb_java_tzdb$ausne$() {
  if ((!$n_Lzonedb_java_tzdb$ausne$)) {
    $n_Lzonedb_java_tzdb$ausne$ = new $c_Lzonedb_java_tzdb$ausne$()
  };
  return $n_Lzonedb_java_tzdb$ausne$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausow$() {
  this.Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe = null;
  $n_Lzonedb_java_tzdb$ausow$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 38180);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 38180);
  var _2 = [[1895032, 0, 38180, 36000], [1981060, 0, 36000, 37800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 38180, 36000], [1981060, 0, 36000, 37800], [1981298, 7200, 37800, 41400], [1982066, 7200, 41400, 37800], [1982304, 7200, 37800, 41400], [1983065, 7200, 41400, 37800], [1983303, 7200, 37800, 41400], [1984064, 7200, 41400, 37800], [1984302, 7200, 37800, 41400], [1985062, 7200, 41400, 37800], [1985300, 7200, 37800, 39600], [1986075, 7200, 39600, 37800], [1986292, 7200, 37800, 39600], [1987074, 7200, 39600, 37800], [1987298, 7200, 37800, 39600], [1988080, 7200, 39600, 37800], [1988304, 7200, 37800, 39600], [1989078, 7200, 39600, 37800], [1989302, 7200, 37800, 39600], [1990063, 7200, 39600, 37800], [1990301, 7200, 37800, 39600], [1991062, 7200, 39600, 37800], [1991300, 7200, 37800, 39600], [1992061, 7200, 39600, 37800], [1992299, 7200, 37800, 39600], [1993066, 7200, 39600, 37800], [1993304, 7200, 37800, 39600], [1994065, 7200, 39600, 37800], [1994303, 7200, 37800, 39600], [1995064, 7200, 39600, 37800], [1995302, 7200, 37800, 39600], [1996091, 7200, 39600, 37800], [1996301, 7200, 37800, 39600], [1997089, 7200, 39600, 37800], [1997299, 7200, 37800, 39600], [1998088, 7200, 39600, 37800], [1998298, 7200, 37800, 39600], [1999087, 7200, 39600, 37800], [1999304, 7200, 37800, 39600], [2000086, 7200, 39600, 37800], [2000240, 7200, 37800, 39600], [2001084, 7200, 39600, 37800], [2001301, 7200, 37800, 39600], [2002090, 7200, 39600, 37800], [2002300, 7200, 37800, 39600], [2003089, 7200, 39600, 37800], [2003299, 7200, 37800, 39600], [2004088, 7200, 39600, 37800], [2004305, 7200, 37800, 39600], [2005086, 7200, 39600, 37800], [2005303, 7200, 37800, 39600], [2006092, 7200, 39600, 37800], [2006302, 7200, 37800, 39600], [2007084, 7200, 39600, 37800], [2007301, 7200, 37800, 39600], [2008097, 7200, 39600, 37800], [2008279, 7200, 37800, 39600], [2009095, 7200, 39600, 37800], [2009277, 7200, 37800, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 1, 37800, 39600, 37800], [10, 1, 7, 7200, 0, 1, 37800, 37800, 39600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausow$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausow$.prototype.constructor = $c_Lzonedb_java_tzdb$ausow$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausow$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausow$.prototype = $c_Lzonedb_java_tzdb$ausow$.prototype;
var $d_Lzonedb_java_tzdb$ausow$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausow$: 0
}, false, "zonedb.java.tzdb$ausow$", {
  Lzonedb_java_tzdb$ausow$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausow$.prototype.$classData = $d_Lzonedb_java_tzdb$ausow$;
var $n_Lzonedb_java_tzdb$ausow$;
function $m_Lzonedb_java_tzdb$ausow$() {
  if ((!$n_Lzonedb_java_tzdb$ausow$)) {
    $n_Lzonedb_java_tzdb$ausow$ = new $c_Lzonedb_java_tzdb$ausow$()
  };
  return $n_Lzonedb_java_tzdb$ausow$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausri$() {
  this.Lzonedb_java_tzdb$ausri$__f_Australia_Currie = null;
  $n_Lzonedb_java_tzdb$ausri$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 34528);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 34528);
  var _2 = [[1895244, 0, 34528, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895244, 0, 34528, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausri$__f_Australia_Currie = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausri$.prototype.constructor = $c_Lzonedb_java_tzdb$ausri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausri$.prototype = $c_Lzonedb_java_tzdb$ausri$.prototype;
var $d_Lzonedb_java_tzdb$ausri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausri$: 0
}, false, "zonedb.java.tzdb$ausri$", {
  Lzonedb_java_tzdb$ausri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausri$.prototype.$classData = $d_Lzonedb_java_tzdb$ausri$;
var $n_Lzonedb_java_tzdb$ausri$;
function $m_Lzonedb_java_tzdb$ausri$() {
  if ((!$n_Lzonedb_java_tzdb$ausri$)) {
    $n_Lzonedb_java_tzdb$ausri$ = new $c_Lzonedb_java_tzdb$ausri$()
  };
  return $n_Lzonedb_java_tzdb$ausri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausrn$() {
  this.Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne = null;
  $n_Lzonedb_java_tzdb$ausrn$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 34792);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 34792);
  var _2 = [[1895032, 0, 34792, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 34792, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982066, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983065, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986075, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987291, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000], [1994303, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995302, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996301, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997299, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998298, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999304, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001301, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002300, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003299, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004305, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005303, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006302, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007301, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausrn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausrn$.prototype.constructor = $c_Lzonedb_java_tzdb$ausrn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausrn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausrn$.prototype = $c_Lzonedb_java_tzdb$ausrn$.prototype;
var $d_Lzonedb_java_tzdb$ausrn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausrn$: 0
}, false, "zonedb.java.tzdb$ausrn$", {
  Lzonedb_java_tzdb$ausrn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausrn$.prototype.$classData = $d_Lzonedb_java_tzdb$ausrn$;
var $n_Lzonedb_java_tzdb$ausrn$;
function $m_Lzonedb_java_tzdb$ausrn$() {
  if ((!$n_Lzonedb_java_tzdb$ausrn$)) {
    $n_Lzonedb_java_tzdb$ausrn$ = new $c_Lzonedb_java_tzdb$ausrn$()
  };
  return $n_Lzonedb_java_tzdb$ausrn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausrt$() {
  this.Lzonedb_java_tzdb$ausrt$__f_Australia_Perth = null;
  $n_Lzonedb_java_tzdb$ausrt$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 27804);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 27804);
  var _2 = [[1895335, 0, 27804, 28800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895335, 0, 27804, 28800], [1917001, 60, 28800, 32400], [1917084, 7200, 32400, 28800], [1942001, 7200, 28800, 32400], [1942088, 7200, 32400, 28800], [1942270, 7200, 28800, 32400], [1943087, 7200, 32400, 28800], [1974300, 7200, 28800, 32400], [1975061, 10800, 32400, 28800], [1983303, 7200, 28800, 32400], [1984064, 10800, 32400, 28800], [1991321, 7200, 28800, 32400], [1992061, 10800, 32400, 28800], [2006337, 7200, 28800, 32400], [2007084, 10800, 32400, 28800], [2007301, 7200, 28800, 32400], [2008090, 10800, 32400, 28800], [2008300, 7200, 28800, 32400], [2009088, 10800, 32400, 28800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$ausrt$__f_Australia_Perth = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$ausrt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausrt$.prototype.constructor = $c_Lzonedb_java_tzdb$ausrt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausrt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausrt$.prototype = $c_Lzonedb_java_tzdb$ausrt$.prototype;
var $d_Lzonedb_java_tzdb$ausrt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausrt$: 0
}, false, "zonedb.java.tzdb$ausrt$", {
  Lzonedb_java_tzdb$ausrt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausrt$.prototype.$classData = $d_Lzonedb_java_tzdb$ausrt$;
var $n_Lzonedb_java_tzdb$ausrt$;
function $m_Lzonedb_java_tzdb$ausrt$() {
  if ((!$n_Lzonedb_java_tzdb$ausrt$)) {
    $n_Lzonedb_java_tzdb$ausrt$ = new $c_Lzonedb_java_tzdb$ausrt$()
  };
  return $n_Lzonedb_java_tzdb$ausrt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$auswi$() {
  this.Lzonedb_java_tzdb$auswi$__f_Australia_Darwin = null;
  $n_Lzonedb_java_tzdb$auswi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 31400);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 31400);
  var _2 = [[1895032, 0, 31400, 32400], [1899121, 0, 32400, 34200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 31400, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$auswi$__f_Australia_Darwin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$auswi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$auswi$.prototype.constructor = $c_Lzonedb_java_tzdb$auswi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$auswi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$auswi$.prototype = $c_Lzonedb_java_tzdb$auswi$.prototype;
var $d_Lzonedb_java_tzdb$auswi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$auswi$: 0
}, false, "zonedb.java.tzdb$auswi$", {
  Lzonedb_java_tzdb$auswi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$auswi$.prototype.$classData = $d_Lzonedb_java_tzdb$auswi$;
var $n_Lzonedb_java_tzdb$auswi$;
function $m_Lzonedb_java_tzdb$auswi$() {
  if ((!$n_Lzonedb_java_tzdb$auswi$)) {
    $n_Lzonedb_java_tzdb$auswi$ = new $c_Lzonedb_java_tzdb$auswi$()
  };
  return $n_Lzonedb_java_tzdb$auswi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurac$() {
  this.Lzonedb_java_tzdb$eurac$__f_Europe_Monaco = null;
  $n_Lzonedb_java_tzdb$eurac$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 1772);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 1772);
  var _2 = [[1891074, 0, 1772, 561], [1911070, 0, 561, 0], [1945259, 3600, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1891074, 0, 1772, 561], [1911070, 0, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923146, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1930102, 82800, 0, 3600], [1930278, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1933084, 82800, 0, 3600], [1933281, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940056, 7200, 0, 3600], [1941125, 0, 3600, 7200], [1941279, 0, 7200, 3600], [1942068, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 3600, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1976088, 3600, 3600, 7200], [1976270, 3600, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurac$__f_Europe_Monaco = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurac$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurac$.prototype.constructor = $c_Lzonedb_java_tzdb$eurac$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurac$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurac$.prototype = $c_Lzonedb_java_tzdb$eurac$.prototype;
var $d_Lzonedb_java_tzdb$eurac$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurac$: 0
}, false, "zonedb.java.tzdb$eurac$", {
  Lzonedb_java_tzdb$eurac$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurac$.prototype.$classData = $d_Lzonedb_java_tzdb$eurac$;
var $n_Lzonedb_java_tzdb$eurac$;
function $m_Lzonedb_java_tzdb$eurac$() {
  if ((!$n_Lzonedb_java_tzdb$eurac$)) {
    $n_Lzonedb_java_tzdb$eurac$ = new $c_Lzonedb_java_tzdb$eurac$()
  };
  return $n_Lzonedb_java_tzdb$eurac$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurad$() {
  this.Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade = null;
  $n_Lzonedb_java_tzdb$eurad$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 4920);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 4920);
  var _2 = [[1884001, 0, 4920, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1884001, 0, 4920, 3600], [1941108, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945128, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurad$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurad$.prototype.constructor = $c_Lzonedb_java_tzdb$eurad$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurad$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurad$.prototype = $c_Lzonedb_java_tzdb$eurad$.prototype;
var $d_Lzonedb_java_tzdb$eurad$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurad$: 0
}, false, "zonedb.java.tzdb$eurad$", {
  Lzonedb_java_tzdb$eurad$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurad$.prototype.$classData = $d_Lzonedb_java_tzdb$eurad$;
var $n_Lzonedb_java_tzdb$eurad$;
function $m_Lzonedb_java_tzdb$eurad$() {
  if ((!$n_Lzonedb_java_tzdb$eurad$)) {
    $n_Lzonedb_java_tzdb$eurad$ = new $c_Lzonedb_java_tzdb$eurad$()
  };
  return $n_Lzonedb_java_tzdb$eurad$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euran$() {
  this.Lzonedb_java_tzdb$euran$__f_Europe_Tirane = null;
  $n_Lzonedb_java_tzdb$euran$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 4760);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 4760);
  var _2 = [[1914001, 0, 4760, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1914001, 0, 4760, 3600], [1940168, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943100, 10800, 7200, 3600], [1974124, 0, 3600, 7200], [1974275, 0, 7200, 3600], [1975121, 0, 3600, 7200], [1975275, 0, 7200, 3600], [1976123, 0, 3600, 7200], [1976277, 0, 7200, 3600], [1977128, 0, 3600, 7200], [1977275, 0, 7200, 3600], [1978126, 0, 3600, 7200], [1978274, 0, 7200, 3600], [1979125, 0, 3600, 7200], [1979273, 0, 7200, 3600], [1980124, 0, 3600, 7200], [1980278, 0, 7200, 3600], [1981116, 0, 3600, 7200], [1981270, 0, 7200, 3600], [1982122, 0, 3600, 7200], [1982276, 0, 7200, 3600], [1983108, 0, 3600, 7200], [1983274, 0, 7200, 3600], [1984092, 0, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$euran$__f_Europe_Tirane = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$euran$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euran$.prototype.constructor = $c_Lzonedb_java_tzdb$euran$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euran$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euran$.prototype = $c_Lzonedb_java_tzdb$euran$.prototype;
var $d_Lzonedb_java_tzdb$euran$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euran$: 0
}, false, "zonedb.java.tzdb$euran$", {
  Lzonedb_java_tzdb$euran$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euran$.prototype.$classData = $d_Lzonedb_java_tzdb$euran$;
var $n_Lzonedb_java_tzdb$euran$;
function $m_Lzonedb_java_tzdb$euran$() {
  if ((!$n_Lzonedb_java_tzdb$euran$)) {
    $n_Lzonedb_java_tzdb$euran$ = new $c_Lzonedb_java_tzdb$euran$()
  };
  return $n_Lzonedb_java_tzdb$euran$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurar$() {
  this.Lzonedb_java_tzdb$eurar$__f_Europe_Samara = null;
  $n_Lzonedb_java_tzdb$eurar$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 12020);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 12020);
  var _2 = [[1919182, 12020, 12020, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 7200], [1991272, 7200, 7200, 10800], [1991293, 10800, 10800, 14400], [2010087, 7200, 14400, 10800], [2011086, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919182, 12020, 12020, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991293, 10800, 10800, 14400], [1992089, 7200, 14400, 18000], [1992271, 10800, 18000, 14400], [1993087, 7200, 14400, 18000], [1993269, 10800, 18000, 14400], [1994086, 7200, 14400, 18000], [1994268, 10800, 18000, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000], [2004305, 10800, 18000, 14400], [2005086, 7200, 14400, 18000], [2005303, 10800, 18000, 14400], [2006085, 7200, 14400, 18000], [2006302, 10800, 18000, 14400], [2007084, 7200, 14400, 18000], [2007301, 10800, 18000, 14400], [2008090, 7200, 14400, 18000], [2008300, 10800, 18000, 14400], [2009088, 7200, 14400, 18000], [2009298, 10800, 18000, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurar$__f_Europe_Samara = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurar$.prototype.constructor = $c_Lzonedb_java_tzdb$eurar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurar$.prototype = $c_Lzonedb_java_tzdb$eurar$.prototype;
var $d_Lzonedb_java_tzdb$eurar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurar$: 0
}, false, "zonedb.java.tzdb$eurar$", {
  Lzonedb_java_tzdb$eurar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurar$.prototype.$classData = $d_Lzonedb_java_tzdb$eurar$;
var $n_Lzonedb_java_tzdb$eurar$;
function $m_Lzonedb_java_tzdb$eurar$() {
  if ((!$n_Lzonedb_java_tzdb$eurar$)) {
    $n_Lzonedb_java_tzdb$eurar$ = new $c_Lzonedb_java_tzdb$eurar$()
  };
  return $n_Lzonedb_java_tzdb$eurar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurbo$() {
  this.Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon = null;
  $n_Lzonedb_java_tzdb$eurbo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-2205));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-2205));
  var _2 = [[1911365, 84195, (-2205), 0], [1966093, 7200, 0, 3600], [1976270, 3600, 3600, 0], [1992271, 3600, 0, 3600], [1996091, 7200, 3600, 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911365, 84195, (-2205), 0], [1916169, 82800, 0, 3600], [1916306, 3600, 3600, 0], [1917059, 82800, 0, 3600], [1917288, 0, 3600, 0], [1918060, 82800, 0, 3600], [1918288, 0, 3600, 0], [1919059, 82800, 0, 3600], [1919288, 0, 3600, 0], [1920060, 82800, 0, 3600], [1920289, 0, 3600, 0], [1921059, 82800, 0, 3600], [1921288, 0, 3600, 0], [1924107, 82800, 0, 3600], [1924289, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940055, 82800, 0, 3600], [1940280, 0, 3600, 0], [1941095, 82800, 0, 3600], [1941279, 0, 3600, 0], [1942073, 82800, 0, 3600], [1942115, 82800, 3600, 7200], [1942228, 0, 7200, 3600], [1942298, 0, 3600, 0], [1943072, 82800, 0, 3600], [1943107, 82800, 3600, 7200], [1943241, 0, 7200, 3600], [1943304, 0, 3600, 0], [1944071, 82800, 0, 3600], [1944113, 82800, 3600, 7200], [1944240, 0, 7200, 3600], [1944303, 0, 3600, 0], [1945069, 82800, 0, 3600], [1945111, 82800, 3600, 7200], [1945238, 0, 7200, 3600], [1945301, 0, 3600, 0], [1946096, 82800, 0, 3600], [1946279, 0, 3600, 0], [1947096, 7200, 0, 3600], [1947278, 10800, 3600, 0], [1948095, 7200, 0, 3600], [1948277, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949275, 10800, 3600, 0], [1951091, 7200, 0, 3600], [1951280, 10800, 3600, 0], [1952097, 7200, 0, 3600], [1952279, 10800, 3600, 0], [1953095, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954094, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955093, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956092, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957097, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958096, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959095, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960094, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961092, 7200, 0, 3600], [1961274, 10800, 3600, 0], [1962091, 7200, 0, 3600], [1962280, 10800, 3600, 0], [1963097, 7200, 0, 3600], [1963279, 10800, 3600, 0], [1964096, 7200, 0, 3600], [1964278, 10800, 3600, 0], [1965094, 7200, 0, 3600], [1965276, 10800, 3600, 0], [1966093, 7200, 0, 3600], [1976270, 3600, 3600, 0], [1977086, 0, 0, 3600], [1977268, 3600, 3600, 0], [1978092, 0, 0, 3600], [1978274, 3600, 3600, 0], [1979091, 0, 0, 3600], [1979273, 7200, 3600, 0], [1980090, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 7200, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurbo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurbo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurbo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurbo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurbo$.prototype = $c_Lzonedb_java_tzdb$eurbo$.prototype;
var $d_Lzonedb_java_tzdb$eurbo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurbo$: 0
}, false, "zonedb.java.tzdb$eurbo$", {
  Lzonedb_java_tzdb$eurbo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurbo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurbo$;
var $n_Lzonedb_java_tzdb$eurbo$;
function $m_Lzonedb_java_tzdb$eurbo$() {
  if ((!$n_Lzonedb_java_tzdb$eurbo$)) {
    $n_Lzonedb_java_tzdb$eurbo$ = new $c_Lzonedb_java_tzdb$eurbo$()
  };
  return $n_Lzonedb_java_tzdb$eurbo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurbu$() {
  this.Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul = null;
  $n_Lzonedb_java_tzdb$eurbu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6952);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6952);
  var _2 = [[1880001, 0, 6952, 7016], [1910274, 0, 7016, 7200], [1978179, 82800, 7200, 10800], [1984306, 7200, 10800, 7200], [2016250, 82800, 7200, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 6952, 7016], [1910274, 0, 7016, 7200], [1916122, 0, 7200, 10800], [1916275, 0, 10800, 7200], [1920088, 0, 7200, 10800], [1920299, 0, 10800, 7200], [1921093, 0, 7200, 10800], [1921276, 0, 10800, 7200], [1922085, 0, 7200, 10800], [1922281, 0, 10800, 7200], [1924134, 0, 7200, 10800], [1924275, 0, 10800, 7200], [1925121, 0, 7200, 10800], [1925274, 0, 10800, 7200], [1940183, 0, 7200, 10800], [1940280, 0, 10800, 7200], [1940336, 0, 7200, 10800], [1941264, 0, 10800, 7200], [1942091, 0, 7200, 10800], [1945281, 0, 10800, 7200], [1946152, 0, 7200, 10800], [1946274, 0, 10800, 7200], [1947110, 0, 7200, 10800], [1947278, 0, 10800, 7200], [1948109, 0, 7200, 10800], [1948277, 0, 10800, 7200], [1949100, 0, 7200, 10800], [1949275, 0, 10800, 7200], [1950106, 0, 7200, 10800], [1950281, 0, 10800, 7200], [1951112, 0, 7200, 10800], [1951280, 0, 10800, 7200], [1962196, 0, 7200, 10800], [1963303, 0, 10800, 7200], [1964136, 0, 7200, 10800], [1964275, 0, 10800, 7200], [1973154, 3600, 7200, 10800], [1973308, 7200, 10800, 7200], [1974090, 7200, 7200, 10800], [1974307, 7200, 10800, 7200], [1975081, 7200, 7200, 10800], [1975306, 7200, 10800, 7200], [1976081, 7200, 7200, 10800], [1976305, 7200, 10800, 7200], [1977093, 7200, 7200, 10800], [1977289, 7200, 10800, 7200], [1978092, 7200, 7200, 10800], [1983212, 7200, 10800, 14400], [1983275, 7200, 14400, 10800], [1984306, 7200, 10800, 7200], [1985110, 3600, 7200, 10800], [1985271, 7200, 10800, 7200], [1986089, 3600, 7200, 10800], [1986271, 7200, 10800, 7200], [1987088, 3600, 7200, 10800], [1987270, 7200, 10800, 7200], [1988087, 3600, 7200, 10800], [1988269, 7200, 10800, 7200], [1989085, 3600, 7200, 10800], [1989267, 7200, 10800, 7200], [1990084, 3600, 7200, 10800], [1990273, 7200, 10800, 7200], [1991090, 3600, 7200, 10800], [1991272, 7200, 10800, 7200], [1992089, 3600, 7200, 10800], [1992271, 7200, 10800, 7200], [1993087, 3600, 7200, 10800], [1993269, 7200, 10800, 7200], [1994079, 3600, 7200, 10800], [1994268, 7200, 10800, 7200], [1995085, 3600, 7200, 10800], [1995267, 7200, 10800, 7200], [1996091, 3600, 7200, 10800], [1996301, 7200, 10800, 7200], [1997089, 3600, 7200, 10800], [1997299, 7200, 10800, 7200], [1998088, 3600, 7200, 10800], [1998298, 7200, 10800, 7200], [1999087, 3600, 7200, 10800], [1999304, 7200, 10800, 7200], [2000086, 3600, 7200, 10800], [2000303, 7200, 10800, 7200], [2001084, 3600, 7200, 10800], [2001301, 7200, 10800, 7200], [2002090, 3600, 7200, 10800], [2002300, 7200, 10800, 7200], [2003089, 3600, 7200, 10800], [2003299, 7200, 10800, 7200], [2004088, 3600, 7200, 10800], [2004305, 7200, 10800, 7200], [2005086, 3600, 7200, 10800], [2005303, 7200, 10800, 7200], [2006085, 3600, 7200, 10800], [2006302, 7200, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011087, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014090, 10800, 7200, 10800], [2014299, 14400, 10800, 7200], [2015088, 10800, 7200, 10800], [2015312, 14400, 10800, 7200], [2016087, 10800, 7200, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurbu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurbu$.prototype.constructor = $c_Lzonedb_java_tzdb$eurbu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurbu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurbu$.prototype = $c_Lzonedb_java_tzdb$eurbu$.prototype;
var $d_Lzonedb_java_tzdb$eurbu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurbu$: 0
}, false, "zonedb.java.tzdb$eurbu$", {
  Lzonedb_java_tzdb$eurbu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurbu$.prototype.$classData = $d_Lzonedb_java_tzdb$eurbu$;
var $n_Lzonedb_java_tzdb$eurbu$;
function $m_Lzonedb_java_tzdb$eurbu$() {
  if ((!$n_Lzonedb_java_tzdb$eurbu$)) {
    $n_Lzonedb_java_tzdb$eurbu$ = new $c_Lzonedb_java_tzdb$eurbu$()
  };
  return $n_Lzonedb_java_tzdb$eurbu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurco$() {
  this.Lzonedb_java_tzdb$eurco$__f_Europe_Moscow = null;
  $n_Lzonedb_java_tzdb$eurco$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 9017);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 9017);
  var _2 = [[1916185, 0, 9017, 9079], [1919182, 9079, 9079, 10800], [1922274, 0, 10800, 7200], [1930172, 0, 7200, 10800], [1991090, 7200, 10800, 7200], [1992019, 7200, 7200, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916185, 0, 9017, 9079], [1917182, 82800, 9079, 12679], [1917362, 0, 12679, 9079], [1918151, 79200, 9079, 16279], [1918259, 3600, 16279, 12679], [1919151, 82800, 12679, 16279], [1919182, 16279, 16279, 14400], [1919228, 0, 14400, 10800], [1921045, 82800, 10800, 14400], [1921079, 82800, 14400, 18000], [1921244, 0, 18000, 14400], [1921274, 0, 14400, 10800], [1922274, 0, 10800, 7200], [1930172, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992019, 7200, 7200, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurco$__f_Europe_Moscow = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurco$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurco$.prototype.constructor = $c_Lzonedb_java_tzdb$eurco$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurco$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurco$.prototype = $c_Lzonedb_java_tzdb$eurco$.prototype;
var $d_Lzonedb_java_tzdb$eurco$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurco$: 0
}, false, "zonedb.java.tzdb$eurco$", {
  Lzonedb_java_tzdb$eurco$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurco$.prototype.$classData = $d_Lzonedb_java_tzdb$eurco$;
var $n_Lzonedb_java_tzdb$eurco$;
function $m_Lzonedb_java_tzdb$eurco$() {
  if ((!$n_Lzonedb_java_tzdb$eurco$)) {
    $n_Lzonedb_java_tzdb$eurco$ = new $c_Lzonedb_java_tzdb$eurco$()
  };
  return $n_Lzonedb_java_tzdb$eurco$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurda$() {
  this.Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam = null;
  $n_Lzonedb_java_tzdb$eurda$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 1172);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 1172);
  var _2 = [[1937181, 82800, 1172, 1200], [1940137, 0, 1200, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916122, 0, 1172, 4772], [1916275, 0, 4772, 1172], [1917106, 7200, 1172, 4772], [1917260, 10800, 4772, 1172], [1918091, 7200, 1172, 4772], [1918273, 10800, 4772, 1172], [1919097, 7200, 1172, 4772], [1919272, 10800, 4772, 1172], [1920096, 7200, 1172, 4772], [1920271, 10800, 4772, 1172], [1921094, 7200, 1172, 4772], [1921269, 10800, 4772, 1172], [1922085, 7200, 1172, 4772], [1922281, 10800, 4772, 1172], [1923152, 7200, 1172, 4772], [1923280, 10800, 4772, 1172], [1924090, 7200, 1172, 4772], [1924279, 10800, 4772, 1172], [1925156, 7200, 1172, 4772], [1925277, 10800, 4772, 1172], [1926135, 7200, 1172, 4772], [1926276, 10800, 4772, 1172], [1927135, 7200, 1172, 4772], [1927275, 10800, 4772, 1172], [1928136, 7200, 1172, 4772], [1928281, 10800, 4772, 1172], [1929135, 7200, 1172, 4772], [1929279, 10800, 4772, 1172], [1930135, 7200, 1172, 4772], [1930278, 10800, 4772, 1172], [1931135, 7200, 1172, 4772], [1931277, 10800, 4772, 1172], [1932143, 7200, 1172, 4772], [1932276, 10800, 4772, 1172], [1933135, 7200, 1172, 4772], [1933281, 10800, 4772, 1172], [1934135, 7200, 1172, 4772], [1934280, 10800, 4772, 1172], [1935135, 7200, 1172, 4772], [1935279, 10800, 4772, 1172], [1936136, 7200, 1172, 4772], [1936278, 10800, 4772, 1172], [1937142, 7200, 1172, 4772], [1937182, 0, 4772, 4800], [1937276, 10800, 4800, 1200], [1938135, 7200, 1200, 4800], [1938275, 10800, 4800, 1200], [1939135, 7200, 1200, 4800], [1939281, 10800, 4800, 1200], [1940137, 0, 1200, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurda$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurda$.prototype.constructor = $c_Lzonedb_java_tzdb$eurda$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurda$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurda$.prototype = $c_Lzonedb_java_tzdb$eurda$.prototype;
var $d_Lzonedb_java_tzdb$eurda$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurda$: 0
}, false, "zonedb.java.tzdb$eurda$", {
  Lzonedb_java_tzdb$eurda$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurda$.prototype.$classData = $d_Lzonedb_java_tzdb$eurda$;
var $n_Lzonedb_java_tzdb$eurda$;
function $m_Lzonedb_java_tzdb$eurda$() {
  if ((!$n_Lzonedb_java_tzdb$eurda$)) {
    $n_Lzonedb_java_tzdb$eurda$ = new $c_Lzonedb_java_tzdb$eurda$()
  };
  return $n_Lzonedb_java_tzdb$eurda$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurdo$() {
  this.Lzonedb_java_tzdb$eurdo$__f_Europe_London = null;
  $n_Lzonedb_java_tzdb$eurdo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-75));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-75));
  var _2 = [[1847335, 0, (-75), 0], [1968300, 82800, 0, 3600], [1971304, 10800, 3600, 0]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1847335, 0, (-75), 0], [1916142, 7200, 0, 3600], [1916275, 10800, 3600, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1941124, 7200, 3600, 7200], [1941222, 10800, 7200, 3600], [1942095, 7200, 3600, 7200], [1942221, 10800, 7200, 3600], [1943094, 7200, 3600, 7200], [1943227, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945196, 10800, 7200, 3600], [1945280, 10800, 3600, 0], [1946104, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947103, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1947306, 10800, 3600, 0], [1948074, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958110, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959109, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960101, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961085, 7200, 0, 3600], [1961302, 10800, 3600, 0], [1962084, 7200, 0, 3600], [1962301, 10800, 3600, 0], [1963090, 7200, 0, 3600], [1963300, 10800, 3600, 0], [1964082, 7200, 0, 3600], [1964299, 10800, 3600, 0], [1965080, 7200, 0, 3600], [1965297, 10800, 3600, 0], [1966079, 7200, 0, 3600], [1966296, 10800, 3600, 0], [1967078, 7200, 0, 3600], [1967302, 10800, 3600, 0], [1968049, 7200, 0, 3600], [1971304, 10800, 3600, 0], [1972079, 7200, 0, 3600], [1972303, 10800, 3600, 0], [1973077, 7200, 0, 3600], [1973301, 10800, 3600, 0], [1974076, 7200, 0, 3600], [1974300, 10800, 3600, 0], [1975075, 7200, 0, 3600], [1975299, 10800, 3600, 0], [1976081, 7200, 0, 3600], [1976298, 10800, 3600, 0], [1977079, 7200, 0, 3600], [1977296, 10800, 3600, 0], [1978078, 7200, 0, 3600], [1978302, 10800, 3600, 0], [1979077, 7200, 0, 3600], [1979301, 10800, 3600, 0], [1980076, 7200, 0, 3600], [1980300, 10800, 3600, 0], [1981088, 3600, 0, 3600], [1981298, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982297, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983296, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984302, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985300, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986299, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987298, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988297, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989302, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990301, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991300, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992299, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993297, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994296, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995295, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurdo$__f_Europe_London = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurdo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurdo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurdo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurdo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurdo$.prototype = $c_Lzonedb_java_tzdb$eurdo$.prototype;
var $d_Lzonedb_java_tzdb$eurdo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurdo$: 0
}, false, "zonedb.java.tzdb$eurdo$", {
  Lzonedb_java_tzdb$eurdo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurdo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurdo$;
var $n_Lzonedb_java_tzdb$eurdo$;
function $m_Lzonedb_java_tzdb$eurdo$() {
  if ((!$n_Lzonedb_java_tzdb$eurdo$)) {
    $n_Lzonedb_java_tzdb$eurdo$ = new $c_Lzonedb_java_tzdb$eurdo$()
  };
  return $n_Lzonedb_java_tzdb$eurdo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurel$() {
  this.Lzonedb_java_tzdb$eurel$__f_Europe_Brussels = null;
  $n_Lzonedb_java_tzdb$eurel$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 1050);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 1050);
  var _2 = [[1892122, 1050, 1050, 0], [1914312, 0, 0, 3600], [1918315, 43200, 3600, 0], [1940141, 7200, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1892122, 1050, 1050, 0], [1914312, 0, 0, 3600], [1916122, 0, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1918315, 43200, 3600, 0], [1919060, 82800, 0, 3600], [1919278, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923111, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932094, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933085, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934098, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935090, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937094, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938086, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1940141, 10800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1946139, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurel$__f_Europe_Brussels = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurel$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurel$.prototype.constructor = $c_Lzonedb_java_tzdb$eurel$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurel$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurel$.prototype = $c_Lzonedb_java_tzdb$eurel$.prototype;
var $d_Lzonedb_java_tzdb$eurel$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurel$: 0
}, false, "zonedb.java.tzdb$eurel$", {
  Lzonedb_java_tzdb$eurel$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurel$.prototype.$classData = $d_Lzonedb_java_tzdb$eurel$;
var $n_Lzonedb_java_tzdb$eurel$;
function $m_Lzonedb_java_tzdb$eurel$() {
  if ((!$n_Lzonedb_java_tzdb$eurel$)) {
    $n_Lzonedb_java_tzdb$eurel$ = new $c_Lzonedb_java_tzdb$eurel$()
  };
  return $n_Lzonedb_java_tzdb$eurel$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euren$() {
  this.Lzonedb_java_tzdb$euren$__f_Europe_Athens = null;
  $n_Lzonedb_java_tzdb$euren$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5692);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5692);
  var _2 = [[1916210, 60, 5692, 7200], [1941119, 82800, 7200, 3600], [1944095, 0, 3600, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1916210, 60, 5692, 7200], [1932189, 0, 7200, 10800], [1932245, 0, 10800, 7200], [1941097, 0, 7200, 10800], [1941120, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943089, 0, 3600, 7200], [1943277, 0, 7200, 3600], [1944095, 0, 3600, 7200], [1952183, 0, 7200, 10800], [1952307, 0, 10800, 7200], [1975102, 0, 7200, 10800], [1975330, 3600, 10800, 7200], [1976102, 7200, 7200, 10800], [1976284, 10800, 10800, 7200], [1977093, 7200, 7200, 10800], [1977269, 10800, 10800, 7200], [1978092, 7200, 7200, 10800], [1978267, 14400, 10800, 7200], [1979091, 32400, 7200, 10800], [1979272, 7200, 10800, 7200], [1980092, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 10800, 7200, 10800], [1981270, 14400, 10800, 7200], [1982087, 10800, 7200, 10800], [1982269, 14400, 10800, 7200], [1983086, 10800, 7200, 10800], [1983268, 14400, 10800, 7200], [1984085, 10800, 7200, 10800], [1984274, 14400, 10800, 7200], [1985090, 10800, 7200, 10800], [1985272, 14400, 10800, 7200], [1986089, 10800, 7200, 10800], [1986271, 14400, 10800, 7200], [1987088, 10800, 7200, 10800], [1987270, 14400, 10800, 7200], [1988087, 10800, 7200, 10800], [1988269, 14400, 10800, 7200], [1989085, 10800, 7200, 10800], [1989267, 14400, 10800, 7200], [1990084, 10800, 7200, 10800], [1990273, 14400, 10800, 7200], [1991090, 10800, 7200, 10800], [1991272, 14400, 10800, 7200], [1992089, 10800, 7200, 10800], [1992271, 14400, 10800, 7200], [1993087, 10800, 7200, 10800], [1993269, 14400, 10800, 7200], [1994086, 10800, 7200, 10800], [1994268, 14400, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$euren$__f_Europe_Athens = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$euren$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euren$.prototype.constructor = $c_Lzonedb_java_tzdb$euren$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euren$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euren$.prototype = $c_Lzonedb_java_tzdb$euren$.prototype;
var $d_Lzonedb_java_tzdb$euren$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euren$: 0
}, false, "zonedb.java.tzdb$euren$", {
  Lzonedb_java_tzdb$euren$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euren$.prototype.$classData = $d_Lzonedb_java_tzdb$euren$;
var $n_Lzonedb_java_tzdb$euren$;
function $m_Lzonedb_java_tzdb$euren$() {
  if ((!$n_Lzonedb_java_tzdb$euren$)) {
    $n_Lzonedb_java_tzdb$euren$ = new $c_Lzonedb_java_tzdb$euren$()
  };
  return $n_Lzonedb_java_tzdb$euren$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eures$() {
  this.Lzonedb_java_tzdb$eures$__f_Europe_Bucharest = null;
  this.Lzonedb_java_tzdb$eures$__f_Europe_Budapest = null;
  $n_Lzonedb_java_tzdb$eures$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6264);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6264);
  var _2 = [[1931205, 0, 6264, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931205, 0, 6264, 7200], [1932142, 0, 7200, 10800], [1932276, 3600, 10800, 7200], [1933092, 0, 7200, 10800], [1933274, 3600, 10800, 7200], [1934098, 0, 7200, 10800], [1934280, 3600, 10800, 7200], [1935097, 0, 7200, 10800], [1935279, 3600, 10800, 7200], [1936096, 0, 7200, 10800], [1936278, 3600, 10800, 7200], [1937094, 0, 7200, 10800], [1937276, 3600, 10800, 7200], [1938093, 0, 7200, 10800], [1938275, 3600, 10800, 7200], [1939092, 0, 7200, 10800], [1939274, 3600, 10800, 7200], [1979147, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980096, 82800, 7200, 10800], [1980272, 3600, 10800, 7200], [1981088, 7200, 7200, 10800], [1981270, 10800, 10800, 7200], [1982087, 7200, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 7200, 7200, 10800], [1983268, 10800, 10800, 7200], [1984085, 7200, 7200, 10800], [1984274, 10800, 10800, 7200], [1985090, 7200, 7200, 10800], [1985272, 10800, 10800, 7200], [1986089, 7200, 7200, 10800], [1986271, 10800, 10800, 7200], [1987088, 7200, 7200, 10800], [1987270, 10800, 10800, 7200], [1988087, 7200, 7200, 10800], [1988269, 10800, 10800, 7200], [1989085, 7200, 7200, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 3600, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 3600, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 3600, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eures$__f_Europe_Bucharest = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 4580);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 4580);
  var _2$3 = [[1890274, 0, 4580, 3600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1890274, 0, 4580, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918091, 10800, 3600, 7200], [1918259, 10800, 7200, 3600], [1919105, 10800, 3600, 7200], [1919328, 10800, 7200, 3600], [1941098, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945121, 82800, 3600, 7200], [1945305, 0, 7200, 3600], [1946090, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947096, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948095, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1950107, 7200, 3600, 7200], [1950296, 10800, 7200, 3600], [1954143, 0, 3600, 7200], [1954276, 0, 7200, 3600], [1955143, 0, 3600, 7200], [1955276, 0, 7200, 3600], [1956155, 0, 3600, 7200], [1956274, 0, 7200, 3600], [1957153, 3600, 3600, 7200], [1957272, 10800, 7200, 3600], [1980097, 3600, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$eures$__f_Europe_Budapest = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$eures$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eures$.prototype.constructor = $c_Lzonedb_java_tzdb$eures$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eures$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eures$.prototype = $c_Lzonedb_java_tzdb$eures$.prototype;
var $d_Lzonedb_java_tzdb$eures$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eures$: 0
}, false, "zonedb.java.tzdb$eures$", {
  Lzonedb_java_tzdb$eures$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eures$.prototype.$classData = $d_Lzonedb_java_tzdb$eures$;
var $n_Lzonedb_java_tzdb$eures$;
function $m_Lzonedb_java_tzdb$eures$() {
  if ((!$n_Lzonedb_java_tzdb$eures$)) {
    $n_Lzonedb_java_tzdb$eures$ = new $c_Lzonedb_java_tzdb$eures$()
  };
  return $n_Lzonedb_java_tzdb$eures$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurfi$() {
  this.Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia = null;
  $n_Lzonedb_java_tzdb$eurfi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5596);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5596);
  var _2 = [[1880001, 0, 5596, 7016], [1894334, 0, 7016, 7200], [1942306, 10800, 7200, 3600], [1945092, 10800, 3600, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 5596, 7016], [1894334, 0, 7016, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 10800, 3600, 7200], [1979090, 82800, 7200, 10800], [1979274, 3600, 10800, 7200], [1980096, 82800, 7200, 10800], [1980273, 3600, 10800, 7200], [1981094, 82800, 7200, 10800], [1981270, 7200, 10800, 7200], [1982093, 82800, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 7200, 7200, 10800], [1983268, 10800, 10800, 7200], [1984085, 7200, 7200, 10800], [1984274, 10800, 10800, 7200], [1985090, 7200, 7200, 10800], [1985272, 10800, 10800, 7200], [1986089, 7200, 7200, 10800], [1986271, 10800, 10800, 7200], [1987088, 7200, 7200, 10800], [1987270, 10800, 10800, 7200], [1988087, 7200, 7200, 10800], [1988269, 10800, 10800, 7200], [1989085, 7200, 7200, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurfi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurfi$.prototype.constructor = $c_Lzonedb_java_tzdb$eurfi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurfi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurfi$.prototype = $c_Lzonedb_java_tzdb$eurfi$.prototype;
var $d_Lzonedb_java_tzdb$eurfi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurfi$: 0
}, false, "zonedb.java.tzdb$eurfi$", {
  Lzonedb_java_tzdb$eurfi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurfi$.prototype.$classData = $d_Lzonedb_java_tzdb$eurfi$;
var $n_Lzonedb_java_tzdb$eurfi$;
function $m_Lzonedb_java_tzdb$eurfi$() {
  if ((!$n_Lzonedb_java_tzdb$eurfi$)) {
    $n_Lzonedb_java_tzdb$eurfi$ = new $c_Lzonedb_java_tzdb$eurfi$()
  };
  return $n_Lzonedb_java_tzdb$eurfi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurge$() {
  this.Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen = null;
  $n_Lzonedb_java_tzdb$eurge$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3020);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3020);
  var _2 = [[1894001, 0, 3020, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1894001, 0, 3020, 3600], [1916135, 82800, 3600, 7200], [1916274, 82800, 7200, 3600], [1940136, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945227, 10800, 7200, 3600], [1946121, 7200, 3600, 7200], [1946244, 10800, 7200, 3600], [1947124, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1948130, 7200, 3600, 7200], [1948221, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurge$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurge$.prototype.constructor = $c_Lzonedb_java_tzdb$eurge$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurge$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurge$.prototype = $c_Lzonedb_java_tzdb$eurge$.prototype;
var $d_Lzonedb_java_tzdb$eurge$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurge$: 0
}, false, "zonedb.java.tzdb$eurge$", {
  Lzonedb_java_tzdb$eurge$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurge$.prototype.$classData = $d_Lzonedb_java_tzdb$eurge$;
var $n_Lzonedb_java_tzdb$eurge$;
function $m_Lzonedb_java_tzdb$eurge$() {
  if ((!$n_Lzonedb_java_tzdb$eurge$)) {
    $n_Lzonedb_java_tzdb$eurge$ = new $c_Lzonedb_java_tzdb$eurge$()
  };
  return $n_Lzonedb_java_tzdb$eurge$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurgu$() {
  this.Lzonedb_java_tzdb$eurgu$__f_Europe_Prague = null;
  $n_Lzonedb_java_tzdb$eurgu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3464);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3464);
  var _2 = [[1891274, 0, 3464, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1891274, 0, 3464, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945274, 10800, 7200, 3600], [1946126, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1946335, 10800, 3600, 0], [1947054, 7200, 0, 3600], [1947110, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949099, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurgu$__f_Europe_Prague = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurgu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurgu$.prototype.constructor = $c_Lzonedb_java_tzdb$eurgu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurgu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurgu$.prototype = $c_Lzonedb_java_tzdb$eurgu$.prototype;
var $d_Lzonedb_java_tzdb$eurgu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurgu$: 0
}, false, "zonedb.java.tzdb$eurgu$", {
  Lzonedb_java_tzdb$eurgu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurgu$.prototype.$classData = $d_Lzonedb_java_tzdb$eurgu$;
var $n_Lzonedb_java_tzdb$eurgu$;
function $m_Lzonedb_java_tzdb$eurgu$() {
  if ((!$n_Lzonedb_java_tzdb$eurgu$)) {
    $n_Lzonedb_java_tzdb$eurgu$ = new $c_Lzonedb_java_tzdb$eurgu$()
  };
  return $n_Lzonedb_java_tzdb$eurgu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurha$() {
  this.Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan = null;
  $n_Lzonedb_java_tzdb$eurha$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 11532);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 11532);
  var _2 = [[1924122, 0, 11532, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924122, 0, 11532, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurha$.prototype.constructor = $c_Lzonedb_java_tzdb$eurha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurha$.prototype = $c_Lzonedb_java_tzdb$eurha$.prototype;
var $d_Lzonedb_java_tzdb$eurha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurha$: 0
}, false, "zonedb.java.tzdb$eurha$", {
  Lzonedb_java_tzdb$eurha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurha$.prototype.$classData = $d_Lzonedb_java_tzdb$eurha$;
var $n_Lzonedb_java_tzdb$eurha$;
function $m_Lzonedb_java_tzdb$eurha$() {
  if ((!$n_Lzonedb_java_tzdb$eurha$)) {
    $n_Lzonedb_java_tzdb$eurha$ = new $c_Lzonedb_java_tzdb$eurha$()
  };
  return $n_Lzonedb_java_tzdb$eurha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurhy$() {
  this.Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye = null;
  $n_Lzonedb_java_tzdb$eurhy$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8440);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8440);
  var _2 = [[1880001, 0, 8440, 8400], [1924123, 0, 8400, 7200], [1930172, 0, 7200, 10800], [1941237, 0, 10800, 3600], [1943298, 0, 3600, 10800], [1991090, 7200, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 8440, 8400], [1924123, 0, 8400, 7200], [1930172, 0, 7200, 10800], [1941237, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1943298, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurhy$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurhy$.prototype.constructor = $c_Lzonedb_java_tzdb$eurhy$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurhy$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurhy$.prototype = $c_Lzonedb_java_tzdb$eurhy$.prototype;
var $d_Lzonedb_java_tzdb$eurhy$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurhy$: 0
}, false, "zonedb.java.tzdb$eurhy$", {
  Lzonedb_java_tzdb$eurhy$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurhy$.prototype.$classData = $d_Lzonedb_java_tzdb$eurhy$;
var $n_Lzonedb_java_tzdb$eurhy$;
function $m_Lzonedb_java_tzdb$eurhy$() {
  if ((!$n_Lzonedb_java_tzdb$eurhy$)) {
    $n_Lzonedb_java_tzdb$eurhy$ = new $c_Lzonedb_java_tzdb$eurhy$()
  };
  return $n_Lzonedb_java_tzdb$eurhy$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euric$() {
  this.Lzonedb_java_tzdb$euric$__f_Europe_Zurich = null;
  $n_Lzonedb_java_tzdb$euric$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 2048);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 2048);
  var _2 = [[1853197, 0, 2048, 1786], [1894152, 0, 1786, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1853197, 0, 2048, 1786], [1894152, 0, 1786, 3600], [1941125, 3600, 3600, 7200], [1941279, 7200, 7200, 3600], [1942124, 3600, 3600, 7200], [1942278, 7200, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$euric$__f_Europe_Zurich = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$euric$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euric$.prototype.constructor = $c_Lzonedb_java_tzdb$euric$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euric$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euric$.prototype = $c_Lzonedb_java_tzdb$euric$.prototype;
var $d_Lzonedb_java_tzdb$euric$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euric$: 0
}, false, "zonedb.java.tzdb$euric$", {
  Lzonedb_java_tzdb$euric$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euric$.prototype.$classData = $d_Lzonedb_java_tzdb$euric$;
var $n_Lzonedb_java_tzdb$euric$;
function $m_Lzonedb_java_tzdb$euric$() {
  if ((!$n_Lzonedb_java_tzdb$euric$)) {
    $n_Lzonedb_java_tzdb$euric$ = new $c_Lzonedb_java_tzdb$euric$()
  };
  return $n_Lzonedb_java_tzdb$euric$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurie$() {
  this.Lzonedb_java_tzdb$eurie$__f_Europe_Kiev = null;
  $n_Lzonedb_java_tzdb$eurie$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 7324);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 7324);
  var _2 = [[1924123, 0, 7324, 7200], [1930172, 0, 7200, 10800], [1941263, 0, 10800, 3600], [1943310, 0, 3600, 10800], [1990182, 3600, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1924123, 0, 7324, 7200], [1930172, 0, 7200, 10800], [1941263, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1943310, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990182, 7200, 14400, 10800], [1991272, 10800, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurie$__f_Europe_Kiev = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurie$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurie$.prototype.constructor = $c_Lzonedb_java_tzdb$eurie$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurie$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurie$.prototype = $c_Lzonedb_java_tzdb$eurie$.prototype;
var $d_Lzonedb_java_tzdb$eurie$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurie$: 0
}, false, "zonedb.java.tzdb$eurie$", {
  Lzonedb_java_tzdb$eurie$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurie$.prototype.$classData = $d_Lzonedb_java_tzdb$eurie$;
var $n_Lzonedb_java_tzdb$eurie$;
function $m_Lzonedb_java_tzdb$eurie$() {
  if ((!$n_Lzonedb_java_tzdb$eurie$)) {
    $n_Lzonedb_java_tzdb$eurie$ = new $c_Lzonedb_java_tzdb$eurie$()
  };
  return $n_Lzonedb_java_tzdb$eurie$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurig$() {
  this.Lzonedb_java_tzdb$eurig$__f_Europe_Riga = null;
  $n_Lzonedb_java_tzdb$eurig$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5794);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5794);
  var _2 = [[1926131, 0, 5794, 7200], [1940218, 0, 7200, 10800], [1941182, 0, 10800, 3600], [1944287, 0, 3600, 10800], [1989085, 7200, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1918105, 7200, 5794, 9394], [1918259, 10800, 9394, 5794], [1919091, 7200, 5794, 9394], [1919142, 10800, 9394, 5794], [1926131, 0, 5794, 7200], [1940218, 0, 7200, 10800], [1941182, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1944287, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996273, 10800, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurig$__f_Europe_Riga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurig$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurig$.prototype.constructor = $c_Lzonedb_java_tzdb$eurig$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurig$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurig$.prototype = $c_Lzonedb_java_tzdb$eurig$.prototype;
var $d_Lzonedb_java_tzdb$eurig$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurig$: 0
}, false, "zonedb.java.tzdb$eurig$", {
  Lzonedb_java_tzdb$eurig$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurig$.prototype.$classData = $d_Lzonedb_java_tzdb$eurig$;
var $n_Lzonedb_java_tzdb$eurig$;
function $m_Lzonedb_java_tzdb$eurig$() {
  if ((!$n_Lzonedb_java_tzdb$eurig$)) {
    $n_Lzonedb_java_tzdb$eurig$ = new $c_Lzonedb_java_tzdb$eurig$()
  };
  return $n_Lzonedb_java_tzdb$eurig$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurin$() {
  this.Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn = null;
  $n_Lzonedb_java_tzdb$eurin$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5940);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5940);
  var _2 = [[1918032, 0, 5940, 3600], [1919182, 0, 3600, 5940], [1921121, 0, 5940, 7200], [1940219, 0, 7200, 10800], [1941258, 0, 10800, 3600], [1944265, 82800, 3600, 10800], [1989085, 7200, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1918032, 0, 5940, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1919182, 0, 3600, 5940], [1921121, 0, 5940, 7200], [1940219, 0, 7200, 10800], [1941258, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944266, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurin$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurin$.prototype.constructor = $c_Lzonedb_java_tzdb$eurin$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurin$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurin$.prototype = $c_Lzonedb_java_tzdb$eurin$.prototype;
var $d_Lzonedb_java_tzdb$eurin$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurin$: 0
}, false, "zonedb.java.tzdb$eurin$", {
  Lzonedb_java_tzdb$eurin$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurin$.prototype.$classData = $d_Lzonedb_java_tzdb$eurin$;
var $n_Lzonedb_java_tzdb$eurin$;
function $m_Lzonedb_java_tzdb$eurin$() {
  if ((!$n_Lzonedb_java_tzdb$eurin$)) {
    $n_Lzonedb_java_tzdb$eurin$ = new $c_Lzonedb_java_tzdb$eurin$()
  };
  return $n_Lzonedb_java_tzdb$eurin$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euriu$() {
  this.Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius = null;
  $n_Lzonedb_java_tzdb$euriu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6076);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6076);
  var _2 = [[1880001, 0, 6076, 5040], [1917001, 0, 5040, 5736], [1919283, 0, 5736, 3600], [1920194, 0, 3600, 7200], [1920283, 0, 7200, 3600], [1940216, 0, 3600, 10800], [1941175, 0, 10800, 3600], [1944213, 82800, 3600, 10800], [1989085, 7200, 10800, 7200], [1998088, 10800, 7200, 3600], [1999304, 7200, 3600, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 6076, 5040], [1917001, 0, 5040, 5736], [1919283, 0, 5736, 3600], [1920194, 0, 3600, 7200], [1920283, 0, 7200, 3600], [1940216, 0, 3600, 10800], [1941175, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944214, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998298, 10800, 7200, 3600], [1999087, 7200, 3600, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$euriu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euriu$.prototype.constructor = $c_Lzonedb_java_tzdb$euriu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euriu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euriu$.prototype = $c_Lzonedb_java_tzdb$euriu$.prototype;
var $d_Lzonedb_java_tzdb$euriu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euriu$: 0
}, false, "zonedb.java.tzdb$euriu$", {
  Lzonedb_java_tzdb$euriu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euriu$.prototype.$classData = $d_Lzonedb_java_tzdb$euriu$;
var $n_Lzonedb_java_tzdb$euriu$;
function $m_Lzonedb_java_tzdb$euriu$() {
  if ((!$n_Lzonedb_java_tzdb$euriu$)) {
    $n_Lzonedb_java_tzdb$euriu$ = new $c_Lzonedb_java_tzdb$euriu$()
  };
  return $n_Lzonedb_java_tzdb$euriu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurli$() {
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Berlin = null;
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Dublin = null;
  $n_Lzonedb_java_tzdb$eurli$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3208);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3208);
  var _2 = [[1893091, 0, 3208, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1893091, 0, 3208, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945144, 7200, 7200, 10800], [1945267, 10800, 10800, 7200], [1945322, 10800, 7200, 3600], [1946104, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1947096, 10800, 3600, 7200], [1947131, 10800, 7200, 10800], [1947180, 10800, 10800, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Berlin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", (-1500));
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", (-1500));
  var _2$3 = [[1880215, 0, (-1500), (-1521)], [1916275, 7200, (-1521), 0], [1968300, 82800, 0, 3600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1880215, 0, (-1500), (-1521)], [1916142, 7200, (-1521), 2079], [1916275, 10800, 2079, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947306, 10800, 3600, 0], [1948109, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958110, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959109, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960101, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961085, 7200, 0, 3600], [1961302, 10800, 3600, 0], [1962084, 7200, 0, 3600], [1962301, 10800, 3600, 0], [1963090, 7200, 0, 3600], [1963300, 10800, 3600, 0], [1964082, 7200, 0, 3600], [1964299, 10800, 3600, 0], [1965080, 7200, 0, 3600], [1965297, 10800, 3600, 0], [1966079, 7200, 0, 3600], [1966296, 10800, 3600, 0], [1967078, 7200, 0, 3600], [1967302, 10800, 3600, 0], [1968049, 7200, 0, 3600], [1971304, 10800, 3600, 0], [1972079, 7200, 0, 3600], [1972303, 10800, 3600, 0], [1973077, 7200, 0, 3600], [1973301, 10800, 3600, 0], [1974076, 7200, 0, 3600], [1974300, 10800, 3600, 0], [1975075, 7200, 0, 3600], [1975299, 10800, 3600, 0], [1976081, 7200, 0, 3600], [1976298, 10800, 3600, 0], [1977079, 7200, 0, 3600], [1977296, 10800, 3600, 0], [1978078, 7200, 0, 3600], [1978302, 10800, 3600, 0], [1979077, 7200, 0, 3600], [1979301, 10800, 3600, 0], [1980076, 7200, 0, 3600], [1980300, 10800, 3600, 0], [1981088, 3600, 0, 3600], [1981298, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982297, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983296, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984302, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985300, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986299, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987298, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988297, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989302, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990301, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991300, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992299, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993297, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994296, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995295, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 25, 7, 3600, 0, 0, 3600, 0, 3600], [10, 25, 7, 3600, 0, 0, 3600, 3600, 0]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Dublin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$eurli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurli$.prototype.constructor = $c_Lzonedb_java_tzdb$eurli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurli$.prototype = $c_Lzonedb_java_tzdb$eurli$.prototype;
var $d_Lzonedb_java_tzdb$eurli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurli$: 0
}, false, "zonedb.java.tzdb$eurli$", {
  Lzonedb_java_tzdb$eurli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurli$.prototype.$classData = $d_Lzonedb_java_tzdb$eurli$;
var $n_Lzonedb_java_tzdb$eurli$;
function $m_Lzonedb_java_tzdb$eurli$() {
  if ((!$n_Lzonedb_java_tzdb$eurli$)) {
    $n_Lzonedb_java_tzdb$eurli$ = new $c_Lzonedb_java_tzdb$eurli$()
  };
  return $n_Lzonedb_java_tzdb$eurli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurlt$() {
  this.Lzonedb_java_tzdb$eurlt$__f_Europe_Malta = null;
  $n_Lzonedb_java_tzdb$eurlt$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3484);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3484);
  var _2 = [[1893306, 0, 3484, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1893306, 0, 3484, 3600], [1916156, 0, 3600, 7200], [1916275, 0, 7200, 3600], [1917091, 0, 3600, 7200], [1917274, 0, 7200, 3600], [1918069, 0, 3600, 7200], [1918280, 0, 7200, 3600], [1919061, 0, 3600, 7200], [1919278, 0, 7200, 3600], [1920081, 0, 3600, 7200], [1920263, 0, 7200, 3600], [1940167, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945258, 3600, 7200, 3600], [1946076, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947075, 0, 3600, 7200], [1947278, 3600, 7200, 3600], [1948060, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1966142, 0, 3600, 7200], [1966268, 0, 7200, 3600], [1967148, 0, 3600, 7200], [1967267, 3600, 7200, 3600], [1968147, 0, 3600, 7200], [1968266, 3600, 7200, 3600], [1969152, 0, 3600, 7200], [1969271, 3600, 7200, 3600], [1970151, 0, 3600, 7200], [1970270, 3600, 7200, 3600], [1971143, 0, 3600, 7200], [1971269, 3600, 7200, 3600], [1972149, 0, 3600, 7200], [1972275, 3600, 7200, 3600], [1973090, 0, 3600, 7200], [1973272, 3600, 7200, 3600], [1974111, 0, 3600, 7200], [1974259, 3600, 7200, 3600], [1975110, 7200, 3600, 7200], [1975264, 7200, 7200, 3600], [1976109, 7200, 3600, 7200], [1976263, 7200, 7200, 3600], [1977107, 7200, 3600, 7200], [1977261, 7200, 7200, 3600], [1978106, 7200, 3600, 7200], [1978260, 7200, 7200, 3600], [1979105, 7200, 3600, 7200], [1979259, 7200, 7200, 3600], [1980091, 7200, 3600, 7200], [1980265, 7200, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurlt$__f_Europe_Malta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurlt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurlt$.prototype.constructor = $c_Lzonedb_java_tzdb$eurlt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurlt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurlt$.prototype = $c_Lzonedb_java_tzdb$eurlt$.prototype;
var $d_Lzonedb_java_tzdb$eurlt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurlt$: 0
}, false, "zonedb.java.tzdb$eurlt$", {
  Lzonedb_java_tzdb$eurlt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurlt$.prototype.$classData = $d_Lzonedb_java_tzdb$eurlt$;
var $n_Lzonedb_java_tzdb$eurlt$;
function $m_Lzonedb_java_tzdb$eurlt$() {
  if ((!$n_Lzonedb_java_tzdb$eurlt$)) {
    $n_Lzonedb_java_tzdb$eurlt$ = new $c_Lzonedb_java_tzdb$eurlt$()
  };
  return $n_Lzonedb_java_tzdb$eurlt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurna$() {
  this.Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau = null;
  $n_Lzonedb_java_tzdb$eurna$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6920);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6920);
  var _2 = [[1880001, 0, 6920, 6900], [1918046, 0, 6900, 6264], [1931205, 0, 6264, 7200], [1941197, 82800, 7200, 3600], [1944236, 82800, 3600, 10800], [1990126, 3600, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 6920, 6900], [1918046, 0, 6900, 6264], [1931205, 0, 6264, 7200], [1932142, 0, 7200, 10800], [1932276, 3600, 10800, 7200], [1933092, 0, 7200, 10800], [1933274, 3600, 10800, 7200], [1934098, 0, 7200, 10800], [1934280, 3600, 10800, 7200], [1935097, 0, 7200, 10800], [1935279, 3600, 10800, 7200], [1936096, 0, 7200, 10800], [1936278, 3600, 10800, 7200], [1937094, 0, 7200, 10800], [1937276, 3600, 10800, 7200], [1938093, 0, 7200, 10800], [1938275, 3600, 10800, 7200], [1939092, 0, 7200, 10800], [1939274, 3600, 10800, 7200], [1940228, 0, 7200, 10800], [1941198, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944237, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990126, 7200, 14400, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 7200, 0, 1, 7200, 7200, 10800], [10, 25, 7, 10800, 0, 1, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurna$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurna$.prototype.constructor = $c_Lzonedb_java_tzdb$eurna$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurna$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurna$.prototype = $c_Lzonedb_java_tzdb$eurna$.prototype;
var $d_Lzonedb_java_tzdb$eurna$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurna$: 0
}, false, "zonedb.java.tzdb$eurna$", {
  Lzonedb_java_tzdb$eurna$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurna$.prototype.$classData = $d_Lzonedb_java_tzdb$eurna$;
var $n_Lzonedb_java_tzdb$eurna$;
function $m_Lzonedb_java_tzdb$eurna$() {
  if ((!$n_Lzonedb_java_tzdb$eurna$)) {
    $n_Lzonedb_java_tzdb$eurna$ = new $c_Lzonedb_java_tzdb$eurna$()
  };
  return $n_Lzonedb_java_tzdb$eurna$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurnk$() {
  this.Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki = null;
  $n_Lzonedb_java_tzdb$eurnk$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5989);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5989);
  var _2 = [[1921121, 0, 5989, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1921121, 0, 5989, 7200], [1942093, 0, 7200, 10800], [1942277, 3600, 10800, 7200], [1981088, 7200, 7200, 10800], [1981270, 10800, 10800, 7200], [1982087, 7200, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 10800, 7200, 10800], [1983268, 14400, 10800, 7200], [1984085, 10800, 7200, 10800], [1984274, 14400, 10800, 7200], [1985090, 10800, 7200, 10800], [1985272, 14400, 10800, 7200], [1986089, 10800, 7200, 10800], [1986271, 14400, 10800, 7200], [1987088, 10800, 7200, 10800], [1987270, 14400, 10800, 7200], [1988087, 10800, 7200, 10800], [1988269, 14400, 10800, 7200], [1989085, 10800, 7200, 10800], [1989267, 14400, 10800, 7200], [1990084, 10800, 7200, 10800], [1990273, 14400, 10800, 7200], [1991090, 10800, 7200, 10800], [1991272, 14400, 10800, 7200], [1992089, 10800, 7200, 10800], [1992271, 14400, 10800, 7200], [1993087, 10800, 7200, 10800], [1993269, 14400, 10800, 7200], [1994086, 10800, 7200, 10800], [1994268, 14400, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurnk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurnk$.prototype.constructor = $c_Lzonedb_java_tzdb$eurnk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurnk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurnk$.prototype = $c_Lzonedb_java_tzdb$eurnk$.prototype;
var $d_Lzonedb_java_tzdb$eurnk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurnk$: 0
}, false, "zonedb.java.tzdb$eurnk$", {
  Lzonedb_java_tzdb$eurnk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurnk$.prototype.$classData = $d_Lzonedb_java_tzdb$eurnk$;
var $n_Lzonedb_java_tzdb$eurnk$;
function $m_Lzonedb_java_tzdb$eurnk$() {
  if ((!$n_Lzonedb_java_tzdb$eurnk$)) {
    $n_Lzonedb_java_tzdb$eurnk$ = new $c_Lzonedb_java_tzdb$eurnk$()
  };
  return $n_Lzonedb_java_tzdb$eurnk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurnn$() {
  this.Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna = null;
  $n_Lzonedb_java_tzdb$eurnn$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 3921);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 3921);
  var _2 = [[1893091, 0, 3921, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1893091, 0, 3921, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1920096, 7200, 3600, 7200], [1920257, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945102, 10800, 7200, 3600], [1946104, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1947096, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1980097, 0, 3600, 7200], [1980272, 0, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurnn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurnn$.prototype.constructor = $c_Lzonedb_java_tzdb$eurnn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurnn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurnn$.prototype = $c_Lzonedb_java_tzdb$eurnn$.prototype;
var $d_Lzonedb_java_tzdb$eurnn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurnn$: 0
}, false, "zonedb.java.tzdb$eurnn$", {
  Lzonedb_java_tzdb$eurnn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurnn$.prototype.$classData = $d_Lzonedb_java_tzdb$eurnn$;
var $n_Lzonedb_java_tzdb$eurnn$;
function $m_Lzonedb_java_tzdb$eurnn$() {
  if ((!$n_Lzonedb_java_tzdb$eurnn$)) {
    $n_Lzonedb_java_tzdb$eurnn$ = new $c_Lzonedb_java_tzdb$eurnn$()
  };
  return $n_Lzonedb_java_tzdb$eurnn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurns$() {
  this.Lzonedb_java_tzdb$eurns$__f_Europe_Minsk = null;
  $n_Lzonedb_java_tzdb$eurns$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 6616);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 6616);
  var _2 = [[1880001, 0, 6616, 6600], [1924123, 0, 6600, 7200], [1930172, 0, 7200, 10800], [1941179, 0, 10800, 3600], [1944184, 82800, 3600, 10800], [1991090, 7200, 10800, 7200], [2011086, 7200, 7200, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 6616, 6600], [1924123, 0, 6600, 7200], [1930172, 0, 7200, 10800], [1941179, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944185, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200], [1999087, 7200, 7200, 10800], [1999304, 10800, 10800, 7200], [2000086, 7200, 7200, 10800], [2000303, 10800, 10800, 7200], [2001084, 7200, 7200, 10800], [2001301, 10800, 10800, 7200], [2002090, 7200, 7200, 10800], [2002300, 10800, 10800, 7200], [2003089, 7200, 7200, 10800], [2003299, 10800, 10800, 7200], [2004088, 7200, 7200, 10800], [2004305, 10800, 10800, 7200], [2005086, 7200, 7200, 10800], [2005303, 10800, 10800, 7200], [2006085, 7200, 7200, 10800], [2006302, 10800, 10800, 7200], [2007084, 7200, 7200, 10800], [2007301, 10800, 10800, 7200], [2008090, 7200, 7200, 10800], [2008300, 10800, 10800, 7200], [2009088, 7200, 7200, 10800], [2009298, 10800, 10800, 7200], [2010087, 7200, 7200, 10800], [2010304, 10800, 10800, 7200], [2011086, 7200, 7200, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurns$__f_Europe_Minsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurns$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurns$.prototype.constructor = $c_Lzonedb_java_tzdb$eurns$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurns$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurns$.prototype = $c_Lzonedb_java_tzdb$eurns$.prototype;
var $d_Lzonedb_java_tzdb$eurns$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurns$: 0
}, false, "zonedb.java.tzdb$eurns$", {
  Lzonedb_java_tzdb$eurns$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurns$.prototype.$classData = $d_Lzonedb_java_tzdb$eurns$;
var $n_Lzonedb_java_tzdb$eurns$;
function $m_Lzonedb_java_tzdb$eurns$() {
  if ((!$n_Lzonedb_java_tzdb$eurns$)) {
    $n_Lzonedb_java_tzdb$eurns$ = new $c_Lzonedb_java_tzdb$eurns$()
  };
  return $n_Lzonedb_java_tzdb$eurns$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurol$() {
  this.Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm = null;
  $n_Lzonedb_java_tzdb$eurol$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 4332);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 4332);
  var _2 = [[1879001, 0, 4332, 3614], [1900001, 0, 3614, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1879001, 0, 4332, 3614], [1900001, 0, 3614, 3600], [1916135, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurol$.prototype.constructor = $c_Lzonedb_java_tzdb$eurol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurol$.prototype = $c_Lzonedb_java_tzdb$eurol$.prototype;
var $d_Lzonedb_java_tzdb$eurol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurol$: 0
}, false, "zonedb.java.tzdb$eurol$", {
  Lzonedb_java_tzdb$eurol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurol$.prototype.$classData = $d_Lzonedb_java_tzdb$eurol$;
var $n_Lzonedb_java_tzdb$eurol$;
function $m_Lzonedb_java_tzdb$eurol$() {
  if ((!$n_Lzonedb_java_tzdb$eurol$)) {
    $n_Lzonedb_java_tzdb$eurol$ = new $c_Lzonedb_java_tzdb$eurol$()
  };
  return $n_Lzonedb_java_tzdb$eurol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurom$() {
  this.Lzonedb_java_tzdb$eurom$__f_Europe_Rome = null;
  $n_Lzonedb_java_tzdb$eurom$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 2996);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 2996);
  var _2 = [[1893304, 85796, 2996, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1893304, 85796, 2996, 3600], [1916156, 0, 3600, 7200], [1916275, 0, 7200, 3600], [1917091, 0, 3600, 7200], [1917274, 0, 7200, 3600], [1918069, 0, 3600, 7200], [1918280, 0, 7200, 3600], [1919061, 0, 3600, 7200], [1919278, 0, 7200, 3600], [1920081, 0, 3600, 7200], [1920263, 0, 7200, 3600], [1940167, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945258, 3600, 7200, 3600], [1946076, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947075, 0, 3600, 7200], [1947278, 3600, 7200, 3600], [1948060, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1966142, 0, 3600, 7200], [1966268, 0, 7200, 3600], [1967148, 0, 3600, 7200], [1967267, 3600, 7200, 3600], [1968147, 0, 3600, 7200], [1968266, 3600, 7200, 3600], [1969152, 0, 3600, 7200], [1969271, 3600, 7200, 3600], [1970151, 0, 3600, 7200], [1970270, 3600, 7200, 3600], [1971143, 0, 3600, 7200], [1971269, 3600, 7200, 3600], [1972149, 0, 3600, 7200], [1972275, 3600, 7200, 3600], [1973154, 0, 3600, 7200], [1973273, 3600, 7200, 3600], [1974146, 0, 3600, 7200], [1974272, 3600, 7200, 3600], [1975152, 0, 3600, 7200], [1975271, 3600, 7200, 3600], [1976151, 0, 3600, 7200], [1976270, 3600, 7200, 3600], [1977142, 0, 3600, 7200], [1977268, 3600, 7200, 3600], [1978148, 0, 3600, 7200], [1978274, 3600, 7200, 3600], [1979147, 0, 3600, 7200], [1979273, 3600, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurom$__f_Europe_Rome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurom$.prototype.constructor = $c_Lzonedb_java_tzdb$eurom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurom$.prototype = $c_Lzonedb_java_tzdb$eurom$.prototype;
var $d_Lzonedb_java_tzdb$eurom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurom$: 0
}, false, "zonedb.java.tzdb$eurom$", {
  Lzonedb_java_tzdb$eurom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurom$.prototype.$classData = $d_Lzonedb_java_tzdb$eurom$;
var $n_Lzonedb_java_tzdb$eurom$;
function $m_Lzonedb_java_tzdb$eurom$() {
  if ((!$n_Lzonedb_java_tzdb$eurom$)) {
    $n_Lzonedb_java_tzdb$eurom$ = new $c_Lzonedb_java_tzdb$eurom$()
  };
  return $n_Lzonedb_java_tzdb$eurom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurpo$() {
  this.Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol = null;
  $n_Lzonedb_java_tzdb$eurpo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 8184);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 8184);
  var _2 = [[1880001, 0, 8184, 8160], [1924123, 0, 8160, 7200], [1930172, 0, 7200, 10800], [1941305, 0, 10800, 3600], [1944103, 82800, 3600, 10800], [1990182, 7200, 10800, 7200], [1994120, 82800, 7200, 10800], [1997089, 14400, 10800, 7200], [2014089, 7200, 7200, 14400], [2014299, 7200, 14400, 10800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 8184, 8160], [1924123, 0, 8160, 7200], [1930172, 0, 7200, 10800], [1941305, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944104, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990182, 7200, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994121, 0, 10800, 14400], [1994268, 0, 14400, 10800], [1995085, 0, 10800, 14400], [1995267, 0, 14400, 10800], [1996091, 0, 10800, 14400], [1996301, 14400, 14400, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2000086, 10800, 7200, 10800], [2000303, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200], [2005086, 10800, 7200, 10800], [2005303, 14400, 10800, 7200], [2006085, 10800, 7200, 10800], [2006302, 14400, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011086, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014089, 7200, 7200, 14400], [2014299, 7200, 14400, 10800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurpo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurpo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurpo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurpo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurpo$.prototype = $c_Lzonedb_java_tzdb$eurpo$.prototype;
var $d_Lzonedb_java_tzdb$eurpo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurpo$: 0
}, false, "zonedb.java.tzdb$eurpo$", {
  Lzonedb_java_tzdb$eurpo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurpo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurpo$;
var $n_Lzonedb_java_tzdb$eurpo$;
function $m_Lzonedb_java_tzdb$eurpo$() {
  if ((!$n_Lzonedb_java_tzdb$eurpo$)) {
    $n_Lzonedb_java_tzdb$eurpo$ = new $c_Lzonedb_java_tzdb$eurpo$()
  };
  return $n_Lzonedb_java_tzdb$eurpo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurra$() {
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad = null;
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd = null;
  $n_Lzonedb_java_tzdb$eurra$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 4920);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 4920);
  var _2 = [[1893091, 0, 4920, 3600], [1945099, 82800, 3600, 7200], [1946097, 0, 7200, 10800], [1989085, 7200, 10800, 7200], [2011086, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1893091, 0, 4920, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945119, 0, 7200, 10800], [1945305, 0, 10800, 7200], [1946097, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200], [1999087, 7200, 7200, 10800], [1999304, 10800, 10800, 7200], [2000086, 7200, 7200, 10800], [2000303, 10800, 10800, 7200], [2001084, 7200, 7200, 10800], [2001301, 10800, 10800, 7200], [2002090, 7200, 7200, 10800], [2002300, 10800, 10800, 7200], [2003089, 7200, 7200, 10800], [2003299, 10800, 10800, 7200], [2004088, 7200, 7200, 10800], [2004305, 10800, 10800, 7200], [2005086, 7200, 7200, 10800], [2005303, 10800, 10800, 7200], [2006085, 7200, 7200, 10800], [2006302, 10800, 10800, 7200], [2007084, 7200, 7200, 10800], [2007301, 10800, 10800, 7200], [2008090, 7200, 7200, 10800], [2008300, 10800, 10800, 7200], [2009088, 7200, 7200, 10800], [2009298, 10800, 10800, 7200], [2010087, 7200, 7200, 10800], [2010304, 10800, 10800, 7200], [2011086, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 10660);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 10660);
  var _2$3 = [[1920003, 0, 10660, 10800], [1930172, 0, 10800, 14400], [1988087, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2018301, 7200, 10800, 14400]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1920003, 0, 10660, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2018301, 7200, 10800, 14400]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$eurra$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurra$.prototype.constructor = $c_Lzonedb_java_tzdb$eurra$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurra$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurra$.prototype = $c_Lzonedb_java_tzdb$eurra$.prototype;
var $d_Lzonedb_java_tzdb$eurra$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurra$: 0
}, false, "zonedb.java.tzdb$eurra$", {
  Lzonedb_java_tzdb$eurra$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurra$.prototype.$classData = $d_Lzonedb_java_tzdb$eurra$;
var $n_Lzonedb_java_tzdb$eurra$;
function $m_Lzonedb_java_tzdb$eurra$() {
  if ((!$n_Lzonedb_java_tzdb$eurra$)) {
    $n_Lzonedb_java_tzdb$eurra$ = new $c_Lzonedb_java_tzdb$eurra$()
  };
  return $n_Lzonedb_java_tzdb$eurra$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurri$() {
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Madrid = null;
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Paris = null;
  $n_Lzonedb_java_tzdb$eurri$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-884));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-884));
  var _2 = [[1900365, 85516, (-884), 0], [1940076, 82800, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900365, 85516, (-884), 0], [1918105, 82800, 0, 3600], [1918280, 3600, 3600, 0], [1919096, 82800, 0, 3600], [1919280, 3600, 3600, 0], [1924107, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928106, 0, 0, 3600], [1928281, 3600, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 3600, 3600, 0], [1937167, 82800, 0, 3600], [1937276, 3600, 3600, 0], [1938092, 82800, 0, 3600], [1938120, 82800, 3600, 7200], [1938276, 0, 7200, 3600], [1939281, 3600, 3600, 0], [1940076, 82800, 0, 3600], [1942122, 82800, 3600, 7200], [1942244, 3600, 7200, 3600], [1943107, 82800, 3600, 7200], [1943276, 3600, 7200, 3600], [1944106, 82800, 3600, 7200], [1944275, 3600, 7200, 3600], [1945104, 82800, 3600, 7200], [1945273, 3600, 7200, 3600], [1946103, 82800, 3600, 7200], [1946272, 3600, 7200, 3600], [1949120, 82800, 3600, 7200], [1949275, 3600, 7200, 3600], [1974103, 82800, 3600, 7200], [1974279, 3600, 7200, 3600], [1975102, 82800, 3600, 7200], [1975278, 3600, 7200, 3600], [1976087, 82800, 3600, 7200], [1976270, 3600, 7200, 3600], [1977092, 82800, 3600, 7200], [1977268, 3600, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Madrid = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 561);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 561);
  var _2$3 = [[1911070, 60, 561, 0], [1940166, 79200, 0, 3600], [1944237, 82800, 3600, 0], [1945259, 3600, 0, 3600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1911070, 60, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923146, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1930102, 82800, 0, 3600], [1930278, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1933084, 82800, 0, 3600], [1933281, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940056, 7200, 0, 3600], [1940166, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 3600, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1976088, 3600, 3600, 7200], [1976270, 3600, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Paris = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$eurri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurri$.prototype.constructor = $c_Lzonedb_java_tzdb$eurri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurri$.prototype = $c_Lzonedb_java_tzdb$eurri$.prototype;
var $d_Lzonedb_java_tzdb$eurri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurri$: 0
}, false, "zonedb.java.tzdb$eurri$", {
  Lzonedb_java_tzdb$eurri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurri$.prototype.$classData = $d_Lzonedb_java_tzdb$eurri$;
var $n_Lzonedb_java_tzdb$eurri$;
function $m_Lzonedb_java_tzdb$eurri$() {
  if ((!$n_Lzonedb_java_tzdb$eurri$)) {
    $n_Lzonedb_java_tzdb$eurri$ = new $c_Lzonedb_java_tzdb$eurri$()
  };
  return $n_Lzonedb_java_tzdb$eurri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurro$() {
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod = null;
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Kirov = null;
  $n_Lzonedb_java_tzdb$eurro$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5352);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5352);
  var _2 = [[1890274, 0, 5352, 3600], [1945180, 0, 3600, 10800], [1990182, 7200, 10800, 3600], [1991090, 10800, 3600, 7200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1890274, 0, 5352, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944300, 0, 7200, 3600], [1945180, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990182, 7200, 10800, 3600], [1991090, 10800, 3600, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 11928);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 11928);
  var _2$3 = [[1919182, 11928, 11928, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1919182, 11928, 11928, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Kirov = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$eurro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurro$.prototype.constructor = $c_Lzonedb_java_tzdb$eurro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurro$.prototype = $c_Lzonedb_java_tzdb$eurro$.prototype;
var $d_Lzonedb_java_tzdb$eurro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurro$: 0
}, false, "zonedb.java.tzdb$eurro$", {
  Lzonedb_java_tzdb$eurro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurro$.prototype.$classData = $d_Lzonedb_java_tzdb$eurro$;
var $n_Lzonedb_java_tzdb$eurro$;
function $m_Lzonedb_java_tzdb$eurro$() {
  if ((!$n_Lzonedb_java_tzdb$eurro$)) {
    $n_Lzonedb_java_tzdb$eurro$ = new $c_Lzonedb_java_tzdb$eurro$()
  };
  return $n_Lzonedb_java_tzdb$eurro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurrr$() {
  this.Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra = null;
  $n_Lzonedb_java_tzdb$eurrr$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 364);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 364);
  var _2 = [[1901001, 0, 364, 0], [1946273, 0, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 364, 0], [1946273, 0, 0, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurrr$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurrr$.prototype.constructor = $c_Lzonedb_java_tzdb$eurrr$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurrr$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurrr$.prototype = $c_Lzonedb_java_tzdb$eurrr$.prototype;
var $d_Lzonedb_java_tzdb$eurrr$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurrr$: 0
}, false, "zonedb.java.tzdb$eurrr$", {
  Lzonedb_java_tzdb$eurrr$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurrr$.prototype.$classData = $d_Lzonedb_java_tzdb$eurrr$;
var $n_Lzonedb_java_tzdb$eurrr$;
function $m_Lzonedb_java_tzdb$eurrr$() {
  if ((!$n_Lzonedb_java_tzdb$eurrr$)) {
    $n_Lzonedb_java_tzdb$eurrr$ = new $c_Lzonedb_java_tzdb$eurrr$()
  };
  return $n_Lzonedb_java_tzdb$eurrr$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eursa$() {
  this.Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw = null;
  $n_Lzonedb_java_tzdb$eursa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 5040);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 5040);
  var _2 = [[1915217, 0, 5040, 3600], [1918259, 7200, 3600, 7200], [1922152, 0, 7200, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1915217, 0, 5040, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1919105, 7200, 7200, 10800], [1919259, 10800, 10800, 7200], [1922152, 0, 7200, 3600], [1940175, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944278, 7200, 7200, 3600], [1945119, 0, 3600, 7200], [1945305, 0, 7200, 3600], [1946104, 0, 3600, 7200], [1946280, 10800, 7200, 3600], [1947124, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1957153, 3600, 3600, 7200], [1957272, 7200, 7200, 3600], [1958089, 3600, 3600, 7200], [1958271, 7200, 7200, 3600], [1959151, 3600, 3600, 7200], [1959277, 7200, 7200, 3600], [1960094, 3600, 3600, 7200], [1960276, 7200, 7200, 3600], [1961148, 3600, 3600, 7200], [1961274, 7200, 7200, 3600], [1962147, 3600, 3600, 7200], [1962273, 7200, 7200, 3600], [1963146, 3600, 3600, 7200], [1963272, 7200, 7200, 3600], [1964152, 3600, 3600, 7200], [1964271, 7200, 7200, 3600], [1977093, 3600, 3600, 7200], [1977268, 7200, 7200, 3600], [1978092, 3600, 3600, 7200], [1978274, 7200, 7200, 3600], [1979091, 3600, 3600, 7200], [1979273, 7200, 7200, 3600], [1980097, 3600, 3600, 7200], [1980272, 7200, 7200, 3600], [1981088, 3600, 3600, 7200], [1981270, 7200, 7200, 3600], [1982087, 3600, 3600, 7200], [1982269, 7200, 7200, 3600], [1983086, 3600, 3600, 7200], [1983268, 7200, 7200, 3600], [1984085, 3600, 3600, 7200], [1984274, 7200, 7200, 3600], [1985090, 3600, 3600, 7200], [1985272, 7200, 7200, 3600], [1986089, 3600, 3600, 7200], [1986271, 7200, 7200, 3600], [1987088, 3600, 3600, 7200], [1987270, 7200, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eursa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eursa$.prototype.constructor = $c_Lzonedb_java_tzdb$eursa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eursa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eursa$.prototype = $c_Lzonedb_java_tzdb$eursa$.prototype;
var $d_Lzonedb_java_tzdb$eursa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eursa$: 0
}, false, "zonedb.java.tzdb$eursa$", {
  Lzonedb_java_tzdb$eursa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eursa$.prototype.$classData = $d_Lzonedb_java_tzdb$eursa$;
var $n_Lzonedb_java_tzdb$eursa$;
function $m_Lzonedb_java_tzdb$eursa$() {
  if ((!$n_Lzonedb_java_tzdb$eursa$)) {
    $n_Lzonedb_java_tzdb$eursa$ = new $c_Lzonedb_java_tzdb$eursa$()
  };
  return $n_Lzonedb_java_tzdb$eursa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eursl$() {
  this.Lzonedb_java_tzdb$eursl$__f_Europe_Oslo = null;
  $n_Lzonedb_java_tzdb$eursl$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 2580);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 2580);
  var _2 = [[1895001, 0, 2580, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895001, 0, 2580, 3600], [1916143, 3600, 3600, 7200], [1916274, 0, 7200, 3600], [1940223, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945274, 10800, 7200, 3600], [1959074, 7200, 3600, 7200], [1959263, 10800, 7200, 3600], [1960080, 7200, 3600, 7200], [1960262, 10800, 7200, 3600], [1961078, 7200, 3600, 7200], [1961260, 10800, 7200, 3600], [1962077, 7200, 3600, 7200], [1962259, 10800, 7200, 3600], [1963076, 7200, 3600, 7200], [1963258, 10800, 7200, 3600], [1964075, 7200, 3600, 7200], [1964264, 10800, 7200, 3600], [1965115, 7200, 3600, 7200], [1965262, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eursl$__f_Europe_Oslo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eursl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eursl$.prototype.constructor = $c_Lzonedb_java_tzdb$eursl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eursl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eursl$.prototype = $c_Lzonedb_java_tzdb$eursl$.prototype;
var $d_Lzonedb_java_tzdb$eursl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eursl$: 0
}, false, "zonedb.java.tzdb$eursl$", {
  Lzonedb_java_tzdb$eursl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eursl$.prototype.$classData = $d_Lzonedb_java_tzdb$eursl$;
var $n_Lzonedb_java_tzdb$eursl$;
function $m_Lzonedb_java_tzdb$eursl$() {
  if ((!$n_Lzonedb_java_tzdb$eursl$)) {
    $n_Lzonedb_java_tzdb$eursl$ = new $c_Lzonedb_java_tzdb$eursl$()
  };
  return $n_Lzonedb_java_tzdb$eursl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurta$() {
  this.Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar = null;
  $n_Lzonedb_java_tzdb$eurta$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-1284));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-1284));
  var _2 = [[1880215, 0, (-1284), 0], [1957104, 7200, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880215, 0, (-1284), 0], [1916142, 7200, 0, 3600], [1916275, 10800, 3600, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1941124, 7200, 3600, 7200], [1941222, 10800, 7200, 3600], [1942095, 7200, 3600, 7200], [1942221, 10800, 7200, 3600], [1943094, 7200, 3600, 7200], [1943227, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945196, 10800, 7200, 3600], [1945280, 10800, 3600, 0], [1946104, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947103, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1947306, 10800, 3600, 0], [1948074, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurta$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurta$.prototype.constructor = $c_Lzonedb_java_tzdb$eurta$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurta$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurta$.prototype = $c_Lzonedb_java_tzdb$eurta$.prototype;
var $d_Lzonedb_java_tzdb$eurta$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurta$: 0
}, false, "zonedb.java.tzdb$eurta$", {
  Lzonedb_java_tzdb$eurta$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurta$.prototype.$classData = $d_Lzonedb_java_tzdb$eurta$;
var $n_Lzonedb_java_tzdb$eurta$;
function $m_Lzonedb_java_tzdb$eurta$() {
  if ((!$n_Lzonedb_java_tzdb$eurta$)) {
    $n_Lzonedb_java_tzdb$eurta$ = new $c_Lzonedb_java_tzdb$eurta$()
  };
  return $n_Lzonedb_java_tzdb$eurta$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurto$() {
  this.Lzonedb_java_tzdb$eurto$__f_Europe_Saratov = null;
  $n_Lzonedb_java_tzdb$eurto$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 11058);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 11058);
  var _2 = [[1919182, 11058, 11058, 10800], [1930172, 0, 10800, 14400], [1988087, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016339, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919182, 11058, 11058, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016339, 7200, 10800, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurto$__f_Europe_Saratov = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurto$.prototype.constructor = $c_Lzonedb_java_tzdb$eurto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurto$.prototype = $c_Lzonedb_java_tzdb$eurto$.prototype;
var $d_Lzonedb_java_tzdb$eurto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurto$: 0
}, false, "zonedb.java.tzdb$eurto$", {
  Lzonedb_java_tzdb$eurto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurto$.prototype.$classData = $d_Lzonedb_java_tzdb$eurto$;
var $n_Lzonedb_java_tzdb$eurto$;
function $m_Lzonedb_java_tzdb$eurto$() {
  if ((!$n_Lzonedb_java_tzdb$eurto$)) {
    $n_Lzonedb_java_tzdb$eurto$ = new $c_Lzonedb_java_tzdb$eurto$()
  };
  return $n_Lzonedb_java_tzdb$eurto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurur$() {
  this.Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg = null;
  $n_Lzonedb_java_tzdb$eurur$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 1476);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 1476);
  var _2 = [[1904153, 0, 1476, 3600], [1918329, 0, 3600, 0], [1940135, 7200, 0, 3600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1904153, 0, 1476, 3600], [1916135, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917118, 82800, 3600, 7200], [1917260, 3600, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1918329, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919278, 10800, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 7200, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 7200, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 3600, 3600, 0], [1923111, 82800, 0, 3600], [1923280, 7200, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1925095, 82800, 0, 3600], [1925277, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 3600, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932094, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933085, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934098, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935090, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937094, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938086, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1940135, 10800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944262, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1946139, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurur$.prototype.constructor = $c_Lzonedb_java_tzdb$eurur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurur$.prototype = $c_Lzonedb_java_tzdb$eurur$.prototype;
var $d_Lzonedb_java_tzdb$eurur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurur$: 0
}, false, "zonedb.java.tzdb$eurur$", {
  Lzonedb_java_tzdb$eurur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurur$.prototype.$classData = $d_Lzonedb_java_tzdb$eurur$;
var $n_Lzonedb_java_tzdb$eurur$;
function $m_Lzonedb_java_tzdb$eurur$() {
  if ((!$n_Lzonedb_java_tzdb$eurur$)) {
    $n_Lzonedb_java_tzdb$eurur$ = new $c_Lzonedb_java_tzdb$eurur$()
  };
  return $n_Lzonedb_java_tzdb$eurur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurvs$() {
  this.Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk = null;
  $n_Lzonedb_java_tzdb$eurvs$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 11616);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 11616);
  var _2 = [[1919182, 11616, 11616, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 7200], [1992019, 7200, 7200, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1919182, 11616, 11616, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992019, 7200, 7200, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$eurvs$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurvs$.prototype.constructor = $c_Lzonedb_java_tzdb$eurvs$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurvs$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurvs$.prototype = $c_Lzonedb_java_tzdb$eurvs$.prototype;
var $d_Lzonedb_java_tzdb$eurvs$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurvs$: 0
}, false, "zonedb.java.tzdb$eurvs$", {
  Lzonedb_java_tzdb$eurvs$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurvs$.prototype.$classData = $d_Lzonedb_java_tzdb$eurvs$;
var $n_Lzonedb_java_tzdb$eurvs$;
function $m_Lzonedb_java_tzdb$eurvs$() {
  if ((!$n_Lzonedb_java_tzdb$eurvs$)) {
    $n_Lzonedb_java_tzdb$eurvs$ = new $c_Lzonedb_java_tzdb$eurvs$()
  };
  return $n_Lzonedb_java_tzdb$eurvs$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indah$() {
  this.Lzonedb_java_tzdb$indah$__f_Indian_Mahe = null;
  $n_Lzonedb_java_tzdb$indah$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 13308);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 13308);
  var _2 = [[1906152, 0, 13308, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1906152, 0, 13308, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indah$__f_Indian_Mahe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indah$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indah$.prototype.constructor = $c_Lzonedb_java_tzdb$indah$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indah$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indah$.prototype = $c_Lzonedb_java_tzdb$indah$.prototype;
var $d_Lzonedb_java_tzdb$indah$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indah$: 0
}, false, "zonedb.java.tzdb$indah$", {
  Lzonedb_java_tzdb$indah$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indah$.prototype.$classData = $d_Lzonedb_java_tzdb$indah$;
var $n_Lzonedb_java_tzdb$indah$;
function $m_Lzonedb_java_tzdb$indah$() {
  if ((!$n_Lzonedb_java_tzdb$indah$)) {
    $n_Lzonedb_java_tzdb$indah$ = new $c_Lzonedb_java_tzdb$indah$()
  };
  return $n_Lzonedb_java_tzdb$indah$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indco$() {
  this.Lzonedb_java_tzdb$indco$__f_Indian_Cocos = null;
  $n_Lzonedb_java_tzdb$indco$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 23260);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 23260);
  var _2 = [[1900001, 0, 23260, 23400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1900001, 0, 23260, 23400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indco$__f_Indian_Cocos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indco$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indco$.prototype.constructor = $c_Lzonedb_java_tzdb$indco$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indco$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indco$.prototype = $c_Lzonedb_java_tzdb$indco$.prototype;
var $d_Lzonedb_java_tzdb$indco$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indco$: 0
}, false, "zonedb.java.tzdb$indco$", {
  Lzonedb_java_tzdb$indco$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indco$.prototype.$classData = $d_Lzonedb_java_tzdb$indco$;
var $n_Lzonedb_java_tzdb$indco$;
function $m_Lzonedb_java_tzdb$indco$() {
  if ((!$n_Lzonedb_java_tzdb$indco$)) {
    $n_Lzonedb_java_tzdb$indco$ = new $c_Lzonedb_java_tzdb$indco$()
  };
  return $n_Lzonedb_java_tzdb$indco$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indgo$() {
  this.Lzonedb_java_tzdb$indgo$__f_Indian_Chagos = null;
  $n_Lzonedb_java_tzdb$indgo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 17380);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 17380);
  var _2 = [[1907001, 0, 17380, 18000], [1996001, 0, 18000, 21600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1907001, 0, 17380, 18000], [1996001, 0, 18000, 21600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indgo$__f_Indian_Chagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indgo$.prototype.constructor = $c_Lzonedb_java_tzdb$indgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indgo$.prototype = $c_Lzonedb_java_tzdb$indgo$.prototype;
var $d_Lzonedb_java_tzdb$indgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indgo$: 0
}, false, "zonedb.java.tzdb$indgo$", {
  Lzonedb_java_tzdb$indgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indgo$.prototype.$classData = $d_Lzonedb_java_tzdb$indgo$;
var $n_Lzonedb_java_tzdb$indgo$;
function $m_Lzonedb_java_tzdb$indgo$() {
  if ((!$n_Lzonedb_java_tzdb$indgo$)) {
    $n_Lzonedb_java_tzdb$indgo$ = new $c_Lzonedb_java_tzdb$indgo$()
  };
  return $n_Lzonedb_java_tzdb$indgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indio$() {
  this.Lzonedb_java_tzdb$indio$__f_Indian_Reunion = null;
  $n_Lzonedb_java_tzdb$indio$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 13312);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 13312);
  var _2 = [[1911152, 0, 13312, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1911152, 0, 13312, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indio$__f_Indian_Reunion = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indio$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indio$.prototype.constructor = $c_Lzonedb_java_tzdb$indio$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indio$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indio$.prototype = $c_Lzonedb_java_tzdb$indio$.prototype;
var $d_Lzonedb_java_tzdb$indio$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indio$: 0
}, false, "zonedb.java.tzdb$indio$", {
  Lzonedb_java_tzdb$indio$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indio$.prototype.$classData = $d_Lzonedb_java_tzdb$indio$;
var $n_Lzonedb_java_tzdb$indio$;
function $m_Lzonedb_java_tzdb$indio$() {
  if ((!$n_Lzonedb_java_tzdb$indio$)) {
    $n_Lzonedb_java_tzdb$indio$ = new $c_Lzonedb_java_tzdb$indio$()
  };
  return $n_Lzonedb_java_tzdb$indio$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indiu$() {
  this.Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius = null;
  $n_Lzonedb_java_tzdb$indiu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 13800);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 13800);
  var _2 = [[1907001, 0, 13800, 14400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1907001, 0, 13800, 14400], [1982283, 0, 14400, 18000], [1983080, 0, 18000, 14400], [2008300, 7200, 14400, 18000], [2009088, 7200, 18000, 14400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indiu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indiu$.prototype.constructor = $c_Lzonedb_java_tzdb$indiu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indiu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indiu$.prototype = $c_Lzonedb_java_tzdb$indiu$.prototype;
var $d_Lzonedb_java_tzdb$indiu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indiu$: 0
}, false, "zonedb.java.tzdb$indiu$", {
  Lzonedb_java_tzdb$indiu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indiu$.prototype.$classData = $d_Lzonedb_java_tzdb$indiu$;
var $n_Lzonedb_java_tzdb$indiu$;
function $m_Lzonedb_java_tzdb$indiu$() {
  if ((!$n_Lzonedb_java_tzdb$indiu$)) {
    $n_Lzonedb_java_tzdb$indiu$ = new $c_Lzonedb_java_tzdb$indiu$()
  };
  return $n_Lzonedb_java_tzdb$indiu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indle$() {
  this.Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen = null;
  $n_Lzonedb_java_tzdb$indle$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 0);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 0);
  var _2 = [[1950001, 0, 0, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1950001, 0, 0, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indle$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indle$.prototype.constructor = $c_Lzonedb_java_tzdb$indle$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indle$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indle$.prototype = $c_Lzonedb_java_tzdb$indle$.prototype;
var $d_Lzonedb_java_tzdb$indle$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indle$: 0
}, false, "zonedb.java.tzdb$indle$", {
  Lzonedb_java_tzdb$indle$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indle$.prototype.$classData = $d_Lzonedb_java_tzdb$indle$;
var $n_Lzonedb_java_tzdb$indle$;
function $m_Lzonedb_java_tzdb$indle$() {
  if ((!$n_Lzonedb_java_tzdb$indle$)) {
    $n_Lzonedb_java_tzdb$indle$ = new $c_Lzonedb_java_tzdb$indle$()
  };
  return $n_Lzonedb_java_tzdb$indle$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indma$() {
  this.Lzonedb_java_tzdb$indma$__f_Indian_Christmas = null;
  $n_Lzonedb_java_tzdb$indma$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 25372);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 25372);
  var _2 = [[1895032, 0, 25372, 25200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1895032, 0, 25372, 25200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indma$__f_Indian_Christmas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indma$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indma$.prototype.constructor = $c_Lzonedb_java_tzdb$indma$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indma$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indma$.prototype = $c_Lzonedb_java_tzdb$indma$.prototype;
var $d_Lzonedb_java_tzdb$indma$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indma$: 0
}, false, "zonedb.java.tzdb$indma$", {
  Lzonedb_java_tzdb$indma$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indma$.prototype.$classData = $d_Lzonedb_java_tzdb$indma$;
var $n_Lzonedb_java_tzdb$indma$;
function $m_Lzonedb_java_tzdb$indma$() {
  if ((!$n_Lzonedb_java_tzdb$indma$)) {
    $n_Lzonedb_java_tzdb$indma$ = new $c_Lzonedb_java_tzdb$indma$()
  };
  return $n_Lzonedb_java_tzdb$indma$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indve$() {
  this.Lzonedb_java_tzdb$indve$__f_Indian_Maldives = null;
  $n_Lzonedb_java_tzdb$indve$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 17640);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 17640);
  var _2 = [[1960001, 0, 17640, 18000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1960001, 0, 17640, 18000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$indve$__f_Indian_Maldives = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$indve$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indve$.prototype.constructor = $c_Lzonedb_java_tzdb$indve$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indve$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indve$.prototype = $c_Lzonedb_java_tzdb$indve$.prototype;
var $d_Lzonedb_java_tzdb$indve$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indve$: 0
}, false, "zonedb.java.tzdb$indve$", {
  Lzonedb_java_tzdb$indve$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indve$.prototype.$classData = $d_Lzonedb_java_tzdb$indve$;
var $n_Lzonedb_java_tzdb$indve$;
function $m_Lzonedb_java_tzdb$indve$() {
  if ((!$n_Lzonedb_java_tzdb$indve$)) {
    $n_Lzonedb_java_tzdb$indve$ = new $c_Lzonedb_java_tzdb$indve$()
  };
  return $n_Lzonedb_java_tzdb$indve$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacag$() {
  this.Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago = null;
  $n_Lzonedb_java_tzdb$pacag$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 45432);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 45432);
  var _2 = [[1892187, 0, 45432, (-40968)], [1911001, 0, (-40968), (-39600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1892187, 0, 45432, (-40968)], [1911001, 0, (-40968), (-39600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacag$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacag$.prototype.constructor = $c_Lzonedb_java_tzdb$pacag$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacag$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacag$.prototype = $c_Lzonedb_java_tzdb$pacag$.prototype;
var $d_Lzonedb_java_tzdb$pacag$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacag$: 0
}, false, "zonedb.java.tzdb$pacag$", {
  Lzonedb_java_tzdb$pacag$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacag$.prototype.$classData = $d_Lzonedb_java_tzdb$pacag$;
var $n_Lzonedb_java_tzdb$pacag$;
function $m_Lzonedb_java_tzdb$pacag$() {
  if ((!$n_Lzonedb_java_tzdb$pacag$)) {
    $n_Lzonedb_java_tzdb$pacag$ = new $c_Lzonedb_java_tzdb$pacag$()
  };
  return $n_Lzonedb_java_tzdb$pacag$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacak$() {
  this.Lzonedb_java_tzdb$pacak$__f_Pacific_Wake = null;
  $n_Lzonedb_java_tzdb$pacak$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 39988);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 39988);
  var _2 = [[1901001, 0, 39988, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 39988, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacak$__f_Pacific_Wake = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacak$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacak$.prototype.constructor = $c_Lzonedb_java_tzdb$pacak$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacak$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacak$.prototype = $c_Lzonedb_java_tzdb$pacak$.prototype;
var $d_Lzonedb_java_tzdb$pacak$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacak$: 0
}, false, "zonedb.java.tzdb$pacak$", {
  Lzonedb_java_tzdb$pacak$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacak$.prototype.$classData = $d_Lzonedb_java_tzdb$pacak$;
var $n_Lzonedb_java_tzdb$pacak$;
function $m_Lzonedb_java_tzdb$pacak$() {
  if ((!$n_Lzonedb_java_tzdb$pacak$)) {
    $n_Lzonedb_java_tzdb$pacak$ = new $c_Lzonedb_java_tzdb$pacak$()
  };
  return $n_Lzonedb_java_tzdb$pacak$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacan$() {
  this.Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland = null;
  $n_Lzonedb_java_tzdb$pacan$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 41944);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 41944);
  var _2 = [[1868307, 0, 41944, 41400], [1945365, 84600, 41400, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1868307, 0, 41944, 41400], [1927310, 7200, 41400, 45000], [1928064, 7200, 45000, 41400], [1928288, 7200, 41400, 43200], [1929076, 7200, 43200, 41400], [1929286, 7200, 41400, 43200], [1930075, 7200, 43200, 41400], [1930285, 7200, 41400, 43200], [1931074, 7200, 43200, 41400], [1931284, 7200, 41400, 43200], [1932080, 7200, 43200, 41400], [1932283, 7200, 41400, 43200], [1933078, 7200, 43200, 41400], [1933281, 7200, 41400, 43200], [1934119, 7200, 43200, 41400], [1934273, 7200, 41400, 43200], [1935118, 7200, 43200, 41400], [1935272, 7200, 41400, 43200], [1936117, 7200, 43200, 41400], [1936271, 7200, 41400, 43200], [1937115, 7200, 43200, 41400], [1937269, 7200, 41400, 43200], [1938114, 7200, 43200, 41400], [1938268, 7200, 41400, 43200], [1939120, 7200, 43200, 41400], [1939267, 7200, 41400, 43200], [1940119, 7200, 43200, 41400], [1940273, 7200, 41400, 43200], [1974307, 7200, 43200, 46800], [1975054, 10800, 46800, 43200], [1975299, 7200, 43200, 46800], [1976067, 10800, 46800, 43200], [1976305, 7200, 43200, 46800], [1977065, 10800, 46800, 43200], [1977303, 7200, 43200, 46800], [1978064, 10800, 46800, 43200], [1978302, 7200, 43200, 46800], [1979063, 10800, 46800, 43200], [1979301, 7200, 43200, 46800], [1980062, 10800, 46800, 43200], [1980300, 7200, 43200, 46800], [1981060, 10800, 46800, 43200], [1981298, 7200, 43200, 46800], [1982066, 10800, 46800, 43200], [1982304, 7200, 43200, 46800], [1983065, 10800, 46800, 43200], [1983303, 7200, 43200, 46800], [1984064, 10800, 46800, 43200], [1984302, 7200, 43200, 46800], [1985062, 10800, 46800, 43200], [1985300, 7200, 43200, 46800], [1986061, 10800, 46800, 43200], [1986299, 7200, 43200, 46800], [1987060, 10800, 46800, 43200], [1987298, 7200, 43200, 46800], [1988066, 10800, 46800, 43200], [1988304, 7200, 43200, 46800], [1989064, 10800, 46800, 43200], [1989281, 7200, 43200, 46800], [1990077, 10800, 46800, 43200], [1990280, 7200, 43200, 46800], [1991076, 10800, 46800, 43200], [1991279, 7200, 43200, 46800], [1992075, 10800, 46800, 43200], [1992278, 7200, 43200, 46800], [1993080, 10800, 46800, 43200], [1993276, 7200, 43200, 46800], [1994079, 10800, 46800, 43200], [1994275, 7200, 43200, 46800], [1995078, 10800, 46800, 43200], [1995274, 7200, 43200, 46800], [1996077, 10800, 46800, 43200], [1996280, 7200, 43200, 46800], [1997075, 10800, 46800, 43200], [1997278, 7200, 43200, 46800], [1998074, 10800, 46800, 43200], [1998277, 7200, 43200, 46800], [1999080, 10800, 46800, 43200], [1999276, 7200, 43200, 46800], [2000079, 10800, 46800, 43200], [2000275, 7200, 43200, 46800], [2001077, 10800, 46800, 43200], [2001280, 7200, 43200, 46800], [2002076, 10800, 46800, 43200], [2002279, 7200, 43200, 46800], [2003075, 10800, 46800, 43200], [2003278, 7200, 43200, 46800], [2004081, 10800, 46800, 43200], [2004277, 7200, 43200, 46800], [2005079, 10800, 46800, 43200], [2005275, 7200, 43200, 46800], [2006078, 10800, 46800, 43200], [2006274, 7200, 43200, 46800], [2007077, 10800, 46800, 43200], [2007273, 7200, 43200, 46800], [2008097, 10800, 46800, 43200], [2008272, 7200, 43200, 46800], [2009095, 10800, 46800, 43200], [2009270, 7200, 43200, 46800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 43200, 46800, 43200], [9, 24, 7, 7200, 0, 2, 43200, 43200, 46800]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacan$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacan$.prototype.constructor = $c_Lzonedb_java_tzdb$pacan$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacan$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacan$.prototype = $c_Lzonedb_java_tzdb$pacan$.prototype;
var $d_Lzonedb_java_tzdb$pacan$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacan$: 0
}, false, "zonedb.java.tzdb$pacan$", {
  Lzonedb_java_tzdb$pacan$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacan$.prototype.$classData = $d_Lzonedb_java_tzdb$pacan$;
var $n_Lzonedb_java_tzdb$pacan$;
function $m_Lzonedb_java_tzdb$pacan$() {
  if ((!$n_Lzonedb_java_tzdb$pacan$)) {
    $n_Lzonedb_java_tzdb$pacan$ = new $c_Lzonedb_java_tzdb$pacan$()
  };
  return $n_Lzonedb_java_tzdb$pacan$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacap$() {
  this.Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu = null;
  $n_Lzonedb_java_tzdb$pacap$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 44360);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 44360);
  var _2 = [[1901001, 0, 44360, 44400], [1941001, 0, 44400, 46800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 44360, 44400], [1941001, 0, 44400, 46800], [1999280, 7200, 46800, 50400], [2000079, 10800, 50400, 46800], [2000310, 7200, 46800, 50400], [2001028, 7200, 50400, 46800], [2001308, 7200, 46800, 50400], [2002027, 7200, 50400, 46800], [2016311, 7200, 46800, 50400], [2017015, 10800, 50400, 46800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacap$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacap$.prototype.constructor = $c_Lzonedb_java_tzdb$pacap$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacap$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacap$.prototype = $c_Lzonedb_java_tzdb$pacap$.prototype;
var $d_Lzonedb_java_tzdb$pacap$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacap$: 0
}, false, "zonedb.java.tzdb$pacap$", {
  Lzonedb_java_tzdb$pacap$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacap$.prototype.$classData = $d_Lzonedb_java_tzdb$pacap$;
var $n_Lzonedb_java_tzdb$pacap$;
function $m_Lzonedb_java_tzdb$pacap$() {
  if ((!$n_Lzonedb_java_tzdb$pacap$)) {
    $n_Lzonedb_java_tzdb$pacap$ = new $c_Lzonedb_java_tzdb$pacap$()
  };
  return $n_Lzonedb_java_tzdb$pacap$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacat$() {
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati = null;
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Efate = null;
  $n_Lzonedb_java_tzdb$pacat$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-37760));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-37760));
  var _2 = [[1901001, 0, (-37760), (-38400)], [1979274, 0, (-38400), (-36000)], [1994365, 0, (-36000), 50400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-37760), (-38400)], [1979274, 0, (-38400), (-36000)], [1994365, 0, (-36000), 50400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 40396);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 40396);
  var _2$3 = [[1912013, 0, 40396, 39600]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1912013, 0, 40396, 39600], [1983268, 0, 39600, 43200], [1984085, 0, 43200, 39600], [1984297, 0, 39600, 43200], [1985083, 0, 43200, 39600], [1985272, 0, 39600, 43200], [1986082, 0, 43200, 39600], [1986271, 0, 39600, 43200], [1987088, 0, 43200, 39600], [1987270, 0, 39600, 43200], [1988087, 0, 43200, 39600], [1988269, 0, 39600, 43200], [1989085, 0, 43200, 39600], [1989267, 0, 39600, 43200], [1990084, 0, 43200, 39600], [1990266, 0, 39600, 43200], [1991083, 0, 43200, 39600], [1991272, 0, 39600, 43200], [1992026, 0, 43200, 39600], [1992299, 0, 39600, 43200], [1993024, 0, 43200, 39600]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Efate = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
}
$c_Lzonedb_java_tzdb$pacat$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacat$.prototype.constructor = $c_Lzonedb_java_tzdb$pacat$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacat$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacat$.prototype = $c_Lzonedb_java_tzdb$pacat$.prototype;
var $d_Lzonedb_java_tzdb$pacat$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacat$: 0
}, false, "zonedb.java.tzdb$pacat$", {
  Lzonedb_java_tzdb$pacat$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacat$.prototype.$classData = $d_Lzonedb_java_tzdb$pacat$;
var $n_Lzonedb_java_tzdb$pacat$;
function $m_Lzonedb_java_tzdb$pacat$() {
  if ((!$n_Lzonedb_java_tzdb$pacat$)) {
    $n_Lzonedb_java_tzdb$pacat$ = new $c_Lzonedb_java_tzdb$pacat$()
  };
  return $n_Lzonedb_java_tzdb$pacat$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacaw$() {
  this.Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa = null;
  $n_Lzonedb_java_tzdb$pacaw$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 41524);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 41524);
  var _2 = [[1901001, 0, 41524, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 41524, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacaw$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacaw$.prototype.constructor = $c_Lzonedb_java_tzdb$pacaw$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacaw$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacaw$.prototype = $c_Lzonedb_java_tzdb$pacaw$.prototype;
var $d_Lzonedb_java_tzdb$pacaw$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacaw$: 0
}, false, "zonedb.java.tzdb$pacaw$", {
  Lzonedb_java_tzdb$pacaw$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacaw$.prototype.$classData = $d_Lzonedb_java_tzdb$pacaw$;
var $n_Lzonedb_java_tzdb$pacaw$;
function $m_Lzonedb_java_tzdb$pacaw$() {
  if ((!$n_Lzonedb_java_tzdb$pacaw$)) {
    $n_Lzonedb_java_tzdb$pacaw$ = new $c_Lzonedb_java_tzdb$pacaw$()
  };
  return $n_Lzonedb_java_tzdb$pacaw$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacei$() {
  this.Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein = null;
  $n_Lzonedb_java_tzdb$pacei$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 40160);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 40160);
  var _2 = [[1901001, 0, 40160, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944037, 0, 32400, 39600], [1969274, 0, 39600, (-43200)], [1993233, 0, (-43200), 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 40160, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944037, 0, 32400, 39600], [1969274, 0, 39600, (-43200)], [1993233, 0, (-43200), 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacei$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacei$.prototype.constructor = $c_Lzonedb_java_tzdb$pacei$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacei$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacei$.prototype = $c_Lzonedb_java_tzdb$pacei$.prototype;
var $d_Lzonedb_java_tzdb$pacei$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacei$: 0
}, false, "zonedb.java.tzdb$pacei$", {
  Lzonedb_java_tzdb$pacei$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacei$.prototype.$classData = $d_Lzonedb_java_tzdb$pacei$;
var $n_Lzonedb_java_tzdb$pacei$;
function $m_Lzonedb_java_tzdb$pacei$() {
  if ((!$n_Lzonedb_java_tzdb$pacei$)) {
    $n_Lzonedb_java_tzdb$pacei$ = new $c_Lzonedb_java_tzdb$pacei$()
  };
  return $n_Lzonedb_java_tzdb$pacei$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacgo$() {
  this.Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos = null;
  $n_Lzonedb_java_tzdb$pacgo$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-21504));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-21504));
  var _2 = [[1931001, 0, (-21504), (-18000)], [1986001, 0, (-18000), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1931001, 0, (-21504), (-18000)], [1986001, 0, (-18000), (-21600)], [1992333, 0, (-21600), (-18000)], [1993036, 0, (-18000), (-21600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacgo$.prototype.constructor = $c_Lzonedb_java_tzdb$pacgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacgo$.prototype = $c_Lzonedb_java_tzdb$pacgo$.prototype;
var $d_Lzonedb_java_tzdb$pacgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacgo$: 0
}, false, "zonedb.java.tzdb$pacgo$", {
  Lzonedb_java_tzdb$pacgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacgo$.prototype.$classData = $d_Lzonedb_java_tzdb$pacgo$;
var $n_Lzonedb_java_tzdb$pacgo$;
function $m_Lzonedb_java_tzdb$pacgo$() {
  if ((!$n_Lzonedb_java_tzdb$pacgo$)) {
    $n_Lzonedb_java_tzdb$pacgo$ = new $c_Lzonedb_java_tzdb$pacgo$()
  };
  return $n_Lzonedb_java_tzdb$pacgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacha$() {
  this.Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham = null;
  $n_Lzonedb_java_tzdb$pacha$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 44028);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 44028);
  var _2 = [[1868307, 0, 44028, 44100], [1946001, 0, 44100, 45900]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1868307, 0, 44028, 44100], [1946001, 0, 44100, 45900], [1974307, 9900, 45900, 49500], [1975054, 13500, 49500, 45900], [1975299, 9900, 45900, 49500], [1976067, 13500, 49500, 45900], [1976305, 9900, 45900, 49500], [1977065, 13500, 49500, 45900], [1977303, 9900, 45900, 49500], [1978064, 13500, 49500, 45900], [1978302, 9900, 45900, 49500], [1979063, 13500, 49500, 45900], [1979301, 9900, 45900, 49500], [1980062, 13500, 49500, 45900], [1980300, 9900, 45900, 49500], [1981060, 13500, 49500, 45900], [1981298, 9900, 45900, 49500], [1982066, 13500, 49500, 45900], [1982304, 9900, 45900, 49500], [1983065, 13500, 49500, 45900], [1983303, 9900, 45900, 49500], [1984064, 13500, 49500, 45900], [1984302, 9900, 45900, 49500], [1985062, 13500, 49500, 45900], [1985300, 9900, 45900, 49500], [1986061, 13500, 49500, 45900], [1986299, 9900, 45900, 49500], [1987060, 13500, 49500, 45900], [1987298, 9900, 45900, 49500], [1988066, 13500, 49500, 45900], [1988304, 9900, 45900, 49500], [1989064, 13500, 49500, 45900], [1989281, 9900, 45900, 49500], [1990077, 13500, 49500, 45900], [1990280, 9900, 45900, 49500], [1991076, 13500, 49500, 45900], [1991279, 9900, 45900, 49500], [1992075, 13500, 49500, 45900], [1992278, 9900, 45900, 49500], [1993080, 13500, 49500, 45900], [1993276, 9900, 45900, 49500], [1994079, 13500, 49500, 45900], [1994275, 9900, 45900, 49500], [1995078, 13500, 49500, 45900], [1995274, 9900, 45900, 49500], [1996077, 13500, 49500, 45900], [1996280, 9900, 45900, 49500], [1997075, 13500, 49500, 45900], [1997278, 9900, 45900, 49500], [1998074, 13500, 49500, 45900], [1998277, 9900, 45900, 49500], [1999080, 13500, 49500, 45900], [1999276, 9900, 45900, 49500], [2000079, 13500, 49500, 45900], [2000275, 9900, 45900, 49500], [2001077, 13500, 49500, 45900], [2001280, 9900, 45900, 49500], [2002076, 13500, 49500, 45900], [2002279, 9900, 45900, 49500], [2003075, 13500, 49500, 45900], [2003278, 9900, 45900, 49500], [2004081, 13500, 49500, 45900], [2004277, 9900, 45900, 49500], [2005079, 13500, 49500, 45900], [2005275, 9900, 45900, 49500], [2006078, 13500, 49500, 45900], [2006274, 9900, 45900, 49500], [2007077, 13500, 49500, 45900], [2007273, 9900, 45900, 49500], [2008097, 13500, 49500, 45900], [2008272, 9900, 45900, 49500], [2009095, 13500, 49500, 45900], [2009270, 9900, 45900, 49500]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 9900, 0, 2, 45900, 49500, 45900], [9, 24, 7, 9900, 0, 2, 45900, 45900, 49500]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacha$.prototype.constructor = $c_Lzonedb_java_tzdb$pacha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacha$.prototype = $c_Lzonedb_java_tzdb$pacha$.prototype;
var $d_Lzonedb_java_tzdb$pacha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacha$: 0
}, false, "zonedb.java.tzdb$pacha$", {
  Lzonedb_java_tzdb$pacha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacha$.prototype.$classData = $d_Lzonedb_java_tzdb$pacha$;
var $n_Lzonedb_java_tzdb$pacha$;
function $m_Lzonedb_java_tzdb$pacha$() {
  if ((!$n_Lzonedb_java_tzdb$pacha$)) {
    $n_Lzonedb_java_tzdb$pacha$ = new $c_Lzonedb_java_tzdb$pacha$()
  };
  return $n_Lzonedb_java_tzdb$pacha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacie$() {
  this.Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier = null;
  $n_Lzonedb_java_tzdb$pacie$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-32388));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-32388));
  var _2 = [[1912275, 0, (-32388), (-32400)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912275, 0, (-32388), (-32400)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacie$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacie$.prototype.constructor = $c_Lzonedb_java_tzdb$pacie$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacie$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacie$.prototype = $c_Lzonedb_java_tzdb$pacie$.prototype;
var $d_Lzonedb_java_tzdb$pacie$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacie$: 0
}, false, "zonedb.java.tzdb$pacie$", {
  Lzonedb_java_tzdb$pacie$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacie$.prototype.$classData = $d_Lzonedb_java_tzdb$pacie$;
var $n_Lzonedb_java_tzdb$pacie$;
function $m_Lzonedb_java_tzdb$pacie$() {
  if ((!$n_Lzonedb_java_tzdb$pacie$)) {
    $n_Lzonedb_java_tzdb$pacie$ = new $c_Lzonedb_java_tzdb$pacie$()
  };
  return $n_Lzonedb_java_tzdb$pacie$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacij$() {
  this.Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji = null;
  $n_Lzonedb_java_tzdb$pacij$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 42944);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 42944);
  var _2 = [[1915299, 0, 42944, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1915299, 0, 42944, 43200], [1998305, 7200, 43200, 46800], [1999059, 10800, 46800, 43200], [1999311, 7200, 43200, 46800], [2000058, 10800, 46800, 43200], [2009333, 7200, 43200, 46800], [2010087, 10800, 46800, 43200], [2010297, 7200, 43200, 46800], [2011065, 10800, 46800, 43200], [2011296, 7200, 43200, 46800], [2012022, 10800, 46800, 43200], [2012295, 7200, 43200, 46800], [2013020, 10800, 46800, 43200], [2013300, 7200, 43200, 46800], [2014019, 7200, 46800, 43200], [2014306, 7200, 43200, 46800], [2015018, 10800, 46800, 43200], [2015305, 7200, 43200, 46800], [2016017, 10800, 46800, 43200], [2016311, 7200, 43200, 46800], [2017015, 10800, 46800, 43200], [2017309, 7200, 43200, 46800], [2018014, 10800, 46800, 43200], [2018308, 7200, 43200, 46800], [2019013, 10800, 46800, 43200], [2019314, 7200, 43200, 46800], [2020012, 10800, 46800, 43200], [2020313, 7200, 43200, 46800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[1, 12, 7, 10800, 0, 1, 43200, 46800, 43200], [11, 8, 7, 7200, 0, 1, 43200, 43200, 46800]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacij$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacij$.prototype.constructor = $c_Lzonedb_java_tzdb$pacij$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacij$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacij$.prototype = $c_Lzonedb_java_tzdb$pacij$.prototype;
var $d_Lzonedb_java_tzdb$pacij$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacij$: 0
}, false, "zonedb.java.tzdb$pacij$", {
  Lzonedb_java_tzdb$pacij$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacij$.prototype.$classData = $d_Lzonedb_java_tzdb$pacij$;
var $n_Lzonedb_java_tzdb$pacij$;
function $m_Lzonedb_java_tzdb$pacij$() {
  if ((!$n_Lzonedb_java_tzdb$pacij$)) {
    $n_Lzonedb_java_tzdb$pacij$ = new $c_Lzonedb_java_tzdb$pacij$()
  };
  return $n_Lzonedb_java_tzdb$pacij$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacir$() {
  this.Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn = null;
  $n_Lzonedb_java_tzdb$pacir$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-31220));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-31220));
  var _2 = [[1901001, 0, (-31220), (-30600)], [1998117, 0, (-30600), (-28800)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-31220), (-30600)], [1998117, 0, (-30600), (-28800)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacir$.prototype.constructor = $c_Lzonedb_java_tzdb$pacir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacir$.prototype = $c_Lzonedb_java_tzdb$pacir$.prototype;
var $d_Lzonedb_java_tzdb$pacir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacir$: 0
}, false, "zonedb.java.tzdb$pacir$", {
  Lzonedb_java_tzdb$pacir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacir$.prototype.$classData = $d_Lzonedb_java_tzdb$pacir$;
var $n_Lzonedb_java_tzdb$pacir$;
function $m_Lzonedb_java_tzdb$pacir$() {
  if ((!$n_Lzonedb_java_tzdb$pacir$)) {
    $n_Lzonedb_java_tzdb$pacir$ = new $c_Lzonedb_java_tzdb$pacir$()
  };
  return $n_Lzonedb_java_tzdb$pacir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacit$() {
  this.Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti = null;
  $n_Lzonedb_java_tzdb$pacit$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-35896));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-35896));
  var _2 = [[1912275, 0, (-35896), (-36000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912275, 0, (-35896), (-36000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacit$.prototype.constructor = $c_Lzonedb_java_tzdb$pacit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacit$.prototype = $c_Lzonedb_java_tzdb$pacit$.prototype;
var $d_Lzonedb_java_tzdb$pacit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacit$: 0
}, false, "zonedb.java.tzdb$pacit$", {
  Lzonedb_java_tzdb$pacit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacit$.prototype.$classData = $d_Lzonedb_java_tzdb$pacit$;
var $n_Lzonedb_java_tzdb$pacit$;
function $m_Lzonedb_java_tzdb$pacit$() {
  if ((!$n_Lzonedb_java_tzdb$pacit$)) {
    $n_Lzonedb_java_tzdb$pacit$ = new $c_Lzonedb_java_tzdb$pacit$()
  };
  return $n_Lzonedb_java_tzdb$pacit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$paciu$() {
  this.Lzonedb_java_tzdb$paciu$__f_Pacific_Niue = null;
  $n_Lzonedb_java_tzdb$paciu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-40780));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-40780));
  var _2 = [[1901001, 0, (-40780), (-40800)], [1951001, 0, (-40800), (-41400)], [1978274, 0, (-41400), (-39600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-40780), (-40800)], [1951001, 0, (-40800), (-41400)], [1978274, 0, (-41400), (-39600)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$paciu$__f_Pacific_Niue = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$paciu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$paciu$.prototype.constructor = $c_Lzonedb_java_tzdb$paciu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$paciu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$paciu$.prototype = $c_Lzonedb_java_tzdb$paciu$.prototype;
var $d_Lzonedb_java_tzdb$paciu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$paciu$: 0
}, false, "zonedb.java.tzdb$paciu$", {
  Lzonedb_java_tzdb$paciu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$paciu$.prototype.$classData = $d_Lzonedb_java_tzdb$paciu$;
var $n_Lzonedb_java_tzdb$paciu$;
function $m_Lzonedb_java_tzdb$paciu$() {
  if ((!$n_Lzonedb_java_tzdb$paciu$)) {
    $n_Lzonedb_java_tzdb$paciu$ = new $c_Lzonedb_java_tzdb$paciu$()
  };
  return $n_Lzonedb_java_tzdb$paciu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacla$() {
  this.Lzonedb_java_tzdb$pacla$__f_Pacific_Palau = null;
  $n_Lzonedb_java_tzdb$pacla$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-54124));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-54124));
  var _2 = [[1844366, 0, (-54124), 32276], [1901001, 0, 32276, 32400]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-54124), 32276], [1901001, 0, 32276, 32400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacla$__f_Pacific_Palau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacla$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacla$.prototype.constructor = $c_Lzonedb_java_tzdb$pacla$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacla$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacla$.prototype = $c_Lzonedb_java_tzdb$pacla$.prototype;
var $d_Lzonedb_java_tzdb$pacla$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacla$: 0
}, false, "zonedb.java.tzdb$pacla$", {
  Lzonedb_java_tzdb$pacla$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacla$.prototype.$classData = $d_Lzonedb_java_tzdb$pacla$;
var $n_Lzonedb_java_tzdb$pacla$;
function $m_Lzonedb_java_tzdb$pacla$() {
  if ((!$n_Lzonedb_java_tzdb$pacla$)) {
    $n_Lzonedb_java_tzdb$pacla$ = new $c_Lzonedb_java_tzdb$pacla$()
  };
  return $n_Lzonedb_java_tzdb$pacla$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacli$() {
  this.Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis = null;
  $n_Lzonedb_java_tzdb$pacli$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 44120);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 44120);
  var _2 = [[1901001, 0, 44120, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 44120, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacli$.prototype.constructor = $c_Lzonedb_java_tzdb$pacli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacli$.prototype = $c_Lzonedb_java_tzdb$pacli$.prototype;
var $d_Lzonedb_java_tzdb$pacli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacli$: 0
}, false, "zonedb.java.tzdb$pacli$", {
  Lzonedb_java_tzdb$pacli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacli$.prototype.$classData = $d_Lzonedb_java_tzdb$pacli$;
var $n_Lzonedb_java_tzdb$pacli$;
function $m_Lzonedb_java_tzdb$pacli$() {
  if ((!$n_Lzonedb_java_tzdb$pacli$)) {
    $n_Lzonedb_java_tzdb$pacli$ = new $c_Lzonedb_java_tzdb$pacli$()
  };
  return $n_Lzonedb_java_tzdb$pacli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacll$() {
  this.Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville = null;
  $n_Lzonedb_java_tzdb$pacll$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 37336);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 37336);
  var _2 = [[1880001, 0, 37336, 35312], [1895001, 0, 35312, 36000], [1942182, 0, 36000, 32400], [1945233, 0, 32400, 36000], [2014362, 7200, 36000, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 37336, 35312], [1895001, 0, 35312, 36000], [1942182, 0, 36000, 32400], [1945233, 0, 32400, 36000], [2014362, 7200, 36000, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacll$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacll$.prototype.constructor = $c_Lzonedb_java_tzdb$pacll$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacll$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacll$.prototype = $c_Lzonedb_java_tzdb$pacll$.prototype;
var $d_Lzonedb_java_tzdb$pacll$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacll$: 0
}, false, "zonedb.java.tzdb$pacll$", {
  Lzonedb_java_tzdb$pacll$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacll$.prototype.$classData = $d_Lzonedb_java_tzdb$pacll$;
var $n_Lzonedb_java_tzdb$pacll$;
function $m_Lzonedb_java_tzdb$pacll$() {
  if ((!$n_Lzonedb_java_tzdb$pacll$)) {
    $n_Lzonedb_java_tzdb$pacll$ = new $c_Lzonedb_java_tzdb$pacll$()
  };
  return $n_Lzonedb_java_tzdb$pacll$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacme$() {
  this.Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea = null;
  $n_Lzonedb_java_tzdb$pacme$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 39948);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 39948);
  var _2 = [[1912013, 0, 39948, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912013, 0, 39948, 39600], [1977338, 0, 39600, 43200], [1978058, 0, 43200, 39600], [1978337, 0, 39600, 43200], [1979058, 0, 43200, 39600], [1996336, 7200, 39600, 43200], [1997061, 10800, 43200, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacme$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacme$.prototype.constructor = $c_Lzonedb_java_tzdb$pacme$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacme$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacme$.prototype = $c_Lzonedb_java_tzdb$pacme$.prototype;
var $d_Lzonedb_java_tzdb$pacme$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacme$: 0
}, false, "zonedb.java.tzdb$pacme$", {
  Lzonedb_java_tzdb$pacme$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacme$.prototype.$classData = $d_Lzonedb_java_tzdb$pacme$;
var $n_Lzonedb_java_tzdb$pacme$;
function $m_Lzonedb_java_tzdb$pacme$() {
  if ((!$n_Lzonedb_java_tzdb$pacme$)) {
    $n_Lzonedb_java_tzdb$pacme$ = new $c_Lzonedb_java_tzdb$pacme$()
  };
  return $n_Lzonedb_java_tzdb$pacme$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacna$() {
  this.Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal = null;
  $n_Lzonedb_java_tzdb$pacna$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 38388);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 38388);
  var _2 = [[1912275, 0, 38388, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912275, 0, 38388, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacna$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacna$.prototype.constructor = $c_Lzonedb_java_tzdb$pacna$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacna$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacna$.prototype = $c_Lzonedb_java_tzdb$pacna$.prototype;
var $d_Lzonedb_java_tzdb$pacna$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacna$: 0
}, false, "zonedb.java.tzdb$pacna$", {
  Lzonedb_java_tzdb$pacna$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacna$.prototype.$classData = $d_Lzonedb_java_tzdb$pacna$;
var $n_Lzonedb_java_tzdb$pacna$;
function $m_Lzonedb_java_tzdb$pacna$() {
  if ((!$n_Lzonedb_java_tzdb$pacna$)) {
    $n_Lzonedb_java_tzdb$pacna$ = new $c_Lzonedb_java_tzdb$pacna$()
  };
  return $n_Lzonedb_java_tzdb$pacna$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacng$() {
  this.Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga = null;
  $n_Lzonedb_java_tzdb$pacng$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-38344));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-38344));
  var _2 = [[1901001, 0, (-38344), (-37800)], [1978316, 0, (-37800), (-36000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-38344), (-37800)], [1978316, 0, (-37800), (-34200)], [1979063, 0, (-34200), (-36000)], [1979301, 0, (-36000), (-34200)], [1980062, 0, (-34200), (-36000)], [1980300, 0, (-36000), (-34200)], [1981060, 0, (-34200), (-36000)], [1981298, 0, (-36000), (-34200)], [1982066, 0, (-34200), (-36000)], [1982304, 0, (-36000), (-34200)], [1983065, 0, (-34200), (-36000)], [1983303, 0, (-36000), (-34200)], [1984064, 0, (-34200), (-36000)], [1984302, 0, (-36000), (-34200)], [1985062, 0, (-34200), (-36000)], [1985300, 0, (-36000), (-34200)], [1986061, 0, (-34200), (-36000)], [1986299, 0, (-36000), (-34200)], [1987060, 0, (-34200), (-36000)], [1987298, 0, (-36000), (-34200)], [1988066, 0, (-34200), (-36000)], [1988304, 0, (-36000), (-34200)], [1989064, 0, (-34200), (-36000)], [1989302, 0, (-36000), (-34200)], [1990063, 0, (-34200), (-36000)], [1990301, 0, (-36000), (-34200)], [1991062, 0, (-34200), (-36000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacng$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacng$.prototype.constructor = $c_Lzonedb_java_tzdb$pacng$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacng$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacng$.prototype = $c_Lzonedb_java_tzdb$pacng$.prototype;
var $d_Lzonedb_java_tzdb$pacng$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacng$: 0
}, false, "zonedb.java.tzdb$pacng$", {
  Lzonedb_java_tzdb$pacng$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacng$.prototype.$classData = $d_Lzonedb_java_tzdb$pacng$;
var $n_Lzonedb_java_tzdb$pacng$;
function $m_Lzonedb_java_tzdb$pacng$() {
  if ((!$n_Lzonedb_java_tzdb$pacng$)) {
    $n_Lzonedb_java_tzdb$pacng$ = new $c_Lzonedb_java_tzdb$pacng$()
  };
  return $n_Lzonedb_java_tzdb$pacng$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacof$() {
  this.Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo = null;
  $n_Lzonedb_java_tzdb$pacof$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-41096));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-41096));
  var _2 = [[1901001, 0, (-41096), (-39600)], [2011364, 0, (-39600), 46800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-41096), (-39600)], [2011364, 0, (-39600), 46800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacof$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacof$.prototype.constructor = $c_Lzonedb_java_tzdb$pacof$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacof$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacof$.prototype = $c_Lzonedb_java_tzdb$pacof$.prototype;
var $d_Lzonedb_java_tzdb$pacof$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacof$: 0
}, false, "zonedb.java.tzdb$pacof$", {
  Lzonedb_java_tzdb$pacof$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacof$.prototype.$classData = $d_Lzonedb_java_tzdb$pacof$;
var $n_Lzonedb_java_tzdb$pacof$;
function $m_Lzonedb_java_tzdb$pacof$() {
  if ((!$n_Lzonedb_java_tzdb$pacof$)) {
    $n_Lzonedb_java_tzdb$pacof$ = new $c_Lzonedb_java_tzdb$pacof$()
  };
  return $n_Lzonedb_java_tzdb$pacof$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacol$() {
  this.Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk = null;
  $n_Lzonedb_java_tzdb$pacol$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 40312);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 40312);
  var _2 = [[1901001, 0, 40312, 40320], [1951001, 0, 40320, 41400], [2015277, 7200, 41400, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 40312, 40320], [1951001, 0, 40320, 41400], [1974300, 7200, 41400, 45000], [1975061, 10800, 45000, 41400], [2015277, 7200, 41400, 39600], [2019279, 7200, 39600, 43200], [2020096, 10800, 43200, 39600], [2020278, 7200, 39600, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 7200, 0, 2, 39600, 43200, 39600], [10, 1, 7, 7200, 0, 2, 39600, 39600, 43200]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacol$.prototype.constructor = $c_Lzonedb_java_tzdb$pacol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacol$.prototype = $c_Lzonedb_java_tzdb$pacol$.prototype;
var $d_Lzonedb_java_tzdb$pacol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacol$: 0
}, false, "zonedb.java.tzdb$pacol$", {
  Lzonedb_java_tzdb$pacol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacol$.prototype.$classData = $d_Lzonedb_java_tzdb$pacol$;
var $n_Lzonedb_java_tzdb$pacol$;
function $m_Lzonedb_java_tzdb$pacol$() {
  if ((!$n_Lzonedb_java_tzdb$pacol$)) {
    $n_Lzonedb_java_tzdb$pacol$ = new $c_Lzonedb_java_tzdb$pacol$()
  };
  return $n_Lzonedb_java_tzdb$pacol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacpe$() {
  this.Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei = null;
  $n_Lzonedb_java_tzdb$pacpe$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-48428));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-48428));
  var _2 = [[1844366, 0, (-48428), 37972], [1901001, 0, 37972, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-48428), 37972], [1901001, 0, 37972, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacpe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacpe$.prototype.constructor = $c_Lzonedb_java_tzdb$pacpe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacpe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacpe$.prototype = $c_Lzonedb_java_tzdb$pacpe$.prototype;
var $d_Lzonedb_java_tzdb$pacpe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacpe$: 0
}, false, "zonedb.java.tzdb$pacpe$", {
  Lzonedb_java_tzdb$pacpe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacpe$.prototype.$classData = $d_Lzonedb_java_tzdb$pacpe$;
var $n_Lzonedb_java_tzdb$pacpe$;
function $m_Lzonedb_java_tzdb$pacpe$() {
  if ((!$n_Lzonedb_java_tzdb$pacpe$)) {
    $n_Lzonedb_java_tzdb$pacpe$ = new $c_Lzonedb_java_tzdb$pacpe$()
  };
  return $n_Lzonedb_java_tzdb$pacpe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacpi$() {
  this.Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia = null;
  $n_Lzonedb_java_tzdb$pacpi$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 45184);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 45184);
  var _2 = [[1892187, 0, 45184, (-41216)], [1911001, 0, (-41216), (-41400)], [1950001, 0, (-41400), (-39600)], [2011363, 82800, (-39600), 46800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1892187, 0, 45184, (-41216)], [1911001, 0, (-41216), (-41400)], [1950001, 0, (-41400), (-39600)], [2010269, 0, (-39600), (-36000)], [2011092, 14400, (-36000), (-39600)], [2011267, 10800, (-39600), (-36000)], [2011364, 0, (-36000), 50400], [2012092, 14400, 50400, 46800], [2012274, 10800, 46800, 50400], [2013097, 14400, 50400, 46800], [2013272, 10800, 46800, 50400]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 1, 7, 14400, 0, 1, 46800, 50400, 46800], [9, 24, 7, 10800, 0, 1, 46800, 46800, 50400]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacpi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacpi$.prototype.constructor = $c_Lzonedb_java_tzdb$pacpi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacpi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacpi$.prototype = $c_Lzonedb_java_tzdb$pacpi$.prototype;
var $d_Lzonedb_java_tzdb$pacpi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacpi$: 0
}, false, "zonedb.java.tzdb$pacpi$", {
  Lzonedb_java_tzdb$pacpi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacpi$.prototype.$classData = $d_Lzonedb_java_tzdb$pacpi$;
var $n_Lzonedb_java_tzdb$pacpi$;
function $m_Lzonedb_java_tzdb$pacpi$() {
  if ((!$n_Lzonedb_java_tzdb$pacpi$)) {
    $n_Lzonedb_java_tzdb$pacpi$ = new $c_Lzonedb_java_tzdb$pacpi$()
  };
  return $n_Lzonedb_java_tzdb$pacpi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacra$() {
  this.Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae = null;
  $n_Lzonedb_java_tzdb$pacra$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-47284));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-47284));
  var _2 = [[1844366, 0, (-47284), 39116], [1901001, 0, 39116, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600], [1969274, 0, 39600, 43200], [1999001, 0, 43200, 39600]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-47284), 39116], [1901001, 0, 39116, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600], [1969274, 0, 39600, 43200], [1999001, 0, 43200, 39600]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacra$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacra$.prototype.constructor = $c_Lzonedb_java_tzdb$pacra$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacra$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacra$.prototype = $c_Lzonedb_java_tzdb$pacra$.prototype;
var $d_Lzonedb_java_tzdb$pacra$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacra$: 0
}, false, "zonedb.java.tzdb$pacra$", {
  Lzonedb_java_tzdb$pacra$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacra$.prototype.$classData = $d_Lzonedb_java_tzdb$pacra$;
var $n_Lzonedb_java_tzdb$pacra$;
function $m_Lzonedb_java_tzdb$pacra$() {
  if ((!$n_Lzonedb_java_tzdb$pacra$)) {
    $n_Lzonedb_java_tzdb$pacra$ = new $c_Lzonedb_java_tzdb$pacra$()
  };
  return $n_Lzonedb_java_tzdb$pacra$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacsa$() {
  this.Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas = null;
  $n_Lzonedb_java_tzdb$pacsa$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-33480));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-33480));
  var _2 = [[1912275, 0, (-33480), (-34200)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1912275, 0, (-33480), (-34200)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacsa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacsa$.prototype.constructor = $c_Lzonedb_java_tzdb$pacsa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacsa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacsa$.prototype = $c_Lzonedb_java_tzdb$pacsa$.prototype;
var $d_Lzonedb_java_tzdb$pacsa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacsa$: 0
}, false, "zonedb.java.tzdb$pacsa$", {
  Lzonedb_java_tzdb$pacsa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacsa$.prototype.$classData = $d_Lzonedb_java_tzdb$pacsa$;
var $n_Lzonedb_java_tzdb$pacsa$;
function $m_Lzonedb_java_tzdb$pacsa$() {
  if ((!$n_Lzonedb_java_tzdb$pacsa$)) {
    $n_Lzonedb_java_tzdb$pacsa$ = new $c_Lzonedb_java_tzdb$pacsa$()
  };
  return $n_Lzonedb_java_tzdb$pacsa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacsb$() {
  this.Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby = null;
  $n_Lzonedb_java_tzdb$pacsb$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 35320);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 35320);
  var _2 = [[1880001, 0, 35320, 35312], [1895001, 0, 35312, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1880001, 0, 35320, 35312], [1895001, 0, 35312, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacsb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacsb$.prototype.constructor = $c_Lzonedb_java_tzdb$pacsb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacsb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacsb$.prototype = $c_Lzonedb_java_tzdb$pacsb$.prototype;
var $d_Lzonedb_java_tzdb$pacsb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacsb$: 0
}, false, "zonedb.java.tzdb$pacsb$", {
  Lzonedb_java_tzdb$pacsb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacsb$.prototype.$classData = $d_Lzonedb_java_tzdb$pacsb$;
var $n_Lzonedb_java_tzdb$pacsb$;
function $m_Lzonedb_java_tzdb$pacsb$() {
  if ((!$n_Lzonedb_java_tzdb$pacsb$)) {
    $n_Lzonedb_java_tzdb$pacsb$ = new $c_Lzonedb_java_tzdb$pacsb$()
  };
  return $n_Lzonedb_java_tzdb$pacsb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacte$() {
  this.Lzonedb_java_tzdb$pacte$__f_Pacific_Easter = null;
  $n_Lzonedb_java_tzdb$pacte$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-26248));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-26248));
  var _2 = [[1932245, 0, (-26248), (-25200)], [1982072, 72000, (-25200), (-21600)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1932245, 0, (-26248), (-25200)], [1968307, 75600, (-25200), (-21600)], [1969088, 75600, (-21600), (-25200)], [1969326, 75600, (-25200), (-21600)], [1970087, 75600, (-21600), (-25200)], [1970283, 75600, (-25200), (-21600)], [1971072, 75600, (-21600), (-25200)], [1971282, 75600, (-25200), (-21600)], [1972071, 75600, (-21600), (-25200)], [1972288, 75600, (-25200), (-21600)], [1973069, 75600, (-21600), (-25200)], [1973272, 75600, (-25200), (-21600)], [1974068, 75600, (-21600), (-25200)], [1974285, 75600, (-25200), (-21600)], [1975067, 75600, (-21600), (-25200)], [1975284, 75600, (-25200), (-21600)], [1976073, 75600, (-21600), (-25200)], [1976283, 75600, (-25200), (-21600)], [1977071, 75600, (-21600), (-25200)], [1977281, 75600, (-25200), (-21600)], [1978070, 75600, (-21600), (-25200)], [1978287, 75600, (-25200), (-21600)], [1979069, 75600, (-21600), (-25200)], [1979286, 75600, (-25200), (-21600)], [1980068, 75600, (-21600), (-25200)], [1980285, 75600, (-25200), (-21600)], [1981073, 75600, (-21600), (-25200)], [1981283, 75600, (-25200), (-21600)], [1982282, 79200, (-21600), (-18000)], [1983071, 79200, (-18000), (-21600)], [1983281, 79200, (-21600), (-18000)], [1984070, 79200, (-18000), (-21600)], [1984287, 79200, (-21600), (-18000)], [1985068, 79200, (-18000), (-21600)], [1985285, 79200, (-21600), (-18000)], [1986067, 79200, (-18000), (-21600)], [1986284, 79200, (-21600), (-18000)], [1987101, 79200, (-18000), (-21600)], [1987283, 79200, (-21600), (-18000)], [1988072, 79200, (-18000), (-21600)], [1988282, 79200, (-21600), (-18000)], [1989070, 79200, (-18000), (-21600)], [1989287, 79200, (-21600), (-18000)], [1990069, 79200, (-18000), (-21600)], [1990258, 79200, (-21600), (-18000)], [1991068, 79200, (-18000), (-21600)], [1991285, 79200, (-21600), (-18000)], [1992074, 79200, (-18000), (-21600)], [1992284, 79200, (-21600), (-18000)], [1993072, 79200, (-18000), (-21600)], [1993282, 79200, (-21600), (-18000)], [1994071, 79200, (-18000), (-21600)], [1994281, 79200, (-21600), (-18000)], [1995070, 79200, (-18000), (-21600)], [1995287, 79200, (-21600), (-18000)], [1996069, 79200, (-18000), (-21600)], [1996286, 79200, (-21600), (-18000)], [1997088, 79200, (-18000), (-21600)], [1997284, 79200, (-21600), (-18000)], [1998073, 79200, (-18000), (-21600)], [1998269, 79200, (-21600), (-18000)], [1999093, 79200, (-18000), (-21600)], [1999282, 79200, (-21600), (-18000)], [2000071, 79200, (-18000), (-21600)], [2000288, 79200, (-21600), (-18000)], [2001069, 79200, (-18000), (-21600)], [2001286, 79200, (-21600), (-18000)], [2002068, 79200, (-18000), (-21600)], [2002285, 79200, (-21600), (-18000)], [2003067, 79200, (-18000), (-21600)], [2003284, 79200, (-21600), (-18000)], [2004073, 79200, (-18000), (-21600)], [2004283, 79200, (-21600), (-18000)], [2005071, 79200, (-18000), (-21600)], [2005281, 79200, (-21600), (-18000)], [2006070, 79200, (-18000), (-21600)], [2006287, 79200, (-21600), (-18000)], [2007069, 79200, (-18000), (-21600)], [2007286, 79200, (-21600), (-18000)], [2008089, 79200, (-18000), (-21600)], [2008285, 79200, (-21600), (-18000)], [2009073, 79200, (-18000), (-21600)], [2009283, 79200, (-21600), (-18000)], [2010093, 79200, (-18000), (-21600)], [2010282, 79200, (-21600), (-18000)], [2011127, 79200, (-18000), (-21600)], [2011232, 79200, (-21600), (-18000)], [2012119, 79200, (-18000), (-21600)], [2012245, 79200, (-21600), (-18000)], [2013117, 79200, (-18000), (-21600)], [2013250, 79200, (-21600), (-18000)], [2014116, 79200, (-18000), (-21600)], [2014249, 79200, (-21600), (-18000)], [2016135, 79200, (-18000), (-21600)], [2016226, 79200, (-21600), (-18000)], [2017133, 79200, (-18000), (-21600)], [2017224, 79200, (-21600), (-18000)], [2018132, 79200, (-18000), (-21600)], [2018223, 79200, (-21600), (-18000)], [2019096, 79200, (-18000), (-21600)], [2019250, 79200, (-21600), (-18000)], [2020095, 79200, (-18000), (-21600)], [2020249, 79200, (-21600), (-18000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [[4, 2, 7, 10800, 0, 0, (-21600), (-18000), (-21600)], [9, 2, 7, 14400, 0, 0, (-21600), (-21600), (-18000)]];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacte$__f_Pacific_Easter = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacte$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacte$.prototype.constructor = $c_Lzonedb_java_tzdb$pacte$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacte$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacte$.prototype = $c_Lzonedb_java_tzdb$pacte$.prototype;
var $d_Lzonedb_java_tzdb$pacte$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacte$: 0
}, false, "zonedb.java.tzdb$pacte$", {
  Lzonedb_java_tzdb$pacte$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacte$.prototype.$classData = $d_Lzonedb_java_tzdb$pacte$;
var $n_Lzonedb_java_tzdb$pacte$;
function $m_Lzonedb_java_tzdb$pacte$() {
  if ((!$n_Lzonedb_java_tzdb$pacte$)) {
    $n_Lzonedb_java_tzdb$pacte$ = new $c_Lzonedb_java_tzdb$pacte$()
  };
  return $n_Lzonedb_java_tzdb$pacte$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacua$() {
  this.Lzonedb_java_tzdb$pacua$__f_Pacific_Guam = null;
  $n_Lzonedb_java_tzdb$pacua$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-51660));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-51660));
  var _2 = [[1844366, 0, (-51660), 34740], [1901001, 0, 34740, 36000], [1941344, 0, 36000, 32400], [1944213, 0, 32400, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-51660), 34740], [1901001, 0, 34740, 36000], [1941344, 0, 36000, 32400], [1944213, 0, 32400, 36000], [1959178, 7200, 36000, 39600], [1961029, 7200, 39600, 36000], [1967244, 7200, 36000, 39600], [1969026, 60, 39600, 36000], [1969173, 7200, 36000, 39600], [1969243, 7200, 39600, 36000], [1970116, 7200, 36000, 39600], [1970249, 7200, 39600, 36000], [1971115, 7200, 36000, 39600], [1971248, 7200, 39600, 36000], [1973350, 7200, 36000, 39600], [1974055, 7200, 39600, 36000], [1976147, 7200, 36000, 39600], [1976235, 7260, 39600, 36000], [1977114, 7200, 36000, 39600], [1977240, 7200, 39600, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacua$__f_Pacific_Guam = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacua$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacua$.prototype.constructor = $c_Lzonedb_java_tzdb$pacua$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacua$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacua$.prototype = $c_Lzonedb_java_tzdb$pacua$.prototype;
var $d_Lzonedb_java_tzdb$pacua$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacua$: 0
}, false, "zonedb.java.tzdb$pacua$", {
  Lzonedb_java_tzdb$pacua$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacua$.prototype.$classData = $d_Lzonedb_java_tzdb$pacua$;
var $n_Lzonedb_java_tzdb$pacua$;
function $m_Lzonedb_java_tzdb$pacua$() {
  if ((!$n_Lzonedb_java_tzdb$pacua$)) {
    $n_Lzonedb_java_tzdb$pacua$ = new $c_Lzonedb_java_tzdb$pacua$()
  };
  return $n_Lzonedb_java_tzdb$pacua$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacul$() {
  this.Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu = null;
  $n_Lzonedb_java_tzdb$pacul$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-37886));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-37886));
  var _2 = [[1896013, 43200, (-37886), (-37800)], [1947159, 7200, (-37800), (-36000)]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1896013, 43200, (-37886), (-37800)], [1933120, 7200, (-37800), (-34200)], [1933141, 43200, (-34200), (-37800)], [1942040, 7200, (-37800), (-34200)], [1945273, 7200, (-34200), (-37800)], [1947159, 7200, (-37800), (-36000)]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacul$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacul$.prototype.constructor = $c_Lzonedb_java_tzdb$pacul$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacul$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacul$.prototype = $c_Lzonedb_java_tzdb$pacul$.prototype;
var $d_Lzonedb_java_tzdb$pacul$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacul$: 0
}, false, "zonedb.java.tzdb$pacul$", {
  Lzonedb_java_tzdb$pacul$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacul$.prototype.$classData = $d_Lzonedb_java_tzdb$pacul$;
var $n_Lzonedb_java_tzdb$pacul$;
function $m_Lzonedb_java_tzdb$pacul$() {
  if ((!$n_Lzonedb_java_tzdb$pacul$)) {
    $n_Lzonedb_java_tzdb$pacul$ = new $c_Lzonedb_java_tzdb$pacul$()
  };
  return $n_Lzonedb_java_tzdb$pacul$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacur$() {
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury = null;
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru = null;
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro = null;
  $n_Lzonedb_java_tzdb$pacur$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-41060));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-41060));
  var _2 = [[1901001, 0, (-41060), (-43200)], [1979274, 0, (-43200), (-39600)], [1994365, 0, (-39600), 46800]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, (-41060), (-43200)], [1979274, 0, (-43200), (-39600)], [1994365, 0, (-39600), 46800]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x10 = $m_sr_ScalaRunTime$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "s", 40060);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "w", 40060);
  var _2$3 = [[1921015, 0, 40060, 41400], [1942241, 0, 41400, 32400], [1945251, 0, 32400, 41400], [1979041, 7200, 41400, 43200]];
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "t", _2$3);
  var _2$4 = [[1921015, 0, 40060, 41400], [1942241, 0, 41400, 32400], [1945251, 0, 32400, 41400], [1979041, 7200, 41400, 43200]];
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "l", _2$4);
  var _2$5 = [];
  var fields$1 = $$x10.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x9, $$x8, $$x7, $$x6, $ct_T2__O__O__(new $c_T2(), "r", _2$5)]));
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x15 = $m_sr_ScalaRunTime$();
  var $$x14 = $ct_T2__O__O__(new $c_T2(), "s", 41088);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), "w", 41088);
  var _2$6 = [[1901001, 0, 41088, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944030, 0, 32400, 39600], [1969274, 0, 39600, 43200]];
  var $$x12 = $ct_T2__O__O__(new $c_T2(), "t", _2$6);
  var _2$7 = [[1901001, 0, 41088, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944030, 0, 32400, 39600], [1969274, 0, 39600, 43200]];
  var $$x11 = $ct_T2__O__O__(new $c_T2(), "l", _2$7);
  var _2$8 = [];
  var fields$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x14, $$x13, $$x12, $$x11, $ct_T2__O__O__(new $c_T2(), "r", _2$8)]));
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2)
}
$c_Lzonedb_java_tzdb$pacur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacur$.prototype.constructor = $c_Lzonedb_java_tzdb$pacur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacur$.prototype = $c_Lzonedb_java_tzdb$pacur$.prototype;
var $d_Lzonedb_java_tzdb$pacur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacur$: 0
}, false, "zonedb.java.tzdb$pacur$", {
  Lzonedb_java_tzdb$pacur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacur$.prototype.$classData = $d_Lzonedb_java_tzdb$pacur$;
var $n_Lzonedb_java_tzdb$pacur$;
function $m_Lzonedb_java_tzdb$pacur$() {
  if ((!$n_Lzonedb_java_tzdb$pacur$)) {
    $n_Lzonedb_java_tzdb$pacur$ = new $c_Lzonedb_java_tzdb$pacur$()
  };
  return $n_Lzonedb_java_tzdb$pacur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacut$() {
  this.Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti = null;
  $n_Lzonedb_java_tzdb$pacut$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", 43012);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", 43012);
  var _2 = [[1901001, 0, 43012, 43200]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1901001, 0, 43012, 43200]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacut$.prototype.constructor = $c_Lzonedb_java_tzdb$pacut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacut$.prototype = $c_Lzonedb_java_tzdb$pacut$.prototype;
var $d_Lzonedb_java_tzdb$pacut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacut$: 0
}, false, "zonedb.java.tzdb$pacut$", {
  Lzonedb_java_tzdb$pacut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacut$.prototype.$classData = $d_Lzonedb_java_tzdb$pacut$;
var $n_Lzonedb_java_tzdb$pacut$;
function $m_Lzonedb_java_tzdb$pacut$() {
  if ((!$n_Lzonedb_java_tzdb$pacut$)) {
    $n_Lzonedb_java_tzdb$pacut$ = new $c_Lzonedb_java_tzdb$pacut$()
  };
  return $n_Lzonedb_java_tzdb$pacut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacuu$() {
  this.Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk = null;
  $n_Lzonedb_java_tzdb$pacuu$ = this;
  var $$x5 = $m_sr_ScalaRunTime$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "s", (-49972));
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "w", (-49972));
  var _2 = [[1844366, 0, (-49972), 36428], [1901001, 0, 36428, 36000], [1914274, 0, 36000, 32400], [1919032, 0, 32400, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 36000]];
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "t", _2);
  var _2$1 = [[1844366, 0, (-49972), 36428], [1901001, 0, 36428, 36000], [1914274, 0, 36000, 32400], [1919032, 0, 32400, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 36000]];
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "l", _2$1);
  var _2$2 = [];
  var fields = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "r", _2$2)]));
  this.Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Lzonedb_java_tzdb$pacuu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacuu$.prototype.constructor = $c_Lzonedb_java_tzdb$pacuu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacuu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacuu$.prototype = $c_Lzonedb_java_tzdb$pacuu$.prototype;
var $d_Lzonedb_java_tzdb$pacuu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacuu$: 0
}, false, "zonedb.java.tzdb$pacuu$", {
  Lzonedb_java_tzdb$pacuu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacuu$.prototype.$classData = $d_Lzonedb_java_tzdb$pacuu$;
var $n_Lzonedb_java_tzdb$pacuu$;
function $m_Lzonedb_java_tzdb$pacuu$() {
  if ((!$n_Lzonedb_java_tzdb$pacuu$)) {
    $n_Lzonedb_java_tzdb$pacuu$ = new $c_Lzonedb_java_tzdb$pacuu$()
  };
  return $n_Lzonedb_java_tzdb$pacuu$
}
/** @constructor */
function $c_Lcats_Eval() {
  /*<skip>*/
}
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
  /*<skip>*/
}
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2) => ((a) => {
    var value = f$2.apply__O__O(a);
    return new $c_Lcats_Now(value)
  }))(f)))
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  if ((this instanceof $c_Lcats_Eval$FlatMap)) {
    var c = $as_Lcats_Eval$FlatMap(this);
    return new $c_Lcats_Eval$$anon$1(f, c)
  } else if ((this instanceof $c_Lcats_Eval$Defer)) {
    var c$2 = $as_Lcats_Eval$Defer(this);
    return new $c_Lcats_Eval$$anon$2(f, c$2)
  } else {
    return new $c_Lcats_Eval$$anon$3(f, this)
  }
});
function $as_Lcats_Eval(obj) {
  return (((obj instanceof $c_Lcats_Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval"))
}
function $isArrayOf_Lcats_Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval)))
}
function $asArrayOf_Lcats_Eval(obj, depth) {
  return (($isArrayOf_Lcats_Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval;", depth))
}
/** @constructor */
function $c_Lcats_EvalInstances0() {
  /*<skip>*/
}
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
  /*<skip>*/
}
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
/** @constructor */
function $c_Lcats_Foldable$$anon$3() {
  /*<skip>*/
}
$c_Lcats_Foldable$$anon$3.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$$anon$3.prototype.constructor = $c_Lcats_Foldable$$anon$3;
/** @constructor */
function $h_Lcats_Foldable$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$3.prototype = $c_Lcats_Foldable$$anon$3.prototype;
$c_Lcats_Foldable$$anon$3.prototype.uncons__s_Option = (function() {
  return $m_s_None$()
});
var $d_Lcats_Foldable$$anon$3 = new $TypeData().initClass({
  Lcats_Foldable$$anon$3: 0
}, false, "cats.Foldable$$anon$3", {
  Lcats_Foldable$$anon$3: 1,
  Lcats_Foldable$Source: 1,
  O: 1
});
$c_Lcats_Foldable$$anon$3.prototype.$classData = $d_Lcats_Foldable$$anon$3;
/** @constructor */
function $c_Lcats_Foldable$$anon$4(a$5, src$10) {
  this.Lcats_Foldable$$anon$4__f_a$1 = null;
  this.Lcats_Foldable$$anon$4__f_src$1 = null;
  this.Lcats_Foldable$$anon$4__f_a$1 = a$5;
  this.Lcats_Foldable$$anon$4__f_src$1 = src$10
}
$c_Lcats_Foldable$$anon$4.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$$anon$4.prototype.constructor = $c_Lcats_Foldable$$anon$4;
/** @constructor */
function $h_Lcats_Foldable$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$4.prototype = $c_Lcats_Foldable$$anon$4.prototype;
$c_Lcats_Foldable$$anon$4.prototype.uncons__s_Option = (function() {
  var _1 = this.Lcats_Foldable$$anon$4__f_a$1;
  var _2 = this.Lcats_Foldable$$anon$4__f_src$1;
  var value = $ct_T2__O__O__(new $c_T2(), _1, _2);
  return new $c_s_Some(value)
});
var $d_Lcats_Foldable$$anon$4 = new $TypeData().initClass({
  Lcats_Foldable$$anon$4: 0
}, false, "cats.Foldable$$anon$4", {
  Lcats_Foldable$$anon$4: 1,
  Lcats_Foldable$Source: 1,
  O: 1
});
$c_Lcats_Foldable$$anon$4.prototype.$classData = $d_Lcats_Foldable$$anon$4;
function $is_Lcats_SemigroupK(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_SemigroupK)))
}
function $as_Lcats_SemigroupK(obj) {
  return (($is_Lcats_SemigroupK(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.SemigroupK"))
}
function $isArrayOf_Lcats_SemigroupK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_SemigroupK)))
}
function $asArrayOf_Lcats_SemigroupK(obj, depth) {
  return (($isArrayOf_Lcats_SemigroupK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.SemigroupK;", depth))
}
/** @constructor */
function $c_Lcats_Show$$anon$2(target$1, tc$1) {
  this.Lcats_Show$$anon$2__f_self = null;
  this.Lcats_Show$$anon$2__f_typeClassInstance = null;
  this.Lcats_Show$$anon$2__f_self = target$1;
  this.Lcats_Show$$anon$2__f_typeClassInstance = tc$1
}
$c_Lcats_Show$$anon$2.prototype = new $h_O();
$c_Lcats_Show$$anon$2.prototype.constructor = $c_Lcats_Show$$anon$2;
/** @constructor */
function $h_Lcats_Show$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$2.prototype = $c_Lcats_Show$$anon$2.prototype;
var $d_Lcats_Show$$anon$2 = new $TypeData().initClass({
  Lcats_Show$$anon$2: 0
}, false, "cats.Show$$anon$2", {
  Lcats_Show$$anon$2: 1,
  O: 1,
  Lcats_Show$Ops: 1
});
$c_Lcats_Show$$anon$2.prototype.$classData = $d_Lcats_Show$$anon$2;
function $ct_Lcats_data_AndThenInstances0__($thiz) {
  $thiz.Lcats_data_AndThenInstances0__f_catsDataArrowForAndThen = new $c_Lcats_data_AndThenInstances0$$anon$1();
  return $thiz
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0() {
  this.Lcats_data_AndThenInstances0__f_catsDataArrowForAndThen = null
}
$c_Lcats_data_AndThenInstances0.prototype = new $h_Lcats_data_AndThenInstances1();
$c_Lcats_data_AndThenInstances0.prototype.constructor = $c_Lcats_data_AndThenInstances0;
/** @constructor */
function $h_Lcats_data_AndThenInstances0() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances0.prototype = $c_Lcats_data_AndThenInstances0.prototype;
/** @constructor */
function $c_Lcats_data_Chain$NonEmpty() {
  /*<skip>*/
}
$c_Lcats_data_Chain$NonEmpty.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$NonEmpty.prototype.constructor = $c_Lcats_data_Chain$NonEmpty;
/** @constructor */
function $h_Lcats_data_Chain$NonEmpty() {
  /*<skip>*/
}
$h_Lcats_data_Chain$NonEmpty.prototype = $c_Lcats_data_Chain$NonEmpty.prototype;
function $as_Lcats_data_Chain$NonEmpty(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$NonEmpty) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$NonEmpty"))
}
function $isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$NonEmpty)))
}
function $asArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$NonEmpty;", depth))
}
/** @constructor */
function $c_Lcats_data_ChainInstances2() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances2.prototype = new $h_Lcats_data_ChainInstances3();
$c_Lcats_data_ChainInstances2.prototype.constructor = $c_Lcats_data_ChainInstances2;
/** @constructor */
function $h_Lcats_data_ChainInstances2() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances2.prototype = $c_Lcats_data_ChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances1() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances1.prototype = new $h_Lcats_data_ValidatedInstances2();
$c_Lcats_data_ValidatedInstances1.prototype.constructor = $c_Lcats_data_ValidatedInstances1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances1() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances1.prototype = $c_Lcats_data_ValidatedInstances1.prototype;
/** @constructor */
function $c_Lcats_data_WriterTInstances12() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances12.prototype = new $h_Lcats_data_WriterTInstances13();
$c_Lcats_data_WriterTInstances12.prototype.constructor = $c_Lcats_data_WriterTInstances12;
/** @constructor */
function $h_Lcats_data_WriterTInstances12() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances12.prototype = $c_Lcats_data_WriterTInstances12.prototype;
function $ps_Lcats_instances_Function0Instances__loop$1__F1__O__O(fn$4, thisA) {
  var thisA$tailLocal1 = thisA;
  while (true) {
    var x17 = $as_s_util_Either($as_F0(fn$4.apply__O__O(thisA$tailLocal1)).apply__O());
    if ((x17 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x17).s_util_Right__f_value;
      return b
    };
    if ((x17 instanceof $c_s_util_Left)) {
      var nextA = $as_s_util_Left(x17).s_util_Left__f_value;
      thisA$tailLocal1 = nextA;
      continue
    };
    throw new $c_s_MatchError(x17)
  }
}
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V(new $c_Lcats_instances_Function1Instances$$anon$1());
  $thiz.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V(new $c_Lcats_instances_Function1Instances$$anon$2($thiz))
}
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1()
}
$c_Lcats_instances_package$equiv$.prototype = new $h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
  /*<skip>*/
}
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
var $d_Lcats_instances_package$equiv$ = new $TypeData().initClass({
  Lcats_instances_package$equiv$: 0
}, false, "cats.instances.package$equiv$", {
  Lcats_instances_package$equiv$: 1,
  O: 1,
  Lcats_instances_EquivInstances: 1
});
$c_Lcats_instances_package$equiv$.prototype.$classData = $d_Lcats_instances_package$equiv$;
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$()
  };
  return $n_Lcats_instances_package$equiv$
}
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1()
}
$c_Lcats_instances_package$ordering$.prototype = new $h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
var $d_Lcats_instances_package$ordering$ = new $TypeData().initClass({
  Lcats_instances_package$ordering$: 0
}, false, "cats.instances.package$ordering$", {
  Lcats_instances_package$ordering$: 1,
  O: 1,
  Lcats_instances_OrderingInstances: 1
});
$c_Lcats_instances_package$ordering$.prototype.$classData = $d_Lcats_instances_package$ordering$;
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$()
  };
  return $n_Lcats_instances_package$ordering$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1()
}
$c_Lcats_instances_package$partialOrdering$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
var $d_Lcats_instances_package$partialOrdering$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrdering$: 0
}, false, "cats.instances.package$partialOrdering$", {
  Lcats_instances_package$partialOrdering$: 1,
  O: 1,
  Lcats_instances_PartialOrderingInstances: 1
});
$c_Lcats_instances_package$partialOrdering$.prototype.$classData = $d_Lcats_instances_package$partialOrdering$;
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$()
  };
  return $n_Lcats_instances_package$partialOrdering$
}
function $f_Lcats_kernel_Eq__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y))
}
function $is_Lcats_kernel_Eq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Eq)))
}
function $as_Lcats_kernel_Eq(obj) {
  return (($is_Lcats_kernel_Eq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Eq"))
}
function $isArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Eq)))
}
function $asArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Eq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Eq;", depth))
}
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_MonoidFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_MonoidFunctions.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_MonoidFunctions.prototype.constructor = $c_Lcats_kernel_MonoidFunctions;
/** @constructor */
function $h_Lcats_kernel_MonoidFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_MonoidFunctions.prototype = $c_Lcats_kernel_MonoidFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
function $is_Lcats_kernel_Semigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Semigroup)))
}
function $as_Lcats_kernel_Semigroup(obj) {
  return (($is_Lcats_kernel_Semigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Semigroup"))
}
function $isArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Semigroup)))
}
function $asArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Semigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Semigroup;", depth))
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StaticMethods$.prototype = new $h_Lcats_kernel_compat_HashCompat();
$c_Lcats_kernel_instances_StaticMethods$.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StaticMethods$.prototype = $c_Lcats_kernel_instances_StaticMethods$.prototype;
var $d_Lcats_kernel_instances_StaticMethods$ = new $TypeData().initClass({
  Lcats_kernel_instances_StaticMethods$: 0
}, false, "cats.kernel.instances.StaticMethods$", {
  Lcats_kernel_instances_StaticMethods$: 1,
  Lcats_kernel_compat_HashCompat: 1,
  O: 1
});
$c_Lcats_kernel_instances_StaticMethods$.prototype.$classData = $d_Lcats_kernel_instances_StaticMethods$;
var $n_Lcats_kernel_instances_StaticMethods$;
function $m_Lcats_kernel_instances_StaticMethods$() {
  if ((!$n_Lcats_kernel_instances_StaticMethods$)) {
    $n_Lcats_kernel_instances_StaticMethods$ = new $c_Lcats_kernel_instances_StaticMethods$()
  };
  return $n_Lcats_kernel_instances_StaticMethods$
}
function $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__($thiz, lastCursor, lastOp) {
  $thiz.Lio_circe_ACursor__f_lastCursor = lastCursor;
  $thiz.Lio_circe_ACursor__f_lastOp = lastOp;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_ACursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null
}
$c_Lio_circe_ACursor.prototype = new $h_O();
$c_Lio_circe_ACursor.prototype.constructor = $c_Lio_circe_ACursor;
/** @constructor */
function $h_Lio_circe_ACursor() {
  /*<skip>*/
}
$h_Lio_circe_ACursor.prototype = $c_Lio_circe_ACursor.prototype;
$c_Lio_circe_ACursor.prototype.history__sci_List = (function() {
  var next = this;
  $m_s_package$();
  var builder = new $c_scm_ListBuffer();
  while ((next !== null)) {
    if ((next.Lio_circe_ACursor__f_lastOp !== null)) {
      var elem = next.Lio_circe_ACursor__f_lastOp;
      builder.addOne__O__scm_ListBuffer(elem)
    };
    next = next.Lio_circe_ACursor__f_lastCursor
  };
  return builder.toList__sci_List()
});
$c_Lio_circe_ACursor.prototype.get__T__Lio_circe_Decoder__s_util_Either = (function(k, d) {
  var this$1 = this.downField__T__Lio_circe_ACursor(k);
  return d.tryDecode__Lio_circe_ACursor__s_util_Either(this$1)
});
function $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either($thiz, c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var hc = $as_Lio_circe_HCursor(c);
    return $thiz.apply__Lio_circe_HCursor__s_util_Either(hc)
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("Attempt to decode value on failed cursor", ops);
    return new $c_s_util_Left(value)
  }
}
function $is_Lio_circe_Decoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_Decoder)))
}
function $as_Lio_circe_Decoder(obj) {
  return (($is_Lio_circe_Decoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Decoder"))
}
function $isArrayOf_Lio_circe_Decoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Decoder)))
}
function $asArrayOf_Lio_circe_Decoder(obj, depth) {
  return (($isArrayOf_Lio_circe_Decoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Decoder;", depth))
}
var $d_Lio_circe_Decoder = new $TypeData().initClass({
  Lio_circe_Decoder: 0
}, true, "io.circe.Decoder", {
  Lio_circe_Decoder: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
var $d_Lio_circe_Encoder = new $TypeData().initClass({
  Lio_circe_Encoder: 0
}, true, "io.circe.Encoder", {
  Lio_circe_Encoder: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_Lio_circe_JsonNumber() {
  /*<skip>*/
}
$c_Lio_circe_JsonNumber.prototype = new $h_O();
$c_Lio_circe_JsonNumber.prototype.constructor = $c_Lio_circe_JsonNumber;
/** @constructor */
function $h_Lio_circe_JsonNumber() {
  /*<skip>*/
}
$h_Lio_circe_JsonNumber.prototype = $c_Lio_circe_JsonNumber.prototype;
$c_Lio_circe_JsonNumber.prototype.toByte__s_Option = (function() {
  var x1 = this.toLong__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var t = $uJ($as_s_Some(x1).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var asByte = ((lo << 24) >> 24);
    var value = asByte;
    var hi$1 = (value >> 31);
    if (((lo === value) && (hi === hi$1))) {
      return new $c_s_Some(asByte)
    } else {
      return $m_s_None$()
    }
  };
  var x = $m_s_None$();
  if ((x === x1)) {
    return $m_s_None$()
  };
  throw new $c_s_MatchError(x1)
});
$c_Lio_circe_JsonNumber.prototype.toShort__s_Option = (function() {
  var x4 = this.toLong__s_Option();
  if ((x4 instanceof $c_s_Some)) {
    var t = $uJ($as_s_Some(x4).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var asShort = ((lo << 16) >> 16);
    var value = asShort;
    var hi$1 = (value >> 31);
    if (((lo === value) && (hi === hi$1))) {
      return new $c_s_Some(asShort)
    } else {
      return $m_s_None$()
    }
  };
  var x = $m_s_None$();
  if ((x === x4)) {
    return $m_s_None$()
  };
  throw new $c_s_MatchError(x4)
});
$c_Lio_circe_JsonNumber.prototype.toInt__s_Option = (function() {
  var x7 = this.toLong__s_Option();
  if ((x7 instanceof $c_s_Some)) {
    var t = $uJ($as_s_Some(x7).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var hi$1 = (lo >> 31);
    if (((lo === lo) && (hi === hi$1))) {
      return new $c_s_Some(lo)
    } else {
      return $m_s_None$()
    }
  };
  var x = $m_s_None$();
  if ((x === x7)) {
    return $m_s_None$()
  };
  throw new $c_s_MatchError(x7)
});
$c_Lio_circe_JsonNumber.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonNumber)) {
    var that$2 = $as_Lio_circe_JsonNumber(that);
    return $m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber.eqv__O__O__Z(this, that$2)
  } else {
    return false
  }
});
$c_Lio_circe_JsonNumber.prototype.hashCode__I = (function() {
  return this.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal().hashCode__I()
});
function $as_Lio_circe_JsonNumber(obj) {
  return (((obj instanceof $c_Lio_circe_JsonNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonNumber"))
}
function $isArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonNumber)))
}
function $asArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonNumber;", depth))
}
/** @constructor */
function $c_Lio_circe_JsonObject() {
  /*<skip>*/
}
$c_Lio_circe_JsonObject.prototype = new $h_O();
$c_Lio_circe_JsonObject.prototype.constructor = $c_Lio_circe_JsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject.prototype = $c_Lio_circe_JsonObject.prototype;
$c_Lio_circe_JsonObject.prototype.toString__T = (function() {
  var this$1 = $as_sc_IterableOnceOps(this.toIterable__sc_Iterable().map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var k = $as_T(x$1$1._1__O());
      var v = $as_Lio_circe_Json(x$1$1._2__O());
      return ((k + " -> ") + $m_Lio_circe_Json$().Lio_circe_Json$__f_showJson.show__O__T(v))
    };
    throw new $c_s_MatchError(x$1$1)
  }))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "object[", ",", "]")
});
$c_Lio_circe_JsonObject.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject)) {
    var that$2 = $as_Lio_circe_JsonObject(that);
    var x = this.toMap__sci_Map();
    var x$2 = that$2.toMap__sci_Map();
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lio_circe_JsonObject.prototype.hashCode__I = (function() {
  return this.toMap__sci_Map().hashCode__I()
});
function $as_Lio_circe_JsonObject(obj) {
  return (((obj instanceof $c_Lio_circe_JsonObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonObject"))
}
function $isArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject)))
}
function $asArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonObject;", depth))
}
function $is_Lio_circe_KeyDecoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_KeyDecoder)))
}
function $as_Lio_circe_KeyDecoder(obj) {
  return (($is_Lio_circe_KeyDecoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.KeyDecoder"))
}
function $isArrayOf_Lio_circe_KeyDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyDecoder)))
}
function $asArrayOf_Lio_circe_KeyDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_KeyDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.KeyDecoder;", depth))
}
/** @constructor */
function $c_Lio_circe_Printer$$anon$2() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this)
}
$c_Lio_circe_Printer$$anon$2.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$2.prototype.constructor = $c_Lio_circe_Printer$$anon$2;
/** @constructor */
function $h_Lio_circe_Printer$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$2.prototype = $c_Lio_circe_Printer$$anon$2.prototype;
$c_Lio_circe_Printer$$anon$2.prototype.initialValue__O = (function() {
  return $ct_jl_StringBuilder__(new $c_jl_StringBuilder())
});
var $d_Lio_circe_Printer$$anon$2 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$2: 0
}, false, "io.circe.Printer$$anon$2", {
  Lio_circe_Printer$$anon$2: 1,
  jl_ThreadLocal: 1,
  O: 1
});
$c_Lio_circe_Printer$$anon$2.prototype.$classData = $d_Lio_circe_Printer$$anon$2;
/** @constructor */
function $c_Lio_circe_Printer$$anon$3() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this)
}
$c_Lio_circe_Printer$$anon$3.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$3.prototype.constructor = $c_Lio_circe_Printer$$anon$3;
/** @constructor */
function $h_Lio_circe_Printer$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$3.prototype = $c_Lio_circe_Printer$$anon$3.prototype;
$c_Lio_circe_Printer$$anon$3.prototype.initialValue__O = (function() {
  return new $c_Lio_circe_Printer$AdaptiveSizePredictor()
});
var $d_Lio_circe_Printer$$anon$3 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$3: 0
}, false, "io.circe.Printer$$anon$3", {
  Lio_circe_Printer$$anon$3: 1,
  jl_ThreadLocal: 1,
  O: 1
});
$c_Lio_circe_Printer$$anon$3.prototype.$classData = $d_Lio_circe_Printer$$anon$3;
/** @constructor */
function $c_Lio_circe_Printer$AdaptiveSizePredictor() {
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_index = 0;
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_nextSize = 0;
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_decreasing = false;
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_index = 0;
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_nextSize = 32;
  this.Lio_circe_Printer$AdaptiveSizePredictor__f_decreasing = false
}
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype = new $h_Lio_circe_Printer$SizePredictor();
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype.constructor = $c_Lio_circe_Printer$AdaptiveSizePredictor;
/** @constructor */
function $h_Lio_circe_Printer$AdaptiveSizePredictor() {
  /*<skip>*/
}
$h_Lio_circe_Printer$AdaptiveSizePredictor.prototype = $c_Lio_circe_Printer$AdaptiveSizePredictor.prototype;
var $d_Lio_circe_Printer$AdaptiveSizePredictor = new $TypeData().initClass({
  Lio_circe_Printer$AdaptiveSizePredictor: 0
}, false, "io.circe.Printer$AdaptiveSizePredictor", {
  Lio_circe_Printer$AdaptiveSizePredictor: 1,
  Lio_circe_Printer$SizePredictor: 1,
  O: 1
});
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype.$classData = $d_Lio_circe_Printer$AdaptiveSizePredictor;
/** @constructor */
function $c_Lio_circe_Printer$PiecesAtDepth() {
  /*<skip>*/
}
$c_Lio_circe_Printer$PiecesAtDepth.prototype = new $h_O();
$c_Lio_circe_Printer$PiecesAtDepth.prototype.constructor = $c_Lio_circe_Printer$PiecesAtDepth;
/** @constructor */
function $h_Lio_circe_Printer$PiecesAtDepth() {
  /*<skip>*/
}
$h_Lio_circe_Printer$PiecesAtDepth.prototype = $c_Lio_circe_Printer$PiecesAtDepth.prototype;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal() {
  /*<skip>*/
}
$c_Lio_circe_numbers_BiggerDecimal.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal.prototype = $c_Lio_circe_numbers_BiggerDecimal.prototype;
/** @constructor */
function $c_jl_Byte$() {
  /*<skip>*/
}
$c_jl_Byte$.prototype = new $h_O();
$c_jl_Byte$.prototype.constructor = $c_jl_Byte$;
/** @constructor */
function $h_jl_Byte$() {
  /*<skip>*/
}
$h_jl_Byte$.prototype = $c_jl_Byte$.prototype;
$c_jl_Byte$.prototype.parseByte__T__I__B = (function(s, radix) {
  var r = $m_jl_Integer$().parseInt__T__I__I(s, radix);
  if (((r < (-128)) || (r > 127))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  } else {
    return ((r << 24) >> 24)
  }
});
var $d_jl_Byte$ = new $TypeData().initClass({
  jl_Byte$: 0
}, false, "java.lang.Byte$", {
  jl_Byte$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Byte$.prototype.$classData = $d_jl_Byte$;
var $n_jl_Byte$;
function $m_jl_Byte$() {
  if ((!$n_jl_Byte$)) {
    $n_jl_Byte$ = new $c_jl_Byte$()
  };
  return $n_jl_Byte$
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43600, 44016, 65296, 66720, 69734, 69872, 69942, 70096, 71360, 120782, 120792, 120802, 120812, 120822]));
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints)
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_isMirroredIndices = null;
  this.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
  /*<skip>*/
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >= 0) && (codePoint < 65536))) {
    return $as_T(String.fromCharCode(codePoint))
  } else if (((codePoint >= 0) && (codePoint <= 1114111))) {
    return $as_T(String.fromCharCode((65535 & (55296 | (((-64) + (codePoint >> 10)) | 0))), (65535 & (56320 | (1023 & codePoint)))))
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))))
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0)
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var p = $m_ju_Arrays$().binarySearch__AI__I__I(a, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1)
    } else {
      var v = ((codePoint - $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v)
    }
  };
  return ((value < radix) ? value : (-1))
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  if ((ch < 256)) {
    return (ch === 48)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var key = ch;
    return ($m_ju_Arrays$().binarySearch__AI__I__I(a, key) >= 0)
  }
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if (((((radix < 2) || (radix > 36)) || (digit < 0)) || (digit >= radix))) {
    return 0
  } else {
    var overBaseTen = (((-10) + digit) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result)
  }
});
$c_jl_Character$.prototype.isISOControl__I__Z = (function(codePoint) {
  return (((codePoint >= 0) && (codePoint <= 31)) || ((codePoint >= 127) && (codePoint <= 159)))
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch))
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint)
      } else {
        var this$1 = this.toString__I__T(codePoint);
        var upperChars = $as_T(this$1.toUpperCase());
        var x1$2 = $uI(upperChars.length);
        switch (x1$2) {
          case 1: {
            return (65535 & $uI(upperChars.charCodeAt(0)));
            break
          }
          case 2: {
            var high = (65535 & $uI(upperChars.charCodeAt(0)));
            var low = (65535 & $uI(upperChars.charCodeAt(1)));
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break
          }
          default: {
            return codePoint
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch))
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105
  } else {
    var this$1 = this.toString__I__T(codePoint);
    var lowerChars = $as_T(this$1.toLowerCase());
    var x1$2 = $uI(lowerChars.length);
    switch (x1$2) {
      case 1: {
        return (65535 & $uI(lowerChars.charCodeAt(0)));
        break
      }
      case 2: {
        var high = (65535 & $uI(lowerChars.charCodeAt(0)));
        var low = (65535 & $uI(lowerChars.charCodeAt(1)));
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break
      }
      default: {
        return codePoint
      }
    }
  }
});
var $d_jl_Character$ = new $TypeData().initClass({
  jl_Character$: 0
}, false, "java.lang.Character$", {
  jl_Character$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Character$.prototype.$classData = $d_jl_Character$;
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$()
  };
  return $n_jl_Character$
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrPat
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat)
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrHexPat
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat)
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var signStr = $as_T(groups[1]);
  var integralPartStr = $as_T(groups[2]);
  var fractionalPartStr = $as_T(groups[3]);
  var binaryExpStr = $as_T(groups[4]);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult)
}
function $p_jl_Double$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
  /*<skip>*/
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  return ((groups !== null) ? $uD(parseFloat(groups[1])) : $p_jl_Double$__parseDoubleSlowPath__T__D(this, s))
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-($uI(fractionalPartStr.length) << 2)) | 0);
  var i = 0;
  while (true) {
    if ((i !== $uI(mantissaStr0.length))) {
      var index = i;
      var $$x1 = ((65535 & $uI(mantissaStr0.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var beginIndex = i;
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  if ((mantissaStr === "")) {
    return 0.0
  };
  var mantissaStrLen = $uI(mantissaStr.length);
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var index$1 = j;
      if (((65535 & $uI(mantissaStr.charCodeAt(index$1))) !== 48)) {
        hasNonZeroChar = true
      };
      j = ((1 + j) | 0)
    };
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = ($as_T(mantissaStr.substring(0, maxPrecisionChars)) + compressedTail)
  } else {
    var truncatedMantissaStr = mantissaStr
  };
  var correction2 = (needsCorrection2 ? ((($uI(mantissaStr.length) - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  var binExpAndCorrection = ((binaryExp + fullCorrection) | 0);
  var binExpAndCorrection_div_3 = ((binExpAndCorrection / 3) | 0);
  var b = binExpAndCorrection_div_3;
  var correctingPow = $uD(Math.pow(2.0, b));
  var b$1 = ((binExpAndCorrection - (binExpAndCorrection_div_3 << 1)) | 0);
  var correctingPow3 = $uD(Math.pow(2.0, b$1));
  return (((mantissa * correctingPow) * correctingPow) * correctingPow3)
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1)
  } else if ((b !== b)) {
    return (-1)
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1))
    } else {
      return 0
    }
  } else {
    return ((a < b) ? (-1) : 1)
  }
});
var $d_jl_Double$ = new $TypeData().initClass({
  jl_Double$: 0
}, false, "java.lang.Double$", {
  jl_Double$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Double$.prototype.$classData = $d_jl_Double$;
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$()
  };
  return $n_jl_Double$
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true
  };
  return $thiz.jl_Float$__f_parseFloatRegExp
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp)
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z)
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z)
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z)
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var this$1 = $m_jl_Integer$();
  var e = ((this$1.parseInt__T__I__I(exponentStr, 10) - $uI(fractionalPartStr.length)) | 0);
  var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(mid);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw new $c_jl_AssertionError(("parseFloatCorrection was given a subnormal mid: " + mid))
  };
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var y = m.shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = x.compareTo__Ljava_math_BigInteger__I(y)
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = v.shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = x$1.compareTo__Ljava_math_BigInteger__I(m)
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = v$1.shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1)
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$4));
    var cmp = x$2.compareTo__Ljava_math_BigInteger__I(y$2)
  };
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $m_jl_FloatingPointBits$().floatToIntBits__F__I(zDown)) === 0) ? zDown : zUp)))
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue)
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
  /*<skip>*/
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  };
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN)
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $$x1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $$x1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr)
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $$x2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $$x2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr)
      }
    }
  };
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? Math.fround((-absResult)) : absResult)
});
var $d_jl_Float$ = new $TypeData().initClass({
  jl_Float$: 0
}, false, "java.lang.Float$", {
  jl_Float$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Float$.prototype.$classData = $d_jl_Float$;
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$()
  };
  return $n_jl_Float$
}
function $p_jl_Integer$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Integer$() {
  /*<skip>*/
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
  /*<skip>*/
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseInt__T__I__I = (function(s, radix) {
  var len = ((s === null) ? 0 : $uI(s.length));
  if ((((len === 0) || (radix < 2)) || (radix > 36))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var firstChar = (65535 & $uI(s.charCodeAt(0)));
  var negative = (firstChar === 45);
  var maxAbsValue = (negative ? 2.147483648E9 : 2.147483647E9);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  if ((i >= $uI(s.length))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var result = 0.0;
  while ((i !== len)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s.charCodeAt(index))), radix);
    result = ((result * radix) + digit);
    if (((digit === (-1)) || (result > maxAbsValue))) {
      $p_jl_Integer$__fail$1__T__E(this, s)
    };
    i = ((1 + i) | 0)
  };
  if (negative) {
    var n = (-result);
    return $uI((n | 0))
  } else {
    var n$1 = result;
    return $uI((n$1 | 0))
  }
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24)
});
var $d_jl_Integer$ = new $TypeData().initClass({
  jl_Integer$: 0
}, false, "java.lang.Integer$", {
  jl_Integer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Integer$.prototype.$classData = $d_jl_Integer$;
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$()
  };
  return $n_jl_Integer$
}
function $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var radix = 0;
    while ((radix < 2)) {
      r.push(null);
      radix = ((1 + radix) | 0)
    };
    while ((radix <= 36)) {
      var barrier = $intDiv(2147483647, radix);
      var radixPowLength = radix;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, radix);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0")
      };
      var value = radixPowLength;
      var hi = (value >> 31);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideUnsignedImpl__I__I__I__I__I((-1), (-1), value, hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, new $c_RTLong(value, hi), paddingZeros, new $c_RTLong(lo, hi$1)));
      radix = ((1 + radix) | 0)
    };
    $thiz.jl_Long$__f_StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true
  };
  return $thiz.jl_Long$__f_StringRadixInfos
}
function $p_jl_Long$__StringRadixInfos__O($thiz) {
  return ((!$thiz.jl_Long$__f_bitmap$0) ? $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) : $thiz.jl_Long$__f_StringRadixInfos)
}
function $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T($thiz, i, radix) {
  var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O($thiz)[radix]);
  var t = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var paddingZeros = radixInfo.jl_Long$StringRadixInfo__f_paddingZeros;
  var hi$1 = ((-2147483648) ^ hi);
  var res = "";
  var lo$1 = i.RTLong__f_lo;
  var hi$2 = i.RTLong__f_hi;
  var value__lo = lo$1;
  var value__hi = hi$2;
  while (true) {
    var b__lo = value__lo;
    var b__hi = value__hi;
    var lo$2 = b__lo;
    var hi$3 = ((-2147483648) ^ b__hi);
    if (((hi$3 === hi$1) ? (((-2147483648) ^ lo$2) >= ((-2147483648) ^ lo)) : (hi$3 > hi$1))) {
      var this$1__lo = value__lo;
      var this$1__hi = value__hi;
      var this$2 = $m_RTLong$();
      var lo$3 = this$2.divideUnsignedImpl__I__I__I__I__I(this$1__lo, this$1__hi, lo, hi);
      var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var this$3__lo = value__lo;
      var this$3__hi = value__hi;
      var a0 = (65535 & lo$3);
      var a1 = ((lo$3 >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((((((((Math.imul(lo$3, hi) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo = this$3__lo;
      var ahi = this$3__hi;
      var lo$5 = ((alo - lo$4) | 0);
      var remStr = $as_T(lo$5.toString(radix));
      res = ((("" + $as_T(paddingZeros.substring($uI(remStr.length)))) + remStr) + res);
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$4;
      value__lo = $$x1__lo;
      value__hi = $$x1__hi
    } else {
      break
    }
  };
  var this$7__lo = value__lo;
  var this$7__hi = value__hi;
  var x = this$7__lo;
  var $$x2 = x.toString(radix);
  return (("" + $as_T($$x2)) + res)
}
function $p_jl_Long$__parseLongError__T__E($thiz, s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s$1.charCodeAt(index))), radix$1);
    if ((digit === (-1))) {
      $p_jl_Long$__parseLongError__T__E($thiz, s$1)
    };
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0)
  };
  return result
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
  /*<skip>*/
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$toStringImpl__J__I__T = (function(i, radix) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  if (((lo >> 31) === hi)) {
    return $as_T(lo.toString(radix))
  } else if ((hi < 0)) {
    var lo$1 = i.RTLong__f_lo;
    var hi$1 = i.RTLong__f_hi;
    var lo$2 = ((-lo$1) | 0);
    var hi$2 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
    return ("-" + $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, new $c_RTLong(lo$2, hi$2), radix))
  } else {
    return $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, i, radix)
  }
});
$c_jl_Long$.prototype.parseLong__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  };
  var start = 0;
  var neg = false;
  var x1 = (65535 & $uI(s.charCodeAt(0)));
  switch (x1) {
    case 43: {
      start = 1;
      break
    }
    case 45: {
      start = 1;
      neg = true;
      break
    }
  };
  var t = this.parseUnsignedLongInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo$1, hi$1)
  } else {
    if ((hi < 0)) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo, hi)
  }
});
$c_jl_Long$.prototype.parseUnsignedLongInternal__T__I__I__J = (function(s, radix, start) {
  var length = $uI(s.length);
  if ((((start >= length) || (radix < 2)) || (radix > 36))) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O(this)[radix]);
    var chunkLen = radixInfo.jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $$x2 = $m_jl_Character$();
        var index = firstChunkStart;
        var $$x1 = $$x2.isZeroDigit__C__Z((65535 & $uI(s.charCodeAt(index))))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        firstChunkStart = ((1 + firstChunkStart) | 0)
      } else {
        break
      }
    };
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    var firstChunkLength = ((1 + $intMod((((-1) + ((length - firstChunkStart) | 0)) | 0), chunkLen)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0)
    } else {
      var t = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((Math.imul(x, hi$1) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$1 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$2 = ((lo$1 + x$1) | 0);
      var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$2) | 0) : hi$2);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$2, hi$4)
      } else {
        var t$1 = radixInfo.jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$5 = t$1.RTLong__f_hi;
        var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$4 === hi$5) ? (((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$3)) : (hi$4 > hi$5))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        var a0$1 = (65535 & lo$2);
        var a1$1 = ((lo$2 >>> 16) | 0);
        var b0$1 = (65535 & lo);
        var b1$1 = ((lo >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$7 = ((((((((Math.imul(lo$2, hi$1) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$5 = ((lo$4 + x$2) | 0);
        var hi$8 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$7) | 0) : hi$7);
        var hi$9 = ((-2147483648) ^ hi$8);
        if (((hi$9 === (-2147483648)) && (((-2147483648) ^ lo$5) < ((-2147483648) ^ x$2)))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        return new $c_RTLong(lo$5, hi$8)
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $$x1 = $as_T($uD((hi >>> 0)).toString(16));
    var s = $as_T($uD((lo >>> 0)).toString(16));
    var beginIndex = $uI(s.length);
    return ($$x1 + (("" + $as_T("00000000".substring(beginIndex))) + s))
  } else {
    return $as_T($uD((lo >>> 0)).toString(16))
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $$x2 = $as_T($uD((hp >>> 0)).toString(8));
    var s = $as_T($uD((mp >>> 0)).toString(8));
    var beginIndex = $uI(s.length);
    var $$x1 = $as_T("0000000000".substring(beginIndex));
    var s$1 = $as_T($uD((lp >>> 0)).toString(8));
    var beginIndex$1 = $uI(s$1.length);
    return (($$x2 + (("" + $$x1) + s)) + (("" + $as_T("0000000000".substring(beginIndex$1))) + s$1))
  } else if ((mp !== 0)) {
    var $$x3 = $as_T($uD((mp >>> 0)).toString(8));
    var s$2 = $as_T($uD((lp >>> 0)).toString(8));
    var beginIndex$2 = $uI(s$2.length);
    return ($$x3 + (("" + $as_T("0000000000".substring(beginIndex$2))) + s$2))
  } else {
    return $as_T($uD((lp >>> 0)).toString(8))
  }
});
var $d_jl_Long$ = new $TypeData().initClass({
  jl_Long$: 0
}, false, "java.lang.Long$", {
  jl_Long$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Long$.prototype.$classData = $d_jl_Long$;
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$()
  };
  return $n_jl_Long$
}
/** @constructor */
function $c_jl_Number() {
  /*<skip>*/
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
  /*<skip>*/
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $c_RTLong))
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"))
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)))
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth))
}
/** @constructor */
function $c_jl_Short$() {
  /*<skip>*/
}
$c_jl_Short$.prototype = new $h_O();
$c_jl_Short$.prototype.constructor = $c_jl_Short$;
/** @constructor */
function $h_jl_Short$() {
  /*<skip>*/
}
$h_jl_Short$.prototype = $c_jl_Short$.prototype;
$c_jl_Short$.prototype.parseShort__T__I__S = (function(s, radix) {
  var r = $m_jl_Integer$().parseInt__T__I__I(s, radix);
  if (((r < (-32768)) || (r > 32767))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  } else {
    return ((r << 16) >> 16)
  }
});
var $d_jl_Short$ = new $TypeData().initClass({
  jl_Short$: 0
}, false, "java.lang.Short$", {
  jl_Short$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Short$.prototype.$classData = $d_jl_Short$;
var $n_jl_Short$;
function $m_jl_Short$() {
  if ((!$n_jl_Short$)) {
    $n_jl_Short$ = new $c_jl_Short$()
  };
  return $n_jl_Short$
}
/** @constructor */
function $c_jl_String$() {
  this.jl_String$__f_CASE_INSENSITIVE_ORDER = null;
  this.jl_String$__f_bitmap$0 = false
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
  /*<skip>*/
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > value.u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $$x1 = result;
    var this$1 = value.get(i);
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$1)));
    i = ((1 + i) | 0)
  };
  return result
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args).toString__T()
});
var $d_jl_String$ = new $TypeData().initClass({
  jl_String$: 0
}, false, "java.lang.String$", {
  jl_String$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_String$.prototype.$classData = $d_jl_String$;
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$()
  };
  return $n_jl_String$
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_enableSuppression = enableSuppression;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable()
  };
  return $thiz
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_enableSuppression = false;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_stackTraceStateInternal = null;
    this.jl_Throwable__f_stackTrace = null;
    this.jl_Throwable__f_suppressed = null
  };
  initCause__jl_Throwable__jl_Throwable(cause) {
    this.jl_Throwable__f_e = cause;
    return this
  };
  getMessage__T() {
    return this.jl_Throwable__f_s
  };
  fillInStackTrace__jl_Throwable() {
    var identifyingString = Object.prototype.toString.call(this);
    if ((identifyingString === "[object Error]")) {
      this.jl_Throwable__f_stackTraceStateInternal = this
    } else if ((Error.captureStackTrace === (void 0))) {
      var e = new Error();
      this.jl_Throwable__f_stackTraceStateInternal = e
    } else {
      Error.captureStackTrace(this);
      this.jl_Throwable__f_stackTraceStateInternal = this
    };
    return this
  };
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message))
  };
  $js$exported$meth$toString__O() {
    return this.toString__T()
  };
  $js$exported$prop$name__O() {
    return $objectClassName(this)
  };
  $js$exported$prop$message__O() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m)
  };
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this)
  };
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that)
  };
  get "message"() {
    return this.$js$exported$prop$message__O()
  };
  get "name"() {
    return this.$js$exported$prop$name__O()
  };
  "toString"() {
    return this.$js$exported$meth$toString__O()
  };
}
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"))
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)))
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth))
}
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(diffScale$1)
}
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return ((augend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0)
}
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = thisValue$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0)
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_ONE = null;
  this.Ljava_math_BigDecimal$__f_TEN = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.Ljava_math_BigDecimal$__f_ONE = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  this.Ljava_math_BigDecimal$__f_TEN = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var n = this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n <= 0)) {
    var $$x1 = new $ac_I(0)
  } else {
    var array = new $ac_I(n);
    var i = 0;
    while ((i < n)) {
      var $$x2 = i;
      var arg1 = i;
      array.set($$x2, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.get(arg1)));
      i = ((1 + i) | 0)
    };
    var $$x1 = array
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = $$x1;
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var n$1 = this.Ljava_math_BigDecimal$__f_LongTenPows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n$1 <= 0)) {
    var $$x3 = new $ac_I(0)
  } else {
    var array$1 = new $ac_I(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      var $$x4 = i$1;
      var arg1$1 = i$1;
      array$1.set($$x4, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(arg1$1)));
      i$1 = ((1 + i$1) | 0)
    };
    var $$x3 = array$1
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = $$x3;
  var array$2 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var $$x5 = i$2;
    var arg1$2 = i$2;
    array$2.set($$x5, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), arg1$2, 0));
    i$2 = ((1 + i$2) | 0)
  };
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = array$2;
  var array$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var $$x6 = i$3;
    var arg1$3 = i$3;
    array$3.set($$x6, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, arg1$3));
    i$3 = ((1 + i$3) | 0)
  };
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = array$3;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < this.Ljava_math_BigDecimal$__f_ZeroScaledBy.u.length)) ? this.Ljava_math_BigDecimal$__f_ZeroScaledBy.get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)))
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ unscaledVal.RTLong__f_lo) < (-2147483637)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this.Ljava_math_BigDecimal$__f_BigIntScaledByZero.get(unscaledVal.RTLong__f_lo)
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__D__Ljava_math_BigDecimal = (function(d) {
  if ((((d === Infinity) || (d === (-Infinity))) || (d !== d))) {
    throw new $c_jl_NumberFormatException(("Infinity or NaN: " + d))
  };
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + d))
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < this.Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var this$1 = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = this.Ljava_math_BigDecimal$__f_LongTenPows.get(diffScale);
    var alo = this$1.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$1.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var this$2 = thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo$1 = this$2.RTLong__f_lo;
    var ahi = this$2.RTLong__f_hi;
    var lo$1 = ((alo$1 + lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
    return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  } else {
    var $$x2 = $m_Ljava_math_Multiplication$();
    var $$x1 = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $$x2.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x1, new $c_RTLong(diffScale, hi$2));
    var this$5 = thisValue.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var qr = scaledDividend.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(scaledDivisor);
  var this$1 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
  if ((this$1.Ljava_math_BigInteger__f_sign === 0)) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.Ljava_math_BigInteger$QuotAndRem__f_quot, scale)
  } else {
    var sign = Math.imul(scaledDividend.Ljava_math_BigInteger__f_sign, scaledDivisor.Ljava_math_BigInteger__f_sign);
    var parityBit = (qr.Ljava_math_BigInteger$QuotAndRem__f_quot.testBit__I__Z(0) ? 1 : 0);
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(scaledDivisor) < 63)) {
      var t = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.longValue__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = scaledDivisor.longValue__J();
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      if ((hi < 0)) {
        var lo$2 = ((-lo) | 0);
        var hi$2 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
        var this$5__lo = lo$2;
        var this$5__hi = hi$2
      } else {
        var this$5__lo = lo;
        var this$5__hi = hi
      };
      var lo$3 = this$5__lo;
      var lo$4 = (lo$3 << 1);
      var hi$3 = (((lo$3 >>> 31) | 0) | (this$5__hi << 1));
      var $$x1 = new $c_RTLong(lo$4, hi$3);
      if ((hi$1 < 0)) {
        var lo$5 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
        var x__lo = lo$5;
        var x__hi = hi$4
      } else {
        var x__lo = lo$1;
        var x__hi = hi$1
      };
      var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($$x1, new $c_RTLong(x__lo, x__hi));
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem) | 0)), roundingMode)
    } else {
      var compRem$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.abs__Ljava_math_BigInteger().shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(scaledDivisor.abs__Ljava_math_BigInteger());
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem$2) | 0)), roundingMode)
    };
    if ((compRem$3 !== 0)) {
      var this$9 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
      if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$9) < 63)) {
        var this$11 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot.longValue__J();
        var hi$5 = (compRem$3 >> 31);
        var alo = this$11.RTLong__f_lo;
        var ahi = this$11.RTLong__f_hi;
        var lo$6 = ((alo + compRem$3) | 0);
        var hi$6 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$5) | 0)) | 0) : ((ahi + hi$5) | 0));
        return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$6, hi$6), scale)
      } else {
        var this$14 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
        var $$x2 = $m_Ljava_math_BigInteger$();
        var hi$7 = (compRem$3 >> 31);
        var bi = $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(compRem$3, hi$7));
        var quotient2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$14, bi);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), quotient2, scale)
      }
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.Ljava_math_BigInteger$QuotAndRem__f_quot, scale)
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(scaledDividend.RTLong__f_lo, scaledDividend.RTLong__f_hi, scaledDivisor.RTLong__f_lo, scaledDivisor.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$1 = scaledDividend.RTLong__f_hi;
  var $$x1 = ((hi$1 < 0) ? (-1) : (((hi$1 === 0) && (scaledDividend.RTLong__f_lo === 0)) ? 0 : 1));
  var hi$2 = scaledDivisor.RTLong__f_hi;
  var sign = Math.imul($$x1, ((hi$2 < 0) ? (-1) : (((hi$2 === 0) && (scaledDivisor.RTLong__f_lo === 0)) ? 0 : 1)));
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(scaledDividend.RTLong__f_lo, scaledDividend.RTLong__f_hi, scaledDivisor.RTLong__f_lo, scaledDivisor.RTLong__f_hi);
  var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo === 0) && (hi === 0)))) {
    if ((hi < 0)) {
      var lo$2 = ((-lo) | 0);
      var hi$4 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var this$8__lo = lo$2;
      var this$8__hi = hi$4
    } else {
      var this$8__lo = lo;
      var this$8__hi = hi
    };
    var lo$3 = this$8__lo;
    var lo$4 = (lo$3 << 1);
    var hi$5 = (((lo$3 >>> 31) | 0) | (this$8__hi << 1));
    var $$x3 = new $c_RTLong(lo$4, hi$5);
    var ahi = scaledDivisor.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo$5 = scaledDivisor.RTLong__f_lo;
      var hi$6 = scaledDivisor.RTLong__f_hi;
      var lo$6 = ((-lo$5) | 0);
      var hi$7 = ((lo$5 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var x__lo = lo$6;
      var x__hi = hi$7;
      var $$x2 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x2 = scaledDivisor
    };
    var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($$x3, $$x2);
    var value = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$1), Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    var hi$8 = (value >> 31);
    var lo$7 = ((lo$1 + value) | 0);
    var hi$9 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$3 + hi$8) | 0)) | 0) : ((hi$3 + hi$8) | 0));
    var quotient__lo = lo$7;
    var quotient__hi = hi$9
  } else {
    var quotient__lo = lo$1;
    var quotient__hi = hi$3
  };
  return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(quotient__lo, quotient__hi), scale)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value1.RTLong__f_lo) > ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi > bhi))) {
    return 1
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ value1.RTLong__f_lo) < ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi$1 < bhi$1))) {
      return (-1)
    } else {
      return 0
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((len > 0)) {
    var array = new $ac_J(len);
    var acc = new $c_RTLong(1, 0);
    var i = 1;
    array.set(0, $uJ(acc));
    while ((i < len)) {
      var arg1 = acc;
      var t = $uJ(arg1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hi$1 = (pow >> 31);
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & pow);
      var b1 = ((pow >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(lo, hi$1) + Math.imul(hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      acc = new $c_RTLong(lo$1, hi$2);
      array.set(i, $uJ(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_J(0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var absFraction = ((fraction < 0) ? ((-fraction) | 0) : fraction);
  var sigFraction = ((fraction === 0) ? 0 : ((fraction < 0) ? (-1) : 1));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === roundingMode)) {
    return sigFraction
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === roundingMode)) {
      return 0
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === roundingMode)) {
        return ((sigFraction > 0) ? sigFraction : 0)
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === roundingMode)) {
          return ((sigFraction < 0) ? sigFraction : 0)
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === roundingMode)) {
            return ((absFraction >= 5) ? sigFraction : 0)
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === roundingMode)) {
              return ((absFraction > 5) ? sigFraction : 0)
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === roundingMode)) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0)
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === roundingMode)) {
                  if ((fraction === 0)) {
                    return 0
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary")
                  }
                } else {
                  throw new $c_s_MatchError(roundingMode)
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ longValue.RTLong__f_lo) < 0) : (ahi < (-1)))) {
    var $$x1 = true
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ longValue.RTLong__f_lo) > (-1)) : (ahi$1 > 0))
  };
  if ($$x1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue))
  };
  return longValue.RTLong__f_lo
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo)
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647)
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648))
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi)
  } else {
    var t = sValue
  };
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - Math.clz32(smallValue)) | 0)
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass({
  Ljava_math_BigDecimal$: 0
}, false, "java.math.BigDecimal$", {
  Ljava_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigDecimal$.prototype.$classData = $d_Ljava_math_BigDecimal$;
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$()
  };
  return $n_Ljava_math_BigDecimal$
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var array = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var $$x2 = i;
    var arg1 = i;
    var $$x1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & arg1) === 0) ? (1 << arg1) : 0);
    var hi = (((32 & arg1) === 0) ? 0 : (1 << arg1));
    array.set($$x2, $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi)));
    i = ((1 + i) | 0)
  };
  this.Ljava_math_BigInteger$__f_TWO_POWS = array
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var lo = lVal.RTLong__f_lo;
      var hi = lVal.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo$1, hi$1))
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ lVal.RTLong__f_lo) <= (-2147483638)) : (ahi$1 < 0))) {
      return this.Ljava_math_BigInteger$__f_SMALL_VALUES.get(lVal.RTLong__f_lo)
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal)
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < this.Ljava_math_BigInteger$__f_TWO_POWS.u.length)) {
    return this.Ljava_math_BigInteger$__f_TWO_POWS.get(exp)
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits)
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass({
  Ljava_math_BigInteger$: 0
}, false, "java.math.BigInteger$", {
  Ljava_math_BigInteger$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigInteger$.prototype.$classData = $d_Ljava_math_BigInteger$;
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$()
  };
  return $n_Ljava_math_BigInteger$
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  this.Ljava_math_RoundingMode$__f__values = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
  this.Ljava_math_RoundingMode$__f__values = new ($d_Ljava_math_RoundingMode.getArrayOf().constr)([this.Ljava_math_RoundingMode$__f_UP, this.Ljava_math_RoundingMode$__f_DOWN, this.Ljava_math_RoundingMode$__f_CEILING, this.Ljava_math_RoundingMode$__f_FLOOR, this.Ljava_math_RoundingMode$__f_HALF_UP, this.Ljava_math_RoundingMode$__f_HALF_DOWN, this.Ljava_math_RoundingMode$__f_HALF_EVEN, this.Ljava_math_RoundingMode$__f_UNNECESSARY])
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass({
  Ljava_math_RoundingMode$: 0
}, false, "java.math.RoundingMode$", {
  Ljava_math_RoundingMode$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode$.prototype.$classData = $d_Ljava_math_RoundingMode$;
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$()
  };
  return $n_Ljava_math_RoundingMode$
}
function $ct_Ljava_time_ZoneId__($thiz) {
  if ((($objectGetClass($thiz) !== $d_Ljava_time_ZoneOffset.getClassOf()) && ($objectGetClass($thiz) !== $d_Ljava_time_ZoneRegion.getClassOf()))) {
    throw new $c_jl_AssertionError("Invalid subclass")
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_time_ZoneId() {
  /*<skip>*/
}
$c_Ljava_time_ZoneId.prototype = new $h_O();
$c_Ljava_time_ZoneId.prototype.constructor = $c_Ljava_time_ZoneId;
/** @constructor */
function $h_Ljava_time_ZoneId() {
  /*<skip>*/
}
$h_Ljava_time_ZoneId.prototype = $c_Ljava_time_ZoneId.prototype;
$c_Ljava_time_ZoneId.prototype.normalized__Ljava_time_ZoneId = (function() {
  try {
    var rules = this.getRules__Ljava_time_zone_ZoneRules();
    if (rules.isFixedOffset__Z()) {
      return rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant())
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_time_zone_ZoneRulesException))) {
      throw e
    }
  };
  return this
});
$c_Ljava_time_ZoneId.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZoneId)) {
    var other = $as_Ljava_time_ZoneId(obj);
    return ((this === other) || (this.getId__T() === other.getId__T()))
  } else {
    return false
  }
});
$c_Ljava_time_ZoneId.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.getId__T())
});
$c_Ljava_time_ZoneId.prototype.toString__T = (function() {
  return this.getId__T()
});
function $as_Ljava_time_ZoneId(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneId) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneId"))
}
function $isArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneId)))
}
function $asArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneId(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneId;", depth))
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_ZonedDateTime$$anon$1.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime$$anon$1.prototype.constructor = $c_Ljava_time_ZonedDateTime$$anon$1;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_ZonedDateTime$$anon$1.prototype = $c_Ljava_time_ZonedDateTime$$anon$1.prototype;
$c_Ljava_time_ZonedDateTime$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_ZonedDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime(temporal)
});
var $d_Ljava_time_ZonedDateTime$$anon$1 = new $TypeData().initClass({
  Ljava_time_ZonedDateTime$$anon$1: 0
}, false, "java.time.ZonedDateTime$$anon$1", {
  Ljava_time_ZonedDateTime$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_ZonedDateTime$$anon$1.prototype.$classData = $d_Ljava_time_ZonedDateTime$$anon$1;
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2() {
  /*<skip>*/
}
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var zone = $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
  return (((zone !== null) && (!(zone instanceof $c_Ljava_time_ZoneOffset))) ? zone : null)
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal)
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$2 = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder$$anon$2: 0
}, false, "java.time.format.DateTimeFormatterBuilder$$anon$2", {
  Ljava_time_format_DateTimeFormatterBuilder$$anon$2: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$2;
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3() {
  /*<skip>*/
}
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.compare__T__T__I = (function(str1, str2) {
  return (($uI(str1.length) === $uI(str2.length)) ? $f_T__compareTo__T__I(str1, str2) : (($uI(str1.length) - $uI(str2.length)) | 0))
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.compare__O__O__I = (function(x$0, x$1) {
  return this.compare__T__T__I($as_T(x$0), $as_T(x$1))
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder$$anon$3: 0
}, false, "java.time.format.DateTimeFormatterBuilder$$anon$3", {
  Ljava_time_format_DateTimeFormatterBuilder$$anon$3: 1,
  O: 1,
  ju_Comparator: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$3;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = literal
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal;
  var str = $as_T(String.fromCharCode(c));
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  if ((position === length)) {
    return (~position)
  };
  if (((position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var ch = $dp_charAt__I__C(text, position);
  if ((!context.charEquals__C__C__Z(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal, ch))) {
    return (~position)
  };
  return ((1 + position) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.toString__T = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal === 39) ? "''" : (("'" + $bC(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal)) + "'"))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers, optional) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = printerParsers;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = optional;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__($thiz, printerParsers, optional) {
  var dimensions = new $ac_I(new Int32Array([printerParsers.size__I()]));
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, $asArrayOf_Ljava_time_format_internal_DateTimePrinterParser(printerParsers.toArray__AO__AO($asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_format_internal_DateTimePrinterParser.getClassOf(), dimensions), 1)), 1), optional);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = false
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = (function(optional) {
  return ((optional === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers, optional))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    var length = buf.length__I();
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      context.startOptional__V()
    };
    try {
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((this$2, context$2, buf$2, length$2, nonLocalReturnKey1$2) => ((pp) => {
        var pp$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(pp);
        if ((!pp$1.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context$2, buf$2))) {
          buf$2.setLength__I__V(length$2);
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey1$2, true)
        }
      }))(this, context, buf, length, nonLocalReturnKey1);
      var len = xs.u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var arg1 = xs.get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var arg1$1 = x3.get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var arg1$2 = x4.get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var t = x5.get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var arg1$3 = x6.get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var arg1$4 = x7.get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var arg1$5 = x8.get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var arg1$6 = x9.get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var arg1$7 = x10.get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      }
    } finally {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
        context.endOptional__V()
      }
    };
    return true
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if ((ex.sr_NonLocalReturnControl__f_key === nonLocalReturnKey1)) {
        return $uZ(ex.sr_NonLocalReturnControl__f_value)
      } else {
        throw ex
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var nonLocalReturnKey2 = $ct_O__(new $c_O());
  try {
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      context.startOptional__V();
      var pos = new $c_sr_IntRef(position);
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((this$3, context$2, text$2, _position$2, pos$2, nonLocalReturnKey2$2) => ((pp) => {
        var pp$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(pp);
        var ev$5 = pp$1.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context$2, text$2, pos$2.sr_IntRef__f_elem);
        pos$2.sr_IntRef__f_elem = ev$5;
        if ((pos$2.sr_IntRef__f_elem < 0)) {
          context$2.endOptional__Z__V(false);
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey2$2, _position$2)
        }
      }))(this, context, text, position, pos, nonLocalReturnKey2);
      var len = xs.u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var arg1 = xs.get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var arg1$1 = x3.get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var arg1$2 = x4.get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var t = x5.get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var arg1$3 = x6.get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var arg1$4 = x7.get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var arg1$5 = x8.get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var arg1$6 = x9.get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var arg1$7 = x10.get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      };
      context.endOptional__Z__V(true);
      return pos.sr_IntRef__f_elem
    } else {
      var xs$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f$1 = ((this$2$1, context$3, text$3) => ((x$1, x$2) => {
        var x$1$1 = $uI(x$1);
        var x$2$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(x$2);
        return ((x$1$1 < 0) ? x$1$1 : x$2$1.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context$3, text$3, x$1$1))
      }))(this, context, text);
      if ((xs$1 === null)) {
        throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
      };
      if ((xs$1 !== null)) {
        var length = xs$1.u.length;
        var v = position;
        var i$1 = 0;
        while ((i$1 < length)) {
          var arg1$8 = v;
          var arg2 = xs$1.get(i$1);
          v = f$1(arg1$8, arg2);
          i$1 = ((1 + i$1) | 0)
        };
        var $$x1 = v
      } else if ((xs$1 instanceof $ac_I)) {
        var x4$1 = $asArrayOf_I(xs$1, 1);
        var length$1 = x4$1.u.length;
        var v$1 = position;
        var i$2 = 0;
        while ((i$2 < length$1)) {
          var arg1$9 = v$1;
          var arg2$1 = x4$1.get(i$2);
          v$1 = f$1(arg1$9, arg2$1);
          i$2 = ((1 + i$2) | 0)
        };
        var $$x1 = v$1
      } else if ((xs$1 instanceof $ac_D)) {
        var x5$1 = $asArrayOf_D(xs$1, 1);
        var length$2 = x5$1.u.length;
        var v$2 = position;
        var i$3 = 0;
        while ((i$3 < length$2)) {
          var arg1$10 = v$2;
          var arg2$2 = x5$1.get(i$3);
          v$2 = f$1(arg1$10, arg2$2);
          i$3 = ((1 + i$3) | 0)
        };
        var $$x1 = v$2
      } else if ((xs$1 instanceof $ac_J)) {
        var x6$1 = $asArrayOf_J(xs$1, 1);
        var length$3 = x6$1.u.length;
        var v$3 = position;
        var i$4 = 0;
        while ((i$4 < length$3)) {
          var arg1$11 = v$3;
          var t$1 = x6$1.get(i$4);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          v$3 = f$1(arg1$11, new $c_RTLong(lo$1, hi$1));
          i$4 = ((1 + i$4) | 0)
        };
        var $$x1 = v$3
      } else if ((xs$1 instanceof $ac_F)) {
        var x7$1 = $asArrayOf_F(xs$1, 1);
        var length$4 = x7$1.u.length;
        var v$4 = position;
        var i$5 = 0;
        while ((i$5 < length$4)) {
          var arg1$12 = v$4;
          var arg2$3 = x7$1.get(i$5);
          v$4 = f$1(arg1$12, arg2$3);
          i$5 = ((1 + i$5) | 0)
        };
        var $$x1 = v$4
      } else if ((xs$1 instanceof $ac_C)) {
        var x8$1 = $asArrayOf_C(xs$1, 1);
        var length$5 = x8$1.u.length;
        var v$5 = position;
        var i$6 = 0;
        while ((i$6 < length$5)) {
          var arg1$13 = v$5;
          var arg2$4 = x8$1.get(i$6);
          v$5 = f$1(arg1$13, $bC(arg2$4));
          i$6 = ((1 + i$6) | 0)
        };
        var $$x1 = v$5
      } else if ((xs$1 instanceof $ac_B)) {
        var x9$1 = $asArrayOf_B(xs$1, 1);
        var length$6 = x9$1.u.length;
        var v$6 = position;
        var i$7 = 0;
        while ((i$7 < length$6)) {
          var arg1$14 = v$6;
          var arg2$5 = x9$1.get(i$7);
          v$6 = f$1(arg1$14, arg2$5);
          i$7 = ((1 + i$7) | 0)
        };
        var $$x1 = v$6
      } else if ((xs$1 instanceof $ac_S)) {
        var x10$1 = $asArrayOf_S(xs$1, 1);
        var length$7 = x10$1.u.length;
        var v$7 = position;
        var i$8 = 0;
        while ((i$8 < length$7)) {
          var arg1$15 = v$7;
          var arg2$6 = x10$1.get(i$8);
          v$7 = f$1(arg1$15, arg2$6);
          i$8 = ((1 + i$8) | 0)
        };
        var $$x1 = v$7
      } else if ((xs$1 instanceof $ac_Z)) {
        var x11 = $asArrayOf_Z(xs$1, 1);
        var length$8 = x11.u.length;
        var v$8 = position;
        var i$9 = 0;
        while ((i$9 < length$8)) {
          var arg1$16 = v$8;
          var arg2$7 = x11.get(i$9);
          v$8 = f$1(arg1$16, arg2$7);
          i$9 = ((1 + i$9) | 0)
        };
        var $$x1 = v$8
      } else {
        if ((!$isArrayOf_jl_Void(xs$1, 1))) {
          throw new $c_s_MatchError(xs$1)
        };
        var x12 = $asArrayOf_jl_Void(xs$1, 1);
        var length$9 = x12.u.length;
        var v$9 = position;
        var i$10 = 0;
        while ((i$10 < length$9)) {
          var arg1$17 = v$9;
          var arg2$8 = x12.get(i$10);
          v$9 = f$1(arg1$17, arg2$8);
          i$10 = ((1 + i$10) | 0)
        };
        var $$x1 = v$9
      };
      return $uI($$x1)
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if ((ex.sr_NonLocalReturnControl__f_key === nonLocalReturnKey2)) {
        return $uI(ex.sr_NonLocalReturnControl__f_value)
      } else {
        throw ex
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.toString__T = (function() {
  var buf = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers !== null)) {
    var str = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "[" : "(");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
    var f = ((this$2, buf$2) => ((pp) => {
      var pp$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(pp);
      buf$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + pp$1);
      return buf$2
    }))(this, buf);
    var len = xs.u.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var arg1 = xs.get(i);
        f(arg1);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var arg1$1 = x3.get(i);
        f(arg1$1);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var arg1$2 = x4.get(i);
        f(arg1$2);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var t = x5.get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var arg1$3 = x6.get(i);
        f(arg1$3);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var arg1$4 = x7.get(i);
        f($bC(arg1$4));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var arg1$5 = x8.get(i);
        f(arg1$5);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var arg1$6 = x9.get(i);
        f(arg1$6);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var arg1$7 = x10.get(i);
        f(arg1$7);
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    };
    var str$1 = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "]" : ")");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1)
  };
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CompositePrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal($thiz, value) {
  var this$1 = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field;
  var range = this$1.Ljava_time_temporal_ChronoField__f__range;
  range.checkValidValue__J__Ljava_time_temporal_TemporalField__J($uJ(value), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  var t = range.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var t$1 = range.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var t$2 = $uJ(value);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var valueBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$2, hi$2)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD);
  var fraction = valueBD.divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(rangeBD, 9, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
  return ((fraction.compareTo__Ljava_math_BigDecimal__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO) === 0) ? $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO : fraction.stripTrailingZeros__Ljava_math_BigDecimal())
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long($thiz, fraction) {
  var this$1 = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field;
  var range = this$1.Ljava_time_temporal_ChronoField__f__range;
  var t = range.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var t$1 = range.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var this$2 = fraction.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal(rangeBD).setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(0, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD);
  var t$2 = $p_Ljava_math_BigDecimal__valueExact__I__J(this$2, 64);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  return new $c_RTLong(lo$2, hi$2)
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = field;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = minWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = maxWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = decimalPoint;
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((!field.Ljava_time_temporal_ChronoField__f__range.isFixed__Z())) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Field must have a fixed set of values: " + field))
  };
  if (((minWidth < 0) || (minWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Minimum width must be from 0 to 9 inclusive but was " + minWidth))
  };
  if (((maxWidth < 1) || (maxWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Maximum width must be from 1 to 9 inclusive but was " + maxWidth))
  };
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth))
  }
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var value = context.getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  if ((value === null)) {
    return false
  };
  var symbols = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  var fraction = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal(this, value);
  var this$1 = fraction;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth > 0)) {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
        var c = symbols.Ljava_time_format_DecimalStyle__f_decimalSeparator;
        var str = $as_T(String.fromCharCode(c));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
      };
      var i = 0;
      while ((i < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth)) {
        var c$1 = symbols.Ljava_time_format_DecimalStyle__f_zeroDigit;
        var str$1 = $as_T(String.fromCharCode(c$1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  } else {
    var this$4 = fraction;
    var a = this$4.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var b = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth;
    var a$1 = ((a > b) ? a : b);
    var b$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth;
    var outputScale = ((a$1 < b$1) ? a$1 : b$1);
    fraction = fraction.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(outputScale, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
    var this$7 = fraction.toPlainString__T();
    var str$2 = $as_T(this$7.substring(2));
    str$2 = symbols.convertNumberToI18N__T__T(str$2);
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
      var c$2 = symbols.Ljava_time_format_DecimalStyle__f_decimalSeparator;
      var str$3 = $as_T(String.fromCharCode(c$2));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3)
    };
    var str$4 = str$2;
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4)
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var effectiveMin = (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth : 0);
  var effectiveMax = (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth : 9);
  var length = $dp_length__I(text);
  if ((_position === length)) {
    return ((effectiveMin > 0) ? (~_position) : _position)
  };
  if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
    var $$x1 = $dp_charAt__I__C(text, _position);
    var this$1 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
    if (($$x1 !== this$1.Ljava_time_format_DecimalStyle__f_decimalSeparator)) {
      return ((effectiveMin > 0) ? (~_position) : _position)
    };
    _position = ((1 + _position) | 0)
  };
  var minEndPos = ((_position + effectiveMin) | 0);
  if ((minEndPos > length)) {
    return (~_position)
  };
  var a = ((_position + effectiveMax) | 0);
  var maxEndPos = ((a < length) ? a : length);
  var total = 0;
  var pos = _position;
  var break$1 = false;
  while (((!break$1) && (pos < maxEndPos))) {
    var ch = $dp_charAt__I__C(text, pos);
    pos = ((1 + pos) | 0);
    var digit = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols.convertToDigit__C__I(ch);
    if ((digit < 0)) {
      if ((pos < minEndPos)) {
        return (~_position)
      };
      pos = (((-1) + pos) | 0);
      break$1 = true
    };
    if ((!break$1)) {
      total = ((Math.imul(10, total) + digit) | 0)
    }
  };
  var fraction = $ct_Ljava_math_BigDecimal__I__(new $c_Ljava_math_BigDecimal(), total).movePointLeft__I__Ljava_math_BigDecimal(((pos - _position) | 0));
  var value = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long(this, fraction);
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field, $uJ(value), _position, pos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.toString__T = (function() {
  var decimal = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint ? ",DecimalPoint" : "");
  return ((((((("Fraction(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth) + decimal) + ")")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$FractionPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser(fractionalDigits) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = fractionalDigits
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var inSecs = context.getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var inNanos = $L0;
  if (context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var t = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    inNanos = new $c_RTLong(lo, hi)
  };
  if ((inSecs === null)) {
    return false
  };
  var this$4 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var x = inNanos;
  var t$1 = $uJ(x);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var inNano = this$4.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$4);
  var this$10 = $uJ(inSecs);
  var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
  var this$7 = $uJ(x$1);
  var lo$2 = this$7.RTLong__f_lo;
  var hi$2 = this$7.RTLong__f_hi;
  var lo$3 = ((-lo$2) | 0);
  var hi$3 = ((lo$2 !== 0) ? (~hi$2) : ((-hi$2) | 0));
  var ahi = this$10.RTLong__f_hi;
  if (((ahi === hi$3) ? (((-2147483648) ^ this$10.RTLong__f_lo) >= ((-2147483648) ^ lo$3)) : (ahi > hi$3))) {
    var this$13 = $uJ(inSecs);
    var x$2 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b = $uJ(x$2);
    var alo = this$13.RTLong__f_lo;
    var ahi$1 = this$13.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var lo$4 = ((alo - b.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi$1 - bhi) | 0)) | 0) : ((ahi$1 - bhi) | 0));
    var x$3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$1 = $uJ(x$3);
    var bhi$1 = b$1.RTLong__f_hi;
    var lo$5 = ((lo$4 + b$1.RTLong__f_lo) | 0);
    var hi$5 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$4 + bhi$1) | 0)) | 0) : ((hi$4 + bhi$1) | 0));
    var t$2 = $uJ(new $c_RTLong(lo$5, hi$5));
    var lo$6 = t$2.RTLong__f_lo;
    var hi$6 = t$2.RTLong__f_hi;
    var x$4 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$3 = $uJ(x$4);
    var lo$7 = t$3.RTLong__f_lo;
    var hi$7 = t$3.RTLong__f_hi;
    var b$2 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$6, hi$6), new $c_RTLong(lo$7, hi$7));
    var bhi$2 = b$2.RTLong__f_hi;
    var lo$8 = ((1 + b$2.RTLong__f_lo) | 0);
    var hi$8 = ((lo$8 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
    var t$4 = $uJ(new $c_RTLong(lo$5, hi$5));
    var lo$9 = t$4.RTLong__f_lo;
    var hi$9 = t$4.RTLong__f_hi;
    var x$5 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$5 = $uJ(x$5);
    var lo$10 = t$5.RTLong__f_lo;
    var hi$10 = t$5.RTLong__f_hi;
    var t$6 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$9, hi$9), new $c_RTLong(lo$10, hi$10));
    var lo$11 = t$6.RTLong__f_lo;
    var hi$11 = t$6.RTLong__f_hi;
    var $$x1 = $m_Ljava_time_LocalDateTime$();
    var this$27 = $uJ(new $c_RTLong(lo$11, hi$11));
    var x$6 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$3 = $uJ(x$6);
    var alo$1 = this$27.RTLong__f_lo;
    var ahi$2 = this$27.RTLong__f_hi;
    var bhi$3 = b$3.RTLong__f_hi;
    var lo$12 = ((alo$1 - b$3.RTLong__f_lo) | 0);
    var hi$12 = ((((-2147483648) ^ lo$12) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$2 - bhi$3) | 0)) | 0) : ((ahi$2 - bhi$3) | 0));
    var ldt = $$x1.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$12, hi$12), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var this$30 = $uJ(new $c_RTLong(lo$8, hi$8));
    var ahi$3 = this$30.RTLong__f_hi;
    if (((ahi$3 === 0) ? (this$30.RTLong__f_lo !== 0) : (ahi$3 > 0))) {
      var str = $as_T(String.fromCharCode(43));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + new $c_RTLong(lo$8, hi$8))
    };
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt);
    var this$32 = ldt.Ljava_time_LocalDateTime__f_time;
    if ((this$32.Ljava_time_LocalTime__f_second === 0)) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00")
    }
  } else {
    var this$35 = $uJ(inSecs);
    var x$7 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$4 = $uJ(x$7);
    var alo$2 = this$35.RTLong__f_lo;
    var ahi$4 = this$35.RTLong__f_hi;
    var bhi$4 = b$4.RTLong__f_hi;
    var lo$13 = ((alo$2 + b$4.RTLong__f_lo) | 0);
    var hi$13 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi$4 + bhi$4) | 0)) | 0) : ((ahi$4 + bhi$4) | 0));
    var this$40 = $uJ(new $c_RTLong(lo$13, hi$13));
    var x$8 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b$5 = $uJ(x$8);
    var this$41 = $m_RTLong$();
    var lo$14 = this$41.divideImpl__I__I__I__I__I(this$40.RTLong__f_lo, this$40.RTLong__f_hi, b$5.RTLong__f_lo, b$5.RTLong__f_hi);
    var hi$14 = this$41.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$45 = $uJ(new $c_RTLong(lo$13, hi$13));
    var x$9 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b$6 = $uJ(x$9);
    var this$46 = $m_RTLong$();
    var lo$15 = this$46.remainderImpl__I__I__I__I__I(this$45.RTLong__f_lo, this$45.RTLong__f_hi, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
    var hi$15 = this$46.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $$x2 = $m_Ljava_time_LocalDateTime$();
    var this$50 = $uJ(new $c_RTLong(lo$15, hi$15));
    var x$10 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$7 = $uJ(x$10);
    var alo$3 = this$50.RTLong__f_lo;
    var ahi$5 = this$50.RTLong__f_hi;
    var bhi$5 = b$7.RTLong__f_hi;
    var lo$16 = ((alo$3 - b$7.RTLong__f_lo) | 0);
    var hi$16 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$5 - bhi$5) | 0)) | 0) : ((ahi$5 - bhi$5) | 0));
    var ldt$2 = $$x2.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$16, hi$16), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var pos = buf.length__I();
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt$2);
    var this$52 = ldt$2.Ljava_time_LocalDateTime__f_time;
    if ((this$52.Ljava_time_LocalTime__f_second === 0)) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00")
    };
    var this$54 = $uJ(new $c_RTLong(lo$14, hi$14));
    var ahi$6 = this$54.RTLong__f_hi;
    if ((ahi$6 < 0)) {
      var this$55 = ldt$2.Ljava_time_LocalDateTime__f_date;
      if ((this$55.Ljava_time_LocalDate__f_year === (-10000))) {
        var b$8 = $uJ(new $c_RTLong(lo$14, hi$14));
        var bhi$6 = b$8.RTLong__f_hi;
        var lo$17 = (((-1) + b$8.RTLong__f_lo) | 0);
        var hi$17 = ((lo$17 !== (-1)) ? bhi$6 : (((-1) + bhi$6) | 0));
        buf.replace__I__I__T__jl_StringBuilder(pos, ((2 + pos) | 0), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$17, hi$17))
      } else if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(new $c_RTLong(lo$15, hi$15), 0)) {
        buf.insert__I__T__jl_StringBuilder(pos, ("" + new $c_RTLong(lo$14, hi$14)))
      } else {
        var offset = ((1 + pos) | 0);
        var t$7 = $uJ(new $c_RTLong(lo$14, hi$14));
        var lo$18 = t$7.RTLong__f_lo;
        var hi$18 = t$7.RTLong__f_hi;
        if ((hi$18 < 0)) {
          var lo$19 = ((-lo$18) | 0);
          var hi$19 = ((lo$18 !== 0) ? (~hi$18) : ((-hi$18) | 0));
          var l__lo = lo$19;
          var l__hi = hi$19
        } else {
          var l__lo = lo$18;
          var l__hi = hi$18
        };
        buf.insert__I__T__jl_StringBuilder(offset, $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(l__lo, l__hi))
      }
    }
  };
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-2))) {
    if ((inNano !== 0)) {
      var str$1 = $as_T(String.fromCharCode(46));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      if ((((inNano % 1000000) | 0) === 0)) {
        var i = ((1000 + ((inNano / 1000000) | 0)) | 0);
        var this$65 = ("" + i);
        var str$2 = $as_T(this$65.substring(1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2)
      } else if ((((inNano % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((inNano / 1000) | 0)) | 0);
        var this$68 = ("" + i$1);
        var str$3 = $as_T(this$68.substring(1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3)
      } else {
        var i$2 = ((1000000000 + inNano) | 0);
        var this$71 = ("" + i$2);
        var str$4 = $as_T(this$71.substring(1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4)
      }
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits > 0) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)))) {
    var str$5 = $as_T(String.fromCharCode(46));
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
    var div = 100000000;
    var i$3 = 0;
    while ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)) || (i$3 < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits))) {
      var digit = $intDiv(inNano, div);
      var c = (65535 & ((48 + digit) | 0));
      var str$6 = $as_T(String.fromCharCode(c));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$6);
      inNano = ((inNano - Math.imul(digit, div)) | 0);
      div = ((div / 10) | 0);
      i$3 = ((1 + i$3) | 0)
    }
  };
  var str$7 = $as_T(String.fromCharCode(90));
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$7);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
  var minDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 0 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var maxDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 9 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(84).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2).appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), minDigits, maxDigits, true).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(90);
  var this$2 = $m_ju_Locale$();
  var this$3 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale);
  var parser = this$3.Ljava_time_format_DateTimeFormatter__f_printerParser.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false);
  var pos = parser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((pos < 0)) {
    return pos
  };
  var yearParsed = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var this$4 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var month = this$4.RTLong__f_lo;
  var this$5 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var day = this$5.RTLong__f_lo;
  var this$6 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hour = this$6.RTLong__f_lo;
  var this$7 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var min = this$7.RTLong__f_lo;
  var secVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var nanoVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var sec = ((secVal !== null) ? secVal.RTLong__f_lo : 0);
  var nano = ((nanoVal !== null) ? nanoVal.RTLong__f_lo : 0);
  var this$9 = $uJ(yearParsed);
  var year = ((this$9.RTLong__f_lo % 10000) | 0);
  var days = 0;
  if (((((hour === 24) && (min === 0)) && (sec === 0)) && (nano === 0))) {
    hour = 0;
    days = 1
  } else if ((((hour === 23) && (min === 59)) && (sec === 60))) {
    $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = true;
    sec = 59
  };
  var instantSecs = $L0;
  try {
    var $$x1 = $m_Ljava_time_LocalDateTime$().of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime(year, month, day, hour, min, sec, 0);
    var value = days;
    var hi = (value >> 31);
    var ldt = $$x1.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value, hi));
    var t = ldt.toEpochSecond__Ljava_time_ZoneOffset__J($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var lo = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    instantSecs = new $c_RTLong(lo, hi$1);
    var x = instantSecs;
    var this$18 = $uJ(x);
    var this$15 = $uJ(yearParsed);
    var this$16 = $m_RTLong$();
    var lo$1 = this$16.divideImpl__I__I__I__I__I(this$15.RTLong__f_lo, this$15.RTLong__f_hi, 10000, 0);
    var hi$2 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$1 = $uJ(x$1);
    var lo$2 = t$1.RTLong__f_lo;
    var hi$3 = t$1.RTLong__f_hi;
    var b = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$1, hi$2), new $c_RTLong(lo$2, hi$3));
    var alo = this$18.RTLong__f_lo;
    var ahi = this$18.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var lo$3 = ((alo + b.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
    instantSecs = new $c_RTLong(lo$3, hi$4)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 instanceof $c_jl_RuntimeException)) {
      return (~position)
    } else {
      throw e
    }
  };
  var successPos = pos;
  var $$x2 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  var x$2 = instantSecs;
  successPos = context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x2, $uJ(x$2), position, successPos);
  var $$x3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$5 = (nano >> 31);
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x3, new $c_RTLong(nano, hi$5), position, successPos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.toString__T = (function() {
  return "Instant()"
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, subsequentWidth) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = field;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = minWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = maxWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = signStyle;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = subsequentWidth;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__($thiz, field, minWidth, maxWidth, signStyle) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, 0);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = 0
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, (-1)))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth + subsequentWidth) | 0))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var valueLong = context.getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
  if ((valueLong === null)) {
    return false
  };
  var value = this.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long(context, valueLong);
  var symbols = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(value, new $c_RTLong(0, (-2147483648)))) {
    var str = "9223372036854775808"
  } else {
    var t = $uJ(value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((hi < 0)) {
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var this$5__lo = lo$1;
      var this$5__hi = hi$1
    } else {
      var this$5__lo = lo;
      var this$5__hi = hi
    };
    var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$5__lo, this$5__hi)
  };
  var this$6 = str;
  if (($uI(this$6.length) > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " exceeds the maximum print width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth))
  };
  str = symbols.convertNumberToI18N__T__T(str);
  var this$8 = $uJ(value);
  var ahi = this$8.RTLong__f_hi;
  if ((ahi >= 0)) {
    matchResult5: {
      var x9 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
      var x = $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
      if ((x === x9)) {
        if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth < 19)) {
          var this$11 = $uJ(value);
          var value$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth);
          var hi$2 = (value$1 >> 31);
          var ahi$1 = this$11.RTLong__f_hi;
          var $$x1 = ((ahi$1 === hi$2) ? (((-2147483648) ^ this$11.RTLong__f_lo) >= ((-2147483648) ^ value$1)) : (ahi$1 > hi$2))
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          var c = symbols.Ljava_time_format_DecimalStyle__f_positiveSign;
          var str$1 = $as_T(String.fromCharCode(c));
          buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
          break matchResult5
        } else {
          break matchResult5
        }
      };
      var x$3 = $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
      if ((x$3 === x9)) {
        var c$1 = symbols.Ljava_time_format_DecimalStyle__f_positiveSign;
        var str$2 = $as_T(String.fromCharCode(c$1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
        break matchResult5
      }
    }
  } else {
    matchResult6: {
      var x10 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
      matchAlts1: {
        matchAlts2: {
          var x$5 = $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle();
          if ((x$5 === x10)) {
            break matchAlts2
          };
          var x$7 = $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
          if ((x$7 === x10)) {
            break matchAlts2
          };
          var x$9 = $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
          if ((x$9 === x10)) {
            break matchAlts2
          };
          break matchAlts1
        };
        var c$2 = symbols.Ljava_time_format_DecimalStyle__f_negativeSign;
        var str$3 = $as_T(String.fromCharCode(c$2));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3);
        break matchResult6
      };
      var x$11 = $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle();
      if ((x$11 === x10)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " cannot be negative according to the SignStyle"))
      }
    }
  };
  var i = 0;
  while (true) {
    var $$x3 = i;
    var $$x2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth;
    var this$15 = str;
    if (($$x3 < (($$x2 - $uI(this$15.length)) | 0))) {
      var c$3 = symbols.Ljava_time_format_DecimalStyle__f_zeroDigit;
      var str$4 = $as_T(String.fromCharCode(c$3));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4);
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var str$5 = str;
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long = (function(context, value) {
  return ((context !== null) ? value : value)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z = (function(context) {
  return ((context !== null) ? ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) : ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var length = $dp_length__I(text);
  if ((_position === length)) {
    return (~_position)
  };
  if (((_position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var sign = $dp_charAt__I__C(text, _position);
  var negative = false;
  var positive = false;
  var this$1 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
  if ((sign === this$1.Ljava_time_format_DecimalStyle__f_positiveSign)) {
    if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle.parse__Z__Z__Z__Z(true, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
      return (~_position)
    };
    positive = true;
    _position = ((1 + _position) | 0)
  } else {
    var this$2 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
    if ((sign === this$2.Ljava_time_format_DecimalStyle__f_negativeSign)) {
      if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle.parse__Z__Z__Z__Z(false, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
        return (~_position)
      };
      negative = true;
      _position = ((1 + _position) | 0)
    } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle()) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
      return (~_position)
    }
  };
  var effMinWidth = ((context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context)) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth : 1);
  var minEndPos = ((_position + effMinWidth) | 0);
  if ((minEndPos > length)) {
    return (~_position)
  };
  var $$x1 = ((context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context)) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth : 9);
  var a = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth;
  var effMaxWidth = (($$x1 + ((a > 0) ? a : 0)) | 0);
  var total = $L0;
  var totalBig = null;
  var pos = _position;
  var pass = 0;
  var outerBreak = false;
  while (((!outerBreak) && (pass < 2))) {
    var a$1 = ((pos + effMaxWidth) | 0);
    var maxEndPos = ((a$1 < length) ? a$1 : length);
    var break$1 = false;
    while (((!break$1) && (pos < maxEndPos))) {
      var ch = $dp_charAt__I__C(text, pos);
      pos = ((1 + pos) | 0);
      var digit = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols.convertToDigit__C__I(ch);
      if ((digit < 0)) {
        pos = (((-1) + pos) | 0);
        if ((pos < minEndPos)) {
          return (~_position)
        };
        break$1 = true
      };
      if ((!break$1)) {
        if ((((pos - _position) | 0) > 18)) {
          if ((totalBig === null)) {
            var x = total;
            var t = $uJ(x);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            totalBig = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi))
          };
          var this$8 = totalBig.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
          var hi$1 = (digit >> 31);
          var bi = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(digit, hi$1));
          totalBig = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi)
        } else {
          var x$1 = total;
          var b = $uJ(x$1);
          var blo = b.RTLong__f_lo;
          var b0 = (65535 & blo);
          var b1 = ((blo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$2 = ((Math.imul(10, b.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$3 = (digit >> 31);
          var lo$2 = ((lo$1 + digit) | 0);
          var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
          total = new $c_RTLong(lo$2, hi$4)
        }
      }
    };
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (pass === 0))) {
      var parseLen = ((pos - _position) | 0);
      var b$1 = ((parseLen - this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth) | 0);
      effMaxWidth = ((effMinWidth > b$1) ? effMinWidth : b$1);
      pos = _position;
      total = $L0;
      totalBig = null;
      pass = ((1 + pass) | 0)
    } else {
      outerBreak = true
    }
  };
  if (negative) {
    if ((totalBig !== null)) {
      var xn = totalBig;
      var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if (($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
        return (~(((-1) + _position) | 0))
      };
      totalBig = totalBig.negate__Ljava_math_BigInteger()
    } else {
      var xn$1 = total;
      if (($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, 0) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
        return (~(((-1) + _position) | 0))
      };
      var x$2 = total;
      var this$16 = $uJ(x$2);
      var lo$3 = this$16.RTLong__f_lo;
      var hi$5 = this$16.RTLong__f_hi;
      var lo$4 = ((-lo$3) | 0);
      var hi$6 = ((lo$3 !== 0) ? (~hi$5) : ((-hi$5) | 0));
      total = new $c_RTLong(lo$4, hi$6)
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
    var parseLen$2 = ((pos - _position) | 0);
    if (positive) {
      if ((parseLen$2 <= this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
        return (~(((-1) + _position) | 0))
      }
    } else if ((parseLen$2 > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
      return (~_position)
    }
  };
  if ((totalBig !== null)) {
    var this$20 = totalBig;
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$20) > 63)) {
      totalBig = totalBig.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
      pos = (((-1) + pos) | 0)
    };
    var t$1 = totalBig.longValue__J();
    var lo$5 = t$1.RTLong__f_lo;
    var hi$7 = t$1.RTLong__f_hi;
    return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, new $c_RTLong(lo$5, hi$7), _position, pos)
  };
  return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, total, _position, pos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I = (function(context, value, errorPos, successPos) {
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, $uJ(value), errorPos, successPos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.toString__T = (function() {
  return ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === 1) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth === 19)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle())) ? (("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ")") : (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle())) ? (((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ")") : (((((((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle) + ")")))
});
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I($thiz, pattern) {
  var i = 0;
  while ((i < $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u.length)) {
    if (($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.get(i) === pattern)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid zone offset pattern: " + pattern))
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z($thiz, array, arrayIndex, parseText, required) {
  if ((((((3 + $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type) | 0) / 2) | 0) < arrayIndex)) {
    return false
  };
  var pos = array.get(0);
  if ((((($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) && (arrayIndex > 1))) {
    if (((((1 + pos) | 0) > $dp_length__I(parseText)) || ($dp_charAt__I__C(parseText, pos) !== 58))) {
      return required
    };
    pos = ((1 + pos) | 0)
  };
  if ((((2 + pos) | 0) > $dp_length__I(parseText))) {
    return required
  };
  var ch1 = $dp_charAt__I__C(parseText, pos);
  pos = ((1 + pos) | 0);
  var ch2 = $dp_charAt__I__C(parseText, pos);
  pos = ((1 + pos) | 0);
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    return required
  };
  var value = ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0);
  if (((value < 0) || (value > 59))) {
    return required
  };
  array.set(arrayIndex, value);
  array.set(0, pos);
  return false
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser(noOffsetText, pattern) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = noOffsetText;
  if ((noOffsetText === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "noOffsetText")
  };
  if ((pattern === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pattern")
  };
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I(this, pattern)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var offsetSecs = context.getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  if ((offsetSecs === null)) {
    return false
  };
  var t = $uJ(offsetSecs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var totalSecs = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo, hi));
  if ((totalSecs === 0)) {
    var str = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else {
    var a = ((((totalSecs / 3600) | 0) % 100) | 0);
    var absHours = ((a < 0) ? ((-a) | 0) : a);
    var a$1 = ((((totalSecs / 60) | 0) % 60) | 0);
    var absMinutes = ((a$1 < 0) ? ((-a$1) | 0) : a$1);
    var a$2 = ((totalSecs % 60) | 0);
    var absSeconds = ((a$2 < 0) ? ((-a$2) | 0) : a$2);
    var bufPos = buf.length__I();
    var output = absHours;
    var str$1 = ((totalSecs < 0) ? "-" : "+");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
    var c = (65535 & ((48 + ((absHours / 10) | 0)) | 0));
    var str$2 = $as_T(String.fromCharCode(c));
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
    var c$1 = (65535 & ((48 + ((absHours % 10) | 0)) | 0));
    var str$3 = $as_T(String.fromCharCode(c$1));
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3);
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 3) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 1) && (absMinutes > 0)))) {
      var str$4 = ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) ? ":" : "");
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$4);
      var c$2 = (65535 & ((48 + ((absMinutes / 10) | 0)) | 0));
      var str$5 = $as_T(String.fromCharCode(c$2));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
      var c$3 = (65535 & ((48 + ((absMinutes % 10) | 0)) | 0));
      var str$6 = $as_T(String.fromCharCode(c$3));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$6);
      output = ((output + absMinutes) | 0);
      if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 7) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 5) && (absSeconds > 0)))) {
        var str$7 = ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) ? ":" : "");
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$7);
        var c$4 = (65535 & ((48 + ((absSeconds / 10) | 0)) | 0));
        var str$8 = $as_T(String.fromCharCode(c$4));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$8);
        var c$5 = (65535 & ((48 + ((absSeconds % 10) | 0)) | 0));
        var str$9 = $as_T(String.fromCharCode(c$5));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$9);
        output = ((output + absSeconds) | 0)
      }
    };
    if ((output === 0)) {
      buf.setLength__I__V(bufPos);
      var str$10 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$10)
    }
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
  var noOffsetLen = $uI(this$1.length);
  if ((noOffsetLen === 0)) {
    if ((position === length)) {
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, position)
    }
  } else {
    if ((position === length)) {
      return (~position)
    };
    if (context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText, 0, noOffsetLen)) {
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0))
    }
  };
  var sign = $dp_charAt__I__C(text, position);
  if (((sign === 43) || (sign === 45))) {
    var negative = ((sign === 45) ? (-1) : 1);
    var dimensions = new $ac_I(new Int32Array([4]));
    var array = $asArrayOf_I($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_I.getClassOf(), dimensions), 1);
    array.set(0, ((1 + position) | 0));
    if ((!(($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 1, text, true) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 2, text, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 3))) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 3, text, false)))) {
      var hi = (negative >> 31);
      var value = array.get(1);
      var hi$1 = (value >> 31);
      var b0 = (65535 & value);
      var b1 = ((value >>> 16) | 0);
      var a0b0 = Math.imul(3600, b0);
      var a0b1 = Math.imul(3600, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((Math.imul(3600, hi$1) + ((c1part >>> 16) | 0)) | 0);
      var value$1 = array.get(2);
      var hi$3 = (value$1 >> 31);
      var b0$1 = (65535 & value$1);
      var b1$1 = ((value$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(60, b0$1);
      var a0b1$1 = Math.imul(60, b1$1);
      var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$4 = ((Math.imul(60, hi$3) + ((c1part$1 >>> 16) | 0)) | 0);
      var lo$2 = ((lo + lo$1) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$4) | 0)) | 0) : ((hi$2 + hi$4) | 0));
      var value$2 = array.get(3);
      var hi$6 = (value$2 >> 31);
      var lo$3 = ((lo$2 + value$2) | 0);
      var hi$7 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$5 + hi$6) | 0)) | 0) : ((hi$5 + hi$6) | 0));
      var a0 = (65535 & negative);
      var a1 = ((negative >>> 16) | 0);
      var b0$2 = (65535 & lo$3);
      var b1$2 = ((lo$3 >>> 16) | 0);
      var a0b0$2 = Math.imul(a0, b0$2);
      var a1b0 = Math.imul(a1, b0$2);
      var a0b1$2 = Math.imul(a0, b1$2);
      var lo$4 = ((a0b0$2 + (((a1b0 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$8 = ((((((((Math.imul(negative, hi$7) + Math.imul(hi, lo$3)) | 0) + Math.imul(a1, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0) | 0) >>> 16) | 0)) | 0);
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $uJ(new $c_RTLong(lo$4, hi$8)), position, array.get(0))
    }
  };
  if ((noOffsetLen === 0)) {
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0))
  };
  return (~position)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.toString__T = (function() {
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
  var converted = $as_T(this$1.split("'").join("''"));
  return (((("Offset(" + $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type)) + ",'") + converted) + "')")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(printerParser, padWidth, padChar) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = printerParser;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = padWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = padChar
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var preLen = buf.length__I();
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
    return false
  };
  var len = ((buf.length__I() - preLen) | 0);
  if ((len > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Cannot print as output of " + len) + " characters exceeds pad width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth))
  };
  var i = 0;
  while ((i < ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth - len) | 0))) {
    var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar;
    buf.insert__I__T__jl_StringBuilder(preLen, $as_T(String.fromCharCode(c)));
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _text = text;
  var strict = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict;
  var caseSensitive = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive;
  if ((position > $dp_length__I(_text))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  if ((position === $dp_length__I(_text))) {
    return (~position)
  };
  var endPos = ((position + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) | 0);
  if ((endPos > $dp_length__I(_text))) {
    if (strict) {
      return (~position)
    };
    endPos = $dp_length__I(_text)
  };
  var pos = position;
  while (((pos < endPos) && (caseSensitive ? ($dp_charAt__I__C(_text, pos) === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar) : context.charEquals__C__C__Z($dp_charAt__I__C(_text, pos), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)))) {
    pos = ((1 + pos) | 0)
  };
  _text = $dp_subSequence__I__I__jl_CharSequence(_text, 0, endPos);
  var resultPos = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, _text, pos);
  if (((resultPos !== endPos) && strict)) {
    return (~((position + pos) | 0))
  };
  return resultPos
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.toString__T = (function() {
  return (((("Pad(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar === 32) ? ")" : ((",'" + $bC(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)) + "')")))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId($thiz, regionIds, parsedZoneId, caseSensitive) {
  if ((parsedZoneId === null)) {
    return null
  } else if (caseSensitive) {
    return (regionIds.contains__O__Z(parsedZoneId) ? $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(parsedZoneId) : null)
  } else {
    var regionIdsIterator = regionIds.iterator__ju_Iterator();
    while (regionIdsIterator.hasNext__Z()) {
      var regionId = $as_T(regionIdsIterator.next__O());
      _return$1: {
        var len = $uI(regionId.length);
        if ((!((parsedZoneId === null) || ($uI(parsedZoneId.length) !== len)))) {
          var i = 0;
          while ((i !== len)) {
            var index = i;
            var c = (65535 & $uI(regionId.charCodeAt(index)));
            var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
            var index$1 = i;
            var c$1 = (65535 & $uI(parsedZoneId.charCodeAt(index$1)));
            if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
              var $$x1 = false;
              break _return$1
            };
            i = ((1 + i) | 0)
          };
          var $$x1 = true
        } else {
          var $$x1 = false
        }
      };
      if ($$x1) {
        return $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(regionId)
      }
    };
    return null
  }
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I($thiz, context, text, prefixPos, position) {
  var this$1 = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, prefixPos, position));
  var prefix = $as_T(this$1.toUpperCase());
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
  if (((position < $dp_length__I(text)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, position), 90))) {
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position
  };
  var endPos = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((endPos < 0)) {
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position
  };
  var this$2 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  var this$3 = $uJ(this$2);
  var offsetSecs = this$3.RTLong__f_lo;
  var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs);
  context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, offset));
  return endPos
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser(query, description) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = query;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = description
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var zone = $as_Ljava_time_ZoneId(context.getValue__Ljava_time_temporal_TemporalQuery__O(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query));
  if ((zone !== null)) {
    var str = zone.getId__T();
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    return true
  } else {
    return false
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  if ((position > length)) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  if ((position === length)) {
    return (~position)
  };
  var nextChar = $dp_charAt__I__C(text, position);
  if (((nextChar === 43) || (nextChar === 45))) {
    var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
    var endPos = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
    if ((endPos < 0)) {
      return endPos
    };
    var this$1 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
    var this$2 = $uJ(this$1);
    var offset = this$2.RTLong__f_lo;
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offset));
    return endPos
  } else if ((length >= ((2 + position) | 0))) {
    var nextNextChar = $dp_charAt__I__C(text, ((1 + position) | 0));
    if ((context.charEquals__C__C__Z(nextChar, 85) && context.charEquals__C__C__Z(nextNextChar, 84))) {
      if (((length >= ((3 + position) | 0)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, ((2 + position) | 0)), 67))) {
        return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0))
      };
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((2 + position) | 0))
    } else if ((((context.charEquals__C__C__Z(nextChar, 71) && (length >= ((3 + position) | 0))) && context.charEquals__C__C__Z(nextNextChar, 77)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, ((2 + position) | 0)), 84))) {
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0))
    }
  };
  var regionIds = $m_Ljava_time_zone_ZoneRulesProvider$().getAvailableZoneIds__ju_Set();
  var regionIdsSize = regionIds.size__I();
  var cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree;
  if ((cached === null)) {
    var $$x1 = true
  } else {
    var x = cached.getKey__O();
    var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, regionIdsSize))
  };
  if ($$x1) {
    cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree;
    if ((cached === null)) {
      var $$x2 = true
    } else {
      var x$1 = cached.getKey__O();
      var $$x2 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, regionIdsSize))
    };
    if ($$x2) {
      var $$x3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$();
      cached = new $c_ju_AbstractMap$SimpleImmutableEntry(regionIdsSize, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(regionIds));
      $$x3.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = cached
    }
  };
  var tree = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(cached.getValue__O());
  var parsedZoneId = null;
  var lastZoneId = null;
  var break$1 = false;
  while (((!break$1) && (tree !== null))) {
    var nodeLength = tree.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
    if ((((position + nodeLength) | 0) > length)) {
      break$1 = true
    } else {
      lastZoneId = parsedZoneId;
      parsedZoneId = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, position, ((position + nodeLength) | 0)));
      tree = tree.get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(parsedZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive)
    }
  };
  var zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, parsedZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
  if ((zone === null)) {
    zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, lastZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
    if ((zone === null)) {
      if (context.charEquals__C__C__Z(nextChar, 90)) {
        context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        return ((1 + position) | 0)
      };
      return (~position)
    };
    parsedZoneId = lastZoneId
  };
  context.setParsed__Ljava_time_ZoneId__V(zone);
  var this$4 = parsedZoneId;
  return ((position + $uI(this$4.length)) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.toString__T = (function() {
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(outer) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = outer;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = $m_Ljava_time_Period$().ZERO__Ljava_time_Period();
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function() {
  var cloned = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer);
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono;
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone;
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.putAll__ju_Map__V(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues);
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond;
  return cloned
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toString__T = (function() {
  return ((((this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.toString__T() + ",") + this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono) + ",") + this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  };
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues;
  var x = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, field, null));
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo, hi))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues;
    var x = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, field, null));
    return $uJ(x)
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono : (((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone : $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toBuilder__Ljava_time_format_DateTimeBuilder = (function() {
  var builder = new $c_Ljava_time_format_DateTimeBuilder();
  builder.Ljava_time_format_DateTimeBuilder__f_fieldValues.putAll__ju_Map__V(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues);
  builder.Ljava_time_format_DateTimeBuilder__f_chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer.getEffectiveChronology__Ljava_time_chrono_Chronology();
  if ((this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone !== null)) {
    builder.Ljava_time_format_DateTimeBuilder__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone
  } else {
    builder.Ljava_time_format_DateTimeBuilder__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone
  };
  builder.Ljava_time_format_DateTimeBuilder__f_leapSecond = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond;
  builder.Ljava_time_format_DateTimeBuilder__f_excessDays = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays;
  return builder
});
function $as_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeParseContext$Parsed"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeParseContext$Parsed;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext$Parsed", {
  Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(temporal$4, effectiveChrono$2, effectiveZone$2, effectiveDate$2) {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = temporal$4;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = effectiveChrono$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = effectiveZone$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = effectiveDate$2
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z())) {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1;
    return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field)
  } else {
    return this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.isSupported__Ljava_time_temporal_TemporalField__Z(field)
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field) : this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1.getLong__Ljava_time_temporal_TemporalField__J(field) : this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.getLong__Ljava_time_temporal_TemporalField__J(field))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.query__Ljava_time_temporal_TemporalQuery__O(query) : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))))
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext$$anon$1", {
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(relative, dayOfWeek) {
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = relative;
  if ((dayOfWeek === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dayOfWeek")
  };
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = dayOfWeek.getValue__I()
}
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.constructor = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype;
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var calDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  if (((this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative < 2) && (calDow === this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue))) {
    return temporal
  } else if (((1 & this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative) === 0)) {
    var daysDiff = ((calDow - this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue) | 0);
    if ((daysDiff >= 0)) {
      var hi = (daysDiff >> 31);
      var lo = ((7 - daysDiff) | 0);
      var hi$1 = ((((-2147483648) ^ lo) > (-2147483641)) ? (((-1) - hi) | 0) : ((-hi) | 0));
      var x__lo = lo;
      var x__hi = hi$1
    } else {
      var hi$2 = (daysDiff >> 31);
      var lo$1 = ((-daysDiff) | 0);
      var hi$3 = ((daysDiff !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var x__lo = lo$1;
      var x__hi = hi$3
    };
    return temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x__lo, x__hi), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit())
  } else {
    var daysDiff$2 = ((this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue - calDow) | 0);
    if ((daysDiff$2 >= 0)) {
      var hi$4 = (daysDiff$2 >> 31);
      var lo$2 = ((7 - daysDiff$2) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > (-2147483641)) ? (((-1) - hi$4) | 0) : ((-hi$4) | 0));
      var x$1__lo = lo$2;
      var x$1__hi = hi$5
    } else {
      var hi$6 = (daysDiff$2 >> 31);
      var lo$3 = ((-daysDiff$2) | 0);
      var hi$7 = ((daysDiff$2 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var x$1__lo = lo$3;
      var x$1__hi = hi$7
    };
    return temporal.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x$1__lo, x$1__hi), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit())
  }
});
var $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek = new $TypeData().initClass({
  Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek: 0
}, false, "java.time.temporal.TemporalAdjusters$RelativeDayOfWeek", {
  Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek: 1,
  O: 1,
  Ljava_time_temporal_TemporalAdjuster: 1
});
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.$classData = $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$1 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$1: 0
}, false, "java.time.temporal.TemporalQueries$$anon$1", {
  Ljava_time_temporal_TemporalQueries$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$2() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_chrono_Chronology(temporal.query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$2 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$2: 0
}, false, "java.time.temporal.TemporalQueries$$anon$2", {
  Ljava_time_temporal_TemporalQueries$$anon$2: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$3() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_temporal_TemporalUnit(temporal.query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$3 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$3: 0
}, false, "java.time.temporal.TemporalQueries$$anon$3", {
  Ljava_time_temporal_TemporalQueries$$anon$3: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$4() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$4 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$4: 0
}, false, "java.time.temporal.TemporalQueries$$anon$4", {
  Ljava_time_temporal_TemporalQueries$$anon$4: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$5() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var zone = $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
  return ((zone !== null) ? zone : $as_Ljava_time_ZoneId(temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())))
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$5 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$5: 0
}, false, "java.time.temporal.TemporalQueries$$anon$5", {
  Ljava_time_temporal_TemporalQueries$$anon$5: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$6() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$6 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$6: 0
}, false, "java.time.temporal.TemporalQueries$$anon$6", {
  Ljava_time_temporal_TemporalQueries$$anon$6: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$7() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$7 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$7: 0
}, false, "java.time.temporal.TemporalQueries$$anon$7", {
  Ljava_time_temporal_TemporalQueries$$anon$7: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
  this.Ljava_time_temporal_ValueRange__f_minSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minSmallest = minSmallest;
  this.Ljava_time_temporal_ValueRange__f_minLargest = minLargest;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = maxSmallest;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = maxLargest
}
$c_Ljava_time_temporal_ValueRange.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange.prototype.constructor = $c_Ljava_time_temporal_ValueRange;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ValueRange.prototype = $c_Ljava_time_temporal_ValueRange.prototype;
$c_Ljava_time_temporal_ValueRange.prototype.isFixed__Z = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
    var this$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    return ((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isIntValue__Z = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidValue__J__Z = (function(value) {
  var b = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = value.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value.RTLong__f_lo) >= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))) {
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = value.RTLong__f_hi;
    var bhi$1 = b$1.RTLong__f_hi;
    return ((ahi$1 === bhi$1) ? (((-2147483648) ^ value.RTLong__f_lo) <= ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 < bhi$1))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidIntValue__J__Z = (function(value) {
  return (this.isIntValue__Z() && this.isValidValue__J__Z(value))
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidValue__J__Ljava_time_temporal_TemporalField__J = (function(value, field) {
  if ((!this.isValidValue__J__Z(value))) {
    if ((field !== null)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Invalid value for " + field) + " (valid values ") + this) + "): ") + value))
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid value (valid values " + this) + "): ") + value))
    }
  } else {
    return value
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I = (function(value, field) {
  if ((!this.isValidIntValue__J__Z(value))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid int value for " + field) + ": ") + value))
  } else {
    return value.RTLong__f_lo
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_temporal_ValueRange)) {
    var other = $as_Ljava_time_temporal_ValueRange(obj);
    if ((this === other)) {
      return true
    } else {
      var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
      var b = other.Ljava_time_temporal_ValueRange__f_minSmallest;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        var this$2 = this.Ljava_time_temporal_ValueRange__f_minLargest;
        var b$1 = other.Ljava_time_temporal_ValueRange__f_minLargest;
        var $$x2 = ((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var this$3 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
        var b$2 = other.Ljava_time_temporal_ValueRange__f_maxSmallest;
        var $$x1 = ((this$3.RTLong__f_lo === b$2.RTLong__f_lo) && (this$3.RTLong__f_hi === b$2.RTLong__f_hi))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$4 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
        var b$3 = other.Ljava_time_temporal_ValueRange__f_maxLargest;
        return ((this$4.RTLong__f_lo === b$3.RTLong__f_lo) && (this$4.RTLong__f_hi === b$3.RTLong__f_hi))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.hashCode__I = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var alo = this$1.RTLong__f_lo;
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var b$1 = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var bhi$1 = b$1.RTLong__f_hi;
  var lo$1 = ((16 + b$1.RTLong__f_lo) | 0);
  var lo$2 = (((32 & lo$1) === 0) ? (lo << lo$1) : 0);
  var hi$2 = (((32 & lo$1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - lo$1) | 0)) | 0) | (hi << lo$1)) : (lo << lo$1));
  var b$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var bhi$2 = b$2.RTLong__f_hi;
  var lo$3 = ((48 + b$2.RTLong__f_lo) | 0);
  var lo$4 = (((32 & lo$3) === 0) ? (((lo$2 >>> lo$3) | 0) | ((hi$2 << 1) << ((31 - lo$3) | 0))) : (hi$2 >> lo$3));
  var hi$4 = (((32 & lo$3) === 0) ? (hi$2 >> lo$3) : (hi$2 >> 31));
  var b$3 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var bhi$3 = b$3.RTLong__f_hi;
  var lo$5 = ((32 + b$3.RTLong__f_lo) | 0);
  var lo$6 = (((32 & lo$5) === 0) ? (lo$4 << lo$5) : 0);
  var hi$6 = (((32 & lo$5) === 0) ? (((((lo$4 >>> 1) | 0) >>> ((31 - lo$5) | 0)) | 0) | (hi$4 << lo$5)) : (lo$4 << lo$5));
  var b$4 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var bhi$4 = b$4.RTLong__f_hi;
  var lo$7 = ((32 + b$4.RTLong__f_lo) | 0);
  var lo$8 = (((32 & lo$7) === 0) ? (((lo$6 >>> lo$7) | 0) | ((hi$6 << 1) << ((31 - lo$7) | 0))) : (hi$6 >> lo$7));
  var hi$8 = (((32 & lo$7) === 0) ? (hi$6 >> lo$7) : (hi$6 >> 31));
  var b$5 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var bhi$5 = b$5.RTLong__f_hi;
  var lo$9 = ((48 + b$5.RTLong__f_lo) | 0);
  var lo$10 = (((32 & lo$9) === 0) ? (lo$8 << lo$9) : 0);
  var hi$10 = (((32 & lo$9) === 0) ? (((((lo$8 >>> 1) | 0) >>> ((31 - lo$9) | 0)) | 0) | (hi$8 << lo$9)) : (lo$8 << lo$9));
  var lo$11 = (((lo$10 >>> 16) | 0) | (hi$10 << 16));
  var hi$11 = (hi$10 >> 16);
  var lo$12 = (lo$11 ^ hi$11);
  return lo$12
});
$c_Ljava_time_temporal_ValueRange.prototype.toString__T = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if ((!((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi)))) {
    var ss = ("/" + this.Ljava_time_temporal_ValueRange__f_minLargest)
  } else {
    var ss = ""
  };
  var this$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  if ((!((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi)))) {
    var sl = ("/" + this.Ljava_time_temporal_ValueRange__f_maxLargest)
  } else {
    var sl = ""
  };
  return ((((this.Ljava_time_temporal_ValueRange__f_minSmallest + ss) + " - ") + this.Ljava_time_temporal_ValueRange__f_maxSmallest) + sl)
});
function $as_Ljava_time_temporal_ValueRange(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ValueRange) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ValueRange"))
}
function $isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ValueRange)))
}
function $asArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ValueRange;", depth))
}
var $d_Ljava_time_temporal_ValueRange = new $TypeData().initClass({
  Ljava_time_temporal_ValueRange: 0
}, false, "java.time.temporal.ValueRange", {
  Ljava_time_temporal_ValueRange: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_ValueRange.prototype.$classData = $d_Ljava_time_temporal_ValueRange;
/** @constructor */
function $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
  /*<skip>*/
}
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = new $h_Ljava_time_zone_ZoneRulesProvider();
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype;
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.provideZoneIds__ju_Set = (function() {
  var zones = $ct_ju_HashSet__(new $c_ju_HashSet());
  zones.add__O__Z("UTC");
  zones.add__O__Z("GMT");
  return zones
});
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.provideRules__T__Z__Ljava_time_zone_ZoneRules = (function(regionId, forCaching) {
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()))
});
var $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider = new $TypeData().initClass({
  Ljava_time_zone_DefaultTzdbZoneRulesProvider: 0
}, false, "java.time.zone.DefaultTzdbZoneRulesProvider", {
  Ljava_time_zone_DefaultTzdbZoneRulesProvider: 1,
  Ljava_time_zone_ZoneRulesProvider: 1,
  O: 1
});
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.$classData = $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider;
/** @constructor */
function $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
  /*<skip>*/
}
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = new $h_Ljava_time_zone_ZoneRulesInitializer();
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
  /*<skip>*/
}
$h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype;
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.initializeProviders__V = (function() {
  var $$x1 = $m_s_Predef$();
  var this$1 = $objectClassName(this);
  var xs = $f_T__split__T__I__AT(this$1, "\\.", 0);
  var this$3 = $$x1.wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_T($m_sc_ArrayOps$().init$extension__O__O(xs), 1));
  var packageName = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ".", "");
  var fqcn = (packageName + ".TzdbZoneRulesProvider");
  var optClassData = $m_sjs_reflect_Reflect$().lookupInstantiatableClass__T__s_Option(fqcn);
  if (optClassData.isEmpty__Z()) {
    $m_s_package$();
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ljava_time_zone_ZoneRulesProvider.getArrayOf().constr)([new $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider()]));
    var this$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    var arg1 = optClassData.get__O();
    var c = $as_sjs_reflect_InstantiatableClass(arg1);
    var instance = $as_Ljava_time_zone_ZoneRulesProvider(c.newInstance__O());
    $m_s_package$();
    var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ljava_time_zone_ZoneRulesProvider.getArrayOf().constr)([instance]));
    var this$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
  };
  var these = this$7;
  while ((!these.isEmpty__Z())) {
    var arg1$1 = these.head__O();
    var provider = $as_Ljava_time_zone_ZoneRulesProvider(arg1$1);
    $m_Ljava_time_zone_ZoneRulesProvider$().registerProvider__Ljava_time_zone_ZoneRulesProvider__V(provider);
    these = $as_sci_List(these.tail__O())
  }
});
var $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer = new $TypeData().initClass({
  Ljava_time_zone_ServiceLoaderZoneRulesInitializer: 0
}, false, "java.time.zone.ServiceLoaderZoneRulesInitializer", {
  Ljava_time_zone_ServiceLoaderZoneRulesInitializer: 1,
  Ljava_time_zone_ZoneRulesInitializer: 1,
  O: 1
});
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.$classData = $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer;
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, zr) {
  var jointDate = $uI(zr[0]);
  var this$2 = ("" + jointDate);
  var x = $as_T(this$2.substring(0, 4));
  var this$5 = $m_jl_Integer$();
  var year = this$5.parseInt__T__I__I(x, 10);
  var this$7 = ("" + jointDate);
  var x$1 = $as_T(this$7.substring(4, 7));
  var this$10 = $m_jl_Integer$();
  var dayOfYear = this$10.parseInt__T__I__I(x$1, 10);
  var date = $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(year, dayOfYear);
  var lt = $uI(zr[1]);
  var hi = (lt >> 31);
  var time = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lt, hi));
  var transition = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(date, time);
  var totalSeconds = $uI(zr[2]);
  var offsetBefore = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zr[3]);
  var offsetAfter = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  return $m_Ljava_time_zone_ZoneOffsetTransition$().of__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter)
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransitionRule__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransitionRule($thiz, zor) {
  var lt = $uI(zor[3]);
  var hi = (lt >> 31);
  var time = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lt, hi));
  if (($uI(zor[2]) >= 0)) {
    var dayOfWeek = $uI(zor[2]);
    var dayOfWeek$1 = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dayOfWeek)
  } else {
    var dayOfWeek$1 = null
  };
  var month = $uI(zor[0]);
  var month$1 = $m_Ljava_time_Month$().of__I__Ljava_time_Month(month);
  var dayOfMonthIndicator = $uI(zor[1]);
  var timeEndOfDay = ($uI(zor[4]) === 1);
  var timeDefnition = $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$().values__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition().get($uI(zor[5]));
  var totalSeconds = $uI(zor[6]);
  var standardOffset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zor[7]);
  var offsetBefore = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  var totalSeconds$2 = $uI(zor[8]);
  var offsetAfter = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$2);
  return $m_Ljava_time_zone_ZoneOffsetTransitionRule$().of__Ljava_time_Month__I__Ljava_time_DayOfWeek__Ljava_time_LocalTime__Z__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransitionRule(month$1, dayOfMonthIndicator, dayOfWeek$1, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter)
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneRules__sjs_js_Dynamic__Ljava_time_zone_ZoneRules($thiz, zr) {
  var totalSeconds = $uI(zr.s);
  var bso = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zr.w);
  var bwo = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  var array = zr.t;
  var len = $uI(array.length);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var arg1 = array[i];
    res[$$x1] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, arg1);
    i = ((1 + i) | 0)
  };
  var array$1 = zr.l;
  var len$1 = $uI(array$1.length);
  var res$1 = new Array(len$1);
  var i$1 = 0;
  while ((i$1 < len$1)) {
    var $$x2 = i$1;
    var arg1$1 = array$1[i$1];
    res$1[$$x2] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, arg1$1);
    i$1 = ((1 + i$1) | 0)
  };
  var array$2 = zr.r;
  var len$2 = $uI(array$2.length);
  var res$2 = new Array(len$2);
  var i$2 = 0;
  while ((i$2 < len$2)) {
    var $$x3 = i$2;
    var arg1$2 = array$2[i$2];
    res$2[$$x3] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransitionRule__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransitionRule($thiz, arg1$2);
    i$2 = ((1 + i$2) | 0)
  };
  var standardTransitionsJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$8 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
  $m_sci_List$();
  var this$10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8);
  var these = this$10;
  while ((!these.isEmpty__Z())) {
    var arg1$3 = these.head__O();
    var _$2 = $as_Ljava_time_zone_ZoneOffsetTransition(arg1$3);
    standardTransitionsJ.add__O__Z(_$2);
    these = $as_sci_List(these.tail__O())
  };
  var transitionListJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$12 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res$1);
  $m_sci_List$();
  var this$14 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12);
  var these$1 = this$14;
  while ((!these$1.isEmpty__Z())) {
    var arg1$4 = these$1.head__O();
    var _$3 = $as_Ljava_time_zone_ZoneOffsetTransition(arg1$4);
    transitionListJ.add__O__Z(_$3);
    these$1 = $as_sci_List(these$1.tail__O())
  };
  var lastRulesJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$16 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res$2);
  $m_sci_List$();
  var this$18 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$16);
  var these$2 = this$18;
  while ((!these$2.isEmpty__Z())) {
    var arg1$5 = these$2.head__O();
    var _$4 = $as_Ljava_time_zone_ZoneOffsetTransitionRule(arg1$5);
    lastRulesJ.add__O__Z(_$4);
    these$2 = $as_sci_List(these$2.tail__O())
  };
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules(bso, bwo, standardTransitionsJ, transitionListJ, lastRulesJ)
}
function $sct_Ljava_time_zone_TzdbZoneRulesProvider__stinit__() {
  $m_sjs_reflect_Reflect$().registerInstantiatableClass__T__jl_Class__sjs_js_Array__V("java.time.zone.TzdbZoneRulesProvider", $d_Ljava_time_zone_TzdbZoneRulesProvider.getClassOf(), [[[], (() => new $c_Ljava_time_zone_TzdbZoneRulesProvider())]])
}
/** @constructor */
function $c_Ljava_time_zone_TzdbZoneRulesProvider() {
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap = null;
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap = null;
  var dict = $m_Lzonedb_java_tzdb$().stdZones__sjs_js_Dynamic();
  var this$3 = new $c_sjs_js_WrappedDictionary(dict);
  $m_s_$less$colon$less$();
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  var dict$1 = $m_Lzonedb_java_tzdb$().fixedZones__sjs_js_Dynamic();
  var this$6 = new $c_sjs_js_WrappedDictionary(dict$1);
  $m_s_$less$colon$less$();
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6)
}
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype = new $h_Ljava_time_zone_ZoneRulesProvider();
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_TzdbZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_TzdbZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_TzdbZoneRulesProvider.prototype = $c_Ljava_time_zone_TzdbZoneRulesProvider.prototype;
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.provideZoneIds__ju_Set = (function() {
  var zones = $ct_ju_HashSet__(new $c_ju_HashSet());
  var this$1 = this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap.keySet__sci_Set();
  var that = this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap.keySet__sci_Set();
  var this$2 = this$1.concat__sc_IterableOnce__sc_SetOps(that);
  var that$1 = $m_Lzonedb_java_tzdb$().zoneLinks__sci_Map().keySet__sci_Set();
  var zonesSet = $as_sci_Set(this$2.concat__sc_IterableOnce__sc_SetOps(that$1));
  zonesSet.foreach__F1__V(new $c_sjsr_AnonFunction1(((zones$2) => ((_$1) => {
    var _$1$1 = $as_T(_$1);
    return zones$2.add__O__Z(_$1$1)
  }))(zones)));
  zones.remove__O__Z("GMT0");
  zones.remove__O__Z("GMT+0");
  zones.remove__O__Z("GMT-0");
  return zones
});
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.provideRules__T__Z__Ljava_time_zone_ZoneRules = (function(regionId, forCaching) {
  var actualRegion = $as_T($m_Lzonedb_java_tzdb$().zoneLinks__sci_Map().getOrElse__O__F0__O(regionId, new $c_sjsr_AnonFunction0(((regionId$2) => (() => regionId$2))(regionId))));
  var this$1 = this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap.get__O__s_Option(actualRegion);
  if (this$1.isEmpty__Z()) {
    var this$2 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var this$2 = new $c_s_Some($p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneRules__sjs_js_Dynamic__Ljava_time_zone_ZoneRules(this, arg1))
  };
  if (this$2.isEmpty__Z()) {
    var this$3 = this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap.get__O__s_Option(actualRegion);
    if (this$3.isEmpty__Z()) {
      var this$4 = $m_s_None$()
    } else {
      var arg1$1 = this$3.get__O();
      var i = $uI(arg1$1);
      var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(i);
      var this$4 = new $c_s_Some($m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset))
    }
  } else {
    var this$4 = this$2
  };
  if (this$4.isEmpty__Z()) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("TimeZone Region " + actualRegion) + " unknown"))
  };
  return $as_Ljava_time_zone_ZoneRules(this$4.get__O())
});
var $d_Ljava_time_zone_TzdbZoneRulesProvider = new $TypeData().initClass({
  Ljava_time_zone_TzdbZoneRulesProvider: 0
}, false, "java.time.zone.TzdbZoneRulesProvider", {
  Ljava_time_zone_TzdbZoneRulesProvider: 1,
  Ljava_time_zone_ZoneRulesProvider: 1,
  O: 1
});
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.$classData = $d_Ljava_time_zone_TzdbZoneRulesProvider;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefinition, standardOffset, offsetBefore, offsetAfter) {
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay = false;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom = 0;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month = month;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek = dayOfWeek;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time = time;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay = timeEndOfDay;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition = timeDefinition;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset = standardOffset;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore = offsetBefore;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter = offsetAfter;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom = ((dayOfMonthIndicator << 24) >> 24)
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.createTransition__I__Ljava_time_zone_ZoneOffsetTransition = (function(year) {
  var date = null;
  if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom < 0)) {
    var $$x4 = $m_Ljava_time_LocalDate$();
    var $$x3 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month;
    var $$x2 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month;
    var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    date = $$x4.of__I__Ljava_time_Month__I__Ljava_time_LocalDate(year, $$x3, ((((1 + $$x2.length__Z__I($$x1.isLeapYear__J__Z(new $c_RTLong(year, hi)))) | 0) + this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom) | 0));
    if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
      var $$x5 = date;
      var dayOfWeek = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek;
      date = $$x5.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(1, dayOfWeek))
    }
  } else {
    date = $m_Ljava_time_LocalDate$().of__I__Ljava_time_Month__I__Ljava_time_LocalDate(year, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom);
    if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
      var $$x6 = date;
      var dayOfWeek$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek;
      date = $$x6.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek$1))
    }
  };
  if (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay) {
    date = date.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  };
  var localDT = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(date, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time);
  var transition = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition.createDateTime__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(localDT, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore);
  return new $c_Ljava_time_zone_ZoneOffsetTransition(transition, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.equals__O__Z = (function(otherRule) {
  if ((otherRule instanceof $c_Ljava_time_zone_ZoneOffsetTransitionRule)) {
    var other = $as_Ljava_time_zone_ZoneOffsetTransitionRule(otherRule);
    if ((this === other)) {
      return true
    } else {
      if (((((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month === other.Ljava_time_zone_ZoneOffsetTransitionRule__f_month) && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom === other.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom)) && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek === other.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek)) && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition === other.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition))) {
        var x = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time;
        var x$2 = other.Ljava_time_zone_ZoneOffsetTransitionRule__f_time;
        var $$x3 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
      } else {
        var $$x3 = false
      };
      if (($$x3 && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay === other.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay))) {
        var x$3 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset;
        var x$4 = other.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset;
        var $$x2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$5 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
        var x$6 = other.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$7 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
        var x$8 = other.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
        return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.hashCode__I = (function() {
  var hash = (((((((((((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time.toSecondOfDay__I() + (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay ? 1 : 0)) | 0) << 15) + (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month.jl_Enum__f__ordinal << 11)) | 0) + (((32 + this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom) | 0) << 5)) | 0) + (((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek === null) ? 7 : this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek.jl_Enum__f__ordinal) << 2)) | 0) + this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition.jl_Enum__f__ordinal) | 0);
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset;
  var $$x2 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
  var $$x1 = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$3 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
  return (((hash ^ $$x2) ^ $$x1) ^ this$3.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var $$x1 = buf.append__T__scm_StringBuilder("TransitionRule[");
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
  var other = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
  $$x1.append__T__scm_StringBuilder(((this$1.compare__Ljava_time_ZoneOffset__I(other) > 0) ? "Gap " : "Overlap ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore).append__T__scm_StringBuilder(" to ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter).append__T__scm_StringBuilder(", ");
  if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
    if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom === (-1))) {
      buf.append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek.jl_Enum__f__name).append__T__scm_StringBuilder(" on or before last day of ").append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month.jl_Enum__f__name)
    } else if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom < 0)) {
      buf.append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek.jl_Enum__f__name).append__T__scm_StringBuilder(" on or before last day minus ").append__I__scm_StringBuilder((((-1) - this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom) | 0)).append__T__scm_StringBuilder(" of ").append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month.jl_Enum__f__name)
    } else {
      var this$2 = buf.append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek.jl_Enum__f__name).append__T__scm_StringBuilder(" on or after ").append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month.jl_Enum__f__name).append__C__scm_StringBuilder(32);
      var x = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom;
      this$2.append__I__scm_StringBuilder(x)
    }
  } else {
    var this$3 = buf.append__T__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month.jl_Enum__f__name).append__C__scm_StringBuilder(32);
    var x$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom;
    this$3.append__I__scm_StringBuilder(x$1)
  };
  buf.append__T__scm_StringBuilder(" at ").append__T__scm_StringBuilder((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay ? "24:00" : this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time.toString__T())).append__T__scm_StringBuilder(" ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition).append__T__scm_StringBuilder(", standard offset ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset).append__C__scm_StringBuilder(93);
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
function $as_Ljava_time_zone_ZoneOffsetTransitionRule(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneOffsetTransitionRule) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneOffsetTransitionRule"))
}
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransitionRule)))
}
function $asArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneOffsetTransitionRule;", depth))
}
var $d_Ljava_time_zone_ZoneOffsetTransitionRule = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule", {
  Ljava_time_zone_ZoneOffsetTransitionRule: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule;
/** @constructor */
function $c_ju_AbstractMap() {
  /*<skip>*/
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
  /*<skip>*/
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.putAll__ju_Map__V = (function(m) {
  var _\uff3fself = new $c_ju_HashMap$EntrySet(m);
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  while (_\uff3fself$1.hasNext__Z()) {
    var arg1 = _\uff3fself$1.next__O();
    var e = $as_ju_Map$Entry(arg1);
    var key = e.getKey__O();
    var value = e.getValue__O();
    if ((key === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $dp_hashCode__I(key);
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
  }
});
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.ju_HashMap__f_contentSize === x2.ju_HashMap__f_contentSize)) {
      var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
      var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
      _return: {
        while (_\uff3fself$1.hasNext__Z()) {
          var arg1 = _\uff3fself$1.next__O();
          var item = $as_ju_Map$Entry(arg1);
          var key = item.getKey__O();
          var a = $p_ju_HashMap__getOrDefaultImpl__O__O__O(x2, key, null);
          var b = item.getValue__O();
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $$x1 = true;
            break _return
          }
        };
        var $$x1 = false
      };
      return (!$$x1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself$1.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself$1.next__O();
    var prev = $uI(arg1);
    var item = $as_ju_Map$Entry(arg2);
    result = ((item.hashCode__I() + prev) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = new $c_ju_HashMap$EntrySet(this).iterator__ju_Iterator();
  while (iter.hasNext__Z()) {
    var entry = $as_ju_Map$Entry(iter.next__O());
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (((("" + result) + entry.getKey__O()) + "=") + entry.getValue__O())
  };
  return (result + "}")
});
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)))
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"))
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)))
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth))
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass({
  ju_Formatter$RootLocaleInfo$: 0
}, false, "java.util.Formatter$RootLocaleInfo$", {
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1,
  O: 1
});
$c_ju_Formatter$RootLocaleInfo$.prototype.$classData = $d_ju_Formatter$RootLocaleInfo$;
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$()
  };
  return $n_ju_Formatter$RootLocaleInfo$
}
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer
  };
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = outer.ju_HashMap__f_java$util$HashMap$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null
}
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
  /*<skip>*/
}
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = this.ju_HashMap$AbstractHashMapIterator__f_$outer.ju_HashMap__f_java$util$HashMap$$table.get(this.ju_HashMap$AbstractHashMapIterator__f_nextIdx);
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true
      }
    };
    return false
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = node;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node.ju_HashMap$Node__f_next;
  return this.extract__ju_HashMap$Node__O(node)
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_HashMap$AbstractHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  };
  this.ju_HashMap$AbstractHashMapIterator__f_$outer.removeNode__ju_HashMap$Node__V(last);
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
  /*<skip>*/
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.getKey__O = (function() {
  return this.ju_HashMap$Node__f_key
});
$c_ju_HashMap$Node.prototype.getValue__O = (function() {
  return this.ju_HashMap$Node__f_value
});
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var b = x2.getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var b$1 = x2.getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)))
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value)
});
function $as_ju_HashMap$Node(obj) {
  return (((obj instanceof $c_ju_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap$Node"))
}
function $isArrayOf_ju_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap$Node)))
}
function $asArrayOf_ju_HashMap$Node(obj, depth) {
  return (($isArrayOf_ju_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap$Node;", depth))
}
var $d_ju_HashMap$Node = new $TypeData().initClass({
  ju_HashMap$Node: 0
}, false, "java.util.HashMap$Node", {
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_HashMap$Node.prototype.$classData = $d_ju_HashMap$Node;
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = outer
  };
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = outer.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest;
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null
}
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype;
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode !== null)
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = node;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = node.ju_LinkedHashMap$Node__f_younger;
  return this.extract__ju_LinkedHashMap$Node__O(node)
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  };
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer.removeNode__ju_HashMap$Node__V(last);
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null
});
function $p_ju_UUID$__fail$1__T__E($thiz, name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1))
}
/** @constructor */
function $c_ju_UUID$() {
  this.ju_UUID$__f_csprng = null;
  this.ju_UUID$__f_randomUUIDBuffer = null;
  this.ju_UUID$__f_bitmap$0 = 0
}
$c_ju_UUID$.prototype = new $h_O();
$c_ju_UUID$.prototype.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
  /*<skip>*/
}
$h_ju_UUID$.prototype = $c_ju_UUID$.prototype;
$c_ju_UUID$.prototype.fromString__T__ju_UUID = (function(name) {
  if (((((($uI(name.length) !== 36) || ((65535 & $uI(name.charCodeAt(8))) !== 45)) || ((65535 & $uI(name.charCodeAt(13))) !== 45)) || ((65535 & $uI(name.charCodeAt(18))) !== 45)) || ((65535 & $uI(name.charCodeAt(23))) !== 45))) {
    $p_ju_UUID$__fail$1__T__E(this, name)
  };
  try {
    var his = $as_T(name.substring(0, 4));
    var los = $as_T(name.substring(4, 8));
    var i1 = (($m_jl_Integer$().parseInt__T__I__I(his, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los, 16));
    var his$1 = $as_T(name.substring(9, 13));
    var los$1 = $as_T(name.substring(14, 18));
    var i2 = (($m_jl_Integer$().parseInt__T__I__I(his$1, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$1, 16));
    var his$2 = $as_T(name.substring(19, 23));
    var los$2 = $as_T(name.substring(24, 28));
    var i3 = (($m_jl_Integer$().parseInt__T__I__I(his$2, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$2, 16));
    var his$3 = $as_T(name.substring(28, 32));
    var los$3 = $as_T(name.substring(32, 36));
    var i4 = (($m_jl_Integer$().parseInt__T__I__I(his$3, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$3, 16));
    return new $c_ju_UUID(i1, i2, i3, i4, null, null)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $p_ju_UUID$__fail$1__T__E(this, name)
    } else {
      throw e
    }
  }
});
var $d_ju_UUID$ = new $TypeData().initClass({
  ju_UUID$: 0
}, false, "java.util.UUID$", {
  ju_UUID$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UUID$.prototype.$classData = $d_ju_UUID$;
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$()
  };
  return $n_ju_UUID$
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  this.ju_concurrent_TimeUnit$__f__values = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
  this.ju_concurrent_TimeUnit$__f__values = new ($d_ju_concurrent_TimeUnit.getArrayOf().constr)([this.ju_concurrent_TimeUnit$__f_NANOSECONDS, this.ju_concurrent_TimeUnit$__f_MICROSECONDS, this.ju_concurrent_TimeUnit$__f_MILLISECONDS, this.ju_concurrent_TimeUnit$__f_SECONDS, this.ju_concurrent_TimeUnit$__f_MINUTES, this.ju_concurrent_TimeUnit$__f_HOURS, this.ju_concurrent_TimeUnit$__f_DAYS])
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647)
  } else {
    var lo = max.RTLong__f_lo;
    var hi = max.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$1 < hi$1))) {
      return new $c_RTLong(1, (-2147483648))
    } else {
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$2, hi$2)
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass({
  ju_concurrent_TimeUnit$: 0
}, false, "java.util.concurrent.TimeUnit$", {
  ju_concurrent_TimeUnit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$.prototype.$classData = $d_ju_concurrent_TimeUnit$;
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$()
  };
  return $n_ju_concurrent_TimeUnit$
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean(value) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = value
}
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1)
});
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicBoolean: 0
}, false, "java.util.concurrent.atomic.AtomicBoolean", {
  ju_concurrent_atomic_AtomicBoolean: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.$classData = $d_ju_concurrent_atomic_AtomicBoolean;
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true
  } else {
    return false
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj)
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicReference: 0
}, false, "java.util.concurrent.atomic.AtomicReference", {
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicReference.prototype.$classData = $d_ju_concurrent_atomic_AtomicReference;
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_appendPos = 0;
  return $thiz
}
function $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available")
  };
  return $thiz.ju_regex_Matcher__f_lastMatch
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_regionEnd0 = 0;
  this.ju_regex_Matcher__f_inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_regionEnd0 = $uI(input0.length);
  this.ju_regex_Matcher__f_inputstr = input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
  /*<skip>*/
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.matches__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.ju_regex_Matcher__f_lastMatch = this.ju_regex_Matcher__f_pattern0.execMatches__T__sjs_js_RegExp$ExecResult(this.ju_regex_Matcher__f_inputstr);
  this.ju_regex_Matcher__f_lastMatchIsForMatches = true;
  return (this.ju_regex_Matcher__f_lastMatch !== null)
});
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = this.ju_regex_Matcher__f_pattern0;
  var input = this.ju_regex_Matcher__f_inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__sjs_js_RegExp$ExecResult(input, start);
  var end = $uI(this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex);
  if ((mtch !== null)) {
    var $$x1 = ((end === $uI(mtch.index)) ? ((1 + end) | 0) : end)
  } else {
    var this$2 = this.ju_regex_Matcher__f_inputstr;
    var $$x1 = ((1 + $uI(this$2.length)) | 0)
  };
  this.ju_regex_Matcher__f_position = $$x1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  return (mtch !== null)
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0)
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $$x1 = this.start__I();
  var this$1 = this.group__T();
  return (($$x1 + $uI(this$1.length)) | 0)
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var value = $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this)[0];
  if ((value === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
  };
  return $as_T(value)
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var value = $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this)[this.ju_regex_Matcher__f_pattern0.numberedGroup__I__I(group)];
  $m_s_$less$colon$less$();
  return $as_T(((value === (void 0)) ? null : value))
});
var $d_ju_regex_Matcher = new $TypeData().initClass({
  ju_regex_Matcher: 0
}, false, "java.util.regex.Matcher", {
  ju_regex_Matcher: 1,
  O: 1,
  ju_regex_MatchResult: 1
});
$c_ju_regex_Matcher.prototype.$classData = $d_ju_regex_Matcher;
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f_indicesBuilder = null;
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f__flags = 0;
  this.ju_regex_Pattern__f_jsPattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_namedGroups = null;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f_bitmap$0 = false;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f__flags = _flags;
  this.ju_regex_Pattern__f_jsPattern = jsPattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_namedGroups = namedGroups;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags)
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
  /*<skip>*/
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.execMatches__T__sjs_js_RegExp$ExecResult = (function(input) {
  return this.ju_regex_Pattern__f_jsRegExpForMatches.exec(input)
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__sjs_js_RegExp$ExecResult = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input)
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group))
  };
  return $uI(this.ju_regex_Pattern__f_groupNumberMap[group])
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""])
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var prevEnd = 0;
    var size$1 = 0;
    while (((size$1 < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        var elem = $as_T(inputStr.substring(beginIndex, endIndex));
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
        size$1 = ((1 + size$1) | 0)
      };
      prevEnd = matcher.end__I()
    };
    var beginIndex$1 = prevEnd;
    var elem$1 = $as_T(inputStr.substring(beginIndex$1));
    var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
    jsElems.push(unboxedElem$1);
    var result = new ($d_T.getArrayOf().constr)(jsElems);
    if ((limit !== 0)) {
      return result
    } else {
      var actualLength = result.u.length;
      while (((actualLength !== 0) && (result.get((((-1) + actualLength) | 0)) === ""))) {
        actualLength = (((-1) + actualLength) | 0)
      };
      if ((actualLength === result.u.length)) {
        return result
      } else {
        var actualResult = new ($d_T.getArrayOf().constr)(actualLength);
        var length = actualLength;
        result.copyTo(0, actualResult, 0, length);
        return actualResult
      }
    }
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass({
  ju_regex_Pattern: 0
}, false, "java.util.regex.Pattern", {
  ju_regex_Pattern: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern.prototype.$classData = $d_ju_regex_Pattern;
/** @constructor */
function $c_ju_regex_Pattern$() {
  /*<skip>*/
}
$c_ju_regex_Pattern$.prototype = new $h_O();
$c_ju_regex_Pattern$.prototype.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
  /*<skip>*/
}
$h_ju_regex_Pattern$.prototype = $c_ju_regex_Pattern$.prototype;
$c_ju_regex_Pattern$.prototype.java$util$regex$Pattern$$matches__T__T__Z = (function(regex, input) {
  var this$1 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return new $c_ju_regex_Matcher(this$1, input).matches__Z()
});
var $d_ju_regex_Pattern$ = new $TypeData().initClass({
  ju_regex_Pattern$: 0
}, false, "java.util.regex.Pattern$", {
  ju_regex_Pattern$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern$.prototype.$classData = $d_ju_regex_Pattern$;
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$()
  };
  return $n_ju_regex_Pattern$
}
/** @constructor */
function $c_Llocales_cldr_fallback_LocalesProvider$() {
  /*<skip>*/
}
$c_Llocales_cldr_fallback_LocalesProvider$.prototype = new $h_O();
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.constructor = $c_Llocales_cldr_fallback_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_fallback_LocalesProvider$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_LocalesProvider$.prototype = $c_Llocales_cldr_fallback_LocalesProvider$.prototype;
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.ldmls__sci_Map = (function() {
  var $$x10 = $m_s_Predef$();
  var xs = $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$().all__ALlocales_cldr_LDML();
  var f = ((this$2) => ((x$1) => {
    var x$1$1 = $as_Llocales_cldr_LDML(x$1);
    var _1 = x$1$1.toLocale__ju_Locale().toLanguageTag__T();
    return $ct_T2__O__O__(new $c_T2(), _1, x$1$1)
  }))(this);
  var len = xs.u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $$x1 = i;
        var arg1 = xs.get(i);
        ys.set($$x1, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $$x2 = i;
        var arg1$1 = x3.get(i);
        ys.set($$x2, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$2 = x4.get(i);
        ys.set($$x3, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $$x4 = i;
        var t = x5.get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $$x5 = i;
        var arg1$3 = x6.get(i);
        ys.set($$x5, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$4 = x7.get(i);
        ys.set($$x6, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$5 = x8.get(i);
        ys.set($$x7, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$6 = x9.get(i);
        ys.set($$x8, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$7 = x10.get(i);
        ys.set($$x9, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  var this$7 = $$x10.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7)
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.currencyData__Llocales_cldr_CurrencyData = (function() {
  return new $c_Llocales_cldr_CurrencyData($as_sci_Seq($m_s_package$().s_package$__f_Seq.empty__sc_SeqOps()), $as_sci_Seq($m_s_package$().s_package$__f_Seq.empty__sc_SeqOps()), $as_sci_Seq($m_s_package$().s_package$__f_Seq.empty__sc_SeqOps()), $as_sci_Seq($m_s_package$().s_package$__f_Seq.empty__sc_SeqOps()))
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.metadata__Llocales_cldr_CLDRMetadata = (function() {
  return new $c_Llocales_cldr_CLDRMetadata(new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0))
});
var $d_Llocales_cldr_fallback_LocalesProvider$ = new $TypeData().initClass({
  Llocales_cldr_fallback_LocalesProvider$: 0
}, false, "locales.cldr.fallback.LocalesProvider$", {
  Llocales_cldr_fallback_LocalesProvider$: 1,
  O: 1,
  Llocales_cldr_LocalesProvider: 1
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.$classData = $d_Llocales_cldr_fallback_LocalesProvider$;
var $n_Llocales_cldr_fallback_LocalesProvider$;
function $m_Llocales_cldr_fallback_LocalesProvider$() {
  if ((!$n_Llocales_cldr_fallback_LocalesProvider$)) {
    $n_Llocales_cldr_fallback_LocalesProvider$ = new $c_Llocales_cldr_fallback_LocalesProvider$()
  };
  return $n_Llocales_cldr_fallback_LocalesProvider$
}
/** @constructor */
function $c_Lnet_timerboard_InputEffects$$anon$1() {
  /*<skip>*/
}
$c_Lnet_timerboard_InputEffects$$anon$1.prototype = new $h_O();
$c_Lnet_timerboard_InputEffects$$anon$1.prototype.constructor = $c_Lnet_timerboard_InputEffects$$anon$1;
/** @constructor */
function $h_Lnet_timerboard_InputEffects$$anon$1() {
  /*<skip>*/
}
$h_Lnet_timerboard_InputEffects$$anon$1.prototype = $c_Lnet_timerboard_InputEffects$$anon$1.prototype;
$c_Lnet_timerboard_InputEffects$$anon$1.prototype.cancel__V = (function() {
  /*<skip>*/
});
var $d_Lnet_timerboard_InputEffects$$anon$1 = new $TypeData().initClass({
  Lnet_timerboard_InputEffects$$anon$1: 0
}, false, "net.timerboard.InputEffects$$anon$1", {
  Lnet_timerboard_InputEffects$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Lnet_timerboard_InputEffects$$anon$1.prototype.$classData = $d_Lnet_timerboard_InputEffects$$anon$1;
/** @constructor */
function $c_Lnet_timerboard_InputEffects$$anon$2(elementId$5, modifier$3) {
  this.Lnet_timerboard_InputEffects$$anon$2__f_elementId$4 = null;
  this.Lnet_timerboard_InputEffects$$anon$2__f_modifier$2 = null;
  this.Lnet_timerboard_InputEffects$$anon$2__f_elementId$4 = elementId$5;
  this.Lnet_timerboard_InputEffects$$anon$2__f_modifier$2 = modifier$3
}
$c_Lnet_timerboard_InputEffects$$anon$2.prototype = new $h_O();
$c_Lnet_timerboard_InputEffects$$anon$2.prototype.constructor = $c_Lnet_timerboard_InputEffects$$anon$2;
/** @constructor */
function $h_Lnet_timerboard_InputEffects$$anon$2() {
  /*<skip>*/
}
$h_Lnet_timerboard_InputEffects$$anon$2.prototype = $c_Lnet_timerboard_InputEffects$$anon$2.prototype;
$c_Lnet_timerboard_InputEffects$$anon$2.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var elementId$2 = this.Lnet_timerboard_InputEffects$$anon$2__f_elementId$4;
  var modifier$1 = this.Lnet_timerboard_InputEffects$$anon$2__f_modifier$2;
  var node = document.getElementById(elementId$2);
  if ((node !== null)) {
    observer.onNext__O__V(modifier$1.apply__O__O(node))
  } else {
    observer.onError__O__V(new $c_Ltyrian_cmds_Dom$NotFound(elementId$2))
  };
  return new $c_Lnet_timerboard_InputEffects$$anon$1()
});
var $d_Lnet_timerboard_InputEffects$$anon$2 = new $TypeData().initClass({
  Lnet_timerboard_InputEffects$$anon$2: 0
}, false, "net.timerboard.InputEffects$$anon$2", {
  Lnet_timerboard_InputEffects$$anon$2: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Lnet_timerboard_InputEffects$$anon$2.prototype.$classData = $d_Lnet_timerboard_InputEffects$$anon$2;
/** @constructor */
function $c_Lnet_timerboard_Timerboard$() {
  this.Lnet_timerboard_Timerboard$__f_inputKeyConfig = null;
  $n_Lnet_timerboard_Timerboard$ = this;
  $m_Ltyrian_Html$();
  var msg = new $c_sjsr_AnonFunction1(((this$1) => ((x$1) => (($uI(x$1.keyCode) === 8) ? $s_Lnet_timerboard_Msg$__SearchBackspace__Lnet_timerboard_Msg() : (($uI(x$1.keyCode) === 13) ? $s_Lnet_timerboard_Msg$__EnterTag__Lnet_timerboard_Msg() : $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg()))))(this));
  this.Lnet_timerboard_Timerboard$__f_inputKeyConfig = new $c_Ltyrian_Event("keydown", msg)
}
$c_Lnet_timerboard_Timerboard$.prototype = new $h_O();
$c_Lnet_timerboard_Timerboard$.prototype.constructor = $c_Lnet_timerboard_Timerboard$;
/** @constructor */
function $h_Lnet_timerboard_Timerboard$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Timerboard$.prototype = $c_Lnet_timerboard_Timerboard$.prototype;
$c_Lnet_timerboard_Timerboard$.prototype.$js$exported$meth$launch__T__O = (function(containerId) {
  $f_Ltyrian_TyrianApp__launch__T__V(this, containerId)
});
$c_Lnet_timerboard_Timerboard$.prototype.$js$exported$meth$launch__T__sjs_js_Dictionary__O = (function(containerId, flags) {
  $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V(this, containerId, flags)
});
$c_Lnet_timerboard_Timerboard$.prototype.init__sci_Map__T2 = (function(flags) {
  var socket = $m_Lnet_timerboard_BackendSocket$().Lnet_timerboard_BackendSocket$__f_init;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var logs = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_s_package$();
  var elems$1 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var state = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var this$3 = $m_Ljava_time_ZonedDateTime$();
  var now = this$3.now__Ljava_time_Clock__Ljava_time_ZonedDateTime(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var system = $m_s_None$();
  var systemNames = $m_sci_Map$EmptyMap$();
  var distances = $m_sci_Map$EmptyMap$();
  $m_s_package$();
  var searchTags = $m_sci_Nil$();
  var sortBy = $s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field();
  var sortDirection = $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction();
  var systems = $m_sci_Map$EmptyMap$();
  var _1 = new $c_Lnet_timerboard_Model(socket, logs, state, now, system, systemNames, distances, "", searchTags, sortBy, sortDirection, systems);
  var $$x1 = $m_sr_ScalaRunTime$();
  var status = $s_Lnet_timerboard_BackendSocket$Status$__Connecting__Lnet_timerboard_BackendSocket$Status();
  var msg = new $c_Lnet_timerboard_Msg$WebSocketStatus(status);
  var cmds = $$x1.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([new $c_Ltyrian_Cmd$Emit(msg), $m_Lnet_timerboard_MapData$().Lnet_timerboard_MapData$__f_get, $m_Lnet_timerboard_Systems$().Lnet_timerboard_Systems$__f_get, $m_Ltyrian_cmds_Dom$().focus__T__F1__Ltyrian_Cmd("search-box", new $c_sjsr_AnonFunction1(((this$19) => ((_$18) => {
    $as_s_util_Either(_$18);
    return $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg()
  }))(this))), $m_Ltyrian_Navigation$().getLocationHash__F1__Ltyrian_Cmd(new $c_sjsr_AnonFunction1(((this$2$1) => ((_$19) => {
    var _$19$1 = $as_s_util_Either(_$19);
    if ((_$19$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$19$1);
      var b = x2.s_util_Right__f_value;
      var r = $as_Ltyrian_Navigation$CurrentHash(b);
      var s = r.Ltyrian_Navigation$CurrentHash__f_hash;
      var $$x2 = new $c_Lnet_timerboard_Msg$LoadHash(s)
    } else {
      if ((!(_$19$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(_$19$1)
      };
      var x3 = $as_s_util_Left(_$19$1);
      var a = x3.s_util_Left__f_value;
      $as_Ltyrian_Navigation$NoHash$(a);
      var $$x2 = $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg()
    };
    return $as_Lnet_timerboard_Msg($$x2)
  }))(this)))]));
  $m_sci_List$();
  var cmds$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds);
  var _2 = new $c_Ltyrian_Cmd$Batch(cmds$1);
  return $ct_T2__O__O__(new $c_T2(), _1, _2)
});
$c_Lnet_timerboard_Timerboard$.prototype.updateHash__Lnet_timerboard_Model__Ltyrian_Cmd = (function(m) {
  return $m_Ltyrian_Navigation$().setLocationHash__T__Ltyrian_Cmd($m_Lnet_timerboard_SearchHashes$().createHashFromModel__Lnet_timerboard_Model__T(m))
});
$c_Lnet_timerboard_Timerboard$.prototype.update__Lnet_timerboard_Msg__Lnet_timerboard_Model__T2 = (function(msg, model) {
  if ((msg instanceof $c_Lnet_timerboard_Msg$LoadHash)) {
    var x$1 = $as_Lnet_timerboard_Msg$LoadHash(msg);
    var x67 = x$1.Lnet_timerboard_Msg$LoadHash__f_s;
    var _1 = $m_Lnet_timerboard_SearchHashes$().updateModelFromhash__Lnet_timerboard_Model__T__Lnet_timerboard_Model(model, x67);
    var _2 = $m_Ltyrian_Cmd$Empty$();
    return $ct_T2__O__O__(new $c_T2(), _1, _2)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$LoadSystemRegions)) {
    var x$1$1 = $as_Lnet_timerboard_Msg$LoadSystemRegions(msg);
    var x64 = x$1$1.Lnet_timerboard_Msg$LoadSystemRegions__f_db;
    var socket = model.Lnet_timerboard_Model__f_socket;
    var logs = model.Lnet_timerboard_Model__f_logs;
    var state = model.Lnet_timerboard_Model__f_state;
    var now = model.Lnet_timerboard_Model__f_now;
    var system = model.Lnet_timerboard_Model__f_system;
    var systemNames = model.Lnet_timerboard_Model__f_systemNames;
    var distances = model.Lnet_timerboard_Model__f_distances;
    var search = model.Lnet_timerboard_Model__f_search;
    var searchTags = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection = model.Lnet_timerboard_Model__f_sortDirection;
    var _1$1 = new $c_Lnet_timerboard_Model(socket, logs, state, now, system, systemNames, distances, search, searchTags, sortBy, sortDirection, x64);
    var _2$1 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Regions loaded"])));
    return $ct_T2__O__O__(new $c_T2(), _1$1, _2$1)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$LoadSystems)) {
    var x$1$2 = $as_Lnet_timerboard_Msg$LoadSystems(msg);
    var x61 = x$1$2.Lnet_timerboard_Msg$LoadSystems__f_systems;
    var f = ((this$6) => ((s$2) => {
      var s = $as_Lnet_timerboard_SolarSystem(s$2);
      var self = s.Lnet_timerboard_SolarSystem__f_name;
      var t = s.Lnet_timerboard_SolarSystem__f_id;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return $ct_T2__O__O__(new $c_T2(), self, new $c_RTLong(lo, hi))
    }))(this);
    if ((x61 === $m_sci_Nil$())) {
      var this$10 = $m_sci_Nil$()
    } else {
      var arg1 = x61.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t$1 = h;
      var rest = $as_sci_List(x61.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest = $as_sci_List(rest.tail__O())
      };
      var this$10 = h
    };
    $m_s_$less$colon$less$();
    var systemNames$2 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$10);
    var socket$2 = model.Lnet_timerboard_Model__f_socket;
    var logs$2 = model.Lnet_timerboard_Model__f_logs;
    var state$2 = model.Lnet_timerboard_Model__f_state;
    var now$2 = model.Lnet_timerboard_Model__f_now;
    var system$2 = model.Lnet_timerboard_Model__f_system;
    var distances$2 = model.Lnet_timerboard_Model__f_distances;
    var search$2 = model.Lnet_timerboard_Model__f_search;
    var searchTags$2 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$2 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$2 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$2 = model.Lnet_timerboard_Model__f_systems;
    var _1$2 = new $c_Lnet_timerboard_Model(socket$2, logs$2, state$2, now$2, system$2, systemNames$2, distances$2, search$2, searchTags$2, sortBy$2, sortDirection$2, systems$2);
    var _2$2 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["System Ids loaded"])));
    return $ct_T2__O__O__(new $c_T2(), _1$2, _2$2)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$SortBy)) {
    var x$1$3 = $as_Lnet_timerboard_Msg$SortBy(msg);
    var x58 = x$1$3.Lnet_timerboard_Msg$SortBy__f_f;
    var x = model.Lnet_timerboard_Model__f_sortBy;
    if ((x === x58)) {
      var sortDirection$3 = model.Lnet_timerboard_Model__f_sortDirection.flip__Lnet_timerboard_Direction();
      var socket$3 = model.Lnet_timerboard_Model__f_socket;
      var logs$3 = model.Lnet_timerboard_Model__f_logs;
      var state$3 = model.Lnet_timerboard_Model__f_state;
      var now$3 = model.Lnet_timerboard_Model__f_now;
      var system$3 = model.Lnet_timerboard_Model__f_system;
      var systemNames$3 = model.Lnet_timerboard_Model__f_systemNames;
      var distances$3 = model.Lnet_timerboard_Model__f_distances;
      var search$3 = model.Lnet_timerboard_Model__f_search;
      var searchTags$3 = model.Lnet_timerboard_Model__f_searchTags;
      var sortBy$3 = model.Lnet_timerboard_Model__f_sortBy;
      var systems$3 = model.Lnet_timerboard_Model__f_systems;
      var _1$3 = new $c_Lnet_timerboard_Model(socket$3, logs$3, state$3, now$3, system$3, systemNames$3, distances$3, search$3, searchTags$3, sortBy$3, sortDirection$3, systems$3)
    } else {
      var socket$1 = model.Lnet_timerboard_Model__f_socket;
      var logs$1 = model.Lnet_timerboard_Model__f_logs;
      var state$1 = model.Lnet_timerboard_Model__f_state;
      var now$1 = model.Lnet_timerboard_Model__f_now;
      var system$1 = model.Lnet_timerboard_Model__f_system;
      var systemNames$1 = model.Lnet_timerboard_Model__f_systemNames;
      var distances$1 = model.Lnet_timerboard_Model__f_distances;
      var search$1 = model.Lnet_timerboard_Model__f_search;
      var searchTags$1 = model.Lnet_timerboard_Model__f_searchTags;
      var sortDirection$1 = model.Lnet_timerboard_Model__f_sortDirection;
      var systems = model.Lnet_timerboard_Model__f_systems;
      var _1$3 = new $c_Lnet_timerboard_Model(socket$1, logs$1, state$1, now$1, system$1, systemNames$1, distances$1, search$1, searchTags$1, x58, sortDirection$1, systems)
    };
    var _2$3 = $m_Ltyrian_Cmd$Empty$();
    return $ct_T2__O__O__(new $c_T2(), _1$3, _2$3)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$Payload)) {
    var x$1$4 = $as_Lnet_timerboard_Msg$Payload(msg);
    var x55 = x$1$4.Lnet_timerboard_Msg$Payload__f_we;
    if ((x55 instanceof $c_Lnet_timerboard_WebsocketEvent$Initial)) {
      var x$1$5 = $as_Lnet_timerboard_WebsocketEvent$Initial(x55);
      var x18 = x$1$5.Lnet_timerboard_WebsocketEvent$Initial__f_initial;
      var socket$4 = model.Lnet_timerboard_Model__f_socket;
      var logs$4 = model.Lnet_timerboard_Model__f_logs;
      var now$4 = model.Lnet_timerboard_Model__f_now;
      var system$4 = model.Lnet_timerboard_Model__f_system;
      var systemNames$4 = model.Lnet_timerboard_Model__f_systemNames;
      var distances$4 = model.Lnet_timerboard_Model__f_distances;
      var search$4 = model.Lnet_timerboard_Model__f_search;
      var searchTags$4 = model.Lnet_timerboard_Model__f_searchTags;
      var sortBy$1 = model.Lnet_timerboard_Model__f_sortBy;
      var sortDirection$4 = model.Lnet_timerboard_Model__f_sortDirection;
      var systems$1 = model.Lnet_timerboard_Model__f_systems;
      var _1$4 = new $c_Lnet_timerboard_Model(socket$4, logs$4, x18, now$4, system$4, systemNames$4, distances$4, search$4, searchTags$4, sortBy$1, sortDirection$4, systems$1);
      var _2$4 = $m_Ltyrian_Cmd$Empty$();
      return $ct_T2__O__O__(new $c_T2(), _1$4, _2$4)
    };
    if ((x55 instanceof $c_Lnet_timerboard_WebsocketEvent$Diff)) {
      var x$1$6 = $as_Lnet_timerboard_WebsocketEvent$Diff(x55);
      var x15 = x$1$6.Lnet_timerboard_WebsocketEvent$Diff__f_diff;
      var value = model.Lnet_timerboard_Model__f_state;
      $m_Lio_circe_Encoder$();
      var encodeA = $m_Lnet_timerboard_Event$().derived$AsObject__Lio_circe_Encoder$AsObject();
      var encoder = new $c_Lio_circe_Encoder$$anon$26(encodeA);
      var this$22 = $as_s_util_Try(x15.apply__O__Lcats_MonadError__O($f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(encoder, value), ($m_Lcats_implicits$(), new $c_Lcats_instances_TryInstances$$anon$1()))).toEither__s_util_Either();
      if ((this$22 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$22);
        var b = x2.s_util_Right__f_value;
        var _$21 = $as_Lio_circe_Json(b);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lnet_timerboard_Event$().derived$Decoder__Lio_circe_Decoder();
        var d = new $c_Lio_circe_Decoder$$anon$45(decodeA);
        var x7 = d.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(_$21, null, null))
      } else {
        var x7 = this$22
      };
      if ((x7 instanceof $c_s_util_Left)) {
        var e = $as_jl_Throwable($as_s_util_Left(x7).s_util_Left__f_value);
        var msg$1 = new $c_Lnet_timerboard_Msg$BadPayload(e);
        var _2$5 = new $c_Ltyrian_Cmd$Emit(msg$1);
        return $ct_T2__O__O__(new $c_T2(), model, _2$5)
      };
      if ((x7 instanceof $c_s_util_Right)) {
        var patched = $as_sci_List($as_s_util_Right(x7).s_util_Right__f_value);
        var socket$5 = model.Lnet_timerboard_Model__f_socket;
        var logs$5 = model.Lnet_timerboard_Model__f_logs;
        var now$5 = model.Lnet_timerboard_Model__f_now;
        var system$5 = model.Lnet_timerboard_Model__f_system;
        var systemNames$5 = model.Lnet_timerboard_Model__f_systemNames;
        var distances$5 = model.Lnet_timerboard_Model__f_distances;
        var search$5 = model.Lnet_timerboard_Model__f_search;
        var searchTags$5 = model.Lnet_timerboard_Model__f_searchTags;
        var sortBy$4 = model.Lnet_timerboard_Model__f_sortBy;
        var sortDirection$5 = model.Lnet_timerboard_Model__f_sortDirection;
        var systems$4 = model.Lnet_timerboard_Model__f_systems;
        var _1$5 = new $c_Lnet_timerboard_Model(socket$5, logs$5, patched, now$5, system$5, systemNames$5, distances$5, search$5, searchTags$5, sortBy$4, sortDirection$5, systems$4);
        var _2$6 = $m_Ltyrian_Cmd$Empty$();
        return $ct_T2__O__O__(new $c_T2(), _1$5, _2$6)
      };
      throw new $c_s_MatchError(x7)
    };
    throw new $c_s_MatchError(x55)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$BadPayload)) {
    var x$1$7 = $as_Lnet_timerboard_Msg$BadPayload(msg);
    var x52 = x$1$7.Lnet_timerboard_Msg$BadPayload__f_e;
    var _2$7 = $m_Ltyrian_cmds_Logger$().error__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([x52.getMessage__T()])));
    return $ct_T2__O__O__(new $c_T2(), model, _2$7)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$BadHttp)) {
    var x$1$8 = $as_Lnet_timerboard_Msg$BadHttp(msg);
    var x49 = x$1$8.Lnet_timerboard_Msg$BadHttp__f_e;
    var _2$8 = $m_Ltyrian_cmds_Logger$().error__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([x49.toString__T()])));
    return $ct_T2__O__O__(new $c_T2(), model, _2$8)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$Other)) {
    var x$1$9 = $as_Lnet_timerboard_Msg$Other(msg);
    var x46 = x$1$9.Lnet_timerboard_Msg$Other__f_s;
    var this$34 = model.Lnet_timerboard_Model__f_logs;
    var logs$4$1 = new $c_sci_$colon$colon(x46, this$34);
    var socket$4$1 = model.Lnet_timerboard_Model__f_socket;
    var state$4 = model.Lnet_timerboard_Model__f_state;
    var now$4$1 = model.Lnet_timerboard_Model__f_now;
    var system$4$1 = model.Lnet_timerboard_Model__f_system;
    var systemNames$4$1 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$4$1 = model.Lnet_timerboard_Model__f_distances;
    var search$4$1 = model.Lnet_timerboard_Model__f_search;
    var searchTags$4$1 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$4$1 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$4$1 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$4$1 = model.Lnet_timerboard_Model__f_systems;
    var _1$6 = new $c_Lnet_timerboard_Model(socket$4$1, logs$4$1, state$4, now$4$1, system$4$1, systemNames$4$1, distances$4$1, search$4$1, searchTags$4$1, sortBy$4$1, sortDirection$4$1, systems$4$1);
    var _2$9 = $m_Ltyrian_Cmd$Empty$();
    return $ct_T2__O__O__(new $c_T2(), _1$6, _2$9)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$WebSocketStatus)) {
    var x$1$10 = $as_Lnet_timerboard_Msg$WebSocketStatus(msg);
    var x43 = x$1$10.Lnet_timerboard_Msg$WebSocketStatus__f_status;
    matchResult5: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x19 = model.Lnet_timerboard_Model__f_socket.update__Lnet_timerboard_BackendSocket$Status__T2(x43);
      if ((x19 !== null)) {
        var nextWS = $as_Lnet_timerboard_BackendSocket(x19._1__O());
        var cmds = $as_Ltyrian_Cmd(x19._2__O());
        var \u03b41$___1 = nextWS;
        var \u03b41$___2 = cmds;
        break matchResult5
      };
      throw new $c_s_MatchError(x19)
    };
    var nextWS$2 = $as_Lnet_timerboard_BackendSocket(\u03b41$___1);
    var cmds$2 = $as_Ltyrian_Cmd(\u03b41$___2);
    var logs$6 = model.Lnet_timerboard_Model__f_logs;
    var state$5 = model.Lnet_timerboard_Model__f_state;
    var now$6 = model.Lnet_timerboard_Model__f_now;
    var system$6 = model.Lnet_timerboard_Model__f_system;
    var systemNames$6 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$6 = model.Lnet_timerboard_Model__f_distances;
    var search$6 = model.Lnet_timerboard_Model__f_search;
    var searchTags$6 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$5 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$6 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$5 = model.Lnet_timerboard_Model__f_systems;
    var _1$7 = new $c_Lnet_timerboard_Model(nextWS$2, logs$6, state$5, now$6, system$6, systemNames$6, distances$6, search$6, searchTags$6, sortBy$5, sortDirection$6, systems$5);
    return $ct_T2__O__O__(new $c_T2(), _1$7, cmds$2)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$Tick)) {
    var x$1$11 = $as_Lnet_timerboard_Msg$Tick(msg);
    var x40 = x$1$11.Lnet_timerboard_Msg$Tick__f_now;
    var socket$6 = model.Lnet_timerboard_Model__f_socket;
    var logs$7 = model.Lnet_timerboard_Model__f_logs;
    var state$6 = model.Lnet_timerboard_Model__f_state;
    var system$7 = model.Lnet_timerboard_Model__f_system;
    var systemNames$7 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$7 = model.Lnet_timerboard_Model__f_distances;
    var search$7 = model.Lnet_timerboard_Model__f_search;
    var searchTags$7 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$6 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$7 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$6 = model.Lnet_timerboard_Model__f_systems;
    var _1$8 = new $c_Lnet_timerboard_Model(socket$6, logs$7, state$6, x40, system$7, systemNames$7, distances$7, search$7, searchTags$7, sortBy$6, sortDirection$7, systems$6);
    var _2$10 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([("Tick " + x40)])));
    return $ct_T2__O__O__(new $c_T2(), _1$8, _2$10)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$Search)) {
    var x$1$12 = $as_Lnet_timerboard_Msg$Search(msg);
    var x37 = x$1$12.Lnet_timerboard_Msg$Search__f_s;
    var socket$7 = model.Lnet_timerboard_Model__f_socket;
    var logs$8 = model.Lnet_timerboard_Model__f_logs;
    var state$7 = model.Lnet_timerboard_Model__f_state;
    var now$7 = model.Lnet_timerboard_Model__f_now;
    var system$8 = model.Lnet_timerboard_Model__f_system;
    var systemNames$8 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$8 = model.Lnet_timerboard_Model__f_distances;
    var searchTags$8 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$7 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$8 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$7 = model.Lnet_timerboard_Model__f_systems;
    var m = new $c_Lnet_timerboard_Model(socket$7, logs$8, state$7, now$7, system$8, systemNames$8, distances$8, x37, searchTags$8, sortBy$7, sortDirection$8, systems$7);
    var _2$11 = this.updateHash__Lnet_timerboard_Model__Ltyrian_Cmd(m);
    return $ct_T2__O__O__(new $c_T2(), m, _2$11)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$System)) {
    var x$1$13 = $as_Lnet_timerboard_Msg$System(msg);
    var x34 = x$1$13.Lnet_timerboard_Msg$System__f_s;
    var this$44 = $m_s_Option$().apply__O__s_Option(x34);
    if (this$44.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1$2 = this$44.get__O();
      var _$22 = $as_T(arg1$2);
      var $$x1 = (_$22 !== "")
    };
    if ($$x1) {
      var system$5$1 = this$44
    } else {
      var system$5$1 = $m_s_None$()
    };
    var socket$5$1 = model.Lnet_timerboard_Model__f_socket;
    var logs$5$1 = model.Lnet_timerboard_Model__f_logs;
    var state$5$1 = model.Lnet_timerboard_Model__f_state;
    var now$5$1 = model.Lnet_timerboard_Model__f_now;
    var systemNames$5$1 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$5$1 = model.Lnet_timerboard_Model__f_distances;
    var search$5$1 = model.Lnet_timerboard_Model__f_search;
    var searchTags$5$1 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$5$1 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$5$1 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$5$1 = model.Lnet_timerboard_Model__f_systems;
    var _1$9 = new $c_Lnet_timerboard_Model(socket$5$1, logs$5$1, state$5$1, now$5$1, system$5$1, systemNames$5$1, distances$5$1, search$5$1, searchTags$5$1, sortBy$5$1, sortDirection$5$1, systems$5$1);
    if (model.Lnet_timerboard_Model__f_systemNames.contains__O__Z(x34)) {
      var $$x3 = $m_sr_ScalaRunTime$();
      var $$x2 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Recalculating distances"])));
      var msg$2 = $s_Lnet_timerboard_Msg$__CalculateDistances__Lnet_timerboard_Msg();
      var cmds$1 = $$x3.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$$x2, new $c_Ltyrian_Cmd$Emit(msg$2)]));
      $m_sci_List$();
      var cmds$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds$1);
      var _2$12 = new $c_Ltyrian_Cmd$Batch(cmds$3)
    } else {
      var _2$12 = $m_Ltyrian_cmds_Logger$().error__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([("unknown system: " + x34)])))
    };
    return $ct_T2__O__O__(new $c_T2(), _1$9, _2$12)
  };
  var x$3 = $s_Lnet_timerboard_Msg$__SearchBackspace__Lnet_timerboard_Msg();
  if (((x$3 === null) ? (msg === null) : x$3.equals__O__Z(msg))) {
    if ((model.Lnet_timerboard_Model__f_search === "")) {
      var searchTags$6$1 = $as_sci_List(model.Lnet_timerboard_Model__f_searchTags.tail__O());
      var socket$6$1 = model.Lnet_timerboard_Model__f_socket;
      var logs$6$1 = model.Lnet_timerboard_Model__f_logs;
      var state$6$1 = model.Lnet_timerboard_Model__f_state;
      var now$6$1 = model.Lnet_timerboard_Model__f_now;
      var system$6$1 = model.Lnet_timerboard_Model__f_system;
      var systemNames$6$1 = model.Lnet_timerboard_Model__f_systemNames;
      var distances$6$1 = model.Lnet_timerboard_Model__f_distances;
      var search$6$1 = model.Lnet_timerboard_Model__f_search;
      var sortBy$6$1 = model.Lnet_timerboard_Model__f_sortBy;
      var sortDirection$6$1 = model.Lnet_timerboard_Model__f_sortDirection;
      var systems$6$1 = model.Lnet_timerboard_Model__f_systems;
      var m$2 = new $c_Lnet_timerboard_Model(socket$6$1, logs$6$1, state$6$1, now$6$1, system$6$1, systemNames$6$1, distances$6$1, search$6$1, searchTags$6$1, sortBy$6$1, sortDirection$6$1, systems$6$1)
    } else {
      var m$2 = model
    };
    var _2$13 = this.updateHash__Lnet_timerboard_Model__Ltyrian_Cmd(m$2);
    return $ct_T2__O__O__(new $c_T2(), m$2, _2$13)
  };
  var x$5 = $s_Lnet_timerboard_Msg$__EnterTag__Lnet_timerboard_Msg();
  if (((x$5 === null) ? (msg === null) : x$5.equals__O__Z(msg))) {
    var this$53 = model.Lnet_timerboard_Model__f_searchTags;
    var elem = model.Lnet_timerboard_Model__f_search;
    var searchTags$7$1 = new $c_sci_$colon$colon(elem, this$53);
    var socket$7$1 = model.Lnet_timerboard_Model__f_socket;
    var logs$7$1 = model.Lnet_timerboard_Model__f_logs;
    var state$7$1 = model.Lnet_timerboard_Model__f_state;
    var now$7$1 = model.Lnet_timerboard_Model__f_now;
    var system$7$1 = model.Lnet_timerboard_Model__f_system;
    var systemNames$7$1 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$7$1 = model.Lnet_timerboard_Model__f_distances;
    var sortBy$7$1 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$7$1 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$7$1 = model.Lnet_timerboard_Model__f_systems;
    var m$3 = new $c_Lnet_timerboard_Model(socket$7$1, logs$7$1, state$7$1, now$7$1, system$7$1, systemNames$7$1, distances$7$1, "", searchTags$7$1, sortBy$7$1, sortDirection$7$1, systems$7$1);
    var cmds$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$m_Lnet_timerboard_InputEffects$().clear__T__F1__Ltyrian_Cmd("search-box", new $c_sjsr_AnonFunction1(((this$4$1) => ((_$23) => {
      $as_s_util_Either(_$23);
      return $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg()
    }))(this))), this.updateHash__Lnet_timerboard_Model__Ltyrian_Cmd(m$3)]));
    $m_sci_List$();
    var cmds$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds$4);
    var _2$14 = new $c_Ltyrian_Cmd$Batch(cmds$5);
    return $ct_T2__O__O__(new $c_T2(), m$3, _2$14)
  };
  var x$7 = $s_Lnet_timerboard_Msg$__SystemTab__Lnet_timerboard_Msg();
  if (((x$7 === null) ? (msg === null) : x$7.equals__O__Z(msg))) {
    var this$58 = model.Lnet_timerboard_Model__f_system;
    if (this$58.isEmpty__Z()) {
      var x22 = $m_s_None$()
    } else {
      var arg1$3 = this$58.get__O();
      var sys = $as_T(arg1$3);
      var this$59 = model.Lnet_timerboard_Model__f_systemNames;
      var x22 = this$59.keySet__sc_Set().find__F1__s_Option(new $c_sjsr_AnonFunction1(((this$60, sys$2) => ((_$24) => {
        var _$24$1 = $as_T(_$24);
        return (($uI(_$24$1.length) >= 0) && ($as_T(_$24$1.substring(0, $uI(sys$2.length))) === sys$2))
      }))(this, sys)))
    };
    if ((x22 instanceof $c_s_Some)) {
      var sys$2$1 = $as_T($as_s_Some(x22).s_Some__f_value);
      var system$8$1 = new $c_s_Some(sys$2$1);
      var socket$8 = model.Lnet_timerboard_Model__f_socket;
      var logs$8$1 = model.Lnet_timerboard_Model__f_logs;
      var state$8 = model.Lnet_timerboard_Model__f_state;
      var now$8 = model.Lnet_timerboard_Model__f_now;
      var systemNames$8$1 = model.Lnet_timerboard_Model__f_systemNames;
      var distances$8$1 = model.Lnet_timerboard_Model__f_distances;
      var search$7$1 = model.Lnet_timerboard_Model__f_search;
      var searchTags$8$1 = model.Lnet_timerboard_Model__f_searchTags;
      var sortBy$8 = model.Lnet_timerboard_Model__f_sortBy;
      var sortDirection$8$1 = model.Lnet_timerboard_Model__f_sortDirection;
      var systems$8 = model.Lnet_timerboard_Model__f_systems;
      var _1$10 = new $c_Lnet_timerboard_Model(socket$8, logs$8$1, state$8, now$8, system$8$1, systemNames$8$1, distances$8$1, search$7$1, searchTags$8$1, sortBy$8, sortDirection$8$1, systems$8);
      var $$x4 = $m_sr_ScalaRunTime$();
      var msg$3 = $s_Lnet_timerboard_Msg$__CalculateDistances__Lnet_timerboard_Msg();
      var cmds$6 = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([new $c_Ltyrian_Cmd$Emit(msg$3), $m_Lnet_timerboard_InputEffects$().setContents__T__T__Ltyrian_Cmd("system-box", sys$2$1)]));
      $m_sci_List$();
      var cmds$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds$6);
      var _2$15 = new $c_Ltyrian_Cmd$Batch(cmds$7);
      return $ct_T2__O__O__(new $c_T2(), _1$10, _2$15)
    };
    var x$9 = $m_s_None$();
    if ((x$9 === x22)) {
      var _2$16 = $m_Ltyrian_Cmd$Empty$();
      return $ct_T2__O__O__(new $c_T2(), model, _2$16)
    };
    throw new $c_s_MatchError(x22)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$DeleteTag)) {
    var x$1$14 = $as_Lnet_timerboard_Msg$DeleteTag(msg);
    var x31 = x$1$14.Lnet_timerboard_Msg$DeleteTag__f_s;
    var this$70 = model.Lnet_timerboard_Model__f_searchTags;
    var f$1 = ((this$6$1, s$8) => ((_$25) => {
      var _$25$1 = $as_T(_$25);
      return (_$25$1 === s$8)
    }))(this, x31);
    var l = this$70;
    block: {
      var result;
      while (true) {
        if (l.isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h$1 = l.head__O();
          var t$2 = $as_sci_List(l.tail__O());
          if (($uZ(f$1(h$1)) === true)) {
            l = t$2;
            continue
          };
          var start = l;
          var remaining = t$2;
          while (true) {
            if (remaining.isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x$2 = remaining.head__O();
              if (($uZ(f$1(x$2)) !== true)) {
                remaining = $as_sci_List(remaining.tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List(start.tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
                currentLast.sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List(toProcess.tail__O())
              };
              var next = $as_sci_List(firstMiss.tail__O());
              var nextToCopy = next;
              while ((!next.isEmpty__Z())) {
                var head = next.head__O();
                if (($uZ(f$1(head)) !== true)) {
                  next = $as_sci_List(next.tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                    currentLast.sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List(nextToCopy.tail__O())
                  };
                  nextToCopy = $as_sci_List(next.tail__O());
                  next = $as_sci_List(next.tail__O())
                }
              };
              if ((!nextToCopy.isEmpty__Z())) {
                currentLast.sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var socket$9 = model.Lnet_timerboard_Model__f_socket;
    var logs$9 = model.Lnet_timerboard_Model__f_logs;
    var state$9 = model.Lnet_timerboard_Model__f_state;
    var now$9 = model.Lnet_timerboard_Model__f_now;
    var system$9 = model.Lnet_timerboard_Model__f_system;
    var systemNames$9 = model.Lnet_timerboard_Model__f_systemNames;
    var distances$9 = model.Lnet_timerboard_Model__f_distances;
    var search$8 = model.Lnet_timerboard_Model__f_search;
    var sortBy$9 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$9 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$9 = model.Lnet_timerboard_Model__f_systems;
    var m$4 = new $c_Lnet_timerboard_Model(socket$9, logs$9, state$9, now$9, system$9, systemNames$9, distances$9, search$8, result, sortBy$9, sortDirection$9, systems$9);
    var _2$17 = this.updateHash__Lnet_timerboard_Model__Ltyrian_Cmd(m$4);
    return $ct_T2__O__O__(new $c_T2(), m$4, _2$17)
  };
  var x$11 = $s_Lnet_timerboard_Msg$__CalculateDistances__Lnet_timerboard_Msg();
  if (((x$11 === null) ? (msg === null) : x$11.equals__O__Z(msg))) {
    var distances$10 = $m_sci_Map$EmptyMap$();
    var socket$10 = model.Lnet_timerboard_Model__f_socket;
    var logs$10 = model.Lnet_timerboard_Model__f_logs;
    var state$10 = model.Lnet_timerboard_Model__f_state;
    var now$10 = model.Lnet_timerboard_Model__f_now;
    var system$10 = model.Lnet_timerboard_Model__f_system;
    var systemNames$10 = model.Lnet_timerboard_Model__f_systemNames;
    var search$9 = model.Lnet_timerboard_Model__f_search;
    var searchTags$10 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$10 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$10 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$10 = model.Lnet_timerboard_Model__f_systems;
    var _1$11 = new $c_Lnet_timerboard_Model(socket$10, logs$10, state$10, now$10, system$10, systemNames$10, distances$10, search$9, searchTags$10, sortBy$10, sortDirection$10, systems$10);
    var $$x7 = $m_sr_ScalaRunTime$();
    var $$x6 = $m_Lnet_timerboard_Routefinder$();
    var this$73 = model.Lnet_timerboard_Model__f_system;
    if (this$73.isEmpty__Z()) {
      var $$x5 = $m_s_None$()
    } else {
      var arg1$4 = this$73.get__O();
      var key = $as_T(arg1$4);
      var $$x5 = model.Lnet_timerboard_Model__f_systemNames.get__O__s_Option(key)
    };
    var cmds$8 = $$x7.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$$x6.get__J__Ltyrian_Cmd($uJ($$x5.get__O())), $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Requesting route info"])))]));
    $m_sci_List$();
    var cmds$9 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds$8);
    var _2$18 = new $c_Ltyrian_Cmd$Batch(cmds$9);
    return $ct_T2__O__O__(new $c_T2(), _1$11, _2$18)
  };
  if ((msg instanceof $c_Lnet_timerboard_Msg$UpdateDistances)) {
    var x$1$15 = $as_Lnet_timerboard_Msg$UpdateDistances(msg);
    var x28 = x$1$15.Lnet_timerboard_Msg$UpdateDistances__f_distances;
    var socket$11 = model.Lnet_timerboard_Model__f_socket;
    var logs$11 = model.Lnet_timerboard_Model__f_logs;
    var state$11 = model.Lnet_timerboard_Model__f_state;
    var now$11 = model.Lnet_timerboard_Model__f_now;
    var system$11 = model.Lnet_timerboard_Model__f_system;
    var systemNames$11 = model.Lnet_timerboard_Model__f_systemNames;
    var search$10 = model.Lnet_timerboard_Model__f_search;
    var searchTags$9 = model.Lnet_timerboard_Model__f_searchTags;
    var sortBy$11 = model.Lnet_timerboard_Model__f_sortBy;
    var sortDirection$11 = model.Lnet_timerboard_Model__f_sortDirection;
    var systems$11 = model.Lnet_timerboard_Model__f_systems;
    var _1$12 = new $c_Lnet_timerboard_Model(socket$11, logs$11, state$11, now$11, system$11, systemNames$11, x28, search$10, searchTags$9, sortBy$11, sortDirection$11, systems$11);
    var _2$19 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Distances recalculated"])));
    return $ct_T2__O__O__(new $c_T2(), _1$12, _2$19)
  };
  var x$13 = $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg();
  if (((x$13 === null) ? (msg === null) : x$13.equals__O__Z(msg))) {
    var _2$20 = $m_Ltyrian_Cmd$Empty$();
    return $ct_T2__O__O__(new $c_T2(), model, _2$20)
  };
  throw new $c_s_MatchError(msg)
});
$c_Lnet_timerboard_Timerboard$.prototype.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html = (function(model, field, name) {
  $m_Ltyrian_Html$();
  var $$x1 = $m_sr_ScalaRunTime$();
  var this$2 = $m_Ltyrian_Html$();
  var msg = new $c_Lnet_timerboard_Msg$SortBy(field);
  var attributes$1 = $$x1.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr(this$2, msg)]));
  var $$x4 = $m_sr_ScalaRunTime$();
  var this$3 = $m_Ltyrian_Html$();
  var $$x3 = $f_Ltyrian_HtmlTags__span$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$3, name);
  var x$2 = model.Lnet_timerboard_Model__f_sortBy;
  if ((field === x$2)) {
    var $$x2 = model.Lnet_timerboard_Model__f_sortDirection.icon__Ltyrian_Html()
  } else {
    $m_Ltyrian_Html$();
    var children = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
    var attributes = $m_s_package$().s_package$__f_Nil;
    $m_sci_List$();
    var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children);
    var $$x2 = new $c_Ltyrian_Tag("span", attributes, children$1)
  };
  var children$2 = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x3, $$x2]));
  $m_sci_List$();
  var attributes$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$1);
  $m_sci_List$();
  var children$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$2);
  return new $c_Ltyrian_Tag("th", attributes$2, children$3)
});
$c_Lnet_timerboard_Timerboard$.prototype.sortByField__sci_List__Lnet_timerboard_Field__Lnet_timerboard_Direction__sci_List = (function(res, f, d) {
  var x = $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction();
  if ((x === d)) {
    return this.sortByField__sci_List__Lnet_timerboard_Field__sci_List(res, f)
  };
  var x$3 = $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction();
  if ((x$3 === d)) {
    return this.sortByField__sci_List__Lnet_timerboard_Field__sci_List(res, f).reverse__sci_List()
  };
  throw new $c_s_MatchError(d)
});
$c_Lnet_timerboard_Timerboard$.prototype.sortByField__sci_List__Lnet_timerboard_Field__sci_List = (function(res, f) {
  var x = $s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field();
  if ((x === f)) {
    var f$1 = new $c_sjsr_AnonFunction1(((this$1) => ((_$26) => {
      var _$26$1 = $as_Lnet_timerboard_RenderEvent(_$26);
      return _$26$1.Lnet_timerboard_RenderEvent__f_time
    }))(this));
    var this$4 = $m_s_math_Ordering$();
    var this$3 = $m_s_$less$colon$less$();
    var asComparable = this$3.s_$less$colon$less$__f_singleton;
    var ord = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$4, asComparable);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$1, ord))
  };
  var x$3 = $s_Lnet_timerboard_Field$__Type__Lnet_timerboard_Field();
  if ((x$3 === f)) {
    var f$2 = new $c_sjsr_AnonFunction1(((this$2$1) => ((_$27) => {
      var _$27$1 = $as_Lnet_timerboard_RenderEvent(_$27);
      return _$27$1.Lnet_timerboard_RenderEvent__f_event_type.toString__T()
    }))(this));
    $m_Lcats_implicits$();
    var ev = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString);
    var ord$1 = new $c_Lcats_kernel_Order$$anon$1(ev);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$2, ord$1))
  };
  var x$5 = $s_Lnet_timerboard_Field$__System__Lnet_timerboard_Field();
  if ((x$5 === f)) {
    var f$3 = new $c_sjsr_AnonFunction1(((this$3$1) => ((_$28) => {
      var _$28$1 = $as_Lnet_timerboard_RenderEvent(_$28);
      return _$28$1.Lnet_timerboard_RenderEvent__f_system
    }))(this));
    $m_Lcats_implicits$();
    var ev$1 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString);
    var ord$2 = new $c_Lcats_kernel_Order$$anon$1(ev$1);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$3, ord$2))
  };
  var x$7 = $s_Lnet_timerboard_Field$__Region__Lnet_timerboard_Field();
  if ((x$7 === f)) {
    var f$4 = new $c_sjsr_AnonFunction1(((this$4$1) => ((_$29) => {
      var _$29$1 = $as_Lnet_timerboard_RenderEvent(_$29);
      return _$29$1.Lnet_timerboard_RenderEvent__f_region
    }))(this));
    $m_Lcats_implicits$();
    var ev$2 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString);
    var ord$3 = new $c_Lcats_kernel_Order$$anon$1(ev$2);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$4, ord$3))
  };
  var x$9 = $s_Lnet_timerboard_Field$__Owner__Lnet_timerboard_Field();
  if ((x$9 === f)) {
    var f$5 = new $c_sjsr_AnonFunction1(((this$5$1) => ((_$30) => {
      var _$30$1 = $as_Lnet_timerboard_RenderEvent(_$30);
      return _$30$1.Lnet_timerboard_RenderEvent__f_owner
    }))(this));
    $m_Lcats_implicits$();
    var ev$3 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString);
    var ord$4 = new $c_Lcats_kernel_Order$$anon$1(ev$3);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$5, ord$4))
  };
  var x$11 = $s_Lnet_timerboard_Field$__DefenderScore__Lnet_timerboard_Field();
  if ((x$11 === f)) {
    var f$6 = new $c_sjsr_AnonFunction1(((this$6$1) => ((_$31) => {
      var _$31$1 = $as_Lnet_timerboard_RenderEvent(_$31);
      return _$31$1.Lnet_timerboard_RenderEvent__f_defender_score
    }))(this));
    $m_Lcats_implicits$();
    var ev$4 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForBigDecimal);
    var ord$5 = new $c_Lcats_kernel_Order$$anon$1(ev$4);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$6, ord$5))
  };
  var x$13 = $s_Lnet_timerboard_Field$__Distance__Lnet_timerboard_Field();
  if ((x$13 === f)) {
    var f$7 = new $c_sjsr_AnonFunction1(((this$7$1) => ((_$32) => {
      var _$32$1 = $as_Lnet_timerboard_RenderEvent(_$32);
      return _$32$1.Lnet_timerboard_RenderEvent__f_distance
    }))(this));
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var evidence$1 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForInt);
    var ev$5 = new $c_Lcats_kernel_instances_OptionOrder(evidence$1);
    var ord$6 = new $c_Lcats_kernel_Order$$anon$1(ev$5);
    return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(res, f$7, ord$6))
  };
  throw new $c_s_MatchError(f)
});
$c_Lnet_timerboard_Timerboard$.prototype.searchTag__T__Ltyrian_Html = (function(s) {
  $m_Ltyrian_Html$();
  var attributes$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("badge badge-outline gap-2")]));
  var $$x4 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var $$x2 = $m_sr_ScalaRunTime$();
  var $$x1 = $m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("fa-solid fa-xmark");
  var this$2 = $m_Ltyrian_Html$();
  var msg = new $c_Lnet_timerboard_Msg$DeleteTag(s);
  var attributes = $$x2.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x1, $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr(this$2, msg)]));
  var children = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
  $m_sci_List$();
  var attributes$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes);
  $m_sci_List$();
  var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children);
  var $$x3 = new $c_Ltyrian_Tag("i", attributes$1, children$1);
  var this$7 = $m_Ltyrian_Html$();
  var children$2 = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x3, $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$7, s)]));
  $m_sci_List$();
  var attributes$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$2);
  $m_sci_List$();
  var children$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$2);
  return new $c_Ltyrian_Tag("div", attributes$3, children$3)
});
$c_Lnet_timerboard_Timerboard$.prototype.systemInputBoxClasses__Lnet_timerboard_Model__sci_List = (function(m) {
  var this$1 = m.Lnet_timerboard_Model__f_system;
  if (this$1.isEmpty__Z()) {
    var this$4 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_T(arg1);
    if (m.Lnet_timerboard_Model__f_systemNames.contains__O__Z(x$1)) {
      $m_s_package$();
      var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["input-success"]));
      var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
    } else {
      $m_s_package$();
      var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["input-error"]));
      var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
    };
    var this$4 = new $c_s_Some($$x1)
  };
  var this$7 = $as_sc_IterableOps((this$4.isEmpty__Z() ? ($m_s_package$(), $m_sci_Nil$()) : this$4.get__O()));
  $m_s_package$();
  var elems$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["input", "input-bordered", "max-w-s"]));
  var suffix = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  return $as_sci_List(this$7.concat__sc_IterableOnce__O(suffix))
});
$c_Lnet_timerboard_Timerboard$.prototype.systemsDatalist__sci_List__Ltyrian_Html = (function(systems) {
  $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("systems")]));
  var f = ((this$1) => ((system) => {
    var system$1 = $as_T(system);
    var this$2 = $m_Ltyrian_Html$();
    return $f_Ltyrian_HtmlTags__option$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$2, system$1)
  }))(this);
  if ((systems === $m_sci_Nil$())) {
    var children = $m_sci_Nil$()
  } else {
    var arg1 = systems.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(systems.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var children = h
  };
  $m_sci_List$();
  var attributes$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes);
  return new $c_Ltyrian_Tag("datalist", attributes$1, children)
});
$c_Lnet_timerboard_Timerboard$.prototype.view__Lnet_timerboard_Model__Ltyrian_Html = (function(model) {
  $m_Ltyrian_Html$();
  var attributes$25 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("overflow-x-auto")]));
  var $$x39 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$11 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("form-control")]));
  var $$x37 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$9 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("input-group")]));
  var $$x36 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("text-5xl font-bold font-sans")]));
  var $$x34 = $m_sr_ScalaRunTime$();
  var this$1 = $m_Ltyrian_Html$();
  var $$x33 = $f_Ltyrian_HtmlTags__span$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$1, " ");
  $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("fa-solid fa-calendar-days")]));
  var children = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
  $m_sci_List$();
  var attributes$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes);
  $m_sci_List$();
  var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children);
  var $$x32 = new $c_Ltyrian_Tag("i", attributes$1, children$1);
  var this$6 = $m_Ltyrian_Html$();
  var children$2 = $$x34.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x33, $$x32, $f_Ltyrian_HtmlTags__span$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$6, " ")]));
  $m_sci_List$();
  var attributes$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$2);
  $m_sci_List$();
  var children$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$2);
  var $$x35 = new $c_Ltyrian_Tag("h1", attributes$3, children$3);
  $m_Ltyrian_Html$();
  var this$12 = model.Lnet_timerboard_Model__f_searchTags.reverse__sci_List();
  var f = ((this$11) => ((s) => {
    var s$1 = $as_T(s);
    return this$11.searchTag__T__Ltyrian_Html(s$1)
  }))(this);
  if ((this$12 === $m_sci_Nil$())) {
    var children$4 = $m_sci_Nil$()
  } else {
    var arg1 = this$12.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$12.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var children$4 = h
  };
  var attributes$4 = $m_s_package$().s_package$__f_Nil;
  var $$x31 = new $c_Ltyrian_Tag("span", attributes$4, children$4);
  $m_Ltyrian_Html$();
  var attributes$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("search-box"), $m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060type$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("text"), $m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("input w-full"), $m_Ltyrian_Html$().Ltyrian_Html$__f_placeholder$minusString.$colon$eq__T__Ltyrian_Attribute("Type here to filter, hit enter to multi-filter"), $m_Ltyrian_Html$().onInput__F1__Ltyrian_Attr(new $c_sjsr_AnonFunction1(((this$2$1) => ((_$33) => {
    var _$33$1 = $as_T(_$33);
    return new $c_Lnet_timerboard_Msg$Search(_$33$1)
  }))(this))), this.Lnet_timerboard_Timerboard$__f_inputKeyConfig]));
  $m_sci_List$();
  var attributes$6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$5);
  var children$5 = $m_s_package$().s_package$__f_Nil;
  var $$x30 = new $c_Ltyrian_Tag("input", attributes$6, children$5);
  $m_Ltyrian_Html$();
  var $$x28 = $m_sr_ScalaRunTime$();
  var $$x27 = $m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("system-box");
  var $$x26 = $m_Ltyrian_Html$().Ltyrian_Html$__f_list$minusString.$colon$eq__T__Ltyrian_Attribute("systems");
  var $$x25 = $m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060type$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("text");
  var $$x24 = $m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString;
  var this$19 = this.systemInputBoxClasses__Lnet_timerboard_Model__sci_List(model);
  var attributes$7 = $$x28.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x27, $$x26, $$x25, $$x24.$colon$eq__T__Ltyrian_Attribute($f_sc_IterableOnceOps__mkString__T__T__T__T(this$19, "", " ", "")), $m_Ltyrian_Html$().Ltyrian_Html$__f_placeholder$minusString.$colon$eq__T__Ltyrian_Attribute("Solar System"), $m_Ltyrian_Html$().onInput__F1__Ltyrian_Attr(new $c_sjsr_AnonFunction1(((this$3$1) => ((_$34) => {
    var _$34$1 = $as_T(_$34);
    return new $c_Lnet_timerboard_Msg$System(_$34$1)
  }))(this)))]));
  $m_sci_List$();
  var attributes$8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$7);
  var children$6 = $m_s_package$().s_package$__f_Nil;
  var $$x29 = new $c_Ltyrian_Tag("input", attributes$8, children$6);
  var this$24 = model.Lnet_timerboard_Model__f_systems;
  var this$25 = this$24.keySet__sc_Set();
  $m_sci_List$();
  var children$7 = $$x36.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x35, $$x31, $$x30, $$x29, this.systemsDatalist__sci_List__Ltyrian_Html($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$25))]));
  $m_sci_List$();
  var attributes$10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$9);
  $m_sci_List$();
  var children$8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$7);
  var children$9 = $$x37.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Tag("label", attributes$10, children$8)]));
  $m_sci_List$();
  var attributes$12 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$11);
  $m_sci_List$();
  var children$10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$9);
  var $$x38 = new $c_Ltyrian_Tag("div", attributes$12, children$10);
  $m_Ltyrian_Html$();
  var attributes$23 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("table table-zebra table-compact w-full")]));
  var $$x23 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var $$x21 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Html.getArrayOf().constr)([this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Type__Lnet_timerboard_Field(), "Type"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__System__Lnet_timerboard_Field(), "System"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Region__Lnet_timerboard_Field(), "Region"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Owner__Lnet_timerboard_Field(), "Owner"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field(), "Time"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field(), "Remaining"), this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__DefenderScore__Lnet_timerboard_Field(), "Defender Score")]));
  var this$39 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$36 = model.Lnet_timerboard_Model__f_system;
  if ((!this$36.isEmpty__Z())) {
    var arg1$2 = this$36.get__O();
    var key = $as_T(arg1$2);
    var $$x20 = model.Lnet_timerboard_Model__f_systemNames.contains__O__Z(key)
  } else {
    var $$x20 = false
  };
  if ($$x20) {
    $m_s_package$();
    var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Html.getArrayOf().constr)([this.header__Lnet_timerboard_Model__Lnet_timerboard_Field__T__Ltyrian_Html(model, $s_Lnet_timerboard_Field$__Distance__Lnet_timerboard_Field(), "Distance (in gates)")]));
    var suffix = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
  } else {
    $m_s_package$();
    var suffix = $m_sci_Nil$()
  };
  var children$11 = this$39.appendedAll__sc_IterableOnce__sci_List(suffix);
  var attributes$13 = $m_s_package$().s_package$__f_Nil;
  var children$12 = $$x21.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Tag("tr", attributes$13, children$11)]));
  var attributes$14 = $m_s_package$().s_package$__f_Nil;
  $m_sci_List$();
  var children$13 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$12);
  var $$x22 = new $c_Ltyrian_Tag("thead", attributes$14, children$13);
  $m_Ltyrian_Html$();
  var this$46 = model.Lnet_timerboard_Model__f_state;
  var f$1 = ((this$5$1, model$3) => ((_$35) => {
    var _$35$1 = $as_Lnet_timerboard_Event(_$35);
    var $$x4 = model$3.Lnet_timerboard_Model__f_now;
    var $$x3 = model$3.Lnet_timerboard_Model__f_systems;
    var $$x2 = model$3.Lnet_timerboard_Model__f_distances;
    var this$45 = model$3.Lnet_timerboard_Model__f_system;
    if (this$45.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1$3 = this$45.get__O();
      var key$1 = $as_T(arg1$3);
      var $$x1 = model$3.Lnet_timerboard_Model__f_systemNames.get__O__s_Option(key$1)
    };
    return _$35$1.compact__Ljava_time_ZonedDateTime__sci_Map__sci_Map__s_Option__Lnet_timerboard_RenderEvent($$x4, $$x3, $$x2, $$x1)
  }))(this, model);
  if ((this$46 === $m_sci_Nil$())) {
    var this$49 = $m_sci_Nil$()
  } else {
    var arg1$4 = this$46.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$46.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$5 = rest$1.head__O();
      var nx$1 = new $c_sci_$colon$colon(f$1(arg1$5), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List(rest$1.tail__O())
    };
    var this$49 = h$1
  };
  var f$2 = ((this$6$1, model$4) => ((e) => {
    var e$1 = $as_Lnet_timerboard_RenderEvent(e);
    var this$47 = model$4.Lnet_timerboard_Model__f_searchTags;
    var elem = model$4.Lnet_timerboard_Model__f_search;
    var this$48 = new $c_sci_$colon$colon(elem, this$47);
    var these = this$48;
    while ((!these.isEmpty__Z())) {
      var arg1$6 = these.head__O();
      var s$2 = $as_T(arg1$6);
      if ((!e$1.matches__T__Z(s$2))) {
        return false
      };
      these = $as_sci_List(these.tail__O())
    };
    return true
  }))(this, model);
  var l = this$49;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h$2 = l.head__O();
        var t$2 = $as_sci_List(l.tail__O());
        if (($uZ(f$2(h$2)) === false)) {
          l = t$2;
          continue
        };
        var start = l;
        var remaining = t$2;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = remaining.head__O();
            if (($uZ(f$2(x)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f$2(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  var this$82 = this.sortByField__sci_List__Lnet_timerboard_Field__Lnet_timerboard_Direction__sci_List(result, model.Lnet_timerboard_Model__f_sortBy, model.Lnet_timerboard_Model__f_sortDirection);
  var f$3 = ((this$7$1, model$5) => ((e$2) => {
    var e$3 = $as_Lnet_timerboard_RenderEvent(e$2);
    $m_Ltyrian_Html$();
    var $$x6 = $m_sr_ScalaRunTime$();
    var $$x5 = $m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString;
    var this$50 = e$3.Lnet_timerboard_RenderEvent__f_id;
    var attributes$20 = $$x6.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x5.$colon$eq__T__Ltyrian_Attribute($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$50.RTLong__f_lo, this$50.RTLong__f_hi))]));
    $m_s_package$();
    var $$x15 = $m_sr_ScalaRunTime$();
    var this$51 = $m_Ltyrian_Html$();
    var plainText = e$3.Lnet_timerboard_RenderEvent__f_event_type.toString__T();
    var $$x14 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$51, plainText);
    $m_Ltyrian_Html$();
    var $$x12 = $m_sr_ScalaRunTime$();
    var this$52 = $m_Ltyrian_Html$();
    var attributes$15 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_href$minusString.$colon$eq__T__Ltyrian_Attribute(("http://evemaps.dotlan.net/search?q=" + e$3.Lnet_timerboard_RenderEvent__f_system))]));
    var plainText$1 = e$3.Lnet_timerboard_RenderEvent__f_system;
    var children$14 = $$x12.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$f_Ltyrian_HtmlTags__a$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$52, attributes$15, plainText$1)]));
    var attributes$16 = $m_s_package$().s_package$__f_Nil;
    $m_sci_List$();
    var children$15 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$14);
    var $$x13 = new $c_Ltyrian_Tag("td", attributes$16, children$15);
    var this$56 = $m_Ltyrian_Html$();
    var plainText$2 = e$3.Lnet_timerboard_RenderEvent__f_region;
    var $$x11 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$56, plainText$2);
    var this$57 = $m_Ltyrian_Html$();
    var plainText$3 = e$3.Lnet_timerboard_RenderEvent__f_owner;
    var $$x10 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$57, plainText$3);
    var this$58 = $m_Ltyrian_Html$();
    var plainText$4 = e$3.Lnet_timerboard_RenderEvent__f_time.toString__T();
    var $$x9 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$58, plainText$4);
    var this$59 = $m_Ltyrian_Html$();
    var plainText$5 = e$3.Lnet_timerboard_RenderEvent__f_remaining;
    var $$x8 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$59, plainText$5);
    var this$61 = $m_Ltyrian_Html$();
    var $$x7 = e$3.Lnet_timerboard_RenderEvent__f_defender_score;
    var this$60 = $m_s_math_BigDecimal$();
    var plainText$6 = ($$x7.$times__s_math_BigDecimal__s_math_BigDecimal(this$60.apply__I__Ljava_math_MathContext__s_math_BigDecimal(100, this$60.s_math_BigDecimal$__f_defaultMathContext)) + "%");
    var elems$2 = $$x15.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Html.getArrayOf().constr)([$$x14, $$x13, $$x11, $$x10, $$x9, $$x8, $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$61, plainText$6)]));
    var this$78 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
    var this$63 = model$5.Lnet_timerboard_Model__f_system;
    if ((!this$63.isEmpty__Z())) {
      var arg1$7 = this$63.get__O();
      var key$2 = $as_T(arg1$7);
      var $$x16 = model$5.Lnet_timerboard_Model__f_systemNames.contains__O__Z(key$2)
    } else {
      var $$x16 = false
    };
    if ($$x16) {
      $m_s_package$();
      var $$x19 = $m_sr_ScalaRunTime$();
      $m_Ltyrian_Html$();
      var $$x18 = $m_sr_ScalaRunTime$();
      var this$64 = e$3.Lnet_timerboard_RenderEvent__f_distance;
      if (this$64.isEmpty__Z()) {
        var this$66 = $m_s_None$()
      } else {
        var arg1$8 = this$64.get__O();
        var _$36 = $uI(arg1$8);
        var this$66 = new $c_s_Some(("" + _$36))
      };
      if (this$66.isEmpty__Z()) {
        var this$68 = $m_s_None$()
      } else {
        var arg1$9 = this$66.get__O();
        var plainText$7 = $as_T(arg1$9);
        var this$67 = $m_Ltyrian_Html$();
        var this$68 = new $c_s_Some($f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$67, plainText$7))
      };
      if (this$68.isEmpty__Z()) {
        $m_Ltyrian_Html$();
        var attributes$17 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("fa-solid fa-spinner")]));
        var children$16 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
        $m_sci_List$();
        var attributes$18 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$17);
        $m_sci_List$();
        var children$17 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$16);
        var $$x17 = new $c_Ltyrian_Tag("i", attributes$18, children$17)
      } else {
        var $$x17 = this$68.get__O()
      };
      var children$18 = $$x18.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$as_Ltyrian_Elem($$x17)]));
      var attributes$19 = $m_s_package$().s_package$__f_Nil;
      $m_sci_List$();
      var children$19 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$18);
      var elems$3 = $$x19.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Html.getArrayOf().constr)([new $c_Ltyrian_Tag("td", attributes$19, children$19)]));
      var suffix$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3)
    } else {
      $m_s_package$();
      var suffix$1 = $m_sci_Nil$()
    };
    var children$20 = this$78.appendedAll__sc_IterableOnce__sci_List(suffix$1);
    $m_sci_List$();
    var attributes$21 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$20);
    return new $c_Ltyrian_Tag("tr", attributes$21, children$20)
  }))(this, model);
  if ((this$82 === $m_sci_Nil$())) {
    var children$21 = $m_sci_Nil$()
  } else {
    var arg1$10 = this$82.head__O();
    var h$3 = new $c_sci_$colon$colon(f$3(arg1$10), $m_sci_Nil$());
    var t$3 = h$3;
    var rest$2 = $as_sci_List(this$82.tail__O());
    while ((rest$2 !== $m_sci_Nil$())) {
      var arg1$11 = rest$2.head__O();
      var nx$2 = new $c_sci_$colon$colon(f$3(arg1$11), $m_sci_Nil$());
      t$3.sci_$colon$colon__f_next = nx$2;
      t$3 = nx$2;
      rest$2 = $as_sci_List(rest$2.tail__O())
    };
    var children$21 = h$3
  };
  var attributes$22 = $m_s_package$().s_package$__f_Nil;
  var children$22 = $$x23.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x22, new $c_Ltyrian_Tag("tbody", attributes$22, children$21)]));
  $m_sci_List$();
  var attributes$24 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$23);
  $m_sci_List$();
  var children$23 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$22);
  var children$24 = $$x39.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x38, new $c_Ltyrian_Tag("table", attributes$24, children$23)]));
  $m_sci_List$();
  var attributes$26 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$25);
  $m_sci_List$();
  var children$25 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$24);
  return new $c_Ltyrian_Tag("div", attributes$26, children$25)
});
$c_Lnet_timerboard_Timerboard$.prototype.toZDT__sjs_js_Date__Ljava_time_ZonedDateTime = (function(d) {
  var this$1 = $m_RTLong$();
  var value = $uD(d.getTime());
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$2 = $m_Ljava_time_Instant$().ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var zone = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
  return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(this$2, zone)
});
$c_Lnet_timerboard_Timerboard$.prototype.subscriptions__Lnet_timerboard_Model__Ltyrian_Sub = (function(model) {
  var $$x4 = $m_sr_ScalaRunTime$();
  var $$x2 = model.Lnet_timerboard_Model__f_socket.subscribe__F1__Ltyrian_Sub(new $c_sjsr_AnonFunction1(((this$1) => ((x$1) => {
    var x$1$1 = $as_Ltyrian_websocket_WebSocketEvent(x$1);
    if ((x$1$1 instanceof $c_Ltyrian_websocket_WebSocketEvent$Error)) {
      var x$1$2 = $as_Ltyrian_websocket_WebSocketEvent$Error(x$1$1);
      var x82 = x$1$2.Ltyrian_websocket_WebSocketEvent$Error__f_error;
      return new $c_Lnet_timerboard_Msg$Other(x82)
    };
    if ((x$1$1 instanceof $c_Ltyrian_websocket_WebSocketEvent$Receive)) {
      var x$1$3 = $as_Ltyrian_websocket_WebSocketEvent$Receive(x$1$1);
      var x79 = x$1$3.Ltyrian_websocket_WebSocketEvent$Receive__f_message;
      var this$5 = $m_Lio_circe_parser_package$().parse__T__s_util_Either(x79);
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$5);
        var b = x2.s_util_Right__f_value;
        var j = $as_Lio_circe_Json(b);
        var d = $m_Lnet_timerboard_WebsocketEvent$().given_Decoder_WebsocketEvent__Lio_circe_Decoder();
        var this$7 = d.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(j, null, null))
      } else {
        var this$7 = this$5
      };
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$7);
        var b$1 = x2$1.s_util_Right__f_value;
        var _$38 = $as_Lnet_timerboard_WebsocketEvent(b$1);
        var $$x3 = new $c_Lnet_timerboard_Msg$Payload(_$38)
      } else {
        if ((!(this$7 instanceof $c_s_util_Left))) {
          throw new $c_s_MatchError(this$7)
        };
        var x3 = $as_s_util_Left(this$7);
        var a = x3.s_util_Left__f_value;
        var _$37 = $as_Lio_circe_Error(a);
        var $$x3 = new $c_Lnet_timerboard_Msg$BadPayload(_$37)
      };
      return $as_Lnet_timerboard_Msg($$x3)
    };
    var x = $s_Ltyrian_websocket_WebSocketEvent$__Open__Ltyrian_websocket_WebSocketEvent();
    if (((x === null) ? (x$1$1 === null) : x.equals__O__Z(x$1$1))) {
      return new $c_Lnet_timerboard_Msg$Other("opened socket")
    };
    if ((x$1$1 instanceof $c_Ltyrian_websocket_WebSocketEvent$Close)) {
      var x$1$4 = $as_Ltyrian_websocket_WebSocketEvent$Close(x$1$1);
      var x75 = x$1$4.Ltyrian_websocket_WebSocketEvent$Close__f_code;
      var x76 = x$1$4.Ltyrian_websocket_WebSocketEvent$Close__f_reason;
      var s = ((("close: " + x75) + ", ") + x76);
      return new $c_Lnet_timerboard_Msg$Other(s)
    };
    var x$3 = $s_Ltyrian_websocket_WebSocketEvent$__Heartbeat__Ltyrian_websocket_WebSocketEvent();
    if (((x$3 === null) ? (x$1$1 === null) : x$3.equals__O__Z(x$1$1))) {
      return new $c_Lnet_timerboard_Msg$Other("tick")
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this)));
  var $$x1 = $m_Ltyrian_Sub$();
  var this$15 = new $c_s_concurrent_duration_package$DurationInt(1);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$15.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var subs = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([$$x2, $$x1.every__s_concurrent_duration_FiniteDuration__T__Ltyrian_Sub(new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit), "tick").map__F1__Ltyrian_Sub(new $c_sjsr_AnonFunction1(((this$2$1) => ((d$1) => {
    var now = this$2$1.toZDT__sjs_js_Date__Ljava_time_ZonedDateTime(d$1);
    return new $c_Lnet_timerboard_Msg$Tick(now)
  }))(this)))]));
  $m_sci_List$();
  var subs$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(subs);
  return new $c_Ltyrian_Sub$Batch(subs$1)
});
$c_Lnet_timerboard_Timerboard$.prototype.launch = (function(arg, ...rest) {
  switch ($uI(rest.length)) {
    case 0: {
      var prep0 = $as_T(arg);
      return this.$js$exported$meth$launch__T__O(prep0);
      break
    }
    case 1: {
      var prep0$2 = $as_T(arg);
      var prep1 = rest[0];
      return this.$js$exported$meth$launch__T__sjs_js_Dictionary__O(prep0$2, prep1);
      break
    }
    default: {
      throw new TypeError("No matching overload")
    }
  }
});
var $d_Lnet_timerboard_Timerboard$ = new $TypeData().initClass({
  Lnet_timerboard_Timerboard$: 0
}, false, "net.timerboard.Timerboard$", {
  Lnet_timerboard_Timerboard$: 1,
  O: 1,
  Ltyrian_TyrianApp: 1
});
$c_Lnet_timerboard_Timerboard$.prototype.$classData = $d_Lnet_timerboard_Timerboard$;
var $n_Lnet_timerboard_Timerboard$;
function $m_Lnet_timerboard_Timerboard$() {
  if ((!$n_Lnet_timerboard_Timerboard$)) {
    $n_Lnet_timerboard_Timerboard$ = new $c_Lnet_timerboard_Timerboard$()
  };
  return $n_Lnet_timerboard_Timerboard$
}
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1()
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
  /*<skip>*/
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass({
  s_$less$colon$less$: 0
}, false, "scala.$less$colon$less$", {
  s_$less$colon$less$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$.prototype.$classData = $d_s_$less$colon$less$;
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$()
  };
  return $n_s_$less$colon$less$
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0)
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result
}
/** @constructor */
function $c_s_Array$() {
  /*<skip>*/
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
  /*<skip>*/
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = it.knownSize__I();
  if ((n > (-1))) {
    var elements = evidence$3.newArray__I__O(n);
    var iterator = it.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, iterator.next__O());
      i = ((1 + i) | 0)
    };
    return elements
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$3.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = it.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if ((srcClass.isArray__Z() && $objectGetClass(dest).isAssignableFrom__jl_Class__Z(srcClass))) {
    src.copyTo(srcPos, dest, destPos, length)
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length)
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else if ((original instanceof $ac_O)) {
    var x3 = $asArrayOf_O(original, 1);
    return $m_ju_Arrays$().copyOf__AO__I__AO(x3, newLength)
  } else if ((original instanceof $ac_I)) {
    var x4 = $asArrayOf_I(original, 1);
    return $m_ju_Arrays$().copyOf__AI__I__AI(x4, newLength)
  } else if ((original instanceof $ac_D)) {
    var x5 = $asArrayOf_D(original, 1);
    return $m_ju_Arrays$().copyOf__AD__I__AD(x5, newLength)
  } else if ((original instanceof $ac_J)) {
    var x6 = $asArrayOf_J(original, 1);
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(x6, newLength)
  } else if ((original instanceof $ac_F)) {
    var x7 = $asArrayOf_F(original, 1);
    return $m_ju_Arrays$().copyOf__AF__I__AF(x7, newLength)
  } else if ((original instanceof $ac_C)) {
    var x8 = $asArrayOf_C(original, 1);
    return $m_ju_Arrays$().copyOf__AC__I__AC(x8, newLength)
  } else if ((original instanceof $ac_B)) {
    var x9 = $asArrayOf_B(original, 1);
    return $m_ju_Arrays$().copyOf__AB__I__AB(x9, newLength)
  } else if ((original instanceof $ac_S)) {
    var x10 = $asArrayOf_S(original, 1);
    return $m_ju_Arrays$().copyOf__AS__I__AS(x10, newLength)
  } else if ((original instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(original, 1);
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(x11, newLength)
  } else {
    throw new $c_s_MatchError(original)
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = ct.runtimeClass__jl_Class();
  if (((runtimeClass !== null) && (runtimeClass === $d_V.getClassOf()))) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else if (runtimeClass.isAssignableFrom__jl_Class__Z($objectGetClass(original).getComponentType__jl_Class())) {
    if (runtimeClass.isPrimitive__Z()) {
      return this.copyOf__O__I__O(original, newLength)
    } else {
      var this$1 = $m_jl_reflect_Array$().newInstance__jl_Class__I__O(runtimeClass, 0);
      var destArrayClass = $objectGetClass(this$1);
      var original$1 = $asArrayOf_O(original, 1);
      return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, destArrayClass)
    }
  } else {
    var dest = ct.newArray__I__O(newLength);
    $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(original));
    return dest
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true
  };
  if ((xs.u.length !== ys.u.length)) {
    return false
  };
  var len = xs.u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(xs.get(i), ys.get(i)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_s_Array$ = new $TypeData().initClass({
  s_Array$: 0
}, false, "scala.Array$", {
  s_Array$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Array$.prototype.$classData = $d_s_Array$;
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$()
  };
  return $n_s_Array$
}
/** @constructor */
function $c_s_Console$() {
  this.s_Console$__f_outVar = null;
  this.s_Console$__f_errVar = null;
  this.s_Console$__f_inVar = null;
  $n_s_Console$ = this;
  this.s_Console$__f_outVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_out);
  this.s_Console$__f_errVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_err);
  this.s_Console$__f_inVar = new $c_s_util_DynamicVariable(null)
}
$c_s_Console$.prototype = new $h_O();
$c_s_Console$.prototype.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
  /*<skip>*/
}
$h_s_Console$.prototype = $c_s_Console$.prototype;
$c_s_Console$.prototype.out__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream(this.s_Console$__f_outVar.s_util_DynamicVariable__f_v)
});
var $d_s_Console$ = new $TypeData().initClass({
  s_Console$: 0
}, false, "scala.Console$", {
  s_Console$: 1,
  O: 1,
  s_io_AnsiColor: 1
});
$c_s_Console$.prototype.$classData = $d_s_Console$;
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$()
  };
  return $n_s_Console$
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null
  } else if ((xs.u.length === 0)) {
    var this$3 = $m_scm_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return this$3.scm_ArraySeq$__f_EmptyArraySeq
  } else {
    return new $c_scm_ArraySeq$ofRef(xs)
  }
});
/** @constructor */
function $c_s_Option$() {
  /*<skip>*/
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
  /*<skip>*/
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x))
});
var $d_s_Option$ = new $TypeData().initClass({
  s_Option$: 0
}, false, "scala.Option$", {
  s_Option$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Option$.prototype.$classData = $d_s_Option$;
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$()
  };
  return $n_s_Option$
}
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  if ($is_s_PartialFunction(k)) {
    var x2 = $as_s_PartialFunction(k);
    return new $c_s_PartialFunction$Combined($thiz, x2)
  } else {
    return new $c_s_PartialFunction$AndThen($thiz, k)
  }
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : default$1.apply__O__O(x))
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)))
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"))
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)))
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth))
}
function $p_s_StringContext$__readUEscape__T__I__T2($thiz, src, startindex) {
  var len = $uI(src.length);
  return $p_s_StringContext$__loop$1__I__I__I__T__T2($thiz, startindex, startindex, len, src)
}
function $p_s_StringContext$__replace__T__I__T($thiz, str, first) {
  var len = $uI(str.length);
  var b = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  return $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T($thiz, 0, first, b, str, len)
}
function $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2($thiz, dindex, codepoint, uindex$1, startindex$1, len$1, src$1) {
  while (true) {
    if ((dindex >= 4)) {
      var usRead = ((uindex$1 - startindex$1) | 0);
      var digitsRead = dindex;
      return new $c_T2$mcCI$sp((65535 & codepoint), ((usRead + digitsRead) | 0))
    } else if ((((dindex + uindex$1) | 0) >= len$1)) {
      throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, ((uindex$1 + dindex) | 0))
    } else {
      var i = ((dindex + uindex$1) | 0);
      var ch = (65535 & $uI(src$1.charCodeAt(i)));
      var this$5 = $m_jl_Character$();
      var codePoint = ch;
      var e = this$5.digitWithValidRadix__I__I__I(codePoint, 36);
      if (((e >= 0) && (e <= 15))) {
        var temp$dindex = ((1 + dindex) | 0);
        var temp$codepoint = (((codepoint << 4) + e) | 0);
        dindex = temp$dindex;
        codepoint = temp$codepoint
      } else {
        throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, ((uindex$1 + dindex) | 0))
      }
    }
  }
}
function $p_s_StringContext$__loop$1__I__I__I__T__T2($thiz, uindex, startindex$1, len$1, src$1) {
  while (true) {
    if ((uindex >= len$1)) {
      throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, (((-1) + uindex) | 0))
    } else {
      var i = uindex;
      if (((65535 & $uI(src$1.charCodeAt(i))) === 117)) {
        uindex = ((1 + uindex) | 0)
      } else {
        return $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2($thiz, 0, 0, uindex, startindex$1, len$1, src$1)
      }
    }
  }
}
function $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T($thiz, i, next, b$1, str$1, len$2) {
  while ((next >= 0)) {
    if ((next > i)) {
      b$1.append__jl_CharSequence__I__I__jl_StringBuilder(str$1, i, next)
    };
    var idx = ((1 + next) | 0);
    if ((idx >= len$2)) {
      throw new $c_s_StringContext$InvalidEscapeException(str$1, next)
    };
    var i$1 = idx;
    var x1 = (65535 & $uI(str$1.charCodeAt(i$1)));
    switch (x1) {
      case 117: {
        var c = 117;
        break
      }
      case 98: {
        var c = 8;
        break
      }
      case 116: {
        var c = 9;
        break
      }
      case 110: {
        var c = 10;
        break
      }
      case 102: {
        var c = 12;
        break
      }
      case 114: {
        var c = 13;
        break
      }
      case 34: {
        var c = 34;
        break
      }
      case 39: {
        var c = 39;
        break
      }
      case 92: {
        var c = 92;
        break
      }
      default: {
        var c;
        throw new $c_s_StringContext$InvalidEscapeException(str$1, next)
      }
    };
    var x1$2 = ((c === 117) ? $p_s_StringContext$__readUEscape__T__I__T2($thiz, str$1, idx) : new $c_T2$mcCI$sp(c, 1));
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2)
    };
    var ch = x1$2._1$mcC$sp__C();
    var advance = x1$2._2$mcI$sp__I();
    idx = ((idx + advance) | 0);
    var str = $as_T(String.fromCharCode(ch));
    b$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    var temp$i = idx;
    var temp$next = $f_T__indexOf__I__I__I(str$1, 92, idx);
    i = temp$i;
    next = temp$next
  };
  if ((i < len$2)) {
    b$1.append__jl_CharSequence__I__I__jl_StringBuilder(str$1, i, len$2)
  };
  return b$1.jl_StringBuilder__f_java$lang$StringBuilder$$content
}
/** @constructor */
function $c_s_StringContext$() {
  /*<skip>*/
}
$c_s_StringContext$.prototype = new $h_O();
$c_s_StringContext$.prototype.constructor = $c_s_StringContext$;
/** @constructor */
function $h_s_StringContext$() {
  /*<skip>*/
}
$h_s_StringContext$.prototype = $c_s_StringContext$.prototype;
$c_s_StringContext$.prototype.processEscapes__T__T = (function(str) {
  var x1 = $f_T__indexOf__I__I(str, 92);
  return ((x1 === (-1)) ? str : $p_s_StringContext$__replace__T__I__T(this, str, x1))
});
$c_s_StringContext$.prototype.checkLengths__sc_Seq__sci_Seq__V = (function(args, parts) {
  if ((parts.length__I() !== ((1 + args.length__I()) | 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("wrong number of arguments (" + args.length__I()) + ") for interpolated string with ") + parts.length__I()) + " parts"))
  }
});
var $d_s_StringContext$ = new $TypeData().initClass({
  s_StringContext$: 0
}, false, "scala.StringContext$", {
  s_StringContext$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_StringContext$.prototype.$classData = $d_s_StringContext$;
var $n_s_StringContext$;
function $m_s_StringContext$() {
  if ((!$n_s_StringContext$)) {
    $n_s_StringContext$ = new $c_s_StringContext$()
  };
  return $n_s_StringContext$
}
/** @constructor */
function $c_s_Symbol(name) {
  this.s_Symbol__f_name = null;
  this.s_Symbol__f_name = name
}
$c_s_Symbol.prototype = new $h_O();
$c_s_Symbol.prototype.constructor = $c_s_Symbol;
/** @constructor */
function $h_s_Symbol() {
  /*<skip>*/
}
$h_s_Symbol.prototype = $c_s_Symbol.prototype;
$c_s_Symbol.prototype.toString__T = (function() {
  return (("Symbol(" + this.s_Symbol__f_name) + ")")
});
$c_s_Symbol.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.s_Symbol__f_name)
});
$c_s_Symbol.prototype.equals__O__Z = (function(other) {
  return (this === other)
});
function $as_s_Symbol(obj) {
  return (((obj instanceof $c_s_Symbol) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Symbol"))
}
function $isArrayOf_s_Symbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Symbol)))
}
function $asArrayOf_s_Symbol(obj, depth) {
  return (($isArrayOf_s_Symbol(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Symbol;", depth))
}
var $d_s_Symbol = new $TypeData().initClass({
  s_Symbol: 0
}, false, "scala.Symbol", {
  s_Symbol: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Symbol.prototype.$classData = $d_s_Symbol;
/** @constructor */
function $c_T2$() {
  /*<skip>*/
}
$c_T2$.prototype = new $h_O();
$c_T2$.prototype.constructor = $c_T2$;
/** @constructor */
function $h_T2$() {
  /*<skip>*/
}
$h_T2$.prototype = $c_T2$.prototype;
$c_T2$.prototype.toString__T = (function() {
  return "Tuple2"
});
var $d_T2$ = new $TypeData().initClass({
  T2$: 0
}, false, "scala.Tuple2$", {
  T2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_T2$.prototype.$classData = $d_T2$;
var $n_T2$;
function $m_T2$() {
  if ((!$n_T2$)) {
    $n_T2$ = new $c_T2$()
  };
  return $n_T2$
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(outer) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = outer
  };
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = outer.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.iterator__sc_Iterator();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$()
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.hasNext__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui.hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.next__O = (function() {
  var e = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui.next__O();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = new $c_s_Some(e);
  return e
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.remove__V = (function() {
  var x1 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var e = x2.s_Some__f_value;
    var x1$2 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying;
    if ((!$is_scm_Set(x1$2))) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "remove")
    };
    var x2$2 = $as_scm_Set(x1$2);
    x2$2.remove__O__Z(e);
    this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$()
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  }
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$SetWrapper$$anon$1", {
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 1,
  O: 1,
  ju_Iterator: 1
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
/** @constructor */
function $c_sci_$colon$colon$() {
  /*<skip>*/
}
$c_sci_$colon$colon$.prototype = new $h_O();
$c_sci_$colon$colon$.prototype.constructor = $c_sci_$colon$colon$;
/** @constructor */
function $h_sci_$colon$colon$() {
  /*<skip>*/
}
$h_sci_$colon$colon$.prototype = $c_sci_$colon$colon$.prototype;
$c_sci_$colon$colon$.prototype.toString__T = (function() {
  return "::"
});
var $d_sci_$colon$colon$ = new $TypeData().initClass({
  sci_$colon$colon$: 0
}, false, "scala.collection.immutable.$colon$colon$", {
  sci_$colon$colon$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_$colon$colon$.prototype.$classData = $d_sci_$colon$colon$;
var $n_sci_$colon$colon$;
function $m_sci_$colon$colon$() {
  if ((!$n_sci_$colon$colon$)) {
    $n_sci_$colon$colon$ = new $c_sci_$colon$colon$()
  };
  return $n_sci_$colon$colon$
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_MapNode__O__O__I__I__I__V(outer.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashMapBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashMapBuilder$$anon$1", {
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashMapBuilder$$anon$1.prototype.$classData = $d_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_SetNode__O__I__I__I__V(outer.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashSetBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashSetBuilder$$anon$1", {
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashSetBuilder$$anon$1.prototype.$classData = $d_sci_HashSetBuilder$$anon$1;
function $is_sci_LazyList$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LazyList$State)))
}
function $as_sci_LazyList$State(obj) {
  return (($is_sci_LazyList$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList$State"))
}
function $isArrayOf_sci_LazyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList$State)))
}
function $asArrayOf_sci_LazyList$State(obj, depth) {
  return (($isArrayOf_sci_LazyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList$State;", depth))
}
/** @constructor */
function $c_sci_List$$anon$1() {
  /*<skip>*/
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
  /*<skip>*/
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this
});
var $d_sci_List$$anon$1 = new $TypeData().initClass({
  sci_List$$anon$1: 0
}, false, "scala.collection.immutable.List$$anon$1", {
  sci_List$$anon$1: 1,
  O: 1,
  F1: 1
});
$c_sci_List$$anon$1.prototype.$classData = $d_sci_List$$anon$1;
/** @constructor */
function $c_sci_MapNode() {
  /*<skip>*/
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
  /*<skip>*/
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"))
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)))
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth))
}
/** @constructor */
function $c_sci_Range$() {
  /*<skip>*/
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
  /*<skip>*/
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
var $d_sci_Range$ = new $TypeData().initClass({
  sci_Range$: 0
}, false, "scala.collection.immutable.Range$", {
  sci_Range$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$.prototype.$classData = $d_sci_Range$;
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$()
  };
  return $n_sci_Range$
}
/** @constructor */
function $c_sci_RedBlackTree$SetHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$SetHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$SetHelper.prototype.constructor = $c_sci_RedBlackTree$SetHelper;
/** @constructor */
function $h_sci_RedBlackTree$SetHelper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$SetHelper.prototype = $c_sci_RedBlackTree$SetHelper.prototype;
$c_sci_RedBlackTree$SetHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree = (function(tree, k) {
  if ((tree === null)) {
    $m_sci_RedBlackTree$();
    return new $c_sci_RedBlackTree$Tree(k, (void 0), null, null, 0)
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return tree
  } else {
    var cmp = this.sci_RedBlackTree$Helper__f_ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k)) : ((cmp > 0) ? this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k)) : tree))
  }
});
/** @constructor */
function $c_sci_SetNode() {
  /*<skip>*/
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
  /*<skip>*/
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"))
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)))
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth))
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, xs) {
  if ((xs === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(xs))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      $thiz.addOne__O__scm_Growable(it.next__O())
    }
  };
  return $thiz
}
/** @constructor */
function $c_scm_StringBuilder$() {
  /*<skip>*/
}
$c_scm_StringBuilder$.prototype = new $h_O();
$c_scm_StringBuilder$.prototype.constructor = $c_scm_StringBuilder$;
/** @constructor */
function $h_scm_StringBuilder$() {
  /*<skip>*/
}
$h_scm_StringBuilder$.prototype = $c_scm_StringBuilder$.prototype;
var $d_scm_StringBuilder$ = new $TypeData().initClass({
  scm_StringBuilder$: 0
}, false, "scala.collection.mutable.StringBuilder$", {
  scm_StringBuilder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder$.prototype.$classData = $d_scm_StringBuilder$;
var $n_scm_StringBuilder$;
function $m_scm_StringBuilder$() {
  if ((!$n_scm_StringBuilder$)) {
    $n_scm_StringBuilder$ = new $c_scm_StringBuilder$()
  };
  return $n_scm_StringBuilder$
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $$x1 = $m_s_Predef$();
  var this$1 = $f_T__trim__T(s);
  var this$2 = $$x1.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2)
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1)
  };
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T(x2.sci_$colon$colon__f_head);
  var rest = x2.sci_$colon$colon__f_next;
  var rest$1 = rest;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1 = rest$1.head__O();
    var s = $as_T(arg1);
    $m_s_package$();
    var array = [s, (s + "s")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest$1 = $as_sci_List(rest$1.tail__O())
  };
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  return new $c_sci_$colon$colon(hd, this$5)
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  $m_s_package$();
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$6, "ns nano nanosecond")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  $m_s_$less$colon$less$();
  var this$21 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20);
  var this$23 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sjsr_AnonFunction1(((this$22) => ((s$2) => {
    var s = $as_T(s$2);
    return $as_T($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s).last__O())
  }))(this));
  var this$25 = new $c_sc_MapView$MapValues(this$23, f);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$25);
  var this$26 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  var rest = this$26;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = rest.head__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1)
    };
    var unit = $as_ju_concurrent_TimeUnit(x0$1._1__O());
    var names = $as_T(x0$1._2__O());
    var this$30 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names);
    var f$1 = ((this$27, unit$1) => ((x$5$2) => {
      var x$5 = $as_T(x$5$2);
      return $ct_T2__O__O__(new $c_T2(), x$5, unit$1)
    }))(this, unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $$x7 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$30.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$30.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = rest$1.head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List(rest$1.tail__O())
      };
      var $$x7 = h$1
    };
    var it = $$x7.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        t.sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List(rest.tail__O())
  };
  var this$32 = ((h === null) ? $m_sci_Nil$() : h);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3()
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass({
  s_concurrent_duration_Duration$: 0
}, false, "scala.concurrent.duration.Duration$", {
  s_concurrent_duration_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_duration_Duration$.prototype.$classData = $d_s_concurrent_duration_Duration$;
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$()
  };
  return $n_s_concurrent_duration_Duration$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"))
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)))
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth))
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt: 0
}, false, "scala.concurrent.duration.package$DurationInt", {
  s_concurrent_duration_package$DurationInt: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationInt.prototype.$classData = $d_s_concurrent_duration_package$DurationInt;
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true
  };
  return $thiz.s_math_BigDecimal$__f_cache
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache)
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
  /*<skip>*/
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc)
});
$c_s_math_BigDecimal$.prototype.exact__Ljava_math_BigDecimal__s_math_BigDecimal = (function(repr) {
  var $$x1 = repr.precision__I();
  var this$1 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (($$x1 <= this$1.Ljava_math_MathContext__f_precision)) {
    var mc = this.s_math_BigDecimal$__f_defaultMathContext
  } else {
    var mc = new $c_Ljava_math_MathContext(repr.precision__I(), $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN)
  };
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), repr, mc)
});
$c_s_math_BigDecimal$.prototype.exact__T__s_math_BigDecimal = (function(s) {
  return this.exact__Ljava_math_BigDecimal__s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s))
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : mc.equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).set(offset, n)
    };
    return n
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__s_math_BigDecimal = (function(l) {
  var value = this.s_math_BigDecimal$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigDecimal$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var i = l.RTLong__f_lo;
    return this.apply__I__Ljava_math_MathContext__s_math_BigDecimal(i, this.s_math_BigDecimal$__f_defaultMathContext)
  } else {
    return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(l), this.s_math_BigDecimal$__f_defaultMathContext)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc)
});
$c_s_math_BigDecimal$.prototype.javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal = (function(x) {
  return ((x === null) ? null : $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), x, this.s_math_BigDecimal$__f_defaultMathContext))
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass({
  s_math_BigDecimal$: 0
}, false, "scala.math.BigDecimal$", {
  s_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigDecimal$.prototype.$classData = $d_s_math_BigDecimal$;
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$()
  };
  return $n_s_math_BigDecimal$
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $thiz.s_math_BigInt$__f_cache.get(offset);
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, new $c_RTLong(i, hi));
    $thiz.s_math_BigInt$__f_cache.set(offset, n)
  };
  return n
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)))
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
  /*<skip>*/
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i)
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(new $c_RTLong(i, hi))
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l.RTLong__f_lo)
  } else {
    return (((l.RTLong__f_lo === 0) && (l.RTLong__f_hi === (-2147483648))) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l))
  }
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(x) <= 63)) {
    var t = x.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value = this.s_math_BigInt$__f_minCached;
    var hi$1 = (value >> 31);
    if (((hi$1 === hi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ lo)) : (hi$1 < hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$2 = (value$1 >> 31);
      var $$x1 = ((hi === hi$2) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$1)) : (hi < hi$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, lo)
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(lo, hi))
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(0, (-2147483648)))
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass({
  s_math_BigInt$: 0
}, false, "scala.math.BigInt$", {
  s_math_BigInt$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigInt$.prototype.$classData = $d_s_math_BigInt$;
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$()
  };
  return $n_s_math_BigInt$
}
function $is_s_math_Equiv(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Equiv)))
}
function $as_s_math_Equiv(obj) {
  return (($is_s_math_Equiv(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv"))
}
function $isArrayOf_s_math_Equiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv)))
}
function $asArrayOf_s_math_Equiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv;", depth))
}
/** @constructor */
function $c_s_math_Fractional$() {
  /*<skip>*/
}
$c_s_math_Fractional$.prototype = new $h_O();
$c_s_math_Fractional$.prototype.constructor = $c_s_math_Fractional$;
/** @constructor */
function $h_s_math_Fractional$() {
  /*<skip>*/
}
$h_s_math_Fractional$.prototype = $c_s_math_Fractional$.prototype;
var $d_s_math_Fractional$ = new $TypeData().initClass({
  s_math_Fractional$: 0
}, false, "scala.math.Fractional$", {
  s_math_Fractional$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Fractional$.prototype.$classData = $d_s_math_Fractional$;
var $n_s_math_Fractional$;
function $m_s_math_Fractional$() {
  if ((!$n_s_math_Fractional$)) {
    $n_s_math_Fractional$ = new $c_s_math_Fractional$()
  };
  return $n_s_math_Fractional$
}
/** @constructor */
function $c_s_math_Integral$() {
  /*<skip>*/
}
$c_s_math_Integral$.prototype = new $h_O();
$c_s_math_Integral$.prototype.constructor = $c_s_math_Integral$;
/** @constructor */
function $h_s_math_Integral$() {
  /*<skip>*/
}
$h_s_math_Integral$.prototype = $c_s_math_Integral$.prototype;
var $d_s_math_Integral$ = new $TypeData().initClass({
  s_math_Integral$: 0
}, false, "scala.math.Integral$", {
  s_math_Integral$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Integral$.prototype.$classData = $d_s_math_Integral$;
var $n_s_math_Integral$;
function $m_s_math_Integral$() {
  if ((!$n_s_math_Integral$)) {
    $n_s_math_Integral$ = new $c_s_math_Integral$()
  };
  return $n_s_math_Integral$
}
/** @constructor */
function $c_s_math_Numeric$() {
  /*<skip>*/
}
$c_s_math_Numeric$.prototype = new $h_O();
$c_s_math_Numeric$.prototype.constructor = $c_s_math_Numeric$;
/** @constructor */
function $h_s_math_Numeric$() {
  /*<skip>*/
}
$h_s_math_Numeric$.prototype = $c_s_math_Numeric$.prototype;
var $d_s_math_Numeric$ = new $TypeData().initClass({
  s_math_Numeric$: 0
}, false, "scala.math.Numeric$", {
  s_math_Numeric$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Numeric$.prototype.$classData = $d_s_math_Numeric$;
var $n_s_math_Numeric$;
function $m_s_math_Numeric$() {
  if ((!$n_s_math_Numeric$)) {
    $n_s_math_Numeric$ = new $c_s_math_Numeric$()
  };
  return $n_s_math_Numeric$
}
/** @constructor */
function $c_s_package$$anon$1() {
  /*<skip>*/
}
$c_s_package$$anon$1.prototype = new $h_O();
$c_s_package$$anon$1.prototype.constructor = $c_s_package$$anon$1;
/** @constructor */
function $h_s_package$$anon$1() {
  /*<skip>*/
}
$h_s_package$$anon$1.prototype = $c_s_package$$anon$1.prototype;
$c_s_package$$anon$1.prototype.toString__T = (function() {
  return "object AnyRef"
});
var $d_s_package$$anon$1 = new $TypeData().initClass({
  s_package$$anon$1: 0
}, false, "scala.package$$anon$1", {
  s_package$$anon$1: 1,
  O: 1,
  s_Specializable: 1
});
$c_s_package$$anon$1.prototype.$classData = $d_s_package$$anon$1;
/** @constructor */
function $c_s_reflect_ClassTag$() {
  /*<skip>*/
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))))
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass({
  s_reflect_ClassTag$: 0
}, false, "scala.reflect.ClassTag$", {
  s_reflect_ClassTag$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_ClassTag$.prototype.$classData = $d_s_reflect_ClassTag$;
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$()
  };
  return $n_s_reflect_ClassTag$
}
/** @constructor */
function $c_s_reflect_Manifest$() {
  /*<skip>*/
}
$c_s_reflect_Manifest$.prototype = new $h_O();
$c_s_reflect_Manifest$.prototype.constructor = $c_s_reflect_Manifest$;
/** @constructor */
function $h_s_reflect_Manifest$() {
  /*<skip>*/
}
$h_s_reflect_Manifest$.prototype = $c_s_reflect_Manifest$.prototype;
var $d_s_reflect_Manifest$ = new $TypeData().initClass({
  s_reflect_Manifest$: 0
}, false, "scala.reflect.Manifest$", {
  s_reflect_Manifest$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_Manifest$.prototype.$classData = $d_s_reflect_Manifest$;
var $n_s_reflect_Manifest$;
function $m_s_reflect_Manifest$() {
  if ((!$n_s_reflect_Manifest$)) {
    $n_s_reflect_Manifest$ = new $c_s_reflect_Manifest$()
  };
  return $n_s_reflect_Manifest$
}
/** @constructor */
function $c_sr_AbstractFunction0() {
  /*<skip>*/
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
  /*<skip>*/
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>"
});
/** @constructor */
function $c_sr_AbstractFunction1() {
  /*<skip>*/
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
  /*<skip>*/
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>"
});
/** @constructor */
function $c_sr_AbstractFunction2() {
  /*<skip>*/
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
  /*<skip>*/
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>"
});
/** @constructor */
function $c_sr_AbstractFunction3() {
  /*<skip>*/
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
  /*<skip>*/
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>"
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem
}
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
  /*<skip>*/
}
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b)
});
var $d_sr_BooleanRef = new $TypeData().initClass({
  sr_BooleanRef: 0
}, false, "scala.runtime.BooleanRef", {
  sr_BooleanRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_BooleanRef.prototype.$classData = $d_sr_BooleanRef;
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
  /*<skip>*/
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i)
});
var $d_sr_IntRef = new $TypeData().initClass({
  sr_IntRef: 0
}, false, "scala.runtime.IntRef", {
  sr_IntRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_IntRef.prototype.$classData = $d_sr_IntRef;
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
  /*<skip>*/
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj)
});
var $d_sr_ObjectRef = new $TypeData().initClass({
  sr_ObjectRef: 0
}, false, "scala.runtime.ObjectRef", {
  sr_ObjectRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_ObjectRef.prototype.$classData = $d_sr_ObjectRef;
/** @constructor */
function $c_s_util_Either$() {
  /*<skip>*/
}
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
  /*<skip>*/
}
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass({
  s_util_Either$: 0
}, false, "scala.util.Either$", {
  s_util_Either$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Either$.prototype.$classData = $d_s_util_Either$;
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$()
  };
  return $n_s_util_Either$
}
/** @constructor */
function $c_s_util_Left$() {
  /*<skip>*/
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
  /*<skip>*/
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left"
});
var $d_s_util_Left$ = new $TypeData().initClass({
  s_util_Left$: 0
}, false, "scala.util.Left$", {
  s_util_Left$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left$.prototype.$classData = $d_s_util_Left$;
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$()
  };
  return $n_s_util_Left$
}
/** @constructor */
function $c_s_util_Right$() {
  /*<skip>*/
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
  /*<skip>*/
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right"
});
var $d_s_util_Right$ = new $TypeData().initClass({
  s_util_Right$: 0
}, false, "scala.util.Right$", {
  s_util_Right$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right$.prototype.$classData = $d_s_util_Right$;
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$()
  };
  return $n_s_util_Right$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_s_package$().s_package$__f_Nil, this.s_util_hashing_MurmurHash3$__f_mapSeed)
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714))
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if (xs.isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    xs.foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n)
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$: 0
}, false, "scala.util.hashing.MurmurHash3$", {
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1,
  O: 1
});
$c_s_util_hashing_MurmurHash3$.prototype.$classData = $d_s_util_hashing_MurmurHash3$;
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$()
  };
  return $n_s_util_hashing_MurmurHash3$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>"
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0)
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$accum$1: 0
}, false, "scala.util.hashing.MurmurHash3$accum$1", {
  s_util_hashing_MurmurHash3$accum$1: 1,
  O: 1,
  F2: 1
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.$classData = $d_s_util_hashing_MurmurHash3$accum$1;
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.s_util_matching_Regex__f_pattern = pattern;
  $thiz.s_util_matching_Regex__f_scala$util$matching$Regex$$groupNames = groupNames;
  return $thiz
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0), groupNames);
  return $thiz
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.s_util_matching_Regex__f_pattern = null;
  this.s_util_matching_Regex__f_scala$util$matching$Regex$$groupNames = null
}
$c_s_util_matching_Regex.prototype = new $h_O();
$c_s_util_matching_Regex.prototype.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
  /*<skip>*/
}
$h_s_util_matching_Regex.prototype = $c_s_util_matching_Regex.prototype;
$c_s_util_matching_Regex.prototype.unapplySeq__jl_CharSequence__s_Option = (function(s) {
  var this$1 = this.s_util_matching_Regex__f_pattern;
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T(s));
  if (m.matches__Z()) {
    $m_s_package$();
    var n = m.ju_regex_Matcher__f_pattern0.ju_regex_Pattern__f_groupCount;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      var arg1 = i;
      var elem = m.group__I__T(((1 + arg1) | 0));
      b.addOne__O__scm_ListBuffer(elem);
      i = ((1 + i) | 0)
    };
    return new $c_s_Some(b.toList__sci_List())
  } else {
    return $m_s_None$()
  }
});
$c_s_util_matching_Regex.prototype.toString__T = (function() {
  return this.s_util_matching_Regex__f_pattern.ju_regex_Pattern__f__pattern
});
var $d_s_util_matching_Regex = new $TypeData().initClass({
  s_util_matching_Regex: 0
}, false, "scala.util.matching.Regex", {
  s_util_matching_Regex: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_matching_Regex.prototype.$classData = $d_s_util_matching_Regex;
function $f_Lsquants_PrimaryUnit__converterTo__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((value) => {
    var value$1 = $uD(value);
    return value$1
  }))
}
function $f_Lsquants_PrimaryUnit__converterFrom__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((value) => {
    var value$1 = $uD(value);
    return value$1
  }))
}
function $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D($thiz, n, num) {
  return $uD($thiz.converterTo__F1().apply__O__O(num.toDouble__O__D(n)))
}
function $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D($thiz, n, num) {
  return $uD($thiz.converterFrom__F1().apply__O__O(num.toDouble__O__D(n)))
}
function $is_Ltyrian_Html(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Html)))
}
function $as_Ltyrian_Html(obj) {
  return (($is_Ltyrian_Html(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Html"))
}
function $isArrayOf_Ltyrian_Html(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Html)))
}
function $asArrayOf_Ltyrian_Html(obj, depth) {
  return (($isArrayOf_Ltyrian_Html(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Html;", depth))
}
var $d_Ltyrian_Html = new $TypeData().initClass({
  Ltyrian_Html: 0
}, true, "tyrian.Html", {
  Ltyrian_Html: 1,
  O: 1,
  Ltyrian_Elem: 1
});
/** @constructor */
function $c_Ltyrian_Navigation$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_Navigation$$anon$1.prototype = new $h_O();
$c_Ltyrian_Navigation$$anon$1.prototype.constructor = $c_Ltyrian_Navigation$$anon$1;
/** @constructor */
function $h_Ltyrian_Navigation$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_Navigation$$anon$1.prototype = $c_Ltyrian_Navigation$$anon$1.prototype;
$c_Ltyrian_Navigation$$anon$1.prototype.cancel__V = (function() {
  /*<skip>*/
});
var $d_Ltyrian_Navigation$$anon$1 = new $TypeData().initClass({
  Ltyrian_Navigation$$anon$1: 0
}, false, "tyrian.Navigation$$anon$1", {
  Ltyrian_Navigation$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_Navigation$$anon$1.prototype.$classData = $d_Ltyrian_Navigation$$anon$1;
/** @constructor */
function $c_Ltyrian_Navigation$$anon$2() {
  /*<skip>*/
}
$c_Ltyrian_Navigation$$anon$2.prototype = new $h_O();
$c_Ltyrian_Navigation$$anon$2.prototype.constructor = $c_Ltyrian_Navigation$$anon$2;
/** @constructor */
function $h_Ltyrian_Navigation$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_Navigation$$anon$2.prototype = $c_Ltyrian_Navigation$$anon$2.prototype;
$c_Ltyrian_Navigation$$anon$2.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var hash = $as_T(window.location.hash);
  if ((hash !== "")) {
    var hash$1 = $as_T(hash.substring(1));
    observer.onNext__O__V(new $c_Ltyrian_Navigation$CurrentHash(hash$1))
  } else {
    observer.onError__O__V($m_Ltyrian_Navigation$NoHash$())
  };
  return new $c_Ltyrian_Navigation$$anon$1()
});
var $d_Ltyrian_Navigation$$anon$2 = new $TypeData().initClass({
  Ltyrian_Navigation$$anon$2: 0
}, false, "tyrian.Navigation$$anon$2", {
  Ltyrian_Navigation$$anon$2: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_Navigation$$anon$2.prototype.$classData = $d_Ltyrian_Navigation$$anon$2;
/** @constructor */
function $c_Ltyrian_Sub$$anon$1(handle$5) {
  this.Ltyrian_Sub$$anon$1__f_handle$3 = 0;
  this.Ltyrian_Sub$$anon$1__f_handle$3 = handle$5
}
$c_Ltyrian_Sub$$anon$1.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$1.prototype.constructor = $c_Ltyrian_Sub$$anon$1;
/** @constructor */
function $h_Ltyrian_Sub$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$1.prototype = $c_Ltyrian_Sub$$anon$1.prototype;
$c_Ltyrian_Sub$$anon$1.prototype.cancel__V = (function() {
  var handle$1 = this.Ltyrian_Sub$$anon$1__f_handle$3;
  window.clearTimeout(handle$1)
});
var $d_Ltyrian_Sub$$anon$1 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$1: 0
}, false, "tyrian.Sub$$anon$1", {
  Ltyrian_Sub$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_Sub$$anon$1.prototype.$classData = $d_Ltyrian_Sub$$anon$1;
/** @constructor */
function $c_Ltyrian_Sub$$anon$2(duration$3, msg$5) {
  this.Ltyrian_Sub$$anon$2__f_duration$2 = null;
  this.Ltyrian_Sub$$anon$2__f_msg$4 = null;
  this.Ltyrian_Sub$$anon$2__f_duration$2 = duration$3;
  this.Ltyrian_Sub$$anon$2__f_msg$4 = msg$5
}
$c_Ltyrian_Sub$$anon$2.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$2.prototype.constructor = $c_Ltyrian_Sub$$anon$2;
/** @constructor */
function $h_Ltyrian_Sub$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$2.prototype = $c_Ltyrian_Sub$$anon$2.prototype;
$c_Ltyrian_Sub$$anon$2.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var this$1 = $m_Ltyrian_Sub$();
  var duration$1 = this.Ltyrian_Sub$$anon$2__f_duration$2;
  var msg$2 = this.Ltyrian_Sub$$anon$2__f_msg$4;
  var $$x3 = window;
  var f = new $c_sjsr_AnonFunction0(((this$2, msg$2$2, observer$2) => (() => {
    observer$2.onNext__O__V(msg$2$2)
  }))(this$1, msg$2, observer));
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(f);
  var this$4 = duration$1.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(duration$1.s_concurrent_duration_FiniteDuration__f_length);
  var $$x1 = $$x3.setTimeout($$x2, $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$4.RTLong__f_lo, this$4.RTLong__f_hi));
  var handle = $uI($$x1);
  return new $c_Ltyrian_Sub$$anon$1(handle)
});
var $d_Ltyrian_Sub$$anon$2 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$2: 0
}, false, "tyrian.Sub$$anon$2", {
  Ltyrian_Sub$$anon$2: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_Sub$$anon$2.prototype.$classData = $d_Ltyrian_Sub$$anon$2;
/** @constructor */
function $c_Ltyrian_Sub$$anon$3(handle$6) {
  this.Ltyrian_Sub$$anon$3__f_handle$4 = 0;
  this.Ltyrian_Sub$$anon$3__f_handle$4 = handle$6
}
$c_Ltyrian_Sub$$anon$3.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$3.prototype.constructor = $c_Ltyrian_Sub$$anon$3;
/** @constructor */
function $h_Ltyrian_Sub$$anon$3() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$3.prototype = $c_Ltyrian_Sub$$anon$3.prototype;
$c_Ltyrian_Sub$$anon$3.prototype.cancel__V = (function() {
  var handle$2 = this.Ltyrian_Sub$$anon$3__f_handle$4;
  window.clearInterval(handle$2)
});
var $d_Ltyrian_Sub$$anon$3 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$3: 0
}, false, "tyrian.Sub$$anon$3", {
  Ltyrian_Sub$$anon$3: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_Sub$$anon$3.prototype.$classData = $d_Ltyrian_Sub$$anon$3;
/** @constructor */
function $c_Ltyrian_Sub$$anon$4(interval$3) {
  this.Ltyrian_Sub$$anon$4__f_interval$2 = null;
  this.Ltyrian_Sub$$anon$4__f_interval$2 = interval$3
}
$c_Ltyrian_Sub$$anon$4.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$4.prototype.constructor = $c_Ltyrian_Sub$$anon$4;
/** @constructor */
function $h_Ltyrian_Sub$$anon$4() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$4.prototype = $c_Ltyrian_Sub$$anon$4.prototype;
$c_Ltyrian_Sub$$anon$4.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var this$1 = $m_Ltyrian_Sub$();
  var interval$1 = this.Ltyrian_Sub$$anon$4__f_interval$2;
  var $$x3 = window;
  var f = new $c_sjsr_AnonFunction0(((this$2, observer$2) => (() => {
    observer$2.onNext__O__V(new Date())
  }))(this$1, observer));
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(f);
  var this$4 = interval$1.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(interval$1.s_concurrent_duration_FiniteDuration__f_length);
  var $$x1 = $$x3.setInterval($$x2, $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$4.RTLong__f_lo, this$4.RTLong__f_hi));
  var handle = $uI($$x1);
  return new $c_Ltyrian_Sub$$anon$3(handle)
});
var $d_Ltyrian_Sub$$anon$4 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$4: 0
}, false, "tyrian.Sub$$anon$4", {
  Ltyrian_Sub$$anon$4: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_Sub$$anon$4.prototype.$classData = $d_Ltyrian_Sub$$anon$4;
/** @constructor */
function $c_Ltyrian_Sub$$anon$5(name$5, target$5, listener$3) {
  this.Ltyrian_Sub$$anon$5__f_name$3 = null;
  this.Ltyrian_Sub$$anon$5__f_target$3 = null;
  this.Ltyrian_Sub$$anon$5__f_listener$2 = null;
  this.Ltyrian_Sub$$anon$5__f_name$3 = name$5;
  this.Ltyrian_Sub$$anon$5__f_target$3 = target$5;
  this.Ltyrian_Sub$$anon$5__f_listener$2 = listener$3
}
$c_Ltyrian_Sub$$anon$5.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$5.prototype.constructor = $c_Ltyrian_Sub$$anon$5;
/** @constructor */
function $h_Ltyrian_Sub$$anon$5() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$5.prototype = $c_Ltyrian_Sub$$anon$5.prototype;
$c_Ltyrian_Sub$$anon$5.prototype.cancel__V = (function() {
  var name$2 = this.Ltyrian_Sub$$anon$5__f_name$3;
  var target$2 = this.Ltyrian_Sub$$anon$5__f_target$3;
  var listener$1 = this.Ltyrian_Sub$$anon$5__f_listener$2;
  target$2.removeEventListener(name$2, listener$1)
});
var $d_Ltyrian_Sub$$anon$5 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$5: 0
}, false, "tyrian.Sub$$anon$5", {
  Ltyrian_Sub$$anon$5: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_Sub$$anon$5.prototype.$classData = $d_Ltyrian_Sub$$anon$5;
/** @constructor */
function $c_Ltyrian_Sub$$anon$6(name$6, target$6, extract$5) {
  this.Ltyrian_Sub$$anon$6__f_name$4 = null;
  this.Ltyrian_Sub$$anon$6__f_target$4 = null;
  this.Ltyrian_Sub$$anon$6__f_extract$4 = null;
  this.Ltyrian_Sub$$anon$6__f_name$4 = name$6;
  this.Ltyrian_Sub$$anon$6__f_target$4 = target$6;
  this.Ltyrian_Sub$$anon$6__f_extract$4 = extract$5
}
$c_Ltyrian_Sub$$anon$6.prototype = new $h_O();
$c_Ltyrian_Sub$$anon$6.prototype.constructor = $c_Ltyrian_Sub$$anon$6;
/** @constructor */
function $h_Ltyrian_Sub$$anon$6() {
  /*<skip>*/
}
$h_Ltyrian_Sub$$anon$6.prototype = $c_Ltyrian_Sub$$anon$6.prototype;
$c_Ltyrian_Sub$$anon$6.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var this$1 = $m_Ltyrian_Sub$();
  var name$1 = this.Ltyrian_Sub$$anon$6__f_name$4;
  var target$1 = this.Ltyrian_Sub$$anon$6__f_target$4;
  var extract$1 = this.Ltyrian_Sub$$anon$6__f_extract$4;
  var f = new $c_sjsr_AnonFunction1(((this$2, extract$1$2, observer$2) => ((a) => {
    matchResult13: {
      var x24 = $as_s_Option(extract$1$2.apply__O__O(a));
      if ((x24 instanceof $c_s_Some)) {
        var msg = $as_s_Some(x24).s_Some__f_value;
        observer$2.onNext__O__V(msg);
        break matchResult13
      };
      var x = $m_s_None$();
      if ((x === x24)) {
        break matchResult13
      };
      throw new $c_s_MatchError(x24)
    }
  }))(this$1, extract$1, observer));
  var listener = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f);
  target$1.addEventListener(name$1, listener);
  return new $c_Ltyrian_Sub$$anon$5(name$1, target$1, listener)
});
var $d_Ltyrian_Sub$$anon$6 = new $TypeData().initClass({
  Ltyrian_Sub$$anon$6: 0
}, false, "tyrian.Sub$$anon$6", {
  Ltyrian_Sub$$anon$6: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_Sub$$anon$6.prototype.$classData = $d_Ltyrian_Sub$$anon$6;
/** @constructor */
function $c_Ltyrian_cmds_Dom$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_cmds_Dom$$anon$1.prototype = new $h_O();
$c_Ltyrian_cmds_Dom$$anon$1.prototype.constructor = $c_Ltyrian_cmds_Dom$$anon$1;
/** @constructor */
function $h_Ltyrian_cmds_Dom$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_cmds_Dom$$anon$1.prototype = $c_Ltyrian_cmds_Dom$$anon$1.prototype;
$c_Ltyrian_cmds_Dom$$anon$1.prototype.cancel__V = (function() {
  /*<skip>*/
});
var $d_Ltyrian_cmds_Dom$$anon$1 = new $TypeData().initClass({
  Ltyrian_cmds_Dom$$anon$1: 0
}, false, "tyrian.cmds.Dom$$anon$1", {
  Ltyrian_cmds_Dom$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_cmds_Dom$$anon$1.prototype.$classData = $d_Ltyrian_cmds_Dom$$anon$1;
/** @constructor */
function $c_Ltyrian_cmds_Dom$$anon$2(elementId$3, modifier$3) {
  this.Ltyrian_cmds_Dom$$anon$2__f_elementId$2 = null;
  this.Ltyrian_cmds_Dom$$anon$2__f_modifier$2 = null;
  this.Ltyrian_cmds_Dom$$anon$2__f_elementId$2 = elementId$3;
  this.Ltyrian_cmds_Dom$$anon$2__f_modifier$2 = modifier$3
}
$c_Ltyrian_cmds_Dom$$anon$2.prototype = new $h_O();
$c_Ltyrian_cmds_Dom$$anon$2.prototype.constructor = $c_Ltyrian_cmds_Dom$$anon$2;
/** @constructor */
function $h_Ltyrian_cmds_Dom$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_cmds_Dom$$anon$2.prototype = $c_Ltyrian_cmds_Dom$$anon$2.prototype;
$c_Ltyrian_cmds_Dom$$anon$2.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var elementId$1 = this.Ltyrian_cmds_Dom$$anon$2__f_elementId$2;
  var modifier$1 = this.Ltyrian_cmds_Dom$$anon$2__f_modifier$2;
  var node = document.getElementById(elementId$1);
  if ((node !== null)) {
    observer.onNext__O__V(modifier$1.apply__O__O(node))
  } else {
    observer.onError__O__V(new $c_Ltyrian_cmds_Dom$NotFound(elementId$1))
  };
  return new $c_Ltyrian_cmds_Dom$$anon$1()
});
var $d_Ltyrian_cmds_Dom$$anon$2 = new $TypeData().initClass({
  Ltyrian_cmds_Dom$$anon$2: 0
}, false, "tyrian.cmds.Dom$$anon$2", {
  Ltyrian_cmds_Dom$$anon$2: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_cmds_Dom$$anon$2.prototype.$classData = $d_Ltyrian_cmds_Dom$$anon$2;
/** @constructor */
function $c_Ltyrian_http_Http$$anon$1(xhr$7) {
  this.Ltyrian_http_Http$$anon$1__f_xhr$6 = null;
  this.Ltyrian_http_Http$$anon$1__f_xhr$6 = xhr$7
}
$c_Ltyrian_http_Http$$anon$1.prototype = new $h_O();
$c_Ltyrian_http_Http$$anon$1.prototype.constructor = $c_Ltyrian_http_Http$$anon$1;
/** @constructor */
function $h_Ltyrian_http_Http$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_http_Http$$anon$1.prototype = $c_Ltyrian_http_Http$$anon$1.prototype;
$c_Ltyrian_http_Http$$anon$1.prototype.cancel__V = (function() {
  var xhr$4 = this.Ltyrian_http_Http$$anon$1__f_xhr$6;
  xhr$4.abort()
});
var $d_Ltyrian_http_Http$$anon$1 = new $TypeData().initClass({
  Ltyrian_http_Http$$anon$1: 0
}, false, "tyrian.http.Http$$anon$1", {
  Ltyrian_http_Http$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Cancelable: 1
});
$c_Ltyrian_http_Http$$anon$1.prototype.$classData = $d_Ltyrian_http_Http$$anon$1;
/** @constructor */
function $c_Ltyrian_http_Http$$anon$2(request$6) {
  this.Ltyrian_http_Http$$anon$2__f_request$5 = null;
  this.Ltyrian_http_Http$$anon$2__f_request$5 = request$6
}
$c_Ltyrian_http_Http$$anon$2.prototype = new $h_O();
$c_Ltyrian_http_Http$$anon$2.prototype.constructor = $c_Ltyrian_http_Http$$anon$2;
/** @constructor */
function $h_Ltyrian_http_Http$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_http_Http$$anon$2.prototype = $c_Ltyrian_http_Http$$anon$2.prototype;
$c_Ltyrian_http_Http$$anon$2.prototype.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable = (function(observer) {
  var this$1 = $m_Ltyrian_http_Http$();
  var request$1 = this.Ltyrian_http_Http$$anon$2__f_request$5;
  var xhr = new XMLHttpRequest();
  $p_Ltyrian_http_Http$__liftedTree1$1__Ltyrian_http_Request__Ltyrian_Task$Observer__Lorg_scalajs_dom_XMLHttpRequest__V(this$1, request$1, observer, xhr);
  return new $c_Ltyrian_http_Http$$anon$1(xhr)
});
var $d_Ltyrian_http_Http$$anon$2 = new $TypeData().initClass({
  Ltyrian_http_Http$$anon$2: 0
}, false, "tyrian.http.Http$$anon$2", {
  Ltyrian_http_Http$$anon$2: 1,
  O: 1,
  Ltyrian_Task$Observable: 1
});
$c_Ltyrian_http_Http$$anon$2.prototype.$classData = $d_Ltyrian_http_Http$$anon$2;
/** @constructor */
function $c_Ltyrian_runtime_TaskRunner$$anon$1(notifier$2) {
  this.Ltyrian_runtime_TaskRunner$$anon$1__f_notifier$1 = null;
  this.Ltyrian_runtime_TaskRunner$$anon$1__f_notifier$1 = notifier$2
}
$c_Ltyrian_runtime_TaskRunner$$anon$1.prototype = new $h_O();
$c_Ltyrian_runtime_TaskRunner$$anon$1.prototype.constructor = $c_Ltyrian_runtime_TaskRunner$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_TaskRunner$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TaskRunner$$anon$1.prototype = $c_Ltyrian_runtime_TaskRunner$$anon$1.prototype;
$c_Ltyrian_runtime_TaskRunner$$anon$1.prototype.onNext__O__V = (function(value) {
  this.Ltyrian_runtime_TaskRunner$$anon$1__f_notifier$1.apply__O__O(($m_s_package$(), new $c_s_util_Right(value)))
});
$c_Ltyrian_runtime_TaskRunner$$anon$1.prototype.onError__O__V = (function(error) {
  this.Ltyrian_runtime_TaskRunner$$anon$1__f_notifier$1.apply__O__O(($m_s_package$(), new $c_s_util_Left(error)))
});
var $d_Ltyrian_runtime_TaskRunner$$anon$1 = new $TypeData().initClass({
  Ltyrian_runtime_TaskRunner$$anon$1: 0
}, false, "tyrian.runtime.TaskRunner$$anon$1", {
  Ltyrian_runtime_TaskRunner$$anon$1: 1,
  O: 1,
  Ltyrian_Task$Observer: 1
});
$c_Ltyrian_runtime_TaskRunner$$anon$1.prototype.$classData = $d_Ltyrian_runtime_TaskRunner$$anon$1;
function $p_Ltyrian_runtime_TyrianRuntime__patch__F2($thiz) {
  if ((!$thiz.Ltyrian_runtime_TyrianRuntime__f_patchbitmap$1)) {
    $thiz.Ltyrian_runtime_TyrianRuntime__f_patch$lzy1 = $m_sjs_js_Any$().toFunction2__sjs_js_Function2__F2($moduleDefault($i_snabbdom).init([$i_snabbdom.propsModule, $i_snabbdom.attributesModule, $i_snabbdom.eventListenersModule]));
    $thiz.Ltyrian_runtime_TyrianRuntime__f_patchbitmap$1 = true
  };
  return $thiz.Ltyrian_runtime_TyrianRuntime__f_patch$lzy1
}
function $ps_Ltyrian_runtime_TyrianRuntime__loop$1__Ltyrian_Sub__sci_List(sub) {
  var x = $m_Ltyrian_Sub$Empty$();
  if ((x === sub)) {
    return $m_s_package$().s_package$__f_Nil
  };
  if (false) {
    var x$1 = $as_Ltyrian_Sub$Combine(sub);
    var x16 = x$1.Ltyrian_Sub$Combine__f_sub1;
    var x17 = x$1.Ltyrian_Sub$Combine__f_sub2;
    var this$2 = $ps_Ltyrian_runtime_TyrianRuntime__loop$1__Ltyrian_Sub__sci_List(x16);
    var suffix = $ps_Ltyrian_runtime_TyrianRuntime__loop$1__Ltyrian_Sub__sci_List(x17);
    return this$2.appendedAll__sc_IterableOnce__sci_List(suffix)
  };
  if ((sub instanceof $c_Ltyrian_Sub$Batch)) {
    var x$1$1 = $as_Ltyrian_Sub$Batch(sub);
    var x13 = x$1$1.Ltyrian_Sub$Batch__f_subs;
    var rest = x13;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = rest.head__O();
      var sub$1 = $as_Ltyrian_Sub(arg1);
      var it = $ps_Ltyrian_runtime_TyrianRuntime__loop$1__Ltyrian_Sub__sci_List(sub$1).iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          t.sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List(rest.tail__O())
    };
    return ((h === null) ? $m_sci_Nil$() : h)
  };
  if ((sub instanceof $c_Ltyrian_Sub$OfObservable)) {
    var s = $as_Ltyrian_Sub$OfObservable(sub);
    $m_s_package$();
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub$OfObservable.getArrayOf().constr)([s]));
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  };
  throw new $c_s_MatchError(sub)
}
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime(init, update, view, subscriptions, node) {
  this.Ltyrian_runtime_TyrianRuntime__f_update = null;
  this.Ltyrian_runtime_TyrianRuntime__f_view = null;
  this.Ltyrian_runtime_TyrianRuntime__f_subscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_initCmd = null;
  this.Ltyrian_runtime_TyrianRuntime__f_currentState = null;
  this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_vnode = null;
  this.Ltyrian_runtime_TyrianRuntime__f_patch$lzy1 = null;
  this.Ltyrian_runtime_TyrianRuntime__f_patchbitmap$1 = false;
  this.Ltyrian_runtime_TyrianRuntime__f_update = update;
  this.Ltyrian_runtime_TyrianRuntime__f_view = view;
  this.Ltyrian_runtime_TyrianRuntime__f_subscriptions = subscriptions;
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((init !== null)) {
      var initState = init._1__O();
      var initCmd = $as_Ltyrian_Cmd(init._2__O());
      var \u03b41$___1 = initState;
      var \u03b41$___2 = initCmd;
      break matchResult1
    };
    throw new $c_s_MatchError(init)
  };
  var initState$2 = \u03b41$___1;
  this.Ltyrian_runtime_TyrianRuntime__f_initCmd = $as_Ltyrian_Cmd(\u03b41$___2);
  this.Ltyrian_runtime_TyrianRuntime__f_currentState = initState$2;
  this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = $m_s_package$().s_package$__f_Nil;
  this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $m_sci_Set$EmptySet$();
  this.Ltyrian_runtime_TyrianRuntime__f_vnode = this.render__sjs_js_Object__O__Lsnabbdom_VNode(node, this.Ltyrian_runtime_TyrianRuntime__f_currentState)
}
$c_Ltyrian_runtime_TyrianRuntime.prototype = new $h_O();
$c_Ltyrian_runtime_TyrianRuntime.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TyrianRuntime.prototype = $c_Ltyrian_runtime_TyrianRuntime.prototype;
$c_Ltyrian_runtime_TyrianRuntime.prototype.onMsg__O__V = (function(msg) {
  matchResult2: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x4 = $as_T2(this.Ltyrian_runtime_TyrianRuntime__f_update.apply__O__O__O(msg, this.Ltyrian_runtime_TyrianRuntime__f_currentState));
    if ((x4 !== null)) {
      var x5 = x4._1__O();
      var x6 = $as_Ltyrian_Cmd(x4._2__O());
      if ((x5 !== null)) {
        if ((x6 !== null)) {
          var \u03b42$___1 = x5;
          var \u03b42$___2 = x6;
          break matchResult2
        }
      }
    };
    throw new $c_s_MatchError(x4)
  };
  var updatedState$2 = \u03b42$___1;
  var cmd$2 = $as_Ltyrian_Cmd(\u03b42$___2);
  this.Ltyrian_runtime_TyrianRuntime__f_currentState = updatedState$2;
  this.Ltyrian_runtime_TyrianRuntime__f_vnode = this.render__sjs_js_Object__O__Lsnabbdom_VNode(this.Ltyrian_runtime_TyrianRuntime__f_vnode, this.Ltyrian_runtime_TyrianRuntime__f_currentState);
  this.performSideEffects__Ltyrian_Cmd__Ltyrian_Sub__F1__V(cmd$2, $as_Ltyrian_Sub(this.Ltyrian_runtime_TyrianRuntime__f_subscriptions.apply__O__O(this.Ltyrian_runtime_TyrianRuntime__f_currentState)), new $c_sjsr_AnonFunction1(((this$2) => ((msg$2) => {
    this$2.onMsg__O__V(msg$2)
  }))(this)))
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.performSideEffects__Ltyrian_Cmd__Ltyrian_Sub__F1__V = (function(cmd, sub, callback) {
  $m_Ltyrian_runtime_CmdRunner$().runCmd__Ltyrian_Cmd__F1__F1__V(cmd, callback, new $c_sjsr_AnonFunction1(((this$1) => ((thunk) => {
    var thunk$1 = $as_F0(thunk);
    $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(0.0, thunk$1)
  }))(this)));
  var allSubs = $ps_Ltyrian_runtime_TyrianRuntime__loop$1__Ltyrian_Sub__sci_List(sub);
  matchResult5: {
    var \u03b43$___1;
    var \u03b43$___2;
    var this$2 = this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions;
    if (this$2.isEmpty__Z()) {
      var x21 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil
    } else {
      $m_sci_List$();
      var l = new $c_scm_ListBuffer();
      $m_sci_List$();
      var r = new $c_scm_ListBuffer();
      var this$5 = this$2.iterator__sc_Iterator();
      while (this$5.hasNext__Z()) {
        var arg1 = this$5.next__O();
        var x$1 = $as_T2(arg1);
        matchResult4: {
          var $$x1;
          if ((x$1 !== null)) {
            var id = $as_T(x$1._1__O());
            var these = allSubs;
            while ((!these.isEmpty__Z())) {
              var arg1$1 = these.head__O();
              var _$1 = $as_Ltyrian_Sub$OfObservable(arg1$1);
              if ((_$1.Ltyrian_Sub$OfObservable__f_id === id)) {
                var $$x1 = true;
                break matchResult4
              };
              these = $as_sci_List(these.tail__O())
            };
            var $$x1 = false;
            break matchResult4
          };
          throw new $c_s_MatchError(x$1)
        };
        if ($$x1) {
          var this$6 = l
        } else {
          var this$6 = r
        };
        this$6.addOne__O__scm_ListBuffer(arg1)
      };
      var x1 = $ct_T2__O__O__(new $c_T2(), l.toList__sci_List(), r.toList__sci_List());
      matchEnd7$1: {
        var x21;
        var p2 = $as_sci_List(x1.T2__f__1);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(p2)) {
          var x21 = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), this$2);
          break matchEnd7$1
        };
        var p4 = $as_sci_List(x1.T2__f__2);
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(p4)) {
          var x21 = $ct_T2__O__O__(new $c_T2(), this$2, $m_sci_Nil$());
          break matchEnd7$1
        };
        var x21 = x1
      }
    };
    if ((x21 !== null)) {
      var stillActives = $as_sci_List(x21._1__O());
      var discarded = $as_sci_List(x21._2__O());
      var \u03b43$___1 = stillActives;
      var \u03b43$___2 = discarded;
      break matchResult5
    };
    throw new $c_s_MatchError(x21)
  };
  var stillActives$2 = $as_sci_List(\u03b43$___1);
  var discarded$2 = $as_sci_List(\u03b43$___2);
  var f = ((this$2$1, stillActives$3) => ((s) => {
    var s$1 = $as_Ltyrian_Sub$OfObservable(s);
    _return$1: {
      var these$1 = stillActives$3;
      while ((!these$1.isEmpty__Z())) {
        var arg1$2 = these$1.head__O();
        var _$2 = $as_T2(arg1$2);
        var x$2 = _$2._1__O();
        var x$2$1 = s$1.Ltyrian_Sub$OfObservable__f_id;
        if ((!(!((x$2 === null) ? (x$2$1 === null) : $dp_equals__O__Z(x$2, x$2$1))))) {
          var $$x2 = false;
          break _return$1
        };
        these$1 = $as_sci_List(these$1.tail__O())
      };
      var $$x2 = true
    };
    if ($$x2) {
      return (!this$2$1.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions.contains__O__Z(s$1.Ltyrian_Sub$OfObservable__f_id))
    } else {
      return false
    }
  }))(this, stillActives$2);
  var l$1 = allSubs;
  block: {
    var result;
    while (true) {
      if (l$1.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = l$1.head__O();
        var t = $as_sci_List(l$1.tail__O());
        if (($uZ(f(h)) === false)) {
          l$1 = t;
          continue
        };
        var start = l$1;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x$4 = remaining.head__O();
            if (($uZ(f(x$4)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  var this$8 = this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions;
  var f$1 = ((_$3) => {
    var _$3$1 = $as_Ltyrian_Sub$OfObservable(_$3);
    return _$3$1.Ltyrian_Sub$OfObservable__f_id
  });
  if ((result === $m_sci_Nil$())) {
    var that = $m_sci_Nil$()
  } else {
    var arg1$3 = result.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
    var t$1 = h$1;
    var rest = $as_sci_List(result.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$4 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var that = h$1
  };
  this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $as_sci_Set(this$8.concat__sc_IterableOnce__sc_SetOps(that));
  this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = stillActives$2;
  var thunk$2 = new $c_sjsr_AnonFunction0(((this$3$1, callback$2, discarded$3, newSubs$2) => (() => {
    var these$2 = discarded$3;
    while ((!these$2.isEmpty__Z())) {
      var arg1$5 = these$2.head__O();
      var _$4 = $as_T2(arg1$5);
      $as_Ltyrian_Task$Cancelable(_$4._2__O()).cancel__V();
      these$2 = $as_sci_List(these$2.tail__O())
    };
    var these$3 = newSubs$2;
    while ((!these$3.isEmpty__Z())) {
      var arg1$6 = these$3.head__O();
      var x$1$1 = $as_Ltyrian_Sub$OfObservable(arg1$6);
      matchResult6: {
        if ((x$1$1 !== null)) {
          var x27 = x$1$1.Ltyrian_Sub$OfObservable__f_id;
          var x28 = x$1$1.Ltyrian_Sub$OfObservable__f_observable;
          var x29 = x$1$1.Ltyrian_Sub$OfObservable__f_f;
          var notifier = x29.andThen__F1__F1(callback$2);
          var cancelable = x28.run__Ltyrian_Task$Observer__Ltyrian_Task$Cancelable(new $c_Ltyrian_runtime_TaskRunner$$anon$1(notifier));
          var this$11 = this$3$1.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions;
          this$3$1.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $as_sci_Set(this$11.excl__O__sci_SetOps(x27));
          var elem$1 = $ct_T2__O__O__(new $c_T2(), x27, cancelable);
          var this$14 = this$3$1.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions;
          this$3$1.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = new $c_sci_$colon$colon(elem$1, this$14);
          break matchResult6
        };
        throw new $c_s_MatchError(x$1$1)
      };
      these$3 = $as_sci_List(these$3.tail__O())
    }
  }))(this, callback, discarded$2, result));
  $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(0.0, thunk$2)
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.toVNode__Ltyrian_Html__Lsnabbdom_VNode = (function(html) {
  if ((html instanceof $c_Ltyrian_Tag)) {
    var x$1 = $as_Ltyrian_Tag(html);
    var x72 = x$1.Ltyrian_Tag__f_name;
    var x73 = x$1.Ltyrian_Tag__f_attributes;
    var x74 = x$1.Ltyrian_Tag__f_children;
    var properties = x73.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_TyrianRuntime$$anon$1());
    var as = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
    var properties$1 = x73.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_TyrianRuntime$$anon$2());
    var props = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties$1);
    var properties$2 = x73.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_TyrianRuntime$$anon$3(this));
    var events = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties$2);
    var f = ((this$5) => ((x$1$1) => {
      var x$1$2 = $as_Ltyrian_Elem(x$1$1);
      matchResult13: {
        var $$x1;
        if ((x$1$2 instanceof $c_Ltyrian_Text)) {
          var t = $as_Ltyrian_Text(x$1$2);
          var s = t.Ltyrian_Text__f_value;
          var $$x1 = new $c_Lsnabbdom_VNodeParam$Text(s);
          break matchResult13
        };
        if ($is_Ltyrian_Html(x$1$2)) {
          var subHtml = $as_Ltyrian_Html(x$1$2);
          var vnode = this$5.toVNode__Ltyrian_Html__Lsnabbdom_VNode(subHtml);
          var $$x1 = new $c_Lsnabbdom_VNodeParam$Node(vnode);
          break matchResult13
        };
        throw new $c_s_MatchError(x$1$2)
      };
      return $as_Lsnabbdom_VNodeParam($$x1)
    }))(this);
    if ((x74 === $m_sci_Nil$())) {
      var childrenElem = $m_sci_Nil$()
    } else {
      var arg1 = x74.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t$1 = h;
      var rest = $as_sci_List(x74.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest = $as_sci_List(rest.tail__O())
      };
      var childrenElem = h
    };
    var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), "props", props), $ct_T2__O__O__(new $c_T2(), "attrs", as), $ct_T2__O__O__(new $c_T2(), "on", events)]));
    var opts = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    return $f_Lsnabbdom_SnabbdomSyntax__h__T__sjs_js_Object__sci_Seq__Lsnabbdom_VNode(this, x72, opts, childrenElem)
  };
  throw new $c_s_MatchError(html)
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.render__sjs_js_Object__O__Lsnabbdom_VNode = (function(oldNode, model) {
  return $p_Ltyrian_runtime_TyrianRuntime__patch__F2(this).apply__O__O__O(oldNode, this.toVNode__Ltyrian_Html__Lsnabbdom_VNode($as_Ltyrian_Html(this.Ltyrian_runtime_TyrianRuntime__f_view.apply__O__O(model))))
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.start__V = (function() {
  this.performSideEffects__Ltyrian_Cmd__Ltyrian_Sub__F1__V(this.Ltyrian_runtime_TyrianRuntime__f_initCmd, $as_Ltyrian_Sub(this.Ltyrian_runtime_TyrianRuntime__f_subscriptions.apply__O__O(this.Ltyrian_runtime_TyrianRuntime__f_currentState)), new $c_sjsr_AnonFunction1(((this$1) => ((msg) => {
    this$1.onMsg__O__V(msg)
  }))(this)))
});
var $d_Ltyrian_runtime_TyrianRuntime = new $TypeData().initClass({
  Ltyrian_runtime_TyrianRuntime: 0
}, false, "tyrian.runtime.TyrianRuntime", {
  Ltyrian_runtime_TyrianRuntime: 1,
  O: 1,
  Lsnabbdom_SnabbdomSyntax: 1
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.$classData = $d_Ltyrian_runtime_TyrianRuntime;
/** @constructor */
function $c_Lcats_Bifunctor$$anon$5(target$2, tc$2) {
  this.Lcats_Bifunctor$$anon$5__f_self = null;
  this.Lcats_Bifunctor$$anon$5__f_typeClassInstance = null;
  this.Lcats_Bifunctor$$anon$5__f_self = target$2;
  this.Lcats_Bifunctor$$anon$5__f_typeClassInstance = tc$2
}
$c_Lcats_Bifunctor$$anon$5.prototype = new $h_O();
$c_Lcats_Bifunctor$$anon$5.prototype.constructor = $c_Lcats_Bifunctor$$anon$5;
/** @constructor */
function $h_Lcats_Bifunctor$$anon$5() {
  /*<skip>*/
}
$h_Lcats_Bifunctor$$anon$5.prototype = $c_Lcats_Bifunctor$$anon$5.prototype;
var $d_Lcats_Bifunctor$$anon$5 = new $TypeData().initClass({
  Lcats_Bifunctor$$anon$5: 0
}, false, "cats.Bifunctor$$anon$5", {
  Lcats_Bifunctor$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor$Ops: 1
});
$c_Lcats_Bifunctor$$anon$5.prototype.$classData = $d_Lcats_Bifunctor$$anon$5;
function $ct_Lcats_Eval$Defer__F0__($thiz, thunk) {
  $thiz.Lcats_Eval$Defer__f_thunk = thunk;
  return $thiz
}
/** @constructor */
function $c_Lcats_Eval$Defer() {
  this.Lcats_Eval$Defer__f_thunk = null
}
$c_Lcats_Eval$Defer.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Defer.prototype.constructor = $c_Lcats_Eval$Defer;
/** @constructor */
function $h_Lcats_Eval$Defer() {
  /*<skip>*/
}
$h_Lcats_Eval$Defer.prototype = $c_Lcats_Eval$Defer.prototype;
$c_Lcats_Eval$Defer.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this)
});
function $as_Lcats_Eval$Defer(obj) {
  return (((obj instanceof $c_Lcats_Eval$Defer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Defer"))
}
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)))
}
function $asArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Defer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Defer;", depth))
}
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
$c_Lcats_Eval$FlatMap.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this)
});
function $as_Lcats_Eval$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_Eval$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$FlatMap"))
}
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)))
}
function $asArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_Eval$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$FlatMap;", depth))
}
/** @constructor */
function $c_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $as_Lcats_Eval$Leaf(obj) {
  return (((obj instanceof $c_Lcats_Eval$Leaf) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Leaf"))
}
function $isArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Leaf)))
}
function $asArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Leaf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Leaf;", depth))
}
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$1();
  $thiz.Lcats_EvalInstances__f_catsDeferForEval = new $c_Lcats_EvalInstances$$anon$2();
  $thiz.Lcats_EvalInstances__f_catsReducibleForEval = new $c_Lcats_EvalInstances$$anon$3();
  $thiz.Lcats_EvalInstances__f_catsRepresentableForEval = new $c_Lcats_EvalInstances$$anon$4($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_EvalInstances__f_catsDeferForEval = null;
  this.Lcats_EvalInstances__f_catsReducibleForEval = null;
  this.Lcats_EvalInstances__f_catsRepresentableForEval = null
}
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
  /*<skip>*/
}
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$2.prototype.constructor = $c_Lcats_EvalInstances$$anon$2;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$2.prototype = $c_Lcats_EvalInstances$$anon$2.prototype;
var $d_Lcats_EvalInstances$$anon$2 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$2: 0
}, false, "cats.EvalInstances$$anon$2", {
  Lcats_EvalInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
});
$c_Lcats_EvalInstances$$anon$2.prototype.$classData = $d_Lcats_EvalInstances$$anon$2;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$4(outer) {
  this.Lcats_EvalInstances$$anon$4__f_F = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var instance = outer.Lcats_EvalInstances__f_catsBimonadForEval;
  this.Lcats_EvalInstances$$anon$4__f_F = instance
}
$c_Lcats_EvalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$4.prototype.constructor = $c_Lcats_EvalInstances$$anon$4;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$4.prototype = $c_Lcats_EvalInstances$$anon$4.prototype;
var $d_Lcats_EvalInstances$$anon$4 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$4: 0
}, false, "cats.EvalInstances$$anon$4", {
  Lcats_EvalInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
});
$c_Lcats_EvalInstances$$anon$4.prototype.$classData = $d_Lcats_EvalInstances$$anon$4;
/** @constructor */
function $c_Lcats_FlatMap$$anon$2(target$2, tc$2) {
  this.Lcats_FlatMap$$anon$2__f_self = null;
  this.Lcats_FlatMap$$anon$2__f_typeClassInstance = null;
  this.Lcats_FlatMap$$anon$2__f_self = target$2;
  this.Lcats_FlatMap$$anon$2__f_typeClassInstance = tc$2
}
$c_Lcats_FlatMap$$anon$2.prototype = new $h_O();
$c_Lcats_FlatMap$$anon$2.prototype.constructor = $c_Lcats_FlatMap$$anon$2;
/** @constructor */
function $h_Lcats_FlatMap$$anon$2() {
  /*<skip>*/
}
$h_Lcats_FlatMap$$anon$2.prototype = $c_Lcats_FlatMap$$anon$2.prototype;
var $d_Lcats_FlatMap$$anon$2 = new $TypeData().initClass({
  Lcats_FlatMap$$anon$2: 0
}, false, "cats.FlatMap$$anon$2", {
  Lcats_FlatMap$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FlatMap$Ops: 1
});
$c_Lcats_FlatMap$$anon$2.prototype.$classData = $d_Lcats_FlatMap$$anon$2;
/** @constructor */
function $c_Lcats_Foldable$$anon$2() {
  /*<skip>*/
}
$c_Lcats_Foldable$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_Foldable$$anon$2.prototype.constructor = $c_Lcats_Foldable$$anon$2;
/** @constructor */
function $h_Lcats_Foldable$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$2.prototype = $c_Lcats_Foldable$$anon$2.prototype;
$c_Lcats_Foldable$$anon$2.prototype.apply__O__O = (function(a) {
  return this
});
var $d_Lcats_Foldable$$anon$2 = new $TypeData().initClass({
  Lcats_Foldable$$anon$2: 0
}, false, "cats.Foldable$$anon$2", {
  Lcats_Foldable$$anon$2: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_Lcats_Foldable$$anon$2.prototype.$classData = $d_Lcats_Foldable$$anon$2;
/** @constructor */
function $c_Lcats_Foldable$$anon$6(target$2, tc$2) {
  this.Lcats_Foldable$$anon$6__f_self = null;
  this.Lcats_Foldable$$anon$6__f_typeClassInstance = null;
  this.Lcats_Foldable$$anon$6__f_self = target$2;
  this.Lcats_Foldable$$anon$6__f_typeClassInstance = tc$2
}
$c_Lcats_Foldable$$anon$6.prototype = new $h_O();
$c_Lcats_Foldable$$anon$6.prototype.constructor = $c_Lcats_Foldable$$anon$6;
/** @constructor */
function $h_Lcats_Foldable$$anon$6() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$6.prototype = $c_Lcats_Foldable$$anon$6.prototype;
var $d_Lcats_Foldable$$anon$6 = new $TypeData().initClass({
  Lcats_Foldable$$anon$6: 0
}, false, "cats.Foldable$$anon$6", {
  Lcats_Foldable$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable$Ops: 1
});
$c_Lcats_Foldable$$anon$6.prototype.$classData = $d_Lcats_Foldable$$anon$6;
/** @constructor */
function $c_Lcats_Functor$$anon$4(target$2, tc$2) {
  this.Lcats_Functor$$anon$4__f_self = null;
  this.Lcats_Functor$$anon$4__f_typeClassInstance = null;
  this.Lcats_Functor$$anon$4__f_self = target$2;
  this.Lcats_Functor$$anon$4__f_typeClassInstance = tc$2
}
$c_Lcats_Functor$$anon$4.prototype = new $h_O();
$c_Lcats_Functor$$anon$4.prototype.constructor = $c_Lcats_Functor$$anon$4;
/** @constructor */
function $h_Lcats_Functor$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Functor$$anon$4.prototype = $c_Lcats_Functor$$anon$4.prototype;
var $d_Lcats_Functor$$anon$4 = new $TypeData().initClass({
  Lcats_Functor$$anon$4: 0
}, false, "cats.Functor$$anon$4", {
  Lcats_Functor$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Functor$Ops: 1
});
$c_Lcats_Functor$$anon$4.prototype.$classData = $d_Lcats_Functor$$anon$4;
/** @constructor */
function $c_Lcats_Invariant$$anon$10() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$10.prototype = new $h_O();
$c_Lcats_Invariant$$anon$10.prototype.constructor = $c_Lcats_Invariant$$anon$10;
/** @constructor */
function $h_Lcats_Invariant$$anon$10() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$10.prototype = $c_Lcats_Invariant$$anon$10.prototype;
var $d_Lcats_Invariant$$anon$10 = new $TypeData().initClass({
  Lcats_Invariant$$anon$10: 0
}, false, "cats.Invariant$$anon$10", {
  Lcats_Invariant$$anon$10: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$10.prototype.$classData = $d_Lcats_Invariant$$anon$10;
/** @constructor */
function $c_Lcats_Invariant$$anon$4() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$4.prototype = new $h_O();
$c_Lcats_Invariant$$anon$4.prototype.constructor = $c_Lcats_Invariant$$anon$4;
/** @constructor */
function $h_Lcats_Invariant$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$4.prototype = $c_Lcats_Invariant$$anon$4.prototype;
var $d_Lcats_Invariant$$anon$4 = new $TypeData().initClass({
  Lcats_Invariant$$anon$4: 0
}, false, "cats.Invariant$$anon$4", {
  Lcats_Invariant$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$4.prototype.$classData = $d_Lcats_Invariant$$anon$4;
/** @constructor */
function $c_Lcats_Invariant$$anon$5() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$5.prototype = new $h_O();
$c_Lcats_Invariant$$anon$5.prototype.constructor = $c_Lcats_Invariant$$anon$5;
/** @constructor */
function $h_Lcats_Invariant$$anon$5() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$5.prototype = $c_Lcats_Invariant$$anon$5.prototype;
var $d_Lcats_Invariant$$anon$5 = new $TypeData().initClass({
  Lcats_Invariant$$anon$5: 0
}, false, "cats.Invariant$$anon$5", {
  Lcats_Invariant$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$5.prototype.$classData = $d_Lcats_Invariant$$anon$5;
/** @constructor */
function $c_Lcats_Invariant$$anon$6() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$6.prototype = new $h_O();
$c_Lcats_Invariant$$anon$6.prototype.constructor = $c_Lcats_Invariant$$anon$6;
/** @constructor */
function $h_Lcats_Invariant$$anon$6() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$6.prototype = $c_Lcats_Invariant$$anon$6.prototype;
var $d_Lcats_Invariant$$anon$6 = new $TypeData().initClass({
  Lcats_Invariant$$anon$6: 0
}, false, "cats.Invariant$$anon$6", {
  Lcats_Invariant$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$6.prototype.$classData = $d_Lcats_Invariant$$anon$6;
/** @constructor */
function $c_Lcats_Invariant$$anon$7() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$7.prototype = new $h_O();
$c_Lcats_Invariant$$anon$7.prototype.constructor = $c_Lcats_Invariant$$anon$7;
/** @constructor */
function $h_Lcats_Invariant$$anon$7() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$7.prototype = $c_Lcats_Invariant$$anon$7.prototype;
var $d_Lcats_Invariant$$anon$7 = new $TypeData().initClass({
  Lcats_Invariant$$anon$7: 0
}, false, "cats.Invariant$$anon$7", {
  Lcats_Invariant$$anon$7: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$7.prototype.$classData = $d_Lcats_Invariant$$anon$7;
/** @constructor */
function $c_Lcats_Invariant$$anon$8() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$8.prototype = new $h_O();
$c_Lcats_Invariant$$anon$8.prototype.constructor = $c_Lcats_Invariant$$anon$8;
/** @constructor */
function $h_Lcats_Invariant$$anon$8() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$8.prototype = $c_Lcats_Invariant$$anon$8.prototype;
var $d_Lcats_Invariant$$anon$8 = new $TypeData().initClass({
  Lcats_Invariant$$anon$8: 0
}, false, "cats.Invariant$$anon$8", {
  Lcats_Invariant$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$8.prototype.$classData = $d_Lcats_Invariant$$anon$8;
/** @constructor */
function $c_Lcats_Invariant$$anon$9() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$9.prototype = new $h_O();
$c_Lcats_Invariant$$anon$9.prototype.constructor = $c_Lcats_Invariant$$anon$9;
/** @constructor */
function $h_Lcats_Invariant$$anon$9() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$9.prototype = $c_Lcats_Invariant$$anon$9.prototype;
var $d_Lcats_Invariant$$anon$9 = new $TypeData().initClass({
  Lcats_Invariant$$anon$9: 0
}, false, "cats.Invariant$$anon$9", {
  Lcats_Invariant$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$9.prototype.$classData = $d_Lcats_Invariant$$anon$9;
/** @constructor */
function $c_Lcats_SemigroupK$$anon$1(outer) {
  this.Lcats_SemigroupK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_SemigroupK$$anon$1__f_$outer = outer
}
$c_Lcats_SemigroupK$$anon$1.prototype = new $h_O();
$c_Lcats_SemigroupK$$anon$1.prototype.constructor = $c_Lcats_SemigroupK$$anon$1;
/** @constructor */
function $h_Lcats_SemigroupK$$anon$1() {
  /*<skip>*/
}
$h_Lcats_SemigroupK$$anon$1.prototype = $c_Lcats_SemigroupK$$anon$1.prototype;
$c_Lcats_SemigroupK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.Lcats_SemigroupK$$anon$1__f_$outer.combineK__O__O__O(x, y)
});
var $d_Lcats_SemigroupK$$anon$1 = new $TypeData().initClass({
  Lcats_SemigroupK$$anon$1: 0
}, false, "cats.SemigroupK$$anon$1", {
  Lcats_SemigroupK$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
});
$c_Lcats_SemigroupK$$anon$1.prototype.$classData = $d_Lcats_SemigroupK$$anon$1;
/** @constructor */
function $c_Lcats_Semigroupal$() {
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrder = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrder = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrdering = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrdering = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEq = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEquiv = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForMonoid = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForSemigroup = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForCommutativeSemigroup = null;
  $n_Lcats_Semigroupal$ = this;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrder = $m_Lcats_instances_package$order$().Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrder = $m_Lcats_instances_package$partialOrder$().Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrdering = $m_Lcats_instances_package$ordering$().Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrdering = $m_Lcats_instances_package$partialOrdering$().Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEq = $m_Lcats_instances_package$eq$().Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEquiv = $m_Lcats_instances_package$equiv$().Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv;
  this.Lcats_Semigroupal$__f_catsSemigroupalForMonoid = ($m_Lcats_instances_package$invariant$(), new $c_Lcats_instances_InvariantMonoidalInstances$$anon$3());
  this.Lcats_Semigroupal$__f_catsSemigroupalForSemigroup = $m_Lcats_instances_package$invariant$().Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup;
  this.Lcats_Semigroupal$__f_catsSemigroupalForCommutativeSemigroup = $m_Lcats_instances_package$invariant$().Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup
}
$c_Lcats_Semigroupal$.prototype = new $h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
  /*<skip>*/
}
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $TypeData().initClass({
  Lcats_Semigroupal$: 0
}, false, "cats.Semigroupal$", {
  Lcats_Semigroupal$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1
});
$c_Lcats_Semigroupal$.prototype.$classData = $d_Lcats_Semigroupal$;
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$()
  };
  return $n_Lcats_Semigroupal$
}
/** @constructor */
function $c_Lcats_Traverse$$anon$3(target$2, tc$2) {
  this.Lcats_Traverse$$anon$3__f_self = null;
  this.Lcats_Traverse$$anon$3__f_typeClassInstance = null;
  this.Lcats_Traverse$$anon$3__f_self = target$2;
  this.Lcats_Traverse$$anon$3__f_typeClassInstance = tc$2
}
$c_Lcats_Traverse$$anon$3.prototype = new $h_O();
$c_Lcats_Traverse$$anon$3.prototype.constructor = $c_Lcats_Traverse$$anon$3;
/** @constructor */
function $h_Lcats_Traverse$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Traverse$$anon$3.prototype = $c_Lcats_Traverse$$anon$3.prototype;
var $d_Lcats_Traverse$$anon$3 = new $TypeData().initClass({
  Lcats_Traverse$$anon$3: 0
}, false, "cats.Traverse$$anon$3", {
  Lcats_Traverse$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Traverse$Ops: 1
});
$c_Lcats_Traverse$$anon$3.prototype.$classData = $d_Lcats_Traverse$$anon$3;
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$orEvalMonoid = null;
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$andEvalMonoid = null;
  $n_Lcats_UnorderedFoldable$ = this;
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$orEvalMonoid = new $c_Lcats_UnorderedFoldable$$anon$1();
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$andEvalMonoid = new $c_Lcats_UnorderedFoldable$$anon$2()
}
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass({
  Lcats_UnorderedFoldable$: 0
}, false, "cats.UnorderedFoldable$", {
  Lcats_UnorderedFoldable$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Lcats_instances_NTupleUnorderedFoldableInstances: 1
});
$c_Lcats_UnorderedFoldable$.prototype.$classData = $d_Lcats_UnorderedFoldable$;
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$()
  };
  return $n_Lcats_UnorderedFoldable$
}
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass({
  Lcats_arrow_FunctionK$$anon$4: 0
}, false, "cats.arrow.FunctionK$$anon$4", {
  Lcats_arrow_FunctionK$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_arrow_FunctionK$$anon$4.prototype.$classData = $d_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $c_Lcats_data_Chain$$anon$2() {
  /*<skip>*/
}
$c_Lcats_data_Chain$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_data_Chain$$anon$2.prototype.constructor = $c_Lcats_data_Chain$$anon$2;
/** @constructor */
function $h_Lcats_data_Chain$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_Chain$$anon$2.prototype = $c_Lcats_data_Chain$$anon$2.prototype;
$c_Lcats_data_Chain$$anon$2.prototype.apply__O__O = (function(a) {
  return this
});
var $d_Lcats_data_Chain$$anon$2 = new $TypeData().initClass({
  Lcats_data_Chain$$anon$2: 0
}, false, "cats.data.Chain$$anon$2", {
  Lcats_data_Chain$$anon$2: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_Lcats_data_Chain$$anon$2.prototype.$classData = $d_Lcats_data_Chain$$anon$2;
/** @constructor */
function $c_Lcats_data_ChainInstances1() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances1.prototype = new $h_Lcats_data_ChainInstances2();
$c_Lcats_data_ChainInstances1.prototype.constructor = $c_Lcats_data_ChainInstances1;
/** @constructor */
function $h_Lcats_data_ChainInstances1() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances1.prototype = $c_Lcats_data_ChainInstances1.prototype;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = new $c_Lcats_data_NonEmptyListInstances$$anon$1();
  return $thiz
}
function $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$1$$_$go$1__F1__scm_ListBuffer__Lcats_data_NonEmptyList__V(f$9, buf$3, v) {
  var v$tailLocal1 = v;
  while (true) {
    matchResult18: {
      var x60 = $as_s_util_Either(v$tailLocal1.Lcats_data_NonEmptyList__f_head);
      if ((x60 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x60).s_util_Right__f_value;
        buf$3.addOne__O__scm_ListBuffer(b);
        matchResult17: {
          var x57 = $m_Lcats_data_NonEmptyList$().fromList__sci_List__s_Option(v$tailLocal1.Lcats_data_NonEmptyList__f_tail);
          if ((x57 instanceof $c_s_Some)) {
            var t = $as_Lcats_data_NonEmptyList($as_s_Some(x57).s_Some__f_value);
            v$tailLocal1 = t;
            continue
          };
          var x = $m_s_None$();
          if ((x === x57)) {
            break matchResult17
          };
          throw new $c_s_MatchError(x57)
        };
        break matchResult18
      };
      if ((x60 instanceof $c_s_util_Left)) {
        var a = $as_s_util_Left(x60).s_util_Left__f_value;
        var this$1 = $as_Lcats_data_NonEmptyList(f$9.apply__O__O(a));
        var l = v$tailLocal1.Lcats_data_NonEmptyList__f_tail;
        v$tailLocal1 = this$1.concat__sci_List__Lcats_data_NonEmptyList(l);
        continue
      };
      throw new $c_s_MatchError(x60)
    };
    return (void 0)
  }
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null
}
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
$c_Lcats_data_NonEmptyListInstances.prototype.catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup = (function() {
  var instance = $as_Lcats_SemigroupK(this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList);
  return instance.algebra__Lcats_kernel_Semigroup()
});
function $ct_Lcats_data_ValidatedInstances__($thiz) {
  $thiz.Lcats_data_ValidatedInstances__f_catsDataBitraverseForValidated = new $c_Lcats_data_ValidatedInstances$$anon$1();
  return $thiz
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances() {
  this.Lcats_data_ValidatedInstances__f_catsDataBitraverseForValidated = null
}
$c_Lcats_data_ValidatedInstances.prototype = new $h_Lcats_data_ValidatedInstances1();
$c_Lcats_data_ValidatedInstances.prototype.constructor = $c_Lcats_data_ValidatedInstances;
/** @constructor */
function $h_Lcats_data_ValidatedInstances() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances.prototype = $c_Lcats_data_ValidatedInstances.prototype;
/** @constructor */
function $c_Lcats_data_WriterTInstances11() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances11.prototype = new $h_Lcats_data_WriterTInstances12();
$c_Lcats_data_WriterTInstances11.prototype.constructor = $c_Lcats_data_WriterTInstances11;
/** @constructor */
function $h_Lcats_data_WriterTInstances11() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances11.prototype = $c_Lcats_data_WriterTInstances11.prototype;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$3() {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$3.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$3.prototype = $c_Lcats_instances_EitherInstances$$anon$3.prototype;
$c_Lcats_instances_EitherInstances$$anon$3.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.combineK__s_util_Either__s_util_Either__s_util_Either = (function(x, y) {
  if ((x instanceof $c_s_util_Left)) {
    return y
  };
  if ((x instanceof $c_s_util_Right)) {
    return x
  };
  throw new $c_s_MatchError(x)
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_util_Either__s_util_Either__s_util_Either($as_s_util_Either(x), $as_s_util_Either(y))
});
var $d_Lcats_instances_EitherInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$3: 0
}, false, "cats.instances.EitherInstances$$anon$3", {
  Lcats_instances_EitherInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$3;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$4(fa$4, fb$2) {
  this.Lcats_instances_EquivInstances$$anon$4__f_fa$1 = null;
  this.Lcats_instances_EquivInstances$$anon$4__f_fb$1 = null;
  this.Lcats_instances_EquivInstances$$anon$4__f_fa$1 = fa$4;
  this.Lcats_instances_EquivInstances$$anon$4__f_fb$1 = fb$2
}
$c_Lcats_instances_EquivInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$4.prototype;
var $d_Lcats_instances_EquivInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$4: 0
}, false, "cats.instances.EquivInstances$$anon$4", {
  Lcats_instances_EquivInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
});
$c_Lcats_instances_EquivInstances$$anon$4.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(this)
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.FunctionInstancesBinCompat0$$anon$1", {
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(outer) {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = outer
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$() {
  /*<skip>*/
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.toString__T = (function() {
  return "Deferred"
});
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ = new $TypeData().initClass({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 0
}, false, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred$", {
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.$classData = $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstances$$anon$1.prototype = $c_Lcats_instances_InvariantInstances$$anon$1.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantInstances$$anon$1: 0
}, false, "cats.instances.InvariantInstances$$anon$1", {
  Lcats_instances_InvariantInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstances$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstances$$anon$2.prototype = $c_Lcats_instances_InvariantInstances$$anon$2.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_InvariantInstances$$anon$2: 0
}, false, "cats.instances.InvariantInstances$$anon$2", {
  Lcats_instances_InvariantInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstances$$anon$2.prototype.$classData = $d_Lcats_instances_InvariantInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_InvariantInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.InvariantInstancesBinCompat0$$anon$1", {
  Lcats_instances_InvariantInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4(fa$13, fb$5) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fa$1 = fa$13;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fb$1 = fb$5
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fa$1.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fb$1.combine__O__O__O(x._2__O(), y._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$4", {
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_MapInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_MapInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_MapInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_MapInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_MapInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.MapInstancesBinCompat0$$anon$1", {
  Lcats_instances_MapInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1
});
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_MapInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.product__sci_SortedSet__sci_SortedSet__sci_SortedSet = (function(fa, fb) {
  var orderingA = fa.ordering__s_math_Ordering();
  var orderingB = fb.ordering__s_math_Ordering();
  return $as_sci_SortedSet(fa.flatMap__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((fb$2, orderingA$2, orderingB$2) => ((a) => $as_sci_SortedSet(fb$2.map__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((a$2) => ((b) => $ct_T2__O__O__(new $c_T2(), a$2, b)))(a)), new $c_s_math_Ordering$Tuple2Ordering(orderingA$2, orderingB$2)))))(fb, orderingA, orderingB)), new $c_s_math_Ordering$Tuple2Ordering(orderingA, orderingB)))
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__sci_SortedSet__sci_SortedSet__sci_SortedSet($as_sci_SortedSet(fa), $as_sci_SortedSet(fb))
});
var $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.SortedSetInstancesBinCompat0$$anon$1", {
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1;
function $is_Lcats_kernel_CommutativeSemigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $as_Lcats_kernel_CommutativeSemigroup(obj) {
  return (($is_Lcats_kernel_CommutativeSemigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.CommutativeSemigroup"))
}
function $isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $asArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.CommutativeSemigroup;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
  this.Lcats_kernel_Comparison$__f_SomeGt = null;
  this.Lcats_kernel_Comparison$__f_SomeEq = null;
  this.Lcats_kernel_Comparison$__f_SomeLt = null;
  this.Lcats_kernel_Comparison$__f_catsKernelEqForComparison = null;
  $n_Lcats_kernel_Comparison$ = this;
  var value = $m_Lcats_kernel_Comparison$GreaterThan$();
  this.Lcats_kernel_Comparison$__f_SomeGt = new $c_s_Some(value);
  var value$1 = $m_Lcats_kernel_Comparison$EqualTo$();
  this.Lcats_kernel_Comparison$__f_SomeEq = new $c_s_Some(value$1);
  var value$2 = $m_Lcats_kernel_Comparison$LessThan$();
  this.Lcats_kernel_Comparison$__f_SomeLt = new $c_s_Some(value$2);
  this.Lcats_kernel_Comparison$__f_catsKernelEqForComparison = new $c_Lcats_kernel_Comparison$$anon$1()
}
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
$c_Lcats_kernel_Comparison$.prototype.ordinal__Lcats_kernel_Comparison__I = (function(x$0) {
  if ((x$0 === $m_Lcats_kernel_Comparison$GreaterThan$())) {
    return 0
  };
  if ((x$0 === $m_Lcats_kernel_Comparison$EqualTo$())) {
    return 1
  };
  if ((x$0 === $m_Lcats_kernel_Comparison$LessThan$())) {
    return 2
  };
  throw new $c_s_MatchError(x$0)
});
$c_Lcats_kernel_Comparison$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_kernel_Comparison__I($as_Lcats_kernel_Comparison(x))
});
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$: 0
}, false, "cats.kernel.Comparison$", {
  Lcats_kernel_Comparison$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_kernel_Comparison$.prototype.$classData = $d_Lcats_kernel_Comparison$;
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$()
  };
  return $n_Lcats_kernel_Comparison$
}
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$4(f$4) {
  this.Lcats_kernel_Eq$$anon$4__f_f$1 = null;
  this.Lcats_kernel_Eq$$anon$4__f_f$1 = f$4
}
$c_Lcats_kernel_Eq$$anon$4.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$4.prototype.constructor = $c_Lcats_kernel_Eq$$anon$4;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$4() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$4.prototype = $c_Lcats_kernel_Eq$$anon$4.prototype;
$c_Lcats_kernel_Eq$$anon$4.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Eq$$anon$4.prototype.eqv__O__O__Z = (function(x, y) {
  return $uZ(this.Lcats_kernel_Eq$$anon$4__f_f$1.apply__O__O__O(x, y))
});
var $d_Lcats_kernel_Eq$$anon$4 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$4: 0
}, false, "cats.kernel.Eq$$anon$4", {
  Lcats_kernel_Eq$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
});
$c_Lcats_kernel_Eq$$anon$4.prototype.$classData = $d_Lcats_kernel_Eq$$anon$4;
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$5() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$$anon$5.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$5.prototype.constructor = $c_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$5() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$5.prototype = $c_Lcats_kernel_Eq$$anon$5.prototype;
$c_Lcats_kernel_Eq$$anon$5.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Eq$$anon$5.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
});
var $d_Lcats_kernel_Eq$$anon$5 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$5: 0
}, false, "cats.kernel.Eq$$anon$5", {
  Lcats_kernel_Eq$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
});
$c_Lcats_kernel_Eq$$anon$5.prototype.$classData = $d_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $c_Lcats_kernel_GroupFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_GroupFunctions.prototype = new $h_Lcats_kernel_MonoidFunctions();
$c_Lcats_kernel_GroupFunctions.prototype.constructor = $c_Lcats_kernel_GroupFunctions;
/** @constructor */
function $h_Lcats_kernel_GroupFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_GroupFunctions.prototype = $c_Lcats_kernel_GroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass({
  Lcats_kernel_Hash$: 0
}, false, "cats.kernel.Hash$", {
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Hash$.prototype.$classData = $d_Lcats_kernel_Hash$;
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$()
  };
  return $n_Lcats_kernel_Hash$
}
function $is_Lcats_kernel_Monoid(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Monoid)))
}
function $as_Lcats_kernel_Monoid(obj) {
  return (($is_Lcats_kernel_Monoid(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Monoid"))
}
function $isArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Monoid)))
}
function $asArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Monoid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Monoid;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Monoid$() {
  /*<skip>*/
}
$c_Lcats_kernel_Monoid$.prototype = new $h_Lcats_kernel_MonoidFunctions();
$c_Lcats_kernel_Monoid$.prototype.constructor = $c_Lcats_kernel_Monoid$;
/** @constructor */
function $h_Lcats_kernel_Monoid$() {
  /*<skip>*/
}
$h_Lcats_kernel_Monoid$.prototype = $c_Lcats_kernel_Monoid$.prototype;
var $d_Lcats_kernel_Monoid$ = new $TypeData().initClass({
  Lcats_kernel_Monoid$: 0
}, false, "cats.kernel.Monoid$", {
  Lcats_kernel_Monoid$: 1,
  Lcats_kernel_MonoidFunctions: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Monoid$.prototype.$classData = $d_Lcats_kernel_Monoid$;
var $n_Lcats_kernel_Monoid$;
function $m_Lcats_kernel_Monoid$() {
  if ((!$n_Lcats_kernel_Monoid$)) {
    $n_Lcats_kernel_Monoid$ = new $c_Lcats_kernel_Monoid$()
  };
  return $n_Lcats_kernel_Monoid$
}
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0)
}
function $is_Lcats_kernel_PartialOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_PartialOrder)))
}
function $as_Lcats_kernel_PartialOrder(obj) {
  return (($is_Lcats_kernel_PartialOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.PartialOrder"))
}
function $isArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_PartialOrder)))
}
function $asArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (($isArrayOf_Lcats_kernel_PartialOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.PartialOrder;", depth))
}
function $p_Lcats_kernel_instances_ListEq__loop$1__sci_List__sci_List__Z($thiz, xs, ys) {
  var ys$tailLocal3 = ys;
  var xs$tailLocal3 = xs;
  while (true) {
    var x21 = xs$tailLocal3;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x21 === null) : x.equals__O__Z(x21))) {
      return ys$tailLocal3.isEmpty__Z()
    };
    if ((x21 instanceof $c_sci_$colon$colon)) {
      var x22 = $as_sci_$colon$colon(x21);
      var x24 = x22.sci_$colon$colon__f_next;
      var x$3 = x22.sci_$colon$colon__f_head;
      var x17 = ys$tailLocal3;
      if ((x17 instanceof $c_sci_$colon$colon)) {
        var x18 = $as_sci_$colon$colon(x17);
        var x20 = x18.sci_$colon$colon__f_next;
        var y = x18.sci_$colon$colon__f_head;
        if ($thiz.Lcats_kernel_instances_ListEq__f_ev.eqv__O__O__Z(x$3, y)) {
          xs$tailLocal3 = x24;
          ys$tailLocal3 = x20;
          continue
        } else {
          return false
        }
      };
      var x$4 = $m_s_package$().s_package$__f_Nil;
      if (((x$4 === null) ? (x17 === null) : x$4.equals__O__Z(x17))) {
        return false
      };
      throw new $c_s_MatchError(x17)
    };
    throw new $c_s_MatchError(x21)
  }
}
/** @constructor */
function $c_Lcats_kernel_instances_ListEq(ev) {
  this.Lcats_kernel_instances_ListEq__f_ev = null;
  this.Lcats_kernel_instances_ListEq__f_ev = ev
}
$c_Lcats_kernel_instances_ListEq.prototype = new $h_O();
$c_Lcats_kernel_instances_ListEq.prototype.constructor = $c_Lcats_kernel_instances_ListEq;
/** @constructor */
function $h_Lcats_kernel_instances_ListEq() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ListEq.prototype = $c_Lcats_kernel_instances_ListEq.prototype;
$c_Lcats_kernel_instances_ListEq.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__sci_List__sci_List__Z = (function(xs, ys) {
  return ((xs === ys) || $p_Lcats_kernel_instances_ListEq__loop$1__sci_List__sci_List__Z(this, xs, ys))
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_List__sci_List__Z($as_sci_List(x), $as_sci_List(y))
});
var $d_Lcats_kernel_instances_ListEq = new $TypeData().initClass({
  Lcats_kernel_instances_ListEq: 0
}, false, "cats.kernel.instances.ListEq", {
  Lcats_kernel_instances_ListEq: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
});
$c_Lcats_kernel_instances_ListEq.prototype.$classData = $d_Lcats_kernel_instances_ListEq;
/** @constructor */
function $c_Lcats_package$$anon$2() {
  this.Lcats_package$$anon$2__f_F = null;
  $m_Lcats_Invariant$();
  var instance = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lcats_package$$anon$2__f_F = instance
}
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
  /*<skip>*/
}
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass({
  Lcats_package$$anon$2: 0
}, false, "cats.package$$anon$2", {
  Lcats_package$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
});
$c_Lcats_package$$anon$2.prototype.$classData = $d_Lcats_package$$anon$2;
/** @constructor */
function $c_Ldiffson_circe_package$$anon$1() {
  this.Ldiffson_circe_package$$anon$1__f_A = null;
  this.Ldiffson_circe_package$$anon$1__f_F = null;
  $m_Lcats_implicits$();
  var instance = new $c_Lcats_instances_EitherInstances$$anon$2();
  this.Ldiffson_circe_package$$anon$1__f_A = instance;
  $m_Lcats_implicits$();
  var instance$1 = new $c_Lcats_instances_EitherInstances$$anon$2();
  this.Ldiffson_circe_package$$anon$1__f_F = instance$1
}
$c_Ldiffson_circe_package$$anon$1.prototype = new $h_O();
$c_Ldiffson_circe_package$$anon$1.prototype.constructor = $c_Ldiffson_circe_package$$anon$1;
/** @constructor */
function $h_Ldiffson_circe_package$$anon$1() {
  /*<skip>*/
}
$h_Ldiffson_circe_package$$anon$1.prototype = $c_Ldiffson_circe_package$$anon$1.prototype;
$c_Ldiffson_circe_package$$anon$1.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Ldiffson_circe_package$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var $$x2 = this.Ldiffson_circe_package$$anon$1__f_F;
  $m_Lcats_implicits$();
  var eab = c.get__T__Lio_circe_Decoder__s_util_Either("op", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString);
  matchResult23: {
    var $$x1;
    if ((eab instanceof $c_s_util_Left)) {
      var a = $as_s_util_Left(eab).s_util_Left__f_value;
      $m_s_package$();
      var _$6 = $as_Lio_circe_DecodingFailure(a);
      var history = new $c_sjsr_AnonFunction0(((_$6$2) => (() => _$6$2.history__sci_List()))(_$6));
      var value = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'op' field", history, _$6);
      var $$x1 = new $c_s_util_Left(value);
      break matchResult23
    };
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      var $$x1 = r;
      break matchResult23
    };
    throw new $c_s_MatchError(eab)
  };
  return $as_s_util_Either($$x2.flatMap__O__F1__O($$x1, new $c_sjsr_AnonFunction1(((this$5, c$2) => ((x$1) => {
    var x$1$1 = $as_T(x$1);
    if ((x$1$1 === "add")) {
      $m_Lcats_implicits$();
      var eab$1 = $as_s_util_Either(this$5.Ldiffson_circe_package$$anon$1__f_A.map2__O__O__F2__O(c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), c$2.get__T__Lio_circe_Decoder__s_util_Either("value", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson), new $c_sjsr_AnonFunction2(((path, value$1) => {
        var path$1 = ((path === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var value$2 = $as_Lio_circe_Json(value$1);
        var evidence$2 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Add(path$1, value$2, evidence$2)
      }))));
      if ((eab$1 instanceof $c_s_util_Left)) {
        var a$1 = $as_s_util_Left(eab$1).s_util_Left__f_value;
        $m_s_package$();
        var _$7 = $as_Lio_circe_DecodingFailure(a$1);
        var history$1 = new $c_sjsr_AnonFunction0(((_$7$2) => (() => _$7$2.history__sci_List()))(_$7));
        var value$3 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'path' or 'value' field", history$1, _$7);
        return new $c_s_util_Left(value$3)
      };
      if ((eab$1 instanceof $c_s_util_Right)) {
        var r$1 = $as_s_util_Right(eab$1);
        $m_Lcats_syntax_EitherUtil$();
        return r$1
      };
      throw new $c_s_MatchError(eab$1)
    } else if ((x$1$1 === "remove")) {
      $m_Lcats_implicits$();
      var $$x4 = this$5.Ldiffson_circe_package$$anon$1__f_A;
      var $$x3 = c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder);
      $m_Lio_circe_Decoder$();
      var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson;
      var eab$2 = $as_s_util_Either($$x4.map2__O__O__F2__O($$x3, c$2.get__T__Lio_circe_Decoder__s_util_Either("old", new $c_Lio_circe_Decoder$$anon$41(d)), new $c_sjsr_AnonFunction2(((path$2, old) => {
        var path$3 = ((path$2 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path$2).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var old$1 = $as_s_Option(old);
        var evidence$3 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Remove(path$3, old$1, evidence$3)
      }))));
      if ((eab$2 instanceof $c_s_util_Left)) {
        var a$2 = $as_s_util_Left(eab$2).s_util_Left__f_value;
        $m_s_package$();
        var _$8 = $as_Lio_circe_DecodingFailure(a$2);
        var history$2 = new $c_sjsr_AnonFunction0(((_$8$2) => (() => _$8$2.history__sci_List()))(_$8));
        var value$4 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'path' field", history$2, _$8);
        return new $c_s_util_Left(value$4)
      };
      if ((eab$2 instanceof $c_s_util_Right)) {
        var r$2 = $as_s_util_Right(eab$2);
        $m_Lcats_syntax_EitherUtil$();
        return r$2
      };
      throw new $c_s_MatchError(eab$2)
    } else if ((x$1$1 === "replace")) {
      $m_Lcats_implicits$();
      var this$19 = this$5.Ldiffson_circe_package$$anon$1__f_A;
      var f0 = c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder);
      var f1 = c$2.get__T__Lio_circe_Decoder__s_util_Either("value", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson);
      $m_Lio_circe_Decoder$();
      var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson;
      var f2 = c$2.get__T__Lio_circe_Decoder__s_util_Either("old", new $c_Lio_circe_Decoder$$anon$41(d$1));
      var f = new $c_sjsr_AnonFunction3(((path$3$1, value$2$1, old$2) => {
        var path$4 = ((path$3$1 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path$3$1).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var value$5 = $as_Lio_circe_Json(value$2$1);
        var old$3 = $as_s_Option(old$2);
        var evidence$4 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Replace(path$4, value$5, old$3, evidence$4)
      }));
      var this$20 = $m_Lcats_Semigroupal$();
      var eab$3 = $as_s_util_Either($f_Lcats_SemigroupalArityFunctions__map3__O__O__O__F3__Lcats_Semigroupal__Lcats_Functor__O(this$20, f0, f1, f2, f, this$19, this$19));
      if ((eab$3 instanceof $c_s_util_Left)) {
        var a$3 = $as_s_util_Left(eab$3).s_util_Left__f_value;
        $m_s_package$();
        var _$9 = $as_Lio_circe_DecodingFailure(a$3);
        var history$3 = new $c_sjsr_AnonFunction0(((_$9$2) => (() => _$9$2.history__sci_List()))(_$9));
        var value$6 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'path' or 'value' field", history$3, _$9);
        return new $c_s_util_Left(value$6)
      };
      if ((eab$3 instanceof $c_s_util_Right)) {
        var r$3 = $as_s_util_Right(eab$3);
        $m_Lcats_syntax_EitherUtil$();
        return r$3
      };
      throw new $c_s_MatchError(eab$3)
    } else if ((x$1$1 === "move")) {
      $m_Lcats_implicits$();
      var eab$4 = $as_s_util_Either(this$5.Ldiffson_circe_package$$anon$1__f_A.map2__O__O__F2__O(c$2.get__T__Lio_circe_Decoder__s_util_Either("from", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), new $c_sjsr_AnonFunction2(((from, path$4$1) => {
        var from$1 = ((from === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(from).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var path$5 = ((path$4$1 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path$4$1).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var evidence$5 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Move(from$1, path$5, evidence$5)
      }))));
      if ((eab$4 instanceof $c_s_util_Left)) {
        var a$4 = $as_s_util_Left(eab$4).s_util_Left__f_value;
        $m_s_package$();
        var _$10 = $as_Lio_circe_DecodingFailure(a$4);
        var history$4 = new $c_sjsr_AnonFunction0(((_$10$2) => (() => _$10$2.history__sci_List()))(_$10));
        var value$7 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'from' or 'path' field", history$4, _$10);
        return new $c_s_util_Left(value$7)
      };
      if ((eab$4 instanceof $c_s_util_Right)) {
        var r$4 = $as_s_util_Right(eab$4);
        $m_Lcats_syntax_EitherUtil$();
        return r$4
      };
      throw new $c_s_MatchError(eab$4)
    } else if ((x$1$1 === "copy")) {
      $m_Lcats_implicits$();
      var eab$5 = $as_s_util_Either(this$5.Ldiffson_circe_package$$anon$1__f_A.map2__O__O__F2__O(c$2.get__T__Lio_circe_Decoder__s_util_Either("from", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), new $c_sjsr_AnonFunction2(((from$2, path$5$1) => {
        var from$3 = ((from$2 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(from$2).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var path$6 = ((path$5$1 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path$5$1).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var evidence$6 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Copy(from$3, path$6, evidence$6)
      }))));
      if ((eab$5 instanceof $c_s_util_Left)) {
        var a$5 = $as_s_util_Left(eab$5).s_util_Left__f_value;
        $m_s_package$();
        var _$11 = $as_Lio_circe_DecodingFailure(a$5);
        var history$5 = new $c_sjsr_AnonFunction0(((_$11$2) => (() => _$11$2.history__sci_List()))(_$11));
        var value$8 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'from' or 'path' field", history$5, _$11);
        return new $c_s_util_Left(value$8)
      };
      if ((eab$5 instanceof $c_s_util_Right)) {
        var r$5 = $as_s_util_Right(eab$5);
        $m_Lcats_syntax_EitherUtil$();
        return r$5
      };
      throw new $c_s_MatchError(eab$5)
    } else if ((x$1$1 === "test")) {
      $m_Lcats_implicits$();
      var eab$6 = $as_s_util_Either(this$5.Ldiffson_circe_package$$anon$1__f_A.map2__O__O__F2__O(c$2.get__T__Lio_circe_Decoder__s_util_Either("path", $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_pointerDecoder), c$2.get__T__Lio_circe_Decoder__s_util_Either("value", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson), new $c_sjsr_AnonFunction2(((path$6$1, value$3$1) => {
        var path$7 = ((path$6$1 === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(path$6$1).Ldiffson_jsonpointer_package$Pointer__f_parts);
        var value$9 = $as_Lio_circe_Json(value$3$1);
        var evidence$7 = $m_Ldiffson_circe_package$jsonyCirce$();
        return new $c_Ldiffson_jsonpatch_Test(path$7, value$9, evidence$7)
      }))));
      if ((eab$6 instanceof $c_s_util_Left)) {
        var a$6 = $as_s_util_Left(eab$6).s_util_Left__f_value;
        $m_s_package$();
        var _$12 = $as_Lio_circe_DecodingFailure(a$6);
        var history$6 = new $c_sjsr_AnonFunction0(((_$12$2) => (() => _$12$2.history__sci_List()))(_$12));
        var value$10 = new $c_Lio_circe_DecodingFailure$$anon$1("missing 'path' or 'value' field", history$6, _$12);
        return new $c_s_util_Left(value$10)
      };
      if ((eab$6 instanceof $c_s_util_Right)) {
        var r$6 = $as_s_util_Right(eab$6);
        $m_Lcats_syntax_EitherUtil$();
        return r$6
      };
      throw new $c_s_MatchError(eab$6)
    } else {
      $m_s_package$();
      $m_Lio_circe_DecodingFailure$();
      var message = (("Unknown operation \"" + x$1$1) + "\"");
      var ops = new $c_sjsr_AnonFunction0(((c$1$2) => (() => c$1$2.history__sci_List()))(c$2));
      var value$11 = new $c_Lio_circe_DecodingFailure$$anon$2(message, ops);
      return new $c_s_util_Left(value$11)
    }
  }))(this, c))))
});
var $d_Ldiffson_circe_package$$anon$1 = new $TypeData().initClass({
  Ldiffson_circe_package$$anon$1: 0
}, false, "diffson.circe.package$$anon$1", {
  Ldiffson_circe_package$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Ldiffson_circe_package$$anon$1.prototype.$classData = $d_Ldiffson_circe_package$$anon$1;
/** @constructor */
function $c_Ldiffson_circe_package$$anon$2() {
  this.Ldiffson_circe_package$$anon$2__f_F = null;
  $m_Lcats_implicits$();
  var instance = new $c_Lcats_instances_EitherInstances$$anon$2();
  this.Ldiffson_circe_package$$anon$2__f_F = instance
}
$c_Ldiffson_circe_package$$anon$2.prototype = new $h_O();
$c_Ldiffson_circe_package$$anon$2.prototype.constructor = $c_Ldiffson_circe_package$$anon$2;
/** @constructor */
function $h_Ldiffson_circe_package$$anon$2() {
  /*<skip>*/
}
$h_Ldiffson_circe_package$$anon$2.prototype = $c_Ldiffson_circe_package$$anon$2.prototype;
$c_Ldiffson_circe_package$$anon$2.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Ldiffson_circe_package$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var $$x1 = this.Ldiffson_circe_package$$anon$2__f_F;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson;
  var d = new $c_Lio_circe_Decoder$$anon$45(decodeA);
  return $as_s_util_Either($$x1.flatMap__O__F1__O($f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(d, c), new $c_sjsr_AnonFunction1(((this$2) => ((list) => {
    var list$1 = $as_sci_List(list);
    var $$x2 = this$2.Ldiffson_circe_package$$anon$2__f_F;
    $m_Lcats_implicits$();
    var tc = $as_Lcats_Traverse($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
    var this$6 = new $c_Lcats_Traverse$$anon$3(list$1, tc);
    var f = new $c_sjsr_AnonFunction1(((_$15) => {
      var _$15$1 = $as_Lio_circe_Json(_$15);
      var d$1 = $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_operationDecoder;
      return d$1.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(_$15$1, null, null))
    }));
    $m_Lcats_implicits$();
    var ev$1 = new $c_Lcats_instances_EitherInstances$$anon$2();
    return $as_s_util_Either($$x2.map__O__F1__O(this$6.Lcats_Traverse$$anon$3__f_typeClassInstance.traverse__O__F1__Lcats_Applicative__O(this$6.Lcats_Traverse$$anon$3__f_self, f, ev$1), new $c_sjsr_AnonFunction1(((_$16) => {
      var _$16$1 = $as_sci_List(_$16);
      var evidence$8 = $m_Ldiffson_circe_package$jsonyCirce$();
      return new $c_Ldiffson_jsonpatch_JsonPatch(_$16$1, evidence$8)
    }))))
  }))(this))))
});
var $d_Ldiffson_circe_package$$anon$2 = new $TypeData().initClass({
  Ldiffson_circe_package$$anon$2: 0
}, false, "diffson.circe.package$$anon$2", {
  Ldiffson_circe_package$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Ldiffson_circe_package$$anon$2.prototype.$classData = $d_Ldiffson_circe_package$$anon$2;
/** @constructor */
function $c_Ldiffson_circe_package$$anon$3() {
  /*<skip>*/
}
$c_Ldiffson_circe_package$$anon$3.prototype = new $h_O();
$c_Ldiffson_circe_package$$anon$3.prototype.constructor = $c_Ldiffson_circe_package$$anon$3;
/** @constructor */
function $h_Ldiffson_circe_package$$anon$3() {
  /*<skip>*/
}
$h_Ldiffson_circe_package$$anon$3.prototype = $c_Ldiffson_circe_package$$anon$3.prototype;
$c_Ldiffson_circe_package$$anon$3.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Ldiffson_circe_package$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x41 = c.value__Lio_circe_Json().asObject__s_Option();
  if ((x41 instanceof $c_s_Some)) {
    var obj = $as_Lio_circe_JsonObject($as_s_Some(x41).s_Some__f_value);
    $m_s_package$();
    var fields = obj.toMap__sci_Map();
    var Json = $m_Ldiffson_circe_package$jsonyCirce$();
    var value = new $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object(fields, Json);
    return new $c_s_util_Right(value)
  };
  var x = $m_s_None$();
  if ((x === x41)) {
    $m_s_package$();
    var toJson = c.value__Lio_circe_Json();
    var value$1 = new $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value(toJson);
    return new $c_s_util_Right(value$1)
  };
  throw new $c_s_MatchError(x41)
});
var $d_Ldiffson_circe_package$$anon$3 = new $TypeData().initClass({
  Ldiffson_circe_package$$anon$3: 0
}, false, "diffson.circe.package$$anon$3", {
  Ldiffson_circe_package$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Ldiffson_circe_package$$anon$3.prototype.$classData = $d_Ldiffson_circe_package$$anon$3;
function $ct_Lio_circe_BiggerDecimalJsonNumber__T__($thiz, input) {
  $thiz.Lio_circe_BiggerDecimalJsonNumber__f_input = input;
  return $thiz
}
function $p_Lio_circe_BiggerDecimalJsonNumber__liftedTree1$1__Ljava_math_BigDecimal__s_math_BigDecimal($thiz, value$1) {
  try {
    var this$1 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
    var x = $thiz.Lio_circe_BiggerDecimalJsonNumber__f_input;
    return this$1.exact__T__s_math_BigDecimal(x)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      return $m_s_math_BigDecimal$().javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal(value$1)
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_Lio_circe_BiggerDecimalJsonNumber() {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null
}
$c_Lio_circe_BiggerDecimalJsonNumber.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.constructor = $c_Lio_circe_BiggerDecimalJsonNumber;
/** @constructor */
function $h_Lio_circe_BiggerDecimalJsonNumber() {
  /*<skip>*/
}
$h_Lio_circe_BiggerDecimalJsonNumber.prototype = $c_Lio_circe_BiggerDecimalJsonNumber.prototype;
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toBigInt__s_Option = (function() {
  var this$1 = this.Lio_circe_JsonBiggerDecimal__f_value;
  var this$2 = this$1.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits);
  if (this$2.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var _$1 = $as_Ljava_math_BigInteger(arg1);
    return new $c_s_Some($m_s_package$().BigInt__s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(_$1))
  }
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toBigDecimal__s_Option = (function() {
  var this$1 = this.Lio_circe_JsonBiggerDecimal__f_value.toBigDecimal__s_Option();
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var value = $as_Ljava_math_BigDecimal(arg1);
    var yn = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(value, yn)) {
      var this$2 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
      var bd = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
      var $$x1 = $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), bd, this$2.s_math_BigDecimal$__f_defaultMathContext)
    } else {
      var $$x1 = $p_Lio_circe_BiggerDecimalJsonNumber__liftedTree1$1__Ljava_math_BigDecimal__s_math_BigDecimal(this, value)
    };
    return new $c_s_Some($$x1)
  }
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toLong__s_Option = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value.toLong__s_Option()
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toString__T = (function() {
  return this.Lio_circe_BiggerDecimalJsonNumber__f_input
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var str = this.Lio_circe_BiggerDecimalJsonNumber__f_input;
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
/** @constructor */
function $c_Lio_circe_Decoder$$anon$1(f$12, outer) {
  this.Lio_circe_Decoder$$anon$1__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$1__f_$outer = null;
  this.Lio_circe_Decoder$$anon$1__f_f$1 = f$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$1__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$1.prototype.constructor = $c_Lio_circe_Decoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$1.prototype = $c_Lio_circe_Decoder$$anon$1.prototype;
$c_Lio_circe_Decoder$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$1.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x10 = this.Lio_circe_Decoder$$anon$1__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x10 instanceof $c_s_util_Right)) {
    var a = $as_s_util_Right(x10).s_util_Right__f_value;
    $m_s_package$();
    var value = this.Lio_circe_Decoder$$anon$1__f_f$1.apply__O__O(a);
    return new $c_s_util_Right(value)
  };
  if ((x10 instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(x10);
    return l
  };
  throw new $c_s_MatchError(x10)
});
var $d_Lio_circe_Decoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$1: 0
}, false, "io.circe.Decoder$$anon$1", {
  Lio_circe_Decoder$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$1.prototype.$classData = $d_Lio_circe_Decoder$$anon$1;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$13(f$16, outer) {
  this.Lio_circe_Decoder$$anon$13__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$13__f_$outer = null;
  this.Lio_circe_Decoder$$anon$13__f_f$1 = f$16;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$13__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$13.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$13.prototype.constructor = $c_Lio_circe_Decoder$$anon$13;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$13() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$13.prototype = $c_Lio_circe_Decoder$$anon$13.prototype;
$c_Lio_circe_Decoder$$anon$13.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$13.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x107 = this.Lio_circe_Decoder$$anon$13__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x107 instanceof $c_s_util_Right)) {
    var a = $as_s_util_Right(x107).s_util_Right__f_value;
    var x102 = $as_s_util_Either(this.Lio_circe_Decoder$$anon$13__f_f$1.apply__O__O(a));
    if ((x102 instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(x102);
      return r
    };
    if ((x102 instanceof $c_s_util_Left)) {
      var message = $as_T($as_s_util_Left(x102).s_util_Left__f_value);
      $m_s_package$();
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
      var value = new $c_Lio_circe_DecodingFailure$$anon$2(message, ops);
      return new $c_s_util_Left(value)
    };
    throw new $c_s_MatchError(x102)
  };
  if ((x107 instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(x107);
    return l
  };
  throw new $c_s_MatchError(x107)
});
var $d_Lio_circe_Decoder$$anon$13 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$13: 0
}, false, "io.circe.Decoder$$anon$13", {
  Lio_circe_Decoder$$anon$13: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$13.prototype.$classData = $d_Lio_circe_Decoder$$anon$13;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$15() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$15.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$15.prototype.constructor = $c_Lio_circe_Decoder$$anon$15;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$15() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$15.prototype = $c_Lio_circe_Decoder$$anon$15.prototype;
$c_Lio_circe_Decoder$$anon$15.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$15.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  return new $c_s_util_Right(c)
});
var $d_Lio_circe_Decoder$$anon$15 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$15: 0
}, false, "io.circe.Decoder$$anon$15", {
  Lio_circe_Decoder$$anon$15: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$15.prototype.$classData = $d_Lio_circe_Decoder$$anon$15;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$16() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$16.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$16.prototype.constructor = $c_Lio_circe_Decoder$$anon$16;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$16() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$16.prototype = $c_Lio_circe_Decoder$$anon$16.prototype;
$c_Lio_circe_Decoder$$anon$16.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$16.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  var value = c.value__Lio_circe_Json();
  return new $c_s_util_Right(value)
});
var $d_Lio_circe_Decoder$$anon$16 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$16: 0
}, false, "io.circe.Decoder$$anon$16", {
  Lio_circe_Decoder$$anon$16: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$16.prototype.$classData = $d_Lio_circe_Decoder$$anon$16;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$17() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$17.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$17.prototype.constructor = $c_Lio_circe_Decoder$$anon$17;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$17() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$17.prototype = $c_Lio_circe_Decoder$$anon$17.prototype;
$c_Lio_circe_Decoder$$anon$17.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$17.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x156 = c.value__Lio_circe_Json().asObject__s_Option();
  if ((x156 instanceof $c_s_Some)) {
    var v = $as_Lio_circe_JsonObject($as_s_Some(x156).s_Some__f_value);
    $m_s_package$();
    return new $c_s_util_Right(v)
  };
  var x = $m_s_None$();
  if ((x === x156)) {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("JsonObject", ops);
    return new $c_s_util_Left(value)
  };
  throw new $c_s_MatchError(x156)
});
var $d_Lio_circe_Decoder$$anon$17 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$17: 0
}, false, "io.circe.Decoder$$anon$17", {
  Lio_circe_Decoder$$anon$17: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$17.prototype.$classData = $d_Lio_circe_Decoder$$anon$17;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$18() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$18.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$18.prototype.constructor = $c_Lio_circe_Decoder$$anon$18;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$18() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$18.prototype = $c_Lio_circe_Decoder$$anon$18.prototype;
$c_Lio_circe_Decoder$$anon$18.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$18.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x159 = c.value__Lio_circe_Json().asNumber__s_Option();
  if ((x159 instanceof $c_s_Some)) {
    var v = $as_Lio_circe_JsonNumber($as_s_Some(x159).s_Some__f_value);
    $m_s_package$();
    return new $c_s_util_Right(v)
  };
  var x = $m_s_None$();
  if ((x === x159)) {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("JsonNumber", ops);
    return new $c_s_util_Left(value)
  };
  throw new $c_s_MatchError(x159)
});
var $d_Lio_circe_Decoder$$anon$18 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$18: 0
}, false, "io.circe.Decoder$$anon$18", {
  Lio_circe_Decoder$$anon$18: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$18.prototype.$classData = $d_Lio_circe_Decoder$$anon$18;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$19() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$19.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$19.prototype.constructor = $c_Lio_circe_Decoder$$anon$19;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$19() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$19.prototype = $c_Lio_circe_Decoder$$anon$19.prototype;
$c_Lio_circe_Decoder$$anon$19.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$19.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x162 = c.value__Lio_circe_Json();
  if ((x162 instanceof $c_Lio_circe_Json$JString)) {
    var x$1 = $as_Lio_circe_Json$JString(x162);
    var x165 = x$1.Lio_circe_Json$JString__f_value;
    $m_s_package$();
    return new $c_s_util_Right(x165)
  };
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("String", ops);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_Decoder$$anon$19 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$19: 0
}, false, "io.circe.Decoder$$anon$19", {
  Lio_circe_Decoder$$anon$19: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$19.prototype.$classData = $d_Lio_circe_Decoder$$anon$19;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$2(f$13, outer) {
  this.Lio_circe_Decoder$$anon$2__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$2__f_$outer = null;
  this.Lio_circe_Decoder$$anon$2__f_f$1 = f$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$2__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$2.prototype.constructor = $c_Lio_circe_Decoder$$anon$2;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$2.prototype = $c_Lio_circe_Decoder$$anon$2.prototype;
$c_Lio_circe_Decoder$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x15 = this.Lio_circe_Decoder$$anon$2__f_$outer.apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x15 instanceof $c_s_util_Right)) {
    var a = $as_s_util_Right(x15).s_util_Right__f_value;
    return $as_Lio_circe_Decoder(this.Lio_circe_Decoder$$anon$2__f_f$1.apply__O__O(a)).apply__Lio_circe_HCursor__s_util_Either(c)
  };
  if ((x15 instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(x15);
    return l
  };
  throw new $c_s_MatchError(x15)
});
$c_Lio_circe_Decoder$$anon$2.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x20 = this.Lio_circe_Decoder$$anon$2__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x20 instanceof $c_s_util_Right)) {
    var a = $as_s_util_Right(x20).s_util_Right__f_value;
    return $as_Lio_circe_Decoder(this.Lio_circe_Decoder$$anon$2__f_f$1.apply__O__O(a)).tryDecode__Lio_circe_ACursor__s_util_Either(c)
  };
  if ((x20 instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(x20);
    return l
  };
  throw new $c_s_MatchError(x20)
});
var $d_Lio_circe_Decoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$2: 0
}, false, "io.circe.Decoder$$anon$2", {
  Lio_circe_Decoder$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$2.prototype.$classData = $d_Lio_circe_Decoder$$anon$2;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$20() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$20.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$20.prototype.constructor = $c_Lio_circe_Decoder$$anon$20;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$20() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$20.prototype = $c_Lio_circe_Decoder$$anon$20.prototype;
$c_Lio_circe_Decoder$$anon$20.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$20.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x166 = c.value__Lio_circe_Json();
  if ((x166 instanceof $c_Lio_circe_Json$JObject)) {
    var x$1 = $as_Lio_circe_Json$JObject(x166);
    var x172 = x$1.Lio_circe_Json$JObject__f_value;
    if (x172.isEmpty__Z()) {
      $m_s_package$();
      return new $c_s_util_Right((void 0))
    }
  };
  if ((x166 instanceof $c_Lio_circe_Json$JArray)) {
    var x$1$1 = $as_Lio_circe_Json$JArray(x166);
    var x169 = x$1$1.Lio_circe_Json$JArray__f_value;
    if ($f_sc_SeqOps__isEmpty__Z(x169)) {
      $m_s_package$();
      return new $c_s_util_Right((void 0))
    }
  };
  if (x166.isNull__Z()) {
    $m_s_package$();
    return new $c_s_util_Right((void 0))
  };
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("Unit", ops);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_Decoder$$anon$20 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$20: 0
}, false, "io.circe.Decoder$$anon$20", {
  Lio_circe_Decoder$$anon$20: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$20.prototype.$classData = $d_Lio_circe_Decoder$$anon$20;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$21() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$21.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$21.prototype.constructor = $c_Lio_circe_Decoder$$anon$21;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$21() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$21.prototype = $c_Lio_circe_Decoder$$anon$21.prototype;
$c_Lio_circe_Decoder$$anon$21.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$21.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x173 = c.value__Lio_circe_Json();
  if ((x173 instanceof $c_Lio_circe_Json$JBoolean)) {
    var x$1 = $as_Lio_circe_Json$JBoolean(x173);
    var x176 = x$1.Lio_circe_Json$JBoolean__f_value;
    $m_s_package$();
    return new $c_s_util_Right(x176)
  };
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("Boolean", ops);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_Decoder$$anon$21 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$21: 0
}, false, "io.circe.Decoder$$anon$21", {
  Lio_circe_Decoder$$anon$21: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$21.prototype.$classData = $d_Lio_circe_Decoder$$anon$21;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$22() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$22.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$22.prototype.constructor = $c_Lio_circe_Decoder$$anon$22;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$22() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$22.prototype = $c_Lio_circe_Decoder$$anon$22.prototype;
$c_Lio_circe_Decoder$$anon$22.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$22.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x177 = c.value__Lio_circe_Json();
  if ((x177 instanceof $c_Lio_circe_Json$JString)) {
    var x$1 = $as_Lio_circe_Json$JString(x177);
    var x180 = x$1.Lio_circe_Json$JString__f_value;
    if (($uI(x180.length) === 1)) {
      $m_s_package$();
      var value = (65535 & $uI(x180.charCodeAt(0)));
      return new $c_s_util_Right($bC(value))
    }
  };
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
  var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("Char", ops);
  return new $c_s_util_Left(value$1)
});
var $d_Lio_circe_Decoder$$anon$22 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$22: 0
}, false, "io.circe.Decoder$$anon$22", {
  Lio_circe_Decoder$$anon$22: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$22.prototype.$classData = $d_Lio_circe_Decoder$$anon$22;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$3(f$14, outer) {
  this.Lio_circe_Decoder$$anon$3__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$3__f_$outer = null;
  this.Lio_circe_Decoder$$anon$3__f_f$1 = f$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$3__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$3.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$3.prototype.constructor = $c_Lio_circe_Decoder$$anon$3;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$3.prototype = $c_Lio_circe_Decoder$$anon$3.prototype;
$c_Lio_circe_Decoder$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$3.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance.handleErrorWith__O__F1__O(this.Lio_circe_Decoder$$anon$3__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c), new $c_sjsr_AnonFunction1(((this$1, c$2) => ((failure) => {
    var failure$1 = $as_Lio_circe_DecodingFailure(failure);
    return $as_Lio_circe_Decoder(this$1.Lio_circe_Decoder$$anon$3__f_f$1.apply__O__O(failure$1)).tryDecode__Lio_circe_ACursor__s_util_Either(c$2)
  }))(this, c))))
});
var $d_Lio_circe_Decoder$$anon$3 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$3: 0
}, false, "io.circe.Decoder$$anon$3", {
  Lio_circe_Decoder$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$3.prototype.$classData = $d_Lio_circe_Decoder$$anon$3;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$31() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$31.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$31.prototype.constructor = $c_Lio_circe_Decoder$$anon$31;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$31() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$31.prototype = $c_Lio_circe_Decoder$$anon$31.prototype;
$c_Lio_circe_Decoder$$anon$31.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  if (c.value__Lio_circe_Json().isNull__Z()) {
    $m_s_package$();
    var value = $m_s_None$();
    return new $c_s_util_Right(value)
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("None", ops);
    return new $c_s_util_Left(value$1)
  }
});
$c_Lio_circe_Decoder$$anon$31.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var c$2 = $as_Lio_circe_HCursor(c);
    if (c$2.value__Lio_circe_Json().isNull__Z()) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone
    } else {
      $m_s_package$();
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0(((c$3) => (() => c$3.history__sci_List()))(c$2));
      var value = new $c_Lio_circe_DecodingFailure$$anon$2("None", ops);
      return new $c_s_util_Left(value)
    }
  };
  if ((c instanceof $c_Lio_circe_FailedCursor)) {
    var c$4 = $as_Lio_circe_FailedCursor(c);
    if ((!c$4.incorrectFocus__Z())) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone
    } else {
      $m_s_package$();
      $m_Lio_circe_DecodingFailure$();
      var ops$1 = new $c_sjsr_AnonFunction0(((c$5) => (() => c$5.history__sci_List()))(c$4));
      var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("None", ops$1);
      return new $c_s_util_Left(value$1)
    }
  };
  throw new $c_s_MatchError(c)
});
var $d_Lio_circe_Decoder$$anon$31 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$31: 0
}, false, "io.circe.Decoder$$anon$31", {
  Lio_circe_Decoder$$anon$31: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$31.prototype.$classData = $d_Lio_circe_Decoder$$anon$31;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$33(a$4) {
  this.Lio_circe_Decoder$$anon$33__f_a$1 = null;
  this.Lio_circe_Decoder$$anon$33__f_a$1 = a$4
}
$c_Lio_circe_Decoder$$anon$33.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$33.prototype.constructor = $c_Lio_circe_Decoder$$anon$33;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$33() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$33.prototype = $c_Lio_circe_Decoder$$anon$33.prototype;
$c_Lio_circe_Decoder$$anon$33.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$33.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  var value = this.Lio_circe_Decoder$$anon$33__f_a$1;
  return new $c_s_util_Right(value)
});
var $d_Lio_circe_Decoder$$anon$33 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$33: 0
}, false, "io.circe.Decoder$$anon$33", {
  Lio_circe_Decoder$$anon$33: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$33.prototype.$classData = $d_Lio_circe_Decoder$$anon$33;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$38(failure$2) {
  this.Lio_circe_Decoder$$anon$38__f_failure$1 = null;
  this.Lio_circe_Decoder$$anon$38__f_failure$1 = failure$2
}
$c_Lio_circe_Decoder$$anon$38.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$38.prototype.constructor = $c_Lio_circe_Decoder$$anon$38;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$38() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$38.prototype = $c_Lio_circe_Decoder$$anon$38.prototype;
$c_Lio_circe_Decoder$$anon$38.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$38.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  var value = this.Lio_circe_Decoder$$anon$38__f_failure$1;
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_Decoder$$anon$38 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$38: 0
}, false, "io.circe.Decoder$$anon$38", {
  Lio_circe_Decoder$$anon$38: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$38.prototype.$classData = $d_Lio_circe_Decoder$$anon$38;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$41(d$4) {
  this.Lio_circe_Decoder$$anon$41__f_d$1 = null;
  this.Lio_circe_Decoder$$anon$41__f_d$1 = d$4
}
$c_Lio_circe_Decoder$$anon$41.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$41.prototype.constructor = $c_Lio_circe_Decoder$$anon$41;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$41() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$41.prototype = $c_Lio_circe_Decoder$$anon$41.prototype;
$c_Lio_circe_Decoder$$anon$41.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$41.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var c$2 = $as_Lio_circe_HCursor(c);
    if (c$2.value__Lio_circe_Json().isNull__Z()) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone
    } else {
      var x283 = this.Lio_circe_Decoder$$anon$41__f_d$1.apply__Lio_circe_HCursor__s_util_Either(c$2);
      if ((x283 instanceof $c_s_util_Right)) {
        var a = $as_s_util_Right(x283).s_util_Right__f_value;
        $m_s_package$();
        var value = new $c_s_Some(a);
        return new $c_s_util_Right(value)
      };
      if ((x283 instanceof $c_s_util_Left)) {
        var df = $as_Lio_circe_DecodingFailure($as_s_util_Left(x283).s_util_Left__f_value);
        $m_s_package$();
        return new $c_s_util_Left(df)
      };
      throw new $c_s_MatchError(x283)
    }
  };
  if ((c instanceof $c_Lio_circe_FailedCursor)) {
    var c$3 = $as_Lio_circe_FailedCursor(c);
    if ((!c$3.incorrectFocus__Z())) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone
    } else {
      $m_s_package$();
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0(((c$4) => (() => c$4.history__sci_List()))(c$3));
      var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("[A]Option[A]", ops);
      return new $c_s_util_Left(value$1)
    }
  };
  throw new $c_s_MatchError(c)
});
var $d_Lio_circe_Decoder$$anon$41 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$41: 0
}, false, "io.circe.Decoder$$anon$41", {
  Lio_circe_Decoder$$anon$41: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$41.prototype.$classData = $d_Lio_circe_Decoder$$anon$41;
function $p_Lio_circe_Decoder$$anon$78__step__Lio_circe_HCursor__O__s_util_Either($thiz, c, a1) {
  var this$ = $thiz;
  var a1$tailLocal1 = a1;
  while (true) {
    var x338 = $as_Lio_circe_Decoder($thiz.Lio_circe_Decoder$$anon$78__f_f$1.apply__O__O(a1$tailLocal1)).apply__Lio_circe_HCursor__s_util_Either(c);
    if ((x338 instanceof $c_s_util_Left)) {
      var l = $as_s_util_Left(x338);
      return l
    };
    if ((x338 instanceof $c_s_util_Right)) {
      var x344 = $as_s_util_Either($as_s_util_Right(x338).s_util_Right__f_value);
      if ((x344 instanceof $c_s_util_Left)) {
        var a2 = $as_s_util_Left(x344).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        a1$tailLocal1 = a2;
        continue
      };
      if ((x344 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x344).s_util_Right__f_value;
        $m_s_package$();
        return new $c_s_util_Right(b)
      }
    };
    throw new $c_s_MatchError(x338)
  }
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$78(a$3, f$18) {
  this.Lio_circe_Decoder$$anon$78__f_a$1 = null;
  this.Lio_circe_Decoder$$anon$78__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$78__f_a$1 = a$3;
  this.Lio_circe_Decoder$$anon$78__f_f$1 = f$18
}
$c_Lio_circe_Decoder$$anon$78.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$78.prototype.constructor = $c_Lio_circe_Decoder$$anon$78;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$78() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$78.prototype = $c_Lio_circe_Decoder$$anon$78.prototype;
$c_Lio_circe_Decoder$$anon$78.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$78.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $p_Lio_circe_Decoder$$anon$78__step__Lio_circe_HCursor__O__s_util_Either(this, c, this.Lio_circe_Decoder$$anon$78__f_a$1)
});
var $d_Lio_circe_Decoder$$anon$78 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$78: 0
}, false, "io.circe.Decoder$$anon$78", {
  Lio_circe_Decoder$$anon$78: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$78.prototype.$classData = $d_Lio_circe_Decoder$$anon$78;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$8(fb$2, outer) {
  this.Lio_circe_Decoder$$anon$8__f_fb$1 = null;
  this.Lio_circe_Decoder$$anon$8__f_$outer = null;
  this.Lio_circe_Decoder$$anon$8__f_fb$1 = fb$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$8__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$8.prototype.constructor = $c_Lio_circe_Decoder$$anon$8;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$8.prototype = $c_Lio_circe_Decoder$$anon$8.prototype;
$c_Lio_circe_Decoder$$anon$8.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$8.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance.product__O__O__O(this.Lio_circe_Decoder$$anon$8__f_$outer.apply__Lio_circe_HCursor__s_util_Either(c), this.Lio_circe_Decoder$$anon$8__f_fb$1.apply__Lio_circe_HCursor__s_util_Either(c)))
});
var $d_Lio_circe_Decoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$8: 0
}, false, "io.circe.Decoder$$anon$8", {
  Lio_circe_Decoder$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$8.prototype.$classData = $d_Lio_circe_Decoder$$anon$8;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$9(d$3, outer) {
  this.Lio_circe_Decoder$$anon$9__f_d$1 = null;
  this.Lio_circe_Decoder$$anon$9__f_$outer = null;
  this.Lio_circe_Decoder$$anon$9__f_d$1 = d$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Decoder$$anon$9__f_$outer = outer
}
$c_Lio_circe_Decoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$9.prototype.constructor = $c_Lio_circe_Decoder$$anon$9;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$9.prototype = $c_Lio_circe_Decoder$$anon$9.prototype;
$c_Lio_circe_Decoder$$anon$9.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$9.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x66 = this.Lio_circe_Decoder$$anon$9__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x66 instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(x66);
    return r
  };
  if ((x66 instanceof $c_s_util_Left)) {
    return $as_Lio_circe_Decoder(this.Lio_circe_Decoder$$anon$9__f_d$1.apply__O()).tryDecode__Lio_circe_ACursor__s_util_Either(c)
  };
  throw new $c_s_MatchError(x66)
});
var $d_Lio_circe_Decoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$9: 0
}, false, "io.circe.Decoder$$anon$9", {
  Lio_circe_Decoder$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$9.prototype.$classData = $d_Lio_circe_Decoder$$anon$9;
function $ct_Lio_circe_Decoder$DecoderWithFailure__T__($thiz, name) {
  $thiz.Lio_circe_Decoder$DecoderWithFailure__f_name = name;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Decoder$DecoderWithFailure() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null
}
$c_Lio_circe_Decoder$DecoderWithFailure.prototype = new $h_O();
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.constructor = $c_Lio_circe_Decoder$DecoderWithFailure;
/** @constructor */
function $h_Lio_circe_Decoder$DecoderWithFailure() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$DecoderWithFailure.prototype = $c_Lio_circe_Decoder$DecoderWithFailure.prototype;
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.fail__Lio_circe_HCursor__s_util_Either = (function(c) {
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var message = this.Lio_circe_Decoder$DecoderWithFailure__f_name;
  var ops = new $c_sjsr_AnonFunction0(((this$1, c$2) => (() => c$2.history__sci_List()))(this, c));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2(message, ops);
  return new $c_s_util_Left(value)
});
function $ct_Lio_circe_Decoder$JavaTimeDecoder__T__($thiz, name) {
  $thiz.Lio_circe_Decoder$JavaTimeDecoder__f_name = name;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Decoder$JavaTimeDecoder() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null
}
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype = new $h_O();
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.constructor = $c_Lio_circe_Decoder$JavaTimeDecoder;
/** @constructor */
function $h_Lio_circe_Decoder$JavaTimeDecoder() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$JavaTimeDecoder.prototype = $c_Lio_circe_Decoder$JavaTimeDecoder.prototype;
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x323 = c.value__Lio_circe_Json();
  if ((x323 instanceof $c_Lio_circe_Json$JString)) {
    var x$1 = $as_Lio_circe_Json$JString(x323);
    var x326 = x$1.Lio_circe_Json$JString__f_value;
    try {
      $m_s_package$();
      var this$2 = $m_Ljava_time_ZonedDateTime$();
      var value = this$2.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_ZonedDateTime(x326, $m_Ljava_time_format_DateTimeFormatter$().ISO_ZONED_DATE_TIME__Ljava_time_format_DateTimeFormatter());
      return new $c_s_util_Right(value)
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        var e$2 = $as_Ljava_time_DateTimeException(e);
        var message = e$2.jl_Throwable__f_s;
        if ((message === null)) {
          $m_s_package$();
          $m_Lio_circe_DecodingFailure$();
          var message$1 = this.Lio_circe_Decoder$JavaTimeDecoder__f_name;
          var ops = new $c_sjsr_AnonFunction0(((this$4, c$2) => (() => c$2.history__sci_List()))(this, c));
          var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2(message$1, ops);
          return new $c_s_util_Left(value$1)
        } else {
          $m_s_package$();
          $m_Lio_circe_DecodingFailure$();
          var message$2 = (((this.Lio_circe_Decoder$JavaTimeDecoder__f_name + " (") + message) + ")");
          var ops$1 = new $c_sjsr_AnonFunction0(((this$2$1, c$3) => (() => c$3.history__sci_List()))(this, c));
          var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2(message$2, ops$1);
          return new $c_s_util_Left(value$2)
        }
      } else {
        throw e
      }
    }
  };
  $m_s_package$();
  $m_Lio_circe_DecodingFailure$();
  var message$3 = this.Lio_circe_Decoder$JavaTimeDecoder__f_name;
  var ops$2 = new $c_sjsr_AnonFunction0(((this$3$1, c$4) => (() => c$4.history__sci_List()))(this, c));
  var value$3 = new $c_Lio_circe_DecodingFailure$$anon$2(message$3, ops$2);
  return new $c_s_util_Left(value$3)
});
/** @constructor */
function $c_Lio_circe_Encoder$$anon$1(f$10, outer) {
  this.Lio_circe_Encoder$$anon$1__f_f$1 = null;
  this.Lio_circe_Encoder$$anon$1__f_$outer = null;
  this.Lio_circe_Encoder$$anon$1__f_f$1 = f$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Encoder$$anon$1__f_$outer = outer
}
$c_Lio_circe_Encoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$1.prototype.constructor = $c_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$1.prototype = $c_Lio_circe_Encoder$$anon$1.prototype;
$c_Lio_circe_Encoder$$anon$1.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.Lio_circe_Encoder$$anon$1__f_$outer.apply__O__Lio_circe_Json(this.Lio_circe_Encoder$$anon$1__f_f$1.apply__O__O(a))
});
var $d_Lio_circe_Encoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$1: 0
}, false, "io.circe.Encoder$$anon$1", {
  Lio_circe_Encoder$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$1.prototype.$classData = $d_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$10() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$10.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$10.prototype.constructor = $c_Lio_circe_Encoder$$anon$10;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$10() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$10.prototype = $c_Lio_circe_Encoder$$anon$10.prototype;
$c_Lio_circe_Encoder$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uF(a);
  return $m_Lio_circe_Json$().fromFloatOrNull__F__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$10 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$10: 0
}, false, "io.circe.Encoder$$anon$10", {
  Lio_circe_Encoder$$anon$10: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$10.prototype.$classData = $d_Lio_circe_Encoder$$anon$10;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$11() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$11.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$11.prototype.constructor = $c_Lio_circe_Encoder$$anon$11;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$11() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$11.prototype = $c_Lio_circe_Encoder$$anon$11.prototype;
$c_Lio_circe_Encoder$$anon$11.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uD(a);
  return $m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$11 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$11: 0
}, false, "io.circe.Encoder$$anon$11", {
  Lio_circe_Encoder$$anon$11: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$11.prototype.$classData = $d_Lio_circe_Encoder$$anon$11;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$12() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$12.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$12.prototype.constructor = $c_Lio_circe_Encoder$$anon$12;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$12() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$12.prototype = $c_Lio_circe_Encoder$$anon$12.prototype;
$c_Lio_circe_Encoder$$anon$12.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uB(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$12 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$12: 0
}, false, "io.circe.Encoder$$anon$12", {
  Lio_circe_Encoder$$anon$12: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$12.prototype.$classData = $d_Lio_circe_Encoder$$anon$12;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$13() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$13.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$13.prototype.constructor = $c_Lio_circe_Encoder$$anon$13;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$13() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$13.prototype = $c_Lio_circe_Encoder$$anon$13.prototype;
$c_Lio_circe_Encoder$$anon$13.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uS(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$13 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$13: 0
}, false, "io.circe.Encoder$$anon$13", {
  Lio_circe_Encoder$$anon$13: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$13.prototype.$classData = $d_Lio_circe_Encoder$$anon$13;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$14() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$14.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$14.prototype.constructor = $c_Lio_circe_Encoder$$anon$14;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$14() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$14.prototype = $c_Lio_circe_Encoder$$anon$14.prototype;
$c_Lio_circe_Encoder$$anon$14.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uI(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$14 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$14: 0
}, false, "io.circe.Encoder$$anon$14", {
  Lio_circe_Encoder$$anon$14: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$14.prototype.$classData = $d_Lio_circe_Encoder$$anon$14;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$15() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$15.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$15.prototype.constructor = $c_Lio_circe_Encoder$$anon$15;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$15() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$15.prototype = $c_Lio_circe_Encoder$$anon$15.prototype;
$c_Lio_circe_Encoder$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  var t = $uJ(a);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_Lio_circe_Json$().fromLong__J__Lio_circe_Json(new $c_RTLong(lo, hi))
});
var $d_Lio_circe_Encoder$$anon$15 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$15: 0
}, false, "io.circe.Encoder$$anon$15", {
  Lio_circe_Encoder$$anon$15: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$15.prototype.$classData = $d_Lio_circe_Encoder$$anon$15;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$16() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$16.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$16.prototype.constructor = $c_Lio_circe_Encoder$$anon$16;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$16() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$16.prototype = $c_Lio_circe_Encoder$$anon$16.prototype;
$c_Lio_circe_Encoder$$anon$16.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_s_math_BigInt(a);
  return $m_Lio_circe_Json$().fromBigInt__s_math_BigInt__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$16 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$16: 0
}, false, "io.circe.Encoder$$anon$16", {
  Lio_circe_Encoder$$anon$16: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$16.prototype.$classData = $d_Lio_circe_Encoder$$anon$16;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$17() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$17.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$17.prototype.constructor = $c_Lio_circe_Encoder$$anon$17;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$17() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$17.prototype = $c_Lio_circe_Encoder$$anon$17.prototype;
$c_Lio_circe_Encoder$$anon$17.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_s_math_BigDecimal(a);
  return $m_Lio_circe_Json$().fromBigDecimal__s_math_BigDecimal__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$17 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$17: 0
}, false, "io.circe.Encoder$$anon$17", {
  Lio_circe_Encoder$$anon$17: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$17.prototype.$classData = $d_Lio_circe_Encoder$$anon$17;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$18() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$18.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$18.prototype.constructor = $c_Lio_circe_Encoder$$anon$18;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$18() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$18.prototype = $c_Lio_circe_Encoder$$anon$18.prototype;
$c_Lio_circe_Encoder$$anon$18.prototype.apply__O__Lio_circe_Json = (function(a) {
  $as_s_None$(a);
  return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
});
var $d_Lio_circe_Encoder$$anon$18 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$18: 0
}, false, "io.circe.Encoder$$anon$18", {
  Lio_circe_Encoder$$anon$18: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$18.prototype.$classData = $d_Lio_circe_Encoder$$anon$18;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$20(f$12) {
  this.Lio_circe_Encoder$$anon$20__f_f$1 = null;
  this.Lio_circe_Encoder$$anon$20__f_f$1 = f$12
}
$c_Lio_circe_Encoder$$anon$20.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$20.prototype.constructor = $c_Lio_circe_Encoder$$anon$20;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$20() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$20.prototype = $c_Lio_circe_Encoder$$anon$20.prototype;
$c_Lio_circe_Encoder$$anon$20.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $as_Lio_circe_Json(this.Lio_circe_Encoder$$anon$20__f_f$1.apply__O__O(a))
});
var $d_Lio_circe_Encoder$$anon$20 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$20: 0
}, false, "io.circe.Encoder$$anon$20", {
  Lio_circe_Encoder$$anon$20: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$20.prototype.$classData = $d_Lio_circe_Encoder$$anon$20;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$23(e$4) {
  this.Lio_circe_Encoder$$anon$23__f_e$1 = null;
  this.Lio_circe_Encoder$$anon$23__f_e$1 = e$4
}
$c_Lio_circe_Encoder$$anon$23.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$23.prototype.constructor = $c_Lio_circe_Encoder$$anon$23;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$23() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$23.prototype = $c_Lio_circe_Encoder$$anon$23.prototype;
$c_Lio_circe_Encoder$$anon$23.prototype.apply__s_Option__Lio_circe_Json = (function(a) {
  if ((a instanceof $c_s_Some)) {
    var v = $as_s_Some(a).s_Some__f_value;
    return this.Lio_circe_Encoder$$anon$23__f_e$1.apply__O__Lio_circe_Json(v)
  };
  var x = $m_s_None$();
  if ((x === a)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
  };
  throw new $c_s_MatchError(a)
});
$c_Lio_circe_Encoder$$anon$23.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__s_Option__Lio_circe_Json($as_s_Option(a))
});
var $d_Lio_circe_Encoder$$anon$23 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$23: 0
}, false, "io.circe.Encoder$$anon$23", {
  Lio_circe_Encoder$$anon$23: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$23.prototype.$classData = $d_Lio_circe_Encoder$$anon$23;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$3() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$3.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$3.prototype.constructor = $c_Lio_circe_Encoder$$anon$3;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$3.prototype = $c_Lio_circe_Encoder$$anon$3.prototype;
$c_Lio_circe_Encoder$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Lio_circe_Json(a);
  return a$1
});
var $d_Lio_circe_Encoder$$anon$3 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$3: 0
}, false, "io.circe.Encoder$$anon$3", {
  Lio_circe_Encoder$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$3.prototype.$classData = $d_Lio_circe_Encoder$$anon$3;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$5() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$5.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$5.prototype.constructor = $c_Lio_circe_Encoder$$anon$5;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$5.prototype = $c_Lio_circe_Encoder$$anon$5.prototype;
$c_Lio_circe_Encoder$$anon$5.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Lio_circe_JsonNumber(a);
  $m_Lio_circe_Json$();
  return new $c_Lio_circe_Json$JNumber(a$1)
});
var $d_Lio_circe_Encoder$$anon$5 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$5: 0
}, false, "io.circe.Encoder$$anon$5", {
  Lio_circe_Encoder$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$5.prototype.$classData = $d_Lio_circe_Encoder$$anon$5;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$6() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$6.prototype.constructor = $c_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$6.prototype = $c_Lio_circe_Encoder$$anon$6.prototype;
$c_Lio_circe_Encoder$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_T(a);
  $m_Lio_circe_Json$();
  return new $c_Lio_circe_Json$JString(a$1)
});
var $d_Lio_circe_Encoder$$anon$6 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$6: 0
}, false, "io.circe.Encoder$$anon$6", {
  Lio_circe_Encoder$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$6.prototype.$classData = $d_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$8() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$8.prototype.constructor = $c_Lio_circe_Encoder$$anon$8;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$8.prototype = $c_Lio_circe_Encoder$$anon$8.prototype;
$c_Lio_circe_Encoder$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uZ(a);
  return $m_Lio_circe_Json$().fromBoolean__Z__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$8: 0
}, false, "io.circe.Encoder$$anon$8", {
  Lio_circe_Encoder$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$8.prototype.$classData = $d_Lio_circe_Encoder$$anon$8;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$9() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$9.prototype.constructor = $c_Lio_circe_Encoder$$anon$9;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$9.prototype = $c_Lio_circe_Encoder$$anon$9.prototype;
$c_Lio_circe_Encoder$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uC(a);
  $m_Lio_circe_Json$();
  var value = $as_T(String.fromCharCode(a$1));
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$9: 0
}, false, "io.circe.Encoder$$anon$9", {
  Lio_circe_Encoder$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$9.prototype.$classData = $d_Lio_circe_Encoder$$anon$9;
/** @constructor */
function $c_Lio_circe_Encoder$JavaTimeEncoder() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype = new $h_O();
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.constructor = $c_Lio_circe_Encoder$JavaTimeEncoder;
/** @constructor */
function $h_Lio_circe_Encoder$JavaTimeEncoder() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$JavaTimeEncoder.prototype = $c_Lio_circe_Encoder$JavaTimeEncoder.prototype;
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.apply__Ljava_time_temporal_TemporalAccessor__Lio_circe_Json = (function(a) {
  $m_Lio_circe_Json$();
  var value = $m_Ljava_time_format_DateTimeFormatter$().ISO_ZONED_DATE_TIME__Ljava_time_format_DateTimeFormatter().format__Ljava_time_temporal_TemporalAccessor__T(a);
  return new $c_Lio_circe_Json$JString(value)
});
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__Ljava_time_temporal_TemporalAccessor__Lio_circe_Json($as_Ljava_time_temporal_TemporalAccessor(a))
});
/** @constructor */
function $c_Lio_circe_FailedCursor(lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = null;
  this.Lio_circe_FailedCursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = lastCursor;
  this.Lio_circe_FailedCursor__f_lastOp = lastOp;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_FailedCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_FailedCursor.prototype.constructor = $c_Lio_circe_FailedCursor;
/** @constructor */
function $h_Lio_circe_FailedCursor() {
  /*<skip>*/
}
$h_Lio_circe_FailedCursor.prototype = $c_Lio_circe_FailedCursor.prototype;
$c_Lio_circe_FailedCursor.prototype.incorrectFocus__Z = (function() {
  return ((this.Lio_circe_FailedCursor__f_lastOp.requiresObject__Z() && (!this.Lio_circe_FailedCursor__f_lastCursor.value__Lio_circe_Json().isObject__Z())) || (this.Lio_circe_FailedCursor__f_lastOp.requiresArray__Z() && (!this.Lio_circe_FailedCursor__f_lastCursor.value__Lio_circe_Json().isArray__Z())))
});
$c_Lio_circe_FailedCursor.prototype.succeeded__Z = (function() {
  return false
});
$c_Lio_circe_FailedCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  return this
});
$c_Lio_circe_FailedCursor.prototype.right__Lio_circe_ACursor = (function() {
  return this
});
function $as_Lio_circe_FailedCursor(obj) {
  return (((obj instanceof $c_Lio_circe_FailedCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.FailedCursor"))
}
function $isArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_FailedCursor)))
}
function $asArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_FailedCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.FailedCursor;", depth))
}
var $d_Lio_circe_FailedCursor = new $TypeData().initClass({
  Lio_circe_FailedCursor: 0
}, false, "io.circe.FailedCursor", {
  Lio_circe_FailedCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_FailedCursor.prototype.$classData = $d_Lio_circe_FailedCursor;
/** @constructor */
function $c_Lio_circe_HCursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null
}
$c_Lio_circe_HCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_HCursor.prototype.constructor = $c_Lio_circe_HCursor;
/** @constructor */
function $h_Lio_circe_HCursor() {
  /*<skip>*/
}
$h_Lio_circe_HCursor.prototype = $c_Lio_circe_HCursor.prototype;
$c_Lio_circe_HCursor.prototype.succeeded__Z = (function() {
  return true
});
$c_Lio_circe_HCursor.prototype.downArray__Lio_circe_ACursor = (function() {
  var x9 = this.value__Lio_circe_Json();
  if ((x9 instanceof $c_Lio_circe_Json$JArray)) {
    var x$1 = $as_Lio_circe_Json$JArray(x9);
    var x12 = x$1.Lio_circe_Json$JArray__f_value;
    if ((!$f_sc_SeqOps__isEmpty__Z(x12))) {
      return new $c_Lio_circe_cursor_ArrayCursor(x12, 0, this, false, this, $m_Lio_circe_CursorOp$DownArray$())
    }
  };
  var op = $m_Lio_circe_CursorOp$DownArray$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
$c_Lio_circe_HCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  var x15 = this.value__Lio_circe_Json();
  if ((x15 instanceof $c_Lio_circe_Json$JObject)) {
    var x$1 = $as_Lio_circe_Json$JObject(x15);
    var x18 = x$1.Lio_circe_Json$JObject__f_value;
    if ((!x18.contains__T__Z(k))) {
      var op = new $c_Lio_circe_CursorOp$DownField(k);
      return new $c_Lio_circe_FailedCursor(this, op)
    } else {
      return new $c_Lio_circe_cursor_ObjectCursor(x18, k, this, false, this, new $c_Lio_circe_CursorOp$DownField(k))
    }
  };
  var op$1 = new $c_Lio_circe_CursorOp$DownField(k);
  return new $c_Lio_circe_FailedCursor(this, op$1)
});
function $as_Lio_circe_HCursor(obj) {
  return (((obj instanceof $c_Lio_circe_HCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.HCursor"))
}
function $isArrayOf_Lio_circe_HCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_HCursor)))
}
function $asArrayOf_Lio_circe_HCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_HCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.HCursor;", depth))
}
function $p_Lio_circe_Json$__arrayEq__sci_Seq__sci_Seq__Z($thiz, x, y) {
  var it0 = x.iterator__sc_Iterator();
  var it1 = y.iterator__sc_Iterator();
  while ((it0.hasNext__Z() && it1.hasNext__Z())) {
    if ($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson.neqv__O__O__Z(it0.next__O(), it1.next__O())) {
      return false
    }
  };
  return (it0.hasNext__Z() === it1.hasNext__Z())
}
/** @constructor */
function $c_Lio_circe_Json$() {
  this.Lio_circe_Json$__f_Null = null;
  this.Lio_circe_Json$__f_True = null;
  this.Lio_circe_Json$__f_False = null;
  this.Lio_circe_Json$__f_eqJson = null;
  this.Lio_circe_Json$__f_showJson = null;
  $n_Lio_circe_Json$ = this;
  this.Lio_circe_Json$__f_Null = $m_Lio_circe_Json$JNull$();
  this.Lio_circe_Json$__f_True = new $c_Lio_circe_Json$JBoolean(true);
  this.Lio_circe_Json$__f_False = new $c_Lio_circe_Json$JBoolean(false);
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2(((this$3) => ((x$1, x$2) => {
    var x$1$1 = $as_Lio_circe_Json(x$1);
    var x$2$1 = $as_Lio_circe_Json(x$2);
    if ((x$1$1 instanceof $c_Lio_circe_Json$JObject)) {
      var x$1$2 = $as_Lio_circe_Json$JObject(x$1$1);
      var x146 = x$1$2.Lio_circe_Json$JObject__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JObject)) {
        var x$1$3 = $as_Lio_circe_Json$JObject(x$2$1);
        var x143 = x$1$3.Lio_circe_Json$JObject__f_value;
        return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_eqJsonObject.eqv__O__O__Z(x146, x143)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_Json$JString)) {
      var x$1$4 = $as_Lio_circe_Json$JString(x$1$1);
      var x138 = x$1$4.Lio_circe_Json$JString__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JString)) {
        var x$1$5 = $as_Lio_circe_Json$JString(x$2$1);
        var x135 = x$1$5.Lio_circe_Json$JString__f_value;
        return (x138 === x135)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_Json$JNumber)) {
      var x$1$6 = $as_Lio_circe_Json$JNumber(x$1$1);
      var x130 = x$1$6.Lio_circe_Json$JNumber__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JNumber)) {
        var x$1$7 = $as_Lio_circe_Json$JNumber(x$2$1);
        var x127 = x$1$7.Lio_circe_Json$JNumber__f_value;
        return $m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber.eqv__O__O__Z(x130, x127)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_Json$JBoolean)) {
      var x$1$8 = $as_Lio_circe_Json$JBoolean(x$1$1);
      var x122 = x$1$8.Lio_circe_Json$JBoolean__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JBoolean)) {
        var x$1$9 = $as_Lio_circe_Json$JBoolean(x$2$1);
        var x119 = x$1$9.Lio_circe_Json$JBoolean__f_value;
        return (x122 === x119)
      }
    };
    if ((x$1$1 instanceof $c_Lio_circe_Json$JArray)) {
      var x$1$10 = $as_Lio_circe_Json$JArray(x$1$1);
      var x114 = x$1$10.Lio_circe_Json$JArray__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JArray)) {
        var x$1$11 = $as_Lio_circe_Json$JArray(x$2$1);
        var x111 = x$1$11.Lio_circe_Json$JArray__f_value;
        return $p_Lio_circe_Json$__arrayEq__sci_Seq__sci_Seq__Z(this$3, x114, x111)
      }
    };
    return (x$1$1.isNull__Z() && x$2$1.isNull__Z())
  }))(this));
  this.Lio_circe_Json$__f_eqJson = new $c_Lcats_kernel_Eq$$anon$4(f);
  this.Lio_circe_Json$__f_showJson = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4())
}
$c_Lio_circe_Json$.prototype = new $h_O();
$c_Lio_circe_Json$.prototype.constructor = $c_Lio_circe_Json$;
/** @constructor */
function $h_Lio_circe_Json$() {
  /*<skip>*/
}
$h_Lio_circe_Json$.prototype = $c_Lio_circe_Json$.prototype;
$c_Lio_circe_Json$.prototype.fromFields__sc_Iterable__Lio_circe_Json = (function(fields) {
  var value = $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(fields);
  return new $c_Lio_circe_Json$JObject(value)
});
$c_Lio_circe_Json$.prototype.fromBoolean__Z__Lio_circe_Json = (function(value) {
  return (value ? this.Lio_circe_Json$__f_True : this.Lio_circe_Json$__f_False)
});
$c_Lio_circe_Json$.prototype.fromInt__I__Lio_circe_Json = (function(value) {
  var hi = (value >> 31);
  var value$1 = new $c_Lio_circe_JsonLong(new $c_RTLong(value, hi));
  return new $c_Lio_circe_Json$JNumber(value$1)
});
$c_Lio_circe_Json$.prototype.fromLong__J__Lio_circe_Json = (function(value) {
  var value$1 = new $c_Lio_circe_JsonLong(value);
  return new $c_Lio_circe_Json$JNumber(value$1)
});
$c_Lio_circe_Json$.prototype.fromDoubleOrNull__D__Lio_circe_Json = (function(value) {
  if (((value === value) && (!((value === Infinity) || (value === (-Infinity)))))) {
    var value$1 = new $c_Lio_circe_JsonDouble(value);
    return new $c_Lio_circe_Json$JNumber(value$1)
  } else {
    return this.Lio_circe_Json$__f_Null
  }
});
$c_Lio_circe_Json$.prototype.fromFloatOrNull__F__Lio_circe_Json = (function(value) {
  if (((value === value) && (!((value === Infinity) || (value === (-Infinity)))))) {
    var value$1 = new $c_Lio_circe_JsonFloat(value);
    return new $c_Lio_circe_Json$JNumber(value$1)
  } else {
    return this.Lio_circe_Json$__f_Null
  }
});
$c_Lio_circe_Json$.prototype.fromBigInt__s_math_BigInt__Lio_circe_Json = (function(value) {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var i = value.bigInteger__Ljava_math_BigInteger();
  var value$1 = $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, i, $L0);
  var input = value.toString__T();
  var value$2 = new $c_Lio_circe_JsonBiggerDecimal(value$1, input);
  return new $c_Lio_circe_Json$JNumber(value$2)
});
$c_Lio_circe_Json$.prototype.fromBigDecimal__s_math_BigDecimal__Lio_circe_Json = (function(value) {
  var value$1 = value.s_math_BigDecimal__f_bigDecimal;
  var value$2 = new $c_Lio_circe_JsonBigDecimal(value$1);
  return new $c_Lio_circe_Json$JNumber(value$2)
});
$c_Lio_circe_Json$.prototype.ordinal__Lio_circe_Json__I = (function(x$0) {
  if ((x$0 === $m_Lio_circe_Json$JNull$())) {
    return 0
  };
  if ((x$0 instanceof $c_Lio_circe_Json$JBoolean)) {
    return 1
  };
  if ((x$0 instanceof $c_Lio_circe_Json$JNumber)) {
    return 2
  };
  if ((x$0 instanceof $c_Lio_circe_Json$JString)) {
    return 3
  };
  if ((x$0 instanceof $c_Lio_circe_Json$JArray)) {
    return 4
  };
  if ((x$0 instanceof $c_Lio_circe_Json$JObject)) {
    return 5
  };
  throw new $c_s_MatchError(x$0)
});
$c_Lio_circe_Json$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_circe_Json__I($as_Lio_circe_Json(x))
});
var $d_Lio_circe_Json$ = new $TypeData().initClass({
  Lio_circe_Json$: 0
}, false, "io.circe.Json$", {
  Lio_circe_Json$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lio_circe_Json$.prototype.$classData = $d_Lio_circe_Json$;
var $n_Lio_circe_Json$;
function $m_Lio_circe_Json$() {
  if ((!$n_Lio_circe_Json$)) {
    $n_Lio_circe_Json$ = new $c_Lio_circe_Json$()
  };
  return $n_Lio_circe_Json$
}
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(fields) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = null;
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = fields
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  var this$1 = this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  return $as_Lio_circe_Json($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null))
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.size__I = (function() {
  return this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields.ju_HashMap__f_contentSize
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.contains__T__Z = (function(k) {
  return this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields.containsKey__O__Z(k)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.isEmpty__Z = (function() {
  return this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields.isEmpty__Z()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.keys__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$$anon$1(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toMap__sci_Map = (function() {
  var builder = new $c_sci_MapBuilderImpl();
  this.size__I();
  var this$2 = this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  var iterator = new $c_ju_HashMap$EntrySet(this$2).iterator__ju_Iterator();
  while (iterator.hasNext__Z()) {
    var next = $as_ju_Map$Entry(iterator.next__O());
    var _1 = next.getKey__O();
    var _2 = next.getValue__O();
    builder.addOne__O__O__sci_MapBuilderImpl(_1, _2)
  };
  return builder.result__sci_Map()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$$anon$3(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = folder.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = folder.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(folder.Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if (folder.Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = new $c_Lio_circe_JsonObject$$anon$3(this);
    var this$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$1);
    var f = new $c_sjsr_AnonFunction1(((this$2) => ((_$4) => {
      var _$4$1 = $as_T2(_$4);
      return $as_T(_$4$1._1__O())
    }))(this));
    var ord = $m_s_math_Ordering$String$();
    var iterable = $as_sc_Iterable($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$3, f, ord))
  } else {
    var iterable = new $c_Lio_circe_JsonObject$$anon$3(this)
  };
  var iterator = iterable.iterator__sc_Iterator();
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBraces);
  while (iterator.hasNext__Z()) {
    var next = $as_T2(iterator.next__O());
    var key = $as_T(next._1__O());
    var value = $as_Lio_circe_Json(next._2__O());
    if (((!folder.Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!value.isNull__Z()))) {
      if ((!first)) {
        folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_objectCommas)
      };
      folder.onString__T__V(key);
      folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_colons);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + folder.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      value.foldWith__Lio_circe_Json$Folder__O(folder);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false
    }
  };
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBraces)
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 1,
  Lio_circe_JsonObject: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $c_Lio_circe_JsonObject$MapAndVectorJsonObject(fields, orderedKeys) {
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = fields;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = orderedKeys
}
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$MapAndVectorJsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = $c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype;
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  return $as_Lio_circe_Json(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key))
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.contains__T__Z = (function(key) {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.contains__O__Z(key)
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.isEmpty__Z = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.isEmpty__Z()
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.keys__sc_Iterable = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toMap__sci_Map = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return $as_sc_Iterable(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys.map__F1__O(new $c_sjsr_AnonFunction1(((this$1) => ((key) => {
    var key$1 = $as_T(key);
    var _2 = this$1.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key$1);
    return $ct_T2__O__O__(new $c_T2(), key$1, _2)
  }))(this))))
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = folder.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = folder.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(folder.Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if (folder.Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys;
    var ord = $m_s_math_Ordering$String$();
    var keyIterator = $as_sci_Vector($f_sc_SeqOps__sorted__s_math_Ordering__O(this$1, ord)).iterator__sc_Iterator()
  } else {
    var keyIterator = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys.iterator__sc_Iterator()
  };
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBraces);
  while (keyIterator.hasNext__Z()) {
    var key = $as_T(keyIterator.next__O());
    var value = $as_Lio_circe_Json(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key));
    if (((!folder.Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!value.isNull__Z()))) {
      if ((!first)) {
        folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_objectCommas)
      };
      folder.onString__T__V(key);
      folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_colons);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + folder.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      value.foldWith__Lio_circe_Json$Folder__O(folder);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false
    }
  };
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBraces)
});
var $d_Lio_circe_JsonObject$MapAndVectorJsonObject = new $TypeData().initClass({
  Lio_circe_JsonObject$MapAndVectorJsonObject: 0
}, false, "io.circe.JsonObject$MapAndVectorJsonObject", {
  Lio_circe_JsonObject$MapAndVectorJsonObject: 1,
  Lio_circe_JsonObject: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.$classData = $d_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$1(f$7, outer) {
  this.Lio_circe_KeyDecoder$$anon$1__f_f$1 = null;
  this.Lio_circe_KeyDecoder$$anon$1__f_$outer = null;
  this.Lio_circe_KeyDecoder$$anon$1__f_f$1 = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_KeyDecoder$$anon$1__f_$outer = outer
}
$c_Lio_circe_KeyDecoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$1.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$1.prototype = $c_Lio_circe_KeyDecoder$$anon$1.prototype;
$c_Lio_circe_KeyDecoder$$anon$1.prototype.apply__T__s_Option = (function(key) {
  var this$1 = this.Lio_circe_KeyDecoder$$anon$1__f_$outer.apply__T__s_Option(key);
  var f = this.Lio_circe_KeyDecoder$$anon$1__f_f$1;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$1.get__O())))
});
var $d_Lio_circe_KeyDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$1: 0
}, false, "io.circe.KeyDecoder$$anon$1", {
  Lio_circe_KeyDecoder$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$1.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$10() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$10.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$10.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$10;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$10() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$10.prototype = $c_Lio_circe_KeyDecoder$$anon$10.prototype;
$c_Lio_circe_KeyDecoder$$anon$10.prototype.apply__T__s_Option = (function(key) {
  return $m_s_None$()
});
var $d_Lio_circe_KeyDecoder$$anon$10 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$10: 0
}, false, "io.circe.KeyDecoder$$anon$10", {
  Lio_circe_KeyDecoder$$anon$10: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$10.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$10;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$11(fa$2, f$9) {
  this.Lio_circe_KeyDecoder$$anon$11__f_fa$1 = null;
  this.Lio_circe_KeyDecoder$$anon$11__f_f$1 = null;
  this.Lio_circe_KeyDecoder$$anon$11__f_fa$1 = fa$2;
  this.Lio_circe_KeyDecoder$$anon$11__f_f$1 = f$9
}
$c_Lio_circe_KeyDecoder$$anon$11.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$11.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$11;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$11() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$11.prototype = $c_Lio_circe_KeyDecoder$$anon$11.prototype;
$c_Lio_circe_KeyDecoder$$anon$11.prototype.apply__T__s_Option = (function(key) {
  var this$1 = this.Lio_circe_KeyDecoder$$anon$11__f_fa$1.apply__T__s_Option(key);
  return (this$1.isEmpty__Z() ? $as_Lio_circe_KeyDecoder(this.Lio_circe_KeyDecoder$$anon$11__f_f$1.apply__O__O((void 0))).apply__T__s_Option(key) : this$1)
});
var $d_Lio_circe_KeyDecoder$$anon$11 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$11: 0
}, false, "io.circe.KeyDecoder$$anon$11", {
  Lio_circe_KeyDecoder$$anon$11: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$11.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$11;
function $p_Lio_circe_KeyDecoder$$anon$12__step__T__O__s_Option($thiz, key, a1) {
  var this$ = $thiz;
  var a1$tailLocal1 = a1;
  while (true) {
    var x1 = $as_Lio_circe_KeyDecoder($thiz.Lio_circe_KeyDecoder$$anon$12__f_f$1.apply__O__O(a1$tailLocal1)).apply__T__s_Option(key);
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$()
    };
    if ((x1 instanceof $c_s_Some)) {
      var x7 = $as_s_util_Either($as_s_Some(x1).s_Some__f_value);
      if ((x7 instanceof $c_s_util_Left)) {
        var a2 = $as_s_util_Left(x7).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        a1$tailLocal1 = a2;
        continue
      };
      if ((x7 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x7).s_util_Right__f_value;
        return new $c_s_Some(b)
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$12(a$4, f$10) {
  this.Lio_circe_KeyDecoder$$anon$12__f_a$1 = null;
  this.Lio_circe_KeyDecoder$$anon$12__f_f$1 = null;
  this.Lio_circe_KeyDecoder$$anon$12__f_a$1 = a$4;
  this.Lio_circe_KeyDecoder$$anon$12__f_f$1 = f$10
}
$c_Lio_circe_KeyDecoder$$anon$12.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$12.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$12;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$12() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$12.prototype = $c_Lio_circe_KeyDecoder$$anon$12.prototype;
$c_Lio_circe_KeyDecoder$$anon$12.prototype.apply__T__s_Option = (function(key) {
  return $p_Lio_circe_KeyDecoder$$anon$12__step__T__O__s_Option(this, key, this.Lio_circe_KeyDecoder$$anon$12__f_a$1)
});
var $d_Lio_circe_KeyDecoder$$anon$12 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$12: 0
}, false, "io.circe.KeyDecoder$$anon$12", {
  Lio_circe_KeyDecoder$$anon$12: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$12.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$12;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$2(f$8, outer) {
  this.Lio_circe_KeyDecoder$$anon$2__f_f$1 = null;
  this.Lio_circe_KeyDecoder$$anon$2__f_$outer = null;
  this.Lio_circe_KeyDecoder$$anon$2__f_f$1 = f$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_KeyDecoder$$anon$2__f_$outer = outer
}
$c_Lio_circe_KeyDecoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$2.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$2;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$2.prototype = $c_Lio_circe_KeyDecoder$$anon$2.prototype;
$c_Lio_circe_KeyDecoder$$anon$2.prototype.apply__T__s_Option = (function(key) {
  var this$1 = this.Lio_circe_KeyDecoder$$anon$2__f_$outer.apply__T__s_Option(key);
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    return $as_Lio_circe_KeyDecoder(this.Lio_circe_KeyDecoder$$anon$2__f_f$1.apply__O__O(arg1)).apply__T__s_Option(key)
  }
});
var $d_Lio_circe_KeyDecoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$2: 0
}, false, "io.circe.KeyDecoder$$anon$2", {
  Lio_circe_KeyDecoder$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$2.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$2;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$5() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$5.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$5.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$5;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$5.prototype = $c_Lio_circe_KeyDecoder$$anon$5.prototype;
$c_Lio_circe_KeyDecoder$$anon$5.prototype.apply__T__s_Option = (function(key) {
  if (($uI(key.length) === 36)) {
    try {
      var value = $m_ju_UUID$().fromString__T__ju_UUID(key);
      return new $c_s_Some(value)
    } catch (e) {
      if ((e instanceof $c_jl_IllegalArgumentException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
var $d_Lio_circe_KeyDecoder$$anon$5 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$5: 0
}, false, "io.circe.KeyDecoder$$anon$5", {
  Lio_circe_KeyDecoder$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$5.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$5;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$8(f$12) {
  this.Lio_circe_KeyDecoder$$anon$8__f_f$1 = null;
  this.Lio_circe_KeyDecoder$$anon$8__f_f$1 = f$12
}
$c_Lio_circe_KeyDecoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$8.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$8;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$8.prototype = $c_Lio_circe_KeyDecoder$$anon$8.prototype;
$c_Lio_circe_KeyDecoder$$anon$8.prototype.apply__T__s_Option = (function(key) {
  try {
    var value = this.Lio_circe_KeyDecoder$$anon$8__f_f$1.apply__O__O(key);
    return new $c_s_Some(value)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      return $m_s_None$()
    } else {
      throw e
    }
  }
});
var $d_Lio_circe_KeyDecoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$8: 0
}, false, "io.circe.KeyDecoder$$anon$8", {
  Lio_circe_KeyDecoder$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$8;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$9(a$3) {
  this.Lio_circe_KeyDecoder$$anon$9__f_a$1 = null;
  this.Lio_circe_KeyDecoder$$anon$9__f_a$1 = a$3
}
$c_Lio_circe_KeyDecoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$9.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$9;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$9.prototype = $c_Lio_circe_KeyDecoder$$anon$9.prototype;
$c_Lio_circe_KeyDecoder$$anon$9.prototype.apply__T__s_Option = (function(key) {
  var value = this.Lio_circe_KeyDecoder$$anon$9__f_a$1;
  return new $c_s_Some(value)
});
var $d_Lio_circe_KeyDecoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$9: 0
}, false, "io.circe.KeyDecoder$$anon$9", {
  Lio_circe_KeyDecoder$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$9.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$9;
/** @constructor */
function $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype.constructor = $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder;
/** @constructor */
function $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype = $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype;
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype.apply__T__s_Option = (function(key) {
  var value = this.decodeSafe__T__O(key);
  return new $c_s_Some(value)
});
function $as_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj) {
  return (((obj instanceof $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.KeyDecoder$AlwaysKeyDecoder"))
}
function $isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyDecoder$AlwaysKeyDecoder)))
}
function $asArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.KeyDecoder$AlwaysKeyDecoder;", depth))
}
function $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__($thiz, decodeK, decodeV) {
  $thiz.Lio_circe_MapDecoder__f_decodeK = decodeK;
  $thiz.Lio_circe_MapDecoder__f_decodeV = decodeV;
  if ((decodeK instanceof $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder)) {
    var decodeK$2 = $as_Lio_circe_KeyDecoder$AlwaysKeyDecoder(decodeK);
    var $$x1 = decodeK$2
  } else {
    var $$x1 = null
  };
  $thiz.Lio_circe_MapDecoder__f_alwaysDecodeK = $$x1;
  return $thiz
}
function $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key) {
  return new $c_Lio_circe_cursor_ObjectCursor(obj, key, c, false, c, new $c_Lio_circe_CursorOp$DownField(key))
}
function $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, key, c, builder) {
  var x7 = $thiz.Lio_circe_MapDecoder__f_decodeV.apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x7 instanceof $c_s_util_Right)) {
    var value = $as_s_util_Right(x7).s_util_Right__f_value;
    var elem = $ct_T2__O__O__(new $c_T2(), key, value);
    builder.addOne__O__scm_Growable(elem);
    return null
  };
  if ((x7 instanceof $c_s_util_Left)) {
    var error = $as_Lio_circe_DecodingFailure($as_s_util_Left(x7).s_util_Left__f_value);
    return error
  };
  throw new $c_s_MatchError(x7)
}
function $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either($thiz, c, obj) {
  var it = obj.keys__sc_Iterable().iterator__sc_Iterator();
  var builder = new $c_sci_MapBuilderImpl();
  var failed = null;
  while (((failed === null) && it.hasNext__Z())) {
    var key = $as_T(it.next__O());
    var atH = $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key);
    if (($thiz.Lio_circe_MapDecoder__f_alwaysDecodeK !== null)) {
      failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, $thiz.Lio_circe_MapDecoder__f_alwaysDecodeK.decodeSafe__T__O(key), atH, builder)
    } else {
      matchResult4: {
        var x12 = $thiz.Lio_circe_MapDecoder__f_decodeK.apply__T__s_Option(key);
        var x = $m_s_None$();
        if ((x === x12)) {
          failed = $m_Lio_circe_MapDecoder$().failure__Lio_circe_HCursor__Lio_circe_DecodingFailure(atH);
          break matchResult4
        };
        if ((x12 instanceof $c_s_Some)) {
          var k = $as_s_Some(x12).s_Some__f_value;
          failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, k, atH, builder);
          break matchResult4
        };
        throw new $c_s_MatchError(x12)
      }
    }
  };
  if ((failed === null)) {
    $m_s_package$();
    var value = builder.result__sci_Map();
    return new $c_s_util_Right(value)
  } else {
    $m_s_package$();
    var value$1 = failed;
    return new $c_s_util_Left(value$1)
  }
}
/** @constructor */
function $c_Lio_circe_MapDecoder() {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null
}
$c_Lio_circe_MapDecoder.prototype = new $h_O();
$c_Lio_circe_MapDecoder.prototype.constructor = $c_Lio_circe_MapDecoder;
/** @constructor */
function $h_Lio_circe_MapDecoder() {
  /*<skip>*/
}
$h_Lio_circe_MapDecoder.prototype = $c_Lio_circe_MapDecoder.prototype;
$c_Lio_circe_MapDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_MapDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x3 = c.value__Lio_circe_Json();
  if ((x3 instanceof $c_Lio_circe_Json$JObject)) {
    var x$1 = $as_Lio_circe_Json$JObject(x3);
    var x6 = x$1.Lio_circe_Json$JObject__f_value;
    return $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either(this, c, x6)
  };
  return $m_Lio_circe_MapDecoder$().failureResult__Lio_circe_HCursor__s_util_Either(c)
});
/** @constructor */
function $c_Lio_circe_ParsingFailure$() {
  this.Lio_circe_ParsingFailure$__f_eqParsingFailure = null;
  this.Lio_circe_ParsingFailure$__f_showParsingFailure = null;
  $n_Lio_circe_ParsingFailure$ = this;
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2(((this$1) => ((x$1, x$2) => {
    var x$1$1 = $as_Lio_circe_ParsingFailure(x$1);
    var x$2$1 = $as_Lio_circe_ParsingFailure(x$2);
    var x9 = $ct_T2__O__O__(new $c_T2(), x$1$1, x$2$1);
    var x10 = $as_Lio_circe_ParsingFailure(x9.T2__f__1);
    var x11 = $as_Lio_circe_ParsingFailure(x9.T2__f__2);
    if ((x10 !== null)) {
      $m_Lio_circe_ParsingFailure$();
      var x16 = x10.Lio_circe_ParsingFailure__f_message;
      var x17 = x10.Lio_circe_ParsingFailure__f_underlying;
      if ((x11 !== null)) {
        $m_Lio_circe_ParsingFailure$();
        var x13 = x11.Lio_circe_ParsingFailure__f_message;
        var x14 = x11.Lio_circe_ParsingFailure__f_underlying;
        return ((x16 === x13) && ((x17 === null) ? (x14 === null) : x17.equals__O__Z(x14)))
      }
    };
    throw new $c_s_MatchError(x9)
  }))(this));
  this.Lio_circe_ParsingFailure$__f_eqParsingFailure = new $c_Lcats_kernel_Eq$$anon$4(f);
  $m_Lcats_Show$();
  var f$1 = new $c_sjsr_AnonFunction1(((this$2$1) => ((failure) => {
    var failure$1 = $as_Lio_circe_ParsingFailure(failure);
    return ("ParsingFailure: " + failure$1.Lio_circe_ParsingFailure__f_message)
  }))(this));
  this.Lio_circe_ParsingFailure$__f_showParsingFailure = new $c_Lcats_Show$$anon$3(f$1)
}
$c_Lio_circe_ParsingFailure$.prototype = new $h_O();
$c_Lio_circe_ParsingFailure$.prototype.constructor = $c_Lio_circe_ParsingFailure$;
/** @constructor */
function $h_Lio_circe_ParsingFailure$() {
  /*<skip>*/
}
$h_Lio_circe_ParsingFailure$.prototype = $c_Lio_circe_ParsingFailure$.prototype;
$c_Lio_circe_ParsingFailure$.prototype.toString__T = (function() {
  return "ParsingFailure"
});
var $d_Lio_circe_ParsingFailure$ = new $TypeData().initClass({
  Lio_circe_ParsingFailure$: 0
}, false, "io.circe.ParsingFailure$", {
  Lio_circe_ParsingFailure$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lio_circe_ParsingFailure$.prototype.$classData = $d_Lio_circe_ParsingFailure$;
var $n_Lio_circe_ParsingFailure$;
function $m_Lio_circe_ParsingFailure$() {
  if ((!$n_Lio_circe_ParsingFailure$)) {
    $n_Lio_circe_ParsingFailure$ = new $c_Lio_circe_ParsingFailure$()
  };
  return $n_Lio_circe_ParsingFailure$
}
function $p_Lio_circe_Printer$__toHex__I__C($thiz, nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0))
}
/** @constructor */
function $c_Lio_circe_Printer$() {
  this.Lio_circe_Printer$__f_noSpaces = null;
  this.Lio_circe_Printer$__f_noSpacesSortKeys = null;
  this.Lio_circe_Printer$__f_spaces2 = null;
  this.Lio_circe_Printer$__f_spaces2SortKeys = null;
  this.Lio_circe_Printer$__f_spaces4 = null;
  this.Lio_circe_Printer$__f_spaces4SortKeys = null;
  this.Lio_circe_Printer$__f_io$circe$Printer$$$SizeTable = null;
  $n_Lio_circe_Printer$ = this;
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft = "";
  $m_Lio_circe_Printer$();
  var lbraceRight = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft = "";
  $m_Lio_circe_Printer$();
  var rbraceRight = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft = "";
  $m_Lio_circe_Printer$();
  var lbracketRight = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft = "";
  $m_Lio_circe_Printer$();
  var rbracketRight = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight = "";
  $m_Lio_circe_Printer$();
  var colonLeft = "";
  $m_Lio_circe_Printer$();
  var colonRight = "";
  $m_Lio_circe_Printer$();
  var reuseWriters = false;
  $m_Lio_circe_Printer$();
  var predictSize = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii = false;
  $m_Lio_circe_Printer$();
  var sortKeys = false;
  this.Lio_circe_Printer$__f_noSpaces = new $c_Lio_circe_Printer(false, "", lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var colonLeft$1 = "";
  $m_Lio_circe_Printer$();
  var colonRight$1 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$1 = false;
  $m_Lio_circe_Printer$();
  var predictSize$1 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$1 = false;
  this.Lio_circe_Printer$__f_noSpacesSortKeys = new $c_Lio_circe_Printer(false, "", lbraceLeft$1, lbraceRight$1, rbraceLeft$1, rbraceRight$1, lbracketLeft$1, lbracketRight$1, rbracketLeft$1, rbracketRight$1, lrbracketsEmpty$1, arrayCommaLeft$1, arrayCommaRight$1, objectCommaLeft$1, objectCommaRight$1, colonLeft$1, colonRight$1, reuseWriters$1, predictSize$1, escapeNonAscii$1, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$2 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$2 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$2 = false;
  $m_Lio_circe_Printer$();
  var predictSize$2 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$2 = false;
  this.Lio_circe_Printer$__f_spaces2 = new $c_Lio_circe_Printer(false, "  ", lbraceLeft$2, "\n", "\n", rbraceRight$2, lbracketLeft$2, "\n", "\n", rbracketRight$2, "\n", arrayCommaLeft$2, "\n", objectCommaLeft$2, "\n", " ", " ", reuseWriters$2, predictSize$2, escapeNonAscii$2, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$3 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$3 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$3 = false;
  $m_Lio_circe_Printer$();
  var predictSize$3 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$3 = false;
  this.Lio_circe_Printer$__f_spaces2SortKeys = new $c_Lio_circe_Printer(false, "  ", lbraceLeft$3, "\n", "\n", rbraceRight$3, lbracketLeft$3, "\n", "\n", rbracketRight$3, "\n", arrayCommaLeft$3, "\n", objectCommaLeft$3, "\n", " ", " ", reuseWriters$3, predictSize$3, escapeNonAscii$3, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$4 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$4 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$4 = false;
  $m_Lio_circe_Printer$();
  var predictSize$4 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$4 = false;
  this.Lio_circe_Printer$__f_spaces4 = new $c_Lio_circe_Printer(false, "    ", lbraceLeft$4, "\n", "\n", rbraceRight$4, lbracketLeft$4, "\n", "\n", rbracketRight$4, "\n", arrayCommaLeft$4, "\n", objectCommaLeft$4, "\n", " ", " ", reuseWriters$4, predictSize$4, escapeNonAscii$4, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$5 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$5 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$5 = false;
  $m_Lio_circe_Printer$();
  var predictSize$5 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$5 = false;
  this.Lio_circe_Printer$__f_spaces4SortKeys = new $c_Lio_circe_Printer(false, "    ", lbraceLeft$5, "\n", "\n", rbraceRight$5, lbracketLeft$5, "\n", "\n", rbracketRight$5, "\n", arrayCommaLeft$5, "\n", objectCommaLeft$5, "\n", " ", " ", reuseWriters$5, predictSize$5, escapeNonAscii$5, true);
  this.Lio_circe_Printer$__f_io$circe$Printer$$$SizeTable = new $ac_I(new Int32Array([32, 48, 64, 80, 96, 112, 128, 144, 160, 176, 192, 208, 224, 240, 256, 272, 288, 304, 320, 336, 352, 368, 384, 400, 416, 432, 448, 464, 480, 496, 512, 1024, 2048, 4096, 8192, 16384, 32768, 65536, 131072, 262144, 524288, 1048576, 2097152, 4194304, 8388608, 16777216, 33554432]))
}
$c_Lio_circe_Printer$.prototype = new $h_O();
$c_Lio_circe_Printer$.prototype.constructor = $c_Lio_circe_Printer$;
/** @constructor */
function $h_Lio_circe_Printer$() {
  /*<skip>*/
}
$h_Lio_circe_Printer$.prototype = $c_Lio_circe_Printer$.prototype;
$c_Lio_circe_Printer$.prototype.toString__T = (function() {
  return "Printer"
});
$c_Lio_circe_Printer$.prototype.io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V = (function(writer, c) {
  writer.append__C__jl_Appendable(117).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 12)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 8)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 4)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & c)))
});
var $d_Lio_circe_Printer$ = new $TypeData().initClass({
  Lio_circe_Printer$: 0
}, false, "io.circe.Printer$", {
  Lio_circe_Printer$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lio_circe_Printer$.prototype.$classData = $d_Lio_circe_Printer$;
var $n_Lio_circe_Printer$;
function $m_Lio_circe_Printer$() {
  if ((!$n_Lio_circe_Printer$)) {
    $n_Lio_circe_Printer$ = new $c_Lio_circe_Printer$()
  };
  return $n_Lio_circe_Printer$
}
/** @constructor */
function $c_Lio_circe_Printer$ConstantPieces(pieces) {
  this.Lio_circe_Printer$ConstantPieces__f_pieces = null;
  this.Lio_circe_Printer$ConstantPieces__f_pieces = pieces
}
$c_Lio_circe_Printer$ConstantPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$ConstantPieces.prototype.constructor = $c_Lio_circe_Printer$ConstantPieces;
/** @constructor */
function $h_Lio_circe_Printer$ConstantPieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$ConstantPieces.prototype = $c_Lio_circe_Printer$ConstantPieces.prototype;
$c_Lio_circe_Printer$ConstantPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  return this.Lio_circe_Printer$ConstantPieces__f_pieces
});
var $d_Lio_circe_Printer$ConstantPieces = new $TypeData().initClass({
  Lio_circe_Printer$ConstantPieces: 0
}, false, "io.circe.Printer$ConstantPieces", {
  Lio_circe_Printer$ConstantPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$ConstantPieces.prototype.$classData = $d_Lio_circe_Printer$ConstantPieces;
function $ct_Lio_circe_Printer$MemoizedPieces__T__($thiz, indent) {
  $thiz.Lio_circe_Printer$MemoizedPieces__f_indent = indent;
  var dimensions = new $ac_I(new Int32Array([128]));
  $thiz.Lio_circe_Printer$MemoizedPieces__f_known = $ct_ju_concurrent_CopyOnWriteArrayList__AO__(new $c_ju_concurrent_CopyOnWriteArrayList(), $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lio_circe_Printer$Pieces.getClassOf(), dimensions), 1));
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Printer$MemoizedPieces() {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null
}
$c_Lio_circe_Printer$MemoizedPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$MemoizedPieces.prototype.constructor = $c_Lio_circe_Printer$MemoizedPieces;
/** @constructor */
function $h_Lio_circe_Printer$MemoizedPieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$MemoizedPieces.prototype = $c_Lio_circe_Printer$MemoizedPieces.prototype;
$c_Lio_circe_Printer$MemoizedPieces.prototype.addIndentation__jl_StringBuilder__T__I__V = (function(builder, s, depth) {
  var lastNewLineIndex = $f_T__lastIndexOf__I__I(s, 10);
  if ((lastNewLineIndex === (-1))) {
    builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    builder.append__jl_CharSequence__I__I__jl_StringBuilder(s, 0, ((1 + lastNewLineIndex) | 0));
    var i = 0;
    while ((i < depth)) {
      var str = this.Lio_circe_Printer$MemoizedPieces__f_indent;
      builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      i = ((1 + i) | 0)
    };
    builder.append__jl_CharSequence__I__I__jl_StringBuilder(s, ((1 + lastNewLineIndex) | 0), $uI(s.length))
  }
});
$c_Lio_circe_Printer$MemoizedPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  if ((i >= 128)) {
    return this.compute__I__Lio_circe_Printer$Pieces(i)
  } else {
    var res = $as_Lio_circe_Printer$Pieces(this.Lio_circe_Printer$MemoizedPieces__f_known.get__I__O(i));
    if ((res !== null)) {
      return res
    } else {
      var tmp = this.compute__I__Lio_circe_Printer$Pieces(i);
      this.Lio_circe_Printer$MemoizedPieces__f_known.set__I__O__O(i, tmp);
      return tmp
    }
  }
});
function $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__($thiz, writer, pieces, dropNullValues, escapeNonAscii, sortKeys) {
  $thiz.Lio_circe_Printer$PrintingFolder__f_writer = writer;
  $thiz.Lio_circe_Printer$PrintingFolder__f_pieces = pieces;
  $thiz.Lio_circe_Printer$PrintingFolder__f_dropNullValues = dropNullValues;
  $thiz.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = escapeNonAscii;
  $thiz.Lio_circe_Printer$PrintingFolder__f_sortKeys = sortKeys;
  $thiz.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Printer$PrintingFolder() {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0
}
$c_Lio_circe_Printer$PrintingFolder.prototype = new $h_O();
$c_Lio_circe_Printer$PrintingFolder.prototype.constructor = $c_Lio_circe_Printer$PrintingFolder;
/** @constructor */
function $h_Lio_circe_Printer$PrintingFolder() {
  /*<skip>*/
}
$h_Lio_circe_Printer$PrintingFolder.prototype = $c_Lio_circe_Printer$PrintingFolder.prototype;
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__V = (function(value) {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(34);
  var i = 0;
  var offset = 0;
  while ((i < $uI(value.length))) {
    var index = i;
    var c = (65535 & $uI(value.charCodeAt(index)));
    var esc;
    switch (c) {
      case 34: {
        var esc = 34;
        break
      }
      case 92: {
        var esc = 92;
        break
      }
      case 8: {
        var esc = 98;
        break
      }
      case 12: {
        var esc = 102;
        break
      }
      case 10: {
        var esc = 110;
        break
      }
      case 13: {
        var esc = 114;
        break
      }
      case 9: {
        var esc = 116;
        break
      }
      default: {
        if ((this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii && (c > 127))) {
          var $$x1 = true
        } else {
          var this$1 = $m_jl_Character$();
          var $$x1 = this$1.isISOControl__I__Z(c)
        };
        var esc = (65535 & ($$x1 ? 1 : 0))
      }
    };
    if ((esc !== 0)) {
      this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__I__I__jl_Appendable(value, offset, i).append__C__jl_Appendable(92);
      if ((esc !== 1)) {
        this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(esc)
      } else {
        $m_Lio_circe_Printer$().io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V(this.Lio_circe_Printer$PrintingFolder__f_writer, c)
      };
      offset = ((1 + i) | 0)
    };
    i = ((1 + i) | 0)
  };
  if ((offset < i)) {
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__I__I__jl_Appendable(value, offset, i)
  };
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(34)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__V = (function(value) {
  var orig = this.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = this.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(this.Lio_circe_Printer$PrintingFolder__f_depth);
  if ($f_sc_SeqOps__isEmpty__Z(value)) {
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lrEmptyBrackets)
  } else {
    var iterator = value.iterator__sc_Iterator();
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBrackets);
    this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
    $as_Lio_circe_Json(iterator.next__O()).foldWith__Lio_circe_Json$Folder__O(this);
    this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    while (iterator.hasNext__Z()) {
      this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_arrayCommas);
      this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $as_Lio_circe_Json(iterator.next__O()).foldWith__Lio_circe_Json$Folder__O(this);
      this.Lio_circe_Printer$PrintingFolder__f_depth = orig
    };
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBrackets)
  }
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onNull__O = (function() {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable("null")
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__O = (function(value) {
  this.onString__T__V(value)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__O = (function(value) {
  this.onArray__sci_Vector__V(value)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  value.appendToFolder__Lio_circe_Printer$PrintingFolder__V(this)
});
function $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__($thiz, decodeA) {
  $thiz.Lio_circe_SeqDecoder__f_decodeA = decodeA;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_SeqDecoder() {
  this.Lio_circe_SeqDecoder__f_decodeA = null
}
$c_Lio_circe_SeqDecoder.prototype = new $h_O();
$c_Lio_circe_SeqDecoder.prototype.constructor = $c_Lio_circe_SeqDecoder;
/** @constructor */
function $h_Lio_circe_SeqDecoder() {
  /*<skip>*/
}
$h_Lio_circe_SeqDecoder.prototype = $c_Lio_circe_SeqDecoder.prototype;
$c_Lio_circe_SeqDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_SeqDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var current = c.downArray__Lio_circe_ACursor();
  if (current.succeeded__Z()) {
    $m_s_package$();
    var builder = new $c_scm_ListBuffer();
    var failed = null;
    while (((failed === null) && current.succeeded__Z())) {
      var x1 = this.Lio_circe_SeqDecoder__f_decodeA.apply__Lio_circe_HCursor__s_util_Either($as_Lio_circe_HCursor(current));
      if ((x1 instanceof $c_s_util_Left)) {
        var e = $as_Lio_circe_DecodingFailure($as_s_util_Left(x1).s_util_Left__f_value);
        failed = e;
        continue
      };
      if ((x1 instanceof $c_s_util_Right)) {
        var a = $as_s_util_Right(x1).s_util_Right__f_value;
        builder.addOne__O__scm_ListBuffer(a);
        current = current.right__Lio_circe_ACursor();
        continue
      };
      throw new $c_s_MatchError(x1)
    };
    if ((failed === null)) {
      $m_s_package$();
      var value = builder.toList__sci_List();
      return new $c_s_util_Right(value)
    } else {
      $m_s_package$();
      var value$1 = failed;
      return new $c_s_util_Left(value$1)
    }
  } else if (c.value__Lio_circe_Json().isArray__Z()) {
    $m_s_package$();
    $m_s_package$();
    var this$5 = new $c_scm_ListBuffer();
    var value$2 = this$5.toList__sci_List();
    return new $c_s_util_Right(value$2)
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$3 = new $c_Lio_circe_DecodingFailure$$anon$2("C[A]", ops);
    return new $c_s_util_Left(value$3)
  }
});
function $ct_Lio_circe_numbers_BiggerDecimal$Zero__($thiz) {
  var value = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = new $c_s_Some(value);
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = new $c_s_Some($L0);
  return $thiz
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$Zero() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null
}
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$Zero;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$Zero() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$Zero.prototype = $c_Lio_circe_numbers_BiggerDecimal$Zero.prototype;
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toBigDecimal__s_Option = (function() {
  return this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal
});
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option = (function(maxDigits) {
  var value = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  return new $c_s_Some(value)
});
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toLong__s_Option = (function() {
  return this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong
});
function $as_Lio_circe_numbers_BiggerDecimal$Zero(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.BiggerDecimal$Zero"))
}
function $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_BiggerDecimal$Zero)))
}
function $asArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.BiggerDecimal$Zero;", depth))
}
/** @constructor */
function $c_Lio_circe_numbers_SigAndExp(unscaled, scale) {
  this.Lio_circe_numbers_SigAndExp__f_unscaled = null;
  this.Lio_circe_numbers_SigAndExp__f_scale = null;
  this.Lio_circe_numbers_SigAndExp__f_unscaled = unscaled;
  this.Lio_circe_numbers_SigAndExp__f_scale = scale
}
$c_Lio_circe_numbers_SigAndExp.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_SigAndExp.prototype.constructor = $c_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $h_Lio_circe_numbers_SigAndExp() {
  /*<skip>*/
}
$h_Lio_circe_numbers_SigAndExp.prototype = $c_Lio_circe_numbers_SigAndExp.prototype;
$c_Lio_circe_numbers_SigAndExp.prototype.isWhole__Z = (function() {
  var this$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
  return (this$1.Ljava_math_BigInteger__f_sign < 1)
});
$c_Lio_circe_numbers_SigAndExp.prototype.toBigDecimal__s_Option = (function() {
  if (((this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && (this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0))) {
    var value = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, this.Lio_circe_numbers_SigAndExp__f_scale.intValue__I());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option = (function(maxDigits) {
  if ((!this.isWhole__Z())) {
    return $m_s_None$()
  } else {
    var this$1 = this.Lio_circe_numbers_SigAndExp__f_unscaled.abs__Ljava_math_BigInteger();
    var this$2 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    var value = $uI(this$2.length);
    var hi = (value >> 31);
    var this$4 = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value, hi));
    var bi = this.Lio_circe_numbers_SigAndExp__f_scale;
    var digits = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi);
    if ((digits.compareTo__Ljava_math_BigInteger__I(maxDigits) > 0)) {
      return $m_s_None$()
    } else {
      var value$1 = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, this.Lio_circe_numbers_SigAndExp__f_scale.intValue__I()).toBigInteger__Ljava_math_BigInteger();
      return new $c_s_Some(value$1)
    }
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toDouble__D = (function() {
  if (((this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && (this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0))) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, this.Lio_circe_numbers_SigAndExp__f_scale.intValue__I()).doubleValue__D()
  } else {
    var this$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
    if ((this$1.Ljava_math_BigInteger__f_sign === 1)) {
      var $$x1 = 0.0
    } else {
      var $$x1 = Infinity
    };
    var this$2 = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    return ($$x1 * this$2.Ljava_math_BigInteger__f_sign)
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toFloat__F = (function() {
  if (((this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && (this.Lio_circe_numbers_SigAndExp__f_scale.compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0))) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, this.Lio_circe_numbers_SigAndExp__f_scale.intValue__I()).floatValue__F()
  } else {
    var this$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
    if ((this$1.Ljava_math_BigInteger__f_sign === 1)) {
      var $$x1 = 0.0
    } else {
      var $$x1 = Infinity
    };
    var this$2 = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    return Math.fround(($$x1 * Math.fround(this$2.Ljava_math_BigInteger__f_sign)))
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toLong__s_Option = (function() {
  if ((!this.isWhole__Z())) {
    return $m_s_None$()
  } else {
    var x1 = this.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits);
    if ((x1 instanceof $c_s_Some)) {
      var i = $as_Ljava_math_BigInteger($as_s_Some(x1).s_Some__f_value);
      var t = i.longValue__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var xn = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, i)) {
        return new $c_s_Some(new $c_RTLong(lo, hi))
      } else {
        return $m_s_None$()
      }
    };
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$()
    };
    throw new $c_s_MatchError(x1)
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_SigAndExp)) {
    var other = $as_Lio_circe_numbers_SigAndExp(that);
    var xn = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    var yn = other.Lio_circe_numbers_SigAndExp__f_unscaled;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
      var xn$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
      var yn$1 = other.Lio_circe_numbers_SigAndExp__f_scale;
      return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, yn$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.hashCode__I = (function() {
  return ((this.Lio_circe_numbers_SigAndExp__f_scale.hashCode__I() + this.Lio_circe_numbers_SigAndExp__f_unscaled.hashCode__I()) | 0)
});
$c_Lio_circe_numbers_SigAndExp.prototype.toString__T = (function() {
  var xn = this.Lio_circe_numbers_SigAndExp__f_scale;
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
    var this$1 = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)
  } else {
    return ((this.Lio_circe_numbers_SigAndExp__f_unscaled + "e") + this.Lio_circe_numbers_SigAndExp__f_scale.negate__Ljava_math_BigInteger())
  }
});
function $as_Lio_circe_numbers_SigAndExp(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_SigAndExp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.SigAndExp"))
}
function $isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_SigAndExp)))
}
function $asArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.SigAndExp;", depth))
}
var $d_Lio_circe_numbers_SigAndExp = new $TypeData().initClass({
  Lio_circe_numbers_SigAndExp: 0
}, false, "io.circe.numbers.SigAndExp", {
  Lio_circe_numbers_SigAndExp: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_SigAndExp.prototype.$classData = $d_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $c_Lio_circe_parser_package$() {
  /*<skip>*/
}
$c_Lio_circe_parser_package$.prototype = new $h_O();
$c_Lio_circe_parser_package$.prototype.constructor = $c_Lio_circe_parser_package$;
/** @constructor */
function $h_Lio_circe_parser_package$() {
  /*<skip>*/
}
$h_Lio_circe_parser_package$.prototype = $c_Lio_circe_parser_package$.prototype;
$c_Lio_circe_parser_package$.prototype.parse__T__s_util_Either = (function(input) {
  try {
    var x5 = $m_Lio_circe_scalajs_package$().convertJsToJson__sjs_js_Any__s_util_Either(JSON.parse(input))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    matchResult1: {
      var x5;
      if ((e$2 !== null)) {
        var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x2.isEmpty__Z())) {
          var x3 = $as_jl_Throwable(x2.get__O());
          $m_s_package$();
          $m_Lio_circe_ParsingFailure$();
          var message = x3.getMessage__T();
          var value = new $c_Lio_circe_ParsingFailure(message, x3);
          var x5 = new $c_s_util_Left(value);
          break matchResult1
        }
      };
      throw e$2
    }
  };
  if ((x5 instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(x5);
    return r
  };
  if ((x5 instanceof $c_s_util_Left)) {
    var exception$2 = $as_jl_Throwable($as_s_util_Left(x5).s_util_Left__f_value);
    $m_s_package$();
    $m_Lio_circe_ParsingFailure$();
    var message$1 = exception$2.getMessage__T();
    var value$1 = new $c_Lio_circe_ParsingFailure(message$1, exception$2);
    return new $c_s_util_Left(value$1)
  };
  throw new $c_s_MatchError(x5)
});
var $d_Lio_circe_parser_package$ = new $TypeData().initClass({
  Lio_circe_parser_package$: 0
}, false, "io.circe.parser.package$", {
  Lio_circe_parser_package$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Parser: 1
});
$c_Lio_circe_parser_package$.prototype.$classData = $d_Lio_circe_parser_package$;
var $n_Lio_circe_parser_package$;
function $m_Lio_circe_parser_package$() {
  if ((!$n_Lio_circe_parser_package$)) {
    $n_Lio_circe_parser_package$ = new $c_Lio_circe_parser_package$()
  };
  return $n_Lio_circe_parser_package$
}
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
  /*<skip>*/
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = o.jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I($as_jl_Enum(o))
});
function $as_jl_Enum(obj) {
  return (((obj instanceof $c_jl_Enum) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Enum"))
}
function $isArrayOf_jl_Enum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Enum)))
}
function $asArrayOf_jl_Enum(obj, depth) {
  return (($isArrayOf_jl_Enum(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Enum;", depth))
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_Exception extends $c_jl_Throwable {
}
var $d_jl_Exception = new $TypeData().initClass({
  jl_Exception: 0
}, false, "java.lang.Exception", {
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Exception.prototype.$classData = $d_jl_Exception;
/** @constructor */
function $c_Ljava_time_Clock$SystemClock(zone) {
  this.Ljava_time_Clock$SystemClock__f_zone = null;
  this.Ljava_time_Clock$SystemClock__f_zone = zone;
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "'zone' can not be null")
  }
}
$c_Ljava_time_Clock$SystemClock.prototype = new $h_Ljava_time_Clock();
$c_Ljava_time_Clock$SystemClock.prototype.constructor = $c_Ljava_time_Clock$SystemClock;
/** @constructor */
function $h_Ljava_time_Clock$SystemClock() {
  /*<skip>*/
}
$h_Ljava_time_Clock$SystemClock.prototype = $c_Ljava_time_Clock$SystemClock.prototype;
$c_Ljava_time_Clock$SystemClock.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Clock$SystemClock)) {
    var clock = $as_Ljava_time_Clock$SystemClock(obj);
    var x = this.Ljava_time_Clock$SystemClock__f_zone;
    var x$2 = clock.Ljava_time_Clock$SystemClock__f_zone;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ljava_time_Clock$SystemClock.prototype.hashCode__I = (function() {
  return ((1 + this.Ljava_time_Clock$SystemClock__f_zone.hashCode__I()) | 0)
});
$c_Ljava_time_Clock$SystemClock.prototype.toString__T = (function() {
  return (("SystemClock[" + this.Ljava_time_Clock$SystemClock__f_zone) + "]")
});
function $as_Ljava_time_Clock$SystemClock(obj) {
  return (((obj instanceof $c_Ljava_time_Clock$SystemClock) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Clock$SystemClock"))
}
function $isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Clock$SystemClock)))
}
function $asArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (($isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Clock$SystemClock;", depth))
}
var $d_Ljava_time_Clock$SystemClock = new $TypeData().initClass({
  Ljava_time_Clock$SystemClock: 0
}, false, "java.time.Clock$SystemClock", {
  Ljava_time_Clock$SystemClock: 1,
  Ljava_time_Clock: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Clock$SystemClock.prototype.$classData = $d_Ljava_time_Clock$SystemClock;
function $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__MONDAY
}
function $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__TUESDAY
}
function $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__WEDNESDAY
}
function $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__THURSDAY
}
function $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__FRIDAY
}
function $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SATURDAY
}
function $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SUNDAY
}
/** @constructor */
function $c_Ljava_time_DayOfWeek$() {
  this.Ljava_time_DayOfWeek$__f_$values = null;
  this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = null;
  this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_DayOfWeek$ = this;
  $t_Ljava_time_DayOfWeek$__MONDAY = new $c_Ljava_time_DayOfWeek$$anon$1();
  $t_Ljava_time_DayOfWeek$__TUESDAY = new $c_Ljava_time_DayOfWeek$$anon$2();
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = new $c_Ljava_time_DayOfWeek$$anon$3();
  $t_Ljava_time_DayOfWeek$__THURSDAY = new $c_Ljava_time_DayOfWeek$$anon$4();
  $t_Ljava_time_DayOfWeek$__FRIDAY = new $c_Ljava_time_DayOfWeek$$anon$5();
  $t_Ljava_time_DayOfWeek$__SATURDAY = new $c_Ljava_time_DayOfWeek$$anon$6();
  $t_Ljava_time_DayOfWeek$__SUNDAY = new $c_Ljava_time_DayOfWeek$$anon$7();
  this.Ljava_time_DayOfWeek$__f_$values = new ($d_Ljava_time_DayOfWeek.getArrayOf().constr)([$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek()])
}
$c_Ljava_time_DayOfWeek$.prototype = new $h_O();
$c_Ljava_time_DayOfWeek$.prototype.constructor = $c_Ljava_time_DayOfWeek$;
/** @constructor */
function $h_Ljava_time_DayOfWeek$() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$.prototype = $c_Ljava_time_DayOfWeek$.prototype;
$c_Ljava_time_DayOfWeek$.prototype.values__ALjava_time_DayOfWeek = (function() {
  var this$1 = this.Ljava_time_DayOfWeek$__f_$values;
  return this$1.clone__O()
});
$c_Ljava_time_DayOfWeek$.prototype.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek = (function() {
  if ((!this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1)) {
    this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = $m_Ljava_time_DayOfWeek$().values__ALjava_time_DayOfWeek();
    this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = true
  };
  return this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1
});
$c_Ljava_time_DayOfWeek$.prototype.of__I__Ljava_time_DayOfWeek = (function(dayOfWeek) {
  if (((dayOfWeek < 1) || (dayOfWeek > 7))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for DayOfWeek: " + dayOfWeek))
  } else {
    return this.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek().get((((-1) + dayOfWeek) | 0))
  }
});
$c_Ljava_time_DayOfWeek$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_DayOfWeek(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_DayOfWeek$ = new $TypeData().initClass({
  Ljava_time_DayOfWeek$: 0
}, false, "java.time.DayOfWeek$", {
  Ljava_time_DayOfWeek$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_DayOfWeek$.prototype.$classData = $d_Ljava_time_DayOfWeek$;
var $n_Ljava_time_DayOfWeek$;
function $m_Ljava_time_DayOfWeek$() {
  if ((!$n_Ljava_time_DayOfWeek$)) {
    $n_Ljava_time_DayOfWeek$ = new $c_Ljava_time_DayOfWeek$()
  };
  return $n_Ljava_time_DayOfWeek$
}
function $s_Ljava_time_Month$__JANUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JANUARY
}
function $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__FEBRUARY
}
function $s_Ljava_time_Month$__MARCH__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MARCH
}
function $s_Ljava_time_Month$__APRIL__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__APRIL
}
function $s_Ljava_time_Month$__MAY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MAY
}
function $s_Ljava_time_Month$__JUNE__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JUNE
}
function $s_Ljava_time_Month$__JULY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JULY
}
function $s_Ljava_time_Month$__AUGUST__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__AUGUST
}
function $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__SEPTEMBER
}
function $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__OCTOBER
}
function $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__NOVEMBER
}
function $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__DECEMBER
}
/** @constructor */
function $c_Ljava_time_Month$() {
  this.Ljava_time_Month$__f_$values = null;
  this.Ljava_time_Month$__f_ENUMS$lzy1 = null;
  this.Ljava_time_Month$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_Month$ = this;
  $t_Ljava_time_Month$__JANUARY = new $c_Ljava_time_Month$$anon$1();
  $t_Ljava_time_Month$__FEBRUARY = new $c_Ljava_time_Month$$anon$2();
  $t_Ljava_time_Month$__MARCH = new $c_Ljava_time_Month$$anon$3();
  $t_Ljava_time_Month$__APRIL = new $c_Ljava_time_Month$$anon$4();
  $t_Ljava_time_Month$__MAY = new $c_Ljava_time_Month$$anon$5();
  $t_Ljava_time_Month$__JUNE = new $c_Ljava_time_Month$$anon$6();
  $t_Ljava_time_Month$__JULY = new $c_Ljava_time_Month$$anon$7();
  $t_Ljava_time_Month$__AUGUST = new $c_Ljava_time_Month$$anon$8();
  $t_Ljava_time_Month$__SEPTEMBER = new $c_Ljava_time_Month$$anon$9();
  $t_Ljava_time_Month$__OCTOBER = new $c_Ljava_time_Month$$anon$10();
  $t_Ljava_time_Month$__NOVEMBER = new $c_Ljava_time_Month$$anon$11();
  $t_Ljava_time_Month$__DECEMBER = new $c_Ljava_time_Month$$anon$12();
  this.Ljava_time_Month$__f_$values = new ($d_Ljava_time_Month.getArrayOf().constr)([$s_Ljava_time_Month$__JANUARY__Ljava_time_Month(), $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month(), $s_Ljava_time_Month$__MARCH__Ljava_time_Month(), $s_Ljava_time_Month$__APRIL__Ljava_time_Month(), $s_Ljava_time_Month$__MAY__Ljava_time_Month(), $s_Ljava_time_Month$__JUNE__Ljava_time_Month(), $s_Ljava_time_Month$__JULY__Ljava_time_Month(), $s_Ljava_time_Month$__AUGUST__Ljava_time_Month(), $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month(), $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month()])
}
$c_Ljava_time_Month$.prototype = new $h_O();
$c_Ljava_time_Month$.prototype.constructor = $c_Ljava_time_Month$;
/** @constructor */
function $h_Ljava_time_Month$() {
  /*<skip>*/
}
$h_Ljava_time_Month$.prototype = $c_Ljava_time_Month$.prototype;
$c_Ljava_time_Month$.prototype.values__ALjava_time_Month = (function() {
  var this$1 = this.Ljava_time_Month$__f_$values;
  return this$1.clone__O()
});
$c_Ljava_time_Month$.prototype.java$time$Month$$$ENUMS__ALjava_time_Month = (function() {
  if ((!this.Ljava_time_Month$__f_ENUMSbitmap$1)) {
    this.Ljava_time_Month$__f_ENUMS$lzy1 = $m_Ljava_time_Month$().values__ALjava_time_Month();
    this.Ljava_time_Month$__f_ENUMSbitmap$1 = true
  };
  return this.Ljava_time_Month$__f_ENUMS$lzy1
});
$c_Ljava_time_Month$.prototype.of__I__Ljava_time_Month = (function(month) {
  if (((month < 1) || (month > 12))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for MonthOfYear: " + month))
  } else {
    return this.java$time$Month$$$ENUMS__ALjava_time_Month().get((((-1) + month) | 0))
  }
});
$c_Ljava_time_Month$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_Month(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_Month$ = new $TypeData().initClass({
  Ljava_time_Month$: 0
}, false, "java.time.Month$", {
  Ljava_time_Month$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_Month$.prototype.$classData = $d_Ljava_time_Month$;
var $n_Ljava_time_Month$;
function $m_Ljava_time_Month$() {
  if ((!$n_Ljava_time_Month$)) {
    $n_Ljava_time_Month$ = new $c_Ljava_time_Month$()
  };
  return $n_Ljava_time_Month$
}
/** @constructor */
function $c_Ljava_time_ZoneRegion(id, rules) {
  this.Ljava_time_ZoneRegion__f_id = null;
  this.Ljava_time_ZoneRegion__f_rules = null;
  this.Ljava_time_ZoneRegion__f_id = id;
  this.Ljava_time_ZoneRegion__f_rules = rules;
  $ct_Ljava_time_ZoneId__(this)
}
$c_Ljava_time_ZoneRegion.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneRegion.prototype.constructor = $c_Ljava_time_ZoneRegion;
/** @constructor */
function $h_Ljava_time_ZoneRegion() {
  /*<skip>*/
}
$h_Ljava_time_ZoneRegion.prototype = $c_Ljava_time_ZoneRegion.prototype;
$c_Ljava_time_ZoneRegion.prototype.getId__T = (function() {
  return this.Ljava_time_ZoneRegion__f_id
});
$c_Ljava_time_ZoneRegion.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return ((this.Ljava_time_ZoneRegion__f_rules !== null) ? this.Ljava_time_ZoneRegion__f_rules : $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(this.Ljava_time_ZoneRegion__f_id, false))
});
var $d_Ljava_time_ZoneRegion = new $TypeData().initClass({
  Ljava_time_ZoneRegion: 0
}, false, "java.time.ZoneRegion", {
  Ljava_time_ZoneRegion: 1,
  Ljava_time_ZoneId: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZoneRegion.prototype.$classData = $d_Ljava_time_ZoneRegion;
function $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V($thiz, fieldValues, field, value) {
  var current = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, field, null));
  if ((current !== null)) {
    var this$1 = $uJ(current);
    var $$x1 = (!((this$1.RTLong__f_lo === value.RTLong__f_lo) && (this$1.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Invalid state, field: " + field) + " ") + current) + " conflicts with ") + field) + " ") + value))
  } else {
    if ((field === null)) {
      var $$x2 = 0
    } else {
      var originalHash = $systemIdentityHashCode(field);
      var $$x2 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    fieldValues.java$util$HashMap$$put0__O__O__I__Z__O(field, value, $$x2, false)
  }
}
function $f_Ljava_time_chrono_Chronology__equals__O__Z($thiz, obj) {
  if ($is_Ljava_time_chrono_Chronology(obj)) {
    var other = $as_Ljava_time_chrono_Chronology(obj);
    return (($thiz === other) || ($f_T__compareTo__T__I("ISO", "ISO") === 0))
  } else {
    return false
  }
}
function $f_Ljava_time_chrono_Chronology__hashCode__I($thiz) {
  var this$1 = $objectGetClass($thiz);
  return ($systemIdentityHashCode(this$1) ^ $f_T__hashCode__I("ISO"))
}
function $is_Ljava_time_chrono_Chronology(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_Chronology)))
}
function $as_Ljava_time_chrono_Chronology(obj) {
  return (($is_Ljava_time_chrono_Chronology(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.Chronology"))
}
function $isArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_Chronology)))
}
function $asArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_Chronology(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.Chronology;", depth))
}
function $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($thiz, field, value) {
  var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  if ((field === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $systemIdentityHashCode(field);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  this$2.java$util$HashMap$$put0__O__O__I__Z__O(field, value, $$x1, false);
  return $thiz
}
function $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z($thiz, resolverStyle) {
  var changes = 0;
  var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var entries = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
  var break$1 = false;
  while (((!break$1) && entries.hasNext__Z())) {
    var entry = $as_ju_Map$Entry(entries.next__O());
    var targetField = $as_Ljava_time_temporal_TemporalField(entry.getKey__O());
    var resolvedObject = null;
    matchResult1: {
      var x1 = resolvedObject;
      if ($is_Ljava_time_chrono_ChronoZonedDateTime(x1)) {
        var czdt = $as_Ljava_time_chrono_ChronoZonedDateTime(x1);
        if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone === null)) {
          $thiz.Ljava_time_format_DateTimeBuilder__f_zone = czdt.Ljava_time_ZonedDateTime__f_zone
        } else {
          var x = $thiz.Ljava_time_format_DateTimeBuilder__f_zone;
          var x$2 = czdt.Ljava_time_ZonedDateTime__f_zone;
          if ((!((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoZonedDateTime must use the effective parsed zone: " + $thiz.Ljava_time_format_DateTimeBuilder__f_zone))
          }
        };
        resolvedObject = czdt.Ljava_time_ZonedDateTime__f_dateTime;
        break matchResult1
      };
      if ($is_Ljava_time_chrono_ChronoLocalDate(x1)) {
        var cld = $as_Ljava_time_chrono_ChronoLocalDate(x1);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, cld);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1
      };
      if ((x1 instanceof $c_Ljava_time_LocalTime)) {
        var lt = $as_Ljava_time_LocalTime(x1);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, lt);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1
      };
      if ((x1 instanceof $c_Ljava_time_chrono_ChronoLocalDateTime)) {
        var cldt = $as_Ljava_time_chrono_ChronoLocalDateTime(x1);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, cldt.Ljava_time_LocalDateTime__f_date);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, cldt.Ljava_time_LocalDateTime__f_time);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1
      };
      if ((x1 === null)) {
        if ((!$thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z(targetField))) {
          changes = ((1 + changes) | 0);
          break$1 = true
        };
        break matchResult1
      };
      var this$2 = resolvedObject;
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unknown type: " + $objectClassName(this$2)))
    }
  };
  if ((changes === 100)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Badly written field")
  };
  return (changes > 0)
}
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, date) {
  var x = $thiz.Ljava_time_format_DateTimeBuilder__f_chrono;
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((!((x === null) ? (x$2 === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoLocalDate must use the effective parsed chronology: " + $thiz.Ljava_time_format_DateTimeBuilder__f_chrono))
  };
  var t = date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var $$x2 = new $c_RTLong(lo, hi);
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $systemIdentityHashCode(key);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var old = $as_jl_Long(this$2.java$util$HashMap$$put0__O__O__I__Z__O(key, $$x2, $$x1, false));
  if ((old !== null)) {
    var this$5 = $uJ(old);
    var $$x3 = (!((this$5.RTLong__f_lo === lo) && (this$5.RTLong__f_hi === hi)))
  } else {
    var $$x3 = false
  };
  if ($$x3) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($uJ(old))) + " differs from ") + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi))) + " while resolving  ") + targetField))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, time) {
  var t = time.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var $$x2 = new $c_RTLong(lo, hi);
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $systemIdentityHashCode(key);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var old = $as_jl_Long(this$2.java$util$HashMap$$put0__O__O__I__Z__O(key, $$x2, $$x1, false));
  if ((old !== null)) {
    var this$5 = $uJ(old);
    var $$x3 = (!((this$5.RTLong__f_lo === lo) && (this$5.RTLong__f_hi === hi)))
  } else {
    var $$x3 = false
  };
  if ($$x3) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime($uJ(old))) + " differs from ") + time) + " while resolving  ") + targetField))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_chrono instanceof $c_Ljava_time_chrono_IsoChronology)) {
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology().resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues, resolverStyle))
  } else if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $$x1 = $m_Ljava_time_LocalDate$();
    var x = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $$x1.ofEpochDay__J__Ljava_time_LocalDate($uJ(x)))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, date) {
  if ((date !== null)) {
    $thiz.Ljava_time_format_DateTimeBuilder__f_date = date;
    var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    var fields = new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator();
    var break$1 = false;
    while (((!break$1) && fields.hasNext__Z())) {
      var field = $as_Ljava_time_temporal_TemporalField(fields.next__O());
      if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
        if (field.isDateBased__Z()) {
          var val1__lo = 0;
          var val1__hi = 0;
          try {
            var t = date.getLong__Ljava_time_temporal_TemporalField__J(field);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var $$x1__lo = lo;
            var $$x1__hi = hi;
            val1__lo = $$x1__lo;
            val1__hi = $$x1__hi
          } catch (e) {
            if ((e instanceof $c_Ljava_time_DateTimeException)) {
              break$1 = true
            } else {
              throw e
            }
          };
          if ((!break$1)) {
            var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
            var x = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, field, null));
            var t$1 = $uJ(x);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            var this$4__lo = val1__lo;
            var this$4__hi = val1__hi;
            if ((!((this$4__lo === lo$1) && (this$4__hi === hi$1)))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: Field " + field) + " ") + new $c_RTLong(val1__lo, val1__hi)) + " differs from ") + field) + " ") + new $c_RTLong(lo$1, hi$1)) + " derived from ") + date))
            }
          }
        }
      }
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((lo === 0) && (hi === 0))))) {
        var this$2 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
        this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$2)
      }
    };
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), (((lo === 24) && (hi === 0)) ? $L0 : new $c_RTLong(lo, hi)))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
    var x$1 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((lo$1 === 0) && (hi$1 === 0))))) {
        var this$4 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
        this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$1, hi$1), this$4)
      }
    };
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), (((lo$1 === 12) && (hi$1 === 0)) ? $L0 : new $c_RTLong(lo$1, hi$1)))
  };
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$7 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
      var this$5 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
      var x$2 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$5, key, null));
      var t$2 = $uJ(x$2);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      this$7.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$2, hi$2), this$7)
    };
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
      var this$10 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
      var this$8 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$1 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
      var x$3 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$8, key$1, null));
      var t$3 = $uJ(x$3);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      this$10.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$3, hi$3), this$10)
    }
  };
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()))) {
    var x$4 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$4 = $uJ(x$4);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var x$5 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var t$5 = $uJ(x$5);
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    var $$x1 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(12, hi$4) + ((c1part >>> 16) | 0)) | 0);
    var lo$7 = ((lo$6 + lo$5) | 0);
    var hi$7 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$6)) ? ((1 + ((hi$6 + hi$5) | 0)) | 0) : ((hi$6 + hi$5) | 0));
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x1, new $c_RTLong(lo$7, hi$7))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$6 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$6 = $uJ(x$6);
    var lo$8 = t$6.RTLong__f_lo;
    var hi$8 = t$6.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$15 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$15.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$8, hi$8), this$15)
    };
    var $$x2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$16 = $m_RTLong$();
    var lo$9 = this$16.divideImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$9 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x2, new $c_RTLong(lo$9, hi$9));
    var $$x3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$17 = $m_RTLong$();
    var lo$10 = this$17.remainderImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$10 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x3, new $c_RTLong(lo$10, hi$10))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$7 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$7 = $uJ(x$7);
    var lo$11 = t$7.RTLong__f_lo;
    var hi$11 = t$7.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$19 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$19.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$11, hi$11), this$19)
    };
    var $$x4 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$20 = $m_RTLong$();
    var lo$12 = this$20.divideImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$12 = this$20.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x4, new $c_RTLong(lo$12, hi$12));
    var $$x5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$21 = $m_RTLong$();
    var lo$13 = this$21.remainderImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$13 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x5, new $c_RTLong(lo$13, hi$13))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$8 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$8 = $uJ(x$8);
    var lo$14 = t$8.RTLong__f_lo;
    var hi$14 = t$8.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$23 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
      this$23.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$14, hi$14), this$23)
    };
    var $$x6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$24 = $m_RTLong$();
    var lo$15 = this$24.divideImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$15 = this$24.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x6, new $c_RTLong(lo$15, hi$15));
    var $$x7 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$25 = $m_RTLong$();
    var lo$16 = this$25.remainderImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$16 = this$25.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x7, new $c_RTLong(lo$16, hi$16))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$9 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$9 = $uJ(x$9);
    var lo$17 = t$9.RTLong__f_lo;
    var hi$17 = t$9.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$27 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
      this$27.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$17, hi$17), this$27)
    };
    var $$x8 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$28 = $m_RTLong$();
    var lo$18 = this$28.divideImpl__I__I__I__I__I(lo$17, hi$17, 3600, 0);
    var hi$18 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x8, new $c_RTLong(lo$18, hi$18));
    var $$x9 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$29 = $m_RTLong$();
    var lo$19 = this$29.divideImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$19 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$30 = $m_RTLong$();
    var lo$20 = this$30.remainderImpl__I__I__I__I__I(lo$19, hi$19, 60, 0);
    var hi$20 = this$30.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x9, new $c_RTLong(lo$20, hi$20));
    var $$x10 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var this$31 = $m_RTLong$();
    var lo$21 = this$31.remainderImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$21 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x10, new $c_RTLong(lo$21, hi$21))
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$10 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$10 = $uJ(x$10);
    var lo$22 = t$10.RTLong__f_lo;
    var hi$22 = t$10.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$33 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
      this$33.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$22, hi$22), this$33)
    };
    var $$x11 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$34 = $m_RTLong$();
    var lo$23 = this$34.divideImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$23 = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x11, new $c_RTLong(lo$23, hi$23));
    var $$x12 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$35 = $m_RTLong$();
    var lo$24 = this$35.remainderImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$24 = this$35.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x12, new $c_RTLong(lo$24, hi$24))
  };
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$38 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$36 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$2 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var x$11 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$36, key$2, null));
      var t$11 = $uJ(x$11);
      var lo$25 = t$11.RTLong__f_lo;
      var hi$25 = t$11.RTLong__f_hi;
      this$38.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$25, hi$25), this$38)
    };
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$41 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$39 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var x$12 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$39, key$3, null));
      var t$12 = $uJ(x$12);
      var lo$26 = t$12.RTLong__f_lo;
      var hi$26 = t$12.RTLong__f_hi;
      this$41.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$26, hi$26), this$41)
    }
  };
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$13 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$13 = $uJ(x$13);
    var lo$27 = t$13.RTLong__f_lo;
    var hi$27 = t$13.RTLong__f_hi;
    var this$43 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    var key$4 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var x$14 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$43, key$4, null));
    var t$14 = $uJ(x$14);
    var lo$28 = t$14.RTLong__f_lo;
    var hi$28 = t$14.RTLong__f_hi;
    var $$x13 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$1 = (65535 & lo$27);
    var b1$1 = ((lo$27 >>> 16) | 0);
    var a0b0$1 = Math.imul(1000, b0$1);
    var a0b1$1 = Math.imul(1000, b1$1);
    var lo$29 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$29 = ((Math.imul(1000, hi$27) + ((c1part$1 >>> 16) | 0)) | 0);
    var this$45 = $m_RTLong$();
    var lo$30 = this$45.remainderImpl__I__I__I__I__I(lo$28, hi$28, 1000, 0);
    var hi$30 = this$45.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$31 = ((lo$29 + lo$30) | 0);
    var hi$31 = ((((-2147483648) ^ lo$31) < ((-2147483648) ^ lo$29)) ? ((1 + ((hi$29 + hi$30) | 0)) | 0) : ((hi$29 + hi$30) | 0));
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x13, new $c_RTLong(lo$31, hi$31))
  };
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var this$47 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    var key$5 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var x$15 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$47, key$5, null));
    var t$15 = $uJ(x$15);
    var lo$32 = t$15.RTLong__f_lo;
    var hi$32 = t$15.RTLong__f_hi;
    var $$x14 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$49 = $m_RTLong$();
    var lo$33 = this$49.divideImpl__I__I__I__I__I(lo$32, hi$32, 1000, 0);
    var hi$33 = this$49.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x14, new $c_RTLong(lo$33, hi$33));
    $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())
  };
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var this$50 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    var key$6 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var x$16 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$50, key$6, null));
    var t$16 = $uJ(x$16);
    var lo$34 = t$16.RTLong__f_lo;
    var hi$34 = t$16.RTLong__f_hi;
    var $$x15 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$52 = $m_RTLong$();
    var lo$35 = this$52.divideImpl__I__I__I__I__I(lo$34, hi$34, 1000000, 0);
    var hi$35 = this$52.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x15, new $c_RTLong(lo$35, hi$35));
    $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())
  };
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$17 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$17 = $uJ(x$17);
    var lo$36 = t$17.RTLong__f_lo;
    var hi$36 = t$17.RTLong__f_hi;
    var $$x16 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$2 = (65535 & lo$36);
    var b1$2 = ((lo$36 >>> 16) | 0);
    var a0b0$2 = Math.imul(1000, b0$2);
    var a0b1$2 = Math.imul(1000, b1$2);
    var lo$37 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$37 = ((Math.imul(1000, hi$36) + ((c1part$2 >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x16, new $c_RTLong(lo$37, hi$37))
  } else if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$18 = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$18 = $uJ(x$18);
    var lo$38 = t$18.RTLong__f_lo;
    var hi$38 = t$18.RTLong__f_hi;
    var $$x17 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$3 = (65535 & lo$38);
    var b1$3 = ((lo$38 >>> 16) | 0);
    var a0b0$3 = Math.imul(16960, b0$3);
    var a1b0 = Math.imul(15, b0$3);
    var a0b1$3 = Math.imul(16960, b1$3);
    var lo$39 = ((a0b0$3 + (((a1b0 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$39 = ((((((Math.imul(1000000, hi$38) + Math.imul(15, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0) | 0) >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x17, new $c_RTLong(lo$39, hi$39))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hod = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null));
  var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key$1 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var moh = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, key$1, null));
  var this$3 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key$2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var som = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$3, key$2, null));
  var this$4 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var key$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var nos = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$4, key$3, null));
  if ((hod === null)) {
    return (void 0)
  };
  if (((moh === null) && ((som !== null) || (nos !== null)))) {
    return (void 0)
  };
  if ((((moh !== null) && (som === null)) && (nos !== null))) {
    return (void 0)
  };
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ((hod !== null)) {
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
        var this$5 = hod;
        var this$6 = $uJ(this$5);
        var $$x4 = ((this$6.RTLong__f_lo === 24) && (this$6.RTLong__f_hi === 0))
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        if ((moh === null)) {
          var $$x3 = true
        } else {
          var this$7 = $uJ(moh);
          var $$x3 = ((this$7.RTLong__f_lo === 0) && (this$7.RTLong__f_hi === 0))
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        if ((som === null)) {
          var $$x2 = true
        } else {
          var this$8 = $uJ(som);
          var $$x2 = ((this$8.RTLong__f_lo === 0) && (this$8.RTLong__f_hi === 0))
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        if ((nos === null)) {
          var $$x1 = true
        } else {
          var this$9 = nos;
          var this$10 = $uJ(this$9);
          var $$x1 = ((this$10.RTLong__f_lo === 0) && (this$10.RTLong__f_hi === 0))
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        hod = $L0;
        var this$12 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$12.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, 1)
      };
      var this$14 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
      var x = hod;
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hodVal = this$14.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this$14);
      if ((moh !== null)) {
        var this$16 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
        var t$1 = $uJ(moh);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var mohVal = this$16.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$16);
        if ((som !== null)) {
          var this$18 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
          var t$2 = $uJ(som);
          var lo$2 = t$2.RTLong__f_lo;
          var hi$2 = t$2.RTLong__f_hi;
          var somVal = this$18.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$2, hi$2), this$18);
          if ((nos !== null)) {
            var this$20 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
            var x$1 = nos;
            var t$3 = $uJ(x$1);
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            var nosVal = this$20.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$3, hi$3), this$20);
            var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal, nosVal);
            $thiz.Ljava_time_format_DateTimeBuilder__f_time = time
          } else {
            var time$1 = $m_Ljava_time_LocalTime$().of__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal);
            $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$1
          }
        } else if ((nos === null)) {
          var time$2 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, mohVal);
          $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$2
        }
      } else if (((som === null) && (nos === null))) {
        var time$3 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, 0);
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$3
      }
    }
  } else if ((hod !== null)) {
    var x$2 = hod;
    var t$4 = $uJ(x$2);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var hodVal$2__lo = lo$4;
    var hodVal$2__hi = hi$4;
    if ((moh !== null)) {
      if ((som !== null)) {
        if ((nos === null)) {
          nos = $L0
        };
        var a__lo = hodVal$2__lo;
        var a__hi = hodVal$2__hi;
        var t$5 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(817405952, 838));
        var lo$5 = t$5.RTLong__f_lo;
        var hi$5 = t$5.RTLong__f_hi;
        var totalNanos__lo = lo$5;
        var totalNanos__hi = hi$5;
        var a$1__lo = totalNanos__lo;
        var a$1__hi = totalNanos__hi;
        var t$6 = $uJ(moh);
        var lo$6 = t$6.RTLong__f_lo;
        var hi$6 = t$6.RTLong__f_hi;
        var t$7 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$6, hi$6), new $c_RTLong((-129542144), 13));
        var lo$7 = t$7.RTLong__f_lo;
        var hi$7 = t$7.RTLong__f_hi;
        var t$8 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$7, hi$7));
        var lo$8 = t$8.RTLong__f_lo;
        var hi$8 = t$8.RTLong__f_hi;
        var $$x5__lo = lo$8;
        var $$x5__hi = hi$8;
        totalNanos__lo = $$x5__lo;
        totalNanos__hi = $$x5__hi;
        var a$2__lo = totalNanos__lo;
        var a$2__hi = totalNanos__hi;
        var t$9 = $uJ(som);
        var lo$9 = t$9.RTLong__f_lo;
        var hi$9 = t$9.RTLong__f_hi;
        var t$10 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$9, hi$9), new $c_RTLong(1000000000, 0));
        var lo$10 = t$10.RTLong__f_lo;
        var hi$10 = t$10.RTLong__f_hi;
        var t$11 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$2__lo, a$2__hi), new $c_RTLong(lo$10, hi$10));
        var lo$11 = t$11.RTLong__f_lo;
        var hi$11 = t$11.RTLong__f_hi;
        var $$x6__lo = lo$11;
        var $$x6__hi = hi$11;
        totalNanos__lo = $$x6__lo;
        totalNanos__hi = $$x6__hi;
        var a$3__lo = totalNanos__lo;
        var a$3__hi = totalNanos__hi;
        var x$3 = nos;
        var t$12 = $uJ(x$3);
        var lo$12 = t$12.RTLong__f_lo;
        var hi$12 = t$12.RTLong__f_hi;
        var t$13 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$3__lo, a$3__hi), new $c_RTLong(lo$12, hi$12));
        var lo$13 = t$13.RTLong__f_lo;
        var hi$13 = t$13.RTLong__f_hi;
        var $$x7__lo = lo$13;
        var $$x7__hi = hi$13;
        totalNanos__lo = $$x7__lo;
        totalNanos__hi = $$x7__hi;
        var a$4__lo = totalNanos__lo;
        var a$4__hi = totalNanos__hi;
        var this$26 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$4__lo, a$4__hi), new $c_RTLong((-1857093632), 20116));
        var excessDays = this$26.RTLong__f_lo;
        var a$5__lo = totalNanos__lo;
        var a$5__hi = totalNanos__hi;
        var t$14 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$5__lo, a$5__hi), new $c_RTLong((-1857093632), 20116));
        var lo$14 = t$14.RTLong__f_lo;
        var hi$14 = t$14.RTLong__f_hi;
        var time$4 = $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$14, hi$14));
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$4;
        var this$27 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$27.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, excessDays)
      } else {
        var a$6__lo = hodVal$2__lo;
        var a$6__hi = hodVal$2__hi;
        var t$15 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$6__lo, a$6__hi), new $c_RTLong(3600, 0));
        var lo$15 = t$15.RTLong__f_lo;
        var hi$15 = t$15.RTLong__f_hi;
        var totalSecs__lo = lo$15;
        var totalSecs__hi = hi$15;
        var a$7__lo = totalSecs__lo;
        var a$7__hi = totalSecs__hi;
        var t$16 = $uJ(moh);
        var lo$16 = t$16.RTLong__f_lo;
        var hi$16 = t$16.RTLong__f_hi;
        var t$17 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$16, hi$16), new $c_RTLong(60, 0));
        var lo$17 = t$17.RTLong__f_lo;
        var hi$17 = t$17.RTLong__f_hi;
        var t$18 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$7__lo, a$7__hi), new $c_RTLong(lo$17, hi$17));
        var lo$18 = t$18.RTLong__f_lo;
        var hi$18 = t$18.RTLong__f_hi;
        var $$x8__lo = lo$18;
        var $$x8__hi = hi$18;
        totalSecs__lo = $$x8__lo;
        totalSecs__hi = $$x8__hi;
        var a$8__lo = totalSecs__lo;
        var a$8__hi = totalSecs__hi;
        var this$29 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$8__lo, a$8__hi), new $c_RTLong(86400, 0));
        var excessDays$2 = this$29.RTLong__f_lo;
        var a$9__lo = totalSecs__lo;
        var a$9__hi = totalSecs__hi;
        var t$19 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$9__lo, a$9__hi), new $c_RTLong(86400, 0));
        var lo$19 = t$19.RTLong__f_lo;
        var hi$19 = t$19.RTLong__f_hi;
        var time$5 = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$19, hi$19));
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$5;
        var this$30 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$30.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, excessDays$2)
      }
    } else {
      var a$10__lo = hodVal$2__lo;
      var a$10__hi = hodVal$2__hi;
      var t$20 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$10__lo, a$10__hi), new $c_RTLong(24, 0));
      var lo$20 = t$20.RTLong__f_lo;
      var hi$20 = t$20.RTLong__f_hi;
      var excessDays$3 = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$20, hi$20));
      var a$11__lo = hodVal$2__lo;
      var a$11__hi = hodVal$2__hi;
      var t$21 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$11__lo, a$11__hi), new $c_RTLong(24, 0));
      var lo$21 = t$21.RTLong__f_lo;
      var hi$21 = t$21.RTLong__f_hi;
      var $$x9__lo = lo$21;
      var $$x9__hi = hi$21;
      hodVal$2__lo = $$x9__lo;
      hodVal$2__hi = $$x9__hi;
      var $$x10 = $m_Ljava_time_LocalTime$();
      var this$31__lo = hodVal$2__lo;
      var this$31__hi = hodVal$2__hi;
      var time$6 = $$x10.of__I__I__Ljava_time_LocalTime(this$31__lo, 0);
      $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$6;
      var this$32 = $m_Ljava_time_Period$();
      $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$32.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, excessDays$3)
    }
  };
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())
}
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V($thiz) {
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_zone)
    } else {
      var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      var offsetSecs = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null));
      if ((offsetSecs !== null)) {
        var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs.RTLong__f_lo);
        $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, offset)
      }
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, selectedZone) {
  var this$2 = $m_Ljava_time_Instant$();
  var x = $as_jl_Long($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()));
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var instant = this$2.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), 0);
  var zdt = $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, selectedZone);
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_date === null)) {
    var this$4 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
    var date = this$4.Ljava_time_LocalDateTime__f_date;
    $thiz.Ljava_time_format_DateTimeBuilder__f_date = date
  } else {
    var $$x1 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    var this$5 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
    $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, $$x1, this$5.Ljava_time_LocalDateTime__f_date)
  };
  var $$x2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$6 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
  var value = this$6.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$1 = (value >> 31);
  $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x2, new $c_RTLong(value, hi$1))
}
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__V($thiz) {
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.ju_HashMap__f_contentSize > 0)) {
    if ((($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null) && ($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
      var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$1, localTime))
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_date)
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_time)
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, temporal) {
  var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var it = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
  while (it.hasNext__Z()) {
    var entry = $as_ju_Map$Entry(it.next__O());
    var field = $as_Ljava_time_temporal_TemporalField(entry.getKey__O());
    var x = $as_jl_Long(entry.getValue__O());
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      var temporalValue__lo = 0;
      var temporalValue__hi = 0;
      try {
        var t$1 = temporal.getLong__Ljava_time_temporal_TemporalField__J(field);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var $$x1__lo = lo$1;
        var $$x1__hi = hi$1;
        temporalValue__lo = $$x1__lo;
        temporalValue__hi = $$x1__hi
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((!(e$2 instanceof $c_jl_RuntimeException))) {
          throw e
        }
      };
      var this$3__lo = temporalValue__lo;
      var this$3__hi = temporalValue__hi;
      if ((!((this$3__lo === lo) && (this$3__hi === hi)))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Cross check failed: " + field) + " ") + new $c_RTLong(temporalValue__lo, temporalValue__hi)) + " vs ") + field) + " ") + new $c_RTLong(lo, hi)))
      };
      it.remove__V()
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V($thiz) {
  if ((($thiz.Ljava_time_format_DateTimeBuilder__f_time === null) && (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) || $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField())))) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var x = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null));
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$5 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$1 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$3 = $m_RTLong$();
      var lo$1 = this$3.divideImpl__I__I__I__I__I(lo, hi, 1000, 0);
      var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x2 = new $c_RTLong(lo$1, hi$1);
      if ((key$1 === null)) {
        var $$x1 = 0
      } else {
        var originalHash = $systemIdentityHashCode(key$1);
        var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
      };
      this$5.java$util$HashMap$$put0__O__O__I__Z__O(key$1, $$x2, $$x1, false);
      var this$10 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$2 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$8 = $m_RTLong$();
      var lo$2 = this$8.divideImpl__I__I__I__I__I(lo, hi, 1000000, 0);
      var hi$2 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x4 = new $c_RTLong(lo$2, hi$2);
      if ((key$2 === null)) {
        var $$x3 = 0
      } else {
        var originalHash$1 = $systemIdentityHashCode(key$2);
        var $$x3 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0))
      };
      this$10.java$util$HashMap$$put0__O__O__I__Z__O(key$2, $$x4, $$x3, false)
    } else {
      var this$14 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$3 === null)) {
        var $$x5 = 0
      } else {
        var originalHash$2 = $systemIdentityHashCode(key$3);
        var $$x5 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0))
      };
      this$14.java$util$HashMap$$put0__O__O__I__Z__O(key$3, $L0, $$x5, false);
      var this$18 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$4 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$4 === null)) {
        var $$x6 = 0
      } else {
        var originalHash$3 = $systemIdentityHashCode(key$4);
        var $$x6 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0))
      };
      this$18.java$util$HashMap$$put0__O__O__I__Z__O(key$4, $L0, $$x6, false);
      var this$22 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$5 === null)) {
        var $$x7 = 0
      } else {
        var originalHash$4 = $systemIdentityHashCode(key$5);
        var $$x7 = (originalHash$4 ^ ((originalHash$4 >>> 16) | 0))
      };
      this$22.java$util$HashMap$$put0__O__O__I__Z__O(key$5, $L0, $$x7, false)
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V($thiz) {
  if ((($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null) && ($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
    var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    var key = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    var offsetSecs = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null));
    if ((offsetSecs !== null)) {
      var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs.RTLong__f_lo);
      var this$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      var this$3 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$2, localTime);
      var this$4 = $m_Ljava_time_ZonedDateTime$();
      var t = this$4.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$3, offset, null).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$6 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$1 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
      var $$x2 = new $c_RTLong(lo, hi);
      if ((key$1 === null)) {
        var $$x1 = 0
      } else {
        var originalHash = $systemIdentityHashCode(key$1);
        var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
      };
      this$6.java$util$HashMap$$put0__O__O__I__Z__O(key$1, $$x2, $$x1, false)
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone !== null)) {
      var this$9 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      var this$10 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$9, localTime$1);
      var zone = $thiz.Ljava_time_format_DateTimeBuilder__f_zone;
      var this$11 = $m_Ljava_time_ZonedDateTime$();
      var t$1 = this$11.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$10, zone, null).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var this$13 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var key$2 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
      var $$x4 = new $c_RTLong(lo$1, hi$1);
      if ((key$2 === null)) {
        var $$x3 = 0
      } else {
        var originalHash$1 = $systemIdentityHashCode(key$2);
        var $$x3 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0))
      };
      this$13.java$util$HashMap$$put0__O__O__I__Z__O(key$2, $$x4, $$x3, false)
    }
  }
}
/** @constructor */
function $c_Ljava_time_format_DateTimeBuilder() {
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = null;
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_leapSecond = false;
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null;
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_leapSecond = false;
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null
}
$c_Ljava_time_format_DateTimeBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeBuilder() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeBuilder.prototype = $c_Ljava_time_format_DateTimeBuilder.prototype;
$c_Ljava_time_format_DateTimeBuilder.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder = (function(field, value) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var this$2 = this.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var old = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, field, null));
  if ((old !== null)) {
    var this$3 = $uJ(old);
    var $$x1 = (!((this$3.RTLong__f_lo === value.RTLong__f_lo) && (this$3.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: " + field) + " ") + old) + " differs from ") + field) + " ") + value) + ": ") + this))
  } else {
    return $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder(this, field, value)
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder = (function(resolverStyle, resolverFields) {
  if ((resolverFields !== null)) {
    var this$1 = this.Ljava_time_format_DateTimeBuilder__f_fieldValues;
    new $c_ju_HashMap$KeySet(this$1).retainAll__ju_Collection__Z(resolverFields)
  };
  $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
  $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  if ($p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z(this, resolverStyle)) {
    $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
    $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
    $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle)
  };
  $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__crossCheck__V(this);
  if (((((this.Ljava_time_format_DateTimeBuilder__f_excessDays !== null) && (!this.Ljava_time_format_DateTimeBuilder__f_excessDays.isZero__Z())) && (this.Ljava_time_format_DateTimeBuilder__f_date !== null)) && (this.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
    var this$2 = this.Ljava_time_format_DateTimeBuilder__f_date;
    var amount = this.Ljava_time_format_DateTimeBuilder__f_excessDays;
    this.Ljava_time_format_DateTimeBuilder__f_date = $as_Ljava_time_LocalDate(amount.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$2));
    this.Ljava_time_format_DateTimeBuilder__f_excessDays = $m_Ljava_time_Period$().ZERO__Ljava_time_Period()
  };
  $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V(this);
  $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V(this);
  return this
});
$c_Ljava_time_format_DateTimeBuilder.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field !== null)) {
    if (this.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z(field)) {
      var $$x1 = true
    } else if ((this.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      var this$1 = this.Ljava_time_format_DateTimeBuilder__f_date;
      var $$x1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    } else {
      return ((this.Ljava_time_format_DateTimeBuilder__f_time !== null) && this.Ljava_time_format_DateTimeBuilder__f_time.isSupported__Ljava_time_temporal_TemporalField__Z(field))
    }
  } else {
    return false
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var this$2 = this.Ljava_time_format_DateTimeBuilder__f_fieldValues;
  var value = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, field, null));
  if ((value === null)) {
    if ((this.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      var this$3 = this.Ljava_time_format_DateTimeBuilder__f_date;
      var $$x1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$3, field)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return this.Ljava_time_format_DateTimeBuilder__f_date.getLong__Ljava_time_temporal_TemporalField__J(field)
    };
    if (((this.Ljava_time_format_DateTimeBuilder__f_time !== null) && this.Ljava_time_format_DateTimeBuilder__f_time.isSupported__Ljava_time_temporal_TemporalField__Z(field))) {
      return this.Ljava_time_format_DateTimeBuilder__f_time.getLong__Ljava_time_temporal_TemporalField__J(field)
    };
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field not found: " + field))
  };
  return $uJ(value)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_zone : ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_chrono : ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? ((this.Ljava_time_format_DateTimeBuilder__f_date !== null) ? $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(this.Ljava_time_format_DateTimeBuilder__f_date) : null) : ((query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_time : (((query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this) : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))))))
});
$c_Ljava_time_format_DateTimeBuilder.prototype.toString__T = (function() {
  var fields = ((this.Ljava_time_format_DateTimeBuilder__f_fieldValues.ju_HashMap__f_contentSize > 0) ? (("fields=" + this.Ljava_time_format_DateTimeBuilder__f_fieldValues) + ", ") : "");
  return (((((((((("DateTimeBuilder[" + fields) + " ") + this.Ljava_time_format_DateTimeBuilder__f_chrono) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_zone) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_date) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_time) + "]")
});
var $d_Ljava_time_format_DateTimeBuilder = new $TypeData().initClass({
  Ljava_time_format_DateTimeBuilder: 0
}, false, "java.time.format.DateTimeBuilder", {
  Ljava_time_format_DateTimeBuilder: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  jl_Cloneable: 1
});
$c_Ljava_time_format_DateTimeBuilder.prototype.$classData = $d_Ljava_time_format_DateTimeBuilder;
function $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__STRICT
}
function $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__SMART
}
function $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__LENIENT
}
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$() {
  this.Ljava_time_format_ResolverStyle$__f_$values = null;
  $n_Ljava_time_format_ResolverStyle$ = this;
  $t_Ljava_time_format_ResolverStyle$__STRICT = new $c_Ljava_time_format_ResolverStyle$$anon$1();
  $t_Ljava_time_format_ResolverStyle$__SMART = new $c_Ljava_time_format_ResolverStyle$$anon$2();
  $t_Ljava_time_format_ResolverStyle$__LENIENT = new $c_Ljava_time_format_ResolverStyle$$anon$3();
  this.Ljava_time_format_ResolverStyle$__f_$values = new ($d_Ljava_time_format_ResolverStyle.getArrayOf().constr)([$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle(), $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle(), $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle()])
}
$c_Ljava_time_format_ResolverStyle$.prototype = new $h_O();
$c_Ljava_time_format_ResolverStyle$.prototype.constructor = $c_Ljava_time_format_ResolverStyle$;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle$.prototype = $c_Ljava_time_format_ResolverStyle$.prototype;
$c_Ljava_time_format_ResolverStyle$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_format_ResolverStyle(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_format_ResolverStyle$ = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle$: 0
}, false, "java.time.format.ResolverStyle$", {
  Ljava_time_format_ResolverStyle$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_format_ResolverStyle$.prototype.$classData = $d_Ljava_time_format_ResolverStyle$;
var $n_Ljava_time_format_ResolverStyle$;
function $m_Ljava_time_format_ResolverStyle$() {
  if ((!$n_Ljava_time_format_ResolverStyle$)) {
    $n_Ljava_time_format_ResolverStyle$ = new $c_Ljava_time_format_ResolverStyle$()
  };
  return $n_Ljava_time_format_ResolverStyle$
}
function $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NORMAL
}
function $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__ALWAYS
}
function $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NEVER
}
function $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE
}
function $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD
}
/** @constructor */
function $c_Ljava_time_format_SignStyle$() {
  this.Ljava_time_format_SignStyle$__f_$values = null;
  $n_Ljava_time_format_SignStyle$ = this;
  $t_Ljava_time_format_SignStyle$__NORMAL = new $c_Ljava_time_format_SignStyle$$anon$1();
  $t_Ljava_time_format_SignStyle$__ALWAYS = new $c_Ljava_time_format_SignStyle$$anon$2();
  $t_Ljava_time_format_SignStyle$__NEVER = new $c_Ljava_time_format_SignStyle$$anon$3();
  $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = new $c_Ljava_time_format_SignStyle$$anon$4();
  $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = new $c_Ljava_time_format_SignStyle$$anon$5();
  this.Ljava_time_format_SignStyle$__f_$values = new ($d_Ljava_time_format_SignStyle.getArrayOf().constr)([$s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle(), $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle(), $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle(), $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle(), $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()])
}
$c_Ljava_time_format_SignStyle$.prototype = new $h_O();
$c_Ljava_time_format_SignStyle$.prototype.constructor = $c_Ljava_time_format_SignStyle$;
/** @constructor */
function $h_Ljava_time_format_SignStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$.prototype = $c_Ljava_time_format_SignStyle$.prototype;
$c_Ljava_time_format_SignStyle$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_format_SignStyle(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_format_SignStyle$ = new $TypeData().initClass({
  Ljava_time_format_SignStyle$: 0
}, false, "java.time.format.SignStyle$", {
  Ljava_time_format_SignStyle$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_format_SignStyle$.prototype.$classData = $d_Ljava_time_format_SignStyle$;
var $n_Ljava_time_format_SignStyle$;
function $m_Ljava_time_format_SignStyle$() {
  if ((!$n_Ljava_time_format_SignStyle$)) {
    $n_Ljava_time_format_SignStyle$ = new $c_Ljava_time_format_SignStyle$()
  };
  return $n_Ljava_time_format_SignStyle$
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_$values = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = this;
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4();
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_$values = new ($d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.getArrayOf().constr)([$s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(), $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(), $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(), $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser()])
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$
}
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND
}
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND
}
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND
}
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE
}
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR
}
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM
}
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM
}
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR
}
function $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR
}
function $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR
}
function $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH
}
function $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA
}
function $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR
}
function $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ERA
}
function $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS
}
function $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$() {
  this.Ljava_time_temporal_ChronoField$__f_$values = null;
  $n_Ljava_time_temporal_ChronoField$ = this;
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$1();
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$2();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$3();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$4();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$5();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$6();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = new $c_Ljava_time_temporal_ChronoField$$anon$7();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$8();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = new $c_Ljava_time_temporal_ChronoField$$anon$9();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$10();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$11();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$12();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$13();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$14();
  $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$15();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = new $c_Ljava_time_temporal_ChronoField$$anon$16();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$17();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$18();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$19();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$20();
  $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$21();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$22();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$23();
  $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$24();
  $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$25();
  $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = new $c_Ljava_time_temporal_ChronoField$$anon$26();
  $t_Ljava_time_temporal_ChronoField$__YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$27();
  $t_Ljava_time_temporal_ChronoField$__ERA = new $c_Ljava_time_temporal_ChronoField$$anon$28();
  $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$29();
  $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$30();
  this.Ljava_time_temporal_ChronoField$__f_$values = new ($d_Ljava_time_temporal_ChronoField.getArrayOf().constr)([$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()])
}
$c_Ljava_time_temporal_ChronoField$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoField$.prototype.constructor = $c_Ljava_time_temporal_ChronoField$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$.prototype = $c_Ljava_time_temporal_ChronoField$.prototype;
$c_Ljava_time_temporal_ChronoField$.prototype.values__ALjava_time_temporal_ChronoField = (function() {
  var this$1 = this.Ljava_time_temporal_ChronoField$__f_$values;
  return this$1.clone__O()
});
$c_Ljava_time_temporal_ChronoField$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_temporal_ChronoField(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_temporal_ChronoField$ = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$: 0
}, false, "java.time.temporal.ChronoField$", {
  Ljava_time_temporal_ChronoField$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_temporal_ChronoField$.prototype.$classData = $d_Ljava_time_temporal_ChronoField$;
var $n_Ljava_time_temporal_ChronoField$;
function $m_Ljava_time_temporal_ChronoField$() {
  if ((!$n_Ljava_time_temporal_ChronoField$)) {
    $n_Ljava_time_temporal_ChronoField$ = new $c_Ljava_time_temporal_ChronoField$()
  };
  return $n_Ljava_time_temporal_ChronoField$
}
function $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__NANOS
}
function $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MICROS
}
function $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLIS
}
function $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__SECONDS
}
function $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MINUTES
}
function $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HOURS
}
function $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS
}
function $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DAYS
}
function $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__WEEKS
}
function $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MONTHS
}
function $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__YEARS
}
function $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DECADES
}
function $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__CENTURIES
}
function $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA
}
function $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__ERAS
}
function $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__FOREVER
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$() {
  this.Ljava_time_temporal_ChronoUnit$__f_$values = null;
  $n_Ljava_time_temporal_ChronoUnit$ = this;
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = new $c_Ljava_time_temporal_ChronoUnit$$anon$1();
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = new $c_Ljava_time_temporal_ChronoUnit$$anon$2();
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = new $c_Ljava_time_temporal_ChronoUnit$$anon$3();
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = new $c_Ljava_time_temporal_ChronoUnit$$anon$4();
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = new $c_Ljava_time_temporal_ChronoUnit$$anon$5();
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = new $c_Ljava_time_temporal_ChronoUnit$$anon$6();
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$7();
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$8();
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = new $c_Ljava_time_temporal_ChronoUnit$$anon$9();
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = new $c_Ljava_time_temporal_ChronoUnit$$anon$10();
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = new $c_Ljava_time_temporal_ChronoUnit$$anon$11();
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = new $c_Ljava_time_temporal_ChronoUnit$$anon$12();
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = new $c_Ljava_time_temporal_ChronoUnit$$anon$13();
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = new $c_Ljava_time_temporal_ChronoUnit$$anon$14();
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = new $c_Ljava_time_temporal_ChronoUnit$$anon$15();
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = new $c_Ljava_time_temporal_ChronoUnit$$anon$16();
  this.Ljava_time_temporal_ChronoUnit$__f_$values = new ($d_Ljava_time_temporal_ChronoUnit.getArrayOf().constr)([$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()])
}
$c_Ljava_time_temporal_ChronoUnit$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoUnit$.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$.prototype = $c_Ljava_time_temporal_ChronoUnit$.prototype;
$c_Ljava_time_temporal_ChronoUnit$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_temporal_ChronoUnit(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_temporal_ChronoUnit$ = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$: 0
}, false, "java.time.temporal.ChronoUnit$", {
  Ljava_time_temporal_ChronoUnit$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$;
var $n_Ljava_time_temporal_ChronoUnit$;
function $m_Ljava_time_temporal_ChronoUnit$() {
  if ((!$n_Ljava_time_temporal_ChronoUnit$)) {
    $n_Ljava_time_temporal_ChronoUnit$ = new $c_Ljava_time_temporal_ChronoUnit$()
  };
  return $n_Ljava_time_temporal_ChronoUnit$
}
function $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O($thiz, dt) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    if ((($thiz.Ljava_time_zone_StandardZoneRules__f_lastRules.u.length > 0) && dt.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.get((((-1) + $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u.length) | 0))))) {
      var this$1 = dt.Ljava_time_LocalDateTime__f_date;
      var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, this$1.Ljava_time_LocalDate__f_year);
      var info = new $c_sr_ObjectRef(null);
      var f = ((this$4, dt$2, info$2, nonLocalReturnKey1$2) => ((trans) => {
        var trans$1 = $as_Ljava_time_zone_ZoneOffsetTransition(trans);
        var ev$3 = $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__O(this$4, dt$2, trans$1);
        info$2.sr_ObjectRef__f_elem = ev$3;
        if ((info$2.sr_ObjectRef__f_elem instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
          var $$x1 = true
        } else {
          var x = info$2.sr_ObjectRef__f_elem;
          var x$2 = trans$1.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
          var $$x1 = ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2))
        };
        if ($$x1) {
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey1$2, info$2.sr_ObjectRef__f_elem)
        }
      }))($thiz, dt, info, nonLocalReturnKey1);
      var len = transArray.u.length;
      var i = 0;
      if ((transArray !== null)) {
        while ((i < len)) {
          var arg1 = transArray.get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_I)) {
        var x3 = $asArrayOf_I(transArray, 1);
        while ((i < len)) {
          var arg1$1 = x3.get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_D)) {
        var x4 = $asArrayOf_D(transArray, 1);
        while ((i < len)) {
          var arg1$2 = x4.get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_J)) {
        var x5 = $asArrayOf_J(transArray, 1);
        while ((i < len)) {
          var t = x5.get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_F)) {
        var x6 = $asArrayOf_F(transArray, 1);
        while ((i < len)) {
          var arg1$3 = x6.get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_C)) {
        var x7 = $asArrayOf_C(transArray, 1);
        while ((i < len)) {
          var arg1$4 = x7.get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_B)) {
        var x8 = $asArrayOf_B(transArray, 1);
        while ((i < len)) {
          var arg1$5 = x8.get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_S)) {
        var x9 = $asArrayOf_S(transArray, 1);
        while ((i < len)) {
          var arg1$6 = x9.get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(transArray, 1);
        while ((i < len)) {
          var arg1$7 = x10.get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(transArray)
      };
      return info.sr_ObjectRef__f_elem
    };
    var a = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions;
    var index = $m_ju_Arrays$().binarySearch__AO__O__I(a, dt);
    if ((index === (-1))) {
      return $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get(0)
    };
    if ((index < 0)) {
      index = (((-2) - index) | 0)
    } else {
      if ((index < (((-1) + $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u.length) | 0))) {
        var x$1 = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.get(index);
        var x$2$1 = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.get(((1 + index) | 0));
        var $$x2 = ((x$1 === null) ? (x$2$1 === null) : x$1.equals__O__Z(x$2$1))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        index = ((1 + index) | 0)
      }
    };
    if (((1 & index) === 0)) {
      var dtBefore = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.get(index);
      var dtAfter = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.get(((1 + index) | 0));
      var offsetBefore = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get(((index / 2) | 0));
      var offsetAfter = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get(((1 + ((index / 2) | 0)) | 0));
      return ((offsetAfter.Ljava_time_ZoneOffset__f_totalSeconds > offsetBefore.Ljava_time_ZoneOffset__f_totalSeconds) ? new $c_Ljava_time_zone_ZoneOffsetTransition(dtBefore, offsetBefore, offsetAfter) : new $c_Ljava_time_zone_ZoneOffsetTransition(dtAfter, offsetBefore, offsetAfter))
    } else {
      return $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get(((1 + ((index / 2) | 0)) | 0))
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if ((ex.sr_NonLocalReturnControl__f_key === nonLocalReturnKey1)) {
        return ex.sr_NonLocalReturnControl__f_value
      } else {
        throw ex
      }
    } else {
      throw e
    }
  }
}
function $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__O($thiz, dt, trans) {
  var localTransition = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
  if (trans.isGap__Z()) {
    if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition)) {
      return trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
    } else {
      var this$2 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value >> 31);
      if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$2, this$2.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value, hi), $L0, 1))) {
        return trans
      } else {
        return trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
      }
    }
  } else if ((!dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition))) {
    return trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
  } else {
    var this$4 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
    var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
    var hi$1 = (value$1 >> 31);
    if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$4, this$4.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi$1), $L0, 1))) {
      return trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
    } else {
      return trans
    }
  }
}
function $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, year) {
  var this$2 = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRulesCache;
  var transArray = $asArrayOf_Ljava_time_zone_ZoneOffsetTransition($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$2, year, null), 1);
  if ((transArray !== null)) {
    return transArray
  };
  var ruleArray = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRules;
  var dimensions = new $ac_I(new Int32Array([ruleArray.u.length]));
  transArray = $asArrayOf_Ljava_time_zone_ZoneOffsetTransition($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_zone_ZoneOffsetTransition.getClassOf(), dimensions), 1);
  var i = 0;
  while ((i < ruleArray.u.length)) {
    transArray.set(i, ruleArray.get(i).createTransition__I__Ljava_time_zone_ZoneOffsetTransition(year));
    i = ((1 + i) | 0)
  };
  if ((year < $m_Ljava_time_zone_StandardZoneRules$().Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$$LAST_CACHED_YEAR)) {
    var this$4 = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRulesCache;
    var value = transArray;
    this$4.java$util$HashMap$$put0__O__O__I__Z__O(year, value, (year ^ ((year >>> 16) | 0)), false)
  };
  return transArray
}
function $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I($thiz, epochSecond, offset) {
  var value = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var ahi = epochSecond.RTLong__f_hi;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
  var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(86400, 0));
  var lo$1 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var this$3 = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$2));
  return this$3.Ljava_time_LocalDate__f_year
}
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, lastRules, savingsLocalTransitions) {
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = null;
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = standardTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = standardOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = savingsInstantTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = wallOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = lastRules;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = savingsLocalTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = $ct_ju_HashMap__(new $c_ju_HashMap())
}
$c_Ljava_time_zone_StandardZoneRules.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_StandardZoneRules.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules() {
  /*<skip>*/
}
$h_Ljava_time_zone_StandardZoneRules.prototype = $c_Ljava_time_zone_StandardZoneRules.prototype;
$c_Ljava_time_zone_StandardZoneRules.prototype.isFixedOffset__Z = (function() {
  return (this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.u.length === 0)
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  var t = instant.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if ((this.Ljava_time_zone_StandardZoneRules__f_lastRules.u.length > 0)) {
    var b = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.get((((-1) + this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.u.length) | 0));
    var bhi = b.RTLong__f_hi;
    var $$x1 = ((hi === bhi) ? (((-2147483648) ^ lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (hi > bhi))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var year = $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I(this, new $c_RTLong(lo, hi), this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get((((-1) + this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u.length) | 0)));
    var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition(this, year);
    var trans = null;
    var i = 0;
    while ((i < transArray.u.length)) {
      trans = transArray.get(i);
      var this$1 = trans;
      var b$1 = this$1.Ljava_time_zone_ZoneOffsetTransition__f_transition.toEpochSecond__Ljava_time_ZoneOffset__J(this$1.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
      var bhi$1 = b$1.RTLong__f_hi;
      if (((hi === bhi$1) ? (((-2147483648) ^ lo) < ((-2147483648) ^ b$1.RTLong__f_lo)) : (hi < bhi$1))) {
        var this$2 = trans;
        return this$2.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
      };
      i = ((1 + i) | 0)
    };
    var this$3 = trans;
    return this$3.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
  };
  var a = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var index = $m_ju_Arrays$().binarySearch__AJ__J__I(a, new $c_RTLong(lo, hi));
  if ((index < 0)) {
    index = (((-2) - index) | 0)
  };
  return this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.get(((1 + index) | 0))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var x4 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O(this, localDateTime);
  if ((x4 instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var transition = $as_Ljava_time_zone_ZoneOffsetTransition(x4);
    return transition.getValidOffsets__ju_List()
  };
  if ((x4 instanceof $c_Ljava_time_ZoneOffset)) {
    var offset = $as_Ljava_time_ZoneOffset(x4);
    return $m_ju_Collections$().singletonList__O__ju_List(offset)
  };
  throw new $c_s_MatchError(x4)
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  var x7 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O(this, localDateTime);
  if ((x7 instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var transition = $as_Ljava_time_zone_ZoneOffsetTransition(x7);
    return transition
  };
  return null
});
$c_Ljava_time_zone_StandardZoneRules.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(localDateTime, offset) {
  return this.getValidOffsets__Ljava_time_LocalDateTime__ju_List(localDateTime).contains__O__Z(offset)
});
$c_Ljava_time_zone_StandardZoneRules.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    var other = $as_Ljava_time_zone_StandardZoneRules(obj);
    if ((this === other)) {
      return true
    } else {
      var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      var b = other.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      if ($m_ju_Arrays$().equals__AJ__AJ__Z(a, b)) {
        var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var b$1 = other.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var $$x3 = $m_ju_Arrays$().equals__AO__AO__Z(a$1, b$1)
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var b$2 = other.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var $$x2 = $m_ju_Arrays$().equals__AJ__AJ__Z(a$2, b$2)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var b$3 = other.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var $$x1 = $m_ju_Arrays$().equals__AO__AO__Z(a$3, b$3)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
        var b$4 = other.Ljava_time_zone_StandardZoneRules__f_lastRules;
        return $m_ju_Arrays$().equals__AO__AO__Z(a$4, b$4)
      } else {
        return false
      }
    }
  } else if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    if (this.isFixedOffset__Z()) {
      var x = this.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      var this$1 = $as_Ljava_time_zone_ZoneRules$Fixed(obj);
      $m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant();
      var x$2 = this$1.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_StandardZoneRules.prototype.hashCode__I = (function() {
  var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
  var $$x4 = $m_ju_Arrays$().hashCode__AJ__I(a);
  var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
  var $$x3 = $m_ju_Arrays$().hashCode__AO__I(a$1);
  var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var $$x2 = $m_ju_Arrays$().hashCode__AJ__I(a$2);
  var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
  var $$x1 = $m_ju_Arrays$().hashCode__AO__I(a$3);
  var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
  return (((($$x4 ^ $$x3) ^ $$x2) ^ $$x1) ^ $m_ju_Arrays$().hashCode__AO__I(a$4))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.toString__T = (function() {
  return (("StandardZoneRules[currentStandardOffset=" + this.Ljava_time_zone_StandardZoneRules__f_standardOffsets.get((((-1) + this.Ljava_time_zone_StandardZoneRules__f_standardOffsets.u.length) | 0))) + "]")
});
function $as_Ljava_time_zone_StandardZoneRules(obj) {
  return (((obj instanceof $c_Ljava_time_zone_StandardZoneRules) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.StandardZoneRules"))
}
function $isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_StandardZoneRules)))
}
function $asArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.StandardZoneRules;", depth))
}
var $d_Ljava_time_zone_StandardZoneRules = new $TypeData().initClass({
  Ljava_time_zone_StandardZoneRules: 0
}, false, "java.time.zone.StandardZoneRules", {
  Ljava_time_zone_StandardZoneRules: 1,
  Ljava_time_zone_ZoneRules: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_StandardZoneRules.prototype.$classData = $d_Ljava_time_zone_StandardZoneRules;
function $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$();
  return $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC
}
function $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$();
  return $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL
}
function $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$();
  return $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_$values = null;
  $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$ = this;
  $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1();
  $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2();
  $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3();
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_$values = new ($d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.getArrayOf().constr)([$s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(), $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(), $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition()])
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.values__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = (function() {
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_$values;
  return this$1.clone__O()
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$TimeDefinition$", {
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
var $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
function $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$)) {
    $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$ = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$Fixed(offset) {
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = null;
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = offset
}
$c_Ljava_time_zone_ZoneRules$Fixed.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.constructor = $c_Ljava_time_zone_ZoneRules$Fixed;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$Fixed() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules$Fixed.prototype = $c_Ljava_time_zone_ZoneRules$Fixed.prototype;
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isFixedOffset__Z = (function() {
  return true
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  return this.Ljava_time_zone_ZoneRules$Fixed__f_offset
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var o = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return $m_ju_Collections$().singletonList__O__ju_List(o)
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  return null
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(dateTime, offset) {
  var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return ((x === null) ? (offset === null) : x.equals__O__Z(offset))
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    var fixed = $as_Ljava_time_zone_ZoneRules$Fixed(obj);
    if ((this === fixed)) {
      return true
    } else {
      var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$2 = fixed.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    var rules = $as_Ljava_time_zone_StandardZoneRules(obj);
    if (rules.isFixedOffset__Z()) {
      var x$3 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$4 = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.hashCode__I = (function() {
  var this$1 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return (1 ^ (((31 + $$x1) | 0) ^ ((31 + this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)))
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.toString__T = (function() {
  return ("FixedRules:" + this.Ljava_time_zone_ZoneRules$Fixed__f_offset)
});
function $as_Ljava_time_zone_ZoneRules$Fixed(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRules$Fixed"))
}
function $isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules$Fixed)))
}
function $asArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRules$Fixed;", depth))
}
var $d_Ljava_time_zone_ZoneRules$Fixed = new $TypeData().initClass({
  Ljava_time_zone_ZoneRules$Fixed: 0
}, false, "java.time.zone.ZoneRules$Fixed", {
  Ljava_time_zone_ZoneRules$Fixed: 1,
  Ljava_time_zone_ZoneRules: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.$classData = $d_Ljava_time_zone_ZoneRules$Fixed;
function $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z($thiz, iter, o$2) {
  while (true) {
    if (iter.hasNext__Z()) {
      var a = iter.next__O();
      if (((a === null) ? (o$2 === null) : $dp_equals__O__Z(a, o$2))) {
        iter.remove__V();
        return true
      }
    } else {
      return false
    }
  }
}
/** @constructor */
function $c_ju_AbstractCollection() {
  /*<skip>*/
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
  /*<skip>*/
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = _\uff3fself.next__O();
    if (((o === null) ? (arg1 === null) : $dp_equals__O__Z(o, arg1))) {
      return true
    }
  };
  return false
});
$c_ju_AbstractCollection.prototype.toArray__AO = (function() {
  return this.toArray__AO__AO(new $ac_O(this.size__I()))
});
$c_ju_AbstractCollection.prototype.toArray__AO__AO = (function(a) {
  if ((a.u.length >= this.size__I())) {
    var toFill = a
  } else {
    var componentType = $objectGetClass(a).getComponentType__jl_Class();
    var length = this.size__I();
    var toFill = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1)
  };
  var iter = this.iterator__ju_Iterator();
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var arg1 = i;
    toFill.set(arg1, iter.next__O());
    i = ((1 + i) | 0)
  };
  if ((toFill.u.length > this.size__I())) {
    toFill.set(this.size__I(), null)
  };
  return toFill
});
$c_ju_AbstractCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractCollection.prototype.remove__O__Z = (function(o) {
  return $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z(this, this.iterator__ju_Iterator(), o)
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var arg1 = _\uff3fself.next__O();
      if ((!this.contains__O__Z(arg1))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_AbstractCollection.prototype.addAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  var result = false;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uZ(arg1);
    result = (this.add__O__Z(arg2) || prev)
  };
  return $uZ(result)
});
$c_ju_AbstractCollection.prototype.retainAll__ju_Collection__Z = (function(c) {
  var iter = this.iterator__ju_Iterator();
  var changed = false;
  while (iter.hasNext__Z()) {
    var arg1 = iter.next__O();
    if ((!c.contains__O__Z(arg1))) {
      iter.remove__V();
      changed = true
    }
  };
  return changed
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + _\uff3fself.next__O())
  };
  return (result + "]")
});
/** @constructor */
function $c_ju_AbstractMap$SimpleImmutableEntry(key, value) {
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = key;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = value
}
$c_ju_AbstractMap$SimpleImmutableEntry.prototype = new $h_O();
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.constructor = $c_ju_AbstractMap$SimpleImmutableEntry;
/** @constructor */
function $h_ju_AbstractMap$SimpleImmutableEntry() {
  /*<skip>*/
}
$h_ju_AbstractMap$SimpleImmutableEntry.prototype = $c_ju_AbstractMap$SimpleImmutableEntry.prototype;
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getKey__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_key
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getValue__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_value
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.equals__O__Z = (function(o) {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z(this, o)
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.hashCode__I = (function() {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I(this)
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.toString__T = (function() {
  return ((this.ju_AbstractMap$SimpleImmutableEntry__f_key + "=") + this.ju_AbstractMap$SimpleImmutableEntry__f_value)
});
var $d_ju_AbstractMap$SimpleImmutableEntry = new $TypeData().initClass({
  ju_AbstractMap$SimpleImmutableEntry: 0
}, false, "java.util.AbstractMap$SimpleImmutableEntry", {
  ju_AbstractMap$SimpleImmutableEntry: 1,
  O: 1,
  ju_Map$Entry: 1,
  Ljava_io_Serializable: 1
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.$classData = $d_ju_AbstractMap$SimpleImmutableEntry;
function $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableIterator__f_inner = inner;
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator() {
  this.ju_Collections$UnmodifiableIterator__f_inner = null
}
$c_ju_Collections$UnmodifiableIterator.prototype = new $h_O();
$c_ju_Collections$UnmodifiableIterator.prototype.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableIterator.prototype = $c_ju_Collections$UnmodifiableIterator.prototype;
$c_ju_Collections$UnmodifiableIterator.prototype.hasNext__Z = (function() {
  return this.ju_Collections$UnmodifiableIterator__f_inner.hasNext__Z()
});
$c_ju_Collections$UnmodifiableIterator.prototype.next__O = (function() {
  return this.ju_Collections$UnmodifiableIterator__f_inner.next__O()
});
$c_ju_Collections$UnmodifiableIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_Collections$UnmodifiableIterator = new $TypeData().initClass({
  ju_Collections$UnmodifiableIterator: 0
}, false, "java.util.Collections$UnmodifiableIterator", {
  ju_Collections$UnmodifiableIterator: 1,
  O: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1
});
$c_ju_Collections$UnmodifiableIterator.prototype.$classData = $d_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $c_ju_HashMap$KeyIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer)
}
$c_ju_HashMap$KeyIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$KeyIterator.prototype.constructor = $c_ju_HashMap$KeyIterator;
/** @constructor */
function $h_ju_HashMap$KeyIterator() {
  /*<skip>*/
}
$h_ju_HashMap$KeyIterator.prototype = $c_ju_HashMap$KeyIterator.prototype;
$c_ju_HashMap$KeyIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_key
});
var $d_ju_HashMap$KeyIterator = new $TypeData().initClass({
  ju_HashMap$KeyIterator: 0
}, false, "java.util.HashMap$KeyIterator", {
  ju_HashMap$KeyIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_HashMap$KeyIterator.prototype.$classData = $d_ju_HashMap$KeyIterator;
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer)
}
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
$c_ju_HashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node
});
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass({
  ju_HashMap$NodeIterator: 0
}, false, "java.util.HashMap$NodeIterator", {
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_HashMap$NodeIterator.prototype.$classData = $d_ju_HashMap$NodeIterator;
/** @constructor */
function $c_ju_LinkedHashMap$KeyIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer)
}
$c_ju_LinkedHashMap$KeyIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$KeyIterator.prototype.constructor = $c_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $h_ju_LinkedHashMap$KeyIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$KeyIterator.prototype = $c_ju_LinkedHashMap$KeyIterator.prototype;
$c_ju_LinkedHashMap$KeyIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_key
});
var $d_ju_LinkedHashMap$KeyIterator = new $TypeData().initClass({
  ju_LinkedHashMap$KeyIterator: 0
}, false, "java.util.LinkedHashMap$KeyIterator", {
  ju_LinkedHashMap$KeyIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_LinkedHashMap$KeyIterator.prototype.$classData = $d_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  this.ju_LinkedHashMap$Node__f_older = null;
  this.ju_LinkedHashMap$Node__f_younger = null;
  this.ju_LinkedHashMap$Node__f_older = older;
  this.ju_LinkedHashMap$Node__f_younger = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next)
}
$c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_LinkedHashMap$Node.prototype.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$Node.prototype = $c_ju_LinkedHashMap$Node.prototype;
function $as_ju_LinkedHashMap$Node(obj) {
  return (((obj instanceof $c_ju_LinkedHashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.LinkedHashMap$Node"))
}
function $isArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_LinkedHashMap$Node)))
}
function $asArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (($isArrayOf_ju_LinkedHashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.LinkedHashMap$Node;", depth))
}
var $d_ju_LinkedHashMap$Node = new $TypeData().initClass({
  ju_LinkedHashMap$Node: 0
}, false, "java.util.LinkedHashMap$Node", {
  ju_LinkedHashMap$Node: 1,
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_LinkedHashMap$Node.prototype.$classData = $d_ju_LinkedHashMap$Node;
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer)
}
$c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$NodeIterator.prototype.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $c_ju_LinkedHashMap$NodeIterator.prototype;
$c_ju_LinkedHashMap$NodeIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node
});
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().initClass({
  ju_LinkedHashMap$NodeIterator: 0
}, false, "java.util.LinkedHashMap$NodeIterator", {
  ju_LinkedHashMap$NodeIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_LinkedHashMap$NodeIterator.prototype.$classData = $d_ju_LinkedHashMap$NodeIterator;
function $f_ju_List__sort__ju_Comparator__V($thiz, c) {
  var arrayBuf = $thiz.toArray__AO();
  $m_ju_Arrays$().sort__AO__ju_Comparator__V(arrayBuf, c);
  var len = arrayBuf.u.length;
  if ($is_ju_RandomAccess($thiz)) {
    var i = 0;
    while ((i !== len)) {
      $thiz.set__I__O__O(i, arrayBuf.get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var i$2 = 0;
    var iter = $thiz.listIterator__ju_ListIterator();
    while ((i$2 !== len)) {
      iter.next__O();
      iter.set__O__V(arrayBuf.get(i$2));
      i$2 = ((1 + i$2) | 0)
    }
  }
}
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)))
}
function $as_ju_List(obj) {
  return (($is_ju_List(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.List"))
}
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)))
}
function $asArrayOf_ju_List(obj, depth) {
  return (($isArrayOf_ju_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.List;", depth))
}
function $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__DISPLAY
}
function $s_ju_Locale$Category$__FORMAT__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__FORMAT
}
/** @constructor */
function $c_ju_Locale$Category$() {
  this.ju_Locale$Category$__f_$values = null;
  $n_ju_Locale$Category$ = this;
  $t_ju_Locale$Category$__DISPLAY = new $c_ju_Locale$$anon$2();
  $t_ju_Locale$Category$__FORMAT = new $c_ju_Locale$$anon$3();
  this.ju_Locale$Category$__f_$values = new ($d_ju_Locale$Category.getArrayOf().constr)([$s_ju_Locale$Category$__DISPLAY__ju_Locale$Category(), $s_ju_Locale$Category$__FORMAT__ju_Locale$Category()])
}
$c_ju_Locale$Category$.prototype = new $h_O();
$c_ju_Locale$Category$.prototype.constructor = $c_ju_Locale$Category$;
/** @constructor */
function $h_ju_Locale$Category$() {
  /*<skip>*/
}
$h_ju_Locale$Category$.prototype = $c_ju_Locale$Category$.prototype;
$c_ju_Locale$Category$.prototype.values__Aju_Locale$Category = (function() {
  var this$1 = this.ju_Locale$Category$__f_$values;
  return this$1.clone__O()
});
$c_ju_Locale$Category$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_ju_Locale$Category(x);
  return x$0.jl_Enum__f__ordinal
});
var $d_ju_Locale$Category$ = new $TypeData().initClass({
  ju_Locale$Category$: 0
}, false, "java.util.Locale$Category$", {
  ju_Locale$Category$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_ju_Locale$Category$.prototype.$classData = $d_ju_Locale$Category$;
var $n_ju_Locale$Category$;
function $m_ju_Locale$Category$() {
  if ((!$n_ju_Locale$Category$)) {
    $n_ju_Locale$Category$ = new $c_ju_Locale$Category$()
  };
  return $n_ju_Locale$Category$
}
function $ct_ju_TimeZone__($thiz) {
  $thiz.ju_TimeZone__f_ID = null;
  return $thiz
}
/** @constructor */
function $c_ju_TimeZone() {
  this.ju_TimeZone__f_ID = null
}
$c_ju_TimeZone.prototype = new $h_O();
$c_ju_TimeZone.prototype.constructor = $c_ju_TimeZone;
/** @constructor */
function $h_ju_TimeZone() {
  /*<skip>*/
}
$h_ju_TimeZone.prototype = $c_ju_TimeZone.prototype;
/** @constructor */
function $c_ju_UUID(i1, i2, i3, i4, l1, l2) {
  this.ju_UUID__f_i1 = 0;
  this.ju_UUID__f_i2 = 0;
  this.ju_UUID__f_i3 = 0;
  this.ju_UUID__f_i4 = 0;
  this.ju_UUID__f_l1 = null;
  this.ju_UUID__f_l2 = null;
  this.ju_UUID__f_i1 = i1;
  this.ju_UUID__f_i2 = i2;
  this.ju_UUID__f_i3 = i3;
  this.ju_UUID__f_i4 = i4;
  this.ju_UUID__f_l1 = l1;
  this.ju_UUID__f_l2 = l2
}
$c_ju_UUID.prototype = new $h_O();
$c_ju_UUID.prototype.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
  /*<skip>*/
}
$h_ju_UUID.prototype = $c_ju_UUID.prototype;
$c_ju_UUID.prototype.toString__T = (function() {
  var i = this.ju_UUID__f_i1;
  var s = $as_T($uD((i >>> 0)).toString(16));
  var beginIndex = $uI(s.length);
  var $$x5 = $as_T("00000000".substring(beginIndex));
  var i$1 = ((this.ju_UUID__f_i2 >>> 16) | 0);
  var s$1 = $as_T($uD((i$1 >>> 0)).toString(16));
  var beginIndex$1 = $uI(s$1.length);
  var $$x4 = $as_T("0000".substring(beginIndex$1));
  var i$2 = (65535 & this.ju_UUID__f_i2);
  var s$2 = $as_T($uD((i$2 >>> 0)).toString(16));
  var beginIndex$2 = $uI(s$2.length);
  var $$x3 = $as_T("0000".substring(beginIndex$2));
  var i$3 = ((this.ju_UUID__f_i3 >>> 16) | 0);
  var s$3 = $as_T($uD((i$3 >>> 0)).toString(16));
  var beginIndex$3 = $uI(s$3.length);
  var $$x2 = $as_T("0000".substring(beginIndex$3));
  var i$4 = (65535 & this.ju_UUID__f_i3);
  var s$4 = $as_T($uD((i$4 >>> 0)).toString(16));
  var beginIndex$4 = $uI(s$4.length);
  var $$x1 = $as_T("0000".substring(beginIndex$4));
  var i$5 = this.ju_UUID__f_i4;
  var s$5 = $as_T($uD((i$5 >>> 0)).toString(16));
  var beginIndex$5 = $uI(s$5.length);
  return ((((((((((("" + $$x5) + s) + "-") + (("" + $$x4) + s$1)) + "-") + (("" + $$x3) + s$2)) + "-") + (("" + $$x2) + s$3)) + "-") + (("" + $$x1) + s$4)) + (("" + $as_T("00000000".substring(beginIndex$5))) + s$5))
});
$c_ju_UUID.prototype.hashCode__I = (function() {
  return (((this.ju_UUID__f_i1 ^ this.ju_UUID__f_i2) ^ this.ju_UUID__f_i3) ^ this.ju_UUID__f_i4)
});
$c_ju_UUID.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x2 = $as_ju_UUID(that);
    return ((((this.ju_UUID__f_i1 === x2.ju_UUID__f_i1) && (this.ju_UUID__f_i2 === x2.ju_UUID__f_i2)) && (this.ju_UUID__f_i3 === x2.ju_UUID__f_i3)) && (this.ju_UUID__f_i4 === x2.ju_UUID__f_i4))
  } else {
    return false
  }
});
$c_ju_UUID.prototype.compareTo__ju_UUID__I = (function(that) {
  return ((this.ju_UUID__f_i1 !== that.ju_UUID__f_i1) ? ((this.ju_UUID__f_i1 > that.ju_UUID__f_i1) ? 1 : (-1)) : ((this.ju_UUID__f_i2 !== that.ju_UUID__f_i2) ? ((this.ju_UUID__f_i2 > that.ju_UUID__f_i2) ? 1 : (-1)) : ((this.ju_UUID__f_i3 !== that.ju_UUID__f_i3) ? ((this.ju_UUID__f_i3 > that.ju_UUID__f_i3) ? 1 : (-1)) : ((this.ju_UUID__f_i4 !== that.ju_UUID__f_i4) ? ((this.ju_UUID__f_i4 > that.ju_UUID__f_i4) ? 1 : (-1)) : 0))))
});
$c_ju_UUID.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__ju_UUID__I($as_ju_UUID(x$1))
});
function $as_ju_UUID(obj) {
  return (((obj instanceof $c_ju_UUID) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.UUID"))
}
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_UUID)))
}
function $asArrayOf_ju_UUID(obj, depth) {
  return (($isArrayOf_ju_UUID(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.UUID;", depth))
}
var $d_ju_UUID = new $TypeData().initClass({
  ju_UUID: 0
}, false, "java.util.UUID", {
  ju_UUID: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_ju_UUID.prototype.$classData = $d_ju_UUID;
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns$() {
  this.Llocales_cldr_CalendarPatterns$__f_Zero = null;
  $n_Llocales_cldr_CalendarPatterns$ = this;
  $m_Llocales_cldr_CalendarPatterns$();
  var datePatterns = $m_sci_Map$EmptyMap$();
  var timePatterns = $m_sci_Map$EmptyMap$();
  this.Llocales_cldr_CalendarPatterns$__f_Zero = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns)
}
$c_Llocales_cldr_CalendarPatterns$.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns$.prototype.constructor = $c_Llocales_cldr_CalendarPatterns$;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns$() {
  /*<skip>*/
}
$h_Llocales_cldr_CalendarPatterns$.prototype = $c_Llocales_cldr_CalendarPatterns$.prototype;
$c_Llocales_cldr_CalendarPatterns$.prototype.toString__T = (function() {
  return "CalendarPatterns"
});
var $d_Llocales_cldr_CalendarPatterns$ = new $TypeData().initClass({
  Llocales_cldr_CalendarPatterns$: 0
}, false, "locales.cldr.CalendarPatterns$", {
  Llocales_cldr_CalendarPatterns$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Llocales_cldr_CalendarPatterns$.prototype.$classData = $d_Llocales_cldr_CalendarPatterns$;
var $n_Llocales_cldr_CalendarPatterns$;
function $m_Llocales_cldr_CalendarPatterns$() {
  if ((!$n_Llocales_cldr_CalendarPatterns$)) {
    $n_Llocales_cldr_CalendarPatterns$ = new $c_Llocales_cldr_CalendarPatterns$()
  };
  return $n_Llocales_cldr_CalendarPatterns$
}
/** @constructor */
function $c_Lnet_timerboard_Alliance$() {
  this.Lnet_timerboard_Alliance$__f_derived$Decoder$lzy4 = null;
  this.Lnet_timerboard_Alliance$__f_derived$Decoderbitmap$4 = false;
  this.Lnet_timerboard_Alliance$__f_derived$AsObject$lzy4 = null;
  this.Lnet_timerboard_Alliance$__f_derived$AsObjectbitmap$4 = false
}
$c_Lnet_timerboard_Alliance$.prototype = new $h_O();
$c_Lnet_timerboard_Alliance$.prototype.constructor = $c_Lnet_timerboard_Alliance$;
/** @constructor */
function $h_Lnet_timerboard_Alliance$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Alliance$.prototype = $c_Lnet_timerboard_Alliance$.prototype;
$c_Lnet_timerboard_Alliance$.prototype.toString__T = (function() {
  return "Alliance"
});
$c_Lnet_timerboard_Alliance$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Alliance$__f_derived$Decoderbitmap$4)) {
    this.Lnet_timerboard_Alliance$__f_derived$Decoder$lzy4 = new $c_Lnet_timerboard_Alliance$$anon$12();
    this.Lnet_timerboard_Alliance$__f_derived$Decoderbitmap$4 = true
  };
  return this.Lnet_timerboard_Alliance$__f_derived$Decoder$lzy4
});
$c_Lnet_timerboard_Alliance$.prototype.derived$AsObject__Lio_circe_Encoder$AsObject = (function() {
  if ((!this.Lnet_timerboard_Alliance$__f_derived$AsObjectbitmap$4)) {
    this.Lnet_timerboard_Alliance$__f_derived$AsObject$lzy4 = new $c_Lnet_timerboard_Alliance$$anon$13();
    this.Lnet_timerboard_Alliance$__f_derived$AsObjectbitmap$4 = true
  };
  return this.Lnet_timerboard_Alliance$__f_derived$AsObject$lzy4
});
$c_Lnet_timerboard_Alliance$.prototype.fromProduct__s_Product__Lnet_timerboard_Alliance = (function(x$0) {
  return new $c_Lnet_timerboard_Alliance($uJ(x$0.productElement__I__O(0)), $as_T(x$0.productElement__I__O(1)), $as_T(x$0.productElement__I__O(2)))
});
var $d_Lnet_timerboard_Alliance$ = new $TypeData().initClass({
  Lnet_timerboard_Alliance$: 0
}, false, "net.timerboard.Alliance$", {
  Lnet_timerboard_Alliance$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_Alliance$.prototype.$classData = $d_Lnet_timerboard_Alliance$;
var $n_Lnet_timerboard_Alliance$;
function $m_Lnet_timerboard_Alliance$() {
  if ((!$n_Lnet_timerboard_Alliance$)) {
    $n_Lnet_timerboard_Alliance$ = new $c_Lnet_timerboard_Alliance$()
  };
  return $n_Lnet_timerboard_Alliance$
}
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$() {
  this.Lnet_timerboard_BackendSocket$__f_init = null;
  $n_Lnet_timerboard_BackendSocket$ = this;
  $m_Lnet_timerboard_BackendSocket$();
  var socket = $m_s_None$();
  this.Lnet_timerboard_BackendSocket$__f_init = new $c_Lnet_timerboard_BackendSocket("wss://beta.timerboard.net/stream", socket)
}
$c_Lnet_timerboard_BackendSocket$.prototype = new $h_O();
$c_Lnet_timerboard_BackendSocket$.prototype.constructor = $c_Lnet_timerboard_BackendSocket$;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$.prototype = $c_Lnet_timerboard_BackendSocket$.prototype;
$c_Lnet_timerboard_BackendSocket$.prototype.toString__T = (function() {
  return "BackendSocket"
});
var $d_Lnet_timerboard_BackendSocket$ = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket$: 0
}, false, "net.timerboard.BackendSocket$", {
  Lnet_timerboard_BackendSocket$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_BackendSocket$.prototype.$classData = $d_Lnet_timerboard_BackendSocket$;
var $n_Lnet_timerboard_BackendSocket$;
function $m_Lnet_timerboard_BackendSocket$() {
  if ((!$n_Lnet_timerboard_BackendSocket$)) {
    $n_Lnet_timerboard_BackendSocket$ = new $c_Lnet_timerboard_BackendSocket$()
  };
  return $n_Lnet_timerboard_BackendSocket$
}
function $s_Lnet_timerboard_BackendSocket$Status$__Connecting__Lnet_timerboard_BackendSocket$Status() {
  $m_Lnet_timerboard_BackendSocket$Status$();
  return $t_Lnet_timerboard_BackendSocket$Status$__Connecting
}
function $s_Lnet_timerboard_BackendSocket$Status$__Disconnecting__Lnet_timerboard_BackendSocket$Status() {
  $m_Lnet_timerboard_BackendSocket$Status$();
  return $t_Lnet_timerboard_BackendSocket$Status$__Disconnecting
}
function $s_Lnet_timerboard_BackendSocket$Status$__Disconnected__Lnet_timerboard_BackendSocket$Status() {
  $m_Lnet_timerboard_BackendSocket$Status$();
  return $t_Lnet_timerboard_BackendSocket$Status$__Disconnected
}
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$Status$() {
  $n_Lnet_timerboard_BackendSocket$Status$ = this;
  $t_Lnet_timerboard_BackendSocket$Status$__Connecting = new $c_Lnet_timerboard_BackendSocket$$anon$1(0, "Connecting");
  $t_Lnet_timerboard_BackendSocket$Status$__Disconnecting = new $c_Lnet_timerboard_BackendSocket$$anon$1(3, "Disconnecting");
  $t_Lnet_timerboard_BackendSocket$Status$__Disconnected = new $c_Lnet_timerboard_BackendSocket$$anon$1(4, "Disconnected")
}
$c_Lnet_timerboard_BackendSocket$Status$.prototype = new $h_O();
$c_Lnet_timerboard_BackendSocket$Status$.prototype.constructor = $c_Lnet_timerboard_BackendSocket$Status$;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$Status$() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$Status$.prototype = $c_Lnet_timerboard_BackendSocket$Status$.prototype;
$c_Lnet_timerboard_BackendSocket$Status$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Lnet_timerboard_BackendSocket$Status(x);
  return x$0.ordinal__I()
});
var $d_Lnet_timerboard_BackendSocket$Status$ = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket$Status$: 0
}, false, "net.timerboard.BackendSocket$Status$", {
  Lnet_timerboard_BackendSocket$Status$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_BackendSocket$Status$.prototype.$classData = $d_Lnet_timerboard_BackendSocket$Status$;
var $n_Lnet_timerboard_BackendSocket$Status$;
function $m_Lnet_timerboard_BackendSocket$Status$() {
  if ((!$n_Lnet_timerboard_BackendSocket$Status$)) {
    $n_Lnet_timerboard_BackendSocket$Status$ = new $c_Lnet_timerboard_BackendSocket$Status$()
  };
  return $n_Lnet_timerboard_BackendSocket$Status$
}
function $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction() {
  $m_Lnet_timerboard_Direction$();
  return $t_Lnet_timerboard_Direction$__Asc
}
function $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction() {
  $m_Lnet_timerboard_Direction$();
  return $t_Lnet_timerboard_Direction$__Desc
}
/** @constructor */
function $c_Lnet_timerboard_Direction$() {
  this.Lnet_timerboard_Direction$__f_$values = null;
  $n_Lnet_timerboard_Direction$ = this;
  $t_Lnet_timerboard_Direction$__Asc = new $c_Lnet_timerboard_Direction$$anon$1(0, "Asc");
  $t_Lnet_timerboard_Direction$__Desc = new $c_Lnet_timerboard_Direction$$anon$1(1, "Desc");
  this.Lnet_timerboard_Direction$__f_$values = new ($d_Lnet_timerboard_Direction.getArrayOf().constr)([$s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction(), $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction()])
}
$c_Lnet_timerboard_Direction$.prototype = new $h_O();
$c_Lnet_timerboard_Direction$.prototype.constructor = $c_Lnet_timerboard_Direction$;
/** @constructor */
function $h_Lnet_timerboard_Direction$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Direction$.prototype = $c_Lnet_timerboard_Direction$.prototype;
$c_Lnet_timerboard_Direction$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Lnet_timerboard_Direction(x);
  return x$0.Lnet_timerboard_Direction$$anon$1__f__$ordinal$1
});
var $d_Lnet_timerboard_Direction$ = new $TypeData().initClass({
  Lnet_timerboard_Direction$: 0
}, false, "net.timerboard.Direction$", {
  Lnet_timerboard_Direction$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_Direction$.prototype.$classData = $d_Lnet_timerboard_Direction$;
var $n_Lnet_timerboard_Direction$;
function $m_Lnet_timerboard_Direction$() {
  if ((!$n_Lnet_timerboard_Direction$)) {
    $n_Lnet_timerboard_Direction$ = new $c_Lnet_timerboard_Direction$()
  };
  return $n_Lnet_timerboard_Direction$
}
/** @constructor */
function $c_Lnet_timerboard_Event$() {
  this.Lnet_timerboard_Event$__f_derived$Decoder$lzy5 = null;
  this.Lnet_timerboard_Event$__f_derived$Decoderbitmap$5 = false;
  this.Lnet_timerboard_Event$__f_derived$AsObject$lzy5 = null;
  this.Lnet_timerboard_Event$__f_derived$AsObjectbitmap$5 = false
}
$c_Lnet_timerboard_Event$.prototype = new $h_O();
$c_Lnet_timerboard_Event$.prototype.constructor = $c_Lnet_timerboard_Event$;
/** @constructor */
function $h_Lnet_timerboard_Event$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Event$.prototype = $c_Lnet_timerboard_Event$.prototype;
$c_Lnet_timerboard_Event$.prototype.toString__T = (function() {
  return "Event"
});
$c_Lnet_timerboard_Event$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Event$__f_derived$Decoderbitmap$5)) {
    this.Lnet_timerboard_Event$__f_derived$Decoder$lzy5 = new $c_Lnet_timerboard_Event$$anon$14();
    this.Lnet_timerboard_Event$__f_derived$Decoderbitmap$5 = true
  };
  return this.Lnet_timerboard_Event$__f_derived$Decoder$lzy5
});
$c_Lnet_timerboard_Event$.prototype.derived$AsObject__Lio_circe_Encoder$AsObject = (function() {
  if ((!this.Lnet_timerboard_Event$__f_derived$AsObjectbitmap$5)) {
    this.Lnet_timerboard_Event$__f_derived$AsObject$lzy5 = new $c_Lnet_timerboard_Event$$anon$15();
    this.Lnet_timerboard_Event$__f_derived$AsObjectbitmap$5 = true
  };
  return this.Lnet_timerboard_Event$__f_derived$AsObject$lzy5
});
$c_Lnet_timerboard_Event$.prototype.fromProduct__s_Product__Lnet_timerboard_Event = (function(x$0) {
  return new $c_Lnet_timerboard_Event($as_T(x$0.productElement__I__O(0)), $as_Lnet_timerboard_InnerEvent(x$0.productElement__I__O(1)), $as_Lnet_timerboard_Alliance(x$0.productElement__I__O(2)))
});
var $d_Lnet_timerboard_Event$ = new $TypeData().initClass({
  Lnet_timerboard_Event$: 0
}, false, "net.timerboard.Event$", {
  Lnet_timerboard_Event$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_Event$.prototype.$classData = $d_Lnet_timerboard_Event$;
var $n_Lnet_timerboard_Event$;
function $m_Lnet_timerboard_Event$() {
  if ((!$n_Lnet_timerboard_Event$)) {
    $n_Lnet_timerboard_Event$ = new $c_Lnet_timerboard_Event$()
  };
  return $n_Lnet_timerboard_Event$
}
function $s_Lnet_timerboard_EventType$__tcu_defense__Lnet_timerboard_EventType() {
  $m_Lnet_timerboard_EventType$();
  return $t_Lnet_timerboard_EventType$__tcu_defense
}
function $s_Lnet_timerboard_EventType$__ihub_defense__Lnet_timerboard_EventType() {
  $m_Lnet_timerboard_EventType$();
  return $t_Lnet_timerboard_EventType$__ihub_defense
}
function $s_Lnet_timerboard_EventType$__station_defense__Lnet_timerboard_EventType() {
  $m_Lnet_timerboard_EventType$();
  return $t_Lnet_timerboard_EventType$__station_defense
}
function $s_Lnet_timerboard_EventType$__station_freeport__Lnet_timerboard_EventType() {
  $m_Lnet_timerboard_EventType$();
  return $t_Lnet_timerboard_EventType$__station_freeport
}
/** @constructor */
function $c_Lnet_timerboard_EventType$() {
  this.Lnet_timerboard_EventType$__f_$values = null;
  this.Lnet_timerboard_EventType$__f_derived$EnumCodec$lzy1 = null;
  this.Lnet_timerboard_EventType$__f_derived$EnumCodecbitmap$1 = false;
  $n_Lnet_timerboard_EventType$ = this;
  $t_Lnet_timerboard_EventType$__tcu_defense = new $c_Lnet_timerboard_EventType$$anon$6(0, "tcu_defense");
  $t_Lnet_timerboard_EventType$__ihub_defense = new $c_Lnet_timerboard_EventType$$anon$6(1, "ihub_defense");
  $t_Lnet_timerboard_EventType$__station_defense = new $c_Lnet_timerboard_EventType$$anon$6(2, "station_defense");
  $t_Lnet_timerboard_EventType$__station_freeport = new $c_Lnet_timerboard_EventType$$anon$6(3, "station_freeport");
  this.Lnet_timerboard_EventType$__f_$values = new ($d_Lnet_timerboard_EventType.getArrayOf().constr)([$s_Lnet_timerboard_EventType$__tcu_defense__Lnet_timerboard_EventType(), $s_Lnet_timerboard_EventType$__ihub_defense__Lnet_timerboard_EventType(), $s_Lnet_timerboard_EventType$__station_defense__Lnet_timerboard_EventType(), $s_Lnet_timerboard_EventType$__station_freeport__Lnet_timerboard_EventType()])
}
$c_Lnet_timerboard_EventType$.prototype = new $h_O();
$c_Lnet_timerboard_EventType$.prototype.constructor = $c_Lnet_timerboard_EventType$;
/** @constructor */
function $h_Lnet_timerboard_EventType$() {
  /*<skip>*/
}
$h_Lnet_timerboard_EventType$.prototype = $c_Lnet_timerboard_EventType$.prototype;
$c_Lnet_timerboard_EventType$.prototype.derived$EnumCodec__Lnet_timerboard_CirceEnumHelpers$EnumCodec = (function() {
  if ((!this.Lnet_timerboard_EventType$__f_derived$EnumCodecbitmap$1)) {
    var m$proxy1 = $m_Lnet_timerboard_EventType$();
    this.Lnet_timerboard_EventType$__f_derived$EnumCodec$lzy1 = new $c_Lnet_timerboard_EventType$$anon$7(m$proxy1);
    this.Lnet_timerboard_EventType$__f_derived$EnumCodecbitmap$1 = true
  };
  return this.Lnet_timerboard_EventType$__f_derived$EnumCodec$lzy1
});
$c_Lnet_timerboard_EventType$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Lnet_timerboard_EventType(x);
  return x$0.Lnet_timerboard_EventType$$anon$6__f__$ordinal$4
});
var $d_Lnet_timerboard_EventType$ = new $TypeData().initClass({
  Lnet_timerboard_EventType$: 0
}, false, "net.timerboard.EventType$", {
  Lnet_timerboard_EventType$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_EventType$.prototype.$classData = $d_Lnet_timerboard_EventType$;
var $n_Lnet_timerboard_EventType$;
function $m_Lnet_timerboard_EventType$() {
  if ((!$n_Lnet_timerboard_EventType$)) {
    $n_Lnet_timerboard_EventType$ = new $c_Lnet_timerboard_EventType$()
  };
  return $n_Lnet_timerboard_EventType$
}
function $s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__Time
}
function $s_Lnet_timerboard_Field$__Type__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__Type
}
function $s_Lnet_timerboard_Field$__System__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__System
}
function $s_Lnet_timerboard_Field$__Region__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__Region
}
function $s_Lnet_timerboard_Field$__Owner__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__Owner
}
function $s_Lnet_timerboard_Field$__DefenderScore__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__DefenderScore
}
function $s_Lnet_timerboard_Field$__Distance__Lnet_timerboard_Field() {
  $m_Lnet_timerboard_Field$();
  return $t_Lnet_timerboard_Field$__Distance
}
/** @constructor */
function $c_Lnet_timerboard_Field$() {
  this.Lnet_timerboard_Field$__f_$values = null;
  $n_Lnet_timerboard_Field$ = this;
  $t_Lnet_timerboard_Field$__Time = new $c_Lnet_timerboard_Field$$anon$2(0, "Time");
  $t_Lnet_timerboard_Field$__Type = new $c_Lnet_timerboard_Field$$anon$2(1, "Type");
  $t_Lnet_timerboard_Field$__System = new $c_Lnet_timerboard_Field$$anon$2(2, "System");
  $t_Lnet_timerboard_Field$__Region = new $c_Lnet_timerboard_Field$$anon$2(3, "Region");
  $t_Lnet_timerboard_Field$__Owner = new $c_Lnet_timerboard_Field$$anon$2(4, "Owner");
  $t_Lnet_timerboard_Field$__DefenderScore = new $c_Lnet_timerboard_Field$$anon$2(5, "DefenderScore");
  $t_Lnet_timerboard_Field$__Distance = new $c_Lnet_timerboard_Field$$anon$2(6, "Distance");
  this.Lnet_timerboard_Field$__f_$values = new ($d_Lnet_timerboard_Field.getArrayOf().constr)([$s_Lnet_timerboard_Field$__Time__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__Type__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__System__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__Region__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__Owner__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__DefenderScore__Lnet_timerboard_Field(), $s_Lnet_timerboard_Field$__Distance__Lnet_timerboard_Field()])
}
$c_Lnet_timerboard_Field$.prototype = new $h_O();
$c_Lnet_timerboard_Field$.prototype.constructor = $c_Lnet_timerboard_Field$;
/** @constructor */
function $h_Lnet_timerboard_Field$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Field$.prototype = $c_Lnet_timerboard_Field$.prototype;
$c_Lnet_timerboard_Field$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Lnet_timerboard_Field(x);
  return x$0.Lnet_timerboard_Field$$anon$2__f__$ordinal$2
});
var $d_Lnet_timerboard_Field$ = new $TypeData().initClass({
  Lnet_timerboard_Field$: 0
}, false, "net.timerboard.Field$", {
  Lnet_timerboard_Field$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_Field$.prototype.$classData = $d_Lnet_timerboard_Field$;
var $n_Lnet_timerboard_Field$;
function $m_Lnet_timerboard_Field$() {
  if ((!$n_Lnet_timerboard_Field$)) {
    $n_Lnet_timerboard_Field$ = new $c_Lnet_timerboard_Field$()
  };
  return $n_Lnet_timerboard_Field$
}
/** @constructor */
function $c_Lnet_timerboard_InnerEvent$() {
  this.Lnet_timerboard_InnerEvent$__f_derived$Decoder$lzy3 = null;
  this.Lnet_timerboard_InnerEvent$__f_derived$Decoderbitmap$3 = false;
  this.Lnet_timerboard_InnerEvent$__f_derived$AsObject$lzy3 = null;
  this.Lnet_timerboard_InnerEvent$__f_derived$AsObjectbitmap$3 = false
}
$c_Lnet_timerboard_InnerEvent$.prototype = new $h_O();
$c_Lnet_timerboard_InnerEvent$.prototype.constructor = $c_Lnet_timerboard_InnerEvent$;
/** @constructor */
function $h_Lnet_timerboard_InnerEvent$() {
  /*<skip>*/
}
$h_Lnet_timerboard_InnerEvent$.prototype = $c_Lnet_timerboard_InnerEvent$.prototype;
$c_Lnet_timerboard_InnerEvent$.prototype.toString__T = (function() {
  return "InnerEvent"
});
$c_Lnet_timerboard_InnerEvent$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_InnerEvent$__f_derived$Decoderbitmap$3)) {
    this.Lnet_timerboard_InnerEvent$__f_derived$Decoder$lzy3 = new $c_Lnet_timerboard_InnerEvent$$anon$10();
    this.Lnet_timerboard_InnerEvent$__f_derived$Decoderbitmap$3 = true
  };
  return this.Lnet_timerboard_InnerEvent$__f_derived$Decoder$lzy3
});
$c_Lnet_timerboard_InnerEvent$.prototype.derived$AsObject__Lio_circe_Encoder$AsObject = (function() {
  if ((!this.Lnet_timerboard_InnerEvent$__f_derived$AsObjectbitmap$3)) {
    this.Lnet_timerboard_InnerEvent$__f_derived$AsObject$lzy3 = new $c_Lnet_timerboard_InnerEvent$$anon$11();
    this.Lnet_timerboard_InnerEvent$__f_derived$AsObjectbitmap$3 = true
  };
  return this.Lnet_timerboard_InnerEvent$__f_derived$AsObject$lzy3
});
$c_Lnet_timerboard_InnerEvent$.prototype.fromProduct__s_Product__Lnet_timerboard_InnerEvent = (function(x$0) {
  return new $c_Lnet_timerboard_InnerEvent($as_s_math_BigDecimal(x$0.productElement__I__O(0)), $uJ(x$0.productElement__I__O(1)), $uJ(x$0.productElement__I__O(2)), $uJ(x$0.productElement__I__O(3)), $as_s_math_BigDecimal(x$0.productElement__I__O(4)), $as_Lnet_timerboard_EventType(x$0.productElement__I__O(5)), $as_s_Option(x$0.productElement__I__O(6)), $uJ(x$0.productElement__I__O(7)), $as_Ljava_time_ZonedDateTime(x$0.productElement__I__O(8)), $uJ(x$0.productElement__I__O(9)))
});
var $d_Lnet_timerboard_InnerEvent$ = new $TypeData().initClass({
  Lnet_timerboard_InnerEvent$: 0
}, false, "net.timerboard.InnerEvent$", {
  Lnet_timerboard_InnerEvent$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_InnerEvent$.prototype.$classData = $d_Lnet_timerboard_InnerEvent$;
var $n_Lnet_timerboard_InnerEvent$;
function $m_Lnet_timerboard_InnerEvent$() {
  if ((!$n_Lnet_timerboard_InnerEvent$)) {
    $n_Lnet_timerboard_InnerEvent$ = new $c_Lnet_timerboard_InnerEvent$()
  };
  return $n_Lnet_timerboard_InnerEvent$
}
function $s_Lnet_timerboard_Msg$__SearchBackspace__Lnet_timerboard_Msg() {
  $m_Lnet_timerboard_Msg$();
  return $t_Lnet_timerboard_Msg$__SearchBackspace
}
function $s_Lnet_timerboard_Msg$__EnterTag__Lnet_timerboard_Msg() {
  $m_Lnet_timerboard_Msg$();
  return $t_Lnet_timerboard_Msg$__EnterTag
}
function $s_Lnet_timerboard_Msg$__SystemTab__Lnet_timerboard_Msg() {
  $m_Lnet_timerboard_Msg$();
  return $t_Lnet_timerboard_Msg$__SystemTab
}
function $s_Lnet_timerboard_Msg$__None__Lnet_timerboard_Msg() {
  $m_Lnet_timerboard_Msg$();
  return $t_Lnet_timerboard_Msg$__None
}
function $s_Lnet_timerboard_Msg$__CalculateDistances__Lnet_timerboard_Msg() {
  $m_Lnet_timerboard_Msg$();
  return $t_Lnet_timerboard_Msg$__CalculateDistances
}
/** @constructor */
function $c_Lnet_timerboard_Msg$() {
  $n_Lnet_timerboard_Msg$ = this;
  $t_Lnet_timerboard_Msg$__SearchBackspace = new $c_Lnet_timerboard_Msg$$anon$5(13, "SearchBackspace");
  $t_Lnet_timerboard_Msg$__EnterTag = new $c_Lnet_timerboard_Msg$$anon$5(14, "EnterTag");
  $t_Lnet_timerboard_Msg$__SystemTab = new $c_Lnet_timerboard_Msg$$anon$5(15, "SystemTab");
  $t_Lnet_timerboard_Msg$__None = new $c_Lnet_timerboard_Msg$$anon$5(16, "None");
  $t_Lnet_timerboard_Msg$__CalculateDistances = new $c_Lnet_timerboard_Msg$$anon$5(17, "CalculateDistances")
}
$c_Lnet_timerboard_Msg$.prototype = new $h_O();
$c_Lnet_timerboard_Msg$.prototype.constructor = $c_Lnet_timerboard_Msg$;
/** @constructor */
function $h_Lnet_timerboard_Msg$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$.prototype = $c_Lnet_timerboard_Msg$.prototype;
$c_Lnet_timerboard_Msg$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Lnet_timerboard_Msg(x);
  return x$0.ordinal__I()
});
var $d_Lnet_timerboard_Msg$ = new $TypeData().initClass({
  Lnet_timerboard_Msg$: 0
}, false, "net.timerboard.Msg$", {
  Lnet_timerboard_Msg$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_Msg$.prototype.$classData = $d_Lnet_timerboard_Msg$;
var $n_Lnet_timerboard_Msg$;
function $m_Lnet_timerboard_Msg$() {
  if ((!$n_Lnet_timerboard_Msg$)) {
    $n_Lnet_timerboard_Msg$ = new $c_Lnet_timerboard_Msg$()
  };
  return $n_Lnet_timerboard_Msg$
}
/** @constructor */
function $c_Lnet_timerboard_Participant$() {
  this.Lnet_timerboard_Participant$__f_derived$Decoder$lzy2 = null;
  this.Lnet_timerboard_Participant$__f_derived$Decoderbitmap$2 = false;
  this.Lnet_timerboard_Participant$__f_derived$AsObject$lzy2 = null;
  this.Lnet_timerboard_Participant$__f_derived$AsObjectbitmap$2 = false
}
$c_Lnet_timerboard_Participant$.prototype = new $h_O();
$c_Lnet_timerboard_Participant$.prototype.constructor = $c_Lnet_timerboard_Participant$;
/** @constructor */
function $h_Lnet_timerboard_Participant$() {
  /*<skip>*/
}
$h_Lnet_timerboard_Participant$.prototype = $c_Lnet_timerboard_Participant$.prototype;
$c_Lnet_timerboard_Participant$.prototype.toString__T = (function() {
  return "Participant"
});
$c_Lnet_timerboard_Participant$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Participant$__f_derived$Decoderbitmap$2)) {
    this.Lnet_timerboard_Participant$__f_derived$Decoder$lzy2 = new $c_Lnet_timerboard_Participant$$anon$8();
    this.Lnet_timerboard_Participant$__f_derived$Decoderbitmap$2 = true
  };
  return this.Lnet_timerboard_Participant$__f_derived$Decoder$lzy2
});
$c_Lnet_timerboard_Participant$.prototype.derived$AsObject__Lio_circe_Encoder$AsObject = (function() {
  if ((!this.Lnet_timerboard_Participant$__f_derived$AsObjectbitmap$2)) {
    this.Lnet_timerboard_Participant$__f_derived$AsObject$lzy2 = new $c_Lnet_timerboard_Participant$$anon$9();
    this.Lnet_timerboard_Participant$__f_derived$AsObjectbitmap$2 = true
  };
  return this.Lnet_timerboard_Participant$__f_derived$AsObject$lzy2
});
$c_Lnet_timerboard_Participant$.prototype.fromProduct__s_Product__Lnet_timerboard_Participant = (function(x$0) {
  return new $c_Lnet_timerboard_Participant($uJ(x$0.productElement__I__O(0)), $as_s_math_BigDecimal(x$0.productElement__I__O(1)))
});
var $d_Lnet_timerboard_Participant$ = new $TypeData().initClass({
  Lnet_timerboard_Participant$: 0
}, false, "net.timerboard.Participant$", {
  Lnet_timerboard_Participant$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_Participant$.prototype.$classData = $d_Lnet_timerboard_Participant$;
var $n_Lnet_timerboard_Participant$;
function $m_Lnet_timerboard_Participant$() {
  if ((!$n_Lnet_timerboard_Participant$)) {
    $n_Lnet_timerboard_Participant$ = new $c_Lnet_timerboard_Participant$()
  };
  return $n_Lnet_timerboard_Participant$
}
/** @constructor */
function $c_Lnet_timerboard_SolarSystem$() {
  this.Lnet_timerboard_SolarSystem$__f_derived$AsObject$lzy1 = null;
  this.Lnet_timerboard_SolarSystem$__f_derived$AsObjectbitmap$1 = false;
  this.Lnet_timerboard_SolarSystem$__f_derived$Decoder$lzy1 = null;
  this.Lnet_timerboard_SolarSystem$__f_derived$Decoderbitmap$1 = false
}
$c_Lnet_timerboard_SolarSystem$.prototype = new $h_O();
$c_Lnet_timerboard_SolarSystem$.prototype.constructor = $c_Lnet_timerboard_SolarSystem$;
/** @constructor */
function $h_Lnet_timerboard_SolarSystem$() {
  /*<skip>*/
}
$h_Lnet_timerboard_SolarSystem$.prototype = $c_Lnet_timerboard_SolarSystem$.prototype;
$c_Lnet_timerboard_SolarSystem$.prototype.toString__T = (function() {
  return "SolarSystem"
});
$c_Lnet_timerboard_SolarSystem$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_SolarSystem$__f_derived$Decoderbitmap$1)) {
    this.Lnet_timerboard_SolarSystem$__f_derived$Decoder$lzy1 = new $c_Lnet_timerboard_SolarSystem$$anon$4();
    this.Lnet_timerboard_SolarSystem$__f_derived$Decoderbitmap$1 = true
  };
  return this.Lnet_timerboard_SolarSystem$__f_derived$Decoder$lzy1
});
$c_Lnet_timerboard_SolarSystem$.prototype.fromProduct__s_Product__Lnet_timerboard_SolarSystem = (function(x$0) {
  return new $c_Lnet_timerboard_SolarSystem($as_T(x$0.productElement__I__O(0)), $uJ(x$0.productElement__I__O(1)))
});
var $d_Lnet_timerboard_SolarSystem$ = new $TypeData().initClass({
  Lnet_timerboard_SolarSystem$: 0
}, false, "net.timerboard.SolarSystem$", {
  Lnet_timerboard_SolarSystem$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_SolarSystem$.prototype.$classData = $d_Lnet_timerboard_SolarSystem$;
var $n_Lnet_timerboard_SolarSystem$;
function $m_Lnet_timerboard_SolarSystem$() {
  if ((!$n_Lnet_timerboard_SolarSystem$)) {
    $n_Lnet_timerboard_SolarSystem$ = new $c_Lnet_timerboard_SolarSystem$()
  };
  return $n_Lnet_timerboard_SolarSystem$
}
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$() {
  this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEvent$lzy1 = null;
  this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEventbitmap$1 = false;
  this.Lnet_timerboard_WebsocketEvent$__f_given_Encoder_WebsocketEvent$lzy1 = null;
  this.Lnet_timerboard_WebsocketEvent$__f_given_Encoder_WebsocketEventbitmap$1 = false
}
$c_Lnet_timerboard_WebsocketEvent$.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$.prototype = $c_Lnet_timerboard_WebsocketEvent$.prototype;
$c_Lnet_timerboard_WebsocketEvent$.prototype.given_Decoder_WebsocketEvent__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEventbitmap$1)) {
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    $m_Lio_circe_Decoder$();
    var instance = $m_Lnet_timerboard_WebsocketEvent$Initial$().derived$Decoder__Lio_circe_Decoder();
    var tc = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decoderInstances;
    var this$3 = new $c_Lcats_Functor$$anon$4(instance, tc);
    var fa = this$3.Lcats_Functor$$anon$4__f_self;
    $m_Lio_circe_Decoder$();
    var ev$8 = $as_Lio_circe_Decoder(fa);
    this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEvent$lzy1 = $as_Lio_circe_Decoder($m_Lcats_syntax_ApplicativeErrorOps$().orElse$extension__O__F0__Lcats_ApplicativeError__O(ev$8, new $c_sjsr_AnonFunction0(((this$6) => (() => {
      $m_Lcats_implicits$();
      $m_Lio_circe_Decoder$();
      var instance$1 = $m_Lnet_timerboard_WebsocketEvent$Diff$().derived$Decoder__Lio_circe_Decoder();
      var tc$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decoderInstances;
      var this$9 = new $c_Lcats_Functor$$anon$4(instance$1, tc$1);
      var fa$1 = this$9.Lcats_Functor$$anon$4__f_self;
      return $as_Lio_circe_Decoder(fa$1)
    }))(this)), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decoderInstances));
    this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEventbitmap$1 = true
  };
  return this.Lnet_timerboard_WebsocketEvent$__f_given_Decoder_WebsocketEvent$lzy1
});
$c_Lnet_timerboard_WebsocketEvent$.prototype.ordinal__Lnet_timerboard_WebsocketEvent__I = (function(x$0) {
  if ((x$0 instanceof $c_Lnet_timerboard_WebsocketEvent$Initial)) {
    return 0
  };
  if ((x$0 instanceof $c_Lnet_timerboard_WebsocketEvent$Diff)) {
    return 1
  };
  throw new $c_s_MatchError(x$0)
});
$c_Lnet_timerboard_WebsocketEvent$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lnet_timerboard_WebsocketEvent__I($as_Lnet_timerboard_WebsocketEvent(x))
});
var $d_Lnet_timerboard_WebsocketEvent$ = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$: 0
}, false, "net.timerboard.WebsocketEvent$", {
  Lnet_timerboard_WebsocketEvent$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_timerboard_WebsocketEvent$.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$;
var $n_Lnet_timerboard_WebsocketEvent$;
function $m_Lnet_timerboard_WebsocketEvent$() {
  if ((!$n_Lnet_timerboard_WebsocketEvent$)) {
    $n_Lnet_timerboard_WebsocketEvent$ = new $c_Lnet_timerboard_WebsocketEvent$()
  };
  return $n_Lnet_timerboard_WebsocketEvent$
}
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$Diff$() {
  this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoder$lzy7 = null;
  this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoderbitmap$7 = false;
  this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$AsObject$lzy7 = null;
  this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$AsObjectbitmap$7 = false
}
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$Diff$;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$Diff$() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$Diff$.prototype = $c_Lnet_timerboard_WebsocketEvent$Diff$.prototype;
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype.toString__T = (function() {
  return "Diff"
});
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoderbitmap$7)) {
    this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoder$lzy7 = new $c_Lnet_timerboard_WebsocketEvent$$anon$18();
    this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoderbitmap$7 = true
  };
  return this.Lnet_timerboard_WebsocketEvent$Diff$__f_derived$Decoder$lzy7
});
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype.fromProduct__s_Product__Lnet_timerboard_WebsocketEvent$Diff = (function(x$0) {
  return new $c_Lnet_timerboard_WebsocketEvent$Diff($as_Ldiffson_jsonpatch_JsonPatch(x$0.productElement__I__O(0)))
});
var $d_Lnet_timerboard_WebsocketEvent$Diff$ = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$Diff$: 0
}, false, "net.timerboard.WebsocketEvent$Diff$", {
  Lnet_timerboard_WebsocketEvent$Diff$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_WebsocketEvent$Diff$.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$Diff$;
var $n_Lnet_timerboard_WebsocketEvent$Diff$;
function $m_Lnet_timerboard_WebsocketEvent$Diff$() {
  if ((!$n_Lnet_timerboard_WebsocketEvent$Diff$)) {
    $n_Lnet_timerboard_WebsocketEvent$Diff$ = new $c_Lnet_timerboard_WebsocketEvent$Diff$()
  };
  return $n_Lnet_timerboard_WebsocketEvent$Diff$
}
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$Initial$() {
  this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoder$lzy6 = null;
  this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoderbitmap$6 = false;
  this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$AsObject$lzy6 = null;
  this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$AsObjectbitmap$6 = false
}
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$Initial$;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$Initial$() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$Initial$.prototype = $c_Lnet_timerboard_WebsocketEvent$Initial$.prototype;
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype.toString__T = (function() {
  return "Initial"
});
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype.derived$Decoder__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoderbitmap$6)) {
    this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoder$lzy6 = new $c_Lnet_timerboard_WebsocketEvent$$anon$16();
    this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoderbitmap$6 = true
  };
  return this.Lnet_timerboard_WebsocketEvent$Initial$__f_derived$Decoder$lzy6
});
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype.fromProduct__s_Product__Lnet_timerboard_WebsocketEvent$Initial = (function(x$0) {
  return new $c_Lnet_timerboard_WebsocketEvent$Initial($as_sci_List(x$0.productElement__I__O(0)))
});
var $d_Lnet_timerboard_WebsocketEvent$Initial$ = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$Initial$: 0
}, false, "net.timerboard.WebsocketEvent$Initial$", {
  Lnet_timerboard_WebsocketEvent$Initial$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lnet_timerboard_WebsocketEvent$Initial$.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$Initial$;
var $n_Lnet_timerboard_WebsocketEvent$Initial$;
function $m_Lnet_timerboard_WebsocketEvent$Initial$() {
  if ((!$n_Lnet_timerboard_WebsocketEvent$Initial$)) {
    $n_Lnet_timerboard_WebsocketEvent$Initial$ = new $c_Lnet_timerboard_WebsocketEvent$Initial$()
  };
  return $n_Lnet_timerboard_WebsocketEvent$Initial$
}
/** @constructor */
function $c_s_$less$colon$less() {
  /*<skip>*/
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
  /*<skip>*/
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  this.s_Predef$__f_$minus$greater = null;
  this.s_Predef$__f_Manifest = null;
  this.s_Predef$__f_NoManifest = null;
  $n_s_Predef$ = this;
  $m_s_package$();
  $m_sci_List$();
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
  this.s_Predef$__f_$minus$greater = $m_T2$();
  this.s_Predef$__f_Manifest = $m_s_reflect_Manifest$();
  this.s_Predef$__f_NoManifest = $m_s_reflect_NoManifest$()
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
  /*<skip>*/
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed")
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed")
  }
});
$c_s_Predef$.prototype.$qmark$qmark$qmark__E = (function() {
  throw new $c_s_NotImplementedError()
});
var $d_s_Predef$ = new $TypeData().initClass({
  s_Predef$: 0
}, false, "scala.Predef$", {
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1,
  O: 1
});
$c_s_Predef$.prototype.$classData = $d_s_Predef$;
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$()
  };
  return $n_s_Predef$
}
function $f_s_Product1__productElement__I__O($thiz, n) {
  if ((n === 0)) {
    return $thiz.T1__f__1
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 0)"))
  }
}
function $f_s_Product10__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T10__f__1;
      break
    }
    case 1: {
      return $thiz.T10__f__2;
      break
    }
    case 2: {
      return $thiz.T10__f__3;
      break
    }
    case 3: {
      return $thiz.T10__f__4;
      break
    }
    case 4: {
      return $thiz.T10__f__5;
      break
    }
    case 5: {
      return $thiz.T10__f__6;
      break
    }
    case 6: {
      return $thiz.T10__f__7;
      break
    }
    case 7: {
      return $thiz.T10__f__8;
      break
    }
    case 8: {
      return $thiz.T10__f__9;
      break
    }
    case 9: {
      return $thiz.T10__f__10;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 9)"))
    }
  }
}
function $f_s_Product11__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T11__f__1;
      break
    }
    case 1: {
      return $thiz.T11__f__2;
      break
    }
    case 2: {
      return $thiz.T11__f__3;
      break
    }
    case 3: {
      return $thiz.T11__f__4;
      break
    }
    case 4: {
      return $thiz.T11__f__5;
      break
    }
    case 5: {
      return $thiz.T11__f__6;
      break
    }
    case 6: {
      return $thiz.T11__f__7;
      break
    }
    case 7: {
      return $thiz.T11__f__8;
      break
    }
    case 8: {
      return $thiz.T11__f__9;
      break
    }
    case 9: {
      return $thiz.T11__f__10;
      break
    }
    case 10: {
      return $thiz.T11__f__11;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 10)"))
    }
  }
}
function $f_s_Product12__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T12__f__1;
      break
    }
    case 1: {
      return $thiz.T12__f__2;
      break
    }
    case 2: {
      return $thiz.T12__f__3;
      break
    }
    case 3: {
      return $thiz.T12__f__4;
      break
    }
    case 4: {
      return $thiz.T12__f__5;
      break
    }
    case 5: {
      return $thiz.T12__f__6;
      break
    }
    case 6: {
      return $thiz.T12__f__7;
      break
    }
    case 7: {
      return $thiz.T12__f__8;
      break
    }
    case 8: {
      return $thiz.T12__f__9;
      break
    }
    case 9: {
      return $thiz.T12__f__10;
      break
    }
    case 10: {
      return $thiz.T12__f__11;
      break
    }
    case 11: {
      return $thiz.T12__f__12;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 11)"))
    }
  }
}
function $f_s_Product13__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T13__f__1;
      break
    }
    case 1: {
      return $thiz.T13__f__2;
      break
    }
    case 2: {
      return $thiz.T13__f__3;
      break
    }
    case 3: {
      return $thiz.T13__f__4;
      break
    }
    case 4: {
      return $thiz.T13__f__5;
      break
    }
    case 5: {
      return $thiz.T13__f__6;
      break
    }
    case 6: {
      return $thiz.T13__f__7;
      break
    }
    case 7: {
      return $thiz.T13__f__8;
      break
    }
    case 8: {
      return $thiz.T13__f__9;
      break
    }
    case 9: {
      return $thiz.T13__f__10;
      break
    }
    case 10: {
      return $thiz.T13__f__11;
      break
    }
    case 11: {
      return $thiz.T13__f__12;
      break
    }
    case 12: {
      return $thiz.T13__f__13;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 12)"))
    }
  }
}
function $f_s_Product14__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T14__f__1;
      break
    }
    case 1: {
      return $thiz.T14__f__2;
      break
    }
    case 2: {
      return $thiz.T14__f__3;
      break
    }
    case 3: {
      return $thiz.T14__f__4;
      break
    }
    case 4: {
      return $thiz.T14__f__5;
      break
    }
    case 5: {
      return $thiz.T14__f__6;
      break
    }
    case 6: {
      return $thiz.T14__f__7;
      break
    }
    case 7: {
      return $thiz.T14__f__8;
      break
    }
    case 8: {
      return $thiz.T14__f__9;
      break
    }
    case 9: {
      return $thiz.T14__f__10;
      break
    }
    case 10: {
      return $thiz.T14__f__11;
      break
    }
    case 11: {
      return $thiz.T14__f__12;
      break
    }
    case 12: {
      return $thiz.T14__f__13;
      break
    }
    case 13: {
      return $thiz.T14__f__14;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 13)"))
    }
  }
}
function $f_s_Product15__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T15__f__1;
      break
    }
    case 1: {
      return $thiz.T15__f__2;
      break
    }
    case 2: {
      return $thiz.T15__f__3;
      break
    }
    case 3: {
      return $thiz.T15__f__4;
      break
    }
    case 4: {
      return $thiz.T15__f__5;
      break
    }
    case 5: {
      return $thiz.T15__f__6;
      break
    }
    case 6: {
      return $thiz.T15__f__7;
      break
    }
    case 7: {
      return $thiz.T15__f__8;
      break
    }
    case 8: {
      return $thiz.T15__f__9;
      break
    }
    case 9: {
      return $thiz.T15__f__10;
      break
    }
    case 10: {
      return $thiz.T15__f__11;
      break
    }
    case 11: {
      return $thiz.T15__f__12;
      break
    }
    case 12: {
      return $thiz.T15__f__13;
      break
    }
    case 13: {
      return $thiz.T15__f__14;
      break
    }
    case 14: {
      return $thiz.T15__f__15;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 14)"))
    }
  }
}
function $f_s_Product16__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T16__f__1;
      break
    }
    case 1: {
      return $thiz.T16__f__2;
      break
    }
    case 2: {
      return $thiz.T16__f__3;
      break
    }
    case 3: {
      return $thiz.T16__f__4;
      break
    }
    case 4: {
      return $thiz.T16__f__5;
      break
    }
    case 5: {
      return $thiz.T16__f__6;
      break
    }
    case 6: {
      return $thiz.T16__f__7;
      break
    }
    case 7: {
      return $thiz.T16__f__8;
      break
    }
    case 8: {
      return $thiz.T16__f__9;
      break
    }
    case 9: {
      return $thiz.T16__f__10;
      break
    }
    case 10: {
      return $thiz.T16__f__11;
      break
    }
    case 11: {
      return $thiz.T16__f__12;
      break
    }
    case 12: {
      return $thiz.T16__f__13;
      break
    }
    case 13: {
      return $thiz.T16__f__14;
      break
    }
    case 14: {
      return $thiz.T16__f__15;
      break
    }
    case 15: {
      return $thiz.T16__f__16;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 15)"))
    }
  }
}
function $f_s_Product17__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T17__f__1;
      break
    }
    case 1: {
      return $thiz.T17__f__2;
      break
    }
    case 2: {
      return $thiz.T17__f__3;
      break
    }
    case 3: {
      return $thiz.T17__f__4;
      break
    }
    case 4: {
      return $thiz.T17__f__5;
      break
    }
    case 5: {
      return $thiz.T17__f__6;
      break
    }
    case 6: {
      return $thiz.T17__f__7;
      break
    }
    case 7: {
      return $thiz.T17__f__8;
      break
    }
    case 8: {
      return $thiz.T17__f__9;
      break
    }
    case 9: {
      return $thiz.T17__f__10;
      break
    }
    case 10: {
      return $thiz.T17__f__11;
      break
    }
    case 11: {
      return $thiz.T17__f__12;
      break
    }
    case 12: {
      return $thiz.T17__f__13;
      break
    }
    case 13: {
      return $thiz.T17__f__14;
      break
    }
    case 14: {
      return $thiz.T17__f__15;
      break
    }
    case 15: {
      return $thiz.T17__f__16;
      break
    }
    case 16: {
      return $thiz.T17__f__17;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 16)"))
    }
  }
}
function $f_s_Product18__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T18__f__1;
      break
    }
    case 1: {
      return $thiz.T18__f__2;
      break
    }
    case 2: {
      return $thiz.T18__f__3;
      break
    }
    case 3: {
      return $thiz.T18__f__4;
      break
    }
    case 4: {
      return $thiz.T18__f__5;
      break
    }
    case 5: {
      return $thiz.T18__f__6;
      break
    }
    case 6: {
      return $thiz.T18__f__7;
      break
    }
    case 7: {
      return $thiz.T18__f__8;
      break
    }
    case 8: {
      return $thiz.T18__f__9;
      break
    }
    case 9: {
      return $thiz.T18__f__10;
      break
    }
    case 10: {
      return $thiz.T18__f__11;
      break
    }
    case 11: {
      return $thiz.T18__f__12;
      break
    }
    case 12: {
      return $thiz.T18__f__13;
      break
    }
    case 13: {
      return $thiz.T18__f__14;
      break
    }
    case 14: {
      return $thiz.T18__f__15;
      break
    }
    case 15: {
      return $thiz.T18__f__16;
      break
    }
    case 16: {
      return $thiz.T18__f__17;
      break
    }
    case 17: {
      return $thiz.T18__f__18;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 17)"))
    }
  }
}
function $f_s_Product19__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T19__f__1;
      break
    }
    case 1: {
      return $thiz.T19__f__2;
      break
    }
    case 2: {
      return $thiz.T19__f__3;
      break
    }
    case 3: {
      return $thiz.T19__f__4;
      break
    }
    case 4: {
      return $thiz.T19__f__5;
      break
    }
    case 5: {
      return $thiz.T19__f__6;
      break
    }
    case 6: {
      return $thiz.T19__f__7;
      break
    }
    case 7: {
      return $thiz.T19__f__8;
      break
    }
    case 8: {
      return $thiz.T19__f__9;
      break
    }
    case 9: {
      return $thiz.T19__f__10;
      break
    }
    case 10: {
      return $thiz.T19__f__11;
      break
    }
    case 11: {
      return $thiz.T19__f__12;
      break
    }
    case 12: {
      return $thiz.T19__f__13;
      break
    }
    case 13: {
      return $thiz.T19__f__14;
      break
    }
    case 14: {
      return $thiz.T19__f__15;
      break
    }
    case 15: {
      return $thiz.T19__f__16;
      break
    }
    case 16: {
      return $thiz.T19__f__17;
      break
    }
    case 17: {
      return $thiz.T19__f__18;
      break
    }
    case 18: {
      return $thiz.T19__f__19;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 18)"))
    }
  }
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break
    }
    case 1: {
      return $thiz._2__O();
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
    }
  }
}
function $f_s_Product20__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T20__f__1;
      break
    }
    case 1: {
      return $thiz.T20__f__2;
      break
    }
    case 2: {
      return $thiz.T20__f__3;
      break
    }
    case 3: {
      return $thiz.T20__f__4;
      break
    }
    case 4: {
      return $thiz.T20__f__5;
      break
    }
    case 5: {
      return $thiz.T20__f__6;
      break
    }
    case 6: {
      return $thiz.T20__f__7;
      break
    }
    case 7: {
      return $thiz.T20__f__8;
      break
    }
    case 8: {
      return $thiz.T20__f__9;
      break
    }
    case 9: {
      return $thiz.T20__f__10;
      break
    }
    case 10: {
      return $thiz.T20__f__11;
      break
    }
    case 11: {
      return $thiz.T20__f__12;
      break
    }
    case 12: {
      return $thiz.T20__f__13;
      break
    }
    case 13: {
      return $thiz.T20__f__14;
      break
    }
    case 14: {
      return $thiz.T20__f__15;
      break
    }
    case 15: {
      return $thiz.T20__f__16;
      break
    }
    case 16: {
      return $thiz.T20__f__17;
      break
    }
    case 17: {
      return $thiz.T20__f__18;
      break
    }
    case 18: {
      return $thiz.T20__f__19;
      break
    }
    case 19: {
      return $thiz.T20__f__20;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 19)"))
    }
  }
}
function $f_s_Product21__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T21__f__1;
      break
    }
    case 1: {
      return $thiz.T21__f__2;
      break
    }
    case 2: {
      return $thiz.T21__f__3;
      break
    }
    case 3: {
      return $thiz.T21__f__4;
      break
    }
    case 4: {
      return $thiz.T21__f__5;
      break
    }
    case 5: {
      return $thiz.T21__f__6;
      break
    }
    case 6: {
      return $thiz.T21__f__7;
      break
    }
    case 7: {
      return $thiz.T21__f__8;
      break
    }
    case 8: {
      return $thiz.T21__f__9;
      break
    }
    case 9: {
      return $thiz.T21__f__10;
      break
    }
    case 10: {
      return $thiz.T21__f__11;
      break
    }
    case 11: {
      return $thiz.T21__f__12;
      break
    }
    case 12: {
      return $thiz.T21__f__13;
      break
    }
    case 13: {
      return $thiz.T21__f__14;
      break
    }
    case 14: {
      return $thiz.T21__f__15;
      break
    }
    case 15: {
      return $thiz.T21__f__16;
      break
    }
    case 16: {
      return $thiz.T21__f__17;
      break
    }
    case 17: {
      return $thiz.T21__f__18;
      break
    }
    case 18: {
      return $thiz.T21__f__19;
      break
    }
    case 19: {
      return $thiz.T21__f__20;
      break
    }
    case 20: {
      return $thiz.T21__f__21;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 20)"))
    }
  }
}
function $f_s_Product22__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T22__f__1;
      break
    }
    case 1: {
      return $thiz.T22__f__2;
      break
    }
    case 2: {
      return $thiz.T22__f__3;
      break
    }
    case 3: {
      return $thiz.T22__f__4;
      break
    }
    case 4: {
      return $thiz.T22__f__5;
      break
    }
    case 5: {
      return $thiz.T22__f__6;
      break
    }
    case 6: {
      return $thiz.T22__f__7;
      break
    }
    case 7: {
      return $thiz.T22__f__8;
      break
    }
    case 8: {
      return $thiz.T22__f__9;
      break
    }
    case 9: {
      return $thiz.T22__f__10;
      break
    }
    case 10: {
      return $thiz.T22__f__11;
      break
    }
    case 11: {
      return $thiz.T22__f__12;
      break
    }
    case 12: {
      return $thiz.T22__f__13;
      break
    }
    case 13: {
      return $thiz.T22__f__14;
      break
    }
    case 14: {
      return $thiz.T22__f__15;
      break
    }
    case 15: {
      return $thiz.T22__f__16;
      break
    }
    case 16: {
      return $thiz.T22__f__17;
      break
    }
    case 17: {
      return $thiz.T22__f__18;
      break
    }
    case 18: {
      return $thiz.T22__f__19;
      break
    }
    case 19: {
      return $thiz.T22__f__20;
      break
    }
    case 20: {
      return $thiz.T22__f__21;
      break
    }
    case 21: {
      return $thiz.T22__f__22;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 21)"))
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break
    }
    case 1: {
      return $thiz.T3__f__2;
      break
    }
    case 2: {
      return $thiz.T3__f__3;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"))
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break
    }
    case 1: {
      return $thiz.T4__f__2;
      break
    }
    case 2: {
      return $thiz.T4__f__3;
      break
    }
    case 3: {
      return $thiz.T4__f__4;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"))
    }
  }
}
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T5__f__1;
      break
    }
    case 1: {
      return $thiz.T5__f__2;
      break
    }
    case 2: {
      return $thiz.T5__f__3;
      break
    }
    case 3: {
      return $thiz.T5__f__4;
      break
    }
    case 4: {
      return $thiz.T5__f__5;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"))
    }
  }
}
function $f_s_Product6__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T6__f__1;
      break
    }
    case 1: {
      return $thiz.T6__f__2;
      break
    }
    case 2: {
      return $thiz.T6__f__3;
      break
    }
    case 3: {
      return $thiz.T6__f__4;
      break
    }
    case 4: {
      return $thiz.T6__f__5;
      break
    }
    case 5: {
      return $thiz.T6__f__6;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 5)"))
    }
  }
}
function $f_s_Product7__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T7__f__1;
      break
    }
    case 1: {
      return $thiz.T7__f__2;
      break
    }
    case 2: {
      return $thiz.T7__f__3;
      break
    }
    case 3: {
      return $thiz.T7__f__4;
      break
    }
    case 4: {
      return $thiz.T7__f__5;
      break
    }
    case 5: {
      return $thiz.T7__f__6;
      break
    }
    case 6: {
      return $thiz.T7__f__7;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 6)"))
    }
  }
}
function $f_s_Product8__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T8__f__1;
      break
    }
    case 1: {
      return $thiz.T8__f__2;
      break
    }
    case 2: {
      return $thiz.T8__f__3;
      break
    }
    case 3: {
      return $thiz.T8__f__4;
      break
    }
    case 4: {
      return $thiz.T8__f__5;
      break
    }
    case 5: {
      return $thiz.T8__f__6;
      break
    }
    case 6: {
      return $thiz.T8__f__7;
      break
    }
    case 7: {
      return $thiz.T8__f__8;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 7)"))
    }
  }
}
function $f_s_Product9__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T9__f__1;
      break
    }
    case 1: {
      return $thiz.T9__f__2;
      break
    }
    case 2: {
      return $thiz.T9__f__3;
      break
    }
    case 3: {
      return $thiz.T9__f__4;
      break
    }
    case 4: {
      return $thiz.T9__f__5;
      break
    }
    case 5: {
      return $thiz.T9__f__6;
      break
    }
    case 6: {
      return $thiz.T9__f__7;
      break
    }
    case 7: {
      return $thiz.T9__f__8;
      break
    }
    case 8: {
      return $thiz.T9__f__9;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 8)"))
    }
  }
}
/** @constructor */
function $c_s_Symbol$() {
  this.s_JSUniquenessCache__f_cache = null;
  $ct_s_JSUniquenessCache__(this)
}
$c_s_Symbol$.prototype = new $h_s_JSUniquenessCache();
$c_s_Symbol$.prototype.constructor = $c_s_Symbol$;
/** @constructor */
function $h_s_Symbol$() {
  /*<skip>*/
}
$h_s_Symbol$.prototype = $c_s_Symbol$.prototype;
var $d_s_Symbol$ = new $TypeData().initClass({
  s_Symbol$: 0
}, false, "scala.Symbol$", {
  s_Symbol$: 1,
  s_JSUniquenessCache: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Symbol$.prototype.$classData = $d_s_Symbol$;
var $n_s_Symbol$;
function $m_s_Symbol$() {
  if ((!$n_s_Symbol$)) {
    $n_s_Symbol$ = new $c_s_Symbol$()
  };
  return $n_s_Symbol$
}
/** @constructor */
function $c_T$package$EmptyTuple$() {
  /*<skip>*/
}
$c_T$package$EmptyTuple$.prototype = new $h_O();
$c_T$package$EmptyTuple$.prototype.constructor = $c_T$package$EmptyTuple$;
/** @constructor */
function $h_T$package$EmptyTuple$() {
  /*<skip>*/
}
$h_T$package$EmptyTuple$.prototype = $c_T$package$EmptyTuple$.prototype;
$c_T$package$EmptyTuple$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_T$package$EmptyTuple$.prototype.productPrefix__T = (function() {
  return ""
});
$c_T$package$EmptyTuple$.prototype.productArity__I = (function() {
  return 0
});
$c_T$package$EmptyTuple$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_T$package$EmptyTuple$.prototype.toString__T = (function() {
  return "()"
});
var $d_T$package$EmptyTuple$ = new $TypeData().initClass({
  T$package$EmptyTuple$: 0
}, false, "scala.Tuple$package$EmptyTuple$", {
  T$package$EmptyTuple$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_T$package$EmptyTuple$.prototype.$classData = $d_T$package$EmptyTuple$;
var $n_T$package$EmptyTuple$;
function $m_T$package$EmptyTuple$() {
  if ((!$n_T$package$EmptyTuple$)) {
    $n_T$package$EmptyTuple$ = new $c_T$package$EmptyTuple$()
  };
  return $n_T$package$EmptyTuple$
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var evidence$12 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.from__sc_IterableOnce__O__O(elems, evidence$7)
});
function $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__($thiz, delegate) {
  $thiz.sc_EvidenceIterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_EvidenceIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_EvidenceIterableFactory$Delegate.prototype = new $h_O();
$c_sc_EvidenceIterableFactory$Delegate.prototype.constructor = $c_sc_EvidenceIterableFactory$Delegate;
/** @constructor */
function $h_sc_EvidenceIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_EvidenceIterableFactory$Delegate.prototype = $c_sc_EvidenceIterableFactory$Delegate.prototype;
$c_sc_EvidenceIterableFactory$Delegate.prototype.newBuilder__O__scm_Builder = (function(evidence$21) {
  return this.sc_EvidenceIterableFactory$Delegate__f_delegate.newBuilder__O__scm_Builder(evidence$21)
});
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.empty__O()
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory
}
$c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
  /*<skip>*/
}
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$ToFactory__f_factory.from__sc_IterableOnce__O(it)
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().initClass({
  sc_IterableFactory$ToFactory: 0
}, false, "scala.collection.IterableFactory$ToFactory", {
  sc_IterableFactory$ToFactory: 1,
  O: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IterableFactory$ToFactory.prototype.$classData = $d_sc_IterableFactory$ToFactory;
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = it.next__O();
  while (it.hasNext__Z()) {
    lst = it.next__O()
  };
  return lst
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1))
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        if ((i === otherSize)) {
          return 1
        };
        it.next__O();
        i = ((1 + i) | 0)
      };
      return ((i - otherSize) | 0)
    }
  }
}
function $f_sc_IterableOps__splitAt__I__T2($thiz, n) {
  return $ct_T2__O__O__(new $c_T2(), $thiz.take__I__O(n), $thiz.drop__I__O(n))
}
function $f_sc_IterableOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, n))
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n))
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return $thiz.drop__I__O(1)
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f))
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f))
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf))
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $$x2 = $thiz.iterableFactory__sc_IterableFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var this$2 = $thiz.iterator__sc_Iterator();
    var xs = new $c_sjsr_AnonFunction0(((this$1, suffix$1) => (() => suffix$1.iterator__sc_Iterator()))($thiz, suffix));
    var $$x1 = this$2.concat__F0__sc_Iterator(xs)
  };
  return $$x2.from__sc_IterableOnce__O($$x1)
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)))
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"))
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)))
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth))
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while (dropped.hasNext__Z()) {
    if ($uZ(p.apply__O__O(dropped.next__O()))) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs)
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.sliceIterator__I__I__sc_Iterator(0, ((n > 0) ? n : 0))
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest))
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.iterator__sc_Iterator();
  while (($thiz.hasNext__Z() && those.hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), those.next__O()))) {
      return false
    }
  };
  return ($thiz.hasNext__Z() === those.hasNext__Z())
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)))
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"))
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)))
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth))
}
var $d_sc_Iterator = new $TypeData().initClass({
  sc_Iterator: 0
}, true, "scala.collection.Iterator", {
  sc_Iterator: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19()
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
  /*<skip>*/
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21()
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return source.iterator__sc_Iterator()
});
var $d_sc_Iterator$ = new $TypeData().initClass({
  sc_Iterator$: 0
}, false, "scala.collection.Iterator$", {
  sc_Iterator$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterator$.prototype.$classData = $d_sc_Iterator$;
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$()
  };
  return $n_sc_Iterator$
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
  /*<skip>*/
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.sc_MapFactory$Delegate__f_delegate.apply__sci_Seq__O(elems)
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_MapFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.empty__O()
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
/** @constructor */
function $c_sc_View$() {
  /*<skip>*/
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
  /*<skip>*/
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sjsr_AnonFunction0(((this$1, x3$1) => (() => x3$1.iterator__sc_Iterator()))(this, x3));
    return new $c_sc_View$$anon$1(it$1)
  } else {
    var this$3 = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it);
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$3)
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((it$2) => {
    var it = $as_sc_IterableOnce(it$2);
    return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$()
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source)
});
var $d_sc_View$ = new $TypeData().initClass({
  sc_View$: 0
}, false, "scala.collection.View$", {
  sc_View$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$.prototype.$classData = $d_sc_View$;
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$()
  };
  return $n_sc_View$
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get((index << 1))
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $ct_T2__O__O__(new $c_T2(), this.sci_BitmapIndexedMapNode__f_content.get((index << 1)), this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode(this.sci_BitmapIndexedMapNode__f_content.get((((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index)
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    return $m_s_None$()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : f.apply__O())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f)
  } else {
    return f.apply__O()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedMapNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)))
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value))
      } else {
        return this
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2))
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updateWithShallowMutations__O__O__I__I__I__I__I = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      var value0 = this.getValue__I__O(index);
      if ((!(Object.is(key0, key) && Object.is(value0, value)))) {
        var dataIx = this.dataIndex__I__I(bitpos);
        var idx = (dataIx << 1);
        this.sci_BitmapIndexedMapNode__f_content.set(((1 + idx) | 0), value)
      };
      return shallowlyMutableNodeMap
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        var x2 = $as_sci_BitmapIndexedMapNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          x2.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = x2;
          break matchEnd4
        }
      };
      var result = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos)
      };
      var subNodeNew$2 = result
    };
    this.sci_BitmapIndexedMapNode__f_content.set((((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$2);
    this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - subNodeSize) | 0) + subNodeNew$2.size__I()) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - subNodeHashCode) | 0) + subNodeNew$2.cachedJavaKeySetHashCode__I()) | 0);
    return returnMutableNodeMap
  } else {
    var dataIx$2 = this.dataIndex__I__I(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.sci_BitmapIndexedMapNode__f_content;
    var dst = new $ac_O(((2 + src.u.length) | 0));
    src.copyTo(0, dst, 0, idx$2);
    dst.set(idx$2, key);
    dst.set(((1 + idx$2) | 0), value);
    var destPos = ((2 + idx$2) | 0);
    var length = ((src.u.length - idx$2) | 0);
    src.copyTo(idx$2, dst, destPos, length);
    this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedMapNode__f_content = dst;
    this.sci_BitmapIndexedMapNode__f_originalHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx$2, originalHash);
    this.sci_BitmapIndexedMapNode__f_size = ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
    return shallowlyMutableNodeMap
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.get(1)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.get(0)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))))
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash)
      }
    } else {
      return this
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === subNode.size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this))
  } else {
    return this
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [$ct_T2__O__O__(new $c_T2(), key0, value0), $ct_T2__O__O__(new $c_T2(), key1, value1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + ((src.u.length - idx) | 0)) | 0);
  src.copyTo(srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = node.getKey__I__O(0);
  var value = node.getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxNew);
  dst.set(idxNew, key);
  dst.set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  src.copyTo(idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachEntry__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    f.apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === x2.sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === x2.sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === x2.sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedMapNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = x2.sci_BitmapIndexedMapNode__f_content;
        var length = this.sci_BitmapIndexedMapNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_BitmapIndexedMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
      return x2
    } else if (((x2.sci_BitmapIndexedMapNode__f_size === 0) || (x2 === this))) {
      return this
    } else if ((x2.sci_BitmapIndexedMapNode__f_size === 1)) {
      var originalHash = x2.getHash__I__I(0);
      return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(x2.getKey__I__O(0), x2.getValue__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift, true)
    };
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedMapNode__f_dataMap | x2.sci_BitmapIndexedMapNode__f_dataMap) | this.sci_BitmapIndexedMapNode__f_nodeMap) | x2.sci_BitmapIndexedMapNode__f_nodeMap);
    var minimumBitPos = $m_sci_Node$().bitposFrom__I__I(((allMap === 0) ? 32 : ((31 - Math.clz32((allMap & ((-allMap) | 0)))) | 0)));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          var leftOriginalHash = this.getHash__I__I(leftIdx);
          if (((leftOriginalHash === x2.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getKey__I__O(leftIdx), x2.getKey__I__O(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos)
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(leftOriginalHash), shift)))
          };
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos)
        } else {
          leftDataOnly = (leftDataOnly | bitpos)
        };
        leftIdx = ((1 + leftIdx) | 0)
      } else if (((bitpos & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos)
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos)
        }
      } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0)
      } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos)
      };
      if ((bitpos === maximumBitPos)) {
        finished = true
      } else {
        bitpos = (bitpos << 1)
      }
    };
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return x2
    };
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = x2.getNode__I__sci_MapNode(rightNodeIdx);
        var newNode = this.getNode__I__sci_MapNode(leftNodeIdx).concat__sci_MapNode__I__sci_MapNode(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = x2.getNode__I__sci_MapNode(rightNodeIdx);
        var leftKey = this.getKey__I__O(leftDataIdx);
        var leftValue = this.getValue__I__O(leftDataIdx);
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash$2);
        var updated = n.updated__O__O__I__I__I__Z__sci_MapNode(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = x2.getHash__I__I(rightDataIdx);
        var newNode$3 = this.getNode__I__sci_MapNode(leftNodeIdx).updated__O__O__I__I__I__Z__sci_MapNode(x2.getKey__I__O(rightDataIdx), x2.getValue__I__O(rightDataIdx), x2.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift, true);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$3);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$3.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$3.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = this.sci_BitmapIndexedMapNode__f_originalHashes.get(leftDataIdx);
        newContent.set((compressedDataIdx << 1), this.getKey__I__O(leftDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), this.getValue__I__O(leftDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0)
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = x2.sci_BitmapIndexedMapNode__f_originalHashes.get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), x2.getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), x2.getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0)
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.getNode__I__sci_MapNode(leftNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = x2.getNode__I__sci_MapNode(rightNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = x2.getHash__I__I(rightDataIdx);
        var newNode$6 = x2.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(this.getKey__I__O(leftDataIdx), this.getValue__I__O(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().improve__I__I(leftOriginalHash$3), x2.getKey__I__O(rightDataIdx), x2.getValue__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = x2.sci_BitmapIndexedMapNode__f_originalHashes.get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), x2.getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), x2.getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0)
      };
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true
      } else {
        bitpos$2 = (bitpos$2 << 1)
      }
    };
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : x2)
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode")
  }
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = this.sci_BitmapIndexedMapNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_MapNode(contentClone.get(i$1)).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedMapNode__f_originalHashes;
  return new $c_sci_BitmapIndexedMapNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode()
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"))
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)))
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth))
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass({
  sci_BitmapIndexedMapNode: 0
}, false, "scala.collection.immutable.BitmapIndexedMapNode", {
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedMapNode.prototype.$classData = $d_sci_BitmapIndexedMapNode;
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_content.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode(this.sci_BitmapIndexedSetNode__f_content.get((((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedSetNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)))
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_SetNode(index$2).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0))
  };
  return false
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2)
    }
  };
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash)
});
$c_sci_BitmapIndexedSetNode.prototype.updateWithShallowMutations__O__I__I__I__I__I = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    var element0UnimprovedHash = this.getHash__I__I(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
      return shallowlyMutableNodeMap
    } else {
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos)
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeCachedJavaKeySetHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        var x2 = $as_sci_BitmapIndexedSetNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          x2.updateWithShallowMutations__O__I__I__I__I__I(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = x2;
          break matchEnd4
        }
      };
      var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos)
      };
      var subNodeNew$3 = subNodeNew$2
    };
    this.sci_BitmapIndexedSetNode__f_content.set((((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$3);
    this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - subNodeSize) | 0) + subNodeNew$3.size__I()) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNodeCachedJavaKeySetHashCode) | 0) + subNodeNew$3.cachedJavaKeySetHashCode__I()) | 0);
    return returnNodeMap
  } else {
    var dataIx = this.dataIndex__I__I(bitpos);
    var src = this.sci_BitmapIndexedSetNode__f_content;
    var dst = new $ac_O(((1 + src.u.length) | 0));
    src.copyTo(0, dst, 0, dataIx);
    dst.set(dataIx, element);
    var destPos = ((1 + dataIx) | 0);
    var length = ((src.u.length - dataIx) | 0);
    src.copyTo(dataIx, dst, destPos, length);
    var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
    this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedSetNode__f_content = dst;
    this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
    this.sci_BitmapIndexedSetNode__f_size = ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0);
    return shallowlyMutableNodeMap
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        if ((index === 0)) {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)))
        } else {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)))
        }
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash)
      }
    } else {
      return this
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    if ((subNodeNewSize === 1)) {
      if ((this.sci_BitmapIndexedSetNode__f_size === subNode.size__I())) {
        return $as_sci_BitmapIndexedSetNode(subNodeNew)
      } else {
        return this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)
      }
    } else if ((subNodeNewSize > 1)) {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew)
    }
  };
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + ((src.u.length - dataIx) | 0)) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dest, dataIx, length);
  this.sci_BitmapIndexedSetNode__f_content.set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIxNew);
  dst.set(dataIxNew, node.getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.copyTo(dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.getNode__I__sci_SetNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === x2.sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === x2.sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === x2.sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedSetNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = x2.sci_BitmapIndexedSetNode__f_content;
        var length = this.sci_BitmapIndexedSetNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = this.sci_BitmapIndexedSetNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_SetNode(contentClone.get(i$1)).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedSetNode__f_originalHashes;
  return new $c_sci_BitmapIndexedSetNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return x2
    } else if (((x2.sci_BitmapIndexedSetNode__f_size === 0) || (x2 === this))) {
      return this
    } else if ((x2.sci_BitmapIndexedSetNode__f_size === 1)) {
      var originalHash = x2.getHash__I__I(0);
      return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(x2.getPayload__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift)
    };
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedSetNode__f_dataMap | x2.sci_BitmapIndexedSetNode__f_dataMap) | this.sci_BitmapIndexedSetNode__f_nodeMap) | x2.sci_BitmapIndexedSetNode__f_nodeMap);
    var minimumBitPos = $m_sci_Node$().bitposFrom__I__I(((allMap === 0) ? 32 : ((31 - Math.clz32((allMap & ((-allMap) | 0)))) | 0)));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          if (((this.getHash__I__I(leftIdx) === x2.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getPayload__I__O(leftIdx), x2.getPayload__I__O(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos)
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(this.getHash__I__I(leftIdx)), shift)))
          };
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos)
        } else {
          leftDataOnly = (leftDataOnly | bitpos)
        };
        leftIdx = ((1 + leftIdx) | 0)
      } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos)
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos)
        }
      } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0)
      } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos)
      };
      if ((bitpos === maximumBitPos)) {
        finished = true
      } else {
        bitpos = (bitpos << 1)
      }
    };
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this
    };
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.getNode__I__sci_SetNode(leftNodeIdx);
        var newNode = leftNode.concat__sci_SetNode__I__sci_SetNode(x2.getNode__I__sci_SetNode(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = x2.getNode__I__sci_SetNode(rightNodeIdx);
        var leftPayload = this.getPayload__I__O(leftDataIdx);
        var leftOriginalHash = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash);
        var newNode$2 = n.updated__O__I__I__I__sci_SetNode(leftPayload, leftOriginalHash, leftImproved, nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$2);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + newNode$2.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$2.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = x2.getHash__I__I(rightDataIdx);
        var leftNode$2 = this.getNode__I__sci_SetNode(leftNodeIdx);
        var updated = leftNode$2.updated__O__I__I__I__sci_SetNode(x2.getPayload__I__O(rightDataIdx), x2.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = this.sci_BitmapIndexedSetNode__f_originalHashes.get(leftDataIdx);
        newContent.set(compressedDataIdx, this.getPayload__I__O(leftDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0)
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = x2.sci_BitmapIndexedSetNode__f_originalHashes.get(rightDataIdx);
        newContent.set(compressedDataIdx, x2.getPayload__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0)
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.getNode__I__sci_SetNode(leftNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = x2.getNode__I__sci_SetNode(rightNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = x2.getHash__I__I(rightDataIdx);
        var newNode$6 = x2.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(this.getPayload__I__O(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().improve__I__I(leftOriginalHash$2), x2.getPayload__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = x2.sci_BitmapIndexedSetNode__f_originalHashes.get(rightDataIdx);
        newContent.set(compressedDataIdx, x2.getPayload__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0)
      };
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true
      } else {
        bitpos$2 = (bitpos$2 << 1)
      }
    };
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this)
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  }
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_SetNode(j).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode()
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"))
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)))
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth))
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass({
  sci_BitmapIndexedSetNode: 0
}, false, "scala.collection.immutable.BitmapIndexedSetNode", {
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedSetNode.prototype.$classData = $d_sci_BitmapIndexedSetNode;
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionMapNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
  /*<skip>*/
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  var i = 0;
  while (iter.hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($as_T2(iter.next__O())._1__O(), key)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = this.get__O__I__I__I__s_Option(key, originalHash, hash, shift);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  } else {
    return this$1.get__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()) : $m_s_None$())
  } else {
    return $m_s_None$()
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? f.apply__O() : $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(x1))._2__O())
  } else {
    return f.apply__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0))
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index, $ct_T2__O__O__(new $c_T2(), key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value))))
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionMapNode__f_content;
    var pred = new $c_sjsr_AnonFunction1(((this$1, key$1) => ((keyValuePair$2) => {
      var keyValuePair = $as_T2(keyValuePair$2);
      return $m_sr_BoxesRunTime$().equals__O__O__Z(keyValuePair._1__O(), key$1)
    }))(this, key));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2(updatedContent.apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash)
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent)
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._1__O()
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(f)
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$1, f$1) => ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = x0$1._1__O();
      var v = x0$1._2__O();
      return f$1.apply__O__O__O(k, v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))(this, f)))
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = $as_T2(iter.next__O());
    f.apply__O__O__O__O(next._1__O(), next._2__O(), this.sci_HashCollisionMapNode__f_originalHash)
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true
    } else if (((this.sci_HashCollisionMapNode__f_hash === x2.sci_HashCollisionMapNode__f_hash) && (this.sci_HashCollisionMapNode__f_content.length__I() === x2.sci_HashCollisionMapNode__f_content.length__I()))) {
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x1$2 = $as_T2(iter.next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2)
        };
        var key = x1$2._1__O();
        var value = x1$2._2__O();
        var index = x2.indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $as_T2(x2.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O())))) {
          return false
        }
      };
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_HashCollisionMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((x2 === this)) {
      return this
    } else {
      var newContent = null;
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = $as_T2(iter.next__O());
        if ((x2.indexOf__O__I(nextPayload._1__O()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(x2.sci_HashCollisionMapNode__f_content)
          };
          newContent.addOne__O__sci_VectorBuilder(nextPayload)
        }
      };
      return ((newContent === null) ? x2 : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent.result__sci_Vector()))
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionMapNode__f_content.length__I(), this.sci_HashCollisionMapNode__f_hash)
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content)
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_HashCollisionMapNode(that, shift)
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"))
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)))
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth))
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass({
  sci_HashCollisionMapNode: 0
}, false, "scala.collection.immutable.HashCollisionMapNode", {
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionMapNode.prototype.$classData = $d_sci_HashCollisionMapNode;
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionSetNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
  /*<skip>*/
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = this.sci_HashCollisionSetNode__f_content;
    return $f_sc_SeqOps__contains__O__Z(this$1, element)
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)))
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionSetNode__f_content;
    var pred = new $c_sjsr_AnonFunction1(((this$1, element$1) => ((element0$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2, element$1)))(this, element));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([updatedContent.apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent))
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_HashCollisionSetNode__f_content.apply__I__O(index)
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    f.apply__O__O(iter.next__O())
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionSetNode__f_content.length__I(), this.sci_HashCollisionSetNode__f_hash)
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === x2.sci_HashCollisionSetNode__f_hash)) {
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        var $$x2 = this$1.length__I();
        var this$2 = x2.sci_HashCollisionSetNode__f_content;
        var $$x1 = ($$x2 === this$2.length__I())
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$3 = this.sci_HashCollisionSetNode__f_content;
        var eta$0$1 = x2.sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && it.hasNext__Z())) {
          var arg1 = it.next__O();
          res = $f_sc_SeqOps__contains__O__Z(eta$0$1, arg1)
        };
        return res
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((x2 === this)) {
      return this
    } else {
      var newContent = null;
      var iter = x2.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = iter.next__O();
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        if ((!$f_sc_SeqOps__contains__O__Z(this$1, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(this.sci_HashCollisionSetNode__f_content)
          };
          newContent.addOne__O__sci_VectorBuilder(nextPayload)
        }
      };
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent.result__sci_Vector()))
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = iter.next__O();
    f.apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash)
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content)
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"))
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)))
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth))
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass({
  sci_HashCollisionSetNode: 0
}, false, "scala.collection.immutable.HashCollisionSetNode", {
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionSetNode.prototype.$classData = $d_sci_HashCollisionSetNode;
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode)
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
  /*<skip>*/
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems)
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source);
    return this$2.result__sci_HashMap()
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder()
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it)
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap
});
var $d_sci_HashMap$ = new $TypeData().initClass({
  sci_HashMap$: 0
}, false, "scala.collection.immutable.HashMap$", {
  sci_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$.prototype.$classData = $d_sci_HashMap$;
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$()
  };
  return $n_sci_HashMap$
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode)
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
  /*<skip>*/
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2
  } else if ((source.knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source);
    return this$2.result__sci_HashSet()
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder()
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source)
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet
});
var $d_sci_HashSet$ = new $TypeData().initClass({
  sci_HashSet$: 0
}, false, "scala.collection.immutable.HashSet$", {
  sci_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet$.prototype.$classData = $d_sci_HashSet$;
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$()
  };
  return $n_sci_HashSet$
}
/** @constructor */
function $c_sci_LazyList$State$Cons(head, tail) {
  this.sci_LazyList$State$Cons__f_head = null;
  this.sci_LazyList$State$Cons__f_tail = null;
  this.sci_LazyList$State$Cons__f_head = head;
  this.sci_LazyList$State$Cons__f_tail = tail
}
$c_sci_LazyList$State$Cons.prototype = new $h_O();
$c_sci_LazyList$State$Cons.prototype.constructor = $c_sci_LazyList$State$Cons;
/** @constructor */
function $h_sci_LazyList$State$Cons() {
  /*<skip>*/
}
$h_sci_LazyList$State$Cons.prototype = $c_sci_LazyList$State$Cons.prototype;
$c_sci_LazyList$State$Cons.prototype.head__O = (function() {
  return this.sci_LazyList$State$Cons__f_head
});
$c_sci_LazyList$State$Cons.prototype.tail__sci_LazyList = (function() {
  return this.sci_LazyList$State$Cons__f_tail
});
var $d_sci_LazyList$State$Cons = new $TypeData().initClass({
  sci_LazyList$State$Cons: 0
}, false, "scala.collection.immutable.LazyList$State$Cons", {
  sci_LazyList$State$Cons: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Cons.prototype.$classData = $d_sci_LazyList$State$Cons;
/** @constructor */
function $c_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$c_sci_LazyList$State$Empty$.prototype = new $h_O();
$c_sci_LazyList$State$Empty$.prototype.constructor = $c_sci_LazyList$State$Empty$;
/** @constructor */
function $h_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$h_sci_LazyList$State$Empty$.prototype = $c_sci_LazyList$State$Empty$.prototype;
$c_sci_LazyList$State$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.tail__sci_LazyList = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_LazyList$State$Empty$ = new $TypeData().initClass({
  sci_LazyList$State$Empty$: 0
}, false, "scala.collection.immutable.LazyList$State$Empty$", {
  sci_LazyList$State$Empty$: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Empty$.prototype.$classData = $d_sci_LazyList$State$Empty$;
var $n_sci_LazyList$State$Empty$;
function $m_sci_LazyList$State$Empty$() {
  if ((!$n_sci_LazyList$State$Empty$)) {
    $n_sci_LazyList$State$Empty$ = new $c_sci_LazyList$State$Empty$()
  };
  return $n_sci_LazyList$State$Empty$
}
/** @constructor */
function $c_sci_Map$() {
  /*<skip>*/
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
  /*<skip>*/
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems)
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if (x2.isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$()
    }
  };
  if ($is_sci_Map(it)) {
    var x3 = $as_sci_Map(it);
    return x3
  };
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it);
  return this$2.result__sci_Map()
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl()
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it)
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$()
});
var $d_sci_Map$ = new $TypeData().initClass({
  sci_Map$: 0
}, false, "scala.collection.immutable.Map$", {
  sci_Map$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$.prototype.$classData = $d_sci_Map$;
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$()
  };
  return $n_sci_Map$
}
/** @constructor */
function $c_sci_Set$() {
  /*<skip>*/
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
  /*<skip>*/
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if ($is_sci_SortedSet(it)) {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$2.result__sci_Set()
  } else if ((it.knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$()
  } else if ($is_sci_Set(it)) {
    var x3 = $as_sci_Set(it);
    return x3
  } else {
    var this$3 = new $c_sci_SetBuilderImpl();
    var this$4 = this$3.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$4.result__sci_Set()
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl()
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source)
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$()
});
var $d_sci_Set$ = new $TypeData().initClass({
  sci_Set$: 0
}, false, "scala.collection.immutable.Set$", {
  sci_Set$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$.prototype.$classData = $d_sci_Set$;
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$()
  };
  return $n_sci_Set$
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)))
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"))
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)))
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth))
}
/** @constructor */
function $c_scm_HashMap$() {
  /*<skip>*/
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
  /*<skip>*/
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap())
});
var $d_scm_HashMap$ = new $TypeData().initClass({
  scm_HashMap$: 0
}, false, "scala.collection.mutable.HashMap$", {
  scm_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap$.prototype.$classData = $d_scm_HashMap$;
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$()
  };
  return $n_scm_HashMap$
}
/** @constructor */
function $c_scm_HashSet$() {
  /*<skip>*/
}
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
  /*<skip>*/
}
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it)
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75)
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet())
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source)
});
var $d_scm_HashSet$ = new $TypeData().initClass({
  scm_HashSet$: 0
}, false, "scala.collection.mutable.HashSet$", {
  scm_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet$.prototype.$classData = $d_scm_HashSet$;
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$()
  };
  return $n_scm_HashSet$
}
/** @constructor */
function $c_s_jdk_CollectionConverters$() {
  /*<skip>*/
}
$c_s_jdk_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_CollectionConverters$.prototype.constructor = $c_s_jdk_CollectionConverters$;
/** @constructor */
function $h_s_jdk_CollectionConverters$() {
  /*<skip>*/
}
$h_s_jdk_CollectionConverters$.prototype = $c_s_jdk_CollectionConverters$.prototype;
var $d_s_jdk_CollectionConverters$ = new $TypeData().initClass({
  s_jdk_CollectionConverters$: 0
}, false, "scala.jdk.CollectionConverters$", {
  s_jdk_CollectionConverters$: 1,
  O: 1,
  sc_convert_AsJavaExtensions: 1,
  sc_convert_AsScalaExtensions: 1
});
$c_s_jdk_CollectionConverters$.prototype.$classData = $d_s_jdk_CollectionConverters$;
var $n_s_jdk_CollectionConverters$;
function $m_s_jdk_CollectionConverters$() {
  if ((!$n_s_jdk_CollectionConverters$)) {
    $n_s_jdk_CollectionConverters$ = new $c_s_jdk_CollectionConverters$()
  };
  return $n_s_jdk_CollectionConverters$
}
/** @constructor */
function $c_s_jdk_javaapi_CollectionConverters$() {
  /*<skip>*/
}
$c_s_jdk_javaapi_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_javaapi_CollectionConverters$.prototype.constructor = $c_s_jdk_javaapi_CollectionConverters$;
/** @constructor */
function $h_s_jdk_javaapi_CollectionConverters$() {
  /*<skip>*/
}
$h_s_jdk_javaapi_CollectionConverters$.prototype = $c_s_jdk_javaapi_CollectionConverters$.prototype;
var $d_s_jdk_javaapi_CollectionConverters$ = new $TypeData().initClass({
  s_jdk_javaapi_CollectionConverters$: 0
}, false, "scala.jdk.javaapi.CollectionConverters$", {
  s_jdk_javaapi_CollectionConverters$: 1,
  O: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
});
$c_s_jdk_javaapi_CollectionConverters$.prototype.$classData = $d_s_jdk_javaapi_CollectionConverters$;
var $n_s_jdk_javaapi_CollectionConverters$;
function $m_s_jdk_javaapi_CollectionConverters$() {
  if ((!$n_s_jdk_javaapi_CollectionConverters$)) {
    $n_s_jdk_javaapi_CollectionConverters$ = new $c_s_jdk_javaapi_CollectionConverters$()
  };
  return $n_s_jdk_javaapi_CollectionConverters$
}
/** @constructor */
function $c_s_math_Equiv$() {
  /*<skip>*/
}
$c_s_math_Equiv$.prototype = new $h_O();
$c_s_math_Equiv$.prototype.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
  /*<skip>*/
}
$h_s_math_Equiv$.prototype = $c_s_math_Equiv$.prototype;
var $d_s_math_Equiv$ = new $TypeData().initClass({
  s_math_Equiv$: 0
}, false, "scala.math.Equiv$", {
  s_math_Equiv$: 1,
  O: 1,
  s_math_LowPriorityEquiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$.prototype.$classData = $d_s_math_Equiv$;
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$()
  };
  return $n_s_math_Equiv$
}
/** @constructor */
function $c_s_math_Ordering$() {
  /*<skip>*/
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
  /*<skip>*/
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass({
  s_math_Ordering$: 0
}, false, "scala.math.Ordering$", {
  s_math_Ordering$: 1,
  O: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$.prototype.$classData = $d_s_math_Ordering$;
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$()
  };
  return $n_s_math_Ordering$
}
function $is_s_math_PartialOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_PartialOrdering)))
}
function $as_s_math_PartialOrdering(obj) {
  return (($is_s_math_PartialOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.PartialOrdering"))
}
function $isArrayOf_s_math_PartialOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_PartialOrdering)))
}
function $asArrayOf_s_math_PartialOrdering(obj, depth) {
  return (($isArrayOf_s_math_PartialOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.PartialOrdering;", depth))
}
/** @constructor */
function $c_s_math_ScalaNumber() {
  /*<skip>*/
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
  /*<skip>*/
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"))
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)))
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth))
}
/** @constructor */
function $c_s_reflect_NoManifest$() {
  /*<skip>*/
}
$c_s_reflect_NoManifest$.prototype = new $h_O();
$c_s_reflect_NoManifest$.prototype.constructor = $c_s_reflect_NoManifest$;
/** @constructor */
function $h_s_reflect_NoManifest$() {
  /*<skip>*/
}
$h_s_reflect_NoManifest$.prototype = $c_s_reflect_NoManifest$.prototype;
$c_s_reflect_NoManifest$.prototype.toString__T = (function() {
  return "<?>"
});
var $d_s_reflect_NoManifest$ = new $TypeData().initClass({
  s_reflect_NoManifest$: 0
}, false, "scala.reflect.NoManifest$", {
  s_reflect_NoManifest$: 1,
  O: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_NoManifest$.prototype.$classData = $d_s_reflect_NoManifest$;
var $n_s_reflect_NoManifest$;
function $m_s_reflect_NoManifest$() {
  if ((!$n_s_reflect_NoManifest$)) {
    $n_s_reflect_NoManifest$ = new $c_s_reflect_NoManifest$()
  };
  return $n_s_reflect_NoManifest$
}
/** @constructor */
function $c_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_sr_Nothing$ = new $TypeData().initClass({
  sr_Nothing$: 0
}, false, "scala.runtime.Nothing$", {
  sr_Nothing$: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_sr_TupleXXL(es) {
  this.sr_TupleXXL__f_es = null;
  this.sr_TupleXXL__f_es = es;
  if ((es.u.length <= 22)) {
    $m_sr_Scala3RunTime$().assertFailed__E()
  }
}
$c_sr_TupleXXL.prototype = new $h_O();
$c_sr_TupleXXL.prototype.constructor = $c_sr_TupleXXL;
/** @constructor */
function $h_sr_TupleXXL() {
  /*<skip>*/
}
$h_sr_TupleXXL.prototype = $c_sr_TupleXXL.prototype;
$c_sr_TupleXXL.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_sr_TupleXXL.prototype.productElement__I__O = (function(n) {
  var arr = this.sr_TupleXXL__f_es;
  return arr.get(n)
});
$c_sr_TupleXXL.prototype.productArity__I = (function() {
  var arr = this.sr_TupleXXL__f_es;
  return arr.u.length
});
$c_sr_TupleXXL.prototype.productPrefix__T = (function() {
  return "TupleXXL"
});
$c_sr_TupleXXL.prototype.toString__T = (function() {
  var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.sr_TupleXXL__f_es);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "(", ",", ")")
});
$c_sr_TupleXXL.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sr_TupleXXL.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sr_TupleXXL)) {
    var that$2 = $as_sr_TupleXXL(that);
    if ((this.sr_TupleXXL__f_es === that$2.sr_TupleXXL__f_es)) {
      return true
    } else {
      var arr = this.sr_TupleXXL__f_es;
      var arr$1 = that$2.sr_TupleXXL__f_es;
      if ((arr.u.length !== arr$1.u.length)) {
        return false
      };
      var i = 0;
      while (true) {
        var $$x1 = i;
        var arr$2 = this.sr_TupleXXL__f_es;
        if (($$x1 < arr$2.u.length)) {
          var arr$3 = this.sr_TupleXXL__f_es;
          var n = i;
          var x = arr$3.get(n);
          var arr$4 = that$2.sr_TupleXXL__f_es;
          var n$1 = i;
          var y = arr$4.get(n$1);
          if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
            return false
          };
          i = ((1 + i) | 0)
        } else {
          break
        }
      };
      return true
    }
  } else {
    return false
  }
});
function $as_sr_TupleXXL(obj) {
  return (((obj instanceof $c_sr_TupleXXL) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.TupleXXL"))
}
function $isArrayOf_sr_TupleXXL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_TupleXXL)))
}
function $asArrayOf_sr_TupleXXL(obj, depth) {
  return (($isArrayOf_sr_TupleXXL(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.TupleXXL;", depth))
}
var $d_sr_TupleXXL = new $TypeData().initClass({
  sr_TupleXXL: 0
}, false, "scala.runtime.TupleXXL", {
  sr_TupleXXL: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_sr_TupleXXL.prototype.$classData = $d_sr_TupleXXL;
/** @constructor */
function $c_sjs_js_Any$() {
  /*<skip>*/
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
  /*<skip>*/
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return ((f$1) => (() => f$1.apply__O()))(f)
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((f$2) => ((arg1$2) => f$2.apply__O__O(arg1$2)))(f)
});
$c_sjs_js_Any$.prototype.toFunction2__sjs_js_Function2__F2 = (function(f) {
  return new $c_sjsr_AnonFunction2(((this$1, f$1) => ((x1$2, x2$2) => f$1(x1$2, x2$2)))(this, f))
});
var $d_sjs_js_Any$ = new $TypeData().initClass({
  sjs_js_Any$: 0
}, false, "scala.scalajs.js.Any$", {
  sjs_js_Any$: 1,
  O: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
});
$c_sjs_js_Any$.prototype.$classData = $d_sjs_js_Any$;
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$()
  };
  return $n_sjs_js_Any$
}
/** @constructor */
function $c_sjsr_AnonFunction0(f) {
  this.sjsr_AnonFunction0__f_f = null;
  this.sjsr_AnonFunction0__f_f = f
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
  /*<skip>*/
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
$c_sjsr_AnonFunction0.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0__f_f)()
});
var $d_sjsr_AnonFunction0 = new $TypeData().initClass({
  sjsr_AnonFunction0: 0
}, false, "scala.scalajs.runtime.AnonFunction0", {
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  O: 1,
  F0: 1
});
$c_sjsr_AnonFunction0.prototype.$classData = $d_sjsr_AnonFunction0;
/** @constructor */
function $c_sjsr_AnonFunction1(f) {
  this.sjsr_AnonFunction1__f_f = null;
  this.sjsr_AnonFunction1__f_f = f
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
  /*<skip>*/
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
$c_sjsr_AnonFunction1.prototype.apply__O__O = (function(arg1) {
  return (0, this.sjsr_AnonFunction1__f_f)(arg1)
});
var $d_sjsr_AnonFunction1 = new $TypeData().initClass({
  sjsr_AnonFunction1: 0
}, false, "scala.scalajs.runtime.AnonFunction1", {
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sjsr_AnonFunction1.prototype.$classData = $d_sjsr_AnonFunction1;
/** @constructor */
function $c_sjsr_AnonFunction2(f) {
  this.sjsr_AnonFunction2__f_f = null;
  this.sjsr_AnonFunction2__f_f = f
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
  /*<skip>*/
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
$c_sjsr_AnonFunction2.prototype.apply__O__O__O = (function(arg1, arg2) {
  return (0, this.sjsr_AnonFunction2__f_f)(arg1, arg2)
});
var $d_sjsr_AnonFunction2 = new $TypeData().initClass({
  sjsr_AnonFunction2: 0
}, false, "scala.scalajs.runtime.AnonFunction2", {
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sjsr_AnonFunction2.prototype.$classData = $d_sjsr_AnonFunction2;
/** @constructor */
function $c_sjsr_AnonFunction3(f) {
  this.sjsr_AnonFunction3__f_f = null;
  this.sjsr_AnonFunction3__f_f = f
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
  /*<skip>*/
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
$c_sjsr_AnonFunction3.prototype.apply__O__O__O__O = (function(arg1, arg2, arg3) {
  return (0, this.sjsr_AnonFunction3__f_f)(arg1, arg2, arg3)
});
var $d_sjsr_AnonFunction3 = new $TypeData().initClass({
  sjsr_AnonFunction3: 0
}, false, "scala.scalajs.runtime.AnonFunction3", {
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1
});
$c_sjsr_AnonFunction3.prototype.$classData = $d_sjsr_AnonFunction3;
class $c_s_util_control_ControlThrowable extends $c_jl_Throwable {
}
function $as_s_util_control_ControlThrowable(obj) {
  return (((obj instanceof $c_s_util_control_ControlThrowable) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"))
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)))
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth))
}
/** @constructor */
function $c_Lsquants_time_Time$() {
  this.Lsquants_time_Time$__f_squants$Dimension$$QuantityString$lzy1 = null;
  this.Lsquants_time_Time$__f_squants$Dimension$$QuantityStringbitmap$1 = false;
  this.Lsquants_time_Time$__f_dimensionImplicit = null;
  this.Lsquants_time_Time$__f_NanosecondsPerSecond = 0.0;
  this.Lsquants_time_Time$__f_MicrosecondsPerSecond = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerNanosecond = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerMicrosecond = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerSecond = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerMinute = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerHour = 0.0;
  this.Lsquants_time_Time$__f_MillisecondsPerDay = 0.0;
  this.Lsquants_time_Time$__f_SecondsPerMinute = 0.0;
  this.Lsquants_time_Time$__f_SecondsPerHour = 0.0;
  this.Lsquants_time_Time$__f_SecondsPerDay = 0.0;
  this.Lsquants_time_Time$__f_MinutesPerHour = 0.0;
  this.Lsquants_time_Time$__f_HoursPerDay = 0.0;
  $n_Lsquants_time_Time$ = this;
  this.Lsquants_time_Time$__f_dimensionImplicit = this;
  this.Lsquants_time_Time$__f_NanosecondsPerSecond = 1.0E9;
  this.Lsquants_time_Time$__f_MicrosecondsPerSecond = 1000000.0;
  this.Lsquants_time_Time$__f_MillisecondsPerNanosecond = 1.0E-6;
  this.Lsquants_time_Time$__f_MillisecondsPerMicrosecond = 0.001;
  this.Lsquants_time_Time$__f_MillisecondsPerSecond = 1000.0;
  this.Lsquants_time_Time$__f_MillisecondsPerMinute = (60.0 * this.Lsquants_time_Time$__f_MillisecondsPerSecond);
  this.Lsquants_time_Time$__f_MillisecondsPerHour = (60.0 * this.Lsquants_time_Time$__f_MillisecondsPerMinute);
  this.Lsquants_time_Time$__f_MillisecondsPerDay = (24.0 * this.Lsquants_time_Time$__f_MillisecondsPerHour);
  this.Lsquants_time_Time$__f_SecondsPerMinute = 60.0;
  this.Lsquants_time_Time$__f_SecondsPerHour = (60.0 * this.Lsquants_time_Time$__f_SecondsPerMinute);
  this.Lsquants_time_Time$__f_SecondsPerDay = (24.0 * this.Lsquants_time_Time$__f_SecondsPerHour);
  this.Lsquants_time_Time$__f_MinutesPerHour = 60.0;
  this.Lsquants_time_Time$__f_HoursPerDay = 24.0
}
$c_Lsquants_time_Time$.prototype = new $h_O();
$c_Lsquants_time_Time$.prototype.constructor = $c_Lsquants_time_Time$;
/** @constructor */
function $h_Lsquants_time_Time$() {
  /*<skip>*/
}
$h_Lsquants_time_Time$.prototype = $c_Lsquants_time_Time$.prototype;
$c_Lsquants_time_Time$.prototype.equals__O__Z = (function(that) {
  return $f_Lsquants_Dimension__equals__O__Z(this, that)
});
$c_Lsquants_time_Time$.prototype.hashCode__I = (function() {
  return $f_Lsquants_Dimension__hashCode__I(this)
});
$c_Lsquants_time_Time$.prototype.apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time = (function(n, unit, num) {
  return new $c_Lsquants_time_Time(num.toDouble__O__D(n), unit)
});
var $d_Lsquants_time_Time$ = new $TypeData().initClass({
  Lsquants_time_Time$: 0
}, false, "squants.time.Time$", {
  Lsquants_time_Time$: 1,
  O: 1,
  Lsquants_Dimension: 1,
  Lsquants_BaseDimension: 1
});
$c_Lsquants_time_Time$.prototype.$classData = $d_Lsquants_time_Time$;
var $n_Lsquants_time_Time$;
function $m_Lsquants_time_Time$() {
  if ((!$n_Lsquants_time_Time$)) {
    $n_Lsquants_time_Time$ = new $c_Lsquants_time_Time$()
  };
  return $n_Lsquants_time_Time$
}
/** @constructor */
function $c_Ltyrian_Attribute$() {
  this.Ltyrian_Attribute$__f_empty = null;
  $n_Ltyrian_Attribute$ = this;
  this.Ltyrian_Attribute$__f_empty = ($m_Ltyrian_Attribute$(), new $c_Ltyrian_Attribute("", ""))
}
$c_Ltyrian_Attribute$.prototype = new $h_O();
$c_Ltyrian_Attribute$.prototype.constructor = $c_Ltyrian_Attribute$;
/** @constructor */
function $h_Ltyrian_Attribute$() {
  /*<skip>*/
}
$h_Ltyrian_Attribute$.prototype = $c_Ltyrian_Attribute$.prototype;
$c_Ltyrian_Attribute$.prototype.toString__T = (function() {
  return "Attribute"
});
var $d_Ltyrian_Attribute$ = new $TypeData().initClass({
  Ltyrian_Attribute$: 0
}, false, "tyrian.Attribute$", {
  Ltyrian_Attribute$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Attribute$.prototype.$classData = $d_Ltyrian_Attribute$;
var $n_Ltyrian_Attribute$;
function $m_Ltyrian_Attribute$() {
  if ((!$n_Ltyrian_Attribute$)) {
    $n_Ltyrian_Attribute$ = new $c_Ltyrian_Attribute$()
  };
  return $n_Ltyrian_Attribute$
}
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect$() {
  /*<skip>*/
}
$c_Ltyrian_Cmd$SideEffect$.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect$.prototype.constructor = $c_Ltyrian_Cmd$SideEffect$;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect$() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$SideEffect$.prototype = $c_Ltyrian_Cmd$SideEffect$.prototype;
$c_Ltyrian_Cmd$SideEffect$.prototype.toString__T = (function() {
  return "SideEffect"
});
$c_Ltyrian_Cmd$SideEffect$.prototype.apply__F0__Ltyrian_Cmd$SideEffect = (function(thunk) {
  var task = new $c_Ltyrian_Task$SideEffect(thunk);
  return new $c_Ltyrian_Cmd$SideEffect(task)
});
var $d_Ltyrian_Cmd$SideEffect$ = new $TypeData().initClass({
  Ltyrian_Cmd$SideEffect$: 0
}, false, "tyrian.Cmd$SideEffect$", {
  Ltyrian_Cmd$SideEffect$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Cmd$SideEffect$.prototype.$classData = $d_Ltyrian_Cmd$SideEffect$;
var $n_Ltyrian_Cmd$SideEffect$;
function $m_Ltyrian_Cmd$SideEffect$() {
  if ((!$n_Ltyrian_Cmd$SideEffect$)) {
    $n_Ltyrian_Cmd$SideEffect$ = new $c_Ltyrian_Cmd$SideEffect$()
  };
  return $n_Ltyrian_Cmd$SideEffect$
}
/** @constructor */
function $c_Ltyrian_Property$() {
  this.Ltyrian_Property$__f_empty = null;
  $n_Ltyrian_Property$ = this;
  this.Ltyrian_Property$__f_empty = ($m_Ltyrian_Property$(), new $c_Ltyrian_Property("", ""))
}
$c_Ltyrian_Property$.prototype = new $h_O();
$c_Ltyrian_Property$.prototype.constructor = $c_Ltyrian_Property$;
/** @constructor */
function $h_Ltyrian_Property$() {
  /*<skip>*/
}
$h_Ltyrian_Property$.prototype = $c_Ltyrian_Property$.prototype;
$c_Ltyrian_Property$.prototype.toString__T = (function() {
  return "Property"
});
var $d_Ltyrian_Property$ = new $TypeData().initClass({
  Ltyrian_Property$: 0
}, false, "tyrian.Property$", {
  Ltyrian_Property$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Property$.prototype.$classData = $d_Ltyrian_Property$;
var $n_Ltyrian_Property$;
function $m_Ltyrian_Property$() {
  if ((!$n_Ltyrian_Property$)) {
    $n_Ltyrian_Property$ = new $c_Ltyrian_Property$()
  };
  return $n_Ltyrian_Property$
}
/** @constructor */
function $c_Ltyrian_Sub$() {
  this.Ltyrian_Sub$__f_given_CanEqual_Option_Option$lzy1 = null;
  this.Ltyrian_Sub$__f_given_CanEqual_Option_Optionbitmap$1 = false;
  this.Ltyrian_Sub$__f_given_CanEqual_Sub_Sub$lzy1 = null;
  this.Ltyrian_Sub$__f_given_CanEqual_Sub_Subbitmap$1 = false
}
$c_Ltyrian_Sub$.prototype = new $h_O();
$c_Ltyrian_Sub$.prototype.constructor = $c_Ltyrian_Sub$;
/** @constructor */
function $h_Ltyrian_Sub$() {
  /*<skip>*/
}
$h_Ltyrian_Sub$.prototype = $c_Ltyrian_Sub$.prototype;
$c_Ltyrian_Sub$.prototype.ofTotalObservable__T__Ltyrian_Task$Observable__Ltyrian_Sub = (function(id, observable) {
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((_$2) => {
    var _$2$1 = $as_s_util_Either(_$2);
    return _$2$1.toOption__s_Option().get__O()
  }))(this));
  return new $c_Ltyrian_Sub$OfObservable(id, observable, f)
});
$c_Ltyrian_Sub$.prototype.emit__O__Ltyrian_Sub = (function(msg) {
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  return this.timeout__s_concurrent_duration_FiniteDuration__O__T__Ltyrian_Sub(new $c_s_concurrent_duration_FiniteDuration($L0, unit), msg, $dp_toString__T(msg))
});
$c_Ltyrian_Sub$.prototype.timeout__s_concurrent_duration_FiniteDuration__O__T__Ltyrian_Sub = (function(duration, msg, id) {
  return this.ofTotalObservable__T__Ltyrian_Task$Observable__Ltyrian_Sub(id, new $c_Ltyrian_Sub$$anon$2(duration, msg))
});
$c_Ltyrian_Sub$.prototype.every__s_concurrent_duration_FiniteDuration__T__Ltyrian_Sub = (function(interval, id) {
  return this.ofTotalObservable__T__Ltyrian_Task$Observable__Ltyrian_Sub(id, new $c_Ltyrian_Sub$$anon$4(interval))
});
$c_Ltyrian_Sub$.prototype.fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Ltyrian_Sub = (function(name, target, extract) {
  return $m_Ltyrian_Sub$().ofTotalObservable__T__Ltyrian_Task$Observable__Ltyrian_Sub((("" + name) + $dp_hashCode__I(target)), new $c_Ltyrian_Sub$$anon$6(name, target, extract))
});
$c_Ltyrian_Sub$.prototype.ordinal__Ltyrian_Sub__I = (function(x$0) {
  if ((x$0 === $m_Ltyrian_Sub$Empty$())) {
    return 0
  };
  if ((x$0 instanceof $c_Ltyrian_Sub$OfObservable)) {
    return 1
  };
  if (false) {
    return 2
  };
  if ((x$0 instanceof $c_Ltyrian_Sub$Batch)) {
    return 3
  };
  throw new $c_s_MatchError(x$0)
});
$c_Ltyrian_Sub$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Ltyrian_Sub__I($as_Ltyrian_Sub(x))
});
var $d_Ltyrian_Sub$ = new $TypeData().initClass({
  Ltyrian_Sub$: 0
}, false, "tyrian.Sub$", {
  Ltyrian_Sub$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_Sub$.prototype.$classData = $d_Ltyrian_Sub$;
var $n_Ltyrian_Sub$;
function $m_Ltyrian_Sub$() {
  if ((!$n_Ltyrian_Sub$)) {
    $n_Ltyrian_Sub$ = new $c_Ltyrian_Sub$()
  };
  return $n_Ltyrian_Sub$
}
function $s_Ltyrian_http_Body$__Empty__Ltyrian_http_Body() {
  $m_Ltyrian_http_Body$();
  return $t_Ltyrian_http_Body$__Empty
}
/** @constructor */
function $c_Ltyrian_http_Body$() {
  this.Ltyrian_http_Body$__f_derived$CanEqual$lzy2 = null;
  this.Ltyrian_http_Body$__f_derived$CanEqualbitmap$2 = false;
  $n_Ltyrian_http_Body$ = this;
  $t_Ltyrian_http_Body$__Empty = new $c_Ltyrian_http_Body$$anon$4()
}
$c_Ltyrian_http_Body$.prototype = new $h_O();
$c_Ltyrian_http_Body$.prototype.constructor = $c_Ltyrian_http_Body$;
/** @constructor */
function $h_Ltyrian_http_Body$() {
  /*<skip>*/
}
$h_Ltyrian_http_Body$.prototype = $c_Ltyrian_http_Body$.prototype;
$c_Ltyrian_http_Body$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ltyrian_http_Body(x);
  return x$0.ordinal__I()
});
var $d_Ltyrian_http_Body$ = new $TypeData().initClass({
  Ltyrian_http_Body$: 0
}, false, "tyrian.http.Body$", {
  Ltyrian_http_Body$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_http_Body$.prototype.$classData = $d_Ltyrian_http_Body$;
var $n_Ltyrian_http_Body$;
function $m_Ltyrian_http_Body$() {
  if ((!$n_Ltyrian_http_Body$)) {
    $n_Ltyrian_http_Body$ = new $c_Ltyrian_http_Body$()
  };
  return $n_Ltyrian_http_Body$
}
function $s_Ltyrian_http_HttpError$__Timeout__Ltyrian_http_HttpError() {
  $m_Ltyrian_http_HttpError$();
  return $t_Ltyrian_http_HttpError$__Timeout
}
function $s_Ltyrian_http_HttpError$__NetworkError__Ltyrian_http_HttpError() {
  $m_Ltyrian_http_HttpError$();
  return $t_Ltyrian_http_HttpError$__NetworkError
}
/** @constructor */
function $c_Ltyrian_http_HttpError$() {
  $n_Ltyrian_http_HttpError$ = this;
  $t_Ltyrian_http_HttpError$__Timeout = new $c_Ltyrian_http_HttpError$$anon$1();
  $t_Ltyrian_http_HttpError$__NetworkError = new $c_Ltyrian_http_HttpError$$anon$2()
}
$c_Ltyrian_http_HttpError$.prototype = new $h_O();
$c_Ltyrian_http_HttpError$.prototype.constructor = $c_Ltyrian_http_HttpError$;
/** @constructor */
function $h_Ltyrian_http_HttpError$() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError$.prototype = $c_Ltyrian_http_HttpError$.prototype;
$c_Ltyrian_http_HttpError$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ltyrian_http_HttpError(x);
  return x$0.ordinal__I()
});
var $d_Ltyrian_http_HttpError$ = new $TypeData().initClass({
  Ltyrian_http_HttpError$: 0
}, false, "tyrian.http.HttpError$", {
  Ltyrian_http_HttpError$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_http_HttpError$.prototype.$classData = $d_Ltyrian_http_HttpError$;
var $n_Ltyrian_http_HttpError$;
function $m_Ltyrian_http_HttpError$() {
  if ((!$n_Ltyrian_http_HttpError$)) {
    $n_Ltyrian_http_HttpError$ = new $c_Ltyrian_http_HttpError$()
  };
  return $n_Ltyrian_http_HttpError$
}
function $s_Ltyrian_http_Method$__Get__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Get
}
function $s_Ltyrian_http_Method$__Post__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Post
}
function $s_Ltyrian_http_Method$__Put__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Put
}
function $s_Ltyrian_http_Method$__Patch__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Patch
}
function $s_Ltyrian_http_Method$__Delete__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Delete
}
function $s_Ltyrian_http_Method$__Options__Ltyrian_http_Method() {
  $m_Ltyrian_http_Method$();
  return $t_Ltyrian_http_Method$__Options
}
/** @constructor */
function $c_Ltyrian_http_Method$() {
  this.Ltyrian_http_Method$__f_$values = null;
  this.Ltyrian_http_Method$__f_derived$CanEqual$lzy1 = null;
  this.Ltyrian_http_Method$__f_derived$CanEqualbitmap$1 = false;
  $n_Ltyrian_http_Method$ = this;
  $t_Ltyrian_http_Method$__Get = new $c_Ltyrian_http_Method$$anon$3(0, "Get");
  $t_Ltyrian_http_Method$__Post = new $c_Ltyrian_http_Method$$anon$3(1, "Post");
  $t_Ltyrian_http_Method$__Put = new $c_Ltyrian_http_Method$$anon$3(2, "Put");
  $t_Ltyrian_http_Method$__Patch = new $c_Ltyrian_http_Method$$anon$3(3, "Patch");
  $t_Ltyrian_http_Method$__Delete = new $c_Ltyrian_http_Method$$anon$3(4, "Delete");
  $t_Ltyrian_http_Method$__Options = new $c_Ltyrian_http_Method$$anon$3(5, "Options");
  this.Ltyrian_http_Method$__f_$values = new ($d_Ltyrian_http_Method.getArrayOf().constr)([$s_Ltyrian_http_Method$__Get__Ltyrian_http_Method(), $s_Ltyrian_http_Method$__Post__Ltyrian_http_Method(), $s_Ltyrian_http_Method$__Put__Ltyrian_http_Method(), $s_Ltyrian_http_Method$__Patch__Ltyrian_http_Method(), $s_Ltyrian_http_Method$__Delete__Ltyrian_http_Method(), $s_Ltyrian_http_Method$__Options__Ltyrian_http_Method()])
}
$c_Ltyrian_http_Method$.prototype = new $h_O();
$c_Ltyrian_http_Method$.prototype.constructor = $c_Ltyrian_http_Method$;
/** @constructor */
function $h_Ltyrian_http_Method$() {
  /*<skip>*/
}
$h_Ltyrian_http_Method$.prototype = $c_Ltyrian_http_Method$.prototype;
$c_Ltyrian_http_Method$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ltyrian_http_Method(x);
  return x$0.Ltyrian_http_Method$$anon$3__f__$ordinal$1
});
var $d_Ltyrian_http_Method$ = new $TypeData().initClass({
  Ltyrian_http_Method$: 0
}, false, "tyrian.http.Method$", {
  Ltyrian_http_Method$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_http_Method$.prototype.$classData = $d_Ltyrian_http_Method$;
var $n_Ltyrian_http_Method$;
function $m_Ltyrian_http_Method$() {
  if ((!$n_Ltyrian_http_Method$)) {
    $n_Ltyrian_http_Method$ = new $c_Ltyrian_http_Method$()
  };
  return $n_Ltyrian_http_Method$
}
/** @constructor */
function $c_Ltyrian_http_Request$() {
  /*<skip>*/
}
$c_Ltyrian_http_Request$.prototype = new $h_O();
$c_Ltyrian_http_Request$.prototype.constructor = $c_Ltyrian_http_Request$;
/** @constructor */
function $h_Ltyrian_http_Request$() {
  /*<skip>*/
}
$h_Ltyrian_http_Request$.prototype = $c_Ltyrian_http_Request$.prototype;
$c_Ltyrian_http_Request$.prototype.toString__T = (function() {
  return "Request"
});
$c_Ltyrian_http_Request$.prototype.get__T__F1__Ltyrian_http_Request = (function(url, decoder) {
  var method = $s_Ltyrian_http_Method$__Get__Ltyrian_http_Method();
  var headers = $m_s_package$().s_package$__f_Nil;
  var body = $s_Ltyrian_http_Body$__Empty__Ltyrian_http_Body();
  var expect = new $c_sjsr_AnonFunction1(((this$1, decoder$2) => ((r) => {
    var r$1 = $as_Ltyrian_http_Response(r);
    $m_Ltyrian_http_Http$Decoder$();
    return $as_s_util_Either(decoder$2.apply__O__O(r$1))
  }))(this, decoder));
  var timeout = $m_s_None$();
  return new $c_Ltyrian_http_Request(method, headers, url, body, expect, timeout, false)
});
var $d_Ltyrian_http_Request$ = new $TypeData().initClass({
  Ltyrian_http_Request$: 0
}, false, "tyrian.http.Request$", {
  Ltyrian_http_Request$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_http_Request$.prototype.$classData = $d_Ltyrian_http_Request$;
var $n_Ltyrian_http_Request$;
function $m_Ltyrian_http_Request$() {
  if ((!$n_Ltyrian_http_Request$)) {
    $n_Ltyrian_http_Request$ = new $c_Ltyrian_http_Request$()
  };
  return $n_Ltyrian_http_Request$
}
/** @constructor */
function $c_Ltyrian_websocket_KeepAliveSettings$() {
  /*<skip>*/
}
$c_Ltyrian_websocket_KeepAliveSettings$.prototype = new $h_O();
$c_Ltyrian_websocket_KeepAliveSettings$.prototype.constructor = $c_Ltyrian_websocket_KeepAliveSettings$;
/** @constructor */
function $h_Ltyrian_websocket_KeepAliveSettings$() {
  /*<skip>*/
}
$h_Ltyrian_websocket_KeepAliveSettings$.prototype = $c_Ltyrian_websocket_KeepAliveSettings$.prototype;
$c_Ltyrian_websocket_KeepAliveSettings$.prototype.toString__T = (function() {
  return "KeepAliveSettings"
});
$c_Ltyrian_websocket_KeepAliveSettings$.prototype.default__Ltyrian_websocket_KeepAliveSettings = (function() {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(20);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var timeout = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
  return new $c_Ltyrian_websocket_KeepAliveSettings(timeout)
});
var $d_Ltyrian_websocket_KeepAliveSettings$ = new $TypeData().initClass({
  Ltyrian_websocket_KeepAliveSettings$: 0
}, false, "tyrian.websocket.KeepAliveSettings$", {
  Ltyrian_websocket_KeepAliveSettings$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_websocket_KeepAliveSettings$.prototype.$classData = $d_Ltyrian_websocket_KeepAliveSettings$;
var $n_Ltyrian_websocket_KeepAliveSettings$;
function $m_Ltyrian_websocket_KeepAliveSettings$() {
  if ((!$n_Ltyrian_websocket_KeepAliveSettings$)) {
    $n_Ltyrian_websocket_KeepAliveSettings$ = new $c_Ltyrian_websocket_KeepAliveSettings$()
  };
  return $n_Ltyrian_websocket_KeepAliveSettings$
}
function $s_Ltyrian_websocket_WebSocketEvent$__Open__Ltyrian_websocket_WebSocketEvent() {
  $m_Ltyrian_websocket_WebSocketEvent$();
  return $t_Ltyrian_websocket_WebSocketEvent$__Open
}
function $s_Ltyrian_websocket_WebSocketEvent$__Heartbeat__Ltyrian_websocket_WebSocketEvent() {
  $m_Ltyrian_websocket_WebSocketEvent$();
  return $t_Ltyrian_websocket_WebSocketEvent$__Heartbeat
}
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent$() {
  this.Ltyrian_websocket_WebSocketEvent$__f_derived$CanEqual$lzy1 = null;
  this.Ltyrian_websocket_WebSocketEvent$__f_derived$CanEqualbitmap$1 = false;
  $n_Ltyrian_websocket_WebSocketEvent$ = this;
  $t_Ltyrian_websocket_WebSocketEvent$__Open = new $c_Ltyrian_websocket_WebSocketEvent$$anon$1(0, "Open");
  $t_Ltyrian_websocket_WebSocketEvent$__Heartbeat = new $c_Ltyrian_websocket_WebSocketEvent$$anon$1(4, "Heartbeat")
}
$c_Ltyrian_websocket_WebSocketEvent$.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocketEvent$.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent$;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent$() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent$.prototype = $c_Ltyrian_websocket_WebSocketEvent$.prototype;
$c_Ltyrian_websocket_WebSocketEvent$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ltyrian_websocket_WebSocketEvent(x);
  return x$0.ordinal__I()
});
var $d_Ltyrian_websocket_WebSocketEvent$ = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketEvent$: 0
}, false, "tyrian.websocket.WebSocketEvent$", {
  Ltyrian_websocket_WebSocketEvent$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_websocket_WebSocketEvent$.prototype.$classData = $d_Ltyrian_websocket_WebSocketEvent$;
var $n_Ltyrian_websocket_WebSocketEvent$;
function $m_Ltyrian_websocket_WebSocketEvent$() {
  if ((!$n_Ltyrian_websocket_WebSocketEvent$)) {
    $n_Ltyrian_websocket_WebSocketEvent$ = new $c_Ltyrian_websocket_WebSocketEvent$()
  };
  return $n_Ltyrian_websocket_WebSocketEvent$
}
function $s_Ltyrian_websocket_WebSocketReadyState$__CONNECTING__Ltyrian_websocket_WebSocketReadyState() {
  $m_Ltyrian_websocket_WebSocketReadyState$();
  return $t_Ltyrian_websocket_WebSocketReadyState$__CONNECTING
}
function $s_Ltyrian_websocket_WebSocketReadyState$__OPEN__Ltyrian_websocket_WebSocketReadyState() {
  $m_Ltyrian_websocket_WebSocketReadyState$();
  return $t_Ltyrian_websocket_WebSocketReadyState$__OPEN
}
function $s_Ltyrian_websocket_WebSocketReadyState$__CLOSING__Ltyrian_websocket_WebSocketReadyState() {
  $m_Ltyrian_websocket_WebSocketReadyState$();
  return $t_Ltyrian_websocket_WebSocketReadyState$__CLOSING
}
function $s_Ltyrian_websocket_WebSocketReadyState$__CLOSED__Ltyrian_websocket_WebSocketReadyState() {
  $m_Ltyrian_websocket_WebSocketReadyState$();
  return $t_Ltyrian_websocket_WebSocketReadyState$__CLOSED
}
/** @constructor */
function $c_Ltyrian_websocket_WebSocketReadyState$() {
  this.Ltyrian_websocket_WebSocketReadyState$__f_$values = null;
  this.Ltyrian_websocket_WebSocketReadyState$__f_derived$CanEqual$lzy1 = null;
  this.Ltyrian_websocket_WebSocketReadyState$__f_derived$CanEqualbitmap$1 = false;
  $n_Ltyrian_websocket_WebSocketReadyState$ = this;
  $t_Ltyrian_websocket_WebSocketReadyState$__CONNECTING = new $c_Ltyrian_websocket_WebSocketReadyState$$anon$1(0, "CONNECTING");
  $t_Ltyrian_websocket_WebSocketReadyState$__OPEN = new $c_Ltyrian_websocket_WebSocketReadyState$$anon$1(1, "OPEN");
  $t_Ltyrian_websocket_WebSocketReadyState$__CLOSING = new $c_Ltyrian_websocket_WebSocketReadyState$$anon$1(2, "CLOSING");
  $t_Ltyrian_websocket_WebSocketReadyState$__CLOSED = new $c_Ltyrian_websocket_WebSocketReadyState$$anon$1(3, "CLOSED");
  this.Ltyrian_websocket_WebSocketReadyState$__f_$values = new ($d_Ltyrian_websocket_WebSocketReadyState.getArrayOf().constr)([$s_Ltyrian_websocket_WebSocketReadyState$__CONNECTING__Ltyrian_websocket_WebSocketReadyState(), $s_Ltyrian_websocket_WebSocketReadyState$__OPEN__Ltyrian_websocket_WebSocketReadyState(), $s_Ltyrian_websocket_WebSocketReadyState$__CLOSING__Ltyrian_websocket_WebSocketReadyState(), $s_Ltyrian_websocket_WebSocketReadyState$__CLOSED__Ltyrian_websocket_WebSocketReadyState()])
}
$c_Ltyrian_websocket_WebSocketReadyState$.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocketReadyState$.prototype.constructor = $c_Ltyrian_websocket_WebSocketReadyState$;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketReadyState$() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketReadyState$.prototype = $c_Ltyrian_websocket_WebSocketReadyState$.prototype;
$c_Ltyrian_websocket_WebSocketReadyState$.prototype.fromInt__I__Ltyrian_websocket_WebSocketReadyState = (function(i) {
  switch (i) {
    case 0: {
      return $s_Ltyrian_websocket_WebSocketReadyState$__CONNECTING__Ltyrian_websocket_WebSocketReadyState();
      break
    }
    case 1: {
      return $s_Ltyrian_websocket_WebSocketReadyState$__OPEN__Ltyrian_websocket_WebSocketReadyState();
      break
    }
    case 2: {
      return $s_Ltyrian_websocket_WebSocketReadyState$__CLOSING__Ltyrian_websocket_WebSocketReadyState();
      break
    }
    case 3: {
      return $s_Ltyrian_websocket_WebSocketReadyState$__CLOSED__Ltyrian_websocket_WebSocketReadyState();
      break
    }
    default: {
      return $s_Ltyrian_websocket_WebSocketReadyState$__CLOSED__Ltyrian_websocket_WebSocketReadyState()
    }
  }
});
$c_Ltyrian_websocket_WebSocketReadyState$.prototype.ordinal__O__I = (function(x) {
  var x$0 = $as_Ltyrian_websocket_WebSocketReadyState(x);
  return x$0.Ltyrian_websocket_WebSocketReadyState$$anon$1__f__$ordinal$1
});
var $d_Ltyrian_websocket_WebSocketReadyState$ = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketReadyState$: 0
}, false, "tyrian.websocket.WebSocketReadyState$", {
  Ltyrian_websocket_WebSocketReadyState$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_websocket_WebSocketReadyState$.prototype.$classData = $d_Ltyrian_websocket_WebSocketReadyState$;
var $n_Ltyrian_websocket_WebSocketReadyState$;
function $m_Ltyrian_websocket_WebSocketReadyState$() {
  if ((!$n_Ltyrian_websocket_WebSocketReadyState$)) {
    $n_Ltyrian_websocket_WebSocketReadyState$ = new $c_Ltyrian_websocket_WebSocketReadyState$()
  };
  return $n_Ltyrian_websocket_WebSocketReadyState$
}
/** @constructor */
function $c_Lcats_Always(f) {
  this.Lcats_Always__f_f = null;
  this.Lcats_Always__f_f = f
}
$c_Lcats_Always.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Always.prototype.constructor = $c_Lcats_Always;
/** @constructor */
function $h_Lcats_Always() {
  /*<skip>*/
}
$h_Lcats_Always.prototype = $c_Lcats_Always.prototype;
$c_Lcats_Always.prototype.value__O = (function() {
  return this.Lcats_Always__f_f.apply__O()
});
var $d_Lcats_Always = new $TypeData().initClass({
  Lcats_Always: 0
}, false, "cats.Always", {
  Lcats_Always: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Always.prototype.$classData = $d_Lcats_Always;
function $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, m) {
  return new $c_sjsr_AnonFunction1(((this$1, m$2) => ((a) => {
    m$2.Lcats_Eval$Memoize__f_result = new $c_s_Some(a);
    return new $c_Lcats_Now(a)
  }))($thiz, m))
}
function $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O($thiz, curr, fs) {
  var fs$tailLocal1 = fs;
  var curr$tailLocal1 = curr;
  while (true) {
    var x52 = curr$tailLocal1;
    if ((x52 instanceof $c_Lcats_Eval$FlatMap)) {
      var c = $as_Lcats_Eval$FlatMap(x52);
      var x26 = $as_Lcats_Eval(c.start__F0().apply__O());
      if ((x26 instanceof $c_Lcats_Eval$FlatMap)) {
        var cc = $as_Lcats_Eval$FlatMap(x26);
        var first = c.run__F1();
        var rest = fs$tailLocal1;
        var nextFs = new $c_Lcats_Eval$Many(first, rest);
        var curr$tailLocal1$tmp1 = $as_Lcats_Eval(cc.start__F0().apply__O());
        var first$1 = cc.run__F1();
        var fs$tailLocal1$tmp1 = new $c_Lcats_Eval$Many(first$1, nextFs);
        curr$tailLocal1 = curr$tailLocal1$tmp1;
        fs$tailLocal1 = fs$tailLocal1$tmp1;
        continue
      };
      if ((x26 instanceof $c_Lcats_Eval$Defer)) {
        var call = $as_Lcats_Eval$Defer(x26);
        var curr$tailLocal1$tmp2 = $as_Lcats_Eval(call.Lcats_Eval$Defer__f_thunk.apply__O());
        var first$2 = c.run__F1();
        var rest$1 = fs$tailLocal1;
        var fs$tailLocal1$tmp2 = new $c_Lcats_Eval$Many(first$2, rest$1);
        curr$tailLocal1 = curr$tailLocal1$tmp2;
        fs$tailLocal1 = fs$tailLocal1$tmp2;
        continue
      };
      if (false) {
        var x28 = $as_Lcats_Eval$Memoize(x26);
        var x30 = x28.Lcats_Eval$Memoize__f_eval;
        var x23 = x28.Lcats_Eval$Memoize__f_result;
        if ((x23 instanceof $c_s_Some)) {
          var a = $as_s_Some(x23).s_Some__f_value;
          curr$tailLocal1 = $as_Lcats_Eval(c.run__F1().apply__O__O(a));
          continue
        };
        var x = $m_s_None$();
        if ((x === x23)) {
          var first$3 = c.run__F1();
          var rest$2 = fs$tailLocal1;
          var nextFs$2 = new $c_Lcats_Eval$Many(first$3, rest$2);
          var first$4 = $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, x28);
          var fs$tailLocal1$tmp3 = new $c_Lcats_Eval$Many(first$4, nextFs$2);
          curr$tailLocal1 = x30;
          fs$tailLocal1 = fs$tailLocal1$tmp3;
          continue
        };
        throw new $c_s_MatchError(x23)
      };
      if ((x26 instanceof $c_Lcats_Eval$Leaf)) {
        var xx = $as_Lcats_Eval$Leaf(x26);
        curr$tailLocal1 = $as_Lcats_Eval(c.run__F1().apply__O__O(xx.value__O()));
        continue
      };
      throw new $c_s_MatchError(x26)
    };
    if ((x52 instanceof $c_Lcats_Eval$Defer)) {
      var call$2 = $as_Lcats_Eval$Defer(x52);
      curr$tailLocal1 = $as_Lcats_Eval(call$2.Lcats_Eval$Defer__f_thunk.apply__O());
      continue
    };
    if (false) {
      var m = $as_Lcats_Eval$Memoize(x52);
      var x41 = m.Lcats_Eval$Memoize__f_result;
      if ((x41 instanceof $c_s_Some)) {
        var a$2 = $as_s_Some(x41).s_Some__f_value;
        var x33 = fs$tailLocal1;
        if ((x33 instanceof $c_Lcats_Eval$Many)) {
          var x$1 = $as_Lcats_Eval$Many(x33);
          var x39 = x$1.Lcats_Eval$Many__f_first;
          var x40 = x$1.Lcats_Eval$Many__f_rest;
          var curr$tailLocal1$tmp4 = $as_Lcats_Eval(x39.apply__O__O(a$2));
          curr$tailLocal1 = curr$tailLocal1$tmp4;
          fs$tailLocal1 = x40;
          continue
        };
        if ((x33 instanceof $c_Lcats_Eval$Ident)) {
          var x$1$1 = $as_Lcats_Eval$Ident(x33);
          return a$2
        };
        throw new $c_s_MatchError(x33)
      };
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        var curr$tailLocal1$tmp5 = m.Lcats_Eval$Memoize__f_eval;
        var first$5 = $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, m);
        var rest$3 = fs$tailLocal1;
        var fs$tailLocal1$tmp5 = new $c_Lcats_Eval$Many(first$5, rest$3);
        curr$tailLocal1 = curr$tailLocal1$tmp5;
        fs$tailLocal1 = fs$tailLocal1$tmp5;
        continue
      };
      throw new $c_s_MatchError(x41)
    };
    if ((x52 instanceof $c_Lcats_Eval$Leaf)) {
      var x$5 = $as_Lcats_Eval$Leaf(x52);
      var a1 = x$5.value__O();
      var x44 = fs$tailLocal1;
      if ((x44 instanceof $c_Lcats_Eval$Many)) {
        var x$1$2 = $as_Lcats_Eval$Many(x44);
        var x50 = x$1$2.Lcats_Eval$Many__f_first;
        var x51 = x$1$2.Lcats_Eval$Many__f_rest;
        var curr$tailLocal1$tmp6 = $as_Lcats_Eval(x50.apply__O__O(a1));
        curr$tailLocal1 = curr$tailLocal1$tmp6;
        fs$tailLocal1 = x51;
        continue
      };
      if ((x44 instanceof $c_Lcats_Eval$Ident)) {
        var x$1$3 = $as_Lcats_Eval$Ident(x44);
        return a1
      };
      throw new $c_s_MatchError(x44)
    };
    throw new $c_s_MatchError(x52)
  }
}
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_EvalInstances__f_catsDeferForEval = null;
  this.Lcats_EvalInstances__f_catsReducibleForEval = null;
  this.Lcats_EvalInstances__f_catsRepresentableForEval = null;
  this.Lcats_Eval$__f_Unit = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  this.Lcats_Eval$__f_Zero = null;
  this.Lcats_Eval$__f_One = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  this.Lcats_Eval$__f_Unit = new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
  this.Lcats_Eval$__f_Zero = new $c_Lcats_Now(0);
  this.Lcats_Eval$__f_One = new $c_Lcats_Now(1)
}
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
  /*<skip>*/
}
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
$c_Lcats_Eval$.prototype.later__F0__Lcats_Eval = (function(a) {
  return new $c_Lcats_Later(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => a$2.apply__O()))(this, a)))
});
$c_Lcats_Eval$.prototype.always__F0__Lcats_Eval = (function(a) {
  return new $c_Lcats_Always(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => a$2.apply__O()))(this, a)))
});
$c_Lcats_Eval$.prototype.cats$Eval$$$evaluate__Lcats_Eval__O = (function(e) {
  var this$1 = $m_s_$less$colon$less$();
  var e$1 = this$1.s_$less$colon$less$__f_singleton;
  return $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O(this, e, new $c_Lcats_Eval$Ident(e$1))
});
$c_Lcats_Eval$.prototype.cats$Eval$$$_$$anon$superArg$1$1__F0__F0 = (function(a$5) {
  return new $c_sjsr_AnonFunction0(((this$1, a$5$2) => (() => $as_Lcats_Eval(a$5$2.apply__O())))(this, a$5))
});
var $d_Lcats_Eval$ = new $TypeData().initClass({
  Lcats_Eval$: 0
}, false, "cats.Eval$", {
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1,
  O: 1
});
$c_Lcats_Eval$.prototype.$classData = $d_Lcats_Eval$;
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$()
  };
  return $n_Lcats_Eval$
}
/** @constructor */
function $c_Lcats_Eval$$anon$1(f$2$2, c$1) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_start = c$1.start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1(((this$1, f$2, c$1$2) => ((s) => new $c_Lcats_Eval$$anon$4(f$2, c$1$2, s, this$1)))(this, f$2$2, c$1))
}
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass({
  Lcats_Eval$$anon$1: 0
}, false, "cats.Eval$$anon$1", {
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$1.prototype.$classData = $d_Lcats_Eval$$anon$1;
/** @constructor */
function $c_Lcats_Eval$$anon$2(f$5, c$5) {
  this.Lcats_Eval$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$2__f_run = null;
  this.Lcats_Eval$$anon$2__f_start = c$5.Lcats_Eval$Defer__f_thunk;
  this.Lcats_Eval$$anon$2__f_run = f$5
}
$c_Lcats_Eval$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$2.prototype = $c_Lcats_Eval$$anon$2.prototype;
$c_Lcats_Eval$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$2__f_start
});
$c_Lcats_Eval$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$2__f_run
});
var $d_Lcats_Eval$$anon$2 = new $TypeData().initClass({
  Lcats_Eval$$anon$2: 0
}, false, "cats.Eval$$anon$2", {
  Lcats_Eval$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$2.prototype.$classData = $d_Lcats_Eval$$anon$2;
/** @constructor */
function $c_Lcats_Eval$$anon$3(f$6, outer) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_Eval$$anon$3__f_start = new $c_sjsr_AnonFunction0(((\u03b4outer) => (() => \u03b4outer))(outer));
  this.Lcats_Eval$$anon$3__f_run = f$6
}
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass({
  Lcats_Eval$$anon$3: 0
}, false, "cats.Eval$$anon$3", {
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$3.prototype.$classData = $d_Lcats_Eval$$anon$3;
/** @constructor */
function $c_Lcats_Eval$$anon$4(f$4, c$3$2, s$1$2, outer) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0(((c$3, s$1) => (() => $as_Lcats_Eval(c$3.run__F1().apply__O__O(s$1))))(c$3$2, s$1$2));
  this.Lcats_Eval$$anon$4__f_run = f$4
}
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass({
  Lcats_Eval$$anon$4: 0
}, false, "cats.Eval$$anon$4", {
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$4.prototype.$classData = $d_Lcats_Eval$$anon$4;
/** @constructor */
function $c_Lcats_Eval$$anon$5(a$7) {
  this.Lcats_Eval$Defer__f_thunk = null;
  $ct_Lcats_Eval$Defer__F0__(this, $m_Lcats_Eval$().cats$Eval$$$_$$anon$superArg$1$1__F0__F0(a$7))
}
$c_Lcats_Eval$$anon$5.prototype = new $h_Lcats_Eval$Defer();
$c_Lcats_Eval$$anon$5.prototype.constructor = $c_Lcats_Eval$$anon$5;
/** @constructor */
function $h_Lcats_Eval$$anon$5() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$5.prototype = $c_Lcats_Eval$$anon$5.prototype;
var $d_Lcats_Eval$$anon$5 = new $TypeData().initClass({
  Lcats_Eval$$anon$5: 0
}, false, "cats.Eval$$anon$5", {
  Lcats_Eval$$anon$5: 1,
  Lcats_Eval$Defer: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$5.prototype.$classData = $d_Lcats_Eval$$anon$5;
function $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O($thiz, fa, z, f, G) {
  var src = $m_Lcats_Foldable$Source$().fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source(fa, $thiz);
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, src), new $c_sjsr_AnonFunction1(((f$2, G$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = x$1$1._1__O();
      var src$1 = $as_Lcats_Foldable$Source(x$1$1._2__O());
      var x63 = src$1.uncons__s_Option();
      if ((x63 instanceof $c_s_Some)) {
        var x65 = $as_T2($as_s_Some(x63).s_Some__f_value);
        if ((x65 !== null)) {
          var a = x65._1__O();
          var src$2 = $as_Lcats_Eval(x65._2__O());
          return G$2.map__O__F1__O(f$2.apply__O__O__O(b, a), new $c_sjsr_AnonFunction1(((src$3) => ((b$2) => {
            $m_s_package$();
            var _2 = src$3.value__O();
            var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
            return new $c_s_util_Left(value)
          }))(src$2)))
        }
      };
      var x = $m_s_None$();
      if ((x === x63)) {
        return G$2.pure__O__O(($m_s_package$(), new $c_s_util_Right(b)))
      };
      throw new $c_s_MatchError(x63)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f, G)))
}
function $is_Lcats_Foldable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Foldable)))
}
function $as_Lcats_Foldable(obj) {
  return (($is_Lcats_Foldable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable"))
}
function $isArrayOf_Lcats_Foldable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable)))
}
function $asArrayOf_Lcats_Foldable(obj, depth) {
  return (($isArrayOf_Lcats_Foldable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable;", depth))
}
/** @constructor */
function $c_Lcats_Later(f) {
  this.Lcats_Later__f_thunk = null;
  this.Lcats_Later__f_value$lzy1 = null;
  this.Lcats_Later__f_valuebitmap$1 = false;
  this.Lcats_Later__f_thunk = f
}
$c_Lcats_Later.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Later.prototype.constructor = $c_Lcats_Later;
/** @constructor */
function $h_Lcats_Later() {
  /*<skip>*/
}
$h_Lcats_Later.prototype = $c_Lcats_Later.prototype;
$c_Lcats_Later.prototype.value__O = (function() {
  if ((!this.Lcats_Later__f_valuebitmap$1)) {
    var result = this.Lcats_Later__f_thunk.apply__O();
    this.Lcats_Later__f_thunk = null;
    this.Lcats_Later__f_value$lzy1 = result;
    this.Lcats_Later__f_valuebitmap$1 = true
  };
  return this.Lcats_Later__f_value$lzy1
});
var $d_Lcats_Later = new $TypeData().initClass({
  Lcats_Later: 0
}, false, "cats.Later", {
  Lcats_Later: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Later.prototype.$classData = $d_Lcats_Later;
/** @constructor */
function $c_Lcats_MonoidK$$anon$1(outer) {
  this.Lcats_MonoidK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_MonoidK$$anon$1__f_$outer = outer
}
$c_Lcats_MonoidK$$anon$1.prototype = new $h_O();
$c_Lcats_MonoidK$$anon$1.prototype.constructor = $c_Lcats_MonoidK$$anon$1;
/** @constructor */
function $h_Lcats_MonoidK$$anon$1() {
  /*<skip>*/
}
$h_Lcats_MonoidK$$anon$1.prototype = $c_Lcats_MonoidK$$anon$1.prototype;
$c_Lcats_MonoidK$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_MonoidK$$anon$1__f_$outer.empty__O()
});
$c_Lcats_MonoidK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.Lcats_MonoidK$$anon$1__f_$outer.combineK__O__O__O(x, y)
});
var $d_Lcats_MonoidK$$anon$1 = new $TypeData().initClass({
  Lcats_MonoidK$$anon$1: 0
}, false, "cats.MonoidK$$anon$1", {
  Lcats_MonoidK$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_MonoidK$$anon$1.prototype.$classData = $d_Lcats_MonoidK$$anon$1;
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$31$1) {
  this.Lcats_Parallel$$anon$2__f_monad = null;
  this.Lcats_Parallel$$anon$2__f_applicative = null;
  this.Lcats_Parallel$$anon$2__f_sequential = null;
  this.Lcats_Parallel$$anon$2__f_parallel = null;
  this.Lcats_Parallel$$anon$2__f_monad = evidence$31$1;
  this.Lcats_Parallel$$anon$2__f_applicative = evidence$31$1;
  this.Lcats_Parallel$$anon$2__f_sequential = new $c_Lcats_arrow_FunctionK$$anon$4();
  this.Lcats_Parallel$$anon$2__f_parallel = new $c_Lcats_arrow_FunctionK$$anon$4()
}
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass({
  Lcats_Parallel$$anon$2: 0
}, false, "cats.Parallel$$anon$2", {
  Lcats_Parallel$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
});
$c_Lcats_Parallel$$anon$2.prototype.$classData = $d_Lcats_Parallel$$anon$2;
/** @constructor */
function $c_Lcats_Show$$anon$1() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$1.prototype = new $h_O();
$c_Lcats_Show$$anon$1.prototype.constructor = $c_Lcats_Show$$anon$1;
/** @constructor */
function $h_Lcats_Show$$anon$1() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$1.prototype = $c_Lcats_Show$$anon$1.prototype;
var $d_Lcats_Show$$anon$1 = new $TypeData().initClass({
  Lcats_Show$$anon$1: 0
}, false, "cats.Show$$anon$1", {
  Lcats_Show$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1
});
$c_Lcats_Show$$anon$1.prototype.$classData = $d_Lcats_Show$$anon$1;
/** @constructor */
function $c_Lcats_Show$$anon$3(f$2) {
  this.Lcats_Show$$anon$3__f_f$1 = null;
  this.Lcats_Show$$anon$3__f_f$1 = f$2
}
$c_Lcats_Show$$anon$3.prototype = new $h_O();
$c_Lcats_Show$$anon$3.prototype.constructor = $c_Lcats_Show$$anon$3;
/** @constructor */
function $h_Lcats_Show$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$3.prototype = $c_Lcats_Show$$anon$3.prototype;
$c_Lcats_Show$$anon$3.prototype.show__O__T = (function(a) {
  return $as_T(this.Lcats_Show$$anon$3__f_f$1.apply__O__O(a))
});
var $d_Lcats_Show$$anon$3 = new $TypeData().initClass({
  Lcats_Show$$anon$3: 0
}, false, "cats.Show$$anon$3", {
  Lcats_Show$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
});
$c_Lcats_Show$$anon$3.prototype.$classData = $d_Lcats_Show$$anon$3;
/** @constructor */
function $c_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$4.prototype = new $h_O();
$c_Lcats_Show$$anon$4.prototype.constructor = $c_Lcats_Show$$anon$4;
/** @constructor */
function $h_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$4.prototype = $c_Lcats_Show$$anon$4.prototype;
$c_Lcats_Show$$anon$4.prototype.show__O__T = (function(a) {
  return $dp_toString__T(a)
});
var $d_Lcats_Show$$anon$4 = new $TypeData().initClass({
  Lcats_Show$$anon$4: 0
}, false, "cats.Show$$anon$4", {
  Lcats_Show$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
});
$c_Lcats_Show$$anon$4.prototype.$classData = $d_Lcats_Show$$anon$4;
/** @constructor */
function $c_Lcats_Show$Shown(toString) {
  this.Lcats_Show$Shown__f_toString = null;
  this.Lcats_Show$Shown__f_toString = toString
}
$c_Lcats_Show$Shown.prototype = new $h_O();
$c_Lcats_Show$Shown.prototype.constructor = $c_Lcats_Show$Shown;
/** @constructor */
function $h_Lcats_Show$Shown() {
  /*<skip>*/
}
$h_Lcats_Show$Shown.prototype = $c_Lcats_Show$Shown.prototype;
$c_Lcats_Show$Shown.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Show$Shown.prototype.hashCode__I = (function() {
  var this$ = this.Lcats_Show$Shown__f_toString;
  return $f_T__hashCode__I(this$)
});
$c_Lcats_Show$Shown.prototype.equals__O__Z = (function(x$0) {
  return $m_Lcats_Show$Shown$().equals$extension__T__O__Z(this.Lcats_Show$Shown__f_toString, x$0)
});
$c_Lcats_Show$Shown.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Show$Shown.prototype.productPrefix__T = (function() {
  return "Shown"
});
$c_Lcats_Show$Shown.prototype.productElement__I__O = (function(n) {
  return $m_Lcats_Show$Shown$().productElement$extension__T__I__O(this.Lcats_Show$Shown__f_toString, n)
});
$c_Lcats_Show$Shown.prototype.toString__T = (function() {
  return this.Lcats_Show$Shown__f_toString
});
function $as_Lcats_Show$Shown(obj) {
  return (((obj instanceof $c_Lcats_Show$Shown) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Show$Shown"))
}
function $isArrayOf_Lcats_Show$Shown(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Show$Shown)))
}
function $asArrayOf_Lcats_Show$Shown(obj, depth) {
  return (($isArrayOf_Lcats_Show$Shown(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Show$Shown;", depth))
}
var $d_Lcats_Show$Shown = new $TypeData().initClass({
  Lcats_Show$Shown: 0
}, false, "cats.Show$Shown", {
  Lcats_Show$Shown: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Show$Shown.prototype.$classData = $d_Lcats_Show$Shown;
function $p_Lcats_data_Chain$ChainIterator__go$1__O($thiz) {
  while (true) {
    if ((($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z())) {
      return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O()
    } else {
      $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
      var x147 = $thiz.Lcats_data_Chain$ChainIterator__f_c;
      if ((x147 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x147);
        var x157 = x$1.Lcats_data_Chain$Singleton__f_a;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $$x1 = null
        } else {
          var head = $as_Lcats_data_Chain$NonEmpty($thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O());
          var $$x1 = head
        };
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $$x1;
        return x157
      };
      if ((x147 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x147);
        var x153 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
        var x154 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
        $thiz.Lcats_data_Chain$ChainIterator__f_c = x153;
        var this$3 = $thiz.Lcats_data_Chain$ChainIterator__f_rights;
        $thiz.Lcats_data_Chain$ChainIterator__f_rights = new $c_sci_$colon$colon(x154, this$3);
        continue
      };
      if ((x147 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x147);
        var x150 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $$x2 = null
        } else {
          var head$2 = $as_Lcats_data_Chain$NonEmpty($thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O());
          var $$x2 = head$2
        };
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $$x2;
        $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = x150.iterator__sc_Iterator();
        return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O()
      };
      if ((x147 === null)) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next called on empty iterator")
      };
      throw new $c_s_MatchError(x147)
    }
  }
}
/** @constructor */
function $c_Lcats_data_Chain$ChainIterator(self) {
  this.Lcats_data_Chain$ChainIterator__f_c = null;
  this.Lcats_data_Chain$ChainIterator__f_rights = null;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
  this.Lcats_data_Chain$ChainIterator__f_c = self;
  this.Lcats_data_Chain$ChainIterator__f_rights = $m_s_package$().s_package$__f_Nil;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null
}
$c_Lcats_data_Chain$ChainIterator.prototype = new $h_O();
$c_Lcats_data_Chain$ChainIterator.prototype.constructor = $c_Lcats_data_Chain$ChainIterator;
/** @constructor */
function $h_Lcats_data_Chain$ChainIterator() {
  /*<skip>*/
}
$h_Lcats_data_Chain$ChainIterator.prototype = $c_Lcats_data_Chain$ChainIterator.prototype;
$c_Lcats_data_Chain$ChainIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lcats_data_Chain$ChainIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lcats_data_Chain$ChainIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_data_Chain$ChainIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_data_Chain$ChainIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lcats_data_Chain$ChainIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lcats_data_Chain$ChainIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lcats_data_Chain$ChainIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lcats_data_Chain$ChainIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lcats_data_Chain$ChainIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lcats_data_Chain$ChainIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lcats_data_Chain$ChainIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lcats_data_Chain$ChainIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lcats_data_Chain$ChainIterator.prototype.hasNext__Z = (function() {
  return ((this.Lcats_data_Chain$ChainIterator__f_c !== null) || ((this.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && this.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z()))
});
$c_Lcats_data_Chain$ChainIterator.prototype.next__O = (function() {
  return $p_Lcats_data_Chain$ChainIterator__go$1__O(this)
});
var $d_Lcats_data_Chain$ChainIterator = new $TypeData().initClass({
  Lcats_data_Chain$ChainIterator: 0
}, false, "cats.data.Chain$ChainIterator", {
  Lcats_data_Chain$ChainIterator: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lcats_data_Chain$ChainIterator.prototype.$classData = $d_Lcats_data_Chain$ChainIterator;
function $ct_Lcats_data_ChainInstances__($thiz) {
  $thiz.Lcats_data_ChainInstances__f_catsDataInstancesForChain = new $c_Lcats_data_ChainInstances$$anon$1();
  $thiz.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = new $c_Lcats_data_ChainInstances$$anon$2();
  return $thiz
}
function $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$1, f$18, as) {
  var x171 = as.uncons__s_Option();
  if ((x171 instanceof $c_s_Some)) {
    var x173 = $as_T2($as_s_Some(x171).s_Some__f_value);
    if ((x173 !== null)) {
      var h = x173._1__O();
      var t = $as_Lcats_data_Chain(x173._2__O());
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$18$2, t$2) => (() => $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$1$2, f$18$2, t$2)))(lb$1, f$18, t));
      return $as_Lcats_Eval(f$18.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)))
    }
  };
  var x = $m_s_None$();
  if ((x === x171)) {
    return lb$1
  };
  throw new $c_s_MatchError(x171)
}
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$1$$_$go$2__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f$22, rest, acc) {
  var acc$tailLocal2 = acc;
  var rest$tailLocal1 = rest;
  while (true) {
    var x191 = rest$tailLocal1;
    if ((x191 instanceof $c_sci_$colon$colon)) {
      var x192 = $as_sci_$colon$colon(x191);
      var x194 = x192.sci_$colon$colon__f_next;
      var hd = $as_Lcats_data_Chain(x192.sci_$colon$colon__f_head);
      var x186 = hd.uncons__s_Option();
      if ((x186 instanceof $c_s_Some)) {
        var x188 = $as_T2($as_s_Some(x186).s_Some__f_value);
        if ((x188 !== null)) {
          var hdh = $as_s_util_Either(x188._1__O());
          var hdt = $as_Lcats_data_Chain(x188._2__O());
          if ((hdh instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(hdh).s_util_Right__f_value;
            var rest$tailLocal1$tmp1 = new $c_sci_$colon$colon(hdt, x194);
            var this$1 = acc$tailLocal2;
            var acc$tailLocal2$tmp1 = this$1.append__O__Lcats_data_Chain(b);
            rest$tailLocal1 = rest$tailLocal1$tmp1;
            acc$tailLocal2 = acc$tailLocal2$tmp1;
            continue
          };
          if ((hdh instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(hdh).s_util_Left__f_value;
            var elem$3 = $as_Lcats_data_Chain(f$22.apply__O__O(a));
            var this$2 = new $c_sci_$colon$colon(hdt, x194);
            rest$tailLocal1 = new $c_sci_$colon$colon(elem$3, this$2);
            continue
          };
          throw new $c_s_MatchError(hdh)
        }
      };
      var x = $m_s_None$();
      if ((x === x186)) {
        rest$tailLocal1 = x194;
        continue
      };
      throw new $c_s_MatchError(x186)
    };
    return acc$tailLocal2
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = null
}
$c_Lcats_data_ChainInstances.prototype = new $h_Lcats_data_ChainInstances1();
$c_Lcats_data_ChainInstances.prototype.constructor = $c_Lcats_data_ChainInstances;
/** @constructor */
function $h_Lcats_data_ChainInstances() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances.prototype = $c_Lcats_data_ChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances$$anon$2.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$2.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances$$anon$2.prototype = $c_Lcats_data_ChainInstances$$anon$2.prototype;
var $d_Lcats_data_ChainInstances$$anon$2 = new $TypeData().initClass({
  Lcats_data_ChainInstances$$anon$2: 0
}, false, "cats.data.ChainInstances$$anon$2", {
  Lcats_data_ChainInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_data_ChainInstances$$anon$2.prototype.$classData = $d_Lcats_data_ChainInstances$$anon$2;
/** @constructor */
function $c_Lcats_data_Validated() {
  /*<skip>*/
}
$c_Lcats_data_Validated.prototype = new $h_O();
$c_Lcats_data_Validated.prototype.constructor = $c_Lcats_data_Validated;
/** @constructor */
function $h_Lcats_data_Validated() {
  /*<skip>*/
}
$h_Lcats_data_Validated.prototype = $c_Lcats_data_Validated.prototype;
$c_Lcats_data_Validated.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Validated.prototype.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(fb, EE) {
  var x198 = $ct_T2__O__O__(new $c_T2(), this, fb);
  var x217 = $as_Lcats_data_Validated(x198.T2__f__1);
  var x218 = $as_Lcats_data_Validated(x198.T2__f__2);
  if ((x217 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1 = $as_Lcats_data_Validated$Valid(x217);
    var x224 = x$1.Lcats_data_Validated$Valid__f_a;
    if ((x218 instanceof $c_Lcats_data_Validated$Valid)) {
      var x$1$1 = $as_Lcats_data_Validated$Valid(x218);
      var x221 = x$1$1.Lcats_data_Validated$Valid__f_a;
      var a = $ct_T2__O__O__(new $c_T2(), x224, x221);
      return new $c_Lcats_data_Validated$Valid(a)
    }
  };
  if ((x217 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x214 = $as_Lcats_data_Validated$Invalid(x217);
    var x216 = x214.Lcats_data_Validated$Invalid__f_e;
    if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x$1$2 = $as_Lcats_data_Validated$Invalid(x218);
      var x213 = x$1$2.Lcats_data_Validated$Invalid__f_e;
      var e = EE.combine__O__O__O(x216, x213);
      return new $c_Lcats_data_Validated$Invalid(e)
    };
    return x214
  };
  if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1$3 = $as_Lcats_data_Validated$Invalid(x218);
    var e$2 = $as_Lcats_data_Validated$Invalid(x218);
    return e$2
  };
  throw new $c_s_MatchError(x198)
});
$c_Lcats_data_Validated.prototype.map__F1__Lcats_data_Validated = (function(f) {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1 = $as_Lcats_data_Validated$Invalid(this);
    var i = $as_Lcats_data_Validated$Invalid(this);
    return i
  };
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1$1 = $as_Lcats_data_Validated$Valid(this);
    var x228 = x$1$1.Lcats_data_Validated$Valid__f_a;
    var a = f.apply__O__O(x228);
    return new $c_Lcats_data_Validated$Valid(a)
  };
  throw new $c_s_MatchError(this)
});
function $as_Lcats_data_Validated(obj) {
  return (((obj instanceof $c_Lcats_data_Validated) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated"))
}
function $isArrayOf_Lcats_data_Validated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated)))
}
function $asArrayOf_Lcats_data_Validated(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated;", depth))
}
/** @constructor */
function $c_Lcats_data_WriterT(run) {
  this.Lcats_data_WriterT__f_run = null;
  this.Lcats_data_WriterT__f_run = run
}
$c_Lcats_data_WriterT.prototype = new $h_O();
$c_Lcats_data_WriterT.prototype.constructor = $c_Lcats_data_WriterT;
/** @constructor */
function $h_Lcats_data_WriterT() {
  /*<skip>*/
}
$h_Lcats_data_WriterT.prototype = $c_Lcats_data_WriterT.prototype;
$c_Lcats_data_WriterT.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_WriterT.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_WriterT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_WriterT)) {
    var x$0$2 = $as_Lcats_data_WriterT(x$0);
    var x = this.Lcats_data_WriterT__f_run;
    var y = x$0$2.Lcats_data_WriterT__f_run;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_data_WriterT.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_WriterT.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_WriterT.prototype.productPrefix__T = (function() {
  return "WriterT"
});
$c_Lcats_data_WriterT.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_WriterT__f_run
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_data_WriterT.prototype.flatMap__F1__Lcats_FlatMap__Lcats_kernel_Semigroup__Lcats_data_WriterT = (function(f, flatMapF, semigroupL) {
  var run = flatMapF.flatMap__O__F1__O(this.Lcats_data_WriterT__f_run, new $c_sjsr_AnonFunction1(((f$2, flatMapF$2, semigroupL$2) => ((lv) => {
    var lv$1 = $as_T2(lv);
    return flatMapF$2.map__O__F1__O($as_Lcats_data_WriterT(f$2.apply__O__O(lv$1._2__O())).Lcats_data_WriterT__f_run, new $c_sjsr_AnonFunction1(((semigroupL$2$2, lv$2) => ((lv2) => {
      var lv2$1 = $as_T2(lv2);
      var _1 = semigroupL$2$2.combine__O__O__O(lv$2._1__O(), lv2$1._1__O());
      var _2 = lv2$1._2__O();
      return $ct_T2__O__O__(new $c_T2(), _1, _2)
    }))(semigroupL$2, lv$1)))
  }))(f, flatMapF, semigroupL)));
  return new $c_Lcats_data_WriterT(run)
});
function $as_Lcats_data_WriterT(obj) {
  return (((obj instanceof $c_Lcats_data_WriterT) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.WriterT"))
}
function $isArrayOf_Lcats_data_WriterT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_WriterT)))
}
function $asArrayOf_Lcats_data_WriterT(obj, depth) {
  return (($isArrayOf_Lcats_data_WriterT(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.WriterT;", depth))
}
var $d_Lcats_data_WriterT = new $TypeData().initClass({
  Lcats_data_WriterT: 0
}, false, "cats.data.WriterT", {
  Lcats_data_WriterT: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_WriterT.prototype.$classData = $d_Lcats_data_WriterT;
/** @constructor */
function $c_Lcats_data_WriterTInstances10() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances10.prototype = new $h_Lcats_data_WriterTInstances11();
$c_Lcats_data_WriterTInstances10.prototype.constructor = $c_Lcats_data_WriterTInstances10;
/** @constructor */
function $h_Lcats_data_WriterTInstances10() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances10.prototype = $c_Lcats_data_WriterTInstances10.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$2(outer) {
  this.Lcats_instances_Function1Instances$$anon$2__f_category = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var instance = outer.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice();
  this.Lcats_instances_Function1Instances$$anon$2__f_category = instance
}
$c_Lcats_instances_Function1Instances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$2.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$2;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$2.prototype = $c_Lcats_instances_Function1Instances$$anon$2.prototype;
$c_Lcats_instances_Function1Instances$$anon$2.prototype.combineK__F1__F1__F1 = (function(x, y) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen($as_F1(this.Lcats_instances_Function1Instances$$anon$2__f_category.compose__O__O__O(x, y)))
});
$c_Lcats_instances_Function1Instances$$anon$2.prototype.empty__O = (function() {
  var this$1 = this.Lcats_instances_Function1Instances$$anon$2__f_category;
  return $as_F1($f_Lcats_arrow_Arrow__id__O(this$1))
});
$c_Lcats_instances_Function1Instances$$anon$2.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__F1__F1__F1($as_F1(x), $as_F1(y))
});
$c_Lcats_instances_Function1Instances$$anon$2.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
var $d_Lcats_instances_Function1Instances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$2: 0
}, false, "cats.instances.Function1Instances$$anon$2", {
  Lcats_instances_Function1Instances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
});
$c_Lcats_instances_Function1Instances$$anon$2.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$2;
/** @constructor */
function $c_Lcats_instances_HashInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_HashInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_HashInstances$$anon$1.prototype.constructor = $c_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_HashInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_HashInstances$$anon$1.prototype = $c_Lcats_instances_HashInstances$$anon$1.prototype;
var $d_Lcats_instances_HashInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_HashInstances$$anon$1: 0
}, false, "cats.instances.HashInstances$$anon$1", {
  Lcats_instances_HashInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1
});
$c_Lcats_instances_HashInstances$$anon$1.prototype.$classData = $d_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(fa$15, fb$6) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$1 = fa$15;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fb$1 = fb$6
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$6() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$1.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fb$1.combine__O__O__O(x._2__O(), y._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$6", {
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$8(fa$5, fb$3) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1 = fa$5;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1 = fb$3;
  var self = fa$5.empty__O();
  var y = fb$3.empty__O();
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty = $ct_T2__O__O__(new $c_T2(), self, y)
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$8;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$8() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1.combine__O__O__O(x._2__O(), y._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.empty__O = (function() {
  return this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$8 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$8: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$8", {
  Lcats_instances_InvariantMonoidalInstances$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$8;
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V(new $c_Lcats_instances_LazyListInstances$$anon$1());
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_LazyListInstances$$anon$2($thiz))
}
function $ps_Lcats_instances_LazyListInstances__step$2__F2__Lcats_Monad__T2__O(f$8, G$3, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_LazyList(in$1._1__O());
      var b = in$1._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5
    };
    throw new $c_s_MatchError(in$1)
  };
  var s$2 = $as_sci_LazyList(\u03b41$___1);
  var b$2 = \u03b41$___2;
  return (s$2.isEmpty__Z() ? G$3.pure__O__O(($m_s_package$(), new $c_s_util_Right(b$2))) : G$3.map__O__F1__O(f$8.apply__O__O__O(b$2, s$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O()), new $c_sjsr_AnonFunction1(((s$3) => ((bnext) => {
    $m_s_package$();
    var _1 = s$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    var value = $ct_T2__O__O__(new $c_T2(), _1, bnext);
    return new $c_s_util_Left(value)
  }))(s$2))))
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$2(outer) {
  this.Lcats_instances_LazyListInstances$$anon$2__f_traverse = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_instances_LazyListInstances$$anon$2__f_traverse = $as_Lcats_Traverse(outer.catsStdInstancesForLazyList__Lcats_Align())
}
$c_Lcats_instances_LazyListInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$2.prototype = $c_Lcats_instances_LazyListInstances$$anon$2.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$2: 0
}, false, "cats.instances.LazyListInstances$$anon$2", {
  Lcats_instances_LazyListInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$2;
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__V(f$4, buf$1, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    matchResult2: {
      var x6 = lists$tailLocal1;
      if ((x6 instanceof $c_sci_$colon$colon)) {
        var x10 = $as_sci_$colon$colon(x6);
        var x11 = $as_sci_List(x10.sci_$colon$colon__f_head);
        var x12 = x10.sci_$colon$colon__f_next;
        if ((x11 instanceof $c_sci_$colon$colon)) {
          var x13 = $as_sci_$colon$colon(x11);
          var x15 = x13.sci_$colon$colon__f_next;
          var ab = $as_s_util_Either(x13.sci_$colon$colon__f_head);
          if ((ab instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(ab).s_util_Right__f_value;
            buf$1.addOne__O__scm_Growable(b);
            lists$tailLocal1 = new $c_sci_$colon$colon(x15, x12);
            continue
          };
          if ((ab instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(ab).s_util_Left__f_value;
            var elem$1 = $as_sci_List(f$4.apply__O__O(a));
            var this$1 = new $c_sci_$colon$colon(x15, x12);
            lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$1);
            continue
          };
          throw new $c_s_MatchError(ab);
          break matchResult2
        };
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (x11 === null) : x.equals__O__Z(x11))) {
          lists$tailLocal1 = x12;
          continue
        }
      };
      var x$3 = $m_s_package$().s_package$__f_Nil;
      if (((x$3 === null) ? (x6 === null) : x$3.equals__O__Z(x6))) {
        break matchResult2
      };
      throw new $c_s_MatchError(x6)
    };
    return (void 0)
  }
}
function $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, as) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (as === null) : x.equals__O__Z(as))) {
    return lb$1
  };
  if ((as instanceof $c_sci_$colon$colon)) {
    var x21 = $as_sci_$colon$colon(as);
    var x23 = x21.sci_$colon$colon__f_next;
    var h = x21.sci_$colon$colon__f_head;
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$6$2, t$2) => (() => $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1$2, f$6$2, t$2)))(lb$1, f$6, x23));
    return $as_Lcats_Eval(f$6.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)))
  };
  throw new $c_s_MatchError(as)
}
function $ps_Lcats_instances_ListInstances__step$2__F2__Lcats_Monad__T2__O(f$19, G$6, in$1) {
  if ((in$1 !== null)) {
    var x61 = $as_sci_List(in$1._1__O());
    var x62 = in$1._2__O();
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x61 === null) : x.equals__O__Z(x61))) {
      return G$6.pure__O__O(($m_s_package$(), new $c_s_util_Right(x62)))
    };
    if ((x61 instanceof $c_sci_$colon$colon)) {
      var x58 = $as_sci_$colon$colon(x61);
      var x60 = x58.sci_$colon$colon__f_next;
      var a = x58.sci_$colon$colon__f_head;
      return G$6.map__O__F1__O(f$19.apply__O__O__O(x62, a), new $c_sjsr_AnonFunction1(((tail$2) => ((bnext) => {
        $m_s_package$();
        var value = $ct_T2__O__O__(new $c_T2(), tail$2, bnext);
        return new $c_s_util_Left(value)
      }))(x60)))
    }
  };
  throw new $c_s_MatchError(in$1)
}
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_ListInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_ListInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)
}
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_ListInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.ListInstancesBinCompat0$$anon$1", {
  Lcats_instances_ListInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_ListInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_OptionInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_OptionInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption)
}
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OptionInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.OptionInstancesBinCompat0$$anon$1", {
  Lcats_instances_OptionInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_OptionInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var z = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1.partialCompare__O__O__D(x._1__O(), y._1__O());
  return ((z === 0.0) ? this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1.partialCompare__O__O__D(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_PartialOrderInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$2: 0
}, false, "cats.instances.PartialOrderInstances$$anon$2", {
  Lcats_instances_PartialOrderInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$4, fb$2) {
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fa$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fb$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fa$1 = fa$4;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fb$1 = fb$2
}
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$3: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$3", {
  Lcats_instances_PartialOrderingInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$3;
function $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__sci_Queue(f$4, bldr$1, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x9 = lists$tailLocal1;
    if ((x9 instanceof $c_sci_$colon$colon)) {
      var x10 = $as_sci_$colon$colon(x9);
      var x12 = x10.sci_$colon$colon__f_next;
      var q = $as_sci_Queue(x10.sci_$colon$colon__f_head);
      if (q.isEmpty__Z()) {
        lists$tailLocal1 = x12;
        continue
      } else {
        matchResult1: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x1 = q.dequeue__T2();
          if ((x1 !== null)) {
            var e = $as_s_util_Either(x1._1__O());
            var es = $as_sci_Queue(x1._2__O());
            var \u03b41$___1 = e;
            var \u03b41$___2 = es;
            break matchResult1
          };
          throw new $c_s_MatchError(x1)
        };
        var e$2 = $as_s_util_Either(\u03b41$___1);
        var es$2 = $as_sci_Queue(\u03b41$___2);
        if ((e$2 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(e$2).s_util_Right__f_value;
          bldr$1.addOne__O__scm_Growable(b);
          lists$tailLocal1 = new $c_sci_$colon$colon(es$2, x12);
          continue
        };
        if ((e$2 instanceof $c_s_util_Left)) {
          var a = $as_s_util_Left(e$2).s_util_Left__f_value;
          var elem$1 = $as_sci_Queue(f$4.apply__O__O(a));
          var this$2 = new $c_sci_$colon$colon(es$2, x12);
          lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$2);
          continue
        };
        throw new $c_s_MatchError(e$2)
      }
    };
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x9 === null) : x.equals__O__Z(x9))) {
      return $as_sci_Queue(bldr$1.result__O())
    };
    throw new $c_s_MatchError(x9)
  }
}
function $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, as) {
  if (as.isEmpty__Z()) {
    return lb$1
  } else {
    matchResult5: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x16 = as.dequeue__T2();
      if ((x16 !== null)) {
        var h = x16._1__O();
        var t = $as_sci_Queue(x16._2__O());
        var \u03b42$___1 = h;
        var \u03b42$___2 = t;
        break matchResult5
      };
      throw new $c_s_MatchError(x16)
    };
    var h$2 = \u03b42$___1;
    var t$2 = $as_sci_Queue(\u03b42$___2);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$6$2, t$3) => (() => $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1$2, f$6$2, t$3)))(lb$1, f$6, t$2));
    return $as_Lcats_Eval(f$6.apply__O__O__O(h$2, new $c_Lcats_Eval$$anon$5(a)))
  }
}
function $ps_Lcats_instances_QueueInstances__step$2__F2__Lcats_Monad__T2__O(f$10, G$1, in$1) {
  matchResult6: {
    var \u03b43$___1;
    var \u03b43$___2;
    if ((in$1 !== null)) {
      var xs = $as_sci_Queue(in$1._1__O());
      var b = in$1._2__O();
      var \u03b43$___1 = xs;
      var \u03b43$___2 = b;
      break matchResult6
    };
    throw new $c_s_MatchError(in$1)
  };
  var xs$2 = $as_sci_Queue(\u03b43$___1);
  var b$2 = \u03b43$___2;
  if (xs$2.isEmpty__Z()) {
    return G$1.pure__O__O(($m_s_package$(), new $c_s_util_Right(b$2)))
  } else {
    matchResult7: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x22 = xs$2.dequeue__T2();
      if ((x22 !== null)) {
        var a = x22._1__O();
        var tail = $as_sci_Queue(x22._2__O());
        var \u03b44$___1 = a;
        var \u03b44$___2 = tail;
        break matchResult7
      };
      throw new $c_s_MatchError(x22)
    };
    var a$2 = \u03b44$___1;
    var tail$2 = $as_sci_Queue(\u03b44$___2);
    return G$1.map__O__F1__O(f$10.apply__O__O__O(b$2, a$2), new $c_sjsr_AnonFunction1(((tail$3) => ((bnext) => {
      $m_s_package$();
      var value = $ct_T2__O__O__(new $c_T2(), tail$3, bnext);
      return new $c_s_util_Left(value)
    }))(tail$2)))
  }
}
function $f_Lcats_instances_SeqInstances__$init$__V($thiz) {
  $thiz.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V(new $c_Lcats_instances_SeqInstances$$anon$1());
  $thiz.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_SeqInstances$$anon$2())
}
function $ps_Lcats_instances_SeqInstances__loop$3__sci_Seq__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$1, f$5, i) {
  if ((i < fa$2.length__I())) {
    var $$x1 = fa$2.apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((fa$2$2, lb$1$2, f$5$2, i$2) => (() => $ps_Lcats_instances_SeqInstances__loop$3__sci_Seq__Lcats_Eval__F2__I__Lcats_Eval(fa$2$2, lb$1$2, f$5$2, ((1 + i$2) | 0))))(fa$2, lb$1, f$5, i));
    return $as_Lcats_Eval(f$5.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
  } else {
    return lb$1
  }
}
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$2() {
  this.Lcats_instances_SeqInstances$$anon$2__f_traverse = null;
  this.Lcats_instances_SeqInstances$$anon$2__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$seq$().Lcats_instances_package$seq$__f_catsStdInstancesForSeq)
}
$c_Lcats_instances_SeqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_SeqInstances$$anon$2.prototype = $c_Lcats_instances_SeqInstances$$anon$2.prototype;
var $d_Lcats_instances_SeqInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_SeqInstances$$anon$2: 0
}, false, "cats.instances.SeqInstances$$anon$2", {
  Lcats_instances_SeqInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_SeqInstances$$anon$2.prototype.$classData = $d_Lcats_instances_SeqInstances$$anon$2;
function $ps_Lcats_instances_StreamInstances__step$2__F2__Lcats_Monad__T2__O(f$8, G$3, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_Stream(in$1._1__O());
      var b = in$1._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5
    };
    throw new $c_s_MatchError(in$1)
  };
  var s$2 = $as_sci_Stream(\u03b41$___1);
  var b$2 = \u03b41$___2;
  return (s$2.isEmpty__Z() ? G$3.pure__O__O(($m_s_package$(), new $c_s_util_Right(b$2))) : G$3.map__O__F1__O(f$8.apply__O__O__O(b$2, s$2.head__O()), new $c_sjsr_AnonFunction1(((s$3) => ((bnext) => {
    $m_s_package$();
    var _1 = s$3.tail__sci_Stream();
    var value = $ct_T2__O__O__(new $c_T2(), _1, bnext);
    return new $c_s_util_Left(value)
  }))(s$2))))
}
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$4(a$2, fn$1) {
  this.Lcats_instances_StreamInstances$$anon$4__f_fn$1 = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_stack = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_state = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_fn$1 = fn$1;
  this.Lcats_instances_StreamInstances$$anon$4__f_stack = $as_sci_Stream(fn$1.apply__O__O(a$2));
  this.Lcats_instances_StreamInstances$$anon$4__f_state = ($m_s_package$(), new $c_s_util_Left((void 0)))
}
$c_Lcats_instances_StreamInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$4.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstances$$anon$4.prototype = $c_Lcats_instances_StreamInstances$$anon$4.prototype;
$c_Lcats_instances_StreamInstances$$anon$4.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.advance__V = (function() {
  var this$ = this;
  while (true) {
    matchResult1: {
      var x1 = this$.Lcats_instances_StreamInstances$$anon$4__f_stack;
      if ((x1 !== null)) {
        var x8 = $m_s_package$$hash$colon$colon$().unapply__sci_Stream__s_Option(x1);
        if ((!x8.isEmpty__Z())) {
          var x9 = $as_T2(x8.get__O());
          var x10 = $as_s_util_Either(x9._1__O());
          var x11 = $as_sci_Stream(x9._2__O());
          if ((x10 instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(x10).s_util_Right__f_value;
            this$.Lcats_instances_StreamInstances$$anon$4__f_stack = x11;
            var $$x1 = this$;
            $m_s_package$();
            var value = new $c_s_Some(b);
            $$x1.Lcats_instances_StreamInstances$$anon$4__f_state = new $c_s_util_Right(value);
            break matchResult1
          };
          if ((x10 instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(x10).s_util_Left__f_value;
            var $$x2 = this$;
            var prefix$1 = $as_sci_Stream(this.Lcats_instances_StreamInstances$$anon$4__f_fn$1.apply__O__O(a));
            var l = new $c_sjsr_AnonFunction0(((tail$3) => (() => tail$3))(x11));
            $$x2.Lcats_instances_StreamInstances$$anon$4__f_stack = prefix$1.lazyAppendedAll__F0__sci_Stream(l);
            this$ = this$;
            continue
          }
        }
      };
      var $$x3 = this$;
      $m_s_package$();
      var value$1 = $m_s_None$();
      $$x3.Lcats_instances_StreamInstances$$anon$4__f_state = new $c_s_util_Right(value$1)
    };
    return (void 0)
  }
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.hasNext__Z = (function() {
  var this$ = this;
  while (true) {
    var x14 = this$.Lcats_instances_StreamInstances$$anon$4__f_state;
    if ((x14 instanceof $c_s_util_Left)) {
      var x$2 = $as_s_util_Left(x14).s_util_Left__f_value;
      var $$x1 = (x$2 === (void 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this$.advance__V();
      this$ = this$;
      continue
    };
    if ((x14 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($as_s_util_Right(x14).s_util_Right__f_value);
      return (!o.isEmpty__Z())
    };
    throw new $c_s_MatchError(x14)
  }
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.next__O = (function() {
  var this$ = this;
  while (true) {
    var x19 = this$.Lcats_instances_StreamInstances$$anon$4__f_state;
    if ((x19 instanceof $c_s_util_Left)) {
      var x$2 = $as_s_util_Left(x19).s_util_Left__f_value;
      var $$x1 = (x$2 === (void 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this$.advance__V();
      this$ = this$;
      continue
    };
    if ((x19 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($as_s_util_Right(x19).s_util_Right__f_value);
      var b = o.get__O();
      this$.advance__V();
      return b
    };
    throw new $c_s_MatchError(x19)
  }
});
var $d_Lcats_instances_StreamInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_StreamInstances$$anon$4: 0
}, false, "cats.instances.StreamInstances$$anon$4", {
  Lcats_instances_StreamInstances$$anon$4: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.$classData = $d_Lcats_instances_StreamInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_StreamInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_StreamInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$stream$().Lcats_instances_package$stream$__f_catsStdInstancesForStream)
}
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_StreamInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.StreamInstancesBinCompat0$$anon$1", {
  Lcats_instances_StreamInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_StreamInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype;
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.map__T2__F1__T2 = (function(fa, f) {
  var _1 = f.apply__O__O(fa._1__O());
  var _2 = f.apply__O__O(fa._2__O());
  return $ct_T2__O__O__(new $c_T2(), _1, _2)
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__T2__F1__T2($as_T2(fa), f)
});
var $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.Tuple2InstancesBinCompat0$$anon$1", {
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1;
function $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$1, f$5, i) {
  if ((i < fa$2.length__I())) {
    var $$x1 = fa$2.apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((fa$2$2, lb$1$2, f$5$2, i$2) => (() => $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2$2, lb$1$2, f$5$2, ((1 + i$2) | 0))))(fa$2, lb$1, f$5, i));
    return $as_Lcats_Eval(f$5.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
  } else {
    return lb$1
  }
}
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_VectorInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_VectorInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector)
}
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_VectorInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.VectorInstancesBinCompat0$$anon$1", {
  Lcats_instances_VectorInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_VectorInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1()
}
$c_Lcats_instances_package$eq$.prototype = new $h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
  /*<skip>*/
}
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
var $d_Lcats_instances_package$eq$ = new $TypeData().initClass({
  Lcats_instances_package$eq$: 0
}, false, "cats.instances.package$eq$", {
  Lcats_instances_package$eq$: 1,
  O: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1
});
$c_Lcats_instances_package$eq$.prototype.$classData = $d_Lcats_instances_package$eq$;
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$()
  };
  return $n_Lcats_instances_package$eq$
}
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForNumeric = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForIntegral = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForFractional = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_InvariantInstances__$init$__V(this);
  this.Lcats_instances_package$invariant$__f_catsInvariantForFractional = new $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$invariant$.prototype = new $h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
  /*<skip>*/
}
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$0
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$0
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantForNumeric = x$0
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantForIntegral = x$0
});
var $d_Lcats_instances_package$invariant$ = new $TypeData().initClass({
  Lcats_instances_package$invariant$: 0
}, false, "cats.instances.package$invariant$", {
  Lcats_instances_package$invariant$: 1,
  O: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_InvariantInstancesBinCompat0: 1
});
$c_Lcats_instances_package$invariant$.prototype.$classData = $d_Lcats_instances_package$invariant$;
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$()
  };
  return $n_Lcats_instances_package$invariant$
}
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1()
}
$c_Lcats_instances_package$order$.prototype = new $h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
  /*<skip>*/
}
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
var $d_Lcats_instances_package$order$ = new $TypeData().initClass({
  Lcats_instances_package$order$: 0
}, false, "cats.instances.package$order$", {
  Lcats_instances_package$order$: 1,
  O: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1
});
$c_Lcats_instances_package$order$.prototype.$classData = $d_Lcats_instances_package$order$;
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$()
  };
  return $n_Lcats_instances_package$order$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1()
}
$c_Lcats_instances_package$partialOrder$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
var $d_Lcats_instances_package$partialOrder$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrder$: 0
}, false, "cats.instances.package$partialOrder$", {
  Lcats_instances_package$partialOrder$: 1,
  O: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1
});
$c_Lcats_instances_package$partialOrder$.prototype.$classData = $d_Lcats_instances_package$partialOrder$;
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$()
  };
  return $n_Lcats_instances_package$partialOrder$
}
function $ct_Lcats_kernel_Comparison__I__D__($thiz, toInt, toDouble) {
  $thiz.Lcats_kernel_Comparison__f_toInt = toInt;
  $thiz.Lcats_kernel_Comparison__f_toDouble = toDouble;
  return $thiz
}
/** @constructor */
function $c_Lcats_kernel_Comparison() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0
}
$c_Lcats_kernel_Comparison.prototype = new $h_O();
$c_Lcats_kernel_Comparison.prototype.constructor = $c_Lcats_kernel_Comparison;
/** @constructor */
function $h_Lcats_kernel_Comparison() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison.prototype = $c_Lcats_kernel_Comparison.prototype;
$c_Lcats_kernel_Comparison.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lcats_kernel_Comparison(obj) {
  return (((obj instanceof $c_Lcats_kernel_Comparison) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Comparison"))
}
function $isArrayOf_Lcats_kernel_Comparison(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Comparison)))
}
function $asArrayOf_Lcats_kernel_Comparison(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Comparison(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Comparison;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Group$() {
  /*<skip>*/
}
$c_Lcats_kernel_Group$.prototype = new $h_Lcats_kernel_GroupFunctions();
$c_Lcats_kernel_Group$.prototype.constructor = $c_Lcats_kernel_Group$;
/** @constructor */
function $h_Lcats_kernel_Group$() {
  /*<skip>*/
}
$h_Lcats_kernel_Group$.prototype = $c_Lcats_kernel_Group$.prototype;
var $d_Lcats_kernel_Group$ = new $TypeData().initClass({
  Lcats_kernel_Group$: 0
}, false, "cats.kernel.Group$", {
  Lcats_kernel_Group$: 1,
  Lcats_kernel_GroupFunctions: 1,
  Lcats_kernel_MonoidFunctions: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Group$.prototype.$classData = $d_Lcats_kernel_Group$;
var $n_Lcats_kernel_Group$;
function $m_Lcats_kernel_Group$() {
  if ((!$n_Lcats_kernel_Group$)) {
    $n_Lcats_kernel_Group$ = new $c_Lcats_kernel_Group$()
  };
  return $n_Lcats_kernel_Group$
}
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$3() {
  /*<skip>*/
}
$c_Lcats_kernel_Hash$$anon$3.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$3.prototype.constructor = $c_Lcats_kernel_Hash$$anon$3;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$3() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$$anon$3.prototype = $c_Lcats_kernel_Hash$$anon$3.prototype;
$c_Lcats_kernel_Hash$$anon$3.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Hash$$anon$3.prototype.hash__O__I = (function(x) {
  return $dp_hashCode__I(x)
});
$c_Lcats_kernel_Hash$$anon$3.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
});
var $d_Lcats_kernel_Hash$$anon$3 = new $TypeData().initClass({
  Lcats_kernel_Hash$$anon$3: 0
}, false, "cats.kernel.Hash$$anon$3", {
  Lcats_kernel_Hash$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_Hash$$anon$3.prototype.$classData = $d_Lcats_kernel_Hash$$anon$3;
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y)
}
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $f_Lcats_kernel_Order__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y))
}
function $is_Lcats_kernel_Order(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Order)))
}
function $as_Lcats_kernel_Order(obj) {
  return (($is_Lcats_kernel_Order(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Order"))
}
function $isArrayOf_Lcats_kernel_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Order)))
}
function $asArrayOf_Lcats_kernel_Order(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Order;", depth))
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass({
  Lcats_kernel_PartialOrder$: 0
}, false, "cats.kernel.PartialOrder$", {
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
});
$c_Lcats_kernel_PartialOrder$.prototype.$classData = $d_Lcats_kernel_PartialOrder$;
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$()
  };
  return $n_Lcats_kernel_PartialOrder$
}
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LazyListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LazyListMonoid.prototype = $c_Lcats_kernel_instances_LazyListMonoid.prototype;
$c_Lcats_kernel_instances_LazyListMonoid.prototype.empty__O = (function() {
  return $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_LazyList(x);
  var y$1 = $as_sci_LazyList(y);
  return x$1.appendedAll__sc_IterableOnce__sci_LazyList(y$1)
});
var $d_Lcats_kernel_instances_LazyListMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_LazyListMonoid: 0
}, false, "cats.kernel.instances.LazyListMonoid", {
  Lcats_kernel_instances_LazyListMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.$classData = $d_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ListMonoid.prototype = $c_Lcats_kernel_instances_ListMonoid.prototype;
$c_Lcats_kernel_instances_ListMonoid.prototype.empty__O = (function() {
  return $m_s_package$().s_package$__f_Nil
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return y$1.$colon$colon$colon__sci_List__sci_List(x$1)
});
var $d_Lcats_kernel_instances_ListMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_ListMonoid: 0
}, false, "cats.kernel.instances.ListMonoid", {
  Lcats_kernel_instances_ListMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_ListMonoid.prototype.$classData = $d_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_QueueMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_QueueMonoid.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_QueueMonoid.prototype = $c_Lcats_kernel_instances_QueueMonoid.prototype;
$c_Lcats_kernel_instances_QueueMonoid.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  return x$1.appendedAll__sc_IterableOnce__sci_Queue(y$1)
});
var $d_Lcats_kernel_instances_QueueMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_QueueMonoid: 0
}, false, "cats.kernel.instances.QueueMonoid", {
  Lcats_kernel_instances_QueueMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.$classData = $d_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_SeqMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_SeqMonoid.prototype = $c_Lcats_kernel_instances_SeqMonoid.prototype;
$c_Lcats_kernel_instances_SeqMonoid.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps())
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  return $as_sci_Seq(x$1.appendedAll__sc_IterableOnce__O(y$1))
});
var $d_Lcats_kernel_instances_SeqMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_SeqMonoid: 0
}, false, "cats.kernel.instances.SeqMonoid", {
  Lcats_kernel_instances_SeqMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.$classData = $d_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_StreamMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StreamMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StreamMonoid.prototype.constructor = $c_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StreamMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StreamMonoid.prototype = $c_Lcats_kernel_instances_StreamMonoid.prototype;
$c_Lcats_kernel_instances_StreamMonoid.prototype.empty__O = (function() {
  $m_s_package$();
  return $m_sci_Stream$Empty$()
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Stream(x);
  var y$1 = $as_sci_Stream(y);
  return $as_sci_Stream($f_sc_IterableOps__concat__sc_IterableOnce__O(x$1, y$1))
});
var $d_Lcats_kernel_instances_StreamMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_StreamMonoid: 0
}, false, "cats.kernel.instances.StreamMonoid", {
  Lcats_kernel_instances_StreamMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.$classData = $d_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y)
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return ""
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T($as_T(x), $as_T(y))
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_StringMonoid: 0
}, false, "cats.kernel.instances.StringMonoid", {
  Lcats_kernel_instances_StringMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_StringMonoid.prototype.$classData = $d_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_VectorMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_VectorMonoid.prototype = $c_Lcats_kernel_instances_VectorMonoid.prototype;
$c_Lcats_kernel_instances_VectorMonoid.prototype.empty__O = (function() {
  $m_s_package$();
  return $m_sci_Vector0$()
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  return x$1.appendedAll__sc_IterableOnce__sci_Vector(y$1)
});
var $d_Lcats_kernel_instances_VectorMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_VectorMonoid: 0
}, false, "cats.kernel.instances.VectorMonoid", {
  Lcats_kernel_instances_VectorMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.$classData = $d_Lcats_kernel_instances_VectorMonoid;
class $c_Ldiffson_PointerException extends $c_jl_Exception {
  constructor(msg) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true)
  };
}
var $d_Ldiffson_PointerException = new $TypeData().initClass({
  Ldiffson_PointerException: 0
}, false, "diffson.PointerException", {
  Ldiffson_PointerException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_PointerException.prototype.$classData = $d_Ldiffson_PointerException;
/** @constructor */
function $c_Ldiffson_jsonpatch_JsonPatch(ops, evidence$8) {
  this.Ldiffson_jsonpatch_JsonPatch__f_ops = null;
  this.Ldiffson_jsonpatch_JsonPatch__f_ops = ops
}
$c_Ldiffson_jsonpatch_JsonPatch.prototype = new $h_O();
$c_Ldiffson_jsonpatch_JsonPatch.prototype.constructor = $c_Ldiffson_jsonpatch_JsonPatch;
/** @constructor */
function $h_Ldiffson_jsonpatch_JsonPatch() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_JsonPatch.prototype = $c_Ldiffson_jsonpatch_JsonPatch.prototype;
$c_Ldiffson_jsonpatch_JsonPatch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_JsonPatch)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_JsonPatch(x$0);
    var x = this.Ldiffson_jsonpatch_JsonPatch__f_ops;
    var x$2 = x$0$2.Ldiffson_jsonpatch_JsonPatch__f_ops;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.productPrefix__T = (function() {
  return "JsonPatch"
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldiffson_jsonpatch_JsonPatch__f_ops
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.apply__O__Lcats_MonadError__O = (function(json, F) {
  $m_Lcats_implicits$();
  var target = this.Ldiffson_jsonpatch_JsonPatch__f_ops;
  var tc = $as_Lcats_Foldable($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
  var this$2 = new $c_Lcats_Foldable$$anon$6(target, tc);
  var f = new $c_sjsr_AnonFunction2(((F$2) => ((json$2, op) => {
    var op$1 = $as_Ldiffson_jsonpatch_Operation(op);
    return op$1.apply__O__Lcats_MonadError__O(json$2, F$2)
  }))(F));
  return this$2.Lcats_Foldable$$anon$6__f_typeClassInstance.foldM__O__O__F2__Lcats_Monad__O(this$2.Lcats_Foldable$$anon$6__f_self, json, f, F)
});
function $as_Ldiffson_jsonpatch_JsonPatch(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_JsonPatch) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.JsonPatch"))
}
function $isArrayOf_Ldiffson_jsonpatch_JsonPatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_JsonPatch)))
}
function $asArrayOf_Ldiffson_jsonpatch_JsonPatch(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_JsonPatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.JsonPatch;", depth))
}
var $d_Ldiffson_jsonpatch_JsonPatch = new $TypeData().initClass({
  Ldiffson_jsonpatch_JsonPatch: 0
}, false, "diffson.jsonpatch.JsonPatch", {
  Ldiffson_jsonpatch_JsonPatch: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_JsonPatch.prototype.$classData = $d_Ldiffson_jsonpatch_JsonPatch;
/** @constructor */
function $c_Ldiffson_jsonpointer_package$Pointer(parts) {
  this.Ldiffson_jsonpointer_package$Pointer__f_parts = null;
  this.Ldiffson_jsonpointer_package$Pointer__f_parts = parts
}
$c_Ldiffson_jsonpointer_package$Pointer.prototype = new $h_O();
$c_Ldiffson_jsonpointer_package$Pointer.prototype.constructor = $c_Ldiffson_jsonpointer_package$Pointer;
/** @constructor */
function $h_Ldiffson_jsonpointer_package$Pointer() {
  /*<skip>*/
}
$h_Ldiffson_jsonpointer_package$Pointer.prototype = $c_Ldiffson_jsonpointer_package$Pointer.prototype;
$c_Ldiffson_jsonpointer_package$Pointer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.hashCode__I = (function() {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  var this$ = this.Ldiffson_jsonpointer_package$Pointer__f_parts;
  return this$.hashCode__I()
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.equals__O__Z = (function(x$0) {
  return $m_Ldiffson_jsonpointer_package$Pointer$().equals$extension__Lcats_data_Chain__O__Z(this.Ldiffson_jsonpointer_package$Pointer__f_parts, x$0)
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.toString__T = (function() {
  return $m_Ldiffson_jsonpointer_package$Pointer$().toString$extension__Lcats_data_Chain__T(this.Ldiffson_jsonpointer_package$Pointer__f_parts)
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.productArity__I = (function() {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  return 1
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.productPrefix__T = (function() {
  $m_Ldiffson_jsonpointer_package$Pointer$();
  return "Pointer"
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.productElement__I__O = (function(n) {
  return $m_Ldiffson_jsonpointer_package$Pointer$().productElement$extension__Lcats_data_Chain__I__O(this.Ldiffson_jsonpointer_package$Pointer__f_parts, n)
});
function $as_Ldiffson_jsonpointer_package$Pointer(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpointer_package$Pointer) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpointer.package$Pointer"))
}
function $isArrayOf_Ldiffson_jsonpointer_package$Pointer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpointer_package$Pointer)))
}
function $asArrayOf_Ldiffson_jsonpointer_package$Pointer(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpointer_package$Pointer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpointer.package$Pointer;", depth))
}
var $d_Ldiffson_jsonpointer_package$Pointer = new $TypeData().initClass({
  Ldiffson_jsonpointer_package$Pointer: 0
}, false, "diffson.jsonpointer.package$Pointer", {
  Ldiffson_jsonpointer_package$Pointer: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpointer_package$Pointer.prototype.$classData = $d_Ldiffson_jsonpointer_package$Pointer;
/** @constructor */
function $c_Lio_circe_CursorOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp.prototype = new $h_O();
$c_Lio_circe_CursorOp.prototype.constructor = $c_Lio_circe_CursorOp;
/** @constructor */
function $h_Lio_circe_CursorOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp.prototype = $c_Lio_circe_CursorOp.prototype;
$c_Lio_circe_CursorOp.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lio_circe_CursorOp(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp"))
}
function $isArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp)))
}
function $asArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp;", depth))
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$23() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Float")
}
$c_Lio_circe_Decoder$$anon$23.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$23.prototype.constructor = $c_Lio_circe_Decoder$$anon$23;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$23() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$23.prototype = $c_Lio_circe_Decoder$$anon$23.prototype;
$c_Lio_circe_Decoder$$anon$23.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x184 = c.value__Lio_circe_Json();
  if ((x184 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x184);
    var x190 = x$1.Lio_circe_Json$JNumber__f_value;
    $m_s_package$();
    var value = x190.toFloat__F();
    return new $c_s_util_Right(value)
  };
  if ((x184 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x184);
    var x187 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x187);
    if (this$4.isEmpty__Z()) {
      var x181 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$8 = $as_Lio_circe_JsonNumber(arg1);
      var x181 = new $c_s_Some(_$8.toFloat__F())
    };
    if ((x181 instanceof $c_s_Some)) {
      var v = $uF($as_s_Some(x181).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x181)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x181)
  };
  if (x184.isNull__Z()) {
    $m_s_package$();
    return new $c_s_util_Right((NaN))
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$23 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$23: 0
}, false, "io.circe.Decoder$$anon$23", {
  Lio_circe_Decoder$$anon$23: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$23.prototype.$classData = $d_Lio_circe_Decoder$$anon$23;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$24() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Double")
}
$c_Lio_circe_Decoder$$anon$24.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$24.prototype.constructor = $c_Lio_circe_Decoder$$anon$24;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$24() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$24.prototype = $c_Lio_circe_Decoder$$anon$24.prototype;
$c_Lio_circe_Decoder$$anon$24.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x194 = c.value__Lio_circe_Json();
  if ((x194 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x194);
    var x200 = x$1.Lio_circe_Json$JNumber__f_value;
    $m_s_package$();
    var value = x200.toDouble__D();
    return new $c_s_util_Right(value)
  };
  if ((x194 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x194);
    var x197 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x197);
    if (this$4.isEmpty__Z()) {
      var x191 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$9 = $as_Lio_circe_JsonNumber(arg1);
      var x191 = new $c_s_Some(_$9.toDouble__D())
    };
    if ((x191 instanceof $c_s_Some)) {
      var v = $uD($as_s_Some(x191).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x191)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x191)
  };
  if (x194.isNull__Z()) {
    $m_s_package$();
    return new $c_s_util_Right((NaN))
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$24 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$24: 0
}, false, "io.circe.Decoder$$anon$24", {
  Lio_circe_Decoder$$anon$24: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$24.prototype.$classData = $d_Lio_circe_Decoder$$anon$24;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$25() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Byte")
}
$c_Lio_circe_Decoder$$anon$25.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$25.prototype.constructor = $c_Lio_circe_Decoder$$anon$25;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$25() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$25.prototype = $c_Lio_circe_Decoder$$anon$25.prototype;
$c_Lio_circe_Decoder$$anon$25.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x207 = c.value__Lio_circe_Json();
  if ((x207 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x207);
    var x213 = x$1.Lio_circe_Json$JNumber__f_value;
    var x201 = x213.toByte__s_Option();
    if ((x201 instanceof $c_s_Some)) {
      var v = $uB($as_s_Some(x201).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x201)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x201)
  };
  if ((x207 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x207);
    var x210 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x210);
    if (this$4.isEmpty__Z()) {
      var x204 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$10 = $as_Lio_circe_JsonNumber(arg1);
      var x204 = _$10.toByte__s_Option()
    };
    if ((x204 instanceof $c_s_Some)) {
      var value = $uB($as_s_Some(x204).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(value)
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x204)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x204)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$25 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$25: 0
}, false, "io.circe.Decoder$$anon$25", {
  Lio_circe_Decoder$$anon$25: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$25.prototype.$classData = $d_Lio_circe_Decoder$$anon$25;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$26() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Short")
}
$c_Lio_circe_Decoder$$anon$26.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$26.prototype.constructor = $c_Lio_circe_Decoder$$anon$26;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$26() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$26.prototype = $c_Lio_circe_Decoder$$anon$26.prototype;
$c_Lio_circe_Decoder$$anon$26.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x220 = c.value__Lio_circe_Json();
  if ((x220 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x220);
    var x226 = x$1.Lio_circe_Json$JNumber__f_value;
    var x214 = x226.toShort__s_Option();
    if ((x214 instanceof $c_s_Some)) {
      var v = $uS($as_s_Some(x214).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x214)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x214)
  };
  if ((x220 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x220);
    var x223 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x223);
    if (this$4.isEmpty__Z()) {
      var x217 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$11 = $as_Lio_circe_JsonNumber(arg1);
      var x217 = _$11.toShort__s_Option()
    };
    if ((x217 instanceof $c_s_Some)) {
      var value = $uS($as_s_Some(x217).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(value)
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x217)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x217)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$26 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$26: 0
}, false, "io.circe.Decoder$$anon$26", {
  Lio_circe_Decoder$$anon$26: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$26.prototype.$classData = $d_Lio_circe_Decoder$$anon$26;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$27() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Int")
}
$c_Lio_circe_Decoder$$anon$27.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$27.prototype.constructor = $c_Lio_circe_Decoder$$anon$27;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$27() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$27.prototype = $c_Lio_circe_Decoder$$anon$27.prototype;
$c_Lio_circe_Decoder$$anon$27.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x233 = c.value__Lio_circe_Json();
  if ((x233 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x233);
    var x239 = x$1.Lio_circe_Json$JNumber__f_value;
    var x227 = x239.toInt__s_Option();
    if ((x227 instanceof $c_s_Some)) {
      var v = $uI($as_s_Some(x227).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x227)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x227)
  };
  if ((x233 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x233);
    var x236 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x236);
    if (this$4.isEmpty__Z()) {
      var x230 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$12 = $as_Lio_circe_JsonNumber(arg1);
      var x230 = _$12.toInt__s_Option()
    };
    if ((x230 instanceof $c_s_Some)) {
      var value = $uI($as_s_Some(x230).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(value)
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x230)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x230)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$27 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$27: 0
}, false, "io.circe.Decoder$$anon$27", {
  Lio_circe_Decoder$$anon$27: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$27.prototype.$classData = $d_Lio_circe_Decoder$$anon$27;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$28() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Long")
}
$c_Lio_circe_Decoder$$anon$28.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$28.prototype.constructor = $c_Lio_circe_Decoder$$anon$28;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$28() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$28.prototype = $c_Lio_circe_Decoder$$anon$28.prototype;
$c_Lio_circe_Decoder$$anon$28.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x246 = c.value__Lio_circe_Json();
  if ((x246 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x246);
    var x252 = x$1.Lio_circe_Json$JNumber__f_value;
    var x240 = x252.toLong__s_Option();
    if ((x240 instanceof $c_s_Some)) {
      var t = $uJ($as_s_Some(x240).s_Some__f_value);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $m_s_package$();
      return new $c_s_util_Right(new $c_RTLong(lo, hi))
    };
    var x = $m_s_None$();
    if ((x === x240)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x240)
  };
  if ((x246 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x246);
    var x249 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x249);
    if (this$4.isEmpty__Z()) {
      var x243 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$13 = $as_Lio_circe_JsonNumber(arg1);
      var x243 = _$13.toLong__s_Option()
    };
    if ((x243 instanceof $c_s_Some)) {
      var t$1 = $uJ($as_s_Some(x243).s_Some__f_value);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      $m_s_package$();
      return new $c_s_util_Right(new $c_RTLong(lo$1, hi$1))
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x243)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x243)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$28 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$28: 0
}, false, "io.circe.Decoder$$anon$28", {
  Lio_circe_Decoder$$anon$28: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$28.prototype.$classData = $d_Lio_circe_Decoder$$anon$28;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$29() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "BigInt")
}
$c_Lio_circe_Decoder$$anon$29.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$29.prototype.constructor = $c_Lio_circe_Decoder$$anon$29;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$29() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$29.prototype = $c_Lio_circe_Decoder$$anon$29.prototype;
$c_Lio_circe_Decoder$$anon$29.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x259 = c.value__Lio_circe_Json();
  if ((x259 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x259);
    var x265 = x$1.Lio_circe_Json$JNumber__f_value;
    var x253 = x265.toBigInt__s_Option();
    if ((x253 instanceof $c_s_Some)) {
      var v = $as_s_math_BigInt($as_s_Some(x253).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x253)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x253)
  };
  if ((x259 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x259);
    var x262 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x262);
    if (this$4.isEmpty__Z()) {
      var x256 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$14 = $as_Lio_circe_JsonNumber(arg1);
      var x256 = _$14.toBigInt__s_Option()
    };
    if ((x256 instanceof $c_s_Some)) {
      var value = $as_s_math_BigInt($as_s_Some(x256).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(value)
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x256)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x256)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$29 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$29: 0
}, false, "io.circe.Decoder$$anon$29", {
  Lio_circe_Decoder$$anon$29: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$29.prototype.$classData = $d_Lio_circe_Decoder$$anon$29;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$30() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "BigDecimal")
}
$c_Lio_circe_Decoder$$anon$30.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$30.prototype.constructor = $c_Lio_circe_Decoder$$anon$30;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$30() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$30.prototype = $c_Lio_circe_Decoder$$anon$30.prototype;
$c_Lio_circe_Decoder$$anon$30.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x272 = c.value__Lio_circe_Json();
  if ((x272 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x272);
    var x278 = x$1.Lio_circe_Json$JNumber__f_value;
    var x266 = x278.toBigDecimal__s_Option();
    if ((x266 instanceof $c_s_Some)) {
      var v = $as_s_math_BigDecimal($as_s_Some(x266).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(v)
    };
    var x = $m_s_None$();
    if ((x === x266)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x266)
  };
  if ((x272 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x272);
    var x275 = x$1$1.Lio_circe_Json$JString__f_value;
    var this$4 = $m_Lio_circe_JsonNumber$().fromString__T__s_Option(x275);
    if (this$4.isEmpty__Z()) {
      var x269 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var _$16 = $as_Lio_circe_JsonNumber(arg1);
      var x269 = _$16.toBigDecimal__s_Option()
    };
    if ((x269 instanceof $c_s_Some)) {
      var value = $as_s_math_BigDecimal($as_s_Some(x269).s_Some__f_value);
      $m_s_package$();
      return new $c_s_util_Right(value)
    };
    var x$3 = $m_s_None$();
    if ((x$3 === x269)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c)
    };
    throw new $c_s_MatchError(x269)
  };
  return this.fail__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_Decoder$$anon$30 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$30: 0
}, false, "io.circe.Decoder$$anon$30", {
  Lio_circe_Decoder$$anon$30: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$30.prototype.$classData = $d_Lio_circe_Decoder$$anon$30;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$42(decodeK$1, decodeV$1) {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null;
  $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__(this, decodeK$1, decodeV$1)
}
$c_Lio_circe_Decoder$$anon$42.prototype = new $h_Lio_circe_MapDecoder();
$c_Lio_circe_Decoder$$anon$42.prototype.constructor = $c_Lio_circe_Decoder$$anon$42;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$42() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$42.prototype = $c_Lio_circe_Decoder$$anon$42.prototype;
var $d_Lio_circe_Decoder$$anon$42 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$42: 0
}, false, "io.circe.Decoder$$anon$42", {
  Lio_circe_Decoder$$anon$42: 1,
  Lio_circe_MapDecoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$42.prototype.$classData = $d_Lio_circe_Decoder$$anon$42;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$45(decodeA$3) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$3)
}
$c_Lio_circe_Decoder$$anon$45.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_Decoder$$anon$45.prototype.constructor = $c_Lio_circe_Decoder$$anon$45;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$45() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$45.prototype = $c_Lio_circe_Decoder$$anon$45.prototype;
var $d_Lio_circe_Decoder$$anon$45 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$45: 0
}, false, "io.circe.Decoder$$anon$45", {
  Lio_circe_Decoder$$anon$45: 1,
  Lio_circe_SeqDecoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$45.prototype.$classData = $d_Lio_circe_Decoder$$anon$45;
/** @constructor */
function $c_Lio_circe_Decoder$StandardJavaTimeDecoder() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null
}
$c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype = new $h_Lio_circe_Decoder$JavaTimeDecoder();
$c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype.constructor = $c_Lio_circe_Decoder$StandardJavaTimeDecoder;
/** @constructor */
function $h_Lio_circe_Decoder$StandardJavaTimeDecoder() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype = $c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype;
function $f_Lio_circe_DerivedDecoder__decodeWith__I__Lio_circe_HCursor__s_util_Either($thiz, index, c) {
  return $thiz.elemDecoders__ALio_circe_Decoder().get(index).tryDecode__Lio_circe_ACursor__s_util_Either(c.downField__T__Lio_circe_ACursor($thiz.elemLabels__AT().get(index)))
}
/** @constructor */
function $c_Lio_circe_DerivedDecoder$$anon$1(c$3, outer) {
  this.Lio_circe_DerivedDecoder$$anon$1__f_c$1 = null;
  this.Lio_circe_DerivedDecoder$$anon$1__f_i = 0;
  this.Lio_circe_DerivedDecoder$$anon$1__f_$outer = null;
  this.Lio_circe_DerivedDecoder$$anon$1__f_c$1 = c$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_DerivedDecoder$$anon$1__f_$outer = outer;
  this.Lio_circe_DerivedDecoder$$anon$1__f_i = 0
}
$c_Lio_circe_DerivedDecoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.constructor = $c_Lio_circe_DerivedDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_DerivedDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_DerivedDecoder$$anon$1.prototype = $c_Lio_circe_DerivedDecoder$$anon$1.prototype;
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.hasNext__Z = (function() {
  var $$x1 = this.Lio_circe_DerivedDecoder$$anon$1__f_i;
  var this$1 = this.Lio_circe_DerivedDecoder$$anon$1__f_$outer;
  return ($$x1 < $f_Lio_circe_DerivedInstance__elemCount__I(this$1))
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.next__s_util_Either = (function() {
  var this$1 = this.Lio_circe_DerivedDecoder$$anon$1__f_$outer;
  var index = this.Lio_circe_DerivedDecoder$$anon$1__f_i;
  var c = this.Lio_circe_DerivedDecoder$$anon$1__f_c$1;
  var result = $f_Lio_circe_DerivedDecoder__decodeWith__I__Lio_circe_HCursor__s_util_Either(this$1, index, c);
  this.Lio_circe_DerivedDecoder$$anon$1__f_i = ((1 + this.Lio_circe_DerivedDecoder$$anon$1__f_i) | 0);
  return result
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.next__O = (function() {
  return this.next__s_util_Either()
});
var $d_Lio_circe_DerivedDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_DerivedDecoder$$anon$1: 0
}, false, "io.circe.DerivedDecoder$$anon$1", {
  Lio_circe_DerivedDecoder$$anon$1: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lio_circe_DerivedDecoder$$anon$1.prototype.$classData = $d_Lio_circe_DerivedDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_DerivedEncoder$$anon$2(value$2, outer) {
  this.Lio_circe_DerivedEncoder$$anon$2__f_elems = null;
  this.Lio_circe_DerivedEncoder$$anon$2__f_index = 0;
  this.Lio_circe_DerivedEncoder$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_DerivedEncoder$$anon$2__f_$outer = outer;
  this.Lio_circe_DerivedEncoder$$anon$2__f_elems = value$2.productIterator__sc_Iterator();
  this.Lio_circe_DerivedEncoder$$anon$2__f_index = 0
}
$c_Lio_circe_DerivedEncoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.constructor = $c_Lio_circe_DerivedEncoder$$anon$2;
/** @constructor */
function $h_Lio_circe_DerivedEncoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_DerivedEncoder$$anon$2.prototype = $c_Lio_circe_DerivedEncoder$$anon$2.prototype;
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.hasNext__Z = (function() {
  return this.Lio_circe_DerivedEncoder$$anon$2__f_elems.hasNext__Z()
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.next__T2 = (function() {
  var this$1 = this.Lio_circe_DerivedEncoder$$anon$2__f_$outer.Lio_circe_DerivedEncoder$$anon$1__f_$outer;
  var index = this.Lio_circe_DerivedEncoder$$anon$2__f_index;
  var value = this.Lio_circe_DerivedEncoder$$anon$2__f_elems.next__O();
  var field = $f_Lio_circe_DerivedEncoder__encodeWith__I__O__T2(this$1, index, value);
  this.Lio_circe_DerivedEncoder$$anon$2__f_index = ((1 + this.Lio_circe_DerivedEncoder$$anon$2__f_index) | 0);
  return field
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_Lio_circe_DerivedEncoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_DerivedEncoder$$anon$2: 0
}, false, "io.circe.DerivedEncoder$$anon$2", {
  Lio_circe_DerivedEncoder$$anon$2: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lio_circe_DerivedEncoder$$anon$2.prototype.$classData = $d_Lio_circe_DerivedEncoder$$anon$2;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$19() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$19.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$19.prototype.constructor = $c_Lio_circe_Encoder$$anon$19;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$19() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$19.prototype = $c_Lio_circe_Encoder$$anon$19.prototype;
var $d_Lio_circe_Encoder$$anon$19 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$19: 0
}, false, "io.circe.Encoder$$anon$19", {
  Lio_circe_Encoder$$anon$19: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1
});
$c_Lio_circe_Encoder$$anon$19.prototype.$classData = $d_Lio_circe_Encoder$$anon$19;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$59() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$59.prototype = new $h_Lio_circe_Encoder$JavaTimeEncoder();
$c_Lio_circe_Encoder$$anon$59.prototype.constructor = $c_Lio_circe_Encoder$$anon$59;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$59() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$59.prototype = $c_Lio_circe_Encoder$$anon$59.prototype;
var $d_Lio_circe_Encoder$$anon$59 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$59: 0
}, false, "io.circe.Encoder$$anon$59", {
  Lio_circe_Encoder$$anon$59: 1,
  Lio_circe_Encoder$JavaTimeEncoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_Encoder$$anon$59.prototype.$classData = $d_Lio_circe_Encoder$$anon$59;
function $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var values = $thiz.encodeArray__O__sci_Vector(a);
  return new $c_Lio_circe_Json$JArray(values)
}
function $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var value = $thiz.encodeObject__O__Lio_circe_JsonObject(a);
  return new $c_Lio_circe_Json$JObject(value)
}
class $c_Lio_circe_Error extends $c_jl_Exception {
  fillInStackTrace__jl_Throwable() {
    return this
  };
}
function $as_Lio_circe_Error(obj) {
  return (((obj instanceof $c_Lio_circe_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Error"))
}
function $isArrayOf_Lio_circe_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Error)))
}
function $asArrayOf_Lio_circe_Error(obj, depth) {
  return (($isArrayOf_Lio_circe_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Error;", depth))
}
/** @constructor */
function $c_Lio_circe_Json() {
  /*<skip>*/
}
$c_Lio_circe_Json.prototype = new $h_O();
$c_Lio_circe_Json.prototype.constructor = $c_Lio_circe_Json;
/** @constructor */
function $h_Lio_circe_Json() {
  /*<skip>*/
}
$h_Lio_circe_Json.prototype = $c_Lio_circe_Json.prototype;
$c_Lio_circe_Json.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_Json.prototype.toString__T = (function() {
  return $m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2.print__Lio_circe_Json__T(this)
});
$c_Lio_circe_Json.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_Json)) {
    var that$2 = $as_Lio_circe_Json(that);
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson.eqv__O__O__Z(this, that$2)
  } else {
    return false
  }
});
function $as_Lio_circe_Json(obj) {
  return (((obj instanceof $c_Lio_circe_Json) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json"))
}
function $isArrayOf_Lio_circe_Json(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json)))
}
function $asArrayOf_Lio_circe_Json(obj, depth) {
  return (($isArrayOf_Lio_circe_Json(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json;", depth))
}
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$4(outer) {
  this.Lio_circe_JsonObject$$anon$4__f_underlying = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var this$1 = outer.Lio_circe_JsonObject$$anon$1__f_$outer.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  this.Lio_circe_JsonObject$$anon$4__f_underlying = new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator()
}
$c_Lio_circe_JsonObject$$anon$4.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$4.prototype.constructor = $c_Lio_circe_JsonObject$$anon$4;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$4() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$$anon$4.prototype = $c_Lio_circe_JsonObject$$anon$4.prototype;
$c_Lio_circe_JsonObject$$anon$4.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_JsonObject$$anon$4.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lio_circe_JsonObject$$anon$4.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_JsonObject$$anon$4.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_JsonObject$$anon$4.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_JsonObject$$anon$4.prototype.hasNext__Z = (function() {
  return this.Lio_circe_JsonObject$$anon$4__f_underlying.hasNext__Z()
});
$c_Lio_circe_JsonObject$$anon$4.prototype.next__T = (function() {
  return $as_T(this.Lio_circe_JsonObject$$anon$4__f_underlying.next__O())
});
$c_Lio_circe_JsonObject$$anon$4.prototype.next__O = (function() {
  return this.next__T()
});
var $d_Lio_circe_JsonObject$$anon$4 = new $TypeData().initClass({
  Lio_circe_JsonObject$$anon$4: 0
}, false, "io.circe.JsonObject$$anon$4", {
  Lio_circe_JsonObject$$anon$4: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lio_circe_JsonObject$$anon$4.prototype.$classData = $d_Lio_circe_JsonObject$$anon$4;
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$6(outer) {
  this.Lio_circe_JsonObject$$anon$6__f_underlying = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var this$1 = outer.Lio_circe_JsonObject$$anon$3__f_$outer.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  this.Lio_circe_JsonObject$$anon$6__f_underlying = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator()
}
$c_Lio_circe_JsonObject$$anon$6.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$6.prototype.constructor = $c_Lio_circe_JsonObject$$anon$6;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$$anon$6.prototype = $c_Lio_circe_JsonObject$$anon$6.prototype;
$c_Lio_circe_JsonObject$$anon$6.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_JsonObject$$anon$6.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lio_circe_JsonObject$$anon$6.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_JsonObject$$anon$6.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_JsonObject$$anon$6.prototype.hasNext__Z = (function() {
  return this.Lio_circe_JsonObject$$anon$6__f_underlying.hasNext__Z()
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__T2 = (function() {
  var field = $as_ju_Map$Entry(this.Lio_circe_JsonObject$$anon$6__f_underlying.next__O());
  var _1 = field.getKey__O();
  var _2 = field.getValue__O();
  return $ct_T2__O__O__(new $c_T2(), _1, _2)
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_Lio_circe_JsonObject$$anon$6 = new $TypeData().initClass({
  Lio_circe_JsonObject$$anon$6: 0
}, false, "io.circe.JsonObject$$anon$6", {
  Lio_circe_JsonObject$$anon$6: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lio_circe_JsonObject$$anon$6.prototype.$classData = $d_Lio_circe_JsonObject$$anon$6;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$3() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$3.prototype = new $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder();
$c_Lio_circe_KeyDecoder$$anon$3.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$3;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$3.prototype = $c_Lio_circe_KeyDecoder$$anon$3.prototype;
$c_Lio_circe_KeyDecoder$$anon$3.prototype.decodeSafe__T__O = (function(key) {
  return key
});
var $d_Lio_circe_KeyDecoder$$anon$3 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$3: 0
}, false, "io.circe.KeyDecoder$$anon$3", {
  Lio_circe_KeyDecoder$$anon$3: 1,
  Lio_circe_KeyDecoder$AlwaysKeyDecoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$3.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$3;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$4() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$4.prototype = new $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder();
$c_Lio_circe_KeyDecoder$$anon$4.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$4;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$4() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$4.prototype = $c_Lio_circe_KeyDecoder$$anon$4.prototype;
$c_Lio_circe_KeyDecoder$$anon$4.prototype.decodeSafe__T__O = (function(key) {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, key))
});
var $d_Lio_circe_KeyDecoder$$anon$4 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$4: 0
}, false, "io.circe.KeyDecoder$$anon$4", {
  Lio_circe_KeyDecoder$$anon$4: 1,
  Lio_circe_KeyDecoder$AlwaysKeyDecoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1
});
$c_Lio_circe_KeyDecoder$$anon$4.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$4;
function $p_Lio_circe_Printer__concat__T__T__T__T($thiz, left, text, right) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + left);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + right);
  return builder.jl_StringBuilder__f_java$lang$StringBuilder$$content
}
/** @constructor */
function $c_Lio_circe_Printer(dropNullValues, indent, lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys) {
  this.Lio_circe_Printer__f_dropNullValues = false;
  this.Lio_circe_Printer__f_indent = null;
  this.Lio_circe_Printer__f_lbraceLeft = null;
  this.Lio_circe_Printer__f_lbraceRight = null;
  this.Lio_circe_Printer__f_rbraceLeft = null;
  this.Lio_circe_Printer__f_rbraceRight = null;
  this.Lio_circe_Printer__f_lbracketLeft = null;
  this.Lio_circe_Printer__f_lbracketRight = null;
  this.Lio_circe_Printer__f_rbracketLeft = null;
  this.Lio_circe_Printer__f_rbracketRight = null;
  this.Lio_circe_Printer__f_lrbracketsEmpty = null;
  this.Lio_circe_Printer__f_arrayCommaLeft = null;
  this.Lio_circe_Printer__f_arrayCommaRight = null;
  this.Lio_circe_Printer__f_objectCommaLeft = null;
  this.Lio_circe_Printer__f_objectCommaRight = null;
  this.Lio_circe_Printer__f_colonLeft = null;
  this.Lio_circe_Printer__f_colonRight = null;
  this.Lio_circe_Printer__f_reuseWriters = false;
  this.Lio_circe_Printer__f_predictSize = false;
  this.Lio_circe_Printer__f_escapeNonAscii = false;
  this.Lio_circe_Printer__f_sortKeys = false;
  this.Lio_circe_Printer__f_pieces = null;
  this.Lio_circe_Printer__f_stringWriter = null;
  this.Lio_circe_Printer__f_sizePredictor = null;
  this.Lio_circe_Printer__f_dropNullValues = dropNullValues;
  this.Lio_circe_Printer__f_indent = indent;
  this.Lio_circe_Printer__f_lbraceLeft = lbraceLeft;
  this.Lio_circe_Printer__f_lbraceRight = lbraceRight;
  this.Lio_circe_Printer__f_rbraceLeft = rbraceLeft;
  this.Lio_circe_Printer__f_rbraceRight = rbraceRight;
  this.Lio_circe_Printer__f_lbracketLeft = lbracketLeft;
  this.Lio_circe_Printer__f_lbracketRight = lbracketRight;
  this.Lio_circe_Printer__f_rbracketLeft = rbracketLeft;
  this.Lio_circe_Printer__f_rbracketRight = rbracketRight;
  this.Lio_circe_Printer__f_lrbracketsEmpty = lrbracketsEmpty;
  this.Lio_circe_Printer__f_arrayCommaLeft = arrayCommaLeft;
  this.Lio_circe_Printer__f_arrayCommaRight = arrayCommaRight;
  this.Lio_circe_Printer__f_objectCommaLeft = objectCommaLeft;
  this.Lio_circe_Printer__f_objectCommaRight = objectCommaRight;
  this.Lio_circe_Printer__f_colonLeft = colonLeft;
  this.Lio_circe_Printer__f_colonRight = colonRight;
  this.Lio_circe_Printer__f_reuseWriters = reuseWriters;
  this.Lio_circe_Printer__f_predictSize = predictSize;
  this.Lio_circe_Printer__f_escapeNonAscii = escapeNonAscii;
  this.Lio_circe_Printer__f_sortKeys = sortKeys;
  if ((indent === "")) {
    var lBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbraceLeft, "{", lbraceRight);
    var rBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbraceRight, "}", rbraceLeft);
    var lBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbracketLeft, "[", lbracketRight);
    var rBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbracketLeft, "]", rbracketRight);
    var lrEmptyBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, "[", lrbracketsEmpty, "]");
    var arrayCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, arrayCommaLeft, ",", arrayCommaRight);
    var objectCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, objectCommaLeft, ",", objectCommaRight);
    var colons = $p_Lio_circe_Printer__concat__T__T__T__T(this, colonLeft, ":", colonRight);
    var $$x1 = new $c_Lio_circe_Printer$ConstantPieces(new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons))
  } else {
    var $$x1 = new $c_Lio_circe_Printer$$anon$1(indent, this)
  };
  this.Lio_circe_Printer__f_pieces = $$x1;
  this.Lio_circe_Printer__f_stringWriter = new $c_Lio_circe_Printer$$anon$2();
  this.Lio_circe_Printer__f_sizePredictor = new $c_Lio_circe_Printer$$anon$3()
}
$c_Lio_circe_Printer.prototype = new $h_O();
$c_Lio_circe_Printer.prototype.constructor = $c_Lio_circe_Printer;
/** @constructor */
function $h_Lio_circe_Printer() {
  /*<skip>*/
}
$h_Lio_circe_Printer.prototype = $c_Lio_circe_Printer.prototype;
$c_Lio_circe_Printer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_Printer.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Printer");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Printer__f_dropNullValues ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lio_circe_Printer__f_indent;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lio_circe_Printer__f_lbraceLeft;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_Printer__f_lbraceRight;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lio_circe_Printer__f_rbraceLeft;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lio_circe_Printer__f_rbraceRight;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lio_circe_Printer__f_lbracketLeft;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lio_circe_Printer__f_lbracketRight;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lio_circe_Printer__f_rbracketLeft;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$8 = this.Lio_circe_Printer__f_rbracketRight;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$9 = this.Lio_circe_Printer__f_lrbracketsEmpty;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$10 = this.Lio_circe_Printer__f_arrayCommaLeft;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$10);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  var x$11 = this.Lio_circe_Printer__f_arrayCommaRight;
  var data$13 = $m_sr_Statics$().anyHash__O__I(x$11);
  acc = $m_sr_Statics$().mix__I__I__I(hash$13, data$13);
  var hash$14 = acc;
  var x$12 = this.Lio_circe_Printer__f_objectCommaLeft;
  var data$14 = $m_sr_Statics$().anyHash__O__I(x$12);
  acc = $m_sr_Statics$().mix__I__I__I(hash$14, data$14);
  var hash$15 = acc;
  var x$13 = this.Lio_circe_Printer__f_objectCommaRight;
  var data$15 = $m_sr_Statics$().anyHash__O__I(x$13);
  acc = $m_sr_Statics$().mix__I__I__I(hash$15, data$15);
  var hash$16 = acc;
  var x$14 = this.Lio_circe_Printer__f_colonLeft;
  var data$16 = $m_sr_Statics$().anyHash__O__I(x$14);
  acc = $m_sr_Statics$().mix__I__I__I(hash$16, data$16);
  var hash$17 = acc;
  var x$15 = this.Lio_circe_Printer__f_colonRight;
  var data$17 = $m_sr_Statics$().anyHash__O__I(x$15);
  acc = $m_sr_Statics$().mix__I__I__I(hash$17, data$17);
  var hash$18 = acc;
  var data$18 = (this.Lio_circe_Printer__f_reuseWriters ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$18, data$18);
  var hash$19 = acc;
  var data$19 = (this.Lio_circe_Printer__f_predictSize ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$19, data$19);
  var hash$20 = acc;
  var data$20 = (this.Lio_circe_Printer__f_escapeNonAscii ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$20, data$20);
  var hash$21 = acc;
  var data$21 = (this.Lio_circe_Printer__f_sortKeys ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$21, data$21);
  var hash$22 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$22, 21)
});
$c_Lio_circe_Printer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_Printer)) {
    var x$0$2 = $as_Lio_circe_Printer(x$0);
    return (((((((((((((((((((((this.Lio_circe_Printer__f_dropNullValues === x$0$2.Lio_circe_Printer__f_dropNullValues) && (this.Lio_circe_Printer__f_reuseWriters === x$0$2.Lio_circe_Printer__f_reuseWriters)) && (this.Lio_circe_Printer__f_predictSize === x$0$2.Lio_circe_Printer__f_predictSize)) && (this.Lio_circe_Printer__f_escapeNonAscii === x$0$2.Lio_circe_Printer__f_escapeNonAscii)) && (this.Lio_circe_Printer__f_sortKeys === x$0$2.Lio_circe_Printer__f_sortKeys)) && (this.Lio_circe_Printer__f_indent === x$0$2.Lio_circe_Printer__f_indent)) && (this.Lio_circe_Printer__f_lbraceLeft === x$0$2.Lio_circe_Printer__f_lbraceLeft)) && (this.Lio_circe_Printer__f_lbraceRight === x$0$2.Lio_circe_Printer__f_lbraceRight)) && (this.Lio_circe_Printer__f_rbraceLeft === x$0$2.Lio_circe_Printer__f_rbraceLeft)) && (this.Lio_circe_Printer__f_rbraceRight === x$0$2.Lio_circe_Printer__f_rbraceRight)) && (this.Lio_circe_Printer__f_lbracketLeft === x$0$2.Lio_circe_Printer__f_lbracketLeft)) && (this.Lio_circe_Printer__f_lbracketRight === x$0$2.Lio_circe_Printer__f_lbracketRight)) && (this.Lio_circe_Printer__f_rbracketLeft === x$0$2.Lio_circe_Printer__f_rbracketLeft)) && (this.Lio_circe_Printer__f_rbracketRight === x$0$2.Lio_circe_Printer__f_rbracketRight)) && (this.Lio_circe_Printer__f_lrbracketsEmpty === x$0$2.Lio_circe_Printer__f_lrbracketsEmpty)) && (this.Lio_circe_Printer__f_arrayCommaLeft === x$0$2.Lio_circe_Printer__f_arrayCommaLeft)) && (this.Lio_circe_Printer__f_arrayCommaRight === x$0$2.Lio_circe_Printer__f_arrayCommaRight)) && (this.Lio_circe_Printer__f_objectCommaLeft === x$0$2.Lio_circe_Printer__f_objectCommaLeft)) && (this.Lio_circe_Printer__f_objectCommaRight === x$0$2.Lio_circe_Printer__f_objectCommaRight)) && (this.Lio_circe_Printer__f_colonLeft === x$0$2.Lio_circe_Printer__f_colonLeft)) && (this.Lio_circe_Printer__f_colonRight === x$0$2.Lio_circe_Printer__f_colonRight))
  } else {
    return false
  }
});
$c_Lio_circe_Printer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_Printer.prototype.productArity__I = (function() {
  return 21
});
$c_Lio_circe_Printer.prototype.productPrefix__T = (function() {
  return "Printer"
});
$c_Lio_circe_Printer.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer__f_dropNullValues;
      break
    }
    case 1: {
      return this.Lio_circe_Printer__f_indent;
      break
    }
    case 2: {
      return this.Lio_circe_Printer__f_lbraceLeft;
      break
    }
    case 3: {
      return this.Lio_circe_Printer__f_lbraceRight;
      break
    }
    case 4: {
      return this.Lio_circe_Printer__f_rbraceLeft;
      break
    }
    case 5: {
      return this.Lio_circe_Printer__f_rbraceRight;
      break
    }
    case 6: {
      return this.Lio_circe_Printer__f_lbracketLeft;
      break
    }
    case 7: {
      return this.Lio_circe_Printer__f_lbracketRight;
      break
    }
    case 8: {
      return this.Lio_circe_Printer__f_rbracketLeft;
      break
    }
    case 9: {
      return this.Lio_circe_Printer__f_rbracketRight;
      break
    }
    case 10: {
      return this.Lio_circe_Printer__f_lrbracketsEmpty;
      break
    }
    case 11: {
      return this.Lio_circe_Printer__f_arrayCommaLeft;
      break
    }
    case 12: {
      return this.Lio_circe_Printer__f_arrayCommaRight;
      break
    }
    case 13: {
      return this.Lio_circe_Printer__f_objectCommaLeft;
      break
    }
    case 14: {
      return this.Lio_circe_Printer__f_objectCommaRight;
      break
    }
    case 15: {
      return this.Lio_circe_Printer__f_colonLeft;
      break
    }
    case 16: {
      return this.Lio_circe_Printer__f_colonRight;
      break
    }
    case 17: {
      return this.Lio_circe_Printer__f_reuseWriters;
      break
    }
    case 18: {
      return this.Lio_circe_Printer__f_predictSize;
      break
    }
    case 19: {
      return this.Lio_circe_Printer__f_escapeNonAscii;
      break
    }
    case 20: {
      return this.Lio_circe_Printer__f_sortKeys;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lio_circe_Printer.prototype.print__Lio_circe_Json__T = (function(json) {
  if ((this.Lio_circe_Printer__f_reuseWriters && (this.Lio_circe_Printer__f_stringWriter !== null))) {
    var w = $as_jl_StringBuilder(this.Lio_circe_Printer__f_stringWriter.get__O());
    w.setLength__I__V(0);
    var writer = w
  } else {
    var writer = $ct_jl_StringBuilder__(new $c_jl_StringBuilder())
  };
  var folder = new $c_Lio_circe_Printer$StringBuilderFolder(this, writer);
  json.foldWith__Lio_circe_Json$Folder__O(folder);
  return writer.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
function $as_Lio_circe_Printer(obj) {
  return (((obj instanceof $c_Lio_circe_Printer) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer"))
}
function $isArrayOf_Lio_circe_Printer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer)))
}
function $asArrayOf_Lio_circe_Printer(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer;", depth))
}
var $d_Lio_circe_Printer = new $TypeData().initClass({
  Lio_circe_Printer: 0
}, false, "io.circe.Printer", {
  Lio_circe_Printer: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer.prototype.$classData = $d_Lio_circe_Printer;
/** @constructor */
function $c_Lio_circe_Printer$$anon$1(indent$2, outer) {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
  this.Lio_circe_Printer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Printer$$anon$1__f_$outer = outer;
  $ct_Lio_circe_Printer$MemoizedPieces__T__(this, indent$2)
}
$c_Lio_circe_Printer$$anon$1.prototype = new $h_Lio_circe_Printer$MemoizedPieces();
$c_Lio_circe_Printer$$anon$1.prototype.constructor = $c_Lio_circe_Printer$$anon$1;
/** @constructor */
function $h_Lio_circe_Printer$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$1.prototype = $c_Lio_circe_Printer$$anon$1.prototype;
$c_Lio_circe_Printer$$anon$1.prototype.compute__I__Lio_circe_Printer$Pieces = (function(i) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "{");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbraceRight, ((1 + i) | 0));
  var lBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "}");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbraceRight, ((1 + i) | 0));
  var rBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbracketRight, ((1 + i) | 0));
  var lBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbracketRight, ((1 + i) | 0));
  var rBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lrbracketsEmpty, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  var lrEmptyBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_arrayCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_arrayCommaRight, ((1 + i) | 0));
  var arrayCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_objectCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_objectCommaRight, ((1 + i) | 0));
  var objectCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_colonLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_colonRight, ((1 + i) | 0));
  var colons = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons)
});
var $d_Lio_circe_Printer$$anon$1 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$1: 0
}, false, "io.circe.Printer$$anon$1", {
  Lio_circe_Printer$$anon$1: 1,
  Lio_circe_Printer$MemoizedPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$$anon$1.prototype.$classData = $d_Lio_circe_Printer$$anon$1;
/** @constructor */
function $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons) {
  this.Lio_circe_Printer$Pieces__f_lBraces = null;
  this.Lio_circe_Printer$Pieces__f_rBraces = null;
  this.Lio_circe_Printer$Pieces__f_lBrackets = null;
  this.Lio_circe_Printer$Pieces__f_rBrackets = null;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = null;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = null;
  this.Lio_circe_Printer$Pieces__f_objectCommas = null;
  this.Lio_circe_Printer$Pieces__f_colons = null;
  this.Lio_circe_Printer$Pieces__f_lBraces = lBraces;
  this.Lio_circe_Printer$Pieces__f_rBraces = rBraces;
  this.Lio_circe_Printer$Pieces__f_lBrackets = lBrackets;
  this.Lio_circe_Printer$Pieces__f_rBrackets = rBrackets;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = lrEmptyBrackets;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = arrayCommas;
  this.Lio_circe_Printer$Pieces__f_objectCommas = objectCommas;
  this.Lio_circe_Printer$Pieces__f_colons = colons
}
$c_Lio_circe_Printer$Pieces.prototype = new $h_O();
$c_Lio_circe_Printer$Pieces.prototype.constructor = $c_Lio_circe_Printer$Pieces;
/** @constructor */
function $h_Lio_circe_Printer$Pieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$Pieces.prototype = $c_Lio_circe_Printer$Pieces.prototype;
$c_Lio_circe_Printer$Pieces.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_Printer$Pieces.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Printer$Pieces.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_Printer$Pieces)) {
    var x$0$2 = $as_Lio_circe_Printer$Pieces(x$0);
    return ((((((((this.Lio_circe_Printer$Pieces__f_lBraces === x$0$2.Lio_circe_Printer$Pieces__f_lBraces) && (this.Lio_circe_Printer$Pieces__f_rBraces === x$0$2.Lio_circe_Printer$Pieces__f_rBraces)) && (this.Lio_circe_Printer$Pieces__f_lBrackets === x$0$2.Lio_circe_Printer$Pieces__f_lBrackets)) && (this.Lio_circe_Printer$Pieces__f_rBrackets === x$0$2.Lio_circe_Printer$Pieces__f_rBrackets)) && (this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets === x$0$2.Lio_circe_Printer$Pieces__f_lrEmptyBrackets)) && (this.Lio_circe_Printer$Pieces__f_arrayCommas === x$0$2.Lio_circe_Printer$Pieces__f_arrayCommas)) && (this.Lio_circe_Printer$Pieces__f_objectCommas === x$0$2.Lio_circe_Printer$Pieces__f_objectCommas)) && (this.Lio_circe_Printer$Pieces__f_colons === x$0$2.Lio_circe_Printer$Pieces__f_colons))
  } else {
    return false
  }
});
$c_Lio_circe_Printer$Pieces.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_Printer$Pieces.prototype.productArity__I = (function() {
  return 8
});
$c_Lio_circe_Printer$Pieces.prototype.productPrefix__T = (function() {
  return "Pieces"
});
$c_Lio_circe_Printer$Pieces.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer$Pieces__f_lBraces;
      break
    }
    case 1: {
      return this.Lio_circe_Printer$Pieces__f_rBraces;
      break
    }
    case 2: {
      return this.Lio_circe_Printer$Pieces__f_lBrackets;
      break
    }
    case 3: {
      return this.Lio_circe_Printer$Pieces__f_rBrackets;
      break
    }
    case 4: {
      return this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets;
      break
    }
    case 5: {
      return this.Lio_circe_Printer$Pieces__f_arrayCommas;
      break
    }
    case 6: {
      return this.Lio_circe_Printer$Pieces__f_objectCommas;
      break
    }
    case 7: {
      return this.Lio_circe_Printer$Pieces__f_colons;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lio_circe_Printer$Pieces(obj) {
  return (((obj instanceof $c_Lio_circe_Printer$Pieces) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer$Pieces"))
}
function $isArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer$Pieces)))
}
function $asArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer$Pieces(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer$Pieces;", depth))
}
var $d_Lio_circe_Printer$Pieces = new $TypeData().initClass({
  Lio_circe_Printer$Pieces: 0
}, false, "io.circe.Printer$Pieces", {
  Lio_circe_Printer$Pieces: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_Printer$Pieces.prototype.$classData = $d_Lio_circe_Printer$Pieces;
/** @constructor */
function $c_Lio_circe_Printer$StringBuilderFolder(outer, writer) {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  this.Lio_circe_Printer$StringBuilderFolder__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_Printer$StringBuilderFolder__f_$outer = outer;
  $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__(this, writer, outer.Lio_circe_Printer__f_pieces, outer.Lio_circe_Printer__f_dropNullValues, outer.Lio_circe_Printer__f_escapeNonAscii, outer.Lio_circe_Printer__f_sortKeys)
}
$c_Lio_circe_Printer$StringBuilderFolder.prototype = new $h_Lio_circe_Printer$PrintingFolder();
$c_Lio_circe_Printer$StringBuilderFolder.prototype.constructor = $c_Lio_circe_Printer$StringBuilderFolder;
/** @constructor */
function $h_Lio_circe_Printer$StringBuilderFolder() {
  /*<skip>*/
}
$h_Lio_circe_Printer$StringBuilderFolder.prototype = $c_Lio_circe_Printer$StringBuilderFolder.prototype;
$c_Lio_circe_Printer$StringBuilderFolder.prototype.onBoolean__Z__O = (function(value) {
  var this$1 = $as_jl_StringBuilder(this.Lio_circe_Printer$PrintingFolder__f_writer);
  var str = ("" + value);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
$c_Lio_circe_Printer$StringBuilderFolder.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  value.appendToStringBuilder__jl_StringBuilder__V($as_jl_StringBuilder(this.Lio_circe_Printer$PrintingFolder__f_writer))
});
var $d_Lio_circe_Printer$StringBuilderFolder = new $TypeData().initClass({
  Lio_circe_Printer$StringBuilderFolder: 0
}, false, "io.circe.Printer$StringBuilderFolder", {
  Lio_circe_Printer$StringBuilderFolder: 1,
  Lio_circe_Printer$PrintingFolder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Json$Folder: 1
});
$c_Lio_circe_Printer$StringBuilderFolder.prototype.$classData = $d_Lio_circe_Printer$StringBuilderFolder;
/** @constructor */
function $c_Lio_circe_cursor_ArrayCursor(values, indexValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ArrayCursor__f_values = null;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = 0;
  this.Lio_circe_cursor_ArrayCursor__f_parent = null;
  this.Lio_circe_cursor_ArrayCursor__f_changed = false;
  this.Lio_circe_cursor_ArrayCursor__f_values = values;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = indexValue;
  this.Lio_circe_cursor_ArrayCursor__f_parent = parent;
  this.Lio_circe_cursor_ArrayCursor__f_changed = changed;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_ArrayCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ArrayCursor.prototype.constructor = $c_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $h_Lio_circe_cursor_ArrayCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_ArrayCursor.prototype = $c_Lio_circe_cursor_ArrayCursor.prototype;
$c_Lio_circe_cursor_ArrayCursor.prototype.value__Lio_circe_Json = (function() {
  return $as_Lio_circe_Json(this.Lio_circe_cursor_ArrayCursor__f_values.apply__I__O(this.Lio_circe_cursor_ArrayCursor__f_indexValue))
});
$c_Lio_circe_cursor_ArrayCursor.prototype.right__Lio_circe_ACursor = (function() {
  var $$x1 = this.Lio_circe_cursor_ArrayCursor__f_indexValue;
  var this$1 = this.Lio_circe_cursor_ArrayCursor__f_values;
  if (($$x1 === (((-1) + this$1.length__I()) | 0))) {
    var op = $m_Lio_circe_CursorOp$MoveRight$();
    return new $c_Lio_circe_FailedCursor(this, op)
  } else {
    return new $c_Lio_circe_cursor_ArrayCursor(this.Lio_circe_cursor_ArrayCursor__f_values, ((1 + this.Lio_circe_cursor_ArrayCursor__f_indexValue) | 0), this.Lio_circe_cursor_ArrayCursor__f_parent, this.Lio_circe_cursor_ArrayCursor__f_changed, this, $m_Lio_circe_CursorOp$MoveRight$())
  }
});
var $d_Lio_circe_cursor_ArrayCursor = new $TypeData().initClass({
  Lio_circe_cursor_ArrayCursor: 0
}, false, "io.circe.cursor.ArrayCursor", {
  Lio_circe_cursor_ArrayCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_ArrayCursor.prototype.$classData = $d_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $c_Lio_circe_cursor_ObjectCursor(obj, keyValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = null;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = null;
  this.Lio_circe_cursor_ObjectCursor__f_parent = null;
  this.Lio_circe_cursor_ObjectCursor__f_changed = false;
  this.Lio_circe_cursor_ObjectCursor__f_obj = obj;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = keyValue;
  this.Lio_circe_cursor_ObjectCursor__f_parent = parent;
  this.Lio_circe_cursor_ObjectCursor__f_changed = changed;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_ObjectCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ObjectCursor.prototype.constructor = $c_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $h_Lio_circe_cursor_ObjectCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_ObjectCursor.prototype = $c_Lio_circe_cursor_ObjectCursor.prototype;
$c_Lio_circe_cursor_ObjectCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_ObjectCursor__f_obj.applyUnsafe__T__Lio_circe_Json(this.Lio_circe_cursor_ObjectCursor__f_keyValue)
});
$c_Lio_circe_cursor_ObjectCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
var $d_Lio_circe_cursor_ObjectCursor = new $TypeData().initClass({
  Lio_circe_cursor_ObjectCursor: 0
}, false, "io.circe.cursor.ObjectCursor", {
  Lio_circe_cursor_ObjectCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_ObjectCursor.prototype.$classData = $d_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $c_Lio_circe_cursor_TopCursor(value, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_TopCursor__f_value = null;
  this.Lio_circe_cursor_TopCursor__f_value = value;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_TopCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_TopCursor.prototype.constructor = $c_Lio_circe_cursor_TopCursor;
/** @constructor */
function $h_Lio_circe_cursor_TopCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_TopCursor.prototype = $c_Lio_circe_cursor_TopCursor.prototype;
$c_Lio_circe_cursor_TopCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_TopCursor__f_value
});
$c_Lio_circe_cursor_TopCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
var $d_Lio_circe_cursor_TopCursor = new $TypeData().initClass({
  Lio_circe_cursor_TopCursor: 0
}, false, "io.circe.cursor.TopCursor", {
  Lio_circe_cursor_TopCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_TopCursor.prototype.$classData = $d_Lio_circe_cursor_TopCursor;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this)
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.isNegativeZero__Z = (function() {
  return false
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toDouble__D = (function() {
  return 0.0
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toFloat__F = (function() {
  return 0.0
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var other = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return (!other.isNegativeZero__Z())
  } else {
    return false
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.hashCode__I = (function() {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(0.0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toString__T = (function() {
  return "0"
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$1 = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$$anon$1: 0
}, false, "io.circe.numbers.BiggerDecimal$$anon$1", {
  Lio_circe_numbers_BiggerDecimal$$anon$1: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this)
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.isNegativeZero__Z = (function() {
  return true
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toDouble__D = (function() {
  return (-0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toFloat__F = (function() {
  return (-0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var other = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return other.isNegativeZero__Z()
  } else {
    return false
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.hashCode__I = (function() {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I((-0))
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toString__T = (function() {
  return "-0"
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$2 = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$$anon$2: 0
}, false, "io.circe.numbers.BiggerDecimal$$anon$2", {
  Lio_circe_numbers_BiggerDecimal$$anon$2: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $c_Lio_circe_scalajs_package$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_scalajs_package$$anon$1.prototype = new $h_O();
$c_Lio_circe_scalajs_package$$anon$1.prototype.constructor = $c_Lio_circe_scalajs_package$$anon$1;
/** @constructor */
function $h_Lio_circe_scalajs_package$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_scalajs_package$$anon$1.prototype = $c_Lio_circe_scalajs_package$$anon$1.prototype;
$c_Lio_circe_scalajs_package$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onArray__sci_Vector__sjs_js_Any = (function(value) {
  var col = $as_sc_IterableOnce(value.map__F1__O(this));
  return $m_sjs_js_JSConverters$JSRichIterableOnce$().toJSArray$extension__sc_IterableOnce__sjs_js_Array(col)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onObject__Lio_circe_JsonObject__sjs_js_Any = (function(value) {
  var this$1 = value.toMap__sci_Map();
  var this$3 = new $c_sc_MapView$MapValues(this$1, this);
  $m_s_$less$colon$less$();
  var map = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  var this$5 = $m_sjs_js_JSConverters$JSRichMap$();
  var result = {};
  map.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$7, result$1) => ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var key = $as_T(x0$1._1__O());
      var value$1 = x0$1._2__O();
      result$1[key] = value$1
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))(this$5, result)));
  return result
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.apply__O__O = (function(v1) {
  var value = $as_Lio_circe_Json(v1);
  return value.foldWith__Lio_circe_Json$Folder__O(this)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onNull__O = (function() {
  return null
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onBoolean__Z__O = (function(value) {
  return value
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  var value$1 = value.toDouble__D();
  return value$1
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onString__T__O = (function(value) {
  return value
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onArray__sci_Vector__O = (function(value) {
  return this.onArray__sci_Vector__sjs_js_Any(value)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  return this.onObject__Lio_circe_JsonObject__sjs_js_Any(value)
});
var $d_Lio_circe_scalajs_package$$anon$1 = new $TypeData().initClass({
  Lio_circe_scalajs_package$$anon$1: 0
}, false, "io.circe.scalajs.package$$anon$1", {
  Lio_circe_scalajs_package$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Json$Folder: 1,
  F1: 1
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.$classData = $d_Lio_circe_scalajs_package$$anon$1;
function $as_Ljava_io_IOException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.IOException"))
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)))
}
function $asArrayOf_Ljava_io_IOException(obj, depth) {
  return (($isArrayOf_Ljava_io_IOException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.IOException;", depth))
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
  /*<skip>*/
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
  /*<skip>*/
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
class $c_jl_AssertionError extends $c_jl_Error {
  constructor(detailMessage) {
    super();
    var message = ("" + detailMessage);
    if ((detailMessage instanceof $c_jl_Throwable)) {
      var x2 = $as_jl_Throwable(detailMessage);
      var cause = x2
    } else {
      var cause = null
    };
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_jl_AssertionError = new $TypeData().initClass({
  jl_AssertionError: 0
}, false, "java.lang.AssertionError", {
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_AssertionError.prototype.$classData = $d_jl_AssertionError;
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($uZ($thiz) ? 1231 : 1237)
}
function $f_jl_Boolean__toString__T($thiz) {
  var b = $uZ($thiz);
  return ("" + b)
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  var that = $as_jl_Boolean(o);
  var x = $uZ($thiz);
  var y = $uZ(that);
  return ((x === y) ? 0 : (x ? 1 : (-1)))
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"))
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)))
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth))
}
var $d_jl_Boolean = new $TypeData().initClass({
  jl_Boolean: 0
}, false, "java.lang.Boolean", {
  jl_Boolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  var value = $uC($thiz);
  return value
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var $$x1 = $uC($thiz);
    var this$1 = $as_jl_Character(that);
    return ($$x1 === $uC(this$1))
  } else {
    return false
  }
}
function $f_jl_Character__toString__T($thiz) {
  var c = $uC($thiz);
  return $as_T(String.fromCharCode(c))
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var that = $as_jl_Character(o);
  var x = $uC($thiz);
  var y = $uC(that);
  return ((x - y) | 0)
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"))
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)))
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth))
}
var $d_jl_Character = new $TypeData().initClass({
  jl_Character: 0
}, false, "java.lang.Character", {
  jl_Character: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => (x instanceof $Char)));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"))
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)))
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth))
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"))
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)))
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth))
}
class $c_jl_ReflectiveOperationException extends $c_jl_Exception {
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
function $as_jl_RuntimeException(obj) {
  return (((obj instanceof $c_jl_RuntimeException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.RuntimeException"))
}
function $isArrayOf_jl_RuntimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_RuntimeException)))
}
function $asArrayOf_jl_RuntimeException(obj, depth) {
  return (($isArrayOf_jl_RuntimeException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.RuntimeException;", depth))
}
var $d_jl_RuntimeException = new $TypeData().initClass({
  jl_RuntimeException: 0
}, false, "java.lang.RuntimeException", {
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_RuntimeException.prototype.$classData = $d_jl_RuntimeException;
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  return $thiz
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
  /*<skip>*/
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_StringBuilder = (function(s, start, end) {
  var s$1 = $dp_subSequence__I__I__jl_CharSequence(((s === null) ? "null" : s), start, end);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s$1);
  return this
});
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = str.u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this
});
$c_jl_StringBuilder.prototype.deleteCharAt__I__jl_StringBuilder = (function(index) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((index < 0) || (index >= $uI(oldContent.length)))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index)
  };
  var $$x1 = $as_T(oldContent.substring(0, index));
  var beginIndex = ((1 + index) | 0);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + $$x1) + $as_T(oldContent.substring(beginIndex)));
  return this
});
$c_jl_StringBuilder.prototype.replace__I__I__T__jl_StringBuilder = (function(start, end, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var length = $uI(oldContent.length);
  if ((((start < 0) || (start > length)) || (start > end))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), start)
  };
  var firstPart = (("" + $as_T(oldContent.substring(0, start))) + str);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((end >= length) ? firstPart : (firstPart + $as_T(oldContent.substring(end))));
  return this
});
$c_jl_StringBuilder.prototype.insert__I__T__jl_StringBuilder = (function(offset, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((offset < 0) || (offset > $uI(oldContent.length)))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), offset)
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + $as_T(oldContent.substring(0, offset))) + str) + $as_T(oldContent.substring(offset)));
  return this
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return $uI(this$1.length)
});
$c_jl_StringBuilder.prototype.setLength__I__V = (function(newLength) {
  if ((newLength < 0)) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), newLength)
  };
  var newContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = newContent;
  var additional = ((newLength - $uI(this$1.length)) | 0);
  if ((additional < 0)) {
    var this$2 = newContent;
    newContent = $as_T(this$2.substring(0, newLength))
  } else {
    var i = 0;
    while ((i !== additional)) {
      newContent = (newContent + "\u0000");
      i = ((1 + i) | 0)
    }
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = newContent
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return (65535 & $uI(this$1.charCodeAt(index)))
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V(this.jl_StringBuilder__f_java$lang$StringBuilder$$content, srcBegin, srcEnd, dst, dstBegin)
});
$c_jl_StringBuilder.prototype.setCharAt__I__C__V = (function(index, ch) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((index < 0) || (index >= $uI(oldContent.length)))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index)
  };
  var $$x1 = $as_T(oldContent.substring(0, index));
  var beginIndex = ((1 + index) | 0);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + $$x1) + $bC(ch)) + $as_T(oldContent.substring(beginIndex)))
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end)
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return $as_T(this$1.substring(start, end))
});
$c_jl_StringBuilder.prototype.append__C__jl_Appendable = (function(c) {
  var str = $as_T(String.fromCharCode(c));
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuilder(csq, start, end)
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this
});
function $as_jl_StringBuilder(obj) {
  return (((obj instanceof $c_jl_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StringBuilder"))
}
function $isArrayOf_jl_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StringBuilder)))
}
function $asArrayOf_jl_StringBuilder(obj, depth) {
  return (($isArrayOf_jl_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StringBuilder;", depth))
}
var $d_jl_StringBuilder = new $TypeData().initClass({
  jl_StringBuilder: 0
}, false, "java.lang.StringBuilder", {
  jl_StringBuilder: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuilder.prototype.$classData = $d_jl_StringBuilder;
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"))
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)))
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth))
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"))
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)))
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth))
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19
  } else {
    var $$x3 = $m_ju_Arrays$();
    var $$x2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var ahi = value.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var $$x1 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x1 = value
    };
    var index = $$x3.binarySearch__AJ__J__I($$x2, $$x1);
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0))
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision)
    } else {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      var this$5 = integerAndFraction.get(1);
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = integerAndFraction.get(1).abs__Ljava_math_BigInteger();
        var compRem = absBi.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = (integerAndFraction.get(0).testBit__I__Z(0) ? 1 : 0);
        var this$6 = integerAndFraction.get(1);
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, mc.Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $$x2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var this$8 = integerAndFraction.get(0);
          integerAndFraction.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi))
        };
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          integerAndFraction.set(0, integerAndFraction.get(0).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
          var newScale__lo = lo$1;
          var newScale__hi = hi$5
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3
      };
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.get(0))
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var this$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((this$1.RTLong__f_lo === (-1)) && (this$1.RTLong__f_hi === (-1))))
  } else {
    return false
  }
}
function $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal($thiz, newScale) {
  if ($p_Ljava_math_BigDecimal__isZero__Z($thiz)) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    var ahi = newScale.RTLong__f_hi;
    return $$x1.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal((((ahi === 0) ? (newScale.RTLong__f_lo !== 0) : (ahi > 0)) ? newScale : $L0))
  } else {
    var ahi$1 = newScale.RTLong__f_hi;
    if ((ahi$1 >= 0)) {
      return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) ? $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)) : $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)))
    } else {
      var lo = newScale.RTLong__f_lo;
      var hi = newScale.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var value = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
      var hi$2 = (value >> 31);
      if ((((hi$1 === hi$2) ? (((-2147483648) ^ lo$1) < ((-2147483648) ^ value)) : (hi$1 < hi$2)) && ((($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__lptbLen$1__J__I($thiz, newScale)) | 0) < 64))) {
        var $$x2 = $m_Ljava_math_BigDecimal$();
        var this$5 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(((-newScale.RTLong__f_lo) | 0));
        var alo = this$5.RTLong__f_lo;
        var blo = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$3 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$5.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $$x2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$2, hi$3), 0)
      } else {
        var $$x5 = $m_Ljava_math_Multiplication$();
        var $$x4 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
        var $$x3 = $m_Ljava_math_BigDecimal$();
        var lo$3 = newScale.RTLong__f_lo;
        var hi$4 = newScale.RTLong__f_hi;
        var lo$4 = ((-lo$3) | 0);
        var hi$5 = ((lo$3 !== 0) ? (~hi$4) : ((-hi$4) | 0));
        var value$1 = $$x3.java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$4, hi$5));
        var hi$6 = (value$1 >> 31);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $$x5.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x4, new $c_RTLong(value$1, hi$6)), 0)
      }
    }
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(discardedPrecision);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$4 === 0) && (hi$6 === 0)))) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    if ((hi$6 < 0)) {
      var lo$5 = ((-lo$4) | 0);
      var hi$7 = ((lo$4 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var this$9__lo = lo$5;
      var this$9__hi = hi$7
    } else {
      var this$9__lo = lo$4;
      var this$9__hi = hi$6
    };
    var lo$6 = this$9__lo;
    var lo$7 = (lo$6 << 1);
    var hi$8 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
    var compRem = $$x1.java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$7, hi$8), new $c_RTLong(lo, hi));
    var frac = Math.imul(((hi$6 < 0) ? (-1) : (((hi$6 === 0) && (lo$4 === 0)) ? 0 : 1)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, mc.Ljava_math_MathContext__f_roundingMode);
    var hi$9 = (value$1 >> 31);
    var lo$8 = ((lo$3 + value$1) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$5 + hi$9) | 0)) | 0) : ((hi$5 + hi$9) | 0));
    if ((hi$10 < 0)) {
      var lo$9 = ((-lo$8) | 0);
      var hi$11 = ((lo$8 !== 0) ? (~hi$10) : ((-hi$10) | 0));
      var this$16__lo = lo$9;
      var this$16__hi = hi$11
    } else {
      var this$16__lo = lo$8;
      var this$16__hi = hi$10
    };
    var a = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$16__lo, this$16__hi);
    if (($uD(Math.log10(a)) >= mc.Ljava_math_MathContext__f_precision)) {
      var lo$10 = (((-1) + lo$1) | 0);
      var hi$12 = ((lo$10 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
      var this$19 = $m_RTLong$();
      var lo$11 = this$19.divideImpl__I__I__I__I__I(lo$8, hi$10, 10, 0);
      var hi$13 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$10, hi$12);
      var x1___2$mcJ$sp = new $c_RTLong(lo$11, hi$13)
    } else {
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
      var x1___2$mcJ$sp = new $c_RTLong(lo$8, hi$10)
    }
  } else {
    var x1___1 = null;
    var x1___2 = null;
    var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
    var x1___2$mcJ$sp = new $c_RTLong(lo$3, hi$5)
  };
  var t$2 = x1___1$mcJ$sp;
  var lo$12 = t$2.RTLong__f_lo;
  var hi$14 = t$2.RTLong__f_hi;
  var t$3 = x1___2$mcJ$sp;
  var lo$13 = t$3.RTLong__f_lo;
  var hi$15 = t$3.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$12, hi$14));
  $thiz.Ljava_math_BigDecimal__f__precision = mc.Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$13, hi$15);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$13, hi$15));
  $thiz.Ljava_math_BigDecimal__f__intVal = null
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  if (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-2147483629)) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  };
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) < bitLengthOfType)) {
    return bigInteger.longValue__J()
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0))
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(unscaledVal);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = unscaledVal.longValue__J()
  }
}
function $p_Ljava_math_BigDecimal__powTenLen$1__I__I($thiz, diffScale$2) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(diffScale$2)
}
function $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, diffScale$2) {
  var a = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = ((subtrahend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__powTenLen$1__I__I($thiz, diffScale$2)) | 0);
  return ((1 + ((a > b) ? a : b)) | 0)
}
function $p_Ljava_math_BigDecimal__powTenLen$2__I__I($thiz, negDiffScale$1) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(negDiffScale$1)
}
function $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, negDiffScale$1) {
  var a = (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__powTenLen$2__I__I($thiz, negDiffScale$1)) | 0);
  var b = subtrahend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  return ((1 + ((a > b) ? a : b)) | 0)
}
function $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal($thiz, divisor$1, diffScale$3, scale$1, roundingMode$1) {
  var scaledDividend0 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var scaledDivisor0 = divisor$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  if ((diffScale$3 > 0)) {
    var $$x1 = $m_Ljava_math_Multiplication$();
    var hi = (diffScale$3 >> 31);
    var _2 = $$x1.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDivisor0, new $c_RTLong(diffScale$3, hi));
    var x1___1 = scaledDividend0;
    var x1___2 = _2
  } else if ((diffScale$3 < 0)) {
    var $$x2 = $m_Ljava_math_Multiplication$();
    var value = ((-diffScale$3) | 0);
    var hi$1 = (value >> 31);
    var _1 = $$x2.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDividend0, new $c_RTLong(value, hi$1));
    var x1___1 = _1;
    var x1___2 = scaledDivisor0
  } else {
    var x1___1 = scaledDividend0;
    var x1___2 = scaledDivisor0
  };
  var scaledDividend = $as_Ljava_math_BigInteger(x1___1);
  var scaledDivisor = $as_Ljava_math_BigInteger(x1___2);
  return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(scaledDividend, scaledDivisor, scale$1, roundingMode$1)
}
function $p_Ljava_math_BigDecimal__cmp$1__J__I($thiz, diffScale$6) {
  return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(diffScale$6.RTLong__f_lo)) | 0)
}
function $p_Ljava_math_BigDecimal__lptbLen$1__J__I($thiz, newScale$2) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(((-newScale$2.RTLong__f_lo) | 0))
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null")
  };
  if (((((last >= in$1.u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.u.length))
  };
  var index = offset;
  if (((offset <= last) && (in$1.get(offset) === 43))) {
    index = ((1 + index) | 0);
    if ((index < last)) {
      $m_Ljava_math_BigDecimal$();
      var c = in$1.get(index);
      var array = [$bC(43), $bC(45)];
      var cs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var $$x1 = $f_sc_SeqOps__contains__O__Z(cs, $bC(c))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  } else {
    var isMinus = ((index <= last) && (in$1.get(index) === 45));
    if ((((1 + index) | 0) < last)) {
      $m_Ljava_math_BigDecimal$();
      var c$1 = in$1.get(((1 + index) | 0));
      var array$1 = [$bC(43), $bC(45)];
      var cs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      var nextIsSign = $f_sc_SeqOps__contains__O__Z(cs$1, $bC(c$1))
    } else {
      var nextIsSign = false
    };
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  };
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (true) {
    if ((index <= last)) {
      $m_Ljava_math_BigDecimal$();
      var c$2 = in$1.get(index);
      var array$2 = [$bC(46), $bC(101), $bC(69)];
      var cs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      var $$x2 = (!$f_sc_SeqOps__contains__O__Z(cs$2, $bC(c$2)))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      if ((!wasNonZero)) {
        if ((in$1.get(index) === 48)) {
          counter = ((1 + counter) | 0)
        } else {
          wasNonZero = true
        }
      };
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  var count = ((index - begin) | 0);
  var this$13 = $m_jl_String$();
  var u = this$13.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (true) {
      if ((index <= last)) {
        $m_Ljava_math_BigDecimal$();
        var c$3 = in$1.get(index);
        var array$3 = [$bC(101), $bC(69)];
        var cs$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        var $$x3 = (!$f_sc_SeqOps__contains__O__Z(cs$3, $bC(c$3)))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        if ((!wasNonZero)) {
          if ((in$1.get(index) === 48)) {
            counter = ((1 + counter) | 0)
          } else {
            wasNonZero = true
          }
        };
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$18 = $m_jl_String$();
    var _1 = (("" + u) + this$18.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b
  };
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if ((index <= last)) {
    $m_Ljava_math_BigDecimal$();
    var c$4 = in$1.get(index);
    var array$4 = [$bC(101), $bC(69)];
    var cs$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    var $$x4 = $f_sc_SeqOps__contains__O__Z(cs$4, $bC(c$4))
  } else {
    var $$x4 = false
  };
  if ($$x4) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$23 = $m_jl_String$();
    var scaleString = this$23.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$25 = $m_jl_Integer$();
    var value$1 = this$25.parseInt__T__I__I(scaleString, 10);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range")
    }
  };
  if ((bufLength < 19)) {
    var this$29 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$29.parseLong__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled))
  };
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, $uI(sVal.length));
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, $uI(sVal.length));
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null")
  };
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__($thiz, iVal) {
  $ct_Ljava_math_BigDecimal__I__I__($thiz, iVal, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__($thiz, lVal) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(augend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo + b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
      return $$x1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var this$4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var bi = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)))
  }
});
$c_Ljava_math_BigDecimal.prototype.subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(subtrahend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return subtrahend.negate__Ljava_math_BigDecimal()
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(subtrahend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo - b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
      return $$x1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var this$4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var bi = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else if ((diffScale > 0)) {
    if (((diffScale < $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I(this, subtrahend, diffScale) < 64))) {
      var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(diffScale);
      var lo$1 = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var $$x2 = $m_Ljava_math_BigDecimal$();
      var this$6 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var this$5 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$1 = this$5.RTLong__f_lo;
      var a0 = (65535 & alo$1);
      var a1 = ((alo$1 >>> 16) | 0);
      var b0 = (65535 & lo$1);
      var b1 = ((lo$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo$1, hi$1) + Math.imul(this$5.RTLong__f_hi, lo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo$2 = this$6.RTLong__f_lo;
      var ahi$1 = this$6.RTLong__f_hi;
      var lo$3 = ((alo$2 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$1 - hi$2) | 0)) | 0) : ((ahi$1 - hi$2) | 0));
      return $$x2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$3, hi$3), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var $$x4 = $m_Ljava_math_Multiplication$();
      var $$x3 = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$4 = (diffScale >> 31);
      var mult = $$x4.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x3, new $c_RTLong(diffScale, hi$4));
      var this$9 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$9, mult), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else {
    var negDiffScale = ((-diffScale) | 0);
    if (((negDiffScale < $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I(this, subtrahend, negDiffScale) < 64))) {
      var t$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(negDiffScale);
      var lo$4 = t$1.RTLong__f_lo;
      var hi$5 = t$1.RTLong__f_hi;
      var $$x5 = $m_Ljava_math_BigDecimal$();
      var this$10 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$3 = this$10.RTLong__f_lo;
      var a0$1 = (65535 & alo$3);
      var a1$1 = ((alo$3 >>> 16) | 0);
      var b0$1 = (65535 & lo$4);
      var b1$1 = ((lo$4 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$6 = ((((((((Math.imul(alo$3, hi$5) + Math.imul(this$10.RTLong__f_hi, lo$4)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var b$2 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var bhi$1 = b$2.RTLong__f_hi;
      var lo$6 = ((lo$5 - b$2.RTLong__f_lo) | 0);
      var hi$7 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$5)) ? (((-1) + ((hi$6 - bhi$1) | 0)) | 0) : ((hi$6 - bhi$1) | 0));
      return $$x5.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$6, hi$7), subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var $$x7 = $m_Ljava_math_Multiplication$();
      var $$x6 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$8 = (negDiffScale >> 31);
      var mult$2 = $$x7.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x6, new $c_RTLong(negDiffScale, hi$8));
      var bi$1 = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var multSub = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(mult$2, bi$1);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), multSub, subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(multiplicand) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) || $p_Ljava_math_BigDecimal__isZero__Z(multiplicand))) {
    return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
  } else if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0) < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo = this$4.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$4.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((lo$1 === 0) && (hi$3 === (-2147483648)))) {
      var this$5 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$5.RTLong__f_hi;
      var $$x2 = (ahi < 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$6 = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$6.RTLong__f_hi;
      var $$x1 = (ahi$1 < 0)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(63), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$3), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    var unscaled = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(multiplicand.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), unscaled, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.multiply__Ljava_math_BigDecimal__Ljava_math_MathContext__Ljava_math_BigDecimal = (function(multiplicand, mc) {
  var result = this.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal(multiplicand);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V(result, mc);
  return result
});
$c_Ljava_math_BigDecimal.prototype.divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(divisor, scale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null")
  } else if ($p_Ljava_math_BigDecimal__isZero__Z(divisor)) {
    throw new $c_jl_ArithmeticException("Division by zero")
  };
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value - value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  var hi$3 = (scale >> 31);
  var lo$1 = ((lo - scale) | 0);
  var hi$4 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ lo)) ? (((-1) + ((hi$2 - hi$3) | 0)) | 0) : ((hi$2 - hi$3) | 0));
  var hi$5 = (lo$1 >> 31);
  if ((!((lo$1 === lo$1) && (hi$5 === hi$4)))) {
    throw new $c_jl_ArithmeticException((("Unable to scale as difference is too big (" + new $c_RTLong(lo$1, hi$4)) + ")"))
  };
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) && (divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
    var lptLen = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
    if ((lo$1 === 0)) {
      var t = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$2, hi$6), scale, roundingMode)
    } else if ((lo$1 > 0)) {
      if (((lo$1 < lptLen) && (((divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(lo$1)) | 0) < 64))) {
        var this$7 = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(lo$1);
        var alo = this$7.RTLong__f_lo;
        var blo = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$3 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$7 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$7.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$7), scale, roundingMode)
      } else {
        return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
      }
    } else if (((lo$1 > ((-lptLen) | 0)) && (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(((-lo$1) | 0))) | 0) < 64))) {
      var this$8 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(((-lo$1) | 0));
      var alo$1 = this$8.RTLong__f_lo;
      var blo$1 = b$1.RTLong__f_lo;
      var a0$1 = (65535 & alo$1);
      var a1$1 = ((alo$1 >>> 16) | 0);
      var b0$1 = (65535 & blo$1);
      var b1$1 = ((blo$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$8 = ((((((((Math.imul(alo$1, b$1.RTLong__f_hi) + Math.imul(this$8.RTLong__f_hi, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(new $c_RTLong(lo$4, hi$8), divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, scale, roundingMode)
    } else {
      return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
    }
  } else {
    return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
  }
});
$c_Ljava_math_BigDecimal.prototype.negate__Ljava_math_BigDecimal = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 63)) {
    var $$x1 = true
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 63)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var $$x1 = (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var $$x2 = $m_Ljava_math_BigDecimal$();
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var lo = this$2.RTLong__f_lo;
    var hi = this$2.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().negate__Ljava_math_BigInteger(), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1)
    } else {
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$2.RTLong__f_hi;
      if (((ahi$1 === 0) ? (this$2.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1
      } else {
        return 0
      }
    }
  } else {
    var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return this$3.Ljava_math_BigInteger__f_sign
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $$x1 = 1
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $$x1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $$x3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $$x2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $$x3.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi)));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $$x1 = ((1 + decimalDigits) | 0)
      } else {
        var $$x1 = decimalDigits
      }
    };
    this.Ljava_math_BigDecimal__f__precision = $$x1
  };
  return this.Ljava_math_BigDecimal__f__precision
});
$c_Ljava_math_BigDecimal.prototype.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(newScale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null")
  };
  var hi = (newScale >> 31);
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var lo = ((newScale - value) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ newScale)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if (((lo === 0) && (hi$2 === 0))) {
    return this
  } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
    var value$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
    var hi$3 = (value$1 >> 31);
    if ((((hi$2 === hi$3) ? (((-2147483648) ^ lo) < ((-2147483648) ^ value$1)) : (hi$2 < hi$3)) && ($p_Ljava_math_BigDecimal__cmp$1__J__I(this, new $c_RTLong(lo, hi$2)) < 64))) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$5 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(lo);
      var alo = this$5.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$5.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $$x1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$4), newScale)
    } else {
      var $$x3 = $m_Ljava_math_Multiplication$();
      var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$5 = (lo >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $$x3.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x2, new $c_RTLong(lo, hi$5)), newScale)
    }
  } else {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var lo$2 = ((-lo) | 0);
      var hi$6 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var value$2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
      var hi$7 = (value$2 >> 31);
      var $$x4 = ((hi$6 === hi$7) ? (((-2147483648) ^ lo$2) < ((-2147483648) ^ value$2)) : (hi$6 < hi$7))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(((-lo) | 0));
      var lo$3 = t.RTLong__f_lo;
      var hi$8 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$8), newScale, roundingMode)
    } else {
      var $$x5 = $m_Ljava_math_Multiplication$();
      var lo$4 = ((-lo) | 0);
      var hi$9 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var powTen = $$x5.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$9));
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), powTen, newScale, roundingMode)
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.movePointLeft__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value + n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  return $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal(this, new $c_RTLong(lo, hi$2))
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return this
  } else {
    var lastPow = (((-1) + $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.testBit__I__Z(0))) {
        var qr = strippedBI.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get(i));
        var this$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
          var this$4__lo = scale__lo;
          var this$4__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = this$4__lo;
          var ahi = this$4__hi;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $$x1__lo = lo;
          var $$x1__hi = hi$2;
          scale__lo = $$x1__lo;
          scale__hi = $$x1__hi;
          continue
        };
        if ((i !== 1)) {
          i = 1;
          continue
        };
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break
      }
    };
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    var t$1 = $uJ(new $c_RTLong(lo$1, hi$3));
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$4)))
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = bi.signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && (bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
        return (-1)
      } else {
        var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = this$2.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? (((-2147483648) ^ this$2.RTLong__f_lo) > ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
          return 1
        } else {
          return 0
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
      if (((hi$3 === hi$4) ? (((-2147483648) ^ diffPrecision) > ((-2147483648) ^ lo$1)) : (hi$3 > hi$4))) {
        return thisSign
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = ((lo$2 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
        if (((hi$5 === hi$6) ? (((-2147483648) ^ diffPrecision) < ((-2147483648) ^ lo$2)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0)
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = bi.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $$x1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
            var _1 = t.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = v.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2
          } else {
            var x1___1 = t;
            var x1___2 = v
          };
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return thisUnscaled.compareTo__Ljava_math_BigInteger__I(valUnscaled)
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1)
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if ((x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var this$1 = x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
      } else {
        var xn = this.Ljava_math_BigDecimal__f__intVal;
        var yn = x2.Ljava_math_BigDecimal__f__intVal;
        return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = this$1.RTLong__f_lo;
    var $$x1 = this.Ljava_math_BigDecimal__f__hashCode;
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = this$2.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $$x1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__intVal.hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else {
    var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString
    } else {
      var this$2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2
      } else {
        var begin = 1
      };
      var end = $uI(intString.length);
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? (((-2147483648) ^ lo$2) >= 2147483642) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = (($as_T(intString.substring(0, pos)) + ".") + $as_T(intString.substring(pos)))
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = (($as_T(intString.substring(0, pos$1)) + "0.") + $as_T(intString.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = $as_T(s2.substring(0, s2Len));
          var result = ((("" + $as_T(s.substring(0, pos$2))) + s2$1) + $as_T(s.substring(pos$2)))
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), (($as_T(intString.substring(0, begin)) + ".") + $as_T(intString.substring(begin)))) : intString);
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5))
      };
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toPlainString__T = (function() {
  var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var intStr = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || ($p_Ljava_math_BigDecimal__isZero__Z(this) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)))) {
    return intStr
  } else {
    var begin = ((this.signum__I() < 0) ? 1 : 0);
    var delta = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var result = ((begin === 1) ? "-" : "");
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0)) {
      delta = ((delta - (($uI(intStr.length) - begin) | 0)) | 0);
      if ((delta >= 0)) {
        result = (result + "0.");
        while ((delta > 100)) {
          result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
          delta = (((-100) + delta) | 0)
        };
        var $$x1 = result;
        var this$2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
        var endIndex = delta;
        result = ((("" + $$x1) + $as_T(this$2.substring(0, endIndex))) + $as_T(intStr.substring(begin)))
      } else {
        delta = ((begin - delta) | 0);
        var $$x3 = result;
        var endIndex$1 = delta;
        var $$x2 = $as_T(intStr.substring(begin, endIndex$1));
        var beginIndex = delta;
        result = (($$x3 + ($$x2 + ".")) + $as_T(intStr.substring(beginIndex)))
      }
    } else {
      result = (("" + result) + $as_T(intStr.substring(begin)));
      while ((delta < (-100))) {
        result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
        delta = ((100 + delta) | 0)
      };
      var $$x4 = result;
      var this$6 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
      var endIndex$2 = ((-delta) | 0);
      result = (("" + $$x4) + $as_T(this$6.substring(0, endIndex$2)))
    };
    return result
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $$x4.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $$x4.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$5 = integerAndFraction.get(1);
    if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    return integerAndFraction.get(0)
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : this.toBigInteger__Ljava_math_BigInteger().longValue__J())
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.toBigInteger__Ljava_math_BigInteger().intValue__I())
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return this$1.RTLong__f_lo
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((this$1.RTLong__f_lo << 16) >> 16)
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((this$1.RTLong__f_lo << 24) >> 24)
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  var floatResult0 = Math.fround(this.signum__I());
  var floatResult = ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147483499) : (hi$2 < (-1))) || (floatResult0 === 0.0)) ? Math.fround((0.0 * floatResult0)) : (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147483519)) : (hi$2 > 0)) ? Math.fround((Infinity * floatResult0)) : Math.fround(this.doubleValue__D())));
  return floatResult
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  var sign = this.signum__I();
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147482574) : (hi$2 < (-1))) || (sign === 0))) {
    return (0.0 * sign)
  } else if (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147482623)) : (hi$2 > 0))) {
    return (Infinity * sign)
  } else {
    var mantissa0 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().abs__Ljava_math_BigInteger();
    var exponent = 1076;
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var value$2 = ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
      var hi$3 = (value$2 >> 31);
      var mantissa = mantissa0.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$2, hi$3)))
    } else {
      var $$x2 = $m_Ljava_math_Multiplication$();
      var value$3 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$4 = (value$3 >> 31);
      var powerOfTen = $$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$3, hi$4));
      var k = ((100 - lo$1) | 0);
      if ((k > 0)) {
        exponent = ((exponent - k) | 0);
        var m = mantissa0.shiftLeft__I__Ljava_math_BigInteger(k)
      } else {
        var m = mantissa0
      };
      var qr = m.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(powerOfTen);
      var compRem = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(powerOfTen);
      exponent = (((-2) + exponent) | 0);
      var this$7 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot.shiftLeft__I__Ljava_math_BigInteger(2);
      var $$x3 = $m_Ljava_math_BigInteger$();
      var value$4 = ((1 + ((Math.imul(compRem, ((3 + compRem) | 0)) / 2) | 0)) | 0);
      var hi$5 = (value$4 >> 31);
      var bi = $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value$4, hi$5));
      var mantissa = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi)
    };
    var lowestSetBit = mantissa.getLowestSetBit__I();
    var discardedSize = (((-54) + $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(mantissa)) | 0);
    var bits__lo = 0;
    var bits__hi = 0;
    var tempBits__lo = 0;
    var tempBits__hi = 0;
    if ((discardedSize > 0)) {
      var t = mantissa.shiftRight__I__Ljava_math_BigInteger(discardedSize).longValue__J();
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$6;
      bits__lo = $$x4__lo;
      bits__hi = $$x4__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b__lo = bits__lo;
      var b__hi = bits__hi;
      var lo$3 = (1 & b__lo);
      if (((lo$3 === 1) && (lowestSetBit < discardedSize))) {
        var $$x5 = true
      } else {
        var b$1__lo = bits__lo;
        var b$1__hi = bits__hi;
        var lo$4 = (3 & b$1__lo);
        var $$x5 = (lo$4 === 3)
      };
      if ($$x5) {
        var b$2__lo = bits__lo;
        var b$2__hi = bits__hi;
        var bhi = b$2__hi;
        var lo$5 = ((2 + b$2__lo) | 0);
        var hi$7 = ((((-2147483648) ^ lo$5) < (-2147483646)) ? ((1 + bhi) | 0) : bhi);
        var $$x6__lo = lo$5;
        var $$x6__hi = hi$7;
        bits__lo = $$x6__lo;
        bits__hi = $$x6__hi
      }
    } else {
      var this$9 = mantissa.longValue__J();
      var n = ((-discardedSize) | 0);
      var lo$6 = this$9.RTLong__f_lo;
      var lo$7 = (((32 & n) === 0) ? (lo$6 << n) : 0);
      var hi$8 = (((32 & n) === 0) ? (((((lo$6 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this$9.RTLong__f_hi << n)) : (lo$6 << n));
      var $$x7__lo = lo$7;
      var $$x7__hi = hi$8;
      bits__lo = $$x7__lo;
      bits__hi = $$x7__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b$3__lo = bits__lo;
      var b$3__hi = bits__hi;
      var lo$8 = (3 & b$3__lo);
      if ((lo$8 === 3)) {
        var b$4__lo = bits__lo;
        var b$4__hi = bits__hi;
        var bhi$1 = b$4__hi;
        var lo$9 = ((2 + b$4__lo) | 0);
        var hi$9 = ((((-2147483648) ^ lo$9) < (-2147483646)) ? ((1 + bhi$1) | 0) : bhi$1);
        var $$x8__lo = lo$9;
        var $$x8__hi = hi$9;
        bits__lo = $$x8__lo;
        bits__hi = $$x8__hi
      }
    };
    var b$5__lo = bits__lo;
    var b$5__hi = bits__hi;
    var hi$10 = (4194304 & b$5__hi);
    if ((hi$10 === 0)) {
      var this$11__lo = bits__lo;
      var this$11__hi = bits__hi;
      var hi$11 = this$11__hi;
      var lo$10 = (((this$11__lo >>> 1) | 0) | (hi$11 << 31));
      var hi$12 = (hi$11 >> 1);
      var $$x9__lo = lo$10;
      var $$x9__hi = hi$12;
      bits__lo = $$x9__lo;
      bits__hi = $$x9__hi;
      exponent = ((exponent + discardedSize) | 0)
    } else {
      var this$12__lo = bits__lo;
      var this$12__hi = bits__hi;
      var hi$13 = this$12__hi;
      var lo$11 = (((this$12__lo >>> 2) | 0) | (hi$13 << 30));
      var hi$14 = (hi$13 >> 2);
      var $$x10__lo = lo$11;
      var $$x10__hi = hi$14;
      bits__lo = $$x10__lo;
      bits__hi = $$x10__hi;
      exponent = ((exponent + ((1 + discardedSize) | 0)) | 0)
    };
    if ((exponent > 2046)) {
      return (Infinity * sign)
    } else if ((exponent < (-53))) {
      return (0.0 * sign)
    } else {
      if ((exponent <= 0)) {
        var this$13__lo = tempBits__lo;
        var this$13__hi = tempBits__hi;
        var hi$15 = this$13__hi;
        var lo$12 = (((this$13__lo >>> 1) | 0) | (hi$15 << 31));
        var hi$16 = (hi$15 >> 1);
        var $$x11__lo = lo$12;
        var $$x11__hi = hi$16;
        bits__lo = $$x11__lo;
        bits__hi = $$x11__hi;
        var this$14__lo = bits__lo;
        var this$14__hi = bits__hi;
        var n$1 = ((63 + exponent) | 0);
        var lo$13 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
        var hi$17 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
        var lo$14 = (this$14__lo & lo$13);
        var hi$18 = (this$14__hi & hi$17);
        var $$x12__lo = lo$14;
        var $$x12__hi = hi$18;
        tempBits__lo = $$x12__lo;
        tempBits__hi = $$x12__hi;
        var this$15__lo = bits__lo;
        var this$15__hi = bits__hi;
        var n$2 = ((-exponent) | 0);
        var hi$19 = this$15__hi;
        var lo$15 = (((32 & n$2) === 0) ? (((this$15__lo >>> n$2) | 0) | ((hi$19 << 1) << ((31 - n$2) | 0))) : (hi$19 >> n$2));
        var hi$20 = (((32 & n$2) === 0) ? (hi$19 >> n$2) : (hi$19 >> 31));
        var $$x13__lo = lo$15;
        var $$x13__hi = hi$20;
        bits__lo = $$x13__lo;
        bits__hi = $$x13__hi;
        var b$6__lo = bits__lo;
        var b$6__hi = bits__hi;
        var lo$16 = (3 & b$6__lo);
        if ((lo$16 === 3)) {
          var $$x14 = true
        } else {
          var b$7__lo = bits__lo;
          var b$7__hi = bits__hi;
          var lo$17 = (1 & b$7__lo);
          if ((lo$17 === 1)) {
            var this$16__lo = tempBits__lo;
            var this$16__hi = tempBits__hi;
            var $$x15 = (!((this$16__lo === 0) && (this$16__hi === 0)))
          } else {
            var $$x15 = false
          };
          if ($$x15) {
            var $$x14 = (lowestSetBit < discardedSize)
          } else {
            var $$x14 = false
          }
        };
        if ($$x14) {
          var b$8__lo = bits__lo;
          var b$8__hi = bits__hi;
          var bhi$2 = b$8__hi;
          var lo$18 = ((1 + b$8__lo) | 0);
          var hi$21 = ((lo$18 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
          var $$x16__lo = lo$18;
          var $$x16__hi = hi$21;
          bits__lo = $$x16__lo;
          bits__hi = $$x16__hi
        };
        exponent = 0;
        var this$18__lo = bits__lo;
        var this$18__hi = bits__hi;
        var hi$22 = this$18__hi;
        var lo$19 = (((this$18__lo >>> 1) | 0) | (hi$22 << 31));
        var hi$23 = (hi$22 >> 1);
        var $$x17__lo = lo$19;
        var $$x17__hi = hi$23;
        bits__lo = $$x17__lo;
        bits__hi = $$x17__hi
      };
      var hi$24 = (sign >> 31);
      var hi$25 = ((-2147483648) & hi$24);
      var value$5 = exponent;
      var hi$27 = (value$5 << 20);
      var hi$28 = (hi$25 | hi$27);
      var b$9__lo = bits__lo;
      var b$9__hi = bits__hi;
      var lo$20 = b$9__lo;
      var hi$29 = (1048575 & b$9__hi);
      var hi$30 = (hi$28 | hi$29);
      return $m_jl_FloatingPointBits$().longBitsToDouble__J__D(new $c_RTLong(lo$20, hi$30))
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  };
  return this.Ljava_math_BigDecimal__f__intVal
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__Ljava_math_BigDecimal__I($as_Ljava_math_BigDecimal(x$1))
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"))
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)))
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth))
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass({
  Ljava_math_BigDecimal: 0
}, false, "java.math.BigDecimal", {
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigDecimal.prototype.$classData = $d_Ljava_math_BigDecimal;
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  var stringLength0 = $uI(s.length);
  if (((65535 & $uI(s.charCodeAt(0))) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3
  } else if (((65535 & $uI(s.charCodeAt(0))) === 43)) {
    var _3$1 = (((-1) + stringLength0) | 0);
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = _3$1
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0
  };
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var arg1 = i;
    var c = (65535 & $uI(s.charCodeAt(arg1)));
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character")
    };
    i = ((1 + i) | 0)
  };
  var charsPerInt = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt.get(radix);
  var bigRadixDigitsLength = $intDiv(stringLength, charsPerInt);
  var topChars = $intMod(stringLength, charsPerInt);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0)
  };
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices.get((((-2) + radix) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = $as_T(s.substring(beginIndex, endIndex));
    var bigRadixDigit = $m_jl_Integer$().parseInt__T__I__I(s$1, radix);
    var this$3 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$3, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0)
  };
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V()
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range")
  };
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]))
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = digits.u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V()
  };
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo]))
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo, hi]))
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this)
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > bi.Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < bi.Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > bi.Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < bi.Ljava_math_BigInteger__f_numberLength) ? ((-bi.Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, bi.Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))))
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if ((divisor.Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if (divisor.isOne__Z()) {
    return ((divisor.Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger())
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var value = this.Ljava_math_BigInteger__f_digits.get(0);
      var value$1 = divisor.Ljava_math_BigInteger__f_digits.get(0);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value, 0, value$1, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var bi__lo = lo;
      var bi__hi = hi$2;
      if ((thisSign !== divisorSign)) {
        var this$4__lo = bi__lo;
        var this$4__hi = bi__hi;
        var lo$1 = this$4__lo;
        var hi$3 = this$4__hi;
        var lo$2 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$3) : ((-hi$3) | 0));
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$4;
        bi__lo = $$x1__lo;
        bi__hi = $$x1__hi
      };
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi))
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, divisor.Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE)
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits.get(0))
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits, divisorLen)
        };
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor).toArray__ALjava_math_BigInteger()
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = divisor.Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, divisorDigits.get(0), divisorSign)
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this)
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === x2.Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === x2.Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z(x2.Ljava_math_BigInteger__f_digits))
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1)
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = this.Ljava_math_BigInteger__f_digits.get(i);
    return (((i << 5) + ((i$1 === 0) ? 32 : ((31 - Math.clz32((i$1 & ((-i$1) | 0)))) | 0))) | 0)
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var arg1 = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + this.Ljava_math_BigInteger__f_digits.get(arg1)) | 0);
      i = ((1 + i) | 0)
    };
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, this.Ljava_math_BigInteger__f_digits.get(0))
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = this.Ljava_math_BigInteger__f_digits.get(1);
    var value$1 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$1;
    var value$3__hi = value
  } else {
    var value$2 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$2;
    var value$3__hi = 0
  };
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3__hi) + Math.imul(hi$3, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4)
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if (((bi.Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi)
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits))
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent")
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0)
    };
    return $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.shiftRight__I__Ljava_math_BigInteger(x).pow__I__Ljava_math_BigInteger(exp))
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp)
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.Ljava_math_BigInteger__f_digits.get(0)) !== 0)
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address")
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0)
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = this.Ljava_math_BigInteger__f_digits.get(intCount);
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit))
    };
    var i = (1 << (31 & n));
    return ((digit & i) !== 0)
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this)
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue
      }
    };
    break
  };
  if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0
  };
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0)
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if ((this.Ljava_math_BigInteger__f_digits.get(i) !== b.get(i))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $$x1 = (-1)
    } else {
      var i = 0;
      while ((this.Ljava_math_BigInteger__f_digits.get(i) === 0)) {
        i = ((1 + i) | 0)
      };
      var $$x1 = i
    };
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $$x1
  };
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && (this.Ljava_math_BigInteger__f_digits.get(0) === 1))
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this))
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__Ljava_math_BigInteger__I($as_Ljava_math_BigInteger(x$1))
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"))
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)))
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth))
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass({
  Ljava_math_BigInteger: 0
}, false, "java.math.BigInteger", {
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigInteger.prototype.$classData = $d_Ljava_math_BigInteger;
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass({
  Ljava_math_RoundingMode: 0
}, false, "java.math.RoundingMode", {
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode.prototype.$classData = $d_Ljava_math_RoundingMode;
/** @constructor */
function $c_Ljava_time_Period(years, months, days) {
  this.Ljava_time_Period__f_years = 0;
  this.Ljava_time_Period__f_months = 0;
  this.Ljava_time_Period__f_days = 0;
  this.Ljava_time_Period__f_years = years;
  this.Ljava_time_Period__f_months = months;
  this.Ljava_time_Period__f_days = days
}
$c_Ljava_time_Period.prototype = new $h_O();
$c_Ljava_time_Period.prototype.constructor = $c_Ljava_time_Period;
/** @constructor */
function $h_Ljava_time_Period() {
  /*<skip>*/
}
$h_Ljava_time_Period.prototype = $c_Ljava_time_Period.prototype;
$c_Ljava_time_Period.prototype.isZero__Z = (function() {
  return (this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period())
});
$c_Ljava_time_Period.prototype.toTotalMonths__J = (function() {
  var value = this.Ljava_time_Period__f_years;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = this.Ljava_time_Period__f_months;
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  return new $c_RTLong(lo$1, hi$3)
});
$c_Ljava_time_Period.prototype.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var _temporal = temporal;
  var obj = _temporal;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  if ((this.Ljava_time_Period__f_years !== 0)) {
    if ((this.Ljava_time_Period__f_months !== 0)) {
      _temporal = _temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(this.toTotalMonths__J(), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit())
    } else {
      var $$x1 = _temporal;
      var value = this.Ljava_time_Period__f_years;
      var hi = (value >> 31);
      _temporal = $$x1.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value, hi), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit())
    }
  } else if ((this.Ljava_time_Period__f_months !== 0)) {
    var $$x2 = _temporal;
    var value$1 = this.Ljava_time_Period__f_months;
    var hi$1 = (value$1 >> 31);
    _temporal = $$x2.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$1, hi$1), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit())
  };
  if ((this.Ljava_time_Period__f_days !== 0)) {
    var $$x3 = _temporal;
    var value$2 = this.Ljava_time_Period__f_days;
    var hi$2 = (value$2 >> 31);
    _temporal = $$x3.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$2, hi$2), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit())
  };
  return _temporal
});
$c_Ljava_time_Period.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Period)) {
    var other = $as_Ljava_time_Period(obj);
    return ((this === other) || (((this.Ljava_time_Period__f_years === other.Ljava_time_Period__f_years) && (this.Ljava_time_Period__f_months === other.Ljava_time_Period__f_months)) && (this.Ljava_time_Period__f_days === other.Ljava_time_Period__f_days)))
  } else {
    return false
  }
});
$c_Ljava_time_Period.prototype.hashCode__I = (function() {
  var $$x1 = this.Ljava_time_Period__f_years;
  var i = this.Ljava_time_Period__f_months;
  var i$1 = this.Ljava_time_Period__f_days;
  return (((($$x1 + ((i << 8) | ((i >>> 24) | 0))) | 0) + ((i$1 << 16) | ((i$1 >>> 16) | 0))) | 0)
});
$c_Ljava_time_Period.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period())) {
    return "P0D"
  } else {
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    buf.append__C__scm_StringBuilder(80);
    if ((this.Ljava_time_Period__f_years !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_years).append__C__scm_StringBuilder(89)
    };
    if ((this.Ljava_time_Period__f_months !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_months).append__C__scm_StringBuilder(77)
    };
    if ((this.Ljava_time_Period__f_days !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_days).append__C__scm_StringBuilder(68)
    };
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
function $as_Ljava_time_Period(obj) {
  return (((obj instanceof $c_Ljava_time_Period) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Period"))
}
function $isArrayOf_Ljava_time_Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Period)))
}
function $asArrayOf_Ljava_time_Period(obj, depth) {
  return (($isArrayOf_Ljava_time_Period(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Period;", depth))
}
var $d_Ljava_time_Period = new $TypeData().initClass({
  Ljava_time_Period: 0
}, false, "java.time.Period", {
  Ljava_time_Period: 1,
  O: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  Ljava_time_chrono_ChronoPeriod: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Period.prototype.$classData = $d_Ljava_time_Period;
function $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I($thiz) {
  var this$1 = $thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  return (($$x1 - this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = transition;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = offsetBefore;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = offsetAfter
}
$c_Ljava_time_zone_ZoneOffsetTransition.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransition;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransition() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransition.prototype = $c_Ljava_time_zone_ZoneOffsetTransition.prototype;
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.isGap__Z = (function() {
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  return ($$x1 > this$2.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.getValidOffsets__ju_List = (function() {
  if (this.isGap__Z()) {
    var this$1 = $m_ju_Collections$();
    return this$1.EMPTY_LIST__ju_List()
  } else {
    var a = new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)([this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore, this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter]);
    return $m_ju_Arrays$().asList__AO__ju_List(a)
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var zot = $as_Ljava_time_zone_ZoneOffsetTransition(other);
    if ((this === zot)) {
      return true
    } else {
      var x = this.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var x$2 = zot.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var x$4 = zot.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        var x$6 = zot.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.hashCode__I = (function() {
  var $$x2 = this.Ljava_time_zone_ZoneOffsetTransition__f_transition.hashCode__I();
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var i = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  return (($$x2 ^ $$x1) ^ ((i << 16) | ((i >>> 16) | 0)))
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  buf.append__T__scm_StringBuilder("Transition[").append__T__scm_StringBuilder((this.isGap__Z() ? "Gap" : "Overlap")).append__T__scm_StringBuilder(" at ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_transition).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore).append__T__scm_StringBuilder(" to ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter).append__C__scm_StringBuilder(93);
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_zone_ZoneOffsetTransition(that);
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  var other$1 = other.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(other.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return this$1.compare__Ljava_time_Instant__I(other$1)
});
function $as_Ljava_time_zone_ZoneOffsetTransition(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneOffsetTransition) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneOffsetTransition"))
}
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransition)))
}
function $asArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneOffsetTransition;", depth))
}
var $d_Ljava_time_zone_ZoneOffsetTransition = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransition: 0
}, false, "java.time.zone.ZoneOffsetTransition", {
  Ljava_time_zone_ZoneOffsetTransition: 1,
  O: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransition;
function $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V($thiz) {
  if (($thiz.ju_AbstractRandomAccessListIterator__f_last === (-1))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException())
  }
}
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_start = start;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz
}
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_start = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0
}
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end)
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last)
});
$c_ju_AbstractRandomAccessListIterator.prototype.remove__V = (function() {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.remove__I__V(this.ju_AbstractRandomAccessListIterator__f_last);
  if ((this.ju_AbstractRandomAccessListIterator__f_last < this.ju_AbstractRandomAccessListIterator__f_i)) {
    this.ju_AbstractRandomAccessListIterator__f_i = (((-1) + this.ju_AbstractRandomAccessListIterator__f_i) | 0)
  };
  this.ju_AbstractRandomAccessListIterator__f_last = (-1);
  this.ju_AbstractRandomAccessListIterator__f_end = (((-1) + this.ju_AbstractRandomAccessListIterator__f_end) | 0)
});
$c_ju_AbstractRandomAccessListIterator.prototype.set__O__V = (function(e) {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.set__I__O__V(this.ju_AbstractRandomAccessListIterator__f_last, e)
});
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s])
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s1, s2])
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s1, s2, s3])
  }
}
function $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, ss) {
  try {
    var len = $uI(ss.length);
    var i = 0;
    while ((i < len)) {
      var arg1 = ss[i];
      var x$1 = $as_T(arg1);
      $thiz.ju_Formatter__f_dest.append__jl_CharSequence__jl_Appendable(x$1);
      i = ((1 + i) | 0)
    }
  } catch (e) {
    if (false) {
      var th = $as_Ljava_io_IOException(e);
      $thiz.ju_Formatter__f_java$util$Formatter$$lastIOException = th
    } else {
      throw e
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var fmtLength = $uI(format.length);
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var fromIndex = fmtIndex;
    var nextPercentIndex = $uI(format.indexOf("%", fromIndex));
    if ((nextPercentIndex < 0)) {
      var beginIndex = fmtIndex;
      $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(format.substring(beginIndex)));
      return $thiz
    };
    var beginIndex$1 = fmtIndex;
    $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(format.substring(beginIndex$1, nextPercentIndex)));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ($uI(execResult.index) !== formatSpecifierIndex))) {
      var conversion = ((formatSpecifierIndex === fmtLength) ? 37 : (65535 & $uI(format.charCodeAt(formatSpecifierIndex))));
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion)
    };
    fmtIndex = $uI(re.lastIndex);
    var index = (((-1) + fmtIndex) | 0);
    var conversion$2 = (65535 & $uI(format.charCodeAt(index)));
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, $as_T(execResult[2]), conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__sjs_js_$bar__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__sjs_js_$bar__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648))
    };
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648))
    };
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width)
      };
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n")
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2))
      };
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%")
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags.get((((-97) + conversionLower) | 0));
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2)
      };
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags)
      };
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__sjs_js_$bar__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i)
          };
          var argIndex = i
        }
      };
      if (((argIndex <= 0) || (argIndex > args.u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      lastArgIndex = argIndex;
      var arg = args.get((((-1) + argIndex) | 0));
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null")
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision)
      }
    }
  };
  return $thiz
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((conversion >= 65) && (conversion <= 90)) ? 256 : 0);
  var len = $uI(flags.length);
  var i = 0;
  while ((i !== len)) {
    var index = i;
    var f = (65535 & $uI(flags.charCodeAt(index)));
    switch (f) {
      case 45: {
        var bit = 1;
        break
      }
      case 35: {
        var bit = 2;
        break
      }
      case 43: {
        var bit = 4;
        break
      }
      case 32: {
        var bit = 8;
        break
      }
      case 48: {
        var bit = 16;
        break
      }
      case 44: {
        var bit = 32;
        break
      }
      case 40: {
        var bit = 64;
        break
      }
      case 60: {
        var bit = 128;
        break
      }
      default: {
        var bit;
        throw new $c_s_MatchError($bC(f))
      }
    };
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f)
    };
    bits = (bits | bit);
    i = ((1 + i) | 0)
  };
  return bits
}
function $p_ju_Formatter__parsePositiveInt__sjs_js_$bar__I($thiz, capture) {
  if ((capture === (void 0))) {
    return (-1)
  } else {
    var s = $as_T(capture);
    var x = $uD(parseInt(s, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2))
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break
    }
    case 104: {
      var i = $dp_hashCode__I(arg);
      var str$2 = $as_T($uD((i >>> 0)).toString(16));
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var x2 = $as_ju_Formattable(arg);
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        x2.formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision)
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2)
        };
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3)
      };
      break
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = $as_T(String.fromCharCode(x2$2))
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x3 = $uI(arg);
        if ((!((x3 >= 0) && (x3 <= 1114111)))) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3)
        };
        if ((x3 < 65536)) {
          var str$4 = $as_T(String.fromCharCode(x3))
        } else {
          var $$x2 = String;
          var value = (55296 | (((-64) + (x3 >> 10)) | 0));
          var value$1 = (56320 | (1023 & x3));
          var $$x1 = $$x2.fromCharCode(value, value$1);
          var str$4 = $as_T($$x1)
        }
      };
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = $uI(arg);
        var str$5 = ("" + x2$3)
      } else if ((arg instanceof $c_RTLong)) {
        var t = $uJ(arg);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var str$5 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x4 = $as_Ljava_math_BigInteger(arg);
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(x4)
      };
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var x2$4 = $as_Ljava_math_BigInteger(arg);
        var radix = (isOctal ? 8 : 16);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(x2$4, radix), prefix)
      } else {
        if ($isInt(arg)) {
          var x2$5 = $uI(arg);
          var str$6 = (isOctal ? $as_T($uD((x2$5 >>> 0)).toString(8)) : $as_T($uD((x2$5 >>> 0)).toString(16)))
        } else {
          if ((!(arg instanceof $c_RTLong))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
          };
          var t$1 = $uJ(arg);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          if (isOctal) {
            var this$17 = $m_jl_Long$();
            var str$6 = this$17.java$lang$Long$$toOctalString__I__I__T(lo$1, hi$1)
          } else {
            var this$18 = $m_jl_Long$();
            var str$6 = this$18.java$lang$Long$$toHexString__I__I__T(lo$1, hi$1)
          }
        };
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76)
        };
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6))
      };
      break
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = $uD(arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6)
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width)
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        var x3$4 = $as_Ljava_math_BigDecimal(arg);
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(x3$4), flags, precision, conversionLower, localeInfo, width)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = $uD(arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    default: {
      throw new $c_jl_AssertionError((("Unknown conversion '" + $bC(conversionLower)) + "' was not rejected earlier"))
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""))
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = x.round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var fractionalDigitCount = (((-1) + $uI(intStr.length)) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var integerPart = $as_T(intStr.substring(0, 1));
  var fractionalPart = (("" + $as_T(intStr.substring(1))) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - rounded.ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var this$3 = ((exponent < 0) ? ((-exponent) | 0) : exponent);
  var exponentAbsStr0 = ("" + this$3);
  var exponentAbsStr = (($uI(exponentAbsStr0.length) === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr)
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = x.setScale__I__ju_Formatter$Decimal(scale);
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var intStrLen = $uI(intStr.length);
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var dotPos = (($uI(expandedIntStr.length) - scale) | 0);
  var integerPart = (signStr + $as_T(expandedIntStr.substring(0, dotPos)));
  return (((scale === 0) && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + $as_T(expandedIntStr.substring(dotPos))))
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = x.round__I__ju_Formatter$Decimal(p);
  var this$1 = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var orderOfMagnitude = (((((-1) + $uI(this$1.length)) | 0) - rounded.ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = (((-1) + ((p - orderOfMagnitude) | 0)) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep)
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, (((-1) + p) | 0), forceDecimalSep)
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg)
  } else {
    var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(arg);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo === 0) && (hi$1 === 0))) {
        var x1___1 = "0";
        var x1___2 = $L0;
        var x1___3 = 0
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = new $c_RTLong(lo, hi$1);
        var x1___3 = (-1022)
      } else {
        var leadingZeros = ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo)) | 0));
        var shift = (((-11) + leadingZeros) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - shift) | 0)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = new $c_RTLong(lo$2, hi$3);
        var x1___3 = normalizedExponent
      }
    } else {
      var _3 = (((-1023) + biasedExponent) | 0);
      var x1___1 = "1";
      var x1___2 = new $c_RTLong(lo, hi$1);
      var x1___3 = _3
    };
    var implicitBitStr = $as_T(x1___1);
    var t$1 = $uJ(x1___2);
    var lo$3 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var exponent = $uI(x1___3);
    var t$2 = $uJ(new $c_RTLong(lo$3, hi$4));
    var lo$4 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    if ((actualPrecision === (-1))) {
      var roundedMantissa__lo = lo$4;
      var roundedMantissa__hi = hi$5
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$5 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$6 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$6 = (((-1) + lo$5) | 0);
      var hi$7 = ((lo$6 !== (-1)) ? hi$6 : (((-1) + hi$6) | 0));
      var lo$7 = (((lo$5 >>> 1) | 0) | (hi$6 << 31));
      var hi$8 = (hi$6 >> 1);
      var lo$8 = (~lo$6);
      var hi$9 = (~hi$7);
      var lo$9 = (lo$4 & lo$8);
      var hi$10 = (hi$5 & hi$9);
      var lo$10 = (lo$4 & lo$6);
      var hi$11 = (hi$5 & hi$7);
      if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) < ((-2147483648) ^ lo$7)) : (hi$11 < hi$8))) {
        var roundedMantissa__lo = lo$9;
        var roundedMantissa__hi = hi$10
      } else if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) > ((-2147483648) ^ lo$7)) : (hi$11 > hi$8))) {
        var lo$11 = ((lo$9 + lo$5) | 0);
        var hi$12 = ((((-2147483648) ^ lo$11) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
        var roundedMantissa__lo = lo$11;
        var roundedMantissa__hi = hi$12
      } else {
        var lo$12 = (lo$9 & lo$5);
        var hi$13 = (hi$10 & hi$6);
        if (((lo$12 === 0) && (hi$13 === 0))) {
          var roundedMantissa__lo = lo$9;
          var roundedMantissa__hi = hi$10
        } else {
          var lo$13 = ((lo$9 + lo$5) | 0);
          var hi$14 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
          var roundedMantissa__lo = lo$13;
          var roundedMantissa__hi = hi$14
        }
      }
    };
    var this$10 = $m_jl_Long$();
    var hi$15 = roundedMantissa__hi;
    var baseStr = this$10.java$lang$Long$$toHexString__I__I__T(roundedMantissa__lo, hi$15);
    var beginIndex = $uI(baseStr.length);
    var padded = (("" + $as_T("0000000000000".substring(beginIndex))) + baseStr);
    $m_ju_Formatter$();
    var condition = ($uI(padded.length) === 13);
    if ((!condition)) {
      throw new $c_jl_AssertionError("padded mantissa does not have the right number of bits")
    };
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = $uI(padded.length);
    while (true) {
      if ((len > minLength)) {
        var index = (((-1) + len) | 0);
        var $$x1 = ((65535 & $uI(padded.charCodeAt(index))) === 48)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        len = (((-1) + len) | 0)
      } else {
        break
      }
    };
    var endIndex = len;
    var mantissaStr = $as_T(padded.substring(0, endIndex));
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest))
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  var truncatedStr = ((precision < 0) ? str : $as_T(str.substring(0, precision)));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr))
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  if ((($uI(str.length) >= width) && ((110 & flags) === 0))) {
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1)
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
  } else {
    if (((65535 & $uI(str.charCodeAt(0))) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str
      } else {
        var x1___1 = "";
        var x1___2 = str
      }
    } else if (((64 & flags) !== 0)) {
      var _2 = ($as_T(str.substring(1)) + ")");
      var x1___1 = "(";
      var x1___2 = _2
    } else {
      var _2$1 = $as_T(str.substring(1));
      var x1___1 = "-";
      var x1___2 = _2$1
    };
    var numberPrefix = $as_T(x1___1);
    var rest0 = $as_T(x1___2);
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2)
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  var len = $uI(s.length);
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var index$1 = index;
      var c = (65535 & $uI(s.charCodeAt(index$1)));
      var $$x1 = ((c >= 48) && (c <= 57))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  index = (((-3) + index) | 0);
  if ((index <= 0)) {
    return s
  } else {
    var beginIndex = index;
    var result = $as_T(s.substring(beginIndex));
    while ((index > 3)) {
      var next = (((-3) + index) | 0);
      var endIndex = index;
      result = (($as_T(s.substring(next, endIndex)) + ",") + result);
      index = next
    };
    var endIndex$1 = index;
    return (($as_T(s.substring(0, endIndex$1)) + ",") + result)
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  return (((256 & flags) !== 0) ? $as_T(str.toUpperCase()) : str)
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  return (((256 & flags) !== 0) ? $as_T(str.toUpperCase()) : str)
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var len = $uI(str.length);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str)
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var len = (($uI(prefix.length) + $uI(str.length)) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str)
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, "0", ((width - len) | 0)), str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str)
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0)
  };
  return result
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException($as_T(String.fromCharCode(flag)))
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException($as_T(String.fromCharCode(conversion)))
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision)
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width)
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  var msg = ((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)");
  throw new $c_ju_IllegalFormatArgumentIndexException(msg)
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg)
}
function $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult$1) {
  return ("%" + execResult$1[0])
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep)
    }
  };
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "")
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  $thiz.ju_Formatter__f_java$util$Formatter$$lastIOException = null;
  return $thiz
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz
}
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false;
  this.ju_Formatter__f_java$util$Formatter$$lastIOException = null
}
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
  /*<skip>*/
}
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args)
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : this.ju_Formatter__f_dest.toString__T())
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags))
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower)
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(arg))
});
var $d_ju_Formatter = new $TypeData().initClass({
  ju_Formatter: 0
}, false, "java.util.Formatter", {
  ju_Formatter: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_ju_Formatter.prototype.$classData = $d_ju_Formatter;
/** @constructor */
function $c_ju_Locale$LocaleBuilder(strict, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes) {
  this.ju_Locale$LocaleBuilder__f_strict = false;
  this.ju_Locale$LocaleBuilder__f_language = null;
  this.ju_Locale$LocaleBuilder__f_region = null;
  this.ju_Locale$LocaleBuilder__f_variant = null;
  this.ju_Locale$LocaleBuilder__f_script = null;
  this.ju_Locale$LocaleBuilder__f_extensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = null;
  this.ju_Locale$LocaleBuilder__f_strict = strict;
  this.ju_Locale$LocaleBuilder__f_language = language;
  this.ju_Locale$LocaleBuilder__f_region = region;
  this.ju_Locale$LocaleBuilder__f_variant = variant;
  this.ju_Locale$LocaleBuilder__f_script = script;
  this.ju_Locale$LocaleBuilder__f_extensions = extensions;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = unicodeAttributes
}
$c_ju_Locale$LocaleBuilder.prototype = new $h_O();
$c_ju_Locale$LocaleBuilder.prototype.constructor = $c_ju_Locale$LocaleBuilder;
/** @constructor */
function $h_ju_Locale$LocaleBuilder() {
  /*<skip>*/
}
$h_ju_Locale$LocaleBuilder.prototype = $c_ju_Locale$LocaleBuilder.prototype;
$c_ju_Locale$LocaleBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_ju_Locale$LocaleBuilder.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LocaleBuilder");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.ju_Locale$LocaleBuilder__f_strict ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.ju_Locale$LocaleBuilder__f_language;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.ju_Locale$LocaleBuilder__f_region;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.ju_Locale$LocaleBuilder__f_variant;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.ju_Locale$LocaleBuilder__f_script;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.ju_Locale$LocaleBuilder__f_extensions;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8)
});
$c_ju_Locale$LocaleBuilder.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_ju_Locale$LocaleBuilder)) {
    var x$0$2 = $as_ju_Locale$LocaleBuilder(x$0);
    if ((this.ju_Locale$LocaleBuilder__f_strict === x$0$2.ju_Locale$LocaleBuilder__f_strict)) {
      var x = this.ju_Locale$LocaleBuilder__f_language;
      var x$2 = x$0$2.ju_Locale$LocaleBuilder__f_language;
      var $$x6 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$3 = this.ju_Locale$LocaleBuilder__f_region;
      var x$4 = x$0$2.ju_Locale$LocaleBuilder__f_region;
      var $$x5 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$5 = this.ju_Locale$LocaleBuilder__f_variant;
      var x$6 = x$0$2.ju_Locale$LocaleBuilder__f_variant;
      var $$x4 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$7 = this.ju_Locale$LocaleBuilder__f_script;
      var x$8 = x$0$2.ju_Locale$LocaleBuilder__f_script;
      var $$x3 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$9 = this.ju_Locale$LocaleBuilder__f_extensions;
      var x$10 = x$0$2.ju_Locale$LocaleBuilder__f_extensions;
      var $$x2 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$11 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var x$12 = x$0$2.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var $$x1 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$13 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var x$14 = x$0$2.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      return ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_Locale$LocaleBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_ju_Locale$LocaleBuilder.prototype.productArity__I = (function() {
  return 8
});
$c_ju_Locale$LocaleBuilder.prototype.productPrefix__T = (function() {
  return "LocaleBuilder"
});
$c_ju_Locale$LocaleBuilder.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.ju_Locale$LocaleBuilder__f_strict;
      break
    }
    case 1: {
      return this.ju_Locale$LocaleBuilder__f_language;
      break
    }
    case 2: {
      return this.ju_Locale$LocaleBuilder__f_region;
      break
    }
    case 3: {
      return this.ju_Locale$LocaleBuilder__f_variant;
      break
    }
    case 4: {
      return this.ju_Locale$LocaleBuilder__f_script;
      break
    }
    case 5: {
      return this.ju_Locale$LocaleBuilder__f_extensions;
      break
    }
    case 6: {
      return this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      break
    }
    case 7: {
      return this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_ju_Locale$LocaleBuilder.prototype.language__T__s_Option = (function(language) {
  if (((language === null) || (language === ""))) {
    var language$3 = $m_s_None$();
    var strict$1 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$1 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$3 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$3 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$1 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$1 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$1 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$1, language$3, region$1, variant$3, script$3, extensions$1, unicodeExtensions$1, unicodeAttributes$1);
    return new $c_s_Some(value)
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkLanguage__T__Z(language))) {
    var value$1 = $as_T(language.toLowerCase());
    var language$4 = new $c_s_Some(value$1);
    var strict$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$2 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$4 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$4 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$2 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$2 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$2 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$2, language$4, region$2, variant$4, script$4, extensions$2, unicodeExtensions$2, unicodeAttributes$2);
    return new $c_s_Some(value$2)
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.script__T__s_Option = (function(script) {
  if (((script === null) || (script === ""))) {
    var script$5 = $m_s_None$();
    var strict$3 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$5 = this.ju_Locale$LocaleBuilder__f_language;
    var region$3 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$5 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$3 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$3 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$3 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$3, language$5, region$3, variant$5, script$5, extensions$3, unicodeExtensions$3, unicodeAttributes$3);
    return new $c_s_Some(value)
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkScript__T__Z(script))) {
    var c = (65535 & $uI(script.charCodeAt(0)));
    var value$1 = (("" + $bC($m_jl_Character$().toUpperCase__C__C(c))) + $as_T(script.substring(1)));
    var script$6 = new $c_s_Some(value$1);
    var strict$4 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$6 = this.ju_Locale$LocaleBuilder__f_language;
    var region$4 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$6 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$4 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$4 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$4 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$4, language$6, region$4, variant$6, script$6, extensions$4, unicodeExtensions$4, unicodeAttributes$4);
    return new $c_s_Some(value$2)
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.region__T__s_Option = (function(region) {
  if (((region === null) || (region === ""))) {
    var region$5 = $m_s_None$();
    var strict$5 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$7 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$7 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$7 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$5 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$5 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$5, language$7, region$5, variant$7, script$7, extensions$5, unicodeExtensions$5, unicodeAttributes$5);
    return new $c_s_Some(value)
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkRegion__T__Z(region))) {
    var value$1 = $as_T(region.toUpperCase());
    var region$6 = new $c_s_Some(value$1);
    var strict$6 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$8 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$8 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$8 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$6 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$6, language$8, region$6, variant$8, script$8, extensions$6, unicodeExtensions$6, unicodeAttributes$6);
    return new $c_s_Some(value$2)
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.variant__T__s_Option = (function(variant) {
  if (((variant === null) || (variant === ""))) {
    var variant$10 = $m_s_None$();
    var strict$8 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$10 = this.ju_Locale$LocaleBuilder__f_language;
    var region$8 = this.ju_Locale$LocaleBuilder__f_region;
    var script$10 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$8 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$8 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$8, language$10, region$8, variant$10, script$10, extensions$8, unicodeExtensions$8, unicodeAttributes$8);
    return new $c_s_Some(value)
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkVariant__T__Z(variant))) {
    var value$1 = $as_T(variant.split("-").join("_"));
    var variant$11 = new $c_s_Some(value$1);
    var strict$9 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$11 = this.ju_Locale$LocaleBuilder__f_language;
    var region$9 = this.ju_Locale$LocaleBuilder__f_region;
    var script$11 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$9 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$9 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$9 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$9, language$11, region$9, variant$11, script$11, extensions$9, unicodeExtensions$9, unicodeAttributes$9);
    return new $c_s_Some(value$2)
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.build__ju_Locale = (function() {
  var this$1 = this.ju_Locale$LocaleBuilder__f_language;
  var $$x2 = $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()));
  var this$2 = this.ju_Locale$LocaleBuilder__f_region;
  var $$x1 = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
  var this$3 = this.ju_Locale$LocaleBuilder__f_variant;
  return new $c_ju_Locale($$x2, $$x1, $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())), this.ju_Locale$LocaleBuilder__f_script, this.ju_Locale$LocaleBuilder__f_extensions, this.ju_Locale$LocaleBuilder__f_unicodeExtensions, this.ju_Locale$LocaleBuilder__f_unicodeAttributes, ($m_ju_Locale$(), true))
});
function $as_ju_Locale$LocaleBuilder(obj) {
  return (((obj instanceof $c_ju_Locale$LocaleBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$LocaleBuilder"))
}
function $isArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$LocaleBuilder)))
}
function $asArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (($isArrayOf_ju_Locale$LocaleBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$LocaleBuilder;", depth))
}
var $d_ju_Locale$LocaleBuilder = new $TypeData().initClass({
  ju_Locale$LocaleBuilder: 0
}, false, "java.util.Locale$LocaleBuilder", {
  ju_Locale$LocaleBuilder: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$LocaleBuilder.prototype.$classData = $d_ju_Locale$LocaleBuilder;
/** @constructor */
function $c_ju_SimpleTimeZone(rawOffset, ID) {
  this.ju_TimeZone__f_ID = null;
  this.ju_SimpleTimeZone__f_rawOffset = 0;
  this.ju_SimpleTimeZone__f_ID = null;
  this.ju_SimpleTimeZone__f_rawOffset = rawOffset;
  this.ju_SimpleTimeZone__f_ID = ID;
  $ct_ju_TimeZone__(this)
}
$c_ju_SimpleTimeZone.prototype = new $h_ju_TimeZone();
$c_ju_SimpleTimeZone.prototype.constructor = $c_ju_SimpleTimeZone;
/** @constructor */
function $h_ju_SimpleTimeZone() {
  /*<skip>*/
}
$h_ju_SimpleTimeZone.prototype = $c_ju_SimpleTimeZone.prototype;
var $d_ju_SimpleTimeZone = new $TypeData().initClass({
  ju_SimpleTimeZone: 0
}, false, "java.util.SimpleTimeZone", {
  ju_SimpleTimeZone: 1,
  ju_TimeZone: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_SimpleTimeZone.prototype.$classData = $d_ju_SimpleTimeZone;
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"))
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)))
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth))
}
var $d_ju_concurrent_TimeUnit = new $TypeData().initClass({
  ju_concurrent_TimeUnit: 0
}, false, "java.util.concurrent.TimeUnit", {
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit.prototype.$classData = $d_ju_concurrent_TimeUnit;
/** @constructor */
function $c_Llocales_cldr_CLDRMetadata(isoCountries, iso3Countries, isoLanguages, iso3Languages, scripts) {
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = null;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = null;
  this.Llocales_cldr_CLDRMetadata__f_scripts = null;
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = isoCountries;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = iso3Countries;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = isoLanguages;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = iso3Languages;
  this.Llocales_cldr_CLDRMetadata__f_scripts = scripts
}
$c_Llocales_cldr_CLDRMetadata.prototype = new $h_O();
$c_Llocales_cldr_CLDRMetadata.prototype.constructor = $c_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $h_Llocales_cldr_CLDRMetadata() {
  /*<skip>*/
}
$h_Llocales_cldr_CLDRMetadata.prototype = $c_Llocales_cldr_CLDRMetadata.prototype;
$c_Llocales_cldr_CLDRMetadata.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_CLDRMetadata.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CLDRMetadata.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_CLDRMetadata)) {
    var x$0$2 = $as_Llocales_cldr_CLDRMetadata(x$0);
    var x = this.Llocales_cldr_CLDRMetadata__f_isoCountries;
    var x$2 = x$0$2.Llocales_cldr_CLDRMetadata__f_isoCountries;
    if ((x === x$2)) {
      var x$3 = this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var x$4 = x$0$2.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var $$x3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$5 = this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      var x$6 = x$0$2.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      var $$x2 = (x$5 === x$6)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var x$8 = x$0$2.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var $$x1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Llocales_cldr_CLDRMetadata__f_scripts;
      var x$10 = x$0$2.Llocales_cldr_CLDRMetadata__f_scripts;
      return (x$9 === x$10)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_CLDRMetadata.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CLDRMetadata.prototype.productArity__I = (function() {
  return 5
});
$c_Llocales_cldr_CLDRMetadata.prototype.productPrefix__T = (function() {
  return "CLDRMetadata"
});
$c_Llocales_cldr_CLDRMetadata.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CLDRMetadata__f_isoCountries;
      break
    }
    case 1: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      break
    }
    case 2: {
      return this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      break
    }
    case 3: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      break
    }
    case 4: {
      return this.Llocales_cldr_CLDRMetadata__f_scripts;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_CLDRMetadata(obj) {
  return (((obj instanceof $c_Llocales_cldr_CLDRMetadata) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CLDRMetadata"))
}
function $isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CLDRMetadata)))
}
function $asArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CLDRMetadata;", depth))
}
var $d_Llocales_cldr_CLDRMetadata = new $TypeData().initClass({
  Llocales_cldr_CLDRMetadata: 0
}, false, "locales.cldr.CLDRMetadata", {
  Llocales_cldr_CLDRMetadata: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CLDRMetadata.prototype.$classData = $d_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns) {
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = datePatterns;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = timePatterns
}
$c_Llocales_cldr_CalendarPatterns.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns.prototype.constructor = $c_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns() {
  /*<skip>*/
}
$h_Llocales_cldr_CalendarPatterns.prototype = $c_Llocales_cldr_CalendarPatterns.prototype;
$c_Llocales_cldr_CalendarPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_CalendarPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CalendarPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarPatterns)) {
    var x$0$2 = $as_Llocales_cldr_CalendarPatterns(x$0);
    var x = this.Llocales_cldr_CalendarPatterns__f_datePatterns;
    var x$2 = x$0$2.Llocales_cldr_CalendarPatterns__f_datePatterns;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarPatterns__f_timePatterns;
      var x$4 = x$0$2.Llocales_cldr_CalendarPatterns__f_timePatterns;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_CalendarPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CalendarPatterns.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CalendarPatterns.prototype.productPrefix__T = (function() {
  return "CalendarPatterns"
});
$c_Llocales_cldr_CalendarPatterns.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_CalendarPatterns__f_datePatterns
  };
  if ((n === 1)) {
    return this.Llocales_cldr_CalendarPatterns__f_timePatterns
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Llocales_cldr_CalendarPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarPatterns"))
}
function $isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarPatterns)))
}
function $asArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarPatterns;", depth))
}
var $d_Llocales_cldr_CalendarPatterns = new $TypeData().initClass({
  Llocales_cldr_CalendarPatterns: 0
}, false, "locales.cldr.CalendarPatterns", {
  Llocales_cldr_CalendarPatterns: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CalendarPatterns.prototype.$classData = $d_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras) {
  this.Llocales_cldr_CalendarSymbols__f_months = null;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = null;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_amPm = null;
  this.Llocales_cldr_CalendarSymbols__f_eras = null;
  this.Llocales_cldr_CalendarSymbols__f_months = months;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = shortMonths;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = weekdays;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = shortWeekdays;
  this.Llocales_cldr_CalendarSymbols__f_amPm = amPm;
  this.Llocales_cldr_CalendarSymbols__f_eras = eras
}
$c_Llocales_cldr_CalendarSymbols.prototype = new $h_O();
$c_Llocales_cldr_CalendarSymbols.prototype.constructor = $c_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $h_Llocales_cldr_CalendarSymbols() {
  /*<skip>*/
}
$h_Llocales_cldr_CalendarSymbols.prototype = $c_Llocales_cldr_CalendarSymbols.prototype;
$c_Llocales_cldr_CalendarSymbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_CalendarSymbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CalendarSymbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarSymbols)) {
    var x$0$2 = $as_Llocales_cldr_CalendarSymbols(x$0);
    var x = this.Llocales_cldr_CalendarSymbols__f_months;
    var x$2 = x$0$2.Llocales_cldr_CalendarSymbols__f_months;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var x$4 = x$0$2.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var $$x4 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$5 = this.Llocales_cldr_CalendarSymbols__f_weekdays;
      var x$6 = x$0$2.Llocales_cldr_CalendarSymbols__f_weekdays;
      var $$x3 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$7 = this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var x$8 = x$0$2.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var $$x2 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$9 = this.Llocales_cldr_CalendarSymbols__f_amPm;
      var x$10 = x$0$2.Llocales_cldr_CalendarSymbols__f_amPm;
      var $$x1 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Llocales_cldr_CalendarSymbols__f_eras;
      var x$12 = x$0$2.Llocales_cldr_CalendarSymbols__f_eras;
      return ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_CalendarSymbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CalendarSymbols.prototype.productArity__I = (function() {
  return 6
});
$c_Llocales_cldr_CalendarSymbols.prototype.productPrefix__T = (function() {
  return "CalendarSymbols"
});
$c_Llocales_cldr_CalendarSymbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CalendarSymbols__f_months;
      break
    }
    case 1: {
      return this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      break
    }
    case 2: {
      return this.Llocales_cldr_CalendarSymbols__f_weekdays;
      break
    }
    case 3: {
      return this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      break
    }
    case 4: {
      return this.Llocales_cldr_CalendarSymbols__f_amPm;
      break
    }
    case 5: {
      return this.Llocales_cldr_CalendarSymbols__f_eras;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_CalendarSymbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarSymbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarSymbols"))
}
function $isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarSymbols)))
}
function $asArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarSymbols;", depth))
}
var $d_Llocales_cldr_CalendarSymbols = new $TypeData().initClass({
  Llocales_cldr_CalendarSymbols: 0
}, false, "locales.cldr.CalendarSymbols", {
  Llocales_cldr_CalendarSymbols: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CalendarSymbols.prototype.$classData = $d_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $c_Llocales_cldr_CurrencyData(currencyTypes, fractions, regions, numericCodes) {
  this.Llocales_cldr_CurrencyData__f_currencyTypes = null;
  this.Llocales_cldr_CurrencyData__f_fractions = null;
  this.Llocales_cldr_CurrencyData__f_regions = null;
  this.Llocales_cldr_CurrencyData__f_numericCodes = null;
  this.Llocales_cldr_CurrencyData__f_currencyTypes = currencyTypes;
  this.Llocales_cldr_CurrencyData__f_fractions = fractions;
  this.Llocales_cldr_CurrencyData__f_regions = regions;
  this.Llocales_cldr_CurrencyData__f_numericCodes = numericCodes
}
$c_Llocales_cldr_CurrencyData.prototype = new $h_O();
$c_Llocales_cldr_CurrencyData.prototype.constructor = $c_Llocales_cldr_CurrencyData;
/** @constructor */
function $h_Llocales_cldr_CurrencyData() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyData.prototype = $c_Llocales_cldr_CurrencyData.prototype;
$c_Llocales_cldr_CurrencyData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_CurrencyData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_CurrencyData)) {
    var x$0$2 = $as_Llocales_cldr_CurrencyData(x$0);
    var x = this.Llocales_cldr_CurrencyData__f_currencyTypes;
    var x$2 = x$0$2.Llocales_cldr_CurrencyData__f_currencyTypes;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CurrencyData__f_fractions;
      var x$4 = x$0$2.Llocales_cldr_CurrencyData__f_fractions;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Llocales_cldr_CurrencyData__f_regions;
      var x$6 = x$0$2.Llocales_cldr_CurrencyData__f_regions;
      var $$x1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Llocales_cldr_CurrencyData__f_numericCodes;
      var x$8 = x$0$2.Llocales_cldr_CurrencyData__f_numericCodes;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_CurrencyData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyData.prototype.productArity__I = (function() {
  return 4
});
$c_Llocales_cldr_CurrencyData.prototype.productPrefix__T = (function() {
  return "CurrencyData"
});
$c_Llocales_cldr_CurrencyData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CurrencyData__f_currencyTypes;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyData__f_fractions;
      break
    }
    case 2: {
      return this.Llocales_cldr_CurrencyData__f_regions;
      break
    }
    case 3: {
      return this.Llocales_cldr_CurrencyData__f_numericCodes;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_CurrencyData(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyData) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyData"))
}
function $isArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyData)))
}
function $asArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyData;", depth))
}
var $d_Llocales_cldr_CurrencyData = new $TypeData().initClass({
  Llocales_cldr_CurrencyData: 0
}, false, "locales.cldr.CurrencyData", {
  Llocales_cldr_CurrencyData: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyData.prototype.$classData = $d_Llocales_cldr_CurrencyData;
function $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__($thiz, parent, locale, defaultNS, digitSymbols, calendarSymbols, calendarPatterns, currencies, numberPatterns) {
  $thiz.Llocales_cldr_LDML__f_parent = parent;
  $thiz.Llocales_cldr_LDML__f_locale = locale;
  $thiz.Llocales_cldr_LDML__f_defaultNS = defaultNS;
  $thiz.Llocales_cldr_LDML__f_digitSymbols = digitSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarSymbols = calendarSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarPatterns = calendarPatterns;
  $thiz.Llocales_cldr_LDML__f_currencies = currencies;
  $thiz.Llocales_cldr_LDML__f_numberPatterns = numberPatterns;
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = currencies.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var _$1 = $as_Llocales_cldr_NumberCurrency(elem);
    var key = _$1.currencyCode__T();
    var bldr = $as_scm_Builder(m.getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(currencies))));
    bldr.addOne__O__scm_Growable(elem)
  };
  var this$2 = $m_sci_HashMap$();
  var result = this$2.sci_HashMap$__f_EmptyMap;
  var mapIt = m.iterator__sc_Iterator();
  while (mapIt.hasNext__Z()) {
    var x1 = $as_T2(mapIt.next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = x1._1__O();
    var v = $as_scm_Builder(x1._2__O());
    result = result.updated__O__O__sci_HashMap(k, v.result__O())
  };
  var this$3 = result;
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$3.iterator__sc_Iterator();
  while (it$1.hasNext__Z()) {
    var arg1 = it$1.next__O();
    var x$1 = $as_T2(arg1);
    matchResult10: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var code = $as_T(x$1._1__O());
        var list = $as_sci_List(x$1._2__O());
        var self = $as_T(code.toUpperCase());
        var y = list.head__O();
        var elem$1___1 = self;
        var elem$1___2 = y;
        break matchResult10
      };
      throw new $c_s_MatchError(x$1)
    };
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0)
  };
  $thiz.Llocales_cldr_LDML__f_byCurrencyCode = b.result__sci_HashMap();
  return $thiz
}
/** @constructor */
function $c_Llocales_cldr_LDML() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  this.Llocales_cldr_LDML__f_byCurrencyCode = null
}
$c_Llocales_cldr_LDML.prototype = new $h_O();
$c_Llocales_cldr_LDML.prototype.constructor = $c_Llocales_cldr_LDML;
/** @constructor */
function $h_Llocales_cldr_LDML() {
  /*<skip>*/
}
$h_Llocales_cldr_LDML.prototype = $c_Llocales_cldr_LDML.prototype;
$c_Llocales_cldr_LDML.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_LDML.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_LDML.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_LDML)) {
    var x$0$2 = $as_Llocales_cldr_LDML(x$0);
    var x = this.Llocales_cldr_LDML__f_parent;
    var x$2 = x$0$2.Llocales_cldr_LDML__f_parent;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_LDML__f_locale;
      var x$4 = x$0$2.Llocales_cldr_LDML__f_locale;
      var $$x6 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$5 = this.Llocales_cldr_LDML__f_defaultNS;
      var x$6 = x$0$2.Llocales_cldr_LDML__f_defaultNS;
      var $$x5 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$7 = this.Llocales_cldr_LDML__f_digitSymbols;
      var x$8 = x$0$2.Llocales_cldr_LDML__f_digitSymbols;
      var $$x4 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$9 = this.Llocales_cldr_LDML__f_calendarSymbols;
      var x$10 = x$0$2.Llocales_cldr_LDML__f_calendarSymbols;
      var $$x3 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$11 = this.Llocales_cldr_LDML__f_calendarPatterns;
      var x$12 = x$0$2.Llocales_cldr_LDML__f_calendarPatterns;
      var $$x2 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$13 = this.Llocales_cldr_LDML__f_currencies;
      var x$14 = x$0$2.Llocales_cldr_LDML__f_currencies;
      var $$x1 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$15 = this.Llocales_cldr_LDML__f_numberPatterns;
      var x$16 = x$0$2.Llocales_cldr_LDML__f_numberPatterns;
      return ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_LDML.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_LDML.prototype.productArity__I = (function() {
  return 8
});
$c_Llocales_cldr_LDML.prototype.productPrefix__T = (function() {
  return "LDML"
});
$c_Llocales_cldr_LDML.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDML__f_parent;
      break
    }
    case 1: {
      return this.Llocales_cldr_LDML__f_locale;
      break
    }
    case 2: {
      return this.Llocales_cldr_LDML__f_defaultNS;
      break
    }
    case 3: {
      return this.Llocales_cldr_LDML__f_digitSymbols;
      break
    }
    case 4: {
      return this.Llocales_cldr_LDML__f_calendarSymbols;
      break
    }
    case 5: {
      return this.Llocales_cldr_LDML__f_calendarPatterns;
      break
    }
    case 6: {
      return this.Llocales_cldr_LDML__f_currencies;
      break
    }
    case 7: {
      return this.Llocales_cldr_LDML__f_numberPatterns;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Llocales_cldr_LDML.prototype.toLocale__ju_Locale = (function() {
  if ((this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_language === "root")) {
    var $$x3 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder("");
    var this$1 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_territory;
    var $$x2 = $$x3.setRegion__T__ju_Locale$Builder($as_T((this$1.isEmpty__Z() ? "" : this$1.get__O())));
    var this$2 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_script;
    var $$x1 = $$x2.setScript__T__ju_Locale$Builder($as_T((this$2.isEmpty__Z() ? "" : this$2.get__O())));
    var this$3 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_variant;
    return $$x1.setVariant__T__ju_Locale$Builder($as_T((this$3.isEmpty__Z() ? "" : this$3.get__O()))).build__ju_Locale()
  } else {
    var $$x6 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder(this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_language);
    var this$4 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_territory;
    var $$x5 = $$x6.setRegion__T__ju_Locale$Builder($as_T((this$4.isEmpty__Z() ? "" : this$4.get__O())));
    var this$5 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_script;
    var $$x4 = $$x5.setScript__T__ju_Locale$Builder($as_T((this$5.isEmpty__Z() ? "" : this$5.get__O())));
    var this$6 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_variant;
    return $$x4.setVariant__T__ju_Locale$Builder($as_T((this$6.isEmpty__Z() ? "" : this$6.get__O()))).build__ju_Locale()
  }
});
function $as_Llocales_cldr_LDML(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDML) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDML"))
}
function $isArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDML)))
}
function $asArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDML(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDML;", depth))
}
var $d_Llocales_cldr_LDML = new $TypeData().initClass({
  Llocales_cldr_LDML: 0
}, false, "locales.cldr.LDML", {
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_LDML.prototype.$classData = $d_Llocales_cldr_LDML;
/** @constructor */
function $c_Llocales_cldr_LDMLLocale(language, territory, variant, script) {
  this.Llocales_cldr_LDMLLocale__f_language = null;
  this.Llocales_cldr_LDMLLocale__f_territory = null;
  this.Llocales_cldr_LDMLLocale__f_variant = null;
  this.Llocales_cldr_LDMLLocale__f_script = null;
  this.Llocales_cldr_LDMLLocale__f_language = language;
  this.Llocales_cldr_LDMLLocale__f_territory = territory;
  this.Llocales_cldr_LDMLLocale__f_variant = variant;
  this.Llocales_cldr_LDMLLocale__f_script = script
}
$c_Llocales_cldr_LDMLLocale.prototype = new $h_O();
$c_Llocales_cldr_LDMLLocale.prototype.constructor = $c_Llocales_cldr_LDMLLocale;
/** @constructor */
function $h_Llocales_cldr_LDMLLocale() {
  /*<skip>*/
}
$h_Llocales_cldr_LDMLLocale.prototype = $c_Llocales_cldr_LDMLLocale.prototype;
$c_Llocales_cldr_LDMLLocale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_LDMLLocale.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_LDMLLocale.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_LDMLLocale)) {
    var x$0$2 = $as_Llocales_cldr_LDMLLocale(x$0);
    if ((this.Llocales_cldr_LDMLLocale__f_language === x$0$2.Llocales_cldr_LDMLLocale__f_language)) {
      var x = this.Llocales_cldr_LDMLLocale__f_territory;
      var x$2 = x$0$2.Llocales_cldr_LDMLLocale__f_territory;
      var $$x2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Llocales_cldr_LDMLLocale__f_variant;
      var x$4 = x$0$2.Llocales_cldr_LDMLLocale__f_variant;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Llocales_cldr_LDMLLocale__f_script;
      var x$6 = x$0$2.Llocales_cldr_LDMLLocale__f_script;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_LDMLLocale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_LDMLLocale.prototype.productArity__I = (function() {
  return 4
});
$c_Llocales_cldr_LDMLLocale.prototype.productPrefix__T = (function() {
  return "LDMLLocale"
});
$c_Llocales_cldr_LDMLLocale.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDMLLocale__f_language;
      break
    }
    case 1: {
      return this.Llocales_cldr_LDMLLocale__f_territory;
      break
    }
    case 2: {
      return this.Llocales_cldr_LDMLLocale__f_variant;
      break
    }
    case 3: {
      return this.Llocales_cldr_LDMLLocale__f_script;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_LDMLLocale(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDMLLocale) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDMLLocale"))
}
function $isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDMLLocale)))
}
function $asArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDMLLocale;", depth))
}
var $d_Llocales_cldr_LDMLLocale = new $TypeData().initClass({
  Llocales_cldr_LDMLLocale: 0
}, false, "locales.cldr.LDMLLocale", {
  Llocales_cldr_LDMLLocale: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_LDMLLocale.prototype.$classData = $d_Llocales_cldr_LDMLLocale;
function $as_Llocales_cldr_NumberCurrency(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberCurrency"))
}
function $isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberCurrency)))
}
function $asArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberCurrency;", depth))
}
/** @constructor */
function $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat) {
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = null;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = null;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = null;
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = decimalFormat;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = percentFormat;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = currencyFormat
}
$c_Llocales_cldr_NumberPatterns.prototype = new $h_O();
$c_Llocales_cldr_NumberPatterns.prototype.constructor = $c_Llocales_cldr_NumberPatterns;
/** @constructor */
function $h_Llocales_cldr_NumberPatterns() {
  /*<skip>*/
}
$h_Llocales_cldr_NumberPatterns.prototype = $c_Llocales_cldr_NumberPatterns.prototype;
$c_Llocales_cldr_NumberPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_NumberPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_NumberPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberPatterns)) {
    var x$0$2 = $as_Llocales_cldr_NumberPatterns(x$0);
    var x = this.Llocales_cldr_NumberPatterns__f_decimalFormat;
    var x$2 = x$0$2.Llocales_cldr_NumberPatterns__f_decimalFormat;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_NumberPatterns__f_percentFormat;
      var x$4 = x$0$2.Llocales_cldr_NumberPatterns__f_percentFormat;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      var x$6 = x$0$2.Llocales_cldr_NumberPatterns__f_currencyFormat;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_NumberPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_NumberPatterns.prototype.productArity__I = (function() {
  return 3
});
$c_Llocales_cldr_NumberPatterns.prototype.productPrefix__T = (function() {
  return "NumberPatterns"
});
$c_Llocales_cldr_NumberPatterns.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_NumberPatterns__f_decimalFormat;
      break
    }
    case 1: {
      return this.Llocales_cldr_NumberPatterns__f_percentFormat;
      break
    }
    case 2: {
      return this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_NumberPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberPatterns"))
}
function $isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberPatterns)))
}
function $asArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberPatterns;", depth))
}
var $d_Llocales_cldr_NumberPatterns = new $TypeData().initClass({
  Llocales_cldr_NumberPatterns: 0
}, false, "locales.cldr.NumberPatterns", {
  Llocales_cldr_NumberPatterns: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_NumberPatterns.prototype.$classData = $d_Llocales_cldr_NumberPatterns;
/** @constructor */
function $c_Llocales_cldr_NumberingSystem(id, digits) {
  this.Llocales_cldr_NumberingSystem__f_id = null;
  this.Llocales_cldr_NumberingSystem__f_digits = null;
  this.Llocales_cldr_NumberingSystem__f_id = id;
  this.Llocales_cldr_NumberingSystem__f_digits = digits
}
$c_Llocales_cldr_NumberingSystem.prototype = new $h_O();
$c_Llocales_cldr_NumberingSystem.prototype.constructor = $c_Llocales_cldr_NumberingSystem;
/** @constructor */
function $h_Llocales_cldr_NumberingSystem() {
  /*<skip>*/
}
$h_Llocales_cldr_NumberingSystem.prototype = $c_Llocales_cldr_NumberingSystem.prototype;
$c_Llocales_cldr_NumberingSystem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_NumberingSystem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_NumberingSystem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberingSystem)) {
    var x$0$2 = $as_Llocales_cldr_NumberingSystem(x$0);
    if ((this.Llocales_cldr_NumberingSystem__f_id === x$0$2.Llocales_cldr_NumberingSystem__f_id)) {
      var x = this.Llocales_cldr_NumberingSystem__f_digits;
      var x$2 = x$0$2.Llocales_cldr_NumberingSystem__f_digits;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_NumberingSystem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_NumberingSystem.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_NumberingSystem.prototype.productPrefix__T = (function() {
  return "NumberingSystem"
});
$c_Llocales_cldr_NumberingSystem.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_NumberingSystem__f_id
  };
  if ((n === 1)) {
    return this.Llocales_cldr_NumberingSystem__f_digits
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Llocales_cldr_NumberingSystem(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberingSystem) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberingSystem"))
}
function $isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberingSystem)))
}
function $asArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberingSystem;", depth))
}
var $d_Llocales_cldr_NumberingSystem = new $TypeData().initClass({
  Llocales_cldr_NumberingSystem: 0
}, false, "locales.cldr.NumberingSystem", {
  Llocales_cldr_NumberingSystem: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_NumberingSystem.prototype.$classData = $d_Llocales_cldr_NumberingSystem;
/** @constructor */
function $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp) {
  this.Llocales_cldr_Symbols__f_ns = null;
  this.Llocales_cldr_Symbols__f_aliasOf = null;
  this.Llocales_cldr_Symbols__f_decimal = null;
  this.Llocales_cldr_Symbols__f_group = null;
  this.Llocales_cldr_Symbols__f_list = null;
  this.Llocales_cldr_Symbols__f_percent = null;
  this.Llocales_cldr_Symbols__f_minus = null;
  this.Llocales_cldr_Symbols__f_perMille = null;
  this.Llocales_cldr_Symbols__f_infinity = null;
  this.Llocales_cldr_Symbols__f_nan = null;
  this.Llocales_cldr_Symbols__f_exp = null;
  this.Llocales_cldr_Symbols__f_ns = ns;
  this.Llocales_cldr_Symbols__f_aliasOf = aliasOf;
  this.Llocales_cldr_Symbols__f_decimal = decimal;
  this.Llocales_cldr_Symbols__f_group = group;
  this.Llocales_cldr_Symbols__f_list = list;
  this.Llocales_cldr_Symbols__f_percent = percent;
  this.Llocales_cldr_Symbols__f_minus = minus;
  this.Llocales_cldr_Symbols__f_perMille = perMille;
  this.Llocales_cldr_Symbols__f_infinity = infinity;
  this.Llocales_cldr_Symbols__f_nan = nan;
  this.Llocales_cldr_Symbols__f_exp = exp
}
$c_Llocales_cldr_Symbols.prototype = new $h_O();
$c_Llocales_cldr_Symbols.prototype.constructor = $c_Llocales_cldr_Symbols;
/** @constructor */
function $h_Llocales_cldr_Symbols() {
  /*<skip>*/
}
$h_Llocales_cldr_Symbols.prototype = $c_Llocales_cldr_Symbols.prototype;
$c_Llocales_cldr_Symbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Llocales_cldr_Symbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_Symbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Llocales_cldr_Symbols)) {
    var x$0$2 = $as_Llocales_cldr_Symbols(x$0);
    var x = this.Llocales_cldr_Symbols__f_ns;
    var x$2 = x$0$2.Llocales_cldr_Symbols__f_ns;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_Symbols__f_aliasOf;
      var x$4 = x$0$2.Llocales_cldr_Symbols__f_aliasOf;
      var $$x9 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x9 = false
    };
    if ($$x9) {
      var x$5 = this.Llocales_cldr_Symbols__f_decimal;
      var x$6 = x$0$2.Llocales_cldr_Symbols__f_decimal;
      var $$x8 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var x$7 = this.Llocales_cldr_Symbols__f_group;
      var x$8 = x$0$2.Llocales_cldr_Symbols__f_group;
      var $$x7 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$9 = this.Llocales_cldr_Symbols__f_list;
      var x$10 = x$0$2.Llocales_cldr_Symbols__f_list;
      var $$x6 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$11 = this.Llocales_cldr_Symbols__f_percent;
      var x$12 = x$0$2.Llocales_cldr_Symbols__f_percent;
      var $$x5 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$13 = this.Llocales_cldr_Symbols__f_minus;
      var x$14 = x$0$2.Llocales_cldr_Symbols__f_minus;
      var $$x4 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$15 = this.Llocales_cldr_Symbols__f_perMille;
      var x$16 = x$0$2.Llocales_cldr_Symbols__f_perMille;
      var $$x3 = ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$17 = this.Llocales_cldr_Symbols__f_infinity;
      var x$18 = x$0$2.Llocales_cldr_Symbols__f_infinity;
      var $$x2 = ((x$17 === null) ? (x$18 === null) : x$17.equals__O__Z(x$18))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$19 = this.Llocales_cldr_Symbols__f_nan;
      var x$20 = x$0$2.Llocales_cldr_Symbols__f_nan;
      var $$x1 = ((x$19 === null) ? (x$20 === null) : x$19.equals__O__Z(x$20))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$21 = this.Llocales_cldr_Symbols__f_exp;
      var x$22 = x$0$2.Llocales_cldr_Symbols__f_exp;
      return ((x$21 === null) ? (x$22 === null) : x$21.equals__O__Z(x$22))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Llocales_cldr_Symbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_Symbols.prototype.productArity__I = (function() {
  return 11
});
$c_Llocales_cldr_Symbols.prototype.productPrefix__T = (function() {
  return "Symbols"
});
$c_Llocales_cldr_Symbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_Symbols__f_ns;
      break
    }
    case 1: {
      return this.Llocales_cldr_Symbols__f_aliasOf;
      break
    }
    case 2: {
      return this.Llocales_cldr_Symbols__f_decimal;
      break
    }
    case 3: {
      return this.Llocales_cldr_Symbols__f_group;
      break
    }
    case 4: {
      return this.Llocales_cldr_Symbols__f_list;
      break
    }
    case 5: {
      return this.Llocales_cldr_Symbols__f_percent;
      break
    }
    case 6: {
      return this.Llocales_cldr_Symbols__f_minus;
      break
    }
    case 7: {
      return this.Llocales_cldr_Symbols__f_perMille;
      break
    }
    case 8: {
      return this.Llocales_cldr_Symbols__f_infinity;
      break
    }
    case 9: {
      return this.Llocales_cldr_Symbols__f_nan;
      break
    }
    case 10: {
      return this.Llocales_cldr_Symbols__f_exp;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Llocales_cldr_Symbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_Symbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.Symbols"))
}
function $isArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_Symbols)))
}
function $asArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_Symbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.Symbols;", depth))
}
var $d_Llocales_cldr_Symbols = new $TypeData().initClass({
  Llocales_cldr_Symbols: 0
}, false, "locales.cldr.Symbols", {
  Llocales_cldr_Symbols: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_Symbols.prototype.$classData = $d_Llocales_cldr_Symbols;
/** @constructor */
function $c_Lnet_timerboard_Alliance(id, ticker, name) {
  this.Lnet_timerboard_Alliance__f_id = $L0;
  this.Lnet_timerboard_Alliance__f_ticker = null;
  this.Lnet_timerboard_Alliance__f_name = null;
  this.Lnet_timerboard_Alliance__f_id = id;
  this.Lnet_timerboard_Alliance__f_ticker = ticker;
  this.Lnet_timerboard_Alliance__f_name = name
}
$c_Lnet_timerboard_Alliance.prototype = new $h_O();
$c_Lnet_timerboard_Alliance.prototype.constructor = $c_Lnet_timerboard_Alliance;
/** @constructor */
function $h_Lnet_timerboard_Alliance() {
  /*<skip>*/
}
$h_Lnet_timerboard_Alliance.prototype = $c_Lnet_timerboard_Alliance.prototype;
$c_Lnet_timerboard_Alliance.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_Alliance.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Alliance");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lnet_timerboard_Alliance__f_id;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lnet_timerboard_Alliance__f_ticker;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lnet_timerboard_Alliance__f_name;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lnet_timerboard_Alliance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Alliance)) {
    var x$0$2 = $as_Lnet_timerboard_Alliance(x$0);
    var this$1 = this.Lnet_timerboard_Alliance__f_id;
    var b = x$0$2.Lnet_timerboard_Alliance__f_id;
    if ((((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi)) && (this.Lnet_timerboard_Alliance__f_ticker === x$0$2.Lnet_timerboard_Alliance__f_ticker))) {
      return (this.Lnet_timerboard_Alliance__f_name === x$0$2.Lnet_timerboard_Alliance__f_name)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_Alliance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Alliance.prototype.productArity__I = (function() {
  return 3
});
$c_Lnet_timerboard_Alliance.prototype.productPrefix__T = (function() {
  return "Alliance"
});
$c_Lnet_timerboard_Alliance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_timerboard_Alliance__f_id;
      break
    }
    case 1: {
      return this.Lnet_timerboard_Alliance__f_ticker;
      break
    }
    case 2: {
      return this.Lnet_timerboard_Alliance__f_name;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lnet_timerboard_Alliance(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Alliance) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Alliance"))
}
function $isArrayOf_Lnet_timerboard_Alliance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Alliance)))
}
function $asArrayOf_Lnet_timerboard_Alliance(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Alliance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Alliance;", depth))
}
var $d_Lnet_timerboard_Alliance = new $TypeData().initClass({
  Lnet_timerboard_Alliance: 0
}, false, "net.timerboard.Alliance", {
  Lnet_timerboard_Alliance: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_Alliance.prototype.$classData = $d_Lnet_timerboard_Alliance;
/** @constructor */
function $c_Lnet_timerboard_BackendSocket(socketUrl, socket) {
  this.Lnet_timerboard_BackendSocket__f_socketUrl = null;
  this.Lnet_timerboard_BackendSocket__f_socket = null;
  this.Lnet_timerboard_BackendSocket__f_socketUrl = socketUrl;
  this.Lnet_timerboard_BackendSocket__f_socket = socket
}
$c_Lnet_timerboard_BackendSocket.prototype = new $h_O();
$c_Lnet_timerboard_BackendSocket.prototype.constructor = $c_Lnet_timerboard_BackendSocket;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket.prototype = $c_Lnet_timerboard_BackendSocket.prototype;
$c_Lnet_timerboard_BackendSocket.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_BackendSocket.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_BackendSocket.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_BackendSocket)) {
    var x$0$2 = $as_Lnet_timerboard_BackendSocket(x$0);
    if ((this.Lnet_timerboard_BackendSocket__f_socketUrl === x$0$2.Lnet_timerboard_BackendSocket__f_socketUrl)) {
      var x = this.Lnet_timerboard_BackendSocket__f_socket;
      var x$2 = x$0$2.Lnet_timerboard_BackendSocket__f_socket;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_BackendSocket.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_BackendSocket.prototype.productArity__I = (function() {
  return 2
});
$c_Lnet_timerboard_BackendSocket.prototype.productPrefix__T = (function() {
  return "BackendSocket"
});
$c_Lnet_timerboard_BackendSocket.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_BackendSocket__f_socketUrl
  };
  if ((n === 1)) {
    return this.Lnet_timerboard_BackendSocket__f_socket
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_BackendSocket.prototype.update__Lnet_timerboard_BackendSocket$Status__T2 = (function(status) {
  if ((status instanceof $c_Lnet_timerboard_BackendSocket$Status$ConnectionError)) {
    var x$1 = $as_Lnet_timerboard_BackendSocket$Status$ConnectionError(status);
    var x16 = x$1.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg;
    var _2 = $m_Ltyrian_cmds_Logger$().error__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([("Failed to open WebSocket connection: " + x16)])));
    return $ct_T2__O__O__(new $c_T2(), this, _2)
  };
  if ((status instanceof $c_Lnet_timerboard_BackendSocket$Status$Connected)) {
    var x$1$1 = $as_Lnet_timerboard_BackendSocket$Status$Connected(status);
    var x13 = x$1$1.Lnet_timerboard_BackendSocket$Status$Connected__f_ws;
    var socket$1 = new $c_s_Some(x13);
    var socketUrl$1 = this.Lnet_timerboard_BackendSocket__f_socketUrl;
    var _1 = new $c_Lnet_timerboard_BackendSocket(socketUrl$1, socket$1);
    var _2$1 = $m_Ltyrian_Cmd$Empty$();
    return $ct_T2__O__O__(new $c_T2(), _1, _2$1)
  };
  var x = $s_Lnet_timerboard_BackendSocket$Status$__Connecting__Lnet_timerboard_BackendSocket$Status();
  if (((x === null) ? (status === null) : x.equals__O__Z(status))) {
    var connect = $m_Ltyrian_websocket_WebSocket$().connect__T__T__Ltyrian_websocket_KeepAliveSettings__F1__Ltyrian_Cmd(this.Lnet_timerboard_BackendSocket__f_socketUrl, "Connect me!", $m_Ltyrian_websocket_KeepAliveSettings$().default__Ltyrian_websocket_KeepAliveSettings(), new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$3 = $as_s_util_Either(x$1$2);
      if ((x$1$3 instanceof $c_s_util_Left)) {
        var err = $as_T($as_s_util_Left(x$1$3).s_util_Left__f_value);
        var this$7 = new $c_Lnet_timerboard_BackendSocket$Status$ConnectionError(err);
        return new $c_Lnet_timerboard_Msg$WebSocketStatus(this$7)
      };
      if ((x$1$3 instanceof $c_s_util_Right)) {
        var ws = $as_Ltyrian_websocket_WebSocket($as_s_util_Right(x$1$3).s_util_Right__f_value);
        var this$10 = new $c_Lnet_timerboard_BackendSocket$Status$Connected(ws);
        return new $c_Lnet_timerboard_Msg$WebSocketStatus(this$10)
      };
      throw new $c_s_MatchError(x$1$3)
    })));
    return $ct_T2__O__O__(new $c_T2(), this, connect)
  };
  var x$3 = $s_Lnet_timerboard_BackendSocket$Status$__Disconnecting__Lnet_timerboard_BackendSocket$Status();
  if (((x$3 === null) ? (status === null) : x$3.equals__O__Z(status))) {
    var log = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Graceful shutdown of BackendSocket connection"])));
    var this$13 = this.Lnet_timerboard_BackendSocket__f_socket;
    if (this$13.isEmpty__Z()) {
      var this$17 = $m_s_None$()
    } else {
      var arg1 = this$13.get__O();
      var ws$1 = $as_Ltyrian_websocket_WebSocket(arg1);
      var cmds = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([log, ws$1.disconnect__Ltyrian_Cmd()]));
      $m_sci_List$();
      var cmds$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds);
      var this$17 = new $c_s_Some(new $c_Ltyrian_Cmd$Batch(cmds$1))
    };
    var cmds$2 = $as_Ltyrian_Cmd((this$17.isEmpty__Z() ? log : this$17.get__O()));
    var socket$2 = $m_s_None$();
    var socketUrl$2 = this.Lnet_timerboard_BackendSocket__f_socketUrl;
    var _1$1 = new $c_Lnet_timerboard_BackendSocket(socketUrl$2, socket$2);
    return $ct_T2__O__O__(new $c_T2(), _1$1, cmds$2)
  };
  var x$5 = $s_Lnet_timerboard_BackendSocket$Status$__Disconnected__Lnet_timerboard_BackendSocket$Status();
  if (((x$5 === null) ? (status === null) : x$5.equals__O__Z(status))) {
    var _2$2 = $m_Ltyrian_cmds_Logger$().info__sci_Seq__Ltyrian_Cmd$SideEffect($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["WebSocket not connected yet"])));
    return $ct_T2__O__O__(new $c_T2(), this, _2$2)
  };
  throw new $c_s_MatchError(status)
});
$c_Lnet_timerboard_BackendSocket.prototype.subscribe__F1__Ltyrian_Sub = (function(toMessage) {
  var this$1 = this.Lnet_timerboard_BackendSocket__f_socket;
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_Ltyrian_Sub$();
    var this$2 = $s_Lnet_timerboard_BackendSocket$Status$__Disconnected__Lnet_timerboard_BackendSocket$Status();
    return $$x1.emit__O__Ltyrian_Sub(new $c_Lnet_timerboard_Msg$WebSocketStatus(this$2))
  } else {
    var arg1 = this$1.get__O();
    var _$2 = $as_Ltyrian_websocket_WebSocket(arg1);
    return _$2.subscribe__F1__Ltyrian_Sub(toMessage)
  }
});
function $as_Lnet_timerboard_BackendSocket(obj) {
  return (((obj instanceof $c_Lnet_timerboard_BackendSocket) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.BackendSocket"))
}
function $isArrayOf_Lnet_timerboard_BackendSocket(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_BackendSocket)))
}
function $asArrayOf_Lnet_timerboard_BackendSocket(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_BackendSocket(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.BackendSocket;", depth))
}
var $d_Lnet_timerboard_BackendSocket = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket: 0
}, false, "net.timerboard.BackendSocket", {
  Lnet_timerboard_BackendSocket: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_BackendSocket.prototype.$classData = $d_Lnet_timerboard_BackendSocket;
/** @constructor */
function $c_Lnet_timerboard_Event(solar_system_name, event, alliance) {
  this.Lnet_timerboard_Event__f_solar_system_name = null;
  this.Lnet_timerboard_Event__f_event = null;
  this.Lnet_timerboard_Event__f_alliance = null;
  this.Lnet_timerboard_Event__f_solar_system_name = solar_system_name;
  this.Lnet_timerboard_Event__f_event = event;
  this.Lnet_timerboard_Event__f_alliance = alliance
}
$c_Lnet_timerboard_Event.prototype = new $h_O();
$c_Lnet_timerboard_Event.prototype.constructor = $c_Lnet_timerboard_Event;
/** @constructor */
function $h_Lnet_timerboard_Event() {
  /*<skip>*/
}
$h_Lnet_timerboard_Event.prototype = $c_Lnet_timerboard_Event.prototype;
$c_Lnet_timerboard_Event.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_Event.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Event.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Event)) {
    var x$0$2 = $as_Lnet_timerboard_Event(x$0);
    if ((this.Lnet_timerboard_Event__f_solar_system_name === x$0$2.Lnet_timerboard_Event__f_solar_system_name)) {
      var x = this.Lnet_timerboard_Event__f_event;
      var x$2 = x$0$2.Lnet_timerboard_Event__f_event;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lnet_timerboard_Event__f_alliance;
      var x$4 = x$0$2.Lnet_timerboard_Event__f_alliance;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_Event.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Event.prototype.productArity__I = (function() {
  return 3
});
$c_Lnet_timerboard_Event.prototype.productPrefix__T = (function() {
  return "Event"
});
$c_Lnet_timerboard_Event.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_timerboard_Event__f_solar_system_name;
      break
    }
    case 1: {
      return this.Lnet_timerboard_Event__f_event;
      break
    }
    case 2: {
      return this.Lnet_timerboard_Event__f_alliance;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lnet_timerboard_Event.prototype.compact__Ljava_time_ZonedDateTime__sci_Map__sci_Map__s_Option__Lnet_timerboard_RenderEvent = (function(now, regionLookup, distances, system) {
  var t$1 = this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_campaign_id;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var event_type = this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_event_type;
  var system$1 = this.Lnet_timerboard_Event__f_solar_system_name;
  var this$1 = regionLookup.get__O__s_Option(this.Lnet_timerboard_Event__f_solar_system_name);
  var region = $as_T((this$1.isEmpty__Z() ? "Unknown" : this$1.get__O()));
  var owner = this.Lnet_timerboard_Event__f_alliance.Lnet_timerboard_Alliance__f_name;
  var time = this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_start_time;
  var remaining = $m_Lnet_timerboard_TimeDiff$().apply__Ljava_time_ZonedDateTime__Ljava_time_ZonedDateTime__T(now, this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_start_time);
  var defender_score = this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_defender_score;
  if (system.isEmpty__Z()) {
    var distance = $m_s_None$()
  } else {
    var arg1 = system.get__O();
    var t = $uJ(arg1);
    var distance = distances.get__O__s_Option(this.Lnet_timerboard_Event__f_event.Lnet_timerboard_InnerEvent__f_solar_system_id)
  };
  return new $c_Lnet_timerboard_RenderEvent(new $c_RTLong(lo$1, hi$1), event_type, system$1, region, owner, time, remaining, defender_score, distance)
});
function $as_Lnet_timerboard_Event(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Event) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Event"))
}
function $isArrayOf_Lnet_timerboard_Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Event)))
}
function $asArrayOf_Lnet_timerboard_Event(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Event;", depth))
}
var $d_Lnet_timerboard_Event = new $TypeData().initClass({
  Lnet_timerboard_Event: 0
}, false, "net.timerboard.Event", {
  Lnet_timerboard_Event: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_Event.prototype.$classData = $d_Lnet_timerboard_Event;
/** @constructor */
function $c_Lnet_timerboard_InnerEvent(attackers_score, campaign_id, constellation_id, defender_id, defender_score, event_type, participants, solar_system_id, start_time, structure_id) {
  this.Lnet_timerboard_InnerEvent__f_attackers_score = null;
  this.Lnet_timerboard_InnerEvent__f_campaign_id = $L0;
  this.Lnet_timerboard_InnerEvent__f_constellation_id = $L0;
  this.Lnet_timerboard_InnerEvent__f_defender_id = $L0;
  this.Lnet_timerboard_InnerEvent__f_defender_score = null;
  this.Lnet_timerboard_InnerEvent__f_event_type = null;
  this.Lnet_timerboard_InnerEvent__f_participants = null;
  this.Lnet_timerboard_InnerEvent__f_solar_system_id = $L0;
  this.Lnet_timerboard_InnerEvent__f_start_time = null;
  this.Lnet_timerboard_InnerEvent__f_structure_id = $L0;
  this.Lnet_timerboard_InnerEvent__f_attackers_score = attackers_score;
  this.Lnet_timerboard_InnerEvent__f_campaign_id = campaign_id;
  this.Lnet_timerboard_InnerEvent__f_constellation_id = constellation_id;
  this.Lnet_timerboard_InnerEvent__f_defender_id = defender_id;
  this.Lnet_timerboard_InnerEvent__f_defender_score = defender_score;
  this.Lnet_timerboard_InnerEvent__f_event_type = event_type;
  this.Lnet_timerboard_InnerEvent__f_participants = participants;
  this.Lnet_timerboard_InnerEvent__f_solar_system_id = solar_system_id;
  this.Lnet_timerboard_InnerEvent__f_start_time = start_time;
  this.Lnet_timerboard_InnerEvent__f_structure_id = structure_id
}
$c_Lnet_timerboard_InnerEvent.prototype = new $h_O();
$c_Lnet_timerboard_InnerEvent.prototype.constructor = $c_Lnet_timerboard_InnerEvent;
/** @constructor */
function $h_Lnet_timerboard_InnerEvent() {
  /*<skip>*/
}
$h_Lnet_timerboard_InnerEvent.prototype = $c_Lnet_timerboard_InnerEvent.prototype;
$c_Lnet_timerboard_InnerEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_InnerEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InnerEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lnet_timerboard_InnerEvent__f_attackers_score;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lnet_timerboard_InnerEvent__f_campaign_id;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var t$1 = this.Lnet_timerboard_InnerEvent__f_constellation_id;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var data$3 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var t$2 = this.Lnet_timerboard_InnerEvent__f_defender_id;
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var data$4 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$1 = this.Lnet_timerboard_InnerEvent__f_defender_score;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$2 = this.Lnet_timerboard_InnerEvent__f_event_type;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$3 = this.Lnet_timerboard_InnerEvent__f_participants;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var t$3 = this.Lnet_timerboard_InnerEvent__f_solar_system_id;
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  var data$8 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$4 = this.Lnet_timerboard_InnerEvent__f_start_time;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var t$4 = this.Lnet_timerboard_InnerEvent__f_structure_id;
  var lo$4 = t$4.RTLong__f_lo;
  var hi$4 = t$4.RTLong__f_hi;
  var data$10 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4));
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$11, 10)
});
$c_Lnet_timerboard_InnerEvent.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_InnerEvent)) {
    var x$0$2 = $as_Lnet_timerboard_InnerEvent(x$0);
    var this$1 = this.Lnet_timerboard_InnerEvent__f_campaign_id;
    var b = x$0$2.Lnet_timerboard_InnerEvent__f_campaign_id;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var this$2 = this.Lnet_timerboard_InnerEvent__f_constellation_id;
      var b$1 = x$0$2.Lnet_timerboard_InnerEvent__f_constellation_id;
      var $$x8 = ((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi))
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var this$3 = this.Lnet_timerboard_InnerEvent__f_defender_id;
      var b$2 = x$0$2.Lnet_timerboard_InnerEvent__f_defender_id;
      var $$x7 = ((this$3.RTLong__f_lo === b$2.RTLong__f_lo) && (this$3.RTLong__f_hi === b$2.RTLong__f_hi))
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var this$4 = this.Lnet_timerboard_InnerEvent__f_solar_system_id;
      var b$3 = x$0$2.Lnet_timerboard_InnerEvent__f_solar_system_id;
      var $$x6 = ((this$4.RTLong__f_lo === b$3.RTLong__f_lo) && (this$4.RTLong__f_hi === b$3.RTLong__f_hi))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var this$5 = this.Lnet_timerboard_InnerEvent__f_structure_id;
      var b$4 = x$0$2.Lnet_timerboard_InnerEvent__f_structure_id;
      var $$x5 = ((this$5.RTLong__f_lo === b$4.RTLong__f_lo) && (this$5.RTLong__f_hi === b$4.RTLong__f_hi))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x = this.Lnet_timerboard_InnerEvent__f_attackers_score;
      var x$2 = x$0$2.Lnet_timerboard_InnerEvent__f_attackers_score;
      var $$x4 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$3 = this.Lnet_timerboard_InnerEvent__f_defender_score;
      var x$4 = x$0$2.Lnet_timerboard_InnerEvent__f_defender_score;
      var $$x3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$5 = this.Lnet_timerboard_InnerEvent__f_event_type;
      var x$6 = x$0$2.Lnet_timerboard_InnerEvent__f_event_type;
      var $$x2 = (x$5 === x$6)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lnet_timerboard_InnerEvent__f_participants;
      var x$8 = x$0$2.Lnet_timerboard_InnerEvent__f_participants;
      var $$x1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lnet_timerboard_InnerEvent__f_start_time;
      var x$10 = x$0$2.Lnet_timerboard_InnerEvent__f_start_time;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_InnerEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_InnerEvent.prototype.productArity__I = (function() {
  return 10
});
$c_Lnet_timerboard_InnerEvent.prototype.productPrefix__T = (function() {
  return "InnerEvent"
});
$c_Lnet_timerboard_InnerEvent.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_timerboard_InnerEvent__f_attackers_score;
      break
    }
    case 1: {
      return this.Lnet_timerboard_InnerEvent__f_campaign_id;
      break
    }
    case 2: {
      return this.Lnet_timerboard_InnerEvent__f_constellation_id;
      break
    }
    case 3: {
      return this.Lnet_timerboard_InnerEvent__f_defender_id;
      break
    }
    case 4: {
      return this.Lnet_timerboard_InnerEvent__f_defender_score;
      break
    }
    case 5: {
      return this.Lnet_timerboard_InnerEvent__f_event_type;
      break
    }
    case 6: {
      return this.Lnet_timerboard_InnerEvent__f_participants;
      break
    }
    case 7: {
      return this.Lnet_timerboard_InnerEvent__f_solar_system_id;
      break
    }
    case 8: {
      return this.Lnet_timerboard_InnerEvent__f_start_time;
      break
    }
    case 9: {
      return this.Lnet_timerboard_InnerEvent__f_structure_id;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lnet_timerboard_InnerEvent(obj) {
  return (((obj instanceof $c_Lnet_timerboard_InnerEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.InnerEvent"))
}
function $isArrayOf_Lnet_timerboard_InnerEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_InnerEvent)))
}
function $asArrayOf_Lnet_timerboard_InnerEvent(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_InnerEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.InnerEvent;", depth))
}
var $d_Lnet_timerboard_InnerEvent = new $TypeData().initClass({
  Lnet_timerboard_InnerEvent: 0
}, false, "net.timerboard.InnerEvent", {
  Lnet_timerboard_InnerEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_InnerEvent.prototype.$classData = $d_Lnet_timerboard_InnerEvent;
/** @constructor */
function $c_Lnet_timerboard_Model(socket, logs, state, now, system, systemNames, distances, search, searchTags, sortBy, sortDirection, systems) {
  this.Lnet_timerboard_Model__f_socket = null;
  this.Lnet_timerboard_Model__f_logs = null;
  this.Lnet_timerboard_Model__f_state = null;
  this.Lnet_timerboard_Model__f_now = null;
  this.Lnet_timerboard_Model__f_system = null;
  this.Lnet_timerboard_Model__f_systemNames = null;
  this.Lnet_timerboard_Model__f_distances = null;
  this.Lnet_timerboard_Model__f_search = null;
  this.Lnet_timerboard_Model__f_searchTags = null;
  this.Lnet_timerboard_Model__f_sortBy = null;
  this.Lnet_timerboard_Model__f_sortDirection = null;
  this.Lnet_timerboard_Model__f_systems = null;
  this.Lnet_timerboard_Model__f_socket = socket;
  this.Lnet_timerboard_Model__f_logs = logs;
  this.Lnet_timerboard_Model__f_state = state;
  this.Lnet_timerboard_Model__f_now = now;
  this.Lnet_timerboard_Model__f_system = system;
  this.Lnet_timerboard_Model__f_systemNames = systemNames;
  this.Lnet_timerboard_Model__f_distances = distances;
  this.Lnet_timerboard_Model__f_search = search;
  this.Lnet_timerboard_Model__f_searchTags = searchTags;
  this.Lnet_timerboard_Model__f_sortBy = sortBy;
  this.Lnet_timerboard_Model__f_sortDirection = sortDirection;
  this.Lnet_timerboard_Model__f_systems = systems
}
$c_Lnet_timerboard_Model.prototype = new $h_O();
$c_Lnet_timerboard_Model.prototype.constructor = $c_Lnet_timerboard_Model;
/** @constructor */
function $h_Lnet_timerboard_Model() {
  /*<skip>*/
}
$h_Lnet_timerboard_Model.prototype = $c_Lnet_timerboard_Model.prototype;
$c_Lnet_timerboard_Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_Model.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Model.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Model)) {
    var x$0$2 = $as_Lnet_timerboard_Model(x$0);
    var x = this.Lnet_timerboard_Model__f_socket;
    var x$2 = x$0$2.Lnet_timerboard_Model__f_socket;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lnet_timerboard_Model__f_logs;
      var x$4 = x$0$2.Lnet_timerboard_Model__f_logs;
      var $$x9 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x9 = false
    };
    if ($$x9) {
      var x$5 = this.Lnet_timerboard_Model__f_state;
      var x$6 = x$0$2.Lnet_timerboard_Model__f_state;
      var $$x8 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var x$7 = this.Lnet_timerboard_Model__f_now;
      var x$8 = x$0$2.Lnet_timerboard_Model__f_now;
      var $$x7 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$9 = this.Lnet_timerboard_Model__f_system;
      var x$10 = x$0$2.Lnet_timerboard_Model__f_system;
      var $$x6 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$11 = this.Lnet_timerboard_Model__f_systemNames;
      var x$12 = x$0$2.Lnet_timerboard_Model__f_systemNames;
      var $$x5 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$13 = this.Lnet_timerboard_Model__f_distances;
      var x$14 = x$0$2.Lnet_timerboard_Model__f_distances;
      var $$x4 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      var $$x4 = false
    };
    if (($$x4 && (this.Lnet_timerboard_Model__f_search === x$0$2.Lnet_timerboard_Model__f_search))) {
      var x$15 = this.Lnet_timerboard_Model__f_searchTags;
      var x$16 = x$0$2.Lnet_timerboard_Model__f_searchTags;
      var $$x3 = ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$17 = this.Lnet_timerboard_Model__f_sortBy;
      var x$18 = x$0$2.Lnet_timerboard_Model__f_sortBy;
      var $$x2 = (x$17 === x$18)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$19 = this.Lnet_timerboard_Model__f_sortDirection;
      var x$20 = x$0$2.Lnet_timerboard_Model__f_sortDirection;
      var $$x1 = (x$19 === x$20)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$21 = this.Lnet_timerboard_Model__f_systems;
      var x$22 = x$0$2.Lnet_timerboard_Model__f_systems;
      return ((x$21 === null) ? (x$22 === null) : x$21.equals__O__Z(x$22))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Model.prototype.productArity__I = (function() {
  return 12
});
$c_Lnet_timerboard_Model.prototype.productPrefix__T = (function() {
  return "Model"
});
$c_Lnet_timerboard_Model.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_timerboard_Model__f_socket;
      break
    }
    case 1: {
      return this.Lnet_timerboard_Model__f_logs;
      break
    }
    case 2: {
      return this.Lnet_timerboard_Model__f_state;
      break
    }
    case 3: {
      return this.Lnet_timerboard_Model__f_now;
      break
    }
    case 4: {
      return this.Lnet_timerboard_Model__f_system;
      break
    }
    case 5: {
      return this.Lnet_timerboard_Model__f_systemNames;
      break
    }
    case 6: {
      return this.Lnet_timerboard_Model__f_distances;
      break
    }
    case 7: {
      return this.Lnet_timerboard_Model__f_search;
      break
    }
    case 8: {
      return this.Lnet_timerboard_Model__f_searchTags;
      break
    }
    case 9: {
      return this.Lnet_timerboard_Model__f_sortBy;
      break
    }
    case 10: {
      return this.Lnet_timerboard_Model__f_sortDirection;
      break
    }
    case 11: {
      return this.Lnet_timerboard_Model__f_systems;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lnet_timerboard_Model(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Model) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Model"))
}
function $isArrayOf_Lnet_timerboard_Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Model)))
}
function $asArrayOf_Lnet_timerboard_Model(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Model;", depth))
}
var $d_Lnet_timerboard_Model = new $TypeData().initClass({
  Lnet_timerboard_Model: 0
}, false, "net.timerboard.Model", {
  Lnet_timerboard_Model: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_Model.prototype.$classData = $d_Lnet_timerboard_Model;
/** @constructor */
function $c_Lnet_timerboard_Participant(alliance_id, score) {
  this.Lnet_timerboard_Participant__f_alliance_id = $L0;
  this.Lnet_timerboard_Participant__f_score = null;
  this.Lnet_timerboard_Participant__f_alliance_id = alliance_id;
  this.Lnet_timerboard_Participant__f_score = score
}
$c_Lnet_timerboard_Participant.prototype = new $h_O();
$c_Lnet_timerboard_Participant.prototype.constructor = $c_Lnet_timerboard_Participant;
/** @constructor */
function $h_Lnet_timerboard_Participant() {
  /*<skip>*/
}
$h_Lnet_timerboard_Participant.prototype = $c_Lnet_timerboard_Participant.prototype;
$c_Lnet_timerboard_Participant.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_Participant.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Participant");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lnet_timerboard_Participant__f_alliance_id;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lnet_timerboard_Participant__f_score;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lnet_timerboard_Participant.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Participant)) {
    var x$0$2 = $as_Lnet_timerboard_Participant(x$0);
    var this$1 = this.Lnet_timerboard_Participant__f_alliance_id;
    var b = x$0$2.Lnet_timerboard_Participant__f_alliance_id;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lnet_timerboard_Participant__f_score;
      var x$2 = x$0$2.Lnet_timerboard_Participant__f_score;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_Participant.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Participant.prototype.productArity__I = (function() {
  return 2
});
$c_Lnet_timerboard_Participant.prototype.productPrefix__T = (function() {
  return "Participant"
});
$c_Lnet_timerboard_Participant.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Participant__f_alliance_id
  };
  if ((n === 1)) {
    return this.Lnet_timerboard_Participant__f_score
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_timerboard_Participant(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Participant) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Participant"))
}
function $isArrayOf_Lnet_timerboard_Participant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Participant)))
}
function $asArrayOf_Lnet_timerboard_Participant(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Participant(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Participant;", depth))
}
var $d_Lnet_timerboard_Participant = new $TypeData().initClass({
  Lnet_timerboard_Participant: 0
}, false, "net.timerboard.Participant", {
  Lnet_timerboard_Participant: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_Participant.prototype.$classData = $d_Lnet_timerboard_Participant;
/** @constructor */
function $c_Lnet_timerboard_RenderEvent(id, event_type, system, region, owner, time, remaining, defender_score, distance) {
  this.Lnet_timerboard_RenderEvent__f_id = $L0;
  this.Lnet_timerboard_RenderEvent__f_event_type = null;
  this.Lnet_timerboard_RenderEvent__f_system = null;
  this.Lnet_timerboard_RenderEvent__f_region = null;
  this.Lnet_timerboard_RenderEvent__f_owner = null;
  this.Lnet_timerboard_RenderEvent__f_time = null;
  this.Lnet_timerboard_RenderEvent__f_remaining = null;
  this.Lnet_timerboard_RenderEvent__f_defender_score = null;
  this.Lnet_timerboard_RenderEvent__f_distance = null;
  this.Lnet_timerboard_RenderEvent__f_id = id;
  this.Lnet_timerboard_RenderEvent__f_event_type = event_type;
  this.Lnet_timerboard_RenderEvent__f_system = system;
  this.Lnet_timerboard_RenderEvent__f_region = region;
  this.Lnet_timerboard_RenderEvent__f_owner = owner;
  this.Lnet_timerboard_RenderEvent__f_time = time;
  this.Lnet_timerboard_RenderEvent__f_remaining = remaining;
  this.Lnet_timerboard_RenderEvent__f_defender_score = defender_score;
  this.Lnet_timerboard_RenderEvent__f_distance = distance
}
$c_Lnet_timerboard_RenderEvent.prototype = new $h_O();
$c_Lnet_timerboard_RenderEvent.prototype.constructor = $c_Lnet_timerboard_RenderEvent;
/** @constructor */
function $h_Lnet_timerboard_RenderEvent() {
  /*<skip>*/
}
$h_Lnet_timerboard_RenderEvent.prototype = $c_Lnet_timerboard_RenderEvent.prototype;
$c_Lnet_timerboard_RenderEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_RenderEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("RenderEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lnet_timerboard_RenderEvent__f_id;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lnet_timerboard_RenderEvent__f_event_type;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lnet_timerboard_RenderEvent__f_system;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lnet_timerboard_RenderEvent__f_region;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lnet_timerboard_RenderEvent__f_owner;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lnet_timerboard_RenderEvent__f_time;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lnet_timerboard_RenderEvent__f_remaining;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lnet_timerboard_RenderEvent__f_defender_score;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lnet_timerboard_RenderEvent__f_distance;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9)
});
$c_Lnet_timerboard_RenderEvent.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_RenderEvent)) {
    var x$0$2 = $as_Lnet_timerboard_RenderEvent(x$0);
    var this$1 = this.Lnet_timerboard_RenderEvent__f_id;
    var b = x$0$2.Lnet_timerboard_RenderEvent__f_id;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lnet_timerboard_RenderEvent__f_event_type;
      var x$2 = x$0$2.Lnet_timerboard_RenderEvent__f_event_type;
      var $$x3 = (x === x$2)
    } else {
      var $$x3 = false
    };
    if (((($$x3 && (this.Lnet_timerboard_RenderEvent__f_system === x$0$2.Lnet_timerboard_RenderEvent__f_system)) && (this.Lnet_timerboard_RenderEvent__f_region === x$0$2.Lnet_timerboard_RenderEvent__f_region)) && (this.Lnet_timerboard_RenderEvent__f_owner === x$0$2.Lnet_timerboard_RenderEvent__f_owner))) {
      var x$3 = this.Lnet_timerboard_RenderEvent__f_time;
      var x$4 = x$0$2.Lnet_timerboard_RenderEvent__f_time;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if (($$x2 && (this.Lnet_timerboard_RenderEvent__f_remaining === x$0$2.Lnet_timerboard_RenderEvent__f_remaining))) {
      var x$5 = this.Lnet_timerboard_RenderEvent__f_defender_score;
      var x$6 = x$0$2.Lnet_timerboard_RenderEvent__f_defender_score;
      var $$x1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lnet_timerboard_RenderEvent__f_distance;
      var x$8 = x$0$2.Lnet_timerboard_RenderEvent__f_distance;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_RenderEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_RenderEvent.prototype.productArity__I = (function() {
  return 9
});
$c_Lnet_timerboard_RenderEvent.prototype.productPrefix__T = (function() {
  return "RenderEvent"
});
$c_Lnet_timerboard_RenderEvent.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_timerboard_RenderEvent__f_id;
      break
    }
    case 1: {
      return this.Lnet_timerboard_RenderEvent__f_event_type;
      break
    }
    case 2: {
      return this.Lnet_timerboard_RenderEvent__f_system;
      break
    }
    case 3: {
      return this.Lnet_timerboard_RenderEvent__f_region;
      break
    }
    case 4: {
      return this.Lnet_timerboard_RenderEvent__f_owner;
      break
    }
    case 5: {
      return this.Lnet_timerboard_RenderEvent__f_time;
      break
    }
    case 6: {
      return this.Lnet_timerboard_RenderEvent__f_remaining;
      break
    }
    case 7: {
      return this.Lnet_timerboard_RenderEvent__f_defender_score;
      break
    }
    case 8: {
      return this.Lnet_timerboard_RenderEvent__f_distance;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lnet_timerboard_RenderEvent.prototype.matches__T__Z = (function(s) {
  var x = this.Lnet_timerboard_RenderEvent__f_event_type.toString__T();
  var xs = this.Lnet_timerboard_RenderEvent__f_system;
  var x$1 = (("" + x) + xs);
  var xs$1 = this.Lnet_timerboard_RenderEvent__f_region;
  var x$2 = (x$1 + xs$1);
  var xs$2 = this.Lnet_timerboard_RenderEvent__f_owner;
  var this$10 = (x$2 + xs$2);
  var this$11 = $as_T(this$10.toLowerCase());
  var s$1 = $as_T(s.toLowerCase());
  return ($uI(this$11.indexOf(s$1)) !== (-1))
});
function $as_Lnet_timerboard_RenderEvent(obj) {
  return (((obj instanceof $c_Lnet_timerboard_RenderEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.RenderEvent"))
}
function $isArrayOf_Lnet_timerboard_RenderEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_RenderEvent)))
}
function $asArrayOf_Lnet_timerboard_RenderEvent(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_RenderEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.RenderEvent;", depth))
}
var $d_Lnet_timerboard_RenderEvent = new $TypeData().initClass({
  Lnet_timerboard_RenderEvent: 0
}, false, "net.timerboard.RenderEvent", {
  Lnet_timerboard_RenderEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_RenderEvent.prototype.$classData = $d_Lnet_timerboard_RenderEvent;
/** @constructor */
function $c_Lnet_timerboard_SolarSystem(name, id) {
  this.Lnet_timerboard_SolarSystem__f_name = null;
  this.Lnet_timerboard_SolarSystem__f_id = $L0;
  this.Lnet_timerboard_SolarSystem__f_name = name;
  this.Lnet_timerboard_SolarSystem__f_id = id
}
$c_Lnet_timerboard_SolarSystem.prototype = new $h_O();
$c_Lnet_timerboard_SolarSystem.prototype.constructor = $c_Lnet_timerboard_SolarSystem;
/** @constructor */
function $h_Lnet_timerboard_SolarSystem() {
  /*<skip>*/
}
$h_Lnet_timerboard_SolarSystem.prototype = $c_Lnet_timerboard_SolarSystem.prototype;
$c_Lnet_timerboard_SolarSystem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_SolarSystem.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SolarSystem");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lnet_timerboard_SolarSystem__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lnet_timerboard_SolarSystem__f_id;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lnet_timerboard_SolarSystem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_SolarSystem)) {
    var x$0$2 = $as_Lnet_timerboard_SolarSystem(x$0);
    var this$1 = this.Lnet_timerboard_SolarSystem__f_id;
    var b = x$0$2.Lnet_timerboard_SolarSystem__f_id;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      return (this.Lnet_timerboard_SolarSystem__f_name === x$0$2.Lnet_timerboard_SolarSystem__f_name)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_timerboard_SolarSystem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_SolarSystem.prototype.productArity__I = (function() {
  return 2
});
$c_Lnet_timerboard_SolarSystem.prototype.productPrefix__T = (function() {
  return "SolarSystem"
});
$c_Lnet_timerboard_SolarSystem.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_SolarSystem__f_name
  };
  if ((n === 1)) {
    return this.Lnet_timerboard_SolarSystem__f_id
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_timerboard_SolarSystem(obj) {
  return (((obj instanceof $c_Lnet_timerboard_SolarSystem) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.SolarSystem"))
}
function $isArrayOf_Lnet_timerboard_SolarSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_SolarSystem)))
}
function $asArrayOf_Lnet_timerboard_SolarSystem(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_SolarSystem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.SolarSystem;", depth))
}
var $d_Lnet_timerboard_SolarSystem = new $TypeData().initClass({
  Lnet_timerboard_SolarSystem: 0
}, false, "net.timerboard.SolarSystem", {
  Lnet_timerboard_SolarSystem: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_SolarSystem.prototype.$classData = $d_Lnet_timerboard_SolarSystem;
/** @constructor */
function $c_s_$eq$colon$eq() {
  /*<skip>*/
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
  /*<skip>*/
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
class $c_s_NotImplementedError extends $c_jl_Error {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true)
  };
}
var $d_s_NotImplementedError = new $TypeData().initClass({
  s_NotImplementedError: 0
}, false, "scala.NotImplementedError", {
  s_NotImplementedError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_NotImplementedError.prototype.$classData = $d_s_NotImplementedError;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sjsr_AnonFunction1(((this$1) => ((x$2) => $m_s_None$()))(this))
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
  /*<skip>*/
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_PartialFunction$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x)
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1)
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass({
  s_PartialFunction$$anon$1: 0
}, false, "scala.PartialFunction$$anon$1", {
  s_PartialFunction$$anon$1: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$$anon$1.prototype.$classData = $d_s_PartialFunction$$anon$1;
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k
}
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
  /*<skip>*/
}
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return this.s_PartialFunction$AndThen__f_pf.isDefinedAt__O__Z(x)
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$AndThen__f_k.apply__O__O(this.s_PartialFunction$AndThen__f_pf.apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = this.s_PartialFunction$AndThen__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? this.s_PartialFunction$AndThen__f_k.apply__O__O(z) : default$1.apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass({
  s_PartialFunction$AndThen: 0
}, false, "scala.PartialFunction$AndThen", {
  s_PartialFunction$AndThen: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$AndThen.prototype.$classData = $d_s_PartialFunction$AndThen;
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k
}
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
  /*<skip>*/
}
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && this.s_PartialFunction$Combined__f_k.isDefinedAt__O__Z(b))
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$Combined__f_k.apply__O__O(this.s_PartialFunction$Combined__f_pf.apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? this.s_PartialFunction$Combined__f_k.applyOrElse__O__F1__O(pfv, new $c_sjsr_AnonFunction1(((this$1, default$2, x$1) => ((x$1$2) => default$2.apply__O__O(x$1)))(this, default$1, x))) : default$1.apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass({
  s_PartialFunction$Combined: 0
}, false, "scala.PartialFunction$Combined", {
  s_PartialFunction$Combined: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$Combined.prototype.$classData = $d_s_PartialFunction$Combined;
/** @constructor */
function $c_s_StringContext(parts) {
  this.s_StringContext__f_s$module = null;
  this.s_StringContext__f_parts = null;
  this.s_StringContext__f_parts = parts
}
$c_s_StringContext.prototype = new $h_O();
$c_s_StringContext.prototype.constructor = $c_s_StringContext;
/** @constructor */
function $h_s_StringContext() {
  /*<skip>*/
}
$h_s_StringContext.prototype = $c_s_StringContext.prototype;
$c_s_StringContext.prototype.productPrefix__T = (function() {
  return "StringContext"
});
$c_s_StringContext.prototype.productArity__I = (function() {
  return 1
});
$c_s_StringContext.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_StringContext__f_parts : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_StringContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_StringContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_StringContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_StringContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_StringContext)) {
    var StringContext$1 = $as_s_StringContext(x$1);
    var x = this.s_StringContext__f_parts;
    var x$2 = StringContext$1.s_StringContext__f_parts;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_StringContext(obj) {
  return (((obj instanceof $c_s_StringContext) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.StringContext"))
}
function $isArrayOf_s_StringContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_StringContext)))
}
function $asArrayOf_s_StringContext(obj, depth) {
  return (($isArrayOf_s_StringContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.StringContext;", depth))
}
var $d_s_StringContext = new $TypeData().initClass({
  s_StringContext: 0
}, false, "scala.StringContext", {
  s_StringContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_StringContext.prototype.$classData = $d_s_StringContext;
/** @constructor */
function $c_sc_AbstractIterator() {
  /*<skip>*/
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
  /*<skip>*/
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sc_AbstractIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sc_AbstractIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1))
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sc_AbstractIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1)
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$())
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
  /*<skip>*/
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass({
  sc_Iterable$: 0
}, false, "scala.collection.Iterable$", {
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterable$.prototype.$classData = $d_sc_Iterable$;
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$()
  };
  return $n_sc_Iterable$
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sjsr_AnonFunction0(((this$1) => (() => $m_sc_Map$().sc_Map$__f_DefaultSentinel))(this))
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
  /*<skip>*/
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass({
  sc_Map$: 0
}, false, "scala.collection.Map$", {
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Map$.prototype.$classData = $d_sc_Map$;
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$()
  };
  return $n_sc_Map$
}
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1()
}
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
  /*<skip>*/
}
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((x$1$2) => {
    var x$1 = $as_scm_HashMap(x$1$2);
    return new $c_sc_MapView$Id(x$1)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_MapView$.prototype.from__sc_MapOps__sc_MapView = (function(it) {
  if ($is_sc_MapView(it)) {
    var x2 = $as_sc_MapView(it);
    return x2
  } else {
    return new $c_sc_MapView$Id(it)
  }
});
$c_sc_MapView$.prototype.apply__sci_Seq__sc_MapView = (function(elems) {
  return this.from__sc_MapOps__sc_MapView(($m_s_$less$colon$less$(), $m_sci_Map$().from__sc_IterableOnce__sci_Map(elems)))
});
$c_sc_MapView$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_MapView(elems)
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView
});
var $d_sc_MapView$ = new $TypeData().initClass({
  sc_MapView$: 0
}, false, "scala.collection.MapView$", {
  sc_MapView$: 1,
  O: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapView$.prototype.$classData = $d_sc_MapView$;
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$()
  };
  return $n_sc_MapView$
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.apply__sci_Seq__O(elems))
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.empty__O())
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it))
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_SeqFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source)
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps()
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems)
});
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0))
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sjsr_AnonFunction1(((this$1, elem$1) => ((x$1$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem$1, x$1$2)))($thiz, elem)), from)
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sjsr_AnonFunction1(((this$1, elem$1) => ((x$3$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, elem$1)))($thiz, elem)))
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var elem = $thiz.head__O();
    b.addOne__O__scm_Growable(elem)
  } else if ((len > 1)) {
    b.sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var elem$1 = arr.get(i);
      b.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0)
    }
  };
  return b.result__O()
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(ord, f))
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0)
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.knownSize__I();
    var knownSizeDifference = ((thatKnownSize !== (-1)) && (thisKnownSize !== thatKnownSize))
  } else {
    var knownSizeDifference = false
  };
  if ((!knownSizeDifference)) {
    var this$1 = $thiz.iterator__sc_Iterator();
    return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that)
  } else {
    return false
  }
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)))
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"))
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)))
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth))
}
/** @constructor */
function $c_sc_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$())
}
$c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Set$.prototype.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
  /*<skip>*/
}
$h_sc_Set$.prototype = $c_sc_Set$.prototype;
var $d_sc_Set$ = new $TypeData().initClass({
  sc_Set$: 0
}, false, "scala.collection.Set$", {
  sc_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Set$.prototype.$classData = $d_sc_Set$;
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$()
  };
  return $n_sc_Set$
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return b.result__O()
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var xs = $as_sc_IterableOnce(f.apply__O__O(it.next__O()));
    b.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return b.result__O()
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var v = pf.applyOrElse__O__F1__O(elem, new $c_sjsr_AnonFunction1(((this$2, marker$1) => ((x$2) => marker$1))($thiz, marker)));
    if ((marker !== v)) {
      b.addOne__O__scm_Growable(v)
    }
  };
  return b.result__O()
}
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1($L0)
}
$c_sci_BitSet$.prototype = new $h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
  /*<skip>*/
}
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    var x2 = $as_sci_BitSet(it);
    return x2
  } else {
    var this$1 = this.newBuilder__scm_Builder();
    return $as_sci_BitSet($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(it)).result__O())
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((bs$2) => {
    var bs = $as_scm_BitSet(bs$2);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(bs.scm_BitSet__f_elems)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a, b) {
  return (((b.RTLong__f_lo === 0) && (b.RTLong__f_hi === 0)) ? new $c_sci_BitSet$BitSet1(a) : new $c_sci_BitSet$BitSet2(a, b))
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = elems.u.length;
  return ((len === 0) ? this.sci_BitSet$__f_empty : ((len === 1) ? new $c_sci_BitSet$BitSet1(elems.get(0)) : ((len === 2) ? this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(elems.get(0), elems.get(1)) : new $c_sci_BitSet$BitSetN(elems))))
});
var $d_sci_BitSet$ = new $TypeData().initClass({
  sci_BitSet$: 0
}, false, "scala.collection.immutable.BitSet$", {
  sci_BitSet$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$.prototype.$classData = $d_sci_BitSet$;
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$()
  };
  return $n_sci_BitSet$
}
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = null;
  this.sci_HashMap$accum$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_HashMap$accum$1__f_$outer = outer
  };
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = outer.sci_HashMap__f_rootNode
}
$c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$c_sci_HashMap$accum$1.prototype.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
  /*<skip>*/
}
$h_sci_HashMap$accum$1.prototype = $c_sci_HashMap$accum$1.prototype;
$c_sci_HashMap$accum$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sci_HashMap$accum$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sci_HashMap$accum$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__V = (function(key, value) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var improved = $m_sc_Hashing$().improve__I__I(originalHash);
  if ((!this.sci_HashMap$accum$1__f_changed)) {
    this.sci_HashMap$accum$1__f_current = this.sci_HashMap$accum$1__f_current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, improved, 0, true);
    if ((this.sci_HashMap$accum$1__f_current !== this.sci_HashMap$accum$1__f_$outer.sci_HashMap__f_rootNode)) {
      this.sci_HashMap$accum$1__f_changed = true;
      this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0))
    }
  } else {
    this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = this.sci_HashMap$accum$1__f_current.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, improved, 0, this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap)
  }
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
$c_sci_HashMap$accum$1.prototype.apply__O__O = (function(v1) {
  var kv = $as_T2(v1);
  this.apply__O__O__V(kv._1__O(), kv._2__O())
});
var $d_sci_HashMap$accum$1 = new $TypeData().initClass({
  sci_HashMap$accum$1: 0
}, false, "scala.collection.immutable.HashMap$accum$1", {
  sci_HashMap$accum$1: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  F1: 1
});
$c_sci_HashMap$accum$1.prototype.$classData = $d_sci_HashMap$accum$1;
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$())
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
  /*<skip>*/
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it))
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it)
});
var $d_sci_Iterable$ = new $TypeData().initClass({
  sci_Iterable$: 0
}, false, "scala.collection.immutable.Iterable$", {
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Iterable$.prototype.$classData = $d_sci_Iterable$;
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$()
  };
  return $n_sci_Iterable$
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f__empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  var state = new $c_sjsr_AnonFunction0(((this$1) => (() => $m_sci_LazyList$State$Empty$()))(this));
  this.sci_LazyList$__f__empty = new $c_sci_LazyList(state).force__sci_LazyList();
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sjsr_AnonFunction1(((this$2) => ((x$10$2) => $m_sr_Statics$PFMarker$()))(this))
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
  /*<skip>*/
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sjsr_AnonFunction0(((this$2, restRef$1, f$1) => (() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
    var rest = new $c_sr_ObjectRef(elem);
    while (((!itHasNext) && (!$as_sci_LazyList(rest.sr_ObjectRef__f_elem).isEmpty__Z()))) {
      var this$5 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      it.sr_ObjectRef__f_elem = $as_sc_IterableOnce(f$1.apply__O__O(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O())).iterator__sc_Iterator();
      itHasNext = $as_sc_Iterator(it.sr_ObjectRef__f_elem).hasNext__Z();
      if ((!itHasNext)) {
        var this$6 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        rest.sr_ObjectRef__f_elem = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem)
      }
    };
    if (itHasNext) {
      var head = $as_sc_Iterator(it.sr_ObjectRef__f_elem).next__O();
      var this$7 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      rest.sr_ObjectRef__f_elem = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sjsr_AnonFunction0(((this$8, it$1, rest$1, f$3) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($as_sc_Iterator(it$1.sr_ObjectRef__f_elem), new $c_sjsr_AnonFunction0(((this$9, rest$1$1, f$3$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest$1$1.sr_ObjectRef__f_elem), f$3$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))(this$8, rest$1, f$3)))))(this$2, it, rest, f$1));
      var tl = new $c_sci_LazyList(state);
      return new $c_sci_LazyList$State$Cons(head, tl)
    } else {
      return $m_sci_LazyList$State$Empty$()
    }
  }))(this, restRef, f));
  return new $c_sci_LazyList(state$1)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sjsr_AnonFunction0(((this$3, restRef$1, iRef$1) => (() => {
    var rest = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
    var i = iRef$1.sr_IntRef__f_elem;
    while (((i > 0) && (!rest.isEmpty__Z()))) {
      var this$4 = rest;
      rest = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      restRef$1.sr_ObjectRef__f_elem = rest;
      i = (((-1) + i) | 0);
      iRef$1.sr_IntRef__f_elem = i
    };
    return rest.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
  }))(this, restRef, iRef));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2
  } else if ((coll.knownSize__I() === 0)) {
    return this.sci_LazyList$__f__empty
  } else {
    var state = new $c_sjsr_AnonFunction0(((this$1, coll$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(coll$1.iterator__sc_Iterator())))(this, coll));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State = (function(it, suffix) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0(((this$1, it$1, suffix$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(it$1, suffix$1)))(this, it, suffix));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $as_sci_LazyList$State(suffix.apply__O())
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State = (function(it) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0(((this$1, it$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(it$1)))(this, it));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $m_sci_LazyList$State$Empty$()
  }
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder()
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f__empty
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source)
});
var $d_sci_LazyList$ = new $TypeData().initClass({
  sci_LazyList$: 0
}, false, "scala.collection.immutable.LazyList$", {
  sci_LazyList$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$.prototype.$classData = $d_sci_LazyList$;
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$()
  };
  return $n_sci_LazyList$
}
/** @constructor */
function $c_sci_Stream$() {
  /*<skip>*/
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
  /*<skip>*/
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems)
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream(coll.iterator__sc_Iterator())
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return (it.hasNext__Z() ? new $c_sci_Stream$Cons(it.next__O(), new $c_sjsr_AnonFunction0(((this$1, it$1) => (() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it$1)))(this, it))) : $m_sci_Stream$Empty$())
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((array$2) => {
    var array = $as_scm_ArrayBuffer(array$2);
    return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$()
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source)
});
var $d_sci_Stream$ = new $TypeData().initClass({
  sci_Stream$: 0
}, false, "scala.collection.immutable.Stream$", {
  sci_Stream$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$.prototype.$classData = $d_sci_Stream$;
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$()
  };
  return $n_sci_Stream$
}
/** @constructor */
function $c_sci_TreeSet$() {
  /*<skip>*/
}
$c_sci_TreeSet$.prototype = new $h_O();
$c_sci_TreeSet$.prototype.constructor = $c_sci_TreeSet$;
/** @constructor */
function $h_sci_TreeSet$() {
  /*<skip>*/
}
$h_sci_TreeSet$.prototype = $c_sci_TreeSet$.prototype;
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(it);
    var x$2 = x2.sci_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return x2
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = x3.ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(x3.iterator__sc_Iterator(), x3.size__I()), ordering)
    }
  };
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ordering)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === (x4.sci_Range__f_step > 0))) {
        var it$2 = x4.iterator__sc_Iterator()
      } else {
        var this$2 = new $c_sc_IndexedSeqView$Id(x4);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$2)
      };
      var tree = $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it$2, x4.length__I());
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), tree, ordering)
    }
  };
  var t = null;
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, i.next__O(), null, false, ordering)
  };
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, ordering)
});
$c_sci_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_sci_TreeSet$TreeSetBuilder(ordering)
});
var $d_sci_TreeSet$ = new $TypeData().initClass({
  sci_TreeSet$: 0
}, false, "scala.collection.immutable.TreeSet$", {
  sci_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet$.prototype.$classData = $d_sci_TreeSet$;
var $n_sci_TreeSet$;
function $m_sci_TreeSet$() {
  if ((!$n_sci_TreeSet$)) {
    $n_sci_TreeSet$ = new $c_sci_TreeSet$()
  };
  return $n_sci_TreeSet$
}
/** @constructor */
function $c_sci_WrappedString$() {
  this.sci_WrappedString$__f_empty = null;
  $n_sci_WrappedString$ = this;
  this.sci_WrappedString$__f_empty = new $c_sci_WrappedString("")
}
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
  /*<skip>*/
}
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  var s = it.knownSize__I();
  if ((s >= 0)) {
    b.sizeHint__I__V(s)
  };
  b.addAll__sc_IterableOnce__scm_Growable(it);
  return $as_sci_WrappedString(b.result__O())
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((x$2) => {
    var x = $as_T(x$2);
    return new $c_sci_WrappedString(x)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
var $d_sci_WrappedString$ = new $TypeData().initClass({
  sci_WrappedString$: 0
}, false, "scala.collection.immutable.WrappedString$", {
  sci_WrappedString$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString$.prototype.$classData = $d_sci_WrappedString$;
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$()
  };
  return $n_sci_WrappedString$
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_Builder$$anon$1__f_$outer = outer
  };
  this.scm_Builder$$anon$1__f_f$1 = f$1
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
  /*<skip>*/
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addOne__O__scm_Growable(x);
  return this
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  this.scm_Builder$$anon$1__f_$outer.sizeHint__I__V(size)
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return this.scm_Builder$$anon$1__f_f$1.apply__O__O(this.scm_Builder$$anon$1__f_$outer.result__O())
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(xs)
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem)
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass({
  scm_Builder$$anon$1: 0
}, false, "scala.collection.mutable.Builder$$anon$1", {
  scm_Builder$$anon$1: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_Builder$$anon$1.prototype.$classData = $d_scm_Builder$$anon$1;
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
  /*<skip>*/
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = this.scm_GrowableBuilder__f_elems;
  this$1.addOne__O__scm_Growable(elem);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  this.scm_GrowableBuilder__f_elems.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(xs)
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem)
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems
});
var $d_scm_GrowableBuilder = new $TypeData().initClass({
  scm_GrowableBuilder: 0
}, false, "scala.collection.mutable.GrowableBuilder", {
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_GrowableBuilder.prototype.$classData = $d_scm_GrowableBuilder;
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
  /*<skip>*/
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass({
  scm_Iterable$: 0
}, false, "scala.collection.mutable.Iterable$", {
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Iterable$.prototype.$classData = $d_scm_Iterable$;
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$()
  };
  return $n_scm_Iterable$
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$())
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
  /*<skip>*/
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass({
  scm_Map$: 0
}, false, "scala.collection.mutable.Map$", {
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$.prototype.$classData = $d_scm_Map$;
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$()
  };
  return $n_scm_Map$
}
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$())
}
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
  /*<skip>*/
}
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass({
  scm_Set$: 0
}, false, "scala.collection.mutable.Set$", {
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Set$.prototype.$classData = $d_scm_Set$;
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$()
  };
  return $n_scm_Set$
}
/** @constructor */
function $c_scm_TreeSet$() {
  /*<skip>*/
}
$c_scm_TreeSet$.prototype = new $h_O();
$c_scm_TreeSet$.prototype.constructor = $c_scm_TreeSet$;
/** @constructor */
function $h_scm_TreeSet$() {
  /*<skip>*/
}
$h_scm_TreeSet$.prototype = $c_scm_TreeSet$.prototype;
$c_scm_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_scm_TreeSet)) {
    var x2 = $as_scm_TreeSet(it);
    var x$2 = x2.scm_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return new $c_scm_TreeSet(x2.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree.treeCopy__scm_RedBlackTree$Tree(), ordering)
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = x3.ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      return new $c_scm_TreeSet($m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(x3.iterator__sc_Iterator(), x3.size__I()), ordering)
    }
  };
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = (ordering === this$1.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === (x4.sci_Range__f_step > 0))) {
        var it$2 = x4.iterator__sc_Iterator()
      } else {
        var this$2 = new $c_sc_IndexedSeqView$Id(x4);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$2)
      };
      return new $c_scm_TreeSet($m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(it$2, x4.length__I()), ordering)
    }
  };
  var t = new $c_scm_RedBlackTree$Tree(null, 0);
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(t, i.next__O(), null, ordering)
  };
  return new $c_scm_TreeSet(t, ordering)
});
$c_scm_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_scm_TreeSet$$anon$1(ordering)
});
var $d_scm_TreeSet$ = new $TypeData().initClass({
  scm_TreeSet$: 0
}, false, "scala.collection.mutable.TreeSet$", {
  scm_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet$.prototype.$classData = $d_scm_TreeSet$;
var $n_scm_TreeSet$;
function $m_scm_TreeSet$() {
  if ((!$n_scm_TreeSet$)) {
    $n_scm_TreeSet$ = new $c_scm_TreeSet$()
  };
  return $n_scm_TreeSet$
}
/** @constructor */
function $c_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"))
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)))
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth))
}
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
}
class $c_sr_NonLocalReturnControl extends $c_s_util_control_ControlThrowable {
  constructor(key, value) {
    super();
    this.sr_NonLocalReturnControl__f_key = null;
    this.sr_NonLocalReturnControl__f_value = null;
    this.sr_NonLocalReturnControl__f_key = key;
    this.sr_NonLocalReturnControl__f_value = value;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, false, false)
  };
  fillInStackTrace__jl_Throwable() {
    return this
  };
}
function $as_sr_NonLocalReturnControl(obj) {
  return (((obj instanceof $c_sr_NonLocalReturnControl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"))
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)))
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth))
}
var $d_sr_NonLocalReturnControl = new $TypeData().initClass({
  sr_NonLocalReturnControl: 0
}, false, "scala.runtime.NonLocalReturnControl", {
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_NonLocalReturnControl.prototype.$classData = $d_sr_NonLocalReturnControl;
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $$x1 = dict[key]
  } else {
    var $$x1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  };
  return $ct_T2__O__O__(new $c_T2(), key, $$x1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass({
  sjs_js_WrappedDictionary$DictionaryIterator: 0
}, false, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", {
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.$classData = $d_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = null;
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = {}
}
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype;
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder = (function(elem) {
  var dict = this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict;
  var key = $as_T(elem._1__O());
  var value = elem._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__sjs_js_WrappedDictionary = (function() {
  return new $c_sjs_js_WrappedDictionary(this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__O = (function() {
  return this.result__sjs_js_WrappedDictionary()
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder($as_T2(elem))
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().initClass({
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 0
}, false, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", {
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.$classData = $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $c_s_util_Either() {
  /*<skip>*/
}
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
  /*<skip>*/
}
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return $as_s_util_Either(f.apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return new $c_s_util_Right(f.apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return new $c_s_Some(b)
  } else {
    return $m_s_None$()
  }
});
function $as_s_util_Either(obj) {
  return (((obj instanceof $c_s_util_Either) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either"))
}
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either)))
}
function $asArrayOf_s_util_Either(obj, depth) {
  return (($isArrayOf_s_util_Either(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either;", depth))
}
/** @constructor */
function $c_s_util_Try() {
  /*<skip>*/
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
  /*<skip>*/
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"))
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)))
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth))
}
/** @constructor */
function $c_Lsquants_Quantity() {
  /*<skip>*/
}
$c_Lsquants_Quantity.prototype = new $h_O();
$c_Lsquants_Quantity.prototype.constructor = $c_Lsquants_Quantity;
/** @constructor */
function $h_Lsquants_Quantity() {
  /*<skip>*/
}
$h_Lsquants_Quantity.prototype = $c_Lsquants_Quantity.prototype;
$c_Lsquants_Quantity.prototype.compareTo__O__I = (function(that) {
  return this.compare__Lsquants_Quantity__I($as_Lsquants_Quantity(that))
});
$c_Lsquants_Quantity.prototype.plus__Lsquants_Quantity__Lsquants_Quantity = (function(that) {
  var this$1 = this.Lsquants_time_Time__f_unit;
  var n = (this.Lsquants_time_Time__f_value + that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_time_Time__f_unit));
  var num = $m_s_math_Numeric$DoubleIsFractional$();
  return $m_Lsquants_time_Time$().apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time(n, this$1, num)
});
$c_Lsquants_Quantity.prototype.negate__Lsquants_Quantity = (function() {
  var this$1 = this.Lsquants_time_Time__f_unit;
  var n = (-this.Lsquants_time_Time__f_value);
  var num = $m_s_math_Numeric$DoubleIsFractional$();
  return $m_Lsquants_time_Time$().apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time(n, this$1, num)
});
$c_Lsquants_Quantity.prototype.floor__Lsquants_Quantity = (function() {
  var this$3 = this.Lsquants_time_Time__f_unit;
  var x = this.Lsquants_time_Time__f_value;
  var n = $uD(Math.floor(x));
  var num = $m_s_math_Numeric$DoubleIsFractional$();
  return $m_Lsquants_time_Time$().apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time(n, this$3, num)
});
$c_Lsquants_Quantity.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lsquants_Quantity)) {
    var x = $as_Lsquants_Quantity(that);
    var x$2 = $m_Lsquants_time_Time$();
    var x$3 = $m_Lsquants_time_Time$();
    if ($f_Lsquants_Dimension__equals__O__Z(x$2, x$3)) {
      return (this.Lsquants_time_Time__f_value === x.to__Lsquants_UnitOfMeasure__D(this.Lsquants_time_Time__f_unit))
    }
  };
  return false
});
$c_Lsquants_Quantity.prototype.hashCode__I = (function() {
  var values = new $ac_O([$m_Lsquants_time_Time$(), this.to__Lsquants_UnitOfMeasure__D(($m_Lsquants_time_Time$(), $m_Lsquants_time_Milliseconds$()))]);
  return $m_ju_Arrays$().hashCode__AO__I(values)
});
$c_Lsquants_Quantity.prototype.compare__Lsquants_Quantity__I = (function(that) {
  return ((this.Lsquants_time_Time__f_value > that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_time_Time__f_unit)) ? 1 : ((this.Lsquants_time_Time__f_value < that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_time_Time__f_unit)) ? (-1) : 0))
});
$c_Lsquants_Quantity.prototype.to__Lsquants_UnitOfMeasure__D = (function(uom) {
  var x$2 = this.Lsquants_time_Time__f_unit;
  if ((uom === x$2)) {
    return this.Lsquants_time_Time__f_value
  } else {
    var this$1 = this.Lsquants_time_Time__f_unit;
    var n = this.Lsquants_time_Time__f_value;
    var num = $m_s_math_Numeric$DoubleIsFractional$();
    var n$1 = $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D(this$1, n, num);
    var num$1 = $m_s_math_Numeric$DoubleIsFractional$();
    return $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D(uom, n$1, num$1)
  }
});
$c_Lsquants_Quantity.prototype.in__Lsquants_UnitOfMeasure__Lsquants_Quantity = (function(uom) {
  var x$2 = this.Lsquants_time_Time__f_unit;
  if ((uom === x$2)) {
    return this
  } else {
    var this$1 = this.Lsquants_time_Time__f_unit;
    var n = this.Lsquants_time_Time__f_value;
    var num = $m_s_math_Numeric$DoubleIsFractional$();
    var n$1 = $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D(this$1, n, num);
    var num$1 = $m_s_math_Numeric$DoubleIsFractional$();
    var n$2 = $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D(uom, n$1, num$1);
    var num$2 = $m_s_math_Numeric$DoubleIsFractional$();
    return $m_Lsquants_time_Time$().apply__O__Lsquants_time_TimeUnit__s_math_Numeric__Lsquants_time_Time(n$2, uom, num$2)
  }
});
$c_Lsquants_Quantity.prototype.toString__T = (function() {
  return this.toString__Lsquants_UnitOfMeasure__T(this.Lsquants_time_Time__f_unit)
});
$c_Lsquants_Quantity.prototype.toString__Lsquants_UnitOfMeasure__T = (function(uom) {
  return (($m_Lsquants_Platform$().crossFormat__D__T(this.to__Lsquants_UnitOfMeasure__D(uom)) + " ") + uom.symbol__T())
});
function $as_Lsquants_Quantity(obj) {
  return (((obj instanceof $c_Lsquants_Quantity) || (obj === null)) ? obj : $throwClassCastException(obj, "squants.Quantity"))
}
function $isArrayOf_Lsquants_Quantity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_Quantity)))
}
function $asArrayOf_Lsquants_Quantity(obj, depth) {
  return (($isArrayOf_Lsquants_Quantity(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsquants.Quantity;", depth))
}
function $is_Lsquants_time_TimeUnit(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsquants_time_TimeUnit)))
}
function $as_Lsquants_time_TimeUnit(obj) {
  return (($is_Lsquants_time_TimeUnit(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "squants.time.TimeUnit"))
}
function $isArrayOf_Lsquants_time_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_time_TimeUnit)))
}
function $asArrayOf_Lsquants_time_TimeUnit(obj, depth) {
  return (($isArrayOf_Lsquants_time_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsquants.time.TimeUnit;", depth))
}
var $d_Lsquants_time_TimeUnit = new $TypeData().initClass({
  Lsquants_time_TimeUnit: 0
}, true, "squants.time.TimeUnit", {
  Lsquants_time_TimeUnit: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1
});
/** @constructor */
function $c_Ltyrian_Cmd$Run$ImcompleteRunCmd(observable) {
  this.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable = null;
  this.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable = observable
}
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype = new $h_O();
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.constructor = $c_Ltyrian_Cmd$Run$ImcompleteRunCmd;
/** @constructor */
function $h_Ltyrian_Cmd$Run$ImcompleteRunCmd() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype = $c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype;
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Run$ImcompleteRunCmd)) {
    var x$0$2 = $as_Ltyrian_Cmd$Run$ImcompleteRunCmd(x$0);
    var x = this.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable;
    var x$2 = x$0$2.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.productPrefix__T = (function() {
  return "ImcompleteRunCmd"
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Run$ImcompleteRunCmd__f_observable
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Run$ImcompleteRunCmd(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Run$ImcompleteRunCmd) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Run$ImcompleteRunCmd"))
}
function $isArrayOf_Ltyrian_Cmd$Run$ImcompleteRunCmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Run$ImcompleteRunCmd)))
}
function $asArrayOf_Ltyrian_Cmd$Run$ImcompleteRunCmd(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Run$ImcompleteRunCmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Run$ImcompleteRunCmd;", depth))
}
var $d_Ltyrian_Cmd$Run$ImcompleteRunCmd = new $TypeData().initClass({
  Ltyrian_Cmd$Run$ImcompleteRunCmd: 0
}, false, "tyrian.Cmd$Run$ImcompleteRunCmd", {
  Ltyrian_Cmd$Run$ImcompleteRunCmd: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Run$ImcompleteRunCmd.prototype.$classData = $d_Ltyrian_Cmd$Run$ImcompleteRunCmd;
/** @constructor */
function $c_Ltyrian_Navigation$CurrentHash(hash) {
  this.Ltyrian_Navigation$CurrentHash__f_hash = null;
  this.Ltyrian_Navigation$CurrentHash__f_hash = hash
}
$c_Ltyrian_Navigation$CurrentHash.prototype = new $h_O();
$c_Ltyrian_Navigation$CurrentHash.prototype.constructor = $c_Ltyrian_Navigation$CurrentHash;
/** @constructor */
function $h_Ltyrian_Navigation$CurrentHash() {
  /*<skip>*/
}
$h_Ltyrian_Navigation$CurrentHash.prototype = $c_Ltyrian_Navigation$CurrentHash.prototype;
$c_Ltyrian_Navigation$CurrentHash.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Navigation$CurrentHash.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Navigation$CurrentHash.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Navigation$CurrentHash)) {
    var x$0$2 = $as_Ltyrian_Navigation$CurrentHash(x$0);
    return (this.Ltyrian_Navigation$CurrentHash__f_hash === x$0$2.Ltyrian_Navigation$CurrentHash__f_hash)
  } else {
    return false
  }
});
$c_Ltyrian_Navigation$CurrentHash.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Navigation$CurrentHash.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Navigation$CurrentHash.prototype.productPrefix__T = (function() {
  return "CurrentHash"
});
$c_Ltyrian_Navigation$CurrentHash.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Navigation$CurrentHash__f_hash
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Navigation$CurrentHash(obj) {
  return (((obj instanceof $c_Ltyrian_Navigation$CurrentHash) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Navigation$CurrentHash"))
}
function $isArrayOf_Ltyrian_Navigation$CurrentHash(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Navigation$CurrentHash)))
}
function $asArrayOf_Ltyrian_Navigation$CurrentHash(obj, depth) {
  return (($isArrayOf_Ltyrian_Navigation$CurrentHash(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Navigation$CurrentHash;", depth))
}
var $d_Ltyrian_Navigation$CurrentHash = new $TypeData().initClass({
  Ltyrian_Navigation$CurrentHash: 0
}, false, "tyrian.Navigation$CurrentHash", {
  Ltyrian_Navigation$CurrentHash: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Navigation$CurrentHash.prototype.$classData = $d_Ltyrian_Navigation$CurrentHash;
/** @constructor */
function $c_Ltyrian_cmds_Dom$NotFound(elementId) {
  this.Ltyrian_cmds_Dom$NotFound__f_elementId = null;
  this.Ltyrian_cmds_Dom$NotFound__f_elementId = elementId
}
$c_Ltyrian_cmds_Dom$NotFound.prototype = new $h_O();
$c_Ltyrian_cmds_Dom$NotFound.prototype.constructor = $c_Ltyrian_cmds_Dom$NotFound;
/** @constructor */
function $h_Ltyrian_cmds_Dom$NotFound() {
  /*<skip>*/
}
$h_Ltyrian_cmds_Dom$NotFound.prototype = $c_Ltyrian_cmds_Dom$NotFound.prototype;
$c_Ltyrian_cmds_Dom$NotFound.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_cmds_Dom$NotFound)) {
    var x$0$2 = $as_Ltyrian_cmds_Dom$NotFound(x$0);
    return (this.Ltyrian_cmds_Dom$NotFound__f_elementId === x$0$2.Ltyrian_cmds_Dom$NotFound__f_elementId)
  } else {
    return false
  }
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.productPrefix__T = (function() {
  return "NotFound"
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_cmds_Dom$NotFound__f_elementId
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_cmds_Dom$NotFound(obj) {
  return (((obj instanceof $c_Ltyrian_cmds_Dom$NotFound) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.cmds.Dom$NotFound"))
}
function $isArrayOf_Ltyrian_cmds_Dom$NotFound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_cmds_Dom$NotFound)))
}
function $asArrayOf_Ltyrian_cmds_Dom$NotFound(obj, depth) {
  return (($isArrayOf_Ltyrian_cmds_Dom$NotFound(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.cmds.Dom$NotFound;", depth))
}
var $d_Ltyrian_cmds_Dom$NotFound = new $TypeData().initClass({
  Ltyrian_cmds_Dom$NotFound: 0
}, false, "tyrian.cmds.Dom$NotFound", {
  Ltyrian_cmds_Dom$NotFound: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_cmds_Dom$NotFound.prototype.$classData = $d_Ltyrian_cmds_Dom$NotFound;
function $as_Ltyrian_http_Header(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Header"))
}
function $isArrayOf_Ltyrian_http_Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Header)))
}
function $asArrayOf_Ltyrian_http_Header(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Header(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Header;", depth))
}
/** @constructor */
function $c_Ltyrian_http_Request(method, headers, url, body, expect, timeout, withCredentials) {
  this.Ltyrian_http_Request__f_method = null;
  this.Ltyrian_http_Request__f_headers = null;
  this.Ltyrian_http_Request__f_url = null;
  this.Ltyrian_http_Request__f_body = null;
  this.Ltyrian_http_Request__f_expect = null;
  this.Ltyrian_http_Request__f_timeout = null;
  this.Ltyrian_http_Request__f_withCredentials = false;
  this.Ltyrian_http_Request__f_method = method;
  this.Ltyrian_http_Request__f_headers = headers;
  this.Ltyrian_http_Request__f_url = url;
  this.Ltyrian_http_Request__f_body = body;
  this.Ltyrian_http_Request__f_expect = expect;
  this.Ltyrian_http_Request__f_timeout = timeout;
  this.Ltyrian_http_Request__f_withCredentials = withCredentials
}
$c_Ltyrian_http_Request.prototype = new $h_O();
$c_Ltyrian_http_Request.prototype.constructor = $c_Ltyrian_http_Request;
/** @constructor */
function $h_Ltyrian_http_Request() {
  /*<skip>*/
}
$h_Ltyrian_http_Request.prototype = $c_Ltyrian_http_Request.prototype;
$c_Ltyrian_http_Request.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_http_Request.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Request");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Ltyrian_http_Request__f_method;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Ltyrian_http_Request__f_headers;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Ltyrian_http_Request__f_url;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Ltyrian_http_Request__f_body;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Ltyrian_http_Request__f_expect;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Ltyrian_http_Request__f_timeout;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Ltyrian_http_Request__f_withCredentials ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Ltyrian_http_Request.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_http_Request)) {
    var x$0$2 = $as_Ltyrian_http_Request(x$0);
    if ((this.Ltyrian_http_Request__f_withCredentials === x$0$2.Ltyrian_http_Request__f_withCredentials)) {
      var x = this.Ltyrian_http_Request__f_method;
      var x$2 = x$0$2.Ltyrian_http_Request__f_method;
      var $$x4 = (x === x$2)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$3 = this.Ltyrian_http_Request__f_headers;
      var x$4 = x$0$2.Ltyrian_http_Request__f_headers;
      var $$x3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x3 = false
    };
    if (($$x3 && (this.Ltyrian_http_Request__f_url === x$0$2.Ltyrian_http_Request__f_url))) {
      var x$5 = this.Ltyrian_http_Request__f_body;
      var x$6 = x$0$2.Ltyrian_http_Request__f_body;
      var $$x2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Ltyrian_http_Request__f_expect;
      var x$8 = x$0$2.Ltyrian_http_Request__f_expect;
      var $$x1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Ltyrian_http_Request__f_timeout;
      var x$10 = x$0$2.Ltyrian_http_Request__f_timeout;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_http_Request.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_http_Request.prototype.productArity__I = (function() {
  return 7
});
$c_Ltyrian_http_Request.prototype.productPrefix__T = (function() {
  return "Request"
});
$c_Ltyrian_http_Request.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_http_Request__f_method;
      break
    }
    case 1: {
      return this.Ltyrian_http_Request__f_headers;
      break
    }
    case 2: {
      return this.Ltyrian_http_Request__f_url;
      break
    }
    case 3: {
      return this.Ltyrian_http_Request__f_body;
      break
    }
    case 4: {
      return this.Ltyrian_http_Request__f_expect;
      break
    }
    case 5: {
      return this.Ltyrian_http_Request__f_timeout;
      break
    }
    case 6: {
      return this.Ltyrian_http_Request__f_withCredentials;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Ltyrian_http_Request(obj) {
  return (((obj instanceof $c_Ltyrian_http_Request) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Request"))
}
function $isArrayOf_Ltyrian_http_Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Request)))
}
function $asArrayOf_Ltyrian_http_Request(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Request(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Request;", depth))
}
var $d_Ltyrian_http_Request = new $TypeData().initClass({
  Ltyrian_http_Request: 0
}, false, "tyrian.http.Request", {
  Ltyrian_http_Request: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_http_Request.prototype.$classData = $d_Ltyrian_http_Request;
/** @constructor */
function $c_Ltyrian_http_Response(url, status, headers, body) {
  this.Ltyrian_http_Response__f_url = null;
  this.Ltyrian_http_Response__f_status = null;
  this.Ltyrian_http_Response__f_headers = null;
  this.Ltyrian_http_Response__f_body = null;
  this.Ltyrian_http_Response__f_url = url;
  this.Ltyrian_http_Response__f_status = status;
  this.Ltyrian_http_Response__f_headers = headers;
  this.Ltyrian_http_Response__f_body = body
}
$c_Ltyrian_http_Response.prototype = new $h_O();
$c_Ltyrian_http_Response.prototype.constructor = $c_Ltyrian_http_Response;
/** @constructor */
function $h_Ltyrian_http_Response() {
  /*<skip>*/
}
$h_Ltyrian_http_Response.prototype = $c_Ltyrian_http_Response.prototype;
$c_Ltyrian_http_Response.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_http_Response.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_http_Response.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_http_Response)) {
    var x$0$2 = $as_Ltyrian_http_Response(x$0);
    if ((this.Ltyrian_http_Response__f_url === x$0$2.Ltyrian_http_Response__f_url)) {
      var x = this.Ltyrian_http_Response__f_status;
      var x$2 = x$0$2.Ltyrian_http_Response__f_status;
      var $$x2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Ltyrian_http_Response__f_headers;
      var x$4 = x$0$2.Ltyrian_http_Response__f_headers;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$1 = this.Ltyrian_http_Response__f_body;
      var y = x$0$2.Ltyrian_http_Response__f_body;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_http_Response.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_http_Response.prototype.productArity__I = (function() {
  return 4
});
$c_Ltyrian_http_Response.prototype.productPrefix__T = (function() {
  return "Response"
});
$c_Ltyrian_http_Response.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_http_Response__f_url;
      break
    }
    case 1: {
      return this.Ltyrian_http_Response__f_status;
      break
    }
    case 2: {
      return this.Ltyrian_http_Response__f_headers;
      break
    }
    case 3: {
      return this.Ltyrian_http_Response__f_body;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Ltyrian_http_Response(obj) {
  return (((obj instanceof $c_Ltyrian_http_Response) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Response"))
}
function $isArrayOf_Ltyrian_http_Response(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Response)))
}
function $asArrayOf_Ltyrian_http_Response(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Response(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Response;", depth))
}
var $d_Ltyrian_http_Response = new $TypeData().initClass({
  Ltyrian_http_Response: 0
}, false, "tyrian.http.Response", {
  Ltyrian_http_Response: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_http_Response.prototype.$classData = $d_Ltyrian_http_Response;
/** @constructor */
function $c_Ltyrian_http_Status(code, message) {
  this.Ltyrian_http_Status__f_code = 0;
  this.Ltyrian_http_Status__f_message = null;
  this.Ltyrian_http_Status__f_code = code;
  this.Ltyrian_http_Status__f_message = message
}
$c_Ltyrian_http_Status.prototype = new $h_O();
$c_Ltyrian_http_Status.prototype.constructor = $c_Ltyrian_http_Status;
/** @constructor */
function $h_Ltyrian_http_Status() {
  /*<skip>*/
}
$h_Ltyrian_http_Status.prototype = $c_Ltyrian_http_Status.prototype;
$c_Ltyrian_http_Status.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_http_Status.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Status");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Ltyrian_http_Status__f_code;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Ltyrian_http_Status__f_message;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Ltyrian_http_Status.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_http_Status)) {
    var x$0$2 = $as_Ltyrian_http_Status(x$0);
    return ((this.Ltyrian_http_Status__f_code === x$0$2.Ltyrian_http_Status__f_code) && (this.Ltyrian_http_Status__f_message === x$0$2.Ltyrian_http_Status__f_message))
  } else {
    return false
  }
});
$c_Ltyrian_http_Status.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_http_Status.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_http_Status.prototype.productPrefix__T = (function() {
  return "Status"
});
$c_Ltyrian_http_Status.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_http_Status__f_code
  };
  if ((n === 1)) {
    return this.Ltyrian_http_Status__f_message
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_http_Status(obj) {
  return (((obj instanceof $c_Ltyrian_http_Status) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Status"))
}
function $isArrayOf_Ltyrian_http_Status(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Status)))
}
function $asArrayOf_Ltyrian_http_Status(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Status(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Status;", depth))
}
var $d_Ltyrian_http_Status = new $TypeData().initClass({
  Ltyrian_http_Status: 0
}, false, "tyrian.http.Status", {
  Ltyrian_http_Status: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_http_Status.prototype.$classData = $d_Ltyrian_http_Status;
/** @constructor */
function $c_Ltyrian_websocket_KeepAliveSettings(timeout) {
  this.Ltyrian_websocket_KeepAliveSettings__f_timeout = null;
  this.Ltyrian_websocket_KeepAliveSettings__f_timeout = timeout
}
$c_Ltyrian_websocket_KeepAliveSettings.prototype = new $h_O();
$c_Ltyrian_websocket_KeepAliveSettings.prototype.constructor = $c_Ltyrian_websocket_KeepAliveSettings;
/** @constructor */
function $h_Ltyrian_websocket_KeepAliveSettings() {
  /*<skip>*/
}
$h_Ltyrian_websocket_KeepAliveSettings.prototype = $c_Ltyrian_websocket_KeepAliveSettings.prototype;
$c_Ltyrian_websocket_KeepAliveSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_websocket_KeepAliveSettings)) {
    var x$0$2 = $as_Ltyrian_websocket_KeepAliveSettings(x$0);
    var x = this.Ltyrian_websocket_KeepAliveSettings__f_timeout;
    var x$2 = x$0$2.Ltyrian_websocket_KeepAliveSettings__f_timeout;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.productPrefix__T = (function() {
  return "KeepAliveSettings"
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_websocket_KeepAliveSettings__f_timeout
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_websocket_KeepAliveSettings(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_KeepAliveSettings) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.KeepAliveSettings"))
}
function $isArrayOf_Ltyrian_websocket_KeepAliveSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_KeepAliveSettings)))
}
function $asArrayOf_Ltyrian_websocket_KeepAliveSettings(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_KeepAliveSettings(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.KeepAliveSettings;", depth))
}
var $d_Ltyrian_websocket_KeepAliveSettings = new $TypeData().initClass({
  Ltyrian_websocket_KeepAliveSettings: 0
}, false, "tyrian.websocket.KeepAliveSettings", {
  Ltyrian_websocket_KeepAliveSettings: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_websocket_KeepAliveSettings.prototype.$classData = $d_Ltyrian_websocket_KeepAliveSettings;
/** @constructor */
function $c_Lcats_Eval$Ident(ev) {
  this.Lcats_Eval$Ident__f_ev = null;
  this.Lcats_Eval$Ident__f_ev = ev
}
$c_Lcats_Eval$Ident.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Ident.prototype.constructor = $c_Lcats_Eval$Ident;
/** @constructor */
function $h_Lcats_Eval$Ident() {
  /*<skip>*/
}
$h_Lcats_Eval$Ident.prototype = $c_Lcats_Eval$Ident.prototype;
$c_Lcats_Eval$Ident.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Eval$Ident.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Eval$Ident.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Eval$Ident)) {
    var x$0$2 = $as_Lcats_Eval$Ident(x$0);
    var x = this.Lcats_Eval$Ident__f_ev;
    var x$2 = x$0$2.Lcats_Eval$Ident__f_ev;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lcats_Eval$Ident.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Eval$Ident.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Eval$Ident.prototype.productPrefix__T = (function() {
  return "Ident"
});
$c_Lcats_Eval$Ident.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Ident__f_ev
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_Eval$Ident(obj) {
  return (((obj instanceof $c_Lcats_Eval$Ident) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Ident"))
}
function $isArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Ident)))
}
function $asArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Ident(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Ident;", depth))
}
var $d_Lcats_Eval$Ident = new $TypeData().initClass({
  Lcats_Eval$Ident: 0
}, false, "cats.Eval$Ident", {
  Lcats_Eval$Ident: 1,
  Lcats_Eval$FnStack: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$Ident.prototype.$classData = $d_Lcats_Eval$Ident;
/** @constructor */
function $c_Lcats_Eval$Many(first, rest) {
  this.Lcats_Eval$Many__f_first = null;
  this.Lcats_Eval$Many__f_rest = null;
  this.Lcats_Eval$Many__f_first = first;
  this.Lcats_Eval$Many__f_rest = rest
}
$c_Lcats_Eval$Many.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Many.prototype.constructor = $c_Lcats_Eval$Many;
/** @constructor */
function $h_Lcats_Eval$Many() {
  /*<skip>*/
}
$h_Lcats_Eval$Many.prototype = $c_Lcats_Eval$Many.prototype;
$c_Lcats_Eval$Many.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Eval$Many.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Eval$Many.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Eval$Many)) {
    var x$0$2 = $as_Lcats_Eval$Many(x$0);
    var x = this.Lcats_Eval$Many__f_first;
    var x$2 = x$0$2.Lcats_Eval$Many__f_first;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_Eval$Many__f_rest;
      var x$4 = x$0$2.Lcats_Eval$Many__f_rest;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_Eval$Many.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Eval$Many.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_Eval$Many.prototype.productPrefix__T = (function() {
  return "Many"
});
$c_Lcats_Eval$Many.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Many__f_first
  };
  if ((n === 1)) {
    return this.Lcats_Eval$Many__f_rest
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_Eval$Many(obj) {
  return (((obj instanceof $c_Lcats_Eval$Many) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Many"))
}
function $isArrayOf_Lcats_Eval$Many(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Many)))
}
function $asArrayOf_Lcats_Eval$Many(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Many(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Many;", depth))
}
var $d_Lcats_Eval$Many = new $TypeData().initClass({
  Lcats_Eval$Many: 0
}, false, "cats.Eval$Many", {
  Lcats_Eval$Many: 1,
  Lcats_Eval$FnStack: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$Many.prototype.$classData = $d_Lcats_Eval$Many;
function $as_Lcats_Eval$Memoize(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Memoize"))
}
function $isArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Memoize)))
}
function $asArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Memoize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Memoize;", depth))
}
/** @constructor */
function $c_Lcats_Show$() {
  this.Lcats_Show$__f_catsContravariantForShow = null;
  $n_Lcats_Show$ = this;
  this.Lcats_Show$__f_catsContravariantForShow = new $c_Lcats_Show$$anon$1()
}
$c_Lcats_Show$.prototype = new $h_O();
$c_Lcats_Show$.prototype.constructor = $c_Lcats_Show$;
/** @constructor */
function $h_Lcats_Show$() {
  /*<skip>*/
}
$h_Lcats_Show$.prototype = $c_Lcats_Show$.prototype;
var $d_Lcats_Show$ = new $TypeData().initClass({
  Lcats_Show$: 0
}, false, "cats.Show$", {
  Lcats_Show$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificShowInstances: 1,
  Lcats_instances_NTupleShowInstances: 1,
  Lcats_ShowInstances0: 1,
  Lcats_ShowInstances: 1
});
$c_Lcats_Show$.prototype.$classData = $d_Lcats_Show$;
var $n_Lcats_Show$;
function $m_Lcats_Show$() {
  if ((!$n_Lcats_Show$)) {
    $n_Lcats_Show$ = new $c_Lcats_Show$()
  };
  return $n_Lcats_Show$
}
function $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(self, current) {
  var current$tailLocal1 = current;
  var self$tailLocal1 = self;
  while (true) {
    var x31 = self$tailLocal1;
    if ((x31 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(x31);
      var x50 = x$1.Lcats_data_AndThen$Single__f_f;
      return x50.apply__O__O(current$tailLocal1)
    };
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(x31);
      var x42 = x$1$1.Lcats_data_AndThen$Concat__f_left;
      var x43 = x$1$1.Lcats_data_AndThen$Concat__f_right;
      if ((x42 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x42);
        var x46 = x$1$2.Lcats_data_AndThen$Single__f_f;
        var current$tailLocal1$tmp1 = x46.apply__O__O(current$tailLocal1);
        self$tailLocal1 = x43;
        current$tailLocal1 = current$tailLocal1$tmp1;
        continue
      }
    };
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$3 = $as_Lcats_data_AndThen$Concat(x31);
      var x34 = x$1$3.Lcats_data_AndThen$Concat__f_left;
      var x35 = x$1$3.Lcats_data_AndThen$Concat__f_right;
      if ((x34 instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$4 = $as_Lcats_data_AndThen$Concat(x34);
        var left = $as_Lcats_data_AndThen$Concat(x34);
        self$tailLocal1 = $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(left, x35);
        continue
      }
    };
    throw new $c_s_MatchError(x31)
  }
}
function $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(left, right) {
  var right$tailLocal1 = right;
  var left$tailLocal1 = left;
  while (true) {
    var x52 = left$tailLocal1;
    if ((x52 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1 = $as_Lcats_data_AndThen$Concat(x52);
      var x55 = x$1.Lcats_data_AndThen$Concat__f_left;
      var x56 = x$1.Lcats_data_AndThen$Concat__f_right;
      var right$1 = right$tailLocal1;
      var right$tailLocal1$tmp1 = new $c_Lcats_data_AndThen$Concat(x56, right$1);
      left$tailLocal1 = x55;
      right$tailLocal1 = right$tailLocal1$tmp1;
      continue
    };
    var right$2 = right$tailLocal1;
    return new $c_Lcats_data_AndThen$Concat(x52, right$2)
  }
}
/** @constructor */
function $c_Lcats_data_AndThen() {
  /*<skip>*/
}
$c_Lcats_data_AndThen.prototype = new $h_O();
$c_Lcats_data_AndThen.prototype.constructor = $c_Lcats_data_AndThen;
/** @constructor */
function $h_Lcats_data_AndThen() {
  /*<skip>*/
}
$h_Lcats_data_AndThen.prototype = $c_Lcats_data_AndThen.prototype;
$c_Lcats_data_AndThen.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_AndThen.prototype.apply__O__O = (function(a) {
  return $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, a)
});
$c_Lcats_data_AndThen.prototype.andThen__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this, atg)
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var x12 = x$1.Lcats_data_AndThen$Single__f_f;
      var x13 = x$1.Lcats_data_AndThen$Single__f_index;
      if ((x13 < 128)) {
        var f = x12.andThen__F1__F1(g);
        var index = ((1 + x13) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index)
      }
    };
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var x4 = x$1$1.Lcats_data_AndThen$Concat__f_left;
      var x5 = x$1$1.Lcats_data_AndThen$Concat__f_right;
      if ((x5 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x5);
        var x8 = x$1$2.Lcats_data_AndThen$Single__f_f;
        var x9 = x$1$2.Lcats_data_AndThen$Single__f_index;
        if ((x9 < 128)) {
          var f$1 = x8.andThen__F1__F1(g);
          var index$1 = ((1 + x9) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(x4, right)
        }
      }
    };
    var right$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(this, right$1)
  }
});
$c_Lcats_data_AndThen.prototype.compose__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(atg, this)
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var x27 = x$1.Lcats_data_AndThen$Single__f_f;
      var x28 = x$1.Lcats_data_AndThen$Single__f_index;
      if ((x28 < 128)) {
        var f = x27.compose__F1__F1(g);
        var index = ((1 + x28) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index)
      }
    };
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var x19 = x$1$1.Lcats_data_AndThen$Concat__f_left;
      var x20 = x$1$1.Lcats_data_AndThen$Concat__f_right;
      if ((x19 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x19);
        var x23 = x$1$2.Lcats_data_AndThen$Single__f_f;
        var x24 = x$1$2.Lcats_data_AndThen$Single__f_index;
        if ((x24 < 128)) {
          var f$1 = x23.compose__F1__F1(g);
          var index$1 = ((1 + x24) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x20)
        }
      }
    };
    var left$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(left$1, this)
  }
});
$c_Lcats_data_AndThen.prototype.toString__T = (function() {
  return ("AndThen$" + $systemIdentityHashCode(this))
});
$c_Lcats_data_AndThen.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__Lcats_data_AndThen(g)
});
$c_Lcats_data_AndThen.prototype.compose__F1__F1 = (function(g) {
  return this.compose__F1__Lcats_data_AndThen(g)
});
function $as_Lcats_data_AndThen(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen"))
}
function $isArrayOf_Lcats_data_AndThen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen)))
}
function $asArrayOf_Lcats_data_AndThen(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen;", depth))
}
/** @constructor */
function $c_Lcats_data_AndThen$() {
  this.Lcats_data_AndThenInstances0__f_catsDataArrowForAndThen = null;
  $ct_Lcats_data_AndThenInstances0__(this)
}
$c_Lcats_data_AndThen$.prototype = new $h_Lcats_data_AndThenInstances0();
$c_Lcats_data_AndThen$.prototype.constructor = $c_Lcats_data_AndThen$;
/** @constructor */
function $h_Lcats_data_AndThen$() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$.prototype = $c_Lcats_data_AndThen$.prototype;
$c_Lcats_data_AndThen$.prototype.apply__F1__Lcats_data_AndThen = (function(f) {
  if ((f instanceof $c_Lcats_data_AndThen)) {
    var ref = $as_Lcats_data_AndThen(f);
    return ref
  } else {
    return new $c_Lcats_data_AndThen$Single(f, 0)
  }
});
$c_Lcats_data_AndThen$.prototype.andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen = (function(ab, bc) {
  if ((ab instanceof $c_Lcats_data_AndThen$Single)) {
    var x$1 = $as_Lcats_data_AndThen$Single(ab);
    var x177 = x$1.Lcats_data_AndThen$Single__f_f;
    var x178 = x$1.Lcats_data_AndThen$Single__f_index;
    if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$1 = $as_Lcats_data_AndThen$Single(bc);
      var x151 = x$1$1.Lcats_data_AndThen$Single__f_f;
      var x152 = x$1$1.Lcats_data_AndThen$Single__f_index;
      if ((((x178 + x152) | 0) < 128)) {
        var f = x177.andThen__F1__F1(x151);
        var index = ((1 + ((x178 + x152) | 0)) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index)
      } else {
        return new $c_Lcats_data_AndThen$Concat(ab, bc)
      }
    };
    if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$2 = $as_Lcats_data_AndThen$Concat(bc);
      var x143 = x$1$2.Lcats_data_AndThen$Concat__f_left;
      var x144 = x$1$2.Lcats_data_AndThen$Concat__f_right;
      if ((x143 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$3 = $as_Lcats_data_AndThen$Single(x143);
        var x147 = x$1$3.Lcats_data_AndThen$Single__f_f;
        var x148 = x$1$3.Lcats_data_AndThen$Single__f_index;
        if ((((x178 + x148) | 0) < 128)) {
          var f$1 = x177.andThen__F1__F1(x147);
          var index$1 = ((1 + ((x178 + x148) | 0)) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x144)
        }
      }
    };
    return new $c_Lcats_data_AndThen$Concat(ab, bc)
  };
  if ((ab instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$1$4 = $as_Lcats_data_AndThen$Concat(ab);
    var x169 = x$1$4.Lcats_data_AndThen$Concat__f_left;
    var x170 = x$1$4.Lcats_data_AndThen$Concat__f_right;
    if ((x170 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$5 = $as_Lcats_data_AndThen$Single(x170);
      var x173 = x$1$5.Lcats_data_AndThen$Single__f_f;
      var x174 = x$1$5.Lcats_data_AndThen$Single__f_index;
      if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$6 = $as_Lcats_data_AndThen$Single(bc);
        var x164 = x$1$6.Lcats_data_AndThen$Single__f_f;
        var x165 = x$1$6.Lcats_data_AndThen$Single__f_index;
        if ((((x174 + x165) | 0) < 128)) {
          var f$2 = x173.andThen__F1__F1(x164);
          var index$2 = ((1 + ((x174 + x165) | 0)) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$2, index$2);
          return new $c_Lcats_data_AndThen$Concat(x169, right)
        } else {
          return new $c_Lcats_data_AndThen$Concat(ab, bc)
        }
      };
      if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$7 = $as_Lcats_data_AndThen$Concat(bc);
        var x156 = x$1$7.Lcats_data_AndThen$Concat__f_left;
        var x157 = x$1$7.Lcats_data_AndThen$Concat__f_right;
        if ((x156 instanceof $c_Lcats_data_AndThen$Single)) {
          var x$1$8 = $as_Lcats_data_AndThen$Single(x156);
          var x160 = x$1$8.Lcats_data_AndThen$Single__f_f;
          var x161 = x$1$8.Lcats_data_AndThen$Single__f_index;
          if ((((x174 + x161) | 0) < 128)) {
            var f$3 = x173.andThen__F1__F1(x160);
            var index$3 = ((1 + ((x174 + x161) | 0)) | 0);
            var left$1 = new $c_Lcats_data_AndThen$Single(f$3, index$3);
            var right$1 = new $c_Lcats_data_AndThen$Concat(left$1, x157);
            return new $c_Lcats_data_AndThen$Concat(x169, right$1)
          }
        }
      };
      return new $c_Lcats_data_AndThen$Concat(ab, bc)
    }
  };
  return new $c_Lcats_data_AndThen$Concat(ab, bc)
});
$c_Lcats_data_AndThen$.prototype.ordinal__Lcats_data_AndThen__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    return 0
  };
  if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    return 1
  };
  throw new $c_s_MatchError(x$0)
});
$c_Lcats_data_AndThen$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_data_AndThen__I($as_Lcats_data_AndThen(x))
});
var $d_Lcats_data_AndThen$ = new $TypeData().initClass({
  Lcats_data_AndThen$: 0
}, false, "cats.data.AndThen$", {
  Lcats_data_AndThen$: 1,
  Lcats_data_AndThenInstances0: 1,
  Lcats_data_AndThenInstances1: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_data_AndThen$.prototype.$classData = $d_Lcats_data_AndThen$;
var $n_Lcats_data_AndThen$;
function $m_Lcats_data_AndThen$() {
  if ((!$n_Lcats_data_AndThen$)) {
    $n_Lcats_data_AndThen$ = new $c_Lcats_data_AndThen$()
  };
  return $n_Lcats_data_AndThen$
}
function $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval($thiz, as$1, f$10, G$1, width$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    var flist = $m_Lcats_Eval$().later__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((this$1, as$1$2, f$10$2, G$1$2, end$2) => (() => G$1$2.map__O__F1__O(f$10$2.apply__O__O(as$1$2.apply__I__O((((-1) + end$2) | 0))), new $c_sjsr_AnonFunction1(((this$2) => ((_$6) => {
      var this$3 = $m_s_package$().s_package$__f_Nil;
      return new $c_sci_$colon$colon(_$6, this$3)
    }))(this$1)))))($thiz, as$1, f$10, G$1, end)));
    var idx = (((-2) + end) | 0);
    while ((start <= idx)) {
      var a = as$1.apply__I__O(idx);
      var right = flist;
      $m_Lcats_Eval$();
      var a$1 = new $c_sjsr_AnonFunction0(((this$2$1, f$10$3, G$1$3, a$2, right$2) => (() => G$1$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$10$3.apply__O__O(a$2), right$2, new $c_sjsr_AnonFunction2(((this$4) => ((_$7, _$8) => {
        var _$8$1 = $as_sci_List(_$8);
        return new $c_sci_$colon$colon(_$7, _$8$1)
      }))(this$2$1)))))($thiz, f$10, G$1, a, right));
      flist = new $c_Lcats_Eval$$anon$5(a$1);
      idx = (((-1) + idx) | 0)
    };
    return flist.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$3$1, G$1$4) => ((glist) => G$1$4.map__O__F1__O(glist, new $c_sjsr_AnonFunction1(((this$6) => ((_$9) => {
      var _$9$1 = $as_sci_List(_$9);
      return $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain(_$9$1)
    }))(this$3$1)))))($thiz, G$1)))
  } else {
    var step = $intDiv(((end - start) | 0), width$1);
    $m_Lcats_Eval$();
    var a$3 = new $c_sjsr_AnonFunction0(((this$4$1, as$1$3, f$10$4, G$1$5, width$1$2, start$2, step$2) => (() => $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this$4$1, as$1$3, f$10$4, G$1$5, width$1$2, start$2, ((start$2 + step$2) | 0))))($thiz, as$1, f$10, G$1, width$1, start, step));
    var fchain = new $c_Lcats_Eval$$anon$5(a$3);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var right$3 = $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval($thiz, as$1, f$10, G$1, width$1, start0, end1);
      fchain = fchain.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$5$1, G$1$6, right$4) => ((_$10) => G$1$6.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$10, right$4, new $c_sjsr_AnonFunction2(((this$10) => ((_$11, _$12) => {
        var _$11$1 = $as_Lcats_data_Chain(_$11);
        var _$12$1 = $as_Lcats_data_Chain(_$12);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(_$11$1, _$12$1)
      }))(this$5$1)))))($thiz, G$1, right$3)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0)
    };
    return fchain
  }
}
/** @constructor */
function $c_Lcats_data_Chain$() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = null;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = null;
  this.Lcats_data_Chain$__f_nil = null;
  $ct_Lcats_data_ChainInstances__(this);
  $n_Lcats_data_Chain$ = this;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = new $c_Lcats_data_Chain$$anon$2();
  this.Lcats_data_Chain$__f_nil = $m_Lcats_data_Chain$Empty$()
}
$c_Lcats_data_Chain$.prototype = new $h_Lcats_data_ChainInstances();
$c_Lcats_data_Chain$.prototype.constructor = $c_Lcats_data_Chain$;
/** @constructor */
function $h_Lcats_data_Chain$() {
  /*<skip>*/
}
$h_Lcats_data_Chain$.prototype = $c_Lcats_data_Chain$.prototype;
$c_Lcats_data_Chain$.prototype.concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain = (function(c, c2) {
  if ((c instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(c);
    if ((c2 instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non2 = $as_Lcats_data_Chain$NonEmpty(c2);
      return new $c_Lcats_data_Chain$Append(non, non2)
    } else {
      return non
    }
  } else {
    return c2
  }
});
$c_Lcats_data_Chain$.prototype.fromSeq__sci_Seq__Lcats_data_Chain = (function(s) {
  if (s.isEmpty__Z()) {
    return this.Lcats_data_Chain$__f_nil
  } else if ((s.lengthCompare__I__I(1) === 0)) {
    var a = s.head__O();
    return new $c_Lcats_data_Chain$Singleton(a)
  } else {
    return new $c_Lcats_data_Chain$Wrap(s)
  }
});
$c_Lcats_data_Chain$.prototype.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O = (function(as, f, G) {
  return (as.isEmpty__Z() ? G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil) : $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this, as, f, G, 128, 0, as.length__I()).value__O())
});
var $d_Lcats_data_Chain$ = new $TypeData().initClass({
  Lcats_data_Chain$: 0
}, false, "cats.data.Chain$", {
  Lcats_data_Chain$: 1,
  Lcats_data_ChainInstances: 1,
  Lcats_data_ChainInstances1: 1,
  Lcats_data_ChainInstances2: 1,
  Lcats_data_ChainInstances3: 1,
  O: 1
});
$c_Lcats_data_Chain$.prototype.$classData = $d_Lcats_data_Chain$;
var $n_Lcats_data_Chain$;
function $m_Lcats_data_Chain$() {
  if ((!$n_Lcats_data_Chain$)) {
    $n_Lcats_data_Chain$ = new $c_Lcats_data_Chain$()
  };
  return $n_Lcats_data_Chain$
}
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail
}
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_NonEmptyList)) {
    var x$0$2 = $as_Lcats_data_NonEmptyList(x$0);
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = x$0$2.Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2 = x$0$2.Lcats_data_NonEmptyList__f_tail;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList"
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_NonEmptyList__f_head
  };
  if ((n === 1)) {
    return this.Lcats_data_NonEmptyList__f_tail
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  $m_Lcats_data_NonEmptyList$();
  var head = f.apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var tail = this.Lcats_data_NonEmptyList__f_tail.map__F1__sci_List(f);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var tail = other.$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = other.Lcats_data_NonEmptyList__f_tail;
  var elem = other.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$5 = $as_Lcats_data_NonEmptyList(f.apply__O__O(this.Lcats_data_NonEmptyList__f_head));
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = rest.head__O();
    var this$2 = $as_Lcats_data_NonEmptyList(f.apply__O__O(arg1));
    var this$3 = this$2.Lcats_data_NonEmptyList__f_tail;
    var elem = this$2.Lcats_data_NonEmptyList__f_head;
    var this$4 = new $c_sci_$colon$colon(elem, this$3);
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List(rest.tail__O())
  };
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$5.concat__sci_List__Lcats_data_NonEmptyList(l)
});
$c_Lcats_data_NonEmptyList.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_Foldable$();
  $m_Lcats_UnorderedFoldable$();
  var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$3 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return instance.foldRight__O__Lcats_Eval__F2__Lcats_Eval(new $c_sci_$colon$colon(elem, this$3), lb, f)
});
$c_Lcats_data_NonEmptyList.prototype.traverse__F1__Lcats_Applicative__O = (function(f, G) {
  return G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(this.Lcats_data_NonEmptyList__f_head), $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((this$1, f$2, G$2) => (() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    return instance.traverse__O__F1__Lcats_Applicative__O(this$1.Lcats_data_NonEmptyList__f_tail, f$2, G$2)
  }))(this, f, G))), new $c_sjsr_AnonFunction2(((_$2, _$3) => {
    var _$3$1 = $as_sci_List(_$3);
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(_$2, _$3$1)
  }))).value__O()
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return ("NonEmpty" + new $c_sci_$colon$colon(elem, this$1))
});
function $as_Lcats_data_NonEmptyList(obj) {
  return (((obj instanceof $c_Lcats_data_NonEmptyList) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.NonEmptyList"))
}
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)))
}
function $asArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (($isArrayOf_Lcats_data_NonEmptyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.NonEmptyList;", depth))
}
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass({
  Lcats_data_NonEmptyList: 0
}, false, "cats.data.NonEmptyList", {
  Lcats_data_NonEmptyList: 1,
  O: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_NonEmptyList.prototype.$classData = $d_Lcats_data_NonEmptyList;
/** @constructor */
function $c_Lcats_data_Validated$Invalid(e) {
  this.Lcats_data_Validated$Invalid__f_e = null;
  this.Lcats_data_Validated$Invalid__f_e = e
}
$c_Lcats_data_Validated$Invalid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Invalid.prototype.constructor = $c_Lcats_data_Validated$Invalid;
/** @constructor */
function $h_Lcats_data_Validated$Invalid() {
  /*<skip>*/
}
$h_Lcats_data_Validated$Invalid.prototype = $c_Lcats_data_Validated$Invalid.prototype;
$c_Lcats_data_Validated$Invalid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_Validated$Invalid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$0$2 = $as_Lcats_data_Validated$Invalid(x$0);
    var x = this.Lcats_data_Validated$Invalid__f_e;
    var y = x$0$2.Lcats_data_Validated$Invalid__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_data_Validated$Invalid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_Validated$Invalid.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Validated$Invalid.prototype.productPrefix__T = (function() {
  return "Invalid"
});
$c_Lcats_data_Validated$Invalid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Invalid__f_e
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Validated$Invalid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Invalid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Invalid"))
}
function $isArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Invalid)))
}
function $asArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Invalid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Invalid;", depth))
}
var $d_Lcats_data_Validated$Invalid = new $TypeData().initClass({
  Lcats_data_Validated$Invalid: 0
}, false, "cats.data.Validated$Invalid", {
  Lcats_data_Validated$Invalid: 1,
  Lcats_data_Validated: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Validated$Invalid.prototype.$classData = $d_Lcats_data_Validated$Invalid;
/** @constructor */
function $c_Lcats_data_Validated$Valid(a) {
  this.Lcats_data_Validated$Valid__f_a = null;
  this.Lcats_data_Validated$Valid__f_a = a
}
$c_Lcats_data_Validated$Valid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Valid.prototype.constructor = $c_Lcats_data_Validated$Valid;
/** @constructor */
function $h_Lcats_data_Validated$Valid() {
  /*<skip>*/
}
$h_Lcats_data_Validated$Valid.prototype = $c_Lcats_data_Validated$Valid.prototype;
$c_Lcats_data_Validated$Valid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_Validated$Valid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$0$2 = $as_Lcats_data_Validated$Valid(x$0);
    var x = this.Lcats_data_Validated$Valid__f_a;
    var y = x$0$2.Lcats_data_Validated$Valid__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_data_Validated$Valid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_Validated$Valid.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Validated$Valid.prototype.productPrefix__T = (function() {
  return "Valid"
});
$c_Lcats_data_Validated$Valid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Valid__f_a
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Validated$Valid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Valid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Valid"))
}
function $isArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Valid)))
}
function $asArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Valid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Valid;", depth))
}
var $d_Lcats_data_Validated$Valid = new $TypeData().initClass({
  Lcats_data_Validated$Valid: 0
}, false, "cats.data.Validated$Valid", {
  Lcats_data_Validated$Valid: 1,
  Lcats_data_Validated: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Validated$Valid.prototype.$classData = $d_Lcats_data_Validated$Valid;
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances$$anon$1.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances$$anon$1.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances$$anon$1.prototype = $c_Lcats_data_ValidatedInstances$$anon$1.prototype;
var $d_Lcats_data_ValidatedInstances$$anon$1 = new $TypeData().initClass({
  Lcats_data_ValidatedInstances$$anon$1: 0
}, false, "cats.data.ValidatedInstances$$anon$1", {
  Lcats_data_ValidatedInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
});
$c_Lcats_data_ValidatedInstances$$anon$1.prototype.$classData = $d_Lcats_data_ValidatedInstances$$anon$1;
/** @constructor */
function $c_Lcats_data_WriterTInstances9() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances9.prototype = new $h_Lcats_data_WriterTInstances10();
$c_Lcats_data_WriterTInstances9.prototype.constructor = $c_Lcats_data_WriterTInstances9;
/** @constructor */
function $h_Lcats_data_WriterTInstances9() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances9.prototype = $c_Lcats_data_WriterTInstances9.prototype;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$1.prototype = $c_Lcats_instances_EitherInstances$$anon$1.prototype;
var $d_Lcats_instances_EitherInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$1: 0
}, false, "cats.instances.EitherInstances$$anon$1", {
  Lcats_instances_EitherInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Monoid(fa);
  var fb$1 = $as_Lcats_kernel_Monoid(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$8(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$3", {
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$5() {
  /*<skip>*/
}
$c_Lcats_instances_LazyListInstances$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$5() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$5.prototype = $c_Lcats_instances_LazyListInstances$$anon$5.prototype;
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($as_s_Some(x), true))
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var v = $as_s_Some(x).s_Some__f_value;
    return v
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x))
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1)
});
var $d_Lcats_instances_LazyListInstances$$anon$5 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$5: 0
}, false, "cats.instances.LazyListInstances$$anon$5", {
  Lcats_instances_LazyListInstances$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$5;
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_OrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = this.Lcats_instances_OrderInstances$$anon$2__f_fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? this.Lcats_instances_OrderInstances$$anon$2__f_fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$2: 0
}, false, "cats.instances.OrderInstances$$anon$2", {
  Lcats_instances_OrderInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_TryCoflatMap() {
  /*<skip>*/
}
$c_Lcats_instances_TryCoflatMap.prototype = new $h_O();
$c_Lcats_instances_TryCoflatMap.prototype.constructor = $c_Lcats_instances_TryCoflatMap;
/** @constructor */
function $h_Lcats_instances_TryCoflatMap() {
  /*<skip>*/
}
$h_Lcats_instances_TryCoflatMap.prototype = $c_Lcats_instances_TryCoflatMap.prototype;
/** @constructor */
function $c_Lcats_instances_TryInstances$$anon$4(f$7) {
  this.Lcats_instances_TryInstances$$anon$4__f_f$1 = null;
  this.Lcats_instances_TryInstances$$anon$4__f_f$1 = f$7
}
$c_Lcats_instances_TryInstances$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_TryInstances$$anon$4.prototype.constructor = $c_Lcats_instances_TryInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_TryInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_TryInstances$$anon$4.prototype = $c_Lcats_instances_TryInstances$$anon$4.prototype;
$c_Lcats_instances_TryInstances$$anon$4.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  return this.Lcats_instances_TryInstances$$anon$4__f_f$1.apply__O__O(x)
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcats_instances_TryInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_TryInstances$$anon$4: 0
}, false, "cats.instances.TryInstances$$anon$4", {
  Lcats_instances_TryInstances$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.$classData = $d_Lcats_instances_TryInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_Tuple2Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Tuple2Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Tuple2Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2Instances$$anon$1.prototype = $c_Lcats_instances_Tuple2Instances$$anon$1.prototype;
var $d_Lcats_instances_Tuple2Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Tuple2Instances$$anon$1: 0
}, false, "cats.instances.Tuple2Instances$$anon$1", {
  Lcats_instances_Tuple2Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
});
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Tuple2Instances$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$either$() {
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = null;
  $n_Lcats_instances_package$either$ = this;
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1()
}
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
  /*<skip>*/
}
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
var $d_Lcats_instances_package$either$ = new $TypeData().initClass({
  Lcats_instances_package$either$: 0
}, false, "cats.instances.package$either$", {
  Lcats_instances_package$either$: 1,
  O: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1
});
$c_Lcats_instances_package$either$.prototype.$classData = $d_Lcats_instances_package$either$;
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$()
  };
  return $n_Lcats_instances_package$either$
}
/** @constructor */
function $c_Lcats_instances_package$seq$() {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = null;
  this.Lcats_instances_package$seq$__f_catsStdTraverseFilterForSeq = null;
  $n_Lcats_instances_package$seq$ = this;
  $f_Lcats_instances_SeqInstances__$init$__V(this)
}
$c_Lcats_instances_package$seq$.prototype = new $h_O();
$c_Lcats_instances_package$seq$.prototype.constructor = $c_Lcats_instances_package$seq$;
/** @constructor */
function $h_Lcats_instances_package$seq$() {
  /*<skip>*/
}
$h_Lcats_instances_package$seq$.prototype = $c_Lcats_instances_package$seq$.prototype;
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = x$0
});
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
  this.Lcats_instances_package$seq$__f_catsStdTraverseFilterForSeq = x$0
});
var $d_Lcats_instances_package$seq$ = new $TypeData().initClass({
  Lcats_instances_package$seq$: 0
}, false, "cats.instances.package$seq$", {
  Lcats_instances_package$seq$: 1,
  O: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1
});
$c_Lcats_instances_package$seq$.prototype.$classData = $d_Lcats_instances_package$seq$;
var $n_Lcats_instances_package$seq$;
function $m_Lcats_instances_package$seq$() {
  if ((!$n_Lcats_instances_package$seq$)) {
    $n_Lcats_instances_package$seq$ = new $c_Lcats_instances_package$seq$()
  };
  return $n_Lcats_instances_package$seq$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$$anon$1() {
  /*<skip>*/
}
$c_Lcats_kernel_Comparison$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Comparison$$anon$1.prototype.constructor = $c_Lcats_kernel_Comparison$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Comparison$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$$anon$1.prototype = $c_Lcats_kernel_Comparison$$anon$1.prototype;
$c_Lcats_kernel_Comparison$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.eqv__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.combine__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Lcats_kernel_Comparison = (function(x, y) {
  var x$2 = $m_Lcats_kernel_Comparison$EqualTo$();
  if ((x$2 === x)) {
    return y
  } else {
    return x
  }
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Z($as_Lcats_kernel_Comparison(x), $as_Lcats_kernel_Comparison(y))
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.empty__O = (function() {
  return $m_Lcats_kernel_Comparison$EqualTo$()
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Lcats_kernel_Comparison($as_Lcats_kernel_Comparison(x), $as_Lcats_kernel_Comparison(y))
});
var $d_Lcats_kernel_Comparison$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_Comparison$$anon$1: 0
}, false, "cats.kernel.Comparison$$anon$1", {
  Lcats_kernel_Comparison$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.$classData = $d_Lcats_kernel_Comparison$$anon$1;
/** @constructor */
function $c_Lcats_kernel_Order$() {
  /*<skip>*/
}
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass({
  Lcats_kernel_Order$: 0
}, false, "cats.kernel.Order$", {
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
});
$c_Lcats_kernel_Order$.prototype.$classData = $d_Lcats_kernel_Order$;
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$()
  };
  return $n_Lcats_kernel_Order$
}
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  return ((x === y) ? 0.0 : (($f_sc_BitSetOps__size__I(x) < $f_sc_BitSetOps__size__I(y)) ? ($f_sc_IterableOnceOps__forall__F1__Z(x, y) ? (-1.0) : (NaN)) : (($f_sc_BitSetOps__size__I(y) < $f_sc_BitSetOps__size__I(x)) ? ($f_sc_IterableOnceOps__forall__F1__Z(y, x) ? 1.0 : (NaN)) : (((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y)) ? 0.0 : (NaN)))))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_sci_BitSet(x);
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(x$1, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D($as_sci_BitSet(x), $as_sci_BitSet(y))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z($as_sci_BitSet(x), $as_sci_BitSet(y))
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetPartialOrder: 0
}, false, "cats.kernel.instances.BitSetPartialOrder", {
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.$classData = $d_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $c_Lcats_kernel_instances_OptionOrder(A) {
  this.Lcats_kernel_instances_OptionOrder__f_A = null;
  this.Lcats_kernel_instances_OptionOrder__f_A = A
}
$c_Lcats_kernel_instances_OptionOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_OptionOrder.prototype.constructor = $c_Lcats_kernel_instances_OptionOrder;
/** @constructor */
function $h_Lcats_kernel_instances_OptionOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_OptionOrder.prototype = $c_Lcats_kernel_instances_OptionOrder.prototype;
$c_Lcats_kernel_instances_OptionOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_OptionOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_OptionOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_OptionOrder.prototype.compare__s_Option__s_Option__I = (function(x, y) {
  var x$2 = $m_s_None$();
  if ((x$2 === x)) {
    return (y.isEmpty__Z() ? 0 : (-1))
  };
  if ((x instanceof $c_s_Some)) {
    var a = $as_s_Some(x).s_Some__f_value;
    var x$4 = $m_s_None$();
    if ((x$4 === y)) {
      return 1
    };
    if ((y instanceof $c_s_Some)) {
      var b = $as_s_Some(y).s_Some__f_value;
      return this.Lcats_kernel_instances_OptionOrder__f_A.compare__O__O__I(a, b)
    };
    throw new $c_s_MatchError(y)
  };
  throw new $c_s_MatchError(x)
});
$c_Lcats_kernel_instances_OptionOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__s_Option__s_Option__I($as_s_Option(x), $as_s_Option(y))
});
var $d_Lcats_kernel_instances_OptionOrder = new $TypeData().initClass({
  Lcats_kernel_instances_OptionOrder: 0
}, false, "cats.kernel.instances.OptionOrder", {
  Lcats_kernel_instances_OptionOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
});
$c_Lcats_kernel_instances_OptionOrder.prototype.$classData = $d_Lcats_kernel_instances_OptionOrder;
/** @constructor */
function $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object(fields, Json) {
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields = null;
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_Json = null;
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields = fields;
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_Json = Json
}
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype = new $h_O();
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.constructor = $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object;
/** @constructor */
function $h_Ldiffson_jsonmergepatch_JsonMergePatch$Object() {
  /*<skip>*/
}
$h_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype = $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype;
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object)) {
    var x$0$2 = $as_Ldiffson_jsonmergepatch_JsonMergePatch$Object(x$0);
    var x = this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields;
    var x$2 = x$0$2.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.productPrefix__T = (function() {
  return "Object"
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.toJson__O = (function() {
  var fields = this.Ldiffson_jsonmergepatch_JsonMergePatch$Object__f_fields;
  return $m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json(fields)
});
function $as_Ldiffson_jsonmergepatch_JsonMergePatch$Object(obj) {
  return (((obj instanceof $c_Ldiffson_jsonmergepatch_JsonMergePatch$Object) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonmergepatch.JsonMergePatch$Object"))
}
function $isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Object(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonmergepatch_JsonMergePatch$Object)))
}
function $asArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Object(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Object(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonmergepatch.JsonMergePatch$Object;", depth))
}
var $d_Ldiffson_jsonmergepatch_JsonMergePatch$Object = new $TypeData().initClass({
  Ldiffson_jsonmergepatch_JsonMergePatch$Object: 0
}, false, "diffson.jsonmergepatch.JsonMergePatch$Object", {
  Ldiffson_jsonmergepatch_JsonMergePatch$Object: 1,
  O: 1,
  Ldiffson_jsonmergepatch_JsonMergePatch: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Object.prototype.$classData = $d_Ldiffson_jsonmergepatch_JsonMergePatch$Object;
/** @constructor */
function $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value(toJson) {
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson = null;
  this.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson = toJson
}
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype = new $h_O();
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.constructor = $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value;
/** @constructor */
function $h_Ldiffson_jsonmergepatch_JsonMergePatch$Value() {
  /*<skip>*/
}
$h_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype = $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype;
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value)) {
    var x$0$2 = $as_Ldiffson_jsonmergepatch_JsonMergePatch$Value(x$0);
    var x = this.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson;
    var y = x$0$2.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.productPrefix__T = (function() {
  return "Value"
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.toJson__O = (function() {
  return this.Ldiffson_jsonmergepatch_JsonMergePatch$Value__f_toJson
});
function $as_Ldiffson_jsonmergepatch_JsonMergePatch$Value(obj) {
  return (((obj instanceof $c_Ldiffson_jsonmergepatch_JsonMergePatch$Value) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonmergepatch.JsonMergePatch$Value"))
}
function $isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonmergepatch_JsonMergePatch$Value)))
}
function $asArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Value(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonmergepatch_JsonMergePatch$Value(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonmergepatch.JsonMergePatch$Value;", depth))
}
var $d_Ldiffson_jsonmergepatch_JsonMergePatch$Value = new $TypeData().initClass({
  Ldiffson_jsonmergepatch_JsonMergePatch$Value: 0
}, false, "diffson.jsonmergepatch.JsonMergePatch$Value", {
  Ldiffson_jsonmergepatch_JsonMergePatch$Value: 1,
  O: 1,
  Ldiffson_jsonmergepatch_JsonMergePatch: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonmergepatch_JsonMergePatch$Value.prototype.$classData = $d_Ldiffson_jsonmergepatch_JsonMergePatch$Value;
/** @constructor */
function $c_Ldiffson_jsonpatch_Add(path, value, evidence$2) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Add__f_path = null;
  this.Ldiffson_jsonpatch_Add__f_value = null;
  this.Ldiffson_jsonpatch_Add__f_evidence$2 = null;
  this.Ldiffson_jsonpatch_Add__f_path = path;
  this.Ldiffson_jsonpatch_Add__f_value = value;
  this.Ldiffson_jsonpatch_Add__f_evidence$2 = evidence$2;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$2)
}
$c_Ldiffson_jsonpatch_Add.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Add.prototype.constructor = $c_Ldiffson_jsonpatch_Add;
/** @constructor */
function $h_Ldiffson_jsonpatch_Add() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Add.prototype = $c_Ldiffson_jsonpatch_Add.prototype;
$c_Ldiffson_jsonpatch_Add.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Add.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Add.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Add)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Add(x$0);
    var x = this.Ldiffson_jsonpatch_Add__f_path;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Add__f_path;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Ldiffson_jsonpatch_Add__f_value;
      var y = x$0$2.Ldiffson_jsonpatch_Add__f_value;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Add.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Add.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiffson_jsonpatch_Add.prototype.productPrefix__T = (function() {
  return "Add"
});
$c_Ldiffson_jsonpatch_Add.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return new $c_Ldiffson_jsonpointer_package$Pointer(this.Ldiffson_jsonpatch_Add__f_path)
  };
  if ((n === 1)) {
    return this.Ldiffson_jsonpatch_Add__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonpatch_Add.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Add__f_path
});
$c_Ldiffson_jsonpatch_Add.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O = (function(original, pointer, parent, F) {
  var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(pointer);
  var x78 = _2.Ldiffson_jsonpointer_package$Pointer__f_parts;
  var x = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
  if (((x === null) ? (x78 === null) : x.equals__O__Z(x78))) {
    return F.pure__O__O(this.Ldiffson_jsonpatch_Add__f_value)
  };
  if ((original !== null)) {
    var json = $as_Lio_circe_Json(original);
    var x74 = json.asArray__s_Option();
    if ((!x74.isEmpty__Z())) {
      var x75 = $as_sci_Vector(x74.get__O());
      var x69 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x78);
      if ((!x69.isEmpty__Z())) {
        var x70 = $as_s_util_Either(x69.get__O());
        if (((x70 instanceof $c_s_util_Left) && ($as_s_util_Left(x70).s_util_Left__f_value === "-"))) {
          var elem = this.Ldiffson_jsonpatch_Add__f_value;
          var values = $as_sci_Vector(x75.appended__O__O(elem));
          $m_Lio_circe_Json$();
          return F.pure__O__O(new $c_Lio_circe_Json$JArray(values))
        };
        if ((x70 !== null)) {
          var x61 = x70.toOption__s_Option();
          if ((!x61.isEmpty__Z())) {
            var x62 = $uI(x61.get__O());
            if ((x62 > x75.length__I())) {
              var $$x1 = $m_Lcats_Show$ShowInterpolator$();
              $m_Lcats_implicits$();
              var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
              var sc = new $c_s_StringContext(parts);
              return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x62, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForInt)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
            } else {
              matchResult6: {
                var \u03b42$___1;
                var \u03b42$___2;
                var x41 = $f_sc_IterableOps__splitAt__I__T2(x75, x62);
                if ((x41 !== null)) {
                  var before = $as_sci_Vector(x41._1__O());
                  var after = $as_sci_Vector(x41._2__O());
                  var \u03b42$___1 = before;
                  var \u03b42$___2 = after;
                  break matchResult6
                };
                throw new $c_s_MatchError(x41)
              };
              var before$2 = $as_sci_Vector(\u03b42$___1);
              var after$2 = $as_sci_Vector(\u03b42$___2);
              var elem$1 = this.Ldiffson_jsonpatch_Add__f_value;
              var suffix = after$2.prepended__O__sci_Vector(elem$1);
              var values$1 = before$2.appendedAll__sc_IterableOnce__sci_Vector(suffix);
              $m_Lio_circe_Json$();
              return F.pure__O__O(new $c_Lio_circe_Json$JArray(values$1))
            }
          }
        }
      }
    };
    var Json$3 = this.Ldiffson_jsonpatch_Add__f_evidence$2;
    var x53 = Json$3.fields__Lio_circe_Json__s_Option($as_Lio_circe_Json(original));
    if ((!x53.isEmpty__Z())) {
      var x54 = $as_sci_Map(x53.get__O());
      var x47 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x78);
      if ((!x47.isEmpty__Z())) {
        var x48 = $as_s_util_Either(x47.get__O());
        if ((x48 !== null)) {
          var x50 = $m_Ldiffson_jsonpointer_package$ObjectField$().unapply__s_util_Either__s_Option(x48);
          if ((!x50.isEmpty__Z())) {
            var x51 = $as_T(x50.get__O());
            var fields = $as_sci_Map(x54.updated__O__O__sci_MapOps(x51, this.Ldiffson_jsonpatch_Add__f_value));
            return F.pure__O__O($m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json(fields))
          }
        }
      }
    }
  };
  return $c_Ldiffson_jsonpatch_Operation.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O.call(this, original, pointer, parent, F)
});
function $as_Ldiffson_jsonpatch_Add(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Add) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Add"))
}
function $isArrayOf_Ldiffson_jsonpatch_Add(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Add)))
}
function $asArrayOf_Ldiffson_jsonpatch_Add(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Add(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Add;", depth))
}
var $d_Ldiffson_jsonpatch_Add = new $TypeData().initClass({
  Ldiffson_jsonpatch_Add: 0
}, false, "diffson.jsonpatch.Add", {
  Ldiffson_jsonpatch_Add: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Add.prototype.$classData = $d_Ldiffson_jsonpatch_Add;
/** @constructor */
function $c_Ldiffson_jsonpatch_Copy(from, path, evidence$6) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Copy__f_from = null;
  this.Ldiffson_jsonpatch_Copy__f_path = null;
  this.Ldiffson_jsonpatch_Copy__f_evidence$6 = null;
  this.Ldiffson_jsonpatch_Copy__f_from = from;
  this.Ldiffson_jsonpatch_Copy__f_path = path;
  this.Ldiffson_jsonpatch_Copy__f_evidence$6 = evidence$6;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$6)
}
$c_Ldiffson_jsonpatch_Copy.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Copy.prototype.constructor = $c_Ldiffson_jsonpatch_Copy;
/** @constructor */
function $h_Ldiffson_jsonpatch_Copy() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Copy.prototype = $c_Ldiffson_jsonpatch_Copy.prototype;
$c_Ldiffson_jsonpatch_Copy.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Copy.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Copy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Copy)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Copy(x$0);
    var x = this.Ldiffson_jsonpatch_Copy__f_from;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Copy__f_from;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ldiffson_jsonpatch_Copy__f_path;
      var x$4 = x$0$2.Ldiffson_jsonpatch_Copy__f_path;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Copy.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Copy.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiffson_jsonpatch_Copy.prototype.productPrefix__T = (function() {
  return "Copy"
});
$c_Ldiffson_jsonpatch_Copy.prototype.productElement__I__O = (function(n) {
  matchResult22: {
    var $$x1;
    if ((n === 0)) {
      var $$x1 = this.Ldiffson_jsonpatch_Copy__f_from;
      break matchResult22
    };
    if ((n === 1)) {
      var $$x1 = this.Ldiffson_jsonpatch_Copy__f_path;
      break matchResult22
    };
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return new $c_Ldiffson_jsonpointer_package$Pointer($$x1)
});
$c_Ldiffson_jsonpatch_Copy.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Copy__f_path
});
$c_Ldiffson_jsonpatch_Copy.prototype.apply__O__Lcats_MonadError__O = (function(original, F) {
  $m_Lcats_implicits$();
  var target = $m_Ldiffson_jsonpointer_package$Pointer$().evaluate$extension__Lcats_data_Chain__O__Lcats_MonadError__Ldiffson_Jsony__O(this.Ldiffson_jsonpatch_Copy__f_from, original, F, this.Ldiffson_jsonpatch_Copy__f_evidence$6);
  var this$7 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1(((this$2, original$2, F$2) => ((value) => {
    $m_Lcats_implicits$();
    var path = this$2.Ldiffson_jsonpatch_Copy__f_path;
    var evidence$2 = this$2.Ldiffson_jsonpatch_Copy__f_evidence$6;
    var this$4 = new $c_Ldiffson_jsonpatch_Add(path, value, evidence$2);
    var target$1 = this$4.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(original$2, this$4.Ldiffson_jsonpatch_Add__f_path, $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root, F$2);
    var this$6 = new $c_Lcats_Functor$$anon$4(target$1, F$2);
    var f = new $c_sjsr_AnonFunction1(((res) => res));
    return this$6.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$6.Lcats_Functor$$anon$4__f_self, f)
  }))(this, original, F));
  return this$7.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$$anon$2__f_self, f$1)
});
function $as_Ldiffson_jsonpatch_Copy(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Copy) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Copy"))
}
function $isArrayOf_Ldiffson_jsonpatch_Copy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Copy)))
}
function $asArrayOf_Ldiffson_jsonpatch_Copy(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Copy(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Copy;", depth))
}
var $d_Ldiffson_jsonpatch_Copy = new $TypeData().initClass({
  Ldiffson_jsonpatch_Copy: 0
}, false, "diffson.jsonpatch.Copy", {
  Ldiffson_jsonpatch_Copy: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Copy.prototype.$classData = $d_Ldiffson_jsonpatch_Copy;
function $ps_Ldiffson_jsonpatch_Move__prefix$1__Lcats_data_Chain__Lcats_data_Chain__Z(p1, p2) {
  var p2$tailLocal1 = p2;
  var p1$tailLocal1 = p1;
  while (true) {
    var _1 = new $c_Ldiffson_jsonpointer_package$Pointer(p1$tailLocal1);
    var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(p2$tailLocal1);
    var x172 = _1.Ldiffson_jsonpointer_package$Pointer__f_parts;
    var x173 = _2.Ldiffson_jsonpointer_package$Pointer__f_parts;
    var x178 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x172);
    if ((!x178.isEmpty__Z())) {
      var x179 = $as_T2(x178.get__O());
      var h1 = $as_s_util_Either(x179._1__O());
      var tl1 = ((x179._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x179._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
      var x174 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x173);
      if ((!x174.isEmpty__Z())) {
        var x175 = $as_T2(x174.get__O());
        var h2 = $as_s_util_Either(x175._1__O());
        var tl2 = ((x175._2__O() === null) ? null : $as_Ldiffson_jsonpointer_package$Pointer(x175._2__O()).Ldiffson_jsonpointer_package$Pointer__f_parts);
        if (((h1 === null) ? (h2 === null) : h1.equals__O__Z(h2))) {
          p1$tailLocal1 = tl1;
          p2$tailLocal1 = tl2;
          continue
        }
      }
    };
    var x$3 = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
    if (((x$3 === null) ? (x172 === null) : x$3.equals__O__Z(x172))) {
      var x168 = $m_Ldiffson_jsonpointer_package$Inner$().unapply__Lcats_data_Chain__s_Option(x173);
      if ((!x168.isEmpty__Z())) {
        $as_T2(x168.get__O());
        return true
      }
    };
    return false
  }
}
/** @constructor */
function $c_Ldiffson_jsonpatch_Move(from, path, evidence$5) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Move__f_from = null;
  this.Ldiffson_jsonpatch_Move__f_path = null;
  this.Ldiffson_jsonpatch_Move__f_evidence$5 = null;
  this.Ldiffson_jsonpatch_Move__f_from = from;
  this.Ldiffson_jsonpatch_Move__f_path = path;
  this.Ldiffson_jsonpatch_Move__f_evidence$5 = evidence$5;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$5)
}
$c_Ldiffson_jsonpatch_Move.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Move.prototype.constructor = $c_Ldiffson_jsonpatch_Move;
/** @constructor */
function $h_Ldiffson_jsonpatch_Move() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Move.prototype = $c_Ldiffson_jsonpatch_Move.prototype;
$c_Ldiffson_jsonpatch_Move.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Move.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Move.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Move)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Move(x$0);
    var x = this.Ldiffson_jsonpatch_Move__f_from;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Move__f_from;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ldiffson_jsonpatch_Move__f_path;
      var x$4 = x$0$2.Ldiffson_jsonpatch_Move__f_path;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Move.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Move.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiffson_jsonpatch_Move.prototype.productPrefix__T = (function() {
  return "Move"
});
$c_Ldiffson_jsonpatch_Move.prototype.productElement__I__O = (function(n) {
  matchResult18: {
    var $$x1;
    if ((n === 0)) {
      var $$x1 = this.Ldiffson_jsonpatch_Move__f_from;
      break matchResult18
    };
    if ((n === 1)) {
      var $$x1 = this.Ldiffson_jsonpatch_Move__f_path;
      break matchResult18
    };
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return new $c_Ldiffson_jsonpointer_package$Pointer($$x1)
});
$c_Ldiffson_jsonpatch_Move.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Move__f_path
});
$c_Ldiffson_jsonpatch_Move.prototype.apply__O__Lcats_MonadError__O = (function(original, F) {
  if ($ps_Ldiffson_jsonpatch_Move__prefix$1__Lcats_data_Chain__Lcats_data_Chain__Z(this.Ldiffson_jsonpatch_Move__f_from, this.Ldiffson_jsonpatch_Move__f_path)) {
    return F.raiseError__O__O(new $c_Ldiffson_PatchException("The destination path cannot be a descendant of the source path"))
  } else {
    $m_Lcats_implicits$();
    var target = $m_Ldiffson_jsonpointer_package$Pointer$().evaluate$extension__Lcats_data_Chain__O__Lcats_MonadError__Ldiffson_Jsony__O(this.Ldiffson_jsonpatch_Move__f_from, original, F, this.Ldiffson_jsonpatch_Move__f_evidence$5);
    var this$13 = new $c_Lcats_FlatMap$$anon$2(target, F);
    var f$2 = new $c_sjsr_AnonFunction1(((this$2, original$2, F$2) => ((value) => {
      $m_Lcats_implicits$();
      var path = this$2.Ldiffson_jsonpatch_Move__f_from;
      var old = $m_s_None$();
      var evidence$3 = this$2.Ldiffson_jsonpatch_Move__f_evidence$5;
      var this$5 = new $c_Ldiffson_jsonpatch_Remove(path, old, evidence$3);
      var target$1 = this$5.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(original$2, this$5.Ldiffson_jsonpatch_Remove__f_path, $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root, F$2);
      var this$12 = new $c_Lcats_FlatMap$$anon$2(target$1, F$2);
      var f$1 = new $c_sjsr_AnonFunction1(((this$7, F$1$2, value$2) => ((cleaned) => {
        $m_Lcats_implicits$();
        var path$1 = this$7.Ldiffson_jsonpatch_Move__f_path;
        var evidence$2 = this$7.Ldiffson_jsonpatch_Move__f_evidence$5;
        var this$9 = new $c_Ldiffson_jsonpatch_Add(path$1, value$2, evidence$2);
        var target$2 = this$9.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O(cleaned, this$9.Ldiffson_jsonpatch_Add__f_path, $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root, F$1$2);
        var this$11 = new $c_Lcats_Functor$$anon$4(target$2, F$1$2);
        var f = new $c_sjsr_AnonFunction1(((res) => res));
        return this$11.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$11.Lcats_Functor$$anon$4__f_self, f)
      }))(this$2, F$2, value));
      return this$12.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$$anon$2__f_self, f$1)
    }))(this, original, F));
    return this$13.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$13.Lcats_FlatMap$$anon$2__f_self, f$2)
  }
});
function $as_Ldiffson_jsonpatch_Move(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Move) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Move"))
}
function $isArrayOf_Ldiffson_jsonpatch_Move(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Move)))
}
function $asArrayOf_Ldiffson_jsonpatch_Move(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Move(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Move;", depth))
}
var $d_Ldiffson_jsonpatch_Move = new $TypeData().initClass({
  Ldiffson_jsonpatch_Move: 0
}, false, "diffson.jsonpatch.Move", {
  Ldiffson_jsonpatch_Move: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Move.prototype.$classData = $d_Ldiffson_jsonpatch_Move;
/** @constructor */
function $c_Ldiffson_jsonpatch_Remove(path, old, evidence$3) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Remove__f_path = null;
  this.Ldiffson_jsonpatch_Remove__f_old = null;
  this.Ldiffson_jsonpatch_Remove__f_evidence$3 = null;
  this.Ldiffson_jsonpatch_Remove__f_path = path;
  this.Ldiffson_jsonpatch_Remove__f_old = old;
  this.Ldiffson_jsonpatch_Remove__f_evidence$3 = evidence$3;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$3)
}
$c_Ldiffson_jsonpatch_Remove.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Remove.prototype.constructor = $c_Ldiffson_jsonpatch_Remove;
/** @constructor */
function $h_Ldiffson_jsonpatch_Remove() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Remove.prototype = $c_Ldiffson_jsonpatch_Remove.prototype;
$c_Ldiffson_jsonpatch_Remove.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Remove.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Remove.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Remove)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Remove(x$0);
    var x = this.Ldiffson_jsonpatch_Remove__f_path;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Remove__f_path;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ldiffson_jsonpatch_Remove__f_old;
      var x$4 = x$0$2.Ldiffson_jsonpatch_Remove__f_old;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Remove.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Remove.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiffson_jsonpatch_Remove.prototype.productPrefix__T = (function() {
  return "Remove"
});
$c_Ldiffson_jsonpatch_Remove.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return new $c_Ldiffson_jsonpointer_package$Pointer(this.Ldiffson_jsonpatch_Remove__f_path)
  };
  if ((n === 1)) {
    return this.Ldiffson_jsonpatch_Remove__f_old
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonpatch_Remove.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Remove__f_path
});
$c_Ldiffson_jsonpatch_Remove.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O = (function(value, pointer, parent, F) {
  var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(pointer);
  var x111 = _2.Ldiffson_jsonpointer_package$Pointer__f_parts;
  if ((value !== null)) {
    var json = $as_Lio_circe_Json(value);
    var x118 = json.asArray__s_Option();
    if ((!x118.isEmpty__Z())) {
      var x119 = $as_sci_Vector(x118.get__O());
      var x112 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x111);
      if ((!x112.isEmpty__Z())) {
        var x113 = $as_s_util_Either(x112.get__O());
        if ((x113 !== null)) {
          var x115 = x113.toOption__s_Option();
          if ((!x115.isEmpty__Z())) {
            var x116 = $uI(x115.get__O());
            if ((x116 >= x119.length__I())) {
              var $$x1 = $m_Lcats_Show$ShowInterpolator$();
              $m_Lcats_implicits$();
              var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
              var sc = new $c_s_StringContext(parts);
              return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x116, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForInt)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
            } else {
              matchResult11: {
                var \u03b43$___1;
                var \u03b43$___2;
                var x83 = $f_sc_IterableOps__splitAt__I__T2(x119, x116);
                if ((x83 !== null)) {
                  var before = $as_sci_Vector(x83._1__O());
                  var after = $as_sci_Vector(x83._2__O());
                  var \u03b43$___1 = before;
                  var \u03b43$___2 = after;
                  break matchResult11
                };
                throw new $c_s_MatchError(x83)
              };
              var before$2 = $as_sci_Vector(\u03b43$___1);
              var after$2 = $as_sci_Vector(\u03b43$___2);
              var suffix = after$2.tail__sci_Vector();
              var values = before$2.appendedAll__sc_IterableOnce__sci_Vector(suffix);
              $m_Lio_circe_Json$();
              return F.pure__O__O(new $c_Lio_circe_Json$JArray(values))
            }
          }
        };
        if (((x113 instanceof $c_s_util_Left) && ($as_s_util_Left(x113).s_util_Left__f_value === "-"))) {
          var $$x2 = $m_Lcats_Show$ShowInterpolator$();
          $m_Lcats_implicits$();
          var parts$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element - does not exist at path ", ""]));
          var sc$1 = new $c_s_StringContext(parts$1);
          return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x2.show$extension__s_StringContext__sci_Seq__T(sc$1, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
        }
      }
    };
    var Json$2 = this.Ldiffson_jsonpatch_Remove__f_evidence$3;
    var x97 = Json$2.fields__Lio_circe_Json__s_Option($as_Lio_circe_Json(value));
    if ((!x97.isEmpty__Z())) {
      var x98 = $as_sci_Map(x97.get__O());
      var x91 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x111);
      if ((!x91.isEmpty__Z())) {
        var x92 = $as_s_util_Either(x91.get__O());
        if ((x92 !== null)) {
          var x94 = $m_Ldiffson_jsonpointer_package$ObjectField$().unapply__s_util_Either__s_Option(x92);
          if ((!x94.isEmpty__Z())) {
            var x95 = $as_T(x94.get__O());
            if (x98.contains__O__Z(x95)) {
              var fields = $as_sci_Map(x98.removed__O__sci_MapOps(x95));
              return F.pure__O__O($m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json(fields))
            }
          }
        }
      }
    }
  };
  var x = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
  if (((x === null) ? (x111 === null) : x.equals__O__Z(x111))) {
    return F.raiseError__O__O(new $c_Ldiffson_PatchException("Cannot delete an empty path"))
  };
  return $c_Ldiffson_jsonpatch_Operation.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O.call(this, value, pointer, parent, F)
});
function $as_Ldiffson_jsonpatch_Remove(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Remove) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Remove"))
}
function $isArrayOf_Ldiffson_jsonpatch_Remove(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Remove)))
}
function $asArrayOf_Ldiffson_jsonpatch_Remove(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Remove(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Remove;", depth))
}
var $d_Ldiffson_jsonpatch_Remove = new $TypeData().initClass({
  Ldiffson_jsonpatch_Remove: 0
}, false, "diffson.jsonpatch.Remove", {
  Ldiffson_jsonpatch_Remove: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Remove.prototype.$classData = $d_Ldiffson_jsonpatch_Remove;
/** @constructor */
function $c_Ldiffson_jsonpatch_Replace(path, value, old, evidence$4) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Replace__f_path = null;
  this.Ldiffson_jsonpatch_Replace__f_value = null;
  this.Ldiffson_jsonpatch_Replace__f_old = null;
  this.Ldiffson_jsonpatch_Replace__f_evidence$4 = null;
  this.Ldiffson_jsonpatch_Replace__f_path = path;
  this.Ldiffson_jsonpatch_Replace__f_value = value;
  this.Ldiffson_jsonpatch_Replace__f_old = old;
  this.Ldiffson_jsonpatch_Replace__f_evidence$4 = evidence$4;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$4)
}
$c_Ldiffson_jsonpatch_Replace.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Replace.prototype.constructor = $c_Ldiffson_jsonpatch_Replace;
/** @constructor */
function $h_Ldiffson_jsonpatch_Replace() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Replace.prototype = $c_Ldiffson_jsonpatch_Replace.prototype;
$c_Ldiffson_jsonpatch_Replace.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Replace.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Replace.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Replace)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Replace(x$0);
    var x = this.Ldiffson_jsonpatch_Replace__f_path;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Replace__f_path;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Ldiffson_jsonpatch_Replace__f_value;
      var y = x$0$2.Ldiffson_jsonpatch_Replace__f_value;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Ldiffson_jsonpatch_Replace__f_old;
      var x$4 = x$0$2.Ldiffson_jsonpatch_Replace__f_old;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Replace.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Replace.prototype.productArity__I = (function() {
  return 3
});
$c_Ldiffson_jsonpatch_Replace.prototype.productPrefix__T = (function() {
  return "Replace"
});
$c_Ldiffson_jsonpatch_Replace.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return new $c_Ldiffson_jsonpointer_package$Pointer(this.Ldiffson_jsonpatch_Replace__f_path);
      break
    }
    case 1: {
      return this.Ldiffson_jsonpatch_Replace__f_value;
      break
    }
    case 2: {
      return this.Ldiffson_jsonpatch_Replace__f_old;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Ldiffson_jsonpatch_Replace.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Replace__f_path
});
$c_Ldiffson_jsonpatch_Replace.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O = (function(original, pointer, parent, F) {
  var _2 = new $c_Ldiffson_jsonpointer_package$Pointer(pointer);
  var x158 = _2.Ldiffson_jsonpointer_package$Pointer__f_parts;
  var x = $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_Root;
  if (((x === null) ? (x158 === null) : x.equals__O__Z(x158))) {
    return F.pure__O__O(this.Ldiffson_jsonpatch_Replace__f_value)
  };
  if ((original !== null)) {
    var json = $as_Lio_circe_Json(original);
    var x154 = json.asArray__s_Option();
    if ((!x154.isEmpty__Z())) {
      var x155 = $as_sci_Vector(x154.get__O());
      var x149 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x158);
      if ((!x149.isEmpty__Z())) {
        var x150 = $as_s_util_Either(x149.get__O());
        if ((x150 instanceof $c_s_util_Right)) {
          var idx = $uI($as_s_util_Right(x150).s_util_Right__f_value);
          if ((idx >= x155.length__I())) {
            var $$x1 = $m_Lcats_Show$ShowInterpolator$();
            $m_Lcats_implicits$();
            var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
            var sc = new $c_s_StringContext(parts);
            return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(idx, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForInt)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
          } else {
            var values = x155.updated__I__O__sci_Vector(idx, this.Ldiffson_jsonpatch_Replace__f_value);
            $m_Lio_circe_Json$();
            return F.pure__O__O(new $c_Lio_circe_Json$JArray(values))
          }
        };
        if (((x150 instanceof $c_s_util_Left) && ($as_s_util_Left(x150).s_util_Left__f_value === "-"))) {
          var $$x2 = $m_Lcats_Show$ShowInterpolator$();
          $m_Lcats_implicits$();
          var parts$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element - does not exist at path ", ""]));
          var sc$1 = new $c_s_StringContext(parts$1);
          return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x2.show$extension__s_StringContext__sci_Seq__T(sc$1, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
        }
      }
    };
    var Json$2 = this.Ldiffson_jsonpatch_Replace__f_evidence$4;
    var x134 = Json$2.fields__Lio_circe_Json__s_Option($as_Lio_circe_Json(original));
    if ((!x134.isEmpty__Z())) {
      var x135 = $as_sci_Map(x134.get__O());
      var x128 = $m_Ldiffson_jsonpointer_package$Leaf$().unapply__Lcats_data_Chain__s_Option(x158);
      if ((!x128.isEmpty__Z())) {
        var x129 = $as_s_util_Either(x128.get__O());
        if ((x129 !== null)) {
          var x131 = $m_Ldiffson_jsonpointer_package$ObjectField$().unapply__s_util_Either__s_Option(x129);
          if ((!x131.isEmpty__Z())) {
            var x132 = $as_T(x131.get__O());
            if (x135.contains__O__Z(x132)) {
              var fields = $as_sci_Map(x135.updated__O__O__sci_MapOps(x132, this.Ldiffson_jsonpatch_Replace__f_value));
              return F.pure__O__O($m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json(fields))
            } else {
              var $$x3 = $m_Lcats_Show$ShowInterpolator$();
              $m_Lcats_implicits$();
              var parts$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["element ", " does not exist at path ", ""]));
              var sc$2 = new $c_s_StringContext(parts$2);
              return F.raiseError__O__O(new $c_Ldiffson_PatchException($$x3.show$extension__s_StringContext__sci_Seq__T(sc$2, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(x132, $m_Lcats_implicits$().Lcats_implicits$__f_catsStdShowForString)), new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(parent), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
            }
          }
        }
      }
    }
  };
  return $c_Ldiffson_jsonpatch_Operation.prototype.action__O__Lcats_data_Chain__Lcats_data_Chain__Lcats_MonadError__O.call(this, original, pointer, parent, F)
});
function $as_Ldiffson_jsonpatch_Replace(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Replace) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Replace"))
}
function $isArrayOf_Ldiffson_jsonpatch_Replace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Replace)))
}
function $asArrayOf_Ldiffson_jsonpatch_Replace(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Replace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Replace;", depth))
}
var $d_Ldiffson_jsonpatch_Replace = new $TypeData().initClass({
  Ldiffson_jsonpatch_Replace: 0
}, false, "diffson.jsonpatch.Replace", {
  Ldiffson_jsonpatch_Replace: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Replace.prototype.$classData = $d_Ldiffson_jsonpatch_Replace;
/** @constructor */
function $c_Ldiffson_jsonpatch_Test(path, value, evidence$7) {
  this.Ldiffson_jsonpatch_Operation__f_evidence$1 = null;
  this.Ldiffson_jsonpatch_Test__f_path = null;
  this.Ldiffson_jsonpatch_Test__f_value = null;
  this.Ldiffson_jsonpatch_Test__f_evidence$7 = null;
  this.Ldiffson_jsonpatch_Test__f_path = path;
  this.Ldiffson_jsonpatch_Test__f_value = value;
  this.Ldiffson_jsonpatch_Test__f_evidence$7 = evidence$7;
  $ct_Ldiffson_jsonpatch_Operation__Ldiffson_Jsony__(this, evidence$7)
}
$c_Ldiffson_jsonpatch_Test.prototype = new $h_Ldiffson_jsonpatch_Operation();
$c_Ldiffson_jsonpatch_Test.prototype.constructor = $c_Ldiffson_jsonpatch_Test;
/** @constructor */
function $h_Ldiffson_jsonpatch_Test() {
  /*<skip>*/
}
$h_Ldiffson_jsonpatch_Test.prototype = $c_Ldiffson_jsonpatch_Test.prototype;
$c_Ldiffson_jsonpatch_Test.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ldiffson_jsonpatch_Test.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiffson_jsonpatch_Test.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ldiffson_jsonpatch_Test)) {
    var x$0$2 = $as_Ldiffson_jsonpatch_Test(x$0);
    var x = this.Ldiffson_jsonpatch_Test__f_path;
    var x$2 = x$0$2.Ldiffson_jsonpatch_Test__f_path;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Ldiffson_jsonpatch_Test__f_value;
      var y = x$0$2.Ldiffson_jsonpatch_Test__f_value;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiffson_jsonpatch_Test.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiffson_jsonpatch_Test.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiffson_jsonpatch_Test.prototype.productPrefix__T = (function() {
  return "Test"
});
$c_Ldiffson_jsonpatch_Test.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return new $c_Ldiffson_jsonpointer_package$Pointer(this.Ldiffson_jsonpatch_Test__f_path)
  };
  if ((n === 1)) {
    return this.Ldiffson_jsonpatch_Test__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ldiffson_jsonpatch_Test.prototype.path__Lcats_data_Chain = (function() {
  return this.Ldiffson_jsonpatch_Test__f_path
});
$c_Ldiffson_jsonpatch_Test.prototype.apply__O__Lcats_MonadError__O = (function(original, F) {
  $m_Lcats_implicits$();
  var target = $m_Ldiffson_jsonpointer_package$Pointer$().evaluate$extension__Lcats_data_Chain__O__Lcats_MonadError__Ldiffson_Jsony__O(this.Ldiffson_jsonpatch_Test__f_path, original, F, this.Ldiffson_jsonpatch_Test__f_evidence$7);
  var this$6 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1(((this$2, original$2, F$2) => ((orig) => {
    var x = this$2.Ldiffson_jsonpatch_Test__f_value;
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, orig))) {
      var $$x1 = $m_Lcats_Show$ShowInterpolator$();
      $m_Lcats_implicits$();
      var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["test failed at path ", ""]));
      var sc = new $c_s_StringContext(parts);
      return F$2.raiseError__O__O(new $c_Ldiffson_PatchException($$x1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(new $c_Ldiffson_jsonpointer_package$Pointer(this$2.Ldiffson_jsonpatch_Test__f_path), $m_Ldiffson_jsonpointer_package$Pointer$().Ldiffson_jsonpointer_package$Pointer$__f_show))])))))
    } else {
      return F$2.pure__O__O(original$2)
    }
  }))(this, original, F));
  return this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$$anon$2__f_self, f)
});
function $as_Ldiffson_jsonpatch_Test(obj) {
  return (((obj instanceof $c_Ldiffson_jsonpatch_Test) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.jsonpatch.Test"))
}
function $isArrayOf_Ldiffson_jsonpatch_Test(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_jsonpatch_Test)))
}
function $asArrayOf_Ldiffson_jsonpatch_Test(obj, depth) {
  return (($isArrayOf_Ldiffson_jsonpatch_Test(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.jsonpatch.Test;", depth))
}
var $d_Ldiffson_jsonpatch_Test = new $TypeData().initClass({
  Ldiffson_jsonpatch_Test: 0
}, false, "diffson.jsonpatch.Test", {
  Ldiffson_jsonpatch_Test: 1,
  Ldiffson_jsonpatch_Operation: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiffson_jsonpatch_Test.prototype.$classData = $d_Ldiffson_jsonpatch_Test;
/** @constructor */
function $c_Lio_circe_CursorOp$ArrayOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$ArrayOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ArrayOp.prototype.constructor = $c_Lio_circe_CursorOp$ArrayOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ArrayOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$ArrayOp.prototype = $c_Lio_circe_CursorOp$ArrayOp.prototype;
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresObject__Z = (function() {
  return false
});
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresArray__Z = (function() {
  return true
});
/** @constructor */
function $c_Lio_circe_CursorOp$ObjectOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$ObjectOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ObjectOp.prototype.constructor = $c_Lio_circe_CursorOp$ObjectOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ObjectOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$ObjectOp.prototype = $c_Lio_circe_CursorOp$ObjectOp.prototype;
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresObject__Z = (function() {
  return true
});
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresArray__Z = (function() {
  return false
});
/** @constructor */
function $c_Lio_circe_CursorOp$Op(op) {
  this.Lio_circe_CursorOp$Op__f_op = null;
  this.Lio_circe_CursorOp$Op__f_op = op
}
$c_Lio_circe_CursorOp$Op.prototype = new $h_O();
$c_Lio_circe_CursorOp$Op.prototype.constructor = $c_Lio_circe_CursorOp$Op;
/** @constructor */
function $h_Lio_circe_CursorOp$Op() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$Op.prototype = $c_Lio_circe_CursorOp$Op.prototype;
$c_Lio_circe_CursorOp$Op.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_CursorOp$Op.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$Op.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$Op)) {
    var x$0$2 = $as_Lio_circe_CursorOp$Op(x$0);
    var x = this.Lio_circe_CursorOp$Op__f_op;
    var x$2 = x$0$2.Lio_circe_CursorOp$Op__f_op;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lio_circe_CursorOp$Op.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$Op.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$Op.prototype.productPrefix__T = (function() {
  return "Op"
});
$c_Lio_circe_CursorOp$Op.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$Op__f_op
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lio_circe_CursorOp$Op(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$Op) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Op"))
}
function $isArrayOf_Lio_circe_CursorOp$Op(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Op)))
}
function $asArrayOf_Lio_circe_CursorOp$Op(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Op(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Op;", depth))
}
var $d_Lio_circe_CursorOp$Op = new $TypeData().initClass({
  Lio_circe_CursorOp$Op: 0
}, false, "io.circe.CursorOp$Op", {
  Lio_circe_CursorOp$Op: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$Op.prototype.$classData = $d_Lio_circe_CursorOp$Op;
/** @constructor */
function $c_Lio_circe_CursorOp$SelectField(field) {
  this.Lio_circe_CursorOp$SelectField__f_field = null;
  this.Lio_circe_CursorOp$SelectField__f_field = field
}
$c_Lio_circe_CursorOp$SelectField.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectField.prototype.constructor = $c_Lio_circe_CursorOp$SelectField;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectField() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$SelectField.prototype = $c_Lio_circe_CursorOp$SelectField.prototype;
$c_Lio_circe_CursorOp$SelectField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_CursorOp$SelectField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$SelectField.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$SelectField)) {
    var x$0$2 = $as_Lio_circe_CursorOp$SelectField(x$0);
    return (this.Lio_circe_CursorOp$SelectField__f_field === x$0$2.Lio_circe_CursorOp$SelectField__f_field)
  } else {
    return false
  }
});
$c_Lio_circe_CursorOp$SelectField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$SelectField.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$SelectField.prototype.productPrefix__T = (function() {
  return "SelectField"
});
$c_Lio_circe_CursorOp$SelectField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$SelectField__f_field
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lio_circe_CursorOp$SelectField(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$SelectField) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$SelectField"))
}
function $isArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectField)))
}
function $asArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$SelectField;", depth))
}
var $d_Lio_circe_CursorOp$SelectField = new $TypeData().initClass({
  Lio_circe_CursorOp$SelectField: 0
}, false, "io.circe.CursorOp$SelectField", {
  Lio_circe_CursorOp$SelectField: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$SelectField.prototype.$classData = $d_Lio_circe_CursorOp$SelectField;
/** @constructor */
function $c_Lio_circe_CursorOp$SelectIndex(index) {
  this.Lio_circe_CursorOp$SelectIndex__f_index = 0;
  this.Lio_circe_CursorOp$SelectIndex__f_index = index
}
$c_Lio_circe_CursorOp$SelectIndex.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectIndex.prototype.constructor = $c_Lio_circe_CursorOp$SelectIndex;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectIndex() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$SelectIndex.prototype = $c_Lio_circe_CursorOp$SelectIndex.prototype;
$c_Lio_circe_CursorOp$SelectIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SelectIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_circe_CursorOp$SelectIndex__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
    var x$0$2 = $as_Lio_circe_CursorOp$SelectIndex(x$0);
    return (this.Lio_circe_CursorOp$SelectIndex__f_index === x$0$2.Lio_circe_CursorOp$SelectIndex__f_index)
  } else {
    return false
  }
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productPrefix__T = (function() {
  return "SelectIndex"
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$SelectIndex__f_index
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lio_circe_CursorOp$SelectIndex(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$SelectIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$SelectIndex"))
}
function $isArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectIndex)))
}
function $asArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$SelectIndex;", depth))
}
var $d_Lio_circe_CursorOp$SelectIndex = new $TypeData().initClass({
  Lio_circe_CursorOp$SelectIndex: 0
}, false, "io.circe.CursorOp$SelectIndex", {
  Lio_circe_CursorOp$SelectIndex: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.$classData = $d_Lio_circe_CursorOp$SelectIndex;
/** @constructor */
function $c_Lio_circe_CursorOp$UnconstrainedOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.constructor = $c_Lio_circe_CursorOp$UnconstrainedOp;
/** @constructor */
function $h_Lio_circe_CursorOp$UnconstrainedOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$UnconstrainedOp.prototype = $c_Lio_circe_CursorOp$UnconstrainedOp.prototype;
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresObject__Z = (function() {
  return false
});
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresArray__Z = (function() {
  return false
});
/** @constructor */
function $c_Lio_circe_Decoder$$anon$76() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "ZonedDateTime")
}
$c_Lio_circe_Decoder$$anon$76.prototype = new $h_Lio_circe_Decoder$StandardJavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$76.prototype.constructor = $c_Lio_circe_Decoder$$anon$76;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$76() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$76.prototype = $c_Lio_circe_Decoder$$anon$76.prototype;
var $d_Lio_circe_Decoder$$anon$76 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$76: 0
}, false, "io.circe.Decoder$$anon$76", {
  Lio_circe_Decoder$$anon$76: 1,
  Lio_circe_Decoder$StandardJavaTimeDecoder: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
});
$c_Lio_circe_Decoder$$anon$76.prototype.$classData = $d_Lio_circe_Decoder$$anon$76;
function $ct_Lio_circe_DecodingFailure__T__($thiz, message) {
  $thiz.Lio_circe_DecodingFailure__f_message = message;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_Lio_circe_DecodingFailure extends $c_Lio_circe_Error {
  constructor() {
    super();
    this.Lio_circe_DecodingFailure__f_message = null
  };
  getMessage__T() {
    if (this.history__sci_List().isEmpty__Z()) {
      return this.Lio_circe_DecodingFailure__f_message
    } else {
      var $$x1 = this.Lio_circe_DecodingFailure__f_message;
      var this$1 = this.history__sci_List();
      return (($$x1 + ": ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ",", ""))
    }
  };
  toString__T() {
    return (((("DecodingFailure(" + this.Lio_circe_DecodingFailure__f_message) + ", ") + this.history__sci_List()) + ")")
  };
  equals__O__Z(that) {
    if ((that instanceof $c_Lio_circe_DecodingFailure)) {
      var other = $as_Lio_circe_DecodingFailure(that);
      return $m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_eqDecodingFailure.eqv__O__O__Z(this, other)
    } else {
      return false
    }
  };
  hashCode__I() {
    return $f_T__hashCode__I(this.Lio_circe_DecodingFailure__f_message)
  };
}
function $as_Lio_circe_DecodingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure"))
}
function $isArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure)))
}
function $asArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure;", depth))
}
/** @constructor */
function $c_Lio_circe_Encoder$$anon$4() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$4.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$4.prototype.constructor = $c_Lio_circe_Encoder$$anon$4;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$4() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$4.prototype = $c_Lio_circe_Encoder$$anon$4.prototype;
$c_Lio_circe_Encoder$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$$anon$4.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  var a$1 = $as_Lio_circe_JsonObject(a);
  return a$1
});
var $d_Lio_circe_Encoder$$anon$4 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$4: 0
}, false, "io.circe.Encoder$$anon$4", {
  Lio_circe_Encoder$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lio_circe_Encoder$$anon$4.prototype.$classData = $d_Lio_circe_Encoder$$anon$4;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$7() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$7.prototype.constructor = $c_Lio_circe_Encoder$$anon$7;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$7() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$7.prototype = $c_Lio_circe_Encoder$$anon$7.prototype;
$c_Lio_circe_Encoder$$anon$7.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$$anon$7.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  $as_jl_Void(a);
  return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_empty
});
var $d_Lio_circe_Encoder$$anon$7 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$7: 0
}, false, "io.circe.Encoder$$anon$7", {
  Lio_circe_Encoder$$anon$7: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lio_circe_Encoder$$anon$7.prototype.$classData = $d_Lio_circe_Encoder$$anon$7;
/** @constructor */
function $c_Lio_circe_Json$JArray(value) {
  this.Lio_circe_Json$JArray__f_value = null;
  this.Lio_circe_Json$JArray__f_value = value
}
$c_Lio_circe_Json$JArray.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JArray.prototype.constructor = $c_Lio_circe_Json$JArray;
/** @constructor */
function $h_Lio_circe_Json$JArray() {
  /*<skip>*/
}
$h_Lio_circe_Json$JArray.prototype = $c_Lio_circe_Json$JArray.prototype;
$c_Lio_circe_Json$JArray.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Json$JArray.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JArray.prototype.productPrefix__T = (function() {
  return "JArray"
});
$c_Lio_circe_Json$JArray.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JArray__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JArray.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onArray__sci_Vector__O(this.Lio_circe_Json$JArray__f_value)
});
$c_Lio_circe_Json$JArray.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JArray.prototype.isArray__Z = (function() {
  return true
});
$c_Lio_circe_Json$JArray.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JArray.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JArray.prototype.asArray__s_Option = (function() {
  var value = this.Lio_circe_Json$JArray__f_value;
  return new $c_s_Some(value)
});
$c_Lio_circe_Json$JArray.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lio_circe_Json$JArray(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JArray) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JArray"))
}
function $isArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JArray)))
}
function $asArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JArray;", depth))
}
var $d_Lio_circe_Json$JArray = new $TypeData().initClass({
  Lio_circe_Json$JArray: 0
}, false, "io.circe.Json$JArray", {
  Lio_circe_Json$JArray: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JArray.prototype.$classData = $d_Lio_circe_Json$JArray;
/** @constructor */
function $c_Lio_circe_Json$JBoolean(value) {
  this.Lio_circe_Json$JBoolean__f_value = false;
  this.Lio_circe_Json$JBoolean__f_value = value
}
$c_Lio_circe_Json$JBoolean.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JBoolean.prototype.constructor = $c_Lio_circe_Json$JBoolean;
/** @constructor */
function $h_Lio_circe_Json$JBoolean() {
  /*<skip>*/
}
$h_Lio_circe_Json$JBoolean.prototype = $c_Lio_circe_Json$JBoolean.prototype;
$c_Lio_circe_Json$JBoolean.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("JBoolean");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Json$JBoolean__f_value ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lio_circe_Json$JBoolean.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JBoolean.prototype.productPrefix__T = (function() {
  return "JBoolean"
});
$c_Lio_circe_Json$JBoolean.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JBoolean__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JBoolean.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onBoolean__Z__O(this.Lio_circe_Json$JBoolean__f_value)
});
$c_Lio_circe_Json$JBoolean.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JBoolean.prototype.asArray__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JBoolean.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lio_circe_Json$JBoolean(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JBoolean"))
}
function $isArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JBoolean)))
}
function $asArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JBoolean;", depth))
}
var $d_Lio_circe_Json$JBoolean = new $TypeData().initClass({
  Lio_circe_Json$JBoolean: 0
}, false, "io.circe.Json$JBoolean", {
  Lio_circe_Json$JBoolean: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JBoolean.prototype.$classData = $d_Lio_circe_Json$JBoolean;
/** @constructor */
function $c_Lio_circe_Json$JNumber(value) {
  this.Lio_circe_Json$JNumber__f_value = null;
  this.Lio_circe_Json$JNumber__f_value = value
}
$c_Lio_circe_Json$JNumber.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNumber.prototype.constructor = $c_Lio_circe_Json$JNumber;
/** @constructor */
function $h_Lio_circe_Json$JNumber() {
  /*<skip>*/
}
$h_Lio_circe_Json$JNumber.prototype = $c_Lio_circe_Json$JNumber.prototype;
$c_Lio_circe_Json$JNumber.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Json$JNumber.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JNumber.prototype.productPrefix__T = (function() {
  return "JNumber"
});
$c_Lio_circe_Json$JNumber.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JNumber__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JNumber.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onNumber__Lio_circe_JsonNumber__O(this.Lio_circe_Json$JNumber__f_value)
});
$c_Lio_circe_Json$JNumber.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.asNumber__s_Option = (function() {
  var value = this.Lio_circe_Json$JNumber__f_value;
  return new $c_s_Some(value)
});
$c_Lio_circe_Json$JNumber.prototype.asArray__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNumber.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lio_circe_Json$JNumber(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JNumber"))
}
function $isArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JNumber)))
}
function $asArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JNumber;", depth))
}
var $d_Lio_circe_Json$JNumber = new $TypeData().initClass({
  Lio_circe_Json$JNumber: 0
}, false, "io.circe.Json$JNumber", {
  Lio_circe_Json$JNumber: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JNumber.prototype.$classData = $d_Lio_circe_Json$JNumber;
/** @constructor */
function $c_Lio_circe_Json$JObject(value) {
  this.Lio_circe_Json$JObject__f_value = null;
  this.Lio_circe_Json$JObject__f_value = value
}
$c_Lio_circe_Json$JObject.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JObject.prototype.constructor = $c_Lio_circe_Json$JObject;
/** @constructor */
function $h_Lio_circe_Json$JObject() {
  /*<skip>*/
}
$h_Lio_circe_Json$JObject.prototype = $c_Lio_circe_Json$JObject.prototype;
$c_Lio_circe_Json$JObject.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Json$JObject.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JObject.prototype.productPrefix__T = (function() {
  return "JObject"
});
$c_Lio_circe_Json$JObject.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JObject__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JObject.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onObject__Lio_circe_JsonObject__O(this.Lio_circe_Json$JObject__f_value)
});
$c_Lio_circe_Json$JObject.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JObject.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JObject.prototype.isObject__Z = (function() {
  return true
});
$c_Lio_circe_Json$JObject.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JObject.prototype.asArray__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JObject.prototype.asObject__s_Option = (function() {
  var value = this.Lio_circe_Json$JObject__f_value;
  return new $c_s_Some(value)
});
function $as_Lio_circe_Json$JObject(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JObject"))
}
function $isArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JObject)))
}
function $asArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JObject;", depth))
}
var $d_Lio_circe_Json$JObject = new $TypeData().initClass({
  Lio_circe_Json$JObject: 0
}, false, "io.circe.Json$JObject", {
  Lio_circe_Json$JObject: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JObject.prototype.$classData = $d_Lio_circe_Json$JObject;
/** @constructor */
function $c_Lio_circe_Json$JString(value) {
  this.Lio_circe_Json$JString__f_value = null;
  this.Lio_circe_Json$JString__f_value = value
}
$c_Lio_circe_Json$JString.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JString.prototype.constructor = $c_Lio_circe_Json$JString;
/** @constructor */
function $h_Lio_circe_Json$JString() {
  /*<skip>*/
}
$h_Lio_circe_Json$JString.prototype = $c_Lio_circe_Json$JString.prototype;
$c_Lio_circe_Json$JString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Json$JString.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JString.prototype.productPrefix__T = (function() {
  return "JString"
});
$c_Lio_circe_Json$JString.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JString__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JString.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onString__T__O(this.Lio_circe_Json$JString__f_value)
});
$c_Lio_circe_Json$JString.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JString.prototype.asArray__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JString.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lio_circe_Json$JString(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JString) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JString"))
}
function $isArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JString)))
}
function $asArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JString;", depth))
}
var $d_Lio_circe_Json$JString = new $TypeData().initClass({
  Lio_circe_Json$JString: 0
}, false, "io.circe.Json$JString", {
  Lio_circe_Json$JString: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JString.prototype.$classData = $d_Lio_circe_Json$JString;
/** @constructor */
function $c_Lio_circe_JsonBigDecimal(value) {
  this.Lio_circe_JsonBigDecimal__f_value = null;
  this.Lio_circe_JsonBigDecimal__f_value = value
}
$c_Lio_circe_JsonBigDecimal.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonBigDecimal.prototype.constructor = $c_Lio_circe_JsonBigDecimal;
/** @constructor */
function $h_Lio_circe_JsonBigDecimal() {
  /*<skip>*/
}
$h_Lio_circe_JsonBigDecimal.prototype = $c_Lio_circe_JsonBigDecimal.prototype;
$c_Lio_circe_JsonBigDecimal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_JsonBigDecimal.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonBigDecimal.prototype.productPrefix__T = (function() {
  return "JsonBigDecimal"
});
$c_Lio_circe_JsonBigDecimal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonBigDecimal__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_JsonBigDecimal.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var $$x1 = d.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var value = d.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi))
});
$c_Lio_circe_JsonBigDecimal.prototype.toBigDecimal__s_Option = (function() {
  var value = $ct_s_math_BigDecimal__Ljava_math_BigDecimal__(new $c_s_math_BigDecimal(), this.Lio_circe_JsonBigDecimal__f_value);
  return new $c_s_Some(value)
});
$c_Lio_circe_JsonBigDecimal.prototype.toBigInt__s_Option = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var $$x1 = d.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var value = d.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var this$3 = $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi));
  var this$4 = this$3.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var _$2 = $as_Ljava_math_BigInteger(arg1);
    return new $c_s_Some($m_s_package$().BigInt__s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(_$2))
  }
});
$c_Lio_circe_JsonBigDecimal.prototype.toDouble__D = (function() {
  return this.Lio_circe_JsonBigDecimal__f_value.doubleValue__D()
});
$c_Lio_circe_JsonBigDecimal.prototype.toFloat__F = (function() {
  return this.Lio_circe_JsonBigDecimal__f_value.floatValue__F()
});
$c_Lio_circe_JsonBigDecimal.prototype.toLong__s_Option = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var $$x1 = d.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var value = d.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi)).toLong__s_Option()
});
$c_Lio_circe_JsonBigDecimal.prototype.toString__T = (function() {
  return this.Lio_circe_JsonBigDecimal__f_value.toString__T()
});
$c_Lio_circe_JsonBigDecimal.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var str = this.Lio_circe_JsonBigDecimal__f_value.toString__T();
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
function $as_Lio_circe_JsonBigDecimal(obj) {
  return (((obj instanceof $c_Lio_circe_JsonBigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonBigDecimal"))
}
function $isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonBigDecimal)))
}
function $asArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonBigDecimal;", depth))
}
var $d_Lio_circe_JsonBigDecimal = new $TypeData().initClass({
  Lio_circe_JsonBigDecimal: 0
}, false, "io.circe.JsonBigDecimal", {
  Lio_circe_JsonBigDecimal: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_JsonBigDecimal.prototype.$classData = $d_Lio_circe_JsonBigDecimal;
/** @constructor */
function $c_Lio_circe_JsonDouble(value) {
  this.Lio_circe_JsonDouble__f_value = 0.0;
  this.Lio_circe_JsonDouble__f_value = value
}
$c_Lio_circe_JsonDouble.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonDouble.prototype.constructor = $c_Lio_circe_JsonDouble;
/** @constructor */
function $h_Lio_circe_JsonDouble() {
  /*<skip>*/
}
$h_Lio_circe_JsonDouble.prototype = $c_Lio_circe_JsonDouble.prototype;
$c_Lio_circe_JsonDouble.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_JsonDouble.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonDouble.prototype.productPrefix__T = (function() {
  return "JsonDouble"
});
$c_Lio_circe_JsonDouble.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonDouble__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_JsonDouble.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonDouble__f_value)
});
$c_Lio_circe_JsonDouble.prototype.toBigDecimal__s_Option = (function() {
  var $$x1 = $m_s_math_BigDecimal$();
  var d = this.Lio_circe_JsonDouble__f_value;
  var value = $$x1.javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d));
  return new $c_s_Some(value)
});
$c_Lio_circe_JsonDouble.prototype.toBigInt__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsWhole__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var value = $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), asBigDecimal.toBigInteger__Ljava_math_BigInteger());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_JsonDouble.prototype.toDouble__D = (function() {
  return this.Lio_circe_JsonDouble__f_value
});
$c_Lio_circe_JsonDouble.prototype.toFloat__F = (function() {
  return Math.fround(this.Lio_circe_JsonDouble__f_value)
});
$c_Lio_circe_JsonDouble.prototype.toLong__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var t = asBigDecimal.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi))
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_JsonDouble.prototype.toString__T = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  return ("" + d)
});
$c_Lio_circe_JsonDouble.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var d = this.Lio_circe_JsonDouble__f_value;
  var str = ("" + d);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
function $as_Lio_circe_JsonDouble(obj) {
  return (((obj instanceof $c_Lio_circe_JsonDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonDouble"))
}
function $isArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonDouble)))
}
function $asArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonDouble;", depth))
}
var $d_Lio_circe_JsonDouble = new $TypeData().initClass({
  Lio_circe_JsonDouble: 0
}, false, "io.circe.JsonDouble", {
  Lio_circe_JsonDouble: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_JsonDouble.prototype.$classData = $d_Lio_circe_JsonDouble;
function $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal($thiz) {
  var f = $thiz.Lio_circe_JsonFloat__f_value;
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + f))
}
/** @constructor */
function $c_Lio_circe_JsonFloat(value) {
  this.Lio_circe_JsonFloat__f_value = 0.0;
  this.Lio_circe_JsonFloat__f_value = value
}
$c_Lio_circe_JsonFloat.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonFloat.prototype.constructor = $c_Lio_circe_JsonFloat;
/** @constructor */
function $h_Lio_circe_JsonFloat() {
  /*<skip>*/
}
$h_Lio_circe_JsonFloat.prototype = $c_Lio_circe_JsonFloat.prototype;
$c_Lio_circe_JsonFloat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_JsonFloat.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonFloat.prototype.productPrefix__T = (function() {
  return "JsonFloat"
});
$c_Lio_circe_JsonFloat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonFloat__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_JsonFloat.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromFloat__F__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonFloat__f_value)
});
$c_Lio_circe_JsonFloat.prototype.toBigDecimal__s_Option = (function() {
  var value = $m_s_math_BigDecimal$().javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal($p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this));
  return new $c_s_Some(value)
});
$c_Lio_circe_JsonFloat.prototype.toBigInt__s_Option = (function() {
  var asBigDecimal = $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsWhole__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var value = $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), asBigDecimal.toBigInteger__Ljava_math_BigInteger());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_JsonFloat.prototype.toDouble__D = (function() {
  return $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this).doubleValue__D()
});
$c_Lio_circe_JsonFloat.prototype.toFloat__F = (function() {
  return this.Lio_circe_JsonFloat__f_value
});
$c_Lio_circe_JsonFloat.prototype.toLong__s_Option = (function() {
  var asBigDecimal = $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var t = asBigDecimal.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi))
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_JsonFloat.prototype.toString__T = (function() {
  var f = this.Lio_circe_JsonFloat__f_value;
  return ("" + f)
});
$c_Lio_circe_JsonFloat.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var f = this.Lio_circe_JsonFloat__f_value;
  var str = ("" + f);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
function $as_Lio_circe_JsonFloat(obj) {
  return (((obj instanceof $c_Lio_circe_JsonFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonFloat"))
}
function $isArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonFloat)))
}
function $asArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonFloat;", depth))
}
var $d_Lio_circe_JsonFloat = new $TypeData().initClass({
  Lio_circe_JsonFloat: 0
}, false, "io.circe.JsonFloat", {
  Lio_circe_JsonFloat: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_JsonFloat.prototype.$classData = $d_Lio_circe_JsonFloat;
/** @constructor */
function $c_Lio_circe_JsonLong(value) {
  this.Lio_circe_JsonLong__f_value = $L0;
  this.Lio_circe_JsonLong__f_value = value
}
$c_Lio_circe_JsonLong.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonLong.prototype.constructor = $c_Lio_circe_JsonLong;
/** @constructor */
function $h_Lio_circe_JsonLong() {
  /*<skip>*/
}
$h_Lio_circe_JsonLong.prototype = $c_Lio_circe_JsonLong.prototype;
$c_Lio_circe_JsonLong.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_JsonLong.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonLong.prototype.productPrefix__T = (function() {
  return "JsonLong"
});
$c_Lio_circe_JsonLong.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonLong__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_JsonLong.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromLong__J__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonLong__f_value)
});
$c_Lio_circe_JsonLong.prototype.toBigDecimal__s_Option = (function() {
  var value = $m_s_package$().BigDecimal__s_math_BigDecimal$().apply__J__s_math_BigDecimal(this.Lio_circe_JsonLong__f_value);
  return new $c_s_Some(value)
});
$c_Lio_circe_JsonLong.prototype.toBigInt__s_Option = (function() {
  var value = $m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(this.Lio_circe_JsonLong__f_value);
  return new $c_s_Some(value)
});
$c_Lio_circe_JsonLong.prototype.toDouble__D = (function() {
  var this$1 = this.Lio_circe_JsonLong__f_value;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
});
$c_Lio_circe_JsonLong.prototype.toFloat__F = (function() {
  var this$1 = this.Lio_circe_JsonLong__f_value;
  return Math.fround($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi))
});
$c_Lio_circe_JsonLong.prototype.toLong__s_Option = (function() {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_Some(new $c_RTLong(lo, hi))
});
$c_Lio_circe_JsonLong.prototype.toString__T = (function() {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
});
$c_Lio_circe_JsonLong.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
function $as_Lio_circe_JsonLong(obj) {
  return (((obj instanceof $c_Lio_circe_JsonLong) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonLong"))
}
function $isArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonLong)))
}
function $asArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonLong;", depth))
}
var $d_Lio_circe_JsonLong = new $TypeData().initClass({
  Lio_circe_JsonLong: 0
}, false, "io.circe.JsonLong", {
  Lio_circe_JsonLong: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_JsonLong.prototype.$classData = $d_Lio_circe_JsonLong;
function $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__($thiz, outer, encodeA) {
  $thiz.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = encodeA;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $thiz.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_$outer = outer;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_$outer = null
}
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = new $h_O();
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.constructor = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder;
/** @constructor */
function $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
  /*<skip>*/
}
$h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype;
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.encodeArray__O__sci_Vector = (function(a) {
  $m_s_package$();
  var builder = new $c_sci_VectorBuilder();
  var a$1 = $as_sci_List(a);
  var iterator = a$1.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    var elem = this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA.apply__O__Lio_circe_Json(iterator.next__O());
    builder.addOne__O__sci_VectorBuilder(elem)
  };
  return builder.result__sci_Vector()
});
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  $thiz.Ljava_io_FilterOutputStream__f_out = out;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
  this.Ljava_io_FilterOutputStream__f_out = null
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
  /*<skip>*/
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"))
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)))
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth))
}
var $d_jl_ArithmeticException = new $TypeData().initClass({
  jl_ArithmeticException: 0
}, false, "java.lang.ArithmeticException", {
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArithmeticException.prototype.$classData = $d_jl_ArithmeticException;
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $uB($thiz)
}
function $f_jl_Byte__toString__T($thiz) {
  var b = $uB($thiz);
  return ("" + b)
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  var that = $as_jl_Byte(o);
  var x = $uB($thiz);
  var y = $uB(that);
  return ((x - y) | 0)
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"))
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)))
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth))
}
var $d_jl_Byte = new $TypeData().initClass({
  jl_Byte: 0
}, false, "java.lang.Byte", {
  jl_Byte: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isByte(x)));
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_ClassCastException(obj) {
  return (((obj instanceof $c_jl_ClassCastException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ClassCastException"))
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)))
}
function $asArrayOf_jl_ClassCastException(obj, depth) {
  return (($isArrayOf_jl_ClassCastException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ClassCastException;", depth))
}
var $d_jl_ClassCastException = new $TypeData().initClass({
  jl_ClassCastException: 0
}, false, "java.lang.ClassCastException", {
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ClassCastException.prototype.$classData = $d_jl_ClassCastException;
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
function $as_jl_IllegalArgumentException(obj) {
  return (((obj instanceof $c_jl_IllegalArgumentException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.IllegalArgumentException"))
}
function $isArrayOf_jl_IllegalArgumentException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_IllegalArgumentException)))
}
function $asArrayOf_jl_IllegalArgumentException(obj, depth) {
  return (($isArrayOf_jl_IllegalArgumentException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.IllegalArgumentException;", depth))
}
var $d_jl_IllegalArgumentException = new $TypeData().initClass({
  jl_IllegalArgumentException: 0
}, false, "java.lang.IllegalArgumentException", {
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalArgumentException.prototype.$classData = $d_jl_IllegalArgumentException;
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().initClass({
  jl_IllegalStateException: 0
}, false, "java.lang.IllegalStateException", {
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalStateException.prototype.$classData = $d_jl_IllegalStateException;
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass({
  jl_IndexOutOfBoundsException: 0
}, false, "java.lang.IndexOutOfBoundsException", {
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IndexOutOfBoundsException.prototype.$classData = $d_jl_IndexOutOfBoundsException;
class $c_jl_InstantiationException extends $c_jl_ReflectiveOperationException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_InstantiationException = new $TypeData().initClass({
  jl_InstantiationException: 0
}, false, "java.lang.InstantiationException", {
  jl_InstantiationException: 1,
  jl_ReflectiveOperationException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_InstantiationException.prototype.$classData = $d_jl_InstantiationException;
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", {
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream$DummyOutputStream;
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_jl_NegativeArraySizeException = new $TypeData().initClass({
  jl_NegativeArraySizeException: 0
}, false, "java.lang.NegativeArraySizeException", {
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NegativeArraySizeException.prototype.$classData = $d_jl_NegativeArraySizeException;
class $c_jl_NoSuchMethodException extends $c_jl_ReflectiveOperationException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_NoSuchMethodException = new $TypeData().initClass({
  jl_NoSuchMethodException: 0
}, false, "java.lang.NoSuchMethodException", {
  jl_NoSuchMethodException: 1,
  jl_ReflectiveOperationException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NoSuchMethodException.prototype.$classData = $d_jl_NoSuchMethodException;
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().initClass({
  jl_NullPointerException: 0
}, false, "java.lang.NullPointerException", {
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NullPointerException.prototype.$classData = $d_jl_NullPointerException;
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"))
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)))
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth))
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Short__hashCode__I($thiz) {
  return $uS($thiz)
}
function $f_jl_Short__toString__T($thiz) {
  var s = $uS($thiz);
  return ("" + s)
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  var that = $as_jl_Short(o);
  var x = $uS($thiz);
  var y = $uS(that);
  return ((x - y) | 0)
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"))
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)))
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth))
}
var $d_jl_Short = new $TypeData().initClass({
  jl_Short: 0
}, false, "java.lang.Short", {
  jl_Short: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isShort(x)));
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().initClass({
  jl_UnsupportedOperationException: 0
}, false, "java.lang.UnsupportedOperationException", {
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_UnsupportedOperationException.prototype.$classData = $d_jl_UnsupportedOperationException;
function $ct_Ljava_time_DateTimeException__T__jl_Throwable__($thiz, message, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz
}
function $ct_Ljava_time_DateTimeException__T__($thiz, message) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, null, true, true);
  return $thiz
}
class $c_Ljava_time_DateTimeException extends $c_jl_RuntimeException {
}
function $as_Ljava_time_DateTimeException(obj) {
  return (((obj instanceof $c_Ljava_time_DateTimeException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.DateTimeException"))
}
function $isArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_DateTimeException)))
}
function $asArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (($isArrayOf_Ljava_time_DateTimeException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.DateTimeException;", depth))
}
var $d_Ljava_time_DateTimeException = new $TypeData().initClass({
  Ljava_time_DateTimeException: 0
}, false, "java.time.DateTimeException", {
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_DateTimeException.prototype.$classData = $d_Ljava_time_DateTimeException;
/** @constructor */
function $c_Ljava_time_Duration(seconds, nanos) {
  this.Ljava_time_Duration__f_seconds = $L0;
  this.Ljava_time_Duration__f_nanos = 0;
  this.Ljava_time_Duration__f_seconds = seconds;
  this.Ljava_time_Duration__f_nanos = nanos
}
$c_Ljava_time_Duration.prototype = new $h_O();
$c_Ljava_time_Duration.prototype.constructor = $c_Ljava_time_Duration;
/** @constructor */
function $h_Ljava_time_Duration() {
  /*<skip>*/
}
$h_Ljava_time_Duration.prototype = $c_Ljava_time_Duration.prototype;
$c_Ljava_time_Duration.prototype.compare__Ljava_time_Duration__I = (function(otherDuration) {
  var t = this.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = otherDuration.Ljava_time_Duration__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Duration__f_nanos - otherDuration.Ljava_time_Duration__f_nanos) | 0))
});
$c_Ljava_time_Duration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Duration)) {
    var otherDuration = $as_Ljava_time_Duration(other);
    if ((this === otherDuration)) {
      return true
    } else {
      var this$1 = this.Ljava_time_Duration__f_seconds;
      var b = otherDuration.Ljava_time_Duration__f_seconds;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Duration__f_nanos === otherDuration.Ljava_time_Duration__f_nanos)
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_Duration.prototype.hashCode__I = (function() {
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var this$1 = this.Ljava_time_Duration__f_seconds;
  var hi = this$1.RTLong__f_hi;
  var lo = (this$2.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Duration__f_nanos)) | 0)
});
$c_Ljava_time_Duration.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Duration$().ZERO__Ljava_time_Duration())) {
    return "PT0S"
  };
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR;
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = this.Ljava_time_Duration__f_seconds;
  var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR;
  var hi$2 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$1 = this$6.remainderImpl__I__I__I__I__I(this$5.RTLong__f_lo, this$5.RTLong__f_hi, value$1, hi$2);
  var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$4 = (value$2 >> 31);
  var this$8 = $m_RTLong$();
  var lo$2 = this$8.divideImpl__I__I__I__I__I(lo$1, hi$3, value$2, hi$4);
  var this$10 = this.Ljava_time_Duration__f_seconds;
  var value$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$6 = (value$3 >> 31);
  var this$11 = $m_RTLong$();
  var lo$3 = this$11.remainderImpl__I__I__I__I__I(this$10.RTLong__f_lo, this$10.RTLong__f_hi, value$3, hi$6);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 24);
  buf.append__T__scm_StringBuilder("PT");
  if ((!((lo === 0) && (hi$1 === 0)))) {
    buf.append__J__scm_StringBuilder(new $c_RTLong(lo, hi$1)).append__C__scm_StringBuilder(72)
  };
  if ((lo$2 !== 0)) {
    buf.append__I__scm_StringBuilder(lo$2).append__C__scm_StringBuilder(77)
  };
  if ((((lo$3 === 0) && (this.Ljava_time_Duration__f_nanos === 0)) && (buf.scm_StringBuilder__f_underlying.length__I() > 2))) {
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  };
  if (((lo$3 < 0) && (this.Ljava_time_Duration__f_nanos > 0))) {
    if ((lo$3 === (-1))) {
      buf.append__T__scm_StringBuilder("-0")
    } else {
      buf.append__I__scm_StringBuilder(((1 + lo$3) | 0))
    }
  } else {
    buf.append__I__scm_StringBuilder(lo$3)
  };
  if ((this.Ljava_time_Duration__f_nanos > 0)) {
    var pos = buf.scm_StringBuilder__f_underlying.length__I();
    if ((lo$3 < 0)) {
      buf.append__I__scm_StringBuilder(((2000000000 - this.Ljava_time_Duration__f_nanos) | 0))
    } else {
      buf.append__I__scm_StringBuilder(((1000000000 + this.Ljava_time_Duration__f_nanos) | 0))
    };
    while (true) {
      var index = (((-1) + buf.scm_StringBuilder__f_underlying.length__I()) | 0);
      if ((buf.scm_StringBuilder__f_underlying.charAt__I__C(index) === 48)) {
        var len = (((-1) + buf.scm_StringBuilder__f_underlying.length__I()) | 0);
        buf.scm_StringBuilder__f_underlying.setLength__I__V(len)
      } else {
        break
      }
    };
    buf.setCharAt__I__C__scm_StringBuilder(pos, 46)
  };
  buf.append__C__scm_StringBuilder(83);
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_Duration.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Duration(that);
  return this.compare__Ljava_time_Duration__I(other)
});
function $as_Ljava_time_Duration(obj) {
  return (((obj instanceof $c_Ljava_time_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Duration"))
}
function $isArrayOf_Ljava_time_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Duration)))
}
function $asArrayOf_Ljava_time_Duration(obj, depth) {
  return (($isArrayOf_Ljava_time_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Duration;", depth))
}
var $d_Ljava_time_Duration = new $TypeData().initClass({
  Ljava_time_Duration: 0
}, false, "java.time.Duration", {
  Ljava_time_Duration: 1,
  O: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Duration.prototype.$classData = $d_Ljava_time_Duration;
function $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x === field)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Field too large for an int: " + field))
  } else {
    var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$3 === field)) {
      var this$1 = $thiz.Ljava_time_ZonedDateTime__f_offset;
      return this$1.Ljava_time_ZoneOffset__f_totalSeconds
    } else {
      return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? $thiz.Ljava_time_ZonedDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field))
    }
  }
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts3: {
    matchAlts4: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === query)) {
        break matchAlts4
      };
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === query)) {
        break matchAlts4
      };
      break matchAlts3
    };
    return $thiz.Ljava_time_ZonedDateTime__f_zone
  };
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  };
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit()
  };
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === query)) {
    return $thiz.Ljava_time_ZonedDateTime__f_offset
  };
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === query)) {
    var $$x1 = $m_Ljava_time_LocalDate$();
    var this$3 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    return $$x1.ofEpochDay__J__Ljava_time_LocalDate(this$3.Ljava_time_LocalDateTime__f_date.toEpochDay__J())
  };
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === query)) {
    var this$4 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    return this$4.Ljava_time_LocalDateTime__f_time
  };
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query)
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz) {
  var this$1 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
  var t = this$1.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var this$2 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
  var value = this$2.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var this$7__lo = secs__lo;
  var this$7__hi = secs__hi;
  var this$5 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  var value$1 = this$5.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = this$7__lo;
  var ahi = this$7__hi;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$5;
  secs__lo = $$x1__lo;
  secs__hi = $$x1__hi;
  return new $c_RTLong(secs__lo, secs__hi)
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I($thiz, other) {
  var t = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(other);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$1 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
    var $$x1 = this$2.Ljava_time_LocalTime__f_nano;
    var this$3 = other.Ljava_time_ZonedDateTime__f_dateTime;
    var this$4 = this$3.Ljava_time_LocalDateTime__f_time;
    cmp = (($$x1 - this$4.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var this$5 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
      var that = other.Ljava_time_ZonedDateTime__f_dateTime;
      cmp = this$5.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that);
      if ((cmp === 0)) {
        cmp = $f_T__compareTo__T__I($thiz.Ljava_time_ZonedDateTime__f_zone.getId__T(), other.Ljava_time_ZonedDateTime__f_zone.getId__T());
        if ((cmp === 0)) {
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          cmp = $f_T__compareTo__T__I("ISO", "ISO")
        }
      }
    }
  };
  return cmp
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__isAfter__Ljava_time_chrono_ChronoZonedDateTime__Z($thiz, other) {
  var t = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(other);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) > ((-2147483648) ^ lo$1)) : (hi > hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$1 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
    var $$x1 = this$2.Ljava_time_LocalTime__f_nano;
    var this$3 = other.Ljava_time_ZonedDateTime__f_dateTime;
    var this$4 = this$3.Ljava_time_LocalDateTime__f_time;
    return ($$x1 > this$4.Ljava_time_LocalTime__f_nano)
  } else {
    return false
  }
}
function $is_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoZonedDateTime)))
}
function $as_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (($is_Ljava_time_chrono_ChronoZonedDateTime(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoZonedDateTime"))
}
function $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoZonedDateTime)))
}
function $asArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoZonedDateTime;", depth))
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology() {
  /*<skip>*/
}
$c_Ljava_time_chrono_IsoChronology.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology.prototype.constructor = $c_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology() {
  /*<skip>*/
}
$h_Ljava_time_chrono_IsoChronology.prototype = $c_Ljava_time_chrono_IsoChronology.prototype;
$c_Ljava_time_chrono_IsoChronology.prototype.compareTo__O__I = (function(that) {
  $as_Ljava_time_chrono_Chronology(that);
  return $f_T__compareTo__T__I("ISO", "ISO")
});
$c_Ljava_time_chrono_IsoChronology.prototype.equals__O__Z = (function(obj) {
  return $f_Ljava_time_chrono_Chronology__equals__O__Z(this, obj)
});
$c_Ljava_time_chrono_IsoChronology.prototype.hashCode__I = (function() {
  return $f_Ljava_time_chrono_Chronology__hashCode__I(this)
});
$c_Ljava_time_chrono_IsoChronology.prototype.toString__T = (function() {
  return "ISO"
});
$c_Ljava_time_chrono_IsoChronology.prototype.isLeapYear__J__Z = (function(prolepticYear) {
  var lo = (3 & prolepticYear.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_RTLong$();
    var lo$1 = this$1.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 100, 0);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true
    } else {
      var this$2 = $m_RTLong$();
      var lo$2 = this$2.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 400, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0))
    }
  } else {
    return false
  }
});
$c_Ljava_time_chrono_IsoChronology.prototype.resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate = (function(fieldValues, resolverStyle) {
  if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $$x1 = $m_Ljava_time_LocalDate$();
    var x = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    return $$x1.ofEpochDay__J__Ljava_time_LocalDate($uJ(x))
  };
  var prolepticMonth = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField()));
  if ((prolepticMonth !== null)) {
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$3 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
      var t = $uJ(prolepticMonth);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      this$3.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$3)
    };
    var field = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var t$1 = $uJ(prolepticMonth);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var b = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$1, hi$1), new $c_RTLong(12, 0));
    var bhi = b.RTLong__f_hi;
    var lo$2 = ((1 + b.RTLong__f_lo) | 0);
    var hi$2 = ((lo$2 === 0) ? ((1 + bhi) | 0) : bhi);
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field, new $c_RTLong(lo$2, hi$2));
    var field$1 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var t$2 = $uJ(prolepticMonth);
    var lo$3 = t$2.RTLong__f_lo;
    var hi$3 = t$2.RTLong__f_hi;
    var t$3 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$3, hi$3), new $c_RTLong(12, 0));
    var lo$4 = t$3.RTLong__f_lo;
    var hi$4 = t$3.RTLong__f_hi;
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$1, new $c_RTLong(lo$4, hi$4))
  };
  var yoeLong = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField()));
  if ((yoeLong !== null)) {
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$8 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
      var t$4 = $uJ(yoeLong);
      var lo$5 = t$4.RTLong__f_lo;
      var hi$5 = t$4.RTLong__f_hi;
      this$8.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$5, hi$5), this$8)
    };
    var era = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField()));
    if ((era === null)) {
      var key = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var year = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, key, null));
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
        if ((year !== null)) {
          var field$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var this$10 = $uJ(year);
          var ahi = this$10.RTLong__f_hi;
          if (((ahi === 0) ? (this$10.RTLong__f_lo !== 0) : (ahi > 0))) {
            var t$6 = $uJ(yoeLong)
          } else {
            var t$5 = $uJ(yoeLong);
            var lo$6 = t$5.RTLong__f_lo;
            var hi$6 = t$5.RTLong__f_hi;
            var t$6 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$6, hi$6))
          };
          var lo$7 = t$6.RTLong__f_lo;
          var hi$7 = t$6.RTLong__f_hi;
          $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$2, new $c_RTLong(lo$7, hi$7))
        } else {
          var key$1 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
          if ((key$1 === null)) {
            var $$x2 = 0
          } else {
            var originalHash = $systemIdentityHashCode(key$1);
            var $$x2 = (originalHash ^ ((originalHash >>> 16) | 0))
          };
          fieldValues.java$util$HashMap$$put0__O__O__I__Z__O(key$1, yoeLong, $$x2, false)
        }
      } else {
        var field$3 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        if ((year === null)) {
          var $$x3 = true
        } else {
          var this$16 = $uJ(year);
          var ahi$1 = this$16.RTLong__f_hi;
          var $$x3 = ((ahi$1 === 0) ? (this$16.RTLong__f_lo !== 0) : (ahi$1 > 0))
        };
        if ($$x3) {
          var t$8 = $uJ(yoeLong)
        } else {
          var t$7 = $uJ(yoeLong);
          var lo$8 = t$7.RTLong__f_lo;
          var hi$8 = t$7.RTLong__f_hi;
          var t$8 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$8, hi$8))
        };
        var lo$9 = t$8.RTLong__f_lo;
        var hi$9 = t$8.RTLong__f_hi;
        $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$3, new $c_RTLong(lo$9, hi$9))
      }
    } else {
      var this$19 = $uJ(era);
      if (((this$19.RTLong__f_lo === 1) && (this$19.RTLong__f_hi === 0))) {
        var field$4 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var t$9 = $uJ(yoeLong);
        var lo$10 = t$9.RTLong__f_lo;
        var hi$10 = t$9.RTLong__f_hi;
        $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$4, new $c_RTLong(lo$10, hi$10))
      } else {
        var this$21 = $uJ(era);
        if (((this$21.RTLong__f_lo === 0) && (this$21.RTLong__f_hi === 0))) {
          var field$5 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var t$10 = $uJ(yoeLong);
          var lo$11 = t$10.RTLong__f_lo;
          var hi$11 = t$10.RTLong__f_hi;
          var t$11 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$11, hi$11));
          var lo$12 = t$11.RTLong__f_lo;
          var hi$12 = t$11.RTLong__f_hi;
          $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$5, new $c_RTLong(lo$12, hi$12))
        } else {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for era: " + era))
        }
      }
    }
  } else if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField())) {
    var this$24 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    var key$2 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    var x$1 = $as_jl_Long($p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, key$2, null));
    var t$12 = $uJ(x$1);
    var lo$13 = t$12.RTLong__f_lo;
    var hi$13 = t$12.RTLong__f_hi;
    this$24.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$13, hi$13), this$24)
  };
  if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField())) {
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        var this$26 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$2 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var t$13 = $uJ(x$2);
        var lo$14 = t$13.RTLong__f_lo;
        var hi$14 = t$13.RTLong__f_hi;
        var y = this$26.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$14, hi$14), this$26);
        var x$3 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$14 = $uJ(x$3);
        var lo$15 = t$14.RTLong__f_lo;
        var hi$15 = t$14.RTLong__f_hi;
        var moy = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$15, hi$15));
        var x$4 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField()));
        var t$15 = $uJ(x$4);
        var lo$16 = t$15.RTLong__f_lo;
        var hi$16 = t$15.RTLong__f_hi;
        var dom = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$16, hi$16));
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var hi$17 = (moy >> 31);
          var t$16 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(moy, hi$17), new $c_RTLong(1, 0));
          var lo$17 = t$16.RTLong__f_lo;
          var hi$18 = t$16.RTLong__f_hi;
          var value = dom;
          var hi$19 = (value >> 31);
          var t$17 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(value, hi$19), new $c_RTLong(1, 0));
          var lo$18 = t$17.RTLong__f_lo;
          var hi$20 = t$17.RTLong__f_hi;
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$17, hi$18)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$18, hi$20))
        } else if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
          var this$32 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
          var value$1 = dom;
          var hi$21 = (value$1 >> 31);
          this$32.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value$1, hi$21), this$32);
          if (((((moy === 4) || (moy === 6)) || (moy === 9)) || (moy === 11))) {
            var a = dom;
            dom = ((a < 30) ? a : 30)
          } else if ((moy === 2)) {
            var a$1 = dom;
            var $$x5 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
            var $$x4 = $m_Ljava_time_Year$();
            var hi$22 = (y >> 31);
            var b$1 = $$x5.length__Z__I($$x4.isLeap__J__Z(new $c_RTLong(y, hi$22)));
            dom = ((a$1 < b$1) ? a$1 : b$1)
          };
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, moy, dom)
        } else {
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, moy, dom)
        }
      };
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField())) {
          var this$37 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var x$5 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
          var t$18 = $uJ(x$5);
          var lo$19 = t$18.RTLong__f_lo;
          var hi$23 = t$18.RTLong__f_hi;
          var y$2 = this$37.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$19, hi$23), this$37);
          if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$6 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var t$19 = $uJ(x$6);
            var lo$20 = t$19.RTLong__f_lo;
            var hi$24 = t$19.RTLong__f_hi;
            var t$20 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$20, hi$24), new $c_RTLong(1, 0));
            var lo$21 = t$20.RTLong__f_lo;
            var hi$25 = t$20.RTLong__f_hi;
            var x$7 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var t$21 = $uJ(x$7);
            var lo$22 = t$21.RTLong__f_lo;
            var hi$26 = t$21.RTLong__f_hi;
            var t$22 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$22, hi$26), new $c_RTLong(1, 0));
            var lo$23 = t$22.RTLong__f_lo;
            var hi$27 = t$22.RTLong__f_hi;
            var x$8 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
            var t$23 = $uJ(x$8);
            var lo$24 = t$23.RTLong__f_lo;
            var hi$28 = t$23.RTLong__f_hi;
            var t$24 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$24, hi$28), new $c_RTLong(1, 0));
            var lo$25 = t$24.RTLong__f_lo;
            var hi$29 = t$24.RTLong__f_hi;
            return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$21, hi$25)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$23, hi$27)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$25, hi$29))
          };
          var this$42 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var x$9 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$25 = $uJ(x$9);
          var lo$26 = t$25.RTLong__f_lo;
          var hi$30 = t$25.RTLong__f_hi;
          var moy$2 = this$42.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$26, hi$30), this$42);
          var this$44 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var x$10 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var t$26 = $uJ(x$10);
          var lo$27 = t$26.RTLong__f_lo;
          var hi$31 = t$26.RTLong__f_hi;
          var aw = this$44.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$27, hi$31), this$44);
          var this$46 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
          var x$11 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
          var t$27 = $uJ(x$11);
          var lo$28 = t$27.RTLong__f_lo;
          var hi$32 = t$27.RTLong__f_hi;
          var ad = this$46.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$28, hi$32), this$46);
          var $$x6 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, moy$2, 1);
          var hi$33 = (aw >> 31);
          var lo$29 = (((-1) + aw) | 0);
          var hi$34 = ((lo$29 !== (-1)) ? hi$33 : (((-1) + hi$33) | 0));
          var b0 = (65535 & lo$29);
          var b1 = ((lo$29 >>> 16) | 0);
          var a0b0 = Math.imul(7, b0);
          var a0b1 = Math.imul(7, b1);
          var lo$30 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$35 = ((Math.imul(7, hi$34) + ((c1part >>> 16) | 0)) | 0);
          var hi$36 = (ad >> 31);
          var lo$31 = (((-1) + ad) | 0);
          var hi$37 = ((lo$31 !== (-1)) ? hi$36 : (((-1) + hi$36) | 0));
          var lo$32 = ((lo$30 + lo$31) | 0);
          var hi$38 = ((((-2147483648) ^ lo$32) < ((-2147483648) ^ lo$30)) ? ((1 + ((hi$35 + hi$37) | 0)) | 0) : ((hi$35 + hi$37) | 0));
          var date = $$x6.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$32, hi$38));
          if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$2))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
          };
          return date
        };
        if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
          var this$53 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var x$12 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
          var t$28 = $uJ(x$12);
          var lo$33 = t$28.RTLong__f_lo;
          var hi$39 = t$28.RTLong__f_hi;
          var y$3 = this$53.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$33, hi$39), this$53);
          if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$13 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var t$29 = $uJ(x$13);
            var lo$34 = t$29.RTLong__f_lo;
            var hi$40 = t$29.RTLong__f_hi;
            var t$30 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$34, hi$40), new $c_RTLong(1, 0));
            var lo$35 = t$30.RTLong__f_lo;
            var hi$41 = t$30.RTLong__f_hi;
            var x$14 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var t$31 = $uJ(x$14);
            var lo$36 = t$31.RTLong__f_lo;
            var hi$42 = t$31.RTLong__f_hi;
            var t$32 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$36, hi$42), new $c_RTLong(1, 0));
            var lo$37 = t$32.RTLong__f_lo;
            var hi$43 = t$32.RTLong__f_hi;
            var x$15 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
            var t$33 = $uJ(x$15);
            var lo$38 = t$33.RTLong__f_lo;
            var hi$44 = t$33.RTLong__f_hi;
            var t$34 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$38, hi$44), new $c_RTLong(1, 0));
            var lo$39 = t$34.RTLong__f_lo;
            var hi$45 = t$34.RTLong__f_hi;
            return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$35, hi$41)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$37, hi$43)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$39, hi$45))
          };
          var this$58 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var x$16 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$35 = $uJ(x$16);
          var lo$40 = t$35.RTLong__f_lo;
          var hi$46 = t$35.RTLong__f_hi;
          var moy$3 = this$58.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$40, hi$46), this$58);
          var this$60 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var x$17 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var t$36 = $uJ(x$17);
          var lo$41 = t$36.RTLong__f_lo;
          var hi$47 = t$36.RTLong__f_hi;
          var aw$2 = this$60.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$41, hi$47), this$60);
          var this$62 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
          var x$18 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var t$37 = $uJ(x$18);
          var lo$42 = t$37.RTLong__f_lo;
          var hi$48 = t$37.RTLong__f_hi;
          var dow = this$62.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$42, hi$48), this$62);
          var $$x8 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, moy$3, 1);
          var hi$49 = (aw$2 >> 31);
          var lo$43 = (((-1) + aw$2) | 0);
          var hi$50 = ((lo$43 !== (-1)) ? hi$49 : (((-1) + hi$49) | 0));
          var $$x7 = $$x8.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$43, hi$50));
          var dayOfWeek = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow);
          var date$2 = $$x7.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek));
          if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$2.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$3))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
          };
          return date$2
        }
      }
    };
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      var this$67 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var x$19 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
      var t$38 = $uJ(x$19);
      var lo$44 = t$38.RTLong__f_lo;
      var hi$51 = t$38.RTLong__f_hi;
      var y$4 = this$67.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$44, hi$51), this$67);
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
        var x$20 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$39 = $uJ(x$20);
        var lo$45 = t$39.RTLong__f_lo;
        var hi$52 = t$39.RTLong__f_hi;
        var t$40 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$45, hi$52), new $c_RTLong(1, 0));
        var lo$46 = t$40.RTLong__f_lo;
        var hi$53 = t$40.RTLong__f_hi;
        return $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, 1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$46, hi$53))
      };
      var this$70 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
      var x$21 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
      var t$41 = $uJ(x$21);
      var lo$47 = t$41.RTLong__f_lo;
      var hi$54 = t$41.RTLong__f_hi;
      var doy = this$70.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$47, hi$54), this$70);
      return $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, doy)
    };
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField())) {
        var this$72 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$22 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var t$42 = $uJ(x$22);
        var lo$48 = t$42.RTLong__f_lo;
        var hi$55 = t$42.RTLong__f_hi;
        var y$5 = this$72.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$48, hi$55), this$72);
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$23 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$43 = $uJ(x$23);
          var lo$49 = t$43.RTLong__f_lo;
          var hi$56 = t$43.RTLong__f_hi;
          var t$44 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$49, hi$56), new $c_RTLong(1, 0));
          var lo$50 = t$44.RTLong__f_lo;
          var hi$57 = t$44.RTLong__f_hi;
          var x$24 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
          var t$45 = $uJ(x$24);
          var lo$51 = t$45.RTLong__f_lo;
          var hi$58 = t$45.RTLong__f_hi;
          var t$46 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$51, hi$58), new $c_RTLong(1, 0));
          var lo$52 = t$46.RTLong__f_lo;
          var hi$59 = t$46.RTLong__f_hi;
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$50, hi$57)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$52, hi$59))
        };
        var this$76 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var x$25 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$47 = $uJ(x$25);
        var lo$53 = t$47.RTLong__f_lo;
        var hi$60 = t$47.RTLong__f_hi;
        var aw$3 = this$76.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$53, hi$60), this$76);
        var this$78 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
        var x$26 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
        var t$48 = $uJ(x$26);
        var lo$54 = t$48.RTLong__f_lo;
        var hi$61 = t$48.RTLong__f_hi;
        var ad$2 = this$78.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$54, hi$61), this$78);
        var $$x9 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1);
        var hi$62 = (aw$3 >> 31);
        var lo$55 = (((-1) + aw$3) | 0);
        var hi$63 = ((lo$55 !== (-1)) ? hi$62 : (((-1) + hi$62) | 0));
        var b0$1 = (65535 & lo$55);
        var b1$1 = ((lo$55 >>> 16) | 0);
        var a0b0$1 = Math.imul(7, b0$1);
        var a0b1$1 = Math.imul(7, b1$1);
        var lo$56 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$64 = ((Math.imul(7, hi$63) + ((c1part$1 >>> 16) | 0)) | 0);
        var value$2 = (((-1) + ad$2) | 0);
        var hi$65 = (value$2 >> 31);
        var lo$57 = ((lo$56 + value$2) | 0);
        var hi$66 = ((((-2147483648) ^ lo$57) < ((-2147483648) ^ lo$56)) ? ((1 + ((hi$64 + hi$65) | 0)) | 0) : ((hi$64 + hi$65) | 0));
        var date$3 = $$x9.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$57, hi$66));
        if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$3.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$5))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year")
        };
        return date$3
      };
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
        var this$84 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$27 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var t$49 = $uJ(x$27);
        var lo$58 = t$49.RTLong__f_lo;
        var hi$67 = t$49.RTLong__f_hi;
        var y$6 = this$84.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$58, hi$67), this$84);
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$28 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$50 = $uJ(x$28);
          var lo$59 = t$50.RTLong__f_lo;
          var hi$68 = t$50.RTLong__f_hi;
          var t$51 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$59, hi$68), new $c_RTLong(1, 0));
          var lo$60 = t$51.RTLong__f_lo;
          var hi$69 = t$51.RTLong__f_hi;
          var x$29 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var t$52 = $uJ(x$29);
          var lo$61 = t$52.RTLong__f_lo;
          var hi$70 = t$52.RTLong__f_hi;
          var t$53 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$61, hi$70), new $c_RTLong(1, 0));
          var lo$62 = t$53.RTLong__f_lo;
          var hi$71 = t$53.RTLong__f_hi;
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$60, hi$69)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$62, hi$71))
        };
        var this$88 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var x$30 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$54 = $uJ(x$30);
        var lo$63 = t$54.RTLong__f_lo;
        var hi$72 = t$54.RTLong__f_hi;
        var aw$4 = this$88.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$63, hi$72), this$88);
        var this$90 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
        var x$31 = $as_jl_Long(fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
        var t$55 = $uJ(x$31);
        var lo$64 = t$55.RTLong__f_lo;
        var hi$73 = t$55.RTLong__f_hi;
        var dow$2 = this$90.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$64, hi$73), this$90);
        var $$x11 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1);
        var hi$74 = (aw$4 >> 31);
        var lo$65 = (((-1) + aw$4) | 0);
        var hi$75 = ((lo$65 !== (-1)) ? hi$74 : (((-1) + hi$74) | 0));
        var $$x10 = $$x11.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$65, hi$75));
        var dayOfWeek$1 = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow$2);
        var date$4 = $$x10.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek$1));
        if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$4.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$6))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
        };
        return date$4
      }
    }
  };
  return null
});
function $as_Ljava_time_chrono_IsoChronology(obj) {
  return (((obj instanceof $c_Ljava_time_chrono_IsoChronology) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.IsoChronology"))
}
function $isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_IsoChronology)))
}
function $asArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.IsoChronology;", depth))
}
var $d_Ljava_time_chrono_IsoChronology = new $TypeData().initClass({
  Ljava_time_chrono_IsoChronology: 0
}, false, "java.time.chrono.IsoChronology", {
  Ljava_time_chrono_IsoChronology: 1,
  O: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_Chronology: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_chrono_IsoChronology.prototype.$classData = $d_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $c_ju_AbstractList() {
  /*<skip>*/
}
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
  /*<skip>*/
}
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.add__O__Z = (function(element) {
  this.add__I__O__V(this.size__I(), element);
  return true
});
$c_ju_AbstractList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.add__I__O__V = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_AbstractList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I())
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_List(o)) {
    var x2 = $as_ju_List(o);
    var oIter = x2.listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while (_\uff3fself.hasNext__Z()) {
        var arg1 = _\uff3fself.next__O();
        if (oIter.hasNext__Z()) {
          var b = oIter.next__O();
          var $$x2 = ((arg1 === null) ? (b === null) : $dp_equals__O__Z(arg1, b))
        } else {
          var $$x2 = false
        };
        if ((!$$x2)) {
          var $$x1 = true;
          break _return
        }
      };
      var $$x1 = false
    };
    if ((!$$x1)) {
      return (!oIter.hasNext__Z())
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = ((Math.imul(31, prev) + ((arg2 === null) ? 0 : $dp_hashCode__I(arg2))) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
/** @constructor */
function $c_ju_AbstractSet() {
  /*<skip>*/
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
  /*<skip>*/
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return ((x2.size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2))
  } else {
    return false
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = (($dp_hashCode__I(arg2) + prev) | 0)
  };
  return $uI(result)
});
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableCollection__f_inner = inner;
  $thiz.ju_Collections$UnmodifiableCollection__f_eagerThrow = true;
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false
}
$c_ju_Collections$UnmodifiableCollection.prototype = new $h_O();
$c_ju_Collections$UnmodifiableCollection.prototype.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableCollection.prototype = $c_ju_Collections$UnmodifiableCollection.prototype;
$c_ju_Collections$UnmodifiableCollection.prototype.size__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.size__I()
});
$c_ju_Collections$UnmodifiableCollection.prototype.isEmpty__Z = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.isEmpty__Z()
});
$c_ju_Collections$UnmodifiableCollection.prototype.contains__O__Z = (function(o) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.contains__O__Z(o)
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toArray__AO()
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO__AO = (function(a) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toArray__AO__AO(a)
});
$c_ju_Collections$UnmodifiableCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.containsAll__ju_Collection__Z(c)
});
$c_ju_Collections$UnmodifiableCollection.prototype.toString__T = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toString__T()
});
$c_ju_Collections$UnmodifiableCollection.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_eagerThrow
});
$c_ju_Collections$UnmodifiableCollection.prototype.iterator__ju_Iterator = (function() {
  return $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(new $c_ju_Collections$UnmodifiableIterator(), this.ju_Collections$UnmodifiableCollection__f_inner.iterator__ju_Iterator())
});
$c_ju_Collections$UnmodifiableCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableCollection.prototype.remove__O__Z = (function(o) {
  if ((this.eagerThrow__Z() || this.ju_Collections$UnmodifiableCollection__f_inner.contains__O__Z(o))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  } else {
    return false
  }
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_ju_ConcurrentModificationException = new $TypeData().initClass({
  ju_ConcurrentModificationException: 0
}, false, "java.util.ConcurrentModificationException", {
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ConcurrentModificationException.prototype.$classData = $d_ju_ConcurrentModificationException;
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
  return ((node === null) ? defaultValue : ($thiz.nodeWasAccessed__ju_HashMap$Node__V(node), node.ju_HashMap$Node__f_value))
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = oldTable.u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.get(i);
    while ((node !== null)) {
      if (((node.ju_HashMap$Node__f_hash & oldlen) === 0)) {
        node.ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          newTable.set(i, node)
        } else {
          lastLow.ju_HashMap$Node__f_next = node
        };
        lastLow = node
      } else {
        node.ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          newTable.set(((oldlen + i) | 0), node)
        } else {
          lastHigh.ju_HashMap$Node__f_next = node
        };
        lastHigh = node
      };
      node = node.ju_HashMap$Node__f_next
    };
    if ((lastLow !== null)) {
      lastLow.ju_HashMap$Node__f_next = null
    };
    if ((lastHigh !== null)) {
      lastHigh.ju_HashMap$Node__f_next = null
    };
    i = ((1 + i) | 0)
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0")
  };
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0")
  };
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_ju_HashMap__($thiz) {
  $ct_ju_HashMap__I__F__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
  /*<skip>*/
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(new $c_ju_HashMap$Node(), key, hash, value, previous, next)
});
$c_ju_HashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.isEmpty__Z = (function() {
  return (this.ju_HashMap__f_contentSize === 0)
});
$c_ju_HashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return (this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0))) !== null)
});
$c_ju_HashMap.prototype.putAll__ju_Map__V = (function(m) {
  if ((m instanceof $c_ju_HashMap)) {
    var x2 = $as_ju_HashMap(m);
    var iter = x2.nodeIterator__ju_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_ju_HashMap$Node(iter.next__O());
      this.java$util$HashMap$$put0__O__O__I__Z__O(next.ju_HashMap$Node__f_key, next.ju_HashMap$Node__f_value, next.ju_HashMap$Node__f_hash, false)
    }
  } else {
    $c_ju_AbstractMap.prototype.putAll__ju_Map__V.call(this, m)
  }
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : node.ju_HashMap$Node__f_value)
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  while (true) {
    if ((node === null)) {
      return null
    } else {
      if ((hash === node.ju_HashMap$Node__f_hash)) {
        var b = node.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        return node
      } else if ((hash < node.ju_HashMap$Node__f_hash)) {
        return null
      } else {
        node = node.ju_HashMap$Node__f_next
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this)
  };
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var x1 = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  if ((x1 === null)) {
    var newNode = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, null, null);
    this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode);
    var newNode$3 = newNode
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.ju_HashMap$Node__f_hash <= hash))) {
      if ((n.ju_HashMap$Node__f_hash === hash)) {
        var b = n.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        this.nodeWasAccessed__ju_HashMap$Node__V(n);
        var old = n.ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          n.ju_HashMap$Node__f_value = value
        };
        return old
      };
      prev = n;
      n = n.ju_HashMap$Node__f_next
    };
    var newNode$2 = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, prev, n);
    if ((prev === null)) {
      this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode$2)
    } else {
      prev.ju_HashMap$Node__f_next = newNode$2
    };
    if ((n !== null)) {
      n.ju_HashMap$Node__f_previous = newNode$2
    };
    var newNode$3 = newNode$2
  };
  this.ju_HashMap__f_contentSize = newContentSize;
  this.nodeWasAdded__ju_HashMap$Node__V(newNode$3);
  return null
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx)
  };
  return node
});
$c_ju_HashMap.prototype.removeNode__ju_HashMap$Node__V = (function(node) {
  var hash = node.ju_HashMap$Node__f_hash;
  this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)))
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = node.ju_HashMap$Node__f_previous;
  var next = node.ju_HashMap$Node__f_next;
  if ((previous === null)) {
    this.ju_HashMap__f_java$util$HashMap$$table.set(idx, next)
  } else {
    previous.ju_HashMap$Node__f_next = next
  };
  if ((next !== null)) {
    next.ju_HashMap$Node__f_previous = previous
  };
  this.ju_HashMap__f_contentSize = (((-1) + this.ju_HashMap__f_contentSize) | 0);
  this.nodeWasRemoved__ju_HashMap$Node__V(node)
});
$c_ju_HashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$NodeIterator(this)
});
$c_ju_HashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$KeyIterator(this)
});
function $as_ju_HashMap(obj) {
  return (((obj instanceof $c_ju_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap"))
}
function $isArrayOf_ju_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap)))
}
function $asArrayOf_ju_HashMap(obj, depth) {
  return (($isArrayOf_ju_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap;", depth))
}
var $d_ju_HashMap = new $TypeData().initClass({
  ju_HashMap: 0
}, false, "java.util.HashMap", {
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_HashMap.prototype.$classData = $d_ju_HashMap;
function $ct_ju_IllformedLocaleException__T__I__($thiz, s, errorIndex) {
  $thiz.ju_IllformedLocaleException__f_errorIndex = errorIndex;
  var s$1 = (s + ((errorIndex < 0) ? "" : ((" [at index " + errorIndex) + "]")));
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s$1, null, true, true);
  return $thiz
}
function $ct_ju_IllformedLocaleException__T__($thiz, s) {
  $ct_ju_IllformedLocaleException__T__I__($thiz, s, (-1));
  return $thiz
}
class $c_ju_IllformedLocaleException extends $c_jl_RuntimeException {
  constructor() {
    super();
    this.ju_IllformedLocaleException__f_errorIndex = 0
  };
}
var $d_ju_IllformedLocaleException = new $TypeData().initClass({
  ju_IllformedLocaleException: 0
}, false, "java.util.IllformedLocaleException", {
  ju_IllformedLocaleException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllformedLocaleException.prototype.$classData = $d_ju_IllformedLocaleException;
/** @constructor */
function $c_ju_Locale$$anon$1() {
  /*<skip>*/
}
$c_ju_Locale$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_ju_Locale$$anon$1.prototype.constructor = $c_ju_Locale$$anon$1;
/** @constructor */
function $h_ju_Locale$$anon$1() {
  /*<skip>*/
}
$h_ju_Locale$$anon$1.prototype = $c_ju_Locale$$anon$1.prototype;
$c_ju_Locale$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    $as_T(x._1__O());
    var x7 = $as_T(x._2__O());
    if ((x7 === "")) {
      return true
    };
    return true
  };
  return false
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x11 = $as_T(x._1__O());
    var x12 = $as_T(x._2__O());
    if ((x12 === "")) {
      return x11
    };
    return ((x11 + "-") + x12)
  };
  return default$1.apply__O__O(x)
});
$c_ju_Locale$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_ju_Locale$$anon$1 = new $TypeData().initClass({
  ju_Locale$$anon$1: 0
}, false, "java.util.Locale$$anon$1", {
  ju_Locale$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$$anon$1.prototype.$classData = $d_ju_Locale$$anon$1;
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().initClass({
  ju_NoSuchElementException: 0
}, false, "java.util.NoSuchElementException", {
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_NoSuchElementException.prototype.$classData = $d_ju_NoSuchElementException;
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_start = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end)
}
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return this.ju_RandomAccessListIterator__f_list.get__I__O(index)
});
$c_ju_RandomAccessListIterator.prototype.set__I__O__V = (function(index, e) {
  this.ju_RandomAccessListIterator__f_list.set__I__O__O(index, e)
});
$c_ju_RandomAccessListIterator.prototype.remove__I__V = (function(index) {
  this.ju_RandomAccessListIterator__f_list.remove__I__O(index)
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass({
  ju_RandomAccessListIterator: 0
}, false, "java.util.RandomAccessListIterator", {
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  O: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
});
$c_ju_RandomAccessListIterator.prototype.$classData = $d_ju_RandomAccessListIterator;
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayListIterator(arraySnapshot, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_start = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = null;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = arraySnapshot;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end)
}
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayListIterator() {
  /*<skip>*/
}
$h_ju_concurrent_CopyOnWriteArrayListIterator.prototype = $c_ju_concurrent_CopyOnWriteArrayListIterator.prototype;
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.get__I__O = (function(index) {
  return this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot[index]
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__I__V = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__I__O__V = (function(index, e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_concurrent_CopyOnWriteArrayListIterator = new $TypeData().initClass({
  ju_concurrent_CopyOnWriteArrayListIterator: 0
}, false, "java.util.concurrent.CopyOnWriteArrayListIterator", {
  ju_concurrent_CopyOnWriteArrayListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  O: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.$classData = $d_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0)
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toNanos__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$1: 0
}, false, "java.util.concurrent.TimeUnit$$anon$1", {
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1)
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMicros__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$2: 0
}, false, "java.util.concurrent.TimeUnit$$anon$2", {
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2)
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMillis__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$3: 0
}, false, "java.util.concurrent.TimeUnit$$anon$3", {
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3)
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toSeconds__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$4: 0
}, false, "java.util.concurrent.TimeUnit$$anon$4", {
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4)
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMinutes__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$5: 0
}, false, "java.util.concurrent.TimeUnit$$anon$5", {
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5)
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toHours__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$6: 0
}, false, "java.util.concurrent.TimeUnit$$anon$6", {
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6)
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toDays__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$7: 0
}, false, "java.util.concurrent.TimeUnit$$anon$7", {
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fen$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  this.Llocales_cldr_LDML__f_byCurrencyCode = null;
  var value = $m_Llocales_cldr_fallback_data_\uff3froot$();
  var $$x8 = new $c_s_Some(value);
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $$x7 = new $c_Llocales_cldr_LDMLLocale("en", territory, variant, script);
  var $$x6 = $m_s_None$();
  $m_s_package$();
  var $$x4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_s_package$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $m_s_package$();
  var elems$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  $m_s_package$();
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  $m_s_package$();
  var elems$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $m_s_package$();
  var elems$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["AM", "PM"]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  $m_s_package$();
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BC", "AD"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $$x3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_s_Predef$().s_Predef$__f_Map;
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "EEEE, MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 1, "MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 2, "MMM d, y"), $ct_T2__O__O__(new $c_T2(), 3, "M/d/yy")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_s_Predef$().s_Predef$__f_Map;
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "h:mm:ss a zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "h:mm:ss a z"), $ct_T2__O__O__(new $c_T2(), 2, "h:mm:ss a"), $ct_T2__O__O__(new $c_T2(), 3, "h:mm a")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $$x2 = new $c_s_Some(value$2);
  $m_s_package$();
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x8, $$x7, $$x6, $$x5, $$x3, $$x2, $$x1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat))
}
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fen$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3fen$.prototype = $c_Llocales_cldr_fallback_data_\uff3fen$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3fen$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3fen$: 0
}, false, "locales.cldr.fallback.data._en$", {
  Llocales_cldr_fallback_data_\uff3fen$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3fen$;
var $n_Llocales_cldr_fallback_data_\uff3fen$;
function $m_Llocales_cldr_fallback_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fen$)) {
    $n_Llocales_cldr_fallback_data_\uff3fen$ = new $c_Llocales_cldr_fallback_data_\uff3fen$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3fen$
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3froot$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  this.Llocales_cldr_LDML__f_byCurrencyCode = null;
  var $$x8 = $m_s_None$();
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $$x7 = new $c_Llocales_cldr_LDMLLocale("root", territory, variant, script);
  var value = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var $$x6 = new $c_s_Some(value);
  $m_s_package$();
  var $$x4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $$x4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_s_package$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $m_s_package$();
  var elems$2 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  $m_s_package$();
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  $m_s_package$();
  var elems$4 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $m_s_package$();
  var elems$5 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  $m_s_package$();
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BCE", "CE"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $$x3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_s_Predef$().s_Predef$__f_Map;
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "y MMMM d, EEEE"), $ct_T2__O__O__(new $c_T2(), 1, "y MMMM d"), $ct_T2__O__O__(new $c_T2(), 2, "y MMM d"), $ct_T2__O__O__(new $c_T2(), 3, "y-MM-dd")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_s_Predef$().s_Predef$__f_Map;
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "HH:mm:ss zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "HH:mm:ss z"), $ct_T2__O__O__(new $c_T2(), 2, "HH:mm:ss"), $ct_T2__O__O__(new $c_T2(), 3, "HH:mm")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $$x2 = new $c_s_Some(value$2);
  $m_s_package$();
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4\u00a0#,##0.00");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x8, $$x7, $$x6, $$x5, $$x3, $$x2, $$x1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat))
}
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3froot$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3froot$.prototype = $c_Llocales_cldr_fallback_data_\uff3froot$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3froot$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3froot$: 0
}, false, "locales.cldr.fallback.data._root$", {
  Llocales_cldr_fallback_data_\uff3froot$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3froot$;
var $n_Llocales_cldr_fallback_data_\uff3froot$;
function $m_Llocales_cldr_fallback_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3froot$)) {
    $n_Llocales_cldr_fallback_data_\uff3froot$ = new $c_Llocales_cldr_fallback_data_\uff3froot$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3froot$
}
/** @constructor */
function $c_Lnet_timerboard_Alliance$$anon$12() {
  this.Lnet_timerboard_Alliance$$anon$12__f_elemLabels = null;
  this.Lnet_timerboard_Alliance$$anon$12__f_elemDecoders$lzy4 = null;
  this.Lnet_timerboard_Alliance$$anon$12__f_elemDecodersbitmap$4 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("name", this$1);
  var this$3 = new $c_sci_$colon$colon("ticker", this$2);
  var this$5 = new $c_sci_$colon$colon("id", this$3);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Alliance$$anon$12__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Alliance$$anon$12.prototype = new $h_O();
$c_Lnet_timerboard_Alliance$$anon$12.prototype.constructor = $c_Lnet_timerboard_Alliance$$anon$12;
/** @constructor */
function $h_Lnet_timerboard_Alliance$$anon$12() {
  /*<skip>*/
}
$h_Lnet_timerboard_Alliance$$anon$12.prototype = $c_Lnet_timerboard_Alliance$$anon$12.prototype;
$c_Lnet_timerboard_Alliance$$anon$12.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Alliance$$anon$12__f_elemLabels
});
$c_Lnet_timerboard_Alliance$$anon$12.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_Alliance$$anon$12.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Alliance$$anon$12__f_elemDecodersbitmap$4)) {
    var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var decodeA$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(decodeA$3, this$1);
    var this$3 = new $c_sci_$colon$colon(decodeA$2, this$2);
    var this$5 = new $c_sci_$colon$colon(decodeA, this$3);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Alliance$$anon$12__f_elemDecoders$lzy4 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Alliance$$anon$12__f_elemDecodersbitmap$4 = true
  };
  return this.Lnet_timerboard_Alliance$$anon$12__f_elemDecoders$lzy4
});
$c_Lnet_timerboard_Alliance$$anon$12.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee137 = $m_Lnet_timerboard_Alliance$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult83: {
        var x202 = iter.next__s_util_Either();
        if ((x202 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x202).s_util_Right__f_value;
          res.set(i, value);
          break matchResult83
        };
        if ((x202 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x202);
          failed = l;
          break matchResult83
        };
        throw new $c_s_MatchError(x202)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee137.fromProduct__s_Product__Lnet_timerboard_Alliance(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("Alliance", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_Alliance$$anon$12 = new $TypeData().initClass({
  Lnet_timerboard_Alliance$$anon$12: 0
}, false, "net.timerboard.Alliance$$anon$12", {
  Lnet_timerboard_Alliance$$anon$12: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_Alliance$$anon$12.prototype.$classData = $d_Lnet_timerboard_Alliance$$anon$12;
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$Status() {
  /*<skip>*/
}
$c_Lnet_timerboard_BackendSocket$Status.prototype = new $h_O();
$c_Lnet_timerboard_BackendSocket$Status.prototype.constructor = $c_Lnet_timerboard_BackendSocket$Status;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$Status() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$Status.prototype = $c_Lnet_timerboard_BackendSocket$Status.prototype;
$c_Lnet_timerboard_BackendSocket$Status.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lnet_timerboard_BackendSocket$Status(obj) {
  return (((obj instanceof $c_Lnet_timerboard_BackendSocket$Status) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.BackendSocket$Status"))
}
function $isArrayOf_Lnet_timerboard_BackendSocket$Status(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_BackendSocket$Status)))
}
function $asArrayOf_Lnet_timerboard_BackendSocket$Status(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_BackendSocket$Status(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.BackendSocket$Status;", depth))
}
/** @constructor */
function $c_Lnet_timerboard_Direction() {
  /*<skip>*/
}
$c_Lnet_timerboard_Direction.prototype = new $h_O();
$c_Lnet_timerboard_Direction.prototype.constructor = $c_Lnet_timerboard_Direction;
/** @constructor */
function $h_Lnet_timerboard_Direction() {
  /*<skip>*/
}
$h_Lnet_timerboard_Direction.prototype = $c_Lnet_timerboard_Direction.prototype;
$c_Lnet_timerboard_Direction.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_Direction.prototype.flip__Lnet_timerboard_Direction = (function() {
  var x = $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction();
  if (((x !== null) && (x === this))) {
    return $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction()
  };
  var x$3 = $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction();
  if (((x$3 !== null) && (x$3 === this))) {
    return $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction()
  };
  throw new $c_s_MatchError(this)
});
$c_Lnet_timerboard_Direction.prototype.icon__Ltyrian_Html = (function() {
  var x = $s_Lnet_timerboard_Direction$__Asc__Lnet_timerboard_Direction();
  if (((x !== null) && (x === this))) {
    var this$1 = $m_Ltyrian_Html$();
    var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("fa-solid fa-arrow-down-short-wide")]));
    return $f_Ltyrian_HtmlTags__i$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$1, attributes, "")
  };
  var x$3 = $s_Lnet_timerboard_Direction$__Desc__Lnet_timerboard_Direction();
  if (((x$3 !== null) && (x$3 === this))) {
    var this$2 = $m_Ltyrian_Html$();
    var attributes$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString.$colon$eq__T__Ltyrian_Attribute("fa-solid fa-arrow-down-wide-short")]));
    return $f_Ltyrian_HtmlTags__i$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$2, attributes$1, "")
  };
  throw new $c_s_MatchError(this)
});
function $as_Lnet_timerboard_Direction(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Direction) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Direction"))
}
function $isArrayOf_Lnet_timerboard_Direction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Direction)))
}
function $asArrayOf_Lnet_timerboard_Direction(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Direction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Direction;", depth))
}
var $d_Lnet_timerboard_Direction = new $TypeData().initClass({
  Lnet_timerboard_Direction: 0
}, false, "net.timerboard.Direction", {
  Lnet_timerboard_Direction: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Direction.prototype.$classData = $d_Lnet_timerboard_Direction;
/** @constructor */
function $c_Lnet_timerboard_Event$$anon$14() {
  this.Lnet_timerboard_Event$$anon$14__f_elemLabels = null;
  this.Lnet_timerboard_Event$$anon$14__f_elemDecoders$lzy5 = null;
  this.Lnet_timerboard_Event$$anon$14__f_elemDecodersbitmap$5 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("alliance", this$1);
  var this$3 = new $c_sci_$colon$colon("event", this$2);
  var this$5 = new $c_sci_$colon$colon("solar_system_name", this$3);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Event$$anon$14__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Event$$anon$14.prototype = new $h_O();
$c_Lnet_timerboard_Event$$anon$14.prototype.constructor = $c_Lnet_timerboard_Event$$anon$14;
/** @constructor */
function $h_Lnet_timerboard_Event$$anon$14() {
  /*<skip>*/
}
$h_Lnet_timerboard_Event$$anon$14.prototype = $c_Lnet_timerboard_Event$$anon$14.prototype;
$c_Lnet_timerboard_Event$$anon$14.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Event$$anon$14__f_elemLabels
});
$c_Lnet_timerboard_Event$$anon$14.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_Event$$anon$14.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Event$$anon$14__f_elemDecodersbitmap$5)) {
    var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var decodeA$2 = $m_Lnet_timerboard_InnerEvent$().derived$Decoder__Lio_circe_Decoder();
    var decodeA$3 = $m_Lnet_timerboard_Alliance$().derived$Decoder__Lio_circe_Decoder();
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(decodeA$3, this$1);
    var this$3 = new $c_sci_$colon$colon(decodeA$2, this$2);
    var this$5 = new $c_sci_$colon$colon(decodeA, this$3);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Event$$anon$14__f_elemDecoders$lzy5 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Event$$anon$14__f_elemDecodersbitmap$5 = true
  };
  return this.Lnet_timerboard_Event$$anon$14__f_elemDecoders$lzy5
});
$c_Lnet_timerboard_Event$$anon$14.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee162 = $m_Lnet_timerboard_Event$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult88: {
        var x218 = iter.next__s_util_Either();
        if ((x218 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x218).s_util_Right__f_value;
          res.set(i, value);
          break matchResult88
        };
        if ((x218 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x218);
          failed = l;
          break matchResult88
        };
        throw new $c_s_MatchError(x218)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee162.fromProduct__s_Product__Lnet_timerboard_Event(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("Event", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_Event$$anon$14 = new $TypeData().initClass({
  Lnet_timerboard_Event$$anon$14: 0
}, false, "net.timerboard.Event$$anon$14", {
  Lnet_timerboard_Event$$anon$14: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_Event$$anon$14.prototype.$classData = $d_Lnet_timerboard_Event$$anon$14;
/** @constructor */
function $c_Lnet_timerboard_EventType() {
  /*<skip>*/
}
$c_Lnet_timerboard_EventType.prototype = new $h_O();
$c_Lnet_timerboard_EventType.prototype.constructor = $c_Lnet_timerboard_EventType;
/** @constructor */
function $h_Lnet_timerboard_EventType() {
  /*<skip>*/
}
$h_Lnet_timerboard_EventType.prototype = $c_Lnet_timerboard_EventType.prototype;
$c_Lnet_timerboard_EventType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lnet_timerboard_EventType(obj) {
  return (((obj instanceof $c_Lnet_timerboard_EventType) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.EventType"))
}
function $isArrayOf_Lnet_timerboard_EventType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_EventType)))
}
function $asArrayOf_Lnet_timerboard_EventType(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_EventType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.EventType;", depth))
}
var $d_Lnet_timerboard_EventType = new $TypeData().initClass({
  Lnet_timerboard_EventType: 0
}, false, "net.timerboard.EventType", {
  Lnet_timerboard_EventType: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_EventType.prototype.$classData = $d_Lnet_timerboard_EventType;
/** @constructor */
function $c_Lnet_timerboard_Field() {
  /*<skip>*/
}
$c_Lnet_timerboard_Field.prototype = new $h_O();
$c_Lnet_timerboard_Field.prototype.constructor = $c_Lnet_timerboard_Field;
/** @constructor */
function $h_Lnet_timerboard_Field() {
  /*<skip>*/
}
$h_Lnet_timerboard_Field.prototype = $c_Lnet_timerboard_Field.prototype;
$c_Lnet_timerboard_Field.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lnet_timerboard_Field(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Field) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Field"))
}
function $isArrayOf_Lnet_timerboard_Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Field)))
}
function $asArrayOf_Lnet_timerboard_Field(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Field(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Field;", depth))
}
var $d_Lnet_timerboard_Field = new $TypeData().initClass({
  Lnet_timerboard_Field: 0
}, false, "net.timerboard.Field", {
  Lnet_timerboard_Field: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Field.prototype.$classData = $d_Lnet_timerboard_Field;
/** @constructor */
function $c_Lnet_timerboard_InnerEvent$$anon$10() {
  this.Lnet_timerboard_InnerEvent$$anon$10__f_elemLabels = null;
  this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecoders$lzy3 = null;
  this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecodersbitmap$3 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("structure_id", this$1);
  var this$3 = new $c_sci_$colon$colon("start_time", this$2);
  var this$4 = new $c_sci_$colon$colon("solar_system_id", this$3);
  var this$5 = new $c_sci_$colon$colon("participants", this$4);
  var this$6 = new $c_sci_$colon$colon("event_type", this$5);
  var this$7 = new $c_sci_$colon$colon("defender_score", this$6);
  var this$8 = new $c_sci_$colon$colon("defender_id", this$7);
  var this$9 = new $c_sci_$colon$colon("constellation_id", this$8);
  var this$10 = new $c_sci_$colon$colon("campaign_id", this$9);
  var this$12 = new $c_sci_$colon$colon("attackers_score", this$10);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$12);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_InnerEvent$$anon$10__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype = new $h_O();
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.constructor = $c_Lnet_timerboard_InnerEvent$$anon$10;
/** @constructor */
function $h_Lnet_timerboard_InnerEvent$$anon$10() {
  /*<skip>*/
}
$h_Lnet_timerboard_InnerEvent$$anon$10.prototype = $c_Lnet_timerboard_InnerEvent$$anon$10.prototype;
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_InnerEvent$$anon$10__f_elemLabels
});
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecodersbitmap$3)) {
    var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBigDecimal;
    var decodeA$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$4 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$5 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBigDecimal;
    var decodeA$6 = $m_Lnet_timerboard_EventType$().derived$EnumCodec__Lnet_timerboard_CirceEnumHelpers$EnumCodec();
    $m_Lio_circe_Decoder$();
    $m_Lio_circe_Decoder$();
    var decodeA$1 = $m_Lnet_timerboard_Participant$().derived$Decoder__Lio_circe_Decoder();
    var d = new $c_Lio_circe_Decoder$$anon$45(decodeA$1);
    var decodeA$7 = new $c_Lio_circe_Decoder$$anon$41(d);
    var decodeA$8 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$9 = $m_Lio_circe_Decoder$().decodeZonedDateTime__Lio_circe_Decoder();
    var decodeA$10 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var this$3 = $m_s_package$().s_package$__f_Nil;
    var this$4 = new $c_sci_$colon$colon(decodeA$10, this$3);
    var this$5 = new $c_sci_$colon$colon(decodeA$9, this$4);
    var this$6 = new $c_sci_$colon$colon(decodeA$8, this$5);
    var this$7 = new $c_sci_$colon$colon(decodeA$7, this$6);
    var this$8 = new $c_sci_$colon$colon(decodeA$6, this$7);
    var this$9 = new $c_sci_$colon$colon(decodeA$5, this$8);
    var this$10 = new $c_sci_$colon$colon(decodeA$4, this$9);
    var this$11 = new $c_sci_$colon$colon(decodeA$3, this$10);
    var this$12 = new $c_sci_$colon$colon(decodeA$2, this$11);
    var this$14 = new $c_sci_$colon$colon(decodeA, this$12);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$14);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecoders$lzy3 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecodersbitmap$3 = true
  };
  return this.Lnet_timerboard_InnerEvent$$anon$10__f_elemDecoders$lzy3
});
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee91 = $m_Lnet_timerboard_InnerEvent$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult78: {
        var x186 = iter.next__s_util_Either();
        if ((x186 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x186).s_util_Right__f_value;
          res.set(i, value);
          break matchResult78
        };
        if ((x186 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x186);
          failed = l;
          break matchResult78
        };
        throw new $c_s_MatchError(x186)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee91.fromProduct__s_Product__Lnet_timerboard_InnerEvent(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("InnerEvent", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_InnerEvent$$anon$10 = new $TypeData().initClass({
  Lnet_timerboard_InnerEvent$$anon$10: 0
}, false, "net.timerboard.InnerEvent$$anon$10", {
  Lnet_timerboard_InnerEvent$$anon$10: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_InnerEvent$$anon$10.prototype.$classData = $d_Lnet_timerboard_InnerEvent$$anon$10;
/** @constructor */
function $c_Lnet_timerboard_Msg() {
  /*<skip>*/
}
$c_Lnet_timerboard_Msg.prototype = new $h_O();
$c_Lnet_timerboard_Msg.prototype.constructor = $c_Lnet_timerboard_Msg;
/** @constructor */
function $h_Lnet_timerboard_Msg() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg.prototype = $c_Lnet_timerboard_Msg.prototype;
$c_Lnet_timerboard_Msg.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lnet_timerboard_Msg(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg"))
}
function $isArrayOf_Lnet_timerboard_Msg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg)))
}
function $asArrayOf_Lnet_timerboard_Msg(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg;", depth))
}
/** @constructor */
function $c_Lnet_timerboard_Participant$$anon$8() {
  this.Lnet_timerboard_Participant$$anon$8__f_elemLabels = null;
  this.Lnet_timerboard_Participant$$anon$8__f_elemDecoders$lzy2 = null;
  this.Lnet_timerboard_Participant$$anon$8__f_elemDecodersbitmap$2 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("score", this$1);
  var this$4 = new $c_sci_$colon$colon("alliance_id", this$2);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Participant$$anon$8__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Participant$$anon$8.prototype = new $h_O();
$c_Lnet_timerboard_Participant$$anon$8.prototype.constructor = $c_Lnet_timerboard_Participant$$anon$8;
/** @constructor */
function $h_Lnet_timerboard_Participant$$anon$8() {
  /*<skip>*/
}
$h_Lnet_timerboard_Participant$$anon$8.prototype = $c_Lnet_timerboard_Participant$$anon$8.prototype;
$c_Lnet_timerboard_Participant$$anon$8.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Participant$$anon$8__f_elemLabels
});
$c_Lnet_timerboard_Participant$$anon$8.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_Participant$$anon$8.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_Participant$$anon$8__f_elemDecodersbitmap$2)) {
    var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var decodeA$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBigDecimal;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(decodeA$2, this$1);
    var this$4 = new $c_sci_$colon$colon(decodeA, this$2);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Participant$$anon$8__f_elemDecoders$lzy2 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Participant$$anon$8__f_elemDecodersbitmap$2 = true
  };
  return this.Lnet_timerboard_Participant$$anon$8__f_elemDecoders$lzy2
});
$c_Lnet_timerboard_Participant$$anon$8.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee48 = $m_Lnet_timerboard_Participant$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult73: {
        var x170 = iter.next__s_util_Either();
        if ((x170 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x170).s_util_Right__f_value;
          res.set(i, value);
          break matchResult73
        };
        if ((x170 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x170);
          failed = l;
          break matchResult73
        };
        throw new $c_s_MatchError(x170)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee48.fromProduct__s_Product__Lnet_timerboard_Participant(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("Participant", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_Participant$$anon$8 = new $TypeData().initClass({
  Lnet_timerboard_Participant$$anon$8: 0
}, false, "net.timerboard.Participant$$anon$8", {
  Lnet_timerboard_Participant$$anon$8: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_Participant$$anon$8.prototype.$classData = $d_Lnet_timerboard_Participant$$anon$8;
/** @constructor */
function $c_Lnet_timerboard_SolarSystem$$anon$4() {
  this.Lnet_timerboard_SolarSystem$$anon$4__f_elemLabels = null;
  this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecoders$lzy1 = null;
  this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecodersbitmap$1 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("id", this$1);
  var this$4 = new $c_sci_$colon$colon("name", this$2);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_SolarSystem$$anon$4__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype = new $h_O();
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.constructor = $c_Lnet_timerboard_SolarSystem$$anon$4;
/** @constructor */
function $h_Lnet_timerboard_SolarSystem$$anon$4() {
  /*<skip>*/
}
$h_Lnet_timerboard_SolarSystem$$anon$4.prototype = $c_Lnet_timerboard_SolarSystem$$anon$4.prototype;
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_SolarSystem$$anon$4__f_elemLabels
});
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecodersbitmap$1)) {
    var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var decodeA$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(decodeA$2, this$1);
    var this$4 = new $c_sci_$colon$colon(decodeA, this$2);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecoders$lzy1 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecodersbitmap$1 = true
  };
  return this.Lnet_timerboard_SolarSystem$$anon$4__f_elemDecoders$lzy1
});
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee18 = $m_Lnet_timerboard_SolarSystem$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult23: {
        var x95 = iter.next__s_util_Either();
        if ((x95 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x95).s_util_Right__f_value;
          res.set(i, value);
          break matchResult23
        };
        if ((x95 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x95);
          failed = l;
          break matchResult23
        };
        throw new $c_s_MatchError(x95)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee18.fromProduct__s_Product__Lnet_timerboard_SolarSystem(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("SolarSystem", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_SolarSystem$$anon$4 = new $TypeData().initClass({
  Lnet_timerboard_SolarSystem$$anon$4: 0
}, false, "net.timerboard.SolarSystem$$anon$4", {
  Lnet_timerboard_SolarSystem$$anon$4: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_SolarSystem$$anon$4.prototype.$classData = $d_Lnet_timerboard_SolarSystem$$anon$4;
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$$anon$16() {
  this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemLabels = null;
  this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecoders$lzy6 = null;
  this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecodersbitmap$6 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$3 = new $c_sci_$colon$colon("initial", this$1);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$$anon$16;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$$anon$16() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$$anon$16.prototype = $c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype;
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemLabels
});
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecodersbitmap$6)) {
    $m_Lio_circe_Decoder$();
    var decodeA = $m_Lnet_timerboard_Event$().derived$Decoder__Lio_circe_Decoder();
    var decodeA$1 = new $c_Lio_circe_Decoder$$anon$45(decodeA);
    var this$2 = $m_s_package$().s_package$__f_Nil;
    var this$4 = new $c_sci_$colon$colon(decodeA$1, this$2);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecoders$lzy6 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecodersbitmap$6 = true
  };
  return this.Lnet_timerboard_WebsocketEvent$$anon$16__f_elemDecoders$lzy6
});
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee181 = $m_Lnet_timerboard_WebsocketEvent$Initial$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult96: {
        var x238 = iter.next__s_util_Either();
        if ((x238 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x238).s_util_Right__f_value;
          res.set(i, value);
          break matchResult96
        };
        if ((x238 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x238);
          failed = l;
          break matchResult96
        };
        throw new $c_s_MatchError(x238)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee181.fromProduct__s_Product__Lnet_timerboard_WebsocketEvent$Initial(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("Initial", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_WebsocketEvent$$anon$16 = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$$anon$16: 0
}, false, "net.timerboard.WebsocketEvent$$anon$16", {
  Lnet_timerboard_WebsocketEvent$$anon$16: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_WebsocketEvent$$anon$16.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$$anon$16;
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$$anon$18() {
  this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemLabels = null;
  this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecoders$lzy7 = null;
  this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecodersbitmap$7 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$3 = new $c_sci_$colon$colon("diff", this$1);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$$anon$18;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$$anon$18() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$$anon$18.prototype = $c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype;
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemLabels
});
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.elemDecoders__ALio_circe_Decoder = (function() {
  if ((!this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecodersbitmap$7)) {
    var decodeA = $m_Ldiffson_circe_package$().Ldiffson_circe_package$__f_jsonPatchDecoder;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$3 = new $c_sci_$colon$colon(decodeA, this$1);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecoders$lzy7 = new ($d_Lio_circe_Decoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecodersbitmap$7 = true
  };
  return this.Lnet_timerboard_WebsocketEvent$$anon$18__f_elemDecoders$lzy7
});
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var \u03b4scrutinee194 = $m_Lnet_timerboard_WebsocketEvent$Diff$();
  if (c.value__Lio_circe_Json().isObject__Z()) {
    var iter = new $c_Lio_circe_DerivedDecoder$$anon$1(c, this);
    var dimensions = new $ac_I(new Int32Array([$f_Lio_circe_DerivedInstance__elemCount__I(this)]));
    var res = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var failed = null;
    var i = 0;
    while ((iter.hasNext__Z() && (failed === null))) {
      matchResult101: {
        var x254 = iter.next__s_util_Either();
        if ((x254 instanceof $c_s_util_Right)) {
          var value = $as_s_util_Right(x254).s_util_Right__f_value;
          res.set(i, value);
          break matchResult101
        };
        if ((x254 instanceof $c_s_util_Left)) {
          var l = $as_s_util_Left(x254);
          failed = l;
          break matchResult101
        };
        throw new $c_s_MatchError(x254)
      };
      i = ((1 + i) | 0)
    };
    if ((failed === null)) {
      $m_s_package$();
      var p = $m_T$().fromArray__O__s_Product(res);
      var value$1 = \u03b4scrutinee194.fromProduct__s_Product__Lnet_timerboard_WebsocketEvent$Diff(p);
      return new $c_s_util_Right(value$1)
    } else {
      return failed
    }
  } else {
    $m_s_package$();
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0(((c$2) => (() => c$2.history__sci_List()))(c));
    var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2("Diff", ops);
    return new $c_s_util_Left(value$2)
  }
});
var $d_Lnet_timerboard_WebsocketEvent$$anon$18 = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$$anon$18: 0
}, false, "net.timerboard.WebsocketEvent$$anon$18", {
  Lnet_timerboard_WebsocketEvent$$anon$18: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_DerivedDecoder: 1
});
$c_Lnet_timerboard_WebsocketEvent$$anon$18.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$$anon$18;
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$Diff(diff) {
  this.Lnet_timerboard_WebsocketEvent$Diff__f_diff = null;
  this.Lnet_timerboard_WebsocketEvent$Diff__f_diff = diff
}
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$Diff;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$Diff() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$Diff.prototype = $c_Lnet_timerboard_WebsocketEvent$Diff.prototype;
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_WebsocketEvent$Diff)) {
    var x$0$2 = $as_Lnet_timerboard_WebsocketEvent$Diff(x$0);
    var x = this.Lnet_timerboard_WebsocketEvent$Diff__f_diff;
    var x$2 = x$0$2.Lnet_timerboard_WebsocketEvent$Diff__f_diff;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.productPrefix__T = (function() {
  return "Diff"
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_WebsocketEvent$Diff__f_diff
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_timerboard_WebsocketEvent$Diff(obj) {
  return (((obj instanceof $c_Lnet_timerboard_WebsocketEvent$Diff) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.WebsocketEvent$Diff"))
}
function $isArrayOf_Lnet_timerboard_WebsocketEvent$Diff(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_WebsocketEvent$Diff)))
}
function $asArrayOf_Lnet_timerboard_WebsocketEvent$Diff(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_WebsocketEvent$Diff(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.WebsocketEvent$Diff;", depth))
}
var $d_Lnet_timerboard_WebsocketEvent$Diff = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$Diff: 0
}, false, "net.timerboard.WebsocketEvent$Diff", {
  Lnet_timerboard_WebsocketEvent$Diff: 1,
  O: 1,
  Lnet_timerboard_WebsocketEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_WebsocketEvent$Diff.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$Diff;
/** @constructor */
function $c_Lnet_timerboard_WebsocketEvent$Initial(initial) {
  this.Lnet_timerboard_WebsocketEvent$Initial__f_initial = null;
  this.Lnet_timerboard_WebsocketEvent$Initial__f_initial = initial
}
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype = new $h_O();
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.constructor = $c_Lnet_timerboard_WebsocketEvent$Initial;
/** @constructor */
function $h_Lnet_timerboard_WebsocketEvent$Initial() {
  /*<skip>*/
}
$h_Lnet_timerboard_WebsocketEvent$Initial.prototype = $c_Lnet_timerboard_WebsocketEvent$Initial.prototype;
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_WebsocketEvent$Initial)) {
    var x$0$2 = $as_Lnet_timerboard_WebsocketEvent$Initial(x$0);
    var x = this.Lnet_timerboard_WebsocketEvent$Initial__f_initial;
    var x$2 = x$0$2.Lnet_timerboard_WebsocketEvent$Initial__f_initial;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.productPrefix__T = (function() {
  return "Initial"
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_WebsocketEvent$Initial__f_initial
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_timerboard_WebsocketEvent$Initial(obj) {
  return (((obj instanceof $c_Lnet_timerboard_WebsocketEvent$Initial) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.WebsocketEvent$Initial"))
}
function $isArrayOf_Lnet_timerboard_WebsocketEvent$Initial(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_WebsocketEvent$Initial)))
}
function $asArrayOf_Lnet_timerboard_WebsocketEvent$Initial(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_WebsocketEvent$Initial(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.WebsocketEvent$Initial;", depth))
}
var $d_Lnet_timerboard_WebsocketEvent$Initial = new $TypeData().initClass({
  Lnet_timerboard_WebsocketEvent$Initial: 0
}, false, "net.timerboard.WebsocketEvent$Initial", {
  Lnet_timerboard_WebsocketEvent$Initial: 1,
  O: 1,
  Lnet_timerboard_WebsocketEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_timerboard_WebsocketEvent$Initial.prototype.$classData = $d_Lnet_timerboard_WebsocketEvent$Initial;
class $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError extends $c_jl_VirtualMachineError {
  constructor(cause) {
    super();
    var message = ((cause === null) ? null : cause.toString__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 0
}, false, "org.scalajs.linker.runtime.UndefinedBehaviorError", {
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype.$classData = $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError;
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x
});
$c_s_$less$colon$less$$anon$1.prototype.compose__F1__F1 = (function(r) {
  return r
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint"
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass({
  s_$less$colon$less$$anon$1: 0
}, false, "scala.$less$colon$less$$anon$1", {
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$$anon$1.prototype.$classData = $d_s_$less$colon$less$$anon$1;
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    $thiz.s_MatchError__f_objString = (($thiz.s_MatchError__f_obj === null) ? "null" : $p_s_MatchError__liftedTree1$1__T($thiz));
    $thiz.s_MatchError__f_bitmap$0 = true
  };
  return $thiz.s_MatchError__f_objString
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString)
}
function $p_s_MatchError__ofClass$1__T($thiz) {
  var this$1 = $thiz.s_MatchError__f_obj;
  return ("of class " + $objectClassName(this$1))
}
function $p_s_MatchError__liftedTree1$1__T($thiz) {
  try {
    return ((($dp_toString__T($thiz.s_MatchError__f_obj) + " (") + $p_s_MatchError__ofClass$1__T($thiz)) + ")")
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      return ("an instance " + $p_s_MatchError__ofClass$1__T($thiz))
    } else {
      throw e
    }
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $p_s_MatchError__objString__T(this)
  };
}
var $d_s_MatchError = new $TypeData().initClass({
  s_MatchError: 0
}, false, "scala.MatchError", {
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_MatchError.prototype.$classData = $d_s_MatchError;
/** @constructor */
function $c_s_Option() {
  /*<skip>*/
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
  /*<skip>*/
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$())
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1)
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    $m_sc_Iterator$();
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a)
  }
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"))
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)))
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth))
}
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = 0;
  this.s_Product$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.s_Product$$anon$1__f_$outer = outer
  };
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = outer.productArity__I()
}
$c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_s_Product$$anon$1.prototype.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
  /*<skip>*/
}
$h_s_Product$$anon$1.prototype = $c_s_Product$$anon$1.prototype;
$c_s_Product$$anon$1.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$1__f_c < this.s_Product$$anon$1__f_cmax)
});
$c_s_Product$$anon$1.prototype.next__O = (function() {
  var result = this.s_Product$$anon$1__f_$outer.productElement__I__O(this.s_Product$$anon$1__f_c);
  this.s_Product$$anon$1__f_c = ((1 + this.s_Product$$anon$1__f_c) | 0);
  return result
});
var $d_s_Product$$anon$1 = new $TypeData().initClass({
  s_Product$$anon$1: 0
}, false, "scala.Product$$anon$1", {
  s_Product$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_s_Product$$anon$1.prototype.$classData = $d_s_Product$$anon$1;
/** @constructor */
function $c_T1(_1) {
  this.T1__f__1 = null;
  this.T1__f__1 = _1
}
$c_T1.prototype = new $h_O();
$c_T1.prototype.constructor = $c_T1;
/** @constructor */
function $h_T1() {
  /*<skip>*/
}
$h_T1.prototype = $c_T1.prototype;
$c_T1.prototype.productArity__I = (function() {
  return 1
});
$c_T1.prototype.productElement__I__O = (function(n) {
  return $f_s_Product1__productElement__I__O(this, n)
});
$c_T1.prototype.toString__T = (function() {
  return (("(" + this.T1__f__1) + ")")
});
$c_T1.prototype.productPrefix__T = (function() {
  return "Tuple1"
});
$c_T1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T1.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T1)) {
    var Tuple1$1 = $as_T1(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.T1__f__1, Tuple1$1.T1__f__1)
  } else {
    return false
  }
});
function $as_T1(obj) {
  return (((obj instanceof $c_T1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple1"))
}
function $isArrayOf_T1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T1)))
}
function $asArrayOf_T1(obj, depth) {
  return (($isArrayOf_T1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple1;", depth))
}
var $d_T1 = new $TypeData().initClass({
  T1: 0
}, false, "scala.Tuple1", {
  T1: 1,
  O: 1,
  s_Product1: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T1.prototype.$classData = $d_T1;
/** @constructor */
function $c_T10(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10) {
  this.T10__f__1 = null;
  this.T10__f__2 = null;
  this.T10__f__3 = null;
  this.T10__f__4 = null;
  this.T10__f__5 = null;
  this.T10__f__6 = null;
  this.T10__f__7 = null;
  this.T10__f__8 = null;
  this.T10__f__9 = null;
  this.T10__f__10 = null;
  this.T10__f__1 = _1;
  this.T10__f__2 = _2;
  this.T10__f__3 = _3;
  this.T10__f__4 = _4;
  this.T10__f__5 = _5;
  this.T10__f__6 = _6;
  this.T10__f__7 = _7;
  this.T10__f__8 = _8;
  this.T10__f__9 = _9;
  this.T10__f__10 = _10
}
$c_T10.prototype = new $h_O();
$c_T10.prototype.constructor = $c_T10;
/** @constructor */
function $h_T10() {
  /*<skip>*/
}
$h_T10.prototype = $c_T10.prototype;
$c_T10.prototype.productArity__I = (function() {
  return 10
});
$c_T10.prototype.productElement__I__O = (function(n) {
  return $f_s_Product10__productElement__I__O(this, n)
});
$c_T10.prototype.toString__T = (function() {
  return (((((((((((((((((((("(" + this.T10__f__1) + ",") + this.T10__f__2) + ",") + this.T10__f__3) + ",") + this.T10__f__4) + ",") + this.T10__f__5) + ",") + this.T10__f__6) + ",") + this.T10__f__7) + ",") + this.T10__f__8) + ",") + this.T10__f__9) + ",") + this.T10__f__10) + ")")
});
$c_T10.prototype.productPrefix__T = (function() {
  return "Tuple10"
});
$c_T10.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T10.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T10.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T10)) {
    var Tuple10$1 = $as_T10(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__1, Tuple10$1.T10__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__2, Tuple10$1.T10__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__3, Tuple10$1.T10__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__4, Tuple10$1.T10__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__5, Tuple10$1.T10__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__6, Tuple10$1.T10__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__7, Tuple10$1.T10__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__8, Tuple10$1.T10__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__9, Tuple10$1.T10__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__10, Tuple10$1.T10__f__10)))))
  } else {
    return false
  }
});
function $as_T10(obj) {
  return (((obj instanceof $c_T10) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple10"))
}
function $isArrayOf_T10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T10)))
}
function $asArrayOf_T10(obj, depth) {
  return (($isArrayOf_T10(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple10;", depth))
}
var $d_T10 = new $TypeData().initClass({
  T10: 0
}, false, "scala.Tuple10", {
  T10: 1,
  O: 1,
  s_Product10: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T10.prototype.$classData = $d_T10;
/** @constructor */
function $c_T11(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11) {
  this.T11__f__1 = null;
  this.T11__f__2 = null;
  this.T11__f__3 = null;
  this.T11__f__4 = null;
  this.T11__f__5 = null;
  this.T11__f__6 = null;
  this.T11__f__7 = null;
  this.T11__f__8 = null;
  this.T11__f__9 = null;
  this.T11__f__10 = null;
  this.T11__f__11 = null;
  this.T11__f__1 = _1;
  this.T11__f__2 = _2;
  this.T11__f__3 = _3;
  this.T11__f__4 = _4;
  this.T11__f__5 = _5;
  this.T11__f__6 = _6;
  this.T11__f__7 = _7;
  this.T11__f__8 = _8;
  this.T11__f__9 = _9;
  this.T11__f__10 = _10;
  this.T11__f__11 = _11
}
$c_T11.prototype = new $h_O();
$c_T11.prototype.constructor = $c_T11;
/** @constructor */
function $h_T11() {
  /*<skip>*/
}
$h_T11.prototype = $c_T11.prototype;
$c_T11.prototype.productArity__I = (function() {
  return 11
});
$c_T11.prototype.productElement__I__O = (function(n) {
  return $f_s_Product11__productElement__I__O(this, n)
});
$c_T11.prototype.toString__T = (function() {
  return (((((((((((((((((((((("(" + this.T11__f__1) + ",") + this.T11__f__2) + ",") + this.T11__f__3) + ",") + this.T11__f__4) + ",") + this.T11__f__5) + ",") + this.T11__f__6) + ",") + this.T11__f__7) + ",") + this.T11__f__8) + ",") + this.T11__f__9) + ",") + this.T11__f__10) + ",") + this.T11__f__11) + ")")
});
$c_T11.prototype.productPrefix__T = (function() {
  return "Tuple11"
});
$c_T11.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T11.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T11.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T11)) {
    var Tuple11$1 = $as_T11(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__1, Tuple11$1.T11__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__2, Tuple11$1.T11__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__3, Tuple11$1.T11__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__4, Tuple11$1.T11__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__5, Tuple11$1.T11__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__6, Tuple11$1.T11__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__7, Tuple11$1.T11__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__8, Tuple11$1.T11__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__9, Tuple11$1.T11__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__10, Tuple11$1.T11__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__11, Tuple11$1.T11__f__11)))))
  } else {
    return false
  }
});
function $as_T11(obj) {
  return (((obj instanceof $c_T11) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple11"))
}
function $isArrayOf_T11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T11)))
}
function $asArrayOf_T11(obj, depth) {
  return (($isArrayOf_T11(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple11;", depth))
}
var $d_T11 = new $TypeData().initClass({
  T11: 0
}, false, "scala.Tuple11", {
  T11: 1,
  O: 1,
  s_Product11: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T11.prototype.$classData = $d_T11;
/** @constructor */
function $c_T12(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12) {
  this.T12__f__1 = null;
  this.T12__f__2 = null;
  this.T12__f__3 = null;
  this.T12__f__4 = null;
  this.T12__f__5 = null;
  this.T12__f__6 = null;
  this.T12__f__7 = null;
  this.T12__f__8 = null;
  this.T12__f__9 = null;
  this.T12__f__10 = null;
  this.T12__f__11 = null;
  this.T12__f__12 = null;
  this.T12__f__1 = _1;
  this.T12__f__2 = _2;
  this.T12__f__3 = _3;
  this.T12__f__4 = _4;
  this.T12__f__5 = _5;
  this.T12__f__6 = _6;
  this.T12__f__7 = _7;
  this.T12__f__8 = _8;
  this.T12__f__9 = _9;
  this.T12__f__10 = _10;
  this.T12__f__11 = _11;
  this.T12__f__12 = _12
}
$c_T12.prototype = new $h_O();
$c_T12.prototype.constructor = $c_T12;
/** @constructor */
function $h_T12() {
  /*<skip>*/
}
$h_T12.prototype = $c_T12.prototype;
$c_T12.prototype.productArity__I = (function() {
  return 12
});
$c_T12.prototype.productElement__I__O = (function(n) {
  return $f_s_Product12__productElement__I__O(this, n)
});
$c_T12.prototype.toString__T = (function() {
  return (((((((((((((((((((((((("(" + this.T12__f__1) + ",") + this.T12__f__2) + ",") + this.T12__f__3) + ",") + this.T12__f__4) + ",") + this.T12__f__5) + ",") + this.T12__f__6) + ",") + this.T12__f__7) + ",") + this.T12__f__8) + ",") + this.T12__f__9) + ",") + this.T12__f__10) + ",") + this.T12__f__11) + ",") + this.T12__f__12) + ")")
});
$c_T12.prototype.productPrefix__T = (function() {
  return "Tuple12"
});
$c_T12.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T12.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T12.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T12)) {
    var Tuple12$1 = $as_T12(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__1, Tuple12$1.T12__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__2, Tuple12$1.T12__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__3, Tuple12$1.T12__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__4, Tuple12$1.T12__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__5, Tuple12$1.T12__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__6, Tuple12$1.T12__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__7, Tuple12$1.T12__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__8, Tuple12$1.T12__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__9, Tuple12$1.T12__f__9))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__10, Tuple12$1.T12__f__10) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__11, Tuple12$1.T12__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__12, Tuple12$1.T12__f__12)))))
  } else {
    return false
  }
});
function $as_T12(obj) {
  return (((obj instanceof $c_T12) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple12"))
}
function $isArrayOf_T12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T12)))
}
function $asArrayOf_T12(obj, depth) {
  return (($isArrayOf_T12(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple12;", depth))
}
var $d_T12 = new $TypeData().initClass({
  T12: 0
}, false, "scala.Tuple12", {
  T12: 1,
  O: 1,
  s_Product12: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T12.prototype.$classData = $d_T12;
/** @constructor */
function $c_T13(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13) {
  this.T13__f__1 = null;
  this.T13__f__2 = null;
  this.T13__f__3 = null;
  this.T13__f__4 = null;
  this.T13__f__5 = null;
  this.T13__f__6 = null;
  this.T13__f__7 = null;
  this.T13__f__8 = null;
  this.T13__f__9 = null;
  this.T13__f__10 = null;
  this.T13__f__11 = null;
  this.T13__f__12 = null;
  this.T13__f__13 = null;
  this.T13__f__1 = _1;
  this.T13__f__2 = _2;
  this.T13__f__3 = _3;
  this.T13__f__4 = _4;
  this.T13__f__5 = _5;
  this.T13__f__6 = _6;
  this.T13__f__7 = _7;
  this.T13__f__8 = _8;
  this.T13__f__9 = _9;
  this.T13__f__10 = _10;
  this.T13__f__11 = _11;
  this.T13__f__12 = _12;
  this.T13__f__13 = _13
}
$c_T13.prototype = new $h_O();
$c_T13.prototype.constructor = $c_T13;
/** @constructor */
function $h_T13() {
  /*<skip>*/
}
$h_T13.prototype = $c_T13.prototype;
$c_T13.prototype.productArity__I = (function() {
  return 13
});
$c_T13.prototype.productElement__I__O = (function(n) {
  return $f_s_Product13__productElement__I__O(this, n)
});
$c_T13.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((("(" + this.T13__f__1) + ",") + this.T13__f__2) + ",") + this.T13__f__3) + ",") + this.T13__f__4) + ",") + this.T13__f__5) + ",") + this.T13__f__6) + ",") + this.T13__f__7) + ",") + this.T13__f__8) + ",") + this.T13__f__9) + ",") + this.T13__f__10) + ",") + this.T13__f__11) + ",") + this.T13__f__12) + ",") + this.T13__f__13) + ")")
});
$c_T13.prototype.productPrefix__T = (function() {
  return "Tuple13"
});
$c_T13.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T13.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T13.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T13)) {
    var Tuple13$1 = $as_T13(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__1, Tuple13$1.T13__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__2, Tuple13$1.T13__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__3, Tuple13$1.T13__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__4, Tuple13$1.T13__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__5, Tuple13$1.T13__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__6, Tuple13$1.T13__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__7, Tuple13$1.T13__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__8, Tuple13$1.T13__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__9, Tuple13$1.T13__f__9))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__10, Tuple13$1.T13__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__11, Tuple13$1.T13__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__12, Tuple13$1.T13__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__13, Tuple13$1.T13__f__13)))))
  } else {
    return false
  }
});
function $as_T13(obj) {
  return (((obj instanceof $c_T13) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple13"))
}
function $isArrayOf_T13(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T13)))
}
function $asArrayOf_T13(obj, depth) {
  return (($isArrayOf_T13(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple13;", depth))
}
var $d_T13 = new $TypeData().initClass({
  T13: 0
}, false, "scala.Tuple13", {
  T13: 1,
  O: 1,
  s_Product13: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T13.prototype.$classData = $d_T13;
/** @constructor */
function $c_T14(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14) {
  this.T14__f__1 = null;
  this.T14__f__2 = null;
  this.T14__f__3 = null;
  this.T14__f__4 = null;
  this.T14__f__5 = null;
  this.T14__f__6 = null;
  this.T14__f__7 = null;
  this.T14__f__8 = null;
  this.T14__f__9 = null;
  this.T14__f__10 = null;
  this.T14__f__11 = null;
  this.T14__f__12 = null;
  this.T14__f__13 = null;
  this.T14__f__14 = null;
  this.T14__f__1 = _1;
  this.T14__f__2 = _2;
  this.T14__f__3 = _3;
  this.T14__f__4 = _4;
  this.T14__f__5 = _5;
  this.T14__f__6 = _6;
  this.T14__f__7 = _7;
  this.T14__f__8 = _8;
  this.T14__f__9 = _9;
  this.T14__f__10 = _10;
  this.T14__f__11 = _11;
  this.T14__f__12 = _12;
  this.T14__f__13 = _13;
  this.T14__f__14 = _14
}
$c_T14.prototype = new $h_O();
$c_T14.prototype.constructor = $c_T14;
/** @constructor */
function $h_T14() {
  /*<skip>*/
}
$h_T14.prototype = $c_T14.prototype;
$c_T14.prototype.productArity__I = (function() {
  return 14
});
$c_T14.prototype.productElement__I__O = (function(n) {
  return $f_s_Product14__productElement__I__O(this, n)
});
$c_T14.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((("(" + this.T14__f__1) + ",") + this.T14__f__2) + ",") + this.T14__f__3) + ",") + this.T14__f__4) + ",") + this.T14__f__5) + ",") + this.T14__f__6) + ",") + this.T14__f__7) + ",") + this.T14__f__8) + ",") + this.T14__f__9) + ",") + this.T14__f__10) + ",") + this.T14__f__11) + ",") + this.T14__f__12) + ",") + this.T14__f__13) + ",") + this.T14__f__14) + ")")
});
$c_T14.prototype.productPrefix__T = (function() {
  return "Tuple14"
});
$c_T14.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T14.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T14.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T14)) {
    var Tuple14$1 = $as_T14(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__1, Tuple14$1.T14__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__2, Tuple14$1.T14__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__3, Tuple14$1.T14__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__4, Tuple14$1.T14__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__5, Tuple14$1.T14__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__6, Tuple14$1.T14__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__7, Tuple14$1.T14__f__7)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__8, Tuple14$1.T14__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__9, Tuple14$1.T14__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__10, Tuple14$1.T14__f__10))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__11, Tuple14$1.T14__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__12, Tuple14$1.T14__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__13, Tuple14$1.T14__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__14, Tuple14$1.T14__f__14)))))
  } else {
    return false
  }
});
function $as_T14(obj) {
  return (((obj instanceof $c_T14) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple14"))
}
function $isArrayOf_T14(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T14)))
}
function $asArrayOf_T14(obj, depth) {
  return (($isArrayOf_T14(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple14;", depth))
}
var $d_T14 = new $TypeData().initClass({
  T14: 0
}, false, "scala.Tuple14", {
  T14: 1,
  O: 1,
  s_Product14: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T14.prototype.$classData = $d_T14;
/** @constructor */
function $c_T15(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15) {
  this.T15__f__1 = null;
  this.T15__f__2 = null;
  this.T15__f__3 = null;
  this.T15__f__4 = null;
  this.T15__f__5 = null;
  this.T15__f__6 = null;
  this.T15__f__7 = null;
  this.T15__f__8 = null;
  this.T15__f__9 = null;
  this.T15__f__10 = null;
  this.T15__f__11 = null;
  this.T15__f__12 = null;
  this.T15__f__13 = null;
  this.T15__f__14 = null;
  this.T15__f__15 = null;
  this.T15__f__1 = _1;
  this.T15__f__2 = _2;
  this.T15__f__3 = _3;
  this.T15__f__4 = _4;
  this.T15__f__5 = _5;
  this.T15__f__6 = _6;
  this.T15__f__7 = _7;
  this.T15__f__8 = _8;
  this.T15__f__9 = _9;
  this.T15__f__10 = _10;
  this.T15__f__11 = _11;
  this.T15__f__12 = _12;
  this.T15__f__13 = _13;
  this.T15__f__14 = _14;
  this.T15__f__15 = _15
}
$c_T15.prototype = new $h_O();
$c_T15.prototype.constructor = $c_T15;
/** @constructor */
function $h_T15() {
  /*<skip>*/
}
$h_T15.prototype = $c_T15.prototype;
$c_T15.prototype.productArity__I = (function() {
  return 15
});
$c_T15.prototype.productElement__I__O = (function(n) {
  return $f_s_Product15__productElement__I__O(this, n)
});
$c_T15.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((("(" + this.T15__f__1) + ",") + this.T15__f__2) + ",") + this.T15__f__3) + ",") + this.T15__f__4) + ",") + this.T15__f__5) + ",") + this.T15__f__6) + ",") + this.T15__f__7) + ",") + this.T15__f__8) + ",") + this.T15__f__9) + ",") + this.T15__f__10) + ",") + this.T15__f__11) + ",") + this.T15__f__12) + ",") + this.T15__f__13) + ",") + this.T15__f__14) + ",") + this.T15__f__15) + ")")
});
$c_T15.prototype.productPrefix__T = (function() {
  return "Tuple15"
});
$c_T15.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T15.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T15.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T15)) {
    var Tuple15$1 = $as_T15(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__1, Tuple15$1.T15__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__2, Tuple15$1.T15__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__3, Tuple15$1.T15__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__4, Tuple15$1.T15__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__5, Tuple15$1.T15__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__6, Tuple15$1.T15__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__7, Tuple15$1.T15__f__7)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__8, Tuple15$1.T15__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__9, Tuple15$1.T15__f__9)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__10, Tuple15$1.T15__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__11, Tuple15$1.T15__f__11))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__12, Tuple15$1.T15__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__13, Tuple15$1.T15__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__14, Tuple15$1.T15__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__15, Tuple15$1.T15__f__15)))))
  } else {
    return false
  }
});
function $as_T15(obj) {
  return (((obj instanceof $c_T15) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple15"))
}
function $isArrayOf_T15(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T15)))
}
function $asArrayOf_T15(obj, depth) {
  return (($isArrayOf_T15(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple15;", depth))
}
var $d_T15 = new $TypeData().initClass({
  T15: 0
}, false, "scala.Tuple15", {
  T15: 1,
  O: 1,
  s_Product15: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T15.prototype.$classData = $d_T15;
/** @constructor */
function $c_T16(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16) {
  this.T16__f__1 = null;
  this.T16__f__2 = null;
  this.T16__f__3 = null;
  this.T16__f__4 = null;
  this.T16__f__5 = null;
  this.T16__f__6 = null;
  this.T16__f__7 = null;
  this.T16__f__8 = null;
  this.T16__f__9 = null;
  this.T16__f__10 = null;
  this.T16__f__11 = null;
  this.T16__f__12 = null;
  this.T16__f__13 = null;
  this.T16__f__14 = null;
  this.T16__f__15 = null;
  this.T16__f__16 = null;
  this.T16__f__1 = _1;
  this.T16__f__2 = _2;
  this.T16__f__3 = _3;
  this.T16__f__4 = _4;
  this.T16__f__5 = _5;
  this.T16__f__6 = _6;
  this.T16__f__7 = _7;
  this.T16__f__8 = _8;
  this.T16__f__9 = _9;
  this.T16__f__10 = _10;
  this.T16__f__11 = _11;
  this.T16__f__12 = _12;
  this.T16__f__13 = _13;
  this.T16__f__14 = _14;
  this.T16__f__15 = _15;
  this.T16__f__16 = _16
}
$c_T16.prototype = new $h_O();
$c_T16.prototype.constructor = $c_T16;
/** @constructor */
function $h_T16() {
  /*<skip>*/
}
$h_T16.prototype = $c_T16.prototype;
$c_T16.prototype.productArity__I = (function() {
  return 16
});
$c_T16.prototype.productElement__I__O = (function(n) {
  return $f_s_Product16__productElement__I__O(this, n)
});
$c_T16.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((("(" + this.T16__f__1) + ",") + this.T16__f__2) + ",") + this.T16__f__3) + ",") + this.T16__f__4) + ",") + this.T16__f__5) + ",") + this.T16__f__6) + ",") + this.T16__f__7) + ",") + this.T16__f__8) + ",") + this.T16__f__9) + ",") + this.T16__f__10) + ",") + this.T16__f__11) + ",") + this.T16__f__12) + ",") + this.T16__f__13) + ",") + this.T16__f__14) + ",") + this.T16__f__15) + ",") + this.T16__f__16) + ")")
});
$c_T16.prototype.productPrefix__T = (function() {
  return "Tuple16"
});
$c_T16.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T16.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T16.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T16)) {
    var Tuple16$1 = $as_T16(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__1, Tuple16$1.T16__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__2, Tuple16$1.T16__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__3, Tuple16$1.T16__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__4, Tuple16$1.T16__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__5, Tuple16$1.T16__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__6, Tuple16$1.T16__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__7, Tuple16$1.T16__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__8, Tuple16$1.T16__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__9, Tuple16$1.T16__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__10, Tuple16$1.T16__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__11, Tuple16$1.T16__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__12, Tuple16$1.T16__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__13, Tuple16$1.T16__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__14, Tuple16$1.T16__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__15, Tuple16$1.T16__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__16, Tuple16$1.T16__f__16)))))
  } else {
    return false
  }
});
function $as_T16(obj) {
  return (((obj instanceof $c_T16) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple16"))
}
function $isArrayOf_T16(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T16)))
}
function $asArrayOf_T16(obj, depth) {
  return (($isArrayOf_T16(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple16;", depth))
}
var $d_T16 = new $TypeData().initClass({
  T16: 0
}, false, "scala.Tuple16", {
  T16: 1,
  O: 1,
  s_Product16: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T16.prototype.$classData = $d_T16;
/** @constructor */
function $c_T17(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17) {
  this.T17__f__1 = null;
  this.T17__f__2 = null;
  this.T17__f__3 = null;
  this.T17__f__4 = null;
  this.T17__f__5 = null;
  this.T17__f__6 = null;
  this.T17__f__7 = null;
  this.T17__f__8 = null;
  this.T17__f__9 = null;
  this.T17__f__10 = null;
  this.T17__f__11 = null;
  this.T17__f__12 = null;
  this.T17__f__13 = null;
  this.T17__f__14 = null;
  this.T17__f__15 = null;
  this.T17__f__16 = null;
  this.T17__f__17 = null;
  this.T17__f__1 = _1;
  this.T17__f__2 = _2;
  this.T17__f__3 = _3;
  this.T17__f__4 = _4;
  this.T17__f__5 = _5;
  this.T17__f__6 = _6;
  this.T17__f__7 = _7;
  this.T17__f__8 = _8;
  this.T17__f__9 = _9;
  this.T17__f__10 = _10;
  this.T17__f__11 = _11;
  this.T17__f__12 = _12;
  this.T17__f__13 = _13;
  this.T17__f__14 = _14;
  this.T17__f__15 = _15;
  this.T17__f__16 = _16;
  this.T17__f__17 = _17
}
$c_T17.prototype = new $h_O();
$c_T17.prototype.constructor = $c_T17;
/** @constructor */
function $h_T17() {
  /*<skip>*/
}
$h_T17.prototype = $c_T17.prototype;
$c_T17.prototype.productArity__I = (function() {
  return 17
});
$c_T17.prototype.productElement__I__O = (function(n) {
  return $f_s_Product17__productElement__I__O(this, n)
});
$c_T17.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((("(" + this.T17__f__1) + ",") + this.T17__f__2) + ",") + this.T17__f__3) + ",") + this.T17__f__4) + ",") + this.T17__f__5) + ",") + this.T17__f__6) + ",") + this.T17__f__7) + ",") + this.T17__f__8) + ",") + this.T17__f__9) + ",") + this.T17__f__10) + ",") + this.T17__f__11) + ",") + this.T17__f__12) + ",") + this.T17__f__13) + ",") + this.T17__f__14) + ",") + this.T17__f__15) + ",") + this.T17__f__16) + ",") + this.T17__f__17) + ")")
});
$c_T17.prototype.productPrefix__T = (function() {
  return "Tuple17"
});
$c_T17.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T17.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T17.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T17)) {
    var Tuple17$1 = $as_T17(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__1, Tuple17$1.T17__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__2, Tuple17$1.T17__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__3, Tuple17$1.T17__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__4, Tuple17$1.T17__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__5, Tuple17$1.T17__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__6, Tuple17$1.T17__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__7, Tuple17$1.T17__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__8, Tuple17$1.T17__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__9, Tuple17$1.T17__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__10, Tuple17$1.T17__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__11, Tuple17$1.T17__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__12, Tuple17$1.T17__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__13, Tuple17$1.T17__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__14, Tuple17$1.T17__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__15, Tuple17$1.T17__f__15) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__16, Tuple17$1.T17__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__17, Tuple17$1.T17__f__17))))))
  } else {
    return false
  }
});
function $as_T17(obj) {
  return (((obj instanceof $c_T17) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple17"))
}
function $isArrayOf_T17(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T17)))
}
function $asArrayOf_T17(obj, depth) {
  return (($isArrayOf_T17(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple17;", depth))
}
var $d_T17 = new $TypeData().initClass({
  T17: 0
}, false, "scala.Tuple17", {
  T17: 1,
  O: 1,
  s_Product17: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T17.prototype.$classData = $d_T17;
/** @constructor */
function $c_T18(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18) {
  this.T18__f__1 = null;
  this.T18__f__2 = null;
  this.T18__f__3 = null;
  this.T18__f__4 = null;
  this.T18__f__5 = null;
  this.T18__f__6 = null;
  this.T18__f__7 = null;
  this.T18__f__8 = null;
  this.T18__f__9 = null;
  this.T18__f__10 = null;
  this.T18__f__11 = null;
  this.T18__f__12 = null;
  this.T18__f__13 = null;
  this.T18__f__14 = null;
  this.T18__f__15 = null;
  this.T18__f__16 = null;
  this.T18__f__17 = null;
  this.T18__f__18 = null;
  this.T18__f__1 = _1;
  this.T18__f__2 = _2;
  this.T18__f__3 = _3;
  this.T18__f__4 = _4;
  this.T18__f__5 = _5;
  this.T18__f__6 = _6;
  this.T18__f__7 = _7;
  this.T18__f__8 = _8;
  this.T18__f__9 = _9;
  this.T18__f__10 = _10;
  this.T18__f__11 = _11;
  this.T18__f__12 = _12;
  this.T18__f__13 = _13;
  this.T18__f__14 = _14;
  this.T18__f__15 = _15;
  this.T18__f__16 = _16;
  this.T18__f__17 = _17;
  this.T18__f__18 = _18
}
$c_T18.prototype = new $h_O();
$c_T18.prototype.constructor = $c_T18;
/** @constructor */
function $h_T18() {
  /*<skip>*/
}
$h_T18.prototype = $c_T18.prototype;
$c_T18.prototype.productArity__I = (function() {
  return 18
});
$c_T18.prototype.productElement__I__O = (function(n) {
  return $f_s_Product18__productElement__I__O(this, n)
});
$c_T18.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((("(" + this.T18__f__1) + ",") + this.T18__f__2) + ",") + this.T18__f__3) + ",") + this.T18__f__4) + ",") + this.T18__f__5) + ",") + this.T18__f__6) + ",") + this.T18__f__7) + ",") + this.T18__f__8) + ",") + this.T18__f__9) + ",") + this.T18__f__10) + ",") + this.T18__f__11) + ",") + this.T18__f__12) + ",") + this.T18__f__13) + ",") + this.T18__f__14) + ",") + this.T18__f__15) + ",") + this.T18__f__16) + ",") + this.T18__f__17) + ",") + this.T18__f__18) + ")")
});
$c_T18.prototype.productPrefix__T = (function() {
  return "Tuple18"
});
$c_T18.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T18.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T18.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T18)) {
    var Tuple18$1 = $as_T18(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__1, Tuple18$1.T18__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__2, Tuple18$1.T18__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__3, Tuple18$1.T18__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__4, Tuple18$1.T18__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__5, Tuple18$1.T18__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__6, Tuple18$1.T18__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__7, Tuple18$1.T18__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__8, Tuple18$1.T18__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__9, Tuple18$1.T18__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__10, Tuple18$1.T18__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__11, Tuple18$1.T18__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__12, Tuple18$1.T18__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__13, Tuple18$1.T18__f__13))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__14, Tuple18$1.T18__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__15, Tuple18$1.T18__f__15)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__16, Tuple18$1.T18__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__17, Tuple18$1.T18__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__18, Tuple18$1.T18__f__18))))))
  } else {
    return false
  }
});
function $as_T18(obj) {
  return (((obj instanceof $c_T18) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple18"))
}
function $isArrayOf_T18(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T18)))
}
function $asArrayOf_T18(obj, depth) {
  return (($isArrayOf_T18(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple18;", depth))
}
var $d_T18 = new $TypeData().initClass({
  T18: 0
}, false, "scala.Tuple18", {
  T18: 1,
  O: 1,
  s_Product18: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T18.prototype.$classData = $d_T18;
/** @constructor */
function $c_T19(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19) {
  this.T19__f__1 = null;
  this.T19__f__2 = null;
  this.T19__f__3 = null;
  this.T19__f__4 = null;
  this.T19__f__5 = null;
  this.T19__f__6 = null;
  this.T19__f__7 = null;
  this.T19__f__8 = null;
  this.T19__f__9 = null;
  this.T19__f__10 = null;
  this.T19__f__11 = null;
  this.T19__f__12 = null;
  this.T19__f__13 = null;
  this.T19__f__14 = null;
  this.T19__f__15 = null;
  this.T19__f__16 = null;
  this.T19__f__17 = null;
  this.T19__f__18 = null;
  this.T19__f__19 = null;
  this.T19__f__1 = _1;
  this.T19__f__2 = _2;
  this.T19__f__3 = _3;
  this.T19__f__4 = _4;
  this.T19__f__5 = _5;
  this.T19__f__6 = _6;
  this.T19__f__7 = _7;
  this.T19__f__8 = _8;
  this.T19__f__9 = _9;
  this.T19__f__10 = _10;
  this.T19__f__11 = _11;
  this.T19__f__12 = _12;
  this.T19__f__13 = _13;
  this.T19__f__14 = _14;
  this.T19__f__15 = _15;
  this.T19__f__16 = _16;
  this.T19__f__17 = _17;
  this.T19__f__18 = _18;
  this.T19__f__19 = _19
}
$c_T19.prototype = new $h_O();
$c_T19.prototype.constructor = $c_T19;
/** @constructor */
function $h_T19() {
  /*<skip>*/
}
$h_T19.prototype = $c_T19.prototype;
$c_T19.prototype.productArity__I = (function() {
  return 19
});
$c_T19.prototype.productElement__I__O = (function(n) {
  return $f_s_Product19__productElement__I__O(this, n)
});
$c_T19.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((("(" + this.T19__f__1) + ",") + this.T19__f__2) + ",") + this.T19__f__3) + ",") + this.T19__f__4) + ",") + this.T19__f__5) + ",") + this.T19__f__6) + ",") + this.T19__f__7) + ",") + this.T19__f__8) + ",") + this.T19__f__9) + ",") + this.T19__f__10) + ",") + this.T19__f__11) + ",") + this.T19__f__12) + ",") + this.T19__f__13) + ",") + this.T19__f__14) + ",") + this.T19__f__15) + ",") + this.T19__f__16) + ",") + this.T19__f__17) + ",") + this.T19__f__18) + ",") + this.T19__f__19) + ")")
});
$c_T19.prototype.productPrefix__T = (function() {
  return "Tuple19"
});
$c_T19.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T19.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T19.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T19)) {
    var Tuple19$1 = $as_T19(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__1, Tuple19$1.T19__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__2, Tuple19$1.T19__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__3, Tuple19$1.T19__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__4, Tuple19$1.T19__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__5, Tuple19$1.T19__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__6, Tuple19$1.T19__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__7, Tuple19$1.T19__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__8, Tuple19$1.T19__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__9, Tuple19$1.T19__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__10, Tuple19$1.T19__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__11, Tuple19$1.T19__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__12, Tuple19$1.T19__f__12) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__13, Tuple19$1.T19__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__14, Tuple19$1.T19__f__14)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__15, Tuple19$1.T19__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__16, Tuple19$1.T19__f__16)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__17, Tuple19$1.T19__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__18, Tuple19$1.T19__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__19, Tuple19$1.T19__f__19))))))
  } else {
    return false
  }
});
function $as_T19(obj) {
  return (((obj instanceof $c_T19) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple19"))
}
function $isArrayOf_T19(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T19)))
}
function $asArrayOf_T19(obj, depth) {
  return (($isArrayOf_T19(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple19;", depth))
}
var $d_T19 = new $TypeData().initClass({
  T19: 0
}, false, "scala.Tuple19", {
  T19: 1,
  O: 1,
  s_Product19: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T19.prototype.$classData = $d_T19;
function $ct_T2__O__O__($thiz, _1, _2) {
  $thiz.T2__f__1 = _1;
  $thiz.T2__f__2 = _2;
  return $thiz
}
/** @constructor */
function $c_T2() {
  this.T2__f__1 = null;
  this.T2__f__2 = null
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
  /*<skip>*/
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n)
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")")
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2"
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), Tuple2$1._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), Tuple2$1._2__O()))
  } else {
    return false
  }
});
$c_T2.prototype._1$mcC$sp__C = (function() {
  return $uC(this._1__O())
});
$c_T2.prototype._2$mcI$sp__I = (function() {
  return $uI(this._2__O())
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"))
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)))
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth))
}
var $d_T2 = new $TypeData().initClass({
  T2: 0
}, false, "scala.Tuple2", {
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2.prototype.$classData = $d_T2;
/** @constructor */
function $c_T20(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20) {
  this.T20__f__1 = null;
  this.T20__f__2 = null;
  this.T20__f__3 = null;
  this.T20__f__4 = null;
  this.T20__f__5 = null;
  this.T20__f__6 = null;
  this.T20__f__7 = null;
  this.T20__f__8 = null;
  this.T20__f__9 = null;
  this.T20__f__10 = null;
  this.T20__f__11 = null;
  this.T20__f__12 = null;
  this.T20__f__13 = null;
  this.T20__f__14 = null;
  this.T20__f__15 = null;
  this.T20__f__16 = null;
  this.T20__f__17 = null;
  this.T20__f__18 = null;
  this.T20__f__19 = null;
  this.T20__f__20 = null;
  this.T20__f__1 = _1;
  this.T20__f__2 = _2;
  this.T20__f__3 = _3;
  this.T20__f__4 = _4;
  this.T20__f__5 = _5;
  this.T20__f__6 = _6;
  this.T20__f__7 = _7;
  this.T20__f__8 = _8;
  this.T20__f__9 = _9;
  this.T20__f__10 = _10;
  this.T20__f__11 = _11;
  this.T20__f__12 = _12;
  this.T20__f__13 = _13;
  this.T20__f__14 = _14;
  this.T20__f__15 = _15;
  this.T20__f__16 = _16;
  this.T20__f__17 = _17;
  this.T20__f__18 = _18;
  this.T20__f__19 = _19;
  this.T20__f__20 = _20
}
$c_T20.prototype = new $h_O();
$c_T20.prototype.constructor = $c_T20;
/** @constructor */
function $h_T20() {
  /*<skip>*/
}
$h_T20.prototype = $c_T20.prototype;
$c_T20.prototype.productArity__I = (function() {
  return 20
});
$c_T20.prototype.productElement__I__O = (function(n) {
  return $f_s_Product20__productElement__I__O(this, n)
});
$c_T20.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((("(" + this.T20__f__1) + ",") + this.T20__f__2) + ",") + this.T20__f__3) + ",") + this.T20__f__4) + ",") + this.T20__f__5) + ",") + this.T20__f__6) + ",") + this.T20__f__7) + ",") + this.T20__f__8) + ",") + this.T20__f__9) + ",") + this.T20__f__10) + ",") + this.T20__f__11) + ",") + this.T20__f__12) + ",") + this.T20__f__13) + ",") + this.T20__f__14) + ",") + this.T20__f__15) + ",") + this.T20__f__16) + ",") + this.T20__f__17) + ",") + this.T20__f__18) + ",") + this.T20__f__19) + ",") + this.T20__f__20) + ")")
});
$c_T20.prototype.productPrefix__T = (function() {
  return "Tuple20"
});
$c_T20.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T20.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T20.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T20)) {
    var Tuple20$1 = $as_T20(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__1, Tuple20$1.T20__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__2, Tuple20$1.T20__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__3, Tuple20$1.T20__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__4, Tuple20$1.T20__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__5, Tuple20$1.T20__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__6, Tuple20$1.T20__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__7, Tuple20$1.T20__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__8, Tuple20$1.T20__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__9, Tuple20$1.T20__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__10, Tuple20$1.T20__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__11, Tuple20$1.T20__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__12, Tuple20$1.T20__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__13, Tuple20$1.T20__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__14, Tuple20$1.T20__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__15, Tuple20$1.T20__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__16, Tuple20$1.T20__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__17, Tuple20$1.T20__f__17)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__18, Tuple20$1.T20__f__18) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__19, Tuple20$1.T20__f__19) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__20, Tuple20$1.T20__f__20))))))
  } else {
    return false
  }
});
function $as_T20(obj) {
  return (((obj instanceof $c_T20) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple20"))
}
function $isArrayOf_T20(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T20)))
}
function $asArrayOf_T20(obj, depth) {
  return (($isArrayOf_T20(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple20;", depth))
}
var $d_T20 = new $TypeData().initClass({
  T20: 0
}, false, "scala.Tuple20", {
  T20: 1,
  O: 1,
  s_Product20: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T20.prototype.$classData = $d_T20;
/** @constructor */
function $c_T21(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21) {
  this.T21__f__1 = null;
  this.T21__f__2 = null;
  this.T21__f__3 = null;
  this.T21__f__4 = null;
  this.T21__f__5 = null;
  this.T21__f__6 = null;
  this.T21__f__7 = null;
  this.T21__f__8 = null;
  this.T21__f__9 = null;
  this.T21__f__10 = null;
  this.T21__f__11 = null;
  this.T21__f__12 = null;
  this.T21__f__13 = null;
  this.T21__f__14 = null;
  this.T21__f__15 = null;
  this.T21__f__16 = null;
  this.T21__f__17 = null;
  this.T21__f__18 = null;
  this.T21__f__19 = null;
  this.T21__f__20 = null;
  this.T21__f__21 = null;
  this.T21__f__1 = _1;
  this.T21__f__2 = _2;
  this.T21__f__3 = _3;
  this.T21__f__4 = _4;
  this.T21__f__5 = _5;
  this.T21__f__6 = _6;
  this.T21__f__7 = _7;
  this.T21__f__8 = _8;
  this.T21__f__9 = _9;
  this.T21__f__10 = _10;
  this.T21__f__11 = _11;
  this.T21__f__12 = _12;
  this.T21__f__13 = _13;
  this.T21__f__14 = _14;
  this.T21__f__15 = _15;
  this.T21__f__16 = _16;
  this.T21__f__17 = _17;
  this.T21__f__18 = _18;
  this.T21__f__19 = _19;
  this.T21__f__20 = _20;
  this.T21__f__21 = _21
}
$c_T21.prototype = new $h_O();
$c_T21.prototype.constructor = $c_T21;
/** @constructor */
function $h_T21() {
  /*<skip>*/
}
$h_T21.prototype = $c_T21.prototype;
$c_T21.prototype.productArity__I = (function() {
  return 21
});
$c_T21.prototype.productElement__I__O = (function(n) {
  return $f_s_Product21__productElement__I__O(this, n)
});
$c_T21.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((("(" + this.T21__f__1) + ",") + this.T21__f__2) + ",") + this.T21__f__3) + ",") + this.T21__f__4) + ",") + this.T21__f__5) + ",") + this.T21__f__6) + ",") + this.T21__f__7) + ",") + this.T21__f__8) + ",") + this.T21__f__9) + ",") + this.T21__f__10) + ",") + this.T21__f__11) + ",") + this.T21__f__12) + ",") + this.T21__f__13) + ",") + this.T21__f__14) + ",") + this.T21__f__15) + ",") + this.T21__f__16) + ",") + this.T21__f__17) + ",") + this.T21__f__18) + ",") + this.T21__f__19) + ",") + this.T21__f__20) + ",") + this.T21__f__21) + ")")
});
$c_T21.prototype.productPrefix__T = (function() {
  return "Tuple21"
});
$c_T21.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T21.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T21.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T21)) {
    var Tuple21$1 = $as_T21(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__1, Tuple21$1.T21__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__2, Tuple21$1.T21__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__3, Tuple21$1.T21__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__4, Tuple21$1.T21__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__5, Tuple21$1.T21__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__6, Tuple21$1.T21__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__7, Tuple21$1.T21__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__8, Tuple21$1.T21__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__9, Tuple21$1.T21__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__10, Tuple21$1.T21__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__11, Tuple21$1.T21__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__12, Tuple21$1.T21__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__13, Tuple21$1.T21__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__14, Tuple21$1.T21__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__15, Tuple21$1.T21__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__16, Tuple21$1.T21__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__17, Tuple21$1.T21__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__18, Tuple21$1.T21__f__18))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__19, Tuple21$1.T21__f__19) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__20, Tuple21$1.T21__f__20) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__21, Tuple21$1.T21__f__21))))))
  } else {
    return false
  }
});
function $as_T21(obj) {
  return (((obj instanceof $c_T21) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple21"))
}
function $isArrayOf_T21(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T21)))
}
function $asArrayOf_T21(obj, depth) {
  return (($isArrayOf_T21(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple21;", depth))
}
var $d_T21 = new $TypeData().initClass({
  T21: 0
}, false, "scala.Tuple21", {
  T21: 1,
  O: 1,
  s_Product21: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T21.prototype.$classData = $d_T21;
/** @constructor */
function $c_T22(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22) {
  this.T22__f__1 = null;
  this.T22__f__2 = null;
  this.T22__f__3 = null;
  this.T22__f__4 = null;
  this.T22__f__5 = null;
  this.T22__f__6 = null;
  this.T22__f__7 = null;
  this.T22__f__8 = null;
  this.T22__f__9 = null;
  this.T22__f__10 = null;
  this.T22__f__11 = null;
  this.T22__f__12 = null;
  this.T22__f__13 = null;
  this.T22__f__14 = null;
  this.T22__f__15 = null;
  this.T22__f__16 = null;
  this.T22__f__17 = null;
  this.T22__f__18 = null;
  this.T22__f__19 = null;
  this.T22__f__20 = null;
  this.T22__f__21 = null;
  this.T22__f__22 = null;
  this.T22__f__1 = _1;
  this.T22__f__2 = _2;
  this.T22__f__3 = _3;
  this.T22__f__4 = _4;
  this.T22__f__5 = _5;
  this.T22__f__6 = _6;
  this.T22__f__7 = _7;
  this.T22__f__8 = _8;
  this.T22__f__9 = _9;
  this.T22__f__10 = _10;
  this.T22__f__11 = _11;
  this.T22__f__12 = _12;
  this.T22__f__13 = _13;
  this.T22__f__14 = _14;
  this.T22__f__15 = _15;
  this.T22__f__16 = _16;
  this.T22__f__17 = _17;
  this.T22__f__18 = _18;
  this.T22__f__19 = _19;
  this.T22__f__20 = _20;
  this.T22__f__21 = _21;
  this.T22__f__22 = _22
}
$c_T22.prototype = new $h_O();
$c_T22.prototype.constructor = $c_T22;
/** @constructor */
function $h_T22() {
  /*<skip>*/
}
$h_T22.prototype = $c_T22.prototype;
$c_T22.prototype.productArity__I = (function() {
  return 22
});
$c_T22.prototype.productElement__I__O = (function(n) {
  return $f_s_Product22__productElement__I__O(this, n)
});
$c_T22.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((((("(" + this.T22__f__1) + ",") + this.T22__f__2) + ",") + this.T22__f__3) + ",") + this.T22__f__4) + ",") + this.T22__f__5) + ",") + this.T22__f__6) + ",") + this.T22__f__7) + ",") + this.T22__f__8) + ",") + this.T22__f__9) + ",") + this.T22__f__10) + ",") + this.T22__f__11) + ",") + this.T22__f__12) + ",") + this.T22__f__13) + ",") + this.T22__f__14) + ",") + this.T22__f__15) + ",") + this.T22__f__16) + ",") + this.T22__f__17) + ",") + this.T22__f__18) + ",") + this.T22__f__19) + ",") + this.T22__f__20) + ",") + this.T22__f__21) + ",") + this.T22__f__22) + ")")
});
$c_T22.prototype.productPrefix__T = (function() {
  return "Tuple22"
});
$c_T22.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T22.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T22.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T22)) {
    var Tuple22$1 = $as_T22(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__1, Tuple22$1.T22__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__2, Tuple22$1.T22__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__3, Tuple22$1.T22__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__4, Tuple22$1.T22__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__5, Tuple22$1.T22__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__6, Tuple22$1.T22__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__7, Tuple22$1.T22__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__8, Tuple22$1.T22__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__9, Tuple22$1.T22__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__10, Tuple22$1.T22__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__11, Tuple22$1.T22__f__11))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__12, Tuple22$1.T22__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__13, Tuple22$1.T22__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__14, Tuple22$1.T22__f__14) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__15, Tuple22$1.T22__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__16, Tuple22$1.T22__f__16)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__17, Tuple22$1.T22__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__18, Tuple22$1.T22__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__19, Tuple22$1.T22__f__19))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__20, Tuple22$1.T22__f__20) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__21, Tuple22$1.T22__f__21) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__22, Tuple22$1.T22__f__22))))))
  } else {
    return false
  }
});
function $as_T22(obj) {
  return (((obj instanceof $c_T22) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple22"))
}
function $isArrayOf_T22(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T22)))
}
function $asArrayOf_T22(obj, depth) {
  return (($isArrayOf_T22(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple22;", depth))
}
var $d_T22 = new $TypeData().initClass({
  T22: 0
}, false, "scala.Tuple22", {
  T22: 1,
  O: 1,
  s_Product22: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T22.prototype.$classData = $d_T22;
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
  /*<skip>*/
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n)
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")")
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3"
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, Tuple3$1.T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, Tuple3$1.T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, Tuple3$1.T3__f__3)))
  } else {
    return false
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"))
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)))
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth))
}
var $d_T3 = new $TypeData().initClass({
  T3: 0
}, false, "scala.Tuple3", {
  T3: 1,
  O: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T3.prototype.$classData = $d_T3;
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4
}
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
  /*<skip>*/
}
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n)
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")")
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4"
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T4)) {
    var Tuple4$1 = $as_T4(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, Tuple4$1.T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, Tuple4$1.T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, Tuple4$1.T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, Tuple4$1.T4__f__4)))
  } else {
    return false
  }
});
function $as_T4(obj) {
  return (((obj instanceof $c_T4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple4"))
}
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)))
}
function $asArrayOf_T4(obj, depth) {
  return (($isArrayOf_T4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple4;", depth))
}
var $d_T4 = new $TypeData().initClass({
  T4: 0
}, false, "scala.Tuple4", {
  T4: 1,
  O: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T4.prototype.$classData = $d_T4;
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.T5__f__1 = null;
  this.T5__f__2 = null;
  this.T5__f__3 = null;
  this.T5__f__4 = null;
  this.T5__f__5 = null;
  this.T5__f__1 = _1;
  this.T5__f__2 = _2;
  this.T5__f__3 = _3;
  this.T5__f__4 = _4;
  this.T5__f__5 = _5
}
$c_T5.prototype = new $h_O();
$c_T5.prototype.constructor = $c_T5;
/** @constructor */
function $h_T5() {
  /*<skip>*/
}
$h_T5.prototype = $c_T5.prototype;
$c_T5.prototype.productArity__I = (function() {
  return 5
});
$c_T5.prototype.productElement__I__O = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n)
});
$c_T5.prototype.toString__T = (function() {
  return (((((((((("(" + this.T5__f__1) + ",") + this.T5__f__2) + ",") + this.T5__f__3) + ",") + this.T5__f__4) + ",") + this.T5__f__5) + ")")
});
$c_T5.prototype.productPrefix__T = (function() {
  return "Tuple5"
});
$c_T5.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T5.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T5.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T5)) {
    var Tuple5$1 = $as_T5(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__1, Tuple5$1.T5__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__2, Tuple5$1.T5__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__3, Tuple5$1.T5__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__4, Tuple5$1.T5__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__5, Tuple5$1.T5__f__5))))
  } else {
    return false
  }
});
function $as_T5(obj) {
  return (((obj instanceof $c_T5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple5"))
}
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T5)))
}
function $asArrayOf_T5(obj, depth) {
  return (($isArrayOf_T5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple5;", depth))
}
var $d_T5 = new $TypeData().initClass({
  T5: 0
}, false, "scala.Tuple5", {
  T5: 1,
  O: 1,
  s_Product5: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T5.prototype.$classData = $d_T5;
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.T6__f__1 = null;
  this.T6__f__2 = null;
  this.T6__f__3 = null;
  this.T6__f__4 = null;
  this.T6__f__5 = null;
  this.T6__f__6 = null;
  this.T6__f__1 = _1;
  this.T6__f__2 = _2;
  this.T6__f__3 = _3;
  this.T6__f__4 = _4;
  this.T6__f__5 = _5;
  this.T6__f__6 = _6
}
$c_T6.prototype = new $h_O();
$c_T6.prototype.constructor = $c_T6;
/** @constructor */
function $h_T6() {
  /*<skip>*/
}
$h_T6.prototype = $c_T6.prototype;
$c_T6.prototype.productArity__I = (function() {
  return 6
});
$c_T6.prototype.productElement__I__O = (function(n) {
  return $f_s_Product6__productElement__I__O(this, n)
});
$c_T6.prototype.toString__T = (function() {
  return (((((((((((("(" + this.T6__f__1) + ",") + this.T6__f__2) + ",") + this.T6__f__3) + ",") + this.T6__f__4) + ",") + this.T6__f__5) + ",") + this.T6__f__6) + ")")
});
$c_T6.prototype.productPrefix__T = (function() {
  return "Tuple6"
});
$c_T6.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T6.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T6.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T6)) {
    var Tuple6$1 = $as_T6(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__1, Tuple6$1.T6__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__2, Tuple6$1.T6__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__3, Tuple6$1.T6__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__4, Tuple6$1.T6__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__5, Tuple6$1.T6__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__6, Tuple6$1.T6__f__6))))
  } else {
    return false
  }
});
function $as_T6(obj) {
  return (((obj instanceof $c_T6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple6"))
}
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T6)))
}
function $asArrayOf_T6(obj, depth) {
  return (($isArrayOf_T6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple6;", depth))
}
var $d_T6 = new $TypeData().initClass({
  T6: 0
}, false, "scala.Tuple6", {
  T6: 1,
  O: 1,
  s_Product6: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T6.prototype.$classData = $d_T6;
/** @constructor */
function $c_T7(_1, _2, _3, _4, _5, _6, _7) {
  this.T7__f__1 = null;
  this.T7__f__2 = null;
  this.T7__f__3 = null;
  this.T7__f__4 = null;
  this.T7__f__5 = null;
  this.T7__f__6 = null;
  this.T7__f__7 = null;
  this.T7__f__1 = _1;
  this.T7__f__2 = _2;
  this.T7__f__3 = _3;
  this.T7__f__4 = _4;
  this.T7__f__5 = _5;
  this.T7__f__6 = _6;
  this.T7__f__7 = _7
}
$c_T7.prototype = new $h_O();
$c_T7.prototype.constructor = $c_T7;
/** @constructor */
function $h_T7() {
  /*<skip>*/
}
$h_T7.prototype = $c_T7.prototype;
$c_T7.prototype.productArity__I = (function() {
  return 7
});
$c_T7.prototype.productElement__I__O = (function(n) {
  return $f_s_Product7__productElement__I__O(this, n)
});
$c_T7.prototype.toString__T = (function() {
  return (((((((((((((("(" + this.T7__f__1) + ",") + this.T7__f__2) + ",") + this.T7__f__3) + ",") + this.T7__f__4) + ",") + this.T7__f__5) + ",") + this.T7__f__6) + ",") + this.T7__f__7) + ")")
});
$c_T7.prototype.productPrefix__T = (function() {
  return "Tuple7"
});
$c_T7.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T7.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T7.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T7)) {
    var Tuple7$1 = $as_T7(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__1, Tuple7$1.T7__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__2, Tuple7$1.T7__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__3, Tuple7$1.T7__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__4, Tuple7$1.T7__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__5, Tuple7$1.T7__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__6, Tuple7$1.T7__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__7, Tuple7$1.T7__f__7))))
  } else {
    return false
  }
});
function $as_T7(obj) {
  return (((obj instanceof $c_T7) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple7"))
}
function $isArrayOf_T7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T7)))
}
function $asArrayOf_T7(obj, depth) {
  return (($isArrayOf_T7(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple7;", depth))
}
var $d_T7 = new $TypeData().initClass({
  T7: 0
}, false, "scala.Tuple7", {
  T7: 1,
  O: 1,
  s_Product7: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T7.prototype.$classData = $d_T7;
/** @constructor */
function $c_T8(_1, _2, _3, _4, _5, _6, _7, _8) {
  this.T8__f__1 = null;
  this.T8__f__2 = null;
  this.T8__f__3 = null;
  this.T8__f__4 = null;
  this.T8__f__5 = null;
  this.T8__f__6 = null;
  this.T8__f__7 = null;
  this.T8__f__8 = null;
  this.T8__f__1 = _1;
  this.T8__f__2 = _2;
  this.T8__f__3 = _3;
  this.T8__f__4 = _4;
  this.T8__f__5 = _5;
  this.T8__f__6 = _6;
  this.T8__f__7 = _7;
  this.T8__f__8 = _8
}
$c_T8.prototype = new $h_O();
$c_T8.prototype.constructor = $c_T8;
/** @constructor */
function $h_T8() {
  /*<skip>*/
}
$h_T8.prototype = $c_T8.prototype;
$c_T8.prototype.productArity__I = (function() {
  return 8
});
$c_T8.prototype.productElement__I__O = (function(n) {
  return $f_s_Product8__productElement__I__O(this, n)
});
$c_T8.prototype.toString__T = (function() {
  return (((((((((((((((("(" + this.T8__f__1) + ",") + this.T8__f__2) + ",") + this.T8__f__3) + ",") + this.T8__f__4) + ",") + this.T8__f__5) + ",") + this.T8__f__6) + ",") + this.T8__f__7) + ",") + this.T8__f__8) + ")")
});
$c_T8.prototype.productPrefix__T = (function() {
  return "Tuple8"
});
$c_T8.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T8.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T8.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T8)) {
    var Tuple8$1 = $as_T8(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__1, Tuple8$1.T8__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__2, Tuple8$1.T8__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__3, Tuple8$1.T8__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__4, Tuple8$1.T8__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__5, Tuple8$1.T8__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__6, Tuple8$1.T8__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__7, Tuple8$1.T8__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__8, Tuple8$1.T8__f__8))))
  } else {
    return false
  }
});
function $as_T8(obj) {
  return (((obj instanceof $c_T8) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple8"))
}
function $isArrayOf_T8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T8)))
}
function $asArrayOf_T8(obj, depth) {
  return (($isArrayOf_T8(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple8;", depth))
}
var $d_T8 = new $TypeData().initClass({
  T8: 0
}, false, "scala.Tuple8", {
  T8: 1,
  O: 1,
  s_Product8: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T8.prototype.$classData = $d_T8;
/** @constructor */
function $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9) {
  this.T9__f__1 = null;
  this.T9__f__2 = null;
  this.T9__f__3 = null;
  this.T9__f__4 = null;
  this.T9__f__5 = null;
  this.T9__f__6 = null;
  this.T9__f__7 = null;
  this.T9__f__8 = null;
  this.T9__f__9 = null;
  this.T9__f__1 = _1;
  this.T9__f__2 = _2;
  this.T9__f__3 = _3;
  this.T9__f__4 = _4;
  this.T9__f__5 = _5;
  this.T9__f__6 = _6;
  this.T9__f__7 = _7;
  this.T9__f__8 = _8;
  this.T9__f__9 = _9
}
$c_T9.prototype = new $h_O();
$c_T9.prototype.constructor = $c_T9;
/** @constructor */
function $h_T9() {
  /*<skip>*/
}
$h_T9.prototype = $c_T9.prototype;
$c_T9.prototype.productArity__I = (function() {
  return 9
});
$c_T9.prototype.productElement__I__O = (function(n) {
  return $f_s_Product9__productElement__I__O(this, n)
});
$c_T9.prototype.toString__T = (function() {
  return (((((((((((((((((("(" + this.T9__f__1) + ",") + this.T9__f__2) + ",") + this.T9__f__3) + ",") + this.T9__f__4) + ",") + this.T9__f__5) + ",") + this.T9__f__6) + ",") + this.T9__f__7) + ",") + this.T9__f__8) + ",") + this.T9__f__9) + ")")
});
$c_T9.prototype.productPrefix__T = (function() {
  return "Tuple9"
});
$c_T9.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T9.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T9.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T9)) {
    var Tuple9$1 = $as_T9(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__1, Tuple9$1.T9__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__2, Tuple9$1.T9__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__3, Tuple9$1.T9__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__4, Tuple9$1.T9__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__5, Tuple9$1.T9__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__6, Tuple9$1.T9__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__7, Tuple9$1.T9__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__8, Tuple9$1.T9__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__9, Tuple9$1.T9__f__9)))))
  } else {
    return false
  }
});
function $as_T9(obj) {
  return (((obj instanceof $c_T9) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple9"))
}
function $isArrayOf_T9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T9)))
}
function $asArrayOf_T9(obj, depth) {
  return (($isArrayOf_T9(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple9;", depth))
}
var $d_T9 = new $TypeData().initClass({
  T9: 0
}, false, "scala.Tuple9", {
  T9: 1,
  O: 1,
  s_Product9: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T9.prototype.$classData = $d_T9;
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord = $L0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_BitSetOps$$anon$1__f_$outer = outer
  };
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var this$1 = outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    var $$x1 = new $c_RTLong(lo$1, hi$1)
  } else {
    var $$x1 = outer.word__I__J(0)
  };
  this.sc_BitSetOps$$anon$1__f_currentWord = $$x1
}
$c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
  /*<skip>*/
}
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var this$1 = this.sc_BitSetOps$$anon$1__f_currentWord;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= this.sc_BitSetOps$$anon$1__f_$outer.nwords__I())) {
        return false
      };
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      this.sc_BitSetOps$$anon$1__f_currentWord = this.sc_BitSetOps$$anon$1__f_$outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos)
    } else {
      break
    }
  };
  return true
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var t = this.sc_BitSetOps$$anon$1__f_currentWord;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var bitPos = ((lo !== 0) ? ((lo === 0) ? 32 : ((31 - Math.clz32((lo & ((-lo) | 0)))) | 0)) : ((32 + ((hi === 0) ? 32 : ((31 - Math.clz32((hi & ((-hi) | 0)))) | 0))) | 0));
    var this$5 = this.sc_BitSetOps$$anon$1__f_currentWord;
    var b = this.sc_BitSetOps$$anon$1__f_currentWord;
    var bhi = b.RTLong__f_hi;
    var lo$1 = (((-1) + b.RTLong__f_lo) | 0);
    var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var lo$2 = (this$5.RTLong__f_lo & lo$1);
    var hi$2 = (this$5.RTLong__f_hi & hi$1);
    this.sc_BitSetOps$$anon$1__f_currentWord = new $c_RTLong(lo$2, hi$2);
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0)
  } else {
    return $uI($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().initClass({
  sc_BitSetOps$$anon$1: 0
}, false, "scala.collection.BitSetOps$$anon$1", {
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_BitSetOps$$anon$1.prototype.$classData = $d_sc_BitSetOps$$anon$1;
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate)
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass({
  sc_ClassTagSeqFactory$AnySeqDelegate: 0
}, false, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", {
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
});
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.$classData = $d_sc_ClassTagSeqFactory$AnySeqDelegate;
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), $thiz, n))
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n))
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f))
}
function $f_sc_Iterable__toString__T($thiz) {
  var start = ($thiz.className__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, ", ", ")")
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)))
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"))
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)))
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth))
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = null;
  $thiz.sc_Iterator$$anon$10__f_cur = $as_sc_IterableOnce($thiz.sc_Iterator$$anon$10__f_f$3.apply__O__O($thiz.sc_Iterator$$anon$10__f_$outer.next__O())).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1)
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$10__f_$outer = outer
  };
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1)
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!this.sc_Iterator$$anon$10__f_cur.hasNext__Z())) {
      if ((!this.sc_Iterator$$anon$10__f_$outer.hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false
      };
      $p_sc_Iterator$$anon$10__nextCur__V(this)
    };
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1)
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1)
  };
  return this.sc_Iterator$$anon$10__f_cur.next__O()
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass({
  sc_Iterator$$anon$10: 0
}, false, "scala.collection.Iterator$$anon$10", {
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$10.prototype.$classData = $d_sc_Iterator$$anon$10;
/** @constructor */
function $c_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E()
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass({
  sc_Iterator$$anon$19: 0
}, false, "scala.collection.Iterator$$anon$19", {
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$19.prototype.$classData = $d_sc_Iterator$$anon$19;
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed)
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this)
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass({
  sc_Iterator$$anon$20: 0
}, false, "scala.collection.Iterator$$anon$20", {
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$20.prototype.$classData = $d_sc_Iterator$$anon$20;
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$9__f_$outer = outer
  };
  this.sc_Iterator$$anon$9__f_f$2 = f$2
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.knownSize__I()
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.hasNext__Z()
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return this.sc_Iterator$$anon$9__f_f$2.apply__O__O(this.sc_Iterator$$anon$9__f_$outer.next__O())
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass({
  sc_Iterator$$anon$9: 0
}, false, "scala.collection.Iterator$$anon$9", {
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$9.prototype.$classData = $d_sc_Iterator$$anon$9;
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
    var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
    $thiz.sc_Iterator$ConcatIterator__f_current = c.sc_Iterator$ConcatIterator__f_current;
    $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = c.sc_Iterator$ConcatIterator__f_currentHasNextChecked;
    if ((c.sc_Iterator$ConcatIterator__f_tail !== null)) {
      if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = c.sc_Iterator$ConcatIterator__f_last
      };
      c.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
      $thiz.sc_Iterator$ConcatIterator__f_tail = c.sc_Iterator$ConcatIterator__f_tail
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $thiz.sc_Iterator$ConcatIterator__f_tail.headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $thiz.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail
      };
      $thiz.sc_Iterator$ConcatIterator__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail.sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $thiz.sc_Iterator$ConcatIterator__f_current.hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if (this.sc_Iterator$ConcatIterator__f_current.hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this)
    }
  } else {
    return false
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return this.sc_Iterator$ConcatIterator__f_current.next__O()
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  } else {
    this.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  };
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  };
  return this
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"))
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)))
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth))
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass({
  sc_Iterator$ConcatIterator: 0
}, false, "scala.collection.Iterator$ConcatIterator", {
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$ConcatIterator.prototype.$classData = $d_sc_Iterator$ConcatIterator;
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($thiz.sc_Iterator$SliceIterator__f_underlying.hasNext__Z()) {
      $thiz.sc_Iterator$SliceIterator__f_underlying.next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (((-1) + $thiz.sc_Iterator$SliceIterator__f_dropping) | 0)
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1)
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that)
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start
}
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
  /*<skip>*/
}
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = this.sc_Iterator$SliceIterator__f_underlying.knownSize__I();
  if ((size < 0)) {
    return (-1)
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize)
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && this.sc_Iterator$SliceIterator__f_underlying.hasNext__Z())
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = (((-1) + this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining) | 0);
    return this.sc_Iterator$SliceIterator__f_underlying.next__O()
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? this.sc_Iterator$SliceIterator__f_underlying.next__O() : $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo)
  } else if ((until <= lo)) {
    var rest = 0
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0)
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that)
  };
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    this.sc_Iterator$SliceIterator__f_dropping = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass({
  sc_Iterator$SliceIterator: 0
}, false, "scala.collection.Iterator$SliceIterator", {
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$SliceIterator.prototype.$classData = $d_sc_Iterator$SliceIterator;
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.sc_Iterator$UnfoldIterator__f_f = null;
  this.sc_Iterator$UnfoldIterator__f_state = null;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
  this.sc_Iterator$UnfoldIterator__f_f = f;
  this.sc_Iterator$UnfoldIterator__f_state = init;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null
}
$c_sc_Iterator$UnfoldIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$UnfoldIterator.prototype.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
  /*<skip>*/
}
$h_sc_Iterator$UnfoldIterator.prototype = $c_sc_Iterator$UnfoldIterator.prototype;
$c_sc_Iterator$UnfoldIterator.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$UnfoldIterator__f_nextResult === null)) {
    var res = $as_s_Option(this.sc_Iterator$UnfoldIterator__f_f.apply__O__O(this.sc_Iterator$UnfoldIterator__f_state));
    if ((res === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null during unfold")
    };
    this.sc_Iterator$UnfoldIterator__f_nextResult = res;
    this.sc_Iterator$UnfoldIterator__f_state = null
  };
  var this$1 = this.sc_Iterator$UnfoldIterator__f_nextResult;
  return (!this$1.isEmpty__Z())
});
$c_sc_Iterator$UnfoldIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var x1 = $as_T2(this.sc_Iterator$UnfoldIterator__f_nextResult.get__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var value = x1._1__O();
    var newState = x1._2__O();
    this.sc_Iterator$UnfoldIterator__f_state = newState;
    this.sc_Iterator$UnfoldIterator__f_nextResult = null;
    return value
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$UnfoldIterator = new $TypeData().initClass({
  sc_Iterator$UnfoldIterator: 0
}, false, "scala.collection.Iterator$UnfoldIterator", {
  sc_Iterator$UnfoldIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$UnfoldIterator.prototype.$classData = $d_sc_Iterator$UnfoldIterator;
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0(((this$1, initialHead) => (() => initialHead))(this, coll)))
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
  return (!this$1.isEmpty__Z())
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var cur = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
    var result = cur.head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0(((this$1, cur$1) => (() => $as_sc_LinearSeq(cur$1.tail__O())))(this, cur)));
    return result
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass({
  sc_LinearSeqIterator: 0
}, false, "scala.collection.LinearSeqIterator", {
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_LinearSeqIterator.prototype.$classData = $d_sc_LinearSeqIterator;
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz))
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = these;
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return len
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len))
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0))
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if (skipped.isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return skipped.head__O()
}
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = $as_sc_LinearSeq(these.tail__O())
  }
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return false
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    acc = op.apply__O__O__O(acc, these.head__O());
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return acc
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2)
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that)
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = these;
    if ((!this$3.isEmpty__Z())) {
      if ($uZ(p.apply__O__O(these.head__O()))) {
        return i
      };
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return (-1)
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var this$1 = a;
      if ((!this$1.isEmpty__Z())) {
        var this$2 = b;
        var $$x1 = (!this$2.isEmpty__Z())
      } else {
        var $$x1 = false
      };
      if (($$x1 && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sc_LinearSeq(a.tail__O());
        var temp$b = $as_sc_LinearSeq(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (a.isEmpty__Z() && b.isEmpty__Z())
      }
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)))
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"))
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)))
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth))
}
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.sc_MapOps$$anon$2__f_iter = null;
  this.sc_MapOps$$anon$2__f_iter = outer.iterator__sc_Iterator()
}
$c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$2.prototype.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$2.prototype = $c_sc_MapOps$$anon$2.prototype;
$c_sc_MapOps$$anon$2.prototype.hasNext__Z = (function() {
  return this.sc_MapOps$$anon$2__f_iter.hasNext__Z()
});
$c_sc_MapOps$$anon$2.prototype.next__O = (function() {
  return $as_T2(this.sc_MapOps$$anon$2__f_iter.next__O())._1__O()
});
var $d_sc_MapOps$$anon$2 = new $TypeData().initClass({
  sc_MapOps$$anon$2: 0
}, false, "scala.collection.MapOps$$anon$2", {
  sc_MapOps$$anon$2: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_MapOps$$anon$2.prototype.$classData = $d_sc_MapOps$$anon$2;
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ($is_sc_Iterable(that)) {
    var x2 = $as_sc_Iterable(that);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var $$x1 = $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0(((this$1, that$1) => (() => that$1.iterator__sc_Iterator()))($thiz, that)))
  };
  return $as_sc_SetOps($thiz.fromSpecific__sc_IterableOnce__O($$x1))
}
function $is_sc_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SetOps)))
}
function $as_sc_SetOps(obj) {
  return (($is_sc_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SetOps"))
}
function $isArrayOf_sc_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SetOps)))
}
function $asArrayOf_sc_SetOps(obj, depth) {
  return (($isArrayOf_sc_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SetOps;", depth))
}
/** @constructor */
function $c_sc_SortedIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_SortedIterableFactory$Delegate.prototype = new $h_sc_EvidenceIterableFactory$Delegate();
$c_sc_SortedIterableFactory$Delegate.prototype.constructor = $c_sc_SortedIterableFactory$Delegate;
/** @constructor */
function $h_sc_SortedIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SortedIterableFactory$Delegate.prototype = $c_sc_SortedIterableFactory$Delegate.prototype;
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.isEmpty__Z())
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_StrictOptimizedLinearSeqOps(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.tail__O());
  return r
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 0
}, false, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", {
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.$classData = $d_sc_StrictOptimizedLinearSeqOps$$anon$1;
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null)
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = bm.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedMapNode__f_dataMap = (bm.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedMapNode__f_content = dst;
  bm.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedMapNode__f_size = ((1 + bm.sci_BitmapIndexedMapNode__f_size) | 0);
  bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashMapBuilder__f_aliased = null
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.copy__sci_BitmapIndexedMapNode()
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
  /*<skip>*/
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = x2.getKey__I__O(index);
      var key0UnimprovedHash = x2.getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        x2.sci_BitmapIndexedMapNode__f_content.set(((1 + (index << 1)) | 0), value)
      } else {
        var value0 = x2.getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_MapNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHash = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedMapNode__f_size = ((x2.sci_BitmapIndexedMapNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0)
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value)
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = x3.indexOf__O__I(key);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value))
    } else {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index$3, $ct_T2__O__O__(new $c_T2(), key, value))
    }
  } else {
    throw new $c_s_MatchError(mapNode)
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if ((this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = elem._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem._1__O(), elem._2__O(), h, im, 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2)
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, hash, 0)
    }
  } else if ($is_sci_Map(xs)) {
    var x4 = $as_sci_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((this$1) => ((key$2, value$2) => this$1.addOne__O__O__sci_HashMapBuilder(key$2, value$2)))(this)))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2(it.next__O()))
    }
  };
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(xs)
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem))
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap()
});
var $d_sci_HashMapBuilder = new $TypeData().initClass({
  sci_HashMapBuilder: 0
}, false, "scala.collection.immutable.HashMapBuilder", {
  sci_HashMapBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashMapBuilder.prototype.$classData = $d_sci_HashMapBuilder;
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null)
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var src = bm.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedSetNode__f_dataMap = (bm.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedSetNode__f_content = dst;
  bm.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedSetNode__f_size = ((1 + bm.sci_BitmapIndexedSetNode__f_size) | 0);
  bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  bm.sci_BitmapIndexedSetNode__f_content.set(dataIx, elem)
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashSetBuilder__f_aliased = null
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.copy__sci_BitmapIndexedSetNode()
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
  /*<skip>*/
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = x2.getPayload__I__O(index);
      var element0UnimprovedHash = x2.getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0)
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_SetNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHashCode = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedSetNode__f_size = ((x2.sci_BitmapIndexedSetNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0)
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash)
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = x3.sci_HashCollisionSetNode__f_content;
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)
    } else {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.updated__I__O__sci_Vector(index$3, element)
    }
  } else {
    throw new $c_s_MatchError(setNode)
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if ((this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2)
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder(it.next__O())
    }
  };
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(xs)
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem)
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet()
});
var $d_sci_HashSetBuilder = new $TypeData().initClass({
  sci_HashSetBuilder: 0
}, false, "scala.collection.immutable.HashSetBuilder", {
  sci_HashSetBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashSetBuilder.prototype.$classData = $d_sci_HashSetBuilder;
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$())
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
  /*<skip>*/
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source)
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it)
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass({
  sci_IndexedSeq$: 0
}, false, "scala.collection.immutable.IndexedSeq$", {
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_IndexedSeq$.prototype.$classData = $d_sci_IndexedSeq$;
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$()
  };
  return $n_sci_IndexedSeq$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V()
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((this$1, deferred$1) => (() => deferred$1.eval__sci_LazyList$State()))(this, deferred));
  this.sci_LazyList$LazyBuilder__f_list = new $c_sci_LazyList(state);
  this.sci_LazyList$LazyBuilder__f_next = deferred
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0(((this$1) => (() => $m_sci_LazyList$State$Empty$()))(this)));
  return this.sci_LazyList$LazyBuilder__f_list
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0(((this$1, elem$1, deferred$1) => (() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0(((this$2, deferred$2) => (() => deferred$2.eval__sci_LazyList$State()))(this$1, deferred$1));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(elem$1, tl)
  }))(this, elem, deferred)));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if ((xs.knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0(((this$1, xs$1, deferred$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(xs$1.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0(((this$2, deferred$3) => (() => deferred$3.eval__sci_LazyList$State()))(this$1, deferred$1)))))(this, xs, deferred)));
    this.sci_LazyList$LazyBuilder__f_next = deferred
  };
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(xs)
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem)
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList()
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass({
  sci_LazyList$LazyBuilder: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder", {
  sci_LazyList$LazyBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_LazyList$LazyBuilder.prototype.$classData = $d_sci_LazyList$LazyBuilder;
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
  /*<skip>*/
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  return (!this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z())
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  if (this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var this$1 = this.sci_LazyList$LazyIterator__f_lazyList;
    var res = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    var this$2 = this.sci_LazyList$LazyIterator__f_lazyList;
    this.sci_LazyList$LazyIterator__f_lazyList = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    return res
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass({
  sci_LazyList$LazyIterator: 0
}, false, "scala.collection.immutable.LazyList$LazyIterator", {
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LazyList$LazyIterator.prototype.$classData = $d_sci_LazyList$LazyIterator;
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1()
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
  /*<skip>*/
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer()
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source)
});
var $d_sci_List$ = new $TypeData().initClass({
  sci_List$: 0
}, false, "scala.collection.immutable.List$", {
  sci_List$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_List$.prototype.$classData = $d_sci_List$;
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$()
  };
  return $n_sci_List$
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2)
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3)
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4)
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break
    }
    case 3: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
  /*<skip>*/
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? this.sci_MapBuilderImpl__f_hashMapBuilder.result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  } else if ((this.sci_MapBuilderImpl__f_elems.size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else if (this.sci_MapBuilderImpl__f_elems.contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder()
    };
    $as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  };
  return this
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? (this.sci_MapBuilderImpl__f_hashMapBuilder.addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(xs)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl(elem$1._1__O(), elem$1._2__O())
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map()
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"))
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)))
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth))
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass({
  sci_MapBuilderImpl: 0
}, false, "scala.collection.immutable.MapBuilderImpl", {
  sci_MapBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_MapBuilderImpl.prototype.$classData = $d_sci_MapBuilderImpl;
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyIterator.prototype.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
  /*<skip>*/
}
$h_sci_MapKeyIterator.prototype = $c_sci_MapKeyIterator.prototype;
$c_sci_MapKeyIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sci_MapKeyIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapKeyIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_MapKeyIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_MapKeyIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_MapKeyIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_MapKeyIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var key = $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return key
});
var $d_sci_MapKeyIterator = new $TypeData().initClass({
  sci_MapKeyIterator: 0
}, false, "scala.collection.immutable.MapKeyIterator", {
  sci_MapKeyIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyIterator.prototype.$classData = $d_sci_MapKeyIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleHashIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $$x2 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $$x2.tuple2Hash__I__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x), (-889275714))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_MapKeyValueTupleHashIterator__f_hash = this.sci_ChampBaseReverseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator()
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleHashIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleHashIterator", {
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleHashIterator.prototype.$classData = $d_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sci_MapKeyValueTupleIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapKeyValueTupleIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_MapKeyValueTupleIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_MapKeyValueTupleIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_MapKeyValueTupleIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_MapKeyValueTupleIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleIterator", {
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleIterator.prototype.$classData = $d_sci_MapKeyValueTupleIterator;
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  };
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while ((slice.u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx)
  };
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul(slice.u.length, (1 << Math.imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0)
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz)
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io
  };
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $thiz.sci_NewVectorIterator__f_a1.u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = v.sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len
}
$c_sci_NewVectorIterator.prototype = new $h_O();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
  /*<skip>*/
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_NewVectorIterator.prototype.isEmpty__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_NewVectorIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_NewVectorIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_NewVectorIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_NewVectorIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_NewVectorIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_NewVectorIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0)
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this)
  };
  var r = this.sci_NewVectorIterator__f_a1.get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this)
      };
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io
      };
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
      }
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.take__I__sc_Iterator = (function(n) {
  if ((n < ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0))) {
    var trunc = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.sci_NewVectorIterator__f_totalLength = ((this.sci_NewVectorIterator__f_totalLength - trunc) | 0);
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - trunc) | 0);
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 < this.sci_NewVectorIterator__f_a1len)) {
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
    };
    if ((this.sci_NewVectorIterator__f_totalLength < this.sci_NewVectorIterator__f_sliceEnd)) {
      this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_totalLength
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((xsLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var total = ((x$1 > 0) ? x$1 : 0);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this)
    };
    var a = ((total - copied) | 0);
    var b = ((this.sci_NewVectorIterator__f_a1.u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      src.copyTo(srcPos, xs, destPos, count)
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count)
    };
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0)
  };
  return total
});
var $d_sci_NewVectorIterator = new $TypeData().initClass({
  sci_NewVectorIterator: 0
}, false, "scala.collection.immutable.NewVectorIterator", {
  sci_NewVectorIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
});
$c_sci_NewVectorIterator.prototype.$classData = $d_sci_NewVectorIterator;
/** @constructor */
function $c_sci_Queue$() {
  /*<skip>*/
}
$c_sci_Queue$.prototype = new $h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
  /*<skip>*/
}
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((x$2) => {
    var x = $as_sci_List(x$2);
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), x)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(source);
    return x2
  } else {
    $m_sci_List$();
    var list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return (list.isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), list))
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), elems.toList__sci_List())
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source)
});
var $d_sci_Queue$ = new $TypeData().initClass({
  sci_Queue$: 0
}, false, "scala.collection.immutable.Queue$", {
  sci_Queue$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$.prototype.$classData = $d_sci_Queue$;
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$()
  };
  return $n_sci_Queue$
}
function $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, key) {
  return (($thiz.sci_RedBlackTree$TreeIterator__f_root === null) ? null : $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, $thiz.sci_RedBlackTree$TreeIterator__f_root, key))
}
function $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, tree, key$1) {
  while (true) {
    if ((tree === null)) {
      if (($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var $$x1 = $thiz.sci_RedBlackTree$TreeIterator__f_ordering;
      var this$1 = tree;
      if ($$x1.lteq__O__O__Z(key$1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var tree$1 = tree;
        $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.set($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else {
        var tree$2 = tree;
        tree = tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      }
    }
  }
}
function $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__($thiz, root, start, ordering) {
  $thiz.sci_RedBlackTree$TreeIterator__f_root = root;
  $thiz.sci_RedBlackTree$TreeIterator__f_ordering = ordering;
  if ((root === null)) {
    var $$x1 = null
  } else {
    var i = ((1 + (2147483647 & root.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    var maximumHeight = (((-2) + (((32 - Math.clz32(i)) | 0) << 1)) | 0);
    var $$x1 = new ($d_sci_RedBlackTree$Tree.getArrayOf().constr)(maximumHeight)
  };
  $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts = $$x1;
  $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  $thiz.sci_RedBlackTree$TreeIterator__f_lookahead = ((!start.isEmpty__Z()) ? $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, start.get__O()) : $thiz.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(root));
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$TreeIterator() {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null
}
$c_sci_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RedBlackTree$TreeIterator.prototype.constructor = $c_sci_RedBlackTree$TreeIterator;
/** @constructor */
function $h_sci_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$TreeIterator.prototype = $c_sci_RedBlackTree$TreeIterator.prototype;
$c_sci_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)
});
$c_sci_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
  if ((tree !== null)) {
    this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    return this.nextResult__sci_RedBlackTree$Tree__O(tree)
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sci_RedBlackTree$TreeIterator.prototype.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  while (true) {
    if ((tree === null)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var this$1 = tree;
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === null)) {
        return tree
      } else {
        var tree$1 = tree;
        this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.set(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      }
    }
  }
});
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$())
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
  /*<skip>*/
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source)
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it)
});
var $d_sci_Seq$ = new $TypeData().initClass({
  sci_Seq$: 0
}, false, "scala.collection.immutable.Seq$", {
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Seq$.prototype.$classData = $d_sci_Seq$;
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$()
  };
  return $n_sci_Seq$
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
  /*<skip>*/
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? this.sci_SetBuilderImpl__f_hashSetBuilder.result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  } else if ((this.sci_SetBuilderImpl__f_elems.size__I() < 4)) {
    var this$1 = this.sci_SetBuilderImpl__f_elems;
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem))
  } else if ((!this.sci_SetBuilderImpl__f_elems.contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder()
    };
    $as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  };
  return this
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? (this.sci_SetBuilderImpl__f_hashSetBuilder.addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(xs)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem)
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set()
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"))
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)))
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth))
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass({
  sci_SetBuilderImpl: 0
}, false, "scala.collection.immutable.SetBuilderImpl", {
  sci_SetBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_SetBuilderImpl.prototype.$classData = $d_sci_SetBuilderImpl;
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
  /*<skip>*/
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetHashIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sci_SetHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_SetHashIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_SetHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetHashIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_SetHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetHashIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_SetHashIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_SetHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_SetHashIterator__f_hash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this
});
var $d_sci_SetHashIterator = new $TypeData().initClass({
  sci_SetHashIterator: 0
}, false, "scala.collection.immutable.SetHashIterator", {
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetHashIterator.prototype.$classData = $d_sci_SetHashIterator;
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
  /*<skip>*/
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sci_SetIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_SetIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sci_SetIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_SetIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_SetIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_SetIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
var $d_sci_SetIterator = new $TypeData().initClass({
  sci_SetIterator: 0
}, false, "scala.collection.immutable.SetIterator", {
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetIterator.prototype.$classData = $d_sci_SetIterator;
function $p_sci_Vector$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 250
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $p_sci_Vector$__liftedTree1$1__I(this);
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0)
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
  /*<skip>*/
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems)
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2
  } else {
    var knownSize = it.knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$()
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = x2$2.elemTag__s_reflect_ClassTag().runtimeClass__jl_Class();
          if (((x !== null) && (x === $d_O.getClassOf()))) {
            var a1$3 = x2$2.sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5
          }
        };
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          x3.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5
        };
        var a1$2 = new $ac_O(knownSize);
        var this$1 = it.iterator__sc_Iterator();
        this$1.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2
      };
      return new $c_sci_Vector1(a1$3)
    } else {
      var this$2 = new $c_sci_VectorBuilder();
      var this$3 = this$2.addAll__sc_IterableOnce__sci_VectorBuilder(it);
      return this$3.result__sci_Vector()
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder()
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source)
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$()
});
var $d_sci_Vector$ = new $TypeData().initClass({
  sci_Vector$: 0
}, false, "scala.collection.immutable.Vector$", {
  sci_Vector$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector$.prototype.$classData = $d_sci_Vector$;
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$()
  };
  return $n_sci_Vector$
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz)
    };
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    data.copyTo(0, dest, destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      data.copyTo(copy1, dest$1, 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0)
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var x1 = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice)
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sjsr_AnonFunction1(((this$3) => ((data$2) => {
        var data = $asArrayOf_O(data$2, 1);
        $p_sci_VectorBuilder__addArr1__AO__V(this$3, data)
      }))($thiz)))
    };
    sliceIdx = ((1 + sliceIdx) | 0)
  };
  return $thiz
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor)
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a2.set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1)
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a3.set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2)
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a4.set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3)
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a5.set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4)
  } else if ((xor < 1073741824)) {
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $thiz.sci_VectorBuilder__f_a6.set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $thiz.sci_VectorBuilder__f_a6.set((31 & ((idx >>> 25) | 0)), $thiz.sci_VectorBuilder__f_a5)
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth))
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 1
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
  /*<skip>*/
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = prefix1.u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = ((prefix1.u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = v.vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = v1.sci_Vector__f_prefix1.u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = v1.sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = ((a.u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = v2.sci_Vector2__f_data2;
      var a$1 = v2.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$1.u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_offset = ((32 - v2.sci_Vector2__f_len1) | 0);
      var i$1 = ((v2.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a2.set(0, v2.sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = d2.u.length;
      d2.copyTo(0, dest, 1, length);
      this.sci_VectorBuilder__f_a2.set(((1 + d2.u.length) | 0), this.sci_VectorBuilder__f_a1);
      break
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = v3.sci_Vector3__f_data3;
      var s2 = v3.sci_Vector3__f_suffix2;
      var a$2 = v3.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$2.u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_offset = ((1024 - v3.sci_Vector3__f_len12) | 0);
      var i$2 = ((v3.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a3.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v3.sci_Vector__f_prefix1, v3.sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = d3.u.length;
      d3.copyTo(0, dest$1, 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      this.sci_VectorBuilder__f_a3.set(((1 + d3.u.length) | 0), this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = v4.sci_Vector4__f_data4;
      var s3 = v4.sci_Vector4__f_suffix3;
      var s2$2 = v4.sci_Vector4__f_suffix2;
      var a$3 = v4.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$3.u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_offset = ((32768 - v4.sci_Vector4__f_len123) | 0);
      var i$3 = ((v4.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a4.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v4.sci_Vector__f_prefix1, v4.sci_Vector4__f_prefix2), v4.sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = d4.u.length;
      d4.copyTo(0, dest$2, 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      this.sci_VectorBuilder__f_a4.set(((1 + d4.u.length) | 0), this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = v5.sci_Vector5__f_data5;
      var s4 = v5.sci_Vector5__f_suffix4;
      var s3$2 = v5.sci_Vector5__f_suffix3;
      var s2$3 = v5.sci_Vector5__f_suffix2;
      var a$4 = v5.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$4.u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_offset = ((1048576 - v5.sci_Vector5__f_len1234) | 0);
      var i$4 = ((v5.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a5.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v5.sci_Vector__f_prefix1, v5.sci_Vector5__f_prefix2), v5.sci_Vector5__f_prefix3), v5.sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = d5.u.length;
      d5.copyTo(0, dest$3, 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      this.sci_VectorBuilder__f_a5.set(((1 + d5.u.length) | 0), this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$2.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$3.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = v6.sci_Vector6__f_data6;
      var s5 = v6.sci_Vector6__f_suffix5;
      var s4$2 = v6.sci_Vector6__f_suffix4;
      var s3$3 = v6.sci_Vector6__f_suffix3;
      var s2$4 = v6.sci_Vector6__f_suffix2;
      var a$5 = v6.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$5.u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_offset = ((33554432 - v6.sci_Vector6__f_len12345) | 0);
      var i$5 = ((v6.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a6.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v6.sci_Vector__f_prefix1, v6.sci_Vector6__f_prefix2), v6.sci_Vector6__f_prefix3), v6.sci_Vector6__f_prefix4), v6.sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = d6.u.length;
      d6.copyTo(0, dest$4, 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      this.sci_VectorBuilder__f_a6.set(((1 + d6.u.length) | 0), this.sci_VectorBuilder__f_a5);
      this.sci_VectorBuilder__f_a5.set(s5.u.length, this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4$2.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$4.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  };
  return this
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this)
  };
  this.sci_VectorBuilder__f_a1.set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2))
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$()
  } else if ((len <= 32)) {
    if ((realLen === 32)) {
      return new $c_sci_Vector1(this.sci_VectorBuilder__f_a1)
    } else {
      var original = this.sci_VectorBuilder__f_a1;
      return new $c_sci_Vector1($m_ju_Arrays$().copyOf__AO__I__AO(original, realLen))
    }
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original$1 = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i2), 2);
    var prefix1 = this.sci_VectorBuilder__f_a2.get(0);
    var a = this.sci_VectorBuilder__f_a2.get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a.u.length === len$1) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_offset) | 0), data, suffix1, realLen)
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$2 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, 1, i3), 3);
    var a$1 = this.sci_VectorBuilder__f_a3.get(0);
    var to = a$1.u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 1, to), 2);
    var prefix1$2 = this.sci_VectorBuilder__f_a3.get(0).get(0);
    var original$3 = this.sci_VectorBuilder__f_a3.get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$3, i2$2), 2);
    var a$2 = this.sci_VectorBuilder__f_a3.get(i3).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$2.u.length === len$2) ? a$2 : $m_ju_Arrays$().copyOf__AO__I__AO(a$2, len$2));
    var len1 = prefix1$2.u.length;
    var len12 = ((len1 + (prefix2.u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen)
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$4 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, 1, i4), 4);
    var a$3 = this.sci_VectorBuilder__f_a4.get(0);
    var to$1 = a$3.u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 1, to$1), 3);
    var a$4 = this.sci_VectorBuilder__f_a4.get(0).get(0);
    var to$2 = a$4.u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$2), 2);
    var prefix1$3 = this.sci_VectorBuilder__f_a4.get(0).get(0).get(0);
    var original$5 = this.sci_VectorBuilder__f_a4.get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i3$2), 3);
    var original$6 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$6, i2$3), 2);
    var a$5 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$5.u.length === len$3) ? a$5 : $m_ju_Arrays$().copyOf__AO__I__AO(a$5, len$3));
    var len1$2 = prefix1$3.u.length;
    var len12$2 = ((len1$2 + (prefix2$2.u.length << 5)) | 0);
    var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen)
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$7 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$7, 1, i5), 5);
    var a$6 = this.sci_VectorBuilder__f_a5.get(0);
    var to$3 = a$6.u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$6, 1, to$3), 4);
    var a$7 = this.sci_VectorBuilder__f_a5.get(0).get(0);
    var to$4 = a$7.u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$4), 3);
    var a$8 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0);
    var to$5 = a$8.u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$5), 2);
    var prefix1$4 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0).get(0);
    var original$8 = this.sci_VectorBuilder__f_a5.get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i4$2), 4);
    var original$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i3$3), 3);
    var original$10 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$10, i2$4), 2);
    var a$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$9.u.length === len$4) ? a$9 : $m_ju_Arrays$().copyOf__AO__I__AO(a$9, len$4));
    var len1$3 = prefix1$4.u.length;
    var len12$3 = ((len1$3 + (prefix2$3.u.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
    var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen)
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$11 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$11, 1, i6), 6);
    var a$10 = this.sci_VectorBuilder__f_a6.get(0);
    var to$6 = a$10.u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$10, 1, to$6), 5);
    var a$11 = this.sci_VectorBuilder__f_a6.get(0).get(0);
    var to$7 = a$11.u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$7), 4);
    var a$12 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0);
    var to$8 = a$12.u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$8), 3);
    var a$13 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0);
    var to$9 = a$13.u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$9), 2);
    var prefix1$5 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0).get(0);
    var original$12 = this.sci_VectorBuilder__f_a6.get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i5$2), 5);
    var original$13 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i4$3), 4);
    var original$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i3$4), 3);
    var original$15 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$15, i2$5), 2);
    var a$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$14.u.length === len$5) ? a$14 : $m_ju_Arrays$().copyOf__AO__I__AO(a$14, len$5));
    var len1$4 = prefix1$5.u.length;
    var len12$4 = ((len1$4 + (prefix2$4.u.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
    var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen)
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")")
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector()
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem)
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"))
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)))
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth))
}
var $d_sci_VectorBuilder = new $TypeData().initClass({
  sci_VectorBuilder: 0
}, false, "scala.collection.immutable.VectorBuilder", {
  sci_VectorBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_VectorBuilder.prototype.$classData = $d_sci_VectorBuilder;
function $p_scm_ArrayBuffer$__resizeEnsuring$1__I__I__I__I($thiz, length, end, n) {
  var hi = (length >> 31);
  var newSize__lo = length;
  var newSize__hi = hi;
  var this$2__lo = newSize__lo;
  var this$2__hi = newSize__hi;
  var lo = this$2__lo;
  var lo$1 = (lo << 1);
  var hi$1 = (((lo >>> 31) | 0) | (this$2__hi << 1));
  var t = (((hi$1 === 0) ? (((-2147483648) ^ lo$1) > (-2147483632)) : (hi$1 > 0)) ? new $c_RTLong(lo$1, hi$1) : new $c_RTLong(16, 0));
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$2;
  newSize__lo = $$x1__lo;
  newSize__hi = $$x1__hi;
  while (true) {
    var this$6__lo = newSize__lo;
    var this$6__hi = newSize__hi;
    var hi$3 = (n >> 31);
    var ahi = this$6__hi;
    if (((ahi === hi$3) ? (((-2147483648) ^ this$6__lo) < ((-2147483648) ^ n)) : (ahi < hi$3))) {
      var this$7__lo = newSize__lo;
      var this$7__hi = newSize__hi;
      var lo$3 = this$7__lo;
      var lo$4 = (lo$3 << 1);
      var hi$4 = (((lo$3 >>> 31) | 0) | (this$7__hi << 1));
      var $$x2__lo = lo$4;
      var $$x2__hi = hi$4;
      newSize__lo = $$x2__lo;
      newSize__hi = $$x2__hi
    } else {
      break
    }
  };
  var this$8__lo = newSize__lo;
  var this$8__hi = newSize__hi;
  var ahi$1 = this$8__hi;
  if (((ahi$1 === 0) ? (((-2147483648) ^ this$8__lo) <= (-1)) : (ahi$1 < 0))) {
    var this$9__lo = newSize__lo;
    var this$9__hi = newSize__hi;
    return this$9__lo
  } else if ((end === 2147483647)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_Exception__T__(new $c_jl_Exception(), "Collections can not have more than 2147483647 elements"))
  } else {
    return 2147483647
  }
}
/** @constructor */
function $c_scm_ArrayBuffer$() {
  /*<skip>*/
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems)
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = coll.knownSize__I();
  if ((k >= 0)) {
    var array = new $ac_O(((k > 16) ? k : 16));
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      x2.copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k)
  } else {
    var this$6 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$6.addAll__sc_IterableOnce__scm_ArrayBuffer(coll)
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1()
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, end, n) {
  if ((n <= array.u.length)) {
    return array
  } else {
    var a = new $ac_O($p_scm_ArrayBuffer$__resizeEnsuring$1__I__I__I__I(this, array.u.length, end, n));
    $m_s_Array$().copy__O__I__O__I__I__V(array, 0, a, 0, end);
    return a
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source)
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass({
  scm_ArrayBuffer$: 0
}, false, "scala.collection.mutable.ArrayBuffer$", {
  scm_ArrayBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer$.prototype.$classData = $d_scm_ArrayBuffer$;
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$()
  };
  return $n_scm_ArrayBuffer$
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()))
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems).ensureSize__I__V(size)
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass({
  scm_ArrayBuffer$$anon$1: 0
}, false, "scala.collection.mutable.ArrayBuffer$$anon$1", {
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayBuffer$$anon$1.prototype.$classData = $d_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$())
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
  /*<skip>*/
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass({
  scm_Buffer$: 0
}, false, "scala.collection.mutable.Buffer$", {
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Buffer$.prototype.$classData = $d_scm_Buffer$;
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$()
  };
  return $n_scm_Buffer$
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  $as_scm_HashMap(this.scm_GrowableBuilder__f_elems).sizeHint__I__V(size)
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass({
  scm_HashMap$$anon$6: 0
}, false, "scala.collection.mutable.HashMap$$anon$6", {
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashMap$$anon$6.prototype.$classData = $d_scm_HashMap$$anon$6;
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.scm_HashMap$HashMapIterator__f_$outer = outer
  };
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
  /*<skip>*/
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = this.scm_HashMap$HashMapIterator__f_$outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = this.scm_HashMap$HashMapIterator__f_node.scm_HashMap$Node__f__next;
    return r
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  $as_scm_HashSet(this.scm_GrowableBuilder__f_elems).sizeHint__I__V(size)
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass({
  scm_HashSet$$anon$4: 0
}, false, "scala.collection.mutable.HashSet$$anon$4", {
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashSet$$anon$4.prototype.$classData = $d_scm_HashSet$$anon$4;
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.scm_HashSet$HashSetIterator__f_$outer = outer
  };
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null
}
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
  /*<skip>*/
}
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = this.scm_HashSet$HashSetIterator__f_$outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(this.scm_HashSet$HashSetIterator__f_i);
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = this.scm_HashSet$HashSetIterator__f_node.scm_HashSet$Node__f__next;
    return r
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_empty = empty;
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
  /*<skip>*/
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
  /*<skip>*/
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass({
  scm_IndexedSeq$: 0
}, false, "scala.collection.mutable.IndexedSeq$", {
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_IndexedSeq$.prototype.$classData = $d_scm_IndexedSeq$;
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$()
  };
  return $n_scm_IndexedSeq$
}
/** @constructor */
function $c_scm_ListBuffer$() {
  /*<skip>*/
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
  /*<skip>*/
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems)
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer())
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer()
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source)
});
var $d_scm_ListBuffer$ = new $TypeData().initClass({
  scm_ListBuffer$: 0
}, false, "scala.collection.mutable.ListBuffer$", {
  scm_ListBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer$.prototype.$classData = $d_scm_ListBuffer$;
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$()
  };
  return $n_scm_ListBuffer$
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
  /*<skip>*/
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_MutationTracker$CheckedIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return this.scm_MutationTracker$CheckedIterator__f_underlying.hasNext__Z()
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return this.scm_MutationTracker$CheckedIterator__f_underlying.next__O()
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass({
  scm_MutationTracker$CheckedIterator: 0
}, false, "scala.collection.mutable.MutationTracker$CheckedIterator", {
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_MutationTracker$CheckedIterator.prototype.$classData = $d_scm_MutationTracker$CheckedIterator;
function $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz) {
  var this$1 = $thiz.scm_RedBlackTree$TreeIterator__f_end;
  if ((((!this$1.isEmpty__Z()) && ($thiz.scm_RedBlackTree$TreeIterator__f_nextNode !== null)) && ($thiz.scm_RedBlackTree$TreeIterator__f_ord.compare__O__O__I($thiz.scm_RedBlackTree$TreeIterator__f_nextNode.scm_RedBlackTree$Node__f_key, $thiz.scm_RedBlackTree$TreeIterator__f_end.get__O()) >= 0))) {
    $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = null
  }
}
function $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__($thiz, tree, start, end, ord) {
  $thiz.scm_RedBlackTree$TreeIterator__f_end = end;
  $thiz.scm_RedBlackTree$TreeIterator__f_ord = ord;
  var x = $m_s_None$();
  if ((x === start)) {
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root)
  } else if ((start instanceof $c_s_Some)) {
    var x3 = $as_s_Some(start);
    var from = x3.s_Some__f_value;
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root, from, ord)
  } else {
    var $$x1;
    throw new $c_s_MatchError(start)
  };
  $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = $$x1;
  $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz);
  return $thiz
}
/** @constructor */
function $c_scm_RedBlackTree$TreeIterator() {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null
}
$c_scm_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_RedBlackTree$TreeIterator.prototype.constructor = $c_scm_RedBlackTree$TreeIterator;
/** @constructor */
function $h_scm_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$TreeIterator.prototype = $c_scm_RedBlackTree$TreeIterator.prototype;
$c_scm_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.scm_RedBlackTree$TreeIterator__f_nextNode !== null)
});
$c_scm_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var x1 = this.scm_RedBlackTree$TreeIterator__f_nextNode;
  if ((x1 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  } else {
    this.scm_RedBlackTree$TreeIterator__f_nextNode = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(x1);
    $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V(this);
    return x1.scm_RedBlackTree$Node__f_key
  }
});
/** @constructor */
function $c_scm_TreeSet$$anon$1(ordering$1) {
  this.scm_TreeSet$$anon$1__f_tree = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = ordering$1;
  this.scm_TreeSet$$anon$1__f_tree = new $c_scm_RedBlackTree$Tree(null, 0)
}
$c_scm_TreeSet$$anon$1.prototype = new $h_O();
$c_scm_TreeSet$$anon$1.prototype.constructor = $c_scm_TreeSet$$anon$1;
/** @constructor */
function $h_scm_TreeSet$$anon$1() {
  /*<skip>*/
}
$h_scm_TreeSet$$anon$1.prototype = $c_scm_TreeSet$$anon$1.prototype;
$c_scm_TreeSet$$anon$1.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_TreeSet$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_TreeSet$$anon$1 = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet$$anon$1__f_tree, elem, null, this.scm_TreeSet$$anon$1__f_ordering$1);
  return this
});
$c_scm_TreeSet$$anon$1.prototype.result__scm_TreeSet = (function() {
  return new $c_scm_TreeSet(this.scm_TreeSet$$anon$1__f_tree, this.scm_TreeSet$$anon$1__f_ordering$1)
});
$c_scm_TreeSet$$anon$1.prototype.result__O = (function() {
  return this.result__scm_TreeSet()
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet$$anon$1(elem)
});
var $d_scm_TreeSet$$anon$1 = new $TypeData().initClass({
  scm_TreeSet$$anon$1: 0
}, false, "scala.collection.mutable.TreeSet$$anon$1", {
  scm_TreeSet$$anon$1: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_TreeSet$$anon$1.prototype.$classData = $d_scm_TreeSet$$anon$1;
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
  };
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    var x2 = $as_s_concurrent_duration_Duration$Infinite(other);
    if ((x2 !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
    }
  };
  return this
});
function $as_s_concurrent_duration_Duration$Infinite(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration$Infinite) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration$Infinite"))
}
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)))
}
function $asArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration$Infinite;", depth))
}
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var lo = max.RTLong__f_lo;
  var hi = max.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi$1 === bhi) ? (((-2147483648) ^ lo$1) <= ((-2147483648) ^ b.RTLong__f_lo)) : (hi$1 < bhi))) {
    var this$3 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = this$3.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? (((-2147483648) ^ this$3.RTLong__f_lo) <= ((-2147483648) ^ max.RTLong__f_lo)) : (ahi < bhi$1))
  } else {
    return false
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $$x1 = $as_T($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName.apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var this$1 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($$x1 + (((this$1.RTLong__f_lo === 1) && (this$1.RTLong__f_hi === 0)) ? "" : "s"))
}
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var bhi = b.RTLong__f_hi;
    var lo = (((-1) - b.RTLong__f_lo) | 0);
    var hi = ((2147483647 - bhi) | 0);
    var ahi$1 = a.RTLong__f_hi;
    var $$x2 = ((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    if ((ahi$2 < 0)) {
      var bhi$1 = b.RTLong__f_hi;
      var lo$1 = ((-b.RTLong__f_lo) | 0);
      var hi$1 = ((lo$1 !== 0) ? ((2147483647 - bhi$1) | 0) : (((-2147483648) - bhi$1) | 0));
      var ahi$3 = a.RTLong__f_hi;
      var $$x1 = ((ahi$3 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$3 < hi$1))
    } else {
      var $$x1 = false
    }
  };
  if ($$x1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow")
  };
  var alo = a.RTLong__f_lo;
  var ahi$4 = a.RTLong__f_hi;
  var bhi$2 = b.RTLong__f_hi;
  var lo$2 = ((alo + b.RTLong__f_lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi$4 + bhi$2) | 0)) | 0) : ((ahi$4 + bhi$2) | 0));
  return new $c_RTLong(lo$2, hi$2)
}
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength, otherUnit) {
  var this$1 = otherUnit.convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit
  } else {
    var commonUnit = otherUnit
  };
  var t = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, commonUnit.convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length, $thiz.s_concurrent_duration_FiniteDuration__f_unit), commonUnit.convert__J__ju_concurrent_TimeUnit__J(otherLength, otherUnit));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), commonUnit)
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === unit)) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647))
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === unit)) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483))
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === unit)) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147))
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === unit)) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2))
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === unit)) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0))
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === unit)) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0))
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === unit)) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0))
              } else {
                var t = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS.convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? (((-2147483648) ^ lo) >= 2147376897) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-2147376897)) : (hi < 0)))
              }
            }
          }
        }
      }
    }
  };
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)")
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
  /*<skip>*/
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this))
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var t = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var t$1 = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$2.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    var t$4 = $uJ(new $c_RTLong(lo$3, hi$3));
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var t$5 = $uJ(new $c_RTLong(lo$1, hi$1));
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5)
  } else {
    return ((-other.compare__s_concurrent_duration_Duration__I(this)) | 0)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, x2.s_concurrent_duration_FiniteDuration__f_length, x2.s_concurrent_duration_FiniteDuration__f_unit)
  } else {
    return other
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var b = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return (this === other)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"))
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)))
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth))
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass({
  s_concurrent_duration_FiniteDuration: 0
}, false, "scala.concurrent.duration.FiniteDuration", {
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_FiniteDuration.prototype.$classData = $d_s_concurrent_duration_FiniteDuration;
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) <= 0)
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x2 = $as_s_math_Ordering$Reverse(other);
    var x = x2.s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && x.equals__O__Z($thiz))
  } else {
    return false
  }
}
function $is_s_math_Ordering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering)))
}
function $as_s_math_Ordering(obj) {
  return (($is_s_math_Ordering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering"))
}
function $isArrayOf_s_math_Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering)))
}
function $asArrayOf_s_math_Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering;", depth))
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $as_s_reflect_ClassTag(x).runtimeClass__jl_Class();
    return (x$2 === x$3)
  } else {
    return false
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return (clazz.isArray__Z() ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz.getComponentType__jl_Class())) + "]") : clazz.getName__T())
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)))
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"))
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)))
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth))
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = x$2.productArity__I()
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax)
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = this.sr_ScalaRunTime$$anon$1__f_x$2.productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass({
  sr_ScalaRunTime$$anon$1: 0
}, false, "scala.runtime.ScalaRunTime$$anon$1", {
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sr_ScalaRunTime$$anon$1.prototype.$classData = $d_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $c_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems)
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source)).result__O())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source)
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass({
  sjs_js_WrappedArray$: 0
}, false, "scala.scalajs.js.WrappedArray$", {
  sjs_js_WrappedArray$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray$.prototype.$classData = $d_sjs_js_WrappedArray$;
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$()
  };
  return $n_sjs_js_WrappedArray$
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = this.newBuilder__scm_Builder();
  return $as_sjsr_WrappedVarArgs($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source)).result__O())
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((x$1$2) => {
    var x$1 = $as_sjs_js_WrappedArray(x$1$2);
    return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array)
  }))(this));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source)
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs())
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass({
  sjsr_WrappedVarArgs$: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs$", {
  sjsr_WrappedVarArgs$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs$.prototype.$classData = $d_sjsr_WrappedVarArgs$;
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$()
  };
  return $n_sjsr_WrappedVarArgs$
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
  /*<skip>*/
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.getOrElse__F0__O = (function(default$1) {
  return default$1.apply__O()
});
$c_s_util_Failure.prototype.orElse__F0__s_util_Try = (function(default$1) {
  try {
    return $as_s_util_Try(default$1.apply__O())
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.flatMap__F1__s_util_Try = (function(f) {
  return this
});
$c_s_util_Failure.prototype.map__F1__s_util_Try = (function(f) {
  return this
});
$c_s_util_Failure.prototype.recoverWith__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1(((this$2, marker$1) => ((x$2) => {
      $as_jl_Throwable(x$2);
      return marker$1
    }))(this, marker)));
    return ((marker !== v) ? $as_s_util_Try(v) : this)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$()
});
$c_s_util_Failure.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Left(this.s_util_Failure__f_exception)
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure"
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = Failure$1.s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"))
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)))
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth))
}
var $d_s_util_Failure = new $TypeData().initClass({
  s_util_Failure: 0
}, false, "scala.util.Failure", {
  s_util_Failure: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Failure.prototype.$classData = $d_s_util_Failure;
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value
}
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
  /*<skip>*/
}
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.isRight__Z = (function() {
  return false
});
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left"
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Left)) {
    var Left$1 = $as_s_util_Left(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, Left$1.s_util_Left__f_value)
  } else {
    return false
  }
});
function $as_s_util_Left(obj) {
  return (((obj instanceof $c_s_util_Left) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Left"))
}
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)))
}
function $asArrayOf_s_util_Left(obj, depth) {
  return (($isArrayOf_s_util_Left(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Left;", depth))
}
var $d_s_util_Left = new $TypeData().initClass({
  s_util_Left: 0
}, false, "scala.util.Left", {
  s_util_Left: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left.prototype.$classData = $d_s_util_Left;
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value
}
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
  /*<skip>*/
}
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.isRight__Z = (function() {
  return true
});
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right"
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Right)) {
    var Right$1 = $as_s_util_Right(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, Right$1.s_util_Right__f_value)
  } else {
    return false
  }
});
function $as_s_util_Right(obj) {
  return (((obj instanceof $c_s_util_Right) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Right"))
}
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)))
}
function $asArrayOf_s_util_Right(obj, depth) {
  return (($isArrayOf_s_util_Right(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Right;", depth))
}
var $d_s_util_Right = new $TypeData().initClass({
  s_util_Right: 0
}, false, "scala.util.Right", {
  s_util_Right: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right.prototype.$classData = $d_s_util_Right;
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
  /*<skip>*/
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.getOrElse__F0__O = (function(default$1) {
  return this.s_util_Success__f_value
});
$c_s_util_Success.prototype.orElse__F0__s_util_Try = (function(default$1) {
  return this
});
$c_s_util_Success.prototype.flatMap__F1__s_util_Try = (function(f) {
  try {
    return $as_s_util_Try(f.apply__O__O(this.s_util_Success__f_value))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.map__F1__s_util_Try = (function(f) {
  try {
    return new $c_s_util_Success(f.apply__O__O(this.s_util_Success__f_value))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.recoverWith__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Right(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, Success$1.s_util_Success__f_value)
  } else {
    return false
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"))
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)))
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth))
}
var $d_s_util_Success = new $TypeData().initClass({
  s_util_Success: 0
}, false, "scala.util.Success", {
  s_util_Success: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Success.prototype.$classData = $d_s_util_Success;
/** @constructor */
function $c_Lsnabbdom_VNodeParam$Node(vnode) {
  this.Lsnabbdom_VNodeParam$Node__f_vnode = null;
  this.Lsnabbdom_VNodeParam$Node__f_vnode = vnode
}
$c_Lsnabbdom_VNodeParam$Node.prototype = new $h_O();
$c_Lsnabbdom_VNodeParam$Node.prototype.constructor = $c_Lsnabbdom_VNodeParam$Node;
/** @constructor */
function $h_Lsnabbdom_VNodeParam$Node() {
  /*<skip>*/
}
$h_Lsnabbdom_VNodeParam$Node.prototype = $c_Lsnabbdom_VNodeParam$Node.prototype;
$c_Lsnabbdom_VNodeParam$Node.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lsnabbdom_VNodeParam$Node.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsnabbdom_VNodeParam$Node.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lsnabbdom_VNodeParam$Node)) {
    var x$0$2 = $as_Lsnabbdom_VNodeParam$Node(x$0);
    var x = this.Lsnabbdom_VNodeParam$Node__f_vnode;
    var y = x$0$2.Lsnabbdom_VNodeParam$Node__f_vnode;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lsnabbdom_VNodeParam$Node.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsnabbdom_VNodeParam$Node.prototype.productArity__I = (function() {
  return 1
});
$c_Lsnabbdom_VNodeParam$Node.prototype.productPrefix__T = (function() {
  return "Node"
});
$c_Lsnabbdom_VNodeParam$Node.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_VNodeParam$Node__f_vnode
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lsnabbdom_VNodeParam$Node.prototype.asVnodes__sci_List = (function() {
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsnabbdom_VNode.getArrayOf().constr)([this.Lsnabbdom_VNodeParam$Node__f_vnode]));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
function $as_Lsnabbdom_VNodeParam$Node(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNodeParam$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeParam$Node"))
}
function $isArrayOf_Lsnabbdom_VNodeParam$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeParam$Node)))
}
function $asArrayOf_Lsnabbdom_VNodeParam$Node(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeParam$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeParam$Node;", depth))
}
var $d_Lsnabbdom_VNodeParam$Node = new $TypeData().initClass({
  Lsnabbdom_VNodeParam$Node: 0
}, false, "snabbdom.VNodeParam$Node", {
  Lsnabbdom_VNodeParam$Node: 1,
  O: 1,
  Lsnabbdom_VNodeParam: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_VNodeParam$Node.prototype.$classData = $d_Lsnabbdom_VNodeParam$Node;
/** @constructor */
function $c_Lsnabbdom_VNodeParam$Text(s) {
  this.Lsnabbdom_VNodeParam$Text__f_s = null;
  this.Lsnabbdom_VNodeParam$Text__f_s = s
}
$c_Lsnabbdom_VNodeParam$Text.prototype = new $h_O();
$c_Lsnabbdom_VNodeParam$Text.prototype.constructor = $c_Lsnabbdom_VNodeParam$Text;
/** @constructor */
function $h_Lsnabbdom_VNodeParam$Text() {
  /*<skip>*/
}
$h_Lsnabbdom_VNodeParam$Text.prototype = $c_Lsnabbdom_VNodeParam$Text.prototype;
$c_Lsnabbdom_VNodeParam$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lsnabbdom_VNodeParam$Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsnabbdom_VNodeParam$Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lsnabbdom_VNodeParam$Text)) {
    var x$0$2 = $as_Lsnabbdom_VNodeParam$Text(x$0);
    return (this.Lsnabbdom_VNodeParam$Text__f_s === x$0$2.Lsnabbdom_VNodeParam$Text__f_s)
  } else {
    return false
  }
});
$c_Lsnabbdom_VNodeParam$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsnabbdom_VNodeParam$Text.prototype.productArity__I = (function() {
  return 1
});
$c_Lsnabbdom_VNodeParam$Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Lsnabbdom_VNodeParam$Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_VNodeParam$Text__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lsnabbdom_VNodeParam$Text.prototype.asVnodes__sci_List = (function() {
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([this.Lsnabbdom_VNodeParam$Text__f_s]));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
function $as_Lsnabbdom_VNodeParam$Text(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNodeParam$Text) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeParam$Text"))
}
function $isArrayOf_Lsnabbdom_VNodeParam$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeParam$Text)))
}
function $asArrayOf_Lsnabbdom_VNodeParam$Text(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeParam$Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeParam$Text;", depth))
}
var $d_Lsnabbdom_VNodeParam$Text = new $TypeData().initClass({
  Lsnabbdom_VNodeParam$Text: 0
}, false, "snabbdom.VNodeParam$Text", {
  Lsnabbdom_VNodeParam$Text: 1,
  O: 1,
  Lsnabbdom_VNodeParam: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_VNodeParam$Text.prototype.$classData = $d_Lsnabbdom_VNodeParam$Text;
/** @constructor */
function $c_Lsquants_time_Days$() {
  this.Lsquants_time_Days$__f_conversionFactor = 0.0;
  this.Lsquants_time_Days$__f_symbol = null;
  $n_Lsquants_time_Days$ = this;
  this.Lsquants_time_Days$__f_conversionFactor = ($m_Lsquants_time_Hours$().Lsquants_time_Hours$__f_conversionFactor * $m_Lsquants_time_Time$().Lsquants_time_Time$__f_HoursPerDay);
  this.Lsquants_time_Days$__f_symbol = "d"
}
$c_Lsquants_time_Days$.prototype = new $h_O();
$c_Lsquants_time_Days$.prototype.constructor = $c_Lsquants_time_Days$;
/** @constructor */
function $h_Lsquants_time_Days$() {
  /*<skip>*/
}
$h_Lsquants_time_Days$.prototype = $c_Lsquants_time_Days$.prototype;
$c_Lsquants_time_Days$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterTo__F1(this)
});
$c_Lsquants_time_Days$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterFrom__F1(this)
});
$c_Lsquants_time_Days$.prototype.conversionFactor__D = (function() {
  return this.Lsquants_time_Days$__f_conversionFactor
});
$c_Lsquants_time_Days$.prototype.symbol__T = (function() {
  return this.Lsquants_time_Days$__f_symbol
});
var $d_Lsquants_time_Days$ = new $TypeData().initClass({
  Lsquants_time_Days$: 0
}, false, "squants.time.Days$", {
  Lsquants_time_Days$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_time_TimeUnit: 1
});
$c_Lsquants_time_Days$.prototype.$classData = $d_Lsquants_time_Days$;
var $n_Lsquants_time_Days$;
function $m_Lsquants_time_Days$() {
  if ((!$n_Lsquants_time_Days$)) {
    $n_Lsquants_time_Days$ = new $c_Lsquants_time_Days$()
  };
  return $n_Lsquants_time_Days$
}
/** @constructor */
function $c_Lsquants_time_Hours$() {
  this.Lsquants_time_Hours$__f_conversionFactor = 0.0;
  this.Lsquants_time_Hours$__f_symbol = null;
  $n_Lsquants_time_Hours$ = this;
  this.Lsquants_time_Hours$__f_conversionFactor = ($m_Lsquants_time_Minutes$().Lsquants_time_Minutes$__f_conversionFactor * $m_Lsquants_time_Time$().Lsquants_time_Time$__f_MinutesPerHour);
  this.Lsquants_time_Hours$__f_symbol = "h"
}
$c_Lsquants_time_Hours$.prototype = new $h_O();
$c_Lsquants_time_Hours$.prototype.constructor = $c_Lsquants_time_Hours$;
/** @constructor */
function $h_Lsquants_time_Hours$() {
  /*<skip>*/
}
$h_Lsquants_time_Hours$.prototype = $c_Lsquants_time_Hours$.prototype;
$c_Lsquants_time_Hours$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterTo__F1(this)
});
$c_Lsquants_time_Hours$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterFrom__F1(this)
});
$c_Lsquants_time_Hours$.prototype.conversionFactor__D = (function() {
  return this.Lsquants_time_Hours$__f_conversionFactor
});
$c_Lsquants_time_Hours$.prototype.symbol__T = (function() {
  return this.Lsquants_time_Hours$__f_symbol
});
var $d_Lsquants_time_Hours$ = new $TypeData().initClass({
  Lsquants_time_Hours$: 0
}, false, "squants.time.Hours$", {
  Lsquants_time_Hours$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_time_TimeUnit: 1
});
$c_Lsquants_time_Hours$.prototype.$classData = $d_Lsquants_time_Hours$;
var $n_Lsquants_time_Hours$;
function $m_Lsquants_time_Hours$() {
  if ((!$n_Lsquants_time_Hours$)) {
    $n_Lsquants_time_Hours$ = new $c_Lsquants_time_Hours$()
  };
  return $n_Lsquants_time_Hours$
}
/** @constructor */
function $c_Lsquants_time_Minutes$() {
  this.Lsquants_time_Minutes$__f_conversionFactor = 0.0;
  this.Lsquants_time_Minutes$__f_symbol = null;
  $n_Lsquants_time_Minutes$ = this;
  this.Lsquants_time_Minutes$__f_conversionFactor = ($m_Lsquants_time_Seconds$().Lsquants_time_Seconds$__f_conversionFactor * $m_Lsquants_time_Time$().Lsquants_time_Time$__f_SecondsPerMinute);
  this.Lsquants_time_Minutes$__f_symbol = "min"
}
$c_Lsquants_time_Minutes$.prototype = new $h_O();
$c_Lsquants_time_Minutes$.prototype.constructor = $c_Lsquants_time_Minutes$;
/** @constructor */
function $h_Lsquants_time_Minutes$() {
  /*<skip>*/
}
$h_Lsquants_time_Minutes$.prototype = $c_Lsquants_time_Minutes$.prototype;
$c_Lsquants_time_Minutes$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterTo__F1(this)
});
$c_Lsquants_time_Minutes$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterFrom__F1(this)
});
$c_Lsquants_time_Minutes$.prototype.conversionFactor__D = (function() {
  return this.Lsquants_time_Minutes$__f_conversionFactor
});
$c_Lsquants_time_Minutes$.prototype.symbol__T = (function() {
  return this.Lsquants_time_Minutes$__f_symbol
});
var $d_Lsquants_time_Minutes$ = new $TypeData().initClass({
  Lsquants_time_Minutes$: 0
}, false, "squants.time.Minutes$", {
  Lsquants_time_Minutes$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_time_TimeUnit: 1
});
$c_Lsquants_time_Minutes$.prototype.$classData = $d_Lsquants_time_Minutes$;
var $n_Lsquants_time_Minutes$;
function $m_Lsquants_time_Minutes$() {
  if ((!$n_Lsquants_time_Minutes$)) {
    $n_Lsquants_time_Minutes$ = new $c_Lsquants_time_Minutes$()
  };
  return $n_Lsquants_time_Minutes$
}
/** @constructor */
function $c_Lsquants_time_Time(value, unit) {
  this.Lsquants_time_Time__f_value = 0.0;
  this.Lsquants_time_Time__f_unit = null;
  this.Lsquants_time_Time__f_value = value;
  this.Lsquants_time_Time__f_unit = unit
}
$c_Lsquants_time_Time.prototype = new $h_Lsquants_Quantity();
$c_Lsquants_time_Time.prototype.constructor = $c_Lsquants_time_Time;
/** @constructor */
function $h_Lsquants_time_Time() {
  /*<skip>*/
}
$h_Lsquants_time_Time.prototype = $c_Lsquants_time_Time.prototype;
function $as_Lsquants_time_Time(obj) {
  return (((obj instanceof $c_Lsquants_time_Time) || (obj === null)) ? obj : $throwClassCastException(obj, "squants.time.Time"))
}
function $isArrayOf_Lsquants_time_Time(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_time_Time)))
}
function $asArrayOf_Lsquants_time_Time(obj, depth) {
  return (($isArrayOf_Lsquants_time_Time(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsquants.time.Time;", depth))
}
var $d_Lsquants_time_Time = new $TypeData().initClass({
  Lsquants_time_Time: 0
}, false, "squants.time.Time", {
  Lsquants_time_Time: 1,
  Lsquants_Quantity: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1
});
$c_Lsquants_time_Time.prototype.$classData = $d_Lsquants_time_Time;
/** @constructor */
function $c_Ltyrian_Attribute(name, value) {
  this.Ltyrian_Attribute__f_name = null;
  this.Ltyrian_Attribute__f_value = null;
  this.Ltyrian_Attribute__f_name = name;
  this.Ltyrian_Attribute__f_value = value
}
$c_Ltyrian_Attribute.prototype = new $h_O();
$c_Ltyrian_Attribute.prototype.constructor = $c_Ltyrian_Attribute;
/** @constructor */
function $h_Ltyrian_Attribute() {
  /*<skip>*/
}
$h_Ltyrian_Attribute.prototype = $c_Ltyrian_Attribute.prototype;
$c_Ltyrian_Attribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Attribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Attribute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Attribute)) {
    var x$0$2 = $as_Ltyrian_Attribute(x$0);
    return ((this.Ltyrian_Attribute__f_name === x$0$2.Ltyrian_Attribute__f_name) && (this.Ltyrian_Attribute__f_value === x$0$2.Ltyrian_Attribute__f_value))
  } else {
    return false
  }
});
$c_Ltyrian_Attribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Attribute.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Attribute.prototype.productPrefix__T = (function() {
  return "Attribute"
});
$c_Ltyrian_Attribute.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Attribute__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Attribute__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Attribute(obj) {
  return (((obj instanceof $c_Ltyrian_Attribute) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attribute"))
}
function $isArrayOf_Ltyrian_Attribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attribute)))
}
function $asArrayOf_Ltyrian_Attribute(obj, depth) {
  return (($isArrayOf_Ltyrian_Attribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attribute;", depth))
}
var $d_Ltyrian_Attribute = new $TypeData().initClass({
  Ltyrian_Attribute: 0
}, false, "tyrian.Attribute", {
  Ltyrian_Attribute: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Attribute.prototype.$classData = $d_Ltyrian_Attribute;
/** @constructor */
function $c_Ltyrian_Cmd$Batch(cmds) {
  this.Ltyrian_Cmd$Batch__f_cmds = null;
  this.Ltyrian_Cmd$Batch__f_cmds = cmds
}
$c_Ltyrian_Cmd$Batch.prototype = new $h_O();
$c_Ltyrian_Cmd$Batch.prototype.constructor = $c_Ltyrian_Cmd$Batch;
/** @constructor */
function $h_Ltyrian_Cmd$Batch() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Batch.prototype = $c_Ltyrian_Cmd$Batch.prototype;
$c_Ltyrian_Cmd$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Batch)) {
    var x$0$2 = $as_Ltyrian_Cmd$Batch(x$0);
    var x = this.Ltyrian_Cmd$Batch__f_cmds;
    var x$2 = x$0$2.Ltyrian_Cmd$Batch__f_cmds;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Batch.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$Batch.prototype.productPrefix__T = (function() {
  return "Batch"
});
$c_Ltyrian_Cmd$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Batch__f_cmds
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Batch"))
}
function $isArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Batch)))
}
function $asArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Batch;", depth))
}
var $d_Ltyrian_Cmd$Batch = new $TypeData().initClass({
  Ltyrian_Cmd$Batch: 0
}, false, "tyrian.Cmd$Batch", {
  Ltyrian_Cmd$Batch: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Batch.prototype.$classData = $d_Ltyrian_Cmd$Batch;
function $as_Ltyrian_Cmd$Combine(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Combine"))
}
function $isArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Combine)))
}
function $asArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Combine;", depth))
}
/** @constructor */
function $c_Ltyrian_Cmd$Emit(msg) {
  this.Ltyrian_Cmd$Emit__f_msg = null;
  this.Ltyrian_Cmd$Emit__f_msg = msg
}
$c_Ltyrian_Cmd$Emit.prototype = new $h_O();
$c_Ltyrian_Cmd$Emit.prototype.constructor = $c_Ltyrian_Cmd$Emit;
/** @constructor */
function $h_Ltyrian_Cmd$Emit() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Emit.prototype = $c_Ltyrian_Cmd$Emit.prototype;
$c_Ltyrian_Cmd$Emit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Emit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Emit.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Emit)) {
    var x$0$2 = $as_Ltyrian_Cmd$Emit(x$0);
    var x = this.Ltyrian_Cmd$Emit__f_msg;
    var y = x$0$2.Ltyrian_Cmd$Emit__f_msg;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Emit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Emit.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$Emit.prototype.productPrefix__T = (function() {
  return "Emit"
});
$c_Ltyrian_Cmd$Emit.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Emit__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Emit(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Emit) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Emit"))
}
function $isArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Emit)))
}
function $asArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Emit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Emit;", depth))
}
var $d_Ltyrian_Cmd$Emit = new $TypeData().initClass({
  Ltyrian_Cmd$Emit: 0
}, false, "tyrian.Cmd$Emit", {
  Ltyrian_Cmd$Emit: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Emit.prototype.$classData = $d_Ltyrian_Cmd$Emit;
/** @constructor */
function $c_Ltyrian_Cmd$Run(observable, toMessage) {
  this.Ltyrian_Cmd$Run__f_observable = null;
  this.Ltyrian_Cmd$Run__f_toMessage = null;
  this.Ltyrian_Cmd$Run__f_observable = observable;
  this.Ltyrian_Cmd$Run__f_toMessage = toMessage
}
$c_Ltyrian_Cmd$Run.prototype = new $h_O();
$c_Ltyrian_Cmd$Run.prototype.constructor = $c_Ltyrian_Cmd$Run;
/** @constructor */
function $h_Ltyrian_Cmd$Run() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Run.prototype = $c_Ltyrian_Cmd$Run.prototype;
$c_Ltyrian_Cmd$Run.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Run.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Run.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Run)) {
    var x$0$2 = $as_Ltyrian_Cmd$Run(x$0);
    var x = this.Ltyrian_Cmd$Run__f_observable;
    var x$2 = x$0$2.Ltyrian_Cmd$Run__f_observable;
    if ((x === x$2)) {
      var x$3 = this.Ltyrian_Cmd$Run__f_toMessage;
      var x$4 = x$0$2.Ltyrian_Cmd$Run__f_toMessage;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Run.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Run.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Cmd$Run.prototype.productPrefix__T = (function() {
  return "Run"
});
$c_Ltyrian_Cmd$Run.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Run__f_observable
  };
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Run__f_toMessage
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Run(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Run) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Run"))
}
function $isArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Run)))
}
function $asArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Run(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Run;", depth))
}
var $d_Ltyrian_Cmd$Run = new $TypeData().initClass({
  Ltyrian_Cmd$Run: 0
}, false, "tyrian.Cmd$Run", {
  Ltyrian_Cmd$Run: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Run.prototype.$classData = $d_Ltyrian_Cmd$Run;
/** @constructor */
function $c_Ltyrian_Cmd$RunTask(task, toMessage) {
  this.Ltyrian_Cmd$RunTask__f_task = null;
  this.Ltyrian_Cmd$RunTask__f_toMessage = null;
  this.Ltyrian_Cmd$RunTask__f_task = task;
  this.Ltyrian_Cmd$RunTask__f_toMessage = toMessage
}
$c_Ltyrian_Cmd$RunTask.prototype = new $h_O();
$c_Ltyrian_Cmd$RunTask.prototype.constructor = $c_Ltyrian_Cmd$RunTask;
/** @constructor */
function $h_Ltyrian_Cmd$RunTask() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$RunTask.prototype = $c_Ltyrian_Cmd$RunTask.prototype;
$c_Ltyrian_Cmd$RunTask.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$RunTask.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$RunTask.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$RunTask)) {
    var x$0$2 = $as_Ltyrian_Cmd$RunTask(x$0);
    var x = this.Ltyrian_Cmd$RunTask__f_task;
    var x$2 = x$0$2.Ltyrian_Cmd$RunTask__f_task;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Cmd$RunTask__f_toMessage;
      var x$4 = x$0$2.Ltyrian_Cmd$RunTask__f_toMessage;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$RunTask.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$RunTask.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Cmd$RunTask.prototype.productPrefix__T = (function() {
  return "RunTask"
});
$c_Ltyrian_Cmd$RunTask.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$RunTask__f_task
  };
  if ((n === 1)) {
    return this.Ltyrian_Cmd$RunTask__f_toMessage
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_Cmd$RunTask.prototype.map__F1__Ltyrian_Cmd$RunTask = (function(f) {
  var task = this.Ltyrian_Cmd$RunTask__f_task;
  var toMessage = this.Ltyrian_Cmd$RunTask__f_toMessage.andThen__F1__F1(f);
  return new $c_Ltyrian_Cmd$RunTask(task, toMessage)
});
function $as_Ltyrian_Cmd$RunTask(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$RunTask) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$RunTask"))
}
function $isArrayOf_Ltyrian_Cmd$RunTask(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$RunTask)))
}
function $asArrayOf_Ltyrian_Cmd$RunTask(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$RunTask(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$RunTask;", depth))
}
var $d_Ltyrian_Cmd$RunTask = new $TypeData().initClass({
  Ltyrian_Cmd$RunTask: 0
}, false, "tyrian.Cmd$RunTask", {
  Ltyrian_Cmd$RunTask: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$RunTask.prototype.$classData = $d_Ltyrian_Cmd$RunTask;
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect(task) {
  this.Ltyrian_Cmd$SideEffect__f_task = null;
  this.Ltyrian_Cmd$SideEffect__f_task = task
}
$c_Ltyrian_Cmd$SideEffect.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect.prototype.constructor = $c_Ltyrian_Cmd$SideEffect;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$SideEffect.prototype = $c_Ltyrian_Cmd$SideEffect.prototype;
$c_Ltyrian_Cmd$SideEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$SideEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$SideEffect.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$SideEffect)) {
    var x$0$2 = $as_Ltyrian_Cmd$SideEffect(x$0);
    var x = this.Ltyrian_Cmd$SideEffect__f_task;
    var x$2 = x$0$2.Ltyrian_Cmd$SideEffect__f_task;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$SideEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$SideEffect.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$SideEffect.prototype.productPrefix__T = (function() {
  return "SideEffect"
});
$c_Ltyrian_Cmd$SideEffect.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$SideEffect__f_task
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$SideEffect(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$SideEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$SideEffect"))
}
function $isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$SideEffect)))
}
function $asArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$SideEffect;", depth))
}
var $d_Ltyrian_Cmd$SideEffect = new $TypeData().initClass({
  Ltyrian_Cmd$SideEffect: 0
}, false, "tyrian.Cmd$SideEffect", {
  Ltyrian_Cmd$SideEffect: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$SideEffect.prototype.$classData = $d_Ltyrian_Cmd$SideEffect;
/** @constructor */
function $c_Ltyrian_Event(name, msg) {
  this.Ltyrian_Event__f_name = null;
  this.Ltyrian_Event__f_msg = null;
  this.Ltyrian_Event__f_name = name;
  this.Ltyrian_Event__f_msg = msg
}
$c_Ltyrian_Event.prototype = new $h_O();
$c_Ltyrian_Event.prototype.constructor = $c_Ltyrian_Event;
/** @constructor */
function $h_Ltyrian_Event() {
  /*<skip>*/
}
$h_Ltyrian_Event.prototype = $c_Ltyrian_Event.prototype;
$c_Ltyrian_Event.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Event.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Event.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Event)) {
    var x$0$2 = $as_Ltyrian_Event(x$0);
    if ((this.Ltyrian_Event__f_name === x$0$2.Ltyrian_Event__f_name)) {
      var x = this.Ltyrian_Event__f_msg;
      var x$2 = x$0$2.Ltyrian_Event__f_msg;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Event.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Event.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Event.prototype.productPrefix__T = (function() {
  return "Event"
});
$c_Ltyrian_Event.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Event__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Event__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Event(obj) {
  return (((obj instanceof $c_Ltyrian_Event) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Event"))
}
function $isArrayOf_Ltyrian_Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Event)))
}
function $asArrayOf_Ltyrian_Event(obj, depth) {
  return (($isArrayOf_Ltyrian_Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Event;", depth))
}
var $d_Ltyrian_Event = new $TypeData().initClass({
  Ltyrian_Event: 0
}, false, "tyrian.Event", {
  Ltyrian_Event: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Event.prototype.$classData = $d_Ltyrian_Event;
/** @constructor */
function $c_Ltyrian_Html$() {
  this.Ltyrian_Html$__f_accept$minusString = null;
  this.Ltyrian_Html$__f_accessKey$minusString = null;
  this.Ltyrian_Html$__f_action$minusString = null;
  this.Ltyrian_Html$__f_alt$minusString = null;
  this.Ltyrian_Html$__f_autoComplete$minusString = null;
  this.Ltyrian_Html$__f_charset$minusString = null;
  this.Ltyrian_Html$__f_cite$minusString = null;
  this.Ltyrian_Html$__f_$u0060class$u0060$minusString = null;
  this.Ltyrian_Html$__f_cls$minusString = null;
  this.Ltyrian_Html$__f_className$minusString = null;
  this.Ltyrian_Html$__f__class$minusString = null;
  this.Ltyrian_Html$__f_cols$minusString = null;
  this.Ltyrian_Html$__f_cols$minusInt = null;
  this.Ltyrian_Html$__f_colSpan$minusString = null;
  this.Ltyrian_Html$__f_colSpan$minusInt = null;
  this.Ltyrian_Html$__f_content$minusString = null;
  this.Ltyrian_Html$__f_contentEditable$minusString = null;
  this.Ltyrian_Html$__f_contentEditable$minusBoolean = null;
  this.Ltyrian_Html$__f_coords$minusString = null;
  this.Ltyrian_Html$__f_data$minusString = null;
  this.Ltyrian_Html$__f_dateTime$minusString = null;
  this.Ltyrian_Html$__f_dir$minusString = null;
  this.Ltyrian_Html$__f_dirname$minusString = null;
  this.Ltyrian_Html$__f_draggable$minusString = null;
  this.Ltyrian_Html$__f_draggable$minusBoolean = null;
  this.Ltyrian_Html$__f_encType$minusString = null;
  this.Ltyrian_Html$__f_forId$minusString = null;
  this.Ltyrian_Html$__f_htmlFor$minusString = null;
  this.Ltyrian_Html$__f_form$minusString = null;
  this.Ltyrian_Html$__f_formAction$minusString = null;
  this.Ltyrian_Html$__f_headers$minusString = null;
  this.Ltyrian_Html$__f_height$minusString = null;
  this.Ltyrian_Html$__f_height$minusInt = null;
  this.Ltyrian_Html$__f_high$minusString = null;
  this.Ltyrian_Html$__f_high$minusDouble = null;
  this.Ltyrian_Html$__f_href$minusString = null;
  this.Ltyrian_Html$__f_hrefLang$minusString = null;
  this.Ltyrian_Html$__f_http$minusString = null;
  this.Ltyrian_Html$__f_id$minusString = null;
  this.Ltyrian_Html$__f_kind$minusString = null;
  this.Ltyrian_Html$__f_label$minusString = null;
  this.Ltyrian_Html$__f_lang$minusString = null;
  this.Ltyrian_Html$__f_list$minusString = null;
  this.Ltyrian_Html$__f_low$minusString = null;
  this.Ltyrian_Html$__f_low$minusDouble = null;
  this.Ltyrian_Html$__f_max$minusString = null;
  this.Ltyrian_Html$__f_max$minusInt = null;
  this.Ltyrian_Html$__f_maxLength$minusString = null;
  this.Ltyrian_Html$__f_maxLength$minusInt = null;
  this.Ltyrian_Html$__f_media$minusString = null;
  this.Ltyrian_Html$__f_method$minusString = null;
  this.Ltyrian_Html$__f_min$minusString = null;
  this.Ltyrian_Html$__f_min$minusInt = null;
  this.Ltyrian_Html$__f_multiple$minusString = null;
  this.Ltyrian_Html$__f_muted$minusString = null;
  this.Ltyrian_Html$__f_name$minusString = null;
  this.Ltyrian_Html$__f_optimum$minusString = null;
  this.Ltyrian_Html$__f_optimum$minusDouble = null;
  this.Ltyrian_Html$__f_pattern$minusString = null;
  this.Ltyrian_Html$__f_placeholder$minusString = null;
  this.Ltyrian_Html$__f_poster$minusString = null;
  this.Ltyrian_Html$__f_preload$minusString = null;
  this.Ltyrian_Html$__f_rel$minusString = null;
  this.Ltyrian_Html$__f_rows$minusString = null;
  this.Ltyrian_Html$__f_rows$minusInt = null;
  this.Ltyrian_Html$__f_rowSpan$minusString = null;
  this.Ltyrian_Html$__f_rowSpan$minusInt = null;
  this.Ltyrian_Html$__f_scope$minusString = null;
  this.Ltyrian_Html$__f_shape$minusString = null;
  this.Ltyrian_Html$__f_size$minusString = null;
  this.Ltyrian_Html$__f_size$minusInt = null;
  this.Ltyrian_Html$__f_sizes$minusString = null;
  this.Ltyrian_Html$__f_span$minusString = null;
  this.Ltyrian_Html$__f_span$minusInt = null;
  this.Ltyrian_Html$__f_spellCheck$minusString = null;
  this.Ltyrian_Html$__f_spellCheck$minusBoolean = null;
  this.Ltyrian_Html$__f_src$minusString = null;
  this.Ltyrian_Html$__f_srcDoc$minusString = null;
  this.Ltyrian_Html$__f_srcLang$minusString = null;
  this.Ltyrian_Html$__f_srcSet$minusString = null;
  this.Ltyrian_Html$__f_start$minusString = null;
  this.Ltyrian_Html$__f_start$minusInt = null;
  this.Ltyrian_Html$__f_step$minusString = null;
  this.Ltyrian_Html$__f_step$minusInt = null;
  this.Ltyrian_Html$__f_style$minusString = null;
  this.Ltyrian_Html$__f_tabIndex$minusString = null;
  this.Ltyrian_Html$__f_tabIndex$minusInt = null;
  this.Ltyrian_Html$__f_target$minusString = null;
  this.Ltyrian_Html$__f_title$minusString = null;
  this.Ltyrian_Html$__f_translate$minusString = null;
  this.Ltyrian_Html$__f_$u0060type$u0060$minusString = null;
  this.Ltyrian_Html$__f__type$minusString = null;
  this.Ltyrian_Html$__f_typ$minusString = null;
  this.Ltyrian_Html$__f_tpe$minusString = null;
  this.Ltyrian_Html$__f_useMap$minusString = null;
  this.Ltyrian_Html$__f_width$minusString = null;
  this.Ltyrian_Html$__f_width$minusInt = null;
  this.Ltyrian_Html$__f_wrap$minusString = null;
  this.Ltyrian_Html$__f_value$minusString = null;
  this.Ltyrian_Html$__f_value$minusDouble = null;
  this.Ltyrian_Html$__f_value$minusBoolean = null;
  $n_Ltyrian_Html$ = this;
  $f_Ltyrian_HtmlAttributes__$init$__V(this)
}
$c_Ltyrian_Html$.prototype = new $h_O();
$c_Ltyrian_Html$.prototype.constructor = $c_Ltyrian_Html$;
/** @constructor */
function $h_Ltyrian_Html$() {
  /*<skip>*/
}
$h_Ltyrian_Html$.prototype = $c_Ltyrian_Html$.prototype;
$c_Ltyrian_Html$.prototype.onInput__F1__Ltyrian_Attr = (function(msg) {
  var msg$1 = new $c_sjsr_AnonFunction1(((this$1, msg$2) => ((e) => msg$2.apply__O__O($as_T(e.target.value))))(this, msg));
  return new $c_Ltyrian_Event("input", msg$1)
});
$c_Ltyrian_Html$.prototype.ordinal__Ltyrian_Html__I = (function(x$0) {
  if ((x$0 instanceof $c_Ltyrian_Tag)) {
    return 0
  };
  throw new $c_s_MatchError(x$0)
});
$c_Ltyrian_Html$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Ltyrian_Html__I($as_Ltyrian_Html(x))
});
var $d_Ltyrian_Html$ = new $TypeData().initClass({
  Ltyrian_Html$: 0
}, false, "tyrian.Html$", {
  Ltyrian_Html$: 1,
  O: 1,
  Ltyrian_HtmlTags: 1,
  Ltyrian_HtmlAttributes: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_Html$.prototype.$classData = $d_Ltyrian_Html$;
var $n_Ltyrian_Html$;
function $m_Ltyrian_Html$() {
  if ((!$n_Ltyrian_Html$)) {
    $n_Ltyrian_Html$ = new $c_Ltyrian_Html$()
  };
  return $n_Ltyrian_Html$
}
function $as_Ltyrian_NamedAttribute(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.NamedAttribute"))
}
function $isArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_NamedAttribute)))
}
function $asArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (($isArrayOf_Ltyrian_NamedAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.NamedAttribute;", depth))
}
/** @constructor */
function $c_Ltyrian_Property(name, value) {
  this.Ltyrian_Property__f_name = null;
  this.Ltyrian_Property__f_value = null;
  this.Ltyrian_Property__f_name = name;
  this.Ltyrian_Property__f_value = value
}
$c_Ltyrian_Property.prototype = new $h_O();
$c_Ltyrian_Property.prototype.constructor = $c_Ltyrian_Property;
/** @constructor */
function $h_Ltyrian_Property() {
  /*<skip>*/
}
$h_Ltyrian_Property.prototype = $c_Ltyrian_Property.prototype;
$c_Ltyrian_Property.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Property.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Property.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Property)) {
    var x$0$2 = $as_Ltyrian_Property(x$0);
    return ((this.Ltyrian_Property__f_name === x$0$2.Ltyrian_Property__f_name) && (this.Ltyrian_Property__f_value === x$0$2.Ltyrian_Property__f_value))
  } else {
    return false
  }
});
$c_Ltyrian_Property.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Property.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Property.prototype.productPrefix__T = (function() {
  return "Property"
});
$c_Ltyrian_Property.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Property__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Property__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Property(obj) {
  return (((obj instanceof $c_Ltyrian_Property) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Property"))
}
function $isArrayOf_Ltyrian_Property(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Property)))
}
function $asArrayOf_Ltyrian_Property(obj, depth) {
  return (($isArrayOf_Ltyrian_Property(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Property;", depth))
}
var $d_Ltyrian_Property = new $TypeData().initClass({
  Ltyrian_Property: 0
}, false, "tyrian.Property", {
  Ltyrian_Property: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Property.prototype.$classData = $d_Ltyrian_Property;
/** @constructor */
function $c_Ltyrian_Sub$Batch(subs) {
  this.Ltyrian_Sub$Batch__f_subs = null;
  this.Ltyrian_Sub$Batch__f_subs = subs
}
$c_Ltyrian_Sub$Batch.prototype = new $h_O();
$c_Ltyrian_Sub$Batch.prototype.constructor = $c_Ltyrian_Sub$Batch;
/** @constructor */
function $h_Ltyrian_Sub$Batch() {
  /*<skip>*/
}
$h_Ltyrian_Sub$Batch.prototype = $c_Ltyrian_Sub$Batch.prototype;
$c_Ltyrian_Sub$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Sub$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Sub$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Batch)) {
    var x$0$2 = $as_Ltyrian_Sub$Batch(x$0);
    var x = this.Ltyrian_Sub$Batch__f_subs;
    var x$2 = x$0$2.Ltyrian_Sub$Batch__f_subs;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Sub$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Sub$Batch.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Sub$Batch.prototype.productPrefix__T = (function() {
  return "Batch"
});
$c_Ltyrian_Sub$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Sub$Batch__f_subs
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_Sub$Batch.prototype.map__F1__Ltyrian_Sub$Batch = (function(f) {
  var this$2 = this.Ltyrian_Sub$Batch__f_subs;
  var f$1 = ((this$1, f$2) => ((_$1) => {
    var _$1$1 = $as_Ltyrian_Sub(_$1);
    return _$1$1.map__F1__Ltyrian_Sub(f$2)
  }))(this, f);
  if ((this$2 === $m_sci_Nil$())) {
    var subs = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var subs = h
  };
  return new $c_Ltyrian_Sub$Batch(subs)
});
$c_Ltyrian_Sub$Batch.prototype.map__F1__Ltyrian_Sub = (function(f) {
  return this.map__F1__Ltyrian_Sub$Batch(f)
});
function $as_Ltyrian_Sub$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Batch"))
}
function $isArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Batch)))
}
function $asArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Batch;", depth))
}
var $d_Ltyrian_Sub$Batch = new $TypeData().initClass({
  Ltyrian_Sub$Batch: 0
}, false, "tyrian.Sub$Batch", {
  Ltyrian_Sub$Batch: 1,
  O: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Sub$Batch.prototype.$classData = $d_Ltyrian_Sub$Batch;
function $as_Ltyrian_Sub$Combine(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Combine"))
}
function $isArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Combine)))
}
function $asArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Combine;", depth))
}
/** @constructor */
function $c_Ltyrian_Sub$OfObservable(id, observable, f) {
  this.Ltyrian_Sub$OfObservable__f_id = null;
  this.Ltyrian_Sub$OfObservable__f_observable = null;
  this.Ltyrian_Sub$OfObservable__f_f = null;
  this.Ltyrian_Sub$OfObservable__f_id = id;
  this.Ltyrian_Sub$OfObservable__f_observable = observable;
  this.Ltyrian_Sub$OfObservable__f_f = f
}
$c_Ltyrian_Sub$OfObservable.prototype = new $h_O();
$c_Ltyrian_Sub$OfObservable.prototype.constructor = $c_Ltyrian_Sub$OfObservable;
/** @constructor */
function $h_Ltyrian_Sub$OfObservable() {
  /*<skip>*/
}
$h_Ltyrian_Sub$OfObservable.prototype = $c_Ltyrian_Sub$OfObservable.prototype;
$c_Ltyrian_Sub$OfObservable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Sub$OfObservable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Sub$OfObservable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Sub$OfObservable)) {
    var x$0$2 = $as_Ltyrian_Sub$OfObservable(x$0);
    if ((this.Ltyrian_Sub$OfObservable__f_id === x$0$2.Ltyrian_Sub$OfObservable__f_id)) {
      var x = this.Ltyrian_Sub$OfObservable__f_observable;
      var x$2 = x$0$2.Ltyrian_Sub$OfObservable__f_observable;
      var $$x1 = (x === x$2)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Ltyrian_Sub$OfObservable__f_f;
      var x$4 = x$0$2.Ltyrian_Sub$OfObservable__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Sub$OfObservable.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Sub$OfObservable.prototype.productArity__I = (function() {
  return 3
});
$c_Ltyrian_Sub$OfObservable.prototype.productPrefix__T = (function() {
  return "OfObservable"
});
$c_Ltyrian_Sub$OfObservable.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Sub$OfObservable__f_id;
      break
    }
    case 1: {
      return this.Ltyrian_Sub$OfObservable__f_observable;
      break
    }
    case 2: {
      return this.Ltyrian_Sub$OfObservable__f_f;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Ltyrian_Sub$OfObservable.prototype.map__F1__Ltyrian_Sub = (function(g) {
  var id = this.Ltyrian_Sub$OfObservable__f_id;
  var observable = this.Ltyrian_Sub$OfObservable__f_observable;
  var f = this.Ltyrian_Sub$OfObservable__f_f.andThen__F1__F1(g);
  return new $c_Ltyrian_Sub$OfObservable(id, observable, f)
});
function $as_Ltyrian_Sub$OfObservable(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$OfObservable) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$OfObservable"))
}
function $isArrayOf_Ltyrian_Sub$OfObservable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$OfObservable)))
}
function $asArrayOf_Ltyrian_Sub$OfObservable(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$OfObservable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$OfObservable;", depth))
}
var $d_Ltyrian_Sub$OfObservable = new $TypeData().initClass({
  Ltyrian_Sub$OfObservable: 0
}, false, "tyrian.Sub$OfObservable", {
  Ltyrian_Sub$OfObservable: 1,
  O: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Sub$OfObservable.prototype.$classData = $d_Ltyrian_Sub$OfObservable;
/** @constructor */
function $c_Ltyrian_Task$Delay(thunk) {
  this.Ltyrian_Task$Delay__f_thunk = null;
  this.Ltyrian_Task$Delay__f_thunk = thunk
}
$c_Ltyrian_Task$Delay.prototype = new $h_O();
$c_Ltyrian_Task$Delay.prototype.constructor = $c_Ltyrian_Task$Delay;
/** @constructor */
function $h_Ltyrian_Task$Delay() {
  /*<skip>*/
}
$h_Ltyrian_Task$Delay.prototype = $c_Ltyrian_Task$Delay.prototype;
$c_Ltyrian_Task$Delay.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Task$Delay.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Task$Delay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Task$Delay)) {
    var x$0$2 = $as_Ltyrian_Task$Delay(x$0);
    var x = this.Ltyrian_Task$Delay__f_thunk;
    var x$2 = x$0$2.Ltyrian_Task$Delay__f_thunk;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Task$Delay.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Task$Delay.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Task$Delay.prototype.productPrefix__T = (function() {
  return "Delay"
});
$c_Ltyrian_Task$Delay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Task$Delay__f_thunk
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Task$Delay(obj) {
  return (((obj instanceof $c_Ltyrian_Task$Delay) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Delay"))
}
function $isArrayOf_Ltyrian_Task$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Delay)))
}
function $asArrayOf_Ltyrian_Task$Delay(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Delay(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Delay;", depth))
}
var $d_Ltyrian_Task$Delay = new $TypeData().initClass({
  Ltyrian_Task$Delay: 0
}, false, "tyrian.Task$Delay", {
  Ltyrian_Task$Delay: 1,
  O: 1,
  Ltyrian_Task: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Task$Delay.prototype.$classData = $d_Ltyrian_Task$Delay;
function $as_Ltyrian_Task$Failed(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Failed"))
}
function $isArrayOf_Ltyrian_Task$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Failed)))
}
function $asArrayOf_Ltyrian_Task$Failed(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Failed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Failed;", depth))
}
function $as_Ltyrian_Task$FlatMapped(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$FlatMapped"))
}
function $isArrayOf_Ltyrian_Task$FlatMapped(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$FlatMapped)))
}
function $asArrayOf_Ltyrian_Task$FlatMapped(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$FlatMapped(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$FlatMapped;", depth))
}
/** @constructor */
function $c_Ltyrian_Task$Mapped(task, f) {
  this.Ltyrian_Task$Mapped__f_task = null;
  this.Ltyrian_Task$Mapped__f_f = null;
  this.Ltyrian_Task$Mapped__f_task = task;
  this.Ltyrian_Task$Mapped__f_f = f
}
$c_Ltyrian_Task$Mapped.prototype = new $h_O();
$c_Ltyrian_Task$Mapped.prototype.constructor = $c_Ltyrian_Task$Mapped;
/** @constructor */
function $h_Ltyrian_Task$Mapped() {
  /*<skip>*/
}
$h_Ltyrian_Task$Mapped.prototype = $c_Ltyrian_Task$Mapped.prototype;
$c_Ltyrian_Task$Mapped.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Task$Mapped.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Task$Mapped.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Task$Mapped)) {
    var x$0$2 = $as_Ltyrian_Task$Mapped(x$0);
    var x = this.Ltyrian_Task$Mapped__f_task;
    var x$2 = x$0$2.Ltyrian_Task$Mapped__f_task;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Task$Mapped__f_f;
      var x$4 = x$0$2.Ltyrian_Task$Mapped__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Task$Mapped.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Task$Mapped.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Task$Mapped.prototype.productPrefix__T = (function() {
  return "Mapped"
});
$c_Ltyrian_Task$Mapped.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Task$Mapped__f_task
  };
  if ((n === 1)) {
    return this.Ltyrian_Task$Mapped__f_f
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Task$Mapped(obj) {
  return (((obj instanceof $c_Ltyrian_Task$Mapped) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Mapped"))
}
function $isArrayOf_Ltyrian_Task$Mapped(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Mapped)))
}
function $asArrayOf_Ltyrian_Task$Mapped(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Mapped(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Mapped;", depth))
}
var $d_Ltyrian_Task$Mapped = new $TypeData().initClass({
  Ltyrian_Task$Mapped: 0
}, false, "tyrian.Task$Mapped", {
  Ltyrian_Task$Mapped: 1,
  O: 1,
  Ltyrian_Task: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Task$Mapped.prototype.$classData = $d_Ltyrian_Task$Mapped;
function $as_Ltyrian_Task$Multiplied(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Multiplied"))
}
function $isArrayOf_Ltyrian_Task$Multiplied(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Multiplied)))
}
function $asArrayOf_Ltyrian_Task$Multiplied(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Multiplied(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Multiplied;", depth))
}
function $as_Ltyrian_Task$Recovered(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Recovered"))
}
function $isArrayOf_Ltyrian_Task$Recovered(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Recovered)))
}
function $asArrayOf_Ltyrian_Task$Recovered(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Recovered(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Recovered;", depth))
}
/** @constructor */
function $c_Ltyrian_Task$RunObservable(observable) {
  this.Ltyrian_Task$RunObservable__f_observable = null;
  this.Ltyrian_Task$RunObservable__f_observable = observable
}
$c_Ltyrian_Task$RunObservable.prototype = new $h_O();
$c_Ltyrian_Task$RunObservable.prototype.constructor = $c_Ltyrian_Task$RunObservable;
/** @constructor */
function $h_Ltyrian_Task$RunObservable() {
  /*<skip>*/
}
$h_Ltyrian_Task$RunObservable.prototype = $c_Ltyrian_Task$RunObservable.prototype;
$c_Ltyrian_Task$RunObservable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Task$RunObservable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Task$RunObservable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Task$RunObservable)) {
    var x$0$2 = $as_Ltyrian_Task$RunObservable(x$0);
    var x = this.Ltyrian_Task$RunObservable__f_observable;
    var x$2 = x$0$2.Ltyrian_Task$RunObservable__f_observable;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Ltyrian_Task$RunObservable.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Task$RunObservable.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Task$RunObservable.prototype.productPrefix__T = (function() {
  return "RunObservable"
});
$c_Ltyrian_Task$RunObservable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Task$RunObservable__f_observable
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Task$RunObservable(obj) {
  return (((obj instanceof $c_Ltyrian_Task$RunObservable) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$RunObservable"))
}
function $isArrayOf_Ltyrian_Task$RunObservable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$RunObservable)))
}
function $asArrayOf_Ltyrian_Task$RunObservable(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$RunObservable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$RunObservable;", depth))
}
var $d_Ltyrian_Task$RunObservable = new $TypeData().initClass({
  Ltyrian_Task$RunObservable: 0
}, false, "tyrian.Task$RunObservable", {
  Ltyrian_Task$RunObservable: 1,
  O: 1,
  Ltyrian_Task: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Task$RunObservable.prototype.$classData = $d_Ltyrian_Task$RunObservable;
/** @constructor */
function $c_Ltyrian_Task$SideEffect(thunk) {
  this.Ltyrian_Task$SideEffect__f_thunk = null;
  this.Ltyrian_Task$SideEffect__f_thunk = thunk
}
$c_Ltyrian_Task$SideEffect.prototype = new $h_O();
$c_Ltyrian_Task$SideEffect.prototype.constructor = $c_Ltyrian_Task$SideEffect;
/** @constructor */
function $h_Ltyrian_Task$SideEffect() {
  /*<skip>*/
}
$h_Ltyrian_Task$SideEffect.prototype = $c_Ltyrian_Task$SideEffect.prototype;
$c_Ltyrian_Task$SideEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Task$SideEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Task$SideEffect.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Task$SideEffect)) {
    var x$0$2 = $as_Ltyrian_Task$SideEffect(x$0);
    var x = this.Ltyrian_Task$SideEffect__f_thunk;
    var x$2 = x$0$2.Ltyrian_Task$SideEffect__f_thunk;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Task$SideEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Task$SideEffect.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Task$SideEffect.prototype.productPrefix__T = (function() {
  return "SideEffect"
});
$c_Ltyrian_Task$SideEffect.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Task$SideEffect__f_thunk
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Task$SideEffect(obj) {
  return (((obj instanceof $c_Ltyrian_Task$SideEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$SideEffect"))
}
function $isArrayOf_Ltyrian_Task$SideEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$SideEffect)))
}
function $asArrayOf_Ltyrian_Task$SideEffect(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$SideEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$SideEffect;", depth))
}
var $d_Ltyrian_Task$SideEffect = new $TypeData().initClass({
  Ltyrian_Task$SideEffect: 0
}, false, "tyrian.Task$SideEffect", {
  Ltyrian_Task$SideEffect: 1,
  O: 1,
  Ltyrian_Task: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Task$SideEffect.prototype.$classData = $d_Ltyrian_Task$SideEffect;
function $as_Ltyrian_Task$Succeeded(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Task$Succeeded"))
}
function $isArrayOf_Ltyrian_Task$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Task$Succeeded)))
}
function $asArrayOf_Ltyrian_Task$Succeeded(obj, depth) {
  return (($isArrayOf_Ltyrian_Task$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Task$Succeeded;", depth))
}
/** @constructor */
function $c_Ltyrian_Text(value) {
  this.Ltyrian_Text__f_value = null;
  this.Ltyrian_Text__f_value = value
}
$c_Ltyrian_Text.prototype = new $h_O();
$c_Ltyrian_Text.prototype.constructor = $c_Ltyrian_Text;
/** @constructor */
function $h_Ltyrian_Text() {
  /*<skip>*/
}
$h_Ltyrian_Text.prototype = $c_Ltyrian_Text.prototype;
$c_Ltyrian_Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Text)) {
    var x$0$2 = $as_Ltyrian_Text(x$0);
    return (this.Ltyrian_Text__f_value === x$0$2.Ltyrian_Text__f_value)
  } else {
    return false
  }
});
$c_Ltyrian_Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Text.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Ltyrian_Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Text__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Text(obj) {
  return (((obj instanceof $c_Ltyrian_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Text"))
}
function $isArrayOf_Ltyrian_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Text)))
}
function $asArrayOf_Ltyrian_Text(obj, depth) {
  return (($isArrayOf_Ltyrian_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Text;", depth))
}
var $d_Ltyrian_Text = new $TypeData().initClass({
  Ltyrian_Text: 0
}, false, "tyrian.Text", {
  Ltyrian_Text: 1,
  O: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Text.prototype.$classData = $d_Ltyrian_Text;
/** @constructor */
function $c_Ltyrian_http_Body() {
  /*<skip>*/
}
$c_Ltyrian_http_Body.prototype = new $h_O();
$c_Ltyrian_http_Body.prototype.constructor = $c_Ltyrian_http_Body;
/** @constructor */
function $h_Ltyrian_http_Body() {
  /*<skip>*/
}
$h_Ltyrian_http_Body.prototype = $c_Ltyrian_http_Body.prototype;
$c_Ltyrian_http_Body.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Ltyrian_http_Body(obj) {
  return (((obj instanceof $c_Ltyrian_http_Body) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Body"))
}
function $isArrayOf_Ltyrian_http_Body(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Body)))
}
function $asArrayOf_Ltyrian_http_Body(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Body(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Body;", depth))
}
/** @constructor */
function $c_Ltyrian_http_HttpError() {
  /*<skip>*/
}
$c_Ltyrian_http_HttpError.prototype = new $h_O();
$c_Ltyrian_http_HttpError.prototype.constructor = $c_Ltyrian_http_HttpError;
/** @constructor */
function $h_Ltyrian_http_HttpError() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError.prototype = $c_Ltyrian_http_HttpError.prototype;
$c_Ltyrian_http_HttpError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Ltyrian_http_HttpError(obj) {
  return (((obj instanceof $c_Ltyrian_http_HttpError) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.HttpError"))
}
function $isArrayOf_Ltyrian_http_HttpError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_HttpError)))
}
function $asArrayOf_Ltyrian_http_HttpError(obj, depth) {
  return (($isArrayOf_Ltyrian_http_HttpError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.HttpError;", depth))
}
/** @constructor */
function $c_Ltyrian_http_Method() {
  /*<skip>*/
}
$c_Ltyrian_http_Method.prototype = new $h_O();
$c_Ltyrian_http_Method.prototype.constructor = $c_Ltyrian_http_Method;
/** @constructor */
function $h_Ltyrian_http_Method() {
  /*<skip>*/
}
$h_Ltyrian_http_Method.prototype = $c_Ltyrian_http_Method.prototype;
$c_Ltyrian_http_Method.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_http_Method.prototype.asString__T = (function() {
  var x = $s_Ltyrian_http_Method$__Get__Ltyrian_http_Method();
  if (((x !== null) && (x === this))) {
    return "GET"
  };
  var x$3 = $s_Ltyrian_http_Method$__Post__Ltyrian_http_Method();
  if (((x$3 !== null) && (x$3 === this))) {
    return "POST"
  };
  var x$5 = $s_Ltyrian_http_Method$__Put__Ltyrian_http_Method();
  if (((x$5 !== null) && (x$5 === this))) {
    return "PUT"
  };
  var x$7 = $s_Ltyrian_http_Method$__Patch__Ltyrian_http_Method();
  if (((x$7 !== null) && (x$7 === this))) {
    return "PATCH"
  };
  var x$9 = $s_Ltyrian_http_Method$__Delete__Ltyrian_http_Method();
  if (((x$9 !== null) && (x$9 === this))) {
    return "DELETE"
  };
  var x$11 = $s_Ltyrian_http_Method$__Options__Ltyrian_http_Method();
  if (((x$11 !== null) && (x$11 === this))) {
    return "OPTIONS"
  };
  throw new $c_s_MatchError(this)
});
function $as_Ltyrian_http_Method(obj) {
  return (((obj instanceof $c_Ltyrian_http_Method) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Method"))
}
function $isArrayOf_Ltyrian_http_Method(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Method)))
}
function $asArrayOf_Ltyrian_http_Method(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Method(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Method;", depth))
}
var $d_Ltyrian_http_Method = new $TypeData().initClass({
  Ltyrian_http_Method: 0
}, false, "tyrian.http.Method", {
  Ltyrian_http_Method: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_http_Method.prototype.$classData = $d_Ltyrian_http_Method;
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype = $c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype;
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    return true
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var x44 = x$1.Ltyrian_Attribute__f_name;
    var x45 = x$1.Ltyrian_Attribute__f_value;
    return $ct_T2__O__O__(new $c_T2(), x44, x45)
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    var x41 = x$1$1.Ltyrian_NamedAttribute__f_name;
    return $ct_T2__O__O__(new $c_T2(), x41, "")
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_TyrianRuntime$$anon$1 = new $TypeData().initClass({
  Ltyrian_runtime_TyrianRuntime$$anon$1: 0
}, false, "tyrian.runtime.TyrianRuntime$$anon$1", {
  Ltyrian_runtime_TyrianRuntime$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$1.prototype.$classData = $d_Ltyrian_runtime_TyrianRuntime$$anon$1;
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime$$anon$2() {
  /*<skip>*/
}
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime$$anon$2;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype = $c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype;
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Property)) {
    $m_Ltyrian_Property$();
    var x$1 = $as_Ltyrian_Property(x);
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Property)) {
    $m_Ltyrian_Property$();
    var x$1 = $as_Ltyrian_Property(x);
    var x54 = x$1.Ltyrian_Property__f_name;
    var x55 = x$1.Ltyrian_Property__f_value;
    return $ct_T2__O__O__(new $c_T2(), x54, x55)
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_TyrianRuntime$$anon$2 = new $TypeData().initClass({
  Ltyrian_runtime_TyrianRuntime$$anon$2: 0
}, false, "tyrian.runtime.TyrianRuntime$$anon$2", {
  Ltyrian_runtime_TyrianRuntime$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$2.prototype.$classData = $d_Ltyrian_runtime_TyrianRuntime$$anon$2;
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime$$anon$3(outer) {
  this.Ltyrian_runtime_TyrianRuntime$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_runtime_TyrianRuntime$$anon$3__f_$outer = outer
}
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime$$anon$3;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime$$anon$3() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype = $c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype;
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    var x64 = x$1.Ltyrian_Event__f_name;
    var x65 = x$1.Ltyrian_Event__f_msg;
    var f = new $c_sjsr_AnonFunction1(((this$2, msg$2) => ((e) => {
      this$2.Ltyrian_runtime_TyrianRuntime$$anon$3__f_$outer.onMsg__O__V(msg$2.apply__O__O(e))
    }))(this, x65));
    var _2 = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f);
    return $ct_T2__O__O__(new $c_T2(), x64, _2)
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_TyrianRuntime$$anon$3 = new $TypeData().initClass({
  Ltyrian_runtime_TyrianRuntime$$anon$3: 0
}, false, "tyrian.runtime.TyrianRuntime$$anon$3", {
  Ltyrian_runtime_TyrianRuntime$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_TyrianRuntime$$anon$3.prototype.$classData = $d_Ltyrian_runtime_TyrianRuntime$$anon$3;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent() {
  /*<skip>*/
}
$c_Ltyrian_websocket_WebSocketEvent.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocketEvent.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent.prototype = $c_Ltyrian_websocket_WebSocketEvent.prototype;
$c_Ltyrian_websocket_WebSocketEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Ltyrian_websocket_WebSocketEvent(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocketEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocketEvent"))
}
function $isArrayOf_Ltyrian_websocket_WebSocketEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocketEvent)))
}
function $asArrayOf_Ltyrian_websocket_WebSocketEvent(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocketEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocketEvent;", depth))
}
/** @constructor */
function $c_Ltyrian_websocket_WebSocketReadyState() {
  /*<skip>*/
}
$c_Ltyrian_websocket_WebSocketReadyState.prototype = new $h_O();
$c_Ltyrian_websocket_WebSocketReadyState.prototype.constructor = $c_Ltyrian_websocket_WebSocketReadyState;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketReadyState() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketReadyState.prototype = $c_Ltyrian_websocket_WebSocketReadyState.prototype;
$c_Ltyrian_websocket_WebSocketReadyState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_websocket_WebSocketReadyState.prototype.isOpen__Z = (function() {
  var x = $s_Ltyrian_websocket_WebSocketReadyState$__CLOSED__Ltyrian_websocket_WebSocketReadyState();
  if ((!((x !== null) && (x === this)))) {
    var x$3 = $s_Ltyrian_websocket_WebSocketReadyState$__CLOSING__Ltyrian_websocket_WebSocketReadyState();
    return (!((x$3 !== null) && (x$3 === this)))
  } else {
    return false
  }
});
function $as_Ltyrian_websocket_WebSocketReadyState(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocketReadyState) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocketReadyState"))
}
function $isArrayOf_Ltyrian_websocket_WebSocketReadyState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocketReadyState)))
}
function $asArrayOf_Ltyrian_websocket_WebSocketReadyState(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocketReadyState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocketReadyState;", depth))
}
var $d_Ltyrian_websocket_WebSocketReadyState = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketReadyState: 0
}, false, "tyrian.websocket.WebSocketReadyState", {
  Ltyrian_websocket_WebSocketReadyState: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_websocket_WebSocketReadyState.prototype.$classData = $d_Ltyrian_websocket_WebSocketReadyState;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$3() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$3.prototype.constructor = $c_Lcats_EvalInstances$$anon$3;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$3.prototype = $c_Lcats_EvalInstances$$anon$3.prototype;
$c_Lcats_EvalInstances$$anon$3.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_EvalInstances$$anon$3.prototype.foldRight__Lcats_Eval__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return fa.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((lb$2, f$2) => ((_$1) => $as_Lcats_Eval(f$2.apply__O__O__O(_$1, lb$2))))(lb, f)))
});
$c_Lcats_EvalInstances$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_Eval__Lcats_Eval__F2__Lcats_Eval($as_Lcats_Eval(fa), lb, f)
});
var $d_Lcats_EvalInstances$$anon$3 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$3: 0
}, false, "cats.EvalInstances$$anon$3", {
  Lcats_EvalInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1
});
$c_Lcats_EvalInstances$$anon$3.prototype.$classData = $d_Lcats_EvalInstances$$anon$3;
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  $thiz.Lcats_NonEmptyReducible__f_G = G;
  return $thiz
}
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  this.Lcats_NonEmptyReducible__f_G = null
}
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
  /*<skip>*/
}
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
$c_Lcats_NonEmptyReducible.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, H) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var _1 = fa$1.Lcats_data_NonEmptyList__f_head;
  var _2 = fa$1.Lcats_data_NonEmptyList__f_tail;
  var \u03b44$___1 = _1;
  var \u03b44$___2 = _2;
  var a$2 = \u03b44$___1;
  var ga$2 = \u03b44$___2;
  return H.flatMap__O__F1__O(f.apply__O__O__O(z, a$2), new $c_sjsr_AnonFunction1(((this$3, f$2, H$2, ga$3) => ((_$30) => this$3.Lcats_NonEmptyReducible__f_G.foldM__O__O__F2__Lcats_Monad__O(ga$3, _$30, f$2, H$2)))(this, f, H, ga$2)))
});
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value
}
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
  /*<skip>*/
}
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Now)) {
    var x$0$2 = $as_Lcats_Now(x$0);
    var x = this.Lcats_Now__f_value;
    var y = x$0$2.Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now"
});
$c_Lcats_Now.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Now__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_Now.prototype.value__O = (function() {
  return this.Lcats_Now__f_value
});
function $as_Lcats_Now(obj) {
  return (((obj instanceof $c_Lcats_Now) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Now"))
}
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)))
}
function $asArrayOf_Lcats_Now(obj, depth) {
  return (($isArrayOf_Lcats_Now(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Now;", depth))
}
var $d_Lcats_Now = new $TypeData().initClass({
  Lcats_Now: 0
}, false, "cats.Now", {
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lcats_Now.prototype.$classData = $d_Lcats_Now;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False
}
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((ly$2) => ((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True
    };
    if ((x$1$1 === false)) {
      return ly$2
    };
    throw new $c_s_MatchError(x$1$1)
  }))(ly)))
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$1: 0
}, false, "cats.UnorderedFoldable$$anon$1", {
  Lcats_UnorderedFoldable$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True
}
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((ly$2) => ((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return ly$2
    };
    if ((x$1$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False
    };
    throw new $c_s_MatchError(x$1$1)
  }))(ly)))
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$2: 0
}, false, "cats.UnorderedFoldable$$anon$2", {
  Lcats_UnorderedFoldable$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$2;
function $f_Lcats_arrow_Arrow__id__O($thiz) {
  return $thiz.lift__F1__O(new $c_sjsr_AnonFunction1(((x) => x)))
}
/** @constructor */
function $c_Lcats_data_AndThen$Concat(left, right) {
  this.Lcats_data_AndThen$Concat__f_left = null;
  this.Lcats_data_AndThen$Concat__f_right = null;
  this.Lcats_data_AndThen$Concat__f_left = left;
  this.Lcats_data_AndThen$Concat__f_right = right
}
$c_Lcats_data_AndThen$Concat.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Concat.prototype.constructor = $c_Lcats_data_AndThen$Concat;
/** @constructor */
function $h_Lcats_data_AndThen$Concat() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$Concat.prototype = $c_Lcats_data_AndThen$Concat.prototype;
$c_Lcats_data_AndThen$Concat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_AndThen$Concat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$0$2 = $as_Lcats_data_AndThen$Concat(x$0);
    var x = this.Lcats_data_AndThen$Concat__f_left;
    var x$2 = x$0$2.Lcats_data_AndThen$Concat__f_left;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_data_AndThen$Concat__f_right;
      var x$4 = x$0$2.Lcats_data_AndThen$Concat__f_right;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_data_AndThen$Concat.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_AndThen$Concat.prototype.productPrefix__T = (function() {
  return "Concat"
});
$c_Lcats_data_AndThen$Concat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Concat__f_left
  };
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Concat__f_right
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_AndThen$Concat(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Concat) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Concat"))
}
function $isArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Concat)))
}
function $asArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Concat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Concat;", depth))
}
var $d_Lcats_data_AndThen$Concat = new $TypeData().initClass({
  Lcats_data_AndThen$Concat: 0
}, false, "cats.data.AndThen$Concat", {
  Lcats_data_AndThen$Concat: 1,
  Lcats_data_AndThen: 1,
  O: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_AndThen$Concat.prototype.$classData = $d_Lcats_data_AndThen$Concat;
/** @constructor */
function $c_Lcats_data_AndThen$Single(f, index) {
  this.Lcats_data_AndThen$Single__f_f = null;
  this.Lcats_data_AndThen$Single__f_index = 0;
  this.Lcats_data_AndThen$Single__f_f = f;
  this.Lcats_data_AndThen$Single__f_index = index
}
$c_Lcats_data_AndThen$Single.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Single.prototype.constructor = $c_Lcats_data_AndThen$Single;
/** @constructor */
function $h_Lcats_data_AndThen$Single() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$Single.prototype = $c_Lcats_data_AndThen$Single.prototype;
$c_Lcats_data_AndThen$Single.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Single");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_data_AndThen$Single__f_f;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_data_AndThen$Single__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcats_data_AndThen$Single.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    var x$0$2 = $as_Lcats_data_AndThen$Single(x$0);
    if ((this.Lcats_data_AndThen$Single__f_index === x$0$2.Lcats_data_AndThen$Single__f_index)) {
      var x = this.Lcats_data_AndThen$Single__f_f;
      var x$2 = x$0$2.Lcats_data_AndThen$Single__f_f;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_data_AndThen$Single.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_AndThen$Single.prototype.productPrefix__T = (function() {
  return "Single"
});
$c_Lcats_data_AndThen$Single.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Single__f_f
  };
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Single__f_index
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_AndThen$Single(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Single) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Single"))
}
function $isArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Single)))
}
function $asArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Single(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Single;", depth))
}
var $d_Lcats_data_AndThen$Single = new $TypeData().initClass({
  Lcats_data_AndThen$Single: 0
}, false, "cats.data.AndThen$Single", {
  Lcats_data_AndThen$Single: 1,
  Lcats_data_AndThen: 1,
  O: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_AndThen$Single.prototype.$classData = $d_Lcats_data_AndThen$Single;
/** @constructor */
function $c_Lcats_data_Chain$Append(leftNE, rightNE) {
  this.Lcats_data_Chain$Append__f_leftNE = null;
  this.Lcats_data_Chain$Append__f_rightNE = null;
  this.Lcats_data_Chain$Append__f_leftNE = leftNE;
  this.Lcats_data_Chain$Append__f_rightNE = rightNE
}
$c_Lcats_data_Chain$Append.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Append.prototype.constructor = $c_Lcats_data_Chain$Append;
/** @constructor */
function $h_Lcats_data_Chain$Append() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Append.prototype = $c_Lcats_data_Chain$Append.prototype;
$c_Lcats_data_Chain$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Append.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_Chain$Append.prototype.productPrefix__T = (function() {
  return "Append"
});
$c_Lcats_data_Chain$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Append__f_leftNE
  };
  if ((n === 1)) {
    return this.Lcats_data_Chain$Append__f_rightNE
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Append(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Append) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Append"))
}
function $isArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Append)))
}
function $asArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Append(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Append;", depth))
}
var $d_Lcats_data_Chain$Append = new $TypeData().initClass({
  Lcats_data_Chain$Append: 0
}, false, "cats.data.Chain$Append", {
  Lcats_data_Chain$Append: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Append.prototype.$classData = $d_Lcats_data_Chain$Append;
/** @constructor */
function $c_Lcats_data_Chain$Singleton(a) {
  this.Lcats_data_Chain$Singleton__f_a = null;
  this.Lcats_data_Chain$Singleton__f_a = a
}
$c_Lcats_data_Chain$Singleton.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Singleton.prototype.constructor = $c_Lcats_data_Chain$Singleton;
/** @constructor */
function $h_Lcats_data_Chain$Singleton() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Singleton.prototype = $c_Lcats_data_Chain$Singleton.prototype;
$c_Lcats_data_Chain$Singleton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Singleton.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Chain$Singleton.prototype.productPrefix__T = (function() {
  return "Singleton"
});
$c_Lcats_data_Chain$Singleton.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Singleton__f_a
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Singleton(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Singleton) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Singleton"))
}
function $isArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Singleton)))
}
function $asArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Singleton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Singleton;", depth))
}
var $d_Lcats_data_Chain$Singleton = new $TypeData().initClass({
  Lcats_data_Chain$Singleton: 0
}, false, "cats.data.Chain$Singleton", {
  Lcats_data_Chain$Singleton: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Singleton.prototype.$classData = $d_Lcats_data_Chain$Singleton;
/** @constructor */
function $c_Lcats_data_Chain$Wrap(seq) {
  this.Lcats_data_Chain$Wrap__f_seq = null;
  this.Lcats_data_Chain$Wrap__f_seq = seq
}
$c_Lcats_data_Chain$Wrap.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Wrap.prototype.constructor = $c_Lcats_data_Chain$Wrap;
/** @constructor */
function $h_Lcats_data_Chain$Wrap() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Wrap.prototype = $c_Lcats_data_Chain$Wrap.prototype;
$c_Lcats_data_Chain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Wrap.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Chain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap"
});
$c_Lcats_data_Chain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Wrap__f_seq
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Wrap(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Wrap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Wrap"))
}
function $isArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Wrap)))
}
function $asArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Wrap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Wrap;", depth))
}
var $d_Lcats_data_Chain$Wrap = new $TypeData().initClass({
  Lcats_data_Chain$Wrap: 0
}, false, "cats.data.Chain$Wrap", {
  Lcats_data_Chain$Wrap: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Wrap.prototype.$classData = $d_Lcats_data_Chain$Wrap;
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null;
  $ct_Lcats_data_NonEmptyListInstances__(this)
}
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
$c_Lcats_data_NonEmptyList$.prototype.toString__T = (function() {
  return "NonEmptyList"
});
$c_Lcats_data_NonEmptyList$.prototype.fromList__sci_List__s_Option = (function(l) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (l === null) : x.equals__O__Z(l))) {
    return $m_s_None$()
  };
  if ((l instanceof $c_sci_$colon$colon)) {
    var x41 = $as_sci_$colon$colon(l);
    var x43 = x41.sci_$colon$colon__f_next;
    var h = x41.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    var value = new $c_Lcats_data_NonEmptyList(h, x43);
    return new $c_s_Some(value)
  };
  throw new $c_s_MatchError(l)
});
$c_Lcats_data_NonEmptyList$.prototype.fromListUnsafe__sci_List__Lcats_data_NonEmptyList = (function(l) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (l === null) : x.equals__O__Z(l))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyList from empty list")
  };
  if ((l instanceof $c_sci_$colon$colon)) {
    var x45 = $as_sci_$colon$colon(l);
    var x47 = x45.sci_$colon$colon__f_next;
    var h = x45.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(h, x47)
  };
  throw new $c_s_MatchError(l)
});
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass({
  Lcats_data_NonEmptyList$: 0
}, false, "cats.data.NonEmptyList$", {
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_data_NonEmptyList$.prototype.$classData = $d_Lcats_data_NonEmptyList$;
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$()
  };
  return $n_Lcats_data_NonEmptyList$
}
/** @constructor */
function $c_Lcats_data_WriterTInstances8() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances8.prototype = new $h_Lcats_data_WriterTInstances9();
$c_Lcats_data_WriterTInstances8.prototype.constructor = $c_Lcats_data_WriterTInstances8;
/** @constructor */
function $h_Lcats_data_WriterTInstances8() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances8.prototype = $c_Lcats_data_WriterTInstances8.prototype;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  var fb$1 = $as_Lcats_kernel_Semigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$1", {
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  var fb$1 = $as_Lcats_kernel_CommutativeSemigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$2", {
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_OrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderingInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$2: 0
}, false, "cats.instances.OrderingInstances$$anon$2", {
  Lcats_instances_OrderingInstances$$anon$2: 1,
  O: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_SetInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SetInstances$$anon$1.prototype = $c_Lcats_instances_SetInstances$$anon$1.prototype;
$c_Lcats_instances_SetInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$()
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Set(x);
  var y$1 = $as_sci_Set(y);
  return $as_sci_Set(x$1.concat__sc_IterableOnce__sc_SetOps(y$1))
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
var $d_Lcats_instances_SetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SetInstances$$anon$1: 0
}, false, "cats.instances.SetInstances$$anon$1", {
  Lcats_instances_SetInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_SortedSetInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstances$$anon$1.prototype = $c_Lcats_instances_SortedSetInstances$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_SortedSet(x);
  var y$1 = $as_sci_SortedSet(y);
  return $as_sci_SortedSet(x$1.concat__sc_IterableOnce__sc_SetOps(y$1))
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f)
});
var $d_Lcats_instances_SortedSetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstances$$anon$1: 0
}, false, "cats.instances.SortedSetInstances$$anon$1", {
  Lcats_instances_SortedSetInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  this.Lcats_instances_package$list$__f_catsStdTraverseFilterForList = null;
  $n_Lcats_instances_package$list$ = this;
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  this.Lcats_instances_package$list$__f_catsStdTraverseFilterForList = new $c_Lcats_instances_ListInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
  /*<skip>*/
}
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
var $d_Lcats_instances_package$list$ = new $TypeData().initClass({
  Lcats_instances_package$list$: 0
}, false, "cats.instances.package$list$", {
  Lcats_instances_package$list$: 1,
  O: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
});
$c_Lcats_instances_package$list$.prototype.$classData = $d_Lcats_instances_package$list$;
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$()
  };
  return $n_Lcats_instances_package$list$
}
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  this.Lcats_instances_package$stream$__f_catsStdTraverseFilterForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  this.Lcats_instances_package$stream$__f_catsStdTraverseFilterForStream = new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$stream$.prototype = new $h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
  /*<skip>*/
}
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
var $d_Lcats_instances_package$stream$ = new $TypeData().initClass({
  Lcats_instances_package$stream$: 0
}, false, "cats.instances.package$stream$", {
  Lcats_instances_package$stream$: 1,
  O: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
});
$c_Lcats_instances_package$stream$.prototype.$classData = $d_Lcats_instances_package$stream$;
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$()
  };
  return $n_Lcats_instances_package$stream$
}
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  this.Lcats_instances_package$vector$__f_catsStdTraverseFilterForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  this.Lcats_instances_package$vector$__f_catsStdTraverseFilterForVector = new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
  /*<skip>*/
}
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass({
  Lcats_instances_package$vector$: 0
}, false, "cats.instances.package$vector$", {
  Lcats_instances_package$vector$: 1,
  O: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
});
$c_Lcats_instances_package$vector$.prototype.$classData = $d_Lcats_instances_package$vector$;
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$()
  };
  return $n_Lcats_instances_package$vector$
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$1(outer) {
  this.Lcats_kernel_Order$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_kernel_Order$$anon$1__f_$outer = outer
}
$c_Lcats_kernel_Order$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$1.prototype.constructor = $c_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$$anon$1.prototype = $c_Lcats_kernel_Order$$anon$1.prototype;
$c_Lcats_kernel_Order$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcats_kernel_Order$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.Lcats_kernel_Order$$anon$1__f_$outer.compare__O__O__I(x, y)
});
var $d_Lcats_kernel_Order$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_Order$$anon$1: 0
}, false, "cats.kernel.Order$$anon$1", {
  Lcats_kernel_Order$$anon$1: 1,
  O: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
});
$c_Lcats_kernel_Order$$anon$1.prototype.$classData = $d_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__s_math_BigDecimal__s_math_BigDecimal__Z = (function(x, y) {
  return (!$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y))
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigDecimal(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return x$1.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(y$1.s_math_BigDecimal__f_bigDecimal)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigDecimal__s_math_BigDecimal__Z($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalOrder: 0
}, false, "cats.kernel.instances.BigDecimalOrder", {
  Lcats_kernel_instances_BigDecimalOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__D__D__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__D__D__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uD(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__D__D__Z($uD(x), $uD(y))
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__D__D__Z($uD(x), $uD(y))
});
var $d_Lcats_kernel_instances_DoubleOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleOrder: 0
}, false, "cats.kernel.instances.DoubleOrder", {
  Lcats_kernel_instances_DoubleOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.$classData = $d_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__F__F__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__F__F__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uF(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__F__F__Z($uF(x), $uF(y))
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__F__F__Z($uF(x), $uF(y))
});
var $d_Lcats_kernel_instances_FloatOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FloatOrder: 0
}, false, "cats.kernel.instances.FloatOrder", {
  Lcats_kernel_instances_FloatOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_FloatOrder.prototype.$classData = $d_Lcats_kernel_instances_FloatOrder;
class $c_Ldiffson_PatchException extends $c_jl_Exception {
  constructor(msg) {
    super();
    this.Ldiffson_PatchException__f_msg = null;
    this.Ldiffson_PatchException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true)
  };
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true
    } else if ((x$0 instanceof $c_Ldiffson_PatchException)) {
      var x$0$2 = $as_Ldiffson_PatchException(x$0);
      return (this.Ldiffson_PatchException__f_msg === x$0$2.Ldiffson_PatchException__f_msg)
    } else {
      return false
    }
  };
  productArity__I() {
    return 1
  };
  productPrefix__T() {
    return "PatchException"
  };
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Ldiffson_PatchException__f_msg
    };
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
}
function $as_Ldiffson_PatchException(obj) {
  return (((obj instanceof $c_Ldiffson_PatchException) || (obj === null)) ? obj : $throwClassCastException(obj, "diffson.PatchException"))
}
function $isArrayOf_Ldiffson_PatchException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiffson_PatchException)))
}
function $asArrayOf_Ldiffson_PatchException(obj, depth) {
  return (($isArrayOf_Ldiffson_PatchException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiffson.PatchException;", depth))
}
var $d_Ldiffson_PatchException = new $TypeData().initClass({
  Ldiffson_PatchException: 0
}, false, "diffson.PatchException", {
  Ldiffson_PatchException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Ldiffson_PatchException.prototype.$classData = $d_Ldiffson_PatchException;
/** @constructor */
function $c_Ldiffson_circe_package$jsonyCirce$() {
  /*<skip>*/
}
$c_Ldiffson_circe_package$jsonyCirce$.prototype = new $h_O();
$c_Ldiffson_circe_package$jsonyCirce$.prototype.constructor = $c_Ldiffson_circe_package$jsonyCirce$;
/** @constructor */
function $h_Ldiffson_circe_package$jsonyCirce$() {
  /*<skip>*/
}
$h_Ldiffson_circe_package$jsonyCirce$.prototype = $c_Ldiffson_circe_package$jsonyCirce$.prototype;
$c_Ldiffson_circe_package$jsonyCirce$.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Ldiffson_circe_package$jsonyCirce$.prototype.fields__Lio_circe_Json__s_Option = (function(json) {
  var this$1 = json.asObject__s_Option();
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_Lio_circe_JsonObject(arg1);
    return new $c_s_Some(_$1.toMap__sci_Map())
  }
});
$c_Ldiffson_circe_package$jsonyCirce$.prototype.show__O__T = (function(t) {
  var json = $as_Lio_circe_Json(t);
  return $m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces.print__Lio_circe_Json__T(json)
});
$c_Ldiffson_circe_package$jsonyCirce$.prototype.eqv__O__O__Z = (function(x, y) {
  var json1 = $as_Lio_circe_Json(x);
  var json2 = $as_Lio_circe_Json(y);
  return $m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson.eqv__O__O__Z(json1, json2)
});
var $d_Ldiffson_circe_package$jsonyCirce$ = new $TypeData().initClass({
  Ldiffson_circe_package$jsonyCirce$: 0
}, false, "diffson.circe.package$jsonyCirce$", {
  Ldiffson_circe_package$jsonyCirce$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1,
  Ldiffson_Jsony: 1
});
$c_Ldiffson_circe_package$jsonyCirce$.prototype.$classData = $d_Ldiffson_circe_package$jsonyCirce$;
var $n_Ldiffson_circe_package$jsonyCirce$;
function $m_Ldiffson_circe_package$jsonyCirce$() {
  if ((!$n_Ldiffson_circe_package$jsonyCirce$)) {
    $n_Ldiffson_circe_package$jsonyCirce$ = new $c_Ldiffson_circe_package$jsonyCirce$()
  };
  return $n_Ldiffson_circe_package$jsonyCirce$
}
/** @constructor */
function $c_Lio_circe_CursorOp$DownField(k) {
  this.Lio_circe_CursorOp$DownField__f_k = null;
  this.Lio_circe_CursorOp$DownField__f_k = k
}
$c_Lio_circe_CursorOp$DownField.prototype = new $h_Lio_circe_CursorOp$ObjectOp();
$c_Lio_circe_CursorOp$DownField.prototype.constructor = $c_Lio_circe_CursorOp$DownField;
/** @constructor */
function $h_Lio_circe_CursorOp$DownField() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DownField.prototype = $c_Lio_circe_CursorOp$DownField.prototype;
$c_Lio_circe_CursorOp$DownField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$DownField.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$DownField)) {
    var x$0$2 = $as_Lio_circe_CursorOp$DownField(x$0);
    return (this.Lio_circe_CursorOp$DownField__f_k === x$0$2.Lio_circe_CursorOp$DownField__f_k)
  } else {
    return false
  }
});
$c_Lio_circe_CursorOp$DownField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$DownField.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$DownField.prototype.productPrefix__T = (function() {
  return "DownField"
});
$c_Lio_circe_CursorOp$DownField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$DownField__f_k
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lio_circe_CursorOp$DownField(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$DownField) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownField"))
}
function $isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownField)))
}
function $asArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownField;", depth))
}
var $d_Lio_circe_CursorOp$DownField = new $TypeData().initClass({
  Lio_circe_CursorOp$DownField: 0
}, false, "io.circe.CursorOp$DownField", {
  Lio_circe_CursorOp$DownField: 1,
  Lio_circe_CursorOp$ObjectOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$DownField.prototype.$classData = $d_Lio_circe_CursorOp$DownField;
function $as_Lio_circe_CursorOp$DownN(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownN"))
}
function $isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownN)))
}
function $asArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownN;", depth))
}
function $as_Lio_circe_CursorOp$Field(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Field"))
}
function $isArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Field)))
}
function $asArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Field(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Field;", depth))
}
class $c_Lio_circe_DecodingFailure$$anon$1 extends $c_Lio_circe_DecodingFailure {
  constructor(message$1, history$2, outer) {
    super();
    this.Lio_circe_DecodingFailure$$anon$1__f_history$1 = null;
    this.Lio_circe_DecodingFailure$$anon$1__f_history$lzy1 = null;
    this.Lio_circe_DecodingFailure$$anon$1__f_historybitmap$1 = false;
    this.Lio_circe_DecodingFailure$$anon$1__f_history$1 = history$2;
    if ((outer === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    };
    $ct_Lio_circe_DecodingFailure__T__(this, message$1)
  };
  history__sci_List() {
    if ((!this.Lio_circe_DecodingFailure$$anon$1__f_historybitmap$1)) {
      var history$1 = this.Lio_circe_DecodingFailure$$anon$1__f_history$1;
      this.Lio_circe_DecodingFailure$$anon$1__f_history$lzy1 = $as_sci_List(history$1.apply__O());
      this.Lio_circe_DecodingFailure$$anon$1__f_historybitmap$1 = true
    };
    return this.Lio_circe_DecodingFailure$$anon$1__f_history$lzy1
  };
}
var $d_Lio_circe_DecodingFailure$$anon$1 = new $TypeData().initClass({
  Lio_circe_DecodingFailure$$anon$1: 0
}, false, "io.circe.DecodingFailure$$anon$1", {
  Lio_circe_DecodingFailure$$anon$1: 1,
  Lio_circe_DecodingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_DecodingFailure$$anon$1.prototype.$classData = $d_Lio_circe_DecodingFailure$$anon$1;
class $c_Lio_circe_DecodingFailure$$anon$2 extends $c_Lio_circe_DecodingFailure {
  constructor(message$2, ops$1) {
    super();
    this.Lio_circe_DecodingFailure$$anon$2__f_ops$1 = null;
    this.Lio_circe_DecodingFailure$$anon$2__f_history$lzy2 = null;
    this.Lio_circe_DecodingFailure$$anon$2__f_historybitmap$2 = false;
    this.Lio_circe_DecodingFailure$$anon$2__f_ops$1 = ops$1;
    $ct_Lio_circe_DecodingFailure__T__(this, message$2)
  };
  history__sci_List() {
    if ((!this.Lio_circe_DecodingFailure$$anon$2__f_historybitmap$2)) {
      this.Lio_circe_DecodingFailure$$anon$2__f_history$lzy2 = $as_sci_List(this.Lio_circe_DecodingFailure$$anon$2__f_ops$1.apply__O());
      this.Lio_circe_DecodingFailure$$anon$2__f_historybitmap$2 = true
    };
    return this.Lio_circe_DecodingFailure$$anon$2__f_history$lzy2
  };
}
var $d_Lio_circe_DecodingFailure$$anon$2 = new $TypeData().initClass({
  Lio_circe_DecodingFailure$$anon$2: 0
}, false, "io.circe.DecodingFailure$$anon$2", {
  Lio_circe_DecodingFailure$$anon$2: 1,
  Lio_circe_DecodingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_DecodingFailure$$anon$2.prototype.$classData = $d_Lio_circe_DecodingFailure$$anon$2;
function $f_Lio_circe_DerivedEncoder__encodeWith__I__O__T2($thiz, index, value) {
  var _1 = $thiz.elemLabels__AT().get(index);
  var _2 = $thiz.elemEncoders__ALio_circe_Encoder().get(index).apply__O__Lio_circe_Json(value);
  return $ct_T2__O__O__(new $c_T2(), _1, _2)
}
/** @constructor */
function $c_Lio_circe_DerivedEncoder$$anon$1(value$3, outer) {
  this.Lio_circe_DerivedEncoder$$anon$1__f_value$1 = null;
  this.Lio_circe_DerivedEncoder$$anon$1__f_$outer = null;
  this.Lio_circe_DerivedEncoder$$anon$1__f_value$1 = value$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_DerivedEncoder$$anon$1__f_$outer = outer
}
$c_Lio_circe_DerivedEncoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.constructor = $c_Lio_circe_DerivedEncoder$$anon$1;
/** @constructor */
function $h_Lio_circe_DerivedEncoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_DerivedEncoder$$anon$1.prototype = $c_Lio_circe_DerivedEncoder$$anon$1.prototype;
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Iterable$().newBuilder__scm_Builder()
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.className__T = (function() {
  return "Iterable"
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_DerivedEncoder$$anon$2(this.Lio_circe_DerivedEncoder$$anon$1__f_value$1, this)
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll))
});
var $d_Lio_circe_DerivedEncoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_DerivedEncoder$$anon$1: 0
}, false, "io.circe.DerivedEncoder$$anon$1", {
  Lio_circe_DerivedEncoder$$anon$1: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
});
$c_Lio_circe_DerivedEncoder$$anon$1.prototype.$classData = $d_Lio_circe_DerivedEncoder$$anon$1;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$26(encodeA$3) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_$outer = null;
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, $m_Lio_circe_Encoder$(), encodeA$3)
}
$c_Lio_circe_Encoder$$anon$26.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_Encoder$$anon$26.prototype.constructor = $c_Lio_circe_Encoder$$anon$26;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$26() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$26.prototype = $c_Lio_circe_Encoder$$anon$26.prototype;
var $d_Lio_circe_Encoder$$anon$26 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$26: 0
}, false, "io.circe.Encoder$$anon$26", {
  Lio_circe_Encoder$$anon$26: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsArray: 1
});
$c_Lio_circe_Encoder$$anon$26.prototype.$classData = $d_Lio_circe_Encoder$$anon$26;
/** @constructor */
function $c_Lio_circe_JsonBiggerDecimal(value, input) {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = null;
  this.Lio_circe_JsonBiggerDecimal__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = value;
  this.Lio_circe_JsonBiggerDecimal__f_input = input;
  $ct_Lio_circe_BiggerDecimalJsonNumber__T__(this, input)
}
$c_Lio_circe_JsonBiggerDecimal.prototype = new $h_Lio_circe_BiggerDecimalJsonNumber();
$c_Lio_circe_JsonBiggerDecimal.prototype.constructor = $c_Lio_circe_JsonBiggerDecimal;
/** @constructor */
function $h_Lio_circe_JsonBiggerDecimal() {
  /*<skip>*/
}
$h_Lio_circe_JsonBiggerDecimal.prototype = $c_Lio_circe_JsonBiggerDecimal.prototype;
$c_Lio_circe_JsonBiggerDecimal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productArity__I = (function() {
  return 2
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productPrefix__T = (function() {
  return "JsonBiggerDecimal"
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonBiggerDecimal__f_value
  };
  if ((n === 1)) {
    return this.Lio_circe_JsonBiggerDecimal__f_input
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toDouble__D = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value.toDouble__D()
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toFloat__F = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value.toFloat__F()
});
var $d_Lio_circe_JsonBiggerDecimal = new $TypeData().initClass({
  Lio_circe_JsonBiggerDecimal: 0
}, false, "io.circe.JsonBiggerDecimal", {
  Lio_circe_JsonBiggerDecimal: 1,
  Lio_circe_BiggerDecimalJsonNumber: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_JsonBiggerDecimal.prototype.$classData = $d_Lio_circe_JsonBiggerDecimal;
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$1(outer) {
  this.Lio_circe_JsonObject$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_JsonObject$$anon$1__f_$outer = outer
}
$c_Lio_circe_JsonObject$$anon$1.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$1.prototype.constructor = $c_Lio_circe_JsonObject$$anon$1;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$$anon$1.prototype = $c_Lio_circe_JsonObject$$anon$1.prototype;
$c_Lio_circe_JsonObject$$anon$1.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$$anon$4(this);
  return this$1.next__T()
});
$c_Lio_circe_JsonObject$$anon$1.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Iterable$().newBuilder__scm_Builder()
});
$c_Lio_circe_JsonObject$$anon$1.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_Lio_circe_JsonObject$$anon$1.prototype.className__T = (function() {
  return "Iterable"
});
$c_Lio_circe_JsonObject$$anon$1.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$$anon$4(this)
});
$c_Lio_circe_JsonObject$$anon$1.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll))
});
var $d_Lio_circe_JsonObject$$anon$1 = new $TypeData().initClass({
  Lio_circe_JsonObject$$anon$1: 0
}, false, "io.circe.JsonObject$$anon$1", {
  Lio_circe_JsonObject$$anon$1: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
});
$c_Lio_circe_JsonObject$$anon$1.prototype.$classData = $d_Lio_circe_JsonObject$$anon$1;
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$3(outer) {
  this.Lio_circe_JsonObject$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lio_circe_JsonObject$$anon$3__f_$outer = outer
}
$c_Lio_circe_JsonObject$$anon$3.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$3.prototype.constructor = $c_Lio_circe_JsonObject$$anon$3;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$$anon$3.prototype = $c_Lio_circe_JsonObject$$anon$3.prototype;
$c_Lio_circe_JsonObject$$anon$3.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$$anon$6(this);
  return this$1.next__T2()
});
$c_Lio_circe_JsonObject$$anon$3.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Iterable$().newBuilder__scm_Builder()
});
$c_Lio_circe_JsonObject$$anon$3.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_Lio_circe_JsonObject$$anon$3.prototype.className__T = (function() {
  return "Iterable"
});
$c_Lio_circe_JsonObject$$anon$3.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$$anon$6(this)
});
$c_Lio_circe_JsonObject$$anon$3.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll))
});
var $d_Lio_circe_JsonObject$$anon$3 = new $TypeData().initClass({
  Lio_circe_JsonObject$$anon$3: 0
}, false, "io.circe.JsonObject$$anon$3", {
  Lio_circe_JsonObject$$anon$3: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
});
$c_Lio_circe_JsonObject$$anon$3.prototype.$classData = $d_Lio_circe_JsonObject$$anon$3;
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
function $as_jl_ArrayIndexOutOfBoundsException(obj) {
  return (((obj instanceof $c_jl_ArrayIndexOutOfBoundsException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArrayIndexOutOfBoundsException"))
}
function $isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArrayIndexOutOfBoundsException)))
}
function $asArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (($isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArrayIndexOutOfBoundsException;", depth))
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass({
  jl_ArrayIndexOutOfBoundsException: 0
}, false, "java.lang.ArrayIndexOutOfBoundsException", {
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArrayIndexOutOfBoundsException.prototype.$classData = $d_jl_ArrayIndexOutOfBoundsException;
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Double__hashCode__I($thiz) {
  var value = $uD($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Double__toString__T($thiz) {
  var d = $uD($thiz);
  return ("" + d)
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  var that = $as_jl_Double(o);
  return $m_jl_Double$().compare__D__D__I($uD($thiz), $uD(that))
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"))
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)))
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth))
}
var $d_jl_Double = new $TypeData().initClass({
  jl_Double: 0
}, false, "java.lang.Double", {
  jl_Double: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $uF($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Float__toString__T($thiz) {
  var f = $uF($thiz);
  return ("" + f)
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  var that = $as_jl_Float(o);
  var a = $uF($thiz);
  var b = $uF(that);
  return $m_jl_Double$().compare__D__D__I(a, b)
}
function $as_jl_Float(obj) {
  return (($isFloat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"))
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)))
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth))
}
var $d_jl_Float = new $TypeData().initClass({
  jl_Float: 0
}, false, "java.lang.Float", {
  jl_Float: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $uI($thiz)
}
function $f_jl_Integer__toString__T($thiz) {
  var i = $uI($thiz);
  return ("" + i)
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  var that = $as_jl_Integer(o);
  var x = $uI($thiz);
  var y = $uI(that);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"))
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)))
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth))
}
var $d_jl_Integer = new $TypeData().initClass({
  jl_Integer: 0
}, false, "java.lang.Integer", {
  jl_Integer: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_jl_Long(that);
    var this$1 = $uJ($thiz);
    var b = $uJ(x2);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
}
function $f_jl_Long__hashCode__I($thiz) {
  var t = $uJ($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
}
function $f_jl_Long__toString__T($thiz) {
  var this$1 = $uJ($thiz);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
}
function $f_jl_Long__compareTo__O__I($thiz, o) {
  var that = $as_jl_Long(o);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I($thiz.RTLong__f_lo, $thiz.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
}
function $as_jl_Long(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"))
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)))
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth))
}
var $d_jl_Long = new $TypeData().initClass({
  jl_Long: 0
}, false, "java.lang.Long", {
  jl_Long: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => (x instanceof $c_RTLong)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"))
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)))
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth))
}
var $d_jl_NumberFormatException = new $TypeData().initClass({
  jl_NumberFormatException: 0
}, false, "java.lang.NumberFormatException", {
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NumberFormatException.prototype.$classData = $d_jl_NumberFormatException;
function $f_T__charAt__I__C($thiz, index) {
  return (65535 & $uI($thiz.charCodeAt(index)))
}
function $f_T__codePointAt__I__I($thiz, index) {
  return $uI($thiz.codePointAt(index))
}
function $f_T__hashCode__I($thiz) {
  var res = 0;
  var mul = 1;
  var i = (((-1) + $uI($thiz.length)) | 0);
  while ((i >= 0)) {
    var $$x1 = res;
    var index = i;
    res = (($$x1 + Math.imul((65535 & $uI($thiz.charCodeAt(index))), mul)) | 0);
    mul = Math.imul(31, mul);
    i = (((-1) + i) | 0)
  };
  return res
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $uI($thiz.length);
  var strLength = $uI(anotherString.length);
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var $$x1 = $uI($thiz.charCodeAt(index));
    var index$1 = i;
    var cmp = (((65535 & $$x1) - (65535 & $uI(anotherString.charCodeAt(index$1)))) | 0);
    if ((cmp !== 0)) {
      return cmp
    };
    i = ((1 + i) | 0)
  };
  return ((thisLength - strLength) | 0)
}
function $f_T__endsWith__T__Z($thiz, suffix) {
  return ($as_T($thiz.substring((($uI($thiz.length) - $uI(suffix.length)) | 0))) === suffix)
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $uI($thiz.length)) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound")
  };
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $$x1 = i;
    var index = i;
    dst.set((($$x1 + offset) | 0), (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str))
}
function $f_T__indexOf__I__I__I($thiz, ch, fromIndex) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str, fromIndex))
}
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.lastIndexOf(str))
}
function $f_T__length__I($thiz) {
  return $uI($thiz.length)
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit)
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  return $as_T($thiz.substring(beginIndex, endIndex))
}
function $f_T__toCharArray__AC($thiz) {
  var len = $uI($thiz.length);
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var index = i;
    result.set($$x1, (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  };
  return result
}
function $f_T__trim__T($thiz) {
  var len = $uI($thiz.length);
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $$x1 = ((65535 & $uI($thiz.charCodeAt(index))) <= 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      start = ((1 + start) | 0)
    } else {
      break
    }
  };
  if ((start === len)) {
    return ""
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (((65535 & $uI($thiz.charCodeAt(index$1))) <= 32)) {
        end = (((-1) + end) | 0)
      } else {
        break
      }
    };
    if (((start === 0) && (end === len))) {
      return $thiz
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $as_T($thiz.substring(beginIndex, endIndex))
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, $as_T(o))
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"))
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)))
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth))
}
var $d_T = new $TypeData().initClass({
  T: 0
}, false, "java.lang.String", {
  T: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "string")));
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__I__($thiz, index) {
  var s = ("String index out of range: " + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass({
  jl_StringIndexOutOfBoundsException: 0
}, false, "java.lang.StringIndexOutOfBoundsException", {
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringIndexOutOfBoundsException.prototype.$classData = $d_jl_StringIndexOutOfBoundsException;
function $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? field.isDateBased__Z() : ((field !== null) && $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field)))
}
function $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  };
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()
  };
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($thiz.toEpochDay__J())
  };
  matchAlts1: {
    matchAlts2: {
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts2
      };
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2
      };
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2
      };
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2
      };
      break matchAlts1
    };
    return null
  };
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query)
}
function $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I($thiz, other) {
  var t = $thiz.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    cmp = $f_T__compareTo__T__I("ISO", "ISO")
  };
  return cmp
}
function $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var this$1 = $thiz.toEpochDay__J();
  var b = other.toEpochDay__J();
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
}
function $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var this$1 = $thiz.toEpochDay__J();
  var b = other.toEpochDay__J();
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
}
function $is_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoLocalDate)))
}
function $as_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (($is_Ljava_time_chrono_ChronoLocalDate(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDate"))
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDate)))
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDate;", depth))
}
/** @constructor */
function $c_Ljava_time_chrono_ChronoLocalDateTime() {
  /*<skip>*/
}
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype = new $h_O();
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.constructor = $c_Ljava_time_chrono_ChronoLocalDateTime;
/** @constructor */
function $h_Ljava_time_chrono_ChronoLocalDateTime() {
  /*<skip>*/
}
$h_Ljava_time_chrono_ChronoLocalDateTime.prototype = $c_Ljava_time_chrono_ChronoLocalDateTime.prototype;
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  };
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit()
  };
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(this.Ljava_time_LocalDateTime__f_date.toEpochDay__J())
  };
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === query)) {
    return this.Ljava_time_LocalDateTime__f_time
  };
  matchAlts1: {
    matchAlts2: {
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2
      };
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2
      };
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2
      };
      break matchAlts1
    };
    return null
  };
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), this.Ljava_time_LocalDateTime__f_date.toEpochDay__J()).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J())
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant = (function(offset) {
  var $$x2 = $m_Ljava_time_Instant$();
  var $$x1 = this.toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$1 = this.Ljava_time_LocalDateTime__f_time;
  var value = this$1.Ljava_time_LocalTime__f_nano;
  var hi = (value >> 31);
  return $$x2.ofEpochSecond__J__J__Ljava_time_Instant($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toEpochSecond__Ljava_time_ZoneOffset__J = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = this.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var this$5__lo = secs__lo;
  var this$5__hi = secs__hi;
  var value$1 = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = this$5__lo;
  var ahi = this$5__hi;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$5;
  secs__lo = $$x1__lo;
  secs__hi = $$x1__hi;
  return new $c_RTLong(secs__lo, secs__hi)
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  var this$1 = this.Ljava_time_LocalDateTime__f_date;
  var that = other.Ljava_time_LocalDateTime__f_date;
  var cmp = this$1.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that);
  if ((cmp === 0)) {
    var this$2 = this.Ljava_time_LocalDateTime__f_time;
    var other$1 = other.Ljava_time_LocalDateTime__f_time;
    cmp = this$2.compare__Ljava_time_LocalTime__I(other$1);
    if ((cmp === 0)) {
      $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      cmp = $f_T__compareTo__T__I("ISO", "ISO")
    }
  };
  return cmp
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) > ((-2147483648) ^ lo$1)) : (hi > hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$1 = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var b = other.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var ahi = this$1.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
  } else {
    return false
  }
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) < ((-2147483648) ^ lo$1)) : (hi < hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$1 = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var b = other.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var ahi = this$1.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
  } else {
    return false
  }
});
function $as_Ljava_time_chrono_ChronoLocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_chrono_ChronoLocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDateTime"))
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDateTime)))
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDateTime;", depth))
}
class $c_Ljava_time_format_DateTimeParseException extends $c_Ljava_time_DateTimeException {
  constructor(message, parsedData, errorIndex, cause) {
    super();
    this.Ljava_time_format_DateTimeParseException__f_errorIndex = 0;
    this.Ljava_time_format_DateTimeParseException__f_parsedString = null;
    this.Ljava_time_format_DateTimeParseException__f_errorIndex = errorIndex;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
    this.Ljava_time_format_DateTimeParseException__f_parsedString = $dp_toString__T(parsedData)
  };
}
function $as_Ljava_time_format_DateTimeParseException(obj) {
  return (((obj instanceof $c_Ljava_time_format_DateTimeParseException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.DateTimeParseException"))
}
function $isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DateTimeParseException)))
}
function $asArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (($isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.DateTimeParseException;", depth))
}
var $d_Ljava_time_format_DateTimeParseException = new $TypeData().initClass({
  Ljava_time_format_DateTimeParseException: 0
}, false, "java.time.format.DateTimeParseException", {
  Ljava_time_format_DateTimeParseException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_DateTimeParseException.prototype.$classData = $d_Ljava_time_format_DateTimeParseException;
class $c_Ljava_time_temporal_UnsupportedTemporalTypeException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true)
  };
}
var $d_Ljava_time_temporal_UnsupportedTemporalTypeException = new $TypeData().initClass({
  Ljava_time_temporal_UnsupportedTemporalTypeException: 0
}, false, "java.time.temporal.UnsupportedTemporalTypeException", {
  Ljava_time_temporal_UnsupportedTemporalTypeException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_UnsupportedTemporalTypeException.prototype.$classData = $d_Ljava_time_temporal_UnsupportedTemporalTypeException;
class $c_Ljava_time_zone_ZoneRulesException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true)
  };
}
function $as_Ljava_time_zone_ZoneRulesException(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesException"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesException)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesException;", depth))
}
var $d_Ljava_time_zone_ZoneRulesException = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesException: 0
}, false, "java.time.zone.ZoneRulesException", {
  Ljava_time_zone_ZoneRulesException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneRulesException.prototype.$classData = $d_Ljava_time_zone_ZoneRulesException;
/** @constructor */
function $c_ju_Arrays$$anon$1() {
  /*<skip>*/
}
$c_ju_Arrays$$anon$1.prototype = new $h_O();
$c_ju_Arrays$$anon$1.prototype.constructor = $c_ju_Arrays$$anon$1;
/** @constructor */
function $h_ju_Arrays$$anon$1() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$1.prototype = $c_ju_Arrays$$anon$1.prototype;
$c_ju_Arrays$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_ju_Arrays$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $dp_compareTo__O__I($as_jl_Comparable(x), y)
});
var $d_ju_Arrays$$anon$1 = new $TypeData().initClass({
  ju_Arrays$$anon$1: 0
}, false, "java.util.Arrays$$anon$1", {
  ju_Arrays$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Arrays$$anon$1.prototype.$classData = $d_ju_Arrays$$anon$1;
/** @constructor */
function $c_ju_Arrays$$anon$3(cmp$1) {
  this.ju_Arrays$$anon$3__f_cmp$1 = null;
  this.ju_Arrays$$anon$3__f_cmp$1 = cmp$1
}
$c_ju_Arrays$$anon$3.prototype = new $h_O();
$c_ju_Arrays$$anon$3.prototype.constructor = $c_ju_Arrays$$anon$3;
/** @constructor */
function $h_ju_Arrays$$anon$3() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$3.prototype = $c_ju_Arrays$$anon$3.prototype;
$c_ju_Arrays$$anon$3.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_ju_Arrays$$anon$3.prototype.compare__O__O__I = (function(x, y) {
  return this.ju_Arrays$$anon$3__f_cmp$1.compare__O__O__I(x, y)
});
var $d_ju_Arrays$$anon$3 = new $TypeData().initClass({
  ju_Arrays$$anon$3: 0
}, false, "java.util.Arrays$$anon$3", {
  ju_Arrays$$anon$3: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Arrays$$anon$3.prototype.$classData = $d_ju_Arrays$$anon$3;
/** @constructor */
function $c_ju_Collections$UnmodifiableListIterator(innerIterator) {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
  $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(this, innerIterator)
}
$c_ju_Collections$UnmodifiableListIterator.prototype = new $h_ju_Collections$UnmodifiableIterator();
$c_ju_Collections$UnmodifiableListIterator.prototype.constructor = $c_ju_Collections$UnmodifiableListIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableListIterator() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableListIterator.prototype = $c_ju_Collections$UnmodifiableListIterator.prototype;
$c_ju_Collections$UnmodifiableListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_Collections$UnmodifiableListIterator = new $TypeData().initClass({
  ju_Collections$UnmodifiableListIterator: 0
}, false, "java.util.Collections$UnmodifiableListIterator", {
  ju_Collections$UnmodifiableListIterator: 1,
  ju_Collections$UnmodifiableIterator: 1,
  O: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1,
  ju_Collections$WrappedListIterator: 1,
  ju_ListIterator: 1
});
$c_ju_Collections$UnmodifiableListIterator.prototype.$classData = $d_ju_Collections$UnmodifiableListIterator;
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_ju_FormatterClosedException = new $TypeData().initClass({
  ju_FormatterClosedException: 0
}, false, "java.util.FormatterClosedException", {
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatterClosedException.prototype.$classData = $d_ju_FormatterClosedException;
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.ju_HashMap$EntrySet__f_$outer = outer
  }
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
  /*<skip>*/
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_HashMap$EntrySet__f_$outer;
  return this$1.nodeIterator__ju_Iterator()
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return this.ju_HashMap$EntrySet__f_$outer.ju_HashMap__f_contentSize
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    var key = x2.getKey__O();
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = x2.getValue__O();
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$EntrySet.prototype.remove__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var key = x2.getKey__O();
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var idx = (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = x2.getValue__O();
      var $$x1 = ((a === null) ? (b === null) : $dp_equals__O__Z(a, b))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this.ju_HashMap$EntrySet__f_$outer.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass({
  ju_HashMap$EntrySet: 0
}, false, "java.util.HashMap$EntrySet", {
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$EntrySet.prototype.$classData = $d_ju_HashMap$EntrySet;
/** @constructor */
function $c_ju_HashMap$KeySet(outer) {
  this.ju_HashMap$KeySet__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.ju_HashMap$KeySet__f_$outer = outer
  }
}
$c_ju_HashMap$KeySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$KeySet.prototype.constructor = $c_ju_HashMap$KeySet;
/** @constructor */
function $h_ju_HashMap$KeySet() {
  /*<skip>*/
}
$h_ju_HashMap$KeySet.prototype = $c_ju_HashMap$KeySet.prototype;
$c_ju_HashMap$KeySet.prototype.iterator__ju_Iterator = (function() {
  return this.ju_HashMap$KeySet__f_$outer.keyIterator__ju_Iterator()
});
$c_ju_HashMap$KeySet.prototype.size__I = (function() {
  return this.ju_HashMap$KeySet__f_$outer.ju_HashMap__f_contentSize
});
$c_ju_HashMap$KeySet.prototype.contains__O__Z = (function(o) {
  return this.ju_HashMap$KeySet__f_$outer.containsKey__O__Z(o)
});
$c_ju_HashMap$KeySet.prototype.remove__O__Z = (function(o) {
  return (this.ju_HashMap$KeySet__f_$outer.java$util$HashMap$$remove0__O__ju_HashMap$Node(o) !== null)
});
var $d_ju_HashMap$KeySet = new $TypeData().initClass({
  ju_HashMap$KeySet: 0
}, false, "java.util.HashMap$KeySet", {
  ju_HashMap$KeySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$KeySet.prototype.$classData = $d_ju_HashMap$KeySet;
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.ju_LinkedHashMap__f_youngest;
  if ((older !== null)) {
    older.ju_LinkedHashMap$Node__f_younger = node
  } else {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = node
  };
  node.ju_LinkedHashMap$Node__f_older = older;
  node.ju_LinkedHashMap$Node__f_younger = null;
  $thiz.ju_LinkedHashMap__f_youngest = node
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = node.ju_LinkedHashMap$Node__f_older;
  var younger = node.ju_LinkedHashMap$Node__f_younger;
  if ((older === null)) {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = younger
  } else {
    older.ju_LinkedHashMap$Node__f_younger = younger
  };
  if ((younger === null)) {
    $thiz.ju_LinkedHashMap__f_youngest = older
  } else {
    younger.ju_LinkedHashMap$Node__f_older = older
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.ju_LinkedHashMap__f_loadFactor = loadFactor;
  $thiz.ju_LinkedHashMap__f_accessOrder = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  this.ju_LinkedHashMap__f_loadFactor = 0.0;
  this.ju_LinkedHashMap__f_accessOrder = false;
  this.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = null;
  this.ju_LinkedHashMap__f_youngest = null
}
$c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$c_ju_LinkedHashMap.prototype.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
  /*<skip>*/
}
$h_ju_LinkedHashMap.prototype = $c_ju_LinkedHashMap.prototype;
$c_ju_LinkedHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, null, null)
});
$c_ju_LinkedHashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  if (this.ju_LinkedHashMap__f_accessOrder) {
    var myNode = $as_ju_LinkedHashMap$Node(node);
    if ((myNode.ju_LinkedHashMap$Node__f_younger !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, myNode);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, myNode)
    }
  }
});
$c_ju_LinkedHashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node))
});
$c_ju_LinkedHashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node))
});
$c_ju_LinkedHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this)
});
$c_ju_LinkedHashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$KeyIterator(this)
});
var $d_ju_LinkedHashMap = new $TypeData().initClass({
  ju_LinkedHashMap: 0
}, false, "java.util.LinkedHashMap", {
  ju_LinkedHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_LinkedHashMap.prototype.$classData = $d_ju_LinkedHashMap;
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    return ((((idx >= 0) && (re !== null)) && (idx < $uI(re.length))) ? (((base + "\n") + $as_T(" ".repeat(idx))) + "^") : base)
  };
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass({
  ju_regex_PatternSyntaxException: 0
}, false, "java.util.regex.PatternSyntaxException", {
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_PatternSyntaxException.prototype.$classData = $d_ju_regex_PatternSyntaxException;
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$Status$Connected(ws) {
  this.Lnet_timerboard_BackendSocket$Status$Connected__f_ws = null;
  this.Lnet_timerboard_BackendSocket$Status$Connected__f_ws = ws
}
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype = new $h_Lnet_timerboard_BackendSocket$Status();
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.constructor = $c_Lnet_timerboard_BackendSocket$Status$Connected;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$Status$Connected() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$Status$Connected.prototype = $c_Lnet_timerboard_BackendSocket$Status$Connected.prototype;
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_BackendSocket$Status$Connected)) {
    var x$0$2 = $as_Lnet_timerboard_BackendSocket$Status$Connected(x$0);
    var x = this.Lnet_timerboard_BackendSocket$Status$Connected__f_ws;
    var x$2 = x$0$2.Lnet_timerboard_BackendSocket$Status$Connected__f_ws;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.productPrefix__T = (function() {
  return "Connected"
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_BackendSocket$Status$Connected__f_ws
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.ordinal__I = (function() {
  return 1
});
function $as_Lnet_timerboard_BackendSocket$Status$Connected(obj) {
  return (((obj instanceof $c_Lnet_timerboard_BackendSocket$Status$Connected) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.BackendSocket$Status$Connected"))
}
function $isArrayOf_Lnet_timerboard_BackendSocket$Status$Connected(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_BackendSocket$Status$Connected)))
}
function $asArrayOf_Lnet_timerboard_BackendSocket$Status$Connected(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_BackendSocket$Status$Connected(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.BackendSocket$Status$Connected;", depth))
}
var $d_Lnet_timerboard_BackendSocket$Status$Connected = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket$Status$Connected: 0
}, false, "net.timerboard.BackendSocket$Status$Connected", {
  Lnet_timerboard_BackendSocket$Status$Connected: 1,
  Lnet_timerboard_BackendSocket$Status: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_BackendSocket$Status$Connected.prototype.$classData = $d_Lnet_timerboard_BackendSocket$Status$Connected;
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$Status$ConnectionError(msg) {
  this.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg = null;
  this.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg = msg
}
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype = new $h_Lnet_timerboard_BackendSocket$Status();
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.constructor = $c_Lnet_timerboard_BackendSocket$Status$ConnectionError;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$Status$ConnectionError() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype = $c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype;
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_BackendSocket$Status$ConnectionError)) {
    var x$0$2 = $as_Lnet_timerboard_BackendSocket$Status$ConnectionError(x$0);
    return (this.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg === x$0$2.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg)
  } else {
    return false
  }
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.productPrefix__T = (function() {
  return "ConnectionError"
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_BackendSocket$Status$ConnectionError__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.ordinal__I = (function() {
  return 2
});
function $as_Lnet_timerboard_BackendSocket$Status$ConnectionError(obj) {
  return (((obj instanceof $c_Lnet_timerboard_BackendSocket$Status$ConnectionError) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.BackendSocket$Status$ConnectionError"))
}
function $isArrayOf_Lnet_timerboard_BackendSocket$Status$ConnectionError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_BackendSocket$Status$ConnectionError)))
}
function $asArrayOf_Lnet_timerboard_BackendSocket$Status$ConnectionError(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_BackendSocket$Status$ConnectionError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.BackendSocket$Status$ConnectionError;", depth))
}
var $d_Lnet_timerboard_BackendSocket$Status$ConnectionError = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket$Status$ConnectionError: 0
}, false, "net.timerboard.BackendSocket$Status$ConnectionError", {
  Lnet_timerboard_BackendSocket$Status$ConnectionError: 1,
  Lnet_timerboard_BackendSocket$Status: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_BackendSocket$Status$ConnectionError.prototype.$classData = $d_Lnet_timerboard_BackendSocket$Status$ConnectionError;
/** @constructor */
function $c_Lnet_timerboard_EventType$$anon$7(s$3) {
  this.Lnet_timerboard_EventType$$anon$7__f_s$2 = null;
  this.Lnet_timerboard_EventType$$anon$7__f_s$2 = s$3
}
$c_Lnet_timerboard_EventType$$anon$7.prototype = new $h_O();
$c_Lnet_timerboard_EventType$$anon$7.prototype.constructor = $c_Lnet_timerboard_EventType$$anon$7;
/** @constructor */
function $h_Lnet_timerboard_EventType$$anon$7() {
  /*<skip>*/
}
$h_Lnet_timerboard_EventType$$anon$7.prototype = $c_Lnet_timerboard_EventType$$anon$7.prototype;
$c_Lnet_timerboard_EventType$$anon$7.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lnet_timerboard_EventType$$anon$7.prototype.apply__Lnet_timerboard_EventType__Lio_circe_Json = (function(t) {
  $m_Lio_circe_Json$();
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("station_freeport", this$1);
  var this$3 = new $c_sci_$colon$colon("station_defense", this$2);
  var this$4 = new $c_sci_$colon$colon("ihub_defense", this$3);
  var this$5 = new $c_sci_$colon$colon("tcu_defense", this$4);
  var n = this.Lnet_timerboard_EventType$$anon$7__f_s$2.ordinal__O__I(t);
  var value = $as_T($f_sc_LinearSeqOps__apply__I__O(this$5, n));
  return new $c_Lio_circe_Json$JString(value)
});
$c_Lnet_timerboard_EventType$$anon$7.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var this$13 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var f = new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_T(s);
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon("station_freeport", this$1);
    var this$3 = new $c_sci_$colon$colon("station_defense", this$2);
    var this$4 = new $c_sci_$colon$colon("ihub_defense", this$3);
    var this$5 = new $c_sci_$colon$colon("tcu_defense", this$4);
    var x165 = $f_sc_SeqOps__indexOf__O__I__I(this$5, s$1, 0);
    if ((x165 === (-1))) {
      $m_s_package$();
      var value = (("'" + s$1) + "' was not a type of EventType");
      return new $c_s_util_Left(value)
    };
    $m_s_package$();
    var ev$6 = $s_Lnet_timerboard_EventType$__tcu_defense__Lnet_timerboard_EventType();
    var ev$7 = $s_Lnet_timerboard_EventType$__ihub_defense__Lnet_timerboard_EventType();
    var ev$8 = $s_Lnet_timerboard_EventType$__station_defense__Lnet_timerboard_EventType();
    var ev$9 = $s_Lnet_timerboard_EventType$__station_freeport__Lnet_timerboard_EventType();
    var this$7 = $m_s_package$().s_package$__f_Nil;
    var this$8 = new $c_sci_$colon$colon(ev$9, this$7);
    var this$9 = new $c_sci_$colon$colon(ev$8, this$8);
    var this$10 = new $c_sci_$colon$colon(ev$7, this$9);
    var this$11 = new $c_sci_$colon$colon(ev$6, this$10);
    var value$1 = $f_sc_LinearSeqOps__apply__I__O(this$11, x165);
    return new $c_s_util_Right(value$1)
  }));
  var this$14 = new $c_Lio_circe_Decoder$$anon$13(f, this$13);
  return this$14.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lnet_timerboard_EventType$$anon$7.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__Lnet_timerboard_EventType__Lio_circe_Json($as_Lnet_timerboard_EventType(a))
});
var $d_Lnet_timerboard_EventType$$anon$7 = new $TypeData().initClass({
  Lnet_timerboard_EventType$$anon$7: 0
}, false, "net.timerboard.EventType$$anon$7", {
  Lnet_timerboard_EventType$$anon$7: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Codec: 1,
  Lnet_timerboard_CirceEnumHelpers$EnumCodec: 1
});
$c_Lnet_timerboard_EventType$$anon$7.prototype.$classData = $d_Lnet_timerboard_EventType$$anon$7;
/** @constructor */
function $c_Lnet_timerboard_Msg$BadHttp(e) {
  this.Lnet_timerboard_Msg$BadHttp__f_e = null;
  this.Lnet_timerboard_Msg$BadHttp__f_e = e
}
$c_Lnet_timerboard_Msg$BadHttp.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$BadHttp.prototype.constructor = $c_Lnet_timerboard_Msg$BadHttp;
/** @constructor */
function $h_Lnet_timerboard_Msg$BadHttp() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$BadHttp.prototype = $c_Lnet_timerboard_Msg$BadHttp.prototype;
$c_Lnet_timerboard_Msg$BadHttp.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$BadHttp)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$BadHttp(x$0);
    var x = this.Lnet_timerboard_Msg$BadHttp__f_e;
    var x$2 = x$0$2.Lnet_timerboard_Msg$BadHttp__f_e;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.productPrefix__T = (function() {
  return "BadHttp"
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$BadHttp__f_e
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.ordinal__I = (function() {
  return 5
});
function $as_Lnet_timerboard_Msg$BadHttp(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$BadHttp) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$BadHttp"))
}
function $isArrayOf_Lnet_timerboard_Msg$BadHttp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$BadHttp)))
}
function $asArrayOf_Lnet_timerboard_Msg$BadHttp(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$BadHttp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$BadHttp;", depth))
}
var $d_Lnet_timerboard_Msg$BadHttp = new $TypeData().initClass({
  Lnet_timerboard_Msg$BadHttp: 0
}, false, "net.timerboard.Msg$BadHttp", {
  Lnet_timerboard_Msg$BadHttp: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$BadHttp.prototype.$classData = $d_Lnet_timerboard_Msg$BadHttp;
/** @constructor */
function $c_Lnet_timerboard_Msg$BadPayload(e) {
  this.Lnet_timerboard_Msg$BadPayload__f_e = null;
  this.Lnet_timerboard_Msg$BadPayload__f_e = e
}
$c_Lnet_timerboard_Msg$BadPayload.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$BadPayload.prototype.constructor = $c_Lnet_timerboard_Msg$BadPayload;
/** @constructor */
function $h_Lnet_timerboard_Msg$BadPayload() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$BadPayload.prototype = $c_Lnet_timerboard_Msg$BadPayload.prototype;
$c_Lnet_timerboard_Msg$BadPayload.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$BadPayload)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$BadPayload(x$0);
    var x = this.Lnet_timerboard_Msg$BadPayload__f_e;
    var x$2 = x$0$2.Lnet_timerboard_Msg$BadPayload__f_e;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.productPrefix__T = (function() {
  return "BadPayload"
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$BadPayload__f_e
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.ordinal__I = (function() {
  return 6
});
function $as_Lnet_timerboard_Msg$BadPayload(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$BadPayload) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$BadPayload"))
}
function $isArrayOf_Lnet_timerboard_Msg$BadPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$BadPayload)))
}
function $asArrayOf_Lnet_timerboard_Msg$BadPayload(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$BadPayload(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$BadPayload;", depth))
}
var $d_Lnet_timerboard_Msg$BadPayload = new $TypeData().initClass({
  Lnet_timerboard_Msg$BadPayload: 0
}, false, "net.timerboard.Msg$BadPayload", {
  Lnet_timerboard_Msg$BadPayload: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$BadPayload.prototype.$classData = $d_Lnet_timerboard_Msg$BadPayload;
/** @constructor */
function $c_Lnet_timerboard_Msg$DeleteTag(s) {
  this.Lnet_timerboard_Msg$DeleteTag__f_s = null;
  this.Lnet_timerboard_Msg$DeleteTag__f_s = s
}
$c_Lnet_timerboard_Msg$DeleteTag.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$DeleteTag.prototype.constructor = $c_Lnet_timerboard_Msg$DeleteTag;
/** @constructor */
function $h_Lnet_timerboard_Msg$DeleteTag() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$DeleteTag.prototype = $c_Lnet_timerboard_Msg$DeleteTag.prototype;
$c_Lnet_timerboard_Msg$DeleteTag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$DeleteTag)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$DeleteTag(x$0);
    return (this.Lnet_timerboard_Msg$DeleteTag__f_s === x$0$2.Lnet_timerboard_Msg$DeleteTag__f_s)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.productPrefix__T = (function() {
  return "DeleteTag"
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$DeleteTag__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.ordinal__I = (function() {
  return 12
});
function $as_Lnet_timerboard_Msg$DeleteTag(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$DeleteTag) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$DeleteTag"))
}
function $isArrayOf_Lnet_timerboard_Msg$DeleteTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$DeleteTag)))
}
function $asArrayOf_Lnet_timerboard_Msg$DeleteTag(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$DeleteTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$DeleteTag;", depth))
}
var $d_Lnet_timerboard_Msg$DeleteTag = new $TypeData().initClass({
  Lnet_timerboard_Msg$DeleteTag: 0
}, false, "net.timerboard.Msg$DeleteTag", {
  Lnet_timerboard_Msg$DeleteTag: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$DeleteTag.prototype.$classData = $d_Lnet_timerboard_Msg$DeleteTag;
/** @constructor */
function $c_Lnet_timerboard_Msg$LoadHash(s) {
  this.Lnet_timerboard_Msg$LoadHash__f_s = null;
  this.Lnet_timerboard_Msg$LoadHash__f_s = s
}
$c_Lnet_timerboard_Msg$LoadHash.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$LoadHash.prototype.constructor = $c_Lnet_timerboard_Msg$LoadHash;
/** @constructor */
function $h_Lnet_timerboard_Msg$LoadHash() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$LoadHash.prototype = $c_Lnet_timerboard_Msg$LoadHash.prototype;
$c_Lnet_timerboard_Msg$LoadHash.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$LoadHash)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$LoadHash(x$0);
    return (this.Lnet_timerboard_Msg$LoadHash__f_s === x$0$2.Lnet_timerboard_Msg$LoadHash__f_s)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.productPrefix__T = (function() {
  return "LoadHash"
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$LoadHash__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.ordinal__I = (function() {
  return 0
});
function $as_Lnet_timerboard_Msg$LoadHash(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$LoadHash) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$LoadHash"))
}
function $isArrayOf_Lnet_timerboard_Msg$LoadHash(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$LoadHash)))
}
function $asArrayOf_Lnet_timerboard_Msg$LoadHash(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$LoadHash(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$LoadHash;", depth))
}
var $d_Lnet_timerboard_Msg$LoadHash = new $TypeData().initClass({
  Lnet_timerboard_Msg$LoadHash: 0
}, false, "net.timerboard.Msg$LoadHash", {
  Lnet_timerboard_Msg$LoadHash: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$LoadHash.prototype.$classData = $d_Lnet_timerboard_Msg$LoadHash;
/** @constructor */
function $c_Lnet_timerboard_Msg$LoadSystemRegions(db) {
  this.Lnet_timerboard_Msg$LoadSystemRegions__f_db = null;
  this.Lnet_timerboard_Msg$LoadSystemRegions__f_db = db
}
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.constructor = $c_Lnet_timerboard_Msg$LoadSystemRegions;
/** @constructor */
function $h_Lnet_timerboard_Msg$LoadSystemRegions() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$LoadSystemRegions.prototype = $c_Lnet_timerboard_Msg$LoadSystemRegions.prototype;
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$LoadSystemRegions)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$LoadSystemRegions(x$0);
    var x = this.Lnet_timerboard_Msg$LoadSystemRegions__f_db;
    var x$2 = x$0$2.Lnet_timerboard_Msg$LoadSystemRegions__f_db;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.productPrefix__T = (function() {
  return "LoadSystemRegions"
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$LoadSystemRegions__f_db
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.ordinal__I = (function() {
  return 1
});
function $as_Lnet_timerboard_Msg$LoadSystemRegions(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$LoadSystemRegions) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$LoadSystemRegions"))
}
function $isArrayOf_Lnet_timerboard_Msg$LoadSystemRegions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$LoadSystemRegions)))
}
function $asArrayOf_Lnet_timerboard_Msg$LoadSystemRegions(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$LoadSystemRegions(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$LoadSystemRegions;", depth))
}
var $d_Lnet_timerboard_Msg$LoadSystemRegions = new $TypeData().initClass({
  Lnet_timerboard_Msg$LoadSystemRegions: 0
}, false, "net.timerboard.Msg$LoadSystemRegions", {
  Lnet_timerboard_Msg$LoadSystemRegions: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$LoadSystemRegions.prototype.$classData = $d_Lnet_timerboard_Msg$LoadSystemRegions;
/** @constructor */
function $c_Lnet_timerboard_Msg$LoadSystems(systems) {
  this.Lnet_timerboard_Msg$LoadSystems__f_systems = null;
  this.Lnet_timerboard_Msg$LoadSystems__f_systems = systems
}
$c_Lnet_timerboard_Msg$LoadSystems.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$LoadSystems.prototype.constructor = $c_Lnet_timerboard_Msg$LoadSystems;
/** @constructor */
function $h_Lnet_timerboard_Msg$LoadSystems() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$LoadSystems.prototype = $c_Lnet_timerboard_Msg$LoadSystems.prototype;
$c_Lnet_timerboard_Msg$LoadSystems.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$LoadSystems)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$LoadSystems(x$0);
    var x = this.Lnet_timerboard_Msg$LoadSystems__f_systems;
    var x$2 = x$0$2.Lnet_timerboard_Msg$LoadSystems__f_systems;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.productPrefix__T = (function() {
  return "LoadSystems"
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$LoadSystems__f_systems
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.ordinal__I = (function() {
  return 2
});
function $as_Lnet_timerboard_Msg$LoadSystems(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$LoadSystems) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$LoadSystems"))
}
function $isArrayOf_Lnet_timerboard_Msg$LoadSystems(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$LoadSystems)))
}
function $asArrayOf_Lnet_timerboard_Msg$LoadSystems(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$LoadSystems(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$LoadSystems;", depth))
}
var $d_Lnet_timerboard_Msg$LoadSystems = new $TypeData().initClass({
  Lnet_timerboard_Msg$LoadSystems: 0
}, false, "net.timerboard.Msg$LoadSystems", {
  Lnet_timerboard_Msg$LoadSystems: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$LoadSystems.prototype.$classData = $d_Lnet_timerboard_Msg$LoadSystems;
/** @constructor */
function $c_Lnet_timerboard_Msg$Other(s) {
  this.Lnet_timerboard_Msg$Other__f_s = null;
  this.Lnet_timerboard_Msg$Other__f_s = s
}
$c_Lnet_timerboard_Msg$Other.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$Other.prototype.constructor = $c_Lnet_timerboard_Msg$Other;
/** @constructor */
function $h_Lnet_timerboard_Msg$Other() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$Other.prototype = $c_Lnet_timerboard_Msg$Other.prototype;
$c_Lnet_timerboard_Msg$Other.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$Other.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$Other)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$Other(x$0);
    return (this.Lnet_timerboard_Msg$Other__f_s === x$0$2.Lnet_timerboard_Msg$Other__f_s)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$Other.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$Other.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$Other.prototype.productPrefix__T = (function() {
  return "Other"
});
$c_Lnet_timerboard_Msg$Other.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$Other__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$Other.prototype.ordinal__I = (function() {
  return 7
});
function $as_Lnet_timerboard_Msg$Other(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$Other) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$Other"))
}
function $isArrayOf_Lnet_timerboard_Msg$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$Other)))
}
function $asArrayOf_Lnet_timerboard_Msg$Other(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$Other(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$Other;", depth))
}
var $d_Lnet_timerboard_Msg$Other = new $TypeData().initClass({
  Lnet_timerboard_Msg$Other: 0
}, false, "net.timerboard.Msg$Other", {
  Lnet_timerboard_Msg$Other: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$Other.prototype.$classData = $d_Lnet_timerboard_Msg$Other;
/** @constructor */
function $c_Lnet_timerboard_Msg$Payload(we) {
  this.Lnet_timerboard_Msg$Payload__f_we = null;
  this.Lnet_timerboard_Msg$Payload__f_we = we
}
$c_Lnet_timerboard_Msg$Payload.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$Payload.prototype.constructor = $c_Lnet_timerboard_Msg$Payload;
/** @constructor */
function $h_Lnet_timerboard_Msg$Payload() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$Payload.prototype = $c_Lnet_timerboard_Msg$Payload.prototype;
$c_Lnet_timerboard_Msg$Payload.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$Payload.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$Payload)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$Payload(x$0);
    var x = this.Lnet_timerboard_Msg$Payload__f_we;
    var x$2 = x$0$2.Lnet_timerboard_Msg$Payload__f_we;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$Payload.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$Payload.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$Payload.prototype.productPrefix__T = (function() {
  return "Payload"
});
$c_Lnet_timerboard_Msg$Payload.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$Payload__f_we
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$Payload.prototype.ordinal__I = (function() {
  return 4
});
function $as_Lnet_timerboard_Msg$Payload(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$Payload) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$Payload"))
}
function $isArrayOf_Lnet_timerboard_Msg$Payload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$Payload)))
}
function $asArrayOf_Lnet_timerboard_Msg$Payload(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$Payload(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$Payload;", depth))
}
var $d_Lnet_timerboard_Msg$Payload = new $TypeData().initClass({
  Lnet_timerboard_Msg$Payload: 0
}, false, "net.timerboard.Msg$Payload", {
  Lnet_timerboard_Msg$Payload: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$Payload.prototype.$classData = $d_Lnet_timerboard_Msg$Payload;
/** @constructor */
function $c_Lnet_timerboard_Msg$Search(s) {
  this.Lnet_timerboard_Msg$Search__f_s = null;
  this.Lnet_timerboard_Msg$Search__f_s = s
}
$c_Lnet_timerboard_Msg$Search.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$Search.prototype.constructor = $c_Lnet_timerboard_Msg$Search;
/** @constructor */
function $h_Lnet_timerboard_Msg$Search() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$Search.prototype = $c_Lnet_timerboard_Msg$Search.prototype;
$c_Lnet_timerboard_Msg$Search.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$Search.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$Search)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$Search(x$0);
    return (this.Lnet_timerboard_Msg$Search__f_s === x$0$2.Lnet_timerboard_Msg$Search__f_s)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$Search.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$Search.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$Search.prototype.productPrefix__T = (function() {
  return "Search"
});
$c_Lnet_timerboard_Msg$Search.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$Search__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$Search.prototype.ordinal__I = (function() {
  return 10
});
function $as_Lnet_timerboard_Msg$Search(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$Search) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$Search"))
}
function $isArrayOf_Lnet_timerboard_Msg$Search(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$Search)))
}
function $asArrayOf_Lnet_timerboard_Msg$Search(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$Search(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$Search;", depth))
}
var $d_Lnet_timerboard_Msg$Search = new $TypeData().initClass({
  Lnet_timerboard_Msg$Search: 0
}, false, "net.timerboard.Msg$Search", {
  Lnet_timerboard_Msg$Search: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$Search.prototype.$classData = $d_Lnet_timerboard_Msg$Search;
/** @constructor */
function $c_Lnet_timerboard_Msg$SortBy(f) {
  this.Lnet_timerboard_Msg$SortBy__f_f = null;
  this.Lnet_timerboard_Msg$SortBy__f_f = f
}
$c_Lnet_timerboard_Msg$SortBy.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$SortBy.prototype.constructor = $c_Lnet_timerboard_Msg$SortBy;
/** @constructor */
function $h_Lnet_timerboard_Msg$SortBy() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$SortBy.prototype = $c_Lnet_timerboard_Msg$SortBy.prototype;
$c_Lnet_timerboard_Msg$SortBy.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$SortBy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$SortBy)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$SortBy(x$0);
    var x = this.Lnet_timerboard_Msg$SortBy__f_f;
    var x$2 = x$0$2.Lnet_timerboard_Msg$SortBy__f_f;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$SortBy.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$SortBy.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$SortBy.prototype.productPrefix__T = (function() {
  return "SortBy"
});
$c_Lnet_timerboard_Msg$SortBy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$SortBy__f_f
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$SortBy.prototype.ordinal__I = (function() {
  return 3
});
function $as_Lnet_timerboard_Msg$SortBy(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$SortBy) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$SortBy"))
}
function $isArrayOf_Lnet_timerboard_Msg$SortBy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$SortBy)))
}
function $asArrayOf_Lnet_timerboard_Msg$SortBy(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$SortBy(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$SortBy;", depth))
}
var $d_Lnet_timerboard_Msg$SortBy = new $TypeData().initClass({
  Lnet_timerboard_Msg$SortBy: 0
}, false, "net.timerboard.Msg$SortBy", {
  Lnet_timerboard_Msg$SortBy: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$SortBy.prototype.$classData = $d_Lnet_timerboard_Msg$SortBy;
/** @constructor */
function $c_Lnet_timerboard_Msg$System(s) {
  this.Lnet_timerboard_Msg$System__f_s = null;
  this.Lnet_timerboard_Msg$System__f_s = s
}
$c_Lnet_timerboard_Msg$System.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$System.prototype.constructor = $c_Lnet_timerboard_Msg$System;
/** @constructor */
function $h_Lnet_timerboard_Msg$System() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$System.prototype = $c_Lnet_timerboard_Msg$System.prototype;
$c_Lnet_timerboard_Msg$System.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$System.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$System)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$System(x$0);
    return (this.Lnet_timerboard_Msg$System__f_s === x$0$2.Lnet_timerboard_Msg$System__f_s)
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$System.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$System.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$System.prototype.productPrefix__T = (function() {
  return "System"
});
$c_Lnet_timerboard_Msg$System.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$System__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$System.prototype.ordinal__I = (function() {
  return 11
});
function $as_Lnet_timerboard_Msg$System(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$System) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$System"))
}
function $isArrayOf_Lnet_timerboard_Msg$System(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$System)))
}
function $asArrayOf_Lnet_timerboard_Msg$System(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$System(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$System;", depth))
}
var $d_Lnet_timerboard_Msg$System = new $TypeData().initClass({
  Lnet_timerboard_Msg$System: 0
}, false, "net.timerboard.Msg$System", {
  Lnet_timerboard_Msg$System: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$System.prototype.$classData = $d_Lnet_timerboard_Msg$System;
/** @constructor */
function $c_Lnet_timerboard_Msg$Tick(now) {
  this.Lnet_timerboard_Msg$Tick__f_now = null;
  this.Lnet_timerboard_Msg$Tick__f_now = now
}
$c_Lnet_timerboard_Msg$Tick.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$Tick.prototype.constructor = $c_Lnet_timerboard_Msg$Tick;
/** @constructor */
function $h_Lnet_timerboard_Msg$Tick() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$Tick.prototype = $c_Lnet_timerboard_Msg$Tick.prototype;
$c_Lnet_timerboard_Msg$Tick.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$Tick.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$Tick)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$Tick(x$0);
    var x = this.Lnet_timerboard_Msg$Tick__f_now;
    var x$2 = x$0$2.Lnet_timerboard_Msg$Tick__f_now;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$Tick.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$Tick.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$Tick.prototype.productPrefix__T = (function() {
  return "Tick"
});
$c_Lnet_timerboard_Msg$Tick.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$Tick__f_now
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$Tick.prototype.ordinal__I = (function() {
  return 9
});
function $as_Lnet_timerboard_Msg$Tick(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$Tick) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$Tick"))
}
function $isArrayOf_Lnet_timerboard_Msg$Tick(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$Tick)))
}
function $asArrayOf_Lnet_timerboard_Msg$Tick(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$Tick(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$Tick;", depth))
}
var $d_Lnet_timerboard_Msg$Tick = new $TypeData().initClass({
  Lnet_timerboard_Msg$Tick: 0
}, false, "net.timerboard.Msg$Tick", {
  Lnet_timerboard_Msg$Tick: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$Tick.prototype.$classData = $d_Lnet_timerboard_Msg$Tick;
/** @constructor */
function $c_Lnet_timerboard_Msg$UpdateDistances(distances) {
  this.Lnet_timerboard_Msg$UpdateDistances__f_distances = null;
  this.Lnet_timerboard_Msg$UpdateDistances__f_distances = distances
}
$c_Lnet_timerboard_Msg$UpdateDistances.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.constructor = $c_Lnet_timerboard_Msg$UpdateDistances;
/** @constructor */
function $h_Lnet_timerboard_Msg$UpdateDistances() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$UpdateDistances.prototype = $c_Lnet_timerboard_Msg$UpdateDistances.prototype;
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$UpdateDistances)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$UpdateDistances(x$0);
    var x = this.Lnet_timerboard_Msg$UpdateDistances__f_distances;
    var x$2 = x$0$2.Lnet_timerboard_Msg$UpdateDistances__f_distances;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.productPrefix__T = (function() {
  return "UpdateDistances"
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$UpdateDistances__f_distances
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.ordinal__I = (function() {
  return 18
});
function $as_Lnet_timerboard_Msg$UpdateDistances(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$UpdateDistances) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$UpdateDistances"))
}
function $isArrayOf_Lnet_timerboard_Msg$UpdateDistances(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$UpdateDistances)))
}
function $asArrayOf_Lnet_timerboard_Msg$UpdateDistances(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$UpdateDistances(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$UpdateDistances;", depth))
}
var $d_Lnet_timerboard_Msg$UpdateDistances = new $TypeData().initClass({
  Lnet_timerboard_Msg$UpdateDistances: 0
}, false, "net.timerboard.Msg$UpdateDistances", {
  Lnet_timerboard_Msg$UpdateDistances: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$UpdateDistances.prototype.$classData = $d_Lnet_timerboard_Msg$UpdateDistances;
/** @constructor */
function $c_Lnet_timerboard_Msg$WebSocketStatus(status) {
  this.Lnet_timerboard_Msg$WebSocketStatus__f_status = null;
  this.Lnet_timerboard_Msg$WebSocketStatus__f_status = status
}
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.constructor = $c_Lnet_timerboard_Msg$WebSocketStatus;
/** @constructor */
function $h_Lnet_timerboard_Msg$WebSocketStatus() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$WebSocketStatus.prototype = $c_Lnet_timerboard_Msg$WebSocketStatus.prototype;
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_timerboard_Msg$WebSocketStatus)) {
    var x$0$2 = $as_Lnet_timerboard_Msg$WebSocketStatus(x$0);
    var x = this.Lnet_timerboard_Msg$WebSocketStatus__f_status;
    var x$2 = x$0$2.Lnet_timerboard_Msg$WebSocketStatus__f_status;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.productPrefix__T = (function() {
  return "WebSocketStatus"
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_timerboard_Msg$WebSocketStatus__f_status
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.ordinal__I = (function() {
  return 8
});
function $as_Lnet_timerboard_Msg$WebSocketStatus(obj) {
  return (((obj instanceof $c_Lnet_timerboard_Msg$WebSocketStatus) || (obj === null)) ? obj : $throwClassCastException(obj, "net.timerboard.Msg$WebSocketStatus"))
}
function $isArrayOf_Lnet_timerboard_Msg$WebSocketStatus(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_timerboard_Msg$WebSocketStatus)))
}
function $asArrayOf_Lnet_timerboard_Msg$WebSocketStatus(obj, depth) {
  return (($isArrayOf_Lnet_timerboard_Msg$WebSocketStatus(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.timerboard.Msg$WebSocketStatus;", depth))
}
var $d_Lnet_timerboard_Msg$WebSocketStatus = new $TypeData().initClass({
  Lnet_timerboard_Msg$WebSocketStatus: 0
}, false, "net.timerboard.Msg$WebSocketStatus", {
  Lnet_timerboard_Msg$WebSocketStatus: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_timerboard_Msg$WebSocketStatus.prototype.$classData = $d_Lnet_timerboard_Msg$WebSocketStatus;
/** @constructor */
function $c_s_None$() {
  /*<skip>*/
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
  /*<skip>*/
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get")
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_s_None$.prototype.toString__T = (function() {
  return "None"
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E()
});
function $as_s_None$(obj) {
  return (((obj instanceof $c_s_None$) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.None$"))
}
function $isArrayOf_s_None$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_None$)))
}
function $asArrayOf_s_None$(obj, depth) {
  return (($isArrayOf_s_None$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.None$;", depth))
}
var $d_s_None$ = new $TypeData().initClass({
  s_None$: 0
}, false, "scala.None$", {
  s_None$: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_None$.prototype.$classData = $d_s_None$;
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$()
  };
  return $n_s_None$
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
  /*<skip>*/
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some"
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_Some.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, Some$1.s_Some__f_value)
  } else {
    return false
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"))
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)))
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth))
}
var $d_s_Some = new $TypeData().initClass({
  s_Some: 0
}, false, "scala.Some", {
  s_Some: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_Some.prototype.$classData = $d_s_Some;
class $c_s_StringContext$InvalidEscapeException extends $c_jl_IllegalArgumentException {
  constructor(str, index) {
    super();
    this.s_StringContext$InvalidEscapeException__f_index = 0;
    this.s_StringContext$InvalidEscapeException__f_index = index;
    $m_s_Predef$().require__Z__V(((index >= 0) && (index < $uI(str.length))));
    if ((index === (((-1) + $uI(str.length)) | 0))) {
      var $$x1 = "at terminal"
    } else {
      var i = ((1 + index) | 0);
      var $$x1 = (("'\\" + $bC((65535 & $uI(str.charCodeAt(i))))) + "' not one of [\\b, \\t, \\n, \\f, \\r, \\\\, \\\", \\', \\uxxxx] at")
    };
    var s = (((((("invalid escape " + $$x1) + " index ") + index) + " in \"") + str) + "\". Use \\\\ for literal \\.");
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_s_StringContext$InvalidEscapeException = new $TypeData().initClass({
  s_StringContext$InvalidEscapeException: 0
}, false, "scala.StringContext$InvalidEscapeException", {
  s_StringContext$InvalidEscapeException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_StringContext$InvalidEscapeException.prototype.$classData = $d_s_StringContext$InvalidEscapeException;
class $c_s_StringContext$InvalidUnicodeEscapeException extends $c_jl_IllegalArgumentException {
  constructor(str, escapeStart, index) {
    super();
    this.s_StringContext$InvalidUnicodeEscapeException__f_escapeStart = 0;
    this.s_StringContext$InvalidUnicodeEscapeException__f_index = 0;
    this.s_StringContext$InvalidUnicodeEscapeException__f_escapeStart = escapeStart;
    this.s_StringContext$InvalidUnicodeEscapeException__f_index = index;
    var s = ((("invalid unicode escape at index " + index) + " of ") + str);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_s_StringContext$InvalidUnicodeEscapeException = new $TypeData().initClass({
  s_StringContext$InvalidUnicodeEscapeException: 0
}, false, "scala.StringContext$InvalidUnicodeEscapeException", {
  s_StringContext$InvalidUnicodeEscapeException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_StringContext$InvalidUnicodeEscapeException.prototype.$classData = $d_s_StringContext$InvalidUnicodeEscapeException;
/** @constructor */
function $c_T2$mcCI$sp(_1$mcC$sp, _2$mcI$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcCI$sp__f__1$mcC$sp = 0;
  this.T2$mcCI$sp__f__2$mcI$sp = 0;
  this.T2$mcCI$sp__f__1$mcC$sp = _1$mcC$sp;
  this.T2$mcCI$sp__f__2$mcI$sp = _2$mcI$sp;
  $ct_T2__O__O__(this, null, null)
}
$c_T2$mcCI$sp.prototype = new $h_T2();
$c_T2$mcCI$sp.prototype.constructor = $c_T2$mcCI$sp;
/** @constructor */
function $h_T2$mcCI$sp() {
  /*<skip>*/
}
$h_T2$mcCI$sp.prototype = $c_T2$mcCI$sp.prototype;
$c_T2$mcCI$sp.prototype._1$mcC$sp__C = (function() {
  return this.T2$mcCI$sp__f__1$mcC$sp
});
$c_T2$mcCI$sp.prototype._2$mcI$sp__I = (function() {
  return this.T2$mcCI$sp__f__2$mcI$sp
});
$c_T2$mcCI$sp.prototype._2__O = (function() {
  return this.T2$mcCI$sp__f__2$mcI$sp
});
$c_T2$mcCI$sp.prototype._1__O = (function() {
  return $bC(this.T2$mcCI$sp__f__1$mcC$sp)
});
var $d_T2$mcCI$sp = new $TypeData().initClass({
  T2$mcCI$sp: 0
}, false, "scala.Tuple2$mcCI$sp", {
  T2$mcCI$sp: 1,
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2$mcCI$sp.prototype.$classData = $d_T2$mcCI$sp;
/** @constructor */
function $c_sc_AbstractIterable() {
  /*<skip>*/
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
  /*<skip>*/
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T()
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder()
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize)
});
$c_sc_AbstractIterable.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p)
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_AbstractIterable.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sc_AbstractIterable.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_AbstractIterable.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this)
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this)
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_sr_ScalaRunTime$().array_length__O__I($thiz.sc_ArrayOps$ArrayIterator__f_xs);
  return $thiz
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len)
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  try {
    var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $$x1 = this.sc_ArrayOps$ArrayIterator__f_len
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $$x1 = ((a < newPos) ? a : newPos)
    };
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $$x1
  };
  return this
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator: 0
}, false, "scala.collection.ArrayOps$ArrayIterator", {
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator.prototype.$classData = $d_sc_ArrayOps$ArrayIterator;
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value))
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = self.length__I();
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b)
  };
  return this
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", {
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewIterator;
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = self.length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0)
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0)
      }
    }
  };
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", {
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty)
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$3 = $as_sc_Iterator(this.scm_ImmutableBuilder__f_elems);
  var xs = new $c_sjsr_AnonFunction0(((this$1, elem$1) => (() => {
    $m_sc_Iterator$();
    return new $c_sc_Iterator$$anon$20(elem$1)
  }))(this, elem));
  this.scm_ImmutableBuilder__f_elems = this$3.concat__F0__sc_Iterator(xs);
  return this
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem)
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass({
  sc_Iterator$$anon$21: 0
}, false, "scala.collection.Iterator$$anon$21", {
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sc_Iterator$$anon$21.prototype.$classData = $d_sc_Iterator$$anon$21;
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$7__f_$outer = outer
  };
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0
}
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$()
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if (this.sc_Iterator$$anon$7__f_$outer.hasNext__Z()) {
      var x = this.sc_Iterator$$anon$7__f_$outer.next__O();
      var v = this.sc_Iterator$$anon$7__f_pf$1.applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1)
    }
  };
  return (this.sc_Iterator$$anon$7__f_status === 1)
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass({
  sc_Iterator$$anon$7: 0
}, false, "scala.collection.Iterator$$anon$7", {
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
});
$c_sc_Iterator$$anon$7.prototype.$classData = $d_sc_Iterator$$anon$7;
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return default$1.apply__O()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $f_sc_MapOps__default__O__O($thiz, key)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value = x3.s_Some__f_value;
    return value
  } else {
    throw new $c_s_MatchError(x1)
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sjsr_AnonFunction0(((this$1, default$2, x$1) => (() => default$2.apply__O__O(x$1)))($thiz, default$1, x)))
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = $as_T2(it.next__O());
    f.apply__O__O__O(next._1__O(), next._2__O())
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $thiz.get__O__s_Option(key);
  return (!this$1.isEmpty__Z())
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $as_sc_IterableOps($thiz.mapFactory__sc_MapFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f)))
}
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var $$x2 = $thiz.mapFactory__sc_MapFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var $$x1 = $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0(((this$1, suffix$1) => (() => suffix$1.iterator__sc_Iterator()))($thiz, suffix)))
  };
  return $as_sc_IterableOps($$x2.from__sc_IterableOnce__O($$x1))
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$2 = $thiz.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = x0$1._1__O();
      var v = x0$1._2__O();
      return ((k + " -> ") + v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))($thiz));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$3, sb, start, sep, end)
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return b.result__O()
}
function $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$IteratorWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$IteratorWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$IteratorWrapper;", depth))
}
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true
  };
  return $thiz.sci_ArraySeq$__f_emptyImpl
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl)
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this)
}
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
  /*<skip>*/
}
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  if ((it instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(it);
    return x2
  } else {
    return this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag))
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((this$2, evidence$2$1) => ((b$2) => {
    var b = $as_scm_ArrayBuffer(b$2);
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(b, evidence$2$1))
  }))(this, evidence$2));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_sci_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_sci_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_sci_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_sci_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_sci_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_sci_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_sci_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_sci_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_sci_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_sci_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this)
});
var $d_sci_ArraySeq$ = new $TypeData().initClass({
  sci_ArraySeq$: 0
}, false, "scala.collection.immutable.ArraySeq$", {
  sci_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$.prototype.$classData = $d_sci_ArraySeq$;
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$()
  };
  return $n_sci_ArraySeq$
}
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)))
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"))
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)))
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth))
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass({
  sci_Map$Map2$$anon$1: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$1", {
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$1.prototype.$classData = $d_sci_Map$Map2$$anon$1;
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$2.prototype.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$2.prototype = $c_sci_Map$Map2$$anon$2.prototype;
$c_sci_Map$Map2$$anon$2.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().initClass({
  sci_Map$Map2$$anon$2: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$2", {
  sci_Map$Map2$$anon$2: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$2.prototype.$classData = $d_sci_Map$Map2$$anon$2;
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass({
  sci_Map$Map3$$anon$4: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$4", {
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$4.prototype.$classData = $d_sci_Map$Map3$$anon$4;
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$5.prototype.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$5.prototype = $c_sci_Map$Map3$$anon$5.prototype;
$c_sci_Map$Map3$$anon$5.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().initClass({
  sci_Map$Map3$$anon$5: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$5", {
  sci_Map$Map3$$anon$5: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$5.prototype.$classData = $d_sci_Map$Map3$$anon$5;
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass({
  sci_Map$Map4$$anon$7: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$7", {
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$7.prototype.$classData = $d_sci_Map$Map4$$anon$7;
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$8.prototype.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$8.prototype = $c_sci_Map$Map4$$anon$8.prototype;
$c_sci_Map$Map4$$anon$8.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().initClass({
  sci_Map$Map4$$anon$8: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$8", {
  sci_Map$Map4$$anon$8: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$8.prototype.$classData = $d_sci_Map$Map4$$anon$8;
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start
}
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
  /*<skip>*/
}
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + $intDiv(((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0), this.sci_RangeIterator__f_step)) | 0) : 0)
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  };
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? (((-2147483648) ^ value$2) < ((-2147483648) ^ lo)) : (hi$3 < hi$2))) {
        var this$6__lo = value$2;
        var this$6__hi = hi$3
      } else {
        var this$6__lo = lo;
        var this$6__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$6__lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$3)) : (hi$2 < hi$4))
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? (((-2147483648) ^ value$4) > ((-2147483648) ^ lo)) : (hi$5 > hi$2))) {
        var this$10__lo = value$4;
        var this$10__hi = hi$5
      } else {
        var this$10__lo = lo;
        var this$10__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$10__lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ value$5)) : (hi$2 > hi$6))
    }
  };
  return this
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sci_RangeIterator = new $TypeData().initClass({
  sci_RangeIterator: 0
}, false, "scala.collection.immutable.RangeIterator", {
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_RangeIterator.prototype.$classData = $d_sci_RangeIterator;
/** @constructor */
function $c_sci_RedBlackTree$EqualsIterator(tree, evidence$19) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, $m_s_None$(), evidence$19)
}
$c_sci_RedBlackTree$EqualsIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EqualsIterator.prototype.constructor = $c_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $h_sci_RedBlackTree$EqualsIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$EqualsIterator.prototype = $c_sci_RedBlackTree$EqualsIterator.prototype;
$c_sci_RedBlackTree$EqualsIterator.prototype.sameKeys__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === that.sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x1 = null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x1 = this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $$x1;
      if ((that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x2 = null
      } else {
        that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x2 = that.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      that.sci_RedBlackTree$TreeIterator__f_lookahead = $$x2
    } else {
      var this$1 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var $$x3 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$2 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      if (Object.is($$x3, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        equal = true
      } else {
        var $$x5 = this.sci_RedBlackTree$TreeIterator__f_ordering;
        var this$3 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $$x4 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$4 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
        equal = $$x5.equiv__O__O__Z($$x4, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
      };
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var tree$1 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      that.sci_RedBlackTree$TreeIterator__f_lookahead = that.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  };
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead === null))
});
$c_sci_RedBlackTree$EqualsIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
var $d_sci_RedBlackTree$EqualsIterator = new $TypeData().initClass({
  sci_RedBlackTree$EqualsIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$EqualsIterator", {
  sci_RedBlackTree$EqualsIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$EqualsIterator.prototype.$classData = $d_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $c_sci_RedBlackTree$KeysIterator(tree, focus, evidence$21) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$21)
}
$c_sci_RedBlackTree$KeysIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$KeysIterator.prototype.constructor = $c_sci_RedBlackTree$KeysIterator;
/** @constructor */
function $h_sci_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$KeysIterator.prototype = $c_sci_RedBlackTree$KeysIterator.prototype;
$c_sci_RedBlackTree$KeysIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  return tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
var $d_sci_RedBlackTree$KeysIterator = new $TypeData().initClass({
  sci_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$KeysIterator", {
  sci_RedBlackTree$KeysIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$KeysIterator.prototype.$classData = $d_sci_RedBlackTree$KeysIterator;
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
  /*<skip>*/
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0)
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b)
  };
  return this
});
function $is_sci_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SetOps)))
}
function $as_sci_SetOps(obj) {
  return (($is_sci_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetOps"))
}
function $isArrayOf_sci_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetOps)))
}
function $asArrayOf_sci_SetOps(obj, depth) {
  return (($isArrayOf_sci_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetOps;", depth))
}
/** @constructor */
function $c_sci_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_sci_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_sci_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_sci_SortedSet$.prototype.constructor = $c_sci_SortedSet$;
/** @constructor */
function $h_sci_SortedSet$() {
  /*<skip>*/
}
$h_sci_SortedSet$.prototype = $c_sci_SortedSet$.prototype;
var $d_sci_SortedSet$ = new $TypeData().initClass({
  sci_SortedSet$: 0
}, false, "scala.collection.immutable.SortedSet$", {
  sci_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_sci_SortedSet$.prototype.$classData = $d_sci_SortedSet$;
var $n_sci_SortedSet$;
function $m_sci_SortedSet$() {
  if ((!$n_sci_SortedSet$)) {
    $n_sci_SortedSet$ = new $c_sci_SortedSet$()
  };
  return $n_sci_SortedSet$
}
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  $thiz.scm_ArrayBuilder__f_size = 0;
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
  /*<skip>*/
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0))
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
  /*<skip>*/
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2))
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$4 = new $c_scm_ArrayBuilder$generic(evidence$3.runtimeClass__jl_Class());
  var f = new $c_sjsr_AnonFunction1(((this$3) => ((x$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)))(this));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_scm_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return this.scm_ArraySeq$__f_EmptyArraySeq
});
var $d_scm_ArraySeq$ = new $TypeData().initClass({
  scm_ArraySeq$: 0
}, false, "scala.collection.mutable.ArraySeq$", {
  scm_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$.prototype.$classData = $d_scm_ArraySeq$;
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$()
  };
  return $n_scm_ArraySeq$
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $ct_T2__O__O__(new $c_T2(), nd.scm_HashMap$Node__f__key, nd.scm_HashMap$Node__f__value)
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass({
  scm_HashMap$$anon$1: 0
}, false, "scala.collection.mutable.HashMap$$anon$1", {
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$1.prototype.$classData = $d_scm_HashMap$$anon$1;
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$2.prototype.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$2.prototype = $c_scm_HashMap$$anon$2.prototype;
$c_scm_HashMap$$anon$2.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd.scm_HashMap$Node__f__key
});
var $d_scm_HashMap$$anon$2 = new $TypeData().initClass({
  scm_HashMap$$anon$2: 0
}, false, "scala.collection.mutable.HashMap$$anon$2", {
  scm_HashMap$$anon$2: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$2.prototype.$classData = $d_scm_HashMap$$anon$2;
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass({
  scm_HashMap$$anon$4: 0
}, false, "scala.collection.mutable.HashMap$$anon$4", {
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$4.prototype.$classData = $d_scm_HashMap$$anon$4;
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_HashMap$$anon$5__f_$outer = outer
  };
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $$x1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.scm_HashMap$Node__f__hash;
  var x = nd.scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $$x1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass({
  scm_HashMap$$anon$5: 0
}, false, "scala.collection.mutable.HashMap$$anon$5", {
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$5.prototype.$classData = $d_scm_HashMap$$anon$5;
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd.scm_HashSet$Node__f__key
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass({
  scm_HashSet$$anon$1: 0
}, false, "scala.collection.mutable.HashSet$$anon$1", {
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$1.prototype.$classData = $d_scm_HashSet$$anon$1;
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass({
  scm_HashSet$$anon$2: 0
}, false, "scala.collection.mutable.HashSet$$anon$2", {
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$2.prototype.$classData = $d_scm_HashSet$$anon$2;
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_HashSet$$anon$3__f_$outer = outer
  };
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0
}
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = this.scm_HashSet$$anon$3__f_$outer;
  var improvedHash = nd.scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass({
  scm_HashSet$$anon$3: 0
}, false, "scala.collection.mutable.HashSet$$anon$3", {
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$3.prototype.$classData = $d_scm_HashSet$$anon$3;
/** @constructor */
function $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$7) {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null;
  $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__(this, tree, start, end, evidence$7)
}
$c_scm_RedBlackTree$KeysIterator.prototype = new $h_scm_RedBlackTree$TreeIterator();
$c_scm_RedBlackTree$KeysIterator.prototype.constructor = $c_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $h_scm_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$KeysIterator.prototype = $c_scm_RedBlackTree$KeysIterator.prototype;
var $d_scm_RedBlackTree$KeysIterator = new $TypeData().initClass({
  scm_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.mutable.RedBlackTree$KeysIterator", {
  scm_RedBlackTree$KeysIterator: 1,
  scm_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_RedBlackTree$KeysIterator.prototype.$classData = $d_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $c_scm_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_scm_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_scm_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_scm_SortedSet$.prototype.constructor = $c_scm_SortedSet$;
/** @constructor */
function $h_scm_SortedSet$() {
  /*<skip>*/
}
$h_scm_SortedSet$.prototype = $c_scm_SortedSet$.prototype;
var $d_scm_SortedSet$ = new $TypeData().initClass({
  scm_SortedSet$: 0
}, false, "scala.collection.mutable.SortedSet$", {
  scm_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_scm_SortedSet$.prototype.$classData = $d_scm_SortedSet$;
var $n_scm_SortedSet$;
function $m_scm_SortedSet$() {
  if ((!$n_scm_SortedSet$)) {
    $n_scm_SortedSet$ = new $c_scm_SortedSet$()
  };
  return $n_scm_SortedSet$
}
function $as_s_concurrent_duration_Deadline(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Deadline"))
}
function $isArrayOf_s_concurrent_duration_Deadline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Deadline)))
}
function $asArrayOf_s_concurrent_duration_Deadline(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Deadline(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Deadline;", depth))
}
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined"
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1)
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$1: 0
}, false, "scala.concurrent.duration.Duration$$anon$1", {
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf"
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1))
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$2: 0
}, false, "scala.concurrent.duration.Duration$$anon$2", {
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf"
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1))
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$3: 0
}, false, "scala.concurrent.duration.Duration$$anon$3", {
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $c_s_math_LowPriorityOrderingImplicits$$anon$2(outer, asComparable$1) {
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = null;
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = asComparable$1
}
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = new $h_O();
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.constructor = $c_s_math_LowPriorityOrderingImplicits$$anon$2;
/** @constructor */
function $h_s_math_LowPriorityOrderingImplicits$$anon$2() {
  /*<skip>*/
}
$h_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = $c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype;
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return $dp_compareTo__O__I($as_jl_Comparable(this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1.apply__O__O(x)), y)
});
var $d_s_math_LowPriorityOrderingImplicits$$anon$2 = new $TypeData().initClass({
  s_math_LowPriorityOrderingImplicits$$anon$2: 0
}, false, "scala.math.LowPriorityOrderingImplicits$$anon$2", {
  s_math_LowPriorityOrderingImplicits$$anon$2: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.$classData = $d_s_math_LowPriorityOrderingImplicits$$anon$2;
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.s_math_Ordering$$anon$1__f_$outer = outer
  };
  this.s_math_Ordering$$anon$1__f_f$1 = f$1
}
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
  /*<skip>*/
}
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$$anon$1__f_$outer.compare__O__O__I(this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(x), this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(y))
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass({
  s_math_Ordering$$anon$1: 0
}, false, "scala.math.Ordering$$anon$1", {
  s_math_Ordering$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$$anon$1.prototype.$classData = $d_s_math_Ordering$$anon$1;
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
}
function $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z($thiz, x, y) {
  return (x <= y)
}
function $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z($thiz, x, y) {
  return (x === y)
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer
}
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
  /*<skip>*/
}
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : other.equals__O__Z(x$2))
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.compare__O__O__I(y, x)
});
$c_s_math_Ordering$Reverse.prototype.lteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.lteq__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.equiv__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x3 = $as_s_math_Ordering$Reverse(obj);
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = x3.s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  };
  return false
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, this.s_math_Ordering$Reverse__f_outer.hashCode__I())
});
function $as_s_math_Ordering$Reverse(obj) {
  return (((obj instanceof $c_s_math_Ordering$Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Reverse"))
}
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)))
}
function $asArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Reverse;", depth))
}
var $d_s_math_Ordering$Reverse = new $TypeData().initClass({
  s_math_Ordering$Reverse: 0
}, false, "scala.math.Ordering$Reverse", {
  s_math_Ordering$Reverse: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Reverse.prototype.$classData = $d_s_math_Ordering$Reverse;
/** @constructor */
function $c_s_math_Ordering$Tuple2Ordering(ord1, ord2) {
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = ord1;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = ord2
}
$c_s_math_Ordering$Tuple2Ordering.prototype = new $h_O();
$c_s_math_Ordering$Tuple2Ordering.prototype.constructor = $c_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple2Ordering() {
  /*<skip>*/
}
$h_s_math_Ordering$Tuple2Ordering.prototype = $c_s_math_Ordering$Tuple2Ordering.prototype;
$c_s_math_Ordering$Tuple2Ordering.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__T2__T2__I = (function(x, y) {
  var compare1 = this.s_math_Ordering$Tuple2Ordering__f_ord1.compare__O__O__I(x._1__O(), y._1__O());
  if ((compare1 !== 0)) {
    return compare1
  };
  return this.s_math_Ordering$Tuple2Ordering__f_ord2.compare__O__O__I(x._2__O(), y._2__O())
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Tuple2Ordering)) {
    var x3 = $as_s_math_Ordering$Tuple2Ordering(obj);
    var x = this.s_math_Ordering$Tuple2Ordering__f_ord1;
    var x$2 = x3.s_math_Ordering$Tuple2Ordering__f_ord1;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
      var x$4 = x3.s_math_Ordering$Tuple2Ordering__f_ord2;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  };
  return false
});
$c_s_math_Ordering$Tuple2Ordering.prototype.hashCode__I = (function() {
  var _1 = this.s_math_Ordering$Tuple2Ordering__f_ord1;
  var _2 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$2.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  var i = 0;
  while ((i < 2)) {
    var $$x1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break
      }
      case 1: {
        var x = _2;
        break
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
      }
    };
    h = this$2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return this$2.finalizeHash__I__I__I(h, 2)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
function $as_s_math_Ordering$Tuple2Ordering(obj) {
  return (((obj instanceof $c_s_math_Ordering$Tuple2Ordering) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Tuple2Ordering"))
}
function $isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Tuple2Ordering)))
}
function $asArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Tuple2Ordering;", depth))
}
var $d_s_math_Ordering$Tuple2Ordering = new $TypeData().initClass({
  s_math_Ordering$Tuple2Ordering: 0
}, false, "scala.math.Ordering$Tuple2Ordering", {
  s_math_Ordering$Tuple2Ordering: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Tuple2Ordering.prototype.$classData = $d_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, len)
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass({
  s_reflect_ClassTag$GenericClassTag: 0
}, false, "scala.reflect.ClassTag$GenericClassTag", {
  s_reflect_ClassTag$GenericClassTag: 1,
  O: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.$classData = $d_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $c_Ltyrian_Tag(name, attributes, children) {
  this.Ltyrian_Tag__f_name = null;
  this.Ltyrian_Tag__f_attributes = null;
  this.Ltyrian_Tag__f_children = null;
  this.Ltyrian_Tag__f_name = name;
  this.Ltyrian_Tag__f_attributes = attributes;
  this.Ltyrian_Tag__f_children = children
}
$c_Ltyrian_Tag.prototype = new $h_O();
$c_Ltyrian_Tag.prototype.constructor = $c_Ltyrian_Tag;
/** @constructor */
function $h_Ltyrian_Tag() {
  /*<skip>*/
}
$h_Ltyrian_Tag.prototype = $c_Ltyrian_Tag.prototype;
$c_Ltyrian_Tag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Tag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Tag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Tag)) {
    var x$0$2 = $as_Ltyrian_Tag(x$0);
    if ((this.Ltyrian_Tag__f_name === x$0$2.Ltyrian_Tag__f_name)) {
      var x = this.Ltyrian_Tag__f_attributes;
      var x$2 = x$0$2.Ltyrian_Tag__f_attributes;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Ltyrian_Tag__f_children;
      var x$4 = x$0$2.Ltyrian_Tag__f_children;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Tag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Tag.prototype.productArity__I = (function() {
  return 3
});
$c_Ltyrian_Tag.prototype.productPrefix__T = (function() {
  return "Tag"
});
$c_Ltyrian_Tag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Tag__f_name;
      break
    }
    case 1: {
      return this.Ltyrian_Tag__f_attributes;
      break
    }
    case 2: {
      return this.Ltyrian_Tag__f_children;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Ltyrian_Tag(obj) {
  return (((obj instanceof $c_Ltyrian_Tag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Tag"))
}
function $isArrayOf_Ltyrian_Tag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Tag)))
}
function $asArrayOf_Ltyrian_Tag(obj, depth) {
  return (($isArrayOf_Ltyrian_Tag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Tag;", depth))
}
var $d_Ltyrian_Tag = new $TypeData().initClass({
  Ltyrian_Tag: 0
}, false, "tyrian.Tag", {
  Ltyrian_Tag: 1,
  O: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Tag.prototype.$classData = $d_Ltyrian_Tag;
function $as_Ltyrian_http_Body$PlainText(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.Body$PlainText"))
}
function $isArrayOf_Ltyrian_http_Body$PlainText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_Body$PlainText)))
}
function $asArrayOf_Ltyrian_http_Body$PlainText(obj, depth) {
  return (($isArrayOf_Ltyrian_http_Body$PlainText(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.Body$PlainText;", depth))
}
/** @constructor */
function $c_Ltyrian_http_HttpError$BadRequest(msg) {
  this.Ltyrian_http_HttpError$BadRequest__f_msg = null;
  this.Ltyrian_http_HttpError$BadRequest__f_msg = msg
}
$c_Ltyrian_http_HttpError$BadRequest.prototype = new $h_Ltyrian_http_HttpError();
$c_Ltyrian_http_HttpError$BadRequest.prototype.constructor = $c_Ltyrian_http_HttpError$BadRequest;
/** @constructor */
function $h_Ltyrian_http_HttpError$BadRequest() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError$BadRequest.prototype = $c_Ltyrian_http_HttpError$BadRequest.prototype;
$c_Ltyrian_http_HttpError$BadRequest.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_http_HttpError$BadRequest)) {
    var x$0$2 = $as_Ltyrian_http_HttpError$BadRequest(x$0);
    return (this.Ltyrian_http_HttpError$BadRequest__f_msg === x$0$2.Ltyrian_http_HttpError$BadRequest__f_msg)
  } else {
    return false
  }
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.productPrefix__T = (function() {
  return "BadRequest"
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_http_HttpError$BadRequest__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.ordinal__I = (function() {
  return 0
});
function $as_Ltyrian_http_HttpError$BadRequest(obj) {
  return (((obj instanceof $c_Ltyrian_http_HttpError$BadRequest) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.HttpError$BadRequest"))
}
function $isArrayOf_Ltyrian_http_HttpError$BadRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_HttpError$BadRequest)))
}
function $asArrayOf_Ltyrian_http_HttpError$BadRequest(obj, depth) {
  return (($isArrayOf_Ltyrian_http_HttpError$BadRequest(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.HttpError$BadRequest;", depth))
}
var $d_Ltyrian_http_HttpError$BadRequest = new $TypeData().initClass({
  Ltyrian_http_HttpError$BadRequest: 0
}, false, "tyrian.http.HttpError$BadRequest", {
  Ltyrian_http_HttpError$BadRequest: 1,
  Ltyrian_http_HttpError: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_http_HttpError$BadRequest.prototype.$classData = $d_Ltyrian_http_HttpError$BadRequest;
/** @constructor */
function $c_Ltyrian_http_HttpError$DecodingFailure(decodingError, response) {
  this.Ltyrian_http_HttpError$DecodingFailure__f_decodingError = null;
  this.Ltyrian_http_HttpError$DecodingFailure__f_response = null;
  this.Ltyrian_http_HttpError$DecodingFailure__f_decodingError = decodingError;
  this.Ltyrian_http_HttpError$DecodingFailure__f_response = response
}
$c_Ltyrian_http_HttpError$DecodingFailure.prototype = new $h_Ltyrian_http_HttpError();
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.constructor = $c_Ltyrian_http_HttpError$DecodingFailure;
/** @constructor */
function $h_Ltyrian_http_HttpError$DecodingFailure() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError$DecodingFailure.prototype = $c_Ltyrian_http_HttpError$DecodingFailure.prototype;
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_http_HttpError$DecodingFailure)) {
    var x$0$2 = $as_Ltyrian_http_HttpError$DecodingFailure(x$0);
    if ((this.Ltyrian_http_HttpError$DecodingFailure__f_decodingError === x$0$2.Ltyrian_http_HttpError$DecodingFailure__f_decodingError)) {
      var x = this.Ltyrian_http_HttpError$DecodingFailure__f_response;
      var x$2 = x$0$2.Ltyrian_http_HttpError$DecodingFailure__f_response;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.productPrefix__T = (function() {
  return "DecodingFailure"
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_http_HttpError$DecodingFailure__f_decodingError
  };
  if ((n === 1)) {
    return this.Ltyrian_http_HttpError$DecodingFailure__f_response
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.ordinal__I = (function() {
  return 3
});
function $as_Ltyrian_http_HttpError$DecodingFailure(obj) {
  return (((obj instanceof $c_Ltyrian_http_HttpError$DecodingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.http.HttpError$DecodingFailure"))
}
function $isArrayOf_Ltyrian_http_HttpError$DecodingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_http_HttpError$DecodingFailure)))
}
function $asArrayOf_Ltyrian_http_HttpError$DecodingFailure(obj, depth) {
  return (($isArrayOf_Ltyrian_http_HttpError$DecodingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.http.HttpError$DecodingFailure;", depth))
}
var $d_Ltyrian_http_HttpError$DecodingFailure = new $TypeData().initClass({
  Ltyrian_http_HttpError$DecodingFailure: 0
}, false, "tyrian.http.HttpError$DecodingFailure", {
  Ltyrian_http_HttpError$DecodingFailure: 1,
  Ltyrian_http_HttpError: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_http_HttpError$DecodingFailure.prototype.$classData = $d_Ltyrian_http_HttpError$DecodingFailure;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent$Close(code, reason) {
  this.Ltyrian_websocket_WebSocketEvent$Close__f_code = 0;
  this.Ltyrian_websocket_WebSocketEvent$Close__f_reason = null;
  this.Ltyrian_websocket_WebSocketEvent$Close__f_code = code;
  this.Ltyrian_websocket_WebSocketEvent$Close__f_reason = reason
}
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype = new $h_Ltyrian_websocket_WebSocketEvent();
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent$Close;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent$Close() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent$Close.prototype = $c_Ltyrian_websocket_WebSocketEvent$Close.prototype;
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Close");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Ltyrian_websocket_WebSocketEvent$Close__f_code;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Ltyrian_websocket_WebSocketEvent$Close__f_reason;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_websocket_WebSocketEvent$Close)) {
    var x$0$2 = $as_Ltyrian_websocket_WebSocketEvent$Close(x$0);
    return ((this.Ltyrian_websocket_WebSocketEvent$Close__f_code === x$0$2.Ltyrian_websocket_WebSocketEvent$Close__f_code) && (this.Ltyrian_websocket_WebSocketEvent$Close__f_reason === x$0$2.Ltyrian_websocket_WebSocketEvent$Close__f_reason))
  } else {
    return false
  }
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.productPrefix__T = (function() {
  return "Close"
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_websocket_WebSocketEvent$Close__f_code
  };
  if ((n === 1)) {
    return this.Ltyrian_websocket_WebSocketEvent$Close__f_reason
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.ordinal__I = (function() {
  return 3
});
function $as_Ltyrian_websocket_WebSocketEvent$Close(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocketEvent$Close) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocketEvent$Close"))
}
function $isArrayOf_Ltyrian_websocket_WebSocketEvent$Close(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocketEvent$Close)))
}
function $asArrayOf_Ltyrian_websocket_WebSocketEvent$Close(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocketEvent$Close(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocketEvent$Close;", depth))
}
var $d_Ltyrian_websocket_WebSocketEvent$Close = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketEvent$Close: 0
}, false, "tyrian.websocket.WebSocketEvent$Close", {
  Ltyrian_websocket_WebSocketEvent$Close: 1,
  Ltyrian_websocket_WebSocketEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_websocket_WebSocketEvent$Close.prototype.$classData = $d_Ltyrian_websocket_WebSocketEvent$Close;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent$Error(error) {
  this.Ltyrian_websocket_WebSocketEvent$Error__f_error = null;
  this.Ltyrian_websocket_WebSocketEvent$Error__f_error = error
}
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype = new $h_Ltyrian_websocket_WebSocketEvent();
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent$Error;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent$Error() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent$Error.prototype = $c_Ltyrian_websocket_WebSocketEvent$Error.prototype;
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_websocket_WebSocketEvent$Error)) {
    var x$0$2 = $as_Ltyrian_websocket_WebSocketEvent$Error(x$0);
    return (this.Ltyrian_websocket_WebSocketEvent$Error__f_error === x$0$2.Ltyrian_websocket_WebSocketEvent$Error__f_error)
  } else {
    return false
  }
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.productPrefix__T = (function() {
  return "Error"
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_websocket_WebSocketEvent$Error__f_error
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.ordinal__I = (function() {
  return 2
});
function $as_Ltyrian_websocket_WebSocketEvent$Error(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocketEvent$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocketEvent$Error"))
}
function $isArrayOf_Ltyrian_websocket_WebSocketEvent$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocketEvent$Error)))
}
function $asArrayOf_Ltyrian_websocket_WebSocketEvent$Error(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocketEvent$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocketEvent$Error;", depth))
}
var $d_Ltyrian_websocket_WebSocketEvent$Error = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketEvent$Error: 0
}, false, "tyrian.websocket.WebSocketEvent$Error", {
  Ltyrian_websocket_WebSocketEvent$Error: 1,
  Ltyrian_websocket_WebSocketEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_websocket_WebSocketEvent$Error.prototype.$classData = $d_Ltyrian_websocket_WebSocketEvent$Error;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent$Receive(message) {
  this.Ltyrian_websocket_WebSocketEvent$Receive__f_message = null;
  this.Ltyrian_websocket_WebSocketEvent$Receive__f_message = message
}
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype = new $h_Ltyrian_websocket_WebSocketEvent();
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent$Receive;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent$Receive() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent$Receive.prototype = $c_Ltyrian_websocket_WebSocketEvent$Receive.prototype;
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_websocket_WebSocketEvent$Receive)) {
    var x$0$2 = $as_Ltyrian_websocket_WebSocketEvent$Receive(x$0);
    return (this.Ltyrian_websocket_WebSocketEvent$Receive__f_message === x$0$2.Ltyrian_websocket_WebSocketEvent$Receive__f_message)
  } else {
    return false
  }
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.productPrefix__T = (function() {
  return "Receive"
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_websocket_WebSocketEvent$Receive__f_message
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.ordinal__I = (function() {
  return 1
});
function $as_Ltyrian_websocket_WebSocketEvent$Receive(obj) {
  return (((obj instanceof $c_Ltyrian_websocket_WebSocketEvent$Receive) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.websocket.WebSocketEvent$Receive"))
}
function $isArrayOf_Ltyrian_websocket_WebSocketEvent$Receive(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_websocket_WebSocketEvent$Receive)))
}
function $asArrayOf_Ltyrian_websocket_WebSocketEvent$Receive(obj, depth) {
  return (($isArrayOf_Ltyrian_websocket_WebSocketEvent$Receive(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.websocket.WebSocketEvent$Receive;", depth))
}
var $d_Ltyrian_websocket_WebSocketEvent$Receive = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketEvent$Receive: 0
}, false, "tyrian.websocket.WebSocketEvent$Receive", {
  Ltyrian_websocket_WebSocketEvent$Receive: 1,
  Ltyrian_websocket_WebSocketEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Ltyrian_websocket_WebSocketEvent$Receive.prototype.$classData = $d_Ltyrian_websocket_WebSocketEvent$Receive;
function $f_Lcats_Apply__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.map__O__F1__O($thiz.product__O__O__O(fa, fb), $f_F2__tupled__F1(f))
}
function $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => this$1.map2__O__O__F2__O(fa$2, fb$2, f$2)))($thiz, fa, f)))
}
/** @constructor */
function $c_Lcats_data_WriterTInstances7() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances7.prototype = new $h_Lcats_data_WriterTInstances8();
$c_Lcats_data_WriterTInstances7.prototype.constructor = $c_Lcats_data_WriterTInstances7;
/** @constructor */
function $h_Lcats_data_WriterTInstances7() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances7.prototype = $c_Lcats_data_WriterTInstances7.prototype;
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  this.Lcats_instances_package$option$__f_catsStdTraverseFilterForOption = null;
  $n_Lcats_instances_package$option$ = this;
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  this.Lcats_instances_package$option$__f_catsStdTraverseFilterForOption = new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$option$.prototype = new $h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
  /*<skip>*/
}
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
var $d_Lcats_instances_package$option$ = new $TypeData().initClass({
  Lcats_instances_package$option$: 0
}, false, "cats.instances.package$option$", {
  Lcats_instances_package$option$: 1,
  O: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
});
$c_Lcats_instances_package$option$.prototype.$classData = $d_Lcats_instances_package$option$;
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$()
  };
  return $n_Lcats_instances_package$option$
}
/** @constructor */
function $c_Lio_circe_Encoder$() {
  this.Lio_circe_Encoder$__f_encodeJson = null;
  this.Lio_circe_Encoder$__f_encodeJsonObject = null;
  this.Lio_circe_Encoder$__f_encodeJsonNumber = null;
  this.Lio_circe_Encoder$__f_encodeString = null;
  this.Lio_circe_Encoder$__f_encodeUnit = null;
  this.Lio_circe_Encoder$__f_encodeBoolean = null;
  this.Lio_circe_Encoder$__f_encodeJavaBoolean$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaBooleanbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeChar = null;
  this.Lio_circe_Encoder$__f_encodeJavaCharacter$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaCharacterbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeFloat = null;
  this.Lio_circe_Encoder$__f_encodeJavaFloat$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaFloatbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeDouble = null;
  this.Lio_circe_Encoder$__f_encodeJavaDouble$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaDoublebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeByte = null;
  this.Lio_circe_Encoder$__f_encodeJavaByte$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaBytebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeShort = null;
  this.Lio_circe_Encoder$__f_encodeJavaShort$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaShortbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeInt = null;
  this.Lio_circe_Encoder$__f_encodeJavaInteger$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaIntegerbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeLong = null;
  this.Lio_circe_Encoder$__f_encodeJavaLong$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaLongbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeBigInt = null;
  this.Lio_circe_Encoder$__f_encodeJavaBigInteger$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaBigIntegerbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeBigDecimal = null;
  this.Lio_circe_Encoder$__f_encodeJavaBigDecimal$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeJavaBigDecimalbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeUUID$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeUUIDbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeNone = null;
  this.Lio_circe_Encoder$__f_encoderContravariant = null;
  this.Lio_circe_Encoder$__f_encodeDuration$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeDurationbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeInstant$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeInstantbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodePeriod$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodePeriodbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeZoneId$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeZoneIdbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeLocalDate$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeLocalDatebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeLocalTime$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeLocalTimebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeLocalDateTime$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeLocalDateTimebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeMonthDay$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeMonthDaybitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeOffsetTime$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeOffsetTimebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeOffsetDateTime$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeOffsetDateTimebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeYear$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeYearbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeYearMonth$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeYearMonthbitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeZonedDateTime$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeZonedDateTimebitmap$1 = false;
  this.Lio_circe_Encoder$__f_encodeZoneOffset$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeZoneOffsetbitmap$1 = false;
  this.Lio_circe_Encoder$__f_currencyEncoder$lzy1 = null;
  this.Lio_circe_Encoder$__f_currencyEncoderbitmap$1 = false;
  $n_Lio_circe_Encoder$ = this;
  this.Lio_circe_Encoder$__f_encodeJson = new $c_Lio_circe_Encoder$$anon$3();
  this.Lio_circe_Encoder$__f_encodeJsonObject = new $c_Lio_circe_Encoder$$anon$4();
  this.Lio_circe_Encoder$__f_encodeJsonNumber = new $c_Lio_circe_Encoder$$anon$5();
  this.Lio_circe_Encoder$__f_encodeString = new $c_Lio_circe_Encoder$$anon$6();
  this.Lio_circe_Encoder$__f_encodeUnit = new $c_Lio_circe_Encoder$$anon$7();
  this.Lio_circe_Encoder$__f_encodeBoolean = new $c_Lio_circe_Encoder$$anon$8();
  this.Lio_circe_Encoder$__f_encodeChar = new $c_Lio_circe_Encoder$$anon$9();
  this.Lio_circe_Encoder$__f_encodeFloat = new $c_Lio_circe_Encoder$$anon$10();
  this.Lio_circe_Encoder$__f_encodeDouble = new $c_Lio_circe_Encoder$$anon$11();
  this.Lio_circe_Encoder$__f_encodeByte = new $c_Lio_circe_Encoder$$anon$12();
  this.Lio_circe_Encoder$__f_encodeShort = new $c_Lio_circe_Encoder$$anon$13();
  this.Lio_circe_Encoder$__f_encodeInt = new $c_Lio_circe_Encoder$$anon$14();
  this.Lio_circe_Encoder$__f_encodeLong = new $c_Lio_circe_Encoder$$anon$15();
  this.Lio_circe_Encoder$__f_encodeBigInt = new $c_Lio_circe_Encoder$$anon$16();
  this.Lio_circe_Encoder$__f_encodeBigDecimal = new $c_Lio_circe_Encoder$$anon$17();
  this.Lio_circe_Encoder$__f_encodeNone = new $c_Lio_circe_Encoder$$anon$18();
  this.Lio_circe_Encoder$__f_encoderContravariant = new $c_Lio_circe_Encoder$$anon$19()
}
$c_Lio_circe_Encoder$.prototype = new $h_O();
$c_Lio_circe_Encoder$.prototype.constructor = $c_Lio_circe_Encoder$;
/** @constructor */
function $h_Lio_circe_Encoder$() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$.prototype = $c_Lio_circe_Encoder$.prototype;
$c_Lio_circe_Encoder$.prototype.encodeZonedDateTime__Lio_circe_Encoder = (function() {
  if ((!this.Lio_circe_Encoder$__f_encodeZonedDateTimebitmap$1)) {
    this.Lio_circe_Encoder$__f_encodeZonedDateTime$lzy1 = new $c_Lio_circe_Encoder$$anon$59();
    this.Lio_circe_Encoder$__f_encodeZonedDateTimebitmap$1 = true
  };
  return this.Lio_circe_Encoder$__f_encodeZonedDateTime$lzy1
});
var $d_Lio_circe_Encoder$ = new $TypeData().initClass({
  Lio_circe_Encoder$: 0
}, false, "io.circe.Encoder$", {
  Lio_circe_Encoder$: 1,
  O: 1,
  Lio_circe_TupleEncoders: 1,
  Lio_circe_ProductEncoders: 1,
  Lio_circe_LiteralEncoders: 1,
  Lio_circe_EnumerationEncoders: 1,
  Lio_circe_LowPriorityEncoders: 1,
  Lio_circe_MidPriorityEncoders: 1
});
$c_Lio_circe_Encoder$.prototype.$classData = $d_Lio_circe_Encoder$;
var $n_Lio_circe_Encoder$;
function $m_Lio_circe_Encoder$() {
  if ((!$n_Lio_circe_Encoder$)) {
    $n_Lio_circe_Encoder$ = new $c_Lio_circe_Encoder$()
  };
  return $n_Lio_circe_Encoder$
}
class $c_Lio_circe_ParsingFailure extends $c_Lio_circe_Error {
  constructor(message, underlying) {
    super();
    this.Lio_circe_ParsingFailure__f_message = null;
    this.Lio_circe_ParsingFailure__f_underlying = null;
    this.Lio_circe_ParsingFailure__f_message = message;
    this.Lio_circe_ParsingFailure__f_underlying = underlying;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true
    } else if ((x$0 instanceof $c_Lio_circe_ParsingFailure)) {
      var x$0$2 = $as_Lio_circe_ParsingFailure(x$0);
      if ((this.Lio_circe_ParsingFailure__f_message === x$0$2.Lio_circe_ParsingFailure__f_message)) {
        var x = this.Lio_circe_ParsingFailure__f_underlying;
        var x$2 = x$0$2.Lio_circe_ParsingFailure__f_underlying;
        return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  };
  productArity__I() {
    return 2
  };
  productPrefix__T() {
    return "ParsingFailure"
  };
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lio_circe_ParsingFailure__f_message
    };
    if ((n === 1)) {
      return this.Lio_circe_ParsingFailure__f_underlying
    };
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  getMessage__T() {
    return this.Lio_circe_ParsingFailure__f_message
  };
}
function $as_Lio_circe_ParsingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_ParsingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.ParsingFailure"))
}
function $isArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_ParsingFailure)))
}
function $asArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_ParsingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.ParsingFailure;", depth))
}
var $d_Lio_circe_ParsingFailure = new $TypeData().initClass({
  Lio_circe_ParsingFailure: 0
}, false, "io.circe.ParsingFailure", {
  Lio_circe_ParsingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lio_circe_ParsingFailure.prototype.$classData = $d_Lio_circe_ParsingFailure;
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $thiz.Ljava_io_PrintStream__f_autoFlush = autoFlush;
  $thiz.Ljava_io_PrintStream__f_charset = charset;
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  $thiz.Ljava_io_PrintStream__f_closing = false;
  $thiz.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  $thiz.Ljava_io_PrintStream__f_errorFlag = false;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
  /*<skip>*/
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $dp_toString__T(csq)));
  return this
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__Ljava_io_PrintStream = (function(csq, start, end) {
  var csq1 = ((csq === null) ? "null" : csq);
  this.print__T__V($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(csq1, start, end)));
  return this
});
$c_Ljava_io_PrintStream.prototype.append__C__Ljava_io_PrintStream = (function(c) {
  this.print__C__V(c);
  return this
});
$c_Ljava_io_PrintStream.prototype.append__C__jl_Appendable = (function(x$1) {
  return this.append__C__Ljava_io_PrintStream(x$1)
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(x$1, x$2, x$3) {
  return this.append__jl_CharSequence__I__I__Ljava_io_PrintStream(x$1, x$2, x$3)
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(x$1) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(x$1)
});
function $as_Ljava_io_PrintStream(obj) {
  return (((obj instanceof $c_Ljava_io_PrintStream) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.PrintStream"))
}
function $isArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_PrintStream)))
}
function $asArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (($isArrayOf_Ljava_io_PrintStream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.PrintStream;", depth))
}
function $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant($thiz, secondsToAdd, nanosToAdd) {
  var lo = nanosToAdd.RTLong__f_lo;
  var hi = nanosToAdd.RTLong__f_hi;
  var _nanosToAdd__lo = lo;
  var _nanosToAdd__hi = hi;
  var b__lo = _nanosToAdd__lo;
  var b__hi = _nanosToAdd__hi;
  var lo$1 = (secondsToAdd.RTLong__f_lo | b__lo);
  var hi$1 = (secondsToAdd.RTLong__f_hi | b__hi);
  if (((lo$1 === 0) && (hi$1 === 0))) {
    return $thiz
  };
  var t = $thiz.Ljava_time_Instant__f_seconds;
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$2, hi$2), secondsToAdd);
  var lo$3 = t$1.RTLong__f_lo;
  var hi$3 = t$1.RTLong__f_hi;
  var epochSec__lo = lo$3;
  var epochSec__hi = hi$3;
  var a__lo = epochSec__lo;
  var a__hi = epochSec__hi;
  var this$1__lo = _nanosToAdd__lo;
  var this$1__hi = _nanosToAdd__hi;
  var this$2 = $m_RTLong$();
  var lo$4 = this$2.divideImpl__I__I__I__I__I(this$1__lo, this$1__hi, 1000000000, 0);
  var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var t$2 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$4, hi$4));
  var lo$5 = t$2.RTLong__f_lo;
  var hi$5 = t$2.RTLong__f_hi;
  var $$x1__lo = lo$5;
  var $$x1__hi = hi$5;
  epochSec__lo = $$x1__lo;
  epochSec__hi = $$x1__hi;
  var this$3__lo = _nanosToAdd__lo;
  var this$3__hi = _nanosToAdd__hi;
  var this$4 = $m_RTLong$();
  var lo$6 = this$4.remainderImpl__I__I__I__I__I(this$3__lo, this$3__hi, 1000000000, 0);
  var hi$6 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x2__lo = lo$6;
  var $$x2__hi = hi$6;
  _nanosToAdd__lo = $$x2__lo;
  _nanosToAdd__hi = $$x2__hi;
  var value = $thiz.Ljava_time_Instant__f_nanos;
  var hi$7 = (value >> 31);
  var b$1__lo = _nanosToAdd__lo;
  var b$1__hi = _nanosToAdd__hi;
  var bhi = b$1__hi;
  var lo$7 = ((value + b$1__lo) | 0);
  var hi$8 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ value)) ? ((1 + ((hi$7 + bhi) | 0)) | 0) : ((hi$7 + bhi) | 0));
  return $m_Ljava_time_Instant$().ofEpochSecond__J__J__Ljava_time_Instant(new $c_RTLong(epochSec__lo, epochSec__hi), new $c_RTLong(lo$7, hi$8))
}
/** @constructor */
function $c_Ljava_time_Instant(seconds, nanos) {
  this.Ljava_time_Instant__f_seconds = $L0;
  this.Ljava_time_Instant__f_nanos = 0;
  this.Ljava_time_Instant__f_seconds = seconds;
  this.Ljava_time_Instant__f_nanos = nanos
}
$c_Ljava_time_Instant.prototype = new $h_O();
$c_Ljava_time_Instant.prototype.constructor = $c_Ljava_time_Instant;
/** @constructor */
function $h_Ljava_time_Instant() {
  /*<skip>*/
}
$h_Ljava_time_Instant.prototype = $c_Ljava_time_Instant.prototype;
$c_Ljava_time_Instant.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ((((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_Instant.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_Instant.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      return this.Ljava_time_Instant__f_nanos
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        return ((this.Ljava_time_Instant__f_nanos / 1000) | 0)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === f)) {
          return ((this.Ljava_time_Instant__f_nanos / 1000000) | 0)
        } else {
          throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
        }
      }
    }
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field)
  }
});
$c_Ljava_time_Instant.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      return new $c_RTLong(value, hi)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var value$1 = this.Ljava_time_Instant__f_nanos;
        var hi$1 = (value$1 >> 31);
        var this$3 = $m_RTLong$();
        var lo = this$3.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
        var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo, hi$2)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === f)) {
          var value$2 = this.Ljava_time_Instant__f_nanos;
          var hi$3 = (value$2 >> 31);
          var this$5 = $m_RTLong$();
          var lo$1 = this$5.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
          var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          return new $c_RTLong(lo$1, hi$4)
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
          if ((x$7 === f)) {
            return this.Ljava_time_Instant__f_seconds
          } else {
            throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
          }
        }
      }
    }
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    f.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, f);
    var x = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      var nval = Math.imul(1000000, newValue.RTLong__f_lo);
      return ((nval !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval) : this)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var nval$2 = Math.imul(1000, newValue.RTLong__f_lo);
        return ((nval$2 !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval$2) : this)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === f)) {
          var value = this.Ljava_time_Instant__f_nanos;
          var hi = (value >> 31);
          if ((!((newValue.RTLong__f_lo === value) && (newValue.RTLong__f_hi === hi)))) {
            return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, newValue.RTLong__f_lo)
          } else {
            return this
          }
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
          if ((x$7 === f)) {
            var b = this.Ljava_time_Instant__f_seconds;
            if ((!((newValue.RTLong__f_lo === b.RTLong__f_lo) && (newValue.RTLong__f_hi === b.RTLong__f_hi)))) {
              return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(newValue, this.Ljava_time_Instant__f_nanos)
            } else {
              return this
            }
          } else {
            throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
          }
        }
      }
    }
  };
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(field, newValue)
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var u = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === u)) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $L0, amountToAdd)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === u)) {
        var this$1 = $m_RTLong$();
        var lo = this$1.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
        var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $$x1 = new $c_RTLong(lo, hi);
        var this$2 = $m_RTLong$();
        var lo$1 = this$2.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
        var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo$1);
        var b1 = ((lo$1 >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
        return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $$x1, new $c_RTLong(lo$2, hi$2))
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === u)) {
          return this.plusMillis__J__Ljava_time_Instant(amountToAdd)
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === u)) {
            return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, amountToAdd, $L0)
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === u)) {
              var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
              var hi$3 = (value >> 31);
              var t = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value, hi$3));
              var lo$3 = t.RTLong__f_lo;
              var hi$4 = t.RTLong__f_hi;
              return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$3, hi$4), $L0)
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === u)) {
                var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR;
                var hi$5 = (value$1 >> 31);
                var t$1 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value$1, hi$5));
                var lo$4 = t$1.RTLong__f_lo;
                var hi$6 = t$1.RTLong__f_hi;
                return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$4, hi$6), $L0)
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === u)) {
                  var value$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
                  var hi$7 = (value$2 >> 31);
                  var this$6 = $m_RTLong$();
                  var lo$5 = this$6.divideImpl__I__I__I__I__I(value$2, hi$7, 2, 0);
                  var hi$8 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var t$2 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(lo$5, hi$8));
                  var lo$6 = t$2.RTLong__f_lo;
                  var hi$9 = t$2.RTLong__f_hi;
                  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$6, hi$9), $L0)
                } else {
                  var x$15 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === u)) {
                    var value$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
                    var hi$10 = (value$3 >> 31);
                    var t$3 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value$3, hi$10));
                    var lo$7 = t$3.RTLong__f_lo;
                    var hi$11 = t$3.RTLong__f_hi;
                    return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$7, hi$11), $L0)
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToAdd, unit)
});
$c_Ljava_time_Instant.prototype.plusMillis__J__Ljava_time_Instant = (function(millisToAdd) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x1 = new $c_RTLong(lo, hi);
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0 = (65535 & lo$1);
  var b1 = ((lo$1 >>> 16) | 0);
  var a0b0 = Math.imul(16960, b0);
  var a1b0 = Math.imul(15, b0);
  var a0b1 = Math.imul(16960, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((((Math.imul(1000000, hi$1) + Math.imul(15, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $$x1, new $c_RTLong(lo$2, hi$2))
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_Instant.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_Instant.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x2 = temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), this.Ljava_time_Instant__f_seconds);
  var $$x1 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_Instant__f_nanos;
  var hi = (value >> 31);
  return $$x2.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_Instant.prototype.compare__Ljava_time_Instant__I = (function(otherInstant) {
  var t = this.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = otherInstant.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Instant__f_nanos - otherInstant.Ljava_time_Instant__f_nanos) | 0))
});
$c_Ljava_time_Instant.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Instant)) {
    var otherInstant = $as_Ljava_time_Instant(other);
    if ((this === otherInstant)) {
      return true
    } else {
      var this$1 = this.Ljava_time_Instant__f_seconds;
      var b = otherInstant.Ljava_time_Instant__f_seconds;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Instant__f_nanos === otherInstant.Ljava_time_Instant__f_nanos)
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_Instant.prototype.hashCode__I = (function() {
  var this$2 = this.Ljava_time_Instant__f_seconds;
  var this$1 = this.Ljava_time_Instant__f_seconds;
  var hi = this$1.RTLong__f_hi;
  var lo = (this$2.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Instant__f_nanos)) | 0)
});
$c_Ljava_time_Instant.prototype.toString__T = (function() {
  return $m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter().format__Ljava_time_temporal_TemporalAccessor__T(this)
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(field, newValue)
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToAdd, unit)
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToSubtract, unit)
});
$c_Ljava_time_Instant.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Instant(that);
  return this.compare__Ljava_time_Instant__I(other)
});
function $as_Ljava_time_Instant(obj) {
  return (((obj instanceof $c_Ljava_time_Instant) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Instant"))
}
function $isArrayOf_Ljava_time_Instant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Instant)))
}
function $asArrayOf_Ljava_time_Instant(obj, depth) {
  return (($isArrayOf_Ljava_time_Instant(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Instant;", depth))
}
var $d_Ljava_time_Instant = new $TypeData().initClass({
  Ljava_time_Instant: 0
}, false, "java.time.Instant", {
  Ljava_time_Instant: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Instant.prototype.$classData = $d_Ljava_time_Instant;
function $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x1 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x === x1)) {
    var value = $thiz.Ljava_time_LocalTime__f_nano;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  };
  var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$3 === x1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
  };
  var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x$5 === x1)) {
    var value$1 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$1 = (value$1 >> 31);
    var this$3 = $m_RTLong$();
    var lo = this$3.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
    var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo, hi$2)
  };
  var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$7 === x1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
  };
  var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x$9 === x1)) {
    var value$2 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$3 = (value$2 >> 31);
    var this$5 = $m_RTLong$();
    var lo$1 = this$5.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
    var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$1, hi$4)
  };
  var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$11 === x1)) {
    var this$6 = $thiz.toNanoOfDay__J();
    var this$7 = $m_RTLong$();
    var lo$2 = this$7.divideImpl__I__I__I__I__I(this$6.RTLong__f_lo, this$6.RTLong__f_hi, 1000000, 0);
    var hi$5 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$2, hi$5)
  };
  var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  if ((x$13 === x1)) {
    var value$3 = $thiz.Ljava_time_LocalTime__f_second;
    var hi$6 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$6)
  };
  var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$15 === x1)) {
    var value$4 = $thiz.toSecondOfDay__I();
    var hi$7 = (value$4 >> 31);
    return new $c_RTLong(value$4, hi$7)
  };
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  if ((x$17 === x1)) {
    var value$5 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$8 = (value$5 >> 31);
    return new $c_RTLong(value$5, hi$8)
  };
  var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$19 === x1)) {
    var value$6 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$9 = (value$6 >> 31);
    var b0 = (65535 & value$6);
    var b1 = ((value$6 >>> 16) | 0);
    var a0b0 = Math.imul(60, b0);
    var a0b1 = Math.imul(60, b1);
    var lo$3 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$10 = ((Math.imul(60, hi$9) + ((c1part >>> 16) | 0)) | 0);
    var value$7 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$11 = (value$7 >> 31);
    var lo$4 = ((lo$3 + value$7) | 0);
    var hi$12 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$10 + hi$11) | 0)) | 0) : ((hi$10 + hi$11) | 0));
    return new $c_RTLong(lo$4, hi$12)
  };
  var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if ((x$21 === x1)) {
    var value$8 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$13 = (value$8 >> 31);
    var this$15 = $m_RTLong$();
    var lo$5 = this$15.remainderImpl__I__I__I__I__I(value$8, hi$13, 12, 0);
    var hi$14 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$5, hi$14)
  };
  var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if ((x$23 === x1)) {
    var value$9 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$15 = (value$9 >> 31);
    var this$17 = $m_RTLong$();
    var lo$6 = this$17.remainderImpl__I__I__I__I__I(value$9, hi$15, 12, 0);
    var hi$16 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$18 = $m_RTLong$();
    var lo$7 = this$18.remainderImpl__I__I__I__I__I(lo$6, hi$16, 12, 0);
    var hi$17 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$7 === 0) && (hi$17 === 0))) {
      return new $c_RTLong(12, 0)
    } else {
      return new $c_RTLong(lo$6, hi$16)
    }
  };
  var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$25 === x1)) {
    var value$10 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$18 = (value$10 >> 31);
    return new $c_RTLong(value$10, hi$18)
  };
  var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$27 === x1)) {
    if (($thiz.Ljava_time_LocalTime__f_hour === 0)) {
      return new $c_RTLong(24, 0)
    } else {
      var value$11 = $thiz.Ljava_time_LocalTime__f_hour;
      var hi$19 = (value$11 >> 31);
      return new $c_RTLong(value$11, hi$19)
    }
  };
  var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$29 === x1)) {
    var value$12 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$20 = (value$12 >> 31);
    var this$22 = $m_RTLong$();
    var lo$8 = this$22.divideImpl__I__I__I__I__I(value$12, hi$20, 12, 0);
    var hi$21 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$8, hi$21)
  };
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
}
/** @constructor */
function $c_Ljava_time_LocalTime(_hour, _minute, _second, nano) {
  this.Ljava_time_LocalTime__f_nano = 0;
  this.Ljava_time_LocalTime__f_hour = 0;
  this.Ljava_time_LocalTime__f_minute = 0;
  this.Ljava_time_LocalTime__f_second = 0;
  this.Ljava_time_LocalTime__f_nano = nano;
  this.Ljava_time_LocalTime__f_hour = ((_hour << 24) >> 24);
  this.Ljava_time_LocalTime__f_minute = ((_minute << 24) >> 24);
  this.Ljava_time_LocalTime__f_second = ((_second << 24) >> 24)
}
$c_Ljava_time_LocalTime.prototype = new $h_O();
$c_Ljava_time_LocalTime.prototype.constructor = $c_Ljava_time_LocalTime;
/** @constructor */
function $h_Ljava_time_LocalTime() {
  /*<skip>*/
}
$h_Ljava_time_LocalTime.prototype = $c_Ljava_time_LocalTime.prototype;
$c_Ljava_time_LocalTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? field.isTimeBased__Z() : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_LocalTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_LocalTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var this$1 = $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return this$1.RTLong__f_lo
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_LocalTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toNanoOfDay__J()
    };
    if ((field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$1 = this.toNanoOfDay__J();
      var this$2 = $m_RTLong$();
      var lo = this$2.divideImpl__I__I__I__I__I(this$1.RTLong__f_lo, this$1.RTLong__f_hi, 1000, 0);
      var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi)
    };
    return $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field)
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    f.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, f);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      return this.withNano__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        return $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(newValue)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === f)) {
          return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000, newValue.RTLong__f_lo))
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
          if ((x$7 === f)) {
            var $$x1 = $m_Ljava_time_LocalTime$();
            var blo = newValue.RTLong__f_lo;
            var b0 = (65535 & blo);
            var b1 = ((blo >>> 16) | 0);
            var a0b0 = Math.imul(1000, b0);
            var a0b1 = Math.imul(1000, b1);
            var lo = ((a0b0 + (a0b1 << 16)) | 0);
            var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
            var hi = ((Math.imul(1000, newValue.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
            return $$x1.ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo, hi))
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
            if ((x$9 === f)) {
              return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000000, newValue.RTLong__f_lo))
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
              if ((x$11 === f)) {
                var $$x2 = $m_Ljava_time_LocalTime$();
                var blo$1 = newValue.RTLong__f_lo;
                var b0$1 = (65535 & blo$1);
                var b1$1 = ((blo$1 >>> 16) | 0);
                var a0b0$1 = Math.imul(16960, b0$1);
                var a1b0 = Math.imul(15, b0$1);
                var a0b1$1 = Math.imul(16960, b1$1);
                var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
                var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
                var hi$1 = ((((((Math.imul(1000000, newValue.RTLong__f_hi) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
                return $$x2.ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1))
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
                if ((x$13 === f)) {
                  return this.withSecond__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                } else {
                  var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
                  if ((x$15 === f)) {
                    var value = this.toSecondOfDay__I();
                    var hi$2 = (value >> 31);
                    var alo = newValue.RTLong__f_lo;
                    var ahi = newValue.RTLong__f_hi;
                    var lo$2 = ((alo - value) | 0);
                    var hi$3 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$2) | 0)) | 0) : ((ahi - hi$2) | 0));
                    return this.plusSeconds__J__Ljava_time_LocalTime(new $c_RTLong(lo$2, hi$3))
                  } else {
                    var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
                    if ((x$17 === f)) {
                      return this.withMinute__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                    } else {
                      var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
                      if ((x$19 === f)) {
                        var value$1 = ((Math.imul(60, this.Ljava_time_LocalTime__f_hour) + this.Ljava_time_LocalTime__f_minute) | 0);
                        var hi$4 = (value$1 >> 31);
                        var alo$1 = newValue.RTLong__f_lo;
                        var ahi$1 = newValue.RTLong__f_hi;
                        var lo$3 = ((alo$1 - value$1) | 0);
                        var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$4) | 0)) | 0) : ((ahi$1 - hi$4) | 0));
                        return this.plusMinutes__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$5))
                      } else {
                        var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                        if ((x$21 === f)) {
                          var value$2 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
                          var hi$6 = (value$2 >> 31);
                          var alo$2 = newValue.RTLong__f_lo;
                          var ahi$2 = newValue.RTLong__f_hi;
                          var lo$4 = ((alo$2 - value$2) | 0);
                          var hi$7 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$6) | 0)) | 0) : ((ahi$2 - hi$6) | 0));
                          return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$4, hi$7))
                        } else {
                          var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                          if ((x$23 === f)) {
                            var this$8 = (((newValue.RTLong__f_lo === 12) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
                            var value$3 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
                            var hi$8 = (value$3 >> 31);
                            var alo$3 = this$8.RTLong__f_lo;
                            var ahi$3 = this$8.RTLong__f_hi;
                            var lo$5 = ((alo$3 - value$3) | 0);
                            var hi$9 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$3 - hi$8) | 0)) | 0) : ((ahi$3 - hi$8) | 0));
                            return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$9))
                          } else {
                            var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                            if ((x$25 === f)) {
                              return this.withHour__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                            } else {
                              var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                              if ((x$27 === f)) {
                                var this$10 = (((newValue.RTLong__f_lo === 24) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
                                return this.withHour__I__Ljava_time_LocalTime(this$10.RTLong__f_lo)
                              } else {
                                var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
                                if ((x$29 === f)) {
                                  var value$4 = ((this.Ljava_time_LocalTime__f_hour / 12) | 0);
                                  var hi$10 = (value$4 >> 31);
                                  var alo$4 = newValue.RTLong__f_lo;
                                  var ahi$4 = newValue.RTLong__f_hi;
                                  var lo$6 = ((alo$4 - value$4) | 0);
                                  var hi$11 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ alo$4)) ? (((-1) + ((ahi$4 - hi$10) | 0)) | 0) : ((ahi$4 - hi$10) | 0));
                                  var b0$2 = (65535 & lo$6);
                                  var b1$2 = ((lo$6 >>> 16) | 0);
                                  var a0b0$2 = Math.imul(12, b0$2);
                                  var a0b1$2 = Math.imul(12, b1$2);
                                  var lo$7 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                                  var hi$12 = ((Math.imul(12, hi$11) + ((c1part$2 >>> 16) | 0)) | 0);
                                  return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$7, hi$12))
                                } else {
                                  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)
  }
});
$c_Ljava_time_LocalTime.prototype.withHour__I__Ljava_time_LocalTime = (function(hour) {
  if ((this.Ljava_time_LocalTime__f_hour === hour)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var hi = (hour >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withMinute__I__Ljava_time_LocalTime = (function(minute) {
  if ((this.Ljava_time_LocalTime__f_minute === minute)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi = (minute >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withSecond__I__Ljava_time_LocalTime = (function(second) {
  if ((this.Ljava_time_LocalTime__f_second === second)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var hi = (second >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, second, this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withNano__I__Ljava_time_LocalTime = (function(nanoOfSecond) {
  if ((this.Ljava_time_LocalTime__f_nano === nanoOfSecond)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var hi = (nanoOfSecond >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, nanoOfSecond)
  }
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === f)) {
      return this.plusNanos__J__Ljava_time_LocalTime(amountToAdd)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === f)) {
        var b = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MICROS_PER_DAY;
        var this$1 = $m_RTLong$();
        var lo = this$1.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
        return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1))
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === f)) {
          var b$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MILLIS_PER_DAY;
          var this$2 = $m_RTLong$();
          var lo$2 = this$2.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
          var hi$2 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var b0$1 = (65535 & lo$2);
          var b1$1 = ((lo$2 >>> 16) | 0);
          var a0b0$1 = Math.imul(16960, b0$1);
          var a1b0 = Math.imul(15, b0$1);
          var a0b1$1 = Math.imul(16960, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$3 = ((((((Math.imul(1000000, hi$2) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
          return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$3))
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === f)) {
            return this.plusSeconds__J__Ljava_time_LocalTime(amountToAdd)
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === f)) {
              return this.plusMinutes__J__Ljava_time_LocalTime(amountToAdd)
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === f)) {
                return this.plusHours__J__Ljava_time_LocalTime(amountToAdd)
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === f)) {
                  var this$3 = $m_RTLong$();
                  var lo$4 = this$3.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 2, 0);
                  var hi$4 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var b0$2 = (65535 & lo$4);
                  var b1$2 = ((lo$4 >>> 16) | 0);
                  var a0b0$2 = Math.imul(12, b0$2);
                  var a0b1$2 = Math.imul(12, b1$2);
                  var lo$5 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                  var hi$5 = ((Math.imul(12, hi$4) + ((c1part$2 >>> 16) | 0)) | 0);
                  return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$5))
                } else {
                  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToAdd, unit)
  }
});
$c_Ljava_time_LocalTime.prototype.plusHours__J__Ljava_time_LocalTime = (function(hoursToAdd) {
  if (((hoursToAdd.RTLong__f_lo === 0) && (hoursToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(hoursToAdd.RTLong__f_lo, hoursToAdd.RTLong__f_hi, value, hi);
  var newHour = $intMod(((((lo + this.Ljava_time_LocalTime__f_hour) | 0) + $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY) | 0), $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusMinutes__J__Ljava_time_LocalTime = (function(minutesToAdd) {
  if (((minutesToAdd.RTLong__f_lo === 0) && (minutesToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var mofd = ((Math.imul(this.Ljava_time_LocalTime__f_hour, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_HOUR) + this.Ljava_time_LocalTime__f_minute) | 0);
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(minutesToAdd.RTLong__f_lo, minutesToAdd.RTLong__f_hi, value, hi);
  var newMofd = $intMod(((((lo + mofd) | 0) + $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY) | 0), $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY);
  if ((mofd === newMofd)) {
    return this
  };
  var newHour = $intDiv(newMofd, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_HOUR);
  var newMinute = $intMod(newMofd, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_HOUR);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusSeconds__J__Ljava_time_LocalTime = (function(secondstoAdd) {
  if (((secondstoAdd.RTLong__f_lo === 0) && (secondstoAdd.RTLong__f_hi === 0))) {
    return this
  };
  var sofd = ((((Math.imul(this.Ljava_time_LocalTime__f_hour, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR) + Math.imul(this.Ljava_time_LocalTime__f_minute, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE)) | 0) + this.Ljava_time_LocalTime__f_second) | 0);
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(secondstoAdd.RTLong__f_lo, secondstoAdd.RTLong__f_hi, value, hi);
  var newSofd = $intMod(((((lo + sofd) | 0) + $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY) | 0), $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY);
  if ((sofd === newSofd)) {
    return this
  };
  var newHour = $intDiv(newSofd, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR);
  var newMinute = $intMod($intDiv(newSofd, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE), $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_HOUR);
  var newSecond = $intMod(newSofd, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, newSecond, this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusNanos__J__Ljava_time_LocalTime = (function(nanosToAdd) {
  if (((nanosToAdd.RTLong__f_lo === 0) && (nanosToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var this$1 = $m_RTLong$();
  var lo$1 = this$1.remainderImpl__I__I__I__I__I(nanosToAdd.RTLong__f_lo, nanosToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi$1 = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$2 = ((lo$1 + lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi) | 0)) | 0) : ((hi$1 + hi) | 0));
  var b$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var bhi = b$1.RTLong__f_hi;
  var lo$3 = ((lo$2 + b$1.RTLong__f_lo) | 0);
  var hi$3 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$2 + bhi) | 0)) | 0) : ((hi$2 + bhi) | 0));
  var b$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var this$4 = $m_RTLong$();
  var lo$4 = this$4.remainderImpl__I__I__I__I__I(lo$3, hi$3, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
  var hi$4 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === lo$4) && (hi === hi$4))) {
    return this
  };
  var b$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var this$5 = $m_RTLong$();
  var lo$5 = this$5.divideImpl__I__I__I__I__I(lo$4, hi$4, b$3.RTLong__f_lo, b$3.RTLong__f_hi);
  var b$4 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var this$6 = $m_RTLong$();
  var lo$6 = this$6.divideImpl__I__I__I__I__I(lo$4, hi$4, b$4.RTLong__f_lo, b$4.RTLong__f_hi);
  var hi$6 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_HOUR;
  var hi$7 = (value >> 31);
  var this$8 = $m_RTLong$();
  var lo$7 = this$8.remainderImpl__I__I__I__I__I(lo$6, hi$6, value, hi$7);
  var b$5 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var this$9 = $m_RTLong$();
  var lo$8 = this$9.divideImpl__I__I__I__I__I(lo$4, hi$4, b$5.RTLong__f_lo, b$5.RTLong__f_hi);
  var hi$9 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE;
  var hi$10 = (value$1 >> 31);
  var this$11 = $m_RTLong$();
  var lo$9 = this$11.remainderImpl__I__I__I__I__I(lo$8, hi$9, value$1, hi$10);
  var b$6 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var this$12 = $m_RTLong$();
  var lo$10 = this$12.remainderImpl__I__I__I__I__I(lo$4, hi$4, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$5, lo$7, lo$9, lo$10)
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit()
  };
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return this
  };
  matchAlts1: {
    matchAlts2: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts2
      };
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts2
      };
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2
      };
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2
      };
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2
      };
      break matchAlts1
    };
    return null
  };
  return query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)
});
$c_Ljava_time_LocalTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), this.toNanoOfDay__J())
});
$c_Ljava_time_LocalTime.prototype.toSecondOfDay__I = (function() {
  var total = Math.imul(this.Ljava_time_LocalTime__f_hour, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_HOUR);
  total = ((total + Math.imul(this.Ljava_time_LocalTime__f_minute, $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE)) | 0);
  total = ((total + this.Ljava_time_LocalTime__f_second) | 0);
  return total
});
$c_Ljava_time_LocalTime.prototype.toNanoOfDay__J = (function() {
  var value = this.Ljava_time_LocalTime__f_hour;
  var hi = (value >> 31);
  var b = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & value);
  var a1 = ((value >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(value, b.RTLong__f_hi) + Math.imul(hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var total__lo = lo;
  var total__hi = hi$1;
  var this$3__lo = total__lo;
  var this$3__hi = total__hi;
  var value$1 = this.Ljava_time_LocalTime__f_minute;
  var hi$2 = (value$1 >> 31);
  var b$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var blo$1 = b$1.RTLong__f_lo;
  var a0$1 = (65535 & value$1);
  var a1$1 = ((value$1 >>> 16) | 0);
  var b0$1 = (65535 & blo$1);
  var b1$1 = ((blo$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul(value$1, b$1.RTLong__f_hi) + Math.imul(hi$2, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo = this$3__lo;
  var ahi = this$3__hi;
  var lo$2 = ((alo + lo$1) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$3) | 0)) | 0) : ((ahi + hi$3) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$4;
  total__lo = $$x1__lo;
  total__hi = $$x1__hi;
  var this$6__lo = total__lo;
  var this$6__hi = total__hi;
  var value$2 = this.Ljava_time_LocalTime__f_second;
  var hi$5 = (value$2 >> 31);
  var b$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var blo$2 = b$2.RTLong__f_lo;
  var a0$2 = (65535 & value$2);
  var a1$2 = ((value$2 >>> 16) | 0);
  var b0$2 = (65535 & blo$2);
  var b1$2 = ((blo$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((((Math.imul(value$2, b$2.RTLong__f_hi) + Math.imul(hi$5, blo$2)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$1 = this$6__lo;
  var ahi$1 = this$6__hi;
  var lo$4 = ((alo$1 + lo$3) | 0);
  var hi$7 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$1 + hi$6) | 0)) | 0) : ((ahi$1 + hi$6) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$7;
  total__lo = $$x2__lo;
  total__hi = $$x2__hi;
  var this$9__lo = total__lo;
  var this$9__hi = total__hi;
  var value$3 = this.Ljava_time_LocalTime__f_nano;
  var hi$8 = (value$3 >> 31);
  var alo$2 = this$9__lo;
  var ahi$2 = this$9__hi;
  var lo$5 = ((alo$2 + value$3) | 0);
  var hi$9 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi$2 + hi$8) | 0)) | 0) : ((ahi$2 + hi$8) | 0));
  var $$x3__lo = lo$5;
  var $$x3__hi = hi$9;
  total__lo = $$x3__lo;
  total__hi = $$x3__hi;
  return new $c_RTLong(total__lo, total__hi)
});
$c_Ljava_time_LocalTime.prototype.compare__Ljava_time_LocalTime__I = (function(other) {
  var x = this.Ljava_time_LocalTime__f_hour;
  var y = other.Ljava_time_LocalTime__f_hour;
  var cmp = ((x === y) ? 0 : ((x < y) ? (-1) : 1));
  if ((cmp === 0)) {
    var x$1 = this.Ljava_time_LocalTime__f_minute;
    var y$1 = other.Ljava_time_LocalTime__f_minute;
    cmp = ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
    if ((cmp === 0)) {
      var x$2 = this.Ljava_time_LocalTime__f_second;
      var y$2 = other.Ljava_time_LocalTime__f_second;
      cmp = ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
      if ((cmp === 0)) {
        var x$3 = this.Ljava_time_LocalTime__f_nano;
        var y$3 = other.Ljava_time_LocalTime__f_nano;
        cmp = ((x$3 === y$3) ? 0 : ((x$3 < y$3) ? (-1) : 1))
      }
    }
  };
  return cmp
});
$c_Ljava_time_LocalTime.prototype.isAfter__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) > 0)
});
$c_Ljava_time_LocalTime.prototype.isBefore__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) < 0)
});
$c_Ljava_time_LocalTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalTime)) {
    var other = $as_Ljava_time_LocalTime(obj);
    return ((this === other) || ((((this.Ljava_time_LocalTime__f_hour === other.Ljava_time_LocalTime__f_hour) && (this.Ljava_time_LocalTime__f_minute === other.Ljava_time_LocalTime__f_minute)) && (this.Ljava_time_LocalTime__f_second === other.Ljava_time_LocalTime__f_second)) && (this.Ljava_time_LocalTime__f_nano === other.Ljava_time_LocalTime__f_nano)))
  } else {
    return false
  }
});
$c_Ljava_time_LocalTime.prototype.hashCode__I = (function() {
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (lo ^ hi);
  return lo$1
});
$c_Ljava_time_LocalTime.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 18);
  var hourValue = this.Ljava_time_LocalTime__f_hour;
  var minuteValue = this.Ljava_time_LocalTime__f_minute;
  var secondValue = this.Ljava_time_LocalTime__f_second;
  var nanoValue = this.Ljava_time_LocalTime__f_nano;
  buf.append__T__scm_StringBuilder(((hourValue < 10) ? "0" : "")).append__I__scm_StringBuilder(hourValue).append__T__scm_StringBuilder(((minuteValue < 10) ? ":0" : ":")).append__I__scm_StringBuilder(minuteValue);
  if (((secondValue > 0) || (nanoValue > 0))) {
    buf.append__T__scm_StringBuilder(((secondValue < 10) ? ":0" : ":")).append__I__scm_StringBuilder(secondValue);
    if ((nanoValue > 0)) {
      buf.append__C__scm_StringBuilder(46);
      if ((((nanoValue % 1000000) | 0) === 0)) {
        var i = ((1000 + ((nanoValue / 1000000) | 0)) | 0);
        var this$2 = ("" + i);
        buf.append__T__scm_StringBuilder($as_T(this$2.substring(1)))
      } else if ((((nanoValue % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((nanoValue / 1000) | 0)) | 0);
        var this$5 = ("" + i$1);
        buf.append__T__scm_StringBuilder($as_T(this$5.substring(1)))
      } else {
        var i$2 = ((1000000000 + nanoValue) | 0);
        var this$8 = ("" + i$2);
        buf.append__T__scm_StringBuilder($as_T(this$8.substring(1)))
      }
    }
  };
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToAdd, unit)
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToSubtract, unit)
});
$c_Ljava_time_LocalTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_LocalTime(that);
  return this.compare__Ljava_time_LocalTime__I(other)
});
function $as_Ljava_time_LocalTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalTime"))
}
function $isArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalTime)))
}
function $asArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalTime;", depth))
}
var $d_Ljava_time_LocalTime = new $TypeData().initClass({
  Ljava_time_LocalTime: 0
}, false, "java.time.LocalTime", {
  Ljava_time_LocalTime: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalTime.prototype.$classData = $d_Ljava_time_LocalTime;
function $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime($thiz, dateTime, offset) {
  if (($thiz.Ljava_time_OffsetDateTime__f_dateTime === dateTime)) {
    var x = $thiz.Ljava_time_OffsetDateTime__f_offset;
    var $$x1 = ((x === null) ? (offset === null) : x.equals__O__Z(offset))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $thiz
  } else {
    return new $c_Ljava_time_OffsetDateTime(dateTime, offset)
  }
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime(dateTime, offset) {
  this.Ljava_time_OffsetDateTime__f_dateTime = null;
  this.Ljava_time_OffsetDateTime__f_offset = null;
  this.Ljava_time_OffsetDateTime__f_dateTime = dateTime;
  this.Ljava_time_OffsetDateTime__f_offset = offset;
  if ((dateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dateTime")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  }
}
$c_Ljava_time_OffsetDateTime.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime.prototype.constructor = $c_Ljava_time_OffsetDateTime;
/** @constructor */
function $h_Ljava_time_OffsetDateTime() {
  /*<skip>*/
}
$h_Ljava_time_OffsetDateTime.prototype = $c_Ljava_time_OffsetDateTime.prototype;
$c_Ljava_time_OffsetDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_OffsetDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? field.Ljava_time_temporal_ChronoField__f__range : this.Ljava_time_OffsetDateTime__f_dateTime.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field))
});
$c_Ljava_time_OffsetDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
        return this$1.Ljava_time_ZoneOffset__f_totalSeconds
      } else {
        return this.Ljava_time_OffsetDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field)
      }
    }
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      return this.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
        var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi)
      } else {
        return this.Ljava_time_OffsetDateTime__f_dateTime.getLong__Ljava_time_temporal_TemporalField__J(field)
      }
    }
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime = (function(offset) {
  var x$2 = this.Ljava_time_OffsetDateTime__f_offset;
  if (((offset === null) ? (x$2 === null) : offset.equals__O__Z(x$2))) {
    return this
  };
  var $$x1 = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
  var difference = (($$x1 - this$1.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
  var this$3 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var hi = (difference >> 31);
  var adjusted = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$3, this$3.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference, hi), $L0, 1);
  return new $c_Ljava_time_OffsetDateTime(adjusted, offset)
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      var $$x2 = $m_Ljava_time_OffsetDateTime$();
      var $$x1 = $m_Ljava_time_Instant$();
      var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
      var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
      var value = this$2.Ljava_time_LocalTime__f_nano;
      var hi = (value >> 31);
      return $$x2.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime($$x1.ofEpochSecond__J__J__Ljava_time_Instant(newValue, new $c_RTLong(value, hi)), this.Ljava_time_OffsetDateTime__f_offset)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime, $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(f.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, f)))
      } else {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue), this.Ljava_time_OffsetDateTime__f_offset)
      }
    }
  } else {
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(field, newValue)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToAdd, unit) {
  return ((unit instanceof $c_Ljava_time_temporal_ChronoUnit) ? $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit), this.Ljava_time_OffsetDateTime__f_offset) : this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToAdd, unit))
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  };
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit()
  };
  matchAlts3: {
    matchAlts4: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts4
      };
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts4
      };
      break matchAlts3
    };
    return this.Ljava_time_OffsetDateTime__f_offset
  };
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === query)) {
    var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
    return this$1.Ljava_time_LocalDateTime__f_date
  };
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === query)) {
    var this$2 = this.Ljava_time_OffsetDateTime__f_dateTime;
    return this$2.Ljava_time_LocalDateTime__f_time
  };
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === query)) {
    return null
  };
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)
});
$c_Ljava_time_OffsetDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x5 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var $$x4 = temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x5, this$1.Ljava_time_LocalDateTime__f_date.toEpochDay__J());
  var $$x3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$2 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var $$x2 = $$x4.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x3, this$2.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J());
  var $$x1 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var this$3 = this.Ljava_time_OffsetDateTime__f_offset;
  var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return $$x2.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_OffsetDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_OffsetDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = end.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this.Ljava_time_OffsetDateTime__f_offset);
    return this.Ljava_time_OffsetDateTime__f_dateTime.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end.Ljava_time_OffsetDateTime__f_dateTime, unit)
  } else {
    var temporal2 = end;
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, unit)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.compare__Ljava_time_OffsetDateTime__I = (function(other) {
  var x = this.Ljava_time_OffsetDateTime__f_offset;
  var x$2 = other.Ljava_time_OffsetDateTime__f_offset;
  if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
    return this.Ljava_time_OffsetDateTime__f_dateTime.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(other.Ljava_time_OffsetDateTime__f_dateTime)
  };
  var t = this.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(other.Ljava_time_OffsetDateTime__f_offset);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
    var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
    var $$x1 = this$2.Ljava_time_LocalTime__f_nano;
    var this$3 = other.Ljava_time_OffsetDateTime__f_dateTime;
    var this$4 = this$3.Ljava_time_LocalDateTime__f_time;
    cmp = (($$x1 - this$4.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      cmp = this.Ljava_time_OffsetDateTime__f_dateTime.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(other.Ljava_time_OffsetDateTime__f_dateTime)
    }
  };
  return cmp
});
$c_Ljava_time_OffsetDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_OffsetDateTime)) {
    var other = $as_Ljava_time_OffsetDateTime(obj);
    if ((this === other)) {
      return true
    } else {
      var x = this.Ljava_time_OffsetDateTime__f_dateTime;
      var x$2 = other.Ljava_time_OffsetDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_OffsetDateTime__f_offset;
        var x$4 = other.Ljava_time_OffsetDateTime__f_offset;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_OffsetDateTime.prototype.hashCode__I = (function() {
  var $$x1 = this.Ljava_time_OffsetDateTime__f_dateTime.hashCode__I();
  var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
  return ($$x1 ^ this$1.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_OffsetDateTime.prototype.toString__T = (function() {
  return (("" + this.Ljava_time_OffsetDateTime__f_dateTime.toString__T()) + this.Ljava_time_OffsetDateTime__f_offset.Ljava_time_ZoneOffset__f_id)
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(field, newValue)
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToAdd, unit)
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToSubtract, unit)
});
$c_Ljava_time_OffsetDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_OffsetDateTime(that);
  return this.compare__Ljava_time_OffsetDateTime__I(other)
});
function $as_Ljava_time_OffsetDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_OffsetDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.OffsetDateTime"))
}
function $isArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_OffsetDateTime)))
}
function $asArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_OffsetDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.OffsetDateTime;", depth))
}
var $d_Ljava_time_OffsetDateTime = new $TypeData().initClass({
  Ljava_time_OffsetDateTime: 0
}, false, "java.time.OffsetDateTime", {
  Ljava_time_OffsetDateTime: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_OffsetDateTime.prototype.$classData = $d_Ljava_time_OffsetDateTime;
/** @constructor */
function $c_Ljava_time_ZoneOffset(totalSeconds) {
  this.Ljava_time_ZoneOffset__f_totalSeconds = 0;
  this.Ljava_time_ZoneOffset__f_id = null;
  this.Ljava_time_ZoneOffset__f_totalSeconds = totalSeconds;
  $ct_Ljava_time_ZoneId__(this);
  this.Ljava_time_ZoneOffset__f_id = $m_Ljava_time_ZoneOffset$().java$time$ZoneOffset$$$buildId__I__T(totalSeconds)
}
$c_Ljava_time_ZoneOffset.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneOffset.prototype.constructor = $c_Ljava_time_ZoneOffset;
/** @constructor */
function $h_Ljava_time_ZoneOffset() {
  /*<skip>*/
}
$h_Ljava_time_ZoneOffset.prototype = $c_Ljava_time_ZoneOffset.prototype;
$c_Ljava_time_ZoneOffset.prototype.getId__T = (function() {
  return this.Ljava_time_ZoneOffset__f_id
});
$c_Ljava_time_ZoneOffset.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this)
});
$c_Ljava_time_ZoneOffset.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_ZoneOffset.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return field.Ljava_time_temporal_ChronoField__f__range
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
});
$c_Ljava_time_ZoneOffset.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return this.Ljava_time_ZoneOffset__f_totalSeconds
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field)
  }
});
$c_Ljava_time_ZoneOffset.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unsupported field: " + field))
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_ZoneOffset.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return (((query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_ZoneOffset.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x1 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_ZoneOffset.prototype.compare__Ljava_time_ZoneOffset__I = (function(other) {
  return ((other.Ljava_time_ZoneOffset__f_totalSeconds - this.Ljava_time_ZoneOffset__f_totalSeconds) | 0)
});
$c_Ljava_time_ZoneOffset.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZoneOffset)) {
    var that = $as_Ljava_time_ZoneOffset(obj);
    return ((this === that) || (this.Ljava_time_ZoneOffset__f_totalSeconds === that.Ljava_time_ZoneOffset__f_totalSeconds))
  } else {
    return false
  }
});
$c_Ljava_time_ZoneOffset.prototype.hashCode__I = (function() {
  return this.Ljava_time_ZoneOffset__f_totalSeconds
});
$c_Ljava_time_ZoneOffset.prototype.toString__T = (function() {
  return this.Ljava_time_ZoneOffset__f_id
});
$c_Ljava_time_ZoneOffset.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_ZoneOffset(that);
  return this.compare__Ljava_time_ZoneOffset__I(other)
});
function $as_Ljava_time_ZoneOffset(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneOffset"))
}
function $isArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneOffset)))
}
function $asArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneOffset;", depth))
}
var $d_Ljava_time_ZoneOffset = new $TypeData().initClass({
  Ljava_time_ZoneOffset: 0
}, false, "java.time.ZoneOffset", {
  Ljava_time_ZoneOffset: 1,
  Ljava_time_ZoneId: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1
});
$c_Ljava_time_ZoneOffset.prototype.$classData = $d_Ljava_time_ZoneOffset;
function $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime($thiz, offset) {
  var x$2 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  if (((!((offset === null) ? (x$2 === null) : offset.equals__O__Z(x$2))) && $thiz.Ljava_time_ZonedDateTime__f_zone.getRules__Ljava_time_zone_ZoneRules().isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset))) {
    return new $c_Ljava_time_ZonedDateTime($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset, $thiz.Ljava_time_ZonedDateTime__f_zone)
  } else {
    return $thiz
  }
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime(dateTime, offset, zone) {
  this.Ljava_time_ZonedDateTime__f_dateTime = null;
  this.Ljava_time_ZonedDateTime__f_offset = null;
  this.Ljava_time_ZonedDateTime__f_zone = null;
  this.Ljava_time_ZonedDateTime__f_dateTime = dateTime;
  this.Ljava_time_ZonedDateTime__f_offset = offset;
  this.Ljava_time_ZonedDateTime__f_zone = zone
}
$c_Ljava_time_ZonedDateTime.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime.prototype.constructor = $c_Ljava_time_ZonedDateTime;
/** @constructor */
function $h_Ljava_time_ZonedDateTime() {
  /*<skip>*/
}
$h_Ljava_time_ZonedDateTime.prototype = $c_Ljava_time_ZonedDateTime.prototype;
$c_Ljava_time_ZonedDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_ZonedDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? field.Ljava_time_temporal_ChronoField__f__range : this.Ljava_time_ZonedDateTime__f_dateTime.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field))
});
$c_Ljava_time_ZonedDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
        return this$1.Ljava_time_ZoneOffset__f_totalSeconds
      } else {
        return this.Ljava_time_ZonedDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field)
      }
    }
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      return $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
        var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi)
      } else {
        return this.Ljava_time_ZonedDateTime__f_dateTime.getLong__Ljava_time_temporal_TemporalField__J(field)
      }
    }
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var x = this.Ljava_time_ZonedDateTime__f_zone;
  if (((x === null) ? (zone === null) : x.equals__O__Z(zone))) {
    return this
  } else {
    var $$x2 = $m_Ljava_time_ZonedDateTime$();
    var $$x1 = this.Ljava_time_ZonedDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_ZonedDateTime__f_offset);
    var this$2 = this.Ljava_time_ZonedDateTime__f_dateTime;
    var this$3 = this$2.Ljava_time_LocalDateTime__f_time;
    return $$x2.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x1, this$3.Ljava_time_LocalTime__f_nano, zone)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      var $$x1 = $m_Ljava_time_ZonedDateTime$();
      var this$1 = this.Ljava_time_ZonedDateTime__f_dateTime;
      var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
      return $$x1.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newValue, this$2.Ljava_time_LocalTime__f_nano, this.Ljava_time_ZonedDateTime__f_zone)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(f.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, f)))
      } else {
        var newDateTime = this.Ljava_time_ZonedDateTime__f_dateTime.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue);
        return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
      }
    }
  } else {
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(field, newValue)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    if (unit.isDateBased__Z()) {
      var newDateTime = this.Ljava_time_ZonedDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
    } else {
      var newDateTime$1 = this.Ljava_time_ZonedDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newDateTime$1, this.Ljava_time_ZonedDateTime__f_offset, this.Ljava_time_ZonedDateTime__f_zone)
    }
  } else {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToAdd, unit)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  if ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery())) {
    var this$1 = this.Ljava_time_ZonedDateTime__f_dateTime;
    return this$1.Ljava_time_LocalDateTime__f_date
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O(this, query)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_ZonedDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = end.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(this.Ljava_time_ZonedDateTime__f_zone);
    if (unit.isDateBased__Z()) {
      return this.Ljava_time_ZonedDateTime__f_dateTime.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end.Ljava_time_ZonedDateTime__f_dateTime, unit)
    } else {
      var dateTime = this.Ljava_time_ZonedDateTime__f_dateTime;
      var offset = this.Ljava_time_ZonedDateTime__f_offset;
      var $$x1 = new $c_Ljava_time_OffsetDateTime(dateTime, offset);
      var this$2 = end;
      var dateTime$1 = this$2.Ljava_time_ZonedDateTime__f_dateTime;
      var offset$1 = this$2.Ljava_time_ZonedDateTime__f_offset;
      return $$x1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(new $c_Ljava_time_OffsetDateTime(dateTime$1, offset$1), unit)
    }
  } else {
    var temporal2 = end;
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, unit)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZonedDateTime)) {
    var other = $as_Ljava_time_ZonedDateTime(obj);
    if ((this === other)) {
      return true
    } else {
      var x = this.Ljava_time_ZonedDateTime__f_dateTime;
      var x$2 = other.Ljava_time_ZonedDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_ZonedDateTime__f_offset;
        var x$4 = other.Ljava_time_ZonedDateTime__f_offset;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Ljava_time_ZonedDateTime__f_zone;
        var x$6 = other.Ljava_time_ZonedDateTime__f_zone;
        return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_ZonedDateTime.prototype.hashCode__I = (function() {
  var $$x2 = this.Ljava_time_ZonedDateTime__f_dateTime.hashCode__I();
  var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var i = this.Ljava_time_ZonedDateTime__f_zone.hashCode__I();
  return (($$x2 ^ $$x1) ^ ((i << 3) | ((i >>> 29) | 0)))
});
$c_Ljava_time_ZonedDateTime.prototype.toString__T = (function() {
  var str = (("" + this.Ljava_time_ZonedDateTime__f_dateTime.toString__T()) + this.Ljava_time_ZonedDateTime__f_offset.Ljava_time_ZoneOffset__f_id);
  if ((this.Ljava_time_ZonedDateTime__f_offset !== this.Ljava_time_ZonedDateTime__f_zone)) {
    str = ((str + ("[" + this.Ljava_time_ZonedDateTime__f_zone)) + "]")
  };
  return str
});
$c_Ljava_time_ZonedDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_ChronoZonedDateTime(that);
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, other)
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(field, newValue)
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToAdd, unit)
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToSubtract, unit)
});
function $as_Ljava_time_ZonedDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_ZonedDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZonedDateTime"))
}
function $isArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZonedDateTime)))
}
function $asArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_ZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZonedDateTime;", depth))
}
var $d_Ljava_time_ZonedDateTime = new $TypeData().initClass({
  Ljava_time_ZonedDateTime: 0
}, false, "java.time.ZonedDateTime", {
  Ljava_time_ZonedDateTime: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoZonedDateTime: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZonedDateTime.prototype.$classData = $d_Ljava_time_ZonedDateTime;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_Ljava_time_format_ResolverStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_ResolverStyle.prototype.constructor = $c_Ljava_time_format_ResolverStyle;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle.prototype = $c_Ljava_time_format_ResolverStyle.prototype;
$c_Ljava_time_format_ResolverStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Ljava_time_format_ResolverStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_ResolverStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.ResolverStyle"))
}
function $isArrayOf_Ljava_time_format_ResolverStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_ResolverStyle)))
}
function $asArrayOf_Ljava_time_format_ResolverStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_ResolverStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.ResolverStyle;", depth))
}
var $d_Ljava_time_format_ResolverStyle = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle: 0
}, false, "java.time.format.ResolverStyle", {
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_format_ResolverStyle.prototype.$classData = $d_Ljava_time_format_ResolverStyle;
function $ct_Ljava_time_format_SignStyle__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_SignStyle__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_SignStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0
}
$c_Ljava_time_format_SignStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_SignStyle.prototype.constructor = $c_Ljava_time_format_SignStyle;
/** @constructor */
function $h_Ljava_time_format_SignStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle.prototype = $c_Ljava_time_format_SignStyle.prototype;
$c_Ljava_time_format_SignStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_format_SignStyle.prototype.parse__Z__Z__Z__Z = (function(positive, strict, fixedWidth) {
  var x1 = this.Ljava_time_format_SignStyle__f_ordinal;
  switch (x1) {
    case 0: {
      return ((!positive) || (!strict));
      break
    }
    case 1:
    case 4: {
      return true;
      break
    }
    default: {
      return ((!strict) && (!fixedWidth))
    }
  }
});
function $as_Ljava_time_format_SignStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_SignStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.SignStyle"))
}
function $isArrayOf_Ljava_time_format_SignStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_SignStyle)))
}
function $asArrayOf_Ljava_time_format_SignStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_SignStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.SignStyle;", depth))
}
var $d_Ljava_time_format_SignStyle = new $TypeData().initClass({
  Ljava_time_format_SignStyle: 0
}, false, "java.time.format.SignStyle", {
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_format_SignStyle.prototype.$classData = $d_Ljava_time_format_SignStyle;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype = new $h_jl_Enum();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.createDateTime__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(dateTime, standardOffset, wallOffset) {
  var x = $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
  if (((x !== null) && (x === this))) {
    var $$x1 = wallOffset.Ljava_time_ZoneOffset__f_totalSeconds;
    var this$1 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    var difference = (($$x1 - this$1.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
    var hi = (difference >> 31);
    return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(dateTime, dateTime.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference, hi), $L0, 1)
  } else {
    var x$3 = $s_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
    if (((x$3 !== null) && (x$3 === this))) {
      var difference$2 = ((wallOffset.Ljava_time_ZoneOffset__f_totalSeconds - standardOffset.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
      var hi$1 = (difference$2 >> 31);
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(dateTime, dateTime.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference$2, hi$1), $L0, 1)
    } else {
      return dateTime
    }
  }
});
function $as_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneOffsetTransitionRule$TimeDefinition"))
}
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition)))
}
function $asArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneOffsetTransitionRule$TimeDefinition;", depth))
}
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$TimeDefinition", {
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition;
/** @constructor */
function $c_ju_Arrays$$anon$2(a$1) {
  this.ju_Arrays$$anon$2__f_a$1 = null;
  this.ju_Arrays$$anon$2__f_a$1 = a$1
}
$c_ju_Arrays$$anon$2.prototype = new $h_ju_AbstractList();
$c_ju_Arrays$$anon$2.prototype.constructor = $c_ju_Arrays$$anon$2;
/** @constructor */
function $h_ju_Arrays$$anon$2() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$2.prototype = $c_ju_Arrays$$anon$2.prototype;
$c_ju_Arrays$$anon$2.prototype.size__I = (function() {
  return this.ju_Arrays$$anon$2__f_a$1.u.length
});
$c_ju_Arrays$$anon$2.prototype.get__I__O = (function(index) {
  return this.ju_Arrays$$anon$2__f_a$1.get(index)
});
$c_ju_Arrays$$anon$2.prototype.set__I__O__O = (function(index, element) {
  var ret = this.ju_Arrays$$anon$2__f_a$1.get(index);
  this.ju_Arrays$$anon$2__f_a$1.set(index, element);
  return ret
});
var $d_ju_Arrays$$anon$2 = new $TypeData().initClass({
  ju_Arrays$$anon$2: 0
}, false, "java.util.Arrays$$anon$2", {
  ju_Arrays$$anon$2: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1
});
$c_ju_Arrays$$anon$2.prototype.$classData = $d_ju_Arrays$$anon$2;
/** @constructor */
function $c_ju_Collections$$anon$15(o$2) {
  this.ju_Collections$$anon$15__f_o$2 = null;
  this.ju_Collections$$anon$15__f_o$2 = o$2
}
$c_ju_Collections$$anon$15.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$15.prototype.constructor = $c_ju_Collections$$anon$15;
/** @constructor */
function $h_ju_Collections$$anon$15() {
  /*<skip>*/
}
$h_ju_Collections$$anon$15.prototype = $c_ju_Collections$$anon$15.prototype;
$c_ju_Collections$$anon$15.prototype.size__I = (function() {
  return 1
});
$c_ju_Collections$$anon$15.prototype.get__I__O = (function(index) {
  if ((index === 0)) {
    return this.ju_Collections$$anon$15__f_o$2
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
var $d_ju_Collections$$anon$15 = new $TypeData().initClass({
  ju_Collections$$anon$15: 0
}, false, "java.util.Collections$$anon$15", {
  ju_Collections$$anon$15: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Collections$$anon$15.prototype.$classData = $d_ju_Collections$$anon$15;
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_DuplicateFormatFlagsException__f_f = null;
    this.ju_DuplicateFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'")
  };
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass({
  ju_DuplicateFormatFlagsException: 0
}, false, "java.util.DuplicateFormatFlagsException", {
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_DuplicateFormatFlagsException.prototype.$classData = $d_ju_DuplicateFormatFlagsException;
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.ju_FormatFlagsConversionMismatchException__f_f = null;
    this.ju_FormatFlagsConversionMismatchException__f_c = 0;
    this.ju_FormatFlagsConversionMismatchException__f_f = f;
    this.ju_FormatFlagsConversionMismatchException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return ((("Conversion = " + $bC(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f)
  };
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass({
  ju_FormatFlagsConversionMismatchException: 0
}, false, "java.util.FormatFlagsConversionMismatchException", {
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatFlagsConversionMismatchException.prototype.$classData = $d_ju_FormatFlagsConversionMismatchException;
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ju_IllegalFormatArgumentIndexException__f_msg = null;
    this.ju_IllegalFormatArgumentIndexException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return this.ju_IllegalFormatArgumentIndexException__f_msg
  };
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().initClass({
  ju_IllegalFormatArgumentIndexException: 0
}, false, "java.util.IllegalFormatArgumentIndexException", {
  ju_IllegalFormatArgumentIndexException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatArgumentIndexException.prototype.$classData = $d_ju_IllegalFormatArgumentIndexException;
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.ju_IllegalFormatCodePointException__f_c = 0;
    this.ju_IllegalFormatCodePointException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatCodePointException__f_c;
    return ("Code point = 0x" + $as_T($uD((i >>> 0)).toString(16)))
  };
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass({
  ju_IllegalFormatCodePointException: 0
}, false, "java.util.IllegalFormatCodePointException", {
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatCodePointException.prototype.$classData = $d_ju_IllegalFormatCodePointException;
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.ju_IllegalFormatConversionException__f_c = 0;
    this.ju_IllegalFormatConversionException__f_arg = null;
    this.ju_IllegalFormatConversionException__f_c = c;
    this.ju_IllegalFormatConversionException__f_arg = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((arg === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    var this$1 = this.ju_IllegalFormatConversionException__f_c;
    return (($as_T(String.fromCharCode(this$1)) + " != ") + this.ju_IllegalFormatConversionException__f_arg.getName__T())
  };
}
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass({
  ju_IllegalFormatConversionException: 0
}, false, "java.util.IllegalFormatConversionException", {
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatConversionException.prototype.$classData = $d_ju_IllegalFormatConversionException;
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_IllegalFormatFlagsException__f_f = null;
    this.ju_IllegalFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'")
  };
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass({
  ju_IllegalFormatFlagsException: 0
}, false, "java.util.IllegalFormatFlagsException", {
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatFlagsException.prototype.$classData = $d_ju_IllegalFormatFlagsException;
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.ju_IllegalFormatPrecisionException__f_p = 0;
    this.ju_IllegalFormatPrecisionException__f_p = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatPrecisionException__f_p;
    return ("" + i)
  };
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass({
  ju_IllegalFormatPrecisionException: 0
}, false, "java.util.IllegalFormatPrecisionException", {
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatPrecisionException.prototype.$classData = $d_ju_IllegalFormatPrecisionException;
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.ju_IllegalFormatWidthException__f_w = 0;
    this.ju_IllegalFormatWidthException__f_w = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatWidthException__f_w;
    return ("" + i)
  };
}
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass({
  ju_IllegalFormatWidthException: 0
}, false, "java.util.IllegalFormatWidthException", {
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatWidthException.prototype.$classData = $d_ju_IllegalFormatWidthException;
/** @constructor */
function $c_ju_Locale$Category() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_ju_Locale$Category.prototype = new $h_jl_Enum();
$c_ju_Locale$Category.prototype.constructor = $c_ju_Locale$Category;
/** @constructor */
function $h_ju_Locale$Category() {
  /*<skip>*/
}
$h_ju_Locale$Category.prototype = $c_ju_Locale$Category.prototype;
$c_ju_Locale$Category.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_ju_Locale$Category(obj) {
  return (((obj instanceof $c_ju_Locale$Category) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$Category"))
}
function $isArrayOf_ju_Locale$Category(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$Category)))
}
function $asArrayOf_ju_Locale$Category(obj, depth) {
  return (($isArrayOf_ju_Locale$Category(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$Category;", depth))
}
var $d_ju_Locale$Category = new $TypeData().initClass({
  ju_Locale$Category: 0
}, false, "java.util.Locale$Category", {
  ju_Locale$Category: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_ju_Locale$Category.prototype.$classData = $d_ju_Locale$Category;
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatArgumentException__f_s = null;
    this.ju_MissingFormatArgumentException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'")
  };
}
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass({
  ju_MissingFormatArgumentException: 0
}, false, "java.util.MissingFormatArgumentException", {
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatArgumentException.prototype.$classData = $d_ju_MissingFormatArgumentException;
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatWidthException__f_s = null;
    this.ju_MissingFormatWidthException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return this.ju_MissingFormatWidthException__f_s
  };
}
var $d_ju_MissingFormatWidthException = new $TypeData().initClass({
  ju_MissingFormatWidthException: 0
}, false, "java.util.MissingFormatWidthException", {
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatWidthException.prototype.$classData = $d_ju_MissingFormatWidthException;
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_UnknownFormatConversionException__f_s = null;
    this.ju_UnknownFormatConversionException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'")
  };
}
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass({
  ju_UnknownFormatConversionException: 0
}, false, "java.util.UnknownFormatConversionException", {
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UnknownFormatConversionException.prototype.$classData = $d_ju_UnknownFormatConversionException;
function $ct_ju_concurrent_CopyOnWriteArrayList__sjs_js_Array__($thiz, inner) {
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_inner = inner;
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  return $thiz
}
function $ct_ju_concurrent_CopyOnWriteArrayList__($thiz) {
  $ct_ju_concurrent_CopyOnWriteArrayList__sjs_js_Array__($thiz, []);
  return $thiz
}
function $ct_ju_concurrent_CopyOnWriteArrayList__AO__($thiz, toCopyIn) {
  $ct_ju_concurrent_CopyOnWriteArrayList__($thiz);
  var end = toCopyIn.u.length;
  var i = 0;
  while ((i < end)) {
    var arg1 = i;
    $thiz.add__O__Z(toCopyIn.get(arg1));
    i = ((1 + i) | 0)
  };
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayList() {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner = null;
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false
}
$c_ju_concurrent_CopyOnWriteArrayList.prototype = new $h_O();
$c_ju_concurrent_CopyOnWriteArrayList.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayList() {
  /*<skip>*/
}
$h_ju_concurrent_CopyOnWriteArrayList.prototype = $c_ju_concurrent_CopyOnWriteArrayList.prototype;
$c_ju_concurrent_CopyOnWriteArrayList.prototype.size__I = (function() {
  var array = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return $uI(array.length)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = _\uff3fself.next__O();
    if (((o === null) ? (arg1 === null) : $dp_equals__O__Z(o, arg1))) {
      return true
    }
  };
  return false
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO = (function() {
  return $asArrayOf_O(this.toArray__O__O(new $ac_O(this.size__I())), 1)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__O__O = (function(a) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  if (($m_sr_ScalaRunTime$().array_length__O__I(a) >= this.size__I())) {
    var toFill = a
  } else {
    var length = this.size__I();
    var toFill = $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length)
  };
  var iter = this.listIterator__I__ju_ListIterator(0);
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var arg1 = i;
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(toFill, arg1, iter.next__O());
    i = ((1 + i) | 0)
  };
  if (($m_sr_ScalaRunTime$().array_length__O__I(toFill) > this.size__I())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(toFill, this.size__I(), null)
  };
  return toFill
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.innerGet__I__O(index)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.set__I__O__O = (function(index, element) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var oldValue = this.innerGet__I__O(index);
  this.innerSet__I__O__V(index, element);
  return oldValue
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.add__O__Z = (function(e) {
  this.copyIfNeeded__V();
  this.innerPush__O__V(e);
  return true
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  return this.innerRemove__I__O(index)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var arg1 = _\uff3fself.next__O();
      if ((!this.contains__O__Z(arg1))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toString__T = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + _\uff3fself.next__O())
  };
  return (result + "]")
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.equals__O__Z = (function(obj) {
  if ((obj === this)) {
    return true
  } else if ($is_ju_List(obj)) {
    var x2 = $as_ju_List(obj);
    var oIter = x2.listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while (_\uff3fself.hasNext__Z()) {
        var arg1 = _\uff3fself.next__O();
        if (oIter.hasNext__Z()) {
          var b = oIter.next__O();
          var $$x2 = ((arg1 === null) ? (b === null) : $dp_equals__O__Z(arg1, b))
        } else {
          var $$x2 = false
        };
        if ((!$$x2)) {
          var $$x1 = true;
          break _return
        }
      };
      var $$x1 = false
    };
    if ((!$$x1)) {
      return (!oIter.hasNext__Z())
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = ((Math.imul(31, prev) + ((arg2 === null) ? 0 : $dp_hashCode__I(arg2))) | 0)
  };
  return $uI(result)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_concurrent_CopyOnWriteArrayListIterator(this.innerSnapshot__sjs_js_Array(), index, 0, this.size__I())
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerGet__I__O = (function(index) {
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner[index]
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSet__I__O__V = (function(index, elem) {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner[index] = elem
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerPush__O__V = (function(elem) {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner.push(elem)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerRemove__I__O = (function(index) {
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner.splice(index, 1)[0]
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.copyIfNeeded__V = (function() {
  if (this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite) {
    var qual$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    this.ju_concurrent_CopyOnWriteArrayList__f_inner = qual$1.slice();
    this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSnapshot__sjs_js_Array = (function() {
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = true;
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO__AO = (function(a) {
  return $asArrayOf_O(this.toArray__O__O(a), 1)
});
var $d_ju_concurrent_CopyOnWriteArrayList = new $TypeData().initClass({
  ju_concurrent_CopyOnWriteArrayList: 0
}, false, "java.util.concurrent.CopyOnWriteArrayList", {
  ju_concurrent_CopyOnWriteArrayList: 1,
  O: 1,
  ju_List: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.$classData = $d_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $c_Lnet_timerboard_Alliance$$anon$13() {
  this.Lnet_timerboard_Alliance$$anon$13__f_elemLabels = null;
  this.Lnet_timerboard_Alliance$$anon$13__f_elemEncoders$lzy4 = null;
  this.Lnet_timerboard_Alliance$$anon$13__f_elemEncodersbitmap$4 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("name", this$1);
  var this$3 = new $c_sci_$colon$colon("ticker", this$2);
  var this$5 = new $c_sci_$colon$colon("id", this$3);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Alliance$$anon$13__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Alliance$$anon$13.prototype = new $h_O();
$c_Lnet_timerboard_Alliance$$anon$13.prototype.constructor = $c_Lnet_timerboard_Alliance$$anon$13;
/** @constructor */
function $h_Lnet_timerboard_Alliance$$anon$13() {
  /*<skip>*/
}
$h_Lnet_timerboard_Alliance$$anon$13.prototype = $c_Lnet_timerboard_Alliance$$anon$13.prototype;
$c_Lnet_timerboard_Alliance$$anon$13.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Alliance$$anon$13__f_elemLabels
});
$c_Lnet_timerboard_Alliance$$anon$13.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lnet_timerboard_Alliance$$anon$13.prototype.elemEncoders__ALio_circe_Encoder = (function() {
  if ((!this.Lnet_timerboard_Alliance$$anon$13__f_elemEncodersbitmap$4)) {
    var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var encodeA$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(encodeA$3, this$1);
    var this$3 = new $c_sci_$colon$colon(encodeA$2, this$2);
    var this$5 = new $c_sci_$colon$colon(encodeA, this$3);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Alliance$$anon$13__f_elemEncoders$lzy4 = new ($d_Lio_circe_Encoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Alliance$$anon$13__f_elemEncodersbitmap$4 = true
  };
  return this.Lnet_timerboard_Alliance$$anon$13__f_elemEncoders$lzy4
});
$c_Lnet_timerboard_Alliance$$anon$13.prototype.encodeObject__Lnet_timerboard_Alliance__Lio_circe_JsonObject = (function(a) {
  return $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(new $c_Lio_circe_DerivedEncoder$$anon$1(a, this))
});
$c_Lnet_timerboard_Alliance$$anon$13.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lnet_timerboard_Alliance__Lio_circe_JsonObject($as_Lnet_timerboard_Alliance(a))
});
var $d_Lnet_timerboard_Alliance$$anon$13 = new $TypeData().initClass({
  Lnet_timerboard_Alliance$$anon$13: 0
}, false, "net.timerboard.Alliance$$anon$13", {
  Lnet_timerboard_Alliance$$anon$13: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_DerivedEncoder: 1
});
$c_Lnet_timerboard_Alliance$$anon$13.prototype.$classData = $d_Lnet_timerboard_Alliance$$anon$13;
/** @constructor */
function $c_Lnet_timerboard_Event$$anon$15() {
  this.Lnet_timerboard_Event$$anon$15__f_elemLabels = null;
  this.Lnet_timerboard_Event$$anon$15__f_elemEncoders$lzy5 = null;
  this.Lnet_timerboard_Event$$anon$15__f_elemEncodersbitmap$5 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("alliance", this$1);
  var this$3 = new $c_sci_$colon$colon("event", this$2);
  var this$5 = new $c_sci_$colon$colon("solar_system_name", this$3);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Event$$anon$15__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Event$$anon$15.prototype = new $h_O();
$c_Lnet_timerboard_Event$$anon$15.prototype.constructor = $c_Lnet_timerboard_Event$$anon$15;
/** @constructor */
function $h_Lnet_timerboard_Event$$anon$15() {
  /*<skip>*/
}
$h_Lnet_timerboard_Event$$anon$15.prototype = $c_Lnet_timerboard_Event$$anon$15.prototype;
$c_Lnet_timerboard_Event$$anon$15.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Event$$anon$15__f_elemLabels
});
$c_Lnet_timerboard_Event$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lnet_timerboard_Event$$anon$15.prototype.elemEncoders__ALio_circe_Encoder = (function() {
  if ((!this.Lnet_timerboard_Event$$anon$15__f_elemEncodersbitmap$5)) {
    var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var encodeA$2 = $m_Lnet_timerboard_InnerEvent$().derived$AsObject__Lio_circe_Encoder$AsObject();
    var encodeA$3 = $m_Lnet_timerboard_Alliance$().derived$AsObject__Lio_circe_Encoder$AsObject();
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(encodeA$3, this$1);
    var this$3 = new $c_sci_$colon$colon(encodeA$2, this$2);
    var this$5 = new $c_sci_$colon$colon(encodeA, this$3);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Event$$anon$15__f_elemEncoders$lzy5 = new ($d_Lio_circe_Encoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Event$$anon$15__f_elemEncodersbitmap$5 = true
  };
  return this.Lnet_timerboard_Event$$anon$15__f_elemEncoders$lzy5
});
$c_Lnet_timerboard_Event$$anon$15.prototype.encodeObject__Lnet_timerboard_Event__Lio_circe_JsonObject = (function(a) {
  return $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(new $c_Lio_circe_DerivedEncoder$$anon$1(a, this))
});
$c_Lnet_timerboard_Event$$anon$15.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lnet_timerboard_Event__Lio_circe_JsonObject($as_Lnet_timerboard_Event(a))
});
var $d_Lnet_timerboard_Event$$anon$15 = new $TypeData().initClass({
  Lnet_timerboard_Event$$anon$15: 0
}, false, "net.timerboard.Event$$anon$15", {
  Lnet_timerboard_Event$$anon$15: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_DerivedEncoder: 1
});
$c_Lnet_timerboard_Event$$anon$15.prototype.$classData = $d_Lnet_timerboard_Event$$anon$15;
/** @constructor */
function $c_Lnet_timerboard_InnerEvent$$anon$11() {
  this.Lnet_timerboard_InnerEvent$$anon$11__f_elemLabels = null;
  this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncoders$lzy3 = null;
  this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncodersbitmap$3 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("structure_id", this$1);
  var this$3 = new $c_sci_$colon$colon("start_time", this$2);
  var this$4 = new $c_sci_$colon$colon("solar_system_id", this$3);
  var this$5 = new $c_sci_$colon$colon("participants", this$4);
  var this$6 = new $c_sci_$colon$colon("event_type", this$5);
  var this$7 = new $c_sci_$colon$colon("defender_score", this$6);
  var this$8 = new $c_sci_$colon$colon("defender_id", this$7);
  var this$9 = new $c_sci_$colon$colon("constellation_id", this$8);
  var this$10 = new $c_sci_$colon$colon("campaign_id", this$9);
  var this$12 = new $c_sci_$colon$colon("attackers_score", this$10);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$12);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_InnerEvent$$anon$11__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype = new $h_O();
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.constructor = $c_Lnet_timerboard_InnerEvent$$anon$11;
/** @constructor */
function $h_Lnet_timerboard_InnerEvent$$anon$11() {
  /*<skip>*/
}
$h_Lnet_timerboard_InnerEvent$$anon$11.prototype = $c_Lnet_timerboard_InnerEvent$$anon$11.prototype;
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_InnerEvent$$anon$11__f_elemLabels
});
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.elemEncoders__ALio_circe_Encoder = (function() {
  if ((!this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncodersbitmap$3)) {
    var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBigDecimal;
    var encodeA$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$4 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$5 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBigDecimal;
    var encodeA$6 = $m_Lnet_timerboard_EventType$().derived$EnumCodec__Lnet_timerboard_CirceEnumHelpers$EnumCodec();
    $m_Lio_circe_Encoder$();
    $m_Lio_circe_Encoder$();
    var encodeA$1 = $m_Lnet_timerboard_Participant$().derived$AsObject__Lio_circe_Encoder$AsObject();
    var e = new $c_Lio_circe_Encoder$$anon$26(encodeA$1);
    var encodeA$7 = new $c_Lio_circe_Encoder$$anon$23(e);
    var encodeA$8 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$9 = $m_Lio_circe_Encoder$().encodeZonedDateTime__Lio_circe_Encoder();
    var encodeA$10 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var this$3 = $m_s_package$().s_package$__f_Nil;
    var this$4 = new $c_sci_$colon$colon(encodeA$10, this$3);
    var this$5 = new $c_sci_$colon$colon(encodeA$9, this$4);
    var this$6 = new $c_sci_$colon$colon(encodeA$8, this$5);
    var this$7 = new $c_sci_$colon$colon(encodeA$7, this$6);
    var this$8 = new $c_sci_$colon$colon(encodeA$6, this$7);
    var this$9 = new $c_sci_$colon$colon(encodeA$5, this$8);
    var this$10 = new $c_sci_$colon$colon(encodeA$4, this$9);
    var this$11 = new $c_sci_$colon$colon(encodeA$3, this$10);
    var this$12 = new $c_sci_$colon$colon(encodeA$2, this$11);
    var this$14 = new $c_sci_$colon$colon(encodeA, this$12);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$14);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncoders$lzy3 = new ($d_Lio_circe_Encoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncodersbitmap$3 = true
  };
  return this.Lnet_timerboard_InnerEvent$$anon$11__f_elemEncoders$lzy3
});
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.encodeObject__Lnet_timerboard_InnerEvent__Lio_circe_JsonObject = (function(a) {
  return $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(new $c_Lio_circe_DerivedEncoder$$anon$1(a, this))
});
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lnet_timerboard_InnerEvent__Lio_circe_JsonObject($as_Lnet_timerboard_InnerEvent(a))
});
var $d_Lnet_timerboard_InnerEvent$$anon$11 = new $TypeData().initClass({
  Lnet_timerboard_InnerEvent$$anon$11: 0
}, false, "net.timerboard.InnerEvent$$anon$11", {
  Lnet_timerboard_InnerEvent$$anon$11: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_DerivedEncoder: 1
});
$c_Lnet_timerboard_InnerEvent$$anon$11.prototype.$classData = $d_Lnet_timerboard_InnerEvent$$anon$11;
/** @constructor */
function $c_Lnet_timerboard_Participant$$anon$9() {
  this.Lnet_timerboard_Participant$$anon$9__f_elemLabels = null;
  this.Lnet_timerboard_Participant$$anon$9__f_elemEncoders$lzy2 = null;
  this.Lnet_timerboard_Participant$$anon$9__f_elemEncodersbitmap$2 = false;
  var this$1 = $m_s_package$().s_package$__f_Nil;
  var this$2 = new $c_sci_$colon$colon("score", this$1);
  var this$4 = new $c_sci_$colon$colon("alliance_id", this$2);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem)
  };
  this.Lnet_timerboard_Participant$$anon$9__f_elemLabels = new ($d_T.getArrayOf().constr)(jsElems)
}
$c_Lnet_timerboard_Participant$$anon$9.prototype = new $h_O();
$c_Lnet_timerboard_Participant$$anon$9.prototype.constructor = $c_Lnet_timerboard_Participant$$anon$9;
/** @constructor */
function $h_Lnet_timerboard_Participant$$anon$9() {
  /*<skip>*/
}
$h_Lnet_timerboard_Participant$$anon$9.prototype = $c_Lnet_timerboard_Participant$$anon$9.prototype;
$c_Lnet_timerboard_Participant$$anon$9.prototype.elemLabels__AT = (function() {
  return this.Lnet_timerboard_Participant$$anon$9__f_elemLabels
});
$c_Lnet_timerboard_Participant$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lnet_timerboard_Participant$$anon$9.prototype.elemEncoders__ALio_circe_Encoder = (function() {
  if ((!this.Lnet_timerboard_Participant$$anon$9__f_elemEncodersbitmap$2)) {
    var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong;
    var encodeA$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBigDecimal;
    var this$1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = new $c_sci_$colon$colon(encodeA$2, this$1);
    var this$4 = new $c_sci_$colon$colon(encodeA, this$2);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    this.Lnet_timerboard_Participant$$anon$9__f_elemEncoders$lzy2 = new ($d_Lio_circe_Encoder.getArrayOf().constr)(jsElems);
    this.Lnet_timerboard_Participant$$anon$9__f_elemEncodersbitmap$2 = true
  };
  return this.Lnet_timerboard_Participant$$anon$9__f_elemEncoders$lzy2
});
$c_Lnet_timerboard_Participant$$anon$9.prototype.encodeObject__Lnet_timerboard_Participant__Lio_circe_JsonObject = (function(a) {
  return $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(new $c_Lio_circe_DerivedEncoder$$anon$1(a, this))
});
$c_Lnet_timerboard_Participant$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lnet_timerboard_Participant__Lio_circe_JsonObject($as_Lnet_timerboard_Participant(a))
});
var $d_Lnet_timerboard_Participant$$anon$9 = new $TypeData().initClass({
  Lnet_timerboard_Participant$$anon$9: 0
}, false, "net.timerboard.Participant$$anon$9", {
  Lnet_timerboard_Participant$$anon$9: 1,
  O: 1,
  Lio_circe_DerivedInstance: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_DerivedEncoder: 1
});
$c_Lnet_timerboard_Participant$$anon$9.prototype.$classData = $d_Lnet_timerboard_Participant$$anon$9;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uB($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B()
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcB$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", {
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uC($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C())
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcC$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", {
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uD($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D()
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcD$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", {
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uF($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F()
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcF$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", {
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uI($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I()
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcI$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", {
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  try {
    var t = this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return new $c_RTLong(lo, hi)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uJ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J()
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", {
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uS($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S()
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcS$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", {
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  try {
    this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V()
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcV$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", {
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uZ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z()
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", {
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcZ$sp;
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)")
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)))
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"))
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)))
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth))
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = new $h_ju_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.contains__O__Z = (function(o) {
  try {
    return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.contains__O__Z(o)
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      $as_jl_ClassCastException(e);
      return false
    } else {
      throw e
    }
  }
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.isEmpty__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.size__I = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.size__I()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.iterator__ju_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(this)
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$SetWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$SetWrapper", {
  sc_convert_JavaCollectionWrappers$SetWrapper: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set2$$anon$1__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 2)
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
  /*<skip>*/
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set2$$anon$1__f_$outer.scala$collection$immutable$Set$Set2$$getElem__I__O(i)
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass({
  sci_Set$Set2$$anon$1: 0
}, false, "scala.collection.immutable.Set$Set2$$anon$1", {
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2$$anon$1.prototype.$classData = $d_sci_Set$Set2$$anon$1;
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set3$$anon$2__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 3)
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
  /*<skip>*/
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set3$$anon$2__f_$outer.scala$collection$immutable$Set$Set3$$getElem__I__O(i)
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass({
  sci_Set$Set3$$anon$2: 0
}, false, "scala.collection.immutable.Set$Set3$$anon$2", {
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3$$anon$2.prototype.$classData = $d_sci_Set$Set3$$anon$2;
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set4$$anon$3__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 4)
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
  /*<skip>*/
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set4$$anon$3__f_$outer.scala$collection$immutable$Set$Set4$$getElem__I__O(i)
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass({
  sci_Set$Set4$$anon$3: 0
}, false, "scala.collection.immutable.Set$Set4$$anon$3", {
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4$$anon$3.prototype.$classData = $d_sci_Set$Set4$$anon$3;
/** @constructor */
function $c_sci_TreeSet$TreeSetBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeSet$TreeSetBuilder__f_tree = null
}
$c_sci_TreeSet$TreeSetBuilder.prototype = new $h_sci_RedBlackTree$SetHelper();
$c_sci_TreeSet$TreeSetBuilder.prototype.constructor = $c_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $h_sci_TreeSet$TreeSetBuilder() {
  /*<skip>*/
}
$h_sci_TreeSet$TreeSetBuilder.prototype = $c_sci_TreeSet$TreeSetBuilder.prototype;
$c_sci_TreeSet$TreeSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__sci_TreeSet$TreeSetBuilder = (function(elem) {
  this.sci_TreeSet$TreeSetBuilder__f_tree = this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree, elem);
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(xs);
      var x = x2.sci_TreeSet__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = x2.sci_TreeSet__f_tree;
          break matchEnd5
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), x2.sci_TreeSet__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    if (false) {
      var x3 = $as_sci_TreeMap(xs);
      var x$3 = x3.ordering__s_math_Ordering();
      var x$4 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = x3.tree0__sci_RedBlackTree$Tree();
          break matchEnd5
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), x3.tree0__sci_RedBlackTree$Tree(), this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
  };
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), this.sci_RedBlackTree$Helper__f_ordering)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeSet()
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder(xs)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_TreeSet$TreeSetBuilder(elem)
});
var $d_sci_TreeSet$TreeSetBuilder = new $TypeData().initClass({
  sci_TreeSet$TreeSetBuilder: 0
}, false, "scala.collection.immutable.TreeSet$TreeSetBuilder", {
  sci_TreeSet$TreeSetBuilder: 1,
  sci_RedBlackTree$SetHelper: 1,
  sci_RedBlackTree$Helper: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_TreeSet$TreeSetBuilder.prototype.$classData = $d_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = []
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
  /*<skip>*/
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? this.scm_ArrayBuilder$generic__f_elementClass.jl_Class__f_data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem)
  };
  return this
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf()
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $$x1 = true
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $$x1 = (x$6 === $d_sr_Nothing$.getClassOf())
    };
    if ($$x1) {
      var elemRuntimeClass = $d_O.getClassOf()
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass
    }
  };
  return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems)
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic"
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(xs)
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem)
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass({
  scm_ArrayBuilder$generic: 0
}, false, "scala.collection.mutable.ArrayBuilder$generic", {
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuilder$generic.prototype.$classData = $d_scm_ArrayBuilder$generic;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", {
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", {
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)))
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass({
  s_math_Ordering$Boolean$: 0
}, false, "scala.math.Ordering$Boolean$", {
  s_math_Ordering$Boolean$: 1,
  O: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Boolean$.prototype.$classData = $d_s_math_Ordering$Boolean$;
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$()
  };
  return $n_s_math_Ordering$Boolean$
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass({
  s_math_Ordering$Byte$: 0
}, false, "scala.math.Ordering$Byte$", {
  s_math_Ordering$Byte$: 1,
  O: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Byte$.prototype.$classData = $d_s_math_Ordering$Byte$;
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$()
  };
  return $n_s_math_Ordering$Byte$
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
  /*<skip>*/
}
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
  /*<skip>*/
}
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass({
  s_math_Ordering$Char$: 0
}, false, "scala.math.Ordering$Char$", {
  s_math_Ordering$Char$: 1,
  O: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Char$.prototype.$classData = $d_s_math_Ordering$Char$;
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$()
  };
  return $n_s_math_Ordering$Char$
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
  /*<skip>*/
}
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
  /*<skip>*/
}
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass({
  s_math_Ordering$Long$: 0
}, false, "scala.math.Ordering$Long$", {
  s_math_Ordering$Long$: 1,
  O: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Long$.prototype.$classData = $d_s_math_Ordering$Long$;
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$()
  };
  return $n_s_math_Ordering$Long$
}
/** @constructor */
function $c_s_math_Ordering$Short$() {
  /*<skip>*/
}
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
  /*<skip>*/
}
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass({
  s_math_Ordering$Short$: 0
}, false, "scala.math.Ordering$Short$", {
  s_math_Ordering$Short$: 1,
  O: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Short$.prototype.$classData = $d_s_math_Ordering$Short$;
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$()
  };
  return $n_s_math_Ordering$Short$
}
/** @constructor */
function $c_s_math_Ordering$String$() {
  /*<skip>*/
}
$c_s_math_Ordering$String$.prototype = new $h_O();
$c_s_math_Ordering$String$.prototype.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
  /*<skip>*/
}
$h_s_math_Ordering$String$.prototype = $c_s_math_Ordering$String$.prototype;
$c_s_math_Ordering$String$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$String$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_T(x);
  var y$1 = $as_T(y);
  return $f_T__compareTo__T__I(x$1, y$1)
});
var $d_s_math_Ordering$String$ = new $TypeData().initClass({
  s_math_Ordering$String$: 0
}, false, "scala.math.Ordering$String$", {
  s_math_Ordering$String$: 1,
  O: 1,
  s_math_Ordering$StringOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$String$.prototype.$classData = $d_s_math_Ordering$String$;
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$()
  };
  return $n_s_math_Ordering$String$
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
  /*<skip>*/
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_AnyValManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $dp_toString__T(this.sjs_js_JavaScriptException__f_exception)
  };
  fillInStackTrace__jl_Throwable() {
    this.setStackTraceStateInternal__O__(this.sjs_js_JavaScriptException__f_exception);
    return this
  };
  productPrefix__T() {
    return "JavaScriptException"
  };
  productArity__I() {
    return 1
  };
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = JavaScriptException$1.sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  };
  setStackTraceStateInternal__O__(e) {
    this.jl_Throwable__f_stackTraceStateInternal = e
  };
}
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"))
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)))
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth))
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass({
  sjs_js_JavaScriptException: 0
}, false, "scala.scalajs.js.JavaScriptException", {
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sjs_js_JavaScriptException.prototype.$classData = $d_sjs_js_JavaScriptException;
/** @constructor */
function $c_Lsquants_time_Milliseconds$() {
  this.Lsquants_time_Milliseconds$__f_symbol = null;
  this.Lsquants_time_Milliseconds$__f_symbol = "ms"
}
$c_Lsquants_time_Milliseconds$.prototype = new $h_O();
$c_Lsquants_time_Milliseconds$.prototype.constructor = $c_Lsquants_time_Milliseconds$;
/** @constructor */
function $h_Lsquants_time_Milliseconds$() {
  /*<skip>*/
}
$h_Lsquants_time_Milliseconds$.prototype = $c_Lsquants_time_Milliseconds$.prototype;
$c_Lsquants_time_Milliseconds$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_PrimaryUnit__converterTo__F1(this)
});
$c_Lsquants_time_Milliseconds$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_PrimaryUnit__converterFrom__F1(this)
});
$c_Lsquants_time_Milliseconds$.prototype.symbol__T = (function() {
  return this.Lsquants_time_Milliseconds$__f_symbol
});
$c_Lsquants_time_Milliseconds$.prototype.conversionFactor__D = (function() {
  return 1.0
});
var $d_Lsquants_time_Milliseconds$ = new $TypeData().initClass({
  Lsquants_time_Milliseconds$: 0
}, false, "squants.time.Milliseconds$", {
  Lsquants_time_Milliseconds$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_time_TimeUnit: 1,
  Lsquants_PrimaryUnit: 1,
  Lsquants_SiUnit: 1
});
$c_Lsquants_time_Milliseconds$.prototype.$classData = $d_Lsquants_time_Milliseconds$;
var $n_Lsquants_time_Milliseconds$;
function $m_Lsquants_time_Milliseconds$() {
  if ((!$n_Lsquants_time_Milliseconds$)) {
    $n_Lsquants_time_Milliseconds$ = new $c_Lsquants_time_Milliseconds$()
  };
  return $n_Lsquants_time_Milliseconds$
}
/** @constructor */
function $c_Lsquants_time_Seconds$() {
  this.Lsquants_time_Seconds$__f_conversionFactor = 0.0;
  this.Lsquants_time_Seconds$__f_symbol = null;
  $n_Lsquants_time_Seconds$ = this;
  this.Lsquants_time_Seconds$__f_conversionFactor = $m_Lsquants_time_Time$().Lsquants_time_Time$__f_MillisecondsPerSecond;
  this.Lsquants_time_Seconds$__f_symbol = "s"
}
$c_Lsquants_time_Seconds$.prototype = new $h_O();
$c_Lsquants_time_Seconds$.prototype.constructor = $c_Lsquants_time_Seconds$;
/** @constructor */
function $h_Lsquants_time_Seconds$() {
  /*<skip>*/
}
$h_Lsquants_time_Seconds$.prototype = $c_Lsquants_time_Seconds$.prototype;
$c_Lsquants_time_Seconds$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterTo__F1(this)
});
$c_Lsquants_time_Seconds$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterFrom__F1(this)
});
$c_Lsquants_time_Seconds$.prototype.conversionFactor__D = (function() {
  return this.Lsquants_time_Seconds$__f_conversionFactor
});
$c_Lsquants_time_Seconds$.prototype.symbol__T = (function() {
  return this.Lsquants_time_Seconds$__f_symbol
});
var $d_Lsquants_time_Seconds$ = new $TypeData().initClass({
  Lsquants_time_Seconds$: 0
}, false, "squants.time.Seconds$", {
  Lsquants_time_Seconds$: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_time_TimeUnit: 1,
  Lsquants_SiUnit: 1,
  Lsquants_SiBaseUnit: 1
});
$c_Lsquants_time_Seconds$.prototype.$classData = $d_Lsquants_time_Seconds$;
var $n_Lsquants_time_Seconds$;
function $m_Lsquants_time_Seconds$() {
  if ((!$n_Lsquants_time_Seconds$)) {
    $n_Lsquants_time_Seconds$ = new $c_Lsquants_time_Seconds$()
  };
  return $n_Lsquants_time_Seconds$
}
/** @constructor */
function $c_Ltyrian_Navigation$NoHash$() {
  /*<skip>*/
}
$c_Ltyrian_Navigation$NoHash$.prototype = new $h_O();
$c_Ltyrian_Navigation$NoHash$.prototype.constructor = $c_Ltyrian_Navigation$NoHash$;
/** @constructor */
function $h_Ltyrian_Navigation$NoHash$() {
  /*<skip>*/
}
$h_Ltyrian_Navigation$NoHash$.prototype = $c_Ltyrian_Navigation$NoHash$.prototype;
$c_Ltyrian_Navigation$NoHash$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Navigation$NoHash$.prototype.hashCode__I = (function() {
  return (-1957140849)
});
$c_Ltyrian_Navigation$NoHash$.prototype.toString__T = (function() {
  return "NoHash"
});
$c_Ltyrian_Navigation$NoHash$.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_Navigation$NoHash$.prototype.productPrefix__T = (function() {
  return "NoHash"
});
$c_Ltyrian_Navigation$NoHash$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Navigation$NoHash$(obj) {
  return (((obj instanceof $c_Ltyrian_Navigation$NoHash$) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Navigation$NoHash$"))
}
function $isArrayOf_Ltyrian_Navigation$NoHash$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Navigation$NoHash$)))
}
function $asArrayOf_Ltyrian_Navigation$NoHash$(obj, depth) {
  return (($isArrayOf_Ltyrian_Navigation$NoHash$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Navigation$NoHash$;", depth))
}
var $d_Ltyrian_Navigation$NoHash$ = new $TypeData().initClass({
  Ltyrian_Navigation$NoHash$: 0
}, false, "tyrian.Navigation$NoHash$", {
  Ltyrian_Navigation$NoHash$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_Navigation$NoHash$.prototype.$classData = $d_Ltyrian_Navigation$NoHash$;
var $n_Ltyrian_Navigation$NoHash$;
function $m_Ltyrian_Navigation$NoHash$() {
  if ((!$n_Ltyrian_Navigation$NoHash$)) {
    $n_Ltyrian_Navigation$NoHash$ = new $c_Ltyrian_Navigation$NoHash$()
  };
  return $n_Ltyrian_Navigation$NoHash$
}
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2) => ((a) => this$1.map__O__F1__O(fb$2, new $c_sjsr_AnonFunction1(((a$2) => ((b) => $ct_T2__O__O__(new $c_T2(), a$2, b)))(a)))))($thiz, fb)))
}
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2, f$2) => ((a) => this$1.map__O__F1__O(fb$2, new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))($thiz, fb, f)))
}
function $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  $m_Lcats_Eval$();
  var a$1 = $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2, f$2) => ((a) => this$1.map__O__F1__O(fb$2.value__O(), new $c_sjsr_AnonFunction1(((f$3$2, a$2) => ((b) => f$3$2.apply__O__O__O(a$2, b)))(f$2, a)))))($thiz, fb, f)));
  return new $c_Lcats_Now(a$1)
}
function $is_Lcats_Traverse(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Traverse)))
}
function $as_Lcats_Traverse(obj) {
  return (($is_Lcats_Traverse(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Traverse"))
}
function $isArrayOf_Lcats_Traverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Traverse)))
}
function $asArrayOf_Lcats_Traverse(obj, depth) {
  return (($isArrayOf_Lcats_Traverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Traverse;", depth))
}
/** @constructor */
function $c_Lcats_data_Chain$Empty$() {
  /*<skip>*/
}
$c_Lcats_data_Chain$Empty$.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$Empty$.prototype.constructor = $c_Lcats_data_Chain$Empty$;
/** @constructor */
function $h_Lcats_data_Chain$Empty$() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Empty$.prototype = $c_Lcats_data_Chain$Empty$.prototype;
$c_Lcats_data_Chain$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_data_Chain$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Lcats_data_Chain$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_data_Chain$Empty$ = new $TypeData().initClass({
  Lcats_data_Chain$Empty$: 0
}, false, "cats.data.Chain$Empty$", {
  Lcats_data_Chain$Empty$: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_data_Chain$Empty$.prototype.$classData = $d_Lcats_data_Chain$Empty$;
var $n_Lcats_data_Chain$Empty$;
function $m_Lcats_data_Chain$Empty$() {
  if ((!$n_Lcats_data_Chain$Empty$)) {
    $n_Lcats_data_Chain$Empty$ = new $c_Lcats_data_Chain$Empty$()
  };
  return $n_Lcats_data_Chain$Empty$
}
/** @constructor */
function $c_Lcats_data_Validated$() {
  this.Lcats_data_ValidatedInstances__f_catsDataBitraverseForValidated = null;
  this.Lcats_data_Validated$__f_validUnit = null;
  $ct_Lcats_data_ValidatedInstances__(this);
  $n_Lcats_data_Validated$ = this;
  this.Lcats_data_Validated$__f_validUnit = new $c_Lcats_data_Validated$Valid((void 0))
}
$c_Lcats_data_Validated$.prototype = new $h_Lcats_data_ValidatedInstances();
$c_Lcats_data_Validated$.prototype.constructor = $c_Lcats_data_Validated$;
/** @constructor */
function $h_Lcats_data_Validated$() {
  /*<skip>*/
}
$h_Lcats_data_Validated$.prototype = $c_Lcats_data_Validated$.prototype;
$c_Lcats_data_Validated$.prototype.ordinal__Lcats_data_Validated__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    return 0
  };
  if ((x$0 instanceof $c_Lcats_data_Validated$Invalid)) {
    return 1
  };
  throw new $c_s_MatchError(x$0)
});
$c_Lcats_data_Validated$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_data_Validated__I($as_Lcats_data_Validated(x))
});
var $d_Lcats_data_Validated$ = new $TypeData().initClass({
  Lcats_data_Validated$: 0
}, false, "cats.data.Validated$", {
  Lcats_data_Validated$: 1,
  Lcats_data_ValidatedInstances: 1,
  Lcats_data_ValidatedInstances1: 1,
  Lcats_data_ValidatedInstances2: 1,
  O: 1,
  Lcats_data_ValidatedFunctions: 1,
  Lcats_data_ValidatedFunctionsBinCompat0: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_data_Validated$.prototype.$classData = $d_Lcats_data_Validated$;
var $n_Lcats_data_Validated$;
function $m_Lcats_data_Validated$() {
  if ((!$n_Lcats_data_Validated$)) {
    $n_Lcats_data_Validated$ = new $c_Lcats_data_Validated$()
  };
  return $n_Lcats_data_Validated$
}
/** @constructor */
function $c_Lcats_data_WriterTInstances6() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances6.prototype = new $h_Lcats_data_WriterTInstances7();
$c_Lcats_data_WriterTInstances6.prototype.constructor = $c_Lcats_data_WriterTInstances6;
/** @constructor */
function $h_Lcats_data_WriterTInstances6() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances6.prototype = $c_Lcats_data_WriterTInstances6.prototype;
/** @constructor */
function $c_Lcats_kernel_Comparison$EqualTo$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, 0, 0.0)
}
$c_Lcats_kernel_Comparison$EqualTo$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$EqualTo$.prototype.constructor = $c_Lcats_kernel_Comparison$EqualTo$;
/** @constructor */
function $h_Lcats_kernel_Comparison$EqualTo$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$EqualTo$.prototype = $c_Lcats_kernel_Comparison$EqualTo$.prototype;
$c_Lcats_kernel_Comparison$EqualTo$.prototype.hashCode__I = (function() {
  return 159386799
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.toString__T = (function() {
  return "EqualTo"
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productPrefix__T = (function() {
  return "EqualTo"
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$EqualTo$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$EqualTo$: 0
}, false, "cats.kernel.Comparison$EqualTo$", {
  Lcats_kernel_Comparison$EqualTo$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.$classData = $d_Lcats_kernel_Comparison$EqualTo$;
var $n_Lcats_kernel_Comparison$EqualTo$;
function $m_Lcats_kernel_Comparison$EqualTo$() {
  if ((!$n_Lcats_kernel_Comparison$EqualTo$)) {
    $n_Lcats_kernel_Comparison$EqualTo$ = new $c_Lcats_kernel_Comparison$EqualTo$()
  };
  return $n_Lcats_kernel_Comparison$EqualTo$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$GreaterThan$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, 1, 1.0)
}
$c_Lcats_kernel_Comparison$GreaterThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.constructor = $c_Lcats_kernel_Comparison$GreaterThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$GreaterThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$GreaterThan$.prototype = $c_Lcats_kernel_Comparison$GreaterThan$.prototype;
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.hashCode__I = (function() {
  return (-1701951333)
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.toString__T = (function() {
  return "GreaterThan"
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productPrefix__T = (function() {
  return "GreaterThan"
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$GreaterThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$GreaterThan$: 0
}, false, "cats.kernel.Comparison$GreaterThan$", {
  Lcats_kernel_Comparison$GreaterThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.$classData = $d_Lcats_kernel_Comparison$GreaterThan$;
var $n_Lcats_kernel_Comparison$GreaterThan$;
function $m_Lcats_kernel_Comparison$GreaterThan$() {
  if ((!$n_Lcats_kernel_Comparison$GreaterThan$)) {
    $n_Lcats_kernel_Comparison$GreaterThan$ = new $c_Lcats_kernel_Comparison$GreaterThan$()
  };
  return $n_Lcats_kernel_Comparison$GreaterThan$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$LessThan$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, (-1), (-1.0))
}
$c_Lcats_kernel_Comparison$LessThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$LessThan$.prototype.constructor = $c_Lcats_kernel_Comparison$LessThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$LessThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$LessThan$.prototype = $c_Lcats_kernel_Comparison$LessThan$.prototype;
$c_Lcats_kernel_Comparison$LessThan$.prototype.hashCode__I = (function() {
  return (-2140646662)
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.toString__T = (function() {
  return "LessThan"
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productPrefix__T = (function() {
  return "LessThan"
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$LessThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$LessThan$: 0
}, false, "cats.kernel.Comparison$LessThan$", {
  Lcats_kernel_Comparison$LessThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.$classData = $d_Lcats_kernel_Comparison$LessThan$;
var $n_Lcats_kernel_Comparison$LessThan$;
function $m_Lcats_kernel_Comparison$LessThan$() {
  if ((!$n_Lcats_kernel_Comparison$LessThan$)) {
    $n_Lcats_kernel_Comparison$LessThan$ = new $c_Lcats_kernel_Comparison$LessThan$()
  };
  return $n_Lcats_kernel_Comparison$LessThan$
}
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext)
}
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), x.s_math_BigDecimal__f_bigDecimal.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(y.s_math_BigDecimal__f_bigDecimal), x.s_math_BigDecimal__f_mc)
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalGroup: 0
}, false, "cats.kernel.instances.BigDecimalGroup", {
  Lcats_kernel_instances_BigDecimalGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $m_s_package$().BigInt__s_math_BigInt$().apply__I__s_math_BigInt(0)
}
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return x$1.$plus__s_math_BigInt__s_math_BigInt(y$1)
});
var $d_Lcats_kernel_instances_BigIntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntGroup: 0
}, false, "cats.kernel.instances.BigIntGroup", {
  Lcats_kernel_instances_BigIntGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.$classData = $d_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ByteGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24)
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B($uB(x), $uB(y))
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_ByteGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ByteGroup: 0
}, false, "cats.kernel.instances.ByteGroup", {
  Lcats_kernel_instances_ByteGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_ByteGroup.prototype.$classData = $d_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__D__D__D = (function(x, y) {
  return (x + y)
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__D__D__D($uD(x), $uD(y))
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0
});
var $d_Lcats_kernel_instances_DoubleGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleGroup: 0
}, false, "cats.kernel.instances.DoubleGroup", {
  Lcats_kernel_instances_DoubleGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.$classData = $d_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return x$1.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1)
});
var $d_Lcats_kernel_instances_DurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DurationGroup: 0
}, false, "cats.kernel.instances.DurationGroup", {
  Lcats_kernel_instances_DurationGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_DurationGroup.prototype.$classData = $d_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(x$1, y$1.s_concurrent_duration_FiniteDuration__f_length, y$1.s_concurrent_duration_FiniteDuration__f_unit)
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationGroup: 0
}, false, "cats.kernel.instances.FiniteDurationGroup", {
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__F__F__F = (function(x, y) {
  return Math.fround((x + y))
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__F__F__F($uF(x), $uF(y))
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0
});
var $d_Lcats_kernel_instances_FloatGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FloatGroup: 0
}, false, "cats.kernel.instances.FloatGroup", {
  Lcats_kernel_instances_FloatGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_FloatGroup.prototype.$classData = $d_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combine__I__I__I = (function(x, y) {
  return ((x + y) | 0)
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__I__I__I($uI(x), $uI(y))
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_IntGroup: 0
}, false, "cats.kernel.instances.IntGroup", {
  Lcats_kernel_instances_IntGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_IntGroup.prototype.$classData = $d_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combine__J__J__J = (function(x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo + y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  return new $c_RTLong(lo, hi)
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__J__J__J($uJ(x), $uJ(y))
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $L0
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass({
  Lcats_kernel_instances_LongGroup: 0
}, false, "cats.kernel.instances.LongGroup", {
  Lcats_kernel_instances_LongGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_LongGroup.prototype.$classData = $d_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ShortGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16)
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S($uS(x), $uS(y))
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_ShortGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ShortGroup: 0
}, false, "cats.kernel.instances.ShortGroup", {
  Lcats_kernel_instances_ShortGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_ShortGroup.prototype.$classData = $d_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
  this.Lcats_kernel_instances_StringOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_StringOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I(x, y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_T(x);
  return $f_T__hashCode__I(x$1)
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z($as_T(x), $as_T(y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y))
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass({
  Lcats_kernel_instances_StringOrder: 0
}, false, "cats.kernel.instances.StringOrder", {
  Lcats_kernel_instances_StringOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_StringLowerBounded: 1
});
$c_Lcats_kernel_instances_StringOrder.prototype.$classData = $d_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $c_Lcats_kernel_instances_SymbolOrder() {
  this.Lcats_kernel_instances_SymbolOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_SymbolOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_SymbolOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_SymbolOrder.prototype.constructor = $c_Lcats_kernel_instances_SymbolOrder;
/** @constructor */
function $h_Lcats_kernel_instances_SymbolOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_SymbolOrder.prototype = $c_Lcats_kernel_instances_SymbolOrder.prototype;
$c_Lcats_kernel_instances_SymbolOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__s_Symbol__s_Symbol__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__s_Symbol__s_Symbol__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I(x.s_Symbol__f_name, y.s_Symbol__f_name))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_Symbol(x);
  return $f_T__hashCode__I(x$1.s_Symbol__f_name)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_Symbol__s_Symbol__Z($as_s_Symbol(x), $as_s_Symbol(y))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__s_Symbol__s_Symbol__I($as_s_Symbol(x), $as_s_Symbol(y))
});
var $d_Lcats_kernel_instances_SymbolOrder = new $TypeData().initClass({
  Lcats_kernel_instances_SymbolOrder: 0
}, false, "cats.kernel.instances.SymbolOrder", {
  Lcats_kernel_instances_SymbolOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_SymbolLowerBounded: 1
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.$classData = $d_Lcats_kernel_instances_SymbolOrder;
/** @constructor */
function $c_Lio_circe_Json$JNull$() {
  /*<skip>*/
}
$c_Lio_circe_Json$JNull$.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNull$.prototype.constructor = $c_Lio_circe_Json$JNull$;
/** @constructor */
function $h_Lio_circe_Json$JNull$() {
  /*<skip>*/
}
$h_Lio_circe_Json$JNull$.prototype = $c_Lio_circe_Json$JNull$.prototype;
$c_Lio_circe_Json$JNull$.prototype.hashCode__I = (function() {
  return 70780145
});
$c_Lio_circe_Json$JNull$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_Json$JNull$.prototype.productPrefix__T = (function() {
  return "JNull"
});
$c_Lio_circe_Json$JNull$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lio_circe_Json$JNull$.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onNull__O()
});
$c_Lio_circe_Json$JNull$.prototype.isNull__Z = (function() {
  return true
});
$c_Lio_circe_Json$JNull$.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNull$.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNull$.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNull$.prototype.asArray__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNull$.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
var $d_Lio_circe_Json$JNull$ = new $TypeData().initClass({
  Lio_circe_Json$JNull$: 0
}, false, "io.circe.Json$JNull$", {
  Lio_circe_Json$JNull$: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_Json$JNull$.prototype.$classData = $d_Lio_circe_Json$JNull$;
var $n_Lio_circe_Json$JNull$;
function $m_Lio_circe_Json$JNull$() {
  if ((!$n_Lio_circe_Json$JNull$)) {
    $n_Lio_circe_Json$JNull$ = new $c_Lio_circe_Json$JNull$()
  };
  return $n_Lio_circe_Json$JNull$
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if ($thiz.jl_JSConsoleBasedPrintStream__f_isErr) {
      var x = console.error;
      var $$x1 = $uZ((!(!x)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      console.error(line)
    } else {
      console.log(line)
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false;
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_flushed = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_flushed = true;
  this.jl_JSConsoleBasedPrintStream__f_buffer = ""
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.print__C__V = (function(c) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V($as_T(String.fromCharCode(c)))
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s))
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      this.jl_JSConsoleBasedPrintStream__f_flushed = false;
      rest = ""
    } else {
      var $$x1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$3 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $$x1) + $as_T(this$3.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      this.jl_JSConsoleBasedPrintStream__f_flushed = true;
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = $as_T(this$4.substring(beginIndex))
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream", {
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
});
$c_jl_JSConsoleBasedPrintStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream;
function $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x2 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  if ((x === x2)) {
    var value = $thiz.getDayOfWeek__Ljava_time_DayOfWeek().getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  };
  var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$3 === x2)) {
    var value$1 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$1 = (value$1 >> 31);
    var lo = (((-1) + value$1) | 0);
    var hi$2 = ((lo !== (-1)) ? hi$1 : (((-1) + hi$1) | 0));
    var this$4 = $m_RTLong$();
    var lo$1 = this$4.remainderImpl__I__I__I__I__I(lo, hi$2, 7, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$2 = ((1 + lo$1) | 0);
    var hi$4 = ((lo$2 === 0) ? ((1 + hi$3) | 0) : hi$3);
    return new $c_RTLong(lo$2, hi$4)
  };
  var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$5 === x2)) {
    var value$2 = $thiz.getDayOfYear__I();
    var hi$5 = (value$2 >> 31);
    var lo$3 = (((-1) + value$2) | 0);
    var hi$6 = ((lo$3 !== (-1)) ? hi$5 : (((-1) + hi$5) | 0));
    var this$8 = $m_RTLong$();
    var lo$4 = this$8.remainderImpl__I__I__I__I__I(lo$3, hi$6, 7, 0);
    var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$5 = ((1 + lo$4) | 0);
    var hi$8 = ((lo$5 === 0) ? ((1 + hi$7) | 0) : hi$7);
    return new $c_RTLong(lo$5, hi$8)
  };
  var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$7 === x2)) {
    var value$3 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$9 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$9)
  };
  var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$9 === x2)) {
    var value$4 = $thiz.getDayOfYear__I();
    var hi$10 = (value$4 >> 31);
    return new $c_RTLong(value$4, hi$10)
  };
  var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  if ((x$11 === x2)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
  };
  var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$13 === x2)) {
    var value$5 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$11 = (value$5 >> 31);
    var lo$6 = (((-1) + value$5) | 0);
    var hi$12 = ((lo$6 !== (-1)) ? hi$11 : (((-1) + hi$11) | 0));
    var this$14 = $m_RTLong$();
    var lo$7 = this$14.divideImpl__I__I__I__I__I(lo$6, hi$12, 7, 0);
    var hi$13 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$8 = ((1 + lo$7) | 0);
    var hi$14 = ((lo$8 === 0) ? ((1 + hi$13) | 0) : hi$13);
    return new $c_RTLong(lo$8, hi$14)
  };
  var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$15 === x2)) {
    var value$6 = $thiz.getDayOfYear__I();
    var hi$15 = (value$6 >> 31);
    var lo$9 = (((-1) + value$6) | 0);
    var hi$16 = ((lo$9 !== (-1)) ? hi$15 : (((-1) + hi$15) | 0));
    var this$18 = $m_RTLong$();
    var lo$10 = this$18.divideImpl__I__I__I__I__I(lo$9, hi$16, 7, 0);
    var hi$17 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$11 = ((1 + lo$10) | 0);
    var hi$18 = ((lo$11 === 0) ? ((1 + hi$17) | 0) : hi$17);
    return new $c_RTLong(lo$11, hi$18)
  };
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$17 === x2)) {
    var value$7 = $thiz.Ljava_time_LocalDate__f_month;
    var hi$19 = (value$7 >> 31);
    return new $c_RTLong(value$7, hi$19)
  };
  var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$19 === x2)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
  };
  var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
  if ((x$21 === x2)) {
    if (($thiz.Ljava_time_LocalDate__f_year >= 1)) {
      var value$8 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$20 = (value$8 >> 31);
      return new $c_RTLong(value$8, hi$20)
    } else {
      var value$9 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$21 = (value$9 >> 31);
      var lo$12 = ((1 - value$9) | 0);
      var hi$22 = ((((-2147483648) ^ lo$12) > (-2147483647)) ? (((-1) - hi$21) | 0) : ((-hi$21) | 0));
      return new $c_RTLong(lo$12, hi$22)
    }
  };
  var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  if ((x$23 === x2)) {
    var value$10 = $thiz.Ljava_time_LocalDate__f_year;
    var hi$23 = (value$10 >> 31);
    return new $c_RTLong(value$10, hi$23)
  };
  var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
  if ((x$25 === x2)) {
    return (($thiz.Ljava_time_LocalDate__f_year >= 1) ? new $c_RTLong(1, 0) : $L0)
  };
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
}
function $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz) {
  var value = $thiz.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = (((-1) + $thiz.Ljava_time_LocalDate__f_month) | 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  return new $c_RTLong(lo$1, hi$3)
}
function $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J($thiz, end) {
  var this$1 = $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz);
  var lo = this$1.RTLong__f_lo;
  var lo$1 = (lo << 5);
  var hi = (((lo >>> 27) | 0) | (this$1.RTLong__f_hi << 5));
  var value = $thiz.Ljava_time_LocalDate__f_day;
  var hi$1 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  var this$4 = $p_Ljava_time_LocalDate__getProlepticMonth__J(end);
  var lo$3 = this$4.RTLong__f_lo;
  var lo$4 = (lo$3 << 5);
  var hi$3 = (((lo$3 >>> 27) | 0) | (this$4.RTLong__f_hi << 5));
  var value$1 = end.Ljava_time_LocalDate__f_day;
  var hi$4 = (value$1 >> 31);
  var lo$5 = ((lo$4 + value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$3 + hi$4) | 0)) | 0) : ((hi$3 + hi$4) | 0));
  var lo$6 = ((lo$5 - lo$2) | 0);
  var hi$6 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$5)) ? (((-1) + ((hi$5 - hi$2) | 0)) | 0) : ((hi$5 - hi$2) | 0));
  var this$8 = $m_RTLong$();
  var lo$7 = this$8.divideImpl__I__I__I__I__I(lo$6, hi$6, 32, 0);
  var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$7, hi$7)
}
/** @constructor */
function $c_Ljava_time_LocalDate(year, monthOfYear, dayOfMonth) {
  this.Ljava_time_LocalDate__f_year = 0;
  this.Ljava_time_LocalDate__f_month = 0;
  this.Ljava_time_LocalDate__f_day = 0;
  this.Ljava_time_LocalDate__f_year = year;
  this.Ljava_time_LocalDate__f_month = ((monthOfYear << 16) >> 16);
  this.Ljava_time_LocalDate__f_day = ((dayOfMonth << 16) >> 16)
}
$c_Ljava_time_LocalDate.prototype = new $h_O();
$c_Ljava_time_LocalDate.prototype.constructor = $c_Ljava_time_LocalDate;
/** @constructor */
function $h_Ljava_time_LocalDate() {
  /*<skip>*/
}
$h_Ljava_time_LocalDate.prototype = $c_Ljava_time_LocalDate.prototype;
$c_Ljava_time_LocalDate.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this, field)
});
$c_Ljava_time_LocalDate.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    if (f.isDateBased__Z()) {
      var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
      if ((x === f)) {
        var $$x1 = $m_Ljava_time_temporal_ValueRange$();
        var value = this.lengthOfMonth__I();
        var hi = (value >> 31);
        return $$x1.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value, hi))
      } else {
        var x$3 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
        if ((x$3 === f)) {
          var $$x2 = $m_Ljava_time_temporal_ValueRange$();
          var value$1 = this.lengthOfYear__I();
          var hi$1 = (value$1 >> 31);
          return $$x2.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$1, hi$1))
        } else {
          var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          if ((x$5 === f)) {
            var $$x5 = $m_Ljava_time_temporal_ValueRange$();
            if (($m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month) === $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month())) {
              var $$x4 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
              var value$2 = this.Ljava_time_LocalDate__f_year;
              var hi$2 = (value$2 >> 31);
              var $$x3 = (!$$x4.isLeapYear__J__Z(new $c_RTLong(value$2, hi$2)))
            } else {
              var $$x3 = false
            };
            return $$x5.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), ($$x3 ? new $c_RTLong(4, 0) : new $c_RTLong(5, 0)))
          } else {
            var x$7 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
            if ((x$7 === f)) {
              if ((this.Ljava_time_LocalDate__f_year <= 0)) {
                var $$x6 = $m_Ljava_time_temporal_ValueRange$();
                var value$3 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$3 = (value$3 >> 31);
                var lo = ((1 + value$3) | 0);
                var hi$4 = ((lo === 0) ? ((1 + hi$3) | 0) : hi$3);
                return $$x6.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(lo, hi$4))
              } else {
                var $$x7 = $m_Ljava_time_temporal_ValueRange$();
                var value$4 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$5 = (value$4 >> 31);
                return $$x7.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$4, hi$5))
              }
            } else {
              return field.Ljava_time_temporal_ChronoField__f__range
            }
          }
        }
      }
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
    }
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
});
$c_Ljava_time_LocalDate.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var this$1 = $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return this$1.RTLong__f_lo
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_LocalDate.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toEpochDay__J()
    };
    if ((field === $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField())) {
      return $p_Ljava_time_LocalDate__getProlepticMonth__J(this)
    };
    return $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field)
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_LocalDate.prototype.getDayOfYear__I = (function() {
  var $$x2 = $m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month);
  var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  return (((-1) + (($$x2.firstDayOfYear__Z__I($$x1.isLeapYear__J__Z(new $c_RTLong(value, hi))) + this.Ljava_time_LocalDate__f_day) | 0)) | 0)
});
$c_Ljava_time_LocalDate.prototype.getDayOfWeek__Ljava_time_DayOfWeek = (function() {
  var b = this.toEpochDay__J();
  var bhi = b.RTLong__f_hi;
  var lo = ((3 + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < (-2147483645)) ? ((1 + bhi) | 0) : bhi);
  var this$2 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(7, 0));
  var dow0 = this$2.RTLong__f_lo;
  return $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(((1 + dow0) | 0))
});
$c_Ljava_time_LocalDate.prototype.lengthOfMonth__I = (function() {
  var x3 = this.Ljava_time_LocalDate__f_month;
  switch (x3) {
    case 2: {
      var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var value = this.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      if ($$x1.isLeapYear__J__Z(new $c_RTLong(value, hi))) {
        return 29
      } else {
        return 28
      };
      break
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      return 30;
      break
    }
    default: {
      return 31
    }
  }
});
$c_Ljava_time_LocalDate.prototype.lengthOfYear__I = (function() {
  var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  if ($$x1.isLeapYear__J__Z(new $c_RTLong(value, hi))) {
    return 366
  } else {
    return 365
  }
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalDate) ? $as_Ljava_time_LocalDate(adjuster) : $as_Ljava_time_LocalDate(adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this)))
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    f.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, f);
    var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    if ((x === f)) {
      var value = this.getDayOfWeek__Ljava_time_DayOfWeek().getValue__I();
      var hi = (value >> 31);
      var alo = newValue.RTLong__f_lo;
      var ahi = newValue.RTLong__f_hi;
      var lo = ((alo - value) | 0);
      var hi$1 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi) | 0)) | 0) : ((ahi - hi) | 0));
      return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi$1))
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
      if ((x$3 === f)) {
        var b = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
        var alo$1 = newValue.RTLong__f_lo;
        var ahi$1 = newValue.RTLong__f_hi;
        var bhi = b.RTLong__f_hi;
        var lo$1 = ((alo$1 - b.RTLong__f_lo) | 0);
        var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - bhi) | 0)) | 0) : ((ahi$1 - bhi) | 0));
        return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$2))
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
        if ((x$5 === f)) {
          var b$1 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
          var alo$2 = newValue.RTLong__f_lo;
          var ahi$2 = newValue.RTLong__f_hi;
          var bhi$1 = b$1.RTLong__f_hi;
          var lo$2 = ((alo$2 - b$1.RTLong__f_lo) | 0);
          var hi$3 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - bhi$1) | 0)) | 0) : ((ahi$2 - bhi$1) | 0));
          return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$2, hi$3))
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
          if ((x$7 === f)) {
            return this.withDayOfMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
            if ((x$9 === f)) {
              return this.withDayOfYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
              if ((x$11 === f)) {
                return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(newValue)
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
                if ((x$13 === f)) {
                  var b$2 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
                  var alo$3 = newValue.RTLong__f_lo;
                  var ahi$3 = newValue.RTLong__f_hi;
                  var bhi$2 = b$2.RTLong__f_hi;
                  var lo$3 = ((alo$3 - b$2.RTLong__f_lo) | 0);
                  var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$3 - bhi$2) | 0)) | 0) : ((ahi$3 - bhi$2) | 0));
                  return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$3, hi$4))
                } else {
                  var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
                  if ((x$15 === f)) {
                    var b$3 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
                    var alo$4 = newValue.RTLong__f_lo;
                    var ahi$4 = newValue.RTLong__f_hi;
                    var bhi$3 = b$3.RTLong__f_hi;
                    var lo$4 = ((alo$4 - b$3.RTLong__f_lo) | 0);
                    var hi$5 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$4)) ? (((-1) + ((ahi$4 - bhi$3) | 0)) | 0) : ((ahi$4 - bhi$3) | 0));
                    return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$4, hi$5))
                  } else {
                    var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
                    if ((x$17 === f)) {
                      return this.withMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
                    } else {
                      var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
                      if ((x$19 === f)) {
                        var b$4 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
                        var alo$5 = newValue.RTLong__f_lo;
                        var ahi$5 = newValue.RTLong__f_hi;
                        var bhi$4 = b$4.RTLong__f_hi;
                        var lo$5 = ((alo$5 - b$4.RTLong__f_lo) | 0);
                        var hi$6 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$5)) ? (((-1) + ((ahi$5 - bhi$4) | 0)) | 0) : ((ahi$5 - bhi$4) | 0));
                        return this.plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$5, hi$6))
                      } else {
                        var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
                        if ((x$21 === f)) {
                          if ((this.Ljava_time_LocalDate__f_year >= 1)) {
                            var this$9 = newValue
                          } else {
                            var bhi$5 = newValue.RTLong__f_hi;
                            var lo$6 = ((1 - newValue.RTLong__f_lo) | 0);
                            var hi$7 = ((((-2147483648) ^ lo$6) > (-2147483647)) ? (((-1) - bhi$5) | 0) : ((-bhi$5) | 0));
                            var x$1__lo = lo$6;
                            var x$1__hi = hi$7;
                            var this$9 = new $c_RTLong(x$1__lo, x$1__hi)
                          };
                          return this.withYear__I__Ljava_time_LocalDate(this$9.RTLong__f_lo)
                        } else {
                          var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
                          if ((x$23 === f)) {
                            return this.withYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
                          } else {
                            var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
                            if ((x$25 === f)) {
                              var this$10 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
                              if (((this$10.RTLong__f_lo === newValue.RTLong__f_lo) && (this$10.RTLong__f_hi === newValue.RTLong__f_hi))) {
                                return this
                              } else {
                                return this.withYear__I__Ljava_time_LocalDate(((1 - this.Ljava_time_LocalDate__f_year) | 0))
                              }
                            } else {
                              throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue)
  }
});
$c_Ljava_time_LocalDate.prototype.withYear__I__Ljava_time_LocalDate = (function(year) {
  if ((this.Ljava_time_LocalDate__f_year === year)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var hi = (year >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(year, this.Ljava_time_LocalDate__f_month, this.Ljava_time_LocalDate__f_day)
  }
});
$c_Ljava_time_LocalDate.prototype.withMonth__I__Ljava_time_LocalDate = (function(month) {
  if ((this.Ljava_time_LocalDate__f_month === month)) {
    return this
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var hi = (month >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, month, this.Ljava_time_LocalDate__f_day)
  }
});
$c_Ljava_time_LocalDate.prototype.withDayOfMonth__I__Ljava_time_LocalDate = (function(dayOfMonth) {
  return ((this.Ljava_time_LocalDate__f_day === dayOfMonth) ? this : $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, this.Ljava_time_LocalDate__f_month, dayOfMonth))
});
$c_Ljava_time_LocalDate.prototype.withDayOfYear__I__Ljava_time_LocalDate = (function(dayOfYear) {
  return ((this.getDayOfYear__I() === dayOfYear) ? this : $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, dayOfYear))
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x === f)) {
      return this.plusDays__J__Ljava_time_LocalDate(amountToAdd)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === f)) {
        return this.plusWeeks__J__Ljava_time_LocalDate(amountToAdd)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === f)) {
          return this.plusMonths__J__Ljava_time_LocalDate(amountToAdd)
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === f)) {
            return this.plusYears__J__Ljava_time_LocalDate(amountToAdd)
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === f)) {
              return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(10, 0)))
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === f)) {
                return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(100, 0)))
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === f)) {
                  return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(1000, 0)))
                } else {
                  var x$15 = $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === f)) {
                    var $$x1 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
                    var t = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
                    var lo = t.RTLong__f_lo;
                    var hi = t.RTLong__f_hi;
                    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate($$x1, $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo, hi), amountToAdd))
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit)
  }
});
$c_Ljava_time_LocalDate.prototype.plusYears__J__Ljava_time_LocalDate = (function(yearsToAdd) {
  if (((yearsToAdd.RTLong__f_lo === 0) && (yearsToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var this$3 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var bhi = yearsToAdd.RTLong__f_hi;
    var lo = ((value + yearsToAdd.RTLong__f_lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + bhi) | 0)) | 0) : ((hi + bhi) | 0));
    var newYear = this$3.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi$1), this$3);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, this.Ljava_time_LocalDate__f_month, this.Ljava_time_LocalDate__f_day)
  }
});
$c_Ljava_time_LocalDate.prototype.plusMonths__J__Ljava_time_LocalDate = (function(monthsToAdd) {
  if (((monthsToAdd.RTLong__f_lo === 0) && (monthsToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var value$1 = (((-1) + this.Ljava_time_LocalDate__f_month) | 0);
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo + value$1) | 0);
    var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
    var bhi = monthsToAdd.RTLong__f_hi;
    var lo$2 = ((lo$1 + monthsToAdd.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$3 + bhi) | 0)) | 0) : ((hi$3 + bhi) | 0));
    var this$5 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$2, hi$4), new $c_RTLong(12, 0));
    var lo$3 = t.RTLong__f_lo;
    var hi$5 = t.RTLong__f_hi;
    var newYear = this$5.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$3, hi$5), this$5);
    var this$6 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$2, hi$4), new $c_RTLong(12, 0));
    var newMonth = ((1 + this$6.RTLong__f_lo) | 0);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, newMonth, this.Ljava_time_LocalDate__f_day)
  }
});
$c_Ljava_time_LocalDate.prototype.plusWeeks__J__Ljava_time_LocalDate = (function(weeksToAdd) {
  return this.plusDays__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(weeksToAdd, new $c_RTLong(7, 0)))
});
$c_Ljava_time_LocalDate.prototype.plusDays__J__Ljava_time_LocalDate = (function(daysToAdd) {
  if (((daysToAdd.RTLong__f_lo === 0) && (daysToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var t = this.toEpochDay__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo, hi), daysToAdd);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalDate.prototype.minusDays__J__Ljava_time_LocalDate = (function(daysToSubtract) {
  if (((daysToSubtract.RTLong__f_lo === 0) && (daysToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  } else {
    var lo = daysToSubtract.RTLong__f_lo;
    var hi = daysToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDate.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this : $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O(this, query))
});
$c_Ljava_time_LocalDate.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), this.toEpochDay__J())
});
$c_Ljava_time_LocalDate.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x6 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x === x6)) {
      return this.daysUntil__Ljava_time_LocalDate__J(end)
    };
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    if ((x$3 === x6)) {
      var this$1 = this.daysUntil__Ljava_time_LocalDate__J(end);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideImpl__I__I__I__I__I(this$1.RTLong__f_lo, this$1.RTLong__f_hi, 7, 0);
      var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi)
    };
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
    if ((x$5 === x6)) {
      return $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end)
    };
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
    if ((x$7 === x6)) {
      var this$3 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$4 = $m_RTLong$();
      var lo$1 = this$4.divideImpl__I__I__I__I__I(this$3.RTLong__f_lo, this$3.RTLong__f_hi, 12, 0);
      var hi$1 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$1, hi$1)
    };
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
    if ((x$9 === x6)) {
      var this$5 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$6 = $m_RTLong$();
      var lo$2 = this$6.divideImpl__I__I__I__I__I(this$5.RTLong__f_lo, this$5.RTLong__f_hi, 120, 0);
      var hi$2 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$2, hi$2)
    };
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
    if ((x$11 === x6)) {
      var this$7 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$8 = $m_RTLong$();
      var lo$3 = this$8.divideImpl__I__I__I__I__I(this$7.RTLong__f_lo, this$7.RTLong__f_hi, 1200, 0);
      var hi$3 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$3, hi$3)
    };
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
    if ((x$13 === x6)) {
      var this$9 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$10 = $m_RTLong$();
      var lo$4 = this$10.divideImpl__I__I__I__I__I(this$9.RTLong__f_lo, this$9.RTLong__f_hi, 12000, 0);
      var hi$4 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$4, hi$4)
    };
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
    if ((x$15 === x6)) {
      var this$11 = end.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var b = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var alo = this$11.RTLong__f_lo;
      var ahi = this$11.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      var lo$5 = ((alo - b.RTLong__f_lo) | 0);
      var hi$5 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
      return new $c_RTLong(lo$5, hi$5)
    };
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
  } else {
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, unit)
  }
});
$c_Ljava_time_LocalDate.prototype.daysUntil__Ljava_time_LocalDate__J = (function(end) {
  var this$1 = end.toEpochDay__J();
  var b = this.toEpochDay__J();
  var alo = this$1.RTLong__f_lo;
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  return new $c_RTLong(lo, hi)
});
$c_Ljava_time_LocalDate.prototype.toEpochDay__J = (function() {
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var value$1 = this.Ljava_time_LocalDate__f_month;
  var hi$1 = (value$1 >> 31);
  var total__lo = 0;
  var total__hi = 0;
  var this$3__lo = total__lo;
  var this$3__hi = total__hi;
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(365, b0);
  var a0b1 = Math.imul(365, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(365, hi) + ((c1part >>> 16) | 0)) | 0);
  var alo = this$3__lo;
  var ahi = this$3__hi;
  var lo$1 = ((alo + lo) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$2) | 0)) | 0) : ((ahi + hi$2) | 0));
  var $$x1__lo = lo$1;
  var $$x1__hi = hi$3;
  total__lo = $$x1__lo;
  total__hi = $$x1__hi;
  if ((hi >= 0)) {
    var this$13__lo = total__lo;
    var this$13__hi = total__hi;
    var lo$2 = ((3 + value) | 0);
    var hi$4 = ((((-2147483648) ^ lo$2) < (-2147483645)) ? ((1 + hi) | 0) : hi);
    var this$6 = $m_RTLong$();
    var lo$3 = this$6.divideImpl__I__I__I__I__I(lo$2, hi$4, 4, 0);
    var hi$5 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = ((99 + value) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) < (-2147483549)) ? ((1 + hi) | 0) : hi);
    var this$8 = $m_RTLong$();
    var lo$5 = this$8.divideImpl__I__I__I__I__I(lo$4, hi$6, 100, 0);
    var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$6 = ((lo$3 - lo$5) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$3)) ? (((-1) + ((hi$5 - hi$7) | 0)) | 0) : ((hi$5 - hi$7) | 0));
    var lo$7 = ((399 + value) | 0);
    var hi$9 = ((((-2147483648) ^ lo$7) < (-2147483249)) ? ((1 + hi) | 0) : hi);
    var this$11 = $m_RTLong$();
    var lo$8 = this$11.divideImpl__I__I__I__I__I(lo$7, hi$9, 400, 0);
    var hi$10 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$9 = ((lo$6 + lo$8) | 0);
    var hi$11 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$6)) ? ((1 + ((hi$8 + hi$10) | 0)) | 0) : ((hi$8 + hi$10) | 0));
    var alo$1 = this$13__lo;
    var ahi$1 = this$13__hi;
    var lo$10 = ((alo$1 + lo$9) | 0);
    var hi$12 = ((((-2147483648) ^ lo$10) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$1 + hi$11) | 0)) | 0) : ((ahi$1 + hi$11) | 0));
    var $$x2__lo = lo$10;
    var $$x2__hi = hi$12;
    total__lo = $$x2__lo;
    total__hi = $$x2__hi
  } else {
    var this$20__lo = total__lo;
    var this$20__hi = total__hi;
    var this$15 = $m_RTLong$();
    var lo$11 = this$15.divideImpl__I__I__I__I__I(value, hi, (-4), (-1));
    var hi$13 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$16 = $m_RTLong$();
    var lo$12 = this$16.divideImpl__I__I__I__I__I(value, hi, (-100), (-1));
    var hi$14 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$13 = ((lo$11 - lo$12) | 0);
    var hi$15 = ((((-2147483648) ^ lo$13) > ((-2147483648) ^ lo$11)) ? (((-1) + ((hi$13 - hi$14) | 0)) | 0) : ((hi$13 - hi$14) | 0));
    var this$18 = $m_RTLong$();
    var lo$14 = this$18.divideImpl__I__I__I__I__I(value, hi, (-400), (-1));
    var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$15 = ((lo$13 + lo$14) | 0);
    var hi$17 = ((((-2147483648) ^ lo$15) < ((-2147483648) ^ lo$13)) ? ((1 + ((hi$15 + hi$16) | 0)) | 0) : ((hi$15 + hi$16) | 0));
    var alo$2 = this$20__lo;
    var ahi$2 = this$20__hi;
    var lo$16 = ((alo$2 - lo$15) | 0);
    var hi$18 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$17) | 0)) | 0) : ((ahi$2 - hi$17) | 0));
    var $$x3__lo = lo$16;
    var $$x3__hi = hi$18;
    total__lo = $$x3__lo;
    total__hi = $$x3__hi
  };
  var this$24__lo = total__lo;
  var this$24__hi = total__hi;
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(367, b0$1);
  var a0b1$1 = Math.imul(367, b1$1);
  var lo$17 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$19 = ((Math.imul(367, hi$1) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$18 = (((-362) + lo$17) | 0);
  var hi$20 = ((((-2147483648) ^ lo$18) < 2147483286) ? hi$19 : (((-1) + hi$19) | 0));
  var this$23 = $m_RTLong$();
  var lo$19 = this$23.divideImpl__I__I__I__I__I(lo$18, hi$20, 12, 0);
  var hi$21 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var alo$3 = this$24__lo;
  var ahi$3 = this$24__hi;
  var lo$20 = ((alo$3 + lo$19) | 0);
  var hi$22 = ((((-2147483648) ^ lo$20) < ((-2147483648) ^ alo$3)) ? ((1 + ((ahi$3 + hi$21) | 0)) | 0) : ((ahi$3 + hi$21) | 0));
  var $$x4__lo = lo$20;
  var $$x4__hi = hi$22;
  total__lo = $$x4__lo;
  total__hi = $$x4__hi;
  var this$27__lo = total__lo;
  var this$27__hi = total__hi;
  var value$2 = (((-1) + this.Ljava_time_LocalDate__f_day) | 0);
  var hi$23 = (value$2 >> 31);
  var alo$4 = this$27__lo;
  var ahi$4 = this$27__hi;
  var lo$21 = ((alo$4 + value$2) | 0);
  var hi$24 = ((((-2147483648) ^ lo$21) < ((-2147483648) ^ alo$4)) ? ((1 + ((ahi$4 + hi$23) | 0)) | 0) : ((ahi$4 + hi$23) | 0));
  var $$x5__lo = lo$21;
  var $$x5__hi = hi$24;
  total__lo = $$x5__lo;
  total__hi = $$x5__hi;
  if (((hi$1 === 0) ? (((-2147483648) ^ value$1) > (-2147483646)) : (hi$1 > 0))) {
    var b__lo = total__lo;
    var b__hi = total__hi;
    var bhi = b__hi;
    var lo$22 = (((-1) + b__lo) | 0);
    var hi$25 = ((lo$22 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var $$x6__lo = lo$22;
    var $$x6__hi = hi$25;
    total__lo = $$x6__lo;
    total__hi = $$x6__hi;
    var $$x7 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value$3 = this.Ljava_time_LocalDate__f_year;
    var hi$26 = (value$3 >> 31);
    if ((!$$x7.isLeapYear__J__Z(new $c_RTLong(value$3, hi$26)))) {
      var b$1__lo = total__lo;
      var b$1__hi = total__hi;
      var bhi$1 = b$1__hi;
      var lo$23 = (((-1) + b$1__lo) | 0);
      var hi$27 = ((lo$23 !== (-1)) ? bhi$1 : (((-1) + bhi$1) | 0));
      var $$x8__lo = lo$23;
      var $$x8__hi = hi$27;
      total__lo = $$x8__lo;
      total__hi = $$x8__hi
    }
  };
  var this$32__lo = total__lo;
  var this$32__hi = total__hi;
  var b$2 = $m_Ljava_time_LocalDate$().Ljava_time_LocalDate$__f_DAYS_0000_TO_1970;
  var alo$5 = this$32__lo;
  var ahi$5 = this$32__hi;
  var bhi$2 = b$2.RTLong__f_hi;
  var lo$24 = ((alo$5 - b$2.RTLong__f_lo) | 0);
  var hi$28 = ((((-2147483648) ^ lo$24) > ((-2147483648) ^ alo$5)) ? (((-1) + ((ahi$5 - bhi$2) | 0)) | 0) : ((ahi$5 - bhi$2) | 0));
  return new $c_RTLong(lo$24, hi$28)
});
$c_Ljava_time_LocalDate.prototype.compareTo__Ljava_time_chrono_ChronoLocalDate__I = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) : $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other))
});
$c_Ljava_time_LocalDate.prototype.compareTo0__Ljava_time_LocalDate__I = (function(otherDate) {
  var cmp = ((this.Ljava_time_LocalDate__f_year - otherDate.Ljava_time_LocalDate__f_year) | 0);
  if ((cmp === 0)) {
    cmp = ((this.Ljava_time_LocalDate__f_month - otherDate.Ljava_time_LocalDate__f_month) | 0);
    if ((cmp === 0)) {
      cmp = ((this.Ljava_time_LocalDate__f_day - otherDate.Ljava_time_LocalDate__f_day) | 0)
    }
  };
  return cmp
});
$c_Ljava_time_LocalDate.prototype.isAfter__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) > 0) : $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this, other))
});
$c_Ljava_time_LocalDate.prototype.isBefore__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) < 0) : $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this, other))
});
$c_Ljava_time_LocalDate.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDate)) {
    var otherDate = $as_Ljava_time_LocalDate(obj);
    return ((this === otherDate) || (this.compareTo0__Ljava_time_LocalDate__I(otherDate) === 0))
  } else {
    return false
  }
});
$c_Ljava_time_LocalDate.prototype.hashCode__I = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  return (((-2048) & yearValue) ^ (((((yearValue << 11) + (monthValue << 6)) | 0) + dayValue) | 0))
});
$c_Ljava_time_LocalDate.prototype.toString__T = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  var absYear = ((yearValue < 0) ? ((-yearValue) | 0) : yearValue);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 10);
  if ((absYear < 1000)) {
    if ((yearValue < 0)) {
      buf.append__I__scm_StringBuilder((((-10000) + yearValue) | 0)).deleteCharAt__I__scm_StringBuilder(1)
    } else {
      buf.append__I__scm_StringBuilder(((10000 + yearValue) | 0)).deleteCharAt__I__scm_StringBuilder(0)
    }
  } else {
    if ((yearValue > 9999)) {
      buf.append__C__scm_StringBuilder(43)
    };
    buf.append__I__scm_StringBuilder(yearValue)
  };
  var this$2 = buf.append__T__scm_StringBuilder(((monthValue < 10) ? "-0" : "-")).append__I__scm_StringBuilder(monthValue).append__T__scm_StringBuilder(((dayValue < 10) ? "-0" : "-")).append__I__scm_StringBuilder(dayValue);
  return this$2.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue)
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit)
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToSubtract, unit)
});
$c_Ljava_time_LocalDate.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDate__I($as_Ljava_time_chrono_ChronoLocalDate(that))
});
function $as_Ljava_time_LocalDate(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDate) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDate"))
}
function $isArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDate)))
}
function $asArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDate;", depth))
}
var $d_Ljava_time_LocalDate = new $TypeData().initClass({
  Ljava_time_LocalDate: 0
}, false, "java.time.LocalDate", {
  Ljava_time_LocalDate: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoLocalDate: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDate.prototype.$classData = $d_Ljava_time_LocalDate;
function $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, newTime) {
  return ((($thiz.Ljava_time_LocalDateTime__f_date === newDate) && ($thiz.Ljava_time_LocalDateTime__f_time === newTime)) ? $thiz : new $c_Ljava_time_LocalDateTime(newDate, newTime))
}
function $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime($thiz, newDate, hours, minutes, seconds, nanos, sign) {
  var lo = (hours.RTLong__f_lo | minutes.RTLong__f_lo);
  var hi = (hours.RTLong__f_hi | minutes.RTLong__f_hi);
  var lo$1 = (lo | seconds.RTLong__f_lo);
  var hi$1 = (hi | seconds.RTLong__f_hi);
  var lo$2 = (lo$1 | nanos.RTLong__f_lo);
  var hi$2 = (hi$1 | nanos.RTLong__f_hi);
  if (((lo$2 === 0) && (hi$2 === 0))) {
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, $thiz.Ljava_time_LocalDateTime__f_time)
  };
  var b = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var this$1 = $m_RTLong$();
  var lo$3 = this$1.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi$3 = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi$4 = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo$4 = this$3.divideImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, value, hi$4);
  var hi$5 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$5 = ((lo$3 + lo$4) | 0);
  var hi$6 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$3 + hi$5) | 0)) | 0) : ((hi$3 + hi$5) | 0));
  var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY;
  var hi$7 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$6 = this$6.divideImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, value$1, hi$7);
  var hi$8 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$7 = ((lo$5 + lo$6) | 0);
  var hi$9 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$5)) ? ((1 + ((hi$6 + hi$8) | 0)) | 0) : ((hi$6 + hi$8) | 0));
  var value$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY;
  var hi$10 = (value$2 >> 31);
  var this$9 = $m_RTLong$();
  var lo$8 = this$9.divideImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, value$2, hi$10);
  var hi$11 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$9 = ((lo$7 + lo$8) | 0);
  var hi$12 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$7)) ? ((1 + ((hi$9 + hi$11) | 0)) | 0) : ((hi$9 + hi$11) | 0));
  var totDays__lo = lo$9;
  var totDays__hi = hi$12;
  var this$12__lo = totDays__lo;
  var this$12__hi = totDays__hi;
  var hi$13 = (sign >> 31);
  var alo = this$12__lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & sign);
  var b1 = ((sign >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$10 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$14 = ((((((((Math.imul(alo, hi$13) + Math.imul(this$12__hi, sign)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var $$x1__lo = lo$10;
  var $$x1__hi = hi$14;
  totDays__lo = $$x1__lo;
  totDays__hi = $$x1__hi;
  var b$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var this$13 = $m_RTLong$();
  var lo$11 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
  var hi$15 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
  var hi$16 = (value$3 >> 31);
  var this$15 = $m_RTLong$();
  var lo$12 = this$15.remainderImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, value$3, hi$16);
  var hi$17 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
  var blo = b$2.RTLong__f_lo;
  var a0$1 = (65535 & lo$12);
  var a1$1 = ((lo$12 >>> 16) | 0);
  var b0$1 = (65535 & blo);
  var b1$1 = ((blo >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$13 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$18 = ((((((((Math.imul(lo$12, b$2.RTLong__f_hi) + Math.imul(hi$17, blo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$14 = ((lo$11 + lo$13) | 0);
  var hi$19 = ((((-2147483648) ^ lo$14) < ((-2147483648) ^ lo$11)) ? ((1 + ((hi$15 + hi$18) | 0)) | 0) : ((hi$15 + hi$18) | 0));
  var value$4 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY;
  var hi$20 = (value$4 >> 31);
  var this$18 = $m_RTLong$();
  var lo$15 = this$18.remainderImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, value$4, hi$20);
  var hi$21 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
  var blo$1 = b$3.RTLong__f_lo;
  var a0$2 = (65535 & lo$15);
  var a1$2 = ((lo$15 >>> 16) | 0);
  var b0$2 = (65535 & blo$1);
  var b1$2 = ((blo$1 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$16 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$22 = ((((((((Math.imul(lo$15, b$3.RTLong__f_hi) + Math.imul(hi$21, blo$1)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$14 + lo$16) | 0);
  var hi$23 = ((((-2147483648) ^ lo$17) < ((-2147483648) ^ lo$14)) ? ((1 + ((hi$19 + hi$22) | 0)) | 0) : ((hi$19 + hi$22) | 0));
  var value$5 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY;
  var hi$24 = (value$5 >> 31);
  var this$21 = $m_RTLong$();
  var lo$18 = this$21.remainderImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, value$5, hi$24);
  var hi$25 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$4 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
  var blo$2 = b$4.RTLong__f_lo;
  var a0$3 = (65535 & lo$18);
  var a1$3 = ((lo$18 >>> 16) | 0);
  var b0$3 = (65535 & blo$2);
  var b1$3 = ((blo$2 >>> 16) | 0);
  var a0b0$3 = Math.imul(a0$3, b0$3);
  var a1b0$3 = Math.imul(a1$3, b0$3);
  var a0b1$3 = Math.imul(a0$3, b1$3);
  var lo$19 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$26 = ((((((((Math.imul(lo$18, b$4.RTLong__f_hi) + Math.imul(hi$25, blo$2)) | 0) + Math.imul(a1$3, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$17 + lo$19) | 0);
  var hi$27 = ((((-2147483648) ^ lo$20) < ((-2147483648) ^ lo$17)) ? ((1 + ((hi$23 + hi$26) | 0)) | 0) : ((hi$23 + hi$26) | 0));
  var totNanos__lo = lo$20;
  var totNanos__hi = hi$27;
  var t = $thiz.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
  var lo$21 = t.RTLong__f_lo;
  var hi$28 = t.RTLong__f_hi;
  var this$24__lo = totNanos__lo;
  var this$24__hi = totNanos__hi;
  var hi$29 = (sign >> 31);
  var alo$1 = this$24__lo;
  var a0$4 = (65535 & alo$1);
  var a1$4 = ((alo$1 >>> 16) | 0);
  var b0$4 = (65535 & sign);
  var b1$4 = ((sign >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$4, b0$4);
  var a1b0$4 = Math.imul(a1$4, b0$4);
  var a0b1$4 = Math.imul(a0$4, b1$4);
  var lo$22 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$30 = ((((((((Math.imul(alo$1, hi$29) + Math.imul(this$24__hi, sign)) | 0) + Math.imul(a1$4, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$23 = ((lo$22 + lo$21) | 0);
  var hi$31 = ((((-2147483648) ^ lo$23) < ((-2147483648) ^ lo$22)) ? ((1 + ((hi$30 + hi$28) | 0)) | 0) : ((hi$30 + hi$28) | 0));
  var $$x2__lo = lo$23;
  var $$x2__hi = hi$31;
  totNanos__lo = $$x2__lo;
  totNanos__hi = $$x2__hi;
  var this$26__lo = totDays__lo;
  var this$26__hi = totDays__hi;
  var a__lo = totNanos__lo;
  var a__hi = totNanos__hi;
  var t$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var lo$24 = t$1.RTLong__f_lo;
  var hi$32 = t$1.RTLong__f_hi;
  var b$5 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$24, hi$32));
  var alo$2 = this$26__lo;
  var ahi = this$26__hi;
  var bhi = b$5.RTLong__f_hi;
  var lo$25 = ((alo$2 + b$5.RTLong__f_lo) | 0);
  var hi$33 = ((((-2147483648) ^ lo$25) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var $$x3__lo = lo$25;
  var $$x3__hi = hi$33;
  totDays__lo = $$x3__lo;
  totDays__hi = $$x3__hi;
  var a$1__lo = totNanos__lo;
  var a$1__hi = totNanos__hi;
  var t$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
  var lo$26 = t$2.RTLong__f_lo;
  var hi$34 = t$2.RTLong__f_hi;
  var t$3 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$26, hi$34));
  var lo$27 = t$3.RTLong__f_lo;
  var hi$35 = t$3.RTLong__f_hi;
  var newTime = (((lo$27 === lo$21) && (hi$35 === hi$28)) ? $thiz.Ljava_time_LocalDateTime__f_time : $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$27, hi$35)));
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(totDays__lo, totDays__hi)), newTime)
}
function $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I($thiz, other) {
  var cmp = $thiz.Ljava_time_LocalDateTime__f_date.compareTo0__Ljava_time_LocalDate__I(other.Ljava_time_LocalDateTime__f_date);
  if ((cmp === 0)) {
    var this$1 = $thiz.Ljava_time_LocalDateTime__f_time;
    var other$1 = other.Ljava_time_LocalDateTime__f_time;
    cmp = this$1.compare__Ljava_time_LocalTime__I(other$1)
  };
  return cmp
}
/** @constructor */
function $c_Ljava_time_LocalDateTime(date, time) {
  this.Ljava_time_LocalDateTime__f_date = null;
  this.Ljava_time_LocalDateTime__f_time = null;
  this.Ljava_time_LocalDateTime__f_date = date;
  this.Ljava_time_LocalDateTime__f_time = time
}
$c_Ljava_time_LocalDateTime.prototype = new $h_Ljava_time_chrono_ChronoLocalDateTime();
$c_Ljava_time_LocalDateTime.prototype.constructor = $c_Ljava_time_LocalDateTime;
/** @constructor */
function $h_Ljava_time_LocalDateTime() {
  /*<skip>*/
}
$h_Ljava_time_LocalDateTime.prototype = $c_Ljava_time_LocalDateTime.prototype;
$c_Ljava_time_LocalDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isDateBased__Z() || field.isTimeBased__Z()) : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_LocalDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if (field.isTimeBased__Z()) {
      var this$1 = this.Ljava_time_LocalDateTime__f_time;
      return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$1, field)
    } else {
      return this.Ljava_time_LocalDateTime__f_date.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
    }
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
});
$c_Ljava_time_LocalDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? this.Ljava_time_LocalDateTime__f_time.get__Ljava_time_temporal_TemporalField__I(field) : this.Ljava_time_LocalDateTime__f_date.get__Ljava_time_temporal_TemporalField__I(field)) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field))
});
$c_Ljava_time_LocalDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? this.Ljava_time_LocalDateTime__f_time.getLong__Ljava_time_temporal_TemporalField__J(field) : this.Ljava_time_LocalDateTime__f_date.getLong__Ljava_time_temporal_TemporalField__J(field)) : this.getLong__Ljava_time_temporal_TemporalField__J(field))
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime = (function(field, newValue) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, this.Ljava_time_LocalDateTime__f_time.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)) : $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue), this.Ljava_time_LocalDateTime__f_time)) : this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue))
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === f)) {
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, amountToAdd, 1)
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === f)) {
        var b = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MICROS_PER_DAY;
        var this$1 = $m_RTLong$();
        var lo = this$1.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$3 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo, hi));
        var b$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MICROS_PER_DAY;
        var this$2 = $m_RTLong$();
        var lo$1 = this$2.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
        var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo$1);
        var b1 = ((lo$1 >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
        return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$3, this$3.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$2, hi$2), 1)
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === f)) {
          var b$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MILLIS_PER_DAY;
          var this$4 = $m_RTLong$();
          var lo$3 = this$4.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
          var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$6 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$3, hi$3));
          var b$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MILLIS_PER_DAY;
          var this$5 = $m_RTLong$();
          var lo$4 = this$5.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$3.RTLong__f_lo, b$3.RTLong__f_hi);
          var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var b0$1 = (65535 & lo$4);
          var b1$1 = ((lo$4 >>> 16) | 0);
          var a0b0$1 = Math.imul(16960, b0$1);
          var a1b0 = Math.imul(15, b0$1);
          var a0b1$1 = Math.imul(16960, b1$1);
          var lo$5 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$5 = ((((((Math.imul(1000000, hi$4) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
          return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$5, hi$5), 1)
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === f)) {
            return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, amountToAdd, $L0, 1)
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === f)) {
              return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, amountToAdd, $L0, $L0, 1)
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === f)) {
                return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, amountToAdd, $L0, $L0, $L0, 1)
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === f)) {
                  var this$7 = $m_RTLong$();
                  var lo$6 = this$7.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$6 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var this$9 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$6, hi$6));
                  var this$8 = $m_RTLong$();
                  var lo$7 = this$8.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var b0$2 = (65535 & lo$7);
                  var b1$2 = ((lo$7 >>> 16) | 0);
                  var a0b0$2 = Math.imul(12, b0$2);
                  var a0b1$2 = Math.imul(12, b1$2);
                  var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                  var hi$8 = ((Math.imul(12, hi$7) + ((c1part$2 >>> 16) | 0)) | 0);
                  return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$9, this$9.Ljava_time_LocalDateTime__f_date, new $c_RTLong(lo$8, hi$8), $L0, $L0, $L0, 1)
                } else {
                  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit), this.Ljava_time_LocalDateTime__f_time)
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit)
  }
});
$c_Ljava_time_LocalDateTime.prototype.plusDays__J__Ljava_time_LocalDateTime = (function(days) {
  var newDate = this.Ljava_time_LocalDateTime__f_date.plusDays__J__Ljava_time_LocalDate(days);
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, newDate, this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_LocalDateTime__f_date : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O.call(this, query))
});
$c_Ljava_time_LocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal.call(this, temporal)
});
$c_Ljava_time_LocalDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    if (f.isTimeBased__Z()) {
      var t = this.Ljava_time_LocalDateTime__f_date.daysUntil__Ljava_time_LocalDate__J(end.Ljava_time_LocalDateTime__f_date);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var daysUntil__lo = lo;
      var daysUntil__hi = hi;
      var this$1 = end.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
      var b = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
      var alo = this$1.RTLong__f_lo;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      var lo$1 = ((alo - b.RTLong__f_lo) | 0);
      var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
      var timeUntil__lo = lo$1;
      var timeUntil__hi = hi$1;
      var this$3__lo = daysUntil__lo;
      var this$3__hi = daysUntil__hi;
      var ahi$1 = this$3__hi;
      if (((ahi$1 === 0) ? (this$3__lo !== 0) : (ahi$1 > 0))) {
        var this$4__lo = timeUntil__lo;
        var this$4__hi = timeUntil__hi;
        var ahi$2 = this$4__hi;
        var $$x1 = (ahi$2 < 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var b$1__lo = daysUntil__lo;
        var b$1__hi = daysUntil__hi;
        var bhi$1 = b$1__hi;
        var lo$2 = (((-1) + b$1__lo) | 0);
        var hi$2 = ((lo$2 !== (-1)) ? bhi$1 : (((-1) + bhi$1) | 0));
        var $$x2__lo = lo$2;
        var $$x2__hi = hi$2;
        daysUntil__lo = $$x2__lo;
        daysUntil__hi = $$x2__hi;
        var this$6__lo = timeUntil__lo;
        var this$6__hi = timeUntil__hi;
        var b$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
        var alo$1 = this$6__lo;
        var ahi$3 = this$6__hi;
        var bhi$2 = b$2.RTLong__f_hi;
        var lo$3 = ((alo$1 + b$2.RTLong__f_lo) | 0);
        var hi$3 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$3 + bhi$2) | 0)) | 0) : ((ahi$3 + bhi$2) | 0));
        var $$x3__lo = lo$3;
        var $$x3__hi = hi$3;
        timeUntil__lo = $$x3__lo;
        timeUntil__hi = $$x3__hi
      } else {
        var this$8__lo = daysUntil__lo;
        var this$8__hi = daysUntil__hi;
        var ahi$4 = this$8__hi;
        if ((ahi$4 < 0)) {
          var this$9__lo = timeUntil__lo;
          var this$9__hi = timeUntil__hi;
          var ahi$5 = this$9__hi;
          var $$x4 = ((ahi$5 === 0) ? (this$9__lo !== 0) : (ahi$5 > 0))
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var b$3__lo = daysUntil__lo;
          var b$3__hi = daysUntil__hi;
          var bhi$3 = b$3__hi;
          var lo$4 = ((1 + b$3__lo) | 0);
          var hi$4 = ((lo$4 === 0) ? ((1 + bhi$3) | 0) : bhi$3);
          var $$x5__lo = lo$4;
          var $$x5__hi = hi$4;
          daysUntil__lo = $$x5__lo;
          daysUntil__hi = $$x5__hi;
          var this$11__lo = timeUntil__lo;
          var this$11__hi = timeUntil__hi;
          var b$4 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
          var alo$2 = this$11__lo;
          var ahi$6 = this$11__hi;
          var bhi$4 = b$4.RTLong__f_hi;
          var lo$5 = ((alo$2 - b$4.RTLong__f_lo) | 0);
          var hi$5 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$6 - bhi$4) | 0)) | 0) : ((ahi$6 - bhi$4) | 0));
          var $$x6__lo = lo$5;
          var $$x6__hi = hi$5;
          timeUntil__lo = $$x6__lo;
          timeUntil__hi = $$x6__hi
        }
      };
      var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
      if ((x === f)) {
        var a__lo = daysUntil__lo;
        var a__hi = daysUntil__hi;
        var t$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_DAY;
        var lo$6 = t$1.RTLong__f_lo;
        var hi$6 = t$1.RTLong__f_hi;
        var t$2 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$6, hi$6));
        var lo$7 = t$2.RTLong__f_lo;
        var hi$7 = t$2.RTLong__f_hi;
        var b$5__lo = timeUntil__lo;
        var b$5__hi = timeUntil__hi;
        return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$7, hi$7), new $c_RTLong(b$5__lo, b$5__hi))
      } else {
        var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
        if ((x$3 === f)) {
          var a$1__lo = daysUntil__lo;
          var a$1__hi = daysUntil__hi;
          var t$3 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MICROS_PER_DAY;
          var lo$8 = t$3.RTLong__f_lo;
          var hi$8 = t$3.RTLong__f_hi;
          var t$4 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$8, hi$8));
          var lo$10 = t$4.RTLong__f_lo;
          var hi$10 = t$4.RTLong__f_hi;
          var this$13__lo = timeUntil__lo;
          var this$13__hi = timeUntil__hi;
          var this$14 = $m_RTLong$();
          var lo$9 = this$14.divideImpl__I__I__I__I__I(this$13__lo, this$13__hi, 1000, 0);
          var hi$9 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$10, hi$10), new $c_RTLong(lo$9, hi$9))
        } else {
          var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
          if ((x$5 === f)) {
            var a$2__lo = daysUntil__lo;
            var a$2__hi = daysUntil__hi;
            var t$5 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MILLIS_PER_DAY;
            var lo$11 = t$5.RTLong__f_lo;
            var hi$11 = t$5.RTLong__f_hi;
            var t$6 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$2__lo, a$2__hi), new $c_RTLong(lo$11, hi$11));
            var lo$13 = t$6.RTLong__f_lo;
            var hi$13 = t$6.RTLong__f_hi;
            var this$15__lo = timeUntil__lo;
            var this$15__hi = timeUntil__hi;
            var this$16 = $m_RTLong$();
            var lo$12 = this$16.divideImpl__I__I__I__I__I(this$15__lo, this$15__hi, 1000000, 0);
            var hi$12 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$13, hi$13), new $c_RTLong(lo$12, hi$12))
          } else {
            var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
            if ((x$7 === f)) {
              var a$3__lo = daysUntil__lo;
              var a$3__hi = daysUntil__hi;
              var value = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_SECONDS_PER_DAY;
              var hi$14 = (value >> 31);
              var t$7 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$3__lo, a$3__hi), new $c_RTLong(value, hi$14));
              var lo$15 = t$7.RTLong__f_lo;
              var hi$16 = t$7.RTLong__f_hi;
              var this$18__lo = timeUntil__lo;
              var this$18__hi = timeUntil__hi;
              var b$6 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_SECOND;
              var this$19 = $m_RTLong$();
              var lo$14 = this$19.divideImpl__I__I__I__I__I(this$18__lo, this$18__hi, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
              var hi$15 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$15, hi$16), new $c_RTLong(lo$14, hi$15))
            } else {
              var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
              if ((x$9 === f)) {
                var a$4__lo = daysUntil__lo;
                var a$4__hi = daysUntil__hi;
                var value$1 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_MINUTES_PER_DAY;
                var hi$17 = (value$1 >> 31);
                var t$8 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$4__lo, a$4__hi), new $c_RTLong(value$1, hi$17));
                var lo$17 = t$8.RTLong__f_lo;
                var hi$19 = t$8.RTLong__f_hi;
                var this$21__lo = timeUntil__lo;
                var this$21__hi = timeUntil__hi;
                var b$7 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_MINUTE;
                var this$22 = $m_RTLong$();
                var lo$16 = this$22.divideImpl__I__I__I__I__I(this$21__lo, this$21__hi, b$7.RTLong__f_lo, b$7.RTLong__f_hi);
                var hi$18 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$17, hi$19), new $c_RTLong(lo$16, hi$18))
              } else {
                var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
                if ((x$11 === f)) {
                  var a$5__lo = daysUntil__lo;
                  var a$5__hi = daysUntil__hi;
                  var value$2 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_HOURS_PER_DAY;
                  var hi$20 = (value$2 >> 31);
                  var t$9 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$5__lo, a$5__hi), new $c_RTLong(value$2, hi$20));
                  var lo$19 = t$9.RTLong__f_lo;
                  var hi$22 = t$9.RTLong__f_hi;
                  var this$24__lo = timeUntil__lo;
                  var this$24__hi = timeUntil__hi;
                  var b$8 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
                  var this$25 = $m_RTLong$();
                  var lo$18 = this$25.divideImpl__I__I__I__I__I(this$24__lo, this$24__hi, b$8.RTLong__f_lo, b$8.RTLong__f_hi);
                  var hi$21 = this$25.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$19, hi$22), new $c_RTLong(lo$18, hi$21))
                } else {
                  var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                  if ((x$13 === f)) {
                    var a$6__lo = daysUntil__lo;
                    var a$6__hi = daysUntil__hi;
                    var t$10 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$6__lo, a$6__hi), new $c_RTLong(2, 0));
                    var lo$22 = t$10.RTLong__f_lo;
                    var hi$25 = t$10.RTLong__f_hi;
                    var this$26__lo = timeUntil__lo;
                    var this$26__hi = timeUntil__hi;
                    var b$9 = $m_Ljava_time_LocalTime$().Ljava_time_LocalTime$__f_NANOS_PER_HOUR;
                    var blo = b$9.RTLong__f_lo;
                    var b0 = (65535 & blo);
                    var b1 = ((blo >>> 16) | 0);
                    var a0b0 = Math.imul(12, b0);
                    var a0b1 = Math.imul(12, b1);
                    var lo$20 = ((a0b0 + (a0b1 << 16)) | 0);
                    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
                    var hi$23 = ((Math.imul(12, b$9.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
                    var this$27 = $m_RTLong$();
                    var lo$21 = this$27.divideImpl__I__I__I__I__I(this$26__lo, this$26__hi, lo$20, hi$23);
                    var hi$24 = this$27.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                    return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$22, hi$25), new $c_RTLong(lo$21, hi$24))
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    };
    var endDate = ((end.Ljava_time_LocalDateTime__f_date.isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && end.Ljava_time_LocalDateTime__f_time.isBefore__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? end.Ljava_time_LocalDateTime__f_date.minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : ((end.Ljava_time_LocalDateTime__f_date.isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && end.Ljava_time_LocalDateTime__f_time.isAfter__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? end.Ljava_time_LocalDateTime__f_date.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : end.Ljava_time_LocalDateTime__f_date));
    return this.Ljava_time_LocalDateTime__f_date.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endDate, unit)
  } else {
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, unit)
  }
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(other);
    return $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, l)
  } else {
    return this.compare__Ljava_time_chrono_ChronoLocalDateTime__I(other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(other);
    return ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, l) > 0)
  } else {
    return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(other);
    return ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, l) < 0)
  } else {
    return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDateTime)) {
    var other = $as_Ljava_time_LocalDateTime(obj);
    if ((this === other)) {
      return true
    } else {
      var x = this.Ljava_time_LocalDateTime__f_date;
      var x$2 = other.Ljava_time_LocalDateTime__f_date;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_LocalDateTime__f_time;
        var x$4 = other.Ljava_time_LocalDateTime__f_time;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_LocalDateTime.prototype.hashCode__I = (function() {
  return (this.Ljava_time_LocalDateTime__f_date.hashCode__I() ^ this.Ljava_time_LocalDateTime__f_time.hashCode__I())
});
$c_Ljava_time_LocalDateTime.prototype.toString__T = (function() {
  return ((this.Ljava_time_LocalDateTime__f_date.toString__T() + "T") + this.Ljava_time_LocalDateTime__f_time.toString__T())
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue)
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit)
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToSubtract, unit)
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I($as_Ljava_time_chrono_ChronoLocalDateTime(that))
});
function $as_Ljava_time_LocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDateTime"))
}
function $isArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDateTime)))
}
function $asArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDateTime;", depth))
}
var $d_Ljava_time_LocalDateTime = new $TypeData().initClass({
  Ljava_time_LocalDateTime: 0
}, false, "java.time.LocalDateTime", {
  Ljava_time_LocalDateTime: 1,
  Ljava_time_chrono_ChronoLocalDateTime: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDateTime.prototype.$classData = $d_Ljava_time_LocalDateTime;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = new $h_jl_Enum();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var x6 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x6) {
    case 0: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = true;
      break
    }
    case 1: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
      break
    }
    case 2: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = true;
      break
    }
    case 3: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
      break
    }
    default: {
      throw new $c_s_MatchError(x6)
    }
  };
  return position
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.toString__T = (function() {
  var x7 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x7) {
    case 0: {
      return "ParseCaseSensitive(true)";
      break
    }
    case 1: {
      return "ParseCaseSensitive(false)";
      break
    }
    case 2: {
      return "ParseStrict(true)";
      break
    }
    case 3: {
      return "ParseStrict(false)";
      break
    }
    default: {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable")
    }
  }
});
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
function $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__($thiz, name, ordinal, baseUnit, rangeUnit, _range, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoField__f_name = name;
  $thiz.Ljava_time_temporal_ChronoField__f_ordinal = ordinal;
  $thiz.Ljava_time_temporal_ChronoField__f_baseUnit = baseUnit;
  $thiz.Ljava_time_temporal_ChronoField__f_rangeUnit = rangeUnit;
  $thiz.Ljava_time_temporal_ChronoField__f__range = _range;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoField() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false
}
$c_Ljava_time_temporal_ChronoField.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoField.prototype.constructor = $c_Ljava_time_temporal_ChronoField;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField.prototype = $c_Ljava_time_temporal_ChronoField.prototype;
$c_Ljava_time_temporal_ChronoField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_temporal_ChronoField.prototype.isDateBased__Z = (function() {
  return ((this.Ljava_time_temporal_ChronoField__f_ordinal >= $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal) && (this.Ljava_time_temporal_ChronoField__f_ordinal <= $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal))
});
$c_Ljava_time_temporal_ChronoField.prototype.isTimeBased__Z = (function() {
  return (this.Ljava_time_temporal_ChronoField__f_ordinal < $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal)
});
$c_Ljava_time_temporal_ChronoField.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoField__f_name
});
function $as_Ljava_time_temporal_ChronoField(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoField) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoField"))
}
function $isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoField)))
}
function $asArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoField;", depth))
}
var $d_Ljava_time_temporal_ChronoField = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField: 0
}, false, "java.time.temporal.ChronoField", {
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_temporal_ChronoField.prototype.$classData = $d_Ljava_time_temporal_ChronoField;
function $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__($thiz, name, ordinal, duration, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoUnit__f_name = name;
  $thiz.Ljava_time_temporal_ChronoUnit__f_duration = duration;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false
}
$c_Ljava_time_temporal_ChronoUnit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoUnit.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit.prototype = $c_Ljava_time_temporal_ChronoUnit.prototype;
$c_Ljava_time_temporal_ChronoUnit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isDateBased__Z = (function() {
  return ((this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) >= 0) && (this !== $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()))
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isTimeBased__Z = (function() {
  return (this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) < 0)
});
$c_Ljava_time_temporal_ChronoUnit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_name
});
function $as_Ljava_time_temporal_ChronoUnit(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoUnit"))
}
function $isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoUnit)))
}
function $asArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoUnit;", depth))
}
var $d_Ljava_time_temporal_ChronoUnit = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit: 0
}, false, "java.time.temporal.ChronoUnit", {
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_temporal_ChronoUnit.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $c_ju_Collections$$anon$2() {
  /*<skip>*/
}
$c_ju_Collections$$anon$2.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$2.prototype.constructor = $c_ju_Collections$$anon$2;
/** @constructor */
function $h_ju_Collections$$anon$2() {
  /*<skip>*/
}
$h_ju_Collections$$anon$2.prototype = $c_ju_Collections$$anon$2.prototype;
$c_ju_Collections$$anon$2.prototype.get__I__O = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
});
$c_ju_Collections$$anon$2.prototype.size__I = (function() {
  return 0
});
var $d_ju_Collections$$anon$2 = new $TypeData().initClass({
  ju_Collections$$anon$2: 0
}, false, "java.util.Collections$$anon$2", {
  ju_Collections$$anon$2: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  Ljava_io_Serializable: 1,
  ju_RandomAccess: 1
});
$c_ju_Collections$$anon$2.prototype.$classData = $d_ju_Collections$$anon$2;
function $ct_ju_HashSet__ju_HashMap__($thiz, inner) {
  $thiz.ju_HashSet__f_inner = inner;
  $thiz.ju_HashSet__f_innerKeySet = new $c_ju_HashMap$KeySet(inner);
  return $thiz
}
function $ct_ju_HashSet__($thiz) {
  $ct_ju_HashSet__ju_HashMap__($thiz, $ct_ju_HashMap__(new $c_ju_HashMap()));
  return $thiz
}
/** @constructor */
function $c_ju_HashSet() {
  this.ju_HashSet__f_inner = null;
  this.ju_HashSet__f_innerKeySet = null
}
$c_ju_HashSet.prototype = new $h_ju_AbstractSet();
$c_ju_HashSet.prototype.constructor = $c_ju_HashSet;
/** @constructor */
function $h_ju_HashSet() {
  /*<skip>*/
}
$h_ju_HashSet.prototype = $c_ju_HashSet.prototype;
$c_ju_HashSet.prototype.contains__O__Z = (function(o) {
  return this.ju_HashSet__f_inner.containsKey__O__Z(o)
});
$c_ju_HashSet.prototype.remove__O__Z = (function(o) {
  return (this.ju_HashSet__f_inner.remove__O__O(o) !== null)
});
$c_ju_HashSet.prototype.containsAll__ju_Collection__Z = (function(c) {
  return this.ju_HashSet__f_innerKeySet.containsAll__ju_Collection__Z(c)
});
$c_ju_HashSet.prototype.add__O__Z = (function(e) {
  var this$1 = this.ju_HashSet__f_inner;
  if ((e === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I(e);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return (this$1.java$util$HashMap$$put0__O__O__I__Z__O(e, (void 0), $$x1, false) === null)
});
$c_ju_HashSet.prototype.size__I = (function() {
  return this.ju_HashSet__f_inner.ju_HashMap__f_contentSize
});
$c_ju_HashSet.prototype.iterator__ju_Iterator = (function() {
  return this.ju_HashSet__f_innerKeySet.iterator__ju_Iterator()
});
var $d_ju_HashSet = new $TypeData().initClass({
  ju_HashSet: 0
}, false, "java.util.HashSet", {
  ju_HashSet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_HashSet.prototype.$classData = $d_ju_HashSet;
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var this$1 = $thiz.word__I__J((elem >> 6));
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    return (!((lo$1 === 0) && (hi$1 === 0)))
  } else {
    return false
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var $$x1 = s;
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    s = (($$x1 + (($m_jl_Integer$().bitCount__I__I(lo) + $m_jl_Integer$().bitCount__I__I(hi)) | 0)) | 0)
  };
  return s
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var arg1 = it.next__I();
    var this$6 = $thiz.word__I__J(arg1);
    res = ((this$6.RTLong__f_lo === 0) && (this$6.RTLong__f_hi === 0))
  };
  return res
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var j = (i << 6);
    while (true) {
      var this$1__lo = w__lo;
      var this$1__hi = w__hi;
      if ((!((this$1__lo === 0) && (this$1__hi === 0)))) {
        var b__lo = w__lo;
        var b__hi = w__hi;
        var lo$1 = (1 & b__lo);
        if ((lo$1 === 1)) {
          f.apply__O__O(j)
        };
        var this$2__lo = w__lo;
        var this$2__hi = w__hi;
        var hi$1 = this$2__hi;
        var lo$2 = (((this$2__lo >>> 1) | 0) | (hi$1 << 31));
        var hi$2 = ((hi$1 >>> 1) | 0);
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$2;
        w__lo = $$x1__lo;
        w__hi = $$x1__hi;
        j = ((1 + j) | 0)
      } else {
        break
      }
    };
    i = ((1 + i) | 0)
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x = $as_sc_BitSetOps($thiz).nwords__I();
    var that = x2.nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var this$10 = $thiz.word__I__J(v1);
        var b = x2.word__I__J(v1);
        var lo = (this$10.RTLong__f_lo | b.RTLong__f_lo);
        var hi$2 = (this$10.RTLong__f_hi | b.RTLong__f_hi);
        words.set(v1, new $c_RTLong(lo, hi$2));
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break
        };
        i = ((1 + i) | 0)
      }
    };
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words)
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other)
  }
}
function $is_sc_BitSetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSetOps)))
}
function $as_sc_BitSetOps(obj) {
  return (($is_sc_BitSetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSetOps"))
}
function $isArrayOf_sc_BitSetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSetOps)))
}
function $asArrayOf_sc_BitSetOps(obj, depth) {
  return (($isArrayOf_sc_BitSetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSetOps;", depth))
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || s.isEmpty__Z())) {
      return s
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = $as_sc_LinearSeq(s.tail__O());
      n = temp$n;
      s = temp$s
    }
  }
}
function $is_sc_StrictOptimizedLinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $as_sc_StrictOptimizedLinearSeqOps(obj) {
  return (($is_sc_StrictOptimizedLinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedLinearSeqOps"))
}
function $isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $asArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedLinearSeqOps;", depth))
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return $as_sc_IterableOps(b.result__O())
}
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $as_sc_IterableOps(b.result__O())
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hasNext__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying.hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.next__O = (function() {
  return this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying.next__O()
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.productPrefix__T = (function() {
  return "JIteratorWrapper"
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.productArity__I = (function() {
  return 1
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper)) {
    var JIteratorWrapper$1 = $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(x$1);
    var x = this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    var x$2 = JIteratorWrapper$1.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    return (x === x$2)
  } else {
    return false
  }
});
function $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JIteratorWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JIteratorWrapper;", depth))
}
var $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper", {
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $$x3 = $thiz.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = $thiz.s_math_BigDecimal__f_bigDecimal;
    var $$x2 = ((($$x3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = $thiz.toBigInt__s_math_BigInt().hashCode__I()
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $thiz.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
    var $$x1 = $m_sr_Statics$().doubleHash__D__I(dv)
  } else {
    var temp = $thiz.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    var $$x1 = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(temp.scaleByPowerOfTen__I__Ljava_math_BigDecimal(temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale).toBigInteger__Ljava_math_BigInteger().hashCode__I(), temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = $$x1
}
function $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__($thiz, bigDecimal, mc) {
  $thiz.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  $thiz.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal")
  };
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal")
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = 1565550863;
  return $thiz
}
function $ct_s_math_BigDecimal__Ljava_math_BigDecimal__($thiz, bigDecimal) {
  $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__($thiz, bigDecimal, $m_s_math_BigDecimal$().s_math_BigDecimal$__f_defaultMathContext);
  return $thiz
}
/** @constructor */
function $c_s_math_BigDecimal() {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
  /*<skip>*/
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that$1.s_math_BigDecimal__f_bigDecimal)
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this)
  };
  return this.s_math_BigDecimal__f_computedHashCode
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2)
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var $$x2 = x3.bitLength__I();
    var $$x1 = this.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    if (($$x2 > (3.3219280948873626 * (((-2) + (($$x1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$2 = this.toBigIntExact__s_Option();
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var x$1 = $as_s_math_BigInt(arg1);
        return x3.equals__s_math_BigInt__Z(x$1)
      } else {
        return false
      }
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = this.s_math_BigDecimal__f_bigDecimal.floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.byteValueExact__B();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.shortValueExact__S();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() >= 0)) && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() <= 65535))
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.intValueExact__I();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext))
  } else {
    return false
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = this.s_math_BigDecimal__f_bigDecimal;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true
  } else {
    var this$2 = this.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return (this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal) === 0)
});
$c_s_math_BigDecimal.prototype.$times__s_math_BigDecimal__s_math_BigDecimal = (function(that) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), this.s_math_BigDecimal__f_bigDecimal.multiply__Ljava_math_BigDecimal__Ljava_math_MathContext__Ljava_math_BigDecimal(that.s_math_BigDecimal__f_bigDecimal, this.s_math_BigDecimal__f_mc), this.s_math_BigDecimal__f_mc)
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 24) >> 24)
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 16) >> 16)
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.intValue__I()
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.longValue__J()
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.floatValue__F()
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.doubleValue__D()
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigInteger__Ljava_math_BigInteger())
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigIntegerExact__Ljava_math_BigInteger()))
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.toString__T()
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"))
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)))
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth))
}
var $d_s_math_BigDecimal = new $TypeData().initClass({
  s_math_BigDecimal: 0
}, false, "scala.math.BigDecimal", {
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigDecimal.prototype.$classData = $d_s_math_BigDecimal;
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var this$1 = $thiz.s_math_BigInt__f__long;
  return (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))))
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.bigInteger__Ljava_math_BigInteger().shiftRight__I__Ljava_math_BigInteger(2147483647);
  return ((shifted.Ljava_math_BigInteger__f_sign !== 0) && (!shifted.equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne)))
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long = _long;
  return $thiz
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) <= 63) ? bigInteger.longValue__J() : new $c_RTLong(0, (-2147483648))));
  return $thiz
}
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long = $L0
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
  /*<skip>*/
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that))
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read
  } else {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    this.s_math_BigInt__f__bigInteger = write;
    return write
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this)
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x)
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2)
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return x3.equals__O__Z(this)
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4))
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$1 = this.bigInteger__Ljava_math_BigInteger();
      var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
      return ($m_jl_Float$().parseFloat__T__F(s) === x5)
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147483520) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147483521)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147450880) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147450881)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if ((ahi >= 0)) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147418113)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger))
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var this$1 = this.s_math_BigInt__f__long;
      var b = that.s_math_BigInt__f__long;
      return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
    } else {
      return false
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, that.s_math_BigInt__f__bigInteger))
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = that.s_math_BigInt__f__long;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
    } else {
      var this$1 = that.s_math_BigInt__f__bigInteger;
      return ((-this$1.Ljava_math_BigInteger__f_sign) | 0)
    }
  } else if ($p_s_math_BigInt__longEncoding__Z(that)) {
    var this$2 = this.s_math_BigInt__f__bigInteger;
    return this$2.Ljava_math_BigInteger__f_sign
  } else {
    return this.s_math_BigInt__f__bigInteger.compareTo__Ljava_math_BigInteger__I(that.s_math_BigInt__f__bigInteger)
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z(that))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo + lo$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (~hi$3);
    var hi$5 = (hi ^ hi$2);
    var hi$6 = (hi$4 & hi$5);
    if ((hi$6 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2))
    }
  };
  var $$x1 = $m_s_math_BigInt$();
  var this$2 = this.bigInteger__Ljava_math_BigInteger();
  var bi = that.bigInteger__Ljava_math_BigInteger();
  return $$x1.apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi))
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      return (-1)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return ((lo !== 0) ? ((lo === 0) ? 32 : ((31 - Math.clz32((lo & ((-lo) | 0)))) | 0)) : ((32 + ((hi === 0) ? 32 : ((31 - Math.clz32((hi & ((-hi) | 0)))) | 0))) | 0))
    }
  } else {
    return this.bigInteger__Ljava_math_BigInteger().getLowestSetBit__I()
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      var b = this.s_math_BigInt__f__long;
      var bhi = b.RTLong__f_hi;
      var lo = ((1 + b.RTLong__f_lo) | 0);
      var hi = ((lo === 0) ? ((1 + bhi) | 0) : bhi);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo$2 = t.RTLong__f_lo;
      var hi$2 = t.RTLong__f_hi;
      return ((64 - ((hi$2 !== 0) ? Math.clz32(hi$2) : ((32 + Math.clz32(lo$2)) | 0))) | 0)
    }
  } else {
    var this$7 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$7)
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24)
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16)
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return this$1.RTLong__f_lo
  } else {
    return this.bigInteger__Ljava_math_BigInteger().intValue__I()
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? this.s_math_BigInt__f__long : this.s_math_BigInt__f__bigInteger.longValue__J())
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = this.bigInteger__Ljava_math_BigInteger();
  var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  return $m_jl_Float$().parseFloat__T__F(s)
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi >= (-2097152))) {
      var this$2 = this.s_math_BigInt__f__long;
      var ahi$1 = this$2.RTLong__f_hi;
      var $$x1 = ((ahi$1 === 2097152) ? (this$2.RTLong__f_lo === 0) : (ahi$1 < 2097152))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$3 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi)
  } else {
    var this$4 = this.bigInteger__Ljava_math_BigInteger();
    var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4);
    return $m_jl_Double$().parseDouble__T__D(s)
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
  } else {
    var this$2 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2)
  }
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.bigInteger__Ljava_math_BigInteger()
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"))
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)))
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth))
}
var $d_s_math_BigInt = new $TypeData().initClass({
  s_math_BigInt: 0
}, false, "scala.math.BigInt", {
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigInt.prototype.$classData = $d_s_math_BigInt;
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this)
}
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
  /*<skip>*/
}
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Int$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1))
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass({
  s_math_Ordering$Int$: 0
}, false, "scala.math.Ordering$Int$", {
  s_math_Ordering$Int$: 1,
  O: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
});
$c_s_math_Ordering$Int$.prototype.$classData = $d_s_math_Ordering$Int$;
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$()
  };
  return $n_s_math_Ordering$Int$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf()
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf()
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf()
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf()
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf()
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf()
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf()
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf()
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf()
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len)
});
/** @constructor */
function $c_Ltyrian_Cmd$Empty$() {
  /*<skip>*/
}
$c_Ltyrian_Cmd$Empty$.prototype = new $h_O();
$c_Ltyrian_Cmd$Empty$.prototype.constructor = $c_Ltyrian_Cmd$Empty$;
/** @constructor */
function $h_Ltyrian_Cmd$Empty$() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Empty$.prototype = $c_Ltyrian_Cmd$Empty$.prototype;
$c_Ltyrian_Cmd$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
$c_Ltyrian_Cmd$Empty$.prototype.toString__T = (function() {
  return "Empty"
});
$c_Ltyrian_Cmd$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_Cmd$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Ltyrian_Cmd$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Ltyrian_Cmd$Empty$ = new $TypeData().initClass({
  Ltyrian_Cmd$Empty$: 0
}, false, "tyrian.Cmd$Empty$", {
  Ltyrian_Cmd$Empty$: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_Cmd$Empty$.prototype.$classData = $d_Ltyrian_Cmd$Empty$;
var $n_Ltyrian_Cmd$Empty$;
function $m_Ltyrian_Cmd$Empty$() {
  if ((!$n_Ltyrian_Cmd$Empty$)) {
    $n_Ltyrian_Cmd$Empty$ = new $c_Ltyrian_Cmd$Empty$()
  };
  return $n_Ltyrian_Cmd$Empty$
}
/** @constructor */
function $c_Ltyrian_Sub$Empty$() {
  /*<skip>*/
}
$c_Ltyrian_Sub$Empty$.prototype = new $h_O();
$c_Ltyrian_Sub$Empty$.prototype.constructor = $c_Ltyrian_Sub$Empty$;
/** @constructor */
function $h_Ltyrian_Sub$Empty$() {
  /*<skip>*/
}
$h_Ltyrian_Sub$Empty$.prototype = $c_Ltyrian_Sub$Empty$.prototype;
$c_Ltyrian_Sub$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Sub$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
$c_Ltyrian_Sub$Empty$.prototype.toString__T = (function() {
  return "Empty"
});
$c_Ltyrian_Sub$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_Sub$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Ltyrian_Sub$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Ltyrian_Sub$Empty$.prototype.map__F1__Ltyrian_Sub = (function(f) {
  return this
});
var $d_Ltyrian_Sub$Empty$ = new $TypeData().initClass({
  Ltyrian_Sub$Empty$: 0
}, false, "tyrian.Sub$Empty$", {
  Ltyrian_Sub$Empty$: 1,
  O: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_Sub$Empty$.prototype.$classData = $d_Ltyrian_Sub$Empty$;
var $n_Ltyrian_Sub$Empty$;
function $m_Ltyrian_Sub$Empty$() {
  if ((!$n_Ltyrian_Sub$Empty$)) {
    $n_Ltyrian_Sub$Empty$ = new $c_Ltyrian_Sub$Empty$()
  };
  return $n_Ltyrian_Sub$Empty$
}
/** @constructor */
function $c_Lcats_data_WriterTInstances5() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances5.prototype = new $h_Lcats_data_WriterTInstances6();
$c_Lcats_data_WriterTInstances5.prototype.constructor = $c_Lcats_data_WriterTInstances5;
/** @constructor */
function $h_Lcats_data_WriterTInstances5() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances5.prototype = $c_Lcats_data_WriterTInstances5.prototype;
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq = (function(fa, fb) {
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2(((fa$2, fb$2) => ((left, right) => {
    var left$1 = $as_T2(left);
    var right$1 = $as_T2(right);
    return (fa$2.eqv__O__O__Z(left$1._1__O(), right$1._1__O()) && fb$2.eqv__O__O__Z(left$1._2__O(), right$1._2__O()))
  }))(fa, fb));
  return new $c_Lcats_kernel_Eq$$anon$4(f)
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq($as_Lcats_kernel_Eq(fa), $as_Lcats_kernel_Eq(fb))
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EqInstances$$anon$1: 0
}, false, "cats.instances.EqInstances$$anon$1", {
  Lcats_instances_EqInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Equiv(fa);
  var fb$1 = $as_s_math_Equiv(fb);
  return new $c_Lcats_instances_EquivInstances$$anon$4(fa$1, fb$1)
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$1: 0
}, false, "cats.instances.EquivInstances$$anon$1", {
  Lcats_instances_EquivInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var fb$1 = $as_Lcats_kernel_Order(fb);
  return new $c_Lcats_instances_OrderInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$1: 0
}, false, "cats.instances.OrderInstances$$anon$1", {
  Lcats_instances_OrderInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Ordering(fa);
  var fb$1 = $as_s_math_Ordering(fb);
  return new $c_Lcats_instances_OrderingInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$1: 0
}, false, "cats.instances.OrderingInstances$$anon$1", {
  Lcats_instances_OrderingInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var fb$1 = $as_Lcats_kernel_PartialOrder(fb);
  return new $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderInstances$$anon$1", {
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  var fb$1 = $as_s_math_PartialOrdering(fb);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$1", {
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_BitSet(x);
  var y$1 = $as_sci_BitSet(y);
  return $as_sci_BitSet($f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(x$1, y$1))
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetSemilattice: 0
}, false, "cats.kernel.instances.BitSetSemilattice", {
  Lcats_kernel_instances_BitSetSemilattice: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.$classData = $d_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $c_Lcats_kernel_instances_DeadlineOrder() {
  this.Lcats_kernel_instances_DeadlineOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_DeadlineOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_DeadlineOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DeadlineOrder.prototype.constructor = $c_Lcats_kernel_instances_DeadlineOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DeadlineOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DeadlineOrder.prototype = $c_Lcats_kernel_instances_DeadlineOrder.prototype;
$c_Lcats_kernel_instances_DeadlineOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.compare__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__I = (function(x, y) {
  return (((x === null) ? (y === null) : x.equals__O__Z(y)) ? 0 : (x.$greater__O__Z(y) ? 1 : (-1)))
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.eqv__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y))
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.neqv__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : x.equals__O__Z(y)))
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_Deadline(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__I($as_s_concurrent_duration_Deadline(x), $as_s_concurrent_duration_Deadline(y))
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__Z($as_s_concurrent_duration_Deadline(x), $as_s_concurrent_duration_Deadline(y))
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_Deadline__s_concurrent_duration_Deadline__Z($as_s_concurrent_duration_Deadline(x), $as_s_concurrent_duration_Deadline(y))
});
var $d_Lcats_kernel_instances_DeadlineOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DeadlineOrder: 0
}, false, "cats.kernel.instances.DeadlineOrder", {
  Lcats_kernel_instances_DeadlineOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DeadlineBounded: 1
});
$c_Lcats_kernel_instances_DeadlineOrder.prototype.$classData = $d_Lcats_kernel_instances_DeadlineOrder;
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
  this.Lcats_kernel_instances_DurationOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_DurationOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_DurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : x.equals__O__Z(y)))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return x$1.compare__s_concurrent_duration_Duration__I(y$1)
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y))
});
var $d_Lcats_kernel_instances_DurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DurationOrder: 0
}, false, "cats.kernel.instances.DurationOrder", {
  Lcats_kernel_instances_DurationOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DurationBounded: 1
});
$c_Lcats_kernel_instances_DurationOrder.prototype.$classData = $d_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
  this.Lcats_kernel_instances_FiniteDurationOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_FiniteDurationOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : x.equals__O__Z(y)))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var this$1 = x$1.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x$1.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return x$1.compare__s_concurrent_duration_Duration__I(y$1)
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y))
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationOrder: 0
}, false, "cats.kernel.instances.FiniteDurationOrder", {
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UUIDInstances$$anon$1() {
  this.Lcats_kernel_instances_UUIDInstances$$anon$1__f_partialOrder = null;
  this.Lcats_kernel_instances_UUIDInstances$$anon$1__f_partialOrder = this
}
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.constructor = $c_Lcats_kernel_instances_UUIDInstances$$anon$1;
/** @constructor */
function $h_Lcats_kernel_instances_UUIDInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = $c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype;
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_ju_UUID(x);
  var y$1 = $as_ju_UUID(y);
  return x$1.compareTo__ju_UUID__I(y$1)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.hash__O__I = (function(x) {
  var x$1 = $as_ju_UUID(x);
  return x$1.hashCode__I()
});
var $d_Lcats_kernel_instances_UUIDInstances$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_instances_UUIDInstances$$anon$1: 0
}, false, "cats.kernel.instances.UUIDInstances$$anon$1", {
  Lcats_kernel_instances_UUIDInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UUIDBounded: 1
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.$classData = $d_Lcats_kernel_instances_UUIDInstances$$anon$1;
/** @constructor */
function $c_Lio_circe_CursorOp$DeleteGoParent$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.constructor = $c_Lio_circe_CursorOp$DeleteGoParent$;
/** @constructor */
function $h_Lio_circe_CursorOp$DeleteGoParent$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DeleteGoParent$.prototype = $c_Lio_circe_CursorOp$DeleteGoParent$.prototype;
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.hashCode__I = (function() {
  return (-1822060899)
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.toString__T = (function() {
  return "DeleteGoParent"
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productPrefix__T = (function() {
  return "DeleteGoParent"
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lio_circe_CursorOp$DeleteGoParent$ = new $TypeData().initClass({
  Lio_circe_CursorOp$DeleteGoParent$: 0
}, false, "io.circe.CursorOp$DeleteGoParent$", {
  Lio_circe_CursorOp$DeleteGoParent$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.$classData = $d_Lio_circe_CursorOp$DeleteGoParent$;
var $n_Lio_circe_CursorOp$DeleteGoParent$;
function $m_Lio_circe_CursorOp$DeleteGoParent$() {
  if ((!$n_Lio_circe_CursorOp$DeleteGoParent$)) {
    $n_Lio_circe_CursorOp$DeleteGoParent$ = new $c_Lio_circe_CursorOp$DeleteGoParent$()
  };
  return $n_Lio_circe_CursorOp$DeleteGoParent$
}
/** @constructor */
function $c_Lio_circe_CursorOp$DownArray$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$DownArray$.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownArray$.prototype.constructor = $c_Lio_circe_CursorOp$DownArray$;
/** @constructor */
function $h_Lio_circe_CursorOp$DownArray$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DownArray$.prototype = $c_Lio_circe_CursorOp$DownArray$.prototype;
$c_Lio_circe_CursorOp$DownArray$.prototype.hashCode__I = (function() {
  return (-1017900361)
});
$c_Lio_circe_CursorOp$DownArray$.prototype.toString__T = (function() {
  return "DownArray"
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productPrefix__T = (function() {
  return "DownArray"
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lio_circe_CursorOp$DownArray$ = new $TypeData().initClass({
  Lio_circe_CursorOp$DownArray$: 0
}, false, "io.circe.CursorOp$DownArray$", {
  Lio_circe_CursorOp$DownArray$: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_CursorOp$DownArray$.prototype.$classData = $d_Lio_circe_CursorOp$DownArray$;
var $n_Lio_circe_CursorOp$DownArray$;
function $m_Lio_circe_CursorOp$DownArray$() {
  if ((!$n_Lio_circe_CursorOp$DownArray$)) {
    $n_Lio_circe_CursorOp$DownArray$ = new $c_Lio_circe_CursorOp$DownArray$()
  };
  return $n_Lio_circe_CursorOp$DownArray$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveLeft$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveLeft$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveLeft$.prototype.constructor = $c_Lio_circe_CursorOp$MoveLeft$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveLeft$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveLeft$.prototype = $c_Lio_circe_CursorOp$MoveLeft$.prototype;
$c_Lio_circe_CursorOp$MoveLeft$.prototype.hashCode__I = (function() {
  return (-40017000)
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.toString__T = (function() {
  return "MoveLeft"
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productPrefix__T = (function() {
  return "MoveLeft"
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lio_circe_CursorOp$MoveLeft$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveLeft$: 0
}, false, "io.circe.CursorOp$MoveLeft$", {
  Lio_circe_CursorOp$MoveLeft$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.$classData = $d_Lio_circe_CursorOp$MoveLeft$;
var $n_Lio_circe_CursorOp$MoveLeft$;
function $m_Lio_circe_CursorOp$MoveLeft$() {
  if ((!$n_Lio_circe_CursorOp$MoveLeft$)) {
    $n_Lio_circe_CursorOp$MoveLeft$ = new $c_Lio_circe_CursorOp$MoveLeft$()
  };
  return $n_Lio_circe_CursorOp$MoveLeft$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveRight$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveRight$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveRight$.prototype.constructor = $c_Lio_circe_CursorOp$MoveRight$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveRight$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveRight$.prototype = $c_Lio_circe_CursorOp$MoveRight$.prototype;
$c_Lio_circe_CursorOp$MoveRight$.prototype.hashCode__I = (function() {
  return (-1234866005)
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.toString__T = (function() {
  return "MoveRight"
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productPrefix__T = (function() {
  return "MoveRight"
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lio_circe_CursorOp$MoveRight$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveRight$: 0
}, false, "io.circe.CursorOp$MoveRight$", {
  Lio_circe_CursorOp$MoveRight$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.$classData = $d_Lio_circe_CursorOp$MoveRight$;
var $n_Lio_circe_CursorOp$MoveRight$;
function $m_Lio_circe_CursorOp$MoveRight$() {
  if ((!$n_Lio_circe_CursorOp$MoveRight$)) {
    $n_Lio_circe_CursorOp$MoveRight$ = new $c_Lio_circe_CursorOp$MoveRight$()
  };
  return $n_Lio_circe_CursorOp$MoveRight$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveUp$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveUp$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveUp$.prototype.constructor = $c_Lio_circe_CursorOp$MoveUp$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveUp$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveUp$.prototype = $c_Lio_circe_CursorOp$MoveUp$.prototype;
$c_Lio_circe_CursorOp$MoveUp$.prototype.hashCode__I = (function() {
  return (-1984396692)
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.toString__T = (function() {
  return "MoveUp"
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productPrefix__T = (function() {
  return "MoveUp"
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lio_circe_CursorOp$MoveUp$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveUp$: 0
}, false, "io.circe.CursorOp$MoveUp$", {
  Lio_circe_CursorOp$MoveUp$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.$classData = $d_Lio_circe_CursorOp$MoveUp$;
var $n_Lio_circe_CursorOp$MoveUp$;
function $m_Lio_circe_CursorOp$MoveUp$() {
  if ((!$n_Lio_circe_CursorOp$MoveUp$)) {
    $n_Lio_circe_CursorOp$MoveUp$ = new $c_Lio_circe_CursorOp$MoveUp$()
  };
  return $n_Lio_circe_CursorOp$MoveUp$
}
/** @constructor */
function $c_Lio_circe_Decoder$() {
  this.Lio_circe_Decoder$__f_resultInstance = null;
  this.Lio_circe_Decoder$__f_accumulatingResultInstance = null;
  this.Lio_circe_Decoder$__f_resultSemigroupK = null;
  this.Lio_circe_Decoder$__f_decodeHCursor = null;
  this.Lio_circe_Decoder$__f_decodeJson = null;
  this.Lio_circe_Decoder$__f_decodeJsonObject = null;
  this.Lio_circe_Decoder$__f_decodeJsonNumber = null;
  this.Lio_circe_Decoder$__f_decodeString = null;
  this.Lio_circe_Decoder$__f_decodeUnit = null;
  this.Lio_circe_Decoder$__f_decodeBoolean = null;
  this.Lio_circe_Decoder$__f_decodeJavaBoolean$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaBooleanbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeChar = null;
  this.Lio_circe_Decoder$__f_decodeJavaCharacter$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaCharacterbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeFloat = null;
  this.Lio_circe_Decoder$__f_decodeJavaFloat$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaFloatbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeDouble = null;
  this.Lio_circe_Decoder$__f_decodeJavaDouble$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaDoublebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeByte = null;
  this.Lio_circe_Decoder$__f_decodeJavaByte$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaBytebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeShort = null;
  this.Lio_circe_Decoder$__f_decodeJavaShort$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaShortbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeInt = null;
  this.Lio_circe_Decoder$__f_decodeJavaInteger$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaIntegerbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeLong = null;
  this.Lio_circe_Decoder$__f_decodeJavaLong$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaLongbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeBigInt = null;
  this.Lio_circe_Decoder$__f_decodeJavaBigInteger$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaBigIntegerbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeBigDecimal = null;
  this.Lio_circe_Decoder$__f_decodeJavaBigDecimal$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeJavaBigDecimalbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeUUID$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeUUIDbitmap$1 = false;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = null;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$validNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNoneAccumulating = null;
  this.Lio_circe_Decoder$__f_decodeNone = null;
  this.Lio_circe_Decoder$__f_decodeDuration$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeDurationbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeInstant$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeInstantbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodePeriod$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodePeriodbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeZoneId$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeZoneIdbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeLocalDate$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeLocalDatebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeLocalTime$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeLocalTimebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeLocalDateTime$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeLocalDateTimebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeMonthDay$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeMonthDaybitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeOffsetTime$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeOffsetTimebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeOffsetDateTime$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeOffsetDateTimebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeYear$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeYearbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeYearMonth$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeYearMonthbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeZonedDateTime$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeZonedDateTimebitmap$1 = false;
  this.Lio_circe_Decoder$__f_decodeZoneOffset$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeZoneOffsetbitmap$1 = false;
  this.Lio_circe_Decoder$__f_decoderInstances = null;
  this.Lio_circe_Decoder$__f_currencyDecoder$lzy1 = null;
  this.Lio_circe_Decoder$__f_currencyDecoderbitmap$1 = false;
  $n_Lio_circe_Decoder$ = this;
  this.Lio_circe_Decoder$__f_resultInstance = ($m_Lcats_instances_package$either$(), new $c_Lcats_instances_EitherInstances$$anon$2());
  $m_Lcats_data_Validated$();
  var E = $m_Lcats_data_NonEmptyList$().catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup();
  this.Lio_circe_Decoder$__f_accumulatingResultInstance = new $c_Lcats_data_ValidatedInstances$$anon$7(E);
  this.Lio_circe_Decoder$__f_resultSemigroupK = ($m_Lcats_instances_package$either$(), new $c_Lcats_instances_EitherInstances$$anon$3());
  this.Lio_circe_Decoder$__f_decodeHCursor = new $c_Lio_circe_Decoder$$anon$15();
  this.Lio_circe_Decoder$__f_decodeJson = new $c_Lio_circe_Decoder$$anon$16();
  this.Lio_circe_Decoder$__f_decodeJsonObject = new $c_Lio_circe_Decoder$$anon$17();
  this.Lio_circe_Decoder$__f_decodeJsonNumber = new $c_Lio_circe_Decoder$$anon$18();
  this.Lio_circe_Decoder$__f_decodeString = new $c_Lio_circe_Decoder$$anon$19();
  this.Lio_circe_Decoder$__f_decodeUnit = new $c_Lio_circe_Decoder$$anon$20();
  this.Lio_circe_Decoder$__f_decodeBoolean = new $c_Lio_circe_Decoder$$anon$21();
  this.Lio_circe_Decoder$__f_decodeChar = new $c_Lio_circe_Decoder$$anon$22();
  this.Lio_circe_Decoder$__f_decodeFloat = new $c_Lio_circe_Decoder$$anon$23();
  this.Lio_circe_Decoder$__f_decodeDouble = new $c_Lio_circe_Decoder$$anon$24();
  this.Lio_circe_Decoder$__f_decodeByte = new $c_Lio_circe_Decoder$$anon$25();
  this.Lio_circe_Decoder$__f_decodeShort = new $c_Lio_circe_Decoder$$anon$26();
  this.Lio_circe_Decoder$__f_decodeInt = new $c_Lio_circe_Decoder$$anon$27();
  this.Lio_circe_Decoder$__f_decodeLong = new $c_Lio_circe_Decoder$$anon$28();
  this.Lio_circe_Decoder$__f_decodeBigInt = new $c_Lio_circe_Decoder$$anon$29();
  this.Lio_circe_Decoder$__f_decodeBigDecimal = new $c_Lio_circe_Decoder$$anon$30();
  $m_s_package$();
  var value = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = new $c_s_util_Right(value);
  $m_Lcats_data_Validated$();
  var a = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$validNone = new $c_Lcats_data_Validated$Valid(a);
  $m_s_package$();
  var value$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNone = new $c_s_util_Right(value$1);
  $m_Lcats_data_Validated$();
  var a$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNoneAccumulating = new $c_Lcats_data_Validated$Valid(a$1);
  this.Lio_circe_Decoder$__f_decodeNone = new $c_Lio_circe_Decoder$$anon$31();
  this.Lio_circe_Decoder$__f_decoderInstances = new $c_Lio_circe_Decoder$$anon$32()
}
$c_Lio_circe_Decoder$.prototype = new $h_O();
$c_Lio_circe_Decoder$.prototype.constructor = $c_Lio_circe_Decoder$;
/** @constructor */
function $h_Lio_circe_Decoder$() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$.prototype = $c_Lio_circe_Decoder$.prototype;
$c_Lio_circe_Decoder$.prototype.decodeZonedDateTime__Lio_circe_Decoder = (function() {
  if ((!this.Lio_circe_Decoder$__f_decodeZonedDateTimebitmap$1)) {
    this.Lio_circe_Decoder$__f_decodeZonedDateTime$lzy1 = new $c_Lio_circe_Decoder$$anon$76();
    this.Lio_circe_Decoder$__f_decodeZonedDateTimebitmap$1 = true
  };
  return this.Lio_circe_Decoder$__f_decodeZonedDateTime$lzy1
});
var $d_Lio_circe_Decoder$ = new $TypeData().initClass({
  Lio_circe_Decoder$: 0
}, false, "io.circe.Decoder$", {
  Lio_circe_Decoder$: 1,
  O: 1,
  Lio_circe_DecoderDerivation: 1,
  Lio_circe_LowPriorityCollectionDecoders: 1,
  Lio_circe_CollectionDecoders: 1,
  Lio_circe_TupleDecoders: 1,
  Lio_circe_ProductDecoders: 1,
  Lio_circe_LiteralDecoders: 1,
  Lio_circe_EnumerationDecoders: 1,
  Lio_circe_LowPriorityDecoders: 1
});
$c_Lio_circe_Decoder$.prototype.$classData = $d_Lio_circe_Decoder$;
var $n_Lio_circe_Decoder$;
function $m_Lio_circe_Decoder$() {
  if ((!$n_Lio_circe_Decoder$)) {
    $n_Lio_circe_Decoder$ = new $c_Lio_circe_Decoder$()
  };
  return $n_Lio_circe_Decoder$
}
function $ct_Ljava_time_DayOfWeek__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_DayOfWeek__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_DayOfWeek() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0
}
$c_Ljava_time_DayOfWeek.prototype = new $h_jl_Enum();
$c_Ljava_time_DayOfWeek.prototype.constructor = $c_Ljava_time_DayOfWeek;
/** @constructor */
function $h_Ljava_time_DayOfWeek() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek.prototype = $c_Ljava_time_DayOfWeek.prototype;
$c_Ljava_time_DayOfWeek.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_DayOfWeek.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_DayOfWeek__f_ordinal) | 0)
});
$c_Ljava_time_DayOfWeek.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_DayOfWeek.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return field.Ljava_time_temporal_ChronoField__f__range
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
});
$c_Ljava_time_DayOfWeek.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field))
});
$c_Ljava_time_DayOfWeek.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_DayOfWeek.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_DayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x1 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  var value = this.getValue__I();
  var hi = (value >> 31);
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
function $as_Ljava_time_DayOfWeek(obj) {
  return (((obj instanceof $c_Ljava_time_DayOfWeek) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.DayOfWeek"))
}
function $isArrayOf_Ljava_time_DayOfWeek(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_DayOfWeek)))
}
function $asArrayOf_Ljava_time_DayOfWeek(obj, depth) {
  return (($isArrayOf_Ljava_time_DayOfWeek(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.DayOfWeek;", depth))
}
var $d_Ljava_time_DayOfWeek = new $TypeData().initClass({
  Ljava_time_DayOfWeek: 0
}, false, "java.time.DayOfWeek", {
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_DayOfWeek.prototype.$classData = $d_Ljava_time_DayOfWeek;
function $ct_Ljava_time_Month__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_Month__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_Month() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0
}
$c_Ljava_time_Month.prototype = new $h_jl_Enum();
$c_Ljava_time_Month.prototype.constructor = $c_Ljava_time_Month;
/** @constructor */
function $h_Ljava_time_Month() {
  /*<skip>*/
}
$h_Ljava_time_Month.prototype = $c_Ljava_time_Month.prototype;
$c_Ljava_time_Month.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ljava_time_Month.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_Month__f_ordinal) | 0)
});
$c_Ljava_time_Month.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.isSupported__Ljava_time_temporal_TemporalField__Z(field)))
});
$c_Ljava_time_Month.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return field.Ljava_time_temporal_ChronoField__f__range
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
  }
});
$c_Ljava_time_Month.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field))
});
$c_Ljava_time_Month.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return this.getLong__Ljava_time_temporal_TemporalField__J(field)
  }
});
$c_Ljava_time_Month.prototype.plus__J__Ljava_time_Month = (function(months) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(months.RTLong__f_lo, months.RTLong__f_hi, 12, 0);
  return $m_Ljava_time_Month$().java$time$Month$$$ENUMS__ALjava_time_Month().get(((((this.Ljava_time_Month__f_ordinal + ((12 + lo) | 0)) | 0) % 12) | 0))
});
$c_Ljava_time_Month.prototype.length__Z__I = (function(leapYear) {
  var x = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return (leapYear ? 29 : 28)
  };
  matchAlts1: {
    matchAlts2: {
      var x$3 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
      if (((x$3 !== null) && (x$3 === this))) {
        break matchAlts2
      };
      var x$5 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
      if (((x$5 !== null) && (x$5 === this))) {
        break matchAlts2
      };
      var x$7 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
      if (((x$7 !== null) && (x$7 === this))) {
        break matchAlts2
      };
      var x$9 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
      if (((x$9 !== null) && (x$9 === this))) {
        break matchAlts2
      };
      break matchAlts1
    };
    return 30
  };
  return 31
});
$c_Ljava_time_Month.prototype.firstDayOfYear__Z__I = (function(leapYear) {
  var leap = (leapYear ? 1 : 0);
  var x = $s_Ljava_time_Month$__JANUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return 1
  };
  var x$3 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x$3 !== null) && (x$3 === this))) {
    return 32
  };
  var x$5 = $s_Ljava_time_Month$__MARCH__Ljava_time_Month();
  if (((x$5 !== null) && (x$5 === this))) {
    return ((60 + leap) | 0)
  };
  var x$7 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
  if (((x$7 !== null) && (x$7 === this))) {
    return ((91 + leap) | 0)
  };
  var x$9 = $s_Ljava_time_Month$__MAY__Ljava_time_Month();
  if (((x$9 !== null) && (x$9 === this))) {
    return ((121 + leap) | 0)
  };
  var x$11 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
  if (((x$11 !== null) && (x$11 === this))) {
    return ((152 + leap) | 0)
  };
  var x$13 = $s_Ljava_time_Month$__JULY__Ljava_time_Month();
  if (((x$13 !== null) && (x$13 === this))) {
    return ((182 + leap) | 0)
  };
  var x$15 = $s_Ljava_time_Month$__AUGUST__Ljava_time_Month();
  if (((x$15 !== null) && (x$15 === this))) {
    return ((213 + leap) | 0)
  };
  var x$17 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
  if (((x$17 !== null) && (x$17 === this))) {
    return ((244 + leap) | 0)
  };
  var x$19 = $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month();
  if (((x$19 !== null) && (x$19 === this))) {
    return ((274 + leap) | 0)
  };
  var x$21 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
  if (((x$21 !== null) && (x$21 === this))) {
    return ((305 + leap) | 0)
  };
  var x$23 = $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month();
  if (((x$23 !== null) && (x$23 === this))) {
    return ((335 + leap) | 0)
  };
  throw new $c_s_MatchError(this)
});
$c_Ljava_time_Month.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology() : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))))
});
$c_Ljava_time_Month.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((!((x === null) ? (x$2 === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Adjustment only supported on ISO date-time")
  } else {
    var $$x1 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var value = this.getValue__I();
    var hi = (value >> 31);
    return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
  }
});
function $as_Ljava_time_Month(obj) {
  return (((obj instanceof $c_Ljava_time_Month) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Month"))
}
function $isArrayOf_Ljava_time_Month(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Month)))
}
function $asArrayOf_Ljava_time_Month(obj, depth) {
  return (($isArrayOf_Ljava_time_Month(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Month;", depth))
}
var $d_Ljava_time_Month = new $TypeData().initClass({
  Ljava_time_Month: 0
}, false, "java.time.Month", {
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
});
$c_Ljava_time_Month.prototype.$classData = $d_Ljava_time_Month;
function $ct_ju_ArrayList__sjs_js_Array__($thiz, inner) {
  $thiz.ju_ArrayList__f_java$util$ArrayList$$inner = inner;
  return $thiz
}
function $ct_ju_ArrayList__($thiz) {
  $ct_ju_ArrayList__sjs_js_Array__($thiz, []);
  return $thiz
}
function $ct_ju_ArrayList__ju_Collection__($thiz, c) {
  $ct_ju_ArrayList__($thiz);
  $thiz.addAll__ju_Collection__Z(c);
  return $thiz
}
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f_java$util$ArrayList$$inner = null
}
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
  /*<skip>*/
}
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return $uI(this.ju_ArrayList__f_java$util$ArrayList$$inner.length)
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_java$util$ArrayList$$inner[index]
});
$c_ju_ArrayList.prototype.set__I__O__O = (function(index, element) {
  var e = this.get__I__O(index);
  this.ju_ArrayList__f_java$util$ArrayList$$inner[index] = element;
  return e
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  var array = this.ju_ArrayList__f_java$util$ArrayList$$inner;
  array.push(e);
  return true
});
$c_ju_ArrayList.prototype.add__I__O__V = (function(index, element) {
  this.checkIndexOnBounds__I__V(index);
  var $$x1 = $m_sjs_js_ArrayOps$();
  var array = this.ju_ArrayList__f_java$util$ArrayList$$inner;
  $$x1.insert$extension__sjs_js_Array__I__O__V(array, index, element)
});
$c_ju_ArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var $$x1 = $m_sjs_js_ArrayOps$();
  var array = this.ju_ArrayList__f_java$util$ArrayList$$inner;
  return $$x1.remove$extension__sjs_js_Array__I__O(array, index)
});
var $d_ju_ArrayList = new $TypeData().initClass({
  ju_ArrayList: 0
}, false, "java.util.ArrayList", {
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ArrayList.prototype.$classData = $d_ju_ArrayList;
function $ct_ju_Collections$UnmodifiableList__ju_List__($thiz, inner) {
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableList() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false
}
$c_ju_Collections$UnmodifiableList.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableList.prototype.constructor = $c_ju_Collections$UnmodifiableList;
/** @constructor */
function $h_ju_Collections$UnmodifiableList() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableList.prototype = $c_ju_Collections$UnmodifiableList.prototype;
$c_ju_Collections$UnmodifiableList.prototype.get__I__O = (function(index) {
  return $as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner).get__I__O(index)
});
$c_ju_Collections$UnmodifiableList.prototype.equals__O__Z = (function(obj) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.equals__O__Z(obj)
});
$c_ju_Collections$UnmodifiableList.prototype.hashCode__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.hashCode__I()
});
$c_ju_Collections$UnmodifiableList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableList.prototype.listIterator__ju_ListIterator = (function() {
  return new $c_ju_Collections$UnmodifiableListIterator($as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner).listIterator__ju_ListIterator())
});
/** @constructor */
function $c_ju_Collections$UnmodifiableSet(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__(this, inner)
}
$c_ju_Collections$UnmodifiableSet.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableSet.prototype.constructor = $c_ju_Collections$UnmodifiableSet;
/** @constructor */
function $h_ju_Collections$UnmodifiableSet() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableSet.prototype = $c_ju_Collections$UnmodifiableSet.prototype;
$c_ju_Collections$UnmodifiableSet.prototype.equals__O__Z = (function(obj) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.equals__O__Z(obj)
});
$c_ju_Collections$UnmodifiableSet.prototype.hashCode__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.hashCode__I()
});
var $d_ju_Collections$UnmodifiableSet = new $TypeData().initClass({
  ju_Collections$UnmodifiableSet: 0
}, false, "java.util.Collections$UnmodifiableSet", {
  ju_Collections$UnmodifiableSet: 1,
  ju_Collections$UnmodifiableCollection: 1,
  O: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedSet: 1,
  ju_Collections$WrappedEquals: 1,
  ju_Set: 1
});
$c_ju_Collections$UnmodifiableSet.prototype.$classData = $d_ju_Collections$UnmodifiableSet;
/** @constructor */
function $c_sc_AbstractView() {
  /*<skip>*/
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
  /*<skip>*/
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View"
});
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  } else if ($is_sc_Set(that)) {
    var x2 = $as_sc_Set(that);
    if (($thiz.size__I() === x2.size__I())) {
      try {
        return $thiz.subsetOf__sc_Set__Z(x2)
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false
        } else {
          throw e
        }
      }
    } else {
      return false
    }
  } else {
    return false
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)))
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"))
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)))
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth))
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $as_sci_SetOps($thiz);
  var it = that.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var this$1 = result;
    var elem = it.next__O();
    result = this$1.incl__O__sci_SetOps(elem)
  };
  return result
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$AnyManifest$: 0
}, false, "scala.reflect.ManifestFactory$AnyManifest$", {
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$AnyManifest$;
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$()
  };
  return $n_s_reflect_ManifestFactory$AnyManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$BooleanManifest$: 0
}, false, "scala.reflect.ManifestFactory$BooleanManifest$", {
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$BooleanManifest$;
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$()
  };
  return $n_s_reflect_ManifestFactory$BooleanManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ByteManifest$: 0
}, false, "scala.reflect.ManifestFactory$ByteManifest$", {
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ByteManifest$;
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$()
  };
  return $n_s_reflect_ManifestFactory$ByteManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Char";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$CharManifest$: 0
}, false, "scala.reflect.ManifestFactory$CharManifest$", {
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$CharManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$CharManifest$;
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$()
  };
  return $n_s_reflect_ManifestFactory$CharManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Double";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$DoubleManifest$: 0
}, false, "scala.reflect.ManifestFactory$DoubleManifest$", {
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$DoubleManifest$;
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$()
  };
  return $n_s_reflect_ManifestFactory$DoubleManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Float";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$FloatManifest$: 0
}, false, "scala.reflect.ManifestFactory$FloatManifest$", {
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$FloatManifest$;
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$()
  };
  return $n_s_reflect_ManifestFactory$FloatManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Int";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$IntManifest$: 0
}, false, "scala.reflect.ManifestFactory$IntManifest$", {
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$IntManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$IntManifest$;
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$()
  };
  return $n_s_reflect_ManifestFactory$IntManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Long";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$LongManifest$: 0
}, false, "scala.reflect.ManifestFactory$LongManifest$", {
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$LongManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$LongManifest$;
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$()
  };
  return $n_s_reflect_ManifestFactory$LongManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Nothing$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf()
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NothingManifest$: 0
}, false, "scala.reflect.ManifestFactory$NothingManifest$", {
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NothingManifest$;
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$()
  };
  return $n_s_reflect_ManifestFactory$NothingManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Null$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf()
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NullManifest$: 0
}, false, "scala.reflect.ManifestFactory$NullManifest$", {
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NullManifest$;
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$()
  };
  return $n_s_reflect_ManifestFactory$NullManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ObjectManifest$: 0
}, false, "scala.reflect.ManifestFactory$ObjectManifest$", {
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ObjectManifest$;
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$()
  };
  return $n_s_reflect_ManifestFactory$ObjectManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Short";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ShortManifest$: 0
}, false, "scala.reflect.ManifestFactory$ShortManifest$", {
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ShortManifest$;
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$()
  };
  return $n_s_reflect_ManifestFactory$ShortManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$UnitManifest$: 0
}, false, "scala.reflect.ManifestFactory$UnitManifest$", {
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$UnitManifest$;
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$()
  };
  return $n_s_reflect_ManifestFactory$UnitManifest$
}
function $f_Lcats_ApplicativeError__fromTry__s_util_Try__s_$less$colon$less__O($thiz, t, ev) {
  if ((t instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(t).s_util_Success__f_value;
    return $thiz.pure__O__O(a)
  };
  if ((t instanceof $c_s_util_Failure)) {
    var e = $as_s_util_Failure(t).s_util_Failure__f_exception;
    return $thiz.raiseError__O__O(e)
  };
  throw new $c_s_MatchError(t)
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0$$anon$1() {
  this.Lcats_data_AndThenInstances0$$anon$1__f_fn1 = null;
  this.Lcats_data_AndThenInstances0$$anon$1__f_fn1 = $m_Lcats_instances_package$all$().Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1
}
$c_Lcats_data_AndThenInstances0$$anon$1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.constructor = $c_Lcats_data_AndThenInstances0$$anon$1;
/** @constructor */
function $h_Lcats_data_AndThenInstances0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances0$$anon$1.prototype = $c_Lcats_data_AndThenInstances0$$anon$1.prototype;
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.lift__F1__O = (function(f) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(f)
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_Lcats_data_AndThen(f);
  var g$1 = $as_Lcats_data_AndThen(g);
  return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g$1, f$1)
});
var $d_Lcats_data_AndThenInstances0$$anon$1 = new $TypeData().initClass({
  Lcats_data_AndThenInstances0$$anon$1: 0
}, false, "cats.data.AndThenInstances0$$anon$1", {
  Lcats_data_AndThenInstances0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.$classData = $d_Lcats_data_AndThenInstances0$$anon$1;
/** @constructor */
function $c_Lcats_data_WriterTInstances4() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances4.prototype = new $h_Lcats_data_WriterTInstances5();
$c_Lcats_data_WriterTInstances4.prototype.constructor = $c_Lcats_data_WriterTInstances4;
/** @constructor */
function $h_Lcats_data_WriterTInstances4() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances4.prototype = $c_Lcats_data_WriterTInstances4.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Function1Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$1.prototype = $c_Lcats_instances_Function1Instances$$anon$1.prototype;
$c_Lcats_instances_Function1Instances$$anon$1.prototype.lift__F1__O = (function(f) {
  return f
});
$c_Lcats_instances_Function1Instances$$anon$1.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_F1(f);
  var g$1 = $as_F1(g);
  return f$1.compose__F1__F1(g$1)
});
var $d_Lcats_instances_Function1Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$1: 0
}, false, "cats.instances.Function1Instances$$anon$1", {
  Lcats_instances_Function1Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
});
$c_Lcats_instances_Function1Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$1;
/** @constructor */
function $c_ju_Collections$ImmutableList(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  this.ju_Collections$ImmutableList__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableList__ju_List__(this, inner);
  this.ju_Collections$ImmutableList__f_eagerThrow = false
}
$c_ju_Collections$ImmutableList.prototype = new $h_ju_Collections$UnmodifiableList();
$c_ju_Collections$ImmutableList.prototype.constructor = $c_ju_Collections$ImmutableList;
/** @constructor */
function $h_ju_Collections$ImmutableList() {
  /*<skip>*/
}
$h_ju_Collections$ImmutableList.prototype = $c_ju_Collections$ImmutableList.prototype;
$c_ju_Collections$ImmutableList.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$ImmutableList__f_eagerThrow
});
var $d_ju_Collections$ImmutableList = new $TypeData().initClass({
  ju_Collections$ImmutableList: 0
}, false, "java.util.Collections$ImmutableList", {
  ju_Collections$ImmutableList: 1,
  ju_Collections$UnmodifiableList: 1,
  ju_Collections$UnmodifiableCollection: 1,
  O: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedList: 1,
  ju_Collections$WrappedEquals: 1,
  ju_List: 1
});
$c_ju_Collections$ImmutableList.prototype.$classData = $d_ju_Collections$ImmutableList;
/** @constructor */
function $c_Lnet_timerboard_BackendSocket$$anon$1(_$ordinal$2, \u03b4name$2) {
  this.Lnet_timerboard_BackendSocket$$anon$1__f__$ordinal$1 = 0;
  this.Lnet_timerboard_BackendSocket$$anon$1__f_$name$1 = null;
  this.Lnet_timerboard_BackendSocket$$anon$1__f__$ordinal$1 = _$ordinal$2;
  this.Lnet_timerboard_BackendSocket$$anon$1__f_$name$1 = \u03b4name$2
}
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype = new $h_Lnet_timerboard_BackendSocket$Status();
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.constructor = $c_Lnet_timerboard_BackendSocket$$anon$1;
/** @constructor */
function $h_Lnet_timerboard_BackendSocket$$anon$1() {
  /*<skip>*/
}
$h_Lnet_timerboard_BackendSocket$$anon$1.prototype = $c_Lnet_timerboard_BackendSocket$$anon$1.prototype;
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lnet_timerboard_BackendSocket$$anon$1__f_$name$1
});
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.toString__T = (function() {
  return this.Lnet_timerboard_BackendSocket$$anon$1__f_$name$1
});
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.ordinal__I = (function() {
  return this.Lnet_timerboard_BackendSocket$$anon$1__f__$ordinal$1
});
var $d_Lnet_timerboard_BackendSocket$$anon$1 = new $TypeData().initClass({
  Lnet_timerboard_BackendSocket$$anon$1: 0
}, false, "net.timerboard.BackendSocket$$anon$1", {
  Lnet_timerboard_BackendSocket$$anon$1: 1,
  Lnet_timerboard_BackendSocket$Status: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_timerboard_BackendSocket$$anon$1.prototype.$classData = $d_Lnet_timerboard_BackendSocket$$anon$1;
/** @constructor */
function $c_Lnet_timerboard_Direction$$anon$1(_$ordinal$5, \u03b4name$5) {
  this.Lnet_timerboard_Direction$$anon$1__f__$ordinal$1 = 0;
  this.Lnet_timerboard_Direction$$anon$1__f_$name$1 = null;
  this.Lnet_timerboard_Direction$$anon$1__f__$ordinal$1 = _$ordinal$5;
  this.Lnet_timerboard_Direction$$anon$1__f_$name$1 = \u03b4name$5
}
$c_Lnet_timerboard_Direction$$anon$1.prototype = new $h_Lnet_timerboard_Direction();
$c_Lnet_timerboard_Direction$$anon$1.prototype.constructor = $c_Lnet_timerboard_Direction$$anon$1;
/** @constructor */
function $h_Lnet_timerboard_Direction$$anon$1() {
  /*<skip>*/
}
$h_Lnet_timerboard_Direction$$anon$1.prototype = $c_Lnet_timerboard_Direction$$anon$1.prototype;
$c_Lnet_timerboard_Direction$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_timerboard_Direction$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_timerboard_Direction$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lnet_timerboard_Direction$$anon$1__f_$name$1
});
$c_Lnet_timerboard_Direction$$anon$1.prototype.toString__T = (function() {
  return this.Lnet_timerboard_Direction$$anon$1__f_$name$1
});
var $d_Lnet_timerboard_Direction$$anon$1 = new $TypeData().initClass({
  Lnet_timerboard_Direction$$anon$1: 0
}, false, "net.timerboard.Direction$$anon$1", {
  Lnet_timerboard_Direction$$anon$1: 1,
  Lnet_timerboard_Direction: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_timerboard_Direction$$anon$1.prototype.$classData = $d_Lnet_timerboard_Direction$$anon$1;
/** @constructor */
function $c_Lnet_timerboard_EventType$$anon$6(_$ordinal$8, \u03b4name$8) {
  this.Lnet_timerboard_EventType$$anon$6__f__$ordinal$4 = 0;
  this.Lnet_timerboard_EventType$$anon$6__f_$name$4 = null;
  this.Lnet_timerboard_EventType$$anon$6__f__$ordinal$4 = _$ordinal$8;
  this.Lnet_timerboard_EventType$$anon$6__f_$name$4 = \u03b4name$8
}
$c_Lnet_timerboard_EventType$$anon$6.prototype = new $h_Lnet_timerboard_EventType();
$c_Lnet_timerboard_EventType$$anon$6.prototype.constructor = $c_Lnet_timerboard_EventType$$anon$6;
/** @constructor */
function $h_Lnet_timerboard_EventType$$anon$6() {
  /*<skip>*/
}
$h_Lnet_timerboard_EventType$$anon$6.prototype = $c_Lnet_timerboard_EventType$$anon$6.prototype;
$c_Lnet_timerboard_EventType$$anon$6.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_timerboard_EventType$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_timerboard_EventType$$anon$6.prototype.productPrefix__T = (function() {
  return this.Lnet_timerboard_EventType$$anon$6__f_$name$4
});
$c_Lnet_timerboard_EventType$$anon$6.prototype.toString__T = (function() {
  return this.Lnet_timerboard_EventType$$anon$6__f_$name$4
});
var $d_Lnet_timerboard_EventType$$anon$6 = new $TypeData().initClass({
  Lnet_timerboard_EventType$$anon$6: 0
}, false, "net.timerboard.EventType$$anon$6", {
  Lnet_timerboard_EventType$$anon$6: 1,
  Lnet_timerboard_EventType: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_timerboard_EventType$$anon$6.prototype.$classData = $d_Lnet_timerboard_EventType$$anon$6;
/** @constructor */
function $c_Lnet_timerboard_Field$$anon$2(_$ordinal$6, \u03b4name$6) {
  this.Lnet_timerboard_Field$$anon$2__f__$ordinal$2 = 0;
  this.Lnet_timerboard_Field$$anon$2__f_$name$2 = null;
  this.Lnet_timerboard_Field$$anon$2__f__$ordinal$2 = _$ordinal$6;
  this.Lnet_timerboard_Field$$anon$2__f_$name$2 = \u03b4name$6
}
$c_Lnet_timerboard_Field$$anon$2.prototype = new $h_Lnet_timerboard_Field();
$c_Lnet_timerboard_Field$$anon$2.prototype.constructor = $c_Lnet_timerboard_Field$$anon$2;
/** @constructor */
function $h_Lnet_timerboard_Field$$anon$2() {
  /*<skip>*/
}
$h_Lnet_timerboard_Field$$anon$2.prototype = $c_Lnet_timerboard_Field$$anon$2.prototype;
$c_Lnet_timerboard_Field$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_timerboard_Field$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_timerboard_Field$$anon$2.prototype.productPrefix__T = (function() {
  return this.Lnet_timerboard_Field$$anon$2__f_$name$2
});
$c_Lnet_timerboard_Field$$anon$2.prototype.toString__T = (function() {
  return this.Lnet_timerboard_Field$$anon$2__f_$name$2
});
var $d_Lnet_timerboard_Field$$anon$2 = new $TypeData().initClass({
  Lnet_timerboard_Field$$anon$2: 0
}, false, "net.timerboard.Field$$anon$2", {
  Lnet_timerboard_Field$$anon$2: 1,
  Lnet_timerboard_Field: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_timerboard_Field$$anon$2.prototype.$classData = $d_Lnet_timerboard_Field$$anon$2;
/** @constructor */
function $c_Lnet_timerboard_Msg$$anon$5(_$ordinal$7, \u03b4name$7) {
  this.Lnet_timerboard_Msg$$anon$5__f__$ordinal$3 = 0;
  this.Lnet_timerboard_Msg$$anon$5__f_$name$3 = null;
  this.Lnet_timerboard_Msg$$anon$5__f__$ordinal$3 = _$ordinal$7;
  this.Lnet_timerboard_Msg$$anon$5__f_$name$3 = \u03b4name$7
}
$c_Lnet_timerboard_Msg$$anon$5.prototype = new $h_Lnet_timerboard_Msg();
$c_Lnet_timerboard_Msg$$anon$5.prototype.constructor = $c_Lnet_timerboard_Msg$$anon$5;
/** @constructor */
function $h_Lnet_timerboard_Msg$$anon$5() {
  /*<skip>*/
}
$h_Lnet_timerboard_Msg$$anon$5.prototype = $c_Lnet_timerboard_Msg$$anon$5.prototype;
$c_Lnet_timerboard_Msg$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_timerboard_Msg$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_timerboard_Msg$$anon$5.prototype.productPrefix__T = (function() {
  return this.Lnet_timerboard_Msg$$anon$5__f_$name$3
});
$c_Lnet_timerboard_Msg$$anon$5.prototype.toString__T = (function() {
  return this.Lnet_timerboard_Msg$$anon$5__f_$name$3
});
$c_Lnet_timerboard_Msg$$anon$5.prototype.ordinal__I = (function() {
  return this.Lnet_timerboard_Msg$$anon$5__f__$ordinal$3
});
var $d_Lnet_timerboard_Msg$$anon$5 = new $TypeData().initClass({
  Lnet_timerboard_Msg$$anon$5: 0
}, false, "net.timerboard.Msg$$anon$5", {
  Lnet_timerboard_Msg$$anon$5: 1,
  Lnet_timerboard_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_timerboard_Msg$$anon$5.prototype.$classData = $d_Lnet_timerboard_Msg$$anon$5;
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if (x2.canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2)
      }
    };
    return false
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)))
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"))
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)))
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth))
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_s_package$().s_package$__f_Nil
    } else if ((len === 1)) {
      $m_s_package$();
      var array = [$thiz.sc_SeqView$Sorted__f_underlying.head__O()];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
    } else {
      var arr = new $ac_O(len);
      var this$5 = $thiz.sc_SeqView$Sorted__f_underlying;
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr)
    };
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, underlying.length__I(), ord);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false
}
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_SeqView$Sorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_SeqView$Sorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig)
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().apply__I__O(i)
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Sorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass({
  sc_SeqView$Sorted: 0
}, false, "scala.collection.SeqView$Sorted", {
  sc_SeqView$Sorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted.prototype.$classData = $d_sc_SeqView$Sorted;
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed)
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer
  }
}
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).apply__I__O(i)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this$1).iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass({
  sc_SeqView$Sorted$ReverseSorted: 0
}, false, "scala.collection.SeqView$Sorted$ReverseSorted", {
  sc_SeqView$Sorted$ReverseSorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.$classData = $d_sc_SeqView$Sorted$ReverseSorted;
function $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $thiz.sortedIterableFactory__sc_SortedIterableFactory().newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return $as_sc_SortedSet(b.result__O())
}
function $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $thiz.sortedIterableFactory__sc_SortedIterableFactory().newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var xs = $as_sc_IterableOnce(f.apply__O__O(it.next__O()));
    b.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return $as_sc_SortedSet(b.result__O())
}
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
  /*<skip>*/
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator(this.sc_View$$anon$1__f_it$1.apply__O())
});
var $d_sc_View$$anon$1 = new $TypeData().initClass({
  sc_View$$anon$1: 0
}, false, "scala.collection.View$$anon$1", {
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$$anon$1.prototype.$classData = $d_sc_View$$anon$1;
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.sc_View$Collect__f_underlying = null;
  this.sc_View$Collect__f_pf = null;
  this.sc_View$Collect__f_underlying = underlying;
  this.sc_View$Collect__f_pf = pf
}
$c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$c_sc_View$Collect.prototype.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
  /*<skip>*/
}
$h_sc_View$Collect.prototype = $c_sc_View$Collect.prototype;
$c_sc_View$Collect.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Collect__f_underlying.iterator__sc_Iterator();
  var pf = this.sc_View$Collect__f_pf;
  return new $c_sc_Iterator$$anon$7(this$1, pf)
});
var $d_sc_View$Collect = new $TypeData().initClass({
  sc_View$Collect: 0
}, false, "scala.collection.View$Collect", {
  sc_View$Collect: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Collect.prototype.$classData = $d_sc_View$Collect;
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
  /*<skip>*/
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_View$Concat__f_prefix.iterator__sc_Iterator();
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.sc_View$Concat__f_suffix.iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = this.sc_View$Concat__f_prefix.knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = this.sc_View$Concat__f_suffix.knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1))
  } else {
    return (-1)
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return (this.sc_View$Concat__f_prefix.isEmpty__Z() && this.sc_View$Concat__f_suffix.isEmpty__Z())
});
var $d_sc_View$Concat = new $TypeData().initClass({
  sc_View$Concat: 0
}, false, "scala.collection.View$Concat", {
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Concat.prototype.$classData = $d_sc_View$Concat;
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
  /*<skip>*/
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Drop__f_underlying.iterator__sc_Iterator().drop__I__sc_Iterator(this.sc_View$Drop__f_n)
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = this.sc_View$Drop__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0)
  } else {
    return (-1)
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Drop = new $TypeData().initClass({
  sc_View$Drop: 0
}, false, "scala.collection.View$Drop", {
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Drop.prototype.$classData = $d_sc_View$Drop;
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f
}
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
  /*<skip>*/
}
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$FlatMap__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f)
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return ((this.sc_View$FlatMap__f_underlying.knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$FlatMap = new $TypeData().initClass({
  sc_View$FlatMap: 0
}, false, "scala.collection.View$FlatMap", {
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$FlatMap.prototype.$classData = $d_sc_View$FlatMap;
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
  /*<skip>*/
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Map__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f)
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return this.sc_View$Map__f_underlying.knownSize__I()
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return this.sc_View$Map__f_underlying.isEmpty__Z()
});
var $d_sc_View$Map = new $TypeData().initClass({
  sc_View$Map: 0
}, false, "scala.collection.View$Map", {
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Map.prototype.$classData = $d_sc_View$Map;
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Take__f_underlying = underlying;
  $thiz.sc_View$Take__f_n = n;
  $thiz.sc_View$Take__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0
}
$c_sc_View$Take.prototype = new $h_sc_AbstractView();
$c_sc_View$Take.prototype.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
  /*<skip>*/
}
$h_sc_View$Take.prototype = $c_sc_View$Take.prototype;
$c_sc_View$Take.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Take__f_underlying.iterator__sc_Iterator().take__I__sc_Iterator(this.sc_View$Take__f_n)
});
$c_sc_View$Take.prototype.knownSize__I = (function() {
  var size = this.sc_View$Take__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$Take__f_normN;
    return ((size < that) ? size : that)
  } else {
    return (-1)
  }
});
$c_sc_View$Take.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Take = new $TypeData().initClass({
  sc_View$Take: 0
}, false, "scala.collection.View$Take", {
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Take.prototype.$classData = $d_sc_View$Take;
function $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$MutableSetWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableSetWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$MutableSetWrapper;", depth))
}
/** @constructor */
function $c_s_math_Numeric$DoubleIsFractional$() {
  /*<skip>*/
}
$c_s_math_Numeric$DoubleIsFractional$.prototype = new $h_O();
$c_s_math_Numeric$DoubleIsFractional$.prototype.constructor = $c_s_math_Numeric$DoubleIsFractional$;
/** @constructor */
function $h_s_math_Numeric$DoubleIsFractional$() {
  /*<skip>*/
}
$h_s_math_Numeric$DoubleIsFractional$.prototype = $c_s_math_Numeric$DoubleIsFractional$.prototype;
$c_s_math_Numeric$DoubleIsFractional$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.toDouble__O__D = (function(x) {
  var x$1 = $uD(x);
  return x$1
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.equiv__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.lteq__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_s_math_Numeric$DoubleIsFractional$ = new $TypeData().initClass({
  s_math_Numeric$DoubleIsFractional$: 0
}, false, "scala.math.Numeric$DoubleIsFractional$", {
  s_math_Numeric$DoubleIsFractional$: 1,
  O: 1,
  s_math_Numeric$DoubleIsFractional: 1,
  s_math_Fractional: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$Double$IeeeOrdering: 1
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.$classData = $d_s_math_Numeric$DoubleIsFractional$;
var $n_s_math_Numeric$DoubleIsFractional$;
function $m_s_math_Numeric$DoubleIsFractional$() {
  if ((!$n_s_math_Numeric$DoubleIsFractional$)) {
    $n_s_math_Numeric$DoubleIsFractional$ = new $c_s_math_Numeric$DoubleIsFractional$()
  };
  return $n_s_math_Numeric$DoubleIsFractional$
}
/** @constructor */
function $c_s_math_Numeric$LongIsIntegral$() {
  /*<skip>*/
}
$c_s_math_Numeric$LongIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$LongIsIntegral$.prototype.constructor = $c_s_math_Numeric$LongIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$LongIsIntegral$() {
  /*<skip>*/
}
$h_s_math_Numeric$LongIsIntegral$.prototype = $c_s_math_Numeric$LongIsIntegral$.prototype;
$c_s_math_Numeric$LongIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Numeric$LongIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Numeric$LongIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Numeric$LongIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_s_math_Numeric$LongIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
});
var $d_s_math_Numeric$LongIsIntegral$ = new $TypeData().initClass({
  s_math_Numeric$LongIsIntegral$: 0
}, false, "scala.math.Numeric$LongIsIntegral$", {
  s_math_Numeric$LongIsIntegral$: 1,
  O: 1,
  s_math_Numeric$LongIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$LongOrdering: 1
});
$c_s_math_Numeric$LongIsIntegral$.prototype.$classData = $d_s_math_Numeric$LongIsIntegral$;
var $n_s_math_Numeric$LongIsIntegral$;
function $m_s_math_Numeric$LongIsIntegral$() {
  if ((!$n_s_math_Numeric$LongIsIntegral$)) {
    $n_s_math_Numeric$LongIsIntegral$ = new $c_s_math_Numeric$LongIsIntegral$()
  };
  return $n_s_math_Numeric$LongIsIntegral$
}
/** @constructor */
function $c_Ltyrian_http_Body$$anon$4() {
  /*<skip>*/
}
$c_Ltyrian_http_Body$$anon$4.prototype = new $h_Ltyrian_http_Body();
$c_Ltyrian_http_Body$$anon$4.prototype.constructor = $c_Ltyrian_http_Body$$anon$4;
/** @constructor */
function $h_Ltyrian_http_Body$$anon$4() {
  /*<skip>*/
}
$h_Ltyrian_http_Body$$anon$4.prototype = $c_Ltyrian_http_Body$$anon$4.prototype;
$c_Ltyrian_http_Body$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_http_Body$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_http_Body$$anon$4.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Ltyrian_http_Body$$anon$4.prototype.toString__T = (function() {
  return "Empty"
});
$c_Ltyrian_http_Body$$anon$4.prototype.ordinal__I = (function() {
  return 0
});
var $d_Ltyrian_http_Body$$anon$4 = new $TypeData().initClass({
  Ltyrian_http_Body$$anon$4: 0
}, false, "tyrian.http.Body$$anon$4", {
  Ltyrian_http_Body$$anon$4: 1,
  Ltyrian_http_Body: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_http_Body$$anon$4.prototype.$classData = $d_Ltyrian_http_Body$$anon$4;
/** @constructor */
function $c_Ltyrian_http_HttpError$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_http_HttpError$$anon$1.prototype = new $h_Ltyrian_http_HttpError();
$c_Ltyrian_http_HttpError$$anon$1.prototype.constructor = $c_Ltyrian_http_HttpError$$anon$1;
/** @constructor */
function $h_Ltyrian_http_HttpError$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError$$anon$1.prototype = $c_Ltyrian_http_HttpError$$anon$1.prototype;
$c_Ltyrian_http_HttpError$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_http_HttpError$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_http_HttpError$$anon$1.prototype.productPrefix__T = (function() {
  return "Timeout"
});
$c_Ltyrian_http_HttpError$$anon$1.prototype.toString__T = (function() {
  return "Timeout"
});
$c_Ltyrian_http_HttpError$$anon$1.prototype.ordinal__I = (function() {
  return 1
});
var $d_Ltyrian_http_HttpError$$anon$1 = new $TypeData().initClass({
  Ltyrian_http_HttpError$$anon$1: 0
}, false, "tyrian.http.HttpError$$anon$1", {
  Ltyrian_http_HttpError$$anon$1: 1,
  Ltyrian_http_HttpError: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_http_HttpError$$anon$1.prototype.$classData = $d_Ltyrian_http_HttpError$$anon$1;
/** @constructor */
function $c_Ltyrian_http_HttpError$$anon$2() {
  /*<skip>*/
}
$c_Ltyrian_http_HttpError$$anon$2.prototype = new $h_Ltyrian_http_HttpError();
$c_Ltyrian_http_HttpError$$anon$2.prototype.constructor = $c_Ltyrian_http_HttpError$$anon$2;
/** @constructor */
function $h_Ltyrian_http_HttpError$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_http_HttpError$$anon$2.prototype = $c_Ltyrian_http_HttpError$$anon$2.prototype;
$c_Ltyrian_http_HttpError$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_http_HttpError$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_http_HttpError$$anon$2.prototype.productPrefix__T = (function() {
  return "NetworkError"
});
$c_Ltyrian_http_HttpError$$anon$2.prototype.toString__T = (function() {
  return "NetworkError"
});
$c_Ltyrian_http_HttpError$$anon$2.prototype.ordinal__I = (function() {
  return 2
});
var $d_Ltyrian_http_HttpError$$anon$2 = new $TypeData().initClass({
  Ltyrian_http_HttpError$$anon$2: 0
}, false, "tyrian.http.HttpError$$anon$2", {
  Ltyrian_http_HttpError$$anon$2: 1,
  Ltyrian_http_HttpError: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_http_HttpError$$anon$2.prototype.$classData = $d_Ltyrian_http_HttpError$$anon$2;
/** @constructor */
function $c_Ltyrian_http_Method$$anon$3(_$ordinal$2, \u03b4name$2) {
  this.Ltyrian_http_Method$$anon$3__f__$ordinal$1 = 0;
  this.Ltyrian_http_Method$$anon$3__f_$name$1 = null;
  this.Ltyrian_http_Method$$anon$3__f__$ordinal$1 = _$ordinal$2;
  this.Ltyrian_http_Method$$anon$3__f_$name$1 = \u03b4name$2
}
$c_Ltyrian_http_Method$$anon$3.prototype = new $h_Ltyrian_http_Method();
$c_Ltyrian_http_Method$$anon$3.prototype.constructor = $c_Ltyrian_http_Method$$anon$3;
/** @constructor */
function $h_Ltyrian_http_Method$$anon$3() {
  /*<skip>*/
}
$h_Ltyrian_http_Method$$anon$3.prototype = $c_Ltyrian_http_Method$$anon$3.prototype;
$c_Ltyrian_http_Method$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_http_Method$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_http_Method$$anon$3.prototype.productPrefix__T = (function() {
  return this.Ltyrian_http_Method$$anon$3__f_$name$1
});
$c_Ltyrian_http_Method$$anon$3.prototype.toString__T = (function() {
  return this.Ltyrian_http_Method$$anon$3__f_$name$1
});
var $d_Ltyrian_http_Method$$anon$3 = new $TypeData().initClass({
  Ltyrian_http_Method$$anon$3: 0
}, false, "tyrian.http.Method$$anon$3", {
  Ltyrian_http_Method$$anon$3: 1,
  Ltyrian_http_Method: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_http_Method$$anon$3.prototype.$classData = $d_Ltyrian_http_Method$$anon$3;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketEvent$$anon$1(_$ordinal$2, \u03b4name$2) {
  this.Ltyrian_websocket_WebSocketEvent$$anon$1__f__$ordinal$1 = 0;
  this.Ltyrian_websocket_WebSocketEvent$$anon$1__f_$name$1 = null;
  this.Ltyrian_websocket_WebSocketEvent$$anon$1__f__$ordinal$1 = _$ordinal$2;
  this.Ltyrian_websocket_WebSocketEvent$$anon$1__f_$name$1 = \u03b4name$2
}
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype = new $h_Ltyrian_websocket_WebSocketEvent();
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.constructor = $c_Ltyrian_websocket_WebSocketEvent$$anon$1;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketEvent$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype = $c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype;
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.productPrefix__T = (function() {
  return this.Ltyrian_websocket_WebSocketEvent$$anon$1__f_$name$1
});
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.toString__T = (function() {
  return this.Ltyrian_websocket_WebSocketEvent$$anon$1__f_$name$1
});
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.ordinal__I = (function() {
  return this.Ltyrian_websocket_WebSocketEvent$$anon$1__f__$ordinal$1
});
var $d_Ltyrian_websocket_WebSocketEvent$$anon$1 = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketEvent$$anon$1: 0
}, false, "tyrian.websocket.WebSocketEvent$$anon$1", {
  Ltyrian_websocket_WebSocketEvent$$anon$1: 1,
  Ltyrian_websocket_WebSocketEvent: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_websocket_WebSocketEvent$$anon$1.prototype.$classData = $d_Ltyrian_websocket_WebSocketEvent$$anon$1;
/** @constructor */
function $c_Ltyrian_websocket_WebSocketReadyState$$anon$1(_$ordinal$2, \u03b4name$2) {
  this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f__$ordinal$1 = 0;
  this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f_$name$1 = null;
  this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f__$ordinal$1 = _$ordinal$2;
  this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f_$name$1 = \u03b4name$2
}
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype = new $h_Ltyrian_websocket_WebSocketReadyState();
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.constructor = $c_Ltyrian_websocket_WebSocketReadyState$$anon$1;
/** @constructor */
function $h_Ltyrian_websocket_WebSocketReadyState$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype = $c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype;
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.productPrefix__T = (function() {
  return this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f_$name$1
});
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.toString__T = (function() {
  return this.Ltyrian_websocket_WebSocketReadyState$$anon$1__f_$name$1
});
var $d_Ltyrian_websocket_WebSocketReadyState$$anon$1 = new $TypeData().initClass({
  Ltyrian_websocket_WebSocketReadyState$$anon$1: 0
}, false, "tyrian.websocket.WebSocketReadyState$$anon$1", {
  Ltyrian_websocket_WebSocketReadyState$$anon$1: 1,
  Ltyrian_websocket_WebSocketReadyState: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_websocket_WebSocketReadyState$$anon$1.prototype.$classData = $d_Ltyrian_websocket_WebSocketReadyState$$anon$1;
function $f_Lcats_Monad__map__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, f$2) => ((a) => this$1.pure__O__O(f$2.apply__O__O(a))))($thiz, f)))
}
function $f_Lcats_data_WriterTFlatMap1__tailRecM__O__F1__Lcats_data_WriterT($thiz, a, fn) {
  var $$x1 = $thiz.Lcats_data_WriterTInstances4$$anon$1__f_F0;
  var _1 = $thiz.Lcats_data_WriterTInstances4$$anon$1__f_L0.empty__O();
  var run = $$x1.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), _1, a), new $c_sjsr_AnonFunction1(((this$2, fn$2) => ((la) => {
    var la$1 = $as_T2(la);
    return $p_Lcats_data_WriterTFlatMap1__step$2__F1__T2__O(this$2, fn$2, la$1)
  }))($thiz, fn)));
  return new $c_Lcats_data_WriterT(run)
}
function $p_Lcats_data_WriterTFlatMap1__step$2__F1__T2__O($thiz, fn$3, la) {
  var flv = $as_Lcats_data_WriterT(fn$3.apply__O__O(la._2__O())).Lcats_data_WriterT__f_run;
  return $thiz.Lcats_data_WriterTInstances4$$anon$1__f_F0.map__O__F1__O(flv, new $c_sjsr_AnonFunction1(((this$1, la$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x34 = x$1$1._1__O();
      var x35 = $as_s_util_Either(x$1$1._2__O());
      if ((x35 instanceof $c_s_util_Left)) {
        var a = $as_s_util_Left(x35).s_util_Left__f_value;
        var combineL = this$1.Lcats_data_WriterTInstances4$$anon$1__f_L0.combine__O__O__O(la$2._1__O(), x34);
        $m_s_package$();
        var value = $ct_T2__O__O__(new $c_T2(), combineL, a);
        return new $c_s_util_Left(value)
      };
      if ((x35 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x35).s_util_Right__f_value;
        var combineL$2 = this$1.Lcats_data_WriterTInstances4$$anon$1__f_L0.combine__O__O__O(la$2._1__O(), x34);
        $m_s_package$();
        var value$1 = $ct_T2__O__O__(new $c_T2(), combineL$2, b);
        return new $c_s_util_Right(value$1)
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, la)))
}
/** @constructor */
function $c_Lcats_data_WriterTInstances3() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances3.prototype = new $h_Lcats_data_WriterTInstances4();
$c_Lcats_data_WriterTInstances3.prototype.constructor = $c_Lcats_data_WriterTInstances3;
/** @constructor */
function $h_Lcats_data_WriterTInstances3() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances3.prototype = $c_Lcats_data_WriterTInstances3.prototype;
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0)
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y)
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $TypeData().initClass({
  Lcats_kernel_instances_UnitAlgebra: 0
}, false, "cats.kernel.instances.UnitAlgebra", {
  Lcats_kernel_instances_UnitAlgebra: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.$classData = $d_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $c_sc_AbstractSet() {
  /*<skip>*/
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
  /*<skip>*/
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that)
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_sc_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Set$()
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set"
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that)
});
$c_sc_AbstractSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that)
});
$c_sc_AbstractSet.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1)
});
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else if ($is_sc_Map(o)) {
    var x2 = $as_sc_Map(o);
    if (($thiz.size__I() === x2.size__I())) {
      try {
        return $thiz.forall__F1__Z(new $c_sjsr_AnonFunction1(((this$1, x2$1) => ((kv$2) => {
          var kv = $as_T2(kv$2);
          return $m_sr_BoxesRunTime$().equals__O__O__Z(x2$1.getOrElse__O__F0__O(kv._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), kv._2__O())
        }))($thiz, x2)))
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false
        } else {
          throw e
        }
      }
    } else {
      return false
    }
  } else {
    return false
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)))
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"))
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)))
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth))
}
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapView)))
}
function $as_sc_MapView(obj) {
  return (($is_sc_MapView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapView"))
}
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapView)))
}
function $asArrayOf_sc_MapView(obj, depth) {
  return (($isArrayOf_sc_MapView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapView;", depth))
}
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
  /*<skip>*/
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(that);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3)
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this)
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(lo, hi)
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi)
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24)
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16)
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1)
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"))
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)))
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth))
}
var $d_sr_RichLong = new $TypeData().initClass({
  sr_RichLong: 0
}, false, "scala.runtime.RichLong", {
  sr_RichLong: 1,
  O: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
});
$c_sr_RichLong.prototype.$classData = $d_sr_RichLong;
function $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a, f) {
  var fa = f.apply__O__O(a);
  var f$1 = new $c_sjsr_AnonFunction1(((this$1, f$2) => ((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var a$1 = $as_s_util_Left(x$1$1).s_util_Left__f_value;
      return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this$1, a$1, f$2)
    };
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x$1$1).s_util_Right__f_value;
      return new $c_Lcats_Now(b)
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, f));
  var fa$1 = $as_Lcats_Eval(fa);
  return fa$1.flatMap__F1__Lcats_Eval(f$1)
}
function $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__($thiz, evidence$1) {
  $thiz.Lcats_data_ValidatedApplicative__f_evidence$1 = evidence$1;
  return $thiz
}
/** @constructor */
function $c_Lcats_data_ValidatedApplicative() {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null
}
$c_Lcats_data_ValidatedApplicative.prototype = new $h_O();
$c_Lcats_data_ValidatedApplicative.prototype.constructor = $c_Lcats_data_ValidatedApplicative;
/** @constructor */
function $h_Lcats_data_ValidatedApplicative() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedApplicative.prototype = $c_Lcats_data_ValidatedApplicative.prototype;
$c_Lcats_data_ValidatedApplicative.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_ValidatedApplicative.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_data_ValidatedApplicative.prototype.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(fa, fb) {
  $m_Lcats_package$();
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$1;
  return fa.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(fb, ev)
});
$c_Lcats_data_ValidatedApplicative.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Validated(fa);
  return fa$1.map__F1__Lcats_data_Validated(f)
});
$c_Lcats_data_ValidatedApplicative.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Validated$();
  return new $c_Lcats_data_Validated$Valid(x)
});
$c_Lcats_data_ValidatedApplicative.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated($as_Lcats_data_Validated(fa), $as_Lcats_data_Validated(fb))
});
/** @constructor */
function $c_Lcats_data_WriterTInstances2() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances2.prototype = new $h_Lcats_data_WriterTInstances3();
$c_Lcats_data_WriterTInstances2.prototype.constructor = $c_Lcats_data_WriterTInstances2;
/** @constructor */
function $h_Lcats_data_WriterTInstances2() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances2.prototype = $c_Lcats_data_WriterTInstances2.prototype;
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__s_math_BigInt__s_math_BigInt__Z = (function(x, y) {
  return (!$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y))
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigInt(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return x$1.compare__s_math_BigInt__I(y$1)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigInt__s_math_BigInt__Z($as_s_math_BigInt(x), $as_s_math_BigInt(y))
});
var $d_Lcats_kernel_instances_BigIntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntOrder: 0
}, false, "cats.kernel.instances.BigIntOrder", {
  Lcats_kernel_instances_BigIntOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.$classData = $d_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "STRICT", 0)
}
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle$$anon$1.prototype = $c_Ljava_time_format_ResolverStyle$$anon$1.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_ResolverStyle$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle$$anon$1: 0
}, false, "java.time.format.ResolverStyle$$anon$1", {
  Ljava_time_format_ResolverStyle$$anon$1: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.$classData = $d_Ljava_time_format_ResolverStyle$$anon$1;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SMART", 1)
}
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle$$anon$2.prototype = $c_Ljava_time_format_ResolverStyle$$anon$2.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_ResolverStyle$$anon$2 = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle$$anon$2: 0
}, false, "java.time.format.ResolverStyle$$anon$2", {
  Ljava_time_format_ResolverStyle$$anon$2: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.$classData = $d_Ljava_time_format_ResolverStyle$$anon$2;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "LENIENT", 2)
}
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle$$anon$3.prototype = $c_Ljava_time_format_ResolverStyle$$anon$3.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_ResolverStyle$$anon$3 = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle$$anon$3: 0
}, false, "java.time.format.ResolverStyle$$anon$3", {
  Ljava_time_format_ResolverStyle$$anon$3: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.$classData = $d_Ljava_time_format_ResolverStyle$$anon$3;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NORMAL", 0, "NORMAL", 0)
}
$c_Ljava_time_format_SignStyle$$anon$1.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$$anon$1.prototype = $c_Ljava_time_format_SignStyle$$anon$1.prototype;
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_SignStyle$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_SignStyle$$anon$1: 0
}, false, "java.time.format.SignStyle$$anon$1", {
  Ljava_time_format_SignStyle$$anon$1: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.$classData = $d_Ljava_time_format_SignStyle$$anon$1;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "ALWAYS", 1, "ALWAYS", 1)
}
$c_Ljava_time_format_SignStyle$$anon$2.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$$anon$2.prototype = $c_Ljava_time_format_SignStyle$$anon$2.prototype;
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_SignStyle$$anon$2 = new $TypeData().initClass({
  Ljava_time_format_SignStyle$$anon$2: 0
}, false, "java.time.format.SignStyle$$anon$2", {
  Ljava_time_format_SignStyle$$anon$2: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.$classData = $d_Ljava_time_format_SignStyle$$anon$2;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NEVER", 2, "NEVER", 2)
}
$c_Ljava_time_format_SignStyle$$anon$3.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$$anon$3.prototype = $c_Ljava_time_format_SignStyle$$anon$3.prototype;
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_SignStyle$$anon$3 = new $TypeData().initClass({
  Ljava_time_format_SignStyle$$anon$3: 0
}, false, "java.time.format.SignStyle$$anon$3", {
  Ljava_time_format_SignStyle$$anon$3: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.$classData = $d_Ljava_time_format_SignStyle$$anon$3;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NOT_NEGATIVE", 3, "NOT_NEGATIVE", 3)
}
$c_Ljava_time_format_SignStyle$$anon$4.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$4.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$4;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$$anon$4.prototype = $c_Ljava_time_format_SignStyle$$anon$4.prototype;
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_SignStyle$$anon$4 = new $TypeData().initClass({
  Ljava_time_format_SignStyle$$anon$4: 0
}, false, "java.time.format.SignStyle$$anon$4", {
  Ljava_time_format_SignStyle$$anon$4: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.$classData = $d_Ljava_time_format_SignStyle$$anon$4;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "EXCEEDS_PAD", 4, "EXCEEDS_PAD", 4)
}
$c_Ljava_time_format_SignStyle$$anon$5.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$5.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$5;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$$anon$5.prototype = $c_Ljava_time_format_SignStyle$$anon$5.prototype;
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_SignStyle$$anon$5 = new $TypeData().initClass({
  Ljava_time_format_SignStyle$$anon$5: 0
}, false, "java.time.format.SignStyle$$anon$5", {
  Ljava_time_format_SignStyle$$anon$5: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.$classData = $d_Ljava_time_format_SignStyle$$anon$5;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "UTC", 0)
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype = new $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1 = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$$anon$1", {
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1: 1,
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$1;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "WALL", 1)
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype = new $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2 = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$$anon$2", {
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2: 1,
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$2;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "STANDARD", 2)
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype = new $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3 = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$$anon$3", {
  Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3: 1,
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$$anon$3;
/** @constructor */
function $c_ju_Locale$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DISPLAY", 0)
}
$c_ju_Locale$$anon$2.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$$anon$2.prototype.constructor = $c_ju_Locale$$anon$2;
/** @constructor */
function $h_ju_Locale$$anon$2() {
  /*<skip>*/
}
$h_ju_Locale$$anon$2.prototype = $c_ju_Locale$$anon$2.prototype;
$c_ju_Locale$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_ju_Locale$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_ju_Locale$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_ju_Locale$$anon$2 = new $TypeData().initClass({
  ju_Locale$$anon$2: 0
}, false, "java.util.Locale$$anon$2", {
  ju_Locale$$anon$2: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_ju_Locale$$anon$2.prototype.$classData = $d_ju_Locale$$anon$2;
/** @constructor */
function $c_ju_Locale$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "FORMAT", 1)
}
$c_ju_Locale$$anon$3.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$$anon$3.prototype.constructor = $c_ju_Locale$$anon$3;
/** @constructor */
function $h_ju_Locale$$anon$3() {
  /*<skip>*/
}
$h_ju_Locale$$anon$3.prototype = $c_ju_Locale$$anon$3.prototype;
$c_ju_Locale$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_ju_Locale$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_ju_Locale$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_ju_Locale$$anon$3 = new $TypeData().initClass({
  ju_Locale$$anon$3: 0
}, false, "java.util.Locale$$anon$3", {
  ju_Locale$$anon$3: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_ju_Locale$$anon$3.prototype.$classData = $d_ju_Locale$$anon$3;
/** @constructor */
function $c_sc_AbstractSeq() {
  /*<skip>*/
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
  /*<skip>*/
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix)
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeq.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize)
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
/** @constructor */
function $c_sc_AbstractSeqView() {
  /*<skip>*/
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
  /*<skip>*/
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_AbstractSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)))
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"))
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)))
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth))
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)))
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"))
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)))
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth))
}
/** @constructor */
function $c_sc_View$Empty$() {
  /*<skip>*/
}
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
  /*<skip>*/
}
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
var $d_sc_View$Empty$ = new $TypeData().initClass({
  sc_View$Empty$: 0
}, false, "scala.collection.View$Empty$", {
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_View$Empty$.prototype.$classData = $d_sc_View$Empty$;
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$()
  };
  return $n_sc_View$Empty$
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)))
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"))
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)))
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth))
}
function $f_scm_SetOps__remove__O__Z($thiz, elem) {
  var res = $thiz.contains__O__Z(elem);
  var this$1 = $as_scm_Shrinkable($thiz);
  this$1.subtractOne__O__scm_Shrinkable(elem);
  return res
}
/** @constructor */
function $c_Lcats_data_WriterTInstances1() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances1.prototype = new $h_Lcats_data_WriterTInstances2();
$c_Lcats_data_WriterTInstances1.prototype.constructor = $c_Lcats_data_WriterTInstances1;
/** @constructor */
function $h_Lcats_data_WriterTInstances1() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances1.prototype = $c_Lcats_data_WriterTInstances1.prototype;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "SENSITIVE", 0, "SENSITIVE", 0)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$$anon$1", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$1;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "INSENSITIVE", 1, "INSENSITIVE", 1)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$$anon$2", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$2;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "STRICT", 2, "STRICT", 2)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$$anon$3", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$3;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "LENIENT", 3, "LENIENT", 3)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$$anon$4", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$$anon$4;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfSecond", 0, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999999, 0)), "NANO_OF_SECOND", 0)
}
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$1.prototype = $c_Ljava_time_temporal_ChronoField$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$1 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$1: 0
}, false, "java.time.temporal.ChronoField$$anon$1", {
  Ljava_time_temporal_ChronoField$$anon$1: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfDay", 9, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1439, 0)), "MINUTE_OF_DAY", 9)
}
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$10() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$10.prototype = $c_Ljava_time_temporal_ChronoField$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$10 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$10: 0
}, false, "java.time.temporal.ChronoField$$anon$10", {
  Ljava_time_temporal_ChronoField$$anon$10: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$10;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfAmPm", 10, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(11, 0)), "HOUR_OF_AMPM", 10)
}
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$11() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$11.prototype = $c_Ljava_time_temporal_ChronoField$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$11 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$11: 0
}, false, "java.time.temporal.ChronoField$$anon$11", {
  Ljava_time_temporal_ChronoField$$anon$11: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$11;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfAmPm", 11, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)), "CLOCK_HOUR_OF_AMPM", 11)
}
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$12() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$12.prototype = $c_Ljava_time_temporal_ChronoField$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$12 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$12: 0
}, false, "java.time.temporal.ChronoField$$anon$12", {
  Ljava_time_temporal_ChronoField$$anon$12: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$12;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfDay", 12, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(23, 0)), "HOUR_OF_DAY", 12)
}
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$13() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$13.prototype = $c_Ljava_time_temporal_ChronoField$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$13 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$13: 0
}, false, "java.time.temporal.ChronoField$$anon$13", {
  Ljava_time_temporal_ChronoField$$anon$13: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$13;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfDay", 13, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(24, 0)), "CLOCK_HOUR_OF_DAY", 13)
}
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$14() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$14.prototype = $c_Ljava_time_temporal_ChronoField$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$14 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$14: 0
}, false, "java.time.temporal.ChronoField$$anon$14", {
  Ljava_time_temporal_ChronoField$$anon$14: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$14;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AmPmOfDay", 14, $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)), "AMPM_OF_DAY", 14)
}
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$15() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$15.prototype = $c_Ljava_time_temporal_ChronoField$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$15 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$15: 0
}, false, "java.time.temporal.ChronoField$$anon$15", {
  Ljava_time_temporal_ChronoField$$anon$15: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$15;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfWeek", 15, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "DAY_OF_WEEK", 15)
}
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$16() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$16.prototype = $c_Ljava_time_temporal_ChronoField$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$16 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$16: 0
}, false, "java.time.temporal.ChronoField$$anon$16", {
  Ljava_time_temporal_ChronoField$$anon$16: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$16;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$17() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInMonth", 16, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "ALIGNED_DAY_OF_WEEK_IN_MONTH", 16)
}
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$17;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$17() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$17.prototype = $c_Ljava_time_temporal_ChronoField$$anon$17.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$17 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$17: 0
}, false, "java.time.temporal.ChronoField$$anon$17", {
  Ljava_time_temporal_ChronoField$$anon$17: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$17;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$18() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInYear", 17, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "ALIGNED_DAY_OF_WEEK_IN_YEAR", 17)
}
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$18;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$18() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$18.prototype = $c_Ljava_time_temporal_ChronoField$$anon$18.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$18 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$18: 0
}, false, "java.time.temporal.ChronoField$$anon$18", {
  Ljava_time_temporal_ChronoField$$anon$18: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$18;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$19() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $$x1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfMonth", 18, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(28, 0), new $c_RTLong(31, 0)), "DAY_OF_MONTH", 18)
}
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$19;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$19() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$19.prototype = $c_Ljava_time_temporal_ChronoField$$anon$19.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$19 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$19: 0
}, false, "java.time.temporal.ChronoField$$anon$19", {
  Ljava_time_temporal_ChronoField$$anon$19: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$19;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfDay", 1, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong((-1857093633), 20116)), "NANO_OF_DAY", 1)
}
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$2.prototype = $c_Ljava_time_temporal_ChronoField$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$2 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$2: 0
}, false, "java.time.temporal.ChronoField$$anon$2", {
  Ljava_time_temporal_ChronoField$$anon$2: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$2;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$20() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $$x1 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfYear", 19, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(365, 0), new $c_RTLong(366, 0)), "DAY_OF_YEAR", 19)
}
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$20;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$20() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$20.prototype = $c_Ljava_time_temporal_ChronoField$$anon$20.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$20 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$20: 0
}, false, "java.time.temporal.ChronoField$$anon$20", {
  Ljava_time_temporal_ChronoField$$anon$20: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$20;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$21() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "EpochDay", 20, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-170999002), (-86)), new $c_RTLong(169560311, 85)), "EPOCH_DAY", 20)
}
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$21;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$21() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$21.prototype = $c_Ljava_time_temporal_ChronoField$$anon$21.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$21 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$21: 0
}, false, "java.time.temporal.ChronoField$$anon$21", {
  Ljava_time_temporal_ChronoField$$anon$21: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$21;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$22() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x2 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  var $$x1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfMonth", 21, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(4, 0), new $c_RTLong(5, 0)), "ALIGNED_WEEK_OF_MONTH", 21)
}
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$22;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$22() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$22.prototype = $c_Ljava_time_temporal_ChronoField$$anon$22.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$22 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$22: 0
}, false, "java.time.temporal.ChronoField$$anon$22", {
  Ljava_time_temporal_ChronoField$$anon$22: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$22;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$23() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfYear", 22, $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(53, 0)), "ALIGNED_WEEK_OF_YEAR", 22)
}
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$23;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$23() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$23.prototype = $c_Ljava_time_temporal_ChronoField$$anon$23.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$23 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$23: 0
}, false, "java.time.temporal.ChronoField$$anon$23", {
  Ljava_time_temporal_ChronoField$$anon$23: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$23;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$24() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MonthOfYear", 23, $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)), "MONTH_OF_YEAR", 23)
}
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$24;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$24() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$24.prototype = $c_Ljava_time_temporal_ChronoField$$anon$24.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$24 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$24: 0
}, false, "java.time.temporal.ChronoField$$anon$24", {
  Ljava_time_temporal_ChronoField$$anon$24: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$24;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$25() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x4 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var $$x3 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $$x2 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var $$x1 = new $c_RTLong(lo, hi$1);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(12, b0$1);
  var a0b1$1 = Math.imul(12, b1$1);
  var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((Math.imul(12, hi$2) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$2 = ((11 + lo$1) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) < (-2147483637)) ? ((1 + hi$3) | 0) : hi$3);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ProlepticMonth", 24, $$x4, $$x3, $$x2.of__J__J__Ljava_time_temporal_ValueRange($$x1, new $c_RTLong(lo$2, hi$4)), "PROLEPTIC_MONTH", 24)
}
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$25;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$25() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$25.prototype = $c_Ljava_time_temporal_ChronoField$$anon$25.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$25 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$25: 0
}, false, "java.time.temporal.ChronoField$$anon$25", {
  Ljava_time_temporal_ChronoField$$anon$25: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$25;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$26() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x2 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $$x1 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var this$4 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi = (value >> 31);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  var lo = ((1 + value$1) | 0);
  var hi$2 = ((lo === 0) ? ((1 + hi$1) | 0) : hi$1);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "YearOfEra", 25, $$x2, $$x1, this$4.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(value, hi), new $c_RTLong(lo, hi$2)), "YEAR_OF_ERA", 25)
}
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$26;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$26() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$26.prototype = $c_Ljava_time_temporal_ChronoField$$anon$26.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$26 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$26: 0
}, false, "java.time.temporal.ChronoField$$anon$26", {
  Ljava_time_temporal_ChronoField$$anon$26: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$26;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$27() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  var $$x4 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $$x3 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $$x2 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var $$x1 = new $c_RTLong(value, hi);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Year", 26, $$x4, $$x3, $$x2.of__J__J__Ljava_time_temporal_ValueRange($$x1, new $c_RTLong(value$1, hi$1)), "YEAR", 26)
}
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$27;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$27() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$27.prototype = $c_Ljava_time_temporal_ChronoField$$anon$27.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$27 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$27: 0
}, false, "java.time.temporal.ChronoField$$anon$27", {
  Ljava_time_temporal_ChronoField$$anon$27: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$27;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$28() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Era", 27, $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)), "ERA", 27)
}
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$28;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$28() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$28.prototype = $c_Ljava_time_temporal_ChronoField$$anon$28.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$28 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$28: 0
}, false, "java.time.temporal.ChronoField$$anon$28", {
  Ljava_time_temporal_ChronoField$$anon$28: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$28;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$29() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "InstantSeconds", 28, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(0, (-2147483648)), new $c_RTLong((-1), 2147483647)), "INSTANT_SECONDS", 28)
}
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$29;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$29() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$29.prototype = $c_Ljava_time_temporal_ChronoField$$anon$29.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$29 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$29: 0
}, false, "java.time.temporal.ChronoField$$anon$29", {
  Ljava_time_temporal_ChronoField$$anon$29: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$29;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfSecond", 2, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999, 0)), "MICRO_OF_SECOND", 2)
}
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$3.prototype = $c_Ljava_time_temporal_ChronoField$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$3 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$3: 0
}, false, "java.time.temporal.ChronoField$$anon$3", {
  Ljava_time_temporal_ChronoField$$anon$3: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$3;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$30() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "OffsetSeconds", 29, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-64800), (-1)), new $c_RTLong(64800, 0)), "OFFSET_SECONDS", 29)
}
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$30;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$30() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$30.prototype = $c_Ljava_time_temporal_ChronoField$$anon$30.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$30 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$30: 0
}, false, "java.time.temporal.ChronoField$$anon$30", {
  Ljava_time_temporal_ChronoField$$anon$30: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$30;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfDay", 3, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(500654079, 20)), "MICRO_OF_DAY", 3)
}
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$4.prototype = $c_Ljava_time_temporal_ChronoField$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$4 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$4: 0
}, false, "java.time.temporal.ChronoField$$anon$4", {
  Ljava_time_temporal_ChronoField$$anon$4: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$4;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfSecond", 4, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999, 0)), "MILLI_OF_SECOND", 4)
}
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$5.prototype = $c_Ljava_time_temporal_ChronoField$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$5 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$5: 0
}, false, "java.time.temporal.ChronoField$$anon$5", {
  Ljava_time_temporal_ChronoField$$anon$5: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$5;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfDay", 5, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399999, 0)), "MILLI_OF_DAY", 5)
}
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$6.prototype = $c_Ljava_time_temporal_ChronoField$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$6 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$6: 0
}, false, "java.time.temporal.ChronoField$$anon$6", {
  Ljava_time_temporal_ChronoField$$anon$6: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$6;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfMinute", 6, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)), "SECOND_OF_MINUTE", 6)
}
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$7.prototype = $c_Ljava_time_temporal_ChronoField$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$7 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$7: 0
}, false, "java.time.temporal.ChronoField$$anon$7", {
  Ljava_time_temporal_ChronoField$$anon$7: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$7;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfDay", 7, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399, 0)), "SECOND_OF_DAY", 7)
}
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$8() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$8.prototype = $c_Ljava_time_temporal_ChronoField$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$8 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$8: 0
}, false, "java.time.temporal.ChronoField$$anon$8", {
  Ljava_time_temporal_ChronoField$$anon$8: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$8;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_baseUnit = null;
  this.Ljava_time_temporal_ChronoField__f_rangeUnit = null;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoField__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfHour", 8, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)), "MINUTE_OF_HOUR", 8)
}
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$9() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$$anon$9.prototype = $c_Ljava_time_temporal_ChronoField$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoField$$anon$9 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$$anon$9: 0
}, false, "java.time.temporal.ChronoField$$anon$9", {
  Ljava_time_temporal_ChronoField$$anon$9: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.$classData = $d_Ljava_time_temporal_ChronoField$$anon$9;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Nanos", 0, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1, 0)), "NANOS", 0)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$1 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$1: 0
}, false, "java.time.temporal.ChronoUnit$$anon$1", {
  Ljava_time_temporal_ChronoUnit$$anon$1: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Months", 9, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(2629746, 0), 0), "MONTHS", 9)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$10() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$10 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$10: 0
}, false, "java.time.temporal.ChronoUnit$$anon$10", {
  Ljava_time_temporal_ChronoUnit$$anon$10: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$10;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Years", 10, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(31556952, 0), 0), "YEARS", 10)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$11() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$11 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$11: 0
}, false, "java.time.temporal.ChronoUnit$$anon$11", {
  Ljava_time_temporal_ChronoUnit$$anon$11: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$11;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Decades", 11, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(315569520, 0), 0), "DECADES", 11)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$12() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$12 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$12: 0
}, false, "java.time.temporal.ChronoUnit$$anon$12", {
  Ljava_time_temporal_ChronoUnit$$anon$12: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$12;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Centuries", 12, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong((-1139272096), 0), 0), "CENTURIES", 12)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$13() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$13 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$13: 0
}, false, "java.time.temporal.ChronoUnit$$anon$13", {
  Ljava_time_temporal_ChronoUnit$$anon$13: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$13;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millenia", 13, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1492180928, 7), 0), "MILLENNIA", 13)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$14() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$14 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$14: 0
}, false, "java.time.temporal.ChronoUnit$$anon$14", {
  Ljava_time_temporal_ChronoUnit$$anon$14: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$14;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Eras", 14, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1915187200, 7347425), 0), "ERAS", 14)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$15() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$15 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$15: 0
}, false, "java.time.temporal.ChronoUnit$$anon$15", {
  Ljava_time_temporal_ChronoUnit$$anon$15: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$15;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Forever", 15, $m_Ljava_time_Duration$().ofSeconds__J__J__Ljava_time_Duration(new $c_RTLong((-1), 2147483647), new $c_RTLong(999999999, 0)), "FOREVER", 15)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$16() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$16 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$16: 0
}, false, "java.time.temporal.ChronoUnit$$anon$16", {
  Ljava_time_temporal_ChronoUnit$$anon$16: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$16;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Micros", 1, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000, 0)), "MICROS", 1)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$2 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$2: 0
}, false, "java.time.temporal.ChronoUnit$$anon$2", {
  Ljava_time_temporal_ChronoUnit$$anon$2: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$2;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millis", 2, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000000, 0)), "MILLIS", 2)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$3 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$3: 0
}, false, "java.time.temporal.ChronoUnit$$anon$3", {
  Ljava_time_temporal_ChronoUnit$$anon$3: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$3;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Seconds", 3, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1, 0), 0), "SECONDS", 3)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$4 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$4: 0
}, false, "java.time.temporal.ChronoUnit$$anon$4", {
  Ljava_time_temporal_ChronoUnit$$anon$4: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$4;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Minutes", 4, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(60, 0), 0), "MINUTES", 4)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$5 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$5: 0
}, false, "java.time.temporal.ChronoUnit$$anon$5", {
  Ljava_time_temporal_ChronoUnit$$anon$5: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$5;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Hours", 5, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(3600, 0), 0), "HOURS", 5)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$6 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$6: 0
}, false, "java.time.temporal.ChronoUnit$$anon$6", {
  Ljava_time_temporal_ChronoUnit$$anon$6: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$6;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "HalfDays", 6, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(43200, 0), 0), "HALF_DAYS", 6)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$7 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$7: 0
}, false, "java.time.temporal.ChronoUnit$$anon$7", {
  Ljava_time_temporal_ChronoUnit$$anon$7: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$7;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Days", 7, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(86400, 0), 0), "DAYS", 7)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$8() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$8 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$8: 0
}, false, "java.time.temporal.ChronoUnit$$anon$8", {
  Ljava_time_temporal_ChronoUnit$$anon$8: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$8;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_values$lzy1 = null;
  this.Ljava_time_temporal_ChronoUnit__f_valuesbitmap$1 = false;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Weeks", 8, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(604800, 0), 0), "WEEKS", 8)
}
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$9() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$9 = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$$anon$9: 0
}, false, "java.time.temporal.ChronoUnit$$anon$9", {
  Ljava_time_temporal_ChronoUnit$$anon$9: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$$anon$9;
/** @constructor */
function $c_sc_AbstractMap() {
  /*<skip>*/
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
  /*<skip>*/
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o)
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this)
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map"
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.mapFactory__sc_MapFactory().newBuilder__scm_Builder()
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMap.prototype.keySet__sc_Set = (function() {
  return new $c_sc_MapOps$KeySet(this)
});
$c_sc_AbstractMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this)
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f)
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key)
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_AbstractMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix)
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
  /*<skip>*/
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Drop__f_underlying;
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0)
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Drop__f_underlying.apply__I__O(((i + this.sc_View$Drop__f_normN) | 0))
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0))
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
var $d_sc_SeqView$Drop = new $TypeData().initClass({
  sc_SeqView$Drop: 0
}, false, "scala.collection.SeqView$Drop", {
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Drop.prototype.$classData = $d_sc_SeqView$Drop;
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
  /*<skip>*/
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Id__f_underlying.apply__I__O(idx)
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return this.sc_SeqView$Id__f_underlying.length__I()
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Id__f_underlying.knownSize__I()
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_SeqView$Id = new $TypeData().initClass({
  sc_SeqView$Id: 0
}, false, "scala.collection.SeqView$Id", {
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Id.prototype.$classData = $d_sc_SeqView$Id;
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
  /*<skip>*/
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Map__f_f.apply__O__O(this.sc_SeqView$Map__f_underlying.apply__I__O(idx))
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return this.sc_SeqView$Map__f_underlying.length__I()
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Map = new $TypeData().initClass({
  sc_SeqView$Map: 0
}, false, "scala.collection.SeqView$Map", {
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Map.prototype.$classData = $d_sc_SeqView$Map;
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null
}
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
  /*<skip>*/
}
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Reverse__f_underlying.apply__I__O((((((-1) + this.length__I()) | 0) - i) | 0))
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Reverse__f_underlying;
  return this$1.length__I()
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Reverse__f_underlying.reverseIterator__sc_Iterator()
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Reverse__f_underlying.knownSize__I()
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Reverse__f_underlying.isEmpty__Z()
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass({
  sc_SeqView$Reverse: 0
}, false, "scala.collection.SeqView$Reverse", {
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Reverse.prototype.$classData = $d_sc_SeqView$Reverse;
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Take__f_underlying = underlying;
  $thiz.sc_SeqView$Take__f_n = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0
}
$c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$c_sc_SeqView$Take.prototype.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
  /*<skip>*/
}
$h_sc_SeqView$Take.prototype = $c_sc_SeqView$Take.prototype;
$c_sc_SeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Take.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Take.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_SeqView$Take.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Take.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Take.prototype.apply__I__O = (function(idx) {
  if ((idx < this.sc_SeqView$Take__f_n)) {
    return this.sc_SeqView$Take__f_underlying.apply__I__O(idx)
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + ((this.sc_SeqView$Take__f_underlying.knownSize__I() >= 0) ? (((-1) + this.knownSize__I()) | 0) : "unknown")) + ")"))
  }
});
$c_sc_SeqView$Take.prototype.length__I = (function() {
  var x = this.sc_SeqView$Take__f_underlying.length__I();
  var that = this.sc_View$Take__f_normN;
  return ((x < that) ? x : that)
});
$c_sc_SeqView$Take.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Take = new $TypeData().initClass({
  sc_SeqView$Take: 0
}, false, "scala.collection.SeqView$Take", {
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Take.prototype.$classData = $d_sc_SeqView$Take;
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  };
  if ($is_sc_SortedSet(that)) {
    var x2 = $as_sc_SortedSet(that);
    var x = x2.ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      if (($thiz.size__I() === x2.size__I())) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = x2.iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && i1.hasNext__Z())) {
          allEqual = $thiz.ordering__s_math_Ordering().equiv__O__O__Z(i1.next__O(), i2.next__O())
        };
        return allEqual
      } else {
        return false
      }
    }
  };
  return $f_sc_Set__equals__O__Z($thiz, that)
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)))
}
function $as_sc_SortedSet(obj) {
  return (($is_sc_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedSet"))
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)))
}
function $asArrayOf_sc_SortedSet(obj, depth) {
  return (($isArrayOf_sc_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedSet;", depth))
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)))
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"))
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)))
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth))
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, op) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = op.apply__O();
      $thiz.update__O__O__V(key, d);
      return d
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lcats_Invariant$() {
  this.Lcats_Invariant$__f_catsInvariantMonoid = null;
  this.Lcats_Invariant$__f_catsInvariantBand = null;
  this.Lcats_Invariant$__f_catsInvariantSemilattice = null;
  this.Lcats_Invariant$__f_catsInvariantCommutativeMonoid = null;
  this.Lcats_Invariant$__f_catsInvariantBoundedSemilattice = null;
  this.Lcats_Invariant$__f_catsInvariantGroup = null;
  this.Lcats_Invariant$__f_catsInvariantCommutativeGroup = null;
  $n_Lcats_Invariant$ = this;
  this.Lcats_Invariant$__f_catsInvariantMonoid = new $c_Lcats_Invariant$$anon$4();
  this.Lcats_Invariant$__f_catsInvariantBand = new $c_Lcats_Invariant$$anon$5();
  this.Lcats_Invariant$__f_catsInvariantSemilattice = new $c_Lcats_Invariant$$anon$6();
  this.Lcats_Invariant$__f_catsInvariantCommutativeMonoid = new $c_Lcats_Invariant$$anon$7();
  this.Lcats_Invariant$__f_catsInvariantBoundedSemilattice = new $c_Lcats_Invariant$$anon$8();
  this.Lcats_Invariant$__f_catsInvariantGroup = new $c_Lcats_Invariant$$anon$9();
  this.Lcats_Invariant$__f_catsInvariantCommutativeGroup = new $c_Lcats_Invariant$$anon$10()
}
$c_Lcats_Invariant$.prototype = new $h_O();
$c_Lcats_Invariant$.prototype.constructor = $c_Lcats_Invariant$;
/** @constructor */
function $h_Lcats_Invariant$() {
  /*<skip>*/
}
$h_Lcats_Invariant$.prototype = $c_Lcats_Invariant$.prototype;
var $d_Lcats_Invariant$ = new $TypeData().initClass({
  Lcats_Invariant$: 0
}, false, "cats.Invariant$", {
  Lcats_Invariant$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificInvariantInstances: 1,
  Lcats_instances_NTupleMonadInstances5: 1,
  Lcats_instances_NTupleMonadInstances4: 1,
  Lcats_instances_NTupleMonadInstances3: 1,
  Lcats_instances_NTupleMonadInstances2: 1,
  Lcats_instances_NTupleMonadInstances1: 1,
  Lcats_instances_NTupleMonadInstances: 1,
  Lcats_TupleInstances2: 1,
  Lcats_TupleInstances1: 1,
  Lcats_TupleInstances0: 1,
  Lcats_InvariantInstances2: 1,
  Lcats_InvariantInstances1: 1,
  Lcats_InvariantInstances0: 1
});
$c_Lcats_Invariant$.prototype.$classData = $d_Lcats_Invariant$;
var $n_Lcats_Invariant$;
function $m_Lcats_Invariant$() {
  if ((!$n_Lcats_Invariant$)) {
    $n_Lcats_Invariant$ = new $c_Lcats_Invariant$()
  };
  return $n_Lcats_Invariant$
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$7(E$1) {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null;
  $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__(this, E$1)
}
$c_Lcats_data_ValidatedInstances$$anon$7.prototype = new $h_Lcats_data_ValidatedApplicative();
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$7() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances$$anon$7.prototype = $c_Lcats_data_ValidatedInstances$$anon$7.prototype;
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated = (function(fa, f) {
  if ((fa instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1 = $as_Lcats_data_Validated$Invalid(fa);
    var x388 = x$1.Lcats_data_Validated$Invalid__f_e;
    return $as_Lcats_data_Validated(f.apply__O__O(x388))
  };
  if ((fa instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1$1 = $as_Lcats_data_Validated$Valid(fa);
    var v = $as_Lcats_data_Validated$Valid(fa);
    return v
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated($as_Lcats_data_Validated(fa), f)
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.raiseError__O__O = (function(e) {
  return new $c_Lcats_data_Validated$Invalid(e)
});
var $d_Lcats_data_ValidatedInstances$$anon$7 = new $TypeData().initClass({
  Lcats_data_ValidatedInstances$$anon$7: 0
}, false, "cats.data.ValidatedInstances$$anon$7", {
  Lcats_data_ValidatedInstances$$anon$7: 1,
  Lcats_data_ValidatedApplicative: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_ApplicativeError: 1
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.$classData = $d_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $c_Lcats_data_WriterTInstances0() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances0.prototype = new $h_Lcats_data_WriterTInstances1();
$c_Lcats_data_WriterTInstances0.prototype.constructor = $c_Lcats_data_WriterTInstances0;
/** @constructor */
function $h_Lcats_data_WriterTInstances0() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances0.prototype = $c_Lcats_data_WriterTInstances0.prototype;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$6() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$6.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$6;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$6.prototype = $c_Lio_circe_KeyDecoder$$anon$6.prototype;
$c_Lio_circe_KeyDecoder$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.pure__O__O = (function(x) {
  return new $c_Lio_circe_KeyDecoder$$anon$9(x)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  return new $c_Lio_circe_KeyDecoder$$anon$1(f, fa$1)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  return new $c_Lio_circe_KeyDecoder$$anon$2(f, fa$1)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.raiseError__O__O = (function(e) {
  $as_jl_Void(e);
  return new $c_Lio_circe_KeyDecoder$$anon$10()
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  return new $c_Lio_circe_KeyDecoder$$anon$11(fa$1, f)
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  return new $c_Lio_circe_KeyDecoder$$anon$12(a, f)
});
var $d_Lio_circe_KeyDecoder$$anon$6 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$6: 0
}, false, "io.circe.KeyDecoder$$anon$6", {
  Lio_circe_KeyDecoder$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$6;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "MONDAY", 0, "MONDAY", 0)
}
$c_Ljava_time_DayOfWeek$$anon$1.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$1.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$1;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$1.prototype = $c_Ljava_time_DayOfWeek$$anon$1.prototype;
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$1 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$1: 0
}, false, "java.time.DayOfWeek$$anon$1", {
  Ljava_time_DayOfWeek$$anon$1: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$1;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "TUESDAY", 1, "TUESDAY", 1)
}
$c_Ljava_time_DayOfWeek$$anon$2.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$2.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$2;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$2.prototype = $c_Ljava_time_DayOfWeek$$anon$2.prototype;
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$2 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$2: 0
}, false, "java.time.DayOfWeek$$anon$2", {
  Ljava_time_DayOfWeek$$anon$2: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$2;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "WEDNESDAY", 2, "WEDNESDAY", 2)
}
$c_Ljava_time_DayOfWeek$$anon$3.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$3.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$3;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$3.prototype = $c_Ljava_time_DayOfWeek$$anon$3.prototype;
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$3 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$3: 0
}, false, "java.time.DayOfWeek$$anon$3", {
  Ljava_time_DayOfWeek$$anon$3: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$3;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "THURSDAY", 3, "THURSDAY", 3)
}
$c_Ljava_time_DayOfWeek$$anon$4.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$4.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$4;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$4.prototype = $c_Ljava_time_DayOfWeek$$anon$4.prototype;
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$4 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$4: 0
}, false, "java.time.DayOfWeek$$anon$4", {
  Ljava_time_DayOfWeek$$anon$4: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$4;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "FRIDAY", 4, "FRIDAY", 4)
}
$c_Ljava_time_DayOfWeek$$anon$5.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$5.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$5;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$5.prototype = $c_Ljava_time_DayOfWeek$$anon$5.prototype;
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$5 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$5: 0
}, false, "java.time.DayOfWeek$$anon$5", {
  Ljava_time_DayOfWeek$$anon$5: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$5;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SATURDAY", 5, "SATURDAY", 5)
}
$c_Ljava_time_DayOfWeek$$anon$6.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$6.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$6;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$6.prototype = $c_Ljava_time_DayOfWeek$$anon$6.prototype;
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$6 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$6: 0
}, false, "java.time.DayOfWeek$$anon$6", {
  Ljava_time_DayOfWeek$$anon$6: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$6;
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SUNDAY", 6, "SUNDAY", 6)
}
$c_Ljava_time_DayOfWeek$$anon$7.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$7.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$7;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$$anon$7.prototype = $c_Ljava_time_DayOfWeek$$anon$7.prototype;
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_DayOfWeek$$anon$7 = new $TypeData().initClass({
  Ljava_time_DayOfWeek$$anon$7: 0
}, false, "java.time.DayOfWeek$$anon$7", {
  Ljava_time_DayOfWeek$$anon$7: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.$classData = $d_Ljava_time_DayOfWeek$$anon$7;
/** @constructor */
function $c_Ljava_time_Month$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JANUARY", 0, "JANUARY", 0)
}
$c_Ljava_time_Month$$anon$1.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$1.prototype.constructor = $c_Ljava_time_Month$$anon$1;
/** @constructor */
function $h_Ljava_time_Month$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$1.prototype = $c_Ljava_time_Month$$anon$1.prototype;
$c_Ljava_time_Month$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$1 = new $TypeData().initClass({
  Ljava_time_Month$$anon$1: 0
}, false, "java.time.Month$$anon$1", {
  Ljava_time_Month$$anon$1: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$1.prototype.$classData = $d_Ljava_time_Month$$anon$1;
/** @constructor */
function $c_Ljava_time_Month$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "OCTOBER", 9, "OCTOBER", 9)
}
$c_Ljava_time_Month$$anon$10.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$10.prototype.constructor = $c_Ljava_time_Month$$anon$10;
/** @constructor */
function $h_Ljava_time_Month$$anon$10() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$10.prototype = $c_Ljava_time_Month$$anon$10.prototype;
$c_Ljava_time_Month$$anon$10.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$10 = new $TypeData().initClass({
  Ljava_time_Month$$anon$10: 0
}, false, "java.time.Month$$anon$10", {
  Ljava_time_Month$$anon$10: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$10.prototype.$classData = $d_Ljava_time_Month$$anon$10;
/** @constructor */
function $c_Ljava_time_Month$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "NOVEMBER", 10, "NOVEMBER", 10)
}
$c_Ljava_time_Month$$anon$11.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$11.prototype.constructor = $c_Ljava_time_Month$$anon$11;
/** @constructor */
function $h_Ljava_time_Month$$anon$11() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$11.prototype = $c_Ljava_time_Month$$anon$11.prototype;
$c_Ljava_time_Month$$anon$11.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$11 = new $TypeData().initClass({
  Ljava_time_Month$$anon$11: 0
}, false, "java.time.Month$$anon$11", {
  Ljava_time_Month$$anon$11: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$11.prototype.$classData = $d_Ljava_time_Month$$anon$11;
/** @constructor */
function $c_Ljava_time_Month$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "DECEMBER", 11, "DECEMBER", 11)
}
$c_Ljava_time_Month$$anon$12.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$12.prototype.constructor = $c_Ljava_time_Month$$anon$12;
/** @constructor */
function $h_Ljava_time_Month$$anon$12() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$12.prototype = $c_Ljava_time_Month$$anon$12.prototype;
$c_Ljava_time_Month$$anon$12.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$12 = new $TypeData().initClass({
  Ljava_time_Month$$anon$12: 0
}, false, "java.time.Month$$anon$12", {
  Ljava_time_Month$$anon$12: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$12.prototype.$classData = $d_Ljava_time_Month$$anon$12;
/** @constructor */
function $c_Ljava_time_Month$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "FEBRUARY", 1, "FEBRUARY", 1)
}
$c_Ljava_time_Month$$anon$2.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$2.prototype.constructor = $c_Ljava_time_Month$$anon$2;
/** @constructor */
function $h_Ljava_time_Month$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$2.prototype = $c_Ljava_time_Month$$anon$2.prototype;
$c_Ljava_time_Month$$anon$2.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$2 = new $TypeData().initClass({
  Ljava_time_Month$$anon$2: 0
}, false, "java.time.Month$$anon$2", {
  Ljava_time_Month$$anon$2: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$2.prototype.$classData = $d_Ljava_time_Month$$anon$2;
/** @constructor */
function $c_Ljava_time_Month$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MARCH", 2, "MARCH", 2)
}
$c_Ljava_time_Month$$anon$3.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$3.prototype.constructor = $c_Ljava_time_Month$$anon$3;
/** @constructor */
function $h_Ljava_time_Month$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$3.prototype = $c_Ljava_time_Month$$anon$3.prototype;
$c_Ljava_time_Month$$anon$3.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$3 = new $TypeData().initClass({
  Ljava_time_Month$$anon$3: 0
}, false, "java.time.Month$$anon$3", {
  Ljava_time_Month$$anon$3: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$3.prototype.$classData = $d_Ljava_time_Month$$anon$3;
/** @constructor */
function $c_Ljava_time_Month$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "APRIL", 3, "APRIL", 3)
}
$c_Ljava_time_Month$$anon$4.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$4.prototype.constructor = $c_Ljava_time_Month$$anon$4;
/** @constructor */
function $h_Ljava_time_Month$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$4.prototype = $c_Ljava_time_Month$$anon$4.prototype;
$c_Ljava_time_Month$$anon$4.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$4 = new $TypeData().initClass({
  Ljava_time_Month$$anon$4: 0
}, false, "java.time.Month$$anon$4", {
  Ljava_time_Month$$anon$4: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$4.prototype.$classData = $d_Ljava_time_Month$$anon$4;
/** @constructor */
function $c_Ljava_time_Month$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MAY", 4, "MAY", 4)
}
$c_Ljava_time_Month$$anon$5.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$5.prototype.constructor = $c_Ljava_time_Month$$anon$5;
/** @constructor */
function $h_Ljava_time_Month$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$5.prototype = $c_Ljava_time_Month$$anon$5.prototype;
$c_Ljava_time_Month$$anon$5.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$5 = new $TypeData().initClass({
  Ljava_time_Month$$anon$5: 0
}, false, "java.time.Month$$anon$5", {
  Ljava_time_Month$$anon$5: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$5.prototype.$classData = $d_Ljava_time_Month$$anon$5;
/** @constructor */
function $c_Ljava_time_Month$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JUNE", 5, "JUNE", 5)
}
$c_Ljava_time_Month$$anon$6.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$6.prototype.constructor = $c_Ljava_time_Month$$anon$6;
/** @constructor */
function $h_Ljava_time_Month$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$6.prototype = $c_Ljava_time_Month$$anon$6.prototype;
$c_Ljava_time_Month$$anon$6.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$6 = new $TypeData().initClass({
  Ljava_time_Month$$anon$6: 0
}, false, "java.time.Month$$anon$6", {
  Ljava_time_Month$$anon$6: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$6.prototype.$classData = $d_Ljava_time_Month$$anon$6;
/** @constructor */
function $c_Ljava_time_Month$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JULY", 6, "JULY", 6)
}
$c_Ljava_time_Month$$anon$7.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$7.prototype.constructor = $c_Ljava_time_Month$$anon$7;
/** @constructor */
function $h_Ljava_time_Month$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$7.prototype = $c_Ljava_time_Month$$anon$7.prototype;
$c_Ljava_time_Month$$anon$7.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$7 = new $TypeData().initClass({
  Ljava_time_Month$$anon$7: 0
}, false, "java.time.Month$$anon$7", {
  Ljava_time_Month$$anon$7: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$7.prototype.$classData = $d_Ljava_time_Month$$anon$7;
/** @constructor */
function $c_Ljava_time_Month$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "AUGUST", 7, "AUGUST", 7)
}
$c_Ljava_time_Month$$anon$8.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$8.prototype.constructor = $c_Ljava_time_Month$$anon$8;
/** @constructor */
function $h_Ljava_time_Month$$anon$8() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$8.prototype = $c_Ljava_time_Month$$anon$8.prototype;
$c_Ljava_time_Month$$anon$8.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$8 = new $TypeData().initClass({
  Ljava_time_Month$$anon$8: 0
}, false, "java.time.Month$$anon$8", {
  Ljava_time_Month$$anon$8: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$8.prototype.$classData = $d_Ljava_time_Month$$anon$8;
/** @constructor */
function $c_Ljava_time_Month$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "SEPTEMBER", 8, "SEPTEMBER", 8)
}
$c_Ljava_time_Month$$anon$9.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$9.prototype.constructor = $c_Ljava_time_Month$$anon$9;
/** @constructor */
function $h_Ljava_time_Month$$anon$9() {
  /*<skip>*/
}
$h_Ljava_time_Month$$anon$9.prototype = $c_Ljava_time_Month$$anon$9.prototype;
$c_Ljava_time_Month$$anon$9.prototype.productArity__I = (function() {
  return 0
});
$c_Ljava_time_Month$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Ljava_time_Month$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name
});
var $d_Ljava_time_Month$$anon$9 = new $TypeData().initClass({
  Ljava_time_Month$$anon$9: 0
}, false, "java.time.Month$$anon$9", {
  Ljava_time_Month$$anon$9: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ljava_time_Month$$anon$9.prototype.$classData = $d_Ljava_time_Month$$anon$9;
/** @constructor */
function $c_sc_AbstractMapView() {
  /*<skip>*/
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
  /*<skip>*/
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView"
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMapView.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this)
});
$c_sc_AbstractMapView.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMapView.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$()
});
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)))
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"))
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)))
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth))
}
/** @constructor */
function $c_Lcats_data_WriterTInstances() {
  /*<skip>*/
}
$c_Lcats_data_WriterTInstances.prototype = new $h_Lcats_data_WriterTInstances0();
$c_Lcats_data_WriterTInstances.prototype.constructor = $c_Lcats_data_WriterTInstances;
/** @constructor */
function $h_Lcats_data_WriterTInstances() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances.prototype = $c_Lcats_data_WriterTInstances.prototype;
/** @constructor */
function $c_Lcats_instances_Function0Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Function0Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Function0Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Function0Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Function0Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Function0Instances$$anon$1.prototype = $c_Lcats_instances_Function0Instances$$anon$1.prototype;
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.pure__O__F0 = (function(x) {
  return new $c_sjsr_AnonFunction0(((x$2) => (() => x$2))(x))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map__F0__F1__F0 = (function(fa, fn) {
  return new $c_sjsr_AnonFunction0(((fa$2, fn$2) => (() => fn$2.apply__O__O(fa$2.apply__O())))(fa, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2__F0__F0__F2__F0 = (function(fa, fb, fn) {
  return new $c_sjsr_AnonFunction0(((fa$2, fb$2, fn$2) => (() => fn$2.apply__O__O__O(fa$2.apply__O(), fb$2.apply__O())))(fa, fb, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.product__F0__F0__F0 = (function(fa, fb) {
  return new $c_sjsr_AnonFunction0(((fa$2, fb$2) => (() => {
    var _1 = fa$2.apply__O();
    var _2 = fb$2.apply__O();
    return $ct_T2__O__O__(new $c_T2(), _1, _2)
  }))(fa, fb))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.flatMap__F0__F1__F0 = (function(fa, f) {
  return new $c_sjsr_AnonFunction0(((fa$2, f$2) => (() => $as_F0(f$2.apply__O__O(fa$2.apply__O())).apply__O()))(fa, f))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.tailRecM__O__F1__F0 = (function(a, fn) {
  return new $c_sjsr_AnonFunction0(((a$2, fn$2) => (() => $ps_Lcats_instances_Function0Instances__loop$1__F1__O__O(fn$2, a$2)))(a, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__F0(x)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__F0__F0__F2__F0($as_F0(fa), $as_F0(fb), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__F0__F0__F0($as_F0(fa), $as_F0(fb))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.flatMap__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__F0(a, f)
});
var $d_Lcats_instances_Function0Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Function0Instances$$anon$1: 0
}, false, "cats.instances.Function0Instances$$anon$1", {
  Lcats_instances_Function0Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Function0Instances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BooleanOrder() {
  this.Lcats_kernel_instances_BooleanOrder__f_order = null;
  this.Lcats_kernel_instances_BooleanOrder__f_order = this
}
$c_Lcats_kernel_instances_BooleanOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BooleanOrder.prototype.constructor = $c_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BooleanOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BooleanOrder.prototype = $c_Lcats_kernel_instances_BooleanOrder.prototype;
$c_Lcats_kernel_instances_BooleanOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare__Z__Z__I = (function(x, y) {
  return ((x === y) ? 0 : (x ? 1 : (-1)))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv__Z__Z__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.neqv__Z__Z__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uZ(x);
  return (x$1 ? 1231 : 1237)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Z__Z__I($uZ(x), $uZ(y))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__Z__Z__Z($uZ(x), $uZ(y))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__Z__Z__Z($uZ(x), $uZ(y))
});
var $d_Lcats_kernel_instances_BooleanOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BooleanOrder: 0
}, false, "cats.kernel.instances.BooleanOrder", {
  Lcats_kernel_instances_BooleanOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_BooleanBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_BooleanEnumerable: 1
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.$classData = $d_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
  this.Lcats_kernel_instances_ByteOrder__f_order = null;
  this.Lcats_kernel_instances_ByteOrder__f_order = this
}
$c_Lcats_kernel_instances_ByteOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__B__B__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__B__B__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__B__B__I($uB(x), $uB(y))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__B__B__Z($uB(x), $uB(y))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__B__B__Z($uB(x), $uB(y))
});
var $d_Lcats_kernel_instances_ByteOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ByteOrder: 0
}, false, "cats.kernel.instances.ByteOrder", {
  Lcats_kernel_instances_ByteOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ByteEnumerable: 1
});
$c_Lcats_kernel_instances_ByteOrder.prototype.$classData = $d_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $c_Lcats_kernel_instances_CharOrder() {
  this.Lcats_kernel_instances_CharOrder__f_order = null;
  this.Lcats_kernel_instances_CharOrder__f_order = this
}
$c_Lcats_kernel_instances_CharOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_CharOrder.prototype.constructor = $c_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $h_Lcats_kernel_instances_CharOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_CharOrder.prototype = $c_Lcats_kernel_instances_CharOrder.prototype;
$c_Lcats_kernel_instances_CharOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__C__C__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__C__C__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.neqv__C__C__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__C__C__I($uC(x), $uC(y))
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__C__C__Z($uC(x), $uC(y))
});
$c_Lcats_kernel_instances_CharOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__C__C__Z($uC(x), $uC(y))
});
var $d_Lcats_kernel_instances_CharOrder = new $TypeData().initClass({
  Lcats_kernel_instances_CharOrder: 0
}, false, "cats.kernel.instances.CharOrder", {
  Lcats_kernel_instances_CharOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_CharBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_CharEnumerable: 1
});
$c_Lcats_kernel_instances_CharOrder.prototype.$classData = $d_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
  this.Lcats_kernel_instances_IntOrder__f_order = null;
  this.Lcats_kernel_instances_IntOrder__f_order = this
}
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__I__I__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__I__I__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__I__I__I($uI(x), $uI(y))
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__I__I__Z($uI(x), $uI(y))
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__I__I__Z($uI(x), $uI(y))
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_IntOrder: 0
}, false, "cats.kernel.instances.IntOrder", {
  Lcats_kernel_instances_IntOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_IntEnumerable: 1
});
$c_Lcats_kernel_instances_IntOrder.prototype.$classData = $d_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
  this.Lcats_kernel_instances_LongOrder__f_order = null;
  this.Lcats_kernel_instances_LongOrder__f_order = this
}
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__J__J__I = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ x.RTLong__f_lo) < ((-2147483648) ^ y.RTLong__f_lo)) : (ahi < bhi))) {
    return (-1)
  } else {
    var ahi$1 = x.RTLong__f_hi;
    var bhi$1 = y.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ x.RTLong__f_lo) > ((-2147483648) ^ y.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
      return 1
    } else {
      return 0
    }
  }
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__J__J__Z = (function(x, y) {
  return ((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi))
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__J__J__Z = (function(x, y) {
  return (!((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi)))
});
$c_Lcats_kernel_instances_LongOrder.prototype.hash__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__J__J__I($uJ(x), $uJ(y))
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__J__J__Z($uJ(x), $uJ(y))
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__J__J__Z($uJ(x), $uJ(y))
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass({
  Lcats_kernel_instances_LongOrder: 0
}, false, "cats.kernel.instances.LongOrder", {
  Lcats_kernel_instances_LongOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_LongEnumerable: 1
});
$c_Lcats_kernel_instances_LongOrder.prototype.$classData = $d_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
  this.Lcats_kernel_instances_ShortOrder__f_order = null;
  this.Lcats_kernel_instances_ShortOrder__f_order = this
}
$c_Lcats_kernel_instances_ShortOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__S__S__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__S__S__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__S__S__I($uS(x), $uS(y))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__S__S__Z($uS(x), $uS(y))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__S__S__Z($uS(x), $uS(y))
});
var $d_Lcats_kernel_instances_ShortOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ShortOrder: 0
}, false, "cats.kernel.instances.ShortOrder", {
  Lcats_kernel_instances_ShortOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ShortEnumerable: 1
});
$c_Lcats_kernel_instances_ShortOrder.prototype.$classData = $d_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
  this.Lcats_kernel_instances_UnitOrder__f_order = null;
  this.Lcats_kernel_instances_UnitOrder__f_order = this
}
$c_Lcats_kernel_instances_UnitOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return 0
});
$c_Lcats_kernel_instances_UnitOrder.prototype.hash__O__I = (function(x) {
  $as_jl_Void(x);
  return 0
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return true
});
$c_Lcats_kernel_instances_UnitOrder.prototype.neqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return false
});
var $d_Lcats_kernel_instances_UnitOrder = new $TypeData().initClass({
  Lcats_kernel_instances_UnitOrder: 0
}, false, "cats.kernel.instances.UnitOrder", {
  Lcats_kernel_instances_UnitOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_UnitEnumerable: 1
});
$c_Lcats_kernel_instances_UnitOrder.prototype.$classData = $d_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$32() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$32.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$32.prototype.constructor = $c_Lio_circe_Decoder$$anon$32;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$32() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$32.prototype = $c_Lio_circe_Decoder$$anon$32.prototype;
$c_Lio_circe_Decoder$$anon$32.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lio_circe_Decoder$$anon$32.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lio_circe_Decoder$$anon$32.prototype.combineK__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(x, y) {
  var d = new $c_sjsr_AnonFunction0(((y$2) => (() => y$2))(y));
  return new $c_Lio_circe_Decoder$$anon$9(d, x)
});
$c_Lio_circe_Decoder$$anon$32.prototype.map2__Lio_circe_Decoder__Lio_circe_Decoder__F2__Lio_circe_Decoder = (function(fa, fb, f) {
  var this$1 = new $c_Lio_circe_Decoder$$anon$8(fb, fa);
  var f$1 = new $c_sjsr_AnonFunction1(((f$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = x$1$1._1__O();
      var b = x$1$1._2__O();
      return f$2.apply__O__O__O(a, b)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f));
  return new $c_Lio_circe_Decoder$$anon$1(f$1, this$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($as_Lio_circe_Decoder(x), $as_Lio_circe_Decoder(y))
});
$c_Lio_circe_Decoder$$anon$32.prototype.pure__O__O = (function(x) {
  $m_Lio_circe_Decoder$();
  return new $c_Lio_circe_Decoder$$anon$33(x)
});
$c_Lio_circe_Decoder$$anon$32.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  return new $c_Lio_circe_Decoder$$anon$1(f, fa$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  var fb$1 = $as_Lio_circe_Decoder(fb);
  return new $c_Lio_circe_Decoder$$anon$8(fb$1, fa$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lio_circe_Decoder__Lio_circe_Decoder__F2__Lio_circe_Decoder($as_Lio_circe_Decoder(fa), $as_Lio_circe_Decoder(fb), f)
});
$c_Lio_circe_Decoder$$anon$32.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  return new $c_Lio_circe_Decoder$$anon$2(f, fa$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_Lio_circe_DecodingFailure(e);
  $m_Lio_circe_Decoder$();
  return new $c_Lio_circe_Decoder$$anon$38(e$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  return new $c_Lio_circe_Decoder$$anon$3(f, fa$1)
});
$c_Lio_circe_Decoder$$anon$32.prototype.tailRecM__O__F1__O = (function(a, f) {
  return new $c_Lio_circe_Decoder$$anon$78(a, f)
});
var $d_Lio_circe_Decoder$$anon$32 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$32: 0
}, false, "io.circe.Decoder$$anon$32", {
  Lio_circe_Decoder$$anon$32: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1
});
$c_Lio_circe_Decoder$$anon$32.prototype.$classData = $d_Lio_circe_Decoder$$anon$32;
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)))
}
function $as_sc_BitSet(obj) {
  return (($is_sc_BitSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSet"))
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)))
}
function $asArrayOf_sc_BitSet(obj, depth) {
  return (($isArrayOf_sc_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSet;", depth))
}
/** @constructor */
function $c_sc_MapOps$KeySet(outer) {
  this.sc_MapOps$KeySet__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_MapOps$KeySet__f_$outer = outer
  }
}
$c_sc_MapOps$KeySet.prototype = new $h_sc_AbstractSet();
$c_sc_MapOps$KeySet.prototype.constructor = $c_sc_MapOps$KeySet;
/** @constructor */
function $h_sc_MapOps$KeySet() {
  /*<skip>*/
}
$h_sc_MapOps$KeySet.prototype = $c_sc_MapOps$KeySet.prototype;
$c_sc_MapOps$KeySet.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapOps$KeySet__f_$outer.keysIterator__sc_Iterator()
});
$c_sc_MapOps$KeySet.prototype.contains__O__Z = (function(key) {
  return this.sc_MapOps$KeySet__f_$outer.contains__O__Z(key)
});
$c_sc_MapOps$KeySet.prototype.size__I = (function() {
  return this.sc_MapOps$KeySet__f_$outer.size__I()
});
$c_sc_MapOps$KeySet.prototype.knownSize__I = (function() {
  return this.sc_MapOps$KeySet__f_$outer.knownSize__I()
});
$c_sc_MapOps$KeySet.prototype.isEmpty__Z = (function() {
  return this.sc_MapOps$KeySet__f_$outer.isEmpty__Z()
});
var $d_sc_MapOps$KeySet = new $TypeData().initClass({
  sc_MapOps$KeySet: 0
}, false, "scala.collection.MapOps$KeySet", {
  sc_MapOps$KeySet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapOps$KeySet.prototype.$classData = $d_sc_MapOps$KeySet;
/** @constructor */
function $c_sc_MapView$$anon$1() {
  /*<skip>*/
}
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
  /*<skip>*/
}
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass({
  sc_MapView$$anon$1: 0
}, false, "scala.collection.MapView$$anon$1", {
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$$anon$1.prototype.$classData = $d_sc_MapView$$anon$1;
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
  /*<skip>*/
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return this.sc_MapView$Id__f_underlying.get__O__s_Option(key)
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return this.sc_MapView$Id__f_underlying.knownSize__I()
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$Id = new $TypeData().initClass({
  sc_MapView$Id: 0
}, false, "scala.collection.MapView$Id", {
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$Id.prototype.$classData = $d_sc_MapView$Id;
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
  /*<skip>*/
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_MapView$MapValues__f_underlying.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((kv$2) => {
    var kv = $as_T2(kv$2);
    return $ct_T2__O__O__(new $c_T2(), kv._1__O(), this$1.sc_MapView$MapValues__f_f.apply__O__O(kv._2__O()))
  }))(this));
  return new $c_sc_Iterator$$anon$9(this$2, f)
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = this.sc_MapView$MapValues__f_underlying.get__O__s_Option(key);
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$1.get__O())))
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return this.sc_MapView$MapValues__f_underlying.knownSize__I()
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$MapValues__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$MapValues = new $TypeData().initClass({
  sc_MapView$MapValues: 0
}, false, "scala.collection.MapView$MapValues", {
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$MapValues.prototype.$classData = $d_sc_MapView$MapValues;
/** @constructor */
function $c_sci_AbstractSet() {
  /*<skip>*/
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
  /*<skip>*/
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$()
});
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass({
  sc_IndexedSeqView$Drop: 0
}, false, "scala.collection.IndexedSeqView$Drop", {
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Drop.prototype.$classData = $d_sc_IndexedSeqView$Drop;
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.take__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass({
  sc_IndexedSeqView$Id: 0
}, false, "scala.collection.IndexedSeqView$Id", {
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Id.prototype.$classData = $d_sc_IndexedSeqView$Id;
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Map.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass({
  sc_IndexedSeqView$Map: 0
}, false, "scala.collection.IndexedSeqView$Map", {
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Map.prototype.$classData = $d_sc_IndexedSeqView$Map;
/** @constructor */
function $c_sc_IndexedSeqView$Reverse(underlying) {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass({
  sc_IndexedSeqView$Reverse: 0
}, false, "scala.collection.IndexedSeqView$Reverse", {
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Reverse.prototype.$classData = $d_sc_IndexedSeqView$Reverse;
function $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0
}
$c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$c_sc_IndexedSeqView$Take.prototype.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Take.prototype = $c_sc_IndexedSeqView$Take.prototype;
$c_sc_IndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Take.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Take.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Take.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Take.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
var $d_sc_IndexedSeqView$Take = new $TypeData().initClass({
  sc_IndexedSeqView$Take: 0
}, false, "scala.collection.IndexedSeqView$Take", {
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Take.prototype.$classData = $d_sc_IndexedSeqView$Take;
/** @constructor */
function $c_sci_AbstractSeq() {
  /*<skip>*/
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
  /*<skip>*/
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
  /*<skip>*/
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return this.scm_ArrayBufferView__f_underlying.apply__I__O(n)
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = this.scm_ArrayBufferView__f_underlying;
  return this$1.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView"
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_scm_ArrayBufferView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
var $d_scm_ArrayBufferView = new $TypeData().initClass({
  scm_ArrayBufferView: 0
}, false, "scala.collection.mutable.ArrayBufferView", {
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_scm_ArrayBufferView.prototype.$classData = $d_scm_ArrayBufferView;
/** @constructor */
function $c_Lcats_data_WriterTInstances4$$anon$1(F$8, L$4) {
  this.Lcats_data_WriterTInstances4$$anon$1__f_F0 = null;
  this.Lcats_data_WriterTInstances4$$anon$1__f_L0 = null;
  this.Lcats_data_WriterTInstances4$$anon$1__f_F0 = F$8;
  this.Lcats_data_WriterTInstances4$$anon$1__f_L0 = L$4
}
$c_Lcats_data_WriterTInstances4$$anon$1.prototype = new $h_O();
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.constructor = $c_Lcats_data_WriterTInstances4$$anon$1;
/** @constructor */
function $h_Lcats_data_WriterTInstances4$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_WriterTInstances4$$anon$1.prototype = $c_Lcats_data_WriterTInstances4$$anon$1.prototype;
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_WriterT(fa);
  return fa$1.flatMap__F1__Lcats_FlatMap__Lcats_kernel_Semigroup__Lcats_data_WriterT(f, this.Lcats_data_WriterTInstances4$$anon$1__f_F0, this.Lcats_data_WriterTInstances4$$anon$1__f_L0)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_data_WriterTFlatMap1__tailRecM__O__F1__Lcats_data_WriterT(this, a, f)
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.pure__O__O = (function(x) {
  var applicativeF = this.Lcats_data_WriterTInstances4$$anon$1__f_F0;
  var monoidL = this.Lcats_data_WriterTInstances4$$anon$1__f_L0;
  var this$2 = $m_Lcats_data_WriterT$();
  var l = monoidL.empty__O();
  return $f_Lcats_data_WriterTFunctions__put__O__O__Lcats_Applicative__Lcats_data_WriterT(this$2, x, l, applicativeF)
});
var $d_Lcats_data_WriterTInstances4$$anon$1 = new $TypeData().initClass({
  Lcats_data_WriterTInstances4$$anon$1: 0
}, false, "cats.data.WriterTInstances4$$anon$1", {
  Lcats_data_WriterTInstances4$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_data_WriterTFunctor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_data_WriterTApply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_data_WriterTApplicative: 1,
  Lcats_FlatMap: 1,
  Lcats_data_WriterTFlatMap1: 1,
  Lcats_Monad: 1,
  Lcats_data_WriterTMonad: 1
});
$c_Lcats_data_WriterTInstances4$$anon$1.prototype.$classData = $d_Lcats_data_WriterTInstances4$$anon$1;
/** @constructor */
function $c_sci_AbstractMap() {
  /*<skip>*/
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
  /*<skip>*/
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$()
});
$c_sci_AbstractMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return this
});
$c_sci_AbstractMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this)
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$()
});
$c_sci_AbstractMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set()
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === x2.length__I())
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true
    } else {
      var length = $thiz.length__I();
      var equal = (length === x2.length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = x2.applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? (((-2147483648) ^ length) > ((-2147483648) ^ lo)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength
        } else {
          var maxApplyCompare = length
        };
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), x2.apply__I__O(index));
          index = ((1 + index) | 0)
        };
        if (((index < length) && equal)) {
          var thisIt = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          var thatIt = x2.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          while ((equal && thisIt.hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z(thisIt.next__O(), thatIt.next__O())
          }
        }
      };
      return equal
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o)
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)))
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"))
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)))
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth))
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
  /*<skip>*/
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
  /*<skip>*/
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem)
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass({
  sci_Set$EmptySet$: 0
}, false, "scala.collection.immutable.Set$EmptySet$", {
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$EmptySet$.prototype.$classData = $d_sci_Set$EmptySet$;
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$()
  };
  return $n_sci_Set$EmptySet$
}
/** @constructor */
function $c_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass({
  Lcats_kernel_Eq$: 0
}, false, "cats.kernel.Eq$", {
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_OrderInstances0: 1
});
$c_Lcats_kernel_Eq$.prototype.$classData = $d_Lcats_kernel_Eq$;
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$()
  };
  return $n_Lcats_kernel_Eq$
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(m) {
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = null;
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = m
}
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = new $h_O();
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype;
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_IndexedSeq$().newBuilder__scm_Builder()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.className__T = (function() {
  return "IndexedSeq"
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.length__I = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__I__O = (function(i) {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.apply__I__O(i)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterator__sc_Iterator = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.iterator__sc_Iterator()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_IndexedSeq$();
  return this$1.from__sc_IterableOnce__sci_IndexedSeq(coll)
});
var $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq = new $TypeData().initClass({
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 0
}, false, "cats.kernel.instances.StaticMethods$WrappedIndexedSeq", {
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  sci_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1,
  sci_SeqOps: 1,
  sci_Seq: 1,
  sc_IndexedSeqOps: 1,
  sc_IndexedSeq: 1,
  sci_IndexedSeqOps: 1,
  sci_IndexedSeq: 1
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.$classData = $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s
}
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
  /*<skip>*/
}
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = this.sc_StringView__f_s;
  return $uI(this$1.length)
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")")
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView"
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sc_StringView)) {
    var StringView$1 = $as_sc_StringView(x$1);
    return (this.sc_StringView__f_s === StringView$1.sc_StringView__f_s)
  } else {
    return false
  }
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = this.sc_StringView__f_s;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sc_StringView(obj) {
  return (((obj instanceof $c_sc_StringView) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StringView"))
}
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)))
}
function $asArrayOf_sc_StringView(obj, depth) {
  return (($isArrayOf_sc_StringView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StringView;", depth))
}
var $d_sc_StringView = new $TypeData().initClass({
  sc_StringView: 0
}, false, "scala.collection.StringView", {
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_StringView.prototype.$classData = $d_sc_StringView;
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
  /*<skip>*/
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem))
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this)
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O(this.sci_Set$Set1__f_elem1))
});
$c_sci_Set$Set1.prototype.find__F1__s_Option = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set1__f_elem1)) ? new $c_s_Some(this.sci_Set$Set1__f_elem1) : $m_s_None$())
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$()
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set1 = new $TypeData().initClass({
  sci_Set$Set1: 0
}, false, "scala.collection.immutable.Set$Set1", {
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set1.prototype.$classData = $d_sci_Set$Set1;
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
  /*<skip>*/
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2))
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem))
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this))
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this)
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set2__f_elem1);
  f.apply__O__O(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set2__f_elem2)))
});
$c_sci_Set$Set2.prototype.find__F1__s_Option = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set2__f_elem1)) ? new $c_s_Some(this.sci_Set$Set2__f_elem1) : ($uZ(p.apply__O__O(this.sci_Set$Set2__f_elem2)) ? new $c_s_Some(this.sci_Set$Set2__f_elem2) : $m_s_None$()))
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set2 = new $TypeData().initClass({
  sci_Set$Set2: 0
}, false, "scala.collection.immutable.Set$Set2", {
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2.prototype.$classData = $d_sci_Set$Set2;
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
  /*<skip>*/
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3))
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem))
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)))
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this)
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set3__f_elem1);
  f.apply__O__O(this.sci_Set$Set3__f_elem2);
  f.apply__O__O(this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem3)))
});
$c_sci_Set$Set3.prototype.find__F1__s_Option = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem1)) ? new $c_s_Some(this.sci_Set$Set3__f_elem1) : ($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem2)) ? new $c_s_Some(this.sci_Set$Set3__f_elem2) : ($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem3)) ? new $c_s_Some(this.sci_Set$Set3__f_elem3) : $m_s_None$())))
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set3 = new $TypeData().initClass({
  sci_Set$Set3: 0
}, false, "scala.collection.immutable.Set$Set3", {
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3.prototype.$classData = $d_sci_Set$Set3;
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
  /*<skip>*/
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = this$1.sci_HashSet$__f_EmptySet;
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = this$2.incl__O__sci_HashSet(elem$1);
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = this$3.incl__O__sci_HashSet(elem$2);
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = this$4.incl__O__sci_HashSet(elem$3);
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = this$5.incl__O__sci_HashSet(elem$4);
    return this$6.incl__O__sci_HashSet(elem)
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))))
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this)
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set4__f_elem1);
  f.apply__O__O(this.sci_Set$Set4__f_elem2);
  f.apply__O__O(this.sci_Set$Set4__f_elem3);
  f.apply__O__O(this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem4)))
});
$c_sci_Set$Set4.prototype.find__F1__s_Option = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem1)) ? new $c_s_Some(this.sci_Set$Set4__f_elem1) : ($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem2)) ? new $c_s_Some(this.sci_Set$Set4__f_elem2) : ($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem3)) ? new $c_s_Some(this.sci_Set$Set4__f_elem3) : ($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem4)) ? new $c_s_Some(this.sci_Set$Set4__f_elem4) : $m_s_None$()))))
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder(builder.addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"))
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)))
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth))
}
var $d_sci_Set$Set4 = new $TypeData().initClass({
  sci_Set$Set4: 0
}, false, "scala.collection.immutable.Set$Set4", {
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4.prototype.$classData = $d_sci_Set$Set4;
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)))
}
function $as_sci_SortedSet(obj) {
  return (($is_sci_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedSet"))
}
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)))
}
function $asArrayOf_sci_SortedSet(obj, depth) {
  return (($isArrayOf_sci_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedSet;", depth))
}
/** @constructor */
function $c_scm_AbstractSeq() {
  /*<skip>*/
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
  /*<skip>*/
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Drop: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Drop", {
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.$classData = $d_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f)
}
$c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$c_scm_CheckedIndexedSeqView$Map.prototype.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $c_scm_CheckedIndexedSeqView$Map.prototype;
$c_scm_CheckedIndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Map: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Map", {
  scm_CheckedIndexedSeqView$Map: 1,
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Map.prototype.$classData = $d_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Take(underlying, n, mutationCount) {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$Take.prototype = new $h_sc_IndexedSeqView$Take();
$c_scm_CheckedIndexedSeqView$Take.prototype.constructor = $c_scm_CheckedIndexedSeqView$Take;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Take() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Take.prototype = $c_scm_CheckedIndexedSeqView$Take.prototype;
$c_scm_CheckedIndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Take = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Take: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Take", {
  scm_CheckedIndexedSeqView$Take: 1,
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Take.prototype.$classData = $d_scm_CheckedIndexedSeqView$Take;
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)))
}
function $as_scm_Set(obj) {
  return (($is_scm_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Set"))
}
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)))
}
function $asArrayOf_scm_Set(obj, depth) {
  return (($isArrayOf_scm_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Set;", depth))
}
/** @constructor */
function $c_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return default$1.apply__O()
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.keysIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sci_Map = (function(suffix) {
  if ($is_sci_Map(suffix)) {
    var x2 = $as_sci_Map(suffix);
    return x2
  } else {
    return $as_sci_Map($f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix))
  }
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map(suffix)
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value)
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key)
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass({
  sci_Map$EmptyMap$: 0
}, false, "scala.collection.immutable.Map$EmptyMap$", {
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$EmptyMap$.prototype.$classData = $d_sci_Map$EmptyMap$;
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$()
  };
  return $n_sci_Map$EmptyMap$
}
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_MapOps$ImmutableKeySet__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null
}
$c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$c_sci_MapOps$ImmutableKeySet.prototype.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
  /*<skip>*/
}
$h_sci_MapOps$ImmutableKeySet.prototype = $c_sci_MapOps$ImmutableKeySet.prototype;
$c_sci_MapOps$ImmutableKeySet.prototype.iterator__sc_Iterator = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.keysIterator__sc_Iterator()
});
$c_sci_MapOps$ImmutableKeySet.prototype.contains__O__Z = (function(key) {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(key)
});
$c_sci_MapOps$ImmutableKeySet.prototype.size__I = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.size__I()
});
$c_sci_MapOps$ImmutableKeySet.prototype.knownSize__I = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.knownSize__I()
});
$c_sci_MapOps$ImmutableKeySet.prototype.isEmpty__Z = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.isEmpty__Z()
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_Set = (function(elem) {
  if (this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(elem)) {
    return this
  } else {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this));
    return $as_sci_Set(this$3.incl__O__sci_SetOps(elem))
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_Set = (function(elem) {
  if (this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(elem)) {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this));
    return $as_sci_Set(this$3.excl__O__sci_SetOps(elem))
  } else {
    return this
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().initClass({
  sci_MapOps$ImmutableKeySet: 0
}, false, "scala.collection.immutable.MapOps$ImmutableKeySet", {
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_MapOps$ImmutableKeySet.prototype.$classData = $d_sci_MapOps$ImmutableKeySet;
function $f_scm_Buffer__subtractOne__O__scm_Buffer($thiz, x) {
  var i = $thiz.indexOf__O__I__I(x, 0);
  if ((i !== (-1))) {
    $thiz.remove__I__O(i)
  };
  return $thiz
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$1.prototype.constructor = $c_Lcats_EvalInstances$$anon$1;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$1.prototype = $c_Lcats_EvalInstances$$anon$1.prototype;
$c_Lcats_EvalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return fa$1.map__F1__Lcats_Eval(f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_Now(x)
});
$c_Lcats_EvalInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return fa$1.flatMap__F1__Lcats_Eval(f)
});
var $d_Lcats_EvalInstances$$anon$1 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$1: 0
}, false, "cats.EvalInstances$$anon$1", {
  Lcats_EvalInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1
});
$c_Lcats_EvalInstances$$anon$1.prototype.$classData = $d_Lcats_EvalInstances$$anon$1;
/** @constructor */
function $c_Lcats_data_WriterT$() {
  /*<skip>*/
}
$c_Lcats_data_WriterT$.prototype = new $h_Lcats_data_WriterTInstances();
$c_Lcats_data_WriterT$.prototype.constructor = $c_Lcats_data_WriterT$;
/** @constructor */
function $h_Lcats_data_WriterT$() {
  /*<skip>*/
}
$h_Lcats_data_WriterT$.prototype = $c_Lcats_data_WriterT$.prototype;
$c_Lcats_data_WriterT$.prototype.toString__T = (function() {
  return "WriterT"
});
var $d_Lcats_data_WriterT$ = new $TypeData().initClass({
  Lcats_data_WriterT$: 0
}, false, "cats.data.WriterT$", {
  Lcats_data_WriterT$: 1,
  Lcats_data_WriterTInstances: 1,
  Lcats_data_WriterTInstances0: 1,
  Lcats_data_WriterTInstances1: 1,
  Lcats_data_WriterTInstances2: 1,
  Lcats_data_WriterTInstances3: 1,
  Lcats_data_WriterTInstances4: 1,
  Lcats_data_WriterTInstances5: 1,
  Lcats_data_WriterTInstances6: 1,
  Lcats_data_WriterTInstances7: 1,
  Lcats_data_WriterTInstances8: 1,
  Lcats_data_WriterTInstances9: 1,
  Lcats_data_WriterTInstances10: 1,
  Lcats_data_WriterTInstances11: 1,
  Lcats_data_WriterTInstances12: 1,
  Lcats_data_WriterTInstances13: 1,
  O: 1,
  Lcats_data_WriterTFunctions: 1,
  Lcats_data_WriterTFunctions0: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_data_WriterT$.prototype.$classData = $d_Lcats_data_WriterT$;
var $n_Lcats_data_WriterT$;
function $m_Lcats_data_WriterT$() {
  if ((!$n_Lcats_data_WriterT$)) {
    $n_Lcats_data_WriterT$ = new $c_Lcats_data_WriterT$()
  };
  return $n_Lcats_data_WriterT$
}
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__s_util_Either__F1__s_util_Either = (function(fea, f) {
  if ((fea instanceof $c_s_util_Left)) {
    var e = $as_s_util_Left(fea).s_util_Left__f_value;
    return $as_s_util_Either(f.apply__O__O(e))
  };
  if ((fea instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(fea);
    return r
  };
  throw new $c_s_MatchError(fea)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__s_util_Either = (function(b, f) {
  var this$ = this;
  var b$tailLocal1 = b;
  while (true) {
    var x26 = $as_s_util_Either(f.apply__O__O(b$tailLocal1));
    if ((x26 instanceof $c_s_util_Left)) {
      var left = $as_s_util_Left(x26);
      return left
    };
    if ((x26 instanceof $c_s_util_Right)) {
      var e = $as_s_util_Either($as_s_util_Right(x26).s_util_Right__f_value);
      if ((e instanceof $c_s_util_Left)) {
        var b1 = $as_s_util_Left(e).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        b$tailLocal1 = b1;
        continue
      };
      if ((e instanceof $c_s_util_Right)) {
        var right = $as_s_util_Right(e);
        return right
      };
      throw new $c_s_MatchError(e)
    };
    throw new $c_s_MatchError(x26)
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fb, fc, f) {
  if ((fb instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(fb);
    $m_Lcats_syntax_EitherUtil$();
    return new $c_Lcats_Now(l)
  };
  if ((fb instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fb).s_util_Right__f_value;
    return fc.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2, b$2) => ((_$10) => {
      var _$10$1 = $as_s_util_Either(_$10);
      if ((_$10$1 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(_$10$1);
        var b$1 = x2.s_util_Right__f_value;
        return new $c_s_util_Right(f$2.apply__O__O__O(b$2, b$1))
      } else {
        return _$10$1
      }
    }))(f, b)))
  };
  throw new $c_s_MatchError(fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__s_util_Either__F1__Lcats_Applicative__O = (function(fa, f, F) {
  if ((fa instanceof $c_s_util_Left)) {
    var left = $as_s_util_Left(fa);
    return F.pure__O__O(left)
  };
  if ((fa instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fa).s_util_Right__f_value;
    return F.map__O__F1__O(f.apply__O__O(b), new $c_sjsr_AnonFunction1(((_$13) => {
      $m_s_package$();
      return new $c_s_util_Right(_$13)
    })))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fa, lc, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return lc
  };
  if ((fa instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fa).s_util_Right__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(b, lc))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.pure__O__O = (function(x) {
  $m_s_package$();
  return new $c_s_util_Right(x)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return fa$1.flatMap__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Either__F1__s_util_Either($as_s_util_Either(fa), f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.raiseError__O__O = (function(e) {
  $m_s_package$();
  return new $c_s_util_Left(e)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return fa$1.map__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Either(a, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), fb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(fa), f, evidence$1)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), lb, f)
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$2: 0
}, false, "cats.instances.EitherInstances$$anon$2", {
  Lcats_instances_EitherInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass({
  Lcats_kernel_Semigroup$: 0
}, false, "cats.kernel.Semigroup$", {
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_GroupInstances: 1
});
$c_Lcats_kernel_Semigroup$.prototype.$classData = $d_Lcats_kernel_Semigroup$;
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$()
  };
  return $n_Lcats_kernel_Semigroup$
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)) ? $thiz : newHashMap.keySet__sci_Set())
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer).sci_HashMap__f_rootNode) ? $thiz : new $c_sci_HashMap(newRootNode).keySet__sci_Set())
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer)
}
$c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$c_sci_HashMap$HashKeySet.prototype.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
  /*<skip>*/
}
$h_sci_HashMap$HashKeySet.prototype = $c_sci_HashMap$HashKeySet.prototype;
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_Set = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var improvedHash = $m_sc_Hashing$().improve__I__I(originalHash);
  var newNode = $as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer).sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(elem, null, originalHash, improvedHash, 0, false);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, newNode)
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_Set = (function(elem) {
  var this$1 = $as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.removed__O__sci_HashMap(elem))
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_HashMap$HashKeySet = new $TypeData().initClass({
  sci_HashMap$HashKeySet: 0
}, false, "scala.collection.immutable.HashMap$HashKeySet", {
  sci_HashMap$HashKeySet: 1,
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$HashKeySet.prototype.$classData = $d_sci_HashMap$HashKeySet;
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
  /*<skip>*/
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map1.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$())
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : default$1.apply__O())
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = $ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.keysIterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Map$Map1__f_key1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value))
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this)
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1)
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map1 = new $TypeData().initClass({
  sci_Map$Map1: 0
}, false, "scala.collection.immutable.Map$Map1", {
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map1.prototype.$classData = $d_sci_Map$Map1;
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
  /*<skip>*/
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map2.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2))
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()))
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : default$1.apply__O()))
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this)
});
$c_sci_Map$Map2.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$2(this)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)))
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this))
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))))
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2)
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map2 = new $TypeData().initClass({
  sci_Map$Map2: 0
}, false, "scala.collection.immutable.Map$Map2", {
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map2.prototype.$classData = $d_sci_Map$Map2;
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
  /*<skip>*/
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map3.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3))
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())))
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : default$1.apply__O())))
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this)
});
$c_sci_Map$Map3.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$5(this)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))))
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)))
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))))
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3)
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map3 = new $TypeData().initClass({
  sci_Map$Map3: 0
}, false, "scala.collection.immutable.Map$Map3", {
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map3.prototype.$classData = $d_sci_Map$Map3;
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
  /*<skip>*/
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map4.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4))
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))))
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : default$1.apply__O()))))
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this)
});
$c_sci_Map$Map4.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$8(this)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value)
  } else {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap.updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4).updated__O__O__sci_HashMap(key, value)
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))))
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ(p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))))
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return builder.addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4)
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"))
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)))
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth))
}
var $d_sci_Map$Map4 = new $TypeData().initClass({
  sci_Map$Map4: 0
}, false, "scala.collection.immutable.Map$Map4", {
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map4.prototype.$classData = $d_sci_Map$Map4;
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)))
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"))
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)))
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth))
}
/** @constructor */
function $c_Lcats_instances_TryInstances$$anon$1() {
  this.Lcats_instances_TryInstances$$anon$1__f_successUnit = null;
  this.Lcats_instances_TryInstances$$anon$1__f_successUnit = new $c_s_util_Success((void 0))
}
$c_Lcats_instances_TryInstances$$anon$1.prototype = new $h_Lcats_instances_TryCoflatMap();
$c_Lcats_instances_TryInstances$$anon$1.prototype.constructor = $c_Lcats_instances_TryInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_TryInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_TryInstances$$anon$1.prototype = $c_Lcats_instances_TryInstances$$anon$1.prototype;
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.product__s_util_Try__s_util_Try__s_util_Try = (function(ta, tb) {
  var x1 = $ct_T2__O__O__(new $c_T2(), ta, tb);
  var x8 = $as_s_util_Try(x1.T2__f__1);
  var x9 = $as_s_util_Try(x1.T2__f__2);
  if ((x8 instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(x8).s_util_Success__f_value;
    if ((x9 instanceof $c_s_util_Success)) {
      var b = $as_s_util_Success(x9).s_util_Success__f_value;
      var value = $ct_T2__O__O__(new $c_T2(), a, b);
      return new $c_s_util_Success(value)
    }
  };
  if ((x8 instanceof $c_s_util_Failure)) {
    var f = $as_s_util_Failure(x8);
    return f
  };
  if ((x9 instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(x9);
    return f$2
  };
  throw new $c_s_MatchError(x1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2__s_util_Try__s_util_Try__F2__s_util_Try = (function(ta, tb, f) {
  var x14 = $ct_T2__O__O__(new $c_T2(), ta, tb);
  var x21 = $as_s_util_Try(x14.T2__f__1);
  var x22 = $as_s_util_Try(x14.T2__f__2);
  if ((x21 instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(x21).s_util_Success__f_value;
    if ((x22 instanceof $c_s_util_Success)) {
      var b = $as_s_util_Success(x22).s_util_Success__f_value;
      try {
        return new $c_s_util_Success(f.apply__O__O__O(a, b))
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((e$2 !== null)) {
          if ((e$2 !== null)) {
            var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
            if ((!o11.isEmpty__Z())) {
              var e$3 = $as_jl_Throwable(o11.get__O());
              return new $c_s_util_Failure(e$3)
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        } else {
          throw e
        }
      }
    }
  };
  if ((x21 instanceof $c_s_util_Failure)) {
    var f$3 = $as_s_util_Failure(x21);
    return f$3
  };
  if ((x22 instanceof $c_s_util_Failure)) {
    var f$4 = $as_s_util_Failure(x22);
    return f$4
  };
  throw new $c_s_MatchError(x14)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2Eval__s_util_Try__Lcats_Eval__F2__Lcats_Eval = (function(ta, tb, f) {
  if ((ta instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(ta);
    return new $c_Lcats_Now(f$2)
  };
  if ((ta instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(ta).s_util_Success__f_value;
    return tb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$3, a$2) => ((_$1) => {
      var _$1$1 = $as_s_util_Try(_$1);
      return _$1$1.map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((f$2$2, a$2$2) => ((_$2) => f$2$2.apply__O__O__O(a$2$2, _$2)))(f$3, a$2)))
    }))(f, a)))
  };
  throw new $c_s_MatchError(ta)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldRight__s_util_Try__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
  };
  if ((fa instanceof $c_s_util_Failure)) {
    return lb
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.traverse__s_util_Try__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return G.map__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1(((_$4) => new $c_s_util_Success(_$4))))
  };
  if ((fa instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(fa);
    return G.pure__O__O(f$2)
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.tailRecM__O__F1__s_util_Try = (function(b, f) {
  var this$ = this;
  var b$tailLocal1 = b;
  while (true) {
    var x45 = $as_s_util_Try(f.apply__O__O(b$tailLocal1));
    if ((x45 instanceof $c_s_util_Failure)) {
      var f$2 = $as_s_util_Failure(x45);
      return f$2
    };
    if ((x45 instanceof $c_s_util_Success)) {
      var x51 = $as_s_util_Either($as_s_util_Success(x45).s_util_Success__f_value);
      if ((x51 instanceof $c_s_util_Left)) {
        var b1 = $as_s_util_Left(x51).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        b$tailLocal1 = b1;
        continue
      };
      if ((x51 instanceof $c_s_util_Right)) {
        var c = $as_s_util_Right(x51).s_util_Right__f_value;
        return new $c_s_util_Success(c)
      }
    };
    throw new $c_s_MatchError(x45)
  }
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.handleErrorWith__s_util_Try__F1__s_util_Try = (function(ta, f) {
  return ta.recoverWith__s_PartialFunction__s_util_Try(new $c_Lcats_instances_TryInstances$$anon$4(f))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_util_Success(x)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_util_Try__s_util_Try__s_util_Try($as_s_util_Try(fa), $as_s_util_Try(fb))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_util_Try__s_util_Try__F2__s_util_Try($as_s_util_Try(fa), $as_s_util_Try(fb), f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Try__Lcats_Eval__F2__Lcats_Eval($as_s_util_Try(fa), fb, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var ta = $as_s_util_Try(fa);
  return ta.flatMap__F1__s_util_Try(f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Try__Lcats_Eval__F2__Lcats_Eval($as_s_util_Try(fa), lb, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Try__F1__Lcats_Applicative__O($as_s_util_Try(fa), f, evidence$1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Try(a, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Try__F1__s_util_Try($as_s_util_Try(fa), f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return new $c_s_util_Failure(e$1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var ta = $as_s_util_Try(fa);
  return ta.map__F1__s_util_Try(f)
});
var $d_Lcats_instances_TryInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_TryInstances$$anon$1: 0
}, false, "cats.instances.TryInstances$$anon$1", {
  Lcats_instances_TryInstances$$anon$1: 1,
  Lcats_instances_TryCoflatMap: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_CoflatMap: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.$classData = $d_Lcats_instances_TryInstances$$anon$1;
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode))
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
  /*<skip>*/
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$()
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.size__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return (this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size === 0)
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode))
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return this.sci_HashSet__f_rootNode.contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0)
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sci_HashSet = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if (this.isEmpty__Z()) {
      return x2
    } else {
      var newNode = this.sci_HashSet__f_rootNode.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(x2.sci_HashSet__f_rootNode, 0);
      return ((newNode === x2.sci_HashSet__f_rootNode) ? x2 : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode))
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var iter = new $c_scm_HashSet$$anon$2(x3);
    var current = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var improvedHash = next.scm_HashSet$Node__f__hash;
      var originalHash = x3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__I__I__I__sci_BitmapIndexedSetNode(next.scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((current !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var improvedHash$1 = next$2.scm_HashSet$Node__f__hash;
          var originalHash$2 = x3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__I__I__I__I__I(next$2.scm_HashSet$Node__f__key, originalHash$2, improved$2, 0, shallowlyMutableNodeMap)
        };
        return new $c_sci_HashSet(current)
      }
    };
    return this
  } else {
    var iter$2 = that.iterator__sc_Iterator();
    var current$2 = this.sci_HashSet__f_rootNode;
    while (iter$2.hasNext__Z()) {
      var element = iter$2.next__O();
      var originalHash$3 = $m_sr_Statics$().anyHash__O__I(element);
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = current$2.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash$3, improved$3, 0);
      if ((current$2 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$3, 0));
        while (iter$2.hasNext__Z()) {
          var element$2 = iter$2.next__O();
          var originalHash$4 = $m_sr_Statics$().anyHash__O__I(element$2);
          var improved$4 = $m_sc_Hashing$().improve__I__I(originalHash$4);
          shallowlyMutableNodeMap$2 = current$2.updateWithShallowMutations__O__I__I__I__I__I(element$2, originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2)
        };
        return new $c_sci_HashSet(current$2)
      }
    };
    return this
  }
});
$c_sci_HashSet.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  this.sci_HashSet__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = x2.sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that)
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashSet.prototype.take__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__take__I__O(this, n))
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = this.iterator__sc_Iterator().next__O();
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_HashSet(that)
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem)
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"))
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)))
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth))
}
var $d_sci_HashSet = new $TypeData().initClass({
  sci_HashSet: 0
}, false, "scala.collection.immutable.HashSet", {
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet.prototype.$classData = $d_sci_HashSet;
/** @constructor */
function $c_scm_AbstractSet() {
  /*<skip>*/
}
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
  /*<skip>*/
}
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$()
});
$c_scm_AbstractSet.prototype.remove__O__Z = (function(elem) {
  return $f_scm_SetOps__remove__O__Z(this, elem)
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this
});
/** @constructor */
function $c_Lcats_instances_QueueInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_QueueInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_QueueInstances$$anon$1.prototype.constructor = $c_Lcats_instances_QueueInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_QueueInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_QueueInstances$$anon$1.prototype = $c_Lcats_instances_QueueInstances$$anon$1.prototype;
$c_Lcats_instances_QueueInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__sci_Queue = (function(x) {
  var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs)))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__sci_Queue__sci_Queue__F2__sci_Queue = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_sci_Queue$EmptyQueue$()
  } else {
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var arg1 = it.next__O();
      var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
      var it$1 = fb.iterator__sc_Iterator();
      while (it$1.hasNext__Z()) {
        var arg1$1 = it$1.next__O();
        var elem = f.apply__O__O__O(arg1, arg1$1);
        b$1.addOne__O__scm_Growable(elem)
      };
      var xs = $as_sc_IterableOnce(b$1.result__O());
      b.addAll__sc_IterableOnce__scm_Growable(xs)
    };
    return $as_sci_Queue(b.result__O())
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_Queue$EmptyQueue$();
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$4, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_Queue(fb$2);
      return this$4.map2__sci_Queue__sci_Queue__F2__sci_Queue(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__sci_Queue = (function(a, f) {
  var bldr = $m_sci_Queue$().newBuilder__scm_Builder();
  var elem$2 = $as_sci_Queue(f.apply__O__O(a));
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__sci_Queue(f, bldr, new $c_sci_$colon$colon(elem$2, this$1))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_sci_Queue$EmptyQueue$())
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$2 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$2.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1(((chain) => {
      var chain$1 = $as_Lcats_data_Chain(chain);
      var z = $m_sci_Queue$EmptyQueue$();
      var result = z;
      var iter = chain$1.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var arg1 = result;
        var arg2 = iter.next__O();
        var _$2 = $as_sci_Queue(arg1);
        result = _$2.enqueue__O__sci_Queue(arg2)
      };
      return $as_sci_Queue(result)
    })))
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__sci_Queue__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), fa, z), new $c_sjsr_AnonFunction1(((f$2, G$2) => ((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_QueueInstances__step$2__F2__Lcats_Monad__T2__O(f$2, G$2, in$2)
  }))(f, G)))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  return x$1.appendedAll__sc_IterableOnce__sci_Queue(y$1)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Queue(x)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(fa$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Queue__sci_Queue__F2__sci_Queue($as_sci_Queue(fa), $as_sci_Queue(fb), f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), fb, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Queue(a, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), lb, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(fa), f, evidence$1)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Queue__O__F2__Lcats_Monad__O($as_sci_Queue(fa), z, f, G)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_QueueMonoid()
});
var $d_Lcats_instances_QueueInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_QueueInstances$$anon$1: 0
}, false, "cats.instances.QueueInstances$$anon$1", {
  Lcats_instances_QueueInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.$classData = $d_Lcats_instances_QueueInstances$$anon$1;
function $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State($thiz) {
  if ((!$thiz.sci_LazyList__f_bitmap$0)) {
    if ($thiz.sci_LazyList__f_midEvaluation) {
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "self-referential LazyList or a derivation thereof has no more elements"))
    };
    $thiz.sci_LazyList__f_midEvaluation = true;
    try {
      var res = $as_sci_LazyList$State($thiz.sci_LazyList__f_lazyState.apply__O())
    } finally {
      $thiz.sci_LazyList__f_midEvaluation = false
    };
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = true;
    $thiz.sci_LazyList__f_lazyState = null;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state = res;
    $thiz.sci_LazyList__f_bitmap$0 = true
  };
  return $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((this$1, f$1) => (() => {
    if (this$1.isEmpty__Z()) {
      return $m_sci_LazyList$State$Empty$()
    } else {
      $m_sci_LazyList$();
      var hd = f$1.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), f$1);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }))($thiz, f));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0(((this$1, n$1) => (() => {
      if (this$1.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), (((-1) + n$1) | 0));
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    }))($thiz, n));
    return new $c_sci_LazyList(state)
  }
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
  } else if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    var elem$1 = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    var elem$2 = null;
    elem$2 = elem$1;
    if ((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ((!$as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated) || ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
      elem = $as_sci_LazyList(elem$2);
      if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
        var this$3 = $as_sci_LazyList(elem$2);
        elem$2 = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        while (((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) && ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$4 = $as_sci_LazyList(elem);
          var obj$1 = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
          var this$5 = $as_sci_LazyList(elem);
          elem = this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$6 = $as_sci_LazyList(elem$2);
          elem$2 = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
            var this$7 = $as_sci_LazyList(elem$2);
            elem$2 = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
          }
        }
      }
    };
    if ((!($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z())))) {
      while (($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$8 = $as_sci_LazyList(elem);
        var obj$2 = this$8.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        var this$9 = $as_sci_LazyList(elem);
        elem = this$9.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      if ((!$as_sci_LazyList(elem).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      }
    } else {
      var runner = $thiz;
      var k = 0;
      while (true) {
        var a = runner;
        var b$1 = $as_sci_LazyList(elem$2);
        if ((!((a === b$1) || (a.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$10 = runner;
          runner = this$10.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$11 = $as_sci_LazyList(elem$2);
          elem$2 = this$11.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          k = ((1 + k) | 0)
        } else {
          break
        }
      };
      var a$1 = $as_sci_LazyList(elem);
      var b$2 = $as_sci_LazyList(elem$2);
      if ((((a$1 === b$2) || (a$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State())) && (k > 0))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$12 = $as_sci_LazyList(elem);
        var obj$3 = this$12.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        var this$13 = $as_sci_LazyList(elem);
        elem = this$13.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      while (true) {
        var a$2 = $as_sci_LazyList(elem);
        var b$3 = $as_sci_LazyList(elem$2);
        if ((!((a$2 === b$3) || (a$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$14 = $as_sci_LazyList(elem);
          var obj$4 = this$14.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          var this$15 = $as_sci_LazyList(elem);
          elem = this$15.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
        } else {
          break
        }
      };
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_LazyList(lazyState) {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$state = null;
  this.sci_LazyList__f_lazyState = null;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
  this.sci_LazyList__f_bitmap$0 = false;
  this.sci_LazyList__f_lazyState = lazyState;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
  /*<skip>*/
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$state__sci_LazyList$State = (function() {
  return ((!this.sci_LazyList__f_bitmap$0) ? $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State(this) : this.sci_LazyList__f_scala$collection$immutable$LazyList$$state)
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? 0 : (-1))
});
$c_sci_LazyList.prototype.head__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O()
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    var this$1 = these;
    these = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    var this$2 = these;
    these = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if (these.isEmpty__Z()) {
      return this
    };
    var this$3 = these;
    these = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if ((these === those)) {
      return this
    };
    var this$4 = those;
    those = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  return this
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this))
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    var this$1 = _$this;
    f.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
    var this$2 = _$this;
    _$this = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var this$1 = _$this;
      var temp$_$this = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      var $$x1 = z;
      var this$2 = _$this;
      var temp$z = op.apply__O__O__O($$x1, this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList"
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((this$1, suffix$1) => (() => {
    if (this$1.isEmpty__Z()) {
      var x1 = $as_sc_IterableOnce(suffix$1.apply__O());
      if ((x1 instanceof $c_sci_LazyList)) {
        var x2 = $as_sci_LazyList(x1);
        return x2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
      } else {
        return ((x1.knownSize__I() === 0) ? $m_sci_LazyList$State$Empty$() : $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(x1.iterator__sc_Iterator()))
      }
    } else {
      $m_sci_LazyList$();
      var hd = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
      var tl = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList().lazyAppendedAll__F0__sci_LazyList(suffix$1);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }))(this, suffix));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0(((this$1, suffix$1) => (() => suffix$1))(this, suffix))))
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)))
});
$c_sci_LazyList.prototype.take__I__sci_LazyList = (function(n) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $p_sci_LazyList__takeImpl__I__sci_LazyList(this, n))
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_LazyList.prototype.take__I__O = (function(n) {
  return this.take__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix)
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$()
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"))
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)))
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth))
}
var $d_sci_LazyList = new $TypeData().initClass({
  sci_LazyList: 0
}, false, "scala.collection.immutable.LazyList", {
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList.prototype.$classData = $d_sci_LazyList;
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if (scout.tailDefined__Z()) {
          scout = $as_sci_Stream(scout.tail__O());
          while ((($as_sci_Stream(elem) !== scout) && scout.tailDefined__Z())) {
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $as_sci_Stream(elem).head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($as_sci_Stream(elem).tail__O());
            scout = $as_sci_Stream(scout.tail__O());
            if (scout.tailDefined__Z()) {
              scout = $as_sci_Stream(scout.tail__O())
            }
          }
        }
      };
      if ((!scout.tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        var this$2 = $as_sci_Stream(elem);
        if ((!this$2.isEmpty__Z())) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3)
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream(runner.tail__O());
          scout = $as_sci_Stream(scout.tail__O());
          k = ((1 + k) | 0)
        };
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        }
      }
    };
    var this$3 = $as_sci_Stream(elem);
    if ((!this$3.isEmpty__Z())) {
      if ((!$as_sci_Stream(elem).tailDefined__Z())) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      } else {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
      }
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_Stream() {
  /*<skip>*/
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
  /*<skip>*/
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this)
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream"
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    f.apply__O__O(_$this.head__O());
    _$this = $as_sci_Stream(_$this.tail__O())
  }
});
$c_sci_Stream.prototype.take__I__sci_Stream = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $m_sci_Stream$Empty$() : ((n === 1) ? new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0(((this$2) => (() => $m_sci_Stream$Empty$()))(this))) : new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0(((this$2$1, n$1) => (() => $as_sci_Stream(this$2$1.tail__O()).take__I__sci_Stream((((-1) + n$1) | 0))))(this, n)))))
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var temp$_$this = $as_sci_Stream(_$this.tail__O());
      var temp$z = op.apply__O__O__O(z, _$this.head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(suffix.apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source)
  } else {
    var hd = this.head__O();
    var tl = new $c_sjsr_AnonFunction0(((this$2, suffix$1) => (() => $as_sci_Stream(this$2.tail__O()).lazyAppendedAll__F0__sci_Stream(suffix$1)))(this, suffix));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var hd = f.apply__O__O(this.head__O());
    var tl = new $c_sjsr_AnonFunction0(((this$2, f$1) => (() => $as_sci_Stream(this$2.tail__O()).map__F1__sci_Stream(f$1)))(this, f));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z()) && prefix.isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).tail__O());
      if ((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1)
      }
    };
    return ($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z() ? $m_sci_Stream$Empty$() : prefix.lazyAppendedAll__F0__sci_Stream(new $c_sjsr_AnonFunction0(((this$6, nonEmptyPrefix$1, f$1) => (() => $as_sci_Stream($as_sci_Stream(nonEmptyPrefix$1.sr_ObjectRef__f_elem).tail__O()).flatMap__F1__sci_Stream(f$1)))(this, nonEmptyPrefix, f))))
  }
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Stream(n)
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$()
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"))
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)))
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth))
}
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self
}
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
  /*<skip>*/
}
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sci_WrappedString.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_WrappedString.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_WrappedString.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sci_WrappedString.prototype.head__O = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(0))))
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  var x = $uI(this$1.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self
});
$c_sci_WrappedString.prototype.indexOf__O__I__I = (function(elem, from) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    return $f_T__indexOf__I__I__I(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, x2, from)
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
  }
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var x2 = $asArrayOf_C(xs, 1);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var srcLen = $uI(this$1.length);
    var destLen = x2.u.length;
    var x = ((len < srcLen) ? len : srcLen);
    var y = ((destLen - start) | 0);
    var x$1 = ((x < y) ? x : y);
    var copied = ((x$1 > 0) ? x$1 : 0);
    $f_T__getChars__I__I__AC__I__V(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, 0, copied, x2, start);
    return copied
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(suffix);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var s = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((("" + this$1) + s))
  } else {
    return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  if ((o instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(o);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
  }
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString"
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(other);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sc_Seq__equals__O__Z(this, other)
  }
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sci_WrappedString(obj) {
  return (((obj instanceof $c_sci_WrappedString) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"))
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)))
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth))
}
var $d_sci_WrappedString = new $TypeData().initClass({
  sci_WrappedString: 0
}, false, "scala.collection.immutable.WrappedString", {
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString.prototype.$classData = $d_sci_WrappedString;
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from)
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sjsr_WrappedVarArgs.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder()
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sjsr_WrappedVarArgs.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sjsr_WrappedVarArgs.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length)
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx]
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs"
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll)
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"))
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)))
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth))
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass({
  sjsr_WrappedVarArgs: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs", {
  sjsr_WrappedVarArgs: 1,
  O: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs.prototype.$classData = $d_sjsr_WrappedVarArgs;
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances$$anon$1.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$1.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances$$anon$1.prototype = $c_Lcats_data_ChainInstances$$anon$1.prototype;
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var xs = fa.iterator__sc_Iterator();
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(xs);
    return $$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G)
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.tailRecM__O__F1__Lcats_data_Chain = (function(a, f) {
  var elem$4 = $as_Lcats_data_Chain(f.apply__O__O(a));
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$1$$_$go$2__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f, new $c_sci_$colon$colon(elem$4, this$1), $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil
  } else {
    var this$1 = $m_Lcats_data_Chain$();
    var result = this$1.Lcats_data_Chain$__f_nil;
    var iter = fa.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var this$2 = result;
      var arg1 = iter.next__O();
      var c = fb.map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1(((f$23$2, a$2) => ((b) => f$23$2.apply__O__O__O(a$2, b)))(f, arg1)));
      result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c)
    };
    return result
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$3, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_Lcats_data_Chain(fb$2);
      return this$3.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), lb, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return fa$1.map__F1__Lcats_data_Chain(f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, evidence$1)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.empty__O = (function() {
  return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var c = $as_Lcats_data_Chain(x);
  var c2 = $as_Lcats_data_Chain(y);
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(c, c2)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton(x)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return fa$1.flatMap__F1__Lcats_data_Chain(f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_Chain(a, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain($as_Lcats_data_Chain(fa), $as_Lcats_data_Chain(fb), f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), fb, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
var $d_Lcats_data_ChainInstances$$anon$1 = new $TypeData().initClass({
  Lcats_data_ChainInstances$$anon$1: 0
}, false, "cats.data.ChainInstances$$anon$1", {
  Lcats_data_ChainInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.$classData = $d_Lcats_data_ChainInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__sci_LazyList__sci_LazyList__sci_LazyList = (function(x, y) {
  return x.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0(((y$2) => (() => y$2))(y)))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__sci_LazyList = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_LazyList;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty : fa.flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((fb$2, f$2) => ((a) => fb$2.map__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))(fb, f))))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty;
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$3, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_LazyList(fb$2);
      return this$3.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((s) => {
    var s$1 = $as_sci_LazyList(s);
    if (s$1.isEmpty__Z()) {
      return lb$2
    } else {
      var $$x1 = s$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((this$3, lb$1$2, f$4$2, s$2) => (() => this$3.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(s$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), lb$1$2, f$4$2)))(this$2, lb$2, f$2, s$1));
      return $as_Lcats_Eval(f$2.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
    }
  }))(this, lb, f)))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__sci_LazyList__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((G$2) => (() => G$2.pure__O__O($m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty)))(G))), new $c_sjsr_AnonFunction2(((f$2, G$3) => ((a, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return G$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$2.apply__O__O(a), lgsb$1, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$3$1 = $as_sci_LazyList(_$3);
      $m_sci_LazyList$();
      var l = new $c_sjsr_AnonFunction0(((_$3$2) => (() => _$3$2))(_$3$1));
      return $m_sci_LazyList$Deferrer$().$hash$colon$colon$extension__F0__F0__sci_LazyList(l, new $c_sjsr_AnonFunction0(((_$2$2) => (() => _$2$2))(_$2)))
    })))
  }))(f, G))).value__O()
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__sci_LazyList = (function(a, fn) {
  $m_s_package$();
  $m_s_package$();
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Left.getArrayOf().constr)([($m_s_package$(), new $c_s_util_Left(a))]));
  var init = xs.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((fn$2) => ((it) => {
    var it$1 = $as_sc_Iterator(it);
    if ((!it$1.hasNext__Z())) {
      return $m_s_None$()
    } else {
      var x1 = $as_s_util_Either(it$1.next__O());
      if ((x1 instanceof $c_s_util_Left)) {
        var a$1 = $as_s_util_Left(x1).s_util_Left__f_value;
        var _1 = $m_s_None$();
        var this$3 = $as_sci_LazyList(fn$2.apply__O__O(a$1)).iterator__sc_Iterator();
        var xs$1 = new $c_sjsr_AnonFunction0(((it$2) => (() => it$2))(it$1));
        var _2 = this$3.concat__F0__sc_Iterator(xs$1);
        var value = $ct_T2__O__O__(new $c_T2(), _1, _2);
        return new $c_s_Some(value)
      };
      if ((x1 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x1).s_util_Right__f_value;
        var _1$1 = new $c_s_Some(b);
        var value$1 = $ct_T2__O__O__(new $c_T2(), _1$1, it$1);
        return new $c_s_Some(value$1)
      };
      throw new $c_s_MatchError(x1)
    }
  }))(fn));
  var kernel = new $c_sc_Iterator$UnfoldIterator(init, f);
  var $$x1 = $m_s_package$().s_package$__f_LazyList;
  var pf = new $c_Lcats_instances_LazyListInstances$$anon$5();
  return $$x1.from__sc_IterableOnce__sci_LazyList(new $c_sc_Iterator$$anon$7(kernel, pf))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__sci_LazyList__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), fa, z), new $c_sjsr_AnonFunction1(((f$2, G$2) => ((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_LazyListInstances__step$2__F2__Lcats_Monad__T2__O(f$2, G$2, in$2)
  }))(f, G)))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_LazyList__sci_LazyList__sci_LazyList($as_sci_LazyList(x), $as_sci_LazyList(y))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_LazyList(x)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1.map__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1.flatMap__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList($as_sci_LazyList(fa), $as_sci_LazyList(fb), f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), fb, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), lb, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(fa), f, evidence$1)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_LazyList(a, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_LazyList__O__F2__Lcats_Monad__O($as_sci_LazyList(fa), z, f, G)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_LazyListMonoid()
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$1: 0
}, false, "cats.instances.LazyListInstances$$anon$1", {
  Lcats_instances_LazyListInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1() {
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = null;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = null;
  $m_Lcats_Eval$();
  var a = $m_s_package$().s_package$__f_Nil;
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = new $c_Lcats_Now(a);
  var this$3 = $m_s_package$().s_package$__f_Nil;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = new $c_sci_$colon$colon((void 0), this$3)
}
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_s_package$().s_package$__f_Nil
  } else {
    var rest = fa;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = rest.head__O();
      var f$1 = ((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f, arg1);
      if ((fb === $m_sci_Nil$())) {
        var $$x1 = $m_sci_Nil$()
      } else {
        var arg1$1 = fb.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(fb.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$2 = rest$1.head__O();
          var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
          t$1.sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = $as_sci_List(rest$1.tail__O())
        };
        var $$x1 = h$1
      };
      var it = $$x1.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1
        } else {
          t.sci_$colon$colon__f_next = nx$1
        };
        t = nx$1
      };
      rest = $as_sci_List(rest.tail__O())
    };
    return ((h === null) ? $m_sci_Nil$() : h)
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return (fa.isEmpty__Z() ? this.Lcats_instances_ListInstances$$anon$1__f_evalNil : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => {
    var fb$1 = $as_sci_List(fb$2);
    return this$1.map2__sci_List__sci_List__F2__sci_List(fa$2, fb$1, f$2)
  }))(this, fa, f))))
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__sci_List = (function(a, f) {
  $m_s_package$();
  var buf = new $c_scm_ListBuffer();
  var elem$2 = $as_sci_List(f.apply__O__O(a));
  var this$2 = $m_s_package$().s_package$__f_Nil;
  $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__V(f, buf, new $c_sci_$colon$colon(elem$2, this$2));
  return buf.toList__sci_List()
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_s_package$().s_package$__f_Nil)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return _$3$1.toList__sci_List()
    })))
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__sci_List__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), fa, z), new $c_sjsr_AnonFunction1(((f$2, G$2) => ((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_ListInstances__step$2__F2__Lcats_Monad__T2__O(f$2, G$2, in$2)
  }))(f, G)))
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_package$().s_package$__f_Nil
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return y$1.$colon$colon$colon__sci_List__sci_List(x$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return new $c_sci_$colon$colon(x, this$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return fa$1.map__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return fa$1.flatMap__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List($as_sci_List(fa), $as_sci_List(fb), f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), fb, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_List(a, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), lb, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, evidence$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_List__O__F2__Lcats_Monad__O($as_sci_List(fa), z, f, G)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_ListMonoid()
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_ListInstances$$anon$1: 0
}, false, "cats.instances.ListInstances$$anon$1", {
  Lcats_instances_ListInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$1() {
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Seq$().empty__sc_SeqOps();
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a)
}
$c_Lcats_instances_SeqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SeqInstances$$anon$1.prototype = $c_Lcats_instances_SeqInstances$$anon$1.prototype;
$c_Lcats_instances_SeqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__sci_Seq = (function(x) {
  return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]))))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__sci_Seq__sci_Seq__F2__sci_Seq = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()) : $as_sci_Seq(fa.flatMap__F1__O(new $c_sjsr_AnonFunction1(((fb$2, f$2) => ((a) => $as_sc_IterableOnce(fb$2.map__F1__O(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a))))))(fb, f)))))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return (fa.isEmpty__Z() ? this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => {
    var fb$1 = $as_sci_Seq(fb$2);
    return this$1.map2__sci_Seq__sci_Seq__F2__sci_Seq(fa$2, fb$1, f$2)
  }))(this, fa, f))))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldRight__sci_Seq__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_SeqInstances__loop$3__sci_Seq__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$2, f$2, 0)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__sci_Seq = (function(a, fn) {
  var buf = $m_sci_Seq$().newBuilder__scm_Builder();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$as_sc_IterableOnce(fn.apply__O__O(a)).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult3: {
      var x11 = $as_sci_List(elem$1);
      var x = $m_s_package$().s_package$__f_Nil;
      if (((x === null) ? (x11 === null) : x.equals__O__Z(x11))) {
        break matchResult3
      };
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = $as_sci_$colon$colon(x11);
        var x16 = $as_sc_Iterator(x15.sci_$colon$colon__f_head);
        var x17 = x15.sci_$colon$colon__f_next;
        if ((!x16.hasNext__Z())) {
          elem$1 = x17;
          continue
        };
        var x6 = $as_s_util_Either(x16.next__O());
        if ((x6 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(x6).s_util_Right__f_value;
          buf.addOne__O__scm_Growable(b);
          continue
        };
        if ((x6 instanceof $c_s_util_Left)) {
          var a$1 = $as_s_util_Left(x6).s_util_Left__f_value;
          var elem$1$1 = $as_sc_IterableOnce(fn.apply__O__O(a$1)).iterator__sc_Iterator();
          var this$3 = new $c_sci_$colon$colon(x16, x17);
          var ev$2 = new $c_sci_$colon$colon(elem$1$1, this$3);
          elem$1 = ev$2;
          continue
        };
        throw new $c_s_MatchError(x6);
        break matchResult3
      };
      throw new $c_s_MatchError(x11)
    };
    break
  };
  return $as_sci_Seq(buf.result__O())
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return G.map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa.toIndexedSeq__sci_IndexedSeq(), f, G), new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lcats_data_Chain(_$3);
    return _$3$1.toVector__sci_Vector()
  })))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__sci_Seq__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = fa.length__I();
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, 0), new $c_sjsr_AnonFunction1(((fa$2, f$2, G$2, length$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = x$1$1._1__O();
      var i = $uI(x$1$1._2__O());
      return ((i < length$2) ? G$2.map__O__F1__O(f$2.apply__O__O__O(b, fa$2.apply__I__O(i)), new $c_sjsr_AnonFunction1(((i$2) => ((b$2) => {
        $m_s_package$();
        var _2 = ((1 + i$2) | 0);
        var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
        return new $c_s_util_Left(value)
      }))(i))) : G$2.pure__O__O(($m_s_package$(), new $c_s_util_Right(b))))
    };
    throw new $c_s_MatchError(x$1$1)
  }))(fa, f, G, length)))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps())
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  return $as_sci_Seq(x$1.appendedAll__sc_IterableOnce__O(y$1))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Seq(x)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq(fa$1.map__F1__O(f))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq(fa$1.flatMap__F1__O(f))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Seq__sci_Seq__F2__sci_Seq($as_sci_Seq(fa), $as_sci_Seq(fb), f)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval($as_sci_Seq(fa), fb, f)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Seq__Lcats_Eval__F2__Lcats_Eval($as_sci_Seq(fa), lb, f)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Seq(a, f)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(fa), f, evidence$1)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Seq__O__F2__Lcats_Monad__O($as_sci_Seq(fa), z, f, G)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_SeqMonoid()
});
var $d_Lcats_instances_SeqInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SeqInstances$$anon$1: 0
}, false, "cats.instances.SeqInstances$$anon$1", {
  Lcats_instances_SeqInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__sci_Stream = (function() {
  $m_s_package$();
  return $m_sci_Stream$Empty$()
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__sci_Stream__sci_Stream__sci_Stream = (function(x, y) {
  var l = new $c_sjsr_AnonFunction0(((y$2) => (() => y$2))(y));
  return x.lazyAppendedAll__F0__sci_Stream(l)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__sci_Stream = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Stream;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Stream(elems)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? ($m_s_package$(), $m_sci_Stream$Empty$()) : fa.flatMap__F1__sci_Stream(new $c_sjsr_AnonFunction1(((fb$2, f$2) => ((a) => fb$2.map__F1__sci_Stream(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))(fb, f))))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    $m_s_package$();
    var a = $m_sci_Stream$Empty$();
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$4, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_Stream(fb$2);
      return this$4.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((s) => {
    var s$1 = $as_sci_Stream(s);
    if (s$1.isEmpty__Z()) {
      return lb$2
    } else {
      var $$x1 = s$1.head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((this$3, lb$1$2, f$4$2, s$2) => (() => this$3.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(s$2.tail__sci_Stream(), lb$1$2, f$4$2)))(this$2, lb$2, f$2, s$1));
      return $as_Lcats_Eval(f$2.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
    }
  }))(this, lb, f)))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__sci_Stream__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((G$2) => (() => G$2.pure__O__O(($m_s_package$(), $m_sci_Stream$Empty$()))))(G))), new $c_sjsr_AnonFunction2(((f$2, G$3) => ((a, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return G$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$2.apply__O__O(a), lgsb$1, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$3$1 = $as_sci_Stream(_$3);
      var l = new $c_sjsr_AnonFunction0(((_$3$2) => (() => _$3$2))(_$3$1));
      return new $c_sci_Stream$Cons(_$2, l)
    })))
  }))(f, G))).value__O()
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__sci_Stream = (function(a, fn) {
  var it = new $c_Lcats_instances_StreamInstances$$anon$4(a, fn);
  var factory = $m_sci_Stream$();
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  return $as_sci_Stream(factory$1.fromSpecific__sc_IterableOnce__O(it))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__sci_Stream__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), fa, z), new $c_sjsr_AnonFunction1(((f$2, G$2) => ((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_StreamInstances__step$2__F2__Lcats_Monad__T2__O(f$2, G$2, in$2)
  }))(f, G)))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__O = (function() {
  return this.empty__sci_Stream()
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_Stream__sci_Stream__sci_Stream($as_sci_Stream(x), $as_sci_Stream(y))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Stream(x)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1.map__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1.flatMap__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream($as_sci_Stream(fa), $as_sci_Stream(fb), f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), fb, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), lb, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(fa), f, evidence$1)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Stream(a, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Stream__O__F2__Lcats_Monad__O($as_sci_Stream(fa), z, f, G)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_StreamMonoid()
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_StreamInstances$$anon$1: 0
}, false, "cats.instances.StreamInstances$$anon$1", {
  Lcats_instances_StreamInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.$classData = $d_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1() {
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  $m_s_package$();
  var a = $m_sci_Vector0$();
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a)
}
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__sci_Vector = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Vector;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Vector(elems)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  if ($f_sc_SeqOps__isEmpty__Z(fb)) {
    $m_s_package$();
    return $m_sci_Vector0$()
  } else {
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var arg1 = it.next__O();
      var xs = $as_sc_IterableOnce(fb.map__F1__O(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b$1) => f$1$2.apply__O__O__O(a$2, b$1)))(f, arg1))));
      b.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
    };
    return b.result__sci_Vector()
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($f_sc_SeqOps__isEmpty__Z(fa) ? this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => {
    var fb$1 = $as_sci_Vector(fb$2);
    return this$1.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa$2, fb$1, f$2)
  }))(this, fa, f))))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$2, f$2, 0)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, fn) {
  $m_s_package$();
  var buf = new $c_sci_VectorBuilder();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$as_sci_Vector(fn.apply__O__O(a)).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult3: {
      var x11 = $as_sci_List(elem$1);
      var x = $m_s_package$().s_package$__f_Nil;
      if (((x === null) ? (x11 === null) : x.equals__O__Z(x11))) {
        break matchResult3
      };
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = $as_sci_$colon$colon(x11);
        var x16 = $as_sc_Iterator(x15.sci_$colon$colon__f_head);
        var x17 = x15.sci_$colon$colon__f_next;
        if ((!x16.hasNext__Z())) {
          elem$1 = x17;
          continue
        };
        var x6 = $as_s_util_Either(x16.next__O());
        if ((x6 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(x6).s_util_Right__f_value;
          buf.addOne__O__sci_VectorBuilder(b);
          continue
        };
        if ((x6 instanceof $c_s_util_Left)) {
          var a$1 = $as_s_util_Left(x6).s_util_Left__f_value;
          var elem$1$1 = $as_sci_Vector(fn.apply__O__O(a$1)).iterator__sc_Iterator();
          var this$4 = new $c_sci_$colon$colon(x16, x17);
          var ev$2 = new $c_sci_$colon$colon(elem$1$1, this$4);
          elem$1 = ev$2;
          continue
        };
        throw new $c_s_MatchError(x6);
        break matchResult3
      };
      throw new $c_s_MatchError(x11)
    };
    break
  };
  return buf.result__sci_Vector()
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return G.map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa, f, G), new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lcats_data_Chain(_$3);
    return _$3$1.toVector__sci_Vector()
  })))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__sci_Vector__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = fa.length__I();
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, 0), new $c_sjsr_AnonFunction1(((fa$2, f$2, G$2, length$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = x$1$1._1__O();
      var i = $uI(x$1$1._2__O());
      return ((i < length$2) ? G$2.map__O__F1__O(f$2.apply__O__O__O(b, fa$2.apply__I__O(i)), new $c_sjsr_AnonFunction1(((i$2) => ((b$2) => {
        $m_s_package$();
        var _2 = ((1 + i$2) | 0);
        var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
        return new $c_s_util_Left(value)
      }))(i))) : G$2.pure__O__O(($m_s_package$(), new $c_s_util_Right(b))))
    };
    throw new $c_s_MatchError(x$1$1)
  }))(fa, f, G, length)))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.empty__O = (function() {
  $m_s_package$();
  return $m_sci_Vector0$()
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  return x$1.appendedAll__sc_IterableOnce__sci_Vector(y$1)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Vector(x)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector(fa$1.map__F1__O(f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa$1, f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector($as_sci_Vector(fa), $as_sci_Vector(fb), f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), fb, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), lb, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Vector(a, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, evidence$1)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Vector__O__F2__Lcats_Monad__O($as_sci_Vector(fa), z, f, G)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_VectorMonoid()
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_VectorInstances$$anon$1: 0
}, false, "cats.instances.VectorInstances$$anon$1", {
  Lcats_instances_VectorInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.$classData = $d_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
  /*<skip>*/
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$()
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.size__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return (this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0)
});
$c_sci_HashMap.prototype.keySet__sci_Set = (function() {
  return ((this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this))
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1)
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sci_HashMap = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if (this.isEmpty__Z()) {
      return x2
    } else {
      var newNode = this.sci_HashMap__f_rootNode.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(x2.sci_HashMap__f_rootNode, 0);
      if ((newNode === x2.sci_HashMap__f_rootNode)) {
        return x2
      } else {
        var newRootNode = this.sci_HashMap__f_rootNode.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(x2.sci_HashMap__f_rootNode, 0);
        return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
      }
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(that);
    var iter = x3.nodeIterator__sc_Iterator();
    var current = this.sci_HashMap__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, improved, 0, true);
      if ((current !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashMap$Node(iter.next__O());
          var improvedHash$1 = next$2.scm_HashMap$Node__f__hash;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__O__I__I__I__I__I(next$2.scm_HashMap$Node__f__key, next$2.scm_HashMap$Node__f__value, originalHash$2, $m_sc_Hashing$().improve__I__I(originalHash$2), 0, shallowlyMutableNodeMap)
        };
        return new $c_sci_HashMap(current)
      }
    };
    return this
  } else if ($is_sci_Map(that)) {
    var x2$2 = $as_sci_Map(that);
    if (x2$2.isEmpty__Z()) {
      return this
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      x2$2.foreachEntry__F2__V(accum);
      var newRootNode$1 = accum.sci_HashMap$accum$1__f_current;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1))
    }
  } else {
    var it = that.iterator__sc_Iterator();
    if ((!it.hasNext__Z())) {
      return this
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      $f_sc_IterableOnceOps__foreach__F1__V(it, accum$2);
      var newRootNode$2 = accum$2.sci_HashMap$accum$1__f_current;
      return ((newRootNode$2 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$2))
    }
  }
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = $as_T2(this.iterator__sc_Iterator().next__O())._1__O();
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreachEntry__F2__V(f)
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = x2.sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that)
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap"
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashMap.prototype.take__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__take__I__O(this, n))
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2(this.iterator__sc_Iterator().next__O())
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap()
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_HashMap(suffix)
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value)
});
$c_sci_HashMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set()
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"))
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)))
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth))
}
var $d_sci_HashMap = new $TypeData().initClass({
  sci_HashMap: 0
}, false, "scala.collection.immutable.HashMap", {
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap.prototype.$classData = $d_sci_HashMap;
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
  /*<skip>*/
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null)
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream(this.sci_Stream$Cons__f_tlGen.apply__O());
      this.sci_Stream$Cons__f_tlGen = null
    }
  };
  return this.sci_Stream$Cons__f_tlVal
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    these = $as_sci_Stream(these.tail__O())
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if ((these === those)) {
      return this
    };
    those = $as_sci_Stream(those.tail__O())
  };
  return this
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons()
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
var $d_sci_Stream$Cons = new $TypeData().initClass({
  sci_Stream$Cons: 0
}, false, "scala.collection.immutable.Stream$Cons", {
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Cons.prototype.$classData = $d_sci_Stream$Cons;
/** @constructor */
function $c_sci_Stream$Empty$() {
  /*<skip>*/
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
  /*<skip>*/
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream")
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream")
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass({
  sci_Stream$Empty$: 0
}, false, "scala.collection.immutable.Stream$Empty$", {
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Empty$.prototype.$classData = $d_sci_Stream$Empty$;
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$()
  };
  return $n_sci_Stream$Empty$
}
/** @constructor */
function $c_scm_AbstractBuffer() {
  /*<skip>*/
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
  /*<skip>*/
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return $f_scm_Buffer__subtractOne__O__scm_Buffer(this, x)
});
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Buffer(elem)
});
/** @constructor */
function $c_scm_AbstractMap() {
  /*<skip>*/
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
  /*<skip>*/
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$()
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op)
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$()
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this
});
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(idx);
  if ((x1 === null)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, new $c_scm_HashSet$Node(elem, hash, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashSet$Node__f__hash <= hash))) {
      if (((n.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, n.scm_HashSet$Node__f__key))) {
        return false
      };
      prev = n;
      n = n.scm_HashSet$Node__f__next
    };
    if ((prev === null)) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, new $c_scm_HashSet$Node(elem, hash, x1))
    } else {
      prev.scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, prev.scm_HashSet$Node__f__next)
    }
  };
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(idx);
  if ((x1 !== null)) {
    if (((x1.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashSet$Node__f__key, elem))) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, x1.scm_HashSet$Node__f__next);
      $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
      return true
    } else {
      var prev = x1;
      var next = x1.scm_HashSet$Node__f__next;
      while (((next !== null) && (next.scm_HashSet$Node__f__hash <= hash))) {
        if (((next.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashSet$Node__f__key, elem))) {
          prev.scm_HashSet$Node__f__next = next.scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
          return true
        };
        prev = next;
        next = next.scm_HashSet$Node__f__next
      };
      return false
    }
  } else {
    return false
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $asArrayOf_scm_HashSet$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(i);
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashSet$Node__f__next;
            if (((n.scm_HashSet$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashSet$Node__f__next = n;
              lastLow = n
            } else {
              lastHigh.scm_HashSet$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          lastLow.scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(i, preLow.scm_HashSet$Node__f__next)
          };
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(((i + oldlen) | 0), preHigh.scm_HashSet$Node__f__next);
            lastHigh.scm_HashSet$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor))
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0
}
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
  /*<skip>*/
}
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0))
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get((hash & (((-1) + this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0)));
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashSet$Node(elem, hash)) !== null)
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target)
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, (this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length << 1))
  };
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  this.sizeHint__I__V(xs.knownSize__I());
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    var f = new $c_sjsr_AnonFunction2(((this$1) => ((k$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashSet__addElem__O__I__Z(this$1, k$2, this$1.scala$collection$mutable$HashSet$$improveHash__I__I(h))
    }))(this));
    x2.sci_HashSet__f_rootNode.foreachWithHash__F2__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(xs);
    var iter = new $c_scm_HashSet$$anon$2(x3);
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, next.scm_HashSet$Node__f__key, next.scm_HashSet$Node__f__hash)
    };
    return this
  } else {
    return $as_scm_HashSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this)
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$()
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0)
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashSet(xs)
});
function $as_scm_HashSet(obj) {
  return (((obj instanceof $c_scm_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet"))
}
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)))
}
function $asArrayOf_scm_HashSet(obj, depth) {
  return (($isArrayOf_scm_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet;", depth))
}
var $d_scm_HashSet = new $TypeData().initClass({
  scm_HashSet: 0
}, false, "scala.collection.mutable.HashSet", {
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet.prototype.$classData = $d_scm_HashSet;
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary({});
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d
});
$c_sjs_js_WrappedDictionary.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder()
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key])
  } else {
    return $m_s_None$()
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  };
  return this
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T(kv._1__O());
  var value = kv._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict)
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem))
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value)
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary($as_T(elem))
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1))
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass({
  sjs_js_WrappedDictionary: 0
}, false, "scala.scalajs.js.WrappedDictionary", {
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
});
$c_sjs_js_WrappedDictionary.prototype.$classData = $d_sjs_js_WrappedDictionary;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$1() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)))
}
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.tailRecM__O__F1__Lcats_data_NonEmptyList = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$1$$_$go$1__F1__scm_ListBuffer__Lcats_data_NonEmptyList__V(f, buf, $as_Lcats_data_NonEmptyList(f.apply__O__O(a)));
  return $m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(buf.toList__sci_List())
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var a = $as_Lcats_data_NonEmptyList(x);
  var b = $as_Lcats_data_NonEmptyList(y);
  return a.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(b)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.map__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_s_package$().s_package$__f_Nil;
  return new $c_Lcats_data_NonEmptyList(x, tail)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.flatMap__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$3) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.traverse__F1__Lcats_Applicative__O(f, evidence$3)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_NonEmptyList(a, f)
});
var $d_Lcats_data_NonEmptyListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_data_NonEmptyListInstances$$anon$1: 0
}, false, "cats.data.NonEmptyListInstances$$anon$1", {
  Lcats_data_NonEmptyListInstances$$anon$1: 1,
  Lcats_NonEmptyReducible: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_SemigroupK: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.$classData = $d_Lcats_data_NonEmptyListInstances$$anon$1;
function $as_sci_Range(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Range"))
}
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)))
}
function $asArrayOf_sci_Range(obj, depth) {
  return (($isArrayOf_sci_Range(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Range;", depth))
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JSetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = new $h_scm_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JSetWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var b = new $c_scm_HashSet$$anon$4(16, 0.75);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_SetOps(b.scm_GrowableBuilder__f_elems)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.size__I = (function() {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.size__I()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.isEmpty__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.knownSize__I = (function() {
  return (this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.isEmpty__Z() ? 0 : (-1))
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var i = this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.iterator__ju_Iterator();
  return new $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(this$1, i).asScala__sc_Iterator()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.contains__O__Z = (function(elem) {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.contains__O__Z(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.add__O__Z(elem);
  return this
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.remove__O__Z(elem);
  return this
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.remove__O__Z = (function(elem) {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.remove__O__Z(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.productPrefix__T = (function() {
  return "JSetWrapper"
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.productArity__I = (function() {
  return 1
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem)
});
function $as_sc_convert_JavaCollectionWrappers$JSetWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JSetWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JSetWrapper;", depth))
}
var $d_sc_convert_JavaCollectionWrappers$JSetWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JSetWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper", {
  sc_convert_JavaCollectionWrappers$JSetWrapper: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JSetWrapper;
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that
  } else if ($f_sc_SeqOps__isEmpty__Z(that)) {
    return $thiz
  } else {
    var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
    var thatIsObj = (that.unsafeArray__O() instanceof $ac_O);
    var mismatch = (thisIsObj !== thatIsObj);
    if (mismatch) {
      return null
    } else if (thisIsObj) {
      var ax = $thiz.unsafeArray__O();
      var ay = that.unsafeArray__O();
      var len = (($m_sr_ScalaRunTime$().array_length__O__I(ax) + $m_sr_ScalaRunTime$().array_length__O__I(ay)) | 0);
      var a = new $ac_O(len);
      var length = $m_sr_ScalaRunTime$().array_length__O__I(ax);
      ax.copyTo(0, a, 0, length);
      var destPos = $m_sr_ScalaRunTime$().array_length__O__I(ax);
      var length$1 = $m_sr_ScalaRunTime$().array_length__O__I(ay);
      ay.copyTo(0, a, destPos, length$1);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
    } else {
      var ax$2 = $thiz.unsafeArray__O();
      var ay$2 = that.unsafeArray__O();
      var len$2 = (($m_sr_ScalaRunTime$().array_length__O__I(ax$2) + $m_sr_ScalaRunTime$().array_length__O__I(ay$2)) | 0);
      var a$2 = $thiz.elemTag__s_reflect_ClassTag().newArray__I__O(len$2);
      var length$2 = $m_sr_ScalaRunTime$().array_length__O__I(ax$2);
      ax$2.copyTo(0, a$2, 0, length$2);
      var destPos$1 = $m_sr_ScalaRunTime$().array_length__O__I(ax$2);
      var length$3 = $m_sr_ScalaRunTime$().array_length__O__I(ay$2);
      ay$2.copyTo(0, a$2, destPos$1, length$3);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2)
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = suffix$1.knownSize__I();
  if ((k === 0)) {
    return $thiz
  } else {
    $m_s_reflect_ManifestFactory$AnyManifest$();
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      $m_sr_ScalaRunTime$().array_length__O__I($thiz.unsafeArray__O())
    };
    var xs = $thiz.unsafeArray__O();
    var length = $m_sr_ScalaRunTime$().array_length__O__I(xs);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0)
    };
    var it = suffix$1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem$1 = it.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1)
    };
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems))
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
  /*<skip>*/
}
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
  /*<skip>*/
}
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sci_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_ArraySeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < a.u.length)) {
    a.set(i, f.apply__O__O(this.apply__I__O(i)));
    i = ((1 + i) | 0)
  };
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(suffix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, x2);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result)
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix)
  }
});
$c_sci_ArraySeq.prototype.take__I__sci_ArraySeq = (function(n) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this.unsafeArray__O()) <= n)) {
    return this
  } else {
    var $$x1 = $m_sci_ArraySeq$();
    var this$ = this.unsafeArray__O();
    return $$x1.unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n))
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)))
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_sr_ScalaRunTime$().array_length__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = f.apply__O__O__O(b, a);
    i = ((1 + i) | 0)
  };
  return b
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()))
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied)
  };
  return copied
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this.unsafeArray__O()) <= 1)) {
    return this
  } else {
    var this$3 = $m_s_Array$();
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(original).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$3.copyOf__O__I__O(original, newLength)
      } else {
        var original$1 = $asArrayOf_O(original, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(original));
      var $$x1 = dest
    };
    var a = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq()
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.take__I__O = (function(n) {
  return this.take__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix)
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f)
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
function $as_sci_ArraySeq(obj) {
  return (((obj instanceof $c_sci_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq"))
}
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)))
}
function $asArrayOf_sci_ArraySeq(obj, depth) {
  return (($isArrayOf_sci_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq;", depth))
}
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
  /*<skip>*/
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Vector.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$()
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $as_sci_BigVector(this).sci_BigVector__f_length0 : this.sci_Vector__f_prefix1.u.length)
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()))
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = this.sci_Vector__f_prefix1.u.length;
  while ((i !== len)) {
    if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j))
        };
        j = ((1 + j) | 0)
      };
      var $$x1 = i;
      var i$1 = bitmap;
      var newLen = (($$x1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
          k = ((1 + k) | 0)
        };
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
            i = ((1 + i) | 0)
          };
          k = ((1 + k) | 0)
        };
        $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((this$1, pred$1, isFlipped$1, b$1) => ((v$2) => (($uZ(pred$1.apply__O__O(v$2)) !== isFlipped$1) ? b$1.addOne__O__sci_VectorBuilder(v$2) : (void 0))))(this, pred, isFlipped, b)));
        return b.result__sci_Vector()
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$()
        };
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        src.copyTo(0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.set(i, this.sci_Vector__f_prefix1.get(k$2));
            i = ((1 + i) | 0)
          };
          k$2 = ((1 + k$2) | 0)
        };
        return new $c_sci_Vector1(newData)
      }
    };
    i = ((1 + i) | 0)
  };
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((this$2, pred$2, isFlipped$2, b$2$1) => ((v$3$2) => (($uZ(pred$2.apply__O__O(v$3$2)) !== isFlipped$2) ? b$2$1.addOne__O__sci_VectorBuilder(v$3$2) : (void 0))))(this, pred, isFlipped, b$2)));
    return b$2.result__sci_Vector()
  } else {
    return this
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = suffix.knownSize__I();
  return ((k === 0) ? this : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k))
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if (((k > 0) && (k < tinyAppendLimit))) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      x2.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$2, v$1) => ((x$2) => {
        v$1.sr_ObjectRef__f_elem = $as_sci_Vector(v$1.sr_ObjectRef__f_elem).appended__O__sci_Vector(x$2)
      }))(this, v)))
    } else {
      var this$3 = suffix.iterator__sc_Iterator();
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        v.sr_ObjectRef__f_elem = $as_sci_Vector(v.sr_ObjectRef__f_elem).appended__O__sci_Vector(arg1)
      }
    };
    return $as_sci_Vector(v.sr_ObjectRef__f_elem)
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var this$4 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$4);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = v$2.prepended__O__sci_Vector(ri.next__O())
    };
    return v$2
  } else {
    return new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this).addAll__sc_IterableOnce__sci_VectorBuilder(suffix).result__sci_Vector()
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector"
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return this.iterator__sc_Iterator().copyToArray__O__I__I__I(xs, start, len)
});
$c_sci_Vector.prototype.toVector__sci_Vector = (function() {
  return this
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"))
});
$c_sci_Vector.prototype.head__O = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head")
  } else {
    return this.sci_Vector__f_prefix1.get(0)
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until)
});
$c_sci_Vector.prototype.take__I__O = (function(n) {
  return this.slice__I__I__sci_Vector(0, n)
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$()
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"))
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)))
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth))
}
/** @constructor */
function $c_scm_ArraySeq() {
  /*<skip>*/
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
  /*<skip>*/
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_ArraySeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  var s = coll.knownSize__I();
  var it = coll.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
    jsElems.push(unboxedElem)
  };
  var $$x1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $$x1.make__O__scm_ArraySeq(elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems))
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag())
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    if (($m_sr_ScalaRunTime$().array_length__O__I(this.array__O()) !== $m_sr_ScalaRunTime$().array_length__O__I(x2.array__O()))) {
      return false
    }
  };
  return $f_sc_Seq__equals__O__Z(this, other)
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $$x2 = $m_scm_ArraySeq$();
  var $$x1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $$x2.make__O__scm_ArraySeq($$x1.sorted$extension__O__s_math_Ordering__O(xs, ord))
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"))
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)))
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth))
}
/** @constructor */
function $c_Lcats_package$$anon$1() {
  /*<skip>*/
}
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
  /*<skip>*/
}
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_package$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_package$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$3) {
  return f.apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.pure__O__O = (function(a) {
  return a
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return f.apply__O__O(a)
});
$c_Lcats_package$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  var this$ = this;
  var a$tailLocal1 = a;
  while (true) {
    var x1 = $as_s_util_Either(f.apply__O__O(a$tailLocal1));
    if ((x1 instanceof $c_s_util_Left)) {
      var a1 = $as_s_util_Left(x1).s_util_Left__f_value;
      var \u03b4this$tmp1 = this$;
      this$ = \u03b4this$tmp1;
      a$tailLocal1 = a1;
      continue
    };
    if ((x1 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x1).s_util_Right__f_value;
      return b
    };
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return f.apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return f.apply__O__O__O(fa, fb)
});
$c_Lcats_package$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fa$2, f$2) => ((_$8) => f$2.apply__O__O__O(fa$2, _$8)))(fa, f)))
});
$c_Lcats_package$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(a, lb, f) {
  return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass({
  Lcats_package$$anon$1: 0
}, false, "cats.package$$anon$1", {
  Lcats_package$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Distributive: 1
});
$c_Lcats_package$$anon$1.prototype.$classData = $d_Lcats_package$$anon$1;
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var x2 = $as_sci_ArraySeq$ofBoolean(that);
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var a = this$1.clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, a.u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray
});
function $as_sci_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)))
}
function $asArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofBoolean;", depth))
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass({
  sci_ArraySeq$ofBoolean: 0
}, false, "scala.collection.immutable.ArraySeq$ofBoolean", {
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofBoolean.prototype.$classData = $d_sci_ArraySeq$ofBoolean;
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var x2 = $as_sci_ArraySeq$ofByte(that);
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray)
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray
});
function $as_sci_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofByte"))
}
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)))
}
function $asArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofByte;", depth))
}
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass({
  sci_ArraySeq$ofByte: 0
}, false, "scala.collection.immutable.ArraySeq$ofByte", {
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofByte.prototype.$classData = $d_sci_ArraySeq$ofByte;
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var x2 = $as_sci_ArraySeq$ofChar(that);
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray)
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end)
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray
});
function $as_sci_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofChar"))
}
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)))
}
function $asArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofChar;", depth))
}
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass({
  sci_ArraySeq$ofChar: 0
}, false, "scala.collection.immutable.ArraySeq$ofChar", {
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofChar.prototype.$classData = $d_sci_ArraySeq$ofChar;
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var x2 = $as_sci_ArraySeq$ofDouble(that);
    var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofDouble__f_unsafeArray;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray)
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray
});
function $as_sci_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofDouble"))
}
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)))
}
function $asArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofDouble;", depth))
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass({
  sci_ArraySeq$ofDouble: 0
}, false, "scala.collection.immutable.ArraySeq$ofDouble", {
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofDouble.prototype.$classData = $d_sci_ArraySeq$ofDouble;
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var x2 = $as_sci_ArraySeq$ofFloat(that);
    var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofFloat__f_unsafeArray;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray)
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray
});
function $as_sci_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofFloat"))
}
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)))
}
function $asArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofFloat;", depth))
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass({
  sci_ArraySeq$ofFloat: 0
}, false, "scala.collection.immutable.ArraySeq$ofFloat", {
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofFloat.prototype.$classData = $d_sci_ArraySeq$ofFloat;
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var x2 = $as_sci_ArraySeq$ofInt(that);
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray)
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray
});
function $as_sci_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofInt"))
}
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)))
}
function $asArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofInt;", depth))
}
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass({
  sci_ArraySeq$ofInt: 0
}, false, "scala.collection.immutable.ArraySeq$ofInt", {
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofInt.prototype.$classData = $d_sci_ArraySeq$ofInt;
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var x2 = $as_sci_ArraySeq$ofLong(that);
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray)
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray
});
function $as_sci_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofLong"))
}
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)))
}
function $asArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofLong;", depth))
}
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass({
  sci_ArraySeq$ofLong: 0
}, false, "scala.collection.immutable.ArraySeq$ofLong", {
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofLong.prototype.$classData = $d_sci_ArraySeq$ofLong;
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return $$x1.apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofRef)) {
    var x2 = $as_sci_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, x2.sci_ArraySeq$ofRef__f_unsafeArray)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if ((this.sci_ArraySeq$ofRef__f_unsafeArray.u.length <= 1)) {
    return this
  } else {
    var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray
});
function $as_sci_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"))
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)))
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth))
}
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass({
  sci_ArraySeq$ofRef: 0
}, false, "scala.collection.immutable.ArraySeq$ofRef", {
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofRef.prototype.$classData = $d_sci_ArraySeq$ofRef;
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var x2 = $as_sci_ArraySeq$ofShort(that);
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray)
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray
});
function $as_sci_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofShort"))
}
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)))
}
function $asArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofShort;", depth))
}
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass({
  sci_ArraySeq$ofShort: 0
}, false, "scala.collection.immutable.ArraySeq$ofShort", {
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofShort.prototype.$classData = $d_sci_ArraySeq$ofShort;
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofUnit)) {
    var x2 = $as_sci_ArraySeq$ofUnit(that);
    return (this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length === x2.sci_ArraySeq$ofUnit__f_unsafeArray.u.length)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray)
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray
});
function $as_sci_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofUnit"))
}
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)))
}
function $asArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofUnit;", depth))
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass({
  sci_ArraySeq$ofUnit: 0
}, false, "scala.collection.immutable.ArraySeq$ofUnit", {
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofUnit.prototype.$classData = $d_sci_ArraySeq$ofUnit;
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var aEmpty = a.isEmpty__Z();
      var bEmpty = b.isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sci_List(a.tail__O());
        var temp$b = $as_sci_List(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (aEmpty && bEmpty)
      }
    }
  }
}
/** @constructor */
function $c_sci_List() {
  /*<skip>*/
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
  /*<skip>*/
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this)
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$()
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix
  } else if (prefix.isEmpty__Z()) {
    return this
  } else {
    var result = new $c_sci_$colon$colon(prefix.head__O(), this);
    var curr = result;
    var that = $as_sci_List(prefix.tail__O());
    while ((!that.isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon(that.head__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List(that.tail__O())
    };
    return result
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!pres.isEmpty__Z())) {
    var rassoc$1 = pres.head__O();
    var this$1 = these;
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = $as_sci_List(pres.tail__O())
  };
  return these
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$())
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2)
  };
  if ((prefix.knownSize__I() === 0)) {
    return this
  };
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return x3.toList__sci_List()
    }
  };
  var iter = prefix.iterator__sc_Iterator();
  if (iter.hasNext__Z()) {
    var result = new $c_sci_$colon$colon(iter.next__O(), this);
    var curr = result;
    while (iter.hasNext__Z()) {
      var temp = new $c_sci_$colon$colon(iter.next__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp
    };
    return result
  } else {
    return this
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return x2.$colon$colon$colon__sci_List__sci_List(this)
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    var i = 1;
    while (true) {
      if (rest.isEmpty__Z()) {
        return this
      };
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon(rest.head__O(), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List(rest.tail__O())
      } else {
        break
      }
    };
    return h
  }
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(f.apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.apply__O__O(rest.head__O()), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$())
      };
      rest = $as_sci_List(rest.tail__O());
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h)
      }
    };
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx
      };
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $as_sc_IterableOnce(f.apply__O__O(rest.head__O())).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List(rest.tail__O())
  };
  return ((h === null) ? $m_sci_Nil$() : h)
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = $as_sci_List(these.tail__O())
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!these.isEmpty__Z())) {
    var rassoc$6 = these.head__O();
    var this$1 = result;
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = $as_sci_List(these.tail__O())
  };
  return result
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!these.isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List(these.tail__O())
  };
  return len
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len))
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sci_List(these.tail__O())
  };
  return false
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last")
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!scout.isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List(scout.tail__O())
    };
    return these.head__O()
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List"
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2)
  } else {
    return $f_sc_Seq__equals__O__Z(this, o)
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f)
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f)
});
$c_sci_List.prototype.take__I__O = (function(n) {
  return this.take__I__sci_List(n)
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix)
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$()
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"))
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)))
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth))
}
function $p_sci_Queue__indexOutOfRange$1__I__E($thiz, n$1) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n$1))
}
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz
}
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null
}
$c_sci_Queue.prototype = new $h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
  /*<skip>*/
}
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Queue.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $f_sc_LinearSeqOps__foreach__F1__V(this, f)
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$()
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = curr;
      var $$x1 = (!this$1.isEmpty__Z())
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0);
      curr = $as_sci_List(curr.tail__O())
    } else {
      break
    }
  };
  if ((index === n)) {
    var this$2 = curr;
    if ((!this$2.isEmpty__Z())) {
      return curr.head__O()
    } else {
      var this$3 = this.sci_Queue__f_in;
      if ((!this$3.isEmpty__Z())) {
        return this.sci_Queue__f_in.last__O()
      } else {
        $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = this.sci_Queue__f_in.length__I();
    if ((indexFromBack >= inLength)) {
      $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
    } else {
      var this$4 = this.sci_Queue__f_in;
      var n$1 = (((-1) + ((inLength - indexFromBack) | 0)) | 0);
      return $f_sc_LinearSeqOps__apply__I__O(this$4, n$1)
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return this.sci_Queue__f_out.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.sci_Queue__f_in.reverse__sci_List()))(this)))
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return (this.sci_Queue__f_in.isEmpty__Z() && this.sci_Queue__f_out.isEmpty__Z())
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return this.sci_Queue__f_out.head__O()
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return this.sci_Queue__f_in.last__O()
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head on empty queue")
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, $as_sci_List(this.sci_Queue__f_out.tail__O()))
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List(this.sci_Queue__f_in.reverse__sci_List().tail__O()))
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "tail on empty queue")
    }
  }
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return (this.sci_Queue__f_in.exists__F1__Z(p) || this.sci_Queue__f_out.exists__F1__Z(p))
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue"
});
$c_sci_Queue.prototype.length__I = (function() {
  return ((this.sci_Queue__f_in.length__I() + this.sci_Queue__f_out.length__I()) | 0)
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(that);
    var this$1 = x2.sci_Queue__f_in;
    var rassoc$2 = x2.sci_Queue__f_out;
    var suffix = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix)
  } else if ((that instanceof $c_sci_List)) {
    var x3 = $as_sci_List(that);
    var newIn = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(x3)
  } else {
    var result = this.sci_Queue__f_in;
    var iter = that.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var rassoc$4 = iter.next__O();
      var this$2 = result;
      result = new $c_sci_$colon$colon(rassoc$4, this$2)
    };
    var newIn = result
  };
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out))
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = this.sci_Queue__f_in;
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out)
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!this.sci_Queue__f_in.isEmpty__Z()))) {
    var rev = this.sci_Queue__f_in.reverse__sci_List();
    return $ct_T2__O__O__(new $c_T2(), rev.head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List(rev.tail__O())))
  } else if ((x1 instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(x1);
    var x$3 = x3.sci_$colon$colon__f_head;
    var xs = x3.sci_$colon$colon__f_next;
    return $ct_T2__O__O__(new $c_T2(), x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "dequeue on empty queue")
  }
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")")
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix)
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue()
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$()
});
function $as_sci_Queue(obj) {
  return (((obj instanceof $c_sci_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Queue"))
}
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)))
}
function $asArrayOf_sci_Queue(obj, depth) {
  return (($isArrayOf_sci_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Queue;", depth))
}
var $d_sci_Queue = new $TypeData().initClass({
  sci_Queue: 0
}, false, "scala.collection.immutable.Queue", {
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue.prototype.$classData = $d_sci_Queue;
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
  /*<skip>*/
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  var newlen = ((hi - lo) | 0);
  return ((newlen === this.length__I()) ? this : ((hi <= lo) ? $m_sci_Vector0$() : this.slice0__I__I__sci_Vector(lo, hi)))
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array.u.length
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = x2.scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return this.scm_ArraySeq$ofBoolean__f_array.get(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)))
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth))
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass({
  scm_ArraySeq$ofBoolean: 0
}, false, "scala.collection.mutable.ArraySeq$ofBoolean", {
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofBoolean.prototype.$classData = $d_scm_ArraySeq$ofBoolean;
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofByte__f_array.u.length
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return this.scm_ArraySeq$ofByte__f_array.get(index)
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = x2.scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array)
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"))
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)))
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth))
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass({
  scm_ArraySeq$ofByte: 0
}, false, "scala.collection.mutable.ArraySeq$ofByte", {
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofByte.prototype.$classData = $d_scm_ArraySeq$ofByte;
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofChar__f_array.u.length
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return this.scm_ArraySeq$ofChar__f_array.get(index)
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = x2.scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array)
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = sb.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var len = this.scm_ArraySeq$ofChar__f_array.u.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array)
    } else {
      jsb.length__I();
      $uI(end.length);
      $uI(sep.length);
      var c = this.scm_ArraySeq$ofChar__f_array.get(0);
      var str = $as_T(String.fromCharCode(c));
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      var i = 1;
      while ((i < len)) {
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var c$1 = this.scm_ArraySeq$ofChar__f_array.get(i);
        var str$1 = $as_T(String.fromCharCode(c$1));
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return sb
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"))
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)))
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth))
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass({
  scm_ArraySeq$ofChar: 0
}, false, "scala.collection.mutable.ArraySeq$ofChar", {
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofChar.prototype.$classData = $d_scm_ArraySeq$ofChar;
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofDouble__f_array.u.length
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var a = this.scm_ArraySeq$ofDouble__f_array;
    var b = x2.scm_ArraySeq$ofDouble__f_array;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array)
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return this.scm_ArraySeq$ofDouble__f_array.get(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"))
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)))
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth))
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass({
  scm_ArraySeq$ofDouble: 0
}, false, "scala.collection.mutable.ArraySeq$ofDouble", {
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofDouble.prototype.$classData = $d_scm_ArraySeq$ofDouble;
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofFloat__f_array.u.length
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var a = this.scm_ArraySeq$ofFloat__f_array;
    var b = x2.scm_ArraySeq$ofFloat__f_array;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array)
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return this.scm_ArraySeq$ofFloat__f_array.get(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"))
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)))
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth))
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass({
  scm_ArraySeq$ofFloat: 0
}, false, "scala.collection.mutable.ArraySeq$ofFloat", {
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofFloat.prototype.$classData = $d_scm_ArraySeq$ofFloat;
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofInt__f_array.u.length
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = x2.scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array)
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return this.scm_ArraySeq$ofInt__f_array.get(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"))
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)))
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth))
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass({
  scm_ArraySeq$ofInt: 0
}, false, "scala.collection.mutable.ArraySeq$ofInt", {
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofInt.prototype.$classData = $d_scm_ArraySeq$ofInt;
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofLong__f_array.u.length
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = x2.scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array)
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return this.scm_ArraySeq$ofLong__f_array.get(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"))
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)))
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth))
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass({
  scm_ArraySeq$ofLong: 0
}, false, "scala.collection.mutable.ArraySeq$ofLong", {
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofLong.prototype.$classData = $d_scm_ArraySeq$ofLong;
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = this.scm_ArraySeq$ofRef__f_array;
  return $$x1.apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofRef__f_array.u.length
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return this.scm_ArraySeq$ofRef__f_array.get(index)
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, x2.scm_ArraySeq$ofRef__f_array)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array)
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"))
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)))
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth))
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass({
  scm_ArraySeq$ofRef: 0
}, false, "scala.collection.mutable.ArraySeq$ofRef", {
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofRef.prototype.$classData = $d_scm_ArraySeq$ofRef;
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofShort__f_array.u.length
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return this.scm_ArraySeq$ofShort__f_array.get(index)
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = x2.scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array)
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"))
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)))
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth))
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass({
  scm_ArraySeq$ofShort: 0
}, false, "scala.collection.mutable.ArraySeq$ofShort", {
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofShort.prototype.$classData = $d_scm_ArraySeq$ofShort;
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofUnit__f_array.u.length
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return (this.scm_ArraySeq$ofUnit__f_array.u.length === x2.scm_ArraySeq$ofUnit__f_array.u.length)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array)
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  this.scm_ArraySeq$ofUnit__f_array.get(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"))
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)))
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth))
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass({
  scm_ArraySeq$ofUnit: 0
}, false, "scala.collection.mutable.ArraySeq$ofUnit", {
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofUnit.prototype.$classData = $d_scm_ArraySeq$ofUnit;
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
  if ((x1 === null)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashMap$Node__f__hash <= hash))) {
      if (((n.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, n.scm_HashMap$Node__f__key))) {
        var old = n.scm_HashMap$Node__f__value;
        n.scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null)
      };
      prev = n;
      n = n.scm_HashMap$Node__f__next
    };
    if ((prev === null)) {
      $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, x1))
    } else {
      prev.scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, prev.scm_HashMap$Node__f__next)
    }
  };
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)))
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
  if ((x1 === null)) {
    return null
  } else if (((x1.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashMap$Node__f__key, elem))) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, x1.scm_HashMap$Node__f__next);
    $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
    return x1
  } else {
    var prev = x1;
    var next = x1.scm_HashMap$Node__f__next;
    while (((next !== null) && (next.scm_HashMap$Node__f__hash <= hash))) {
      if (((next.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashMap$Node__f__key, elem))) {
        prev.scm_HashMap$Node__f__next = next.scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
        return next
      };
      prev = next;
      next = next.scm_HashMap$Node__f__next
    };
    return null
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum")))
  };
  var oldlen = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashMap$Node__f__next;
            if (((n.scm_HashMap$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashMap$Node__f__next = n;
              lastLow = n
            } else {
              lastHigh.scm_HashMap$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          lastLow.scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(i, preLow.scm_HashMap$Node__f__next)
          };
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            lastHigh.scm_HashMap$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor))
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
  /*<skip>*/
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix)
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash)) !== null)
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target)
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  this.sizeHint__I__V(xs.knownSize__I());
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var f = new $c_sjsr_AnonFunction3(((this$1) => ((k$2, v$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$1, k$2, v$2, (h ^ ((h >>> 16) | 0)), false)
    }))(this));
    x2.sci_HashMap__f_rootNode.foreachWithHash__F3__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, next.scm_HashMap$Node__f__hash, false)
    };
    return this
  } else if ($is_scm_Map(xs)) {
    var x4 = $as_scm_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((this$2) => ((key$2, value$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$2, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false)
    }))(this)));
    return this
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this))
});
$c_scm_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$2(this))
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this))
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some(x1$1.scm_HashMap$Node__f__value))
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : x1$1.scm_HashMap$Node__f__value)
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? default$1.apply__O() : nd.scm_HashMap$Node__f__value)
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return nd.scm_HashMap$Node__f__value
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = defaultValue.apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, (this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
      };
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1
    }
  }
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false)
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem._1__O(), elem._2__O(), false);
  return this
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0)
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
    if ((n !== null)) {
      n.foreachEntry__F2__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$()
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap"
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed)
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem)
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem))
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashMap(xs)
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"))
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)))
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth))
}
var $d_scm_HashMap = new $TypeData().initClass({
  scm_HashMap: 0
}, false, "scala.collection.mutable.HashMap", {
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap.prototype.$classData = $d_scm_HashMap;
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
  /*<skip>*/
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"))
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)))
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth))
}
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
  /*<skip>*/
}
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $TypeData().initClass({
  sci_Queue$EmptyQueue$: 0
}, false, "scala.collection.immutable.Queue$EmptyQueue$", {
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$EmptyQueue$.prototype.$classData = $d_sci_Queue$EmptyQueue$;
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$()
  };
  return $n_sci_Queue$EmptyQueue$
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1)
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
  /*<skip>*/
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var a1c = a1.clone__O();
    a1c.set(index, elem);
    return new $c_sci_Vector1(a1c)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem))
  } else {
    var $$x2 = this.sci_Vector__f_prefix1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2($$x2, 32, $$x1, a, 33)
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1))
  } else {
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0))
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f))
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi))
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 1)) {
    return $m_sci_Vector0$()
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to))
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k))
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector1.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"))
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)))
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth))
}
var $d_sci_Vector1 = new $TypeData().initClass({
  sci_Vector1: 0
}, false, "scala.collection.immutable.Vector1", {
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector1.prototype.$classData = $d_sci_Vector1;
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1() {
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = null;
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = new $c_s_Some((void 0))
}
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__s_Option__s_Option__s_Option = (function(x, y) {
  return ((!x.isEmpty__Z()) ? x : y)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__s_Option = (function(a, f) {
  var this$ = this;
  var a$tailLocal1 = a;
  while (true) {
    var x4 = $as_s_Option(f.apply__O__O(a$tailLocal1));
    var x = $m_s_None$();
    if ((x === x4)) {
      return $m_s_None$()
    };
    if ((x4 instanceof $c_s_Some)) {
      var x10 = $as_s_util_Either($as_s_Some(x4).s_Some__f_value);
      if ((x10 instanceof $c_s_util_Left)) {
        var a1 = $as_s_util_Left(x10).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        a$tailLocal1 = a1;
        continue
      };
      if ((x10 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x10).s_util_Right__f_value;
        return new $c_s_Some(b)
      }
    };
    throw new $c_s_MatchError(x4)
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var value = f.apply__O__O__O(fa.get__O(), fb.get__O());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var _1 = fa.get__O();
    var _2 = fb.get__O();
    var value = $ct_T2__O__O__(new $c_T2(), _1, _2);
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    var value = $m_s_None$();
    return new $c_Lcats_Now(value)
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2, a$2) => ((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var b = $as_s_Some(x$1$1).s_Some__f_value;
        var value$1 = f$2.apply__O__O__O(a$2, b);
        return new $c_s_Some(value$1)
      };
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$1)) {
        return $m_s_None$()
      };
      throw new $c_s_MatchError(x$1$1)
    }))(f, a)))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return lb
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__s_Option__F1__s_Option = (function(fa, f) {
  return (fa.isEmpty__Z() ? $as_s_Option(f.apply__O__O((void 0))) : fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__s_Option__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return evidence$1.pure__O__O($m_s_None$())
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return evidence$1.map__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1(((_$2) => new $c_s_Some(_$2))))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_None$()
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_Option__s_Option__s_Option($as_s_Option(x), $as_s_Option(y))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_Some(x)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  return (fa$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(fa$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  return (fa$1.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f.apply__O__O(fa$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_Option(a, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option($as_s_Option(fa), $as_s_Option(fb), f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), fb, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), lb, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  $as_jl_Void(e);
  return $m_s_None$()
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_Option__F1__s_Option($as_s_Option(fa), f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(fa), f, evidence$1)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OptionInstances$$anon$1: 0
}, false, "cats.instances.OptionInstances$$anon$1", {
  Lcats_instances_OptionInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
  /*<skip>*/
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::"
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"))
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)))
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth))
}
var $d_sci_$colon$colon = new $TypeData().initClass({
  sci_$colon$colon: 0
}, false, "scala.collection.immutable.$colon$colon", {
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_$colon$colon.prototype.$classData = $d_sci_$colon$colon;
/** @constructor */
function $c_sci_Nil$() {
  this.sci_Nil$__f_EmptyUnzip = null;
  $n_sci_Nil$ = this;
  this.sci_Nil$__f_EmptyUnzip = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
  /*<skip>*/
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list")
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list")
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list")
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E()
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E()
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Nil$ = new $TypeData().initClass({
  sci_Nil$: 0
}, false, "scala.collection.immutable.Nil$", {
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_Nil$.prototype.$classData = $d_sci_Nil$;
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$()
  };
  return $n_sci_Nil$
}
function $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet($thiz, t) {
  return ((t === $thiz.sci_TreeSet__f_tree) ? $thiz : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, $thiz.sci_TreeSet__f_ordering))
}
function $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeSet__f_tree = tree;
  $thiz.sci_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  };
  return $thiz
}
function $ct_sci_TreeSet__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz
}
/** @constructor */
function $c_sci_TreeSet() {
  this.sci_TreeSet__f_tree = null;
  this.sci_TreeSet__f_ordering = null
}
$c_sci_TreeSet.prototype = new $h_sci_AbstractSet();
$c_sci_TreeSet.prototype.constructor = $c_sci_TreeSet;
/** @constructor */
function $h_sci_TreeSet() {
  /*<skip>*/
}
$h_sci_TreeSet.prototype = $c_sci_TreeSet.prototype;
$c_sci_TreeSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_sci_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.sci_TreeSet__f_ordering;
  return new $c_sci_TreeSet$TreeSetBuilder(evidence$12)
});
$c_sci_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeSet__f_ordering
});
$c_sci_TreeSet.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)
});
$c_sci_TreeSet.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) === 0)
});
$c_sci_TreeSet.prototype.head__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.last__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.tail__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree), this.sci_TreeSet__f_ordering)
});
$c_sci_TreeSet.prototype.drop__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree))) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6)
  } else {
    return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering)
  }
});
$c_sci_TreeSet.prototype.take__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6)
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)) ? this : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering))
  }
});
$c_sci_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreachKey__sci_RedBlackTree$Tree__F1__V(this.sci_TreeSet__f_tree, f)
});
$c_sci_TreeSet.prototype.iterator__sc_Iterator = (function() {
  $m_sci_RedBlackTree$();
  var tree = this.sci_TreeSet__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$17 = this.sci_TreeSet__f_ordering;
  return new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17)
});
$c_sci_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering)
});
$c_sci_TreeSet.prototype.incl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, null, false, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.excl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sci_TreeSet = (function(that) {
  matchEnd4: {
    var t$2;
    if ((that instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(that);
      var x = this.sci_TreeSet__f_ordering;
      var x$2 = x2.sci_TreeSet__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var t$2 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, x2.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
        break matchEnd4
      }
    };
    var it = that.iterator__sc_Iterator();
    var t = this.sci_TreeSet__f_tree;
    while (it.hasNext__Z()) {
      t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, it.next__O(), null, false, this.sci_TreeSet__f_ordering)
    };
    var t$2 = t
  };
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, t$2)
});
$c_sci_TreeSet.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(obj);
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = x2.sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeSet__f_tree, x2.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering)
    }
  };
  return $f_sc_SortedSet__equals__O__Z(this, obj)
});
$c_sci_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_TreeSet(that)
});
$c_sci_TreeSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.tail__O = (function() {
  return this.tail__sci_TreeSet()
});
$c_sci_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_TreeSet$()
});
function $as_sci_TreeSet(obj) {
  return (((obj instanceof $c_sci_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSet"))
}
function $isArrayOf_sci_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet)))
}
function $asArrayOf_sci_TreeSet(obj, depth) {
  return (($isArrayOf_sci_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSet;", depth))
}
var $d_sci_TreeSet = new $TypeData().initClass({
  sci_TreeSet: 0
}, false, "scala.collection.immutable.TreeSet", {
  sci_TreeSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet.prototype.$classData = $d_sci_TreeSet;
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0)
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
  /*<skip>*/
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail")
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)))
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"))
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this
});
$c_sci_Vector0$.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1))
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i)
});
var $d_sci_Vector0$ = new $TypeData().initClass({
  sci_Vector0$: 0
}, false, "scala.collection.immutable.Vector0$", {
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector0$.prototype.$classData = $d_sci_Vector0$;
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$()
  };
  return $n_sci_Vector0$
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
  /*<skip>*/
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.sci_Vector2__f_data2.u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5)
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10)
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var a1c$2 = a1$2.clone__O();
      a1c$2.set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8)
  } else {
    var $$x5 = this.sci_Vector__f_prefix1;
    var $$x4 = this.sci_Vector2__f_len1;
    var $$x3 = this.sci_Vector2__f_data2;
    var $$x2 = this.sci_Vector2__f_len1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$1.set(0, x);
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    return new $c_sci_Vector3($$x5, $$x4, $$x3, ((960 + $$x2) | 0), $$x1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9)
  } else {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5)
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector2.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"))
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)))
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth))
}
var $d_sci_Vector2 = new $TypeData().initClass({
  sci_Vector2: 0
}, false, "scala.collection.immutable.Vector2", {
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector2.prototype.$classData = $d_sci_Vector2;
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
  /*<skip>*/
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.sci_Vector3__f_data3.u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8)
      } else if ((i2 < this.sci_Vector3__f_suffix2.u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16)
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24)
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.clone__O();
      var a1$3 = a2c$2.get(idx2);
      var a1c$3 = a1$3.clone__O();
      a1c$3.set(idx1, elem);
      a2c$2.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32)
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2)
  } else if ((this.sci_Vector3__f_suffix2.u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20)
  } else {
    var $$x8 = this.sci_Vector__f_prefix1;
    var $$x7 = this.sci_Vector3__f_len1;
    var $$x6 = this.sci_Vector3__f_prefix2;
    var $$x5 = this.sci_Vector3__f_len12;
    var $$x4 = this.sci_Vector3__f_data3;
    var $$x3 = this.sci_Vector3__f_len12;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    return new $c_sci_Vector4($$x8, $$x7, $$x6, $$x5, $$x4, ((30720 + $$x3) | 0), $$x2, a$2, $$x1, a$3, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22)
  } else {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    return new $c_sci_Vector4(a$2, 1, $$x1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8)
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector3.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"))
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)))
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth))
}
var $d_sci_Vector3 = new $TypeData().initClass({
  sci_Vector3: 0
}, false, "scala.collection.immutable.Vector3", {
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector3.prototype.$classData = $d_sci_Vector3;
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
  /*<skip>*/
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.sci_Vector4__f_data4.u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11)
      } else if ((i3 < this.sci_Vector4__f_suffix3.u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22)
      } else if ((i2 < this.sci_Vector4__f_suffix2.u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33)
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44)
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.clone__O();
      var a2$3 = a3c$2.get(idx3);
      var a2c$3 = a2$3.clone__O();
      var a1$4 = a2c$3.get(idx2);
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(idx1, elem);
      a2c$3.set(idx2, a1c$4);
      a3c$2.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55)
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2$1);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1$1, elem);
      a2c$4.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66)
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2)
  } else if ((this.sci_Vector4__f_suffix2.u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14)
  } else if ((this.sci_Vector4__f_suffix3.u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38)
  } else {
    var $$x11 = this.sci_Vector__f_prefix1;
    var $$x10 = this.sci_Vector4__f_len1;
    var $$x9 = this.sci_Vector4__f_prefix2;
    var $$x8 = this.sci_Vector4__f_len12;
    var $$x7 = this.sci_Vector4__f_prefix3;
    var $$x6 = this.sci_Vector4__f_len123;
    var $$x5 = this.sci_Vector4__f_data4;
    var $$x4 = this.sci_Vector4__f_len123;
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    return new $c_sci_Vector5($$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, ((983040 + $$x4) | 0), $$x3, a$3, $$x2, $$x1, a$4, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17)
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41)
  } else {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    return new $c_sci_Vector5(a$3, 1, $$x2, 1, $$x1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11)
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector4.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"))
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)))
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth))
}
var $d_sci_Vector4 = new $TypeData().initClass({
  sci_Vector4: 0
}, false, "scala.collection.immutable.Vector4", {
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector4.prototype.$classData = $d_sci_Vector4;
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
  /*<skip>*/
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.sci_Vector5__f_data5.u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14)
      } else if ((i4 < this.sci_Vector5__f_suffix4.u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28)
      } else if ((i3 < this.sci_Vector5__f_suffix3.u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42)
      } else if ((i2 < this.sci_Vector5__f_suffix2.u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56)
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70)
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.clone__O();
      var a3$3 = a4c$2.get(idx4);
      var a3c$3 = a3$3.clone__O();
      var a2$4 = a3c$3.get(idx3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1, elem);
      a2c$4.set(idx2, a1c$5);
      a3c$3.set(idx3, a2c$4);
      a4c$2.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84)
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3$1);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2$1);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1$1, elem);
      a2c$5.set(idx2$1, a1c$6);
      a3c$4.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98)
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$2);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$2, elem);
      a2c$6.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112)
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2)
  } else if ((this.sci_Vector5__f_suffix2.u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17)
  } else if ((this.sci_Vector5__f_suffix3.u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32)
  } else if ((this.sci_Vector5__f_suffix4.u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62)
  } else {
    var $$x14 = this.sci_Vector__f_prefix1;
    var $$x13 = this.sci_Vector5__f_len1;
    var $$x12 = this.sci_Vector5__f_prefix2;
    var $$x11 = this.sci_Vector5__f_len12;
    var $$x10 = this.sci_Vector5__f_prefix3;
    var $$x9 = this.sci_Vector5__f_len123;
    var $$x8 = this.sci_Vector5__f_prefix4;
    var $$x7 = this.sci_Vector5__f_len1234;
    var $$x6 = this.sci_Vector5__f_data5;
    var $$x5 = this.sci_Vector5__f_len1234;
    var $$x4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    a$5.set(0, elem);
    return new $c_sci_Vector6($$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, ((31457280 + $$x5) | 0), $$x4, a$4, $$x3, $$x2, $$x1, a$5, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21)
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36)
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66)
  } else {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$5.set(0, x);
    return new $c_sci_Vector6(a$4, 1, $$x3, 1, $$x2, 1, $$x1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14)
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector5.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"))
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)))
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth))
}
var $d_sci_Vector5 = new $TypeData().initClass({
  sci_Vector5: 0
}, false, "scala.collection.immutable.Vector5", {
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector5.prototype.$classData = $d_sci_Vector5;
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
  /*<skip>*/
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.sci_Vector6__f_data6.u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var a6c = a6.clone__O();
        var a5 = a6c.get(i6);
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        a6c.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17)
      } else if ((i5 < this.sci_Vector6__f_suffix5.u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var a5c$1 = a5$1.clone__O();
        var a4$1 = a5c$1.get(i5);
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        a5c$1.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34)
      } else if ((i4 < this.sci_Vector6__f_suffix4.u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var a4c$2 = a4$2.clone__O();
        var a3$2 = a4c$2.get(i4);
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        a4c$2.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51)
      } else if ((i3 < this.sci_Vector6__f_suffix3.u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var a3c$3 = a3$3.clone__O();
        var a2$3 = a3c$3.get(i3);
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        a3c$3.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68)
      } else if ((i2 < this.sci_Vector6__f_suffix2.u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var a2c$4 = a2$4.clone__O();
        var a1$4 = a2c$4.get(i2);
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        a2c$4.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85)
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var a1c$5 = a1$5.clone__O();
        a1c$5.set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102)
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.clone__O();
      var a4$3 = a5c$2.get(idx5);
      var a4c$3 = a4$3.clone__O();
      var a3$4 = a4c$3.get(idx4);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1, elem);
      a2c$5.set(idx2, a1c$6);
      a3c$4.set(idx3, a2c$5);
      a4c$3.set(idx4, a3c$4);
      a5c$2.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119)
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.clone__O();
      var a3$5 = a4c$4.get(idx4$1);
      var a3c$5 = a3$5.clone__O();
      var a2$6 = a3c$5.get(idx3$1);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$1);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$1, elem);
      a2c$6.set(idx2$1, a1c$7);
      a3c$5.set(idx3$1, a2c$6);
      a4c$4.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136)
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.clone__O();
      var a2$7 = a3c$6.get(idx3$2);
      var a2c$7 = a2$7.clone__O();
      var a1$8 = a2c$7.get(idx2$2);
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(idx1$2, elem);
      a2c$7.set(idx2$2, a1c$8);
      a3c$6.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153)
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.clone__O();
      var a1$9 = a2c$8.get(idx2$3);
      var a1c$9 = a1$9.clone__O();
      a1c$9.set(idx1$3, elem);
      a2c$8.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170)
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var a1c$10 = a1$10.clone__O();
      a1c$10.set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2)
  } else if ((this.sci_Vector6__f_suffix2.u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20)
  } else if ((this.sci_Vector6__f_suffix3.u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38)
  } else if ((this.sci_Vector6__f_suffix4.u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56)
  } else if ((this.sci_Vector6__f_suffix5.u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25)
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43)
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61)
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17)
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector6.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"))
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)))
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth))
}
var $d_sci_Vector6 = new $TypeData().initClass({
  sci_Vector6: 0
}, false, "scala.collection.immutable.Vector6", {
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector6.prototype.$classData = $d_sci_Vector6;
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
function $ct_scm_StringBuilder__I__($thiz, capacity) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
  /*<skip>*/
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_StringBuilder.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(0))
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_StringBuilder__f_underlying.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()))
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.addAll__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = ct.runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct))
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = this.scm_StringBuilder__f_underlying.length__I();
  var arr = new $ac_C(len);
  this.scm_StringBuilder__f_underlying.getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr
});
$c_scm_StringBuilder.prototype.append__O__scm_StringBuilder = (function(x) {
  var this$2 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = this.scm_StringBuilder__f_underlying;
    $m_sci_WrappedString$();
    var str = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    this.scm_StringBuilder__f_underlying.append__AC__jl_StringBuilder(x3.scm_ArraySeq$ofChar__f_array)
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = this.scm_StringBuilder__f_underlying;
    var s = x4.scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    var ks = xs.knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        b.length__I()
      };
      var it = xs.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var c = $uC(it.next__O());
        var str$1 = $as_T(String.fromCharCode(c));
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1)
      }
    }
  };
  return this
});
$c_scm_StringBuilder.prototype.append__I__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.append__J__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(x.RTLong__f_lo, x.RTLong__f_hi);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.charAt__I__C = (function(index) {
  return this.scm_StringBuilder__f_underlying.charAt__I__C(index)
});
$c_scm_StringBuilder.prototype.deleteCharAt__I__scm_StringBuilder = (function(index) {
  this.scm_StringBuilder__f_underlying.deleteCharAt__I__jl_StringBuilder(index);
  return this
});
$c_scm_StringBuilder.prototype.setCharAt__I__C__scm_StringBuilder = (function(index, ch) {
  this.scm_StringBuilder__f_underlying.setCharAt__I__C__V(index, ch);
  return this
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.scm_StringBuilder__f_underlying.substring__I__I__T(start, end)
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return (this.scm_StringBuilder__f_underlying.length__I() === 0)
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$()
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem))
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"))
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)))
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth))
}
var $d_scm_StringBuilder = new $TypeData().initClass({
  scm_StringBuilder: 0
}, false, "scala.collection.mutable.StringBuilder", {
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder.prototype.$classData = $d_scm_StringBuilder;
/** @constructor */
function $c_sci_BitSet() {
  /*<skip>*/
}
$c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
  /*<skip>*/
}
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that))
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f)
});
$c_sci_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_SortedSet$()
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_sci_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_BitSet$().newBuilder__scm_Builder()
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this
  } else {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$2.RTLong__f_lo | lo);
    var hi$1 = (this$2.RTLong__f_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$1, hi$1))
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$2.RTLong__f_lo & lo$1);
    var hi$2 = (this$2.RTLong__f_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$2, hi$2))
  } else {
    return this
  }
});
$c_sci_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_sci_BitSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
function $as_sci_BitSet(obj) {
  return (((obj instanceof $c_sci_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitSet"))
}
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)))
}
function $asArrayOf_sci_BitSet(obj, depth) {
  return (($isArrayOf_sci_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitSet;", depth))
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = buf.scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = buf.scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz)
  }
}
function $p_scm_ListBuffer__reduceLengthBy__I__V($thiz, num) {
  $thiz.scm_ListBuffer__f_len = (($thiz.scm_ListBuffer__f_len - num) | 0);
  if (($thiz.scm_ListBuffer__f_len <= 0)) {
    $thiz.scm_ListBuffer__f_last0 = null
  }
}
function $p_scm_ListBuffer__locate__I__sci_$colon$colon($thiz, i) {
  if ((i === 0)) {
    return null
  } else if ((i === $thiz.scm_ListBuffer__f_len)) {
    return $thiz.scm_ListBuffer__f_last0
  } else {
    var j = (((-1) + i) | 0);
    var p = $thiz.scm_ListBuffer__f_first;
    while ((j > 0)) {
      p = $as_sci_List(p.tail__O());
      j = (((-1) + j) | 0)
    };
    return $as_sci_$colon$colon(p)
  }
}
function $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, p) {
  return ((p === null) ? $thiz.scm_ListBuffer__f_first : p.sci_$colon$colon__f_next)
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
  /*<skip>*/
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.scm_ListBuffer__f_first.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scm_ListBuffer__f_mutationCount))(this)))
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$()
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0)
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1
  } else {
    this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1
  };
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while (it.hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      last0.sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0)
    };
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0
  };
  return this
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = fresh.scm_ListBuffer__f_first
    } else {
      this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = fresh.scm_ListBuffer__f_first
    };
    this.scm_ListBuffer__f_last0 = fresh.scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + fresh.scm_ListBuffer__f_len) | 0)
  };
  return this
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if ((!this.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(this.scm_ListBuffer__f_first.head__O(), elem)) {
      this.scm_ListBuffer__f_first = $as_sci_List(this.scm_ListBuffer__f_first.tail__O());
      $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1)
    } else {
      var cursor = this.scm_ListBuffer__f_first;
      while (((!$as_sci_List(cursor.tail__O()).isEmpty__Z()) && (!$m_sr_BoxesRunTime$().equals__O__O__Z($as_sc_IterableOps(cursor.tail__O()).head__O(), elem)))) {
        cursor = $as_sci_List(cursor.tail__O())
      };
      if ((!$as_sci_List(cursor.tail__O()).isEmpty__Z())) {
        var z = $as_sci_$colon$colon(cursor);
        var x = z.sci_$colon$colon__f_next;
        var x$2 = this.scm_ListBuffer__f_last0;
        if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
          this.scm_ListBuffer__f_last0 = z
        };
        z.sci_$colon$colon__f_next = $as_sci_List($as_sc_IterableOps(cursor.tail__O()).tail__O());
        $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1)
      }
    }
  };
  return this
});
$c_scm_ListBuffer.prototype.remove__I__O = (function(idx) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.scm_ListBuffer__f_len))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + this.scm_ListBuffer__f_len) | 0)) + ")"))
  };
  var p = $p_scm_ListBuffer__locate__I__sci_$colon$colon(this, idx);
  var nx = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p);
  if ((p === null)) {
    this.scm_ListBuffer__f_first = $as_sci_List(nx.tail__O());
    if (this.scm_ListBuffer__f_first.isEmpty__Z()) {
      this.scm_ListBuffer__f_last0 = null
    }
  } else {
    if ((this.scm_ListBuffer__f_last0 === nx)) {
      this.scm_ListBuffer__f_last0 = p
    };
    p.sci_$colon$colon__f_next = $as_sci_List(nx.tail__O())
  };
  this.scm_ListBuffer__f_len = (((-1) + this.scm_ListBuffer__f_len) | 0);
  return nx.head__O()
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer"
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ListBuffer(x)
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(xs)
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List()
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$()
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"))
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)))
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth))
}
var $d_scm_ListBuffer = new $TypeData().initClass({
  scm_ListBuffer: 0
}, false, "scala.collection.mutable.ListBuffer", {
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer.prototype.$classData = $d_scm_ListBuffer;
/** @constructor */
function $c_sci_BitSet$BitSet1(elems) {
  this.sci_BitSet$BitSet1__f_elems = $L0;
  this.sci_BitSet$BitSet1__f_elems = elems
}
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet1__f_elems : $L0)
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet1__f_elems]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
var $d_sci_BitSet$BitSet1 = new $TypeData().initClass({
  sci_BitSet$BitSet1: 0
}, false, "scala.collection.immutable.BitSet$BitSet1", {
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet1.prototype.$classData = $d_sci_BitSet$BitSet1;
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0, elems1) {
  this.sci_BitSet$BitSet2__f_elems0 = $L0;
  this.sci_BitSet$BitSet2__f_elems1 = $L0;
  this.sci_BitSet$BitSet2__f_elems0 = elems0;
  this.sci_BitSet$BitSet2__f_elems1 = elems1
}
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet2__f_elems0 : ((idx === 1) ? this.sci_BitSet$BitSet2__f_elems1 : $L0))
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w, this.sci_BitSet$BitSet2__f_elems1)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet2__f_elems0, this.sci_BitSet$BitSet2__f_elems1]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
var $d_sci_BitSet$BitSet2 = new $TypeData().initClass({
  sci_BitSet$BitSet2: 0
}, false, "scala.collection.immutable.BitSet$BitSet2", {
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet2.prototype.$classData = $d_sci_BitSet$BitSet2;
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems
}
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
  /*<skip>*/
}
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return this.sci_BitSet$BitSetN__f_elems.u.length
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? this.sci_BitSet$BitSetN__f_elems.get(idx) : $L0)
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
var $d_sci_BitSet$BitSetN = new $TypeData().initClass({
  sci_BitSet$BitSetN: 0
}, false, "scala.collection.immutable.BitSet$BitSetN", {
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSetN.prototype.$classData = $d_sci_BitSet$BitSetN;
function $as_sci_TreeMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeMap"))
}
function $isArrayOf_sci_TreeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeMap)))
}
function $asArrayOf_sci_TreeMap(obj, depth) {
  return (($isArrayOf_sci_TreeMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeMap;", depth))
}
function $p_scm_ArrayBuffer__reduceToSize__I__V($thiz, n) {
  $thiz.scm_ArrayBuffer__f_mutationCount = ((1 + $thiz.scm_ArrayBuffer__f_mutationCount) | 0);
  var a = $thiz.scm_ArrayBuffer__f_array;
  var toIndex = $thiz.scm_ArrayBuffer__f_size0;
  $m_ju_Arrays$().fill__AO__I__I__O__V(a, n, toIndex, null);
  $thiz.scm_ArrayBuffer__f_size0 = n
}
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
  /*<skip>*/
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().iterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().reverseIterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_ArrayBuffer.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n)
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  return this.scm_ArrayBuffer__f_array.get(n)
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  this.scm_ArrayBuffer__f_array.set(index, elem)
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scm_ArrayBuffer__f_mutationCount))(this)))
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  var oldSize = this.scm_ArrayBuffer__f_size0;
  this.ensureSize__I__V(((1 + oldSize) | 0));
  this.scm_ArrayBuffer__f_size0 = ((1 + oldSize) | 0);
  this.update__I__O__V(oldSize, elem);
  return this
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    var elemsLength = x2.scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0));
      $m_s_Array$().copy__O__I__O__I__I__V(x2.scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0)
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems)
  };
  return this
});
$c_scm_ArrayBuffer.prototype.remove__I__O = (function(index) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  var res = this.apply__I__O(index);
  $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, ((1 + index) | 0), this.scm_ArrayBuffer__f_array, index, ((this.scm_ArrayBuffer__f_size0 - ((1 + index) | 0)) | 0));
  $p_scm_ArrayBuffer__reduceToSize__I__V(this, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  return res
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer"
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(xs)
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem)
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"))
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)))
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth))
}
var $d_scm_ArrayBuffer = new $TypeData().initClass({
  scm_ArrayBuffer: 0
}, false, "scala.collection.mutable.ArrayBuffer", {
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer.prototype.$classData = $d_scm_ArrayBuffer;
/** @constructor */
function $c_scm_TreeSet(tree, ordering) {
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = null;
  this.scm_TreeSet__f_ordering = null;
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = tree;
  this.scm_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  }
}
$c_scm_TreeSet.prototype = new $h_scm_AbstractSet();
$c_scm_TreeSet.prototype.constructor = $c_scm_TreeSet;
/** @constructor */
function $h_scm_TreeSet() {
  /*<skip>*/
}
$h_scm_TreeSet.prototype = $c_scm_TreeSet.prototype;
$c_scm_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  var b = new $c_scm_TreeSet$$anon$1(evidence$12);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, this);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, that);
  return b.result__scm_TreeSet()
});
$c_scm_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_scm_TreeSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  return new $c_scm_TreeSet$$anon$1(evidence$12)
});
$c_scm_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.scm_TreeSet__f_ordering
});
$c_scm_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_TreeSet$()
});
$c_scm_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  var start = $m_s_None$();
  var end = $m_s_None$();
  var evidence$4 = this.scm_TreeSet__f_ordering;
  return new $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$4)
});
$c_scm_TreeSet.prototype.addOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, null, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_scm_RedBlackTree$().contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering)
});
$c_scm_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_scm_TreeSet.prototype.size__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return tree.scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.knownSize__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return tree.scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.isEmpty__Z = (function() {
  return $m_scm_RedBlackTree$().isEmpty__scm_RedBlackTree$Tree__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)
});
$c_scm_TreeSet.prototype.head__O = (function() {
  return $m_scm_RedBlackTree$().minKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).get__O()
});
$c_scm_TreeSet.prototype.last__O = (function() {
  return $m_scm_RedBlackTree$().maxKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).get__O()
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_TreeSet(elem)
});
$c_scm_TreeSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet(elem)
});
function $as_scm_TreeSet(obj) {
  return (((obj instanceof $c_scm_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.TreeSet"))
}
function $isArrayOf_scm_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_TreeSet)))
}
function $asArrayOf_scm_TreeSet(obj, depth) {
  return (($isArrayOf_scm_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.TreeSet;", depth))
}
var $d_scm_TreeSet = new $TypeData().initClass({
  scm_TreeSet: 0
}, false, "scala.collection.mutable.TreeSet", {
  scm_TreeSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet.prototype.$classData = $d_scm_TreeSet;
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sjs_js_WrappedArray.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[0]
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.remove__I__O = (function(n) {
  if (((n < 0) || (n >= $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.splice(n, 1)[0]
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray"
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"))
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)))
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth))
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass({
  sjs_js_WrappedArray: 0
}, false, "scala.scalajs.js.WrappedArray", {
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray.prototype.$classData = $d_sjs_js_WrappedArray;
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz
}
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null
}
$c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
  /*<skip>*/
}
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_BitSet($as_sc_SetOps(b.scm_GrowableBuilder__f_elems))
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_scm_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_SortedSet$()
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()))
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return this.scm_BitSet__f_elems.u.length
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? this.scm_BitSet__f_elems.get(idx) : $L0)
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return ((elems.u.length === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems))
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo | lo);
    var hi$1 = (this$1.RTLong__f_hi | hi);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$1, hi$1))
  };
  return this
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$1.RTLong__f_lo & lo$1);
    var hi$2 = (this$1.RTLong__f_hi & hi$1);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$2, hi$2))
  };
  return this
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w) {
  this.ensureCapacity__I__V(idx);
  this.scm_BitSet__f_elems.set(idx, w)
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= this.nwords__I())) {
    var newlen = this.nwords__I();
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432)
    };
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, this.nwords__I());
    this.scm_BitSet__f_elems = elems1
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((((-1) + other.nwords__I()) | 0));
  var i = 0;
  var othernwords = other.nwords__I();
  while ((i < othernwords)) {
    var $$x2 = this.scm_BitSet__f_elems;
    var $$x1 = i;
    var this$1 = this.scm_BitSet__f_elems.get(i);
    var b = other.word__I__J(i);
    var lo = (this$1.RTLong__f_lo | b.RTLong__f_lo);
    var hi = (this$1.RTLong__f_hi | b.RTLong__f_hi);
    $$x2.set($$x1, new $c_RTLong(lo, hi));
    i = ((1 + i) | 0)
  };
  return this
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    var x2 = $as_sc_BitSet(xs);
    return this.$bar$eq__sc_BitSet__scm_BitSet(x2)
  } else if (false) {
    var x3 = $as_sci_Range(xs);
    if ((!x3.sci_Range__f_isEmpty)) {
      var start = x3.min__s_math_Ordering__I($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = x3.max__s_math_Ordering__I($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if (((x3.sci_Range__f_step === 1) || (x3.sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var this$1 = ev$1.get(startIdx);
            var lo$1 = (this$1.RTLong__f_lo | lo);
            var hi$1 = (this$1.RTLong__f_hi | hi);
            ev$1.set(startIdx, new $c_RTLong(lo$1, hi$1));
            var a = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $m_ju_Arrays$().fill__AJ__I__I__J__V(a, fromIndex, endIdx, new $c_RTLong((-1), (-1)));
            var ev$2 = this.scm_BitSet__f_elems;
            var this$2 = ev$2.get(endIdx);
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (this$2.RTLong__f_lo | lo$2);
            var hi$3 = (this$2.RTLong__f_hi | hi$2);
            ev$2.set(endIdx, new $c_RTLong(lo$3, hi$3))
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var this$3 = ev$3.get(endIdx);
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (this$3.RTLong__f_lo | lo$5);
            var hi$6 = (this$3.RTLong__f_hi | hi$5);
            ev$3.set(endIdx, new $c_RTLong(lo$6, hi$6))
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
      }
    };
    return this
  } else if ($is_sc_SortedSet(xs)) {
    var x4 = $as_sc_SortedSet(xs);
    if ((!x4.isEmpty__Z())) {
      var ord = x4.ordering__s_math_Ordering();
      if ((ord === $m_s_math_Ordering$Int$())) {
        this.ensureCapacity__I__V(($uI(x4.last__O()) >> 6))
      } else {
        var this$4 = $m_s_math_Ordering$Int$();
        if ((ord === this$4.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          this.ensureCapacity__I__V(($uI(x4.head__O()) >> 6))
        }
      };
      var iter = x4.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        this.addOne__I__scm_BitSet($uI(iter.next__O()))
      }
    };
    return this
  } else {
    return $as_scm_BitSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var thisnwords = this.nwords__I();
    var bsnwords = x2.nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var this$2 = this.word__I__J(i);
      if ((!((this$2.RTLong__f_lo === 0) && (this$2.RTLong__f_hi === 0)))) {
        return false
      };
      i = ((1 + i) | 0)
    };
    var j = 0;
    while ((j < minWords)) {
      var this$3 = this.word__I__J(j);
      var b = x2.word__I__J(j);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (this$3.RTLong__f_lo & lo);
      var hi$1 = (this$3.RTLong__f_hi & hi);
      if ((!((lo$1 === 0) && (hi$1 === 0)))) {
        return false
      };
      j = ((1 + j) | 0)
    };
    return true
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that)
  }
});
$c_scm_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_BitSet(xs)
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
function $as_scm_BitSet(obj) {
  return (((obj instanceof $c_scm_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.BitSet"))
}
function $isArrayOf_scm_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_BitSet)))
}
function $asArrayOf_scm_BitSet(obj, depth) {
  return (($isArrayOf_scm_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.BitSet;", depth))
}
var $d_scm_BitSet = new $TypeData().initClass({
  scm_BitSet: 0
}, false, "scala.collection.mutable.BitSet", {
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_BitSet.prototype.$classData = $d_scm_BitSet;
function $ct_Lcats_instances_AllInstancesBinCompat__($thiz) {
  $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForByte = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForChar = new $c_Lcats_kernel_instances_CharOrder();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForChar = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForLong = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForShort = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFloat = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDouble = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBoolean = new $c_Lcats_kernel_instances_BooleanOrder();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBoolean = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUnit = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForTuple2 = new $c_Lcats_instances_Tuple2Instances$$anon$1();
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigDecimal = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdBimonadForFunction0 = new $c_Lcats_instances_Function0Instances$$anon$1();
  $f_Lcats_instances_Function1Instances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantForHash = new $c_Lcats_instances_HashInstances$$anon$1();
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz);
  $f_Lcats_instances_LazyListInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSet = new $c_Lcats_instances_SetInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSortedSet = new $c_Lcats_instances_SortedSetInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForString = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForSymbol = new $c_Lcats_kernel_instances_SymbolOrder();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForSymbol = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUUID = new $c_Lcats_kernel_instances_UUIDInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUUID = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsSddDeferForFunction0 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsDataFunctorForPair = new $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForOption = new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForList = new $c_Lcats_instances_ListInstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForVector = new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForStream = new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1();
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdComposeForMap = new $c_Lcats_instances_MapInstancesBinCompat0$$anon$1();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFiniteDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsStdSemigroupalForSortedSet = new $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1();
  $f_Lcats_instances_SeqInstances__$init$__V($thiz);
  $f_Lcats_instances_InvariantInstances__$init$__V($thiz);
  $thiz.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDeadline = new $c_Lcats_kernel_instances_DeadlineOrder();
  return $thiz
}
/** @constructor */
function $c_Lcats_instances_AllInstancesBinCompat() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForChar = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForChar = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBoolean = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBoolean = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdAlgebraForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForTuple2 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBitSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdSemilatticeForBitSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForEither = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEquiv = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBimonadForFunction0 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdMonoidKForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantForHash = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForOption = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrder = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrdering = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrder = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrdering = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForQueue = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSortedSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForStream = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdMonoidForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForSymbol = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForSymbol = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUUID = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUUID = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForVector = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsSddDeferForFunction0 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsDataFunctorForPair = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForOption = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForVector = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForStream = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdComposeForMap = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFiniteDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFiniteDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDurationUnambiguous = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFiniteDurationUnambiguous = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdSemigroupalForSortedSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSeq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForSeq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForNumeric = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForIntegral = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDeadline = null
}
$c_Lcats_instances_AllInstancesBinCompat.prototype = new $h_O();
$c_Lcats_instances_AllInstancesBinCompat.prototype.constructor = $c_Lcats_instances_AllInstancesBinCompat;
/** @constructor */
function $h_Lcats_instances_AllInstancesBinCompat() {
  /*<skip>*/
}
$h_Lcats_instances_AllInstancesBinCompat.prototype = $c_Lcats_instances_AllInstancesBinCompat.prototype;
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForInt = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForInt = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForByte = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForByte = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForLong = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForLong = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForShort = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForShort = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFloat = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFloat = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDouble = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDouble = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUnit = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdAlgebraForUnit = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigInt = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigInt = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigDecimal = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigDecimal = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBitSet = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdSemilatticeForBitSet = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdMonoidKForFunction1 = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalSemigroup = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalCommutativeSemigroup = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForLazyList = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForString = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdMonoidForString = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDuration = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDuration = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFiniteDuration = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFiniteDuration = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSeq = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForSeq = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForNumeric = x$0
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForIntegral = x$0
});
/** @constructor */
function $c_Lcats_instances_package$all$() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForByte = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForChar = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForChar = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForLong = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForShort = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFloat = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDouble = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBoolean = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBoolean = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdAlgebraForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUnit = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForTuple2 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigInt = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForBigDecimal = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForBitSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdSemilatticeForBitSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBitraverseForEither = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForEquiv = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdBimonadForFunction0 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdMonoidKForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantForHash = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForOption = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrder = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForOrdering = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrder = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsContravariantMonoidalForPartialOrdering = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForQueue = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSortedSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForStream = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdMonoidForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForString = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForSymbol = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForSymbol = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForUUID = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForUUID = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForVector = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsSddDeferForFunction0 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsDataFunctorForPair = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForOption = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForVector = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForStream = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdComposeForMap = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForFiniteDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdGroupForFiniteDuration = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForDurationUnambiguous = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdShowForFiniteDurationUnambiguous = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdSemigroupalForSortedSet = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForSeq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdTraverseFilterForSeq = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForNumeric = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsInvariantForIntegral = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsKernelStdOrderForDeadline = null;
  $ct_Lcats_instances_AllInstancesBinCompat__(this)
}
$c_Lcats_instances_package$all$.prototype = new $h_Lcats_instances_AllInstancesBinCompat();
$c_Lcats_instances_package$all$.prototype.constructor = $c_Lcats_instances_package$all$;
/** @constructor */
function $h_Lcats_instances_package$all$() {
  /*<skip>*/
}
$h_Lcats_instances_package$all$.prototype = $c_Lcats_instances_package$all$.prototype;
var $d_Lcats_instances_package$all$ = new $TypeData().initClass({
  Lcats_instances_package$all$: 0
}, false, "cats.instances.package$all$", {
  Lcats_instances_package$all$: 1,
  Lcats_instances_AllInstancesBinCompat: 1,
  O: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_instances_AllInstancesBinCompat7: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_AllInstancesBinCompat8: 1,
  Lcats_kernel_instances_DeadlineInstances: 1,
  Lcats_instances_DeadlineInstances: 1,
  Lcats_instances_AllInstancesBinCompat9: 1
});
$c_Lcats_instances_package$all$.prototype.$classData = $d_Lcats_instances_package$all$;
var $n_Lcats_instances_package$all$;
function $m_Lcats_instances_package$all$() {
  if ((!$n_Lcats_instances_package$all$)) {
    $n_Lcats_instances_package$all$ = new $c_Lcats_instances_package$all$()
  };
  return $n_Lcats_instances_package$all$
}
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsKernelStdOrderForInt = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForInt = null;
  this.Lcats_implicits$__f_catsStdShowForInt = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForByte = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForByte = null;
  this.Lcats_implicits$__f_catsStdShowForByte = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForChar = null;
  this.Lcats_implicits$__f_catsStdShowForChar = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForLong = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForLong = null;
  this.Lcats_implicits$__f_catsStdShowForLong = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForShort = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForShort = null;
  this.Lcats_implicits$__f_catsStdShowForShort = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForFloat = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForFloat = null;
  this.Lcats_implicits$__f_catsStdShowForFloat = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForDouble = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForDouble = null;
  this.Lcats_implicits$__f_catsStdShowForDouble = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBoolean = null;
  this.Lcats_implicits$__f_catsStdShowForBoolean = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForUnit = null;
  this.Lcats_implicits$__f_catsKernelStdAlgebraForUnit = null;
  this.Lcats_implicits$__f_catsStdShowForUnit = null;
  this.Lcats_implicits$__f_catsStdBitraverseForTuple2 = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBigInt = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForBigInt = null;
  this.Lcats_implicits$__f_catsStdShowForBigInt = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBigDecimal = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForBigDecimal = null;
  this.Lcats_implicits$__f_catsStdShowForBigDecimal = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBitSet = null;
  this.Lcats_implicits$__f_catsKernelStdSemilatticeForBitSet = null;
  this.Lcats_implicits$__f_catsStdBitraverseForEither = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForEq = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForEquiv = null;
  this.Lcats_implicits$__f_catsStdBimonadForFunction0 = null;
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  this.Lcats_implicits$__f_catsStdMonoidKForFunction1 = null;
  this.Lcats_implicits$__f_catsContravariantForHash = null;
  this.Lcats_implicits$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_implicits$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForLazyList = null;
  this.Lcats_implicits$__f_catsStdInstancesForList = null;
  this.Lcats_implicits$__f_catsStdInstancesForOption = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrder = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrdering = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrder = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrdering = null;
  this.Lcats_implicits$__f_catsStdInstancesForQueue = null;
  this.Lcats_implicits$__f_catsStdInstancesForSet = null;
  this.Lcats_implicits$__f_catsStdInstancesForSortedSet = null;
  this.Lcats_implicits$__f_catsStdInstancesForStream = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForString = null;
  this.Lcats_implicits$__f_catsKernelStdMonoidForString = null;
  this.Lcats_implicits$__f_catsStdShowForString = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForSymbol = null;
  this.Lcats_implicits$__f_catsStdShowForSymbol = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForUUID = null;
  this.Lcats_implicits$__f_catsStdShowForUUID = null;
  this.Lcats_implicits$__f_catsStdInstancesForVector = null;
  this.Lcats_implicits$__f_catsSddDeferForFunction0 = null;
  this.Lcats_implicits$__f_catsDataFunctorForPair = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForOption = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForList = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForVector = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForStream = null;
  this.Lcats_implicits$__f_catsStdComposeForMap = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForDuration = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForDuration = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForFiniteDuration = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForFiniteDuration = null;
  this.Lcats_implicits$__f_catsStdShowForDurationUnambiguous = null;
  this.Lcats_implicits$__f_catsStdShowForFiniteDurationUnambiguous = null;
  this.Lcats_implicits$__f_catsStdSemigroupalForSortedSet = null;
  $n_Lcats_implicits$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForByte = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForChar = new $c_Lcats_kernel_instances_CharOrder();
  this.Lcats_implicits$__f_catsStdShowForChar = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForLong = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForShort = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForFloat = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForDouble = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForBoolean = new $c_Lcats_kernel_instances_BooleanOrder();
  this.Lcats_implicits$__f_catsStdShowForBoolean = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForUnit = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdBitraverseForTuple2 = new $c_Lcats_instances_Tuple2Instances$$anon$1();
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForBigInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForBigDecimal = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdBimonadForFunction0 = new $c_Lcats_instances_Function0Instances$$anon$1();
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  this.Lcats_implicits$__f_catsContravariantForHash = new $c_Lcats_instances_HashInstances$$anon$1();
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForSet = new $c_Lcats_instances_SetInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForSortedSet = new $c_Lcats_instances_SortedSetInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForString = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForSymbol = new $c_Lcats_kernel_instances_SymbolOrder();
  this.Lcats_implicits$__f_catsStdShowForSymbol = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForUUID = new $c_Lcats_kernel_instances_UUIDInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdShowForUUID = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  this.Lcats_implicits$__f_catsSddDeferForFunction0 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsDataFunctorForPair = new $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForOption = new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForList = new $c_Lcats_instances_ListInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForVector = new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForStream = new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdComposeForMap = new $c_Lcats_instances_MapInstancesBinCompat0$$anon$1();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdShowForFiniteDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdSemigroupalForSortedSet = new $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1()
}
$c_Lcats_implicits$.prototype = new $h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
  /*<skip>*/
}
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForInt = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForInt = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForByte = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForByte = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForLong = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForLong = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForShort = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForShort = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForFloat = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForFloat = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForDouble = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForDouble = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForUnit = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdAlgebraForUnit = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForBigInt = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForBigInt = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForBigDecimal = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForBigDecimal = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForBitSet = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdSemilatticeForBitSet = x$0
});
$c_Lcats_implicits$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForFunction1
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdMonoidKForFunction1 = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_implicits$__f_catsInvariantMonoidalSemigroup = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_implicits$__f_catsInvariantMonoidalCommutativeSemigroup = x$0
});
$c_Lcats_implicits$.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForLazyList
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdTraverseFilterForLazyList = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForString = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdMonoidForString = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForDuration = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForDuration = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForFiniteDuration = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForFiniteDuration = x$0
});
var $d_Lcats_implicits$ = new $TypeData().initClass({
  Lcats_implicits$: 0
}, false, "cats.implicits$", {
  Lcats_implicits$: 1,
  O: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_NonEmptyAlternativeSyntax: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align$ToAlignOps: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_ParallelReduceMapASyntax: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1
});
$c_Lcats_implicits$.prototype.$classData = $d_Lcats_implicits$;
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$()
  };
  return $n_Lcats_implicits$
}
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
var $t_Ljava_time_DayOfWeek$__MONDAY = null;
var $t_Ljava_time_DayOfWeek$__TUESDAY = null;
var $t_Ljava_time_DayOfWeek$__WEDNESDAY = null;
var $t_Ljava_time_DayOfWeek$__THURSDAY = null;
var $t_Ljava_time_DayOfWeek$__FRIDAY = null;
var $t_Ljava_time_DayOfWeek$__SATURDAY = null;
var $t_Ljava_time_DayOfWeek$__SUNDAY = null;
var $t_Ljava_time_Month$__JANUARY = null;
var $t_Ljava_time_Month$__FEBRUARY = null;
var $t_Ljava_time_Month$__MARCH = null;
var $t_Ljava_time_Month$__APRIL = null;
var $t_Ljava_time_Month$__MAY = null;
var $t_Ljava_time_Month$__JUNE = null;
var $t_Ljava_time_Month$__JULY = null;
var $t_Ljava_time_Month$__AUGUST = null;
var $t_Ljava_time_Month$__SEPTEMBER = null;
var $t_Ljava_time_Month$__OCTOBER = null;
var $t_Ljava_time_Month$__NOVEMBER = null;
var $t_Ljava_time_Month$__DECEMBER = null;
var $t_Ljava_time_format_ResolverStyle$__STRICT = null;
var $t_Ljava_time_format_ResolverStyle$__SMART = null;
var $t_Ljava_time_format_ResolverStyle$__LENIENT = null;
var $t_Ljava_time_format_SignStyle$__NORMAL = null;
var $t_Ljava_time_format_SignStyle$__ALWAYS = null;
var $t_Ljava_time_format_SignStyle$__NEVER = null;
var $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = null;
var $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = null;
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = null;
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = null;
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = null;
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = null;
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = null;
var $t_Ljava_time_temporal_ChronoField$__YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__ERA = null;
var $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = null;
var $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = null;
var $t_Ljava_time_temporal_ChronoUnit$__NANOS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MICROS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MILLIS = null;
var $t_Ljava_time_temporal_ChronoUnit$__SECONDS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MINUTES = null;
var $t_Ljava_time_temporal_ChronoUnit$__HOURS = null;
var $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = null;
var $t_Ljava_time_temporal_ChronoUnit$__DAYS = null;
var $t_Ljava_time_temporal_ChronoUnit$__WEEKS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MONTHS = null;
var $t_Ljava_time_temporal_ChronoUnit$__YEARS = null;
var $t_Ljava_time_temporal_ChronoUnit$__DECADES = null;
var $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = null;
var $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = null;
var $t_Ljava_time_temporal_ChronoUnit$__ERAS = null;
var $t_Ljava_time_temporal_ChronoUnit$__FOREVER = null;
var $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC = null;
var $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL = null;
var $t_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD = null;
var $t_ju_Locale$Category$__DISPLAY = null;
var $t_ju_Locale$Category$__FORMAT = null;
var $t_Lnet_timerboard_BackendSocket$Status$__Connecting = null;
var $t_Lnet_timerboard_BackendSocket$Status$__Disconnecting = null;
var $t_Lnet_timerboard_BackendSocket$Status$__Disconnected = null;
var $t_Lnet_timerboard_Direction$__Asc = null;
var $t_Lnet_timerboard_Direction$__Desc = null;
var $t_Lnet_timerboard_EventType$__tcu_defense = null;
var $t_Lnet_timerboard_EventType$__ihub_defense = null;
var $t_Lnet_timerboard_EventType$__station_defense = null;
var $t_Lnet_timerboard_EventType$__station_freeport = null;
var $t_Lnet_timerboard_Field$__Time = null;
var $t_Lnet_timerboard_Field$__Type = null;
var $t_Lnet_timerboard_Field$__System = null;
var $t_Lnet_timerboard_Field$__Region = null;
var $t_Lnet_timerboard_Field$__Owner = null;
var $t_Lnet_timerboard_Field$__DefenderScore = null;
var $t_Lnet_timerboard_Field$__Distance = null;
var $t_Lnet_timerboard_Msg$__SearchBackspace = null;
var $t_Lnet_timerboard_Msg$__EnterTag = null;
var $t_Lnet_timerboard_Msg$__SystemTab = null;
var $t_Lnet_timerboard_Msg$__None = null;
var $t_Lnet_timerboard_Msg$__CalculateDistances = null;
var $t_Ltyrian_http_Body$__Empty = null;
var $t_Ltyrian_http_HttpError$__Timeout = null;
var $t_Ltyrian_http_HttpError$__NetworkError = null;
var $t_Ltyrian_http_Method$__Get = null;
var $t_Ltyrian_http_Method$__Post = null;
var $t_Ltyrian_http_Method$__Put = null;
var $t_Ltyrian_http_Method$__Patch = null;
var $t_Ltyrian_http_Method$__Delete = null;
var $t_Ltyrian_http_Method$__Options = null;
var $t_Ltyrian_websocket_WebSocketEvent$__Open = null;
var $t_Ltyrian_websocket_WebSocketEvent$__Heartbeat = null;
var $t_Ltyrian_websocket_WebSocketReadyState$__CONNECTING = null;
var $t_Ltyrian_websocket_WebSocketReadyState$__OPEN = null;
var $t_Ltyrian_websocket_WebSocketReadyState$__CLOSING = null;
var $t_Ltyrian_websocket_WebSocketReadyState$__CLOSED = null;
$sct_Ljava_time_zone_TzdbZoneRulesProvider__stinit__();
exports.TyrianApp = $m_Lnet_timerboard_Timerboard$();
//# sourceMappingURL=timerboard-fastopt.js.map
